/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 530);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(538);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return DATE_TIME_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return HTTP_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_217", function() { return UTC_TIMEZONE_OFFSET_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return ISO_STRING_YEAR_START_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return ISO_STRING_YEAR_END_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return ISO_STRING_MONTH_START_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return ISO_STRING_MONTH_END_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return ISO_STRING_DAY_START_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return ISO_STRING_DAY_END_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return ISO_STRING_TIME_START_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return ISO_STRING_MINUTES_END_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return DEFAULT_FLEX_COLUMN_NUMBER_OF_SENSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return PAGE_HEADERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return OPERATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return OPERATION_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return STAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CONFIG_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return EVENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CONFIG_TYPE_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return TCP_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_215", function() { return USER_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return SPIDER_DEPLOYMENT_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return INSTALLATION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return STOW_STATION_TIERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_224", function() { return ZANCA_SORT_TIER_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CATCH_ALL_INSTALLATION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_223", function() { return ZANCASORT_LOCATION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return INACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return DEPRECATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CONNECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return DISCONNECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return REACHABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_213", function() { return UNREACHABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return ONLINE_OK; });
/* unused harmony export HEALTH_OK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return DEPLOYMENT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return DEPLOYMENT_TYPE; });
/* unused harmony export SECONDARY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_209", function() { return TRUE_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return FALSE_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return SCC_AUTOMATION_MANAGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return SCC_AUTOMATION_VIEWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return AMAZON_SUFFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_222", function() { return ZANCASORT_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return TESSERACT_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return AUTO_LOADER_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_218", function() { return VAPR_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return AUTO_RETRIEVER_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADTA_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADTA_DEVICE_INFO_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADTF_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ADTF_MATRIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ADTF_SIMPLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ADTF_PULLMODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADTF_DEFAULT_DEVICE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return TRAFFIC_LIGHT_CONTROLLER_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return MODAL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return MODAL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return MODAL_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return TRAFFIC_LIGHT_RESOURCE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return NODE_RESOURCE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return ASL_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return ASML_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return INDUCT_CAMERA_SUB_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return PRINTER_SUB_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_220", function() { return VERIFICATION_CAMERA_SUB_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return HANDSFREE_CAMERA_SUB_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return OVERHEAD_CAMERA_SUB_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return THIN_CLIENT_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return LIDAR_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return SBL_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return SBLV2_ASSET_TYPE; });
/* unused harmony export IOT_AUTOMATION_ASSET_TYPE */
/* unused harmony export MHE_AUTOMATION_ASSET_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return IOT_AUTOMATION_ONLOGIC_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return AUTOMATION_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return AISLE_TYPE_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return LED_CONTROLLER_TYPE_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return LED_CONTROLLER_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return DEFAULT_AISLE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return AUTOMATION_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return SBLV2_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return SBLV3_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return MAX_RETRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return POLLING_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_216", function() { return USE_CASE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return TAKA_CLIENT_LINK_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return DEFAULT_VENDOR_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return ERROR_METRIC_SUFFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return LOADING_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return ALL_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return THREE_DOTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return ENDPOINT_AUTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return ENDPOINT_ADD_ASSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return ENDPOINT_ADD_ASSET_V2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return ENDPOINT_BATCH_UPDATE_ASSET_V2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return ENDPOINT_UPDATE_ASSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return ENDPOINT_UPDATE_ASSET_IN_PLACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return ENDPOINT_SET_ASSET_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return ENDPOINT_GET_ASSET_BY_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return ENDPOINT_GET_ADTA_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return ENDPOINT_GET_ADTF_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return ENDPOINT_GET_ASL_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return ENDPOINT_GET_ASML_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return ENDPOINT_GET_DEVICE_HEALTH_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return RESPONSE_KEY_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return RESPONSE_KEY_DEVICE_HEALTH_STATUS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return ENDPOINT_GET_ASSET_BY_ASSET_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return ENDPOINT_GET_ASSET_VERSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return ENDPOINT_GET_ASSET_BY_VERSION; });
/* unused harmony export ENDPOINT_GET_THIN_CLIENT_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return ENDPOINT_GET_SITE_DEVICES_CONNECTIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return ENDPOINT_DEPLOY_THIN_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return ENDPOINT_GET_CORE_DEVICE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return ENDPOINT_CREATE_REDEPLOYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return ENDPOINT_DELETE_THIN_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return ENDPOINT_PUBLISH_TRAFFIC_LIGHT_COMMAND_TO_THIN_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return ENDPOINT_PUBLISH_COMMAND_TO_THIN_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return ENDPOINT_SWITCH_OVER_THIN_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return ENDPOINT_CHANGE_THIN_CLIENT_USECASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return ENDPOINT_GET_THIN_CLIENT_DEPLOYMENT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return ENDPOINT_GET_LED_CONTROLLERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return ENDPOINT_UPDATE_LED_CONTROLLERS_REMARKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return ENDPOINT_SET_ASSET_DEFAULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return ENDPOINT_GET_ASSET_V2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return ENDPOINT_UPDATE_DISABLE_MONITORING_SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return ENDPOINT_GET_SITE_ASSET_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return ENDPOINT_PUBLISH_LIGHT_COMMAND_TO_THIN_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return ENDPOINT_GET_MHE_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return ENDPOINT_TRIGGER_MHE_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return ENDPOINT_GET_PRESIGNED_URL_MHE_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return ENDPOINT_GET_BAG_LOCATION_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return PROCESS_NODE_RESOURCE; });
/* unused harmony export PROCESS_NODE_USER */
/* unused harmony export ENDPOINT_GET_TCP_ROLES */
/* unused harmony export ENDPOINT_GET_LIDAR_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return ENDPOINT_GET_ASSETS_CONNECTIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return ENDPOINT_GET_MQTT_CONNECTION_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return ENDPOINT_START_MOCK_TEST_FOR_AR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return ENDPOINT_GET_RESOURCE_DYNAMIC_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return ENDPOINT_GET_CART_RECIPE_BY_CART_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return ENDPOINT_GET_RESOURCES_V2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return TEN_SECONDS_LOADER_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return MONITORING_STATUS_LOADER_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return SOFTWARE_STATUS_LOADER_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_214", function() { return USECASE_STATUS_LOADER_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return LIDAR_TESTER_ACTIVATION_PERIOD_MINUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return LIDAR_TESTER_ACTIVATION_INTERVAL_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return LIDAR_TESTER_EVENT_CLEAR_TIMER_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return MILLISECONDS_IN_A_DAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return SKYLARK_LIDAR_CONTROLLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return LIDAR_TESTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return PROVISION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return SKYLARK_BRANCH_PROVISION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return SKYLARK_LEAF_PROVISION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return SKYLARK_BRANCH_PROVISION_TIMEOUT_IN_SECONDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return SKYLARK_LEAF_PROVISION_TIMEOUT_IN_SECONDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return SKYLARK_BRANCH_PROVISION_DISPLAY_TIMEOUT_IN_SECONDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return LEAF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return AISLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return EXPECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return DETECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return ON_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return OFF_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return SENSOR_INDEX_ZERO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return SENSOR_INDEX_ONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return EMPTY_STRING_PLACEHOLDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_212", function() { return UNDERSCORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return COMMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return DOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return EMPTY_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return SEMI_COLON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return COLON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return TIMEOUT_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return SUCCESS_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return ERROR_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return IN_PROGRESS_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return LOADING_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return BLUE_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return ORANGE_COLOR; });
/* unused harmony export RED_COLOR */
/* unused harmony export GREY_COLOR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return SEARCH_ROW_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return PRIMARY_TEXT_COLOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return STATUS_COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_208", function() { return TROUBLESHOOTING_URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return STATUS_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return SKYLARK_PROVISIONING_ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return MHE_VALIDATION_STATUS_TYPE; });
/* unused harmony export MHE_VALIDATION_RESULT_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return MHE_VALIDATION_STATUS_COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return MHE_VALIDATION_RESULT_COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return ASCENDING; });
/* unused harmony export DESCENDING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ALERT_ASSET_STATUS_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ALERT_ASSET_USE_CASE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ALERT_ASSET_USE_CASE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ALERT_START_AR_MOCK_TEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ALERT_ASSET_DEPLOY_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ALERT_ADD_ASSET_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ALERT_RESTART_APPLICATION_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ALERT_UPDATE_ASSET_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ALERT_DELETE_ASSET_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ALERT_UPDATE_ASSET_DEFAULTS_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ALERT_PUBLISH_TRAFFIC_LIGHT_COMMAND_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return ALERT_UPDATE_SUCCESS_ASSET_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ALERT_CREATE_SUCCESS_ASSET_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ALERT_PAGE_REFRESH_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ALERT_DELETE_SUCCESS_ASSET_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return ALERT_UPDATE_SUCCESS_ASSET_DEFAULTS_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ALERT_MHE_VALIDATION_FAILED_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ALERT_MHE_VALIDATION_REPORT_DOES_NOT_EXIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_225", function() { return getUpdateAssetMessageAlertWithSite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return MAX_CSV_SIZE_BYTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return RESTART_APPLICATION_STATUS_TIMEOUT; });
/* unused harmony export MARKETPLACE_LOCALE_MAP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return HEALTH_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return SW_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return EXTERNAL_LINKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return MCM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return JUSTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return MCM_AMAZON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return TCORP_AMAZON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return MAX_LOGS_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_221", function() { return WSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return AUTOMATION_MQTT_TOPIC_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return AUTOMATION_MQTT_TOPIC_SUFFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return LOGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return MAX_RECONNECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return MQTT_CONNECTION_DETAILS_EXPIRY_TIMEOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return MAX_MQTT_RECONNECTION_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return MQTT_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return AWS_REGION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return MERIDIAN_ALERT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return DEVICE_TYPE_RENDER_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return DEVICE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return EU_OV_LOCATION_LABEL_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return NA_OV_LOCATION_LABEL_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return EU_OV_LOCATION_LABEL_REGEX_WITH_OVD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return NA_OV_LOCATION_LABEL_REGEX_WITH_OVD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return MAC_ADDRESS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_210", function() { return UNASSIGN_PRINTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_211", function() { return UNASSIGN_VERIFICATION_CAMERA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return NO_PRINTER_ASSIGNED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return NO_VERIFICATION_CAMERA_ASSIGNED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return BAG_TRACKING_ALLOWED_STATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return AUTO_LOADER_ASSET_ENABLED_STATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_219", function() { return VAPR_ENABLED_STATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return BAG_TRACKING_CONSTANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return LIDAR_TESTER_SENSOR_STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return LOCATION_MAPPING_ATTR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return ANALYTICS_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return DELETE_DEVICE_EXCLUDED_ASSET_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return LIDAR_COLUMN_COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return LIDAR_COLUMN_DIMENSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CART_RESOURCE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return DEFAULT_PERCENTILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return LOW_BATTERY_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return DEFAULT_ANDON_COLOR_HEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return SBL_DASHBOARD_METRIC_PROCESS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return METRIC_GET_RESOURCE_DYNAMIC_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return METRIC_GET_PICK_STATION_RESOURCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return METRIC_UPDATE_PICK_STATION_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return METRIC_GET_PICK_POINT_RESOURCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return METRIC_UPDATE_RETRIEVER_LOCATION_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return PICK_STATION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return PICK_STATION_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return PICK_STATION_STATUS_COLOR; });
/* unused harmony export PICK_ITEM_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return PICK_ITEM_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return RESOURCE_DYNAMIC_ATTRIBUTES_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return DEFAULT_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return DEFAULT_SORT_COLUMN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return LIGHT_COMMAND_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return LIGHT_COMMAND_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return ANDON_PROCESS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return METRIC_PUBLISH_LIGHT_COMMAND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return DEFAULT_ANDON_BATCH_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return BATTERY_COLUMN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return FLOOR_LOCATION_COLUMN; });
/* unused harmony export VERSION_COLUMN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return PROMISE_FULFILLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return SBL_FILTER_COLUMNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return SBL_DASHBOARD_ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return ANDON_COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return TIMER_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CART_FILTER_PANEL_STRINGS; });
var _USE_CASE_MAP;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var DATE_TIME_FORMAT={year:'numeric',month:'long',day:'numeric',hour:'2-digit',minute:'2-digit',second:'2-digit',timeZoneName:'short',hourCycle:'h24'};var HTTP_STATUS={OK:200};var UTC_TIMEZONE_OFFSET_STRING="Z";var ISO_STRING_YEAR_START_INDEX=0;var ISO_STRING_YEAR_END_INDEX=4;var ISO_STRING_MONTH_START_INDEX=5;var ISO_STRING_MONTH_END_INDEX=7;var ISO_STRING_DAY_START_INDEX=8;var ISO_STRING_DAY_END_INDEX=10;var ISO_STRING_TIME_START_INDEX=11;var ISO_STRING_MINUTES_END_INDEX=16;var DEFAULT_FLEX_COLUMN_NUMBER_OF_SENSOR=3;var PAGE_HEADERS={ASL_DEVICES:{head:"asl.heading",headAlt:"ASL Devices",desc:"asl.desc",descAlt:"This page shows the real-time status of ASL devices along with the device and ASL Guided Divert Configuration"},ADTA_DEVICES:{head:"adta.heading",headAlt:"ADTA Devices",desc:"adta.desc",descAlt:"This page shows the real-time status of ADTA devices along with the Sorter Destination and Sorter Test Package Configuration"},THIN_CLIENTS:{head:"thinclients.heading",headAlt:"Thin Clients",desc:"thinclient.desc",descAlt:"This page shows the real-time status of Thin Client devices along with the MAC/IP Address and health status"},SBL_DEVICES:{head:"sbl.heading",headAlt:"SBL Devices",desc:"sbl.desc",descAlt:"This page shows the real-time status of LED Controllers along with the MAC/IP Address and Connectivity"},DEVICE_MANAGEMENT:{head:"devicemanagement.heading",headAlt:"Device Management",desc:"devicemanagement.desc",descAlt:"This page shows the real-time status of Automation devices, Thin Clients and SBL devices and helps you to set configuration of the selected device type."},BAG_TRACKING:{tab:"bagtracking.tabHeading",tabAlt:"RFID Bag Tracking",head:"bagtracking.heading",headAlt:"Bag Tracking",desc:"bagtracking.description",descAlt:"This page shows tracking status of RFID Bags during the depart and receive process"}};var OPERATIONS={ADD:'ADD',EDIT:'EDIT',DELETE:'DELETE',NO_OP:'NO_OP'};var OPERATION_COLOR={ADD:'#c0f9bb',EDIT:'#bbe9f9',DELETE:'#f9bbbb',NO_OP:'transparent'};var STAGE={PROD:'PROD',GAMMA:'GAMMA',BETA:'BETA'};var CONFIG_TYPE={SORTER_DESTINATION:"SORTER_DESTINATION",SORTER_TEST_PACKAGE:"SORTER_TEST_PACKAGE",ADTF_SORTER_DESTINATION:"ADTF_SORTER_DESTINATION",ADTF_SORTER_TEST_PACKAGE:"ADTF_SORTER_TEST_PACKAGE",DIVERT_CONFIGURATION:"DIVERT_CONFIGURATION",LED_CONTROLLER_CONFIGURATION:"LED_CONTROLLER_CONFIGURATION",ZANCA_SORT_TEST_CONFIGURATION:"ZANCA_SORT_TEST_CONFIGURATION",ZANCA_SORT_LOCATION_CONFIGURATION:"ZANCA_SORT_LOCATION_CONFIGURATION",ZANCA_SORT_TIER_CONFIGURATION:"ZANCA_SORT_TIER_CONFIGURATION",TESSERACT_TEST_CONFIGURATION:"TESSERACT_TEST_CONFIGURATION",TESSERACT_STOW_CONFIGURATION:"TESSERACT_STOW_CONFIGURATION",AUTO_RETRIEVER_TEST_CONFIGURATION:"AUTO_RETRIEVER_TEST_CONFIGURATION",PICK_STATION_CONFIGURATION:"PICK_STATION_CONFIGURATION",RETRIEVER_LOCATION_MAPPING:"RETRIEVER_LOCATION_MAPPING",AUTOLOADER_DESTINATION:"AUTOLOADER_DESTINATION",AUTOLOADER_TEST_PACKAGE:"AUTOLOADER_TEST_PACKAGE"};var EVENT_TYPE={MHE_LOG_DATA:"MHE_log_data"};var CONFIG_TYPE_VALUE={SORTER_DESTINATION:"Sorter Destination",SORTER_TEST_PACKAGE:"Sorter Test Package",ADTF_SORTER_DESTINATION:"Sorter Destination",ADTF_SORTER_TEST_PACKAGE:"Sorter Test Package",DIVERT_CONFIGURATION:"Guided Divert Configuration",LED_CONTROLLER_CONFIGURATION:"LED_CONTROLLER_CONFIGURATION",ZANCA_SORT_TEST_CONFIGURATION:"Stow Test Package",ZANCA_SORT_LOCATION_CONFIGURATION:"ZancaSort Locations",ZANCA_SORT_TIER_CONFIGURATION:"ZancaSort Tier Config",TESSERACT_TEST_CONFIGURATION:"Stow Test Package",TESSERACT_STOW_CONFIGURATION:"Stow Destination",AUTO_RETRIEVER_TEST_CONFIGURATION:"Pick Test",PICK_STATION_CONFIGURATION:"Pick Station Config",RETRIEVER_LOCATION_MAPPING:"Location Config",AUTOLOADER_DESTINATION:"AutoLoader Destination ",AUTOLOADER_TEST_PACKAGE:"AutoLoader Test Package"};var TCP_PERMISSIONS="tcpPermissions";var USER_LOGIN="userLogin";var SPIDER_DEPLOYMENT_SERVICE="spiderDeploymentService";var INSTALLATION_TYPES={AISLE:{label:"Aisle",value:"aisle"},BULKY:{label:"Bulky",value:"bulky"},CLUSTER:{label:"Cluster",value:"cluster"},COLUMN:{label:"Column",value:"column"},FLOOR:{label:"Floor location",value:"floor"},JACKPOT:{label:"Jackpot",value:"jackpot"},OV:{label:"OV",value:"ov"},PROBLEM_SOLVE:{label:"Problem_Solve",value:"problem_solve"},RECIRCULATION:{label:"Recirculation",value:"recirculation"},SORT_ZONE:{label:"Sort Zone",value:"sort_zone"},Zone:{label:"Zone",value:"zone"},SIDELINE:{label:"SideLine",value:"sideline"},FRAGILE:{label:"Fragile",value:"fragile"},BIN:{label:"Bin",value:"bin"},STOW_STATION:{label:"Stow Station",value:"stow_station"}// Tier options for a stow station location. A stow station location is a single
// cluster#tier pair, e.g. "A#2" (top) or "A#1" (bottom). The value is the tier token
// written to NARC; the label spells out the tier for the operator.
};var STOW_STATION_TIERS=[{label:"1 (BOTTOM)",value:"1"},{label:"2 (TOP)",value:"2"}];// Allowed tier names for a ZancaSort tier configuration. A ZancaSort stack has exactly
// two tiers, so the tier name is restricted to these values instead of a free form string.
var ZANCA_SORT_TIER_NAMES=["TOP","BOTTOM"];var CATCH_ALL_INSTALLATION_TYPES=[INSTALLATION_TYPES.SIDELINE.value,INSTALLATION_TYPES.JACKPOT.value,INSTALLATION_TYPES.RECIRCULATION.value,INSTALLATION_TYPES.BULKY.value,INSTALLATION_TYPES.OV.value,INSTALLATION_TYPES.PROBLEM_SOLVE.value,INSTALLATION_TYPES.FRAGILE.value];var ZANCASORT_LOCATION_TYPES={WAREHOUSE_LOCATION:{label:"Warehouse Location",value:"WAREHOUSE_LOCATION"},PICK_LOCATION:{label:"Pick Location",value:"PICK_LOCATION"},STOW_LOCATION:{label:"Stow Location",value:"STOW_LOCATION"}// NDMS Status values
};var ACTIVE="ACTIVE";var INACTIVE="INACTIVE";var DEPRECATED="DEPRECATED";var CONNECTED="Connected";var DISCONNECTED="Disconnected";var REACHABLE="Reachable";var UNREACHABLE="Unreachable";var ONLINE_OK="connected";var HEALTH_OK="HEALTHY";// GG software values
var GG_DEPLOYMENT_STATUS={BUILDING:"Building",IN_PROGRESS:"InProgress",SUCCESS:"Success",FAILURE:"Failure",UNKNOWN:"UNKNOWN"};var GG_DEPLOYMENT_TYPE={NEW:"NewDeployment",REDO:"Redeployment",RESET:"ResetDeployment",FORCE_RESET:"ForceResetDeployment"// Portal software values
};var DEPLOYMENT_STATUS={QUEUED:[GG_DEPLOYMENT_STATUS.BUILDING],IN_PROGRESS:[GG_DEPLOYMENT_STATUS.IN_PROGRESS,GG_DEPLOYMENT_STATUS.IN_PROGRESS],SUCCESS:[GG_DEPLOYMENT_STATUS.SUCCESS],FAILURE:[GG_DEPLOYMENT_STATUS.FAILURE,GG_DEPLOYMENT_STATUS.UNKNOWN]};var DEPLOYMENT_TYPE={DEPLOYMENT:[GG_DEPLOYMENT_TYPE.NEW,GG_DEPLOYMENT_TYPE.REDO],RESET:[GG_DEPLOYMENT_TYPE.RESET,GG_DEPLOYMENT_TYPE.FORCE_RESET]};var SECONDARY="Secondary";var PRIMARY="Primary";var TRUE_VALUE="true";var FALSE_VALUE="false";var SCC_AUTOMATION_MANAGER="AmazonFacility::SCC: Automation Manager";var SCC_AUTOMATION_VIEWER="AmazonFacility::SCC: Automation Viewer";var AMAZON_SUFFIX="@amazon.com";var ZANCASORT_ASSET_TYPE="ZANCASORT";var TESSERACT_ASSET_TYPE="TESSERACT";var AUTO_LOADER_ASSET_TYPE="AUTO_LOADER";var VAPR_ASSET_TYPE="VAPR";var AUTO_RETRIEVER_ASSET_TYPE="AUTO_RETRIEVER";var ADTA_ASSET_TYPE="ADTA";var ADTA_DEVICE_INFO_KEY="adtaDeviceInformation";var ADTF_ASSET_TYPE="ADTF";var ADTF_MATRIX="Matrix";var ADTF_SIMPLE="Simple";var ADTF_PULLMODE="PullMode";var ADTF_DEFAULT_DEVICE_ID="1";var TRAFFIC_LIGHT_CONTROLLER_ASSET_TYPE="TRAFFIC_LIGHT_CONTROLLER";var MODAL_SUCCESS="SUCESS";var MODAL_ERROR="ERROR";var MODAL_RESET="RESET";var TRAFFIC_LIGHT_RESOURCE_TYPE="TRAFFIC_LIGHT";var NODE_RESOURCE_TYPE={PICK_STATION:"PICK_STATION",PICK_POINT:"PICK_POINT"};var ASL_ASSET_TYPE="ASL";var ASML_ASSET_TYPE="ASML";var INDUCT_CAMERA_SUB_ASSET_TYPE="INDUCT_CAMERA";var PRINTER_SUB_ASSET_TYPE="PRINTER";var VERIFICATION_CAMERA_SUB_ASSET_TYPE="VERIFICATION_CAMERA";var HANDSFREE_CAMERA_SUB_ASSET_TYPE="HANDSFREE_CAMERA";var OVERHEAD_CAMERA_SUB_ASSET_TYPE="OVERHEAD_CAMERA";var THIN_CLIENT_ASSET_TYPE="EDGE_GATEWAY";var LIDAR_ASSET_TYPE="LIDAR_CONTROLLER";var SBL_ASSET_TYPE="sbl";var SBLV2_ASSET_TYPE="health-monitoring";var IOT_AUTOMATION_ASSET_TYPE="IOTAutomation";var MHE_AUTOMATION_ASSET_TYPE="MHEAutomation";var IOT_AUTOMATION_ONLOGIC_ASSET_TYPE="IOTAutomationOnLogic";var AUTOMATION_ASSET_TYPE="automation";var AISLE_TYPE_CONFIG="AISLE_TYPE";var LED_CONTROLLER_TYPE_CONFIG="LED_CONTROLLER_TYPE";var LED_CONTROLLER_ASSET_TYPE="LED_CONTROLLER";var DEFAULT_AISLE_TYPE="Default";var AUTOMATION_TEXT="Automation";var SBLV2_TEXT="SBLv2";var SBLV3_TEXT="SBLv3";var MAX_RETRIES=6;var POLLING_INTERVAL=5000;// 5 seconds
var USE_CASE_MAP=(_USE_CASE_MAP={},_defineProperty(_USE_CASE_MAP,SBLV2_TEXT,{displayText:SBLV2_TEXT,assetUseCase:SBLV2_ASSET_TYPE,useCase:IOT_AUTOMATION_ASSET_TYPE}),_defineProperty(_USE_CASE_MAP,AUTOMATION_TEXT,{displayText:AUTOMATION_TEXT,assetUseCase:AUTOMATION_ASSET_TYPE,useCase:MHE_AUTOMATION_ASSET_TYPE}),_defineProperty(_USE_CASE_MAP,SBLV3_TEXT,{displayText:SBLV3_TEXT,assetUseCase:IOT_AUTOMATION_ONLOGIC_ASSET_TYPE,useCase:IOT_AUTOMATION_ONLOGIC_ASSET_TYPE}),_USE_CASE_MAP);var TAKA_CLIENT_LINK_PREFIX="https://website.taka.fc.a2z.com/clients";var DEFAULT_VENDOR_ATTRIBUTES={vendor:"",spec_version:"",sorter_type:"",hamper_vendor:"",hamper_version:""};var ERROR_METRIC_SUFFIX="Error";var LOADING_FAILED="Loading Failed!";var ALL_CONFIG="ALL";var THREE_DOTS="...";var ENDPOINT_AUTH="/ndms/getAuthorization";var ENDPOINT_ADD_ASSET="/ndms/addAsset";var ENDPOINT_ADD_ASSET_V2="/ndms/addAssetV2";var ENDPOINT_BATCH_UPDATE_ASSET_V2="/ndms/batchUpdateAssetV2";var ENDPOINT_UPDATE_ASSET="/ndms/updateAsset";var ENDPOINT_UPDATE_ASSET_IN_PLACE="/ndms/updateAssetInPlace";var ENDPOINT_SET_ASSET_STATUS="/ndms/setAssetStatus";var ENDPOINT_GET_ASSET_BY_ASSET_TYPE="/ndms/getAssets";var ENDPOINT_GET_ADTA_STATUS="ndms/getADTAStatus";var ENDPOINT_GET_ADTF_STATUS="ndms/getADTFStatus";var ENDPOINT_GET_ASL_STATUS="ndms/getASLStatus";var ENDPOINT_GET_ASML_STATUS="ndms/getASLStatus";var ENDPOINT_GET_DEVICE_HEALTH_STATUS="/ndms/getDeviceHealthStatus";var RESPONSE_KEY_DATA="data";var RESPONSE_KEY_DEVICE_HEALTH_STATUS_LIST="deviceHealthStatusList";var ENDPOINT_GET_ASSET_BY_ASSET_LABEL="/ndms/getAssetByAssetLabel";var ENDPOINT_GET_ASSET_VERSIONS="/ndms/getAssetVersions";var ENDPOINT_GET_ASSET_BY_VERSION="/ndms/getAssetByVersion";var ENDPOINT_GET_THIN_CLIENT_STATUS="ndms/getThinClientStatus";var ENDPOINT_GET_SITE_DEVICES_CONNECTIVITY="/ndms/getSiteDevicesConnectivity";var ENDPOINT_DEPLOY_THIN_CLIENT="ndms/deployToThinClient";var ENDPOINT_GET_CORE_DEVICE_STATUS="/greengrass/getCoreDeviceStatus/";var ENDPOINT_CREATE_REDEPLOYMENT="/greengrass/redeployThing";var ENDPOINT_DELETE_THIN_CLIENT="ndms/deleteThinClient";var ENDPOINT_PUBLISH_TRAFFIC_LIGHT_COMMAND_TO_THIN_CLIENT="ndms/publishTrafficLightCommandToThinClient";var ENDPOINT_PUBLISH_COMMAND_TO_THIN_CLIENT="ndms/publishCommandToThinClient";var ENDPOINT_SWITCH_OVER_THIN_CLIENT="ndms/switchOverThinClient";var ENDPOINT_CHANGE_THIN_CLIENT_USECASE="ndms/updateThinClientUseCase";var ENDPOINT_GET_THIN_CLIENT_DEPLOYMENT_STATUS="ndms/getThinClientDeployment";var ENDPOINT_GET_LED_CONTROLLERS="ndms/getLEDControllers";var ENDPOINT_UPDATE_LED_CONTROLLERS_REMARKS="ndms/updateLedControllersRemarks";var ENDPOINT_SET_ASSET_DEFAULTS="ndms/setAssetDefaults";var ENDPOINT_GET_ASSET_V2="ndms/getAssetV2";var ENDPOINT_UPDATE_DISABLE_MONITORING_SCHEDULE="ndms/updateDisableMonitoringSchedule";var ENDPOINT_GET_SITE_ASSET_CONFIG="ndms/getSiteAssetConfig";var ENDPOINT_PUBLISH_LIGHT_COMMAND_TO_THIN_CLIENT="ndms/publishLightCommandToThinClient";var ENDPOINT_GET_MHE_VALIDATION="/ndms/getMHEValidationData";var ENDPOINT_TRIGGER_MHE_VALIDATION="ndms/triggerMHEValidation";var ENDPOINT_GET_PRESIGNED_URL_MHE_VALIDATION="ndms/generatePresignedUrl";var ENDPOINT_GET_BAG_LOCATION_INFO="/ndms/getBagLocationInfo";var PROCESS_NODE_RESOURCE="nodeResource";var PROCESS_NODE_USER="nodeUser";var ENDPOINT_GET_TCP_ROLES="getTcpRoles";var ENDPOINT_GET_LIDAR_STATUS="ndms/getLidarStatus";var ENDPOINT_GET_ASSETS_CONNECTIVITY="ndms/getAssetConnectivity";var ENDPOINT_GET_MQTT_CONNECTION_DETAILS="ndms/getMQTTConnectionDetails";var ENDPOINT_START_MOCK_TEST_FOR_AR="ndms/triggerASRSMockTest";var ENDPOINT_GET_RESOURCE_DYNAMIC_ATTRIBUTES="ndms/getResourceDynamicAttributes";var ENDPOINT_GET_CART_RECIPE_BY_CART_TYPE="getCartRecipe";var ENDPOINT_GET_RESOURCES_V2="getResourcesV2";var TEN_SECONDS_LOADER_TIMER=10000;var MONITORING_STATUS_LOADER_TIMER=10000;var SOFTWARE_STATUS_LOADER_TIMER=30000;var USECASE_STATUS_LOADER_TIMER=30000;// The time in minutes for which lidar tester is activated at a time.
var LIDAR_TESTER_ACTIVATION_PERIOD_MINUTES=5;// The refresh time interval for activating Lidar tester events in Lidar service backend.
var LIDAR_TESTER_ACTIVATION_INTERVAL_MS=5*60*1000;// 5 minutes
// The time after which the stow detection event for a sensor is cleared from UI.
var LIDAR_TESTER_EVENT_CLEAR_TIMER_MS=2000;var MILLISECONDS_IN_A_DAY=24*60*60*1000;var SKYLARK_LIDAR_CONTROLLER="Skylark";var LIDAR_TESTER="LIDAR_TESTER";var PROVISION_REQUEST="PROVISION_REQUEST";var SKYLARK_BRANCH_PROVISION_REQUEST="SKYLARK_BRANCH_PROVISION_REQUEST";var SKYLARK_LEAF_PROVISION_REQUEST="SKYLARK_LEAF_PROVISION_REQUEST";var SKYLARK_BRANCH_PROVISION_TIMEOUT_IN_SECONDS=60;var SKYLARK_LEAF_PROVISION_TIMEOUT_IN_SECONDS=60;var SKYLARK_BRANCH_PROVISION_DISPLAY_TIMEOUT_IN_SECONDS=55;var BRANCH="Branch";var LEAF="Leaf";var AISLE="AISLE";var EXPECTED="Expected";var DETECTED="Detected";var ON_STATE="ON";var OFF_STATE="OFF";var SENSOR_INDEX_ZERO="0";var SENSOR_INDEX_ONE="1";var EMPTY_STRING_PLACEHOLDER="-";var UNDERSCORE="_";var COMMA=",";var DOT=".";var EMPTY_STRING="";var SEMI_COLON=";";var COLON=":";var TIMEOUT_STRING="timeout";var SUCCESS_STRING="success";var ERROR_STRING="error";var IN_PROGRESS_STRING="in-progress";var LOADING_STRING="Loading";var ACTIONS_STRING="...";// Colors
var BLUE_COLOR="#077398";var ORANGE_COLOR="#FF714D";var RED_COLOR="#FF5C4D";var GREY_COLOR="#213340";var SEARCH_ROW_COLOR="#F0F1F2";var PRIMARY_TEXT_COLOUR="primary";/**
 * Standardized status colors for consistent UI experience across components
 * These colors ensure WCAG AA compliance for accessibility and maintain visual consistency
 */var STATUS_COLORS={SUCCESS:{BACKGROUND:'#7EC55E',// Material Design Green 400 - used for all success states
TEXT:'#FFFFFF'// White text for proper contrast
},ERROR:{BACKGROUND:'#F44336',// Material Design Red 500 - used for all error states  
TEXT:'#FFFFFF'// White text for proper contrast
},WARNING:{BACKGROUND:'#FFC107',// Material Design Amber 500 - used for timeout/warning states
TEXT:'#000000'// Black text for proper contrast on amber background
},INFO:{BACKGROUND:'#2196F3',// Material Design Blue 500 - used for in-progress/info states
TEXT:'#FFFFFF'// White text for proper contrast
}};// Troubleshooting resources
var TROUBLESHOOTING_URLS={SKYLARK_PROVISIONING:'https://w.amazon.com/bin/view/Last_Mile_Team/Smart-Station/Skylark/SkylarkProvisioningTroubleshootingGuide'};// Status message constants for better maintainability and i18n preparation
var STATUS_MESSAGES={BRANCH_SUCCESS:'Branch Node Provisioning Successful for {count} Aisles',BRANCH_ERROR:'Branch Node Mismatch - Total Aisles: {expected}, Detected Branch Nodes: {detected}. <a href="'+TROUBLESHOOTING_URLS.SKYLARK_PROVISIONING+'" target="_blank" rel="noopener noreferrer">Troubleshooting Guide</a>',BRANCH_TIMEOUT:'Provisioning Timeout - No Provisioning Response Received',LEAF_SUCCESS:'Leaf Provisioning Successful - All Leaf Nodes are Detected',LEAF_ERROR:'Mismatch between expected and detected Leaf Nodes. Check aisle configuration and cable connections. <a href="'+TROUBLESHOOTING_URLS.SKYLARK_PROVISIONING+'" target="_blank" rel="noopener noreferrer">Troubleshooting Guide</a>',LEAF_TIMEOUT:'Leaf Provisioning Timeout - No Response Received from Leaf Nodes. <a href="'+TROUBLESHOOTING_URLS.SKYLARK_PROVISIONING+'" target="_blank" rel="noopener noreferrer">View Troubleshooting Guide</a>',LEAF_IN_PROGRESS:'Leaf Provisioning in Progress'};var SKYLARK_PROVISIONING_ACTIONS={INIT_PROVISIONING:"INIT_PROVISIONING",SET_CLUSTER_STATUS:"SET_CLUSTER_STATUS",RESET_PROVISIONING:"RESET_PROVISIONING",UPDATE_PROVISIONING_DATA:"UPDATE_PROVISIONING_DATA"};var MHE_VALIDATION_STATUS_TYPE={COMPLETED:"COMPLETED",ERROR:"ERROR",IN_QUEUE:"IN_QUEUE",IN_PROGRESS:"IN_PROGRESS"};var MHE_VALIDATION_RESULT_TYPE={PASS:"PASS",FAIL:"FAIL",WARN:"WARN"};var MHE_VALIDATION_STATUS_COLORS={COMPLETED:BLUE_COLOR,IN_QUEUE:GREY_COLOR,IN_PROGRESS:GREY_COLOR,ERROR:ORANGE_COLOR};var MHE_VALIDATION_RESULT_COLORS={PASS:BLUE_COLOR,FAIL:RED_COLOR,WARN:ORANGE_COLOR// sort directions
};var ASCENDING="ascending";var DESCENDING="descending";var ALERT_ASSET_STATUS_MESSAGE="Failed to update Asset Status to Active. Try again!";var ALERT_ASSET_USE_CASE_UPDATE="Failed to update Asset Use Case to Primary. Try again!";var ALERT_ASSET_USE_CASE_CHANGE="Failed to change Thin Client use case. Try again!";var ALERT_START_AR_MOCK_TEST="Failed to start mock test. Try again!";var ALERT_ASSET_DEPLOY_MESSAGE="Failed to deploy Asset. Try again!";var ALERT_ADD_ASSET_MESSAGE="Failed while adding asset. Try again!";var ALERT_RESTART_APPLICATION_FAILED="Failed to restart application.";var ALERT_UPDATE_ASSET_MESSAGE="alert.asset_details_fail";var ALERT_DELETE_ASSET_MESSAGE="alert.asset_delete_fail";var ALERT_UPDATE_ASSET_DEFAULTS_MESSAGE="alert.asset_defaults_fail";var ALERT_PUBLISH_TRAFFIC_LIGHT_COMMAND_MESSAGE="Failed while publishing traffic light command. Try again!";var ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET="Failed to update asset details as same MAC Address already exists. Recheck the MAC Address with RME and try again!";var ALERT_UPDATE_SUCCESS_ASSET_MESSAGE="alert.asset_details_success";var ALERT_CREATE_SUCCESS_ASSET_MESSAGE="alert.asset_create_success";var ALERT_PAGE_REFRESH_MESSAGE=" Please note that it may take few seconds for the latest data to appear. The page will refresh automatically once data is available.";var ALERT_DELETE_SUCCESS_ASSET_MESSAGE="alert.asset_delete_success";var ALERT_UPDATE_SUCCESS_ASSET_DEFAULTS_MESSAGE="alert.asset_defaults_success";var ALERT_MHE_VALIDATION_FAILED_MESSAGE="New Validation could not be created because a validation in the selected time frame already exists or another validation is currently in progress.";var ALERT_MHE_VALIDATION_REPORT_DOES_NOT_EXIST="MHE Validation report does not exist."+" Please reach out to the UTR team for resolution.";var getUpdateAssetMessageAlertWithSite=function getUpdateAssetMessageAlertWithSite(nodeId){return'Failed to update asset details as same MAC Address already exists for Site : '+nodeId+'. Recheck the MAC Address with RME and try again!';};var MAX_CSV_SIZE_BYTES="358400";// 350kbs
var RESTART_APPLICATION_STATUS_TIMEOUT=120000;var MARKETPLACE_LOCALE_MAP={de:["de","de-DE","de-CH","de-AT","de-LU","de-LI"],es:["es","es-ES","es-AR","es-GT","es-CR","es-PA","es-DO","es-MX","es-VE","es-CO","es-PE","es-EC","es-CL","es-UY","es-PY","es-BO","es-SV","es-HN","es-NI","es-PR"],ja:["ja","ja-JP"],it:["it","it-IT","it-CH"],fr:["fr","fr-FR","fr-BE","fr-CA","fr-CH","fr-LU"],ar:["ar","ar-SA","ar-IQ","ar-EG","ar-LY","ar-DZ","ar-MA","ar-TN","ar-OM","ar-YE","ar-SY","ar-JO","ar-LB","ar-KW","ar-AE","ar-BH","ar-QA"],en:["en"]// Health status display values
};var HEALTH_STATUS={HEALTHY:{string:"Healthy",color:BLUE_COLOR},DISCONNECTED:{string:"Disconnected",color:ORANGE_COLOR},UNHEALTHY:{string:"Unhealthy",color:ORANGE_COLOR},LOADING:{string:"Loading...",color:GREY_COLOR},LOADING_FAILED:{string:"Loading failed",color:ORANGE_COLOR}// Health status display values
};var SW_STATUS={QUEUED:{string:"Deployment is Queued",color:BLUE_COLOR},RESTARTED:{string:"Application Restarted",color:BLUE_COLOR},RESTART_IN_PROGRESS:{string:"Restart Application in progress",color:BLUE_COLOR},DEPLOYED:{string:"Deployed",color:BLUE_COLOR},DEPLOYMENT_IN_PROGRESS:{string:"Deployment in progress",color:BLUE_COLOR},RESET_IN_PROGRESS:{string:"Reset in progress",color:BLUE_COLOR},CLEAN:{string:"Clean",color:GREY_COLOR},LOADING:{string:"Loading...",color:GREY_COLOR},ERROR:{string:"Error",color:ORANGE_COLOR},LOADING_FAILED:{string:"Loading failed",color:ORANGE_COLOR}};var EXTERNAL_LINKS=[{id:"external.dashboard",links:{NA:"https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/Runbook/StationDashboards/NA",EU:"https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/Runbook/StationDashboards/EU",FE:"https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/Runbook/StationDashboards/FE"}},{id:"external.logs",links:{NA:"https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/LogDashboard/NA",EU:"https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/LogDashboard/EU",FE:"https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/LogDashboard/FE"}}];var MCM="MCM";var TICKET="Ticket";var JUSTIFICATION="Justification";var MCM_AMAZON="mcm.amazon";var TCORP_AMAZON="t.corp.amazon";var MAX_LOGS_COUNT=300;var WSS="wss";var AUTOMATION_MQTT_TOPIC_PREFIX="site/";var AUTOMATION_MQTT_TOPIC_SUFFIX="/events";var LOGS="logs";var MAX_RECONNECT=5;var MQTT_CONNECTION_DETAILS_EXPIRY_TIMEOUT=60000;var MAX_MQTT_RECONNECTION_TIME=2000;var MQTT_ENDPOINT={BETA:{NA:"a1tgwyzzinp1f0-ats.iot.us-east-1.amazonaws.com"},GAMMA:{NA:"af9drbwk8uihp-ats.iot.us-east-1.amazonaws.com",EU:"a3jy8lc7laf3c-ats.iot.eu-west-1.amazonaws.com",FE:"a1r90n03mcgh1o-ats.iot.us-west-2.amazonaws.com",IN:"a1f3ea7b0jd1zp-ats.iot.eu-west-1.amazonaws.com"},PROD:{NA:"a2o3z9qovyp9aq-ats.iot.us-east-1.amazonaws.com",EU:"a3hm32ps5qiz7a-ats.iot.eu-west-1.amazonaws.com",FE:"a2qxo5h7xpeqx2-ats.iot.us-west-2.amazonaws.com",IN:"a1iavphz4dtx9n-ats.iot.eu-west-1.amazonaws.com"}};var AWS_REGION={NA:"us-east-1",EU:"eu-west-1",FE:"us-west-2",IN:"eu-west-1"};var MERIDIAN_ALERT_TYPE={INFO:"informational",ERROR:"error",WARN:"warning",SUCCESS:"success"};var DEVICE_TYPE_RENDER_STRING={LIDAR_CONTROLLER:"Lidar Controllers",BRANCH_NODE:"Aisle Controllers",LEAF_NODE:"Column Controllers",LIDAR_SENSOR:"Lidar Sensors"};var DEVICE_TYPE={LIDAR_CONTROLLER:"LIDAR_CONTROLLER",BRANCH_NODE:"BRANCH_NODE",LEAF_NODE:"LEAF_NODE",LIDAR_SENSOR:"LIDAR_SENSOR"};var EU_OV_LOCATION_LABEL_REGEX=new RegExp("OVER-[A-Z]\\d*-[A-Z]");var NA_OV_LOCATION_LABEL_REGEX=new RegExp("OV-([A-Z]\\d*)-([A-Z]+$)");var EU_OV_LOCATION_LABEL_REGEX_WITH_OVD=new RegExp("[A-Z]\\d*-[M-UW-Z]");var NA_OV_LOCATION_LABEL_REGEX_WITH_OVD=new RegExp("[A-Z]-\\d*\\.[M-UW-Z]");var MAC_ADDRESS_PREFIX="MAC_ADDRESS:";var UNASSIGN_PRINTER="UNASSIGN PRINTER";var UNASSIGN_VERIFICATION_CAMERA="UNASSIGN VERIFICATION CAMERA";var NO_PRINTER_ASSIGNED="NO PRINTER ASSIGNED";var NO_VERIFICATION_CAMERA_ASSIGNED="NO VERIFICATION CAMERA ASSIGNED";var BAG_TRACKING_ALLOWED_STATIONS=["DJR5"];var AUTO_LOADER_ASSET_ENABLED_STATIONS=["TST2"];// ToDo: Migrate this flag to AppConfig
var VAPR_ENABLED_STATIONS=["TST2","DEL17","DPF1","DNZ3"];var BAG_TRACKING_CONSTANTS={RECEIVE:"RECEIVE",DEPART:"DEPART",INSIDE_STATION:"Inside Station",OUTSIDE_STATION:"Outside Station",RECEIVE_TIME:"RECEIVE_TIME",DEPART_TIME:"DEPART_TIME"// Constant containing lidar sensor state values
};var LIDAR_TESTER_SENSOR_STATES={DEFAULT:1,STOW_DETECTED:2};var LOCATION_MAPPING_ATTR={LEAF_NODE_INDEX:"LEAF_NODE_INDEX",LIDAR_SENSOR_INDEX:"LIDAR_SENSOR_INDEX"/**
 * API key and account Id for Pendo
 */};var ANALYTICS_CONFIG={PENDO_AK:"ae299fdb-5276-403c-4b78-dd8b69d722d7",ACCOUNT_ID:"SCC - AMZL"};var DELETE_DEVICE_EXCLUDED_ASSET_TYPES=[/**
     * Excluded this asset type as LED Controller data is fetched from IoT Core, which is eventually consistent and
     * may not reflect deletions immediately. The logic is handled separately in the Network API with a retry mechanism.
     */LED_CONTROLLER_ASSET_TYPE// Add other excluded asset types here
];/**
 * Visual styling colors for different column types
 * Priority order: FLEX > UNIFIED_OV > REGULAR
 */var LIDAR_COLUMN_COLORS={FLEX:'#D8F2EA',// Soft minty green for flex columns
UNIFIED_OV:'#D0E1FF',// Light blue for unified OV columns  
REGULAR:'#fff',// White for regular columns
ANOMALY:'#000'// Black for anomaly/error state
};/**
 * Column dimensions
 */var LIDAR_COLUMN_DIMENSIONS={WIDE_WIDTH:'140px',// For multi-character or OV columns
NARROW_WIDTH:'70px',// For single character columns
BORDER:'0.5px solid black'// Standard border
};// LED Controller (STAG) constants
var CART_RESOURCE_TYPE="CART";var DEFAULT_PERCENTILE=30;var LOW_BATTERY_THRESHOLD=30;var DEFAULT_ANDON_COLOR_HEX="#D13212";var SBL_DASHBOARD_METRIC_PROCESS_NAME="SBL_DASHBOARD";var METRIC_GET_RESOURCE_DYNAMIC_ATTRIBUTES="getResourceDynamicAttributes";var METRIC_GET_PICK_STATION_RESOURCES="getPickStationResources";var METRIC_UPDATE_PICK_STATION_CONFIG="updatePickStationConfig";var METRIC_GET_PICK_POINT_RESOURCES="getPickPointResources";var METRIC_UPDATE_RETRIEVER_LOCATION_MAPPING="updateRetrieverLocationMapping";var PICK_STATION_STATUS={ENABLED:"ENABLED",DISABLED:"DISABLED"};var PICK_STATION_STATUSES=[PICK_STATION_STATUS.ENABLED,PICK_STATION_STATUS.DISABLED];var PICK_STATION_STATUS_COLOR={ENABLED:"#1d8102",DISABLED:"#d13212"};var PICK_ITEM_TYPE={BAG:"BAG",PACKAGE:"PACKAGE"};var PICK_ITEM_TYPES=[PICK_ITEM_TYPE.BAG,PICK_ITEM_TYPE.PACKAGE];var RESOURCE_DYNAMIC_ATTRIBUTES_KEY="resourceDynamicAttributes";var DEFAULT_DURATION=10;var DEFAULT_SORT_COLUMN="scannableId";var LIGHT_COMMAND_ON="ON";var LIGHT_COMMAND_OFF="OFF";var ANDON_PROCESS_NAME="SBL_ANDON";var METRIC_PUBLISH_LIGHT_COMMAND="publishLightCommand";// Max concurrent requests per batch to avoid throttling the publishLightCommand API.
// TODO: Confirm TPS limit with the thin client backend team and adjust accordingly.
var DEFAULT_ANDON_BATCH_SIZE=10;var BATTERY_COLUMN="battery";var FLOOR_LOCATION_COLUMN="floorLocation";var VERSION_COLUMN="version";var PROMISE_FULFILLED="fulfilled";var SBL_FILTER_COLUMNS=[{key:DEFAULT_SORT_COLUMN,label:'Cart ID'},{key:VERSION_COLUMN,label:'Version'},{key:FLOOR_LOCATION_COLUMN,label:'Location'}];var SBL_DASHBOARD_ACTIONS={LOAD_VIEW:"LOAD_VIEW",RECEIVE_CONFIG:"RECEIVE_CONFIG",RECEIVE_DATA:"RECEIVE_DATA",RECEIVE_ERROR:"RECEIVE_ERROR",SORT_DATA:"SORT_DATA"};var ANDON_COLORS=[{value:"RED",label:"Red",hex:"#D13212"},{value:"YELLOW",label:"Yellow",hex:"#F2B705"},{value:"GREEN",label:"Green",hex:"#1D8102"},{value:"BLUE",label:"Blue",hex:"#0073BB"},{value:"WHITE",label:"White",hex:"#FFFFFF"}];var TIMER_OPTIONS=[{value:5,label:"5 minutes"},{value:10,label:"10 minutes"},{value:15,label:"15 minutes"},{value:30,label:"30 minutes"},{value:60,label:"60 minutes"}];// CartFilterPanel constants
var CART_FILTER_PANEL_STRINGS={SHOWING_BOTTOM:"cartFilter.showingBottom",SHOWING_BOTTOM_DEFAULT:"Showing Bottom {threshold}% — Click to Show All",SHOW_ALL:"cartFilter.showAll",SHOW_ALL_DEFAULT:"Show All Carts",SELECT_BOTTOM:"cartFilter.selectBottom",SELECT_BOTTOM_DEFAULT:"Filter carts to charge",CART_COUNT_FILTERED:"cartFilter.cartCountFiltered",CART_COUNT_FILTERED_DEFAULT:"{matchCount} of {totalCount} carts match",CART_COUNT:"cartFilter.cartCount",CART_COUNT_DEFAULT:"{matchCount} of {totalCount} carts",PERCENTILE_THRESHOLD:"cartFilter.percentileThreshold",PERCENTILE_THRESHOLD_DEFAULT:"Percentile threshold configured at station level: {threshold}%",TOGGLE_FILTER_ARIA:"cartFilter.toggleFilterAria",TOGGLE_FILTER_ARIA_DEFAULT:"Toggle bottom percentile cart filter"};

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCustomElementWrapper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrimitive__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forEach__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pickBy__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isEventHandler__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isReactFalsy__ = __webpack_require__(1429);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






/**
 * Common React props and their corresponding html attributes. React doesn't
 * special case these props for custom elements, so we must do the mapping
 * ourselves.
 */
var COMMON_PROPS = {
    className: 'class',
    htmlFor: 'for',
    tabIndex: 'tabindex',
};
/**
 * Create a React wrapper around a custom element.
 *
 * @prop tag The name of the custom component. Should contain a hyphen.
 * @prop displayName The display name to give this component that will show up
 *     in devtools.
 * @prop attributeMap A mapping from the prop keys expected by react to the
 *     attribute names expected by the custom element.
 * @prop eventMap A mapping of the event names expected by react (e.g. onClick)
 *     to the custom event which should trigger the event handler.
 * @template Element The type of custom element being wrapped.
 * @template Props The React props expected by this component.
 */
function createCustomElementWrapper(tag, displayName, attributeMap, eventMap, slots) {
    if (attributeMap === void 0) { attributeMap = {}; }
    if (eventMap === void 0) { eventMap = {}; }
    if (slots === void 0) { slots = []; }
    var isSlot = function (name) { return slots.indexOf(name) !== -1; };
    var eventNames = Object.keys(eventMap);
    var extractEvents = function (props) {
        return eventNames.map(function (name) { return props[name]; });
    };
    /**
     * The react property names and the value they should be converted to
     * before passing as props to the custom element.
     */
    attributeMap = __assign(__assign({}, attributeMap), COMMON_PROPS);
    var WrappedComponent = __WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](function (_a, ref) {
        var children = _a.children, props = __rest(_a, ["children"]);
        /** The ref we will pass to the underlying custom element. */
        var componentRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
        /**
         * A mapping of props which should be attached as html properties. It is
         * updated on the fly and allows a rich property to be set to null at a
         * later time.
         */
        var knownProperties = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]({});
        var setProperty = function (key, value) {
            var curr = componentRef.current;
            // some of our non-lit components don't check to see if properties have
            // actually changed, and can end up firing events and causing infinite
            // loops in React apps. We make sure to only update properties that have
            // changed here.
            if (curr[key] !== value) {
                curr[key] = value;
            }
        };
        /**
         * Extract from props those that must be attached to the custom element as
         * a property. This includes all rich data, such as objects and arrays.
         * Props that match React's event naming convention are also ignored so
         * they can be attached as React props. Slots are also ignored, since they
         * end up part of the `children` of the component.
         *
         * The knownProperties map will be updated with any new properties
         * encountered, so that these can *always* be attached as props. This
         * makes it so that if a property is later set to `null` or `undefined`,
         * it won't switch to an attribute, but stay a property.
         */
        var getAndUpdateKnownProperties = function () {
            var isProperty = function (key, value) {
                return !(key in eventMap) &&
                    !Object(__WEBPACK_IMPORTED_MODULE_4__isEventHandler__["a" /* default */])(key) &&
                    // slots are handled specially at render
                    !isSlot(key) &&
                    (key in knownProperties.current || !Object(__WEBPACK_IMPORTED_MODULE_1__isPrimitive__["a" /* default */])(value));
            };
            var properties = __assign(__assign({}, knownProperties.current), Object(__WEBPACK_IMPORTED_MODULE_3__pickBy__["a" /* default */])(props, isProperty));
            Object.keys(properties).forEach(function (prop) {
                knownProperties.current[prop] = null;
            });
            return properties;
        };
        /**
         * Pulls the values from props that are neither properties nor custom
         * events, and converts their keys using the `attributeMap`. These values
         * are okay to pass as props through React. This also filters out falsy
         * props due to the way the underlying custom elements handle them. They
         * typically check for the presence of an attribute rather than its value,
         * so even setting to false will trigger a presence check to be true,
         * essentially always enabling that value. Filtering them out gives us the
         * correct behavior.
         */
        var getAttributeProps = function () {
            var isAttribute = function (key, value) {
                // slots are handled specially at render
                return !isSlot(key) &&
                    !(key in knownProperties.current) &&
                    !(key in eventMap) &&
                    !Object(__WEBPACK_IMPORTED_MODULE_5__isReactFalsy__["a" /* default */])(value) &&
                    // only allow primitives & event handlers
                    (Object(__WEBPACK_IMPORTED_MODULE_1__isPrimitive__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_4__isEventHandler__["a" /* default */])(key));
            };
            return Object(__WEBPACK_IMPORTED_MODULE_3__pickBy__["a" /* default */])(props, isAttribute, function (k) { return attributeMap[k] || k; });
        };
        // set up event listeners
        __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
            var removeEventFns = eventNames.map(function (propName) {
                var eventCb = props[propName];
                if (eventCb) {
                    var event_1 = eventMap[propName];
                    componentRef.current.addEventListener(event_1, eventCb);
                    return function () {
                        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                        componentRef.current &&
                            componentRef.current.removeEventListener(event_1, eventCb);
                    };
                }
            });
            return function () {
                removeEventFns.forEach(function (fn) {
                    // TODO: optional chain breaks @size-limit check, and latest version
                    // has dropped node 8 support
                    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                    fn && fn();
                });
            };
            // only update events if any of the passed in event handlers have changed
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, extractEvents(props));
        /**
         * Determine which props should be set as properties on the custom element
         * and set them.
         */
        __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
            var properties = getAndUpdateKnownProperties();
            Object(__WEBPACK_IMPORTED_MODULE_2__forEach__["a" /* default */])(properties, setProperty);
        });
        /**
         * This allows us to attach multiple refs to a single component
         */
        var refMux = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (e) {
            componentRef.current = e;
            if (ref) {
                if (typeof ref === 'function') {
                    ref(e);
                }
                else {
                    ref.current = e;
                }
            }
        }, [ref]);
        var slotChildren = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(children);
        slots.forEach(function (slot, i) {
            var prop = props[slot];
            if (prop) {
                slotChildren.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span', { key: i, slot: slot }, prop));
            }
        });
        var attributeProps = getAttributeProps();
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](tag, __assign(__assign({}, attributeProps), { ref: refMux }), slotChildren);
    });
    WrappedComponent.displayName = displayName;
    return WrappedComponent;
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return injectIntl; });
/* unused harmony export defineMessages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IntlProvider; });
/* unused harmony export FormattedDate */
/* unused harmony export FormattedTime */
/* unused harmony export FormattedRelative */
/* unused harmony export FormattedNumber */
/* unused harmony export FormattedPlural */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormattedMessage; });
/* unused harmony export FormattedHTMLMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache__ = __webpack_require__(708);
/*
 * Copyright 2019, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */










// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

function createError(message, exception) {
  var eMsg = exception ? '\n' + exception : '';
  return '[React Intl] ' + message + eMsg;
}

function defaultErrorHandler(error) {
  if (false) {
    console.error(error);
  }
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_6_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this._wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? /* istanbul ignore next */function (ref) {
            return _this2._wrappedInstance = ref;
          } : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(InjectIntl, WrappedComponent);
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds['second-short'] = newThresholds['second-short'];
  thresholds['minute-short'] = newThresholds['minute-short'];
  thresholds['hour-short'] = newThresholds['hour-short'];
  thresholds['day-short'] = newThresholds['day-short'];
  thresholds['month-short'] = newThresholds['month-short'];
}

function getNamedFormat(formats, type, name, onError) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  onError(createError('No ' + type + ' format named: ' + name));
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting date.', e));
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting time.', e));
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError('Error formatting relative time.', e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting number.', e));
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting plural.', e));
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // Produce a better error if the user calls `intl.formatMessage(element)`

  if (false) {
    invariant(!isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
  }

  // `id` is a required field of a Message Descriptor.
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
  } else {
    // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id + '"', e));
    }
  }

  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {},

  onError: defaultErrorHandler
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.DateTimeFormat),
      getNumberFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.NumberFormat),
      getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats,
            onError = _config.onError;


        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (false) {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }
  return formatMessage({}, { getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a) }, descriptor, values);
};

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.context.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;

      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return chainWalk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return getRandomInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return sortComparator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return isValid; });
/* unused harmony export prettyLog */
/* unused harmony export areObjectsDifferent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return deepCopyObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getDownloadFileName; });
/* unused harmony export paginationHelper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return createDownloadableFile; });
/* harmony export (immutable) */ __webpack_exports__["_14"] = getTimestampNow;
/* unused harmony export getTime */
/* harmony export (immutable) */ __webpack_exports__["K"] = getDateInIsoFormat;
/* harmony export (immutable) */ __webpack_exports__["D"] = getAssetRefreshInterval;
/* harmony export (immutable) */ __webpack_exports__["S"] = getLidarControllerManageByExceptionsRefreshInterval;
/* harmony export (immutable) */ __webpack_exports__["_11"] = getStatusRefreshInterval;
/* harmony export (immutable) */ __webpack_exports__["_1"] = getRFIDStatusRefreshInterval;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getCurrentFormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getFormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return isTimestampWithinHours; });
/* harmony export (immutable) */ __webpack_exports__["_21"] = logOperationalMetric;
/* unused harmony export publishToCSM */
/* unused harmony export publishErrorToCSM */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return getNodeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return getObjectKeyForMHEValidationReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return getMHEValidationFormatDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return getMacWithoutColon; });
/* unused harmony export createRequest */
/* harmony export (immutable) */ __webpack_exports__["A"] = getAPIGatewayPostRequest;
/* harmony export (immutable) */ __webpack_exports__["z"] = getAPIGatewayGetRequest;
/* harmony export (immutable) */ __webpack_exports__["_4"] = getSDSAPIGatewayPostRequest;
/* harmony export (immutable) */ __webpack_exports__["_3"] = getSDSAPIGatewayGetRequest;
/* harmony export (immutable) */ __webpack_exports__["_24"] = publishCountToCSM;
/* harmony export (immutable) */ __webpack_exports__["o"] = convertTableJsonToAsset;
/* harmony export (immutable) */ __webpack_exports__["q"] = convertTableJsonToEdgeGatewayAsset;
/* harmony export (immutable) */ __webpack_exports__["p"] = convertTableJsonToAssetForTrafficLight;
/* harmony export (immutable) */ __webpack_exports__["r"] = convertTableJsonToRequestForNDMS;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return renderElementSeparator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return getUTRRegion; });
/* unused harmony export getUTRStage */
/* unused harmony export AlertTesting */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return assetTypeToConfigTypeDict; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getCurrentDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return formatTimestampToReadable; });
/* harmony export (immutable) */ __webpack_exports__["v"] = formatDate;
/* unused harmony export macToThingName */
/* harmony export (immutable) */ __webpack_exports__["_33"] = thingNameToMac;
/* harmony export (immutable) */ __webpack_exports__["n"] = convertMacToCoreDeviceName;
/* harmony export (immutable) */ __webpack_exports__["i"] = checkNullAndUndefinedAttribute;
/* harmony export (immutable) */ __webpack_exports__["_16"] = getVlan;
/* harmony export (immutable) */ __webpack_exports__["_10"] = getStartEndAisleFromMappings;
/* harmony export (immutable) */ __webpack_exports__["T"] = getLocationFromAssetMappings;
/* harmony export (immutable) */ __webpack_exports__["C"] = getAssetLabelFromMac;
/* harmony export (immutable) */ __webpack_exports__["_34"] = toParentAssetLabel;
/* harmony export (immutable) */ __webpack_exports__["_22"] = macFromParentAssetLabel;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return getSorterConfigLocationStringForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getAutoLoaderConfigLocationStringForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return getStowConfigScannableList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return getShippingIdFromScannableList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return getTestConfigKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return getPickStationsValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return getSorterConfigKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getAutoLoaderConfigKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return getSortedListWithOther; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getADTFSorterConfigKey; });
/* harmony export (immutable) */ __webpack_exports__["l"] = compressSorterConfig;
/* harmony export (immutable) */ __webpack_exports__["k"] = compressAutoLoaderConfig;
/* harmony export (immutable) */ __webpack_exports__["u"] = flattenADTFSorterConfig;
/* harmony export (immutable) */ __webpack_exports__["m"] = convertADTFSorterConfigIntoDBFormat;
/* harmony export (immutable) */ __webpack_exports__["_31"] = sortAlphaNumeric;
/* harmony export (immutable) */ __webpack_exports__["h"] = checkInactiveOrDeprecatedAsset;
/* harmony export (immutable) */ __webpack_exports__["g"] = checkHealthStatusForDeletion;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return versionString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getAliasFromParent; });
/* harmony export (immutable) */ __webpack_exports__["j"] = checkValidLink;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return setAliasToRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return setAliasToTriggerMHEValidationRequest; });
/* unused harmony export isOneBox */
/* harmony export (immutable) */ __webpack_exports__["_17"] = isResponseCode5xx;
/* harmony export (immutable) */ __webpack_exports__["V"] = getMQTTClientConfig;
/* harmony export (immutable) */ __webpack_exports__["G"] = getAutomationMQTTTopic;
/* harmony export (immutable) */ __webpack_exports__["_26"] = renderMHELogsTableHeader;
/* harmony export (immutable) */ __webpack_exports__["_27"] = renderMHELogsTableRow;
/* unused harmony export getHeaderText */
/* unused harmony export getBodyText */
/* unused harmony export getBoldBodyText */
/* harmony export (immutable) */ __webpack_exports__["x"] = generateFileName;
/* harmony export (immutable) */ __webpack_exports__["P"] = getFormattedTimestamp;
/* harmony export (immutable) */ __webpack_exports__["R"] = getInstallationTypes;
/* harmony export (immutable) */ __webpack_exports__["Q"] = getInstallationTypeValues;
/* harmony export (immutable) */ __webpack_exports__["Z"] = getOrdinal;
/* harmony export (immutable) */ __webpack_exports__["H"] = getChildDeviceBySubType;
/* unused harmony export getDeviceAndTabInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return publishAlchemyAnalytics; });
/* harmony export (immutable) */ __webpack_exports__["N"] = getFloorsWithMultipleAssignedSlides;
/* harmony export (immutable) */ __webpack_exports__["_7"] = getSorterConfigForInstallationType;
/* harmony export (immutable) */ __webpack_exports__["M"] = getFloorsForSlide;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return renderStatusWithIcon; });
/* harmony export (immutable) */ __webpack_exports__["_18"] = isSensorLevelConfigEnabledForLidarController;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_BAG_TRACKING_ALLOWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_AUTO_LOADER_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IS_VAPR_ENABLED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handler_ParentDataHandler__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_format__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FeatureUtility__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__resources_EmployeeResource__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_alchemy_components_dist_utils_AlchemyAnalytics_es5_js__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_alchemy_components_dist_utils_AlchemyAnalytics_es5_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_alchemy_components_dist_utils_AlchemyAnalytics_es5_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_check_circle_filled__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_check_circle_filled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_check_circle_filled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_close_medium__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_close_medium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_close_medium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_alert__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_info__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_info__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function getTimeDiff(time){return Date.now()-time;}var metricTypeEnum={COUNT:"count",TIME:"time"};var chainWalk=function chainWalk(func,defaultValue){try{var value=func();return isValid(value)?value:defaultValue;}catch(e){return defaultValue;}};var getRandomInt=function getRandomInt(max){return Math.floor(Math.random()*max);};var sortComparator=function sortComparator(a,b){if(a<b)return-1;else if(a>b)return 1;else return 0;};var isValid=function isValid(value){return!(value===null||value===undefined);};var prettyLog=function prettyLog(data){console.log(JSON.stringify(data,null,2));};var areObjectsDifferent=function areObjectsDifferent(value,value2){return JSON.stringify(value)===JSON.stringify(value2);};var deepCopyObject=function deepCopyObject(data){return JSON.parse(JSON.stringify(data));};var zeroPad=function zeroPad(num,padding){return String(num).padStart(padding||2,'0');};var getDownloadFileName=function getDownloadFileName(configType){var date=new Date();var yr=zeroPad(date.getFullYear(),4);var month=zeroPad(date.getMonth()+1);var day=zeroPad(date.getDay());var hr=zeroPad(date.getHours());var min=zeroPad(date.getMinutes());var sec=zeroPad(date.getSeconds());if(configType in __WEBPACK_IMPORTED_MODULE_1__Constants__["_4" /* CONFIG_TYPE */]){return __WEBPACK_IMPORTED_MODULE_1__Constants__["_5" /* CONFIG_TYPE_VALUE */][configType].replace(/ /g,'_')+"_"+yr+"-"+month+"-"+day+"_"+hr+"-"+min+"-"+sec+".csv";}return"download.csv";};/**
 * Returns the sliced array based on numberOfRowsPerPage and currentPage selected
 * @param data array
 * @param currentPage
 * @param numberOfRowsPerPage
 * @param componentHandler
 * @return array
 */var paginationHelper=function paginationHelper(data,currentPage,numberOfRowsPerPage,componentHandler){if(!data)return null;var startIndex=(currentPage-1)*numberOfRowsPerPage;var endIndex=currentPage*numberOfRowsPerPage;return data.slice(startIndex,endIndex).map(function(instance,index){return componentHandler(instance,startIndex+index+1,index);});};var createDownloadableFile=function createDownloadableFile(filename,text){var element=document.createElement('a');element.setAttribute('href','data:text/plain;charset=utf-8,'+encodeURIComponent(text));element.setAttribute('download',filename);element.style.display='none';document.body.appendChild(element);element.click();document.body.removeChild(element);};function getTimestampNow(){return new Date().getTime();}function getTime(time){if(time==null||time===''){return'';}var date=new Date(time);var hour=date.getHours();var minutes=date.getMinutes();return(hour<10?'0'+hour:hour)+":"+(minutes<10?'0'+minutes:minutes);}function getDateInIsoFormat(date){return Object(__WEBPACK_IMPORTED_MODULE_9_date_fns_format__["default"])(date,"yyyy-MM-dd");}/**
 * This method return the refresh interval in milliseconds for asset details from NARC
 * @returns {number}
 */function getAssetRefreshInterval(){return 5*60*1000;}/**
 * This method return the refresh interval in milliseconds for Manage By Exceptions tab of Lidar Controller
 * @returns {number}
 */function getLidarControllerManageByExceptionsRefreshInterval(){return 10*1000;}/**
 * This method return the refresh interval in milliseconds for status details for assets
 * @returns {number}
 */function getStatusRefreshInterval(){return 2*60*1000;}/**
 * This method return the refresh interval in milliseconds for status details for RFID Bag assets
 * @returns {number}
 */function getRFIDStatusRefreshInterval(){return 30*1000;}/**
 * Returns the current time in format [ MonthName dd, YYYY, HH:MM:SS GMT+__:__ ]
 * This pattern may slightly change according to current locale.
 * @param locale
 * @return string
 */var getCurrentFormattedTime=function getCurrentFormattedTime(locale){var currentDate=new Date();return new Intl.DateTimeFormat(locale,__WEBPACK_IMPORTED_MODULE_1__Constants__["_7" /* DATE_TIME_FORMAT */]).format(currentDate);};var getFormattedTime=function getFormattedTime(locale,timeStamp){var date=new Date(parseFloat(timeStamp));return new Intl.DateTimeFormat(locale,__WEBPACK_IMPORTED_MODULE_1__Constants__["_7" /* DATE_TIME_FORMAT */]).format(date);};var isTimestampWithinHours=function isTimestampWithinHours(timestampUTC,numberOfHours){if(!timestampUTC){return false;}var millisecondsInAnHour=60*60*1000;return timestampUTC>=getTimestampNow()-numberOfHours*millisecondsInAnHour;};function logOperationalMetric(startTime,processName,metricName,isSuccess,isFault){isSuccess?publishToCSM({startTime:startTime,processName:processName,metricName:metricName}):publishErrorToCSM({processName:processName,metricName:metricName,isFault:isFault});}function publishToCSM(args){var metricValue=getTimeDiff(args.startTime);var countMetricReq=publishClientSideMetricsRequest(args.processName,args.metricName,1,metricTypeEnum.COUNT);var timeMetricReq=publishClientSideMetricsRequest(args.processName,args.metricName,metricValue,metricTypeEnum.TIME);Object(__WEBPACK_IMPORTED_MODULE_2__handler_ParentDataHandler__["h" /* publishClientSideMetrics */])(countMetricReq);Object(__WEBPACK_IMPORTED_MODULE_2__handler_ParentDataHandler__["h" /* publishClientSideMetrics */])(timeMetricReq);}function publishErrorToCSM(args){var countMetricReq=null;if(args.isFault===true){countMetricReq=publishClientSideMetricsRequest(args.processName,args.metricName+"Fault",1,metricTypeEnum.COUNT);}else{countMetricReq=publishClientSideMetricsRequest(args.processName,args.metricName+"Error",1,metricTypeEnum.COUNT);}Object(__WEBPACK_IMPORTED_MODULE_2__handler_ParentDataHandler__["h" /* publishClientSideMetrics */])(countMetricReq);}function publishClientSideMetricsRequest(processName,metricName,metricValue,metricType){if(isOneBox()){return{processName:processName+"_ONEBOX",metricName:metricName,metricValue:metricValue,metricType:metricType};}else{return{processName:processName,metricName:metricName,metricValue:metricValue,metricType:metricType};}}var getNodeId=function getNodeId(){var queryParams=new URLSearchParams(window.location.search);return queryParams.get('stationCode');};var getObjectKeyForMHEValidationReport=function getObjectKeyForMHEValidationReport(device,start,end){return getNodeId()+"_"+device.assetType+"_"+device.name+"_"+getMHEValidationFormatDate(start)+"_to_"+getMHEValidationFormatDate(end)+".csv";};var getMHEValidationFormatDate=function getMHEValidationFormatDate(time){var date=new Date(time).toISOString();// Sample ISO String - 2024-01-04T03:03:00.000Z
var year=date.substring(__WEBPACK_IMPORTED_MODULE_1__Constants__["_94" /* ISO_STRING_YEAR_START_INDEX */],__WEBPACK_IMPORTED_MODULE_1__Constants__["_93" /* ISO_STRING_YEAR_END_INDEX */]);var month=date.substring(__WEBPACK_IMPORTED_MODULE_1__Constants__["_91" /* ISO_STRING_MONTH_START_INDEX */],__WEBPACK_IMPORTED_MODULE_1__Constants__["_90" /* ISO_STRING_MONTH_END_INDEX */]);var day=date.substring(__WEBPACK_IMPORTED_MODULE_1__Constants__["_88" /* ISO_STRING_DAY_START_INDEX */],__WEBPACK_IMPORTED_MODULE_1__Constants__["_87" /* ISO_STRING_DAY_END_INDEX */]);var isoTime=date.substring(__WEBPACK_IMPORTED_MODULE_1__Constants__["_92" /* ISO_STRING_TIME_START_INDEX */],__WEBPACK_IMPORTED_MODULE_1__Constants__["_89" /* ISO_STRING_MINUTES_END_INDEX */]);return day+"-"+month+"-"+year+" "+isoTime;};var getMacWithoutColon=function getMacWithoutColon(mac){return mac?mac.replaceAll(':',''):mac;};function createRequest(processName,endPoint,requestBody){return{processName:processName,endPoint:endPoint,request:JSON.stringify(requestBody)};}function getAPIGatewayPostRequest(request,resourcePath){var _Object$assign;return{resourcePath:resourcePath,httpMethod:"post",processName:"deviceManagement",requestBody:Object.assign({},request,(_Object$assign={},_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_1__Constants__["_198" /* TCP_PERMISSIONS */],true),_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_1__Constants__["_215" /* USER_LOGIN */],true),_Object$assign))};}function getAPIGatewayGetRequest(resourcePath){var _requestBody;return{resourcePath:resourcePath,httpMethod:"get",processName:"deviceManagement",requestBody:(_requestBody={},_defineProperty(_requestBody,__WEBPACK_IMPORTED_MODULE_1__Constants__["_198" /* TCP_PERMISSIONS */],true),_defineProperty(_requestBody,__WEBPACK_IMPORTED_MODULE_1__Constants__["_215" /* USER_LOGIN */],true),_requestBody)};}function getSDSAPIGatewayPostRequest(request,resourcePath){var _Object$assign2;return{resourcePath:resourcePath,httpMethod:"post",processName:__WEBPACK_IMPORTED_MODULE_1__Constants__["_189" /* SPIDER_DEPLOYMENT_SERVICE */],requestBody:Object.assign({},request,(_Object$assign2={},_defineProperty(_Object$assign2,__WEBPACK_IMPORTED_MODULE_1__Constants__["_198" /* TCP_PERMISSIONS */],true),_defineProperty(_Object$assign2,__WEBPACK_IMPORTED_MODULE_1__Constants__["_215" /* USER_LOGIN */],true),_Object$assign2))};}function getSDSAPIGatewayGetRequest(request,resourcePath){var _Object$assign3;return{resourcePath:resourcePath,httpMethod:"get",processName:__WEBPACK_IMPORTED_MODULE_1__Constants__["_189" /* SPIDER_DEPLOYMENT_SERVICE */],requestBody:Object.assign({},request,(_Object$assign3={},_defineProperty(_Object$assign3,__WEBPACK_IMPORTED_MODULE_1__Constants__["_198" /* TCP_PERMISSIONS */],true),_defineProperty(_Object$assign3,__WEBPACK_IMPORTED_MODULE_1__Constants__["_215" /* USER_LOGIN */],true),_Object$assign3))};}function publishCountToCSM(args){var countMetricReq=publishClientSideMetricsRequest(args.processName,args.metricName,1,metricTypeEnum.COUNT);Object(__WEBPACK_IMPORTED_MODULE_2__handler_ParentDataHandler__["h" /* publishClientSideMetrics */])(countMetricReq);}function convertTableJsonToAsset(stateValues,assetType,assetStatus,assetSubType){var vendorAttributes=stateValues.vendorAttributes||__WEBPACK_IMPORTED_MODULE_1__Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */];delete stateValues.vendorAttributes;var parentAssetLabel=stateValues.parentAssetLabel;delete stateValues.parentAssetLabel;return{"assetDetails":{"assetLabel":{"type":"MAC_ADDRESS","value":stateValues.mac},"nodeId":getNodeId(),"assetType":assetType,"assetSubType":assetSubType,assetAttributes:stateValues,vendorAttributes:vendorAttributes,"assetStatus":assetStatus,"parentAssetLabel":parentAssetLabel}};}function convertTableJsonToEdgeGatewayAsset(assetAttributes,assetType,assetStatus,device){return{"assetDetails":{"assetLabel":{"type":"MAC_ADDRESS","value":device.mac},"nodeId":getNodeId(),"assetType":assetType,assetAttributes:assetAttributes,"assetStatus":assetStatus}};}function convertTableJsonToAssetForTrafficLight(assetDetails,assetType,assetStatus){return{"assetDetails":{"assetLabel":{"type":"MAC_ADDRESS","value":assetDetails.assetAttributes.mac},"nodeId":getNodeId(),"assetType":assetType,"assetAttributes":assetDetails.assetAttributes,"assetStatus":assetStatus},"assetMappings":assetDetails.assetMappings};}function convertTableJsonToRequestForNDMS(index,assetDetails){return{"label":assetDetails.assetMappings[index].mappedResourceLabel,"color":assetDetails.assetMappings[index].mappingAttributes.color,"wave":parseInt(assetDetails.assetMappings[index].mappingAttributes.wave,10),"nodeId":getNodeId()};}var renderElementSeparator=function renderElementSeparator(){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,null," | ");};var getUTRRegion=function getUTRRegion(){var location=window.location.href;var region="NA";if(location.includes("ui-na")){region="NA";}else if(location.includes("ui-in")){region="IN";}else if(location.includes("ui-eu")){region="EU";}else if(location.includes("ui-jp")){region="FE";}return region;};var getUTRStage=function getUTRStage(){var location=window.location.href;var stage=__WEBPACK_IMPORTED_MODULE_1__Constants__["_190" /* STAGE */].PROD;if(location.includes("ui-beta")){stage=__WEBPACK_IMPORTED_MODULE_1__Constants__["_190" /* STAGE */].BETA;}else if(location.includes("ui-gamma")||location.includes("localhost")){stage=__WEBPACK_IMPORTED_MODULE_1__Constants__["_190" /* STAGE */].GAMMA;}return stage;};var AlertTesting=function AlertTesting(){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_alert___default.a,{size:"small",type:"informational"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"alert.testing",defaultMessage:"No Testing Setup present."}));};var AlertConfiguration=function AlertConfiguration(){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_alert___default.a,{size:"small",type:"informational"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"alert.configuration",defaultMessage:"No Configuration Setup present."}));};var assetTypeToConfigTypeDict={typeADTA:__WEBPACK_IMPORTED_MODULE_1__Constants__["c" /* ADTA_ASSET_TYPE */],typeADTF:__WEBPACK_IMPORTED_MODULE_1__Constants__["e" /* ADTF_ASSET_TYPE */],typeASL:__WEBPACK_IMPORTED_MODULE_1__Constants__["K" /* ASL_ASSET_TYPE */],typeZANCASORT:__WEBPACK_IMPORTED_MODULE_1__Constants__["_222" /* ZANCASORT_ASSET_TYPE */],typeTESSERACT:__WEBPACK_IMPORTED_MODULE_1__Constants__["_200" /* TESSERACT_ASSET_TYPE */],typeAUTO_RETRIEVER:__WEBPACK_IMPORTED_MODULE_1__Constants__["S" /* AUTO_RETRIEVER_ASSET_TYPE */],typeAUTO_LOADER:__WEBPACK_IMPORTED_MODULE_1__Constants__["R" /* AUTO_LOADER_ASSET_TYPE */],typeTC:__WEBPACK_IMPORTED_MODULE_1__Constants__["_201" /* THIN_CLIENT_ASSET_TYPE */],typeASML:__WEBPACK_IMPORTED_MODULE_1__Constants__["L" /* ASML_ASSET_TYPE */],typeVAPR:__WEBPACK_IMPORTED_MODULE_1__Constants__["_218" /* VAPR_ASSET_TYPE */]};var getCurrentDate=function getCurrentDate(){return new Date().getTime();};/**
 * Convert an epoch timestamp (milliseconds) string to a human-readable local date-time string.
 * Expected input format: epoch millis as string, e.g. "1771402357714"
 * Output format adapts to user's browser locale, e.g. "Mar 10, 17:31 PST"
 * Returns empty string if the input is falsy or invalid.
 *
 * @param {string} epochMillis - Epoch timestamp in milliseconds as a string
 * @returns {string} Formatted date-time string or empty string
 */var formatTimestampToReadable=function formatTimestampToReadable(epochMillis){if(!epochMillis)return"";var date=new Date(Number(epochMillis));if(isNaN(date.getTime()))return"";return date.toLocaleString(undefined,{month:"short",day:"numeric",hour:"2-digit",minute:"2-digit",hour12:false,timeZoneName:"short"});};function formatDate(inputDate){// Convert yyyy-MM-dd to MM/dd/yyyy
var date=new Date(inputDate);if(!isNaN(date.getTime())){// Months use 0 index.
return date.getMonth()+1+'/'+date.getDate()+'/'+date.getFullYear();}}// convert mac address ab:ab:ab:ab:ab to thingName tc-ababababab-DBE2_Core
function macToThingName(mac){return"tc-"+mac.replace(/:/g,'')+"-"+getNodeId()+"_Core";}// convert thingName tc-ababababab-DBE2_Core format to mac address ab:ab:ab:ab:ab
function thingNameToMac(thingName){return thingName.split("-")[1].replace(/(..)/g,'$1:').slice(0,-1);}// convert mac address ab:ab:ab:ab:ab to CoreDeviceName spider-ababababab-dbe2
function convertMacToCoreDeviceName(mac){return"spider-"+mac.replace(/:/g,'')+"-"+getNodeId().toLowerCase();}// null and undefined check: return true if not null/undefined and false otherwise
function checkNullAndUndefinedAttribute(attributeName){return!(!attributeName||Object.keys(attributeName).length===0||Object.getPrototypeOf(attributeName)===Object.prototype);}// converts ethernet IP address to VLAN number
function getVlan(ethernetIp){if(ethernetIp){if(ethernetIp.startsWith('192')){// AEN
if(ethernetIp.startsWith('192.168.85')){return'740';}else if(ethernetIp.startsWith('192.168.10.')){return'702';}}else if(ethernetIp.startsWith('10.')){// N19
// Reference: https://w.amazon.com/bin/view/OTIE/N19/Vlans/#IP_Allocation_for_Pod_Based_Network_Stacks_.28golfballv2.2C_tennisball.2C_etc..29
var octets=ethernetIp.split('.');if(octets[1]==='1'&&Number(octets[2])>=64&&Number(octets[2])<96||['88','89','90','91'].includes(octets[2])){return'740';}else if(octets[1]==='32'||octets[1]==='129'&&Number(octets[2])>=0&&Number(octets[2])<128||Number(octets[1])-1%16===0&&Number(octets[2])>=0&&Number(octets[2])<32){// 10.129.0/19
// 10.Nx16+1.0/19
// 10.129.0/17
// 10.32.0/16
return'702';}}}return'Unknown';}// Derives the start and end aisle labels from asset mappings by reading the
// columnAddress prefix (branch index). Branch 1 is always the start aisle.
// Returns {startAisleLabel, endAisleLabel} or null if unable to determine.
function getStartEndAisleFromMappings(assetMappings){var startAisle=null;var endAisle=null;var minBranch=Infinity;var maxBranch=-Infinity;assetMappings.forEach(function(mapping){if(mapping.mappedResourceLabel&&mapping.mappingAttributes){try{var columns=JSON.parse(mapping.mappingAttributes.mappedColumns);var col=columns.find(function(c){return c&&c.columnAddress;});if(col){var branchIndex=parseInt(String(col.columnAddress).split('.')[0],10);if(!isNaN(branchIndex)){if(branchIndex<minBranch){minBranch=branchIndex;startAisle=mapping.mappedResourceLabel;}if(branchIndex>maxBranch){maxBranch=branchIndex;endAisle=mapping.mappedResourceLabel;}}}}catch(e){console.error("Error parsing mappedColumns in getStartEndAisleFromMappings:",e);}}});if(!startAisle||!endAisle)return null;return{startAisleLabel:startAisle,endAisleLabel:endAisle};}function getLocationFromAssetMappings(assetMappings){var result=getStartEndAisleFromMappings(assetMappings);if(result){return result.startAisleLabel+" to "+result.endAisleLabel;}// Fallback: if can't determine from columnAddress, use sorted (old behavior)
var aisleLabels=[];assetMappings.forEach(function(mapping){if(mapping.mappedResourceLabel){aisleLabels.push(mapping.mappedResourceLabel);}});aisleLabels=sortAlphaNumeric(aisleLabels);if(aisleLabels.length===0)return null;return aisleLabels[0]+" to "+aisleLabels[aisleLabels.length-1];}function getAssetLabelFromMac(mac){return{type:"MAC_ADDRESS",value:mac};}/**
 * Builds the parentAssetLabel to store on an asset from the parent's mac address.
 *
 * Lowercased because the parent asset's own MAC_ADDRESS label is stored lowercase, and consumers look the parent up
 * by an exact label match - an uppercase value entered through the mask would be a silent lookup miss.
 *
 * @param parentMac bare mac address of the parent asset, possibly empty
 * @return the label to store, or null when no parent is set
 */function toParentAssetLabel(parentMac){return parentMac?parentMac.toLowerCase():null;}/**
 * The bare mac address carried by a parentAssetLabel, for prefilling an input.
 *
 * Tolerates a MAC_ADDRESS: prefixed value because the ASML flow writes the prefixed form.
 *
 * @param parentAssetLabel the stored parentAssetLabel, possibly null
 * @return the bare mac address, or an empty string when no parent is set
 */function macFromParentAssetLabel(parentAssetLabel){if(!parentAssetLabel)return"";return parentAssetLabel.startsWith(__WEBPACK_IMPORTED_MODULE_1__Constants__["_114" /* MAC_ADDRESS_PREFIX */])?parentAssetLabel.slice(__WEBPACK_IMPORTED_MODULE_1__Constants__["_114" /* MAC_ADDRESS_PREFIX */].length):parentAssetLabel;}var getSorterConfigLocationStringForm=function getSorterConfigLocationStringForm(locations){// Handling empty strings because of wrong entries in some db records.
// TODO: remove this handling later.
if(Array.isArray(locations))return locations.join(';');return locations;};var getAutoLoaderConfigLocationStringForm=function getAutoLoaderConfigLocationStringForm(locations){// Handling empty strings because of wrong entries in some db records.
// TODO: remove this handling later.
if(Array.isArray(locations))return locations.join(';');return locations;};var getStowConfigScannableList=function getStowConfigScannableList(trackingId,shippingId){return[trackingId,shippingId].filter(Boolean);};var getShippingIdFromScannableList=function getShippingIdFromScannableList(scannables,trackingId){var filteredList=scannables.filter(function(item){return item!==trackingId;});return filteredList.length>0?filteredList[0]:"";};var getTestConfigKey=function getTestConfigKey(scannables){return scannables.sort().join(';');};var getPickStationsValue=function getPickStationsValue(pickStationsList){return pickStationsList?pickStationsList.sort().join(__WEBPACK_IMPORTED_MODULE_1__Constants__["_178" /* SEMI_COLON */]):__WEBPACK_IMPORTED_MODULE_1__Constants__["_25" /* EMPTY_STRING */];};var getSorterConfigKey=function getSorterConfigKey(bayId,type){return bayId+"_"+type;};var getAutoLoaderConfigKey=function getAutoLoaderConfigKey(destination,type){return destination+"_"+type;};var getSortedListWithOther=function getSortedListWithOther(unsortedList){var sortedList=unsortedList.filter(function(item){return item!=="other";}).sort();sortedList.push("other");return sortedList;};var getADTFSorterConfigKey=function getADTFSorterConfigKey(sorterId,destinationId,type){return sorterId+"_"+destinationId+"_"+type;};function compressSorterConfig(sorterConfig){var sorterConfigMap={};sorterConfig.forEach(function(config){var key=getSorterConfigKey(config.bayId,config.installation.type);if(key in sorterConfigMap){var _sorterConfigMap$key$;(_sorterConfigMap$key$=sorterConfigMap[key].installation.locations).push.apply(_sorterConfigMap$key$,_toConsumableArray(config.installation.locations));}else{sorterConfigMap[key]=config;}});return Object.values(sorterConfigMap);}function compressAutoLoaderConfig(autoLoaderConfig){var autoLoaderConfigMap={};autoLoaderConfig.forEach(function(config){var key=getAutoLoaderConfigKey(config.destination,config.installation.type);if(key in autoLoaderConfigMap){var _autoLoaderConfigMap$;(_autoLoaderConfigMap$=autoLoaderConfigMap[key].installation.locations).push.apply(_autoLoaderConfigMap$,_toConsumableArray(config.installation.locations));}else{autoLoaderConfigMap[key]=config;}});return Object.values(autoLoaderConfigMap);}function flattenADTFSorterConfig(sorterConfigMap){if(Array.isArray(sorterConfigMap))return sorterConfigMap;var parsedSorterConfig=[];var _loop=function _loop(sorterId){var sorterConfig=sorterConfigMap[sorterId];sorterConfig.forEach(function(config){parsedSorterConfig.push(Object.assign({},config,{sorterId:sorterId}));});};for(var sorterId in sorterConfigMap){_loop(sorterId);}return parsedSorterConfig;}function convertADTFSorterConfigIntoDBFormat(sorterConfig){var parsedSorterConfigMap={};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=sorterConfig[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var config=_step.value;if(config.sorterId in parsedSorterConfigMap){parsedSorterConfigMap[config.sorterId].push({destinationId:config.destinationId,installation:config.installation});}else{parsedSorterConfigMap[config.sorterId]=[{destinationId:config.destinationId,installation:config.installation}];}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return parsedSorterConfigMap;}function sortAlphaNumeric(keys){var sortedKeys=keys.sort(function(a,b){return a.localeCompare(b,undefined,{numeric:true,sensitivity:'base'});});return sortedKeys;}function checkInactiveOrDeprecatedAsset(assetStatus){return assetStatus===__WEBPACK_IMPORTED_MODULE_1__Constants__["_19" /* DEPRECATED */]||assetStatus===__WEBPACK_IMPORTED_MODULE_1__Constants__["_82" /* INACTIVE */];}function checkHealthStatusForDeletion(healthStatus){return healthStatus===__WEBPACK_IMPORTED_MODULE_1__Constants__["_80" /* HEALTH_STATUS */].DISCONNECTED.string||healthStatus===__WEBPACK_IMPORTED_MODULE_1__Constants__["_80" /* HEALTH_STATUS */].LOADING_FAILED.string;}var versionString=function versionString(intl,timestamp,alias){var time=Object(__WEBPACK_IMPORTED_MODULE_7__Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.createdOn"})+getFormattedTime(intl.locale,timestamp);var aliasName=alias?Object(__WEBPACK_IMPORTED_MODULE_7__Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.byUser"})+alias:"";return time+aliasName;};var getAliasFromParent=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var response,name;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__handler_ParentDataHandler__["f" /* getUserLoginFromParent */])();case 2:response=_context.sent;name=response.name.replace(/['"]/g,'');return _context.abrupt("return",name);case 5:case"end":return _context.stop();}}},_callee,this);}));return function getAliasFromParent(){return _ref.apply(this,arguments);};}();function checkValidLink(linkTab,link){if(linkTab===__WEBPACK_IMPORTED_MODULE_1__Constants__["_120" /* MCM */])return link.match(__WEBPACK_IMPORTED_MODULE_1__Constants__["_121" /* MCM_AMAZON */]);else if(linkTab===__WEBPACK_IMPORTED_MODULE_1__Constants__["_203" /* TICKET */])return link.match(__WEBPACK_IMPORTED_MODULE_1__Constants__["_197" /* TCORP_AMAZON */]);else return link.length>0;}var setAliasToRequest=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(request){var alias;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return getAliasFromParent();case 2:alias=_context2.sent;request.assetDetails.alias=alias;return _context2.abrupt("return");case 5:case"end":return _context2.stop();}}},_callee2,this);}));return function setAliasToRequest(_x){return _ref2.apply(this,arguments);};}();var setAliasToTriggerMHEValidationRequest=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(request){var alias;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return getAliasFromParent();case 2:alias=_context3.sent;request.triggerData.validationAttributes["alias"]=alias;return _context3.abrupt("return");case 5:case"end":return _context3.stop();}}},_callee3,this);}));return function setAliasToTriggerMHEValidationRequest(_x2){return _ref3.apply(this,arguments);};}();/**
 * Checks existence of one-box string in the url
 * @return {boolean}
 */function isOneBox(){var location=window.location.href;return location&&location.includes("onebox");}/**
 * Checks if status is 5XX or not
 * @return {boolean}
 */function isResponseCode5xx(input){if(input>=500&&input<=599){return true;}return false;}function getMQTTClientConfig(){var region=getUTRRegion();var stage=getUTRStage();return{host:__WEBPACK_IMPORTED_MODULE_1__Constants__["_138" /* MQTT_ENDPOINT */][stage][region],protocol:__WEBPACK_IMPORTED_MODULE_1__Constants__["_221" /* WSS */],region:__WEBPACK_IMPORTED_MODULE_1__Constants__["T" /* AWS_REGION */][region],maximumReconnectTimeMs:__WEBPACK_IMPORTED_MODULE_1__Constants__["_117" /* MAX_MQTT_RECONNECTION_TIME */]};}function getAutomationMQTTTopic(){return __WEBPACK_IMPORTED_MODULE_1__Constants__["N" /* AUTOMATION_MQTT_TOPIC_PREFIX */]+getNodeId()+__WEBPACK_IMPORTED_MODULE_1__Constants__["O" /* AUTOMATION_MQTT_TOPIC_SUFFIX */];}function renderMHELogsTableHeader(intl){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"10%"},getHeaderText(intl,'mhelog.datetime')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"10%"},getHeaderText(intl,'mhelog.protocol')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"5%"},getHeaderText(intl,'mhelog.devicetype')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"8%"},getHeaderText(intl,'mhelog.devicename')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"12%"},getHeaderText(intl,'mhelog.macip')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"10%"},getHeaderText(intl,'mhelog.eventtype')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"10%"},getHeaderText(intl,'mhelog.message')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"35%"},getHeaderText(intl,'mhelog.payload')));}function renderMHELogsTableRow(data,type){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableRow"],{highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"10%"},getBodyText(data.timestamp)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"10%"},getBodyText(data.component)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"5%"},getBodyText(type)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"8%"},getBodyText(data.name)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"12%"},getBoldBodyText(data.mac),getBodyText(data.ip)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"10%"},getBodyText(data.eventType)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"10%"},getBodyText(data.message)),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],{width:"35%"},getBodyText(JSON.stringify(data.payload))));}function getHeaderText(intl,stringId){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{breakWord:true,truncate:false,type:"h100"},Object(__WEBPACK_IMPORTED_MODULE_7__Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:stringId}));}function getBodyText(data){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{breakWord:true,truncate:false},data);}function getBoldBodyText(data){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{breakWord:true,truncate:false,type:"h100"},data);}function generateFileName(prefix){var date=new Date();var yr=zeroPad(date.getFullYear(),4);var month=zeroPad(date.getMonth()+1);var day=zeroPad(date.getDay());var hr=zeroPad(date.getHours());var min=zeroPad(date.getMinutes());var sec=zeroPad(date.getSeconds());return prefix+"_"+yr+"-"+month+"-"+day+"_"+hr+"-"+min+"-"+sec+".csv";}function getFormattedTimestamp(timestamp){var date=new Date(timestamp);var yr=zeroPad(date.getUTCFullYear(),4);var month=zeroPad(date.getUTCMonth()+1);var day=zeroPad(date.getUTCDate());var hr=zeroPad(date.getUTCHours());var min=zeroPad(date.getUTCMinutes());var sec=zeroPad(date.getUTCSeconds());var milliSec=date.getUTCMilliseconds();return day+"/"+month+"/"+yr+", "+hr+":"+min+":"+sec+"."+milliSec;}function getInstallationTypes(){var assetType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;if(__WEBPACK_IMPORTED_MODULE_1__Constants__["R" /* AUTO_LOADER_ASSET_TYPE */]===assetType){return[__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].SIDELINE,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].AISLE];}var installationTypes=[];if(__WEBPACK_IMPORTED_MODULE_10__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_10__FeatureUtility__["a" /* FEATURES */].IS_SSD_2_X_ENABLED)){installationTypes=[__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].JACKPOT,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].OV,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].BULKY,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].Zone,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].PROBLEM_SOLVE];}else{installationTypes=[__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].FLOOR,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].AISLE,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].JACKPOT,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].RECIRCULATION,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].OV,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].BULKY,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].CLUSTER,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].COLUMN,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].FRAGILE];}// Adding sort zone installation for ADTA_HAMPER_ZONING
if(__WEBPACK_IMPORTED_MODULE_10__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_10__FeatureUtility__["a" /* FEATURES */].IS_ADTA_HAMPER_ZONING_ENABLED)&&!installationTypes.includes(__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].SORT_ZONE)){installationTypes.push(__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].SORT_ZONE);}// Adding problem solve installation for PS_ON_GRID_SORTATION
if(__WEBPACK_IMPORTED_MODULE_10__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_10__FeatureUtility__["a" /* FEATURES */].IS_PROBLEM_SOLVE_ON_GRID_SORTATION_FLOW_ENABLED)&&!installationTypes.includes(__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].PROBLEM_SOLVE)){installationTypes.push(__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].PROBLEM_SOLVE);}// Adding Bin installation for programs diverting packages to bins
// Like Project Rush
if(__WEBPACK_IMPORTED_MODULE_10__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_10__FeatureUtility__["a" /* FEATURES */].IS_BIN_INSTALLATION_TYPE_ENABLED)&&!installationTypes.includes(__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].BIN)){installationTypes.push(__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].BIN);}// INSTALLATION_TYPES.STOW_STATION is intentionally NOT added here. Stow station diversion
// (Dual Stow Operation) applies only to ADTF, whose config modal builds its own
// ADTF_INSTALLATION_TYPES and whose CSV parser validates via checkModalValidationsForConfig.
// This registry feeds the ADTA modal and the ADTA CSV allowlist, where the type has no meaning.
return installationTypes;}function getInstallationTypeValues(){var assetType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;return getInstallationTypes(assetType).map(function(installation){return installation.value;});}function getOrdinal(n){var ord='th';if(n%10===1&&n%100!==11){ord='st';}else if(n%10===2&&n%100!==12){ord='nd';}else if(n%10===3&&n%100!==13){ord='rd';}return ord;}function getChildDeviceBySubType(parentMacAddress,childAssetList,assetSubType){var model={childAsset:null};childAssetList.forEach(function(childAsset){if(childAsset.parentAssetLabel===__WEBPACK_IMPORTED_MODULE_1__Constants__["_114" /* MAC_ADDRESS_PREFIX */]+parentMacAddress&&childAsset.assetSubType===assetSubType){model.childAsset=childAsset;}});return model;}/**
 * Extracts device type and tab name from the current path
 * @param pathname - Current route path (format: /devicemanagement/[device]/[tab])
 * @returns {{deviceType: string, tabName: string}}
 */var getDeviceAndTabInfo=function getDeviceAndTabInfo(pathname){var pathParts=pathname.split('/');var deviceName=pathParts[2];if(!deviceName){//no device is selected
return{deviceType:"None",tabName:"None"};}var tabName=pathParts[3]||'overview';return{deviceType:deviceName.toUpperCase(),tabName:tabName};};/**
 * Publish Alchemy Analytics of current tab to Pendo.
 * @param {string} pathname - Current route path (format: /devicemanagement/[device]/[tab])
 */var publishAlchemyAnalytics=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(pathname){var visitorId,employeeTCPRoles,deviceInfo,visitorData,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_11__resources_EmployeeResource__["c" /* getUserName */])();case 3:visitorId=_context4.sent.split('@')[0];_context4.next=6;return Object(__WEBPACK_IMPORTED_MODULE_11__resources_EmployeeResource__["b" /* getEmployeeTCPRoles */])();case 6:employeeTCPRoles=_context4.sent;deviceInfo=getDeviceAndTabInfo(pathname);visitorData={id:visitorId,stationCode:getNodeId(),stage:getUTRStage(),region:getUTRRegion(),scc_roles:employeeTCPRoles,current_device_type:deviceInfo.deviceType,current_tab_name:deviceInfo.tabName,current_tab_entry_time:Date.now()};if(!window.analytics){window.analytics=new __WEBPACK_IMPORTED_MODULE_12__amzn_alchemy_components_dist_utils_AlchemyAnalytics_es5_js__["AlchemyAnalytics"]({apikey:__WEBPACK_IMPORTED_MODULE_1__Constants__["G" /* ANALYTICS_CONFIG */].PENDO_AK,account:{id:__WEBPACK_IMPORTED_MODULE_1__Constants__["G" /* ANALYTICS_CONFIG */].ACCOUNT_ID},visitor:visitorData});}else{window.analytics.updateOptions({visitor:visitorData});}_context4.next=16;break;case 12:_context4.prev=12;_context4.t0=_context4["catch"](0);error=_context4.t0 instanceof Error?_context4.t0:new Error('Failed to initialize analytics');console.warn('Failed to initialize Pendo',error);case 16:case"end":return _context4.stop();}}},_callee4,_this,[[0,12]]);}));return function publishAlchemyAnalytics(_x5){return _ref4.apply(this,arguments);};}();function getFloorsWithMultipleAssignedSlides(floorSorterConfig,floorsForSlide){var floors=new Map();floorSorterConfig.forEach(function(config){config.installation.locations.forEach(function(location){if(!floors.has(location)){floors.set(location,false);}});});var floorsWithMultipleAssignedSlides=[];floorsForSlide.forEach(function(floorForSlide){if(floors.has(floorForSlide)){if(floors.get(floorForSlide)){floorsWithMultipleAssignedSlides.push(floorForSlide);}else{floors.set(floorForSlide,true);}}});return floorsWithMultipleAssignedSlides;}function getSorterConfigForInstallationType(sorterConfig,installationType){return sorterConfig.filter(function(config){return config.installation&&config.installation.type===installationType.value;});}function getFloorsForSlide(sorterConfig){var locations=[];sorterConfig.forEach(function(config){config.installation.locations.forEach(function(locationString){var individualLocations=locationString.split(__WEBPACK_IMPORTED_MODULE_1__Constants__["_178" /* SEMI_COLON */]);individualLocations.forEach(function(item){if(item.includes(__WEBPACK_IMPORTED_MODULE_1__Constants__["_2" /* COLON */])){var _item$split=item.split(__WEBPACK_IMPORTED_MODULE_1__Constants__["_2" /* COLON */]),_item$split2=_slicedToArray(_item$split,2),start=_item$split2[0],end=_item$split2[1];var prefix=start.substring(0,start.indexOf('L')+1);var suffix=start.substring(start.lastIndexOf(__WEBPACK_IMPORTED_MODULE_1__Constants__["_24" /* DOT */]));var startNum=parseInt(start.substring(start.indexOf('L')+1,start.lastIndexOf(__WEBPACK_IMPORTED_MODULE_1__Constants__["_24" /* DOT */])),10);var endNum=parseInt(end.substring(end.indexOf('L')+1,end.lastIndexOf(__WEBPACK_IMPORTED_MODULE_1__Constants__["_24" /* DOT */])),10);for(var index=startNum;index<=endNum;index++){var paddedNum=index<10?"0"+index:""+index;locations.push(""+prefix+paddedNum+suffix);}}else{locations.push(item);}});});});return locations;}// Helper function to render status with appropriate Meridian icon
var renderStatusWithIcon=function renderStatusWithIcon(status,message,color){var getIconTokens=function getIconTokens(status){switch(status){case __WEBPACK_IMPORTED_MODULE_1__Constants__["_194" /* SUCCESS_STRING */]:return __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_check_circle_filled___default.a;case __WEBPACK_IMPORTED_MODULE_1__Constants__["_71" /* ERROR_STRING */]:return __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_close_medium___default.a;case __WEBPACK_IMPORTED_MODULE_1__Constants__["_204" /* TIMEOUT_STRING */]:return __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_alert___default.a;default:return __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_info___default.a;}};// Define link colors for different backgrounds
var getLinkStyle=function getLinkStyle(status){switch(status){case __WEBPACK_IMPORTED_MODULE_1__Constants__["_71" /* ERROR_STRING */]:return{color:'#FFFFFF',textDecoration:'underline',fontWeight:'bold'};// White on red background
case __WEBPACK_IMPORTED_MODULE_1__Constants__["_204" /* TIMEOUT_STRING */]:return{color:'#000000',textDecoration:'underline',fontWeight:'bold'};// Black on amber background
default:return{color:'#1976D2',textDecoration:'underline'};// Blue for other backgrounds
}};var linkStyle=getLinkStyle(status);return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{style:{display:'flex',alignItems:'center',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon___default.a,{tokens:getIconTokens(status),size:"small",style:{marginRight:'12px'}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{style:{color:color},dangerouslySetInnerHTML:{__html:message.replace(/<a /g,"<a style=\"color: "+linkStyle.color+"; text-decoration: "+linkStyle.textDecoration+"; font-weight: "+(linkStyle.fontWeight||'normal')+";\" ")}}));};function isSensorLevelConfigEnabledForLidarController(lidarDeviceInfo){return lidarDeviceInfo&&lidarDeviceInfo.lidarControllerType===__WEBPACK_IMPORTED_MODULE_1__Constants__["_186" /* SKYLARK_LIDAR_CONTROLLER */]&&lidarDeviceInfo.numberOfNonOVLidarSensors>0;}var IS_BAG_TRACKING_ALLOWED=__WEBPACK_IMPORTED_MODULE_1__Constants__["U" /* BAG_TRACKING_ALLOWED_STATIONS */].includes(getNodeId());var IS_AUTO_LOADER_ENABLED=__WEBPACK_IMPORTED_MODULE_1__Constants__["Q" /* AUTO_LOADER_ASSET_ENABLED_STATIONS */].includes(getNodeId());var IS_VAPR_ENABLED=__WEBPACK_IMPORTED_MODULE_1__Constants__["_219" /* VAPR_ENABLED_STATIONS */].includes(getNodeId());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _column = _interopRequireDefault(__webpack_require__(559));

var _default = _column["default"];
exports["default"] = _default;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(560)();
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _button = _interopRequireDefault(__webpack_require__(677));

var _default = _button["default"];
exports["default"] = _default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _text = _interopRequireDefault(__webpack_require__(709));

var _default = _text["default"];
exports["default"] = _default;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _row = _interopRequireDefault(__webpack_require__(730));

var _default = _row["default"];
exports["default"] = _default;

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return flush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return hydrate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cx", function() { return cx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRegisteredStyles", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sheet", function() { return sheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cache", function() { return cache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__(562);


var _createEmotion = Object(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    cache = _createEmotion.cache;




/***/ }),
/* 12 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _alert = _interopRequireDefault(__webpack_require__(662));

var _default = _alert["default"];
exports["default"] = _default;

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLocalizedMessage; });
var englishStrings=__webpack_require__(353);/**
 * Function to return the english string if string id is not found for the locale
 * @param intl
 * @param stringId
 * @return {*}
 */var getLocalizedMessage=function getLocalizedMessage(_ref){var intl=_ref.intl,stringId=_ref.stringId;return intl.formatMessage({id:stringId,defaultMessage:englishStrings[stringId]});};

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MAC_MASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DIVERT_CODE_MASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return WW_FLEX_CART_RECIPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SCANLESS_SUPPORTED_CART_RECIPES_NA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SCANLESS_SUPPORTED_CART_RECIPES_JP; });
/* harmony export (immutable) */ __webpack_exports__["E"] = getAisleNamePattern;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AISLE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SCANLESS_SUPPORTED_CART_RECIPES_EU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LIDAR_CONTROLLER_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PROTOCOLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return VENDOR_INFO_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return VENDOR_DISPLAY_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SPEC_VERSION_DISPLAY_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SORTER_TYPE_DISPLAY_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HAMPER_VENDOR_DISPLAY_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HAMPER_VERSION_DISPLAY_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INCOMING_AUTO_SINGULATED_DISPLAY_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return INCOMING_AUTO_SORTED_DISPLAY_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PATTERNS; });
/* unused harmony export ZERO_TO_255 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IP_ADDRESS_PATTERN; });
/* harmony export (immutable) */ __webpack_exports__["L"] = isValidEntry;
/* harmony export (immutable) */ __webpack_exports__["_2"] = validateUniqueEntries;
/* unused harmony export isValidOptionalParentAssetLabel */
/* unused harmony export areAllInputsFulfilled */
/* unused harmony export areAllInputsFulfilledForLidarController */
/* unused harmony export areAllInputsFulfilledForMonitoring */
/* unused harmony export areAllInputsFulfilledForConfig */
/* unused harmony export areAllInputsFulfilledForZancaSortTestPackage */
/* unused harmony export areAllInputsFulfilledForTesseractTestPackage */
/* unused harmony export areAllInputsFulfilledForTestPackage */
/* harmony export (immutable) */ __webpack_exports__["S"] = validateNewAslDevice;
/* harmony export (immutable) */ __webpack_exports__["Q"] = validateNewAdtaDevice;
/* harmony export (immutable) */ __webpack_exports__["Y"] = validateNewLedController;
/* harmony export (immutable) */ __webpack_exports__["M"] = validateAddAislesForLedController;
/* harmony export (immutable) */ __webpack_exports__["_3"] = validateUpdateLedController;
/* harmony export (immutable) */ __webpack_exports__["G"] = hasAllNonNullFields;
/* harmony export (immutable) */ __webpack_exports__["O"] = validateLedDefaultValues;
/* harmony export (immutable) */ __webpack_exports__["Z"] = validateNewLidarController;
/* harmony export (immutable) */ __webpack_exports__["R"] = validateNewAdtfDevice;
/* harmony export (immutable) */ __webpack_exports__["_1"] = validateNewZancaSortDevice;
/* harmony export (immutable) */ __webpack_exports__["V"] = validateNewAutoLoaderDevice;
/* harmony export (immutable) */ __webpack_exports__["_0"] = validateNewTesseractDevice;
/* harmony export (immutable) */ __webpack_exports__["W"] = validateNewAutoRetrieverDevice;
/* harmony export (immutable) */ __webpack_exports__["T"] = validateNewAsmlComponentDevice;
/* harmony export (immutable) */ __webpack_exports__["U"] = validateNewAsmlDevice;
/* harmony export (immutable) */ __webpack_exports__["X"] = validateNewControllerDevice;
/* harmony export (immutable) */ __webpack_exports__["y"] = checkModalValidationsForMonitoring;
/* harmony export (immutable) */ __webpack_exports__["x"] = checkModalValidationsForConfig;
/* harmony export (immutable) */ __webpack_exports__["N"] = validateAddDivertConfigModal;
/* harmony export (immutable) */ __webpack_exports__["D"] = checkZancaSortAddTestPackageModalValidations;
/* harmony export (immutable) */ __webpack_exports__["B"] = checkTesseractAddTestPackageModalValidations;
/* harmony export (immutable) */ __webpack_exports__["z"] = checkModalValidationsForTestPackage;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return checkModalValidationsForAutoloaderTestPackage; });
/* harmony export (immutable) */ __webpack_exports__["u"] = checkDeviceMonitoringEnabled;
/* harmony export (immutable) */ __webpack_exports__["F"] = getMonitoringStatusDetails;
/* harmony export (immutable) */ __webpack_exports__["A"] = checkModalValidationsForTriggeringMHEValidation;
/* harmony export (immutable) */ __webpack_exports__["K"] = isStartTimeLaterThanEndTime;
/* harmony export (immutable) */ __webpack_exports__["I"] = isDurationMoreThanTwelveHours;
/* harmony export (immutable) */ __webpack_exports__["J"] = isFromAndToDateTimeEntered;
/* harmony export (immutable) */ __webpack_exports__["v"] = checkDuplicateScannables;
/* harmony export (immutable) */ __webpack_exports__["t"] = checkContainerDestinationConflicts;
/* harmony export (immutable) */ __webpack_exports__["H"] = hasUnavailableFloor;
/* unused harmony export isValidRange */
/* harmony export (immutable) */ __webpack_exports__["_4"] = validateZancaSortLocationConfig;
/* harmony export (immutable) */ __webpack_exports__["_5"] = validateZancaSortTierConfig;
/* harmony export (immutable) */ __webpack_exports__["C"] = checkTierConfigLevelOverlap;
/* harmony export (immutable) */ __webpack_exports__["P"] = validateLocationMappingRow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_input_mask__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FeatureUtility__ = __webpack_require__(63);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var MAC_MASK=new __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_input_mask___default.a('^^:^^:^^:^^:^^:^^',{formatChars:{'^':'[0-9a-fA-F]'}});var DIVERT_CODE_MASK=new __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_input_mask___default.a('^^',{formatChars:{'^':'[0-9]'}});var WANZL_CART_RECIPES={NON_OV:["WANZL_FOUR_BIN_ZERO_OV_TWO_LIDAR"],TWO_TIER_OV:["WANZL_ZERO_BIN_TWO_OV_THREE_LIDAR"],ONE_TIER_OV:["WANZL_ZERO_BIN_ONE_OV_THREE_LIDAR"],FLEX_RACK:["WANZL_EIGHT_BIN_ZERO_OV_THREE_LIDAR","WANZL_FOUR_BIN_ONE_TOP_OV_THREE_LIDAR","WANZL_FOUR_BIN_ONE_BOTTOM_OV_THREE_LIDAR"]};var HARTWALL_CART_RECIPES={NON_OV:["HARTWALL_FOUR_BIN_ZERO_OV_TWO_LIDAR"],TWO_TIER_OV:["HARTWALL_ZERO_BIN_TWO_OV_THREE_LIDAR"],ONE_TIER_OV:["HARTWALL_ZERO_BIN_ONE_OV_THREE_LIDAR"],FLEX_RACK:["HARTWALL_EIGHT_BIN_ZERO_OV_THREE_LIDAR","HARTWALL_FOUR_BIN_ONE_BOTTOM_OV_THREE_LIDAR","HARTWALL_FOUR_BIN_ONE_TOP_OV_THREE_LIDAR"]};var IRSG_CART_RECIPES={NON_OV:["IRSG_FOUR_BIN_ZERO_OV_TWO_LIDAR"],TWO_TIER_OV:["IRSG_ZERO_BIN_TWO_OV_THREE_LIDAR"],ONE_TIER_OV:["IRSG_ZERO_BIN_ONE_OV_THREE_LIDAR"],FLEX_RACK:["IRSG_EIGHT_BIN_ZERO_OV_THREE_LIDAR","IRSG_FOUR_BIN_ONE_BOTTOM_OV_THREE_LIDAR","IRSG_FOUR_BIN_ONE_TOP_OV_THREE_LIDAR"]//Non OV Recipes that used in all regions
//WorldWideNonOVCartRecipes
};var WW_NON_OV_CART_RECIPES=["AMZL_NON_OV_COLUMN_TYPE2"].concat(_toConsumableArray(WANZL_CART_RECIPES.NON_OV),_toConsumableArray(HARTWALL_CART_RECIPES.NON_OV),_toConsumableArray(IRSG_CART_RECIPES.NON_OV));//Two tier OV Recipes that used in all regions
//WorldWideTwoTierOVCartRecipes
var WW_TWO_TIER_OV_CART_RECIPES=[].concat(_toConsumableArray(WANZL_CART_RECIPES.TWO_TIER_OV),_toConsumableArray(HARTWALL_CART_RECIPES.TWO_TIER_OV),_toConsumableArray(IRSG_CART_RECIPES.TWO_TIER_OV));//One Tier OV Recipes that used in all regions
//WorldWideOneTierOVCartRecipes
var WW_ONE_TIER_OV_CART_RECIPES=[].concat(_toConsumableArray(WANZL_CART_RECIPES.ONE_TIER_OV),_toConsumableArray(HARTWALL_CART_RECIPES.ONE_TIER_OV),_toConsumableArray(IRSG_CART_RECIPES.ONE_TIER_OV));var WW_FLEX_CART_RECIPES=[].concat(_toConsumableArray(WANZL_CART_RECIPES.FLEX_RACK),_toConsumableArray(HARTWALL_CART_RECIPES.FLEX_RACK),_toConsumableArray(IRSG_CART_RECIPES.FLEX_RACK));var SCANLESS_SUPPORTED_CART_RECIPES_NA={NON_OV:WW_NON_OV_CART_RECIPES,TWO_TIER_OV:["AMZL_OV_COLUMN_TYPE3","AMZL_OV_COLUMN_TYPE2"].concat(_toConsumableArray(WW_TWO_TIER_OV_CART_RECIPES)),ONE_TIER_OV:["AMZL_OV_COLUMN_TYPE1"].concat(_toConsumableArray(WW_ONE_TIER_OV_CART_RECIPES)),FLEX_RACK:[].concat(_toConsumableArray(WW_FLEX_CART_RECIPES))};var SCANLESS_SUPPORTED_CART_RECIPES_JP={NON_OV:WW_NON_OV_CART_RECIPES,TWO_TIER_OV:["AMZL_OV_COLUMN_TYPE3"].concat(_toConsumableArray(WW_TWO_TIER_OV_CART_RECIPES)),ONE_TIER_OV:["AMZL_OV_COLUMN_TYPE2"].concat(_toConsumableArray(WW_ONE_TIER_OV_CART_RECIPES)),FLEX_RACK:[].concat(_toConsumableArray(WW_FLEX_CART_RECIPES))};function getAisleNamePattern(){var region=Object(__WEBPACK_IMPORTED_MODULE_2__Util__["_15" /* getUTRRegion */])();if(region==="NA"){return PATTERNS.AISLE_NA;}else if(region==="EU"){return PATTERNS.AISLE_EU;}return PATTERNS.AISLE_FE;}var AISLE_NAME={NA:"A-1",EU:"A1",FE:"A1"};var SCANLESS_SUPPORTED_CART_RECIPES_EU={NON_OV:WW_NON_OV_CART_RECIPES,TWO_TIER_OV:["AMZL_OV_COLUMN_TYPE3"].concat(_toConsumableArray(WW_TWO_TIER_OV_CART_RECIPES)),ONE_TIER_OV:["AMZL_OV_COLUMN_TYPE2"].concat(_toConsumableArray(WW_ONE_TIER_OV_CART_RECIPES)),FLEX_RACK:[].concat(_toConsumableArray(WW_FLEX_CART_RECIPES))};var LIDAR_CONTROLLER_TYPES=["Maxilux","Skylark"];var PROTOCOLS={ADTA:['sort','sort-2021-v1','sort-mercury-2.04','adta-a2c-v1'],ADTF:['matrix-v1'],ASL:['slam','slam-2021-v1','slam-2021-v1.3','asl-a2c-v1'],ZANCASORT:['asrs-a2c-v1'],TESSERACT:['asrs-a2c-v1'],AUTO_RETRIEVER:['asrs-a2c-v1'],ASML:['asml-tcp-ip-v1'],AUTO_LOADER:['rufus-a2c-v1'],VAPR:['asrs-a2c-v1']};var VENDOR_INFO_KEYS={VENDOR:["actemium","agito","ami","bastian","bluecrest","caljan","cmc","dematic","duravant","fives","galam","hokusho","igem","impact_automation","intellistore","intralox","kengic","koerber","lac","leonardo","lewco","meikikou","mhs","okura","orion","raymond","retiina","sit","ssi","tgw","ulma","vanderlande","wayzim","zancaner","other"],SPEC_VERSION:["EU_deployment_v1.0","EU_pilot_v1","EU_pilot_v2","EU_prod_v1","EU_prod_v2","EU_v0.5","EU_v1.0","EU_v1.1","EU_v1.5","EU_v2","EU_v3","EU_v3.1","FE_v0","FE_v1","FE_v3","FE_v4","NA_2021","NA_2022","NA 2023","NA_2024","NA_2025","NA_v1.5","pilot","WW_TRD_v0.5","WW_TRD_v1.0","WW_TRD_v1.1","WW_v1.0","WW_v2.0","other"],SORTER_TYPE:["ami_swivel","cmc_swivel","honeywell_transnorm","igem_swivel","intralox","narrow_belt","orion_swivel","modsort","saiet_swivel","other"],HAMPER_VENDOR:["agito","ami","caljan","cannon","cmc","fives","ia","iec","interoll","lewco","meikikou","muvro","preceed","tiffin","other"],HAMPER_VERSION:["EU_v0.5","EU_v1.0","EU_v2.0","EU_v2.1","EU_pilot_v1","NA_v1.0","NA_v1.5","NA_v2.0","NA_v2.3","NA_v2.4","NA_2022","FE_v0","FE_v0.1","FE_v0.2","FE_v1","FE_v2","FE_v3","WW_v1.0","other"],INCOMING_AUTO_SINGULATED:["true","false"],INCOMING_AUTO_SORTED:["true","false"]};var VENDOR_DISPLAY_VALUES={"actemium":"Actemium","agito":"AGITO","ami":"AMI","bastian":"Bastian","bluecrest":"Bluecrest","caljan":"Caljan","cmc":"CMC","dematic":"Dematic","duravant":"Duravant","fives":"Fives","galam":"Galam Robotics","hokusho":"Hokusho","igem":"iGEM","impact_automation":"Impact Automation","intellistore":"intellistore","intralox":"Intralox","kengic":"Kengic","koerber":"Koerber","lac":"LAC","leonardo":"Leonardo","lewco":"Lewco","meikikou":"Meikikou","mhs":"MHS","okura":"Okura","orion":"Orion","raymond":"Raymond","retiina":"Retiina","sit":"Sit","ssi":"SSI","tgw":"TGW","ulma":"ULMA","vanderlande":"Vanderlande","wayzim":"Wayzim","zancaner":"Zancaner","other":"Other"};var SPEC_VERSION_DISPLAY_VALUES={"EU_deployment_v1.0":"EU Deployment v1.0","EU_pilot_v1":"EU Pilot v1","EU_pilot_v2":"EU Pilot v2","EU_prod_v1":"EU Prod v1","EU_prod_v2":"EU Prod v2","EU_v0.5":"EU v0.5","EU_v1.0":"EU v1.0","EU_v1.1":"EU v1.1","EU_v1.5":"EU v1.5","EU_v2":"EU v2","EU_v3":"EU v3","EU_v3.1":"EU v3.1","FE_v0":"FE v0","FE_v1":"FE v1","FE_v3":"FE v3","FE_v4":"FE v4","NA_2021":"NA 2021","NA_2022":"NA 2022","NA 2023":"NA 2023","NA_2024":"NA 2024","NA_2025":"NA 2025","NA_v1.5":"NA v1.5","pilot":"Pilot","WW_TRD_v0.5":"WW TRD v0.5","WW_TRD_v1.0":"WW TRD v1.0","WW_TRD_v1.1":"WW TRD v1.1","WW_v1.0":"WW v1.0","WW_v2.0":"WW v2.0","other":"Other"};var SORTER_TYPE_DISPLAY_VALUES={"ami_swivel":"AMI Swivel","cmc_swivel":"CMC Swivel","honeywell_transnorm":"Honeywell Transnorm","igem_swivel":"iGEM Swivel","intralox":"Intralox ARB S7000","narrow_belt":"Narrow Belt","orion_swivel":"Orion Swivel","modsort":"Regal Dual-Modsort","saiet_swivel":"SAIET Swivel","other":"Other"};var HAMPER_VENDOR_DISPLAY_VALUES={"agito":"AGITO","ami":"AMI","caljan":"Caljan","cannon":"Cannon","cmc":"CMC","fives":"Fives","ia":"Impact Automation","iec":"IEC","interoll":"Interoll","lewco":"Lewco","meikikou":"Meikikou","muvro":"Muvro","preceed":"Preceed","tiffin":"Tiffin","other":"Other"};var HAMPER_VERSION_DISPLAY_VALUES={"EU_v0.5":"EU v0.5","EU_v1.0":"EU v1.0","EU_v2.0":"EU v2.0","EU_v2.1":"EU v2.1","EU_pilot_v1":"EU Pilot v1","NA_v1.0":"NA v1.0","NA_v1.5":"NA v1.5","NA_v2.0":"NA v2.0","NA_v2.3":"NA v2.3","NA_v2.4":"NA v2.4","NA_2022":"NA 2022","FE_v0":"FE v0","FE_v0.1":"FE v0.1","FE_v0.2":"FE v0.2","FE_v1":"FE v1","FE_v2":"FE v2","FE_v3":"FE v3","WW_v1.0":"WW v1.0","other":"Other"};var INCOMING_AUTO_SINGULATED_DISPLAY_VALUES={"true":"Yes","false":"No"};var INCOMING_AUTO_SORTED_DISPLAY_VALUES={"true":"Yes","false":"No"};var PATTERNS={NAME:/^[A-Za-z0-9 -;]{1,50}$/,SLAM:/^slam-2021-v1\.[0-9]$/,DESTINATION:/^[A-Za-z0-9_]{1,50}$/,MAC:/^([0-9a-fA-F]{2}[:]){5}([0-9a-fA-F]{2})$/,MAC_MASK:/([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})/,BAY_ID:/^[A-Za-z0-9 _@.#&+-|]{1,50}$/,CONTAINER_TYPE:/^[A-Za-z0-9_-]{1,20}$/,CONTAINER_LABEL:/^([A-Z])(-)?([1-9])$/,BAG_LABEL:/^[A-Z][-A-Z0-9_]{0,19}$/,DEVICE_ID:/^[A-Z0-9]{1,4}$/,PORT:/^([1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/,CLUSTERS:/^([A-Z]|(([A-Z];)*[A-Z]))$/,PICK_STATIONS:/^([A-Z0-9_]{2,10})(;[A-Z0-9_]{2,10})*$/,LOCATION:/^([A-Z]|(([A-Z];)*[A-Z]))$|^([A-Z],[0-9]{1,3})(;[A-Z],[0-9]{1,3}){0,2}$|^[A-Za-z0-9]$|^[A-B].L[0-9]{0,3}$|^[A-Z].L[0-9]{0,3}.[A-Z]{2}$|^([A-Z],[0-9]+,[A-Z])(;[A-Z],[0-9]+,[A-Z])*$/,STOW_STATION_LOCATION:/^([A-Z]#[12])(;[A-Z]#[12])*$/,CATCH_ALL_LOCATION:/^$|^([A-Z]|(([A-Z];)*[A-Z]))$|^([A-Z],[0-9]{1,3})(;[A-Z],[0-9]{1,3}){0,2}$|^[A-Za-z0-9]$|^[A-B].L[0-9]{0,3}$|^[A-Z].L[0-9]{0,3}.[A-Z]{2}$/,SLIDE_LOCATION_RANGE:/^([A-Z]|(([A-Z];)*[A-Z]))$|^([A-Z],[0-9]{1,3})(;[A-Z],[0-9]{1,3}){0,2}$|^[A-Za-z0-9]$|^[A-B].L[0-9]{0,3}$|^[A-Z].L[0-9]{0,3}.[A-Z]{2}$|^([A-Z],[0-9]+,[A-Z])(;[A-Z],[0-9]+,[A-Z])*$|^([A-Z].L[0-9]{0,3}.[A-Z]{2})([;:][A-Z].L[0-9]{0,3}.[A-Z]{2})*$/,TEST_SCANNABLE:/^([A-Za-z_\-0-9]{11,})(;[A-Za-z_\-0-9]{11,})*$/,TEST_PACKAGE_ID:/^([A-Za-z_\-0-9]{11,})$/,SORT_ZONE:/(([A-Z])(\d*)-(\d)([A-Z]))|(([A-Z])-(\d*).(\d)([A-Z]))|^[A-B].L[0-9]{0,3}$|^[A-Z].L[0-9]{0,3}.[A-Z]{2}$/,DIVERT_CODE:/^[1-9][0-9]$/,SHORT_STRING:/^[A-Za-z0-9 '_]{1,20}/,LONG_STRING:/^[A-Za-z0-9 '_]{1,200}/,DATE:/\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/,AISLE_NA:/^([A-Z]-\d{1,2})$/,AISLE_EU:/^([A-Z]\d{1,2})$/,AISLE_FE:/^([A-Z]\d{1,2})$/,INTEGER:/^[1-9]\d*$/,AISLE:/^([A-Z]-(\d*))$|^([A-Z](\d*))$/,SORT_LOCATION:/^([A-Z]-\d{1,2}\.[A-Z0-9]{1,2}|[A-Z]\d{1,2}-[A-Z0-9]{1,2})$/,BAG_LIST:/^[A-Z0-9-_]+(;[A-Z0-9-_]+)*$/,BIN_LIST:/^(RU\.[0-9]{3})(;RU\.[0-9]{3})*$/};var ZERO_TO_255="(\\d{1,2}|(0|1)\\"+"d{2}|2[0-4]\\d|25[0-5])";// Regex for a digit from 0 to 255 and
// followed by a dot, repeat 4 times.
// this is the regex to validate an IP address.
var IP_ADDRESS_PATTERN=new RegExp("^"+ZERO_TO_255+"\\."+ZERO_TO_255+"\\."+ZERO_TO_255+"\\."+ZERO_TO_255+"$");function isValidEntry(entry,regex){var value=regex.test(entry);return value;}function validateUniqueEntries(entries){var uniqueEntries=new Set(entries);return entries.length===uniqueEntries.size;}/**
 * Validates an optional parentAssetLabel. Left blank it passes - not every asset hangs off a parent - but a value
 * that is present has to be a real mac address, or the consuming service silently never resolves the parent asset.
 *
 * @param parentAssetLabel the stored parentAssetLabel, possibly null or empty
 * @return true when absent, or present and a valid mac address
 */function isValidOptionalParentAssetLabel(parentAssetLabel){return!parentAssetLabel||isValidEntry(Object(__WEBPACK_IMPORTED_MODULE_2__Util__["_22" /* macFromParentAssetLabel */])(parentAssetLabel),PATTERNS.MAC);}function areAllInputsFulfilled(stateValues){if(!stateValues.deviceType)return false;var areInputsFilled=stateValues.name&&stateValues.mac&&stateValues.ip&&stateValues.port&&stateValues.vendorAttributes&&stateValues.vendorAttributes.vendor&&stateValues.vendorAttributes.spec_version;if(stateValues.deviceType==='slam'){return areInputsFilled&&stateValues.deviceConfig.responsePort&&stateValues.deviceConfig.inductLocation&&stateValues.deviceConfig.userId;}areInputsFilled=areInputsFilled&&stateValues.deviceConfig.id;if(stateValues.deviceType.includes("sort")){return areInputsFilled&&stateValues.vendorAttributes.sorter_type&&stateValues.vendorAttributes.hamper_vendor&&stateValues.vendorAttributes.hamper_version&&stateValues.vendorAttributes.incoming_auto_singulated&&stateValues.vendorAttributes.incoming_auto_sorted;}if(stateValues.deviceType.includes("matrix")){return areInputsFilled&&stateValues.vendorAttributes.sorter_type;}if(stateValues.deviceConfig.type===__WEBPACK_IMPORTED_MODULE_1__Constants__["S" /* AUTO_RETRIEVER_ASSET_TYPE */]){return areInputsFilled&&stateValues.pickStations;}return areInputsFilled;}function areAllInputsFulfilledForLidarController(stateValues){var lidarControllerConfig=stateValues.lidarControllerConfig;return lidarControllerConfig&&LIDAR_CONTROLLER_TYPES.includes(lidarControllerConfig.lidarControllerType)&&lidarControllerConfig.macAddress&&lidarControllerConfig.ipAddress&&lidarControllerConfig.startAisleLabel&&lidarControllerConfig.endAisleLabel&&lidarControllerConfig.nonOVCartRecipe&&lidarControllerConfig.twoTierOVCartRecipe;}function areAllInputsFulfilledForMonitoring(stateValues){return stateValues.startTime&&stateValues.endTime&&stateValues.reason&&stateValues.startTime<=stateValues.endTime;}function areAllInputsFulfilledForConfig(config,assetType){if(assetType===__WEBPACK_IMPORTED_MODULE_1__Constants__["c" /* ADTA_ASSET_TYPE */]){if(__WEBPACK_IMPORTED_MODULE_1__Constants__["_1" /* CATCH_ALL_INSTALLATION_TYPES */].includes(config.installation.type)){return config.bayId&&config.installation.type;}else{return config.bayId&&config.installation.type&&config.installation.locations;}}if(assetType===__WEBPACK_IMPORTED_MODULE_1__Constants__["R" /* AUTO_LOADER_ASSET_TYPE */]){if(__WEBPACK_IMPORTED_MODULE_1__Constants__["_1" /* CATCH_ALL_INSTALLATION_TYPES */].includes(config.installation.type)){return config.destination&&config.installation.type;}else{return config.destination&&config.installation.type&&config.installation.locations;}}else if(assetType===__WEBPACK_IMPORTED_MODULE_1__Constants__["e" /* ADTF_ASSET_TYPE */]){if(['miss','jackpot','ov',__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].FRAGILE.value].includes(config.installation.type)){return config.destinationId&&config.sorterId&&config.installation.type;}else{return config.destinationId&&config.sorterId&&config.installation.type&&config.installation.locations;}}else if(assetType===__WEBPACK_IMPORTED_MODULE_1__Constants__["_200" /* TESSERACT_ASSET_TYPE */]){return config.containerType&&config.containerLabel;}else if(assetType===__WEBPACK_IMPORTED_MODULE_1__Constants__["K" /* ASL_ASSET_TYPE */]){return config.divertCode&&config.clusters;}}function areAllInputsFulfilledForZancaSortTestPackage(stowTestPackage){var isNewTestConfigEnabled=__WEBPACK_IMPORTED_MODULE_4__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_4__FeatureUtility__["a" /* FEATURES */].IS_NEW_ZANCASORT_TEST_CONFIG_ENABLED);if(isNewTestConfigEnabled){return stowTestPackage.scannables&&stowTestPackage.destination&&Array.isArray(stowTestPackage.containerList)&&stowTestPackage.containerList.length>0;}else{return stowTestPackage.scannables&&stowTestPackage.destination;}}function areAllInputsFulfilledForTesseractTestPackage(stowTestPackage){return stowTestPackage.trackingId&&stowTestPackage.scannables&&stowTestPackage.destination;}function areAllInputsFulfilledForTestPackage(sorterTestPackage){return sorterTestPackage.scannables&&sorterTestPackage.sortZone;}function validateNewAslDevice(stateValues){if(PROTOCOLS.ASL.includes(stateValues.deviceType)){if(stateValues.deviceType==='slam'){return areAllInputsFulfilled(stateValues)&&isValidEntry(stateValues.ip,IP_ADDRESS_PATTERN)&&isValidEntry(stateValues.mac,PATTERNS.MAC)&&isValidEntry(stateValues.port,PATTERNS.PORT)&&isValidEntry(stateValues.deviceConfig.responsePort,PATTERNS.PORT)&&isValidEntry(stateValues.deviceConfig.inductLocation,PATTERNS.SHORT_STRING)&&isValidEntry(stateValues.deviceConfig.userId,PATTERNS.SHORT_STRING)&&isValidEntry(stateValues.name,PATTERNS.NAME)&&VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor)&&VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version);}else{return areAllInputsFulfilled(stateValues)&&isValidEntry(stateValues.ip,IP_ADDRESS_PATTERN)&&isValidEntry(stateValues.mac,PATTERNS.MAC)&&isValidEntry(stateValues.port,PATTERNS.PORT)&&isValidEntry(stateValues.deviceConfig.id,PATTERNS.DEVICE_ID)&&isValidEntry(stateValues.name,PATTERNS.NAME)&&VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor)&&VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version);}}else{return false;}}function validateNewAdtaDevice(stateValues){return areAllInputsFulfilled(stateValues)&&isValidEntry(stateValues.ip,IP_ADDRESS_PATTERN)&&isValidEntry(stateValues.mac,PATTERNS.MAC)&&PROTOCOLS.ADTA.includes(stateValues.deviceType)&&isValidEntry(stateValues.port,PATTERNS.PORT)&&isValidEntry(stateValues.deviceConfig.id,PATTERNS.DEVICE_ID)&&isValidEntry(stateValues.name,PATTERNS.NAME)&&VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor)&&VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version)&&VENDOR_INFO_KEYS.SORTER_TYPE.includes(stateValues.vendorAttributes.sorter_type)&&VENDOR_INFO_KEYS.HAMPER_VENDOR.includes(stateValues.vendorAttributes.hamper_vendor)&&VENDOR_INFO_KEYS.HAMPER_VERSION.includes(stateValues.vendorAttributes.hamper_version)&&VENDOR_INFO_KEYS.INCOMING_AUTO_SINGULATED.includes(stateValues.vendorAttributes.incoming_auto_singulated)&&VENDOR_INFO_KEYS.INCOMING_AUTO_SORTED.includes(stateValues.vendorAttributes.incoming_auto_sorted);}function validateNewLedController(stateValues){return!isNull(stateValues)&&hasAllNonNullFields(stateValues.ledControllerConfig)&&isValidEntry(stateValues.ledControllerConfig.macAddress,PATTERNS.MAC)&&isValidEntry(stateValues.ledControllerConfig.startAisleLabel,getAisleNamePattern())&&isValidEntry(stateValues.ledControllerConfig.startPortNumber,PATTERNS.PORT)&&isValidEntry(stateValues.ledControllerConfig.aisleType,PATTERNS.LONG_STRING)&&isValidEntry(stateValues.ledControllerConfig.aisleCount,PATTERNS.INTEGER);}function validateAddAislesForLedController(stateValues){return!isNull(stateValues)&&hasAllNonNullFields(stateValues.ledControllerConfig)&&isValidEntry(stateValues.ledControllerConfig.startAisleLabel,getAisleNamePattern())&&isValidEntry(stateValues.ledControllerConfig.startPortNumber,PATTERNS.PORT)&&isValidEntry(stateValues.ledControllerConfig.aisleType,PATTERNS.LONG_STRING)&&isValidEntry(stateValues.ledControllerConfig.aisleCount,PATTERNS.INTEGER);}function validateUpdateLedController(stateValues,mac){return!isNull(stateValues)&&stateValues.length>0&&stateValues.every(function(stateValue){return hasAllNonNullFields(stateValue);})&&stateValues.every(function(value){return isValidEntry(value.aisleName,getAisleNamePattern())&&isValidEntry(value.aisleType,PATTERNS.LONG_STRING)&&isValidEntry(value.portNumber,PATTERNS.PORT);})&&isValidEntry(mac,PATTERNS.MAC);}function isNull(value){return value===null||value===undefined;}function hasAllNonNullFields(obj){if(isNull(obj)||Object.keys(obj).length===0)return false;return Object.values(obj).every(function(value){return!isNull(value);});}function validateLedDefaultValues(defaultValues){return!isNull(defaultValues)&&hasAllNonNullFields(defaultValues.ledControllerDefaultValues)&&isValidEntry(defaultValues.ledControllerDefaultValues.ledControllerType,PATTERNS.LONG_STRING)&&isValidEntry(defaultValues.ledControllerDefaultValues.aisleType,PATTERNS.LONG_STRING)&&Object.values(__WEBPACK_IMPORTED_MODULE_3__enums__["a" /* ledControllerColorOrder */]).includes(defaultValues.ledControllerDefaultValues.colorOrder);}function validateNewLidarController(stateValues){return areAllInputsFulfilledForLidarController(stateValues)&&isValidEntry(stateValues.lidarControllerConfig.ipAddress,IP_ADDRESS_PATTERN)&&isValidEntry(stateValues.lidarControllerConfig.macAddress,PATTERNS.MAC)&&isValidEntry(stateValues.lidarControllerConfig.startAisleLabel,PATTERNS.AISLE)&&isValidEntry(stateValues.lidarControllerConfig.endAisleLabel,PATTERNS.AISLE);}function validateNewAdtfDevice(stateValues){return areAllInputsFulfilled(stateValues)&&isValidEntry(stateValues.ip,IP_ADDRESS_PATTERN)&&isValidEntry(stateValues.mac,PATTERNS.MAC)&&PROTOCOLS.ADTF.includes(stateValues.deviceType)&&isValidEntry(stateValues.port,PATTERNS.PORT)&&isValidEntry(stateValues.deviceConfig.id,PATTERNS.DEVICE_ID)&&isValidEntry(stateValues.name,PATTERNS.NAME)&&VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor)&&VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version)&&VENDOR_INFO_KEYS.SORTER_TYPE.includes(stateValues.vendorAttributes.sorter_type);}function validateNewZancaSortDevice(stateValues){return areAllInputsFulfilled(stateValues)&&isValidEntry(stateValues.name,PATTERNS.NAME)&&isValidEntry(stateValues.mac,PATTERNS.MAC)&&isValidEntry(stateValues.ip,IP_ADDRESS_PATTERN)&&isValidEntry(stateValues.port,PATTERNS.PORT)&&PROTOCOLS.ZANCASORT.includes(stateValues.deviceType)&&isValidEntry(stateValues.deviceConfig.id,PATTERNS.DEVICE_ID)&&VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor)&&VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version)&&isValidOptionalParentAssetLabel(stateValues.parentAssetLabel);}function validateNewAutoLoaderDevice(stateValues){return areAllInputsFulfilled(stateValues)&&isValidEntry(stateValues.name,PATTERNS.NAME)&&isValidEntry(stateValues.mac,PATTERNS.MAC)&&isValidEntry(stateValues.ip,IP_ADDRESS_PATTERN)&&isValidEntry(stateValues.port,PATTERNS.PORT)&&PROTOCOLS.AUTO_LOADER.includes(stateValues.deviceType)&&isValidEntry(stateValues.deviceConfig.id,PATTERNS.DEVICE_ID)&&VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor)&&VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version);}function validateNewTesseractDevice(stateValues){return areAllInputsFulfilled(stateValues)&&isValidEntry(stateValues.name,PATTERNS.NAME)&&isValidEntry(stateValues.mac,PATTERNS.MAC)&&isValidEntry(stateValues.ip,IP_ADDRESS_PATTERN)&&isValidEntry(stateValues.port,PATTERNS.PORT)&&PROTOCOLS.TESSERACT.includes(stateValues.deviceType)&&isValidEntry(stateValues.deviceConfig.id,PATTERNS.DEVICE_ID)&&VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor)&&VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version);}function validateNewAutoRetrieverDevice(stateValues){return areAllInputsFulfilled(stateValues)&&isValidEntry(stateValues.name,PATTERNS.NAME)&&isValidEntry(stateValues.mac,PATTERNS.MAC)&&isValidEntry(stateValues.ip,IP_ADDRESS_PATTERN)&&isValidEntry(stateValues.port,PATTERNS.PORT)&&PROTOCOLS.AUTO_RETRIEVER.includes(stateValues.deviceType)&&isValidEntry(stateValues.deviceConfig.id,PATTERNS.DEVICE_ID)&&VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor)&&VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version)&&isValidEntry(stateValues.pickStations,PATTERNS.PICK_STATIONS);}function validateNewAsmlComponentDevice(stateValues){if(PROTOCOLS.ASML.includes(stateValues.deviceType)){return areAllInputsFulfilled(stateValues)&&isValidEntry(stateValues.ip,IP_ADDRESS_PATTERN)&&isValidEntry(stateValues.mac,PATTERNS.MAC)&&isValidEntry(stateValues.port,PATTERNS.PORT)&&isValidEntry(stateValues.deviceConfig.id,PATTERNS.DEVICE_ID)&&isValidEntry(stateValues.name,PATTERNS.NAME)&&VENDOR_INFO_KEYS.VENDOR.includes(stateValues.vendorAttributes.vendor)&&VENDOR_INFO_KEYS.SPEC_VERSION.includes(stateValues.vendorAttributes.spec_version);}else{return false;}}function validateNewAsmlDevice(stateValues){return isValidEntry(stateValues.inductCameraMac,PATTERNS.MAC)&&(isValidEntry(stateValues.printerMac,PATTERNS.MAC)||stateValues.printerMac===__WEBPACK_IMPORTED_MODULE_1__Constants__["_210" /* UNASSIGN_PRINTER */]||stateValues.printerMac===__WEBPACK_IMPORTED_MODULE_1__Constants__["_142" /* NO_PRINTER_ASSIGNED */]);}function validateNewControllerDevice(mac,ip,name){return mac&&ip&&name&&isValidEntry(ip,IP_ADDRESS_PATTERN)&&isValidEntry(mac,PATTERNS.MAC)&&isValidEntry(name,PATTERNS.NAME);}function checkModalValidationsForMonitoring(stateValues){return areAllInputsFulfilledForMonitoring(stateValues)&&isValidEntry(stateValues.reason,PATTERNS.LONG_STRING);}function checkModalValidationsForConfig(stateValues,mac,assetType){if(assetType===__WEBPACK_IMPORTED_MODULE_1__Constants__["c" /* ADTA_ASSET_TYPE */]){return areAllInputsFulfilledForConfig(stateValues,assetType)&&isValidEntry(stateValues.bayId,PATTERNS.BAY_ID)&&(['jackpot','recirculation','problem_solve'].includes(stateValues.installation.type)||__WEBPACK_IMPORTED_MODULE_1__Constants__["_1" /* CATCH_ALL_INSTALLATION_TYPES */].includes(stateValues.installation.type)&&isValidEntry(stateValues.installation.locations,PATTERNS.CATCH_ALL_LOCATION)||isValidEntry(stateValues.installation.locations,PATTERNS.LOCATION)||__WEBPACK_IMPORTED_MODULE_4__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_4__FeatureUtility__["a" /* FEATURES */].IS_MULTIPLE_BULKY_SLIDES_FOR_DROP_TO_CART_ENABLED)&&__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].BULKY.value.includes(stateValues.installation.type)&&isValidEntry(stateValues.installation.locations,PATTERNS.SLIDE_LOCATION_RANGE)&&isValidRange(stateValues.installation.locations)||__WEBPACK_IMPORTED_MODULE_4__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_4__FeatureUtility__["a" /* FEATURES */].IS_MULTIPLE_FRAGILE_SLIDES_ENABLED_FOR_SSD)&&__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].FRAGILE.value.includes(stateValues.installation.type)&&isValidEntry(stateValues.installation.locations,PATTERNS.SLIDE_LOCATION_RANGE)// uses same regex as bulky
&&isValidRange(stateValues.installation.locations)||__WEBPACK_IMPORTED_MODULE_4__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_4__FeatureUtility__["a" /* FEATURES */].IS_BIN_INSTALLATION_TYPE_ENABLED)&&__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].BIN.value.includes(stateValues.installation.type)&&isValidEntry(stateValues.installation.locations,PATTERNS.BIN_LIST))&&isValidEntry(mac,PATTERNS.MAC);}else if(assetType===__WEBPACK_IMPORTED_MODULE_1__Constants__["e" /* ADTF_ASSET_TYPE */]){// TODO: Add regex pattern for destinationId and sorterId
var locationPattern=stateValues.installation.type===__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].STOW_STATION.value?PATTERNS.STOW_STATION_LOCATION:PATTERNS.LOCATION;return areAllInputsFulfilledForConfig(stateValues,assetType)&&(['miss','jackpot','ov',__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].FRAGILE.value].includes(stateValues.installation.type)||isValidEntry(stateValues.installation.locations,locationPattern))&&isValidEntry(mac,PATTERNS.MAC);}else if(assetType===__WEBPACK_IMPORTED_MODULE_1__Constants__["K" /* ASL_ASSET_TYPE */]){return areAllInputsFulfilledForConfig(stateValues,assetType)&&isValidEntry(stateValues.divertCode,PATTERNS.DIVERT_CODE)&&isValidEntry(stateValues.clusters,PATTERNS.CLUSTERS)&&isValidEntry(mac,PATTERNS.MAC);}else if(__WEBPACK_IMPORTED_MODULE_1__Constants__["_200" /* TESSERACT_ASSET_TYPE */]===assetType){return areAllInputsFulfilledForConfig(stateValues,assetType)&&isValidEntry(stateValues.containerType,PATTERNS.CONTAINER_TYPE)&&isValidEntry(stateValues.containerLabel,PATTERNS.CONTAINER_LABEL)&&isValidEntry(mac,PATTERNS.MAC);}else if(assetType===__WEBPACK_IMPORTED_MODULE_1__Constants__["R" /* AUTO_LOADER_ASSET_TYPE */]){return areAllInputsFulfilledForConfig(stateValues,assetType)&&isValidEntry(stateValues.destination,PATTERNS.DESTINATION)&&([__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].SIDELINE.value].includes(stateValues.installation.type)||__WEBPACK_IMPORTED_MODULE_1__Constants__["_1" /* CATCH_ALL_INSTALLATION_TYPES */].includes(stateValues.installation.type)&&isValidEntry(stateValues.installation.locations,PATTERNS.CATCH_ALL_LOCATION)||isValidEntry(stateValues.installation.locations,PATTERNS.LOCATION))&&isValidEntry(mac,PATTERNS.MAC);}}function validateAddDivertConfigModal(stateValues,mac,assetType){return areAllInputsFulfilledForConfig(stateValues,assetType)&&isValidEntry(stateValues.divertCode,PATTERNS.DIVERT_CODE)&&stateValues.clusters.every(function(cluster){return isValidEntry(cluster,PATTERNS.CLUSTERS);})&&isValidEntry(mac,PATTERNS.MAC);}function checkZancaSortAddTestPackageModalValidations(stateValues){if(__WEBPACK_IMPORTED_MODULE_4__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_4__FeatureUtility__["a" /* FEATURES */].IS_NEW_ZANCASORT_TEST_CONFIG_ENABLED)){return areAllInputsFulfilledForZancaSortTestPackage(stateValues)&&stateValues.scannables.every(function(entry){return isValidEntry(entry,PATTERNS.TEST_SCANNABLE);})&&isValidEntry(stateValues.destination,PATTERNS.SORT_LOCATION)&&stateValues.containerList.every(function(container){return isValidEntry(container,PATTERNS.BAG_LABEL);});}else{return areAllInputsFulfilledForZancaSortTestPackage(stateValues)&&stateValues.scannables.every(function(entry){return isValidEntry(entry,PATTERNS.TEST_SCANNABLE);})&&isValidEntry(stateValues.destination,PATTERNS.BAG_LABEL);}}function checkTesseractAddTestPackageModalValidations(stateValues){return areAllInputsFulfilledForTesseractTestPackage(stateValues)&&isValidEntry(stateValues.trackingId,PATTERNS.TEST_PACKAGE_ID)&&stateValues.scannables.every(function(entry){return isValidEntry(entry,PATTERNS.TEST_PACKAGE_ID);})&&stateValues.scannables.includes(stateValues.trackingId)&&stateValues.scannables.length<=2&&isValidEntry(stateValues.destination,PATTERNS.CONTAINER_LABEL);}function checkModalValidationsForTestPackage(stateValues){return areAllInputsFulfilledForTestPackage(stateValues)&&stateValues.scannables.every(function(entry){return isValidEntry(entry,PATTERNS.TEST_SCANNABLE);})&&isValidEntry(stateValues.sortZone,PATTERNS.SORT_ZONE);}var checkModalValidationsForAutoloaderTestPackage=function checkModalValidationsForAutoloaderTestPackage(config){return Array.isArray(config.scannables)&&config.scannables.length>0&&config.scannables.every(function(scannable){return isValidEntry(scannable,PATTERNS.TEST_SCANNABLE);})&&!isNaN(config.length)&&config.length>0&&!isNaN(config.height)&&config.height>0&&!isNaN(config.width)&&config.width>0&&!isNaN(config.weight)&&config.weight>0&&isValidEntry(config.sortZone,PATTERNS.SORT_ZONE);};function isValidTimestamp(timestamp){var newTimestamp=new Date(Number(timestamp)).getTime();return isNumeric(newTimestamp);}function isNumeric(n){return!isNaN(parseFloat(n))&&isFinite(n);}function checkDeviceMonitoringEnabled(deviceMonitoringStartTime,deviceMonitoringEndTime){if(!isValidTimestamp(deviceMonitoringStartTime)||!isValidTimestamp(deviceMonitoringEndTime)){return{isMonitoringEnabled:true,isValidEntry:false};}if(Object(__WEBPACK_IMPORTED_MODULE_2__Util__["I" /* getCurrentDate */])()<deviceMonitoringStartTime||Object(__WEBPACK_IMPORTED_MODULE_2__Util__["I" /* getCurrentDate */])()>deviceMonitoringEndTime){return{isMonitoringEnabled:true,isValidEntry:true};}return{isMonitoringEnabled:false,isValidEntry:true};}function getMonitoringStatusDetails(deviceMonitoring){return deviceMonitoring.isValidEntry?deviceMonitoring.isMonitoringEnabled?{monitoringStatusColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["X" /* BLUE_COLOR */],monitoringStatusId:'device.monitoringEnabled',monitoringStatusDefaultMessage:'Enabled'}:{monitoringStatusColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["_149" /* ORANGE_COLOR */],monitoringStatusId:'device.monitoringDisabled',monitoringStatusDefaultMessage:'Disabled'}:{monitoringStatusColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["X" /* BLUE_COLOR */],monitoringStatusId:'device.invalidEntry',monitoringStatusDefaultMessage:'Invalid Entry'};}function checkModalValidationsForTriggeringMHEValidation(stateValues,dateTimeInput){return!isStartTimeLaterThanEndTime(stateValues)&&!isDurationMoreThanTwelveHours(stateValues)&&isFromAndToDateTimeEntered(dateTimeInput);}function isStartTimeLaterThanEndTime(stateValues){return stateValues.startTime>=stateValues.endTime;}function isDurationMoreThanTwelveHours(stateValues){return Math.abs(stateValues.endTime-stateValues.startTime)>12*60*60*1000;}function isFromAndToDateTimeEntered(dateTimeInput){return dateTimeInput.valueDateFrom.length>0&&dateTimeInput.valueDateTo.length>0&&dateTimeInput.valueTimeFrom.length>0&&dateTimeInput.valueTimeTo.length>0;}/**
 * Check if scannables are unique.
 * @param {Array} scannables - List of scannables to check
 * @param {Array} existingData - Existing configurations
 * @param {string} currentKey - Current configuration key (for edit case)
 * @returns {Array} - List of duplicate scannables found, empty if none
 */function checkDuplicateScannables(scannables,existingData,currentKey){return scannables.filter(function(scannable){return existingData.some(function(entry){return entry.scannables.includes(scannable)&&Object(__WEBPACK_IMPORTED_MODULE_2__Util__["_13" /* getTestConfigKey */])(entry.scannables)!==currentKey;});});}/**
 * Check if containers are mapped to unique destination/sort zone.
 * @param {Array} containers - List of containers to check
 * @param {string} destination - Destination/sort zone
 * @param {Array} existingData - Existing configurations
 * @param {string} currentKey - Current configuration key (for edit case)
 * @returns {Array} - List of containers with conflicts, empty if none
 */function checkContainerDestinationConflicts(containers,destination,existingData,currentKey){try{var containerToDestinationMap=new Map();existingData.forEach(function(entry){if(Object(__WEBPACK_IMPORTED_MODULE_2__Util__["_13" /* getTestConfigKey */])(entry.scannables)!==currentKey){// Skip current entry if editing
if(entry.containerList&&Array.isArray(entry.containerList)){entry.containerList.forEach(function(container){if(container&&entry.destination){containerToDestinationMap.set(container,entry.destination);}});}}});// Find containers that are already assigned to different destination
return containers.filter(function(container){var existingDestination=containerToDestinationMap.get(container);return existingDestination&&existingDestination!==destination;});}catch(error){console.error('Error in container to destination validation',error);return[];}}function hasUnavailableFloor(floorSorterConfig,floorsForSlide){var availableFloors=new Set();floorSorterConfig.forEach(function(config){config.installation.locations.forEach(function(location){availableFloors.add(location);});});var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=floorsForSlide[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var floorForSlide=_step.value;if(!availableFloors.has(floorForSlide)){return false;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return true;}function isValidRange(locationString){var locations=locationString.split(__WEBPACK_IMPORTED_MODULE_1__Constants__["_178" /* SEMI_COLON */]);var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=locations[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var location=_step2.value;var locationList=location.split(__WEBPACK_IMPORTED_MODULE_1__Constants__["_2" /* COLON */]);if(locationList.length>2){return false;}if(locationList.length===2){if(!isValidRangePair(locationList[0],locationList[1])){return false;}}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}return true;}function isValidRangePair(start,end){var startParts=start.split(__WEBPACK_IMPORTED_MODULE_1__Constants__["_24" /* DOT */]);var endParts=end.split(__WEBPACK_IMPORTED_MODULE_1__Constants__["_24" /* DOT */]);if(startParts.length!==3||endParts.length!==3){return false;}if(startParts[0]!==endParts[0]){return false;}if(startParts[2]!==endParts[2]){return false;}if(!startParts[1].startsWith('L')||!endParts[1].startsWith('L')){return false;}var startNum=parseInt(startParts[1].slice(1),10);var endNum=parseInt(endParts[1].slice(1),10);if(isNaN(startNum)||isNaN(endNum)||startNum>=endNum){return false;}return true;}/**
 * Validates ZancaSort location configuration.
 * Checks for non-empty locationId and locationType, and validates locationType against allowed enum values.
 * @param {Object} config - Configuration object with locationId and locationType properties
 * @returns {boolean} - true if valid, false if invalid
 */function validateZancaSortLocationConfig(config){// Check for non-empty values
if(!config.locationId||!config.locationType){return false;}// Validate location type enum
var validLocationTypes=Object.keys(__WEBPACK_IMPORTED_MODULE_1__Constants__["_223" /* ZANCASORT_LOCATION_TYPES */]);if(!validLocationTypes.includes(config.locationType)){return false;}return true;}/**
 * Validates a single ZancaSort tier configuration entry. The tier name must be one of
 * the allowed tier names, see ZANCA_SORT_TIER_NAMES.
 * @param {Object} config - { tierName, capacity, startLevel, endLevel }
 * @returns {boolean} - true if valid, false if invalid
 */function validateZancaSortTierConfig(config){if(!__WEBPACK_IMPORTED_MODULE_1__Constants__["_224" /* ZANCA_SORT_TIER_NAMES */].includes(config.tierName))return false;if(!Number.isInteger(config.capacity)||config.capacity<=0)return false;if(!Number.isInteger(config.startLevel)||config.startLevel<1)return false;if(!Number.isInteger(config.endLevel)||config.endLevel<1)return false;if(config.startLevel>config.endLevel)return false;return true;}/**
 * Checks for overlapping level ranges across tier configurations.
 * @param {Array} tierConfigs - Array of { tierName, capacity, startLevel, endLevel }
 * @returns {Object|null} - null if no overlap, or { tier1, tier2 } describing the conflicting tiers
 */function checkTierConfigLevelOverlap(tierConfigs){for(var i=0;i<tierConfigs.length;i++){for(var j=i+1;j<tierConfigs.length;j++){var a=tierConfigs[i];var b=tierConfigs[j];// Ranges overlap if one starts before the other ends
if(a.startLevel<=b.endLevel&&b.startLevel<=a.endLevel){return{tier1:a.tierName,tier2:b.tierName};}}}return null;}function validateLocationMappingRow(destination,type,locations,existingRows,isEdit){var DESTINATION_REGEX=/^[a-zA-Z][a-zA-Z0-9_\-.]{0,49}$/;if(!destination||!destination.trim()){return{id:"locationmapping.error.destination_required"};}if(!DESTINATION_REGEX.test(destination.trim())){return{id:"locationmapping.error.destination_invalid"};}if(!type||!__WEBPACK_IMPORTED_MODULE_1__Constants__["_152" /* PICK_ITEM_TYPES */].includes(type)){return{id:"locationmapping.error.type_required"};}if(!locations||locations.length===0){return{id:"locationmapping.error.locations_required"};}if(!isEdit){var duplicate=existingRows.find(function(row){return row.destination===destination.trim()&&row.type===type;});if(duplicate){return{id:"locationmapping.error.duplicate",values:{destination:destination.trim(),type:type}};}}var _loop=function _loop(loc){var conflict=existingRows.find(function(row){return row.type===type&&row.destination!==destination.trim()&&row.locations&&row.locations.includes(loc);});if(conflict){return{v:{id:"locationmapping.error.conflict",values:{pickPoint:loc,destination:conflict.destination,type:type}}};}};var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=locations[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var loc=_step3.value;var _ret=_loop(loc);if((typeof _ret==="undefined"?"undefined":_typeof(_ret))==="object")return _ret.v;}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}return null;}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _icon = _interopRequireDefault(__webpack_require__(681));

var _default = _icon["default"];
exports["default"] = _default;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(660);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ModalFooter", {
  enumerable: true,
  get: function get() {
    return _modalFooter["default"];
  }
});
exports["default"] = void 0;

var _modal = _interopRequireDefault(__webpack_require__(880));

var _modalFooter = _interopRequireDefault(__webpack_require__(408));

var _default = _modal["default"];
exports["default"] = _default;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(757)
var ieee754 = __webpack_require__(758)
var isArray = __webpack_require__(759)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTokenPrefixes = exports.memoizeTokenStyles = exports.getUnthemedTokens = exports.getTokenHelper = exports.getToken = exports.getIconFromTokens = void 0;

var _pascalCase = _interopRequireDefault(__webpack_require__(654));

var _upperFirst = _interopRequireDefault(__webpack_require__(339));

var _lowerFirst = _interopRequireDefault(__webpack_require__(655));

var _functional = __webpack_require__(38);

/**
 * Select a single token from a token object given a key (and optionally a
 * "suffix" key or list of suffix keys). If the token doesn't exist then an
 * attempt is made to replace the last suffix key with "default" and get the
 * value for that token. If that token also doesn't exist then `undefined` is
 * returned.
 *
 * @example
 * const tokens = {
 *   backgroundColorDefault: "#fff",
 *   backgroundColorHover: "#ccc",
 *   backgroundColorPressed: "#f00",
 * }
 * getToken(tokens, "backgroundColor", "active") // #fff
 * getTokens(tokens, "background", ["color", "pressed"]) // #f00
 * getToken(tokens, "myBackgroundColor") // undefined
 */
var getToken = function getToken(tokens, key, suffixKeys) {
  // If we got an array of suffix keys, turn them into a PascalCaseString and
  // look up the token
  if (suffixKeys && Array.isArray(suffixKeys)) {
    var value = tokens["".concat(key).concat((0, _pascalCase["default"])(suffixKeys))];
    return value !== undefined ? value : tokens["".concat(key).concat((0, _pascalCase["default"])(suffixKeys.slice(0, -1)), "Default")]; // If we got a single suffix key then upper case the first character and look
    // up the token
  } else if (suffixKeys) {
    var _value = tokens["".concat(key).concat((0, _upperFirst["default"])(suffixKeys))];
    return _value !== undefined ? _value : tokens["".concat(key, "Default")]; // If we didn't get any suffix keys then do a simple lookup
  } else {
    return tokens[key];
  }
};
/**
 * This will, given a root key and token object, return a special helper that
 * includes token utilities with those inputs already applied. Calling the
 * helper as a function is equivalent to calling `getToken`, but the helper also
 * includes several properties that make it easier to construct CSS from tokens.
 * This helper is useful when working with an object of tokens that all have the
 * same prefix.
 *
 * @example
 * const tokens = {
 *   buttonBorderWidth: 1,
 *   buttonBorderStyle: "dotted",
 *   buttonBorderColor: "#f00",
 * }
 * const t = getTokenHelper("button")(tokens)
 * t("borderWidth") // 1
 * t.borderCss("border") // "1px dotted #f00"
 * t.tokens === tokens // true
 *
 */


exports.getToken = getToken;
var getTokenHelper = (0, _functional.memoizeCurry)(function (prefixKey, tokens) {
  var helper = function helper(key, suffixKeys) {
    return getToken(tokens, prefixKey ? "".concat(prefixKey).concat((0, _upperFirst["default"])(key)) : key, suffixKeys);
  };

  helper.tokens = tokens; // Pass in "myBorder" and shorthand border css will be generated based on
  // "myBorderWidth" and "myBorderColor" tokens.

  helper.borderCss = function (key) {
    var width = helper(key, "width");
    var color = helper(key, "color");
    return width && color ? "".concat(width, "px solid ").concat(color) : undefined;
  }; // Pass in "myShadow" and shorthand box shadow css will be generated based on
  // "myShadowOffsetX", "myShadowOffsetY", "myShadowBlur", "myShadowSpread",
  // and "myShadowColor" tokens


  helper.boxShadowCss = function (key) {
    var color = helper(key, "color");
    return color ? "".concat(helper(key, "offsetX"), "px ").concat(helper(key, "offsetY"), "px ").concat(helper(key, "blur"), "px ").concat(helper(key, "spread"), "px ").concat(color) : undefined;
  }; // Pass in "myMotion" and a single css property or array of properties and
  // shorthand transition css will be generated that animates those properties
  // based on "myMotionFunction" and "myMotionDuration" tokens


  helper.transitionCss = function (key, properties) {
    var transition = "".concat(helper(key, "duration"), " ").concat(helper(key, "function"));
    return Array.isArray(properties) ? properties.map(function (property) {
      return "".concat(property, " ").concat(transition);
    }).join(", ") : "".concat(properties, " ").concat(transition);
  };

  return helper;
}, 1);
/**
 * Gets icon data from a set of icon tokens
 *
 * ```
 * const tokens = {
 *   iconCheckmarkData: "<svg />",
 *.  iconCheckmarkWidth: 12,
 *   iconCheckmarkHeight: 10,
 * }
 * // Returns { data: "<svg />", width: 12, height: 10 }
 * getIconFromTokens(tokens)
 * ```
 */

exports.getTokenHelper = getTokenHelper;

var getIconFromTokens = function getIconFromTokens(tokens) {
  return Object.keys(tokens).reduce(function (result, key) {
    if (key.indexOf("Data") > 0) {
      result.data = tokens[key];
    } else if (key.indexOf("Rtl") > 0) {
      result.dataRtl = tokens[key];
    } else if (key.indexOf("Width") > 0) {
      result.width = tokens[key];
    } else if (key.indexOf("Height") > 0) {
      result.height = tokens[key];
    }

    return result;
  }, {});
};
/**
 * If you pass in a function that returns themed tokens when given a theme
 * object (e.g. any of our "component" tokens), this will call that function
 * with an empty theme object and filter out any tokens that are undefined. This
 * is useful for quickly accessing unthemed component tokens. Use this sparingly
 * as what is and is not themed may change in the future and require a refactor
 * of any code using this function.
 */


exports.getIconFromTokens = getIconFromTokens;

var getUnthemedTokens = function getUnthemedTokens(tokens) {
  var unthemedTokens = tokens({});
  return Object.keys(unthemedTokens).reduce(function (result, key) {
    if (unthemedTokens[key] !== undefined) {
      result[key] = unthemedTokens[key];
    }

    return result;
  }, {});
};
/**
 * Takes an object of tokens and removes the prefix from each token name (object
 * key). The result is returned with the first character of the new keys
 * lowercased.
 *
 * ```
 * const tokens = {
 *   iconCheckmarkData: "<svg />",
 *.  iconCheckmarkWidth: 12,
 *   iconCheckmarkHeight: 10,
 * }
 * // Returns { data: "<svg />", width: 12, height: 10 }
 * removetokenPrefixes(tokens, "iconCheckmark")
 * ```
 */


exports.getUnthemedTokens = getUnthemedTokens;

var removeTokenPrefixes = function removeTokenPrefixes(tokens, prefix) {
  var match = new RegExp("^".concat(prefix));
  return Object.keys(tokens).reduce(function (result, key) {
    if (match.test(key)) {
      result[(0, _lowerFirst["default"])(key.replace(match, ""))] = tokens[key];
    }

    return result;
  }, {});
};
/**
 * Memoize f(tokens, props) that is used extensively throughout meridian components,
 * specify the keys in the object to compare when determining whether to re-use
 * a previous calculation.
 *
 * @example
 * const style = memoizeTokenStyles((t, {a, b}) => css({a, b}), ["a", "b"])
 * style(tokens, {a, b})
 */


exports.removeTokenPrefixes = removeTokenPrefixes;

var memoizeTokenStyles = function memoizeTokenStyles(f, keys) {
  /* eslint-disable-next-line rulesdir/no-partial-memoization */
  var fn = (0, _functional.memoize)(function (t) {
    return (0, _functional.memoizeByKeys)(function (props) {
      return f(t, props);
    }, keys);
  });
  return function (t, props) {
    return fn(t)(props);
  };
};

exports.memoizeTokenStyles = memoizeTokenStyles;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SelectOption", {
  enumerable: true,
  get: function get() {
    return _selectOption["default"];
  }
});
Object.defineProperty(exports, "SelectOptionGroup", {
  enumerable: true,
  get: function get() {
    return _selectOptionGroup["default"];
  }
});
exports["default"] = void 0;

var _select = _interopRequireDefault(__webpack_require__(995));

var _selectOption = _interopRequireDefault(__webpack_require__(435));

var _selectOptionGroup = _interopRequireDefault(__webpack_require__(436));

var _default = _select["default"];
exports["default"] = _default;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _input = _interopRequireDefault(__webpack_require__(895));

var _default = _input["default"];
exports["default"] = _default;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Style", {
  enumerable: true,
  get: function get() {
    return _theme.Style;
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "useTheme", {
  enumerable: true,
  get: function get() {
    return _theme.useTheme;
  }
});

__webpack_require__(651);

var _theme = _interopRequireWildcard(__webpack_require__(652));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _theme["default"];
exports["default"] = _default;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(711);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(25)["default"];

var assertThisInitialized = __webpack_require__(48);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _box = _interopRequireDefault(__webpack_require__(648));

var _default = _box["default"];
exports["default"] = _default;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TableActionBar", {
  enumerable: true,
  get: function get() {
    return _tableActionBar["default"];
  }
});
Object.defineProperty(exports, "TableActionBarOverlay", {
  enumerable: true,
  get: function get() {
    return _tableActionBar.TableActionBarOverlay;
  }
});
Object.defineProperty(exports, "TableCell", {
  enumerable: true,
  get: function get() {
    return _tableCell["default"];
  }
});
Object.defineProperty(exports, "TableRow", {
  enumerable: true,
  get: function get() {
    return _tableRow["default"];
  }
});
Object.defineProperty(exports, "TableSectionHeader", {
  enumerable: true,
  get: function get() {
    return _tableSectionHeader["default"];
  }
});
exports["default"] = void 0;

var _table = _interopRequireDefault(__webpack_require__(710));

var _tableRow = _interopRequireDefault(__webpack_require__(258));

var _tableCell = _interopRequireDefault(__webpack_require__(355));

var _tableSectionHeader = _interopRequireDefault(__webpack_require__(354));

var _tableActionBar = _interopRequireWildcard(__webpack_require__(728));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _table["default"];
exports["default"] = _default;

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalStateContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_GlobalStateReducer__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_toaster__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_toaster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_toaster__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_radio_button__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_radio_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_radio_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_FeatureUtility__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_dompurify__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_dompurify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_dompurify__);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var GlobalStateContext=Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])();var GlobalStateContextProvider=function GlobalStateContextProvider(_ref){var intl=_ref.intl,children=_ref.children;var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_2__reducers_GlobalStateReducer__["a" /* GlobalStateReducer */],__WEBPACK_IMPORTED_MODULE_2__reducers_GlobalStateReducer__["b" /* initialState */]),_useReducer2=_slicedToArray(_useReducer,2),globalState=_useReducer2[0],dispatchGlobal=_useReducer2[1];var setAsyncError=function setAsyncError(asyncError){dispatchGlobal({type:'SET_ASYNC_ERROR',data:{asyncError:asyncError}});};var restartApp=function restartApp(){dispatchGlobal({type:'RESTART_APP'});};var showWarning=function showWarning(msg,callBack){dispatchGlobal({type:'SET_WARNING',data:{warningMsg:msg,warningAction:callBack}});};var onCloseModal=function onCloseModal(){dispatchGlobal({type:'SET_WARNING',data:{warningMsg:'',warningAction:function warningAction(){}}});};var showCustomAlert=function showCustomAlert(message){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_122" /* MERIDIAN_ALERT_TYPE */].INFO;var id=Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_2" /* getRandomInt */])(100);dispatchGlobal({type:'SHOW_CUSTOM_ALERT',data:{toast:{id:id,message:message,type:type}}});};var closeCustomAlert=function closeCustomAlert(toastId){dispatchGlobal({type:'CLOSE_CUSTOM_ALERT',data:{toastId:toastId}});};var setLink=function setLink(link){dispatchGlobal({type:'SET_LINK',data:{link:link}});};var setLinkTab=function setLinkTab(linkTab){dispatchGlobal({type:'SET_LINK_TAB',data:{linkTab:linkTab}});};var setLoadingFeatures=function setLoadingFeatures(loadingFeatures){dispatchGlobal({type:'SET_LOADING_FEATURES',data:{loadingFeatures:loadingFeatures}});};Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:__WEBPACK_IMPORTED_MODULE_16__util_FeatureUtility__["b" /* FeatureUtility */].setAllFeatureStatuses().then(function(response){setLoadingFeatures(true);});case 1:case'end':return _context.stop();}}},_callee,_this);}))();},[]);var value=Object.assign({},globalState,{setAsyncError:setAsyncError,restartApp:restartApp,showWarning:showWarning,showCustomAlert:showCustomAlert,closeCustomAlert:closeCustomAlert});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(GlobalStateContext.Provider,{value:value},children,globalState.toasts.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_toaster___default.a,{toasts:globalState.toasts,onCloseToast:closeCustomAlert,alignmentHorizontal:'center'},function(toast){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert___default.a,{toast:true,onClose:function onClose(){return toast.onClose(toast.id);},type:toast.type},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_17_dompurify___default.a.sanitize((Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:toast.message})||'').replace(/\n/g,'<br/>').replace(/<a /g,'<a target="_blank" rel="noopener noreferrer" '),{ALLOWED_TAGS:['br','a'],ALLOWED_ATTR:['href','target','rel']})}}));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default.a,{title:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'common.warning',defaultMessage:'Warning'}),open:globalState.warningMsg,onClose:function onClose(){onCloseModal();setLink("");},scrollContainer:'viewport',closeLabel:'Close'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,null,globalState.warningMsg),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_radio_button___default.a,{checked:globalState.linkTab===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_120" /* MCM */],onChange:setLinkTab,value:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_120" /* MCM */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.mcm"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_radio_button___default.a,{checked:globalState.linkTab===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_203" /* TICKET */],onChange:setLinkTab,value:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_203" /* TICKET */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.ticket"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_radio_button___default.a,{checked:globalState.linkTab===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_95" /* JUSTIFICATION */],onChange:setLinkTab,value:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_95" /* JUSTIFICATION */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.justification"})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_input___default.a,{id:'link',value:globalState.link,onChange:setLink,type:'text',placeholder:Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.linkPlaceHolder"}),error:!Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["j" /* checkValidLink */])(globalState.linkTab,globalState.link)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:'end',widths:'fit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{type:'tertiary',size:'small',onClick:function onClick(){onCloseModal();setLink("");}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'modal.cancel',defaultMessage:'Cancel'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{type:'primary',size:'small',disabled:!Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["j" /* checkValidLink */])(globalState.linkTab,globalState.link),onClick:function onClick(){setLink("");globalState.warningAction();onCloseModal();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:'modal.confirm',defaultMessage:'Confirm'}))))));};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_intl__["d" /* injectIntl */])(GlobalStateContextProvider));

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DraftContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_DraftSaveReducer__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(5);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DraftContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var DraftContextProvider=function DraftContextProvider(props){var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducers_DraftSaveReducer__["a" /* DraftSaveReducer */],__WEBPACK_IMPORTED_MODULE_1__reducers_DraftSaveReducer__["b" /* initialState */]),_useReducer2=_slicedToArray(_useReducer,2),draftData=_useReducer2[0],dispatchDraft=_useReducer2[1];var setDraftData=function setDraftData(_ref){var data=_ref.data,stateKey=_ref.stateKey,subKey=_ref.subKey,allRowsAdded=_ref.allRowsAdded,override=_ref.override;if(!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(stateKey)||!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(subKey)||!Array.isArray(data))return;var prevData=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["f" /* chainWalk */])(function(){return draftData[stateKey][subKey].data;},null);if(prevData&&!override)return;var editedData=data.map(function(instance){return Object.assign({},instance,{operation:allRowsAdded?__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_147" /* OPERATIONS */].ADD:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_147" /* OPERATIONS */].NO_OP});});dispatchDraft({type:"SET_DATA",data:{data:editedData,stateKey:stateKey,subKey:subKey,allRowsAdded:allRowsAdded}});};var addInstance=function addInstance(_ref2){var stateKey=_ref2.stateKey,subKey=_ref2.subKey,instance=_ref2.instance;if(!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(stateKey)||!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(instance))return;instance.operation=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_147" /* OPERATIONS */].ADD;dispatchDraft({type:"ADD_INSTANCE",data:{stateKey:stateKey,subKey:subKey,newInstance:instance}});};var editInstance=function editInstance(_ref3){var stateKey=_ref3.stateKey,subKey=_ref3.subKey,instance=_ref3.instance,keyComparator=_ref3.keyComparator,valueComparator=_ref3.valueComparator;if(!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(stateKey)||!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(instance)||!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(keyComparator))return;dispatchDraft({type:"EDIT_INSTANCE",data:{stateKey:stateKey,subKey:subKey,newInstance:instance,keyComparator:keyComparator,valueComparator:valueComparator}});};var deleteInstance=function deleteInstance(_ref4){var stateKey=_ref4.stateKey,subKey=_ref4.subKey,keyComparator=_ref4.keyComparator;if(!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(stateKey)||!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(keyComparator))return;dispatchDraft({type:"DELETE_INSTANCE",data:{stateKey:stateKey,subKey:subKey,keyComparator:keyComparator}});};var deleteAll=function deleteAll(_ref5){var stateKey=_ref5.stateKey,subKey=_ref5.subKey;if(!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(stateKey)||!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(subKey))return;dispatchDraft({type:"DELETE_ALL",data:{stateKey:stateKey,subKey:subKey}});};var resetDraftData=function resetDraftData(stateKeys,subKey){if(!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(stateKeys)||!Array.isArray(stateKeys))return;stateKeys.forEach(function(stateKey){return dispatchDraft({type:"RESET_DATA",data:{stateKey:stateKey,subKey:subKey}});});};var getDraftData=function getDraftData(_ref6){var stateKey=_ref6.stateKey,subKey=_ref6.subKey;if(!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(stateKey)||!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(subKey))return;return Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["f" /* chainWalk */])(function(){return draftData[stateKey][subKey].data;},[]);};var getFilteredDraftData=function getFilteredDraftData(_ref7){var stateKey=_ref7.stateKey,subKey=_ref7.subKey;if(!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(stateKey)||!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(subKey))return;var filteredData=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["f" /* chainWalk */])(function(){return draftData[stateKey][subKey].data;},[]).filter(function(instance){return instance.operation!==__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_147" /* OPERATIONS */].DELETE;});return filteredData.map(function(instance){var editedInstance=Object.assign({},instance);if("operation"in editedInstance)delete editedInstance.operation;if("prev"in editedInstance)delete editedInstance.prev;return editedInstance;});};var isDataEdited=function isDataEdited(stateKeys){if(!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(stateKeys))return false;var isEdited=false;stateKeys.forEach(function(stateKey){if(!Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_20" /* isValid */])(stateKey))return;Object.keys(draftData[stateKey]).forEach(function(subKey){draftData[stateKey][subKey].data.forEach(function(instance){if(instance.operation!==__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_147" /* OPERATIONS */].NO_OP){isEdited=true;}});});});return isEdited;};var value={setDraftData:setDraftData,getDraftData:getDraftData,getFilteredDraftData:getFilteredDraftData,resetDraftData:resetDraftData,addInstance:addInstance,editInstance:editInstance,deleteInstance:deleteInstance,isDataEdited:isDataEdited,deleteAll:deleteAll};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DraftContext.Provider,{value:value},props.children);};/* harmony default export */ __webpack_exports__["b"] = (DraftContextProvider);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {
	        function F() {}

	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                F.prototype = this;
	                var subtype = new F();

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init')) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoize = memoize;
exports.memoizeArray = memoizeArray;
exports.memoizeByKeys = memoizeByKeys;
exports.memoizeCurry = memoizeCurry;

/**
 * Author: shekwong@
 */
var END = new Object();
/**
 * Memoize a function with one argument.
 *
 * @example
 * const square = a => a * a
 * const memoizedSquare = memoize(square)
 * memoizedSquare(2) // 4
 */

function memoize(f) {
  var memo = new Map();
  return function (i) {
    if (memo.has(i)) {
      return memo.get(i);
    }

    var result = f(i);
    memo.set(i, result);
    return result;
  };
}
/**
 * Memoize a function with N args by currying it
 *
 * @example
 * const multiply = (a, b) => a * b
 * const memoizedMultiply = memoize(multiply, 1)
 * memoizedMultiply(2)(3) // 6
 */


function memoizeCurry(f, depth) {
  var a = f;

  if (depth == 0) {
    return memoize(a);
  }

  return memoize(function (x) {
    return memoizeCurry(a.bind(null, x), depth - 1);
  });
}
/**
 * A helper function used by memoizeByKeys.
 */


function memoizeByKeysCurry(f, resolver, depth) {
  var a = f;

  if (depth == 0) {
    return memoize(resolver);
  }

  return memoize(function (x) {
    return memoizeByKeysCurry(a.bind(null, x), resolver, depth - 1);
  });
}
/**
 * Memoize a function that accepts an object as its only argument. You must
 * specify the keys in the object to compare when determining whether to re-use
 * a previous calculation.
 *
 * NOTE: This can only support properties in the object that are simple (e.g.
 * strings, numbers, booleans, not nested objects or arrays).
 *
 * @example
 * const multiply = ({ a, b }) => a * b
 * cont memoizedMultiply = memoizeByKeys(multiply, ["a", "b"])
 * memoizedMultiply({ a: 2, b: 3 }) // 6
 */


function memoizeByKeys(f, keys) {
  var args = undefined;
  var g = memoizeByKeysCurry(f, function () {
    return f(args);
  }, keys.length - 1);
  return function (a) {
    if (!a) {
      var _c = g;
      keys.forEach(function () {
        _c = _c(undefined);
      });
      return _c;
    }

    args = a;
    var c = g;
    keys.forEach(function (k) {
      c = c(args[k]);
    });
    return c;
  };
}
/**
 * A helper function used by memoizeArray.
 */


function memoizeByVarArgsCurry(f) {
  var a = f;
  return memoize(function (x) {
    return x === END ? a() : memoizeByVarArgsCurry(a.bind(null, x));
  });
}
/**
 * Memoize a function that accepts an array as its only argument.
 *
 * @example
 * const multiply = numbers => numbers.reduce((result, num) => result * num)
 * cont memoizedMultiply = memoizeArray(multiply)
 * memoizedMultiply([2, 3, 4]) // 24
 */


function memoizeArray(f) {
  var memoized = memoizeByVarArgsCurry(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return f(args);
  });
  return function (vals) {
    var g = memoized;
    vals.forEach(function (v) {
      g = g(v);
    });
    return g(END);
  };
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Takes an object of props and filters them down to only the props with names
 * that start with one of a given set of prefixes.
 */
var filterPropsByPrefix = function filterPropsByPrefix(props, prefixes) {
  return Object.keys(props).filter(function (name) {
    return prefixes.some(function (prefix) {
      return name.indexOf(prefix) === 0;
    });
  }).reduce(function (result, name) {
    result[name] = props[name];
    return result;
  }, {});
};

var _default = filterPropsByPrefix;
exports["default"] = _default;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconTrashData: "data:image/svg+xml,%3csvg width='18' height='20' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round'%3e%3cpath d='M1 1h16'/%3e%3cpath stroke-linejoin='round' d='M3 5v14h12V5'/%3e%3cpath d='M7 5v10M11 5v10'/%3e%3c/g%3e%3c/svg%3e",
  iconTrashWidth: 18,
  iconTrashHeight: 20
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 42 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_loader__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_loader__);
var LoaderView=function LoaderView(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_loader___default.a,{type:"circular",size:"large"})));};/* harmony default export */ __webpack_exports__["a"] = (LoaderView);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DEFAULT_ROUTES; });
/* unused harmony export BAG_TRACKING_ROUTE */
/* unused harmony export AUTO_LOADER_ROUTE */
/* unused harmony export VAPR_ROUTE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DEVICE_MANAGEMENT_ROUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return TRAFFIC_LIGHT_ROUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADTA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return adtaMheValidationRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADTF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADTF_MATRIX_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADTF_SIMPLE_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADTF_PULLMODE_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ASL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return ZANCA_SORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TESSERACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return AUTO_RETRIEVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return AUTO_LOADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return VAPR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADTF_SUB_COMPONENT_ROUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return IN_SITE_ASML_SUB_COMPONENT_ROUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ASML_SUB_COMPONENT_ROUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ASML_SUB_COMPONENT_VALIDATION_ROUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return INDUCT_CAMERA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PRINTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return VERIFICATION_CAMERA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return HANDSFREE_CAMERA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return OVERHEAD_CAMERA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ASML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return aslMheValidationRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return THIN_CLIENTS; });
/* unused harmony export SBL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return LIDARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return TRAFFIC_LIGHTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return LED_CONTROLLERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return LED_CONTROLLERS_WITH_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return LED_CONTROLLER_STAG_ROUTES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__devicemanagement_adtadevice_AdtaDevicePage__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__devicemanagement_asldevice_AslDevicePage__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__devicemanagement_adtadevice_AdtaDeviceOverview__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__devicemanagement_adtadevice_AdtaDeviceConfiguration__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__devicemanagement_adtadevice_AdtaDeviceLogstream__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__devicemanagement_asldevice_AslDeviceOverview__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__devicemanagement_asldevice_AslDeviceConfiguration__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__devicemanagement_asldevice_AslDeviceLogstream__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__devicemanagement_thinclient_ThinClientOverview__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__devicemanagement_sbldevice_SblDeviceOverview__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__devicemanagement_sbldevice_SblDeviceConfiguration__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__devicemanagement_thinclient_ThinClientPage__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__devicemanagement_lidar_LidarOverview__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__devicemanagement_lidar_LidarManageByExceptions__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__devicemanagement_lidar_LidarPage__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__devicemanagement_ledcontroller_LEDControllerOverview__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__devicemanagement_ledcontroller_LEDControllerConfiguration__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__devicemanagement_ledcontroller_SBLDashboard__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__devicemanagement_ledcontroller_LEDControllerPage__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__devicemanagement_ledcontroller_bintester__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__devicemanagement_ledcontroller_aisleconfig_AisleConfigFinder__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__devicemanagement_trafficlightdevice_TrafficLightPage__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__devicemanagement_trafficlightdevice_TrafficLightControllerSelectPage__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__devicemanagement_trafficlightdevice_TrafficLightControllerOverview__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__devicemanagement_adtfdevice_AdtfDeviceOverview__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__devicemanagement_adtfdevice_AdtfDeviceConfiguration__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__devicemanagement_adtfdevice_AdtfMatrixPage__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__devicemanagement_adtfdevice_AdtfDeviceLogstream__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__devicemanagement_adtadevice_AdtaDeviceValidation__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__devicemanagement_asldevice_AslDeviceValidation__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__devicemanagement_zancasort_ZancaSortDevicePage__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__devicemanagement_zancasort_ZancaSortDeviceOverview__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__devicemanagement_tesseract_TesseractDevicePage__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__devicemanagement_tesseract_TesseractDeviceOverview__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__devicemanagement_zancasort_ZancaSortDeviceConfiguration__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__devicemanagement_tesseract_TesseractDeviceConfiguration__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__devicemanagement_autoretriever_AutoRetrieverDeviceOverview__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__devicemanagement_autoretriever_AutoRetrieverDevicePage__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__devicemanagement_bagtracking_BagTrackingPage__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__devicemanagement_zancasort_ZancaSortDeviceLogstream__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__devicemanagement_tesseract_TesseractDeviceLogstream__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__devicemanagement_autoretriever_AutoRetrieverDeviceLogstream__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__devicemanagement_asmldevice_AsmlSubComponentSelectPage__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__devicemanagement_asmldevice_AsmlProtocolValidationSubComponentSelectionPage__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__devicemanagement_asmldevice_InductCameraDeviceValidation__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__devicemanagement_asmldevice_VerificationCameraDeviceValidation__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__devicemanagement_asmldevice_InductCameraDevicePage__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__devicemanagement_asmldevice_InductCameraDeviceOverview__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__devicemanagement_asmldevice_PrinterDeviceOverview__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__devicemanagement_asmldevice_PrinterDevicePage__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__devicemanagement_autoretriever_AutoRetrieverDeviceConfiguration__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__devicemanagement_asmldevice_VerificationCameraDeviceOverview__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__devicemanagement_asmldevice_VerificationCameraDevicePage__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__devicemanagement_asmldevice_AsmlDevicePage__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__devicemanagement_asmldevice_HandsfreeCameraDevicePage__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__devicemanagement_asmldevice_HandsfreeCameraDeviceOverview__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__devicemanagement_asmldevice_OverheadCameraDevicePage__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__devicemanagement_asmldevice_OverheadCameraDeviceOverview__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__devicemanagement_asmldevice_AsmlDeviceOverview__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__devicemanagement_asmldevice_AsmlDeviceLogStream__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__FeatureUtility__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__devicemanagement_lidar_LidarTesterTool__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__devicemanagement_autoloader_AutoLoaderDevicePage__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__devicemanagement_autoloader_AutoLoaderDeviceOverview__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__devicemanagement_autoloader_AutoLoaderDeviceConfiguration__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__devicemanagement_autoloader_AutoLoaderDeviceLogstream__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__devicemanagement_adtfdevice_AdtfSubComponentSelectPage__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__devicemanagement_adtfdevice_AdtfPullModePage__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__devicemanagement_adtfdevice_AdtfSimplePage__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__devicemanagement_adtfdevice_AdtfDevicePage__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__devicemanagement_ledcontrollerstag_LEDControllerSTAGPage__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__devicemanagement_vaprdevice_VaprDevicePage__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__devicemanagement_vaprdevice_VaprDeviceOverview__ = __webpack_require__(1419);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var DEFAULT_ROUTES={"/devicemanagement/asl":"/devicemanagement/asl/overview","/devicemanagement/adta":"/devicemanagement/adta/overview","/devicemanagement/adtfmatrix":"/devicemanagement/adtfmatrix/overview","/devicemanagement/adtf/matrix":"/devicemanagement/adtf/matrix/overview","/devicemanagement/adtf/simple":"/devicemanagement/adtf/simple/overview","/devicemanagement/adtf/pullmode":"/devicemanagement/adtf/pullmode/overview","/devicemanagement/thinclient":"/devicemanagement/thinclient/overview","/devicemanagement/asml/inductcamera":"/devicemanagement/asml/inductcamera/overview","/devicemanagement/asml/printer":"/devicemanagement/asml/printer/overview","/devicemanagement/asml/verificationcamera":"/devicemanagement/asml/verificationcamera/overview","/devicemanagement/asml/handsfreecamera":"/devicemanagement/asml/handsfreecamera/overview","/devicemanagement/asml/overheadcamera":"/devicemanagement/asml/overheadcamera/overview","/devicemanagement/asml/asml":"/devicemanagement/asml/asml/overview","/devicemanagement/sbl":"/devicemanagement/sbl/overview","/devicemanagement/lidar":"/devicemanagement/lidar/overview","/devicemanagement/ledcontroller":"/devicemanagement/ledcontroller/overview","/devicemanagement/ledcontrollerstag":"/devicemanagement/ledcontrollerstag/sbldashboard","/devicemanagement/trafficlight":"/devicemanagement/trafficlight/overview","/devicemanagement/zancasort":"/devicemanagement/zancasort/overview","/devicemanagement/tesseract":"/devicemanagement/tesseract/overview","/devicemanagement/autoretriever":"/devicemanagement/autoretriever/overview","/devicemanagement/bagtracking":"/devicemanagement/bagtracking/overview","/devicemanagement/autoloader":"/devicemanagement/autoloader/overview","/devicemanagement/vapr":"/devicemanagement/vapr/overview"};var BAG_TRACKING_ROUTE=[{name:"Bag Tracking",path:"/devicemanagement/bagtracking",id:"bagtracking.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__devicemanagement_bagtracking_BagTrackingPage__["a" /* default */],{history:props.history,location:props.location});}}];var AUTO_LOADER_ROUTE=[{name:"Auto Loader",path:"/devicemanagement/autoloader",id:"autoloader.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_64__devicemanagement_autoloader_AutoLoaderDevicePage__["a" /* default */],{history:props.history,location:props.location});}}];var VAPR_ROUTE=[{name:"VAPR",path:"/devicemanagement/vapr",id:"vapr.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_74__devicemanagement_vaprdevice_VaprDevicePage__["a" /* default */],{history:props.history,location:props.location});}}];var BASE_ROUTES=[{name:"ADTA",path:"/devicemanagement/adta",id:"adta.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__devicemanagement_adtadevice_AdtaDevicePage__["a" /* default */],{history:props.history,location:props.location,isADTR:false});}},{name:"ADTF Matrix",path:"/devicemanagement/adtfmatrix",id:"adtf.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_71__devicemanagement_adtfdevice_AdtfDevicePage__["a" /* default */],{history:props.history,location:props.location});}},{name:"ADTF",path:"/devicemanagement/adtf",id:"adtf.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_68__devicemanagement_adtfdevice_AdtfSubComponentSelectPage__["a" /* default */],{history:props.history,location:props.location});}},{name:"ASL",path:"/devicemanagement/asl",id:"asl.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__devicemanagement_asldevice_AslDevicePage__["a" /* default */],{history:props.history,location:props.location});}},{name:"Thin Client",path:"/devicemanagement/thinclient",id:"thinclients.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__devicemanagement_thinclient_ThinClientPage__["a" /* default */],{history:props.history,location:props.location});}},{name:"Lidar Controller",path:"/devicemanagement/lidar",id:"lidar.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__devicemanagement_lidar_LidarPage__["a" /* default */],{history:props.history,location:props.location});}},{name:"LED Controller",path:"/devicemanagement/ledcontroller",id:"ledcontroller.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__devicemanagement_ledcontroller_LEDControllerPage__["a" /* default */],{history:props.history,location:props.location});}},{name:"ZancaSort",path:"/devicemanagement/zancasort",id:"zancasort.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__devicemanagement_zancasort_ZancaSortDevicePage__["a" /* default */],{history:props.history,location:props.location});}},{name:"Tesseract",path:"/devicemanagement/tesseract",id:"tesseract.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__devicemanagement_tesseract_TesseractDevicePage__["a" /* default */],{history:props.history,location:props.location});}},{name:"Auto Retriever",path:"/devicemanagement/autoretriever",id:"autoretriever.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__devicemanagement_autoretriever_AutoRetrieverDevicePage__["a" /* default */],{history:props.history,location:props.location});}},{name:"ASML",path:"/devicemanagement/asml",id:"asml.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__devicemanagement_asmldevice_AsmlSubComponentSelectPage__["a" /* default */],{history:props.history,location:props.location});}}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_61__Util__["c" /* IS_BAG_TRACKING_ALLOWED */]?BAG_TRACKING_ROUTE:[]),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_61__Util__["b" /* IS_AUTO_LOADER_ENABLED */]?AUTO_LOADER_ROUTE:[]),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_61__Util__["d" /* IS_VAPR_ENABLED */]?VAPR_ROUTE:[]),[{name:"LED Controller(STAG)",path:"/devicemanagement/ledcontrollerstag",id:"ledcontrollerstag.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_73__devicemanagement_ledcontrollerstag_LEDControllerSTAGPage__["a" /* default */],{history:props.history,location:props.location});}}]);var DEVICE_MANAGEMENT_ROUTES=function DEVICE_MANAGEMENT_ROUTES(){var isAdtfSubtypeEnabled=__WEBPACK_IMPORTED_MODULE_62__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_62__FeatureUtility__["a" /* FEATURES */].IS_ADTF_SUBTYPE_ENABLED);return BASE_ROUTES.filter(function(route){if(!isAdtfSubtypeEnabled&&route.name===__WEBPACK_IMPORTED_MODULE_72__Constants__["e" /* ADTF_ASSET_TYPE */]){return false;}return true;});};var TRAFFIC_LIGHT_ROUTES=[{name:"Traffic Light",path:"/devicemanagement/trafficlight",id:"trafficlight.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__devicemanagement_trafficlightdevice_TrafficLightPage__["a" /* default */],{history:props.history,location:props.location});}}];var ADTA=[{name:"overview",path:"/devicemanagement/adta/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__devicemanagement_adtadevice_AdtaDeviceOverview__["a" /* default */],null);}},{name:"configuration",path:"/devicemanagement/adta/configuration",id:"tab.configuration",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__devicemanagement_adtadevice_AdtaDeviceConfiguration__["a" /* default */],null);}},{name:"logstream",path:"/devicemanagement/adta/logstream",id:"tab.logstream",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__devicemanagement_adtadevice_AdtaDeviceLogstream__["a" /* default */],null);}}];var adtaMheValidationRoute={name:"validation",path:"/devicemanagement/adta/validation",id:"tab.validation",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__devicemanagement_adtadevice_AdtaDeviceValidation__["a" /* default */],null);}};var ADTF=[{name:"overview",path:"/devicemanagement/adtfmatrix/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__devicemanagement_adtfdevice_AdtfDeviceOverview__["a" /* default */],null);}},{name:"configuration",path:"/devicemanagement/adtfmatrix/configuration",id:"tab.configuration",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__devicemanagement_adtfdevice_AdtfDeviceConfiguration__["a" /* default */],null);}},{name:"logstream",path:"/devicemanagement/adtfmatrix/logstream",id:"tab.logstream",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__devicemanagement_adtfdevice_AdtfDeviceLogstream__["a" /* default */],null);}}];var ADTF_MATRIX_ROUTE=[{name:"overview",path:"/devicemanagement/adtf/matrix/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__devicemanagement_adtfdevice_AdtfDeviceOverview__["a" /* default */],null);}},{name:"configuration",path:"/devicemanagement/adtf/matrix/configuration",id:"tab.configuration",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__devicemanagement_adtfdevice_AdtfDeviceConfiguration__["a" /* default */],null);}},{name:"logstream",path:"/devicemanagement/adtf/matrix/logstream",id:"tab.logstream",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__devicemanagement_adtfdevice_AdtfDeviceLogstream__["a" /* default */],null);}}];var ADTF_SIMPLE_ROUTE=[{name:"overview",path:"/devicemanagement/adtf/simple/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__devicemanagement_adtfdevice_AdtfDeviceOverview__["a" /* default */],null);}},{name:"configuration",path:"/devicemanagement/adtf/simple/configuration",id:"tab.configuration",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__devicemanagement_adtfdevice_AdtfDeviceConfiguration__["a" /* default */],null);}},{name:"logstream",path:"/devicemanagement/adtf/simple/logstream",id:"tab.logstream",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__devicemanagement_adtfdevice_AdtfDeviceLogstream__["a" /* default */],null);}}];var ADTF_PULLMODE_ROUTE=[{name:"overview",path:"/devicemanagement/adtf/pullmode/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__devicemanagement_adtfdevice_AdtfDeviceOverview__["a" /* default */],null);}},{name:"configuration",path:"/devicemanagement/adtf/pullmode/configuration",id:"tab.configuration",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__devicemanagement_adtfdevice_AdtfDeviceConfiguration__["a" /* default */],null);}},{name:"logstream",path:"/devicemanagement/adtf/pullmode/logstream",id:"tab.logstream",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__devicemanagement_adtfdevice_AdtfDeviceLogstream__["a" /* default */],null);}}];var ASL=[{name:"overview",path:"/devicemanagement/asl/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__devicemanagement_asldevice_AslDeviceOverview__["a" /* default */],null);}},{name:"configuration",path:"/devicemanagement/asl/configuration",id:"tab.configuration",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__devicemanagement_asldevice_AslDeviceConfiguration__["a" /* default */],null);}},{name:"logstream",path:"/devicemanagement/asl/logstream",id:"tab.logstream",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__devicemanagement_asldevice_AslDeviceLogstream__["a" /* default */],null);}}];var ZANCA_SORT=[{name:"overview",path:"/devicemanagement/zancasort/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__devicemanagement_zancasort_ZancaSortDeviceOverview__["a" /* default */],null);}},{name:"configuration",path:"/devicemanagement/zancasort/configuration",id:"tab.configuration",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__devicemanagement_zancasort_ZancaSortDeviceConfiguration__["a" /* default */],null);}},{name:"logstream",path:"/devicemanagement/zancasort/logstream",id:"tab.logstream",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__devicemanagement_zancasort_ZancaSortDeviceLogstream__["a" /* default */],null);}}];var TESSERACT=[{name:"overview",path:"/devicemanagement/tesseract/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__devicemanagement_tesseract_TesseractDeviceOverview__["a" /* default */],null);}},{name:"configuration",path:"/devicemanagement/tesseract/configuration",id:"tab.configuration",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__devicemanagement_tesseract_TesseractDeviceConfiguration__["a" /* default */],null);}},{name:"logstream",path:"/devicemanagement/tesseract/logstream",id:"tab.logstream",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__devicemanagement_tesseract_TesseractDeviceLogstream__["a" /* default */],null);}}];var AUTO_RETRIEVER=[{name:"overview",path:"/devicemanagement/autoretriever/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__devicemanagement_autoretriever_AutoRetrieverDeviceOverview__["a" /* default */],null);}},{name:"configuration",path:"/devicemanagement/autoretriever/configuration",id:"tab.configuration",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_51__devicemanagement_autoretriever_AutoRetrieverDeviceConfiguration__["a" /* default */],null);}},{name:"logstream",path:"/devicemanagement/autoretriever/logstream",id:"tab.logstream",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__devicemanagement_autoretriever_AutoRetrieverDeviceLogstream__["a" /* default */],null);}}];var AUTO_LOADER=[{name:"overview",path:"/devicemanagement/autoloader/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_65__devicemanagement_autoloader_AutoLoaderDeviceOverview__["a" /* default */],null);}},{name:"configuration",path:"/devicemanagement/autoloader/configuration",id:"tab.configuration",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_66__devicemanagement_autoloader_AutoLoaderDeviceConfiguration__["a" /* default */],null);}},{name:"logstream",path:"/devicemanagement/autoloader/logstream",id:"tab.logstream",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_67__devicemanagement_autoloader_AutoLoaderDeviceLogstream__["a" /* default */],null);}}];var VAPR=[{name:"overview",path:"/devicemanagement/vapr/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_75__devicemanagement_vaprdevice_VaprDeviceOverview__["a" /* default */],null);}}];var ADTF_SUB_COMPONENT_ROUTES=[{name:"Matrix",path:"/devicemanagement/adtf/matrix",id:"adtf.matrix.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__devicemanagement_adtfdevice_AdtfMatrixPage__["a" /* default */],{history:props.history,location:props.location});}},{name:"Simple",path:"/devicemanagement/adtf/simple",id:"adtf.simple.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_70__devicemanagement_adtfdevice_AdtfSimplePage__["a" /* default */],{history:props.history,location:props.location});}},{name:"PullMode",path:"/devicemanagement/adtf/pullmode",id:"adtf.pullmode.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_69__devicemanagement_adtfdevice_AdtfPullModePage__["a" /* default */],{history:props.history,location:props.location});}}];var IN_SITE_ASML_SUB_COMPONENT_ROUTES=[{name:"HANDSFREE CAMERA",path:"/devicemanagement/asml/handsfreecamera",id:"asml.handsfreecamera.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_55__devicemanagement_asmldevice_HandsfreeCameraDevicePage__["a" /* default */],{history:props.history,location:props.location});}},{name:"OVERHEAD CAMERA",path:"/devicemanagement/asml/overheadcamera",id:"asml.overheadcamera.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__devicemanagement_asmldevice_OverheadCameraDevicePage__["a" /* default */],{history:props.history,location:props.location});}}];var ASML_SUB_COMPONENT_ROUTES=[{name:"INDUCT CAMERA",path:"/devicemanagement/asml/inductcamera",id:"asml.inductCamera.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47__devicemanagement_asmldevice_InductCameraDevicePage__["a" /* default */],{history:props.history,location:props.location});}},{name:"PRINTER",path:"/devicemanagement/asml/printer",id:"asml.printer.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_50__devicemanagement_asmldevice_PrinterDevicePage__["a" /* default */],{history:props.history,location:props.location});}},{name:"VERIFICATION CAMERA",path:"/devicemanagement/asml/verificationcamera",id:"asml.verificationcamera.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_53__devicemanagement_asmldevice_VerificationCameraDevicePage__["a" /* default */],{history:props.history,location:props.location});}},{name:"ASML",path:"/devicemanagement/asml/asml",id:"asml.asml.heading",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_54__devicemanagement_asmldevice_AsmlDevicePage__["a" /* default */],{history:props.history,location:props.location});}}];var ASML_SUB_COMPONENT_VALIDATION_ROUTES=[{name:"INDUCT CAMERA",path:"/devicemanagement/asml/asml/validation/inductcamera",id:"asml.inductCamera.heading",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__devicemanagement_asmldevice_InductCameraDeviceValidation__["a" /* default */],null);}},/*  Printer doesn't send any kind messages to TC. Hence, we can't validate Protocol for printer in the way
        we do it for other device. We have to make architectural change in backend to support validation for
        printer. Keeping printer validation disabled un-till the backend is ready.
    {
        name: "PRINTER",
        path: "/devicemanagement/asml/asml/validation/printer",
        id: "asml.printer.heading",
        component: () => {
            return (<PrinterDeviceValidation/>)
        },
    },*/{name:"VERIFICATION CAMERA",path:"/devicemanagement/asml/asml/validation/verificationcamera",id:"asml.verificationcamera.heading",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46__devicemanagement_asmldevice_VerificationCameraDeviceValidation__["a" /* default */],null);}}];var INDUCT_CAMERA=[{name:"overview",path:"/devicemanagement/asml/inductcamera/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__devicemanagement_asmldevice_InductCameraDeviceOverview__["a" /* default */],null);}}];var PRINTER=[{name:"overview",path:"/devicemanagement/asml/printer/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_49__devicemanagement_asmldevice_PrinterDeviceOverview__["a" /* default */],null);}}];var VERIFICATION_CAMERA=[{name:"overview",path:"/devicemanagement/asml/verificationcamera/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52__devicemanagement_asmldevice_VerificationCameraDeviceOverview__["a" /* default */],null);}}];var HANDSFREE_CAMERA=[{name:"overview",path:"/devicemanagement/asml/handsfreecamera/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_56__devicemanagement_asmldevice_HandsfreeCameraDeviceOverview__["a" /* default */],null);}}];var OVERHEAD_CAMERA=[{name:"overview",path:"/devicemanagement/asml/overheadcamera/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_58__devicemanagement_asmldevice_OverheadCameraDeviceOverview__["a" /* default */],null);}}];var ASML=[{name:"overview",path:"/devicemanagement/asml/asml/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_59__devicemanagement_asmldevice_AsmlDeviceOverview__["a" /* default */],null);}},{name:"logstream",path:"/devicemanagement/asml/asml/logstream",id:"tab.logstream",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_60__devicemanagement_asmldevice_AsmlDeviceLogStream__["a" /* default */],null);}},{name:"validation",path:"/devicemanagement/asml/asml/validation",id:"tab.validation",component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__devicemanagement_asmldevice_AsmlProtocolValidationSubComponentSelectionPage__["a" /* default */],{history:props.history,location:props.location});}}];var aslMheValidationRoute={name:"validation",path:"/devicemanagement/asl/validation",id:"tab.validation",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__devicemanagement_asldevice_AslDeviceValidation__["a" /* default */],null);}};var THIN_CLIENTS=[{name:"overview",path:"/devicemanagement/thinclient/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__devicemanagement_thinclient_ThinClientOverview__["a" /* default */],null);}}];var SBL=[{name:"overview",path:"/devicemanagement/sbl/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__devicemanagement_sbldevice_SblDeviceOverview__["a" /* default */],null);}},{name:"configuration",path:"/devicemanagement/sbl/configuration",id:"tab.configuration",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__devicemanagement_sbldevice_SblDeviceConfiguration__["a" /* default */],null);}}];var LIDARS=[{name:"overview",path:"/devicemanagement/lidar/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__devicemanagement_lidar_LidarOverview__["a" /* default */],null);}},{name:"manageByExceptions",path:"/devicemanagement/lidar/managebyexceptions",id:"tab.managebyexceptions",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__devicemanagement_lidar_LidarManageByExceptions__["a" /* default */],null);}},{name:"lidarTester",path:"/devicemanagement/lidar/tester",id:"tab.lidartester",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_63__devicemanagement_lidar_LidarTesterTool__["a" /* default */],null);}}];var TRAFFIC_LIGHTS=[{name:"overview",path:"/devicemanagement/trafficlight/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__devicemanagement_trafficlightdevice_TrafficLightControllerOverview__["a" /* default */],null);}},{name:"trafficlight",path:"/devicemanagement/trafficlight/lightControls",id:"tab.trafficlight",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__devicemanagement_trafficlightdevice_TrafficLightControllerSelectPage__["a" /* default */],null);}}];var LED_CONTROLLERS=[{name:"overview",path:"/devicemanagement/ledcontroller/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__devicemanagement_ledcontroller_LEDControllerOverview__["a" /* default */],null);}},{name:"testing",path:"/devicemanagement/ledcontroller/testing",id:"tab.testing",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__devicemanagement_ledcontroller_bintester__["a" /* default */],null);}},{name:"aisleconfig",path:"/devicemanagement/ledcontroller/aisleconfig",id:"tab.aisleconfigfinder",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__devicemanagement_ledcontroller_aisleconfig_AisleConfigFinder__["a" /* default */],null);}}];var LED_CONTROLLERS_WITH_CONFIG=[{name:"overview",path:"/devicemanagement/ledcontroller/overview",id:"tab.overview",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__devicemanagement_ledcontroller_LEDControllerOverview__["a" /* default */],null);}},{name:"testing",path:"/devicemanagement/ledcontroller/testing",id:"tab.testing",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__devicemanagement_ledcontroller_bintester__["a" /* default */],null);}},{name:"configuration",path:"/devicemanagement/ledcontroller/configuration",id:"tab.configuration",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__devicemanagement_ledcontroller_LEDControllerConfiguration__["a" /* default */],null);}},{name:"aisleconfig",path:"/devicemanagement/ledcontroller/aisleconfig",id:"tab.aisleconfigfinder",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__devicemanagement_ledcontroller_aisleconfig_AisleConfigFinder__["a" /* default */],null);}}];var LED_CONTROLLER_STAG_ROUTES=[{name:"SBL Dashboard",path:"/devicemanagement/ledcontrollerstag/sbldashboard",id:"tab.sbldashboard",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__devicemanagement_ledcontroller_SBLDashboard__["a" /* default */],null);}}];

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = requiredArgs;
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PermissionsContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_EmployeeResource__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_FeatureUtility__ = __webpack_require__(63);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var PermissionsContext=Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])();var PermissionsContextProvider=function PermissionsContextProvider(_ref){var children=_ref.children;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),loadingFeatures=_useContext.loadingFeatures;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isAuthorised=_useState2[0],setIsAuthorised=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),isManager=_useState4[0],setIsManager=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(true),_useState6=_slicedToArray(_useState5,2),isLoading=_useState6[0],setIsLoading=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(true),_useState8=_slicedToArray(_useState7,2),isAuthorized=_useState8[0],setIsAuthorized=_useState8[1];Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var tcpRolesResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_EmployeeResource__["b" /* getEmployeeTCPRoles */])();case 2:tcpRolesResponse=_context.sent;if(tcpRolesResponse.includes(__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_176" /* SCC_AUTOMATION_VIEWER */])||tcpRolesResponse.includes(__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_175" /* SCC_AUTOMATION_MANAGER */])){setIsAuthorised(true);}else{// this is temporary change. this logic should be shifted to backend
setIsAuthorised(false);}if(tcpRolesResponse.includes(__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_175" /* SCC_AUTOMATION_MANAGER */])){setIsManager(true);}setIsLoading(false);case 6:case"end":return _context.stop();}}},_callee,_this);}))();},[]);Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var isPermission;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!__WEBPACK_IMPORTED_MODULE_6__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_6__util_FeatureUtility__["a" /* FEATURES */].IS_DMW_PERMISSIONS_ENABLED)){_context2.next=5;break;}_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_EmployeeResource__["a" /* getEmployeePermission */])();case 3:isPermission=_context2.sent;setIsAuthorized(isPermission);case 5:case"end":return _context2.stop();}}},_callee2,_this);}))();},[loadingFeatures]);if(isLoading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__loader_Loader__["a" /* default */],null);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PermissionsContext.Provider,{value:{isAuthorised:isAuthorised,isManager:isManager,isAuthorized:isAuthorized}},children);};/* harmony default export */ __webpack_exports__["b"] = (PermissionsContextProvider);

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _text = _interopRequireDefault(__webpack_require__(249));

var text = function text(t) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var tokens = (0, _text["default"])(t.tokens);
  return {
    color: t("foregroundColor", keys.color) || t.tokens.themeForegroundPrimaryDefault,
    fontFamily: t("fontFamily", keys.fontFamily) || tokens.textFontFamilyAmazonEmber,
    fontSize: t("fontSize", keys.fontSize) || tokens.textFontSizeB300,
    fontWeight: t("fontWeight", keys.fontWeight) || tokens.textFontWeightB300,
    lineHeight: t("lineHeight", keys.lineHeight) || tokens.textLineHeightB300
  };
};

var _default = text;
exports["default"] = _default;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useBootstrapPrefix;
/* unused harmony export createBootstrapComponent */
/* unused harmony export ThemeConsumer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__restart_context_forwardRef__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__restart_context_forwardRef___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__restart_context_forwardRef__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);



var ThemeContext = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createContext({});
var Consumer = ThemeContext.Consumer,
    Provider = ThemeContext.Provider;

function ThemeProvider(_ref) {
  var prefixes = _ref.prefixes,
      children = _ref.children;
  var copiedPrefixes = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, prefixes);
  }, [prefixes]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Provider, {
    value: copiedPrefixes
  }, children);
}

function useBootstrapPrefix(prefix, defaultPrefix) {
  var prefixes = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(ThemeContext);
  return prefix || prefixes[defaultPrefix] || defaultPrefix;
}

function createBootstrapComponent(Component, opts) {
  if (typeof opts === 'string') opts = {
    prefix: opts
  };
  var isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref

  var _opts = opts,
      prefix = _opts.prefix,
      _opts$forwardRefAs = _opts.forwardRefAs,
      forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? 'ref' : 'innerRef' : _opts$forwardRefAs;
  return __WEBPACK_IMPORTED_MODULE_1__restart_context_forwardRef___default()(function (_ref2, ref) {
    var props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _ref2);

    props[forwardRefAs] = ref; // eslint-disable-next-line react/prop-types

    var bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      bsPrefix: bsPrefix
    }));
  }, {
    displayName: "Bootstrap(" + (Component.displayName || Component.name) + ")"
  });
}


/* unused harmony default export */ var _unused_webpack_default_export = (ThemeProvider);

/***/ }),
/* 50 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = publishClientSideMetrics;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCoralServiceDataFromParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getUserNameFromParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUserLoginFromParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTcpRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getLocaleFromParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAPIGatewayDataFromParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFeaturesFromParent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_MetricUtility__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var postMessagePromises={};var subscribeAbleEvents={"sendCoralServiceData":sendCoralServiceData,"sendApiGatewayResponse":sendApiGatewayResponse,"sendEmployeeNameResponse":sendEmployeeNameResponse,"sendTcpRolesResponse":sendTcpRolesResponse,"sendTcpEmployeeLoginResponse":sendTcpEmployeeLoginResponse,"sendFeatureStatus":sendResponseData};window.addEventListener("message",onNewPostMessageFromParent,false);function onNewPostMessageFromParent(event){if(event.data.method&&subscribeAbleEvents.hasOwnProperty(event.data.method)){subscribeAbleEvents[event.data.method](event.data);}}function sendCoralServiceData(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.responseData);}}function sendApiGatewayResponse(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.responseData);}}function sendEmployeeNameResponse(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.childData);}}function sendTcpRolesResponse(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.childData);}}function sendTcpEmployeeLoginResponse(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.childData);}}function generateGuid(){/**
     * @return {string}
     */function S4(){return((1+Math.random())*0x10000|0).toString(16).substring(1);}return(S4()+S4()+"-"+S4()+"-4"+S4().substr(0,3)+"-"+S4()+"-"+S4()+S4()+S4()).toLowerCase();}function publishClientSideMetrics(args){window.parent.postMessage({method:'publishClientSideMetrics',args:args},"*");}var getCoralServiceDataFromParent=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(args,processName,metricName){var response,startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:response=void 0;startTime=Date.now();_context.prev=2;_context.next=5;return postMessagePromised(window.parent,{method:'getCoralServiceDataFromParent',args:args},'*');case 5:response=_context.sent;_context.next=13;break;case 8:_context.prev=8;_context.t0=_context["catch"](2);console.error('Error ',_context.t0);Object(__WEBPACK_IMPORTED_MODULE_1__util_MetricUtility__["a" /* publishCount */])(processName,metricName+__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_70" /* ERROR_METRIC_SUFFIX */]);throw _context.t0;case 13:Object(__WEBPACK_IMPORTED_MODULE_1__util_MetricUtility__["b" /* publishTime */])(processName,metricName,startTime);return _context.abrupt("return",response);case 15:case"end":return _context.stop();}}},_callee,this,[[2,8]]);}));return function getCoralServiceDataFromParent(_x,_x2,_x3){return _ref.apply(this,arguments);};}();var getUserNameFromParent=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return postMessagePromised(window.parent,{method:'getEmployeeName',args:{}},'*',200);case 2:return _context2.abrupt("return",_context2.sent);case 3:case"end":return _context2.stop();}}},_callee2,this);}));return function getUserNameFromParent(){return _ref2.apply(this,arguments);};}();var getUserLoginFromParent=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return postMessagePromised(window.parent,{method:'getTcpEmployeeLogin',args:{}},'*',200);case 2:return _context3.abrupt("return",_context3.sent);case 3:case"end":return _context3.stop();}}},_callee3,this);}));return function getUserLoginFromParent(){return _ref3.apply(this,arguments);};}();var getTcpRoles=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return postMessagePromised(window.parent,{method:'getTcpRoles',args:{}},'*',200);case 2:return _context4.abrupt("return",_context4.sent);case 3:case"end":return _context4.stop();}}},_callee4,this);}));return function getTcpRoles(){return _ref4.apply(this,arguments);};}();var getLocaleFromParent=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return postMessagePromised(window.parent,{method:'getLocale',args:{}},'*',200);case 2:return _context5.abrupt("return",_context5.sent);case 3:case"end":return _context5.stop();}}},_callee5,this);}));return function getLocaleFromParent(){return _ref5.apply(this,arguments);};}();function postMessagePromised(targetWindow,message,targetOrigin,timeout){var newGuid=generateGuid();message.guid=newGuid;postMessagePromises[newGuid]={};postMessagePromises[newGuid]['promise']=new Promise(function(resolve,reject){postMessagePromises[newGuid]['resolve']=resolve;postMessagePromises[newGuid]['reject']=reject;targetWindow.postMessage(message,targetOrigin);if(timeout){setTimeout(function(){postMessagePromises[newGuid].resolve(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_204" /* TIMEOUT_STRING */]);},timeout);}});return postMessagePromises[newGuid].promise;}var getAPIGatewayDataFromParent=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(args){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return postMessagePromised(window.parent,{method:'getAPIGatewayDataFromParent',args:args},'*');case 2:return _context6.abrupt("return",_context6.sent);case 3:case"end":return _context6.stop();}}},_callee6,this);}));return function getAPIGatewayDataFromParent(_x4){return _ref6.apply(this,arguments);};}();var getFeaturesFromParent=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(features){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return postMessagePromised(window.parent,{method:'getFeatureStatus',args:{features:features}},'*');case 2:return _context7.abrupt("return",_context7.sent);case 3:case"end":return _context7.stop();}}},_callee7,this);}));return function getFeaturesFromParent(_x5){return _ref7.apply(this,arguments);};}();function sendResponseData(data){if(postMessagePromises[data.guid]){postMessagePromises[data.guid].resolve(data.responseData);}}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _column = _interopRequireDefault(__webpack_require__(898));

var _default = _column["default"];
exports["default"] = _default;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tooltip = _interopRequireDefault(__webpack_require__(1011));

var _default = _tooltip["default"];
exports["default"] = _default;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconPlusCircleData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3ccircle cx='12' cy='12' r='11'/%3e%3cpath d='M12 6.004v11.992M17.996 12H6.004'/%3e%3c/g%3e%3c/svg%3e",
  iconPlusCircleWidth: 24,
  iconPlusCircleHeight: 24
};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAssets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addAsset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addAssetV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return batchUpdateAssetV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateAsset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return updateAssetInPlace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setAssetStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAssetByAssetLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAssetVersions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAssetByVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getAssetsConnectivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getSiteDevicesConnectivity; });
/* unused harmony export getResourceDynamicAttributes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(5);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/**
 * Fetches an asset by calling appropriate end point.
 *
 * @returns {Promise<*>}
 * @param nodeId
 * @param assetType
 * @param pageToken
 */var getAssets=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(nodeId,assetType,pageToken){var requestBody,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:requestBody={nodeId:nodeId,assetType:assetType,pageToken:pageToken};args=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["A" /* getAPIGatewayPostRequest */])(requestBody,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_41" /* ENDPOINT_GET_ASSET_BY_ASSET_TYPE */]);_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context.abrupt("return",_context.sent);case 5:case"end":return _context.stop();}}},_callee,this);}));return function getAssets(_x,_x2,_x3){return _ref.apply(this,arguments);};}();/**
 * Adds asset by calling appropriate end point.
 *
 * @param asset
 * @returns {Promise<*>}
 */var addAsset=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(asset){var requestBody,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:requestBody={asset:asset};args=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["A" /* getAPIGatewayPostRequest */])(requestBody,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_27" /* ENDPOINT_ADD_ASSET */]);_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context2.abrupt("return",_context2.sent);case 5:case"end":return _context2.stop();}}},_callee2,this);}));return function addAsset(_x4){return _ref2.apply(this,arguments);};}();/**
 * Adds asset v2 by calling appropriate end point.
 *
 * @param requestBody
 * @returns {Promise<*>}
 */var addAssetV2=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(requestBody){var args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:args=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["A" /* getAPIGatewayPostRequest */])(requestBody,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_28" /* ENDPOINT_ADD_ASSET_V2 */]);_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 3:return _context3.abrupt("return",_context3.sent);case 4:case"end":return _context3.stop();}}},_callee3,this);}));return function addAssetV2(_x5){return _ref3.apply(this,arguments);};}();/**
 * batch update asset v2 by calling appropriate end point.
 *
 * @param requestBody
 * @returns {Promise<*>}
 */var batchUpdateAssetV2=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(requestBody){var args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:args=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["A" /* getAPIGatewayPostRequest */])(requestBody,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_30" /* ENDPOINT_BATCH_UPDATE_ASSET_V2 */]);_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 3:return _context4.abrupt("return",_context4.sent);case 4:case"end":return _context4.stop();}}},_callee4,this);}));return function batchUpdateAssetV2(_x6){return _ref4.apply(this,arguments);};}();/**
 * Updates asset by calling appropriate end point.
 *
 * @param asset
 * @param creationTime
 * @returns {Promise<*>}
 */var updateAsset=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(asset,creationTime){var requestBody,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:requestBody={asset:asset,creationTime:creationTime};args=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["A" /* getAPIGatewayPostRequest */])(requestBody,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_66" /* ENDPOINT_UPDATE_ASSET */]);_context5.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context5.abrupt("return",_context5.sent);case 5:case"end":return _context5.stop();}}},_callee5,this);}));return function updateAsset(_x7,_x8){return _ref5.apply(this,arguments);};}();/**
 * Updates asset inplace by calling appropriate end point.
 *
 * @param asset
 * @param lastUpdateTime
 * @returns {Promise<*>}
 */var updateAssetInPlace=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(asset,lastUpdateTime){var requestBody,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:requestBody={asset:asset,lastUpdateTime:lastUpdateTime};args=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["A" /* getAPIGatewayPostRequest */])(requestBody,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_67" /* ENDPOINT_UPDATE_ASSET_IN_PLACE */]);_context6.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context6.abrupt("return",_context6.sent);case 5:case"end":return _context6.stop();}}},_callee6,this);}));return function updateAssetInPlace(_x9,_x10){return _ref6.apply(this,arguments);};}();/**
 * Deprecate asset by calling appropriate end point.
 *
 * @param assetLabel
 * @param status
 * @returns {Promise<*>}
 */var setAssetStatus=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(assetLabel,status,nodeId,assetType){var requestBody,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:requestBody=Object.assign({assetLabel:assetLabel,assetStatus:status},nodeId!=null&&{nodeId:nodeId},assetType!=null&&{assetType:assetType});args=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["A" /* getAPIGatewayPostRequest */])(requestBody,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_62" /* ENDPOINT_SET_ASSET_STATUS */]);_context7.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context7.abrupt("return",_context7.sent);case 5:case"end":return _context7.stop();}}},_callee7,this);}));return function setAssetStatus(_x11,_x12,_x13,_x14){return _ref7.apply(this,arguments);};}();/**
 * Fetches an asset by calling appropriate end point.
 *
 * @param assetLabel
 * @returns {Promise<*>}
 */var getAssetByAssetLabel=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(assetLabel){var requestBody,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:requestBody={assetLabel:assetLabel};args=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["A" /* getAPIGatewayPostRequest */])(requestBody,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_40" /* ENDPOINT_GET_ASSET_BY_ASSET_LABEL */]);_context8.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context8.abrupt("return",_context8.sent);case 5:case"end":return _context8.stop();}}},_callee8,this);}));return function getAssetByAssetLabel(_x15){return _ref8.apply(this,arguments);};}();/**
 * Fetches rollback versions for a particular device.
 *
 * @param mac
 * @returns {Promise<*>}
 */var getAssetVersions=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(mac){var requestBody,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:requestBody={assetLabel:{type:"MAC_ADDRESS",value:mac}};args=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["A" /* getAPIGatewayPostRequest */])(requestBody,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_44" /* ENDPOINT_GET_ASSET_VERSIONS */]);_context9.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context9.abrupt("return",_context9.sent);case 5:case"end":return _context9.stop();}}},_callee9,this);}));return function getAssetVersions(_x16){return _ref9.apply(this,arguments);};}();/**
 * Fetches rollback version asset for a particular version of a device.
 *
 * @param mac
 * @param rangeKey
 * @returns {Promise<*>}
 */var getAssetByVersion=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(mac,rangeKey){var requestBody,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:requestBody={assetLabel:{type:"MAC_ADDRESS",value:mac},rangeKey:rangeKey};args=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["A" /* getAPIGatewayPostRequest */])(requestBody,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_42" /* ENDPOINT_GET_ASSET_BY_VERSION */]);_context10.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context10.abrupt("return",_context10.sent);case 5:case"end":return _context10.stop();}}},_callee10,this);}));return function getAssetByVersion(_x17,_x18){return _ref10.apply(this,arguments);};}();/**
 * Fetches the connectivity status for assets on a site
 *
 * @param nodeId
 * @param assetType
 * @param deviceIdentifierList
 * @returns asset connectivity Response
 */var getAssetsConnectivity=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(nodeId,assetType,deviceIdentifierList){var request,args,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:request={nodeId:nodeId,assetType:assetType,deviceIdentifierList:deviceIdentifierList};args=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_39" /* ENDPOINT_GET_ASSETS_CONNECTIVITY */]);_context11.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:response=_context11.sent;return _context11.abrupt("return",response);case 6:case"end":return _context11.stop();}}},_callee11,this);}));return function getAssetsConnectivity(_x19,_x20,_x21){return _ref11.apply(this,arguments);};}();/**
 * Fetches the connectivity status for site devices on a site
 *
 * @param nodeId
 * @param deviceType
 * @param filters
 * @returns Site devices connectivity Response
 */var getSiteDevicesConnectivity=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(nodeId,deviceType,filters){var request,args,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:request={nodeId:nodeId,deviceType:deviceType,filters:filters};args=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_56" /* ENDPOINT_GET_SITE_DEVICES_CONNECTIVITY */]);_context12.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:response=_context12.sent;return _context12.abrupt("return",response);case 6:case"end":return _context12.stop();}}},_callee12,this);}));return function getSiteDevicesConnectivity(_x22,_x23,_x24){return _ref12.apply(this,arguments);};}();/**
 * Fetches dynamic attributes for a resource from NDMS.
 *
 * @param nodeId
 * @param resourceType
 * @returns {Promise<*>}
 */var getResourceDynamicAttributes=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(nodeId,resourceType){var requestBody,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:requestBody={nodeId:nodeId,resourceType:resourceType};args=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["A" /* getAPIGatewayPostRequest */])(requestBody,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_54" /* ENDPOINT_GET_RESOURCE_DYNAMIC_ATTRIBUTES */]);_context13.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context13.abrupt("return",_context13.sent);case 5:case"end":return _context13.stop();}}},_callee13,this);}));return function getResourceDynamicAttributes(_x25,_x26){return _ref13.apply(this,arguments);};}();

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavigationRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_tab__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/**
 * Custom hook that checks which route matches the current location
 * and returns its name in the object
 * @param routes
 * @param location
 * @returns Object
 */var useCurrentRoute=function useCurrentRoute(routes,location){var currentPath=location.pathname;var _ref=routes.find(function(route){return!!Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* matchPath */])(currentPath,{path:route.path});})||{},name=_ref.name;return{name:name};};/**
 * Returns Route components from a list of routes
 * @param routes
 * @returns JSX.Element
 */var NavigationRoutes=function NavigationRoutes(_ref2){var routes=_ref2.routes;return routes.map(function(_ref3){var path=_ref3.path,component=_ref3.component;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */],{key:path,path:path,component:component});});};/**
 * Component that handles the tab UI and changes
 * @param routes
 * @returns JSX.Element
 */var TabLayout=function TabLayout(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(useCurrentRoute(props.routes,props.location)),_useState2=_slicedToArray(_useState,2),state=_useState2[0],setState=_useState2[1];var onTabChange=function onTabChange(selectedTab){props.routes.forEach(function(_ref4){var name=_ref4.name,path=_ref4.path;if(name===selectedTab){setState({name:name});props.history.push(path);}});};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_tab__["TabGroup"],{value:state.name,onChange:onTabChange,fill:"line"},props.routes.map(function(_ref5){var name=_ref5.name,id=_ref5.id;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_tab___default.a,{key:name,value:name},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:id}));}));};/* harmony default export */ __webpack_exports__["b"] = (TabLayout);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/**
 * React component for getting the last refresh time in a page
 * using the current locale settings
 * @param deps
 * @param locale
 * @return JSX.Element
 */var RefreshTimer=function RefreshTimer(_ref){var deps=_ref.deps,intl=_ref.intl;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),latestRefreshTime=_useState2[0],setRefreshTime=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setRefreshTime(Object(__WEBPACK_IMPORTED_MODULE_3__Util__["J" /* getCurrentFormattedTime */])(intl.locale));},deps);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a,{type:"b200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:"common.data_last_updated",defaultMessage:"Data last updated"}),": ",latestRefreshTime,".");};RefreshTimer.propTypes={deps:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,locale:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(RefreshTimer));

/***/ }),
/* 59 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(45);

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(790).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      r.strip();
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(124)(module)))

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(663);

var iterableToArrayLimit = __webpack_require__(664);

var unsupportedIterableToArray = __webpack_require__(342);

var nonIterableRest = __webpack_require__(665);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FEATURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FeatureUtility; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__handler_ParentDataHandler__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Util__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var FEATURES={IS_ADTA_HAMPER_ZONING_ENABLED:"isADTAHamperZoningEnabled",IS_ADTF_SUBTYPE_ENABLED:"isADTFSubtypeEnabled",IS_DMW_PERMISSIONS_ENABLED:"isDMWPermissionsEnabled",IS_MHE_VALIDATION_ENABLED:"isMHEValidationEnabled",IS_RFID_BAGS_ENABLED:"isRFIDBagsEnabled",IS_SSD_2_X_ENABLED:"isSSD2XSiteEnabled",IS_SSD3_ENABLED:"isSSD3SiteEnabled",IS_LED_CONTROLLER_ENHANCEMENT_ENABLED:"isLedControllerEnhancementEnabled",IS_NEW_ZANCASORT_TEST_CONFIG_ENABLED:"isNewZancasortTestConfigEnabled",IS_MULTIPLE_BULKY_SLIDES_FOR_DROP_TO_CART_ENABLED:"isMultipleBulkySlidesForDropToCartEnabled",IS_MULTIPLE_FRAGILE_SLIDES_ENABLED_FOR_SSD:"isMultipleFragileSlidesForSSDEnabled",IS_PROBLEM_SOLVE_ON_GRID_SORTATION_FLOW_ENABLED:"isPSOnGridSortationFlowEnabled",IS_BIN_INSTALLATION_TYPE_ENABLED:"isBinInstallationTypeEnabled",IS_ADTA_DEVICE_HEALTH_STATUS_API_ENABLED:"isAdtaDeviceHealthStatusAPIEnabled",IS_IN_SITE_ENABLED:"isINSiteEnabled",IS_STOW_STATION_INSTALLATION_TYPE_ENABLED:"isStowStationInstallationTypeEnabled",IS_VAPR_FOV_ENABLED:"isVaprFovEnabled"/**
 * Use this class whenever there is a requirement whenever a feature context variable
 * is required to be used for both components and other objects.
 */};var FeatureUtility=function(){function FeatureUtility(){_classCallCheck(this,FeatureUtility);}_createClass(FeatureUtility,null,[{key:"getFeatureStatus",value:function getFeatureStatus(featureName){return Object(__WEBPACK_IMPORTED_MODULE_1__Util__["f" /* chainWalk */])(function(){return FeatureUtility.featureStatus[featureName];},false);}},{key:"setAllFeatureStatuses",value:function setAllFeatureStatuses(){return Object(__WEBPACK_IMPORTED_MODULE_0__handler_ParentDataHandler__["c" /* getFeaturesFromParent */])(Object.values(FEATURES)).then(function(featureStatusResponse){Object.values(FEATURES).forEach(function(featureName){FeatureUtility.featureStatus[featureName]=Object(__WEBPACK_IMPORTED_MODULE_1__Util__["f" /* chainWalk */])(function(){return featureStatusResponse.data[featureName];},false);});});}}]);return FeatureUtility;}();FeatureUtility.featureStatus={};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronDownLargeData: "data:image/svg+xml,%3csvg width='21' height='12' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.5 1.5l9 9 9-9' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronDownLargeWidth: 21,
  iconChevronDownLargeHeight: 12
};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _useFocus = _interopRequireDefault(__webpack_require__(680));

var _default = _useFocus["default"];
exports["default"] = _default;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                var block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                var block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                var modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                var modeCreator = mode.createDecryptor;

	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }
	            this._mode = modeCreator.call(mode, this, iv && iv.words);
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                var wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                var salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(106);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _row = _interopRequireDefault(__webpack_require__(848));

var _default = _row["default"];
exports["default"] = _default;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MenuItem", {
  enumerable: true,
  get: function get() {
    return _menuItem["default"];
  }
});
exports["default"] = void 0;

var _menu = _interopRequireDefault(__webpack_require__(861));

var _menuItem = _interopRequireDefault(__webpack_require__(878));

var _default = _menu["default"];
exports["default"] = _default;

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_box__);
var PermissionAlertBanner=function PermissionAlertBanner(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_alert___default.a,{type:"error",size:"large"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"banner.dmwPermission"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_box___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_link___default.a,{target:"Link",href:"https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/DeviceManagementSCC/#HHowtoaccesstheportal"},"Click here")));};/* harmony default export */ __webpack_exports__["a"] = (PermissionAlertBanner);

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _focusRing = _interopRequireDefault(__webpack_require__(347));

var _elevation = __webpack_require__(81);

var _token = __webpack_require__(20);

var _borderRadius = _interopRequireDefault(__webpack_require__(127));

var _rtl = __webpack_require__(80);

/**
 * Styles for our focus ring. Apply these to the focuseable element.
 *
 * NOTE: This applies "position: relative" to the focuseable element in order to
 * position the ring absolutely. This method will not work on elements without
 * a box (e.g. a link that wraps across lines, or an element with display set to
 * "content").
 */
var focusRing = function focusRing(themeTokens, _ref) {
  var _ref2, _ref3;

  var focus = _ref.focus,
      error = _ref.error,
      dropShadow = _ref.dropShadow,
      gapColor = _ref.gapColor,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset,
      _ref$borderWidth = _ref.borderWidth,
      borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 0 : _ref$borderRadius,
      _ref$hoverSelector = _ref.hoverSelector,
      hoverSelector = _ref$hoverSelector === void 0 ? "&:hover" : _ref$hoverSelector,
      _ref$borderSides = _ref.borderSides,
      borderSides = _ref$borderSides === void 0 ? [] : _ref$borderSides;
  var tokens = (0, _focusRing["default"])(themeTokens);
  var state = focus ? "focus" : error ? "error" : undefined;
  var width = (0, _token.getToken)(tokens, "focusRingWidth");
  var color = (0, _token.getToken)(tokens, "focusRingColor", state);
  var dropShadowCss = dropShadow === true ? "".concat((0, _token.getToken)(tokens, "focusRingDropShadowOffsetX"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowOffsetY"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowBlur"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowSpread"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowColor")) : dropShadow; // If we're supposed to fill in the gap between the focus ring and the
  // element then use an inset box shadow.

  var gapShadowCss = color && gapColor ? "inset 0 0 0 ".concat(offset - width, "px ").concat(gapColor) : undefined;
  var dropShadowAndGapShadowCss = dropShadowCss && gapShadowCss ? "".concat(dropShadowCss, ", ").concat(gapShadowCss) : dropShadowCss || gapShadowCss;
  return _ref3 = {
    // The focuseable element needs to be relatively positioned so that we can
    // absolutely position the focus ring
    position: "relative",
    // If the ring entirely overlaps the focused element's border, turn the
    // element's border off to avoid artifacts near the rounded corners
    borderColor: color && offset >= 0 && width - offset >= borderWidth ? "transparent" : undefined
  }, (0, _defineProperty2["default"])(_ref3, hoverSelector, dropShadowCss && !color ? {
    boxShadow: dropShadowCss
  } : undefined), (0, _defineProperty2["default"])(_ref3, hoverSelector.split(",").map(function (selector) {
    return "".concat(selector.trim(), ":after");
  }).join(", "), dropShadowCss && state === "error" ? {
    boxShadow: dropShadowAndGapShadowCss
  } : undefined), (0, _defineProperty2["default"])(_ref3, "zIndex", focus ? _elevation.elevationForeground : error ? _elevation.elevationMidground : _elevation.elevationBackground), (0, _defineProperty2["default"])(_ref3, "&:after", color ? (_ref2 = {
    content: "''",
    pointerEvents: "none",
    position: "absolute",
    top: -offset - borderWidth,
    right: -offset - borderWidth,
    bottom: -offset - borderWidth,
    left: -offset - borderWidth,
    border: "".concat(width, "px solid ").concat(color),
    borderRadius: borderSides.length > 0 ? (0, _borderRadius["default"])(borderRadius, borderSides) : typeof borderRadius === "string" ? borderRadius.split(" ").map(function (radius) {
      var r = parseInt(radius);
      return r > 0 ? "".concat(parseInt(radius) + offset, "px") : "0";
    }).join(" ") : borderRadius > 0 ? borderRadius + offset : 0
  }, (0, _defineProperty2["default"])(_ref2, "[dir=\"rtl\"] &", {
    borderRadius: borderSides.length > 0 ? (0, _borderRadius["default"])(borderRadius, borderSides.map(function (borderSide) {
      return (0, _rtl.getRtl)(borderSide);
    })) : borderRadius
  }), (0, _defineProperty2["default"])(_ref2, "boxShadow", state === "focus" ? dropShadowAndGapShadowCss : gapShadowCss), _ref2) : undefined), _ref3;
};

var _default = focusRing;
exports["default"] = _default;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__(795).version;
elliptic.utils = __webpack_require__(796);
elliptic.rand = __webpack_require__(389);
elliptic.hmacDRBG = __webpack_require__(797);
elliptic.curve = __webpack_require__(200);
elliptic.curves = __webpack_require__(807);

// Protocols
elliptic.ec = __webpack_require__(809);
elliptic.eddsa = __webpack_require__(812);


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(106);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

module.exports = escapeRegExp;


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Constants__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DeleteSingleDeviceModal=function DeleteSingleDeviceModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected,assetType=props.assetType;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),valueMacAddress=_useState2[0],setValueMacAddress=_useState2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext2.showCustomAlert;var onCloseModal=function onCloseModal(){setOpen(false);setSelected("");resetInputState();};var onClickConfirm=function onClickConfirm(mac){showWarning(formatMessage({id:"device.editWarning"}),function(){deleteData(mac);setOpen(false);resetInputState();getData();});};function resetInputState(){setValueMacAddress("");}var prefill=function prefill(){if(!selected)return;setValueMacAddress(selected);};var deleteData=function deleteData(mac){props.dispatch({type:'DELETE_DEVICE_DATA',data:{dispatcher:props.dispatch,mac:mac,assetType:assetType,showCustomAlert:showCustomAlert}});};var getData=function getData(){if(!__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_16" /* DELETE_DEVICE_EXCLUDED_ASSET_TYPES */].includes(assetType)){props.dispatch({type:'LOAD_VIEW',data:{dispatcher:props.dispatch,assetType:assetType}});}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.delete_device_button_modal"}),open:open,onOpen:prefill,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},selected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmmacdelete",defaultMessage:"Please confirm that you wish to delete the following device:"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.macdelete",defaultMessage:"Please enter the MAC Address of the device you would like to remove."})),selected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{type:"h300"}," ",valueMacAddress," "):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default.a,{value:valueMacAddress,onChange:setValueMacAddress,placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.selectmacdelete",defaultMessage:"Select MAC Address to be deleted."}),width:300},props.macAddressArray.map(function(device){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__["SelectOption"],{key:device,value:device,label:device});}),!props.macAddressArray.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.no_device_available",defaultMessage:"No devices available"}))):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(valueMacAddress);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.confirm",defaultMessage:"Confirm"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(DeleteSingleDeviceModal));

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(540);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_date_picker__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_time_picker__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_addDays__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_format__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_textarea__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__devicemanagement_thinclient_context_ThinClientOverviewContext__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__devicemanagement_ledcontroller_context_LEDControllerOverviewContext__ = __webpack_require__(142);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var DisableMonitoringModal=function DisableMonitoringModal(props){var formatMessage=props.intl.formatMessage;var assetType=props.assetType;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(props.context),dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),valueDateFrom=_useState2[0],setValueDateFrom=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),valueTimeFrom=_useState4[0],setValueTimeFrom=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),valueDateTo=_useState6[0],setValueDateTo=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),valueTimeTo=_useState8[0],setValueTimeTo=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),reason=_useState10[0],setReason=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),reload=_useState12[0],setReload=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),show=_useState14[0],setShow=_useState14[1];var formatIso=function formatIso(date){return Object(__WEBPACK_IMPORTED_MODULE_13_date_fns_format__["default"])(date,"yyyy-MM-dd");};var yesterday=formatIso(Object(__WEBPACK_IMPORTED_MODULE_12_date_fns_addDays__["default"])(new Date(),-1));var today=formatIso(new Date());var tomorrow=formatIso(Object(__WEBPACK_IMPORTED_MODULE_12_date_fns_addDays__["default"])(new Date(),1));var sevenDaysFromNow=formatIso(Object(__WEBPACK_IMPORTED_MODULE_12_date_fns_addDays__["default"])(new Date(),+7));var onCloseModal=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function(){return props.onStateChange(false);},[]);function onClickCancel(){setShow(false);props.onStateChange(false);setInputState();}var stateValues={"startTime":Date.parse(Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["v" /* formatDate */])(valueDateFrom)+" "+valueTimeFrom).toString(),"endTime":Date.parse(Object(__WEBPACK_IMPORTED_MODULE_15__util_Util__["v" /* formatDate */])(valueDateTo)+" "+valueTimeTo).toString(),"reason":reason};var setThinClientStatusLoader=function setThinClientStatusLoader(mac){dispatch({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'monitoringStatusLoader',loaderVisible:true}});setTimeout(function(){getData();dispatch({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'monitoringStatusLoader',loaderVisible:false}});},__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_136" /* MONITORING_STATUS_LOADER_TIMER */]);};var setLEDControllerStatusLoader=function setLEDControllerStatusLoader(mac){dispatch({type:'SET_MONITORING_STATUS_LOADER',data:{mac:mac,monitoringStatusLoading:true}});};var updateStatusLoader=function updateStatusLoader(mac){switch(props.context){case __WEBPACK_IMPORTED_MODULE_16__devicemanagement_thinclient_context_ThinClientOverviewContext__["a" /* ThinClientOverviewContext */]:setThinClientStatusLoader(mac);break;case __WEBPACK_IMPORTED_MODULE_18__devicemanagement_ledcontroller_context_LEDControllerOverviewContext__["a" /* LEDControllerOverviewContext */]:setLEDControllerStatusLoader(mac);break;default:}};var onClickConfirm=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(stateValues,mac){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setShow(true);if(Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["y" /* checkModalValidationsForMonitoring */])(stateValues)){stateValues.deviceConfig=JSON.stringify(stateValues.deviceConfig);updateStatusLoader(mac);addData(stateValues,mac);props.onStateChange(false);setInputState();setShow(false);setReload(true);getData();}case 2:case"end":return _context.stop();}}},_callee,_this);}));return function(_x,_x2){return _ref.apply(this,arguments);};}(),[reload]);function setInputState(){// setting state of input fields as empty to have empty inputs on clicking Add Device again
setValueDateFrom("");setValueTimeFrom("");setValueTimeTo("");setValueDateTo("");setReason("");}var addData=function addData(stateValues,mac){dispatch({type:props.reducer,data:{dispatcher:dispatch,stateValues:stateValues,mac:mac,assetType:assetType}});};var getData=function getData(){dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch,assetType:assetType}});};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.monitoring_modal"}),open:props.state,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.start",defaultMessage:"Start Time in UTC Format: MM/DD/YYYY HH:MM:SS"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_date_picker___default.a,{value:valueDateFrom,onChange:setValueDateFrom,label:"Date",presets:[{label:"Yesterday",value:yesterday},{label:"Today",value:today},{label:"Tomorrow",value:tomorrow},{label:"Next week",value:sevenDaysFromNow}],monthsInView:2,locale:"en-US"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_time_picker___default.a,{placeholder:"Time",value:valueTimeFrom,onChange:setValueTimeFrom,invalidInputMessage:"The Trip Start value is not a valid time. The correct time format is hour:minute AM/PM.",width:300,format:{hour:"2-digit",minute:"2-digit",second:"2-digit"},showIcon:false,label:"Time"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.end",defaultMessage:"End Time in UTC Format: MM/DD/YYYY HH:MM:SS"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_date_picker___default.a,{value:valueDateTo,onChange:setValueDateTo,label:"Date",presets:[{label:"Yesterday",value:yesterday},{label:"Today",value:today},{label:"Tomorrow",value:tomorrow},{label:"Next week",value:sevenDaysFromNow}],monthsInView:2,locale:"en-US"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_time_picker___default.a,{placeholder:"Time",value:valueTimeTo,onChange:setValueTimeTo,invalidInputMessage:"The Trip Start value is not a valid time. The correct time format is hour:minute:second AM/PM.",width:300,format:{hour:"2-digit",minute:"2-digit",second:"2-digit"},showIcon:false,label:"Time"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.reason",defaultMessage:"Reason"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_textarea___default.a,{id:"my-input",value:reason,onChange:setReason,type:"text"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["y" /* checkModalValidationsForMonitoring */])(stateValues)&&show&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"})),stateValues.startTime>stateValues.endTime&&show&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.time",defaultMessage:"Please make sure start time is lesser than or equal to end time!"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onClickCancel},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stateValues,props.mac);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirm",defaultMessage:"Confirm"}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(DisableMonitoringModal));

/***/ }),
/* 79 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRtl = exports.getHorizontalDirection = exports.getDOMDirection = void 0;

var _functional = __webpack_require__(38);

var _canUseDom = _interopRequireDefault(__webpack_require__(250));

var rtlMap = {
  left: "right",
  right: "left",
  borderLeft: "borderRight",
  borderRight: "borderLeft",
  start: "right",
  end: "left",
  topLeft: "topRight",
  topRight: "topLeft",
  bottomLeft: "bottomRight",
  bottomRight: "bottomLeft"
};
var horizontalDirectionMap = {
  start: "left",
  end: "right"
};
/**
 * This method returns the RTL equivalent for an LTR direction.
 * Eg:
 *  getRtl("borderLeft") returns "borderRight"
 *  getRtl("start") returns "right"
 */

var getRtl = (0, _functional.memoize)(function (str) {
  return Object.prototype.hasOwnProperty.call(rtlMap, str) ? rtlMap[str] : str;
});
/**
 * This method returns left/right for start/end. This allows us to accept the
 * start/end prop for our components that have directional props (eg: alignmentHorizontal)
 * while still supporting IE11 which doesn't accept start/end.
 */

exports.getRtl = getRtl;
var getHorizontalDirection = (0, _functional.memoize)(function (str) {
  return Object.prototype.hasOwnProperty.call(horizontalDirectionMap, str) ? horizontalDirectionMap[str] : str;
});
/**
 * Returns the dir of the DOM from an anchor passed into it
 *
 * @param anchor
 */

exports.getHorizontalDirection = getHorizontalDirection;

var getDOMDirection = function getDOMDirection(anchor) {
  try {
    var dir = _canUseDom["default"] && anchor !== null && typeof anchor !== "undefined" ? window.getComputedStyle(anchor).direction : "ltr";
    return dir;
  } catch (_) {
    return "ltr";
  }
};

exports.getDOMDirection = getDOMDirection;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports = {
  elevationBackground: 0,
  elevationMidground: 10,
  elevationForeground: 20,
  elevationMasthead: 30,
  elevationFixture: 40,
  elevationSideMenu: 50,
  elevationModal: 60,
  elevationPopover: 70,
  elevationTooltip: 80
};

/***/ }),
/* 82 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toInteger;
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(84).EventEmitter;
var inherits = __webpack_require__(135);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(767);
Stream.Writable = __webpack_require__(773);
Stream.Duplex = __webpack_require__(774);
Stream.Transform = __webpack_require__(775);
Stream.PassThrough = __webpack_require__(776);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _loader = _interopRequireDefault(__webpack_require__(1007));

var _default = _loader["default"];
exports["default"] = _default;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(19).Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(323);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(417);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConditionalWrapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tooltipWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tooltip__);
var ConditionalWrapping=function ConditionalWrapping(_ref){var condition=_ref.condition,wrapper=_ref.wrapper,args=_ref.args,child=_ref.child;return condition?wrapper(child,args):child;};var tooltipWrapper=function tooltipWrapper(child,_ref2){var title=_ref2.title,position=_ref2.position;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tooltip___default.a,{title:title,position:position},child);};

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_pagination__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(4);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var PaginatedTable=function PaginatedTable(_ref){var data=_ref.data,renderRow=_ref.renderRow,renderHeader=_ref.renderHeader,renderSearchRow=_ref.renderSearchRow,onSort=_ref.onSort,sortColumn=_ref.sortColumn,sortDirection=_ref.sortDirection,_ref$numberOfRowsPerP=_ref.numberOfRowsPerPage,numberOfRowsPerPage=_ref$numberOfRowsPerP===undefined?20:_ref$numberOfRowsPerP;var _useState=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(1),_useState2=_slicedToArray(_useState,2),pageCount=_useState2[0],setPageCount=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(1),_useState4=_slicedToArray(_useState3,2),currentPage=_useState4[0],setCurrentPage=_useState4[1];Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function(){var totalRows=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["f" /* chainWalk */])(function(){return data.length;},0);var totalPages=Math.ceil(totalRows/numberOfRowsPerPage);setPageCount(totalPages);});var startIndex=(currentPage-1)*numberOfRowsPerPage;var endIndex=currentPage*numberOfRowsPerPage;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",showDividers:true,showStripes:true,sortColumn:sortColumn,sortDirection:sortDirection,onSort:onSort},renderHeader(),renderSearchRow&&renderSearchRow(),data.slice(startIndex,endIndex).map(function(instance,index){return renderRow(instance,startIndex+index+1,index);})),pageCount===0&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"table.nodata",defaultMessage:"No data present"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_pagination___default.a,{onChange:setCurrentPage,currentPage:currentPage,numberOfPages:pageCount})));};/* harmony default export */ __webpack_exports__["a"] = (PaginatedTable);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var FormContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext({
  controlId: undefined
});
/* harmony default export */ __webpack_exports__["a"] = (FormContext);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Determines if two components are the same. Uses some tricks to smooth out
 * wrinkles with react-hot-loader in development mode
 *
 * @example
 * import Checkbox from "@amzn/meridian/checkbox"
 * import Radio from "@amzn/meridian/radio"
 *
 * console.log(isSameComponent(Checkbox, Checkbox)) // true
 * console.log(isSameComponent(Checkbox, Radio)) // false
 */
var isSameComponent = function isSameComponent(a, b) {
  if (!a || !b) {
    // Bail if either component wasn't provided
    return false;
  } else if (false) {
    // If a name is set then rely on that in development mode. The component
    // name is more reliable than the type in development mode becaues of a
    // limitation of react-hot-loader (see:
    // https://github.com/gaearon/react-hot-loader/issues/304). Don't use this
    // in production though because minification will change the name and break
    // the comparison.
    var aName = a.displayName || a.name;
    var bName = b.displayName || b.name;
    return aName === bName;
  } else {
    // Just check if the components reference the same class/function.
    return a === b;
  }
};
/**
 * Determines if an element is an instance of a particular component.
 *
 * @example
 * import Checkbox from "@amzn/meridian/checkbox"
 *
 * const isCheckbox = isElementOf(Checkbox)
 * console.log(isCheckbox(<Checkbox />)) // true
 */


var isElementOf = function isElementOf(component) {
  return function (element) {
    if (!component || !element) {
      // Bail if either the component or element wasn't provided
      return false;
    } else if (element.type && element.type.WrappedComponent) {
      // If the element's component has a static WrappedComponent property, assume
      // we're working with a HoC and compare the wrapped component instead of the
      // HoC component. The connect HoC from redux uses this pattern, so this
      // check ensures that isElementOf works correctly on redux-connected
      // components.
      return isSameComponent(element.type.WrappedComponent, component) || isSameComponent(element.type.WrappedComponent, component.WrappedComponent);
    } else {
      // If WrappedComonent isn't set do a normal comparison of element.type
      // (the component that element was instantiated from) and component.
      return isSameComponent(element.type, component);
    }
  };
};

var _default = isElementOf;
exports["default"] = _default;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// These styles are helpful for visually hiding an element while still allowing
// the user to interact with it (e.g. hide an input but allow the user to focus
// on it by clicking on an associated label). Simply applying "display: none" to
// an input will tell the browser to ignore it completely and the user will not
// be able to interact with it at all. Having an invisible yet interactive
// element is useful for creating custom styled inputs that are backed by their
// native html counterparts under the hood or for presenting information to
// screen-readers only.
var visuallyHidden = {
  clip: "rect(0 0 0 0)",
  overflow: "hidden",
  position: "absolute",
  top: 0,
  left: 0,
  border: 0,
  width: 1,
  height: 1,
  opacity: 0
};
var _default = visuallyHidden;
exports["default"] = _default;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(364),
    findIndex = __webpack_require__(254);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(849)();
}


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoize = memoize;
exports.memoizeCurry = memoizeCurry;
exports.memoizeByKeys = memoizeByKeys;
exports.memoizeArray = memoizeArray;

/**
 * Author: shekwong@
 */
var END = new Object();
/**
 * Memoize a function with one argument.
 *
 * @example
 * const square = a => a * a
 * const memoizedSquare = memoize(square)
 * memoizedSquare(2) // 4
 */

function memoize(f) {
  var memo = new Map();
  return function (i) {
    if (memo.has(i)) {
      return memo.get(i);
    }

    var result = f(i);
    memo.set(i, result);
    return result;
  };
}
/**
 * Memoize a function with N args by currying it
 *
 * @example
 * const multiply = (a, b) => a * b
 * const memoizedMultiply = memoize(multiply, 1)
 * memoizedMultiply(2)(3) // 6
 */


function memoizeCurry(f, depth) {
  var a = f;

  if (depth == 0) {
    return memoize(a);
  }

  return memoize(function (x) {
    return memoizeCurry(a.bind(null, x), depth - 1);
  });
}
/**
 * A helper function used by memoizeByKeys.
 */


function memoizeByKeysCurry(f, resolver, depth) {
  var a = f;

  if (depth == 0) {
    return memoize(resolver);
  }

  return memoize(function (x) {
    return memoizeByKeysCurry(a.bind(null, x), resolver, depth - 1);
  });
}
/**
 * Memoize a function that accepts an object as its only argument. You must
 * specify the keys in the object to compare when determining whether to re-use
 * a previous calculation.
 *
 * NOTE: This can only support properties in the object that are simple (e.g.
 * strings, numbers, booleans, not nested objects or arrays).
 *
 * @example
 * const multiply = ({ a, b }) => a * b
 * cont memoizedMultiply = memoizeByKeys(multiply, ["a", "b"])
 * memoizedMultiply({ a: 2, b: 3 }) // 6
 */


function memoizeByKeys(f, keys) {
  var args = undefined;
  var g = memoizeByKeysCurry(f, function () {
    return f(args);
  }, keys.length - 1);
  return function (a) {
    if (!a) {
      var _c = g;
      keys.forEach(function () {
        _c = _c(undefined);
      });
      return _c;
    }

    args = a;
    var c = g;
    keys.forEach(function (k) {
      c = c(args[k]);
    });
    return c;
  };
}
/**
 * A helper function used by memoizeArray.
 */


function memoizeByVarArgsCurry(f) {
  var a = f;
  return memoize(function (x) {
    return x === END ? a() : memoizeByVarArgsCurry(a.bind(null, x));
  });
}
/**
 * Memoize a function that accepts an array as its only argument.
 *
 * @example
 * const multiply = numbers => numbers.reduce((result, num) => result * num)
 * cont memoizedMultiply = memoizeArray(multiply)
 * memoizedMultiply([2, 3, 4]) // 24
 */


function memoizeArray(f) {
  var memoized = memoizeByVarArgsCurry(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return f(args);
  });
  return function (vals) {
    var g = memoized;
    vals.forEach(function (v) {
      g = g(v);
    });
    return g(END);
  };
}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _popoverController = _interopRequireDefault(__webpack_require__(870));

var _default = _popoverController["default"];
exports["default"] = _default;

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export escapeDoubleQuotes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SorterConfigCSVParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADTFSorterConfigCSVParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TestConfigCSVParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ARTestConfigCSVParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ZancaSortTestConfigCSVParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ZancaSortLocationConfigCSVParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ZancaSortTierConfigCSVParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TesseractStowConfigCSVParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TesseractTestConfigCSVParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AutoLoaderConfigCSVParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AutoLoaderTestConfigCSVParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DivertConfigCSVParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MHELogsCSVParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RetrieverLocationMappingCSVParser; });
/* harmony export (immutable) */ __webpack_exports__["o"] = createRetrieverLocationMappingCSVParser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sprintf_js__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sprintf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sprintf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeatureUtility__ = __webpack_require__(63);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var commonCSVValidation=function commonCSVValidation(str,parser){if(str.indexOf("\n")===str.length){return{error:"CSV file has no rows"};}var head=str.slice(0,str.indexOf("\n"));var header=head.replace(/\s/g,'').toLowerCase().split(',');var headerCheck=parser.FIELDS.reduce(function(result,val,index){return result&&val.toLowerCase()===header[index];},true);if(header.length!==parser.FIELDS.length||!headerCheck){return{error:"CSV file headers are incorrect. Expected headers: "+JSON.stringify(parser.FIELDS)};}return str.slice(str.indexOf("\n")+1).split("\n");};var escapeDoubleQuotes=function escapeDoubleQuotes(data){return'"'+data.replace(/"/g,'\'')+'"';};var SorterConfigCSVParser={FIELDS:["DestinationId","InstallationType","Locations"],SAMPLE:'DestinationId,InstallationType,Locations\n4001,aisle,"A,1;B,1"\n4002,jackpot,Finger A',STRINGIFY:function STRINGIFY(assets){var res="DestinationId,InstallationType,Locations\n";assets.forEach(function(asset){if(['jackpot','miss','recirculation','problem_solve'].includes(asset.installation.type)){res+=asset.bayId+","+asset.installation.type+","+asset.fingerName+"\n";}else{var locationString="";asset.installation.locations.forEach(function(location,index){if(index){locationString+=";"+location;}else{locationString+=location;}});res+=asset.bayId+","+asset.installation.type+",\""+locationString+"\"\n";}});return res;},PARSE:function PARSE(str,mac){// Get rows after common validation
var rows=commonCSVValidation(str,SorterConfigCSVParser);if(rows.error){return rows;}// Process each row
var sorterConfig=[];var invalidInstallationTypeIndex=[];var hasJackpot=false;var validInstallationType=Object(__WEBPACK_IMPORTED_MODULE_4__Util__["Q" /* getInstallationTypeValues */])();for(var index=0;index<rows.length;index++){// Handle empty rows
var row=rows[index];if(!row){continue;}// Generate sorter config from values
var values=row.split(',');var config={bayId:values[0].replace(/\s/g,''),installation:{type:values[1].toLowerCase().replace(/\s/g,'')}// add index of row to list if installationType is invalid
};!validInstallationType.includes(config.installation.type)&&invalidInstallationTypeIndex.push(index+1);// set has Jackpot to true if config contains a Jackpot value
if(__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].JACKPOT.value===config.installation.type){hasJackpot=true;}if(['miss','jackpot','recirculation','problem_solve'].includes(config.installation.type)){config.fingerName=values[2].trim();}else{config.installation.locations=values.slice(2).join(',').toUpperCase().replace(/\s|"/g,'').split(';');}// Validate row
var validateConfig=JSON.parse(JSON.stringify(config));if(validateConfig.installation.locations){validateConfig.installation.locations=validateConfig.installation.locations.join(";");}if(!Object(__WEBPACK_IMPORTED_MODULE_0__Validations__["x" /* checkModalValidationsForConfig */])(validateConfig,mac,__WEBPACK_IMPORTED_MODULE_1__Constants__["c" /* ADTA_ASSET_TYPE */])){console.log("ERROR = ",validateConfig);console.log("MAC = ",mac);return{error:"Values of row number "+(index+1)+" are invalid"};}// Add to list
sorterConfig.push(config);}if(!hasJackpot){return{error:"Config is missing jackpot destination"};}if(__WEBPACK_IMPORTED_MODULE_5__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_5__FeatureUtility__["a" /* FEATURES */].IS_MULTIPLE_BULKY_SLIDES_FOR_DROP_TO_CART_ENABLED)){var bulkyValidationError=validateMultiSlideAssignmentsForInstallation(sorterConfig,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].BULKY);if(bulkyValidationError)return bulkyValidationError;}if(__WEBPACK_IMPORTED_MODULE_5__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_5__FeatureUtility__["a" /* FEATURES */].IS_MULTIPLE_FRAGILE_SLIDES_ENABLED_FOR_SSD)){var fragileValidationError=validateMultiSlideAssignmentsForInstallation(sorterConfig,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].FRAGILE);if(fragileValidationError)return fragileValidationError;}return invalidInstallationTypeIndex.length>0?{error:"Installation type is invalid for "+invalidInstallationTypeIndex.length+" row(s): "+invalidInstallationTypeIndex.slice(0,Math.min(20,invalidInstallationTypeIndex.length))}:sorterConfig;}/**
 * Validates multi slide assignments for installation type
 * @param sorterConfig
 * @param installationType
 * @returns {{error: string}|null}
 */};var validateMultiSlideAssignmentsForInstallation=function validateMultiSlideAssignmentsForInstallation(sorterConfig,installationType){var floorSorterConfig=Object(__WEBPACK_IMPORTED_MODULE_4__Util__["_7" /* getSorterConfigForInstallationType */])(sorterConfig,__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].FLOOR);var slideSorterConfig=Object(__WEBPACK_IMPORTED_MODULE_4__Util__["_7" /* getSorterConfigForInstallationType */])(sorterConfig,installationType);var floorsForSlide=Object(__WEBPACK_IMPORTED_MODULE_4__Util__["M" /* getFloorsForSlide */])(slideSorterConfig);if(!Object(__WEBPACK_IMPORTED_MODULE_0__Validations__["H" /* hasUnavailableFloor */])(floorSorterConfig,floorsForSlide)){return{error:"Floors assigned to "+installationType.value+" slides are invalid"};}var floorsWithMultipleAssignedSlides=Object(__WEBPACK_IMPORTED_MODULE_4__Util__["N" /* getFloorsWithMultipleAssignedSlides */])(floorSorterConfig,floorsForSlide);if(floorsWithMultipleAssignedSlides.length>0){var locationList=floorsWithMultipleAssignedSlides.length>5?floorsWithMultipleAssignedSlides.slice(0,5)+" and "+(floorsWithMultipleAssignedSlides.length-5)+" more":floorsWithMultipleAssignedSlides;return{error:"Locations: "+locationList+" are having more than 1 "+installationType.value+" slide assigned and are invalid"};}return null;};var ADTFSorterConfigCSVParser={FIELDS:["DestinationId","SorterId","InstallationType","Locations"],SAMPLE:'DestinationId,SorterId,InstallationType,Locations\nL01#0,1,cluster,"A"\nJP#0,1,miss,""',STRINGIFY:function STRINGIFY(assets){var res="DestinationId,SorterId,InstallationType,Locations\n";assets.forEach(function(asset){if(['miss','jackpot','ov',__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].FRAGILE.value].includes(asset.installation.type)){res+=asset.destinationId+","+asset.sorterId+","+asset.installation.type+",\"\"\n";}else{var locationString="";asset.installation.locations.forEach(function(location,index){if(index){locationString+=";"+location;}else{locationString+=location;}});res+=asset.destinationId+","+asset.sorterId+","+asset.installation.type+",\""+locationString+"\"\n";}});return res;},PARSE:function PARSE(str,mac){// Get rows after common validation
var rows=commonCSVValidation(str,ADTFSorterConfigCSVParser);if(rows.error){return rows;}// Process each row
var sorterConfig=[];for(var index=0;index<rows.length;index++){// Handle empty rows
var row=rows[index];if(!row){continue;}// Generate sorter config from values
var values=row.split(',');var config={destinationId:values[0].replace(/\s/g,''),sorterId:values[1].replace(/\s/g,''),installation:{type:values[2].toLowerCase().replace(/\s/g,'')}};if(['miss','jackpot','ov',__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].FRAGILE.value].includes(config.installation.type)){config.installation.locations=[];}else{config.installation.locations=values.slice(3).join(',').toUpperCase().replace(/\s|"/g,'').split(';');}// Validate row
var validateConfig=JSON.parse(JSON.stringify(config));if(validateConfig.installation.locations){validateConfig.installation.locations=validateConfig.installation.locations.join(";");}// Validate row
if(!Object(__WEBPACK_IMPORTED_MODULE_0__Validations__["x" /* checkModalValidationsForConfig */])(validateConfig,mac,__WEBPACK_IMPORTED_MODULE_1__Constants__["e" /* ADTF_ASSET_TYPE */])){return{error:"Values of row number "+(index+1)+" are invalid"};}// Add to list
sorterConfig.push(config);}return sorterConfig;}};var TestConfigCSVParser={FIELDS:["Scannables","SortZone"],SAMPLE:'Scannables,SortZone\nTBA123456789,A1-1A\nTBA123456790,B1-1B',STRINGIFY:function STRINGIFY(assets){var res="Scannables,SortZone\n";assets.forEach(function(asset){var scannablesString="";asset.scannables.forEach(function(scannable,index){if(index){scannablesString+=";"+scannable;}else{scannablesString+=scannable;}});res+=scannablesString+","+asset.sortZone+"\n";});return res;},PARSE:function PARSE(str){// Get rows after common validation
var rows=commonCSVValidation(str,TestConfigCSVParser);// Process rows
var sorterConfig=[];for(var index=0;index<rows.length;index++){// Handle empty rows
var row=rows[index];if(!row){continue;}// Generate sorter config from values
var values=row.replace(/\s/g,'').split(',');var config={scannables:values[0].split(';'),sortZone:values[1]// Validate row
};if(!Object(__WEBPACK_IMPORTED_MODULE_0__Validations__["z" /* checkModalValidationsForTestPackage */])(config)){return{error:"Values of row number "+(index+1)+" are invalid"};}// Add to list
sorterConfig.push(config);}return sorterConfig;}};var ARTestConfigCSVParser={FIELDS:["Picklist","PickItem","ItemType","Cluster","PickStation"],STRINGIFY:function STRINGIFY(data){var res="Picklist,PickItem,ItemType,Cluster,PickStation\n";var index=1;data.forEach(function(picklist){picklist.pickItems.forEach(function(item){res+=Object(__WEBPACK_IMPORTED_MODULE_3_sprintf_js__["sprintf"])('P%d,%s,%s,%s,%s\n',index,item.id,item.type,item.cluster,picklist.pickStation);});index++;});return res;}};var ZancaSortTestConfigCSVParser={FIELDS:__WEBPACK_IMPORTED_MODULE_5__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_5__FeatureUtility__["a" /* FEATURES */].IS_NEW_ZANCASORT_TEST_CONFIG_ENABLED)?["Scannables","SortZone","Bags"]:["Scannables","Destination"],SAMPLE:__WEBPACK_IMPORTED_MODULE_5__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_5__FeatureUtility__["a" /* FEATURES */].IS_NEW_ZANCASORT_TEST_CONFIG_ENABLED)?'Scannables,SortZone,Bags\nTBA123456789,A1-1A,BAG-TEST-01-ZS;BAG-TEST-02-ZS\nTBA123456790,B1-1B,BAG-TEST-03-ZS':'Scannables,Destination\nTBA123456789,BAG-TEST-01-ZS\nTBA123456790,BAG-TEST-02-ZS',STRINGIFY:function STRINGIFY(assets){var res=__WEBPACK_IMPORTED_MODULE_5__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_5__FeatureUtility__["a" /* FEATURES */].IS_NEW_ZANCASORT_TEST_CONFIG_ENABLED)?"Scannables,SortZone,Bags\n":"Scannables,Destination\n";assets.forEach(function(asset){var scannablesString="";asset.scannables.forEach(function(scannable,index){if(index){scannablesString+=";"+scannable;}else{scannablesString+=scannable;}});if(__WEBPACK_IMPORTED_MODULE_5__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_5__FeatureUtility__["a" /* FEATURES */].IS_NEW_ZANCASORT_TEST_CONFIG_ENABLED)){var containerListString="";if(Array.isArray(asset.containerList)&&asset.containerList.length>0){asset.containerList.forEach(function(container,index){if(index){containerListString+=";"+container;}else{containerListString+=container;}});}else{containerListString="";}res+=scannablesString+","+asset.destination+","+containerListString+"\n";}else{res+=scannablesString+","+asset.destination+"\n";}});return res;},PARSE:function PARSE(str){// Get rows after common validation
var rows=commonCSVValidation(str,ZancaSortTestConfigCSVParser);// Process rows
var testConfig=[];if(__WEBPACK_IMPORTED_MODULE_5__FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_5__FeatureUtility__["a" /* FEATURES */].IS_NEW_ZANCASORT_TEST_CONFIG_ENABLED)){var _ret=function(){var seenScannables=new Set();var containerToDestinationMap=new Map();var _loop=function _loop(index){// Handle empty rows
var row=rows[index];if(!row){return"continue";}// Generate test config from values
var values=row.replace(/\s/g,'').split(',');var scannables=values[0].split(';');// Check for duplicate scannables
var duplicates=scannables.filter(function(scannable){return seenScannables.has(scannable);});if(duplicates.length>0){return{v:{v:{error:"Duplicate scannables found in row "+(index+1)+": "+duplicates.join(", ")}}};}// Add scannables to seen set
scannables.forEach(function(scannable){return seenScannables.add(scannable);});var destination=values[1];var containers=values[2].split(';').filter(Boolean);// Check for container to destination conflicts
var conflictingContainers=containers.filter(function(container){var existingDestination=containerToDestinationMap.get(container);return existingDestination&&existingDestination!==destination;});if(conflictingContainers.length>0){var conflicts=conflictingContainers.map(function(container){return container+" (already mapped to "+containerToDestinationMap.get(container)+")";}).join(', ');return{v:{v:{error:"Invalid container mapping in row "+(index+1)+": "+conflicts}}};}// Add new container mappings
containers.forEach(function(container){containerToDestinationMap.set(container,destination);});var config={scannables:scannables,destination:destination,containerList:containers};// Validate row
if(!Object(__WEBPACK_IMPORTED_MODULE_0__Validations__["D" /* checkZancaSortAddTestPackageModalValidations */])(config)){return{v:{v:{error:"Values of row number "+(index+1)+" are invalid"}}};}testConfig.push(config);};for(var index=0;index<rows.length;index++){var _ret2=_loop(index);switch(_ret2){case"continue":continue;default:if((typeof _ret2==="undefined"?"undefined":_typeof(_ret2))==="object")return _ret2.v;}}}();if((typeof _ret==="undefined"?"undefined":_typeof(_ret))==="object")return _ret.v;}else{// Original code for old configuration
for(var index=0;index<rows.length;index++){// Handle empty rows
var row=rows[index];if(!row){continue;}// Generate test config from values
var values=row.replace(/\s/g,'').split(',');var config={scannables:values[0].split(';'),destination:values[1]// Validate row
};if(!Object(__WEBPACK_IMPORTED_MODULE_0__Validations__["D" /* checkZancaSortAddTestPackageModalValidations */])(config)){return{error:"Values of row number "+(index+1)+" are invalid"};}// Add to list
testConfig.push(config);}}return testConfig;}};var ZancaSortLocationConfigCSVParser={FIELDS:["LocationId","LocationType"],SAMPLE:'LocationId,LocationType\nLOC-001,WAREHOUSE_LOCATION\nLOC-002,PICK_LOCATION\nLOC-003,STOW_LOCATION',STRINGIFY:function STRINGIFY(assets){var res="LocationId,LocationType\n";assets.forEach(function(asset){res+=asset.locationId+","+asset.locationType+"\n";});return res;},PARSE:function PARSE(str){// Get rows after common validation
var rows=commonCSVValidation(str,ZancaSortLocationConfigCSVParser);if(rows.error){return rows;}// Process rows
var locationConfig=[];for(var index=0;index<rows.length;index++){// Handle empty rows
var row=rows[index];if(!row){continue;}// Generate destination config from values
var values=row.replace(/\s/g,'').split(',');var config={locationId:values[0],locationType:values[1]// Validate row
};if(!Object(__WEBPACK_IMPORTED_MODULE_0__Validations__["_4" /* validateZancaSortLocationConfig */])(config)){return{error:"Values of row number "+(index+1)+" are invalid"};}// Add to list
locationConfig.push(config);}return locationConfig;}};var ZancaSortTierConfigCSVParser={FIELDS:["TierName","Capacity","StartLevel","EndLevel"],SAMPLE:'TierName,Capacity,StartLevel,EndLevel\nBOTTOM,50,1,5\nTOP,60,6,11',STRINGIFY:function STRINGIFY(assets){var res="TierName,Capacity,StartLevel,EndLevel\n";assets.forEach(function(asset){res+=asset.tierName+","+asset.capacity+","+asset.startLevel+","+asset.endLevel+"\n";});return res;},PARSE:function PARSE(str){// Get rows after common validation
var rows=commonCSVValidation(str,ZancaSortTierConfigCSVParser);if(rows.error){return rows;}// Process rows
var tierConfig=[];var _loop2=function _loop2(index){// Handle empty rows
var row=rows[index];if(!row){return"continue";}// Generate tier config from values
var values=row.split(',').map(function(v){return v.trim();});if(values.length!==4){return{v:{error:"Row "+(index+1)+" has incorrect number of columns"}};}var config={// The tier name is restricted to a fixed set of values, so a lowercase
// entry is upcased instead of being rejected
tierName:values[0].toUpperCase(),capacity:parseInt(values[1],10),startLevel:parseInt(values[2],10),endLevel:parseInt(values[3],10)// Validate tier name against the allowed tier names
};if(!__WEBPACK_IMPORTED_MODULE_1__Constants__["_224" /* ZANCA_SORT_TIER_NAMES */].includes(config.tierName)){return{v:{error:"Tier name \""+values[0]+"\" in row "+(index+1)+" is invalid. "+("Allowed values: "+__WEBPACK_IMPORTED_MODULE_1__Constants__["_224" /* ZANCA_SORT_TIER_NAMES */].join(", "))}};}// Validate row
if(!Object(__WEBPACK_IMPORTED_MODULE_0__Validations__["_5" /* validateZancaSortTierConfig */])(config)){return{v:{error:"Values of row number "+(index+1)+" are invalid"}};}// Check for duplicate tier names
if(tierConfig.some(function(t){return t.tierName===config.tierName;})){return{v:{error:"Duplicate tier name \""+config.tierName+"\" found in row "+(index+1)}};}// Add to list
tierConfig.push(config);};for(var index=0;index<rows.length;index++){var _ret3=_loop2(index);switch(_ret3){case"continue":continue;default:if((typeof _ret3==="undefined"?"undefined":_typeof(_ret3))==="object")return _ret3.v;}}// Check for level overlaps across all tiers
var overlap=Object(__WEBPACK_IMPORTED_MODULE_0__Validations__["C" /* checkTierConfigLevelOverlap */])(tierConfig);if(overlap){return{error:"Level overlap detected between "+overlap.tier1+" and "+overlap.tier2};}return tierConfig;}};var TesseractStowConfigCSVParser={FIELDS:["ContainerType","ContainerLabel"],SAMPLE:'ContainerType,ContainerLabel\nSAMPLE_TYPE_01,A-1\nSAMPLE_TYPE_02,A-2',STRINGIFY:function STRINGIFY(assets){var res="ContainerType,ContainerLabel\n";assets.forEach(function(asset){res+=asset.containerType+","+asset.containerLabel+"\n";});return res;},PARSE:function PARSE(str,mac){// Get rows after common validation
var rows=commonCSVValidation(str,TesseractStowConfigCSVParser);// Process rows
var stowConfig=[];for(var index=0;index<rows.length;index++){// Handle empty rows
var row=rows[index];if(!row){continue;}// Generate config from values
var _values=row.replace(/\s/g,'').split(',');var _config={containerType:_values[0],containerLabel:_values[1]// Validate row
};if(!Object(__WEBPACK_IMPORTED_MODULE_0__Validations__["x" /* checkModalValidationsForConfig */])(_config,mac,__WEBPACK_IMPORTED_MODULE_1__Constants__["_200" /* TESSERACT_ASSET_TYPE */])){return{error:"Values of row number "+(index+1)+" are invalid"};}// Add to list
stowConfig.push(_config);}return stowConfig;}};var TesseractTestConfigCSVParser={FIELDS:["TrackingId","Scannables","Destination"],SAMPLE:'TrackingId,Scannables,Destination\nTBA123456789,SAMP_TEST_001;TBA123456789,A-1\nTBA123456790,TBA123456790,A-2',STRINGIFY:function STRINGIFY(assets){var res="TrackingId,Scannables,Destination\n";assets.forEach(function(asset){var scannablesString="";asset.scannables.forEach(function(scannable,index){if(index){scannablesString+=";"+scannable;}else{scannablesString+=scannable;}});res+=asset.trackingId+","+scannablesString+","+asset.destination+"\n";});return res;},PARSE:function PARSE(str){// Get rows after common validation
var rows=commonCSVValidation(str,TesseractTestConfigCSVParser);// Process rows
var testConfig=[];for(var index=0;index<rows.length;index++){// Handle empty rows
var row=rows[index];if(!row){continue;}// Generate test config from values
var _values2=row.replace(/\s/g,'').split(',');var _config2={trackingId:_values2[0],scannables:_values2[1].split(';'),destination:_values2[2]// Validate row
};if(!Object(__WEBPACK_IMPORTED_MODULE_0__Validations__["B" /* checkTesseractAddTestPackageModalValidations */])(_config2)){return{error:"Values of row number "+(index+1)+" are invalid"};}// Add to list
testConfig.push(_config2);}return testConfig;}};var AutoLoaderConfigCSVParser={FIELDS:["Destination","InstallationType","Locations"],SAMPLE:'Destination,InstallationType,Locations\nConveyor_1,aisle,A-1;A-2\nConveyor_2,sideline,B-1;B-2',STRINGIFY:function STRINGIFY(assets){var res="Destination,InstallationType,Locations\n";assets.forEach(function(asset){if([__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].SIDELINE.value].includes(asset.installation.type)){res+=asset.destination+","+asset.installation.type+",\n";}else{var locationString="";asset.installation.locations.forEach(function(location,index){if(index){locationString+=";"+location;}else{locationString+=location;}});res+=asset.destination+","+asset.installation.type+",\""+locationString+"\"\n";}});return res;},PARSE:function PARSE(str,mac){// Get rows after common validation
var rows=commonCSVValidation(str,AutoLoaderConfigCSVParser);if(rows.error){return rows;}// Process each row
var autoLoaderConfig=[];var invalidInstallationTypeIndex=[];var hasSideLine=false;var validInstallationType=Object(__WEBPACK_IMPORTED_MODULE_4__Util__["Q" /* getInstallationTypeValues */])(__WEBPACK_IMPORTED_MODULE_1__Constants__["R" /* AUTO_LOADER_ASSET_TYPE */]);for(var index=0;index<rows.length;index++){// Handle empty rows
var row=rows[index];if(!row){continue;}// Generate autoLoader config from values
var _values3=row.split(',');var _config3={destination:_values3[0].replace(/\s/g,''),installation:{type:_values3[1].toLowerCase().replace(/\s/g,'')}// add index of row to list if installationType is invalid
};!validInstallationType.includes(_config3.installation.type)&&invalidInstallationTypeIndex.push(index+1);// set has SideLine to true if config contains a sideLine value
if(__WEBPACK_IMPORTED_MODULE_1__Constants__["_84" /* INSTALLATION_TYPES */].SIDELINE.value===_config3.installation.type){hasSideLine=true;}else{_config3.installation.locations=_values3.slice(2).join(',').toUpperCase().replace(/\s|"/g,'').split(';');}// Validate row
var validateConfig=JSON.parse(JSON.stringify(_config3));if(validateConfig.installation.locations){validateConfig.installation.locations=validateConfig.installation.locations.join(";");}if(!Object(__WEBPACK_IMPORTED_MODULE_0__Validations__["x" /* checkModalValidationsForConfig */])(validateConfig,mac,__WEBPACK_IMPORTED_MODULE_1__Constants__["R" /* AUTO_LOADER_ASSET_TYPE */])){return{error:"Values of row number "+(index+1)+" are invalid"};}// Add to list
autoLoaderConfig.push(_config3);}if(!hasSideLine){return{error:"Config is missing sideline destination"};}return invalidInstallationTypeIndex.length>0?{error:"Installation type is invalid for "+invalidInstallationTypeIndex.length+" row(s): "+invalidInstallationTypeIndex.slice(0,Math.min(20,invalidInstallationTypeIndex.length))}:autoLoaderConfig;}};var AutoLoaderTestConfigCSVParser={FIELDS:["Scannables","SortZone","Length","Height","Width","Weight"],SAMPLE:'Scannables,SortZone,Length,Height,Width,Weight\nTBA123456789,A1-1A,100,50,75,5\nTBA123456790,B1-1B,120,60,80,6',STRINGIFY:function STRINGIFY(assets){var res="Scannables,SortZone,Length,Height,Width,Weight\n";assets.forEach(function(asset){var scannablesString="";asset.scannables.forEach(function(scannable,index){if(index){scannablesString+=";"+scannable;}else{scannablesString+=scannable;}});res+=scannablesString+","+asset.sortZone+","+asset.length+","+asset.height+","+asset.width+","+asset.weight+"\n";});return res;},PARSE:function PARSE(str){// Get rows after common validation
var rows=commonCSVValidation(str,AutoLoaderTestConfigCSVParser);// Process rows
var autoLoaderConfig=[];for(var index=0;index<rows.length;index++){// Start from 0 instead of 1
// Handle empty rows
var row=rows[index];if(!row){continue;}// Generate autoloader config from values
var _values4=row.replace(/\s/g,'').split(',');if(_values4.length!==6){return{error:"Row "+(index+1)+" has incorrect number of columns"};}var _config4={scannables:_values4[0].split(';'),sortZone:_values4[1],length:parseFloat(_values4[2]),height:parseFloat(_values4[3]),width:parseFloat(_values4[4]),weight:parseFloat(_values4[5])// Validate row
};if(!Object(__WEBPACK_IMPORTED_MODULE_0__Validations__["w" /* checkModalValidationsForAutoloaderTestPackage */])(_config4)){return{error:"Values of row number "+(index+1)+" are invalid"};}// Add to list
autoLoaderConfig.push(_config4);}return autoLoaderConfig;}};var DivertConfigCSVParser={FIELDS:["DivertCode","Clusters"],SAMPLE:'DivertCode,Clusters\n10,A;B',STRINGIFY:function STRINGIFY(assets){var res="DivertCode,Clusters\n";assets.forEach(function(asset){var clusterString="";asset.clusters.forEach(function(cluster,index){if(index){clusterString+=";"+cluster;}else{clusterString+=cluster;}});res+=asset.divertCode+","+clusterString+"\n";});return res;}};var MHELogsCSVParser={FIELDS:function FIELDS(intl){return Object(__WEBPACK_IMPORTED_MODULE_2__Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'mhelog.datetime'})+","+(Object(__WEBPACK_IMPORTED_MODULE_2__Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'mhelog.protocol'})+",")+(Object(__WEBPACK_IMPORTED_MODULE_2__Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'mhelog.devicetype'})+",")+(Object(__WEBPACK_IMPORTED_MODULE_2__Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'mhelog.devicename'})+",")+(Object(__WEBPACK_IMPORTED_MODULE_2__Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'mhelog.mac'})+",")+(Object(__WEBPACK_IMPORTED_MODULE_2__Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'mhelog.ip'})+",")+(Object(__WEBPACK_IMPORTED_MODULE_2__Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'mhelog.eventtype'})+",")+(Object(__WEBPACK_IMPORTED_MODULE_2__Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'mhelog.message'})+",")+(Object(__WEBPACK_IMPORTED_MODULE_2__Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'mhelog.payload'})+"\n");},STRINGIFY:function STRINGIFY(intl,data,deviceType){var response=MHELogsCSVParser.FIELDS(intl);data.forEach(function(entry){response+=MHELogsCSVParser.FILTER_DATA(entry.timestamp.replace(__WEBPACK_IMPORTED_MODULE_1__Constants__["_3" /* COMMA */],__WEBPACK_IMPORTED_MODULE_1__Constants__["_25" /* EMPTY_STRING */]))+","+MHELogsCSVParser.FILTER_DATA(entry.component)+","+MHELogsCSVParser.FILTER_DATA(deviceType)+","+MHELogsCSVParser.FILTER_DATA(entry.name)+","+MHELogsCSVParser.FILTER_DATA(entry.mac)+","+MHELogsCSVParser.FILTER_DATA(entry.ip)+","+MHELogsCSVParser.FILTER_DATA(entry.eventType)+","+MHELogsCSVParser.FILTER_DATA(entry.message)+","+MHELogsCSVParser.FILTER_DATA(escapeDoubleQuotes(JSON.stringify(entry.payload)))+"\n";});return response;},FILTER_DATA:function FILTER_DATA(data){return data!==undefined?data:'';}};var LOCATION_MAPPING_FIELDS=["PickChute","Type","PickPoints"];var LOCATION_MAPPING_SAMPLE="PickChute,Type,PickPoints\nPC1,BAG,PKP-01;PKP-03\nPC2,PACKAGE,PKP-01;PKP-03\n";var RetrieverLocationMappingCSVParser={FIELDS:LOCATION_MAPPING_FIELDS,SAMPLE:LOCATION_MAPPING_SAMPLE,STRINGIFY:function STRINGIFY(data){var response="PickChute,Type,PickPoints\n";data.forEach(function(row){var locations=Array.isArray(row.locations)?row.locations.join(";"):"";response+=row.destination+","+row.type+","+locations+"\n";});return response;}};function createRetrieverLocationMappingCSVParser(pickPointLabels,intl){return{FIELDS:LOCATION_MAPPING_FIELDS,SAMPLE:LOCATION_MAPPING_SAMPLE,STRINGIFY:RetrieverLocationMappingCSVParser.STRINGIFY,PARSE:function PARSE(text){var fieldParser={FIELDS:LOCATION_MAPPING_FIELDS};var rows=commonCSVValidation(text,fieldParser);if(rows.error)return rows;var rowError=function rowError(rowNum,message){return{error:intl.formatMessage({id:"locationmapping.error.row_prefix"},{row:rowNum,message:message})};};var result=[];for(var i=0;i<rows.length;i++){var row=rows[i].trim();if(!row)continue;var cols=row.split(",");if(cols.length!==3){return rowError(i+1,intl.formatMessage({id:"locationmapping.error.column_count"},{count:cols.length}));}var destination=cols[0].trim();var type=cols[1].trim().toUpperCase();var rawLocations=cols[2].trim().split(";").map(function(l){return l.trim();}).filter(function(l){return l;});var locations=rawLocations.filter(function(val,idx,arr){return arr.indexOf(val)===idx;});if(pickPointLabels&&pickPointLabels.length>0){for(var j=0;j<locations.length;j++){if(pickPointLabels.indexOf(locations[j])===-1){return rowError(i+1,intl.formatMessage({id:"locationmapping.error.pick_point_not_found"},{pickPoint:locations[j]}));}}}var validationError=Object(__WEBPACK_IMPORTED_MODULE_0__Validations__["P" /* validateLocationMappingRow */])(destination,type,locations,result,false);if(validationError){return rowError(i+1,intl.formatMessage({id:validationError.id},validationError.values||{}));}result.push({destination:destination,type:type,locations:locations});}return result;}};}

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_download_small__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_download_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_download_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_Parsers__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_ConditionalWrapping__ = __webpack_require__(91);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var renderDeviceSelectionRow=function renderDeviceSelectionRow(props){var selectedMac=props.selectedMac,setSelectedMac=props.setSelectedMac,setValueConfiguration=props.setValueConfiguration,defaultSelection=props.defaultSelection,configurationKeys=props.configurationKeys,deployDraft=props.deployDraft,sortedDeviceList=props.sortedDeviceList,isDeployDisabled=props.isDeployDisabled,resetDraftData=props.resetDraftData,isRollbackDisabled=props.isRollbackDisabled,rollbackClickHandler=props.rollbackClickHandler,isAuthorized=props.isAuthorized,valueConfiguration=props.valueConfiguration,isSorterConfig=props.isSorterConfig,intl=props.intl,isViewOnly=props.isViewOnly;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default.a,{type:"fill",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",widths:["fill",'30%'],spacing:"400"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"devicename.title",defaultMessage:"Select Device"})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select___default.a,{id:"device-select-options",value:selectedMac,onChange:function onChange(value){setSelectedMac(value);setValueConfiguration(defaultSelection);},placeholder:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"devicename.title",defaultMessage:"Select Device"}),size:"small",width:250},sortedDeviceList.map(function(device){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__["SelectOption"],{key:device.mac,value:device.mac,label:device.name+" ("+device.mac+")"});}),!sortedDeviceList.length&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default.a,{alignment:"center"}," No devices available ")))),!isViewOnly&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,{alignmentHorizontal:"end"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{id:"deploydraft-btn",size:"small",disabled:isDeployDisabled,onClick:deployDraft},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"actions.deploydraft",defaultMessage:"Deploy Draft"})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{id:"discarddraft-btn",size:"small",disabled:isDeployDisabled,type:"tertiary",onClick:function onClick(){return resetDraftData(configurationKeys,selectedMac);}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"actions.discarddraft",defaultMessage:"Discard Draft"})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized&&isSorterConfig,wrapper:__WEBPACK_IMPORTED_MODULE_19__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"top"},child:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{id:"rollback-btn",size:"small",className:"redBtn",disabled:isRollbackDisabled||!isAuthorized&&(isSorterConfig||valueConfiguration===""),onClick:rollbackClickHandler},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"actions.rollback",defaultMessage:"Rollback"}))}))));};var renderConfigurationSelectionRow=function renderConfigurationSelectionRow(props){var selectedMac=props.selectedMac,valueConfiguration=props.valueConfiguration,setValueConfiguration=props.setValueConfiguration,configurationKeys=props.configurationKeys,intl=props.intl,scrollToBottom=props.scrollToBottom,refreshDeps=props.refreshDeps,isDownloadDisabled=props.isDownloadDisabled,downloadConfigHandler=props.downloadConfigHandler;return selectedMac&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,{width:"100%",widths:["60%","40%"]},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"configtype.title",defaultMessage:"Select Config Type"})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select___default.a,{value:valueConfiguration,onChange:setValueConfiguration,disabled:!selectedMac,placeholder:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"configtype.title",defaultMessage:"Select Config Type"}),size:"small",width:200},configurationKeys.map(function(configKey){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__["SelectOption"],{key:configKey,value:configKey,label:__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_5" /* CONFIG_TYPE_VALUE */][configKey]});})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{id:"download-btn",size:"small",onClick:function onClick(){return downloadConfigHandler(valueConfiguration,selectedMac);},disabled:isDownloadDisabled(valueConfiguration,selectedMac)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_download_small___default.a}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"config.download",defaultMessage:"Download Config"}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,{alignmentHorizontal:"end"},valueConfiguration&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__util_RefreshTimer__["a" /* default */],{deps:[].concat(_toConsumableArray(refreshDeps))}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tooltip___default.a,{position:"top",title:intl.formatMessage({id:'tooltip.scrolltobottom',defaultMessage:'Scroll to bottom!'})},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))));};var getStringifiedData=function getStringifiedData(configType,data){if(configType===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_TEST_PACKAGE){return __WEBPACK_IMPORTED_MODULE_15__util_Parsers__["k" /* TestConfigCSVParser */].STRINGIFY(data);}else if(configType===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION){return __WEBPACK_IMPORTED_MODULE_15__util_Parsers__["h" /* SorterConfigCSVParser */].STRINGIFY(data);}else if(configType===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_TEST_PACKAGE){return __WEBPACK_IMPORTED_MODULE_15__util_Parsers__["k" /* TestConfigCSVParser */].STRINGIFY(data);}else if(configType===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION){return __WEBPACK_IMPORTED_MODULE_15__util_Parsers__["a" /* ADTFSorterConfigCSVParser */].STRINGIFY(data);}else if(configType===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION){return __WEBPACK_IMPORTED_MODULE_15__util_Parsers__["e" /* DivertConfigCSVParser */].STRINGIFY(data);}else if(__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION===configType){return __WEBPACK_IMPORTED_MODULE_15__util_Parsers__["m" /* ZancaSortTestConfigCSVParser */].STRINGIFY(data);}else if(__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_LOCATION_CONFIGURATION===configType){return __WEBPACK_IMPORTED_MODULE_15__util_Parsers__["l" /* ZancaSortLocationConfigCSVParser */].STRINGIFY(data);}else if(__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TIER_CONFIGURATION===configType){return __WEBPACK_IMPORTED_MODULE_15__util_Parsers__["n" /* ZancaSortTierConfigCSVParser */].STRINGIFY(data);}else if(__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_TEST_CONFIGURATION===configType){return __WEBPACK_IMPORTED_MODULE_15__util_Parsers__["j" /* TesseractTestConfigCSVParser */].STRINGIFY(data);}else if(__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_STOW_CONFIGURATION===configType){return __WEBPACK_IMPORTED_MODULE_15__util_Parsers__["i" /* TesseractStowConfigCSVParser */].STRINGIFY(data);}else if(__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_4" /* CONFIG_TYPE */].AUTO_RETRIEVER_TEST_CONFIGURATION===configType){return __WEBPACK_IMPORTED_MODULE_15__util_Parsers__["b" /* ARTestConfigCSVParser */].STRINGIFY(data);}else if(__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION===configType){return __WEBPACK_IMPORTED_MODULE_15__util_Parsers__["c" /* AutoLoaderConfigCSVParser */].STRINGIFY(data);}else if(__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_TEST_PACKAGE===configType){return __WEBPACK_IMPORTED_MODULE_15__util_Parsers__["d" /* AutoLoaderTestConfigCSVParser */].STRINGIFY(data);}else if(__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_4" /* CONFIG_TYPE */].RETRIEVER_LOCATION_MAPPING===configType){return __WEBPACK_IMPORTED_MODULE_15__util_Parsers__["g" /* RetrieverLocationMappingCSVParser */].STRINGIFY(data);}else{return"";}};var ConfigurationTabHeader=function ConfigurationTabHeader(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_8_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_14__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getFilteredDraftData=_useContext.getFilteredDraftData;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_8_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_17__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext2.showWarning;var deployDraft=function deployDraft(){showWarning(props.intl.formatMessage({id:"device.editWarning"}),function(){return props.deployDraft();});};var downloadConfigHandler=function downloadConfigHandler(stateKey,subKey){var data=getFilteredDraftData({stateKey:stateKey,subKey:subKey});Object(__WEBPACK_IMPORTED_MODULE_16__util_Util__["s" /* createDownloadableFile */])(Object(__WEBPACK_IMPORTED_MODULE_16__util_Util__["L" /* getDownloadFileName */])(stateKey),getStringifiedData(stateKey,data));};var isDownloadDisabled=function isDownloadDisabled(stateKey,subKey){if(!stateKey||!subKey)return true;var data=getFilteredDraftData({stateKey:stateKey,subKey:subKey});return data.length===0;};return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,null,renderDeviceSelectionRow(Object.assign({},props,{deployDraft:deployDraft})),!props.shouldNotRenderConfigSelection&&renderConfigurationSelectionRow(Object.assign({},props,{downloadConfigHandler:downloadConfigHandler,isDownloadDisabled:isDownloadDisabled})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(ConfigurationTabHeader));

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonui_LogstreamTabHeader__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonui_LogstreamTabBody__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_context_LogStoreContext__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Constants__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var CommonDeviceLogstream=function CommonDeviceLogstream(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__store_context_LogStoreContext__["a" /* LogStoreContext */]),addLog=_useContext.addLog;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isSubscribing=_useState2[0],setIsSubscribing=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),error=_useState4[0],setError=_useState4[1];var protocols=props.protocols,dispatch=props.dispatch,deviceList=props.deviceList,deviceType=props.deviceType,intl=props.intl;var onMessage=function onMessage(message){var parsedData=JSON.parse(message.toString());if(protocols.includes(parsedData.component)){parsedData.timestamp=Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["P" /* getFormattedTimestamp */])(parsedData.timestamp);addLog(parsedData);}};var headerProps={isSubscribing:isSubscribing,setIsSubscribing:setIsSubscribing,topic:Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["G" /* getAutomationMQTTTopic */])(),config:Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["V" /* getMQTTClientConfig */])(),setError:setError,intl:intl,onMessage:onMessage,deviceType:deviceType,deviceList:deviceList,eventType:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_74" /* EVENT_TYPE */].MHE_LOG_DATA};var loadDeviceList=function loadDeviceList(){if(deviceList.length===0){dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});}};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){loadDeviceList();},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonui_LogstreamTabHeader__["a" /* default */],headerProps),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"error"},Object(__WEBPACK_IMPORTED_MODULE_7__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'log.error'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonui_LogstreamTabBody__["a" /* default */],headerProps));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(CommonDeviceLogstream));

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdtfDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_AdtfDeviceOverviewReducer__ = __webpack_require__(1300);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AdtfDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var AdtfDeviceOverviewContextProvider=function AdtfDeviceOverviewContextProvider(props){var data=Object.assign({sortPref:{column:"name",direction:"ascending"},adtfDeviceInformation:{},macAddressArray:[],loadingOverview:true},props.data);var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_AdtfDeviceOverviewReducer__["a" /* AdtfDeviceOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AdtfDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (AdtfDeviceOverviewContextProvider);

/***/ }),
/* 104 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(603),
    getValue = __webpack_require__(606);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(246);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _emotion = __webpack_require__(11);

var _functional = __webpack_require__(38);

var cxMemoizedCurried = (0, _functional.memoizeCurry)(_emotion.cx, 1);
/**
 * A memoized version of cx. Only supports two classes.
 */

var cxMemoized = function cxMemoized(a, b) {
  return cxMemoizedCurried(a)(b);
};

var _default = cxMemoized;
exports["default"] = _default;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _clickable = _interopRequireDefault(__webpack_require__(678));

var _default = _clickable["default"];
exports["default"] = _default;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _focus = _interopRequireDefault(__webpack_require__(712));

var _default = _focus["default"];
exports["default"] = _default;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var processNextTick = __webpack_require__(262);
/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(162);
util.inherits = __webpack_require__(135);
/*</replacement>*/

var Readable = __webpack_require__(374);
var Writable = __webpack_require__(264);

util.inherits(Duplex, Readable);

var keys = objectKeys(Writable.prototype);
for (var v = 0; v < keys.length; v++) {
  var method = keys[v];
  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  processNextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var Buffer = __webpack_require__(19).Buffer;

var isBufferEncoding = Buffer.isEncoding
  || function(encoding) {
       switch (encoding && encoding.toLowerCase()) {
         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
         default: return false;
       }
     }


function assertEncoding(encoding) {
  if (encoding && !isBufferEncoding(encoding)) {
    throw new Error('Unknown encoding: ' + encoding);
  }
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters. CESU-8 is handled as part of the UTF-8 encoding.
//
// @TODO Handling all encodings inside a single object makes it very difficult
// to reason about this code, so it should be split up in the future.
// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
// points as used by CESU-8.
var StringDecoder = exports.StringDecoder = function(encoding) {
  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
  assertEncoding(encoding);
  switch (this.encoding) {
    case 'utf8':
      // CESU-8 represents each of Surrogate Pair by 3-bytes
      this.surrogateSize = 3;
      break;
    case 'ucs2':
    case 'utf16le':
      // UTF-16 represents each of Surrogate Pair by 2-bytes
      this.surrogateSize = 2;
      this.detectIncompleteChar = utf16DetectIncompleteChar;
      break;
    case 'base64':
      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
      this.surrogateSize = 3;
      this.detectIncompleteChar = base64DetectIncompleteChar;
      break;
    default:
      this.write = passThroughWrite;
      return;
  }

  // Enough space to store all bytes of a single character. UTF-8 needs 4
  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
  this.charBuffer = new Buffer(6);
  // Number of bytes received for the current incomplete multi-byte character.
  this.charReceived = 0;
  // Number of bytes expected for the current incomplete multi-byte character.
  this.charLength = 0;
};


// write decodes the given buffer and returns it as JS string that is
// guaranteed to not contain any partial multi-byte characters. Any partial
// character found at the end of the buffer is buffered up, and will be
// returned when calling write again with the remaining bytes.
//
// Note: Converting a Buffer containing an orphan surrogate to a String
// currently works, but converting a String to a Buffer (via `new Buffer`, or
// Buffer#write) will replace incomplete surrogates with the unicode
// replacement character. See https://codereview.chromium.org/121173009/ .
StringDecoder.prototype.write = function(buffer) {
  var charStr = '';
  // if our last write ended with an incomplete multibyte character
  while (this.charLength) {
    // determine how many remaining bytes this buffer has to offer for this char
    var available = (buffer.length >= this.charLength - this.charReceived) ?
        this.charLength - this.charReceived :
        buffer.length;

    // add the new bytes to the char buffer
    buffer.copy(this.charBuffer, this.charReceived, 0, available);
    this.charReceived += available;

    if (this.charReceived < this.charLength) {
      // still not enough chars in this buffer? wait for more ...
      return '';
    }

    // remove bytes belonging to the current character from the buffer
    buffer = buffer.slice(available, buffer.length);

    // get the character that was split
    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    var charCode = charStr.charCodeAt(charStr.length - 1);
    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      this.charLength += this.surrogateSize;
      charStr = '';
      continue;
    }
    this.charReceived = this.charLength = 0;

    // if there are no more bytes in this buffer, just emit our char
    if (buffer.length === 0) {
      return charStr;
    }
    break;
  }

  // determine and set charLength / charReceived
  this.detectIncompleteChar(buffer);

  var end = buffer.length;
  if (this.charLength) {
    // buffer the incomplete character bytes we got
    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
    end -= this.charReceived;
  }

  charStr += buffer.toString(this.encoding, 0, end);

  var end = charStr.length - 1;
  var charCode = charStr.charCodeAt(end);
  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
    var size = this.surrogateSize;
    this.charLength += size;
    this.charReceived += size;
    this.charBuffer.copy(this.charBuffer, size, 0, size);
    buffer.copy(this.charBuffer, 0, 0, size);
    return charStr.substring(0, end);
  }

  // or just emit the charStr
  return charStr;
};

// detectIncompleteChar determines if there is an incomplete UTF-8 character at
// the end of the given buffer. If so, it sets this.charLength to the byte
// length that character, and sets this.charReceived to the number of bytes
// that are available for this character.
StringDecoder.prototype.detectIncompleteChar = function(buffer) {
  // determine how many bytes we have to check at the end of this buffer
  var i = (buffer.length >= 3) ? 3 : buffer.length;

  // Figure out if one of the last i bytes of our buffer announces an
  // incomplete char.
  for (; i > 0; i--) {
    var c = buffer[buffer.length - i];

    // See http://en.wikipedia.org/wiki/UTF-8#Description

    // 110XXXXX
    if (i == 1 && c >> 5 == 0x06) {
      this.charLength = 2;
      break;
    }

    // 1110XXXX
    if (i <= 2 && c >> 4 == 0x0E) {
      this.charLength = 3;
      break;
    }

    // 11110XXX
    if (i <= 3 && c >> 3 == 0x1E) {
      this.charLength = 4;
      break;
    }
  }
  this.charReceived = i;
};

StringDecoder.prototype.end = function(buffer) {
  var res = '';
  if (buffer && buffer.length)
    res = this.write(buffer);

  if (this.charReceived) {
    var cr = this.charReceived;
    var buf = this.charBuffer;
    var enc = this.encoding;
    res += buf.slice(0, cr).toString(enc);
  }

  return res;
};

function passThroughWrite(buffer) {
  return buffer.toString(this.encoding);
}

function utf16DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 2;
  this.charLength = this.charReceived ? 2 : 0;
}

function base64DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 3;
  this.charLength = this.charReceived ? 3 : 0;
}


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__(798);
hash.common = __webpack_require__(799);
hash.sha = __webpack_require__(800);
hash.ripemd = __webpack_require__(801);
hash.hmac = __webpack_require__(802);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoizeTokenStyles = exports.removeTokenPrefixes = exports.getUnthemedTokens = exports.getIconFromTokens = exports.getTokenHelper = exports.getToken = void 0;

var _pascalCase = _interopRequireDefault(__webpack_require__(855));

var _upperFirst = _interopRequireDefault(__webpack_require__(401));

var _lowerFirst = _interopRequireDefault(__webpack_require__(856));

var _functional = __webpack_require__(98);

/**
 * Select a single token from a token object given a key (and optionally a
 * "suffix" key or list of suffix keys). If the token doesn't exist then an
 * attempt is made to replace the last suffix key with "default" and get the
 * value for that token. If that token also doesn't exist then `undefined` is
 * returned.
 *
 * @example
 * const tokens = {
 *   backgroundColorDefault: "#fff",
 *   backgroundColorHover: "#ccc",
 *   backgroundColorPressed: "#f00",
 * }
 * getToken(tokens, "backgroundColor", "active") // #fff
 * getTokens(tokens, "background", ["color", "pressed"]) // #f00
 * getToken(tokens, "myBackgroundColor") // undefined
 */
var getToken = function getToken(tokens, key, suffixKeys) {
  // If we got an array of suffix keys, turn them into a PascalCaseString and
  // look up the token
  if (suffixKeys && Array.isArray(suffixKeys)) {
    var value = tokens["".concat(key).concat((0, _pascalCase["default"])(suffixKeys))];
    return value !== undefined ? value : tokens["".concat(key).concat((0, _pascalCase["default"])(suffixKeys.slice(0, -1)), "Default")]; // If we got a single suffix key then upper case the first character and look
    // up the token
  } else if (suffixKeys) {
    var _value = tokens["".concat(key).concat((0, _upperFirst["default"])(suffixKeys))];
    return _value !== undefined ? _value : tokens["".concat(key, "Default")]; // If we didn't get any suffix keys then do a simple lookup
  } else {
    return tokens[key];
  }
};
/**
 * This will, given a root key and token object, return a special helper that
 * includes token utilities with those inputs already applied. Calling the
 * helper as a function is equivalent to calling `getToken`, but the helper also
 * includes several properties that make it easier to construct CSS from tokens.
 * This helper is useful when working with an object of tokens that all have the
 * same prefix.
 *
 * @example
 * const tokens = {
 *   buttonBorderWidth: 1,
 *   buttonBorderStyle: "dotted",
 *   buttonBorderColor: "#f00",
 * }
 * const t = getTokenHelper("button")(tokens)
 * t("borderWidth") // 1
 * t.borderCss("border") // "1px dotted #f00"
 * t.tokens === tokens // true
 *
 */


exports.getToken = getToken;
var getTokenHelper = (0, _functional.memoizeCurry)(function (prefixKey, tokens) {
  var helper = function helper(key, suffixKeys) {
    return getToken(tokens, prefixKey ? "".concat(prefixKey).concat((0, _upperFirst["default"])(key)) : key, suffixKeys);
  };

  helper.tokens = tokens; // Pass in "myBorder" and shorthand border css will be generated based on
  // "myBorderWidth" and "myBorderColor" tokens.

  helper.borderCss = function (key) {
    var width = helper(key, "width");
    var color = helper(key, "color");
    return width && color ? "".concat(width, "px solid ").concat(color) : undefined;
  }; // Pass in "myShadow" and shorthand box shadow css will be generated based on
  // "myShadowOffsetX", "myShadowOffsetY", "myShadowBlur", "myShadowSpread",
  // and "myShadowColor" tokens


  helper.boxShadowCss = function (key) {
    var color = helper(key, "color");
    return color ? "".concat(helper(key, "offsetX"), "px ").concat(helper(key, "offsetY"), "px ").concat(helper(key, "blur"), "px ").concat(helper(key, "spread"), "px ").concat(color) : undefined;
  }; // Pass in "myMotion" and a single css property or array of properties and
  // shorthand transition css will be generated that animates those properties
  // based on "myMotionFunction" and "myMotionDuration" tokens


  helper.transitionCss = function (key, properties) {
    var transition = "".concat(helper(key, "duration"), " ").concat(helper(key, "function"));
    return Array.isArray(properties) ? properties.map(function (property) {
      return "".concat(property, " ").concat(transition);
    }).join(", ") : "".concat(properties, " ").concat(transition);
  };

  return helper;
}, 1);
/**
 * Gets icon data from a set of icon tokens
 *
 * ```
 * const tokens = {
 *   iconCheckmarkData: "<svg />",
 *.  iconCheckmarkWidth: 12,
 *   iconCheckmarkHeight: 10,
 * }
 * // Returns { data: "<svg />", width: 12, height: 10 }
 * getIconFromTokens(tokens)
 * ```
 */

exports.getTokenHelper = getTokenHelper;

var getIconFromTokens = function getIconFromTokens(tokens) {
  return Object.keys(tokens).reduce(function (result, key) {
    if (key.indexOf("Data") > 0) {
      result.data = tokens[key];
    } else if (key.indexOf("Width") > 0) {
      result.width = tokens[key];
    } else if (key.indexOf("Height") > 0) {
      result.height = tokens[key];
    }

    return result;
  }, {});
};
/**
 * If you pass in a function that returns themed tokens when given a theme
 * object (e.g. any of our "component" tokens), this will call that function
 * with an empty theme object and filter out any tokens that are undefined. This
 * is useful for quickly accessing unthemed component tokens. Use this sparingly
 * as what is and is not themed may change in the future and require a refactor
 * of any code using this function.
 */


exports.getIconFromTokens = getIconFromTokens;

var getUnthemedTokens = function getUnthemedTokens(tokens) {
  var unthemedTokens = tokens({});
  return Object.keys(unthemedTokens).reduce(function (result, key) {
    if (unthemedTokens[key] !== undefined) {
      result[key] = unthemedTokens[key];
    }

    return result;
  }, {});
};
/**
 * Takes an object of tokens and removes the prefix from each token name (object
 * key). The result is returned with the first character of the new keys
 * lowercased.
 *
 * ```
 * const tokens = {
 *   iconCheckmarkData: "<svg />",
 *.  iconCheckmarkWidth: 12,
 *   iconCheckmarkHeight: 10,
 * }
 * // Returns { data: "<svg />", width: 12, height: 10 }
 * removetokenPrefixes(tokens, "iconCheckmark")
 * ```
 */


exports.getUnthemedTokens = getUnthemedTokens;

var removeTokenPrefixes = function removeTokenPrefixes(tokens, prefix) {
  var match = new RegExp("^".concat(prefix));
  return Object.keys(tokens).reduce(function (result, key) {
    if (match.test(key)) {
      result[(0, _lowerFirst["default"])(key.replace(match, ""))] = tokens[key];
    }

    return result;
  }, {});
};
/**
 * Memoize f(tokens, props) that is used extensively throughout meridian components,
 * specify the keys in the object to compare when determining whether to re-use
 * a previous calculation.
 *
 * @example
 * const style = memoizeTokenStyles((t, {a, b}) => css({a, b}), ["a", "b"])
 * style(tokens, {a, b})
 */


exports.removeTokenPrefixes = removeTokenPrefixes;

var memoizeTokenStyles = function memoizeTokenStyles(f, keys) {
  /* eslint-disable-next-line rulesdir/no-partial-memoization */
  var fn = (0, _functional.memoize)(function (t) {
    return (0, _functional.memoizeByKeys)(function (props) {
      return f(t, props);
    }, keys);
  });
  return function (t, props) {
    return fn(t)(props);
  };
};

exports.memoizeTokenStyles = memoizeTokenStyles;

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tokens_base_icon_arrow_right_large__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tokens_base_icon_arrow_right_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tokens_base_icon_arrow_right_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__ = __webpack_require__(33);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var EditMacAddressModal=function EditMacAddressModal(props){var open=props.open,setOpen=props.setOpen,selectedMac=props.selectedMac,setSelectedMac=props.setSelectedMac,dispatch=props.dispatch,stateValues=props.stateValues,assetType=props.assetType;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),newMac=_useState2[0],setNewMac=_useState2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning;var formatMessage=props.intl.formatMessage;var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(true),_useState4=_slicedToArray(_useState3,2),macErr=_useState4[0],setMacErr=_useState4[1];var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext2.showCustomAlert;var onCloseModal=function onCloseModal(){setOpen(false);setMacErr(true);setSelectedMac("");resetInputState();};var onClickConfirm=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:showWarning(formatMessage({id:"device.editWarning"}),function(){onCloseModal();dispatch({type:'UPDATE_DEVICE_MAC',data:{dispatcher:dispatch,stateValues:Object.assign({},stateValues,{mac:newMac}),showCustomAlert:showCustomAlert,mac:selectedMac,assetType:assetType}});getData();});case 1:case"end":return _context.stop();}}},_callee,_this);}));return function onClickConfirm(){return _ref.apply(this,arguments);};}();function resetInputState(){setNewMac("");}var getData=function getData(){dispatch({type:'LOAD_VIEW',data:{dispatcher:props.dispatch}});};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.edit_device_mac_modal"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmmacedit",defaultMessage:"Please enter new mac address for the following device:"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{type:"h300"}," ",selectedMac," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_input___default.a,{id:"mac-input",value:newMac,onChange:function onChange(val){setNewMac(val);setMacErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(val,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].MAC));},mask:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["i" /* MAC_MASK */],error:macErr}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_button___default.a,{type:"primary",size:"medium",disabled:macErr,onClick:function onClick(){return onClickConfirm();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"modal.confirm",defaultMessage:"Confirm"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */])(EditMacAddressModal));

/***/ }),
/* 115 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconArrowRightLargeData: "data:image/svg+xml,%3csvg width='14' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M9 9l4-4-4-4M13 5H1'/%3e%3c/g%3e%3c/svg%3e",
  iconArrowRightLargeRtlSvg: "data:image/svg+xml,%3csvg width='14' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M5 1L1 5l4 4M1 5h12'/%3e%3c/g%3e%3c/svg%3e",
  iconArrowRightLargeWidth: 14,
  iconArrowRightLargeHeight: 10
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * TODO: This limited locale information is included because of the complexity
 * of internationalizing date-related components. In general we should not
 * include locale-specific data in this component library until we have a better
 * idea of what a holistic internationalization API would look like. See:
 * https://sim.amazon.com/issues/b746b914-6eb7-482a-b3aa-5281090ddf16
 *
 * NOTE: This file uses the commonjs module format as it's also imported by
 * scripts/build-typescript-definitions.
 *
 * NOTE: Regarding lowercase "yyyy" and "dd" vs "MM" read this:
 * https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md#popular-mistakes
 *
 * NOTE: For `weekStart`, 0 is Sunday, 1 is Monday, etc.
 *
 * NOTE: The `compactDayOfWeekFormat` is primarily only needed for the DatePicker
 * mini calendar. Accepted formats are `long`, `short`, and `narrow`.
 * In English those correspond to Monday, Mon, and M.
 * Use `narrow` only when needed, otherwise use `short`. Some locales use the
 * same word for long and short, which can break the DatePicker mini calendar
 * Eg: The Burmese/Myanmar locale (my-MM) has dates that are too long using the
 * short format. Monday in Burmese is "တနင်္လာနေ့" for both long and short format.
 * The narrow format of "တနေ့" fits better in the DatePicker's calendar.
 *
 */

/**
 * All supported date locales.
 */
var locales = {
  "ar-AE": {
    format: "dd/MM/yyyy",
    weekStart: 0,
    compactDayOfWeekFormat: "short"
  },
  "de-DE": {
    format: "dd.MM.yyyy",
    weekStart: 1,
    compactDayOfWeekFormat: "short"
  },
  "en-CA": {
    format: "yyyy-MM-dd",
    weekStart: 0,
    compactDayOfWeekFormat: "short"
  },
  "en-GB": {
    format: "dd/MM/yyyy",
    weekStart: 1,
    compactDayOfWeekFormat: "short"
  },
  "en-IN": {
    format: "dd-MM-yyyy",
    weekStart: 1,
    compactDayOfWeekFormat: "short"
  },
  "en-US": {
    format: "MM/dd/yyyy",
    weekStart: 0,
    compactDayOfWeekFormat: "short"
  },
  "es-ES": {
    format: "dd/MM/yyyy",
    weekStart: 1,
    compactDayOfWeekFormat: "short"
  },
  "es-MX": {
    format: "dd/MM/yyyy",
    weekStart: 1,
    compactDayOfWeekFormat: "short"
  },
  "fr-CA": {
    format: "yyyy-MM-dd",
    weekStart: 0,
    compactDayOfWeekFormat: "short"
  },
  "fr-FR": {
    format: "dd/MM/yyyy",
    weekStart: 1,
    compactDayOfWeekFormat: "short"
  },
  "it-IT": {
    format: "dd/MM/yyyy",
    weekStart: 1,
    compactDayOfWeekFormat: "short"
  },
  "ja-JP": {
    format: "yyyy年MM月dd日",
    weekStart: 1,
    compactDayOfWeekFormat: "short"
  },
  "my-MM": {
    format: "dd-MM-yyyy",
    weekStart: 0,
    compactDayOfWeekFormat: "narrow"
  },
  "pl-PL": {
    format: "dd.MM.yyyy",
    weekStart: 1,
    compactDayOfWeekFormat: "short"
  },
  "so-SO": {
    format: "dd/MM/yyyy",
    weekStart: 1,
    compactDayOfWeekFormat: "short"
  },
  "zh-CN": {
    format: "yyyy年MM月dd日",
    weekStart: 1,
    compactDayOfWeekFormat: "short"
  }
};
/**
 * A fallback locale for when an unsupported locale is requested. Note that the
 * locale should still be *valid*, otherwise the Intl APIs we use will fail.
 *
 * The data here was chosen arbitrarily. For the format, it does seem fairly
 * universal that if the four digit year is shown first then it's always
 * year-then-month-then-day. This seems less ambiguous than falling back to,
 * say, en-US which uses the terrible day-then-month-then-year format. For
 * weekStart... 0 comes before 1? 🤷‍♂️
 */

var fallbackLocale = {
  format: "yyyy-MM-dd",
  weekStart: 0,
  compactDayOfWeekFormat: "short"
};
/**
 * Fetch the requested locale, falling back to en-US if the locale isn't
 * supported or isn't valid.
 */

var getDateLocale = function getDateLocale(locale) {
  return locales[locale] || fallbackLocale;
}; // This module is written using commonjs so we can access it in our build
// scripts (specifically for generating TypeScript definitions). This __esModule
// flag tells webpack et al to treat this like an ES module even though it's
// written in commonjs.


module.exports.__esModule = {
  value: true
};
module.exports["default"] = locales;
module.exports.getDateLocale = getDateLocale;

/***/ }),
/* 117 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconUploadSmallData: "data:image/svg+xml,%3csvg width='15' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke-width='2' stroke='currentColor' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M13.5 10v2a1 1 0 01-1 1h-10a1 1 0 01-1-1v-2M10.5 4l-3-3-3 3M7.5 9V1'/%3e%3c/g%3e%3c/svg%3e",
  iconUploadSmallWidth: 15,
  iconUploadSmallHeight: 14
};

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_modal__);
var RollbackModal=function RollbackModal(_ref){var showRollbackModal=_ref.showRollbackModal,setShowRollbackModal=_ref.setShowRollbackModal,isVersionsLoading=_ref.isVersionsLoading,selectedVersion=_ref.selectedVersion,setSelectedVersion=_ref.setSelectedVersion,rollBackVersions=_ref.rollBackVersions,loadRollbackDataToDraft=_ref.loadRollbackDataToDraft,intl=_ref.intl;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_modal___default.a,{title:"Select a version to rollback",open:showRollbackModal,onClose:function onClose(){setShowRollbackModal(false);},scrollContainer:"viewport",closeLabel:"Close"},isVersionsLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__loader_Loader__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,{alignmentHorizontal:"right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select___default.a,{value:selectedVersion,onChange:setSelectedVersion,placeholder:"Select a version to rollback",width:300},rollBackVersions.map(function(version,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__["SelectOption"],{key:index,value:version.rangeKey,label:""+Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_35" /* versionString */])(intl,version.rangeKey,version.alias)});}),!rollBackVersions.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{alignment:"center"}," No Versions Available ")):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:function onClick(){loadRollbackDataToDraft();setShowRollbackModal(false);},type:"primary",size:"small",width:100},"Confirm")));};/* harmony default export */ __webpack_exports__["a"] = (RollbackModal);

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(223);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(__webpack_require__(87));
util.inherits = __webpack_require__(79);
/*</replacement>*/

var Readable = __webpack_require__(473);
var Writable = __webpack_require__(476);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LidarOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_LidarOverviewReducer__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var LidarOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var LidarOverviewContextProvider=function LidarOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},lidarDeviceInformation:{},macAddressArray:[],deviceConnectivityList:[],loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_LidarOverviewReducer__["a" /* LidarOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LidarOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (LidarOverviewContextProvider);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrafficLightDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_TrafficLightOverviewReducer__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var TrafficLightDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var TrafficLightDeviceOverviewContextProvider=function TrafficLightDeviceOverviewContextProvider(props){var data={deviceInformation:{},loadingOverview:true,showResponseModal:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_134" /* MODAL_RESET */],modalMessageToDisplay:''};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_TrafficLightOverviewReducer__["a" /* TrafficLightOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TrafficLightDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (TrafficLightDeviceOverviewContextProvider);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoRetrieverDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_AutoRetrieverDeviceOverviewReducer__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AutoRetrieverDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var AutoRetrieverDeviceOverviewContextProvider=function AutoRetrieverDeviceOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},autoRetrieverDeviceInformation:{},macAddressArray:[],testConfig:{},pickStationResources:[],loadingPickStationResources:false,pickPointResources:[],loadingPickPointResources:false,loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_AutoRetrieverDeviceOverviewReducer__["a" /* AutoRetrieverDeviceOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AutoRetrieverDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (AutoRetrieverDeviceOverviewContextProvider);

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(152),
    getRawTag = __webpack_require__(581),
    objectToString = __webpack_require__(582);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(327),
    isLength = __webpack_require__(238);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(650);
} else {
  module.exports = require("./prop-types");
}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/** Returns a string value for a border radius style.
 *
 * eg: `0px 4px 4px 0px`
 *
 * @returns {string}
 */
var getBorderRadius = function getBorderRadius(borderRadius) {
  var sides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var topLeft = sides.includes("topLeft") ? borderRadius : 0;
  var topRight = sides.includes("topRight") ? borderRadius : 0;
  var bottomLeft = sides.includes("bottomLeft") ? borderRadius : 0;
  var bottomRight = sides.includes("bottomRight") ? borderRadius : 0;
  return "".concat(topLeft, "px ").concat(topRight, "px ").concat(bottomRight, "px ").concat(bottomLeft, "px");
};

var _default = getBorderRadius;
exports["default"] = _default;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSpacing = exports.parseAlignment = void 0;

var _spacing = _interopRequireDefault(__webpack_require__(340));

var _token = __webpack_require__(20);

// Parses the value for a spacing prop. This turns a string of spacing names
// like "medium" or "small medium" into an array of spacing values like ["16px"]
// or ["8px", "16px"].
var parseSpacing = function parseSpacing(spacing) {
  return spacing ? spacing.split(" ").map(function (spacing) {
    return (0, _token.getToken)(_spacing["default"], "spacing", spacing) || 0;
  }) : [];
}; // Parses the value for a alignment prop. Given a valid alignment prop value
// this will return an array of two values representing x and y alignment
// respectively.


exports.parseSpacing = parseSpacing;

var parseAlignment = function parseAlignment(alignment) {
  var values = alignment.split(" ");
  return {
    x: values[1],
    y: values[0]
  };
};

exports.parseAlignment = parseAlignment;

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdtaDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_AdtaDeviceOverviewReducer__ = __webpack_require__(658);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AdtaDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var AdtaDeviceOverviewContextProvider=function AdtaDeviceOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},adtaDeviceInformation:{},macAddressArray:[],loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_AdtaDeviceOverviewReducer__["a" /* AdtaDeviceOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AdtaDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (AdtaDeviceOverviewContextProvider);

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(348);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDefaultOptions;
/* unused harmony export setDefaultOptions */
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {
var inherits = __webpack_require__(42)
var md5 = __webpack_require__(371)
var rmd160 = __webpack_require__(761)
var sha = __webpack_require__(762)

var Base = __webpack_require__(134)

function HashNoConstructor(hash) {
  Base.call(this, 'digest')

  this._hash = hash
  this.buffers = []
}

inherits(HashNoConstructor, Base)

HashNoConstructor.prototype._update = function (data) {
  this.buffers.push(data)
}

HashNoConstructor.prototype._final = function () {
  var buf = Buffer.concat(this.buffers)
  var r = this._hash(buf)
  this.buffers = null

  return r
}

function Hash(hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if ('md5' === alg) return new HashNoConstructor(md5)
  if ('rmd160' === alg || 'ripemd160' === alg) return new HashNoConstructor(rmd160)

  return new Hash(sha(alg))
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = new Buffer(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
  this._s = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = new Buffer(data, enc)
  }

  var l = this._len += data.length
  var s = this._s || 0
  var f = 0
  var buffer = this._block

  while (s < l) {
    var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
    var ch = (t - f)

    for (var i = 0; i < ch; i++) {
      buffer[(s % this._blockSize) + i] = data[i + f]
    }

    s += ch
    f += ch

    if ((s % this._blockSize) === 0) {
      this._update(buffer)
    }
  }
  this._s = s

  return this
}

Hash.prototype.digest = function (enc) {
  // Suppose the length of the message M, in bits, is l
  var l = this._len * 8

  // Append the bit 1 to the end of the message
  this._block[this._len % this._blockSize] = 0x80

  // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
  this._block.fill(0, this._len % this._blockSize + 1)

  if (l % (this._blockSize * 8) >= this._finalSize * 8) {
    this._update(this._block)
    this._block.fill(0)
  }

  // to this append the block which is equal to the number l written in binary
  // TODO: handle case where l is > Math.pow(2, 29)
  this._block.writeInt32BE(l, this._blockSize - 4)

  var hash = this._update(this._block) || this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(161).Buffer;
var Transform = __webpack_require__(85).Transform;
var StringDecoder = __webpack_require__(111).StringDecoder;
var inherits = __webpack_require__(42);
var toBuffer = __webpack_require__(777);

function CipherBase(hashMode) {
	Transform.call(this);
	this.hashMode = typeof hashMode === 'string';
	if (this.hashMode) {
		this[hashMode] = this._finalOrDigest;
	} else {
		this['final'] = this._finalOrDigest;
	}
	if (this._final) {
		this.__final = this._final;
		this._final = null;
	}
	this._decoder = null;
	this._encoding = null;
}
inherits(CipherBase, Transform);

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
	var bufferData = toBuffer(data, inputEnc); // asserts correct input type
	var outData = this._update(bufferData);
	if (this.hashMode) {
		return this;
	}

	if (outputEnc) {
		outData = this._toString(outData, outputEnc);
	}

	return outData;
};

CipherBase.prototype.setAutoPadding = function () {};
CipherBase.prototype.getAuthTag = function () {
	throw new Error('trying to get auth tag in unsupported state');
};

CipherBase.prototype.setAuthTag = function () {
	throw new Error('trying to set auth tag in unsupported state');
};

CipherBase.prototype.setAAD = function () {
	throw new Error('trying to set aad in unsupported state');
};

CipherBase.prototype._transform = function (data, _, next) {
	var err;
	try {
		if (this.hashMode) {
			this._update(data);
		} else {
			this.push(this._update(data));
		}
	} catch (e) {
		err = e;
	} finally {
		next(err);
	}
};
CipherBase.prototype._flush = function (done) {
	var err;
	try {
		this.push(this.__final());
	} catch (e) {
		err = e;
	}

	done(err);
};
CipherBase.prototype._finalOrDigest = function (outputEnc) {
	var outData = this.__final() || Buffer.alloc(0);
	if (outputEnc) {
		outData = this._toString(outData, outputEnc, true);
	}
	return outData;
};

CipherBase.prototype._toString = function (value, enc, fin) {
	if (!this._decoder) {
		this._decoder = new StringDecoder(enc);
		this._encoding = enc;
	}

	if (this._encoding !== enc) {
		throw new Error('can’t switch encodings');
	}

	var out = this._decoder.write(value);
	if (fin) {
		out += this._decoder.end();
	}

	return out;
};

module.exports = CipherBase;


/***/ }),
/* 135 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__(61);

asn1.define = __webpack_require__(816).define;
asn1.base = __webpack_require__(165);
asn1.constants = __webpack_require__(392);
asn1.decoders = __webpack_require__(822);
asn1.encoders = __webpack_require__(824);


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AslDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_AslDeviceOverviewReducer__ = __webpack_require__(844);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AslDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var AslDeviceOverviewContextProvider=function AslDeviceOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},aslDeviceInformation:{},macAddressArray:[],loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_AslDeviceOverviewReducer__["a" /* AslDeviceOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AslDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (AslDeviceOverviewContextProvider);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _supportTextWrapper = _interopRequireDefault(__webpack_require__(897));

var _default = _supportTextWrapper["default"];
exports["default"] = _default;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/** Returns a string value of IDs for the support text used by
 * form field components with a SupportTextWrapper. To be used
 * in an aria-describedby prop to ensure that helper text,
 * constraint text, and error messages are read in the correct
 * order by screen readers.
 *
 * eg: `myinput-constraint-text myinput-helper-text myinput-error-message`
 *
 * @returns {string}
 */
var getSupportTextAriaDescribedby = function getSupportTextAriaDescribedby(_ref) {
  var id = _ref.id,
      hasHelperText = _ref.hasHelperText,
      hasConstraintText = _ref.hasConstraintText,
      hasErrorMessage = _ref.hasErrorMessage,
      errorMessageFirst = _ref.errorMessageFirst;
  var helperText = hasHelperText ? "".concat(id, "-helper-text") : null;
  var constraintText = hasConstraintText ? "".concat(id, "-constraint-text") : null;
  var errorMessage = hasErrorMessage ? "".concat(id, "-error-message") : null;
  return errorMessageFirst ? [errorMessage, helperText, constraintText].filter(Boolean).join(" ") : [helperText, errorMessage, constraintText].filter(Boolean).join(" ");
};

var _default = getSupportTextAriaDescribedby;
exports["default"] = _default;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(931),
    getValue = __webpack_require__(934);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _link = _interopRequireDefault(__webpack_require__(1056));

var _default = _link["default"];
exports["default"] = _default;

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEDControllerOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_LEDControllerOverviewReducer__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var LEDControllerOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var LEDControllerOverviewContextProvider=function LEDControllerOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},ledControllerDeviceInformation:{},aisleTypes:new Set(),ledControllerTypes:[],selectedDefaultValues:{},loadingOverview:true,monitoringStatusLoadingDevices:{}};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_LEDControllerOverviewReducer__["a" /* LEDControllerOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LEDControllerOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (LEDControllerOverviewContextProvider);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getNextAisleName */
/* unused harmony export getNextPortNumber */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getObjectByIndex; });
/* unused harmony export createAisleConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createNextAisleConfig; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getAisleName;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createFirstAisleConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getLastAisleConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createNextAisleConfigs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isAssetCreated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isAssetStatusUpdated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSortedData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Util__ = __webpack_require__(5);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var getNextAisleName=function getNextAisleName(aisleName){var match=aisleName.match(/^([A-Z])(-?)(\d+)$/);if(match){var _match=_slicedToArray(match,4),letter=_match[1],separator=_match[2],number=_match[3];var nextNumber=parseInt(number,10)+1;return""+letter+separator+nextNumber;}return null;};var getNextPortNumber=function getNextPortNumber(numStr){var num=parseInt(numStr,10);return!isNaN(num)?num+1:null;};var getObjectByIndex=function getObjectByIndex(list,index){return list.find(function(item){return item.index===index;});};var createAisleConfig=function createAisleConfig(aisleName,portNumber,aisleType,index){return{aisleName:aisleName,portNumber:portNumber,aisleType:aisleType,index:index};};var createNextAisleConfig=function createNextAisleConfig(aisle,aisleType){return createAisleConfig(getNextAisleName(aisle.aisleName),getNextPortNumber(aisle.portNumber),aisleType,aisle.index+1);};function getAisleName(){var region=Object(__WEBPACK_IMPORTED_MODULE_1__Util__["_15" /* getUTRRegion */])();if(region==="NA"){return __WEBPACK_IMPORTED_MODULE_0__Validations__["a" /* AISLE_NAME */].NA;}else if(region==="EU"){return __WEBPACK_IMPORTED_MODULE_0__Validations__["a" /* AISLE_NAME */].EU;}return __WEBPACK_IMPORTED_MODULE_0__Validations__["a" /* AISLE_NAME */].FE;}var createFirstAisleConfig=function createFirstAisleConfig(aisleType){return createAisleConfig(getAisleName(),1,aisleType,1);};var getLastAisleConfig=function getLastAisleConfig(availableAisles){return availableAisles&&availableAisles.length>0?getObjectByIndex(availableAisles,availableAisles.length):null;};var createNextAisleConfigs=function createNextAisleConfigs(addAislesReq,index){var aisleConfig=createAisleConfig(addAislesReq.startAisleLabel,parseInt(addAislesReq.startPortNumber,10),addAislesReq.aisleType,index+1);var nextAislesConfigList=[aisleConfig];for(var i=1;i<addAislesReq.aisleCount;i++){var nextAisleConfig=createNextAisleConfig(aisleConfig,addAislesReq.aisleType);nextAislesConfigList.push(nextAisleConfig);aisleConfig=nextAisleConfig;}return nextAislesConfigList;};var isAssetCreated=function isAssetCreated(assetDetails,macAddress){if(!assetDetails||!macAddress){return false;}return macAddress in assetDetails;};var isAssetStatusUpdated=function isAssetStatusUpdated(assetDetails,macAddress){if(!assetDetails||!macAddress){return false;}return!(macAddress in assetDetails);};var getSortedData=function getSortedData(devices){devices&&devices.sort(function(a,b){if(a.name<b.name){return-1;}else if(a.name>b.name){return 1;}return 0;});return devices;};

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_file_input__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_file_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_file_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_download_small__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_download_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_download_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Util__ = __webpack_require__(5);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var UploadFileModal=function UploadFileModal(props){var open=props.open,setOpen=props.setOpen,parser=props.parser,mac=props.mac,updateConfig=props.updateConfig;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(undefined),_useState2=_slicedToArray(_useState,2),file=_useState2[0],setFile=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),err=_useState4[0],setErr=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),_useState6=_slicedToArray(_useState5,2),output=_useState6[0],setOutput=_useState6[1];// UI states
var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),complete=_useState8[0],setComplete=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(0),_useState10=_slicedToArray(_useState9,2),percentage=_useState10[0],setPercentage=_useState10[1];// Setup file reader
var fileReader=new FileReader();fileReader.onload=function(event){processText(event.target.result,mac);};fileReader.onprogress=function(event){setPercentage(event.total/event.loaded);};fileReader.onloadend=function(event){setComplete(true);};var onCloseModal=function onCloseModal(){setOpen(false);resetState();};var resetState=function resetState(){setFile(undefined);setErr("");setOutput([]);setComplete(false);};var onClickConfirm=function onClickConfirm(){updateConfig(output);setOpen(false);resetState();};var setFileData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(uploadedFile){var fileObj;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:fileObj=uploadedFile[0];if(!(fileObj.size>__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_115" /* MAX_CSV_SIZE_BYTES */])){_context.next=4;break;}setErr("Error while uploading file: File size too large");return _context.abrupt("return");case 4:setFile(fileObj);setErr("");fileReader.readAsText(fileObj);case 7:case"end":return _context.stop();}}},_callee,_this);}));return function setFileData(_x){return _ref.apply(this,arguments);};}();var processText=function processText(text,mac){var output=parser.PARSE(text,mac);if(output.error){setErr(output.error);}else{setOutput(output);}};var renderFileInput=function renderFileInput(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"upload.subtitle",defaultMessage:"Upload CSV file to overwrite the existing configuration."})),!file?renderPreUpload():renderPostUpload());};var renderPreUpload=function renderPreUpload(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,{alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_file_input___default.a,{onFileAttached:setFileData,showDropZone:true,accept:".csv",type:"single"}),err&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_alert___default.a,{type:"error",size:"medium"}," ",err," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{type:"link",onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["s" /* createDownloadableFile */])("sample.csv",parser.SAMPLE);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"upload.download_sample",defaultMessage:"Download sample CSV file"})," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_download_small___default.a})));};var renderPostUpload=function renderPostUpload(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_file_input__["FileDetails"],{error:file.error,errorMessage:file.errorMessage,file:file,key:file.name,cancelUploadButtonLabel:"Cancel, "+file.name,onClickCancel:function onClickCancel(){fileReader.abort();resetState();},removeFileButtonLabel:"Delete, "+file.name,onClickRemoveFile:function onClickRemoveFile(){resetState();},uploadPercentage:percentage,uploadComplete:complete,uploadCompleteLabel:"Upload complete"}),err&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_alert___default.a,{type:"error",size:"medium"}," ",err," "),output&&!err&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{color:"secondary"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"upload.file_length",values:{length:output.length},defaultMessage:"The uploaded file contains {length} rows."})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"upload.confirm_overwrite",defaultMessage:"Press confirm to overwrite the configuration."})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{type:"primary",onClick:onClickConfirm},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"modal.confirm",defaultMessage:"Confirm"}),"  "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{type:"secondary",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})))));};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal___default.a,{title:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["a" /* FormattedMessage */],{id:"upload.title",defaultMessage:"Upload configuration through CSV"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},renderFileInput());};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_intl__["d" /* injectIntl */])(UploadFileModal));

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex != -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            var words = [];
	            var nBytes = 0;
	            for (var i = 0; i < base64StrLength; i++) {
	                if (i % 4) {
	                    var bits1 = map.indexOf(base64Str.charAt(i - 1)) << ((i % 4) * 2);
	                    var bits2 = map.indexOf(base64Str.charAt(i)) >>> (6 - (i % 4) * 2);
	                    var bitsCombined = bits1 | bits2;
	                    words[nBytes >>> 2] |= (bitsCombined) << (24 - (nBytes % 4) * 8);
	                    nBytes++;
	                }
	            }

	            return WordArray.create(words, nBytes);
	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(295), __webpack_require__(296));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                var block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SafeAnchor__ = __webpack_require__(307);






var defaultProps = {
  variant: 'primary',
  active: false,
  disabled: false,
  type: 'button'
};
var Button = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      variant = _ref.variant,
      size = _ref.size,
      active = _ref.active,
      className = _ref.className,
      block = _ref.block,
      type = _ref.type,
      as = _ref.as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "variant", "size", "active", "className", "block", "type", "as"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'btn');
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, prefix, active && 'active', prefix + "-" + variant, block && prefix + "-block", size && prefix + "-" + size);

  if (props.href) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      as: as,
      ref: ref,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes, props.disabled && 'disabled')
    }));
  }

  if (ref) {
    props.ref = ref;
  }

  if (!as) {
    props.type = type;
  }

  var Component = as || 'button';
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    className: classes
  }));
});
Button.displayName = 'Button';
Button.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZancaSortDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_ZancaSortDeviceOverviewReducer__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var ZancaSortDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var ZancaSortDeviceOverviewContextProvider=function ZancaSortDeviceOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},zancaSortDeviceInformation:{},macAddressArray:[],loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_ZancaSortDeviceOverviewReducer__["a" /* ZancaSortDeviceOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ZancaSortDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (ZancaSortDeviceOverviewContextProvider);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsmlDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_AsmlDeviceOverviewReducer__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AsmlDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var AsmlDeviceOverviewContextProvider=function AsmlDeviceOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},inductCameraDeviceInformation:{},printerDeviceInformation:{},verificationCameraDeviceInformation:{},macAddressArray:[],loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_AsmlDeviceOverviewReducer__["a" /* AsmlDeviceOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AsmlDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (AsmlDeviceOverviewContextProvider);

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(578),
    baseKeys = __webpack_require__(586),
    isArrayLike = __webpack_require__(125);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(88);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 154 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCloseData: "data:image/svg+xml,%3csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1.76 1.76l8.48 8.48M10.24 1.76l-8.48 8.48'/%3e%3c/g%3e%3c/svg%3e",
  iconCloseWidth: 12,
  iconCloseHeight: 12
};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(683);

var iterableToArray = __webpack_require__(684);

var unsupportedIterableToArray = __webpack_require__(342);

var nonIterableSpread = __webpack_require__(685);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Generate a CSS value for an encoded svg icon. This essentially just sets the
 * color and wraps the data in a "url()".
 *
 * @example
 * getIconCss(data, "#000")
 */
var getIconCss = function getIconCss(data, color) {
  return data && color ? "url(\"".concat(data.replace(new RegExp("currentColor", "g"), // NOTE: Encode any "#" chars in the color value to future proof against
  // this change: https://www.chromestatus.com/feature/5656049583390720
  color.replace(new RegExp("#", "g"), "%23")), "\")") : "none";
};

var _default = getIconCss;
exports["default"] = _default;

/***/ }),
/* 157 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    tableActionBarOverlayBackgroundColor: tokens.themeForegroundPrimaryFocus,
    tableForegroundColor: tokens.themeForegroundPrimaryDefault,
    tableBackgroundColorPrimary: tokens.themeBackgroundPrimaryDefault,
    tableBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
    tableBackgroundColorHover: tokens.themeBackgroundSecondaryDefault,
    tableBackgroundColorPressed: tokens.themeBackgroundTertiaryDefault,
    tableBackgroundColorHighlight: tokens.themeBackgroundSecondaryDefault,
    tableBackgroundColorStripe: tokens.themeBackgroundSecondaryDefault,
    tableFontSizeNestedHeader: 14,
    tableFontSizeSectionHeader: 14,
    tableFontSizeBody: 12,
    tableFontWeightHeader: 600,
    tableFontWeightBody: 400,
    tableBorderWidthHeader: 2,
    tableBorderWidthBody: 1,
    tableBorderRadius: 0,
    tableBorderColor: tokens.themeBorderSecondaryDefault,
    tableActionBarOverlayBackgroundColorHover: tokens.themeForegroundAccentHover,
    tableActionBarOverlayBackgroundColorPressed: tokens.themeForegroundAccentPressed,
    tableActionBarOverlayForegroundColor: tokens.themeForegroundInvertedDefault,
    tableSortIndicatorColorDefault: tokens.themeForegroundSecondaryDefault,
    tableSortIndicatorColorHover: tokens.themeForegroundAccentHover,
    tableSortIndicatorColorFocus: tokens.themeForegroundAccentHover,
    tableSortIndicatorColorPressed: tokens.themeForegroundAccentPressed,
    tableSortIndicatorColorSorted: tokens.themeForegroundPrimaryDefault,
    tableSortIndicatorColorPreselected: tokens.themeBorderAccentPreselected,
    tableSortIndicatorWidth: 24,
    tableSortIndicatorHeight: 24,
    tableSortIndicatorSpacing: 4,
    tableSpacingHorizontal: 16,
    tableSpacingVerticalSmall: 8,
    tableSpacingVerticalMedium: 16,
    tableMotionDuration: "100ms",
    tableMotionFunction: "ease",
    tableOverflowShadowOffsetX: 0,
    tableOverflowShadowOffsetY: 8,
    tableOverflowShadowBlur: 8,
    tableOverflowShadowSpread: -4,
    tableOverflowShadowColor: "rgba(11, 12, 12, 0.16)",
    tableOverflowStickyRowShadowOffsetX: 0,
    tableOverflowStickyRowShadowOffsetY: 8,
    tableOverflowStickyRowShadowBlur: 8,
    tableOverflowStickyRowShadowSpread: 0,
    tableOverflowStickyRowShadowColor: "rgba(11, 12, 12, 0.16)",
    tableOverflowStickyColumnShadowOffsetY: 0,
    tableOverflowStickyColumnShadowOffsetX: 8,
    tableOverflowStickyColumnShadowBlur: 8,
    tableOverflowStickyColumnShadowSpread: 0,
    tableOverflowStickyColumnShadowColor: "rgba(11, 12, 12, 0.16)"
  }
};

/***/ }),
/* 158 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronRightSmallData: "data:image/svg+xml,%3csvg width='6' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 9l4-4-4-4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronRightSmallRtlSvg: "data:image/svg+xml,%3csvg width='6' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5 1L1 5l4 4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronRightSmallWidth: 6,
  iconChevronRightSmallHeight: 10
};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(716);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, Buffer, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}

var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > 65536) throw new Error('requested too many random bytes')
  // in case browserify  isn't using the Uint8Array version
  var rawBytes = new global.Uint8Array(size)

  // This will not work in older browsers.
  // See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
  if (size > 0) {  // getRandomValues fails on IE if size == 0
    crypto.getRandomValues(rawBytes)
  }
  // phantomjs doesn't like a buffer being passed here
  var bytes = new Buffer(rawBytes.buffer)

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65), __webpack_require__(19).Buffer, __webpack_require__(55)))

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(19)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__(819).Reporter;
base.DecoderBuffer = __webpack_require__(391).DecoderBuffer;
base.EncoderBuffer = __webpack_require__(391).EncoderBuffer;
base.Node = __webpack_require__(820);


/***/ }),
/* 166 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(857);

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _emotion = __webpack_require__(11);

var _functional = __webpack_require__(98);

var cxMemoizedCurried = (0, _functional.memoizeCurry)(_emotion.cx, 1);
/**
 * A memoized version of cx. Only supports two classes.
 */

var cxMemoized = function cxMemoized(a, b) {
  return cxMemoizedCurried(a)(b);
};

var _default = cxMemoized;
exports["default"] = _default;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "OptionListGroup", {
  enumerable: true,
  get: function get() {
    return _optionListGroup["default"];
  }
});
Object.defineProperty(exports, "OptionListItem", {
  enumerable: true,
  get: function get() {
    return _optionListItem["default"];
  }
});
exports["default"] = void 0;

var _optionList = _interopRequireDefault(__webpack_require__(875));

var _optionListItem = _interopRequireDefault(__webpack_require__(877));

var _optionListGroup = _interopRequireDefault(__webpack_require__(406));

var _default = _optionList["default"];
exports["default"] = _default;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _focusTrap = _interopRequireDefault(__webpack_require__(882));

var _default = _focusTrap["default"];
exports["default"] = _default;

/***/ }),
/* 171 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    inputSpacingVertical: 4,
    inputSpacingInsetVerticalDefault: 0,
    inputSpacingInsetVerticalAuto: 12,
    inputSpacingInsetHorizontal: 12,
    inputHeightSmall: 32,
    inputHeightMedium: 40,
    inputHeightLarge: 48,
    inputHeightXlarge: 60,
    inputLineHeightDefault: "20px",
    inputLineHeightAuto: "24px",
    inputForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    inputForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    inputPlaceholderColorDefault: tokens.themeForegroundSecondaryDefault,
    inputPlaceholderColorDisabled: tokens.themeForegroundPrimaryDisabled,
    inputBorderWidth: 1,
    inputBorderRadius: 4,
    inputBorderColorDefault: tokens.themeBorderPrimaryDefault,
    inputBorderColorDisabled: tokens.themeBorderPrimaryDisabled,
    inputFocusRingBorderWidth: 1,
    inputFocusRingBorderRadius: 4,
    inputBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
    inputBackgroundColorDisabled: tokens.themeBackgroundPrimaryDisabled,
    inputFontSizeDefault: 16,
    inputFontSizeSmall: 14,
    inputEndcapBorderWidth: 1,
    inputEndcapBorderRadius: 4,
    inputEndcapBackgroundColor: tokens.themeBackgroundTertiaryDefault,
    inputLabelFontSizeDefault: 16,
    inputLabelFontSizeFloated: 14,
    inputLabelColorDefault: tokens.themeForegroundPrimaryDefault,
    inputLabelColorFocus: tokens.themeForegroundPrimaryFocus,
    inputLabelColorDisabled: tokens.themeForegroundPrimaryDisabled,
    inputLabelFloatDistanceXlarge: 12,
    inputLabelFloatDistanceAuto: 4,
    inputLabelMotionDuration: "150ms",
    inputLabelMotionFunction: "ease",
    inputSupportTextFontSize: 14,
    inputSupportTextColor: tokens.themeForegroundSecondaryDefault,
    inputSupportTextInset: 2
  }
};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(209),
    getRawTag = __webpack_require__(908),
    objectToString = __webpack_require__(909);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toDateString = exports.parseDateString = exports.isWithinRange = exports.isSameMonth = exports.isSameDay = exports.isBefore = exports.getYear = exports.getMonth = exports.getDay = exports.differenceInMonthsFromRange = exports.differenceInCalendarMonths = void 0;

var _padStart = _interopRequireDefault(__webpack_require__(217));

/**
 * This module contains utilities that work with date strings in the format
 * "YYYY-MM-DD". These functions are much faster than the full-featured
 * functions from the date-fns library, so use them when possible.
 */
var isoDateFormat = "yyyy-MM-dd HH:mm";
/**
 * Extract the value from a date string given a full format string and the
 * tokens within the format string that we want to parse. If an exact value
 * isn't found then undefined is returned. Examples:
 * getValueAtFormatTokens("2012-01-01", "yyyy-MM-dd", "yyyy") -> "2012".
 * getValueAtFormatTokens("haha-01-01", "yyyy-MM-dd", "yyyy") -> undefined.
 * getValueAtFormatTokens("201 -01-01", "yyyy-MM-dd", "yyyy") -> undefined.
 * getValueAtFormatTokens("201", "yyyy-MM-dd", "yyyy") -> undefined.
 */

var getValueAtFormatTokens = function getValueAtFormatTokens(dateString, formatString, formatSubstring) {
  var firstIndex = formatString.indexOf(formatSubstring);
  var lastIndex = firstIndex + formatSubstring.length;
  var value = dateString.slice(firstIndex, lastIndex).replace(/[^0-9]/g, "");
  return value.length === lastIndex - firstIndex ? parseInt(value) : undefined;
};
/**
 * Convert a date-only string (e.g. "11/01/2012") into a date object given a
 * particular format (e.g. MM/DD/YYYY). If the date string doesn't match the
 * format or the date is invalid (e.g. 40/40/2012) then `undefined` is returned.
 * This should be used when parsing user input because `date-fns/parseISO` will
 * accept invalid input like "doh-01-31" and return a random/fallback date.
 */


var parseDateString = function parseDateString() {
  var dateString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isoDateFormat;
  var year = getValueAtFormatTokens(dateString, format, "yyyy");
  var month = getValueAtFormatTokens(dateString, format, "MM") - 1;
  var day = getValueAtFormatTokens(dateString, format, "dd");
  var dateObject = new Date(year, month, day); // Invalid dates are tricky to detect. Here we're looking to see if the date
  // can't be coerced to a number (this is what happens if you pass a non-number
  // into the Date constructor) or if the year, month, or day numbers that we
  // get back from the date don't match what we put it (this is what happens if
  // you pass something like month "40" into the Date constructor).

  return isNaN(dateObject) || dateObject.getFullYear() !== year || dateObject.getMonth() !== month || dateObject.getDate() !== day ? undefined : dateObject;
};
/**
 * Convert a date object into a date string (e.g. "2012-11-01").
 */


exports.parseDateString = parseDateString;

var toDateString = function toDateString(dateObject) {
  return "".concat((0, _padStart["default"])(dateObject.getFullYear(), 4, "0"), "-").concat((0, _padStart["default"])(dateObject.getMonth() + 1, 2, "0"), "-").concat((0, _padStart["default"])(dateObject.getDate(), 2, "0"));
};
/**
 * Determines if two dates in the format "YYYY-MM-DD" fall in the same month.
 * Faster than date-fns when dealing with string dates.
 */


exports.toDateString = toDateString;

var isSameMonth = function isSameMonth(a, b) {
  return a.slice(0, 7) === b.slice(0, 7);
};
/**
 * Determines if two dates in the format "YYYY-MM-DD HH:mm" fall in the same day.
 * Faster than date-fns when dealing with string dates.
 */


exports.isSameMonth = isSameMonth;

var isSameDay = function isSameDay(a, b) {
  return a.slice(0, 10) === b.slice(0, 10);
};
/**
 * Returns the day portion of a date in the format YYYY-MM-DD. Faster than
 * date-fns when dealing with string dates.
 */


exports.isSameDay = isSameDay;

var getDay = function getDay(date) {
  return parseInt(date.slice(8, 10));
};
/**
 * Returns the month portion of a date in the format YYYY-MM-DD. Faster than
 * than date-fns when dealing with string dates.
 */


exports.getDay = getDay;

var getMonth = function getMonth(date) {
  return parseInt(date.slice(5, 7));
};
/**
 * Returns the year portion of a date in the format YYYY-MM-DD. Faster than
 * date-fns when dealing with string dates.
 */


exports.getMonth = getMonth;

var getYear = function getYear(date) {
  return parseInt(date.slice(0, 4));
};
/**
 * Returns a unitless number that can be used to compare one date with another
 * chronologically. This in abstract way of doing this, but it's much faster than
 * actually parsing the dates and comparing them that way.
 */


exports.getYear = getYear;

var getComparable = function getComparable(date) {
  return getYear(date) * 10000 + getMonth(date) * 100 + getDay(date);
};
/**
 * Returns true if a date falls in the range identified by a start and an end
 * date. Faster than date-fns when dealing with string dates.
 */


var isWithinRange = function isWithinRange(date, start, end) {
  var startComparable = getComparable(start);
  var endComparable = getComparable(end);
  var dateComparable = getComparable(date);
  return dateComparable >= startComparable && dateComparable <= endComparable;
};
/**
 * Returns true if a comes before b. Faster than date-fns when dealing with
 * string dates.
 */


exports.isWithinRange = isWithinRange;

var isBefore = function isBefore(a, b) {
  return getComparable(a) < getComparable(b);
};
/**
 * Returns the number of calendar months between two date strings. Faster than
 * date-fns when dealing with string dates.
 */


exports.isBefore = isBefore;

var differenceInCalendarMonths = function differenceInCalendarMonths(a, b) {
  return (getYear(a) - getYear(b)) * 12 + getMonth(a) - getMonth(b);
};
/**
 * Like differenceInCalendarMonths, but the difference is calculated by
 * comparing a single date to a range. If the date is anywhere in the range the
 * difference is 0, otherwise the difference is between the single date and the
 * clostest date in the range.
 */


exports.differenceInCalendarMonths = differenceInCalendarMonths;

var differenceInMonthsFromRange = function differenceInMonthsFromRange(date, start, end) {
  var differenceStart = differenceInCalendarMonths(date, start);
  var differenceEnd = differenceInCalendarMonths(date, end);
  return differenceStart < 0 ? differenceStart : differenceEnd > 0 ? differenceEnd : 0;
};

exports.differenceInMonthsFromRange = differenceInMonthsFromRange;

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogStoreContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_LogStoreReducer__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_LogStoreAction__ = __webpack_require__(465);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/**
 * LogStore represents data store for real time logs received for any device type, represented as a Context.
 * rawLogs        : Stores a list of received logs
 * filteredLogs   : Stores a list of filtered logs
 * maxMessageCount: Maximum logs that can be stored
 * filterQuery    : String to filter logs
 * deviceNameQuery: String representing device name to filter logs
 **/var LogStoreContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var LogStoreContextProvider=function LogStoreContextProvider(props){var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducers_LogStoreReducer__["a" /* LogStoreReducer */],__WEBPACK_IMPORTED_MODULE_1__reducers_LogStoreReducer__["b" /* initialState */]),_useReducer2=_slicedToArray(_useReducer,2),logData=_useReducer2[0],dispatchLog=_useReducer2[1];var filterLogs=function filterLogs(){dispatchLog({type:__WEBPACK_IMPORTED_MODULE_5__action_LogStoreAction__["a" /* LogStoreAction */].FILTER_LOGS});};var setMaxMessageCount=function setMaxMessageCount(count){dispatchLog({type:__WEBPACK_IMPORTED_MODULE_5__action_LogStoreAction__["a" /* LogStoreAction */].SET_MAX_MSG_COUNT,data:{maxMessageCount:count}});};var addLog=function addLog(event){dispatchLog({type:__WEBPACK_IMPORTED_MODULE_5__action_LogStoreAction__["a" /* LogStoreAction */].ADD_LOG,data:{event:event}});rollupLogs();};var rollupLogs=function rollupLogs(){dispatchLog({type:__WEBPACK_IMPORTED_MODULE_5__action_LogStoreAction__["a" /* LogStoreAction */].ROLLUP_LOG});};var clearLogs=function clearLogs(){dispatchLog({type:__WEBPACK_IMPORTED_MODULE_5__action_LogStoreAction__["a" /* LogStoreAction */].CLEAR_LOGS});};var clearFiltering=function clearFiltering(){dispatchLog({type:__WEBPACK_IMPORTED_MODULE_5__action_LogStoreAction__["a" /* LogStoreAction */].CLEAR_FILTERING});};var resetLogStore=function resetLogStore(){clearLogs();clearFiltering();};var displayLogs=function displayLogs(){return logData.rawLogs.map(function(log){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default.a,null,log));});};var value={logData:logData,filterLogs:filterLogs,setMaxMessageCount:setMaxMessageCount,addLog:addLog,clearLogs:clearLogs,displayLogs:displayLogs,clearFiltering:clearFiltering,resetLogStore:resetLogStore};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LogStoreContext.Provider,{value:value},props.children);};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(LogStoreContextProvider));

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return processFlexColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createColumnLabelMapping; });
/* unused harmony export getUnifiedColumnLabelSet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDisplayableColumnLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isAisleMergedOV; });
/* unused harmony export hasFlexColumnsForAisle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getExhaustiveLabelSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getBranchIndexForAssetMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getSortedAssetByAisle; });
/* unused harmony export getColumnSensorStateValues */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return formatAisleLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getMqttTopicForLidarTester; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getLidarTesterActivationRequest; });
/* unused harmony export isOVColumnLabel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BRANCH_STATUS_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LEAF_STATUS_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getConnectivityBadgeStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getStatusBadgeStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isFlexColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isUnifiedOVColumn; });
/* unused harmony export isRegularColumn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return shouldUseWideWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calculateSensorStatesByType; });
/* unused harmony export calculateMergedOVSensorStates */
/* unused harmony export calculateFlexSensorStates */
/* unused harmony export calculateRegularSensorStates */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return determineMergeDirection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Validations__ = __webpack_require__(15);
var _BRANCH_STATUS_CONFIG,_LEAF_STATUS_CONFIG;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// Helper function to get numberOfLidarSensor from flexible cart recipe
var getNumberOfFlexColumnSensor=function getNumberOfFlexColumnSensor(cartType,cartRecipesMap){var cartRecipe=cartType&&cartRecipesMap&&cartRecipesMap.get(cartType);return cartRecipe&&cartRecipe.numberOfLidarSensors||__WEBPACK_IMPORTED_MODULE_1__Constants__["_12" /* DEFAULT_FLEX_COLUMN_NUMBER_OF_SENSOR */];// Default to 3 if not found
};// Helper function to process flexible cart columns in groups based on cart recipe
//For Example for the below config
// {
//     "columnAddress": "1.1",
//     "cartType": "WANZL_EIGHT_BIN_ZERO_OV_THREE_LIDAR",
//     "columnLabel": "A-1.A",
//     "offset": 15,
//     "offsetUnit": "CENTIMETERS"
// },
// {
//     "columnAddress": "1.2",
//     "cartType": "WANZL_EIGHT_BIN_ZERO_OV_THREE_LIDAR",
//     "columnLabel": "",
//     "offset": 15,
//     "offsetUnit": "CENTIMETERS"
// },
// {
//     "columnAddress": "1.3",
//     "cartType": "WANZL_EIGHT_BIN_ZERO_OV_THREE_LIDAR",
//     "columnLabel": "A-1.B",
//     "offset": 15,
//     "offsetUnit": "CENTIMETERS"
// },
// combineLabel is AB for above config
var processFlexColumns=function processFlexColumns(flexColumns,cartRecipesMap){var results=[];if(flexColumns.length===0)return results;flexColumns.sort(function(a,b){return parseFloat(a.columnAddress)-parseFloat(b.columnAddress);});var flexColumnSensor=getNumberOfFlexColumnSensor(flexColumns[0].cartType,cartRecipesMap);var _loop=function _loop(i){var group=flexColumns.slice(i,i+flexColumnSensor);var labels=[];group.forEach(function(column){var label=getDisplayableColumnLabel(column.columnLabel,column.rowLabels,column.cartType);if(label){labels.push(label);}});if(labels.length>0){var combinedLabel=[].concat(_toConsumableArray(new Set(labels.filter(function(l){return l!=='';})))).sort().join('');if(combinedLabel){results.push({combinedLabel:combinedLabel,group:group});}}};for(var i=0;i<flexColumns.length;i+=flexColumnSensor){_loop(i);}return results;};/**
 * Creates a mapping between original column labels and unified column labels.
 * This function identifies related column labels (e.g., "YZ", "Y", "Z") and maps them to a unified label.
 * 
 * @param {Object} device - The lidar controller device object
 * @returns {Object} An object containing the label mapping and component mapping
 */var createColumnLabelMapping=function createColumnLabelMapping(device){var labelMapping={};var componentMapping={};var twoTierLabels=[];var oneTierLabels=[];// First pass: identify two-tier and one-tier column labels
device.displayableAssetMappings.forEach(function(assetMapping){if(!assetMapping.columns)return;assetMapping.columns.forEach(function(column){if(column.rowLabels&&column.rowLabels.length>1){// Two-tier column (e.g., "YZ")
var label=column.rowLabels.map(function(rowLabel){return rowLabel[rowLabel.length-1];}).join('');twoTierLabels.push(label);// Initialize component mapping
if(!componentMapping[label]){componentMapping[label]=column.rowLabels.map(function(rowLabel){return rowLabel[rowLabel.length-1];});}}else if(column.rowLabels&&column.rowLabels.length===1){// One-tier OV column (e.g., "Y")
var _label=column.rowLabels[0][column.rowLabels[0].length-1];oneTierLabels.push(_label);}else{// Non-OV column (e.g., "A")
var _label2=column.columnLabel[column.columnLabel.length-1];oneTierLabels.push(_label2);}});});// Second pass: create mapping from original labels to unified labels
// Map two-tier labels and their components first
twoTierLabels.forEach(function(twoTierLabel){// Map the two-tier label to itself
labelMapping[twoTierLabel]=twoTierLabel;// Map each component of the two-tier label to the two-tier label
var components=componentMapping[twoTierLabel];components.forEach(function(component){labelMapping[component]=twoTierLabel;});});// Map remaining one-tier labels to themselves (only if not already mapped)
oneTierLabels.forEach(function(label){if(!labelMapping[label]){labelMapping[label]=label;}});return{labelMapping:labelMapping,componentMapping:componentMapping};};/**
 * Generates a unified set of column labels from the device data.
 * Identifies related column labels (e.g., "Y", "Z", "YZ") and unifies them to single labels (e.g., "YZ").
 * Removes slash notation for cleaner UI display.
 * 
 * @param {Object} device - The lidar controller device object
 * @returns {Array} A sorted array of clean unified column labels
 */var getUnifiedColumnLabelSet=function getUnifiedColumnLabelSet(device){var _createColumnLabelMap=createColumnLabelMapping(device),labelMapping=_createColumnLabelMap.labelMapping;var unifiedLabels=new Set();// Collect all unique unified labels (no slash notation)
Object.values(labelMapping).forEach(function(unifiedLabel){unifiedLabels.add(unifiedLabel);});return Array.from(unifiedLabels).sort();};// The function takes in a column Label and rowLabel and returns the Label to be displayed on UI
// example for OV column containing T and U bins, we need to show "TU" on UI and so on
// The column here refers to the column in the racks at the delivery station, where the
// packages are stowed. for example column B in aisle A1: (it will have 4 bins: A1-1B, A1-2B, A1-3B, A1-4B)
var getDisplayableColumnLabel=function getDisplayableColumnLabel(columnLabel,rowLabels,cartType){// For flexible cart recipes, combine the column labels and ignore row labels
// e.g., "A-1.A" and "A-1.B" should be combined to "AB" for flex rack
if(rowLabels&&!__WEBPACK_IMPORTED_MODULE_2__Validations__["s" /* WW_FLEX_CART_RECIPES */].includes(cartType)){var label="";rowLabels.forEach(function(rowLabel){label=label+rowLabel[rowLabel.length-1];});return label;}return columnLabel?columnLabel[columnLabel.length-1]:'';};/**
 * Analyzes device to determine if column groups should be unified or separate
 * based on flex consistency across all aisles
 */var analyzeFlexConsistency=function analyzeFlexConsistency(device){var columnGroups={};var aisleFlexGroups={};// Track flex groupings per aisle
// Collect all columns and track flex groupings per aisle
device.displayableAssetMappings.forEach(function(assetMapping){var aisleLabel=assetMapping.aisleLabel;aisleFlexGroups[aisleLabel]=[];if(assetMapping.columns){// Process flex columns to identify groupings in this aisle
var flexColumns=assetMapping.columns.filter(function(col){return __WEBPACK_IMPORTED_MODULE_2__Validations__["s" /* WW_FLEX_CART_RECIPES */].includes(col.cartType);});if(flexColumns.length>0){var flexResults=processFlexColumns(flexColumns,new Map());flexResults.forEach(function(result){aisleFlexGroups[aisleLabel].push(result.combinedLabel);});}assetMapping.columns.forEach(function(column){var label=getDisplayableColumnLabel(column.columnLabel,column.rowLabels,column.cartType);if(label){if(!columnGroups[label]){columnGroups[label]=[];}columnGroups[label].push(Object.assign({},column,{aisleLabel:assetMapping.aisleLabel,isFlex:__WEBPACK_IMPORTED_MODULE_2__Validations__["s" /* WW_FLEX_CART_RECIPES */].includes(column.cartType)}));}});}});var consistencyMap={};// Check each potential unified group considering flex grouping context
Object.keys(columnGroups).forEach(function(label){var columns=columnGroups[label];var allFlex=columns.every(function(col){return col.isFlex;});var allNonFlex=columns.every(function(col){return!col.isFlex;});if(allFlex){// Check if this flex column has consistent grouping across aisles
var flexGroupings=new Set();columns.forEach(function(col){var aisleGroups=aisleFlexGroups[col.aisleLabel]||[];var groupContainingThisLabel=aisleGroups.find(function(group){return group.includes(label);});if(groupContainingThisLabel){flexGroupings.add(groupContainingThisLabel);}});// If flex column appears in different groupings, mark as mixed
if(flexGroupings.size>1){consistencyMap[label]='mixed';}else{consistencyMap[label]='flex';}}else if(allNonFlex){consistencyMap[label]='non-flex';}else{consistencyMap[label]='mixed';}});return{columnGroups:columnGroups,consistencyMap:consistencyMap};};/**
 * Checks if an OV column was dynamically merged in a specific aisle
 * (as opposed to being pre-configured as combined)
 * 
 * @param {string} label - Column label to check (e.g., "TU", "WX")
 * @param {string} aisleLabel - Formatted aisle label (e.g., "C-18")
 * @param {Object} device - Device configuration
 * @returns {boolean} True if this aisle had individual components that got merged
 */var isAisleMergedOV=function isAisleMergedOV(label,aisleLabel,device){// Only check OV columns with multiple characters
if(!isOVColumnLabel(label)||label.length<=1)return false;// Find this specific aisle's configuration
var aisle=device.displayableAssetMappings.find(function(mapping){return formatAisleLabel(mapping.aisleLabel)===aisleLabel;});if(!aisle||!aisle.columns)return false;// Get individual components (e.g., ["T", "U"] from "TU")
var components=label.split('');// Check if this aisle originally had individual components
var hasIndividualComponents=aisle.columns.some(function(column){var columnLabel=getDisplayableColumnLabel(column.columnLabel,column.rowLabels,column.cartType);return components.includes(columnLabel)&&column.rowLabels&&column.rowLabels.length===1;// Individual, not pre-combined
});return hasIndividualComponents;};/**
 * Check if the aisle has any column with flexible rack or not
 * @param {Object} device 
 * @param {String} aisleLabel 
 * @param {List} columnLabels 
 * @returns {boolean} True if aisle has any column with flexible rack.
 */var hasFlexColumnsForAisle=function hasFlexColumnsForAisle(device,aisleLabel,columnLabels){var assetMapping=device.displayableAssetMappings.find(function(mapping){return formatAisleLabel(mapping.aisleLabel)===aisleLabel;});if(!assetMapping||!assetMapping.columns)return false;// Check if ALL specified column labels have flex cart types in this aisle
return columnLabels.every(function(columnLabel){return assetMapping.columns.some(function(column){var label=getDisplayableColumnLabel(column.columnLabel,column.rowLabels,column.cartType);return label===columnLabel&&__WEBPACK_IMPORTED_MODULE_2__Validations__["s" /* WW_FLEX_CART_RECIPES */].includes(column.cartType);});});};// The function takes in the lidar controller device and returns an exhaustive list of all the
// columns present in any of the aisles served by this controller.
// Uses priority-based processing: Check flex consistency first, then process accordingly
var getExhaustiveLabelSet=function getExhaustiveLabelSet(device,cartRecipesMap){var labelSet=new Set();var _analyzeFlexConsisten=analyzeFlexConsistency(device),consistencyMap=_analyzeFlexConsisten.consistencyMap;// Separate flex and non-flex columns
var allFlexColumns=[];var allNonFlexColumns=[];device.displayableAssetMappings.forEach(function(assetMapping){if(assetMapping.columns){assetMapping.columns.forEach(function(column){if(__WEBPACK_IMPORTED_MODULE_2__Validations__["s" /* WW_FLEX_CART_RECIPES */].includes(column.cartType)){allFlexColumns.push(column);}else{allNonFlexColumns.push(column);}});}});// FLEX COLUMN PROCESSING FOR MIXED CONFIGURATIONS:
// Process flex columns - for mixed configurations add individual labels
// Example: If "JK" is mixed (some aisles have J,K separate, others have JK unified),
// add both "J" and "K" to labelSet for consistent display across all aisles
var flexComponentLabels=new Set();if(allFlexColumns.length>0){var flexResults=processFlexColumns(allFlexColumns,cartRecipesMap);flexResults.forEach(function(_ref){var combinedLabel=_ref.combinedLabel,group=_ref.group;// For mixed configurations (2-char combined labels), add individual labels
if(combinedLabel.length===2){var leftLabel=combinedLabel[0];// e.g., "J" from "JK"
var rightLabel=combinedLabel[1];// e.g., "K" from "JK"
// Check if either component has mixed consistency across aisles
if(consistencyMap[leftLabel]==="mixed"||consistencyMap[rightLabel]==="mixed"){labelSet.add(leftLabel);labelSet.add(rightLabel);flexComponentLabels.add(leftLabel);flexComponentLabels.add(rightLabel);}else{// Consistent flex - use combined label
labelSet.add(combinedLabel);}}else{// Non-2-char combined label - use as is
labelSet.add(combinedLabel);}group.forEach(function(column){var label=getDisplayableColumnLabel(column.columnLabel,column.rowLabels,column.cartType);if(label&&label.trim()){flexComponentLabels.add(label);}});});}// Process non-flex columns through unification, excluding flex components
if(allNonFlexColumns.length>0){var deviceForUnification={displayableAssetMappings:[{columns:allNonFlexColumns}]};var unifiedLabels=getUnifiedColumnLabelSet(deviceForUnification);unifiedLabels.forEach(function(label){// Only add if it's not already covered by a flex column
if(!flexComponentLabels.has(label)){labelSet.add(label);}});}return Array.from(labelSet).filter(function(label){return label&&label.trim();}).sort();};// Returns the hardware branch index for an aisle from its columnAddress prefix.
// e.g. columnAddress "2.1" -> returns 2. Returns null if unavailable.
// This is the branch the device's provisioning events (parentNodeIndex = branchId) refer to.
// For FORWARD controllers: branch index == display position (index + 1)
// For REVERSE controllers: branch index != display position
var getBranchIndexForAssetMapping=function getBranchIndexForAssetMapping(assetMapping){var col=(assetMapping.columns||[]).find(function(c){return c&&c.columnAddress;});if(!col)return null;var prefix=parseInt(String(col.columnAddress).split('.')[0],10);return Number.isNaN(prefix)?null:prefix;};// The function takes in the lidar controller device and return the list of
// column mappings for each aisle, sorted in ascending order i.e. A1 comes first, then A2 and so on
var getSortedAssetByAisle=function getSortedAssetByAisle(device){return[].concat(_toConsumableArray(device.displayableAssetMappings.sort(function(a,b){return a.aisleLabel.localeCompare(b.aisleLabel,undefined,{numeric:true,sensitivity:'base'});})));};// The function takes in the sensor state values for a particular column
// and returns an array, each entry representing a single Lidar sensor.
var getColumnSensorStateValues=function getColumnSensorStateValues(columnSensorStates,isSensorLevelConfigEnabled){var values=[];Object.keys(columnSensorStates).forEach(function(key){values.push(Object.assign({},columnSensorStates[key][__WEBPACK_IMPORTED_MODULE_1__Constants__["_180" /* SENSOR_INDEX_ZERO */]]));if(!isSensorLevelConfigEnabled){values.push(Object.assign({},columnSensorStates[key][__WEBPACK_IMPORTED_MODULE_1__Constants__["_179" /* SENSOR_INDEX_ONE */]]));}});return values;};// The function removes the "-" from aisle Label to maintain uniformity across regions.
var formatAisleLabel=function formatAisleLabel(aisleLabel){// Add safety check to prevent errors with undefined or null values
try{return aisleLabel.replace("-","");}catch(error){console.error("Error in formatAisleLabel:",error,"for aisleLabel:",aisleLabel);return"";// Return a safe string
}};// The function returns the mqtt topic to subscribe for listening to
// lidar events of a particular lidar controller
var getMqttTopicForLidarTester=function getMqttTopicForLidarTester(nodeId,ip){return"site/"+nodeId+"/lidarTester/"+ip;};// The function returns the Lidar Tester activation request object.
var getLidarTesterActivationRequest=function getLidarTesterActivationRequest(){return{nodeId:Object(__WEBPACK_IMPORTED_MODULE_0__Util__["X" /* getNodeId */])(),commandType:__WEBPACK_IMPORTED_MODULE_1__Constants__["_102" /* LIDAR_TESTER */],commandParams:JSON.stringify({event:__WEBPACK_IMPORTED_MODULE_1__Constants__["_102" /* LIDAR_TESTER */],period:__WEBPACK_IMPORTED_MODULE_1__Constants__["_104" /* LIDAR_TESTER_ACTIVATION_PERIOD_MINUTES */]})};};// The function classifies a column label as OV or non-OV
var isOVColumnLabel=function isOVColumnLabel(label){// To-Do: Explore a better way for this
return label>"L";};/**
 * Configuration object for branch provisioning status display with styling and messages
 * Maps status strings to their corresponding UI properties (colors, messages)
 */var BRANCH_STATUS_CONFIG=(_BRANCH_STATUS_CONFIG={},_defineProperty(_BRANCH_STATUS_CONFIG,__WEBPACK_IMPORTED_MODULE_1__Constants__["_194" /* SUCCESS_STRING */],{backgroundColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["_191" /* STATUS_COLORS */].SUCCESS.BACKGROUND,textColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["_191" /* STATUS_COLORS */].SUCCESS.TEXT,getMessage:function getMessage(detectedCount){return __WEBPACK_IMPORTED_MODULE_1__Constants__["_192" /* STATUS_MESSAGES */].BRANCH_SUCCESS.replace('{count}',detectedCount);}}),_defineProperty(_BRANCH_STATUS_CONFIG,__WEBPACK_IMPORTED_MODULE_1__Constants__["_71" /* ERROR_STRING */],{backgroundColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["_191" /* STATUS_COLORS */].ERROR.BACKGROUND,textColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["_191" /* STATUS_COLORS */].ERROR.TEXT,getMessage:function getMessage(expectedCount,detectedCount){return __WEBPACK_IMPORTED_MODULE_1__Constants__["_192" /* STATUS_MESSAGES */].BRANCH_ERROR.replace('{expected}',expectedCount).replace('{detected}',detectedCount);}}),_defineProperty(_BRANCH_STATUS_CONFIG,__WEBPACK_IMPORTED_MODULE_1__Constants__["_204" /* TIMEOUT_STRING */],{backgroundColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["_191" /* STATUS_COLORS */].WARNING.BACKGROUND,textColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["_191" /* STATUS_COLORS */].WARNING.TEXT,getMessage:function getMessage(){return __WEBPACK_IMPORTED_MODULE_1__Constants__["_192" /* STATUS_MESSAGES */].BRANCH_TIMEOUT;}}),_BRANCH_STATUS_CONFIG);/**
 * Configuration object for leaf provisioning status display with styling and messages
 * Maps status strings to their corresponding UI properties (colors, messages)
 */var LEAF_STATUS_CONFIG=(_LEAF_STATUS_CONFIG={},_defineProperty(_LEAF_STATUS_CONFIG,__WEBPACK_IMPORTED_MODULE_1__Constants__["_194" /* SUCCESS_STRING */],{backgroundColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["_191" /* STATUS_COLORS */].SUCCESS.BACKGROUND,textColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["_191" /* STATUS_COLORS */].SUCCESS.TEXT,getMessage:function getMessage(){return __WEBPACK_IMPORTED_MODULE_1__Constants__["_192" /* STATUS_MESSAGES */].LEAF_SUCCESS;}}),_defineProperty(_LEAF_STATUS_CONFIG,__WEBPACK_IMPORTED_MODULE_1__Constants__["_71" /* ERROR_STRING */],{backgroundColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["_191" /* STATUS_COLORS */].ERROR.BACKGROUND,textColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["_191" /* STATUS_COLORS */].ERROR.TEXT,getMessage:function getMessage(){return __WEBPACK_IMPORTED_MODULE_1__Constants__["_192" /* STATUS_MESSAGES */].LEAF_ERROR;}}),_defineProperty(_LEAF_STATUS_CONFIG,__WEBPACK_IMPORTED_MODULE_1__Constants__["_204" /* TIMEOUT_STRING */],{backgroundColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["_191" /* STATUS_COLORS */].WARNING.BACKGROUND,textColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["_191" /* STATUS_COLORS */].WARNING.TEXT,getMessage:function getMessage(){return __WEBPACK_IMPORTED_MODULE_1__Constants__["_192" /* STATUS_MESSAGES */].LEAF_TIMEOUT;}}),_defineProperty(_LEAF_STATUS_CONFIG,__WEBPACK_IMPORTED_MODULE_1__Constants__["_85" /* IN_PROGRESS_STRING */],{backgroundColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["_191" /* STATUS_COLORS */].INFO.BACKGROUND,textColor:__WEBPACK_IMPORTED_MODULE_1__Constants__["_191" /* STATUS_COLORS */].INFO.TEXT,getMessage:function getMessage(){return __WEBPACK_IMPORTED_MODULE_1__Constants__["_192" /* STATUS_MESSAGES */].LEAF_IN_PROGRESS;}}),_LEAF_STATUS_CONFIG);// Helper functions for device status badges
var getConnectivityBadgeStyle=function getConnectivityBadgeStyle(connectivity){var isConnected=connectivity&&connectivity.toLowerCase()===__WEBPACK_IMPORTED_MODULE_1__Constants__["_145" /* ONLINE_OK */];return{display:'inline-block',backgroundColor:isConnected?'#00A643':'#FF5963',color:'#ffffff',padding:'4px 8px',borderRadius:'4px',fontSize:'12px',fontWeight:'bold',marginLeft:'10px'};};var getStatusBadgeStyle=function getStatusBadgeStyle(status){var isActive=status&&status.toUpperCase()==='ACTIVE';return{display:'inline-block',backgroundColor:isActive?'#00A643':'#007BFF',color:'#ffffff',padding:'4px 8px',borderRadius:'4px',fontSize:'12px',fontWeight:'bold',marginLeft:'10px'};};/**
 * Determines if a column is a flex column
 * 
 * @param {string} label - Column label to check
 * @returns {boolean} True if column is flex type
 * 
 * @example
 * isFlexColumn("AB") // true (multi-char, non-OV)
 * isFlexColumn("TU") // false (multi-char, but OV)
 * isFlexColumn("A")  // false (single char)
 */var isFlexColumn=function isFlexColumn(label){return label&&label.length>1&&!isOVColumnLabel(label);};/**
 * Determines if a column is a unified OV column
 * 
 * @param {string} label - Column label to check
 * @returns {boolean} True if column is unified OV type
 * 
 * @example
 * isUnifiedOVColumn("TU") // true (multi-char OV)
 * isUnifiedOVColumn("HJ") // false (multi-char, but flex)
 * isUnifiedOVColumn("T")  // false (single char OV)
 */var isUnifiedOVColumn=function isUnifiedOVColumn(label){return label&&label.length>1&&isOVColumnLabel(label)&&!isFlexColumn(label);};/**
 * Determines if a column is a regular (single character) column
 * 
 * @param {string} label - Column label to check
 * @returns {boolean} True if column is regular type
 * 
 * @example
 * isRegularColumn("A")  // true (single char)
 * isRegularColumn("AB") // false (multi-char)
 * isRegularColumn("")   // false (empty)
 */var isRegularColumn=function isRegularColumn(label){return label&&label.length===1;};/**
 * Determines if a column should use wide width (140px vs 70px)
 * 
 * @param {string} label - Column label to check
 * @returns {boolean} True if column should be wide
 * 
 * @example
 * shouldUseWideWidth("AB") // true (multi-char)
 * shouldUseWideWidth("TU") // true (OV column)
 * shouldUseWideWidth("A")  // false (single char)
 */var shouldUseWideWidth=function shouldUseWideWidth(label){return label&&label.length>1||isOVColumnLabel(label);};/**
 * Calculates sensor states based on column type and merge state
 * Delegates to appropriate calculation function based on column characteristics
 * 
 * @param {Object} params.testerViewModel - The tester view model
 * @param {string} params.aisleLabel - Aisle label
 * @param {string} params.label - Column label
 * @param {boolean} params.isSensorLevelConfigEnabled - Sensor config flag
 * @param {boolean} params.shouldMergeRight - Whether merging right
 * @param {boolean} params.shouldMergeLeft - Whether merging left
 * @returns {Object} { sensorStates, isAnomaly }
 * 
 * @example
 * calculateSensorStatesByType({testerViewModel: viewModel, aisleLabel: "A-1", label: "TU", isSensorLevelConfigEnabled: true, 
 *                              shouldMergeRight: false, shouldMergeLeft: false})
 * Returns: { sensorStates: [...], isAnomaly: false }
 */var calculateSensorStatesByType=function calculateSensorStatesByType(_ref2){var testerViewModel=_ref2.testerViewModel,aisleLabel=_ref2.aisleLabel,label=_ref2.label,isSensorLevelConfigEnabled=_ref2.isSensorLevelConfigEnabled,shouldMergeRight=_ref2.shouldMergeRight,shouldMergeLeft=_ref2.shouldMergeLeft;// Handle unified OV columns (e.g., "TU")
if(isUnifiedOVColumn(label)){return calculateMergedOVSensorStates({testerViewModel:testerViewModel,aisleLabel:aisleLabel,label:label,isSensorLevelConfigEnabled:isSensorLevelConfigEnabled});}// Handle flex columns with visual merging
if(shouldMergeRight){return calculateFlexSensorStates({testerViewModel:testerViewModel,aisleLabel:aisleLabel,label:label,isSensorLevelConfigEnabled:isSensorLevelConfigEnabled,isLeftColumn:true// Left side of merge shows 2 sensors
});}if(shouldMergeLeft){return calculateFlexSensorStates({testerViewModel:testerViewModel,aisleLabel:aisleLabel,label:label,isSensorLevelConfigEnabled:isSensorLevelConfigEnabled,isLeftColumn:false// Right side of merge shows 1 sensor
});}// Handle flex columns without merging (e.g., "HJ" when not adjacent to other flex)
if(isFlexColumn(label)){// Check if combined data exists, otherwise look for component data
var combinedData=Object(__WEBPACK_IMPORTED_MODULE_0__Util__["f" /* chainWalk */])(function(){return testerViewModel&&testerViewModel.sensorStateMap&&testerViewModel.sensorStateMap[aisleLabel]&&testerViewModel.sensorStateMap[aisleLabel][label];},null);if(combinedData){var _sensorStates=getColumnSensorStateValues(combinedData,isSensorLevelConfigEnabled);return{sensorStates:_sensorStates,isAnomaly:false};}// For flex columns, construct 3 sensors: left from first component, middle shared, right from last component
var componentColumns=label.split('');var sensorStates=[];var hasAnyComponentData=false;// Get left sensor from first component (H)
var firstComponentData=Object(__WEBPACK_IMPORTED_MODULE_0__Util__["f" /* chainWalk */])(function(){return testerViewModel&&testerViewModel.sensorStateMap&&testerViewModel.sensorStateMap[aisleLabel]&&testerViewModel.sensorStateMap[aisleLabel][componentColumns[0]];},null);if(firstComponentData){hasAnyComponentData=true;var states=getColumnSensorStateValues(firstComponentData,isSensorLevelConfigEnabled);if(states&&states[0])sensorStates.push(states[0]);// Left sensor
if(states&&states[1])sensorStates.push(states[1]);// Middle sensor (shared)
}// Get right sensor from last component (J) - only if different from first
if(componentColumns.length>1){var lastComponentData=Object(__WEBPACK_IMPORTED_MODULE_0__Util__["f" /* chainWalk */])(function(){return testerViewModel&&testerViewModel.sensorStateMap&&testerViewModel.sensorStateMap[aisleLabel]&&testerViewModel.sensorStateMap[aisleLabel][componentColumns[componentColumns.length-1]];},null);if(lastComponentData){hasAnyComponentData=true;var _states=getColumnSensorStateValues(lastComponentData,isSensorLevelConfigEnabled);if(_states&&_states[0])sensorStates.push(_states[0]);// Right sensor
}}return{sensorStates:sensorStates.length>0?sensorStates:null,isAnomaly:!hasAnyComponentData};}// Handle regular single columns
return calculateRegularSensorStates({testerViewModel:testerViewModel,aisleLabel:aisleLabel,label:label,isSensorLevelConfigEnabled:isSensorLevelConfigEnabled});};/**
 * Calculates sensor states for merged OV columns
 * Handles both merged column data and component column fallback
 * 
 * @param {Object} params - Parameters object
 * @param {Object} params.testerViewModel - The tester view model
 * @param {string} params.aisleLabel - Aisle label
 * @param {string} params.label - Column label
 * @param {boolean} params.isSensorLevelConfigEnabled - Sensor config flag
 * @returns {Object} { sensorStates, isAnomaly }
 * 
 * @example
 * calculateMergedOVSensorStates({ testerViewModel: viewModel, aisleLabel: "A-1",  label: "TU", isSensorLevelConfigEnabled: true})
 * Returns: { sensorStates: [...], isAnomaly: false }
 */var calculateMergedOVSensorStates=function calculateMergedOVSensorStates(_ref3){var testerViewModel=_ref3.testerViewModel,aisleLabel=_ref3.aisleLabel,label=_ref3.label,isSensorLevelConfigEnabled=_ref3.isSensorLevelConfigEnabled;// Check if merged column exists
var mergedColumnExists=Object(__WEBPACK_IMPORTED_MODULE_0__Util__["f" /* chainWalk */])(function(){return testerViewModel&&testerViewModel.sensorStateMap&&testerViewModel.sensorStateMap[aisleLabel]&&testerViewModel.sensorStateMap[aisleLabel][label];},false);if(mergedColumnExists){// Use merged column data
var sensorStates=Object(__WEBPACK_IMPORTED_MODULE_0__Util__["f" /* chainWalk */])(function(){return getColumnSensorStateValues(testerViewModel.sensorStateMap[aisleLabel][label],isSensorLevelConfigEnabled);},null);return{sensorStates:sensorStates,isAnomaly:false};}// Fallback to component columns
var componentColumns=label.split('');var componentStates=[];var hasAnyComponentData=false;componentColumns.forEach(function(componentCol){var componentData=Object(__WEBPACK_IMPORTED_MODULE_0__Util__["f" /* chainWalk */])(function(){return testerViewModel&&testerViewModel.sensorStateMap&&testerViewModel.sensorStateMap[aisleLabel]&&testerViewModel.sensorStateMap[aisleLabel][componentCol];},null);if(componentData){hasAnyComponentData=true;var states=getColumnSensorStateValues(componentData,isSensorLevelConfigEnabled);if(states)componentStates.push.apply(componentStates,_toConsumableArray(states));}});return{sensorStates:componentStates.length>0?componentStates:null,isAnomaly:!hasAnyComponentData};};/**
 * Calculates sensor states for flex columns with visual merging
 * Handles left/right sensor distribution for merged display
 * 
 * @param {Object} params - Parameters object
 * @param {Object} params.testerViewModel - The tester view model
 * @param {string} params.aisleLabel - Aisle label
 * @param {string} params.label - Column label
 * @param {boolean} params.isSensorLevelConfigEnabled - Sensor config flag
 * @param {boolean} params.isLeftColumn - True for left side of merge
 * @returns {Object} { sensorStates, isAnomaly }
 * 
 * @example
 * calculateFlexSensorStates({ testerViewModel: viewModel, aisleLabel: "A-1", label: "J",  isSensorLevelConfigEnabled: true, isLeftColumn: true})
 * Returns: { sensorStates: [sensor0, sensor1], isAnomaly: false }
 */var calculateFlexSensorStates=function calculateFlexSensorStates(_ref4){var testerViewModel=_ref4.testerViewModel,aisleLabel=_ref4.aisleLabel,label=_ref4.label,isSensorLevelConfigEnabled=_ref4.isSensorLevelConfigEnabled,isLeftColumn=_ref4.isLeftColumn;var allSensors=Object(__WEBPACK_IMPORTED_MODULE_0__Util__["f" /* chainWalk */])(function(){return getColumnSensorStateValues(testerViewModel&&testerViewModel.sensorStateMap&&testerViewModel.sensorStateMap[aisleLabel]&&testerViewModel.sensorStateMap[aisleLabel][label],isSensorLevelConfigEnabled);},null)||[];var isAnomaly=Object(__WEBPACK_IMPORTED_MODULE_0__Util__["f" /* chainWalk */])(function(){return!testerViewModel||!testerViewModel.sensorStateMap||!testerViewModel.sensorStateMap[aisleLabel]||!testerViewModel.sensorStateMap[aisleLabel][label];},null);// Left column shows first 2 sensors (left + middle)
// Right column shows last 1 sensor (right)
var sensorStates=isLeftColumn?allSensors.slice(0,2):allSensors.slice(-1);return{sensorStates:sensorStates,isAnomaly:isAnomaly};};/**
 * Calculates regular sensor states for single columns
 * 
 * @param {Object} params - Parameters object
 * @param {Object} params.testerViewModel - The tester view model
 * @param {string} params.aisleLabel - Aisle label
 * @param {string} params.label - Column label
 * @param {boolean} params.isSensorLevelConfigEnabled - Sensor config flag
 * @returns {Object} { sensorStates, isAnomaly }
 */var calculateRegularSensorStates=function calculateRegularSensorStates(_ref5){var testerViewModel=_ref5.testerViewModel,aisleLabel=_ref5.aisleLabel,label=_ref5.label,isSensorLevelConfigEnabled=_ref5.isSensorLevelConfigEnabled;var sensorStates=Object(__WEBPACK_IMPORTED_MODULE_0__Util__["f" /* chainWalk */])(function(){return getColumnSensorStateValues(testerViewModel&&testerViewModel.sensorStateMap&&testerViewModel.sensorStateMap[aisleLabel]&&testerViewModel.sensorStateMap[aisleLabel][label],isSensorLevelConfigEnabled);},null);var isAnomaly=Object(__WEBPACK_IMPORTED_MODULE_0__Util__["f" /* chainWalk */])(function(){return!testerViewModel||!testerViewModel.sensorStateMap||!testerViewModel.sensorStateMap[aisleLabel]||!testerViewModel.sensorStateMap[aisleLabel][label];},null);return{sensorStates:sensorStates,isAnomaly:isAnomaly};};/**
 * Determines merge direction for a column based on adjacent columns
 * 
 * @param {Array} params.exhaustiveLabelSet - Complete set of column labels
 * @param {number} params.binIndex - Current column index
 * @param {Object} params.device - Device configuration
 * @param {string} params.aisleLabel - Aisle label
 * @returns {Object} { shouldMergeRight, shouldMergeLeft }
 * 
 * @example
 * determineMergeDirection({exhaustiveLabelSet: ["J", "K", "L"], binIndex: 0, device: deviceConfig, aisleLabel: "A-1"})
 * Returns: { shouldMergeRight: true, shouldMergeLeft: false }
 */var determineMergeDirection=function determineMergeDirection(_ref6){var exhaustiveLabelSet=_ref6.exhaustiveLabelSet,binIndex=_ref6.binIndex,device=_ref6.device,aisleLabel=_ref6.aisleLabel;var shouldMergeRight=false;var shouldMergeLeft=false;if(exhaustiveLabelSet){if(binIndex<exhaustiveLabelSet.length-1){var currentLabel=exhaustiveLabelSet[binIndex];var nextLabel=exhaustiveLabelSet[binIndex+1];shouldMergeRight=hasFlexColumnsForAisle(device,aisleLabel,[currentLabel,nextLabel]);}if(binIndex>0){var _currentLabel=exhaustiveLabelSet[binIndex];var prevLabel=exhaustiveLabelSet[binIndex-1];shouldMergeLeft=hasFlexColumnsForAisle(device,aisleLabel,[prevLabel,_currentLabel]);}}return{shouldMergeRight:shouldMergeRight,shouldMergeLeft:shouldMergeLeft};};

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(49);





var defaultProps = {
  fluid: false
};
var Container = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      fluid = _ref.fluid,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "fluid", "as", "className"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'container');
  var suffix = typeof fluid === 'string' ? "-" + fluid : '-fluid';
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, props, {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, fluid ? "" + prefix + suffix : prefix)
  }));
});
Container.displayName = 'Container';
Container.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(49);





var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
var Col = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "as"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'col');
  var spans = [];
  var classes = [];
  DEVICE_SIZES.forEach(function (brkPoint) {
    var propValue = props[brkPoint];
    delete props[brkPoint];
    var span, offset, order;

    if (propValue != null && typeof propValue === 'object') {
      var _propValue$span = propValue.span;
      span = _propValue$span === void 0 ? true : _propValue$span;
      offset = propValue.offset;
      order = propValue.order;
    } else {
      span = propValue;
    }

    var infix = brkPoint !== 'xs' ? "-" + brkPoint : '';
    if (span != null) spans.push(span === true ? "" + prefix + infix : "" + prefix + infix + "-" + span);
    if (order != null) classes.push("order" + infix + "-" + order);
    if (offset != null) classes.push("offset" + infix + "-" + offset);
  });

  if (!spans.length) {
    spans.push(prefix); // plain 'col'
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a.apply(void 0, [className].concat(spans, classes))
  }));
});
Col.displayName = 'Col';
/* harmony default export */ __webpack_exports__["a"] = (Col);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormCheck__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormFile__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormGroup__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormLabel__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormText__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ThemeProvider__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__createWithBsPrefix__ = __webpack_require__(304);













var defaultProps = {
  inline: false
};
var Form = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      inline = _ref.inline,
      className = _ref.className,
      validated = _ref.validated,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'form' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "inline", "className", "validated", "as"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_11__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'form');
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, validated && 'was-validated', inline && bsPrefix + "-inline")
  }));
});
Form.displayName = 'Form';
Form.defaultProps = defaultProps;
Form.Row = Object(__WEBPACK_IMPORTED_MODULE_12__createWithBsPrefix__["a" /* default */])('form-row');
Form.Group = __WEBPACK_IMPORTED_MODULE_7__FormGroup__["a" /* default */];
Form.Control = __WEBPACK_IMPORTED_MODULE_6__FormControl__["a" /* default */];
Form.Check = __WEBPACK_IMPORTED_MODULE_4__FormCheck__["a" /* default */];
Form.File = __WEBPACK_IMPORTED_MODULE_5__FormFile__["a" /* default */];
Form.Switch = __WEBPACK_IMPORTED_MODULE_10__Switch__["a" /* default */];
Form.Label = __WEBPACK_IMPORTED_MODULE_8__FormLabel__["a" /* default */];
Form.Text = __WEBPACK_IMPORTED_MODULE_9__FormText__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MHEValidationContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_MHEValidationReducer__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var MHEValidationContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var MHEValidationContextProvider=function MHEValidationContextProvider(props){var data={mheValidationInformation:{mheValidationInstanceList:[]},loadingValidationDetails:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducers_MHEValidationReducer__["a" /* MHEValidationReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),mheViewModel=_useReducer2[0],mheDispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MHEValidationContext.Provider,{value:{mheViewModel:mheViewModel,mheDispatch:mheDispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(MHEValidationContextProvider));

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TesseractDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_TesseractDeviceOverviewReducer__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var TesseractDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var TesseractDeviceOverviewContextProvider=function TesseractDeviceOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},tesseractDeviceInformation:{},macAddressArray:[],loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_TesseractDeviceOverviewReducer__["a" /* TesseractDeviceOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TesseractDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (TesseractDeviceOverviewContextProvider);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAsmlComponentDetails;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchAsmlDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAsmlComponentStatusDetails;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchAsmlDeviceStatusDetails;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteAsmlComponentDetails;
/* harmony export (immutable) */ __webpack_exports__["f"] = setAsmlComponentDetails;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setAsmlDeviceDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateAsmlDeviceDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateAsmlComponentMac; });
/* harmony export (immutable) */ __webpack_exports__["h"] = updateAsmlComponentDetails;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateAsmlComponentMonitoringDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__ = __webpack_require__(51);
var getAsmlComponentStatusDetails=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatcher,model){var request,startTime,args,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["X" /* getNodeId */])(),macAddressList:model.macAddressArray};startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_38" /* ENDPOINT_GET_ASML_STATUS */]);_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context4.sent;if(response.status===200){Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAsmlDeviceStatusDetails",true,false);mergeStatusToModel(response,model);}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAsmlDeviceStatusDetails",false,isFault);request.macAddressList.forEach(function(macAddress){model.asmlComponentInformation[macAddress].assetStatus=__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_109" /* LOADING_FAILED */];});}dispatcher({type:"RECEIVE_DATA",data:model});case 8:case"end":return _context4.stop();}}},_callee4,this);}));return function getAsmlComponentStatusDetails(_x9,_x10){return _ref4.apply(this,arguments);};}();var getAsmlDeviceStatusDetails=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatcher,model){var request,startTime,args,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["X" /* getNodeId */])(),macAddressList:model.macAddressArray};startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_38" /* ENDPOINT_GET_ASML_STATUS */]);_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context5.sent;if(response.status===200){Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAsmlDeviceStatusDetails",true,false);mergeStatusToAsmlModel(response,model);}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAsmlDeviceStatusDetails",false,isFault);request.macAddressList.forEach(function(macAddress){if(model.usedInductCameraMacAddressArray.includes(macAddress)){model.inductCameraDeviceInformation[macAddress].assetStatus=__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_109" /* LOADING_FAILED */];}if(model.usedPrinterMacAddressArray.includes(macAddress)){model.printerDeviceInformation[macAddress].assetStatus=__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_109" /* LOADING_FAILED */];}if(model.usedVerificationCameraMacAddressArray.includes(macAddress)){model.verificationCameraDeviceInformation[macAddress].assetStatus=__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_109" /* LOADING_FAILED */];}});}dispatcher({type:"RECEIVE_DATA",data:model});case 8:case"end":return _context5.stop();}}},_callee5,this);}));return function getAsmlDeviceStatusDetails(_x11,_x12){return _ref5.apply(this,arguments);};}();var getAsmlComponentDetails=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatcher,request,assetSubType){var _this=this;var pageToken,assetDeviceDetailList,startTime,isSuccess,isFault,_loop,asmlComponentInformation;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:pageToken=null;assetDeviceDetailList=[];startTime=Date.now();isSuccess=true;isFault=false;// Get assets
_loop=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var response,assetListResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["g" /* getAssets */])(request.nodeId,request.assetType,pageToken);case 2:response=_context6.sent;assetListResponse=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return response.data.assetDetailsList;},[]);assetDeviceDetailList=assetDeviceDetailList.concat(assetListResponse);isSuccess=response.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(response.status);pageToken=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return response.data.pageToken;},null);case 8:case"end":return _context6.stop();}}},_callee6,_this);});case 6:return _context7.delegateYield(_loop(),"t0",7);case 7:if(pageToken){_context7.next=6;break;}case 8:// Extract data
asmlComponentInformation=extractAsmlComponentInformation(assetDeviceDetailList,assetSubType);// Fork status call
if(!asmlComponentInformation.macAddressArray){_context7.next=12;break;}_context7.next=12;return getAsmlComponentStatusDetails(dispatcher,asmlComponentInformation);case 12:// Return data to page
dispatcher({type:"RECEIVE_DATA",data:asmlComponentInformation});// Log operation
Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAsmlDeviceDetails",isSuccess,isFault);case 14:case"end":return _context7.stop();}}},_callee7,this);}));return function getAsmlComponentDetails(_x13,_x14,_x15){return _ref6.apply(this,arguments);};}();var getAsmlDeviceDetails=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatcher,request){var _this2=this;var assetDeviceDetailList,pageToken,isSuccess,isFault,startTime,_loop2,asmlDeviceInformation;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:assetDeviceDetailList=[];pageToken=null;isSuccess=true;isFault=false;// Get assets
startTime=Date.now();_loop2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){var response,assetListResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["g" /* getAssets */])(request.nodeId,request.assetType,pageToken);case 2:response=_context8.sent;assetListResponse=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return response.data.assetDetailsList;});assetDeviceDetailList=assetDeviceDetailList.concat(assetListResponse);isSuccess=response.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(response.status);pageToken=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return response.data.pageToken;},null);case 8:case"end":return _context8.stop();}}},_callee8,_this2);});case 6:return _context9.delegateYield(_loop2(),"t0",7);case 7:if(pageToken){_context9.next=6;break;}case 8:// Extract data
asmlDeviceInformation=extractAsmlDeviceInformation(assetDeviceDetailList);// Fork status call
if(!asmlDeviceInformation.macAddressArray){_context9.next=12;break;}_context9.next=12;return getAsmlDeviceStatusDetails(dispatcher,asmlDeviceInformation);case 12:// Return data to page
dispatcher({type:"RECEIVE_DATA",data:asmlDeviceInformation});// Log operation
Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAsmlDeviceDetails",isSuccess,isFault);case 14:case"end":return _context9.stop();}}},_callee9,this);}));return function getAsmlDeviceDetails(_x16,_x17){return _ref7.apply(this,arguments);};}();var setAssetLabelDeprecatedAsmlComponentDetails=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatcher,request){var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:startTime=Date.now();Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetLabel,request.assetStatus).then(function(result){if(result.status===200){Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteAsmlDeviceDetails",true,false);}else{var isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(result.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteAsmlDeviceDetails",false,isFault);dispatcher({type:"RECEIVE_DATA",data:[]});}});case 2:case"end":return _context10.stop();}}},_callee10,this);}));return function setAssetLabelDeprecatedAsmlComponentDetails(_x18,_x19){return _ref8.apply(this,arguments);};}();var addAsmlComponentDetails=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(dispatcher,request,assetSubType){var _this3=this;var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:startTime=Date.now();_context12.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_29" /* setAliasToRequest */])(request);case 3:Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["a" /* addAsset */])(request).then(function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(result){var isFault,getAssetResult,responseSetAssetStatus,responseUpdateAsset,isFaultInUpdate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(result.status);if(!(result.status===200)){_context11.next=5;break;}Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAsmlDeviceDetails",true,false);_context11.next=28;break;case 5:_context11.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 7:getAssetResult=_context11.sent;if(Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(getAssetResult.data.asset.assetDetails.assetStatus)){_context11.next=12;break;}alert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["B" /* ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET */]);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAsmlDeviceDetails",false,isFault);return _context11.abrupt("return");case 12:_context11.next=14;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]);case 14:responseSetAssetStatus=_context11.sent;if(!(responseSetAssetStatus.status!==200)){_context11.next=19;break;}alert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAsmlDeviceDetails",false,isFault);return _context11.abrupt("return");case 19:_context11.next=21;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 21:responseUpdateAsset=_context11.sent;if(!(responseUpdateAsset.status!==200)){_context11.next=27;break;}isFaultInUpdate=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(responseUpdateAsset.status);alert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAsmlDeviceDetails",false,isFaultInUpdate);return _context11.abrupt("return");case 27:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAsmlDeviceDetails",true,false);case 28:fetchAsmlComponentDetails(dispatcher,assetSubType);case 29:case"end":return _context11.stop();}}},_callee11,_this3);}));return function(_x23){return _ref10.apply(this,arguments);};}());case 4:case"end":return _context12.stop();}}},_callee12,this);}));return function addAsmlComponentDetails(_x20,_x21,_x22){return _ref9.apply(this,arguments);};}();var updateAsmlAsset=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(dispatcher,request,assetSubType){var setAssetStatusResponse,startTime,getAssetResult,updateAssetResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]);case 2:setAssetStatusResponse=_context13.sent;if(!(setAssetStatusResponse.status!==200)){_context13.next=7;break;}alert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);fetchAsmlComponentDetails(dispatcher,assetSubType);return _context13.abrupt("return");case 7:// Update asset details
startTime=Date.now();_context13.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_29" /* setAliasToRequest */])(request);case 10:_context13.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 12:getAssetResult=_context13.sent;_context13.next=15;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 15:updateAssetResponse=_context13.sent;isSuccess=updateAssetResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(updateAssetResponse.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAsmlDeviceDetails",isSuccess,isFault);fetchAsmlComponentDetails(dispatcher,assetSubType);case 20:case"end":return _context13.stop();}}},_callee13,this);}));return function updateAsmlAsset(_x24,_x25,_x26){return _ref11.apply(this,arguments);};}();var updateAsmlComponentMonitoringSchedule=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(dispatcher,request,assetSubType){var startTime,getAssetResult,updateAssetInPlaceResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:// Update asset details
startTime=Date.now();_context14.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 3:getAssetResult=_context14.sent;_context14.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["l" /* updateAssetInPlace */])(request,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.lastUpdateTime;},null));case 6:updateAssetInPlaceResponse=_context14.sent;isSuccess=updateAssetInPlaceResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(updateAssetInPlaceResponse.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAsmlDeviceDetails",isSuccess,isFault);fetchAsmlComponentDetails(dispatcher,assetSubType);case 11:case"end":return _context14.stop();}}},_callee14,this);}));return function updateAsmlComponentMonitoringSchedule(_x27,_x28,_x29){return _ref12.apply(this,arguments);};}();var updateParentAssetLabel=function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(childMacAddress,parentMacAddress){var result,assetResult,updatedAsset,updateAssetInPlaceResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:result={success:true,fault:false};_context16.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["C" /* getAssetLabelFromMac */])(childMacAddress));case 3:assetResult=_context16.sent;if(!(assetResult.status===200)){_context16.next=15;break;}updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["t" /* deepCopyObject */])(assetResult.data.asset);updatedAsset.assetDetails.parentAssetLabel=parentMacAddress;_context16.next=9;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(updatedAsset,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.creationTime;},null));case 9:updateAssetInPlaceResponse=_context16.sent;isSuccess=updateAssetInPlaceResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(updateAssetInPlaceResponse.status);if(isFault){alert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);result.success=isSuccess;result.fault=true;}_context16.next=18;break;case 15:alert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);result.success=false;result.fault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(assetResult.status);case 18:return _context16.abrupt("return",result);case 19:case"end":return _context16.stop();}}},_callee16,this);}));return function updateParentAssetLabel(_x34,_x35){return _ref14.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="ASML_DEVICE_DETAILS";function fetchAsmlComponentDetails(dispatcher,assetSubType){var request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["L" /* ASML_ASSET_TYPE */]};getAsmlComponentDetails(dispatcher,request,assetSubType);}function fetchAsmlDeviceDetails(dispatcher){var request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["L" /* ASML_ASSET_TYPE */]};getAsmlDeviceDetails(dispatcher,request);}function fetchAsmlComponentStatusDetails(dispatcher,model){getAsmlComponentStatusDetails(dispatcher,model);}function fetchAsmlDeviceStatusDetails(dispatcher,model){getAsmlDeviceStatusDetails(dispatcher,model);}function deleteAsmlComponentDetails(dispatcher,mac){var request={assetLabel:{type:"MAC_ADDRESS",value:mac},assetStatus:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_19" /* DEPRECATED */]};setAssetLabelDeprecatedAsmlComponentDetails(dispatcher,request);}function setAsmlComponentDetails(dispatcher,stateValues,assetSubType){stateValues.mac=stateValues.mac.toLowerCase();var request=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["L" /* ASML_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */],assetSubType);addAsmlComponentDetails(dispatcher,request,assetSubType);}var setAsmlDeviceDetails=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher,stateValues){var startTime,addAsmlDeviceResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:startTime=Date.now();// ASML is not an asset in itself. For creating a new ASML asset we are setting the parentAssetLabel of printer
// verification camera to the mac address of the induct camera.
stateValues.printerMac=stateValues.printerMac.toLowerCase();stateValues.verificationCameraMac=stateValues.verificationCameraMac.toLowerCase();_context.next=5;return updateParentAssetLabel(stateValues.printerMac,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_114" /* MAC_ADDRESS_PREFIX */]+stateValues.inductCameraMac);case 5:addAsmlDeviceResponse=_context.sent;if(!(stateValues.verificationCameraMac!==""&&addAsmlDeviceResponse.success)){_context.next=10;break;}_context.next=9;return updateParentAssetLabel(stateValues.verificationCameraMac,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_114" /* MAC_ADDRESS_PREFIX */]+stateValues.inductCameraMac);case 9:addAsmlDeviceResponse=_context.sent;case 10:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAsmlDeviceDetails",addAsmlDeviceResponse.success,addAsmlDeviceResponse.fault);fetchAsmlDeviceDetails(dispatcher);case 12:case"end":return _context.stop();}}},_callee,this);}));return function setAsmlDeviceDetails(_x,_x2){return _ref.apply(this,arguments);};}();var updateAsmlDeviceDetails=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatcher,stateValues){var startTime,updateAsmlDeviceResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:startTime=Date.now();updateAsmlDeviceResponse={success:true,fault:false};stateValues.inductCameraMac=stateValues.inductCameraMac.toLowerCase();stateValues.originalInductCameraMac=stateValues.originalInductCameraMac.toLowerCase();stateValues.printerMac=stateValues.printerMac.toLowerCase();stateValues.originalPrinterMac=stateValues.originalPrinterMac.toLowerCase();stateValues.verificationCameraMac=stateValues.verificationCameraMac.toLowerCase();stateValues.originalVerificationCameraMac=stateValues.originalVerificationCameraMac.toLowerCase();// This flow is used to update the connection between different asml components. It is also use to assign a
// printer and verification camera.
// If old induct camera mac and selected mac is different then we set parentAssetLabel of old printer to null
// new printer to new induct camera mac. Same for verification camera.
// If printer/verification camera mac is different we set parentAssetLabel of old printer to null and new printer
// to selected induct camera mac. We set parentAssetLabel of new printer only if we are not unassigning it. In
// case of already unassigned printer we don't set the parentAssetLable of old printer to null since the relationship
// doesn't exist.
if(!(stateValues.inductCameraMac!==stateValues.originalInductCameraMac)){_context2.next=37;break;}if(!(stateValues.printerMac!==stateValues.originalPrinterMac)){_context2.next=19;break;}_context2.next=12;return updateParentAssetLabel(stateValues.originalPrinterMac,null);case 12:updateAsmlDeviceResponse=_context2.sent;if(!(updateAsmlDeviceResponse.success&&stateValues.printerMac!==__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_210" /* UNASSIGN_PRINTER */].toLowerCase())){_context2.next=17;break;}_context2.next=16;return updateParentAssetLabel(stateValues.printerMac,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_114" /* MAC_ADDRESS_PREFIX */]+stateValues.inductCameraMac);case 16:updateAsmlDeviceResponse=_context2.sent;case 17:_context2.next=22;break;case 19:_context2.next=21;return updateParentAssetLabel(stateValues.printerMac,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_114" /* MAC_ADDRESS_PREFIX */]+stateValues.inductCameraMac);case 21:updateAsmlDeviceResponse=_context2.sent;case 22:if(!(stateValues.verificationCameraMac!==stateValues.originalVerificationCameraMac&&updateAsmlDeviceResponse.success)){_context2.next=32;break;}_context2.next=25;return updateParentAssetLabel(stateValues.originalVerificationCameraMac,null);case 25:updateAsmlDeviceResponse=_context2.sent;if(!(updateAsmlDeviceResponse.success&&stateValues.verificationCameraMac!==__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_211" /* UNASSIGN_VERIFICATION_CAMERA */].toLowerCase())){_context2.next=30;break;}_context2.next=29;return updateParentAssetLabel(stateValues.verificationCameraMac,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_114" /* MAC_ADDRESS_PREFIX */]+stateValues.inductCameraMac);case 29:updateAsmlDeviceResponse=_context2.sent;case 30:_context2.next=35;break;case 32:_context2.next=34;return updateParentAssetLabel(stateValues.verificationCameraMac,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_114" /* MAC_ADDRESS_PREFIX */]+stateValues.inductCameraMac);case 34:updateAsmlDeviceResponse=_context2.sent;case 35:_context2.next=55;break;case 37:if(!(stateValues.printerMac!==stateValues.originalPrinterMac)){_context2.next=46;break;}if(!(stateValues.originalPrinterMac!==__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_142" /* NO_PRINTER_ASSIGNED */].toLowerCase())){_context2.next=42;break;}_context2.next=41;return updateParentAssetLabel(stateValues.originalPrinterMac,null);case 41:updateAsmlDeviceResponse=_context2.sent;case 42:if(!(updateAsmlDeviceResponse.success&&stateValues.printerMac!==__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_210" /* UNASSIGN_PRINTER */].toLowerCase())){_context2.next=46;break;}_context2.next=45;return updateParentAssetLabel(stateValues.printerMac,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_114" /* MAC_ADDRESS_PREFIX */]+stateValues.inductCameraMac);case 45:updateAsmlDeviceResponse=_context2.sent;case 46:if(!(stateValues.verificationCameraMac!==stateValues.originalVerificationCameraMac)){_context2.next=55;break;}if(!(stateValues.originalVerificationCameraMac!==__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_143" /* NO_VERIFICATION_CAMERA_ASSIGNED */].toLowerCase())){_context2.next=51;break;}_context2.next=50;return updateParentAssetLabel(stateValues.originalVerificationCameraMac,null);case 50:updateAsmlDeviceResponse=_context2.sent;case 51:if(!(updateAsmlDeviceResponse.success&&stateValues.verificationCameraMac!==__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_211" /* UNASSIGN_VERIFICATION_CAMERA */].toLowerCase())){_context2.next=55;break;}_context2.next=54;return updateParentAssetLabel(stateValues.verificationCameraMac,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_114" /* MAC_ADDRESS_PREFIX */]+stateValues.inductCameraMac);case 54:updateAsmlDeviceResponse=_context2.sent;case 55:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAsmlDeviceDetails",updateAsmlDeviceResponse.success,updateAsmlDeviceResponse.fault);fetchAsmlDeviceDetails(dispatcher);case 57:case"end":return _context2.stop();}}},_callee2,this);}));return function updateAsmlDeviceDetails(_x3,_x4){return _ref2.apply(this,arguments);};}();var updateAsmlComponentMac=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatcher,stateValues,mac,assetSubType){var startTime,assetLabel,assetResult,nodeId,assetStatus;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:startTime=Date.now();assetLabel=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["C" /* getAssetLabelFromMac */])(stateValues.mac.toLowerCase());_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(assetLabel);case 4:assetResult=_context3.sent;nodeId=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.nodeId;},null);assetStatus=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.assetStatus;},null);if(assetStatus&&!Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(assetStatus)){alert(Object(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_225" /* getUpdateAssetMessageAlertWithSite */])(nodeId));Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAsmlDeviceDetails",false,false);}else{deleteAsmlComponentDetails(dispatcher,mac);setAsmlComponentDetails(dispatcher,stateValues,assetSubType);}case 8:case"end":return _context3.stop();}}},_callee3,this);}));return function updateAsmlComponentMac(_x5,_x6,_x7,_x8){return _ref3.apply(this,arguments);};}();function updateAsmlComponentDetails(dispatcher,stateValues,assetSubType){var request=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["L" /* ASML_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */],assetSubType);updateAsmlAsset(dispatcher,request,assetSubType);}var extractAsmlComponentInformation=function extractAsmlComponentInformation(assetDeviceDetailList,assetSubType){var model={asmlComponentInformation:{},macAddressArray:[]};assetDeviceDetailList.forEach(function(asmlDeviceDetail){if(asmlDeviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]&&assetSubType===asmlDeviceDetail.assetSubType){model.macAddressArray.push(asmlDeviceDetail.assetAttributes.mac);var deviceConfig=JSON.parse(asmlDeviceDetail.assetAttributes.deviceConfig);model.asmlComponentInformation[asmlDeviceDetail.assetAttributes.mac]={name:asmlDeviceDetail.assetAttributes.name,mac:asmlDeviceDetail.assetAttributes.mac,ip:asmlDeviceDetail.assetAttributes.ip,id:deviceConfig.id,port:asmlDeviceDetail.assetAttributes.port,vendorAttributes:asmlDeviceDetail.vendorAttributes||__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */],assetStatus:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_110" /* LOADING_STRING */],deviceType:asmlDeviceDetail.assetAttributes.deviceType,assetType:asmlDeviceDetail.assetType,assetSubType:asmlDeviceDetail.assetSubType,divertConfig:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(asmlDeviceDetail.assetAttributes.divertConfig);},[]),startTime:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(asmlDeviceDetail.assetAttributes.monitoring).startTime;},"0"),endTime:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(asmlDeviceDetail.assetAttributes.monitoring).endTime;},"0"),reason:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(asmlDeviceDetail.assetAttributes.monitoring).reason;},""),parentAssetLabel:asmlDeviceDetail.parentAssetLabel,firmwareVersion:asmlDeviceDetail.assetAttributes.firmwareVersion||null,firmwareVersionUpdatedAt:asmlDeviceDetail.assetAttributes.firmwareVersionUpdatedAt||null};}});return model;};var extractAsmlDeviceInformation=function extractAsmlDeviceInformation(assetDeviceDetailList){var model={inductCameraDeviceInformation:{},printerDeviceInformation:{},verificationCameraDeviceInformation:{},usedInductCameraMacAddressArray:[],usedPrinterMacAddressArray:[],usedVerificationCameraMacAddressArray:[],macAddressArray:[],allInductCameraMacAddressArray:[],allPrinterMacAddressArray:[],allVerificationCameraMacAddressArray:[]};assetDeviceDetailList.forEach(function(asmlDeviceDetail){if(asmlDeviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]){if(asmlDeviceDetail.assetSubType===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_83" /* INDUCT_CAMERA_SUB_ASSET_TYPE */]){model.allInductCameraMacAddressArray.push(asmlDeviceDetail.assetAttributes.mac);}if(asmlDeviceDetail.assetSubType===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_159" /* PRINTER_SUB_ASSET_TYPE */]){model.allPrinterMacAddressArray.push(asmlDeviceDetail.assetAttributes.mac);}if(asmlDeviceDetail.assetSubType===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_220" /* VERIFICATION_CAMERA_SUB_ASSET_TYPE */]){model.allVerificationCameraMacAddressArray.push(asmlDeviceDetail.assetAttributes.mac);}}if(asmlDeviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]&&asmlDeviceDetail.assetSubType===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_83" /* INDUCT_CAMERA_SUB_ASSET_TYPE */]){assetDeviceDetailList.forEach(function(asmlChildDeviceDetail){if(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_114" /* MAC_ADDRESS_PREFIX */]+asmlDeviceDetail.assetAttributes.mac===asmlChildDeviceDetail.parentAssetLabel&&asmlChildDeviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]){model.usedInductCameraMacAddressArray.push(asmlDeviceDetail.assetAttributes.mac);model.macAddressArray.push(asmlDeviceDetail.assetAttributes.mac);model.macAddressArray.push(asmlChildDeviceDetail.assetAttributes.mac);model.inductCameraDeviceInformation[asmlDeviceDetail.assetAttributes.mac]=getAssetInformationFromAssetDetails(asmlDeviceDetail);if(asmlChildDeviceDetail.assetSubType===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_159" /* PRINTER_SUB_ASSET_TYPE */]){model.usedPrinterMacAddressArray.push(asmlChildDeviceDetail.assetAttributes.mac);model.printerDeviceInformation[asmlChildDeviceDetail.assetAttributes.mac]=getAssetInformationFromAssetDetails(asmlChildDeviceDetail);}if(asmlChildDeviceDetail.assetSubType===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_220" /* VERIFICATION_CAMERA_SUB_ASSET_TYPE */]){model.usedVerificationCameraMacAddressArray.push(asmlChildDeviceDetail.assetAttributes.mac);model.verificationCameraDeviceInformation[asmlChildDeviceDetail.assetAttributes.mac]=getAssetInformationFromAssetDetails(asmlChildDeviceDetail);}}});}});return model;};function mergeStatusToModel(response,model){if("data"in response&&"aslStatusList"in response.data){response.data.aslStatusList.forEach(function(singleAsmlDeviceStatusDetail){model.asmlComponentInformation[singleAsmlDeviceStatusDetail.mac].assetStatus=singleAsmlDeviceStatusDetail.status;});}}function mergeStatusToAsmlModel(response,model){if("data"in response&&"aslStatusList"in response.data){response.data.aslStatusList.forEach(function(singleAsmlDeviceStatusDetail){if(model.usedInductCameraMacAddressArray.includes(singleAsmlDeviceStatusDetail.mac)){model.inductCameraDeviceInformation[singleAsmlDeviceStatusDetail.mac].assetStatus=singleAsmlDeviceStatusDetail.status;}if(model.usedPrinterMacAddressArray.includes(singleAsmlDeviceStatusDetail.mac)){model.printerDeviceInformation[singleAsmlDeviceStatusDetail.mac].assetStatus=singleAsmlDeviceStatusDetail.status;}if(model.usedVerificationCameraMacAddressArray.includes(singleAsmlDeviceStatusDetail.mac)){model.verificationCameraDeviceInformation[singleAsmlDeviceStatusDetail.mac].assetStatus=singleAsmlDeviceStatusDetail.status;}});}}var updateExistingAssetAttributes=function updateExistingAssetAttributes(asset,stateValues){var updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["t" /* deepCopyObject */])(asset);updatedAsset.assetDetails.assetAttributes.monitoring=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(stateValues);},asset.assetDetails.assetAttributes.monitoring);return updatedAsset;};var updateAsmlComponentMonitoringDetails=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(dispatcher,stateValues,mac,assetSubType){var getAssetResult,updatedAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 2:getAssetResult=_context15.sent;updatedAsset=updateExistingAssetAttributes(getAssetResult.data.asset,stateValues);updateAsmlComponentMonitoringSchedule(dispatcher,updatedAsset,assetSubType);case 5:case"end":return _context15.stop();}}},_callee15,this);}));return function updateAsmlComponentMonitoringDetails(_x30,_x31,_x32,_x33){return _ref13.apply(this,arguments);};}();var getAssetInformationFromAssetDetails=function getAssetInformationFromAssetDetails(asmlDeviceDetail){var asset={name:asmlDeviceDetail.assetAttributes.name,mac:asmlDeviceDetail.assetAttributes.mac,ip:asmlDeviceDetail.assetAttributes.ip,port:asmlDeviceDetail.assetAttributes.port,vendorAttributes:asmlDeviceDetail.vendorAttributes||__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */],assetStatus:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_110" /* LOADING_STRING */],deviceType:asmlDeviceDetail.assetAttributes.deviceType,assetType:asmlDeviceDetail.assetType,assetSubType:asmlDeviceDetail.assetSubType,divertConfig:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(asmlDeviceDetail.assetAttributes.divertConfig);},[]),startTime:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(asmlDeviceDetail.assetAttributes.monitoring).startTime;},"0"),endTime:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(asmlDeviceDetail.assetAttributes.monitoring).endTime;},"0"),reason:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(asmlDeviceDetail.assetAttributes.monitoring).reason;},""),parentAssetLabel:asmlDeviceDetail.parentAssetLabel,firmwareVersion:asmlDeviceDetail.assetAttributes.firmwareVersion||null,firmwareVersionUpdatedAt:asmlDeviceDetail.assetAttributes.firmwareVersionUpdatedAt||null};return asset;};

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoLoaderDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_AutoLoaderDeviceOverviewReducer__ = __webpack_require__(1401);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AutoLoaderDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var AutoLoaderOverviewContextProvider=function AutoLoaderOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},autoLoaderDeviceInformation:{},macAddressArray:[],loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_AutoLoaderDeviceOverviewReducer__["a" /* AutoLoaderDeviceOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AutoLoaderDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (AutoLoaderOverviewContextProvider);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BrowserRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HashRouter; });
/* unused harmony export Link */
/* unused harmony export NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(319);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(235);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Link, _React$Component);

  function Link() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Link.prototype;

  _proto.handleClick = function handleClick(event, history) {
    try {
      if (this.props.onClick) this.props.onClick(event);
    } catch (ex) {
      event.preventDefault();
      throw ex;
    }

    if (!event.defaultPrevented && // onClick prevented default
    event.button === 0 && ( // ignore everything but left clicks
    !this.props.target || this.props.target === "_self") && // let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        var method = this.props.replace ? history.replace : history.push;
        method(this.props.to);
      }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        innerRef = _this$props.innerRef,
        replace = _this$props.replace,
        to = _this$props.to,
        rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["innerRef", "replace", "to"]); // eslint-disable-line no-unused-vars


    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, context.location) : to;
      var href = location ? context.history.createHref(location) : "";
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        onClick: function onClick(event) {
          return _this.handleClick(event, context.history);
        },
        href: href,
        ref: innerRef
      }));
    });
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object]);
  var innerRefType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.propTypes = {
    innerRef: innerRefType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


function NavLink(_ref) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "strict", "style", "to"]);

  var path = typeof to === "object" ? to.pathname : to; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var pathToMatch = locationProp ? locationProp.pathname : context.location.pathname;
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["f" /* matchPath */])(pathToMatch, {
      path: escapedPath,
      exact: exact,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, context.location) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styleProp, activeStyle) : styleProp;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Link, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: to
    }, rest));
  });
}

if (false) {
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    strict: PropTypes.bool,
    style: PropTypes.object
  });
}




/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(591),
    baseMatchesProperty = __webpack_require__(637),
    identity = __webpack_require__(248),
    isArray = __webpack_require__(82),
    property = __webpack_require__(645);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(593),
    listCacheDelete = __webpack_require__(594),
    listCacheGet = __webpack_require__(595),
    listCacheHas = __webpack_require__(596),
    listCacheSet = __webpack_require__(597);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(239);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(105);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(615);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(123),
    isObjectLike = __webpack_require__(104);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(191);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKeyboardFocusNodes = exports.getFocusNodes = exports.getBoundingFocusNodes = exports.canKeyboardFocusNode = exports.canFocusNode = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(155));

var _findIndex = _interopRequireDefault(__webpack_require__(254));

var _findLastIndex = _interopRequireDefault(__webpack_require__(349));

var focusNodeQuery = "button, input, select, textarea, [tabindex], [href]";
/**
 * Returns true if a node can be focused
 */

var canFocusNode = function canFocusNode(node) {
  return node && node.matches ? node.matches(focusNodeQuery) : node && node.msMatchesSelector ? node.msMatchesSelector(focusNodeQuery) : false;
};

exports.canFocusNode = canFocusNode;

var canKeyboardFocusNode = function canKeyboardFocusNode(node) {
  return canFocusNode(node) && node.getAttribute("tabindex") !== "-1";
};

exports.canKeyboardFocusNode = canKeyboardFocusNode;

var getFocusNodes = function getFocusNodes(node) {
  return node ? [].slice.call(node.querySelectorAll(focusNodeQuery)) : [];
};

exports.getFocusNodes = getFocusNodes;

var getKeyboardFocusNodes = function getKeyboardFocusNodes(node) {
  return getFocusNodes(node).filter(canKeyboardFocusNode);
};
/**
 * Returns an object containing two arrays of focuseable nodes keyed under
 * "startNodes" and "endNodes". The startNodes array contains every node that,
 * when focused, will cause the parent node to lose focus if the user presses
 * shift + tab (moving back in the tab order). The endNodes array contains every
 * node that, when focused, will cause the parent node to lose focus if the user
 * presses tab (moving forward in the tab order).
 */


exports.getKeyboardFocusNodes = getKeyboardFocusNodes;

var getBoundingFocusNodes = function getBoundingFocusNodes(node) {
  var nodes = [canFocusNode(node) ? node : undefined].concat((0, _toConsumableArray2["default"])(getFocusNodes(node))).filter(Boolean);
  var startFocusIndex = (0, _findIndex["default"])(nodes, canKeyboardFocusNode);
  var endFocusIndex = (0, _findLastIndex["default"])(nodes, canKeyboardFocusNode);
  var startNodes = startFocusIndex !== -1 ? nodes.slice(0, startFocusIndex + 1) : nodes;
  var endNodes = endFocusIndex !== -1 ? nodes.slice(endFocusIndex) : nodes;
  return {
    startNodes: startNodes,
    endNodes: endNodes
  };
};

exports.getBoundingFocusNodes = getBoundingFocusNodes;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isElementOf = _interopRequireDefault(__webpack_require__(94));

/**
 * Determines if an element is an instance of any one component from a list of
 * components.
 */
var isElementOfAny = function isElementOfAny(components) {
  return function (element) {
    return [].concat(components).some(function (component) {
      return (0, _isElementOf["default"])(component)(element);
    });
  };
};

var _default = isElementOfAny;
exports["default"] = _default;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var addDebouncedEventListener = function addDebouncedEventListener(node, event, listener, options) {
  var timeout = null;

  var debouncedListener = function debouncedListener(event) {
    window.cancelAnimationFrame(timeout);

    if (window && window.requestAnimationFrame) {
      timeout = window.requestAnimationFrame(function () {
        return listener(event);
      });
    }
  };

  if (node && node.addEventListener) {
    node.addEventListener(event, debouncedListener, options);
  }

  return function () {
    window.cancelAnimationFrame(timeout);

    if (node && node.removeEventListener) {
      node.removeEventListener(event, debouncedListener, options);
    }
  };
};

var _default = addDebouncedEventListener;
exports["default"] = _default;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec

// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var uint_max = Math.pow(2, 32)
function fixup_uint32 (x) {
  var ret, x_pos
  ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x
  return ret
}
function scrub_vec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
  return false
}

function Global () {
  this.SBOX = []
  this.INV_SBOX = []
  this.SUB_MIX = [[], [], [], []]
  this.INV_SUB_MIX = [[], [], [], []]
  this.init()
  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
}

Global.prototype.init = function () {
  var d, i, sx, t, x, x2, x4, x8, xi, _i
  d = (function () {
    var _i, _results
    _results = []
    for (i = _i = 0; _i < 256; i = ++_i) {
      if (i < 128) {
        _results.push(i << 1)
      } else {
        _results.push((i << 1) ^ 0x11b)
      }
    }
    return _results
  })()
  x = 0
  xi = 0
  for (i = _i = 0; _i < 256; i = ++_i) {
    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    this.SBOX[x] = sx
    this.INV_SBOX[sx] = x
    x2 = d[x]
    x4 = d[x2]
    x8 = d[x4]
    t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    this.SUB_MIX[3][x] = t
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    this.INV_SUB_MIX[3][sx] = t
    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }
  return true
}

var G = new Global()

AES.blockSize = 4 * 4

AES.prototype.blockSize = AES.blockSize

AES.keySize = 256 / 8

AES.prototype.keySize = AES.keySize

function bufferToArray (buf) {
  var len = buf.length / 4
  var out = new Array(len)
  var i = -1
  while (++i < len) {
    out[i] = buf.readUInt32BE(i * 4)
  }
  return out
}
function AES (key) {
  this._key = bufferToArray(key)
  this._doReset()
}

AES.prototype._doReset = function () {
  var invKsRow, keySize, keyWords, ksRow, ksRows, t
  keyWords = this._key
  keySize = keyWords.length
  this._nRounds = keySize + 6
  ksRows = (this._nRounds + 1) * 4
  this._keySchedule = []
  for (ksRow = 0; ksRow < ksRows; ksRow++) {
    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t)
  }
  this._invKeySchedule = []
  for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
    ksRow = ksRows - invKsRow
    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)]
    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]]
  }
  return true
}

AES.prototype.encryptBlock = function (M) {
  M = bufferToArray(new Buffer(M))
  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX)
  var buf = new Buffer(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = bufferToArray(new Buffer(M))
  var temp = [M[3], M[1]]
  M[1] = temp[0]
  M[3] = temp[1]
  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX)
  var buf = new Buffer(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrub_vec(this._keySchedule)
  scrub_vec(this._invKeySchedule)
  scrub_vec(this._key)
}

AES.prototype._doCryptBlock = function (M, keySchedule, SUB_MIX, SBOX) {
  var ksRow, s0, s1, s2, s3, t0, t1, t2, t3

  s0 = M[0] ^ keySchedule[0]
  s1 = M[1] ^ keySchedule[1]
  s2 = M[2] ^ keySchedule[2]
  s3 = M[3] ^ keySchedule[3]
  ksRow = 4
  for (var round = 1; round < this._nRounds; round++) {
    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }
  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  return [
    fixup_uint32(t0),
    fixup_uint32(t1),
    fixup_uint32(t2),
    fixup_uint32(t3)
  ]
}

exports.AES = AES

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 197 */
/***/ (function(module, exports) {

exports['aes-128-ecb'] = {
  cipher: 'AES',
  key: 128,
  iv: 0,
  mode: 'ECB',
  type: 'block'
}
exports['aes-192-ecb'] = {
  cipher: 'AES',
  key: 192,
  iv: 0,
  mode: 'ECB',
  type: 'block'
}
exports['aes-256-ecb'] = {
  cipher: 'AES',
  key: 256,
  iv: 0,
  mode: 'ECB',
  type: 'block'
}
exports['aes-128-cbc'] = {
  cipher: 'AES',
  key: 128,
  iv: 16,
  mode: 'CBC',
  type: 'block'
}
exports['aes-192-cbc'] = {
  cipher: 'AES',
  key: 192,
  iv: 16,
  mode: 'CBC',
  type: 'block'
}
exports['aes-256-cbc'] = {
  cipher: 'AES',
  key: 256,
  iv: 16,
  mode: 'CBC',
  type: 'block'
}
exports['aes128'] = exports['aes-128-cbc']
exports['aes192'] = exports['aes-192-cbc']
exports['aes256'] = exports['aes-256-cbc']
exports['aes-128-cfb'] = {
  cipher: 'AES',
  key: 128,
  iv: 16,
  mode: 'CFB',
  type: 'stream'
}
exports['aes-192-cfb'] = {
  cipher: 'AES',
  key: 192,
  iv: 16,
  mode: 'CFB',
  type: 'stream'
}
exports['aes-256-cfb'] = {
  cipher: 'AES',
  key: 256,
  iv: 16,
  mode: 'CFB',
  type: 'stream'
}
exports['aes-128-cfb8'] = {
  cipher: 'AES',
  key: 128,
  iv: 16,
  mode: 'CFB8',
  type: 'stream'
}
exports['aes-192-cfb8'] = {
  cipher: 'AES',
  key: 192,
  iv: 16,
  mode: 'CFB8',
  type: 'stream'
}
exports['aes-256-cfb8'] = {
  cipher: 'AES',
  key: 256,
  iv: 16,
  mode: 'CFB8',
  type: 'stream'
}
exports['aes-128-cfb1'] = {
  cipher: 'AES',
  key: 128,
  iv: 16,
  mode: 'CFB1',
  type: 'stream'
}
exports['aes-192-cfb1'] = {
  cipher: 'AES',
  key: 192,
  iv: 16,
  mode: 'CFB1',
  type: 'stream'
}
exports['aes-256-cfb1'] = {
  cipher: 'AES',
  key: 256,
  iv: 16,
  mode: 'CFB1',
  type: 'stream'
}
exports['aes-128-ofb'] = {
  cipher: 'AES',
  key: 128,
  iv: 16,
  mode: 'OFB',
  type: 'stream'
}
exports['aes-192-ofb'] = {
  cipher: 'AES',
  key: 192,
  iv: 16,
  mode: 'OFB',
  type: 'stream'
}
exports['aes-256-ofb'] = {
  cipher: 'AES',
  key: 256,
  iv: 16,
  mode: 'OFB',
  type: 'stream'
}
exports['aes-128-ctr'] = {
  cipher: 'AES',
  key: 128,
  iv: 16,
  mode: 'CTR',
  type: 'stream'
}
exports['aes-192-ctr'] = {
  cipher: 'AES',
  key: 192,
  iv: 16,
  mode: 'CTR',
  type: 'stream'
}
exports['aes-256-ctr'] = {
  cipher: 'AES',
  key: 256,
  iv: 16,
  mode: 'CTR',
  type: 'stream'
}
exports['aes-128-gcm'] = {
  cipher: 'AES',
  key: 128,
  iv: 12,
  mode: 'GCM',
  type: 'auth'
}
exports['aes-192-gcm'] = {
  cipher: 'AES',
  key: 192,
  iv: 12,
  mode: 'GCM',
  type: 'auth'
}
exports['aes-256-gcm'] = {
  cipher: 'AES',
  key: 256,
  iv: 12,
  mode: 'GCM',
  type: 'auth'
}


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var md5 = __webpack_require__(371)
module.exports = EVP_BytesToKey
function EVP_BytesToKey (password, salt, keyLen, ivLen) {
  if (!Buffer.isBuffer(password)) {
    password = new Buffer(password, 'binary')
  }
  if (salt && !Buffer.isBuffer(salt)) {
    salt = new Buffer(salt, 'binary')
  }
  keyLen = keyLen / 8
  ivLen = ivLen || 0
  var ki = 0
  var ii = 0
  var key = new Buffer(keyLen)
  var iv = new Buffer(ivLen)
  var addmd = 0
  var md_buf
  var i
  var bufs = []
  while (true) {
    if (addmd++ > 0) {
      bufs.push(md_buf)
    }
    bufs.push(password)
    if (salt) {
      bufs.push(salt)
    }
    md_buf = md5(Buffer.concat(bufs))
    bufs = []
    i = 0
    if (keyLen > 0) {
      while (true) {
        if (keyLen === 0) {
          break
        }
        if (i === md_buf.length) {
          break
        }
        key[ki++] = md_buf[i]
        keyLen--
        i++
      }
    }
    if (ivLen > 0 && i !== md_buf.length) {
      while (true) {
        if (ivLen === 0) {
          break
        }
        if (i === md_buf.length) {
          break
        }
        iv[ii++] = md_buf[i]
        ivLen--
        i++
      }
    }
    if (keyLen === 0 && ivLen === 0) {
      break
    }
  }
  for (i = 0; i < md_buf.length; i++) {
    md_buf[i] = 0
  }
  return {
    key: key,
    iv: iv
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(164)

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}

function getBlock (self) {
  var out = self._cipher.encryptBlock(self._prev)
  incr32(self._prev)
  return out
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__(803);
curve.short = __webpack_require__(804);
curve.mont = __webpack_require__(805);
curve.edwards = __webpack_require__(806);


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var asn1 = __webpack_require__(815)
var aesid = __webpack_require__(826)
var fixProc = __webpack_require__(827)
var ciphers = __webpack_require__(268)
var compat = __webpack_require__(378)
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = new Buffer(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'PUBLIC KEY':
      ndata = asn1.PublicKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen)
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(841);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 203 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    popoverForegroundColorOutline: tokens.themeForegroundPrimaryDefault,
    popoverForegroundColorFill: "#FFFFFF",
    popoverBackgroundColorOutline: tokens.themeBackgroundPrimaryDefault,
    popoverBackgroundColorFill: "#252829",
    popoverBorderWidth: 1,
    popoverBorderRadius: 4,
    popoverBorderColorOutline: tokens.themeBorderSecondaryDefault,
    popoverBorderColorFill: tokens.themeBorderAlternateDefault,
    popoverSpacingInsetVerticalSmall: 8,
    popoverSpacingInsetVerticalMedium: 12,
    popoverSpacingInsetHorizontalSmall: 8,
    popoverSpacingInsetHorizontalMedium: 12,
    popoverArrowWidth: 16,
    popoverArrowHeight: 8,
    popoverHeaderSpacingHorizontal: 8,
    popoverHeaderFontWeight: 600,
    popoverDropShadowOffsetX: 0,
    popoverDropShadowOffsetY: 1,
    popoverDropShadowBlur: 2,
    popoverDropShadowSpread: 0,
    popoverDropShadowColor: "rgba(11, 12, 12, 0.16)",
    popoverMotionDuration: "150ms",
    popoverMotionFunction: "ease",
    popoverClosedScale: 90,
    popoverOffsetWithArrow: 16,
    popoverOffsetWithoutArrow: 8
  }
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _popoverBody = _interopRequireDefault(__webpack_require__(864));

var _default = _popoverBody["default"];
exports["default"] = _default;

/***/ }),
/* 205 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBestOrigin = exports.getAvailableSpace = exports.flipOrigin = exports.flipAlignment = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Flip an alignment string (e.g. from "top" to "bottom" etc)
 */
var flipAlignment = function flipAlignment(alignment) {
  return {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left",
    center: "center"
  }[alignment];
};
/**
 * Flip an origin (in the form of { x: "left", y: "bottom"}) across either one
 * or both axis.
 */


exports.flipAlignment = flipAlignment;

var flipOrigin = function flipOrigin(origin, flipX, flipY) {
  return {
    x: flipX ? flipAlignment(origin.x) : origin.x,
    y: flipY ? flipAlignment(origin.y) : origin.y
  };
};
/**
 * Given an anchor origin, popover origin, anchor rectangle, viewport rectangle,
 * any arbitrary extra space, and an axis, determine how much space is available
 * in the viewport along the provided axis to render a popover.
 */


exports.flipOrigin = flipOrigin;

var getAvailableSpaceOnAxis = function getAvailableSpaceOnAxis(axis, _ref) {
  var anchorOrigin = _ref.anchorOrigin,
      popoverOrigin = _ref.popoverOrigin,
      anchorRect = _ref.anchorRect,
      viewportRect = _ref.viewportRect,
      extraSpace = _ref.extraSpace;
  var edge = axis === "x" ? "left" : "top";
  var dimension = axis === "x" ? "width" : "height";
  var oppositeEdge = flipAlignment(edge); // Determine the position along the requested axis in the viewport that
  // represents the edge of the available space for the popover

  var popoverEdge = anchorOrigin[axis] === edge ? anchorRect[edge] : anchorOrigin[axis] === oppositeEdge ? anchorRect[edge] + anchorRect[dimension] : anchorOrigin[axis] === "center" ? anchorRect[edge] + anchorRect[dimension] / 2 : undefined; // Calculate the available space along the requested axis that the popover can
  // use to render

  var availableSpace = popoverOrigin[axis] === edge ? viewportRect[dimension] - popoverEdge - extraSpace[axis] : popoverOrigin[axis] === oppositeEdge ? popoverEdge - extraSpace[axis] : popoverOrigin[axis] === "center" ? 2 * (Math.min(viewportRect[dimension] - popoverEdge, popoverEdge) - extraSpace[axis]) : undefined;
  return Math.max(0, availableSpace);
}; // Given an anchor origin, popover origin, anchor rectangle, viewport rectangle,
// and any arbitrary extra space, determine how much space is available in the
// viewport to render a popover.


var getAvailableSpace = function getAvailableSpace(args) {
  return {
    x: getAvailableSpaceOnAxis("x", args),
    y: getAvailableSpaceOnAxis("y", args)
  };
};
/**
 * Given an axis and a bunch of other information, this determines the
 * transform that, when applied to the popover and anchor origins, will result
 * in the best origins to display the popover. The transform will either be a
 * shift left or right (or up or down) along the axis (e.g. center -> left or
 * center -> right) or a flip across the axis entirely (to the other side of the
 * anchor).
 *
 * Required args:
 *  - anchorOrigin
 *  - popoverOrigin
 *  - anchorRect
 *  - viewportRect
 *  - popoverRect
 *  - extraSpace
 */


exports.getAvailableSpace = getAvailableSpace;

var getBestOriginTransformOnAxis = function getBestOriginTransformOnAxis(axis, args) {
  var getSpace = function getSpace(anchorOrigin, popoverOrigin) {
    return getAvailableSpaceOnAxis(axis, _objectSpread(_objectSpread({}, args), {}, {
      anchorOrigin: anchorOrigin,
      popoverOrigin: popoverOrigin
    }));
  };

  var edge = axis === "x" ? "left" : "top";
  var dimension = axis === "x" ? "width" : "height";
  var oppositeEdge = flipAlignment(edge);
  var spaceWithPreferredOrigin = getSpace(args.anchorOrigin, args.popoverOrigin);
  var preferredOriginIsGood = spaceWithPreferredOrigin >= args.popoverRect[dimension]; // If the popover is center-aligned on the anchor then try shifting it
  // left/right or up/down (depending on the axis)

  var tryShift = args.popoverOrigin[axis] === "center" && args.anchorOrigin[axis] === "center" && !preferredOriginIsGood;
  var spaceShiftedStart = tryShift ? getSpace(_objectSpread(_objectSpread({}, args.anchorOrigin), {}, (0, _defineProperty2["default"])({}, axis, edge)), _objectSpread(_objectSpread({}, args.popoverOrigin), {}, (0, _defineProperty2["default"])({}, axis, edge))) : 0;
  var spaceShiftedEnd = tryShift ? getSpace(_objectSpread(_objectSpread({}, args.anchorOrigin), {}, (0, _defineProperty2["default"])({}, axis, oppositeEdge)), _objectSpread(_objectSpread({}, args.popoverOrigin), {}, (0, _defineProperty2["default"])({}, axis, oppositeEdge))) : 0;
  var shift = spaceShiftedStart > spaceWithPreferredOrigin && spaceShiftedStart > spaceShiftedEnd ? edge : spaceShiftedEnd > spaceWithPreferredOrigin ? oppositeEdge : undefined; // If shifting didn't work then try flipping the popover over the axis
  // entirely (to the other side of the anchor).

  var tryFlip = !preferredOriginIsGood && !shift;
  var flip = tryFlip && getSpace(flipOrigin(args.anchorOrigin, axis === "x", axis === "y"), flipOrigin(args.popoverOrigin, axis === "x", axis === "y")) > spaceWithPreferredOrigin;
  return shift ? {
    type: "shift",
    axis: axis,
    alignment: shift
  } : flip ? {
    type: "flip",
    axis: axis
  } : {
    type: "none"
  };
};
/**
 * This is used to apply a transform from `getBestOriginTransformOnAxis` to an
 * origin object.
 */


var transformOrigin = function transformOrigin(transform, origin) {
  switch (transform.type) {
    case "shift":
      return _objectSpread(_objectSpread({}, origin), {}, (0, _defineProperty2["default"])({}, transform.axis, transform.alignment));

    case "flip":
      return flipOrigin(origin, transform.axis === "x", transform.axis === "y");

    default:
      return origin;
  }
};
/**
 * Determine the anchor and popover origins that will work best for displaying
 * the popover. If there is enough space to show the popover at the origins
 * requested by the user then that will always be treated as the best option.
 * If there is not enough space at those origins *and* there are alternate
 * origins that will buy us more space, the origins that will give us the most
 * space are treated as the best option.
 *
 * Required args:
 *  - anchorOrigin
 *  - popoverOrigin
 *  - anchorRect
 *  - viewportRect
 *  - popoverRect
 *  - extraSpace
 *
 * Note that a popover may be shifted side to side or flipped over it's anchor
 * entirely, but it will never moved to an adjacent side (e.g. from the left to
 * the top). Designers/developers should be able to choose good enough defaults
 * for their popovers that this kind of transform won't be necessary to render
 * the popovers within the viewport.
 */


var getBestOrigin = function getBestOrigin(args) {
  // Determine the transforms along the x and y axis that will result in the
  // best display of the popover (not running off any edges of the viewport).
  var transformX = getBestOriginTransformOnAxis("x", args);
  var transformY = getBestOriginTransformOnAxis("y", args); // Apply the transforms to both the anchor origin and the popover origin

  var bestAnchorOrigin = transformOrigin(transformY, transformOrigin(transformX, args.anchorOrigin));
  var bestPopoverOrigin = transformOrigin(transformY, transformOrigin(transformX, args.popoverOrigin)); // Return the new origins along with the available space that they obtained
  // for the popover

  return {
    anchorOrigin: bestAnchorOrigin,
    popoverOrigin: bestPopoverOrigin,
    availableSpace: getAvailableSpace(_objectSpread(_objectSpread({}, args), {}, {
      anchorOrigin: bestAnchorOrigin,
      popoverOrigin: bestPopoverOrigin
    }))
  };
};

exports.getBestOrigin = getBestOrigin;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _portal = _interopRequireDefault(__webpack_require__(871));

var _default = _portal["default"];
exports["default"] = _default;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Executes code after waiting at least one whole animation frame. This is
// helpful when you want to allow DOM updates to settle before triggering
// something like a css transition. This returns a function that can be used to
// cancel the callback.
var waitAnimationFrame = function waitAnimationFrame(callback) {
  var frame = requestAnimationFrame(function () {
    frame = requestAnimationFrame(callback);
  });
  return function () {
    return cancelAnimationFrame(frame);
  };
};

var _default = waitAnimationFrame;
exports["default"] = _default;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(89);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 210 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(921),
    listCacheDelete = __webpack_require__(922),
    listCacheGet = __webpack_require__(923),
    listCacheHas = __webpack_require__(924),
    listCacheSet = __webpack_require__(925);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(424);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(140);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(943);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(172),
    isObjectLike = __webpack_require__(173);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(215);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var createPadding = __webpack_require__(1021),
    stringSize = __webpack_require__(443),
    toInteger = __webpack_require__(130),
    toString = __webpack_require__(106);

/**
 * Pads `string` on the left side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padStart('abc', 6);
 * // => '   abc'
 *
 * _.padStart('abc', 6, '_-');
 * // => '_-_abc'
 *
 * _.padStart('abc', 3);
 * // => 'abc'
 */
function padStart(string, length, chars) {
  string = toString(string);
  length = toInteger(length);

  var strLength = length ? stringSize(string) : 0;
  return (length && strLength < length)
    ? (createPadding(length - strLength, chars) + string)
    : string;
}

module.exports = padStart;


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(45);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intlDateTimeRangeFormat = exports.intlDateTimeFormatToParts = exports.intlDateTimeFormatResolvedOptions = exports.intlDateTimeFormat = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _isSameYear = _interopRequireDefault(__webpack_require__(1037));

var _isSameDay = _interopRequireDefault(__webpack_require__(1038));

var _functional = __webpack_require__(38);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var formatIncludesTime = function formatIncludesTime(format) {
  return format && (format.hour || format.minute || format.second);
};
/**
 * Memoized access to the the Intl.DateTimeFormat API
 */


var intlDateTimeFormatCurried = (0, _functional.memoizeCurry)(function (format, locale) {
  return new Intl.DateTimeFormat(locale, format);
}, 1);
/**
 * Format a date using the Intl.DateTimeFormat API. See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
 * for formatting options.
 *
 * NOTE: This has a few known limitations in IE11:
 *   - If the timeZone format option is set the date will be shown in UTC,
 *     regardless of the timezone requested.
 *   - Certain combinations of format options that IE11 doesn't support will
 *     result in the full ISO date being rendered (e.g.
 *     `{ weekday: "short", day: "numeric" }` will render as something like
 *     "Mon, October 29, 2018 12:00:00AM" for the locale en-US in IE11).
 */

var intlDateTimeFormat = function intlDateTimeFormat(date, format) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en-US";

  // HACK: IE11 will explode if timeZone is set to anything but UTC. Instead
  // of erroring out this code will just fall back to UTC in IE11. This is
  // better than crashing the app, but is obviously not ideal in terms of UX. We
  // should warn our users about this in our documentation and encourage them to
  // either drop IE11 support or consider a polyfill or alternate method of
  // formatting dates.
  if (format && format.timeZone && format.timeZone !== "UTC") {
    try {
      return intlDateTimeFormatCurried(format)(locale).format(date);
    } catch (e) {
      return intlDateTimeFormatCurried(_objectSpread(_objectSpread({}, format), {}, {
        timeZone: "UTC"
      }))(locale).format(date) + " UTC";
    }
  } else {
    return intlDateTimeFormatCurried(format)(locale).format(date);
  }
};
/**
 * Format a date range using the Intl.DateTimeFormat API (uses some custom
 * logic as the Intl formatRange method is not well supported). See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
 * for formatting options.
 */


exports.intlDateTimeFormat = intlDateTimeFormat;

var intlDateTimeRangeFormat = function intlDateTimeRangeFormat(startDate, endDate, format) {
  var locale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "en-US";

  // If we were given the exact same date times, or date times on the same day
  // and we're not showing time components, then just render one.
  if (startDate === endDate || (0, _isSameDay["default"])(startDate, endDate) && !formatIncludesTime(format)) {
    return [intlDateTimeFormat(startDate, format, locale), null];
  } // If we're showing dates (no time components) and the start & end dates fall
  // in the same year, don't show the year for the start date (e.g. show
  // "May 23 - May 25, 2020" instead of "My 23, 2020 - May 25, 2020").
  else if ((0, _isSameYear["default"])(startDate, endDate) && !formatIncludesTime(format)) {
    var startFormat = Object.assign({}, format, {
      year: undefined,
      era: undefined
    });
    return [intlDateTimeFormat(startDate, startFormat, locale), intlDateTimeFormat(endDate, format, locale)];
  } // If we're showing a time range that occurs on a single day, don't show the
  // timezone in the first date and don't show the date in the second date (e.g.
  // show "January 1, 2020, 8 AM - 10 AM PST" instead of
  // "January 1, 2020, 8 AM PST - January 1, 2020, 10 AM PST")
  else if ((0, _isSameDay["default"])(startDate, endDate) && formatIncludesTime(format)) {
    var _startFormat = Object.assign({}, format, {
      timeZoneName: undefined
    });

    var endFormat = Object.assign({}, format, {
      weekday: undefined,
      year: undefined,
      month: undefined,
      day: undefined,
      era: undefined
    });
    return [intlDateTimeFormat(startDate, _startFormat, locale), intlDateTimeFormat(endDate, endFormat, locale)];
  } // If none of our special cases matched just return each fully formed date
  else {
    return [intlDateTimeFormat(startDate, format, locale), intlDateTimeFormat(endDate, format, locale)];
  }
};
/**
 * Format to parts a date using the Intl.DateTimeFormat API. See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
 * for formatting options.
 */


exports.intlDateTimeRangeFormat = intlDateTimeRangeFormat;

var intlDateTimeFormatToParts = function intlDateTimeFormatToParts(date, format) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en-US";
  // HACK: IE11 does not have allow formatToParts. Instead of erroring out this
  // code will fall back to parsing via a regular expression on a time
  // formatted to "en-US" with 2-digit hour/minute/second
  var canDo = Intl.DateTimeFormat.prototype.formatToParts;

  if (canDo) {
    return intlDateTimeFormatCurried(format)(locale).formatToParts(date) // HACK: Some implementations of the Intl API lower-case the "P" in
    // "dayPeriod" (looking at you Node...)
    .map(function (part) {
      return part.type === "dayperiod" ? _objectSpread(_objectSpread({}, part), {}, {
        type: "dayPeriod"
      }) : part;
    });
  } else {
    var formattedString = intlDateTimeFormat(date, {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }, "en-US").replace(/\u200E/gi, ""); // remove any hidden spaces that might throw off our regex https://stackoverflow.com/questions/60981701/ie11-intl-datetimeformat-output-wont-match-regex

    var _formattedString$matc = formattedString.match(/(\d{2}):(\d{2}):(\d{2}) (\w{2})/i),
        _formattedString$matc2 = (0, _slicedToArray2["default"])(_formattedString$matc, 5),
        hour = _formattedString$matc2[1],
        minute = _formattedString$matc2[2],
        second = _formattedString$matc2[3],
        dayPeriod = _formattedString$matc2[4];

    return [{
      type: "hour",
      value: hour
    }, {
      type: "literal",
      value: ":"
    }, {
      type: "minute",
      value: minute
    }, {
      type: "literal",
      value: ":"
    }, {
      type: "second",
      value: second
    }, {
      type: "literal",
      value: " "
    }, {
      type: "dayPeriod",
      value: dayPeriod
    }];
  }
};
/**
 * Get resolved options from a format/locale using the Intl.DateTimeFormat API. See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/resolvedOptions
 * for options.
 */


exports.intlDateTimeFormatToParts = intlDateTimeFormatToParts;

var intlDateTimeFormatResolvedOptions = function intlDateTimeFormatResolvedOptions(format) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
  // HACK: IE11 does not have allow resolvedOptions. Instead of erroring out
  // this code will fall back to the typical response for "en-US" with format
  // set to 2-digit hour/minute/second. Even if we can use resolvedOptions, we
  // merge in the default options because some environments may leave certain
  // options off (like hourCycle in Node...).
  var canDo = Intl.DateTimeFormat.prototype.resolvedOptions;
  var defaultOptions = {
    locale: "en-US",
    calendar: "gregory",
    numberingSystem: "latn",
    timeZone: "UTC",
    hourCycle: "h12",
    hour12: true,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    fractionalSecondDigits: 0
  };

  if (canDo) {
    return _objectSpread(_objectSpread({}, defaultOptions), intlDateTimeFormatCurried(format)(locale).resolvedOptions());
  } else {
    return defaultOptions;
  }
};

exports.intlDateTimeFormatResolvedOptions = intlDateTimeFormatResolvedOptions;

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sleep;
function sleep(timeoutMs){return new Promise(function(resolve){setTimeout(resolve,timeoutMs);});}

/***/ }),
/* 221 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconDownloadSmallData: "data:image/svg+xml,%3csvg width='15' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M13.5 10v2a1 1 0 01-1 1h-10a1 1 0 01-1-1v-2M4.5 6l3 3 3-3M7.5 1v8'/%3e%3c/g%3e%3c/svg%3e",
  iconDownloadSmallWidth: 15,
  iconDownloadSmallHeight: 14
};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":""}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(1112);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(1113);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65), __webpack_require__(55)))

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(19)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));

/***/ }),
/* 226 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconEditData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M18.22 2.92l2.86 2.86L7.16 20H4v-3.16L18.22 2.92zm0-2.41a1 1 0 00-.7.28L2 16v4a1.84 1.84 0 001.89 2H8L23.2 6.47a1 1 0 000-1.4L18.93.81a1 1 0 00-.71-.29V.51z' fill='currentColor' fill-rule='nonzero'/%3e%3cpath d='M13.33 5.02l5.65 5.65M5.03 13.31l5.66 5.66' stroke='currentColor' stroke-width='2'/%3e%3c/g%3e%3c/svg%3e",
  iconEditWidth: 24,
  iconEditHeight: 24
};

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null));

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(1258);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadSiteConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__ = __webpack_require__(51);
var loadConfig=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var baseUrl;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:baseUrl=window.location.origin;_context.next=3;return fetch(baseUrl+"/config/config.json").then(function(response){return response.json();});case 3:appConfig=_context.sent;case 4:case"end":return _context.stop();}}},_callee,this);}));return function loadConfig(){return _ref.apply(this,arguments);};}();var loadSiteConfig=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var request,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["X" /* getNodeId */])()};args=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_55" /* ENDPOINT_GET_SITE_ASSET_CONFIG */]);_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context2.abrupt("return",_context2.sent);case 5:case"end":return _context2.stop();}}},_callee2,this);}));return function loadSiteConfig(){return _ref2.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var appConfig={};function getConfig(){return appConfig;}

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(49);





var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
var defaultProps = {
  noGutters: false
};
var Row = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      noGutters = _ref.noGutters,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "noGutters", "as"]);

  var decoratedBsPrefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'row');
  var sizePrefix = decoratedBsPrefix + "-cols";
  var classes = [];
  DEVICE_SIZES.forEach(function (brkPoint) {
    var propValue = props[brkPoint];
    delete props[brkPoint];
    var cols;

    if (propValue != null && typeof propValue === 'object') {
      cols = propValue.cols;
    } else {
      cols = propValue;
    }

    var infix = brkPoint !== 'xs' ? "-" + brkPoint : '';
    if (cols != null) classes.push("" + sizePrefix + infix + "-" + cols);
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, props, {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a.apply(void 0, [className, decoratedBsPrefix, noGutters && 'no-gutters'].concat(classes))
  }));
});
Row.displayName = 'Row';
Row.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Row);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mheValidationTabHeader__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NewValidationModal__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mhevalidation_context_MHEValidationContext__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PaginatedTable__ = __webpack_require__(92);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var ValidationTabBody=function ValidationTabBody(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__mhevalidation_context_MHEValidationContext__["a" /* MHEValidationContext */]),mheViewModel=_useContext.mheViewModel,mheDispatch=_useContext.mheDispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_14__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext2.showCustomAlert;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),selectedMac=_useState2[0],setSelectedMac=_useState2[1];var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openTriggerValidationModal=_useState4[0],setOpenTriggerValidationModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState6=_slicedToArray(_useState5,2),openActionsMenu=_useState6[0],setOpenActionsMenu=_useState6[1];var deviceList=props.deviceList,dispatch=props.dispatch,intl=props.intl;var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=true;setOpenActionsMenu(_open);},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=false;setOpenActionsMenu(_open);},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openTriggerValidationModal&&selectedMac){getMHEValidationData();var interval=setInterval(function(){if(!document.hidden){getMHEValidationData();}},Object(__WEBPACK_IMPORTED_MODULE_8__util_Util__["D" /* getAssetRefreshInterval */])());return function(){return clearInterval(interval);};}},[selectedMac,openTriggerValidationModal]);var getMHEValidationData=function getMHEValidationData(){mheDispatch({type:'LOAD_VIEW',data:{macAddress:selectedMac,dispatcher:mheDispatch}});};var getDeviceData=function getDeviceData(){setOpenTriggerValidationModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openTriggerValidationModal){getDeviceData();var interval=setInterval(function(){if(!document.hidden){getDeviceData();}},Object(__WEBPACK_IMPORTED_MODULE_8__util_Util__["D" /* getAssetRefreshInterval */])());return function(){return clearInterval(interval);};}},[openTriggerValidationModal]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,mheViewModel.mheValidationInformation.mheValidationInstanceList.length);},[mheViewModel.mheValidationInformation.mheValidationInstanceList]);var getSelectedDevice=function getSelectedDevice(){return deviceList.find(function(device){return device.mac===selectedMac;});};var downloadReport=function downloadReport(device,start,end){mheDispatch({type:"GET_PRESIGNED_URL",data:{objectKey:Object(__WEBPACK_IMPORTED_MODULE_8__util_Util__["Y" /* getObjectKeyForMHEValidationReport */])(device,start,end),dispatcher:mheDispatch,showCustomAlert:showCustomAlert}});};var getModalProps=function getModalProps(){return{selectedDevice:getSelectedDevice(),state:openTriggerValidationModal,onStateChange:setOpenTriggerValidationModal,dispatch:mheDispatch};};var getHeaderProps=function getHeaderProps(){return{selectedMac:selectedMac,setSelectedMac:setSelectedMac,deviceList:deviceList,setOpenTriggerValidationModal:setOpenTriggerValidationModal,openTriggerValidationModal:openTriggerValidationModal};};function renderMHEValidationTableHeader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{width:"15%"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"mhevalidation.starttime"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{width:"15%"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"mhevalidation.endtime"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{width:"12%"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"mhevalidation.status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{width:"11%"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"mhevalidation.result"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{width:"12%"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"mhevalidation.requestedby"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{width:"30%"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"mhevalidation.remarks"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{width:"5%"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"mhevalidation.action"})));}function isActionDisabled(status){return status!==__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_131" /* MHE_VALIDATION_STATUS_TYPE */].COMPLETED&&status!==__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_131" /* MHE_VALIDATION_STATUS_TYPE */].ERROR;}function renderMHEValidationTableRow(validation,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableRow"],{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{sortColumn:"name",width:"15%"},Object(__WEBPACK_IMPORTED_MODULE_8__util_Util__["U" /* getMHEValidationFormatDate */])(validation.startTime)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{sortColumn:"name",width:"15%"},Object(__WEBPACK_IMPORTED_MODULE_8__util_Util__["U" /* getMHEValidationFormatDate */])(validation.endTime)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{sortColumn:"name",width:"12%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{color:__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_130" /* MHE_VALIDATION_STATUS_COLORS */][validation.status]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,validation.status))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{sortColumn:"name",width:"11%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{color:__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_129" /* MHE_VALIDATION_RESULT_COLORS */][Object(__WEBPACK_IMPORTED_MODULE_8__util_Util__["f" /* chainWalk */])(function(){return validation.validationResultAttributes.result;},"N/A")]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,Object(__WEBPACK_IMPORTED_MODULE_8__util_Util__["f" /* chainWalk */])(function(){return validation.validationResultAttributes.result;},"N/A")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{sortColumn:"name",width:"12%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object(__WEBPACK_IMPORTED_MODULE_8__util_Util__["f" /* chainWalk */])(function(){return validation.validationAttributes.alias;},"-"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{sortColumn:"name",width:"30%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,Object(__WEBPACK_IMPORTED_MODULE_8__util_Util__["f" /* chainWalk */])(function(){return validation.validationAttributes.remarks;},""))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{width:"5%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",disabled:isActionDisabled(validation.status),onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"my-menu","aria-haspopup":"menu","aria-expanded":"false"},"..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_menu___default.a,{anchorNode:actionButtonRefs.current[index],open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},validation.status===__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_131" /* MHE_VALIDATION_STATUS_TYPE */].COMPLETED&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return downloadReport(getSelectedDevice(),validation.startTime,validation.endTime);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:"actions.download",defaultMessage:"Download report"}))))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__mheValidationTabHeader__["a" /* default */],getHeaderProps()),selectedMac&&(mheViewModel.loadingValidationDetails?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__loader_Loader__["a" /* default */],null):Object(__WEBPACK_IMPORTED_MODULE_8__util_Util__["f" /* chainWalk */])(function(){return mheViewModel.mheValidationInformation.mheValidationInstanceList.length;},0)===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:"alert.mheValidation",defaultMessage:"No validations present for this device."})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__PaginatedTable__["a" /* default */],{data:mheViewModel.mheValidationInformation.mheValidationInstanceList,renderRow:renderMHEValidationTableRow,renderHeader:renderMHEValidationTableHeader,numberOfRowsPerPage:10}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null))),openTriggerValidationModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__NewValidationModal__["a" /* default */],getModalProps()));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ValidationTabBody));

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavigationRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_escapeRegExp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_escapeRegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_escapeRegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_context_LogStoreContext__ = __webpack_require__(175);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/**
 * Custom hook that checks which route matches the current location
 * and returns its name in the object
 * @param routes
 * @param location
 * @returns Object
 */var useCurrentRoute=function useCurrentRoute(routes,location){var currentPath=location.pathname;var _ref=routes.find(function(route){return!!Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* matchPath */])(currentPath,{path:route.path});})||{},name=_ref.name;return{name:name};};/**
 * Returns Route components from a list of routes
 * @param routes
 * @returns JSX.Element
 */var NavigationRoutes=function NavigationRoutes(_ref2){var routes=_ref2.routes;return routes.map(function(_ref3){var path=_ref3.path,component=_ref3.component;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:path,path:path,component:component});});};/**
 * Component that handles the tab UI and changes
 * @returns JSX.Element
 * @param props
 * @param intl
 */var SelectLayout=function SelectLayout(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(useCurrentRoute(props.routes,props.location)),_useState2=_slicedToArray(_useState,2),state=_useState2[0],setState=_useState2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__store_context_LogStoreContext__["a" /* LogStoreContext */]),resetLogStore=_useContext.resetLogStore;var formatMessage=props.intl.formatMessage;var onSelectChange=function onSelectChange(selectedTab){props.routes.forEach(function(_ref4){var name=_ref4.name,path=_ref4.path;if(name===selectedTab){setState({name:name});props.history.push(path);}});resetLogStore();};var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),_useState4=_slicedToArray(_useState3,2),searchQuery=_useState4[0],setSearchQuery=_useState4[1];// Here we filter out options by creating an escaped regular expression
// out of the search query and test it against each option label
var searchRegExp=new RegExp(__WEBPACK_IMPORTED_MODULE_6_lodash_escapeRegExp___default()(searchQuery),"i");var matchedOptions=props.routes.filter(function(option){return!searchQuery||searchRegExp.test(option.name);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_box___default.a,{type:"fill",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"deviceManagement.filters",defaultMessage:"Select Device Type"})),"\xA0\xA0\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select___default.a,{value:state.name,onChange:onSelectChange,placeholder:formatMessage({id:"deviceManagement.tag"}),searchQuery:searchQuery,onSearch:setSearchQuery,width:200},matchedOptions.map(function(deviceType){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__["SelectOption"],{key:deviceType.name,value:deviceType.name,label:deviceType.name});}),!matchedOptions.length?// If there are no matched options, we display a message to our
// users saying their query returned no results
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"300",spacingInset:"600"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,{alignment:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"deviceManagement.noresults",defaultMessage:"No Results"}))):null)));};SelectLayout.propTypes={intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(SelectLayout));

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(549)();
}


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(580),
    isObjectLike = __webpack_require__(104);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 237 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 238 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 239 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(105),
    root = __webpack_require__(88);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(607),
    mapCacheDelete = __webpack_require__(614),
    mapCacheGet = __webpack_require__(616),
    mapCacheHas = __webpack_require__(617),
    mapCacheSet = __webpack_require__(618);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(241),
    setCacheAdd = __webpack_require__(620),
    setCacheHas = __webpack_require__(621);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 243 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 244 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(82),
    isSymbol = __webpack_require__(191);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(152),
    arrayMap = __webpack_require__(247),
    isArray = __webpack_require__(82),
    isSymbol = __webpack_require__(191);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 247 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 248 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 249 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    textFontFamilyAmazonEmber: "\"Amazon Ember\", \"Amazon Ember Arabic\", Arial, sans-serif",
    textFontFamilyAmazonEmberArabic: "\"Amazon Ember Arabic\", \"Amazon Ember\", Arial, sans-serif",
    textFontFamilyAmazonEmberDisplay: "\"Amazon Ember Display\", \"Amazon Ember\", Arial, sans-serif",
    textFontFamilyAmazonEmberMonospace: "\"Amazon Ember Monospace\", \"Courier New\", Courier, monospace",
    textFontFamilyBookerly: "Bookerly, Georgia, serif",
    textFontFamilyBookerlyDisplay: "\"Bookerly Display\", Georgia, serif",
    textFontSizeD300: 76,
    textFontSizeD200: 54,
    textFontSizeD100: 48,
    textFontSizeD50: 36,
    textFontSizeH600: 36,
    textFontSizeH500: 28,
    textFontSizeH400: 24,
    textFontSizeH300: 20,
    textFontSizeH200: 18,
    textFontSizeH100: 16,
    textFontSizeB500: 20,
    textFontSizeB400: 18,
    textFontSizeB300: 16,
    textFontSizeB200: 14,
    textFontSizeB100: 12,
    textFontWeightD300: 200,
    textFontWeightD200: 200,
    textFontWeightD100: 200,
    textFontWeightD50: 200,
    textFontWeightH600: 600,
    textFontWeightH500: 600,
    textFontWeightH400: 600,
    textFontWeightH300: 600,
    textFontWeightH200: 600,
    textFontWeightH100: 600,
    textFontWeightB500: 400,
    textFontWeightB400: 400,
    textFontWeightB300: 400,
    textFontWeightB200: 400,
    textFontWeightB100: 400,
    textLineHeightD300: "96px",
    textLineHeightD200: "64px",
    textLineHeightD100: "60px",
    textLineHeightD50: "48px",
    textLineHeightH600: "48px",
    textLineHeightH500: "36px",
    textLineHeightH400: "32px",
    textLineHeightH300: "24px",
    textLineHeightH200: "24px",
    textLineHeightH100: "20px",
    textLineHeightB500: "28px",
    textLineHeightB400: "28px",
    textLineHeightB300: "24px",
    textLineHeightB200: "20px",
    textLineHeightB100: "16px",
    textColorPrimary: tokens.themeForegroundPrimaryDefault,
    textColorSecondary: tokens.themeForegroundSecondaryDefault,
    textColorError: tokens.themeForegroundPrimaryError,
    textColorInverted: tokens.themeForegroundInvertedDefault,
    textListSpacingHorizontal: 20,
    textListSpacingVertical: 8
  }
};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var _default = canUseDOM;
exports["default"] = _default;

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return metricType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ledControllerColorOrder; });
var metricType={COUNT:"count",TIME:"time"};var ledControllerColorOrder={RGB:"RGB",RBG:"RBG",BRG:"BRG",BGR:"BGR",GBR:"GBR",GRB:"GRB"};

/***/ }),
/* 252 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertErrorSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23FF7494' fill-rule='nonzero' cx='8' cy='8' r='8'/%3e%3cpath d='M8 16A8 8 0 108 0a8 8 0 000 16zm0-1A7 7 0 118 1a7 7 0 010 14z' fill='%23CC0C39' fill-rule='nonzero'/%3e%3cpath d='M8 4v4' stroke='%23232F3E' stroke-width='2' stroke-linecap='round'/%3e%3ccircle fill='%23232F3E' fill-rule='nonzero' cx='8' cy='12' r='1'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertErrorSmallWidth: 16,
  iconAlertErrorSmallHeight: 16
};

/***/ }),
/* 253 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    buttonMotionDuration: "100ms",
    buttonMotionFunction: "ease",
    buttonBackgroundColorPrimaryDefault: tokens.themeForegroundAccentDefault,
    buttonBackgroundColorPrimaryHover: tokens.themeForegroundAccentHover,
    buttonBackgroundColorPrimaryPressed: tokens.themeForegroundAccentPressed,
    buttonBackgroundColorPrimaryDisabled: tokens.themeForegroundAccentDisabled,
    buttonBackgroundColorSecondaryDefault: tokens.themeBackgroundTertiaryDefault,
    buttonBackgroundColorSecondaryHover: tokens.themeBackgroundTertiaryHover,
    buttonBackgroundColorSecondaryPressed: tokens.themeBackgroundTertiaryPressed,
    buttonBackgroundColorSecondaryDisabled: tokens.themeBackgroundTertiaryDisabled,
    buttonBackgroundColorTertiaryDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorTertiaryHover: tokens.themeForegroundAccentHover,
    buttonBackgroundColorTertiaryPressed: tokens.themeForegroundAccentPressed,
    buttonBackgroundColorLinkDarkBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorLinkDarkBackdropHover: "rgba(255, 255, 255, 0.22)",
    buttonBackgroundColorLinkDarkBackdropPressed: "rgba(255, 255, 255, 0.36)",
    buttonBackgroundColorLinkLightBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorLinkLightBackdropHover: "rgba(11, 12, 12, 0.1)",
    buttonBackgroundColorLinkLightBackdropPressed: "rgba(11, 12, 12, 0.26)",
    buttonBackgroundColorIconDarkBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorIconDarkBackdropHover: "rgba(255, 255, 255, 0.22)",
    buttonBackgroundColorIconDarkBackdropPressed: "rgba(255, 255, 255, 0.36)",
    buttonBackgroundColorIconLightBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorIconLightBackdropHover: "rgba(11, 12, 12, 0.1)",
    buttonBackgroundColorIconLightBackdropPressed: "rgba(11, 12, 12, 0.26)",
    buttonForegroundColorPrimaryDefault: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorPrimaryDisabled: tokens.themeBackgroundAccentDisabled,
    buttonForegroundColorSecondaryDefault: tokens.themeForegroundPrimaryDefault,
    buttonForegroundColorSecondaryDisabled: tokens.themeForegroundTertiaryDisabled,
    buttonForegroundColorTertiaryDefault: tokens.themeForegroundAccentDefault,
    buttonForegroundColorTertiaryHover: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorTertiaryFocus: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorTertiaryPressed: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorTertiaryDisabled: tokens.themeBorderAccentDisabled,
    buttonForegroundColorLinkDarkBackdropDefault: tokens.themePalette300,
    buttonForegroundColorLinkDarkBackdropHover: tokens.themePalette200,
    buttonForegroundColorLinkDarkBackdropPressed: tokens.themePalette100,
    buttonForegroundColorLinkDarkBackdropDisabled: tokens.themePaletteMuted500,
    buttonForegroundColorLinkLightBackdropDefault: tokens.themePalette500,
    buttonForegroundColorLinkLightBackdropHover: tokens.themePalette600,
    buttonForegroundColorLinkLightBackdropPressed: tokens.themePalette700,
    buttonForegroundColorLinkLightBackdropDisabled: tokens.themePaletteMuted200,
    buttonForegroundColorIconDarkBackdropDefault: "#FFFFFF",
    buttonForegroundColorIconDarkBackdropDisabled: "#697576",
    buttonForegroundColorIconLightBackdropDefault: "#232F3E",
    buttonForegroundColorIconLightBackdropDisabled: "#BBC0C1",
    buttonFontSizeSmall: 14,
    buttonFontSizeMedium: 16,
    buttonFontSizeLarge: 18,
    buttonFontSizeXlarge: 28,
    buttonBorderWidth: 2,
    buttonBorderRadius: 4,
    buttonBorderColorTertiaryDefault: tokens.themeForegroundAccentDefault,
    buttonBorderColorTertiaryHover: tokens.themeForegroundAccentHover,
    buttonBorderColorTertiaryPressed: tokens.themeForegroundAccentPressed,
    buttonBorderColorTertiaryDisabled: tokens.themeBorderAccentDisabled,
    buttonSpacingInsetHorizontalSmall: 10,
    buttonSpacingInsetHorizontalMedium: 16,
    buttonSpacingInsetHorizontalLarge: 16,
    buttonSpacingInsetHorizontalXlarge: 24,
    buttonHeightSmall: 32,
    buttonHeightMedium: 40,
    buttonHeightLarge: 48,
    buttonHeightXlarge: 64,
    buttonFocusOutlineOffset: 4
  }
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(255),
    baseIteratee = __webpack_require__(186),
    toInteger = __webpack_require__(130);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 255 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var noTextWrap = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};
var _default = noTextWrap;
exports["default"] = _default;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _keycode = _interopRequireDefault(__webpack_require__(72));

var _emotion = __webpack_require__(11);

var _focus = _interopRequireDefault(__webpack_require__(109));

var _isElementOfAny = _interopRequireDefault(__webpack_require__(194));

var _functional = __webpack_require__(38);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return (0, _emotion.css)({
    "&[mdn-row-background-color-custom] > *": {
      backgroundColor: "".concat(backgroundColor, " !important")
    }
  });
}, ["backgroundColor"]);
/**
 * Used to render a table row. Children must be TableCell components. Place this
 * as a child of the Table component.
 */

var TableRow = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TableRow, _React$Component);

  var _super = _createSuper(TableRow);

  function TableRow() {
    var _this;

    (0, _classCallCheck2["default"])(this, TableRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isRow", (0, _isElementOfAny["default"])(_this.props.rowComponents));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDown", function (event) {
      var key = (0, _keycode["default"])(event);

      if (key === "space" || key === "enter") {
        _this.props.onClick(); // Prevent default space and enter behavior (scroll or submit,
        // respectively)


        event.preventDefault();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderRow", function (_ref2) {
      var parent = _ref2.parent,
          cells = _ref2.cells,
          focus = _ref2.focus,
          focusTrigger = _ref2.focusTrigger,
          _ref2$focusProps = _ref2.focusProps,
          focusProps = _ref2$focusProps === void 0 ? {} : _ref2$focusProps;
      var props = _this.props;
      var clickable = Boolean(props.onClick);
      var hexBgColor = props.backgroundColor && props.backgroundColor !== "primary" && props.backgroundColor !== "secondary" ? props.backgroundColor : undefined;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
      return /*#__PURE__*/_react["default"].createElement("tr", (0, _extends2["default"])({}, passThroughProps, {
        className: styles({
          backgroundColor: hexBgColor
        }),
        onClick: props.onClick,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onKeyDown: clickable ? _this.onKeyDown : undefined,
        tabIndex: clickable ? "0" : undefined,
        "mdn-row-focus": focus && focusTrigger === "keyboard" ? "" : undefined,
        "mdn-row-parent": parent ? "" : undefined,
        "mdn-row-highlight": props.highlight ? "" : undefined,
        "mdn-row-background-color-primary": props.backgroundColor === "primary" ? "" : undefined,
        "mdn-row-background-color-secondary": props.backgroundColor === "secondary" ? "" : undefined,
        "mdn-row-background-color-custom": hexBgColor ? "" : undefined,
        "mdn-row-highlight-on-hover": props.highlightOnHover ? "" : undefined,
        "mdn-row-highlight-on-press": props.onClick && props.highlightOnHover ? "" : undefined,
        "mdn-row-open": parent && props.open ? "" : undefined,
        "mdn-row-child": props.child ? "" : undefined,
        "mdn-row-last-child": props.lastChild ? "" : undefined
      }, focusProps), cells);
    });
    return _this;
  }

  (0, _createClass2["default"])(TableRow, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onClick = _this$props.onClick,
          open = _this$props.open,
          children = _this$props.children;
      var childRows = [];
      var cells = []; // Separate cells from nested rows

      _react["default"].Children.forEach(children, function (child) {
        if (_this2.isRow(child)) {
          childRows.push(child);
        } else {
          cells.push(child);
        }
      });

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, onClick ? /*#__PURE__*/_react["default"].createElement(_focus["default"], null, function (focus) {
        return _this2.renderRow(_objectSpread({
          parent: childRows.length > 0,
          cells: cells
        }, focus));
      }) : this.renderRow({
        parent: childRows.length > 0,
        cells: cells
      }), open ? childRows.map(function (row, index) {
        return /*#__PURE__*/_react["default"].cloneElement(row, {
          child: true,
          lastChild: index === childRows.length - 1
        });
      }) : null);
    }
  }]);
  return TableRow;
}(_react["default"].Component);

TableRow.propTypes =  false ? {
  /**
   * A list of `TableCell` elements, as well as any nested `TableRow` elements
   * for expandable tables.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Set the cell's background color using a preset, or using a string
   * containing any valid CSS color. WARNING: AA accessibility requires
   * a color contrast ratio of 4.5:1 or higher. Please keep this in mind
   * when providing custom background colors, and be sure to check your
   * contrast ratios with a tool like https://contrastchecker.com/
   *
   * @since 5.x
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary"]), _propTypes["default"].string]),

  /**
   * Indicates that this row is a child of another row. This prop is set
   * automatically when one TableRow is nested inside another, so in most
   * cases you should not have to touch this.
   */
  child: _propTypes["default"].bool,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * This determines if the row is highlighted.
   *
   * @deprecated 5.x
   */
  highlight: _propTypes["default"].bool,

  /**
   * This determines if the row should highlight when the user hovers over it.
   * If the row is clickable (i.e. a click handler is passed to the `onClick`
   * prop) then it will also take on a pressed when the user activates it.
   */
  highlightOnHover: _propTypes["default"].bool,

  /**
   * Indicates that this row is the last child of another row. This prop is
   * set automatically when one TableRow is nested inside another, so in most
   * cases you should not have to touch this.
   */
  lastChild: _propTypes["default"].bool,

  /**
   * Determines if rows that are children of this row are visible or hidden.
   */
  open: _propTypes["default"].bool,

  /**
   * The component that will render any nested table rows (for expandable
   * tables). Inherits the value passed to the "rowComponents" prop of Table by
   * default.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  rowComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * Bind a click handler to the row. This will make the row focuseable via
   * keyboard. Avoid using this if the row contains clickable children (e.g.
   * a link or a button).
   */
  onClick: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves over the component. The [mouseenter event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseenter_event)
   * is passed as the first argument to the function.
   *
   * This is helpful for tracking the row's hovered state.
   */
  onMouseEnter: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves off of the component. The [mouseleave event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseleave_event)
   * is passed as the first argument to the function.
   *
   * This is helpful for tracking the row's hovered state.
   */
  onMouseLeave: _propTypes["default"].func
} : {};
var _default = TableRow;
exports["default"] = _default;

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid_index_js__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subMilliseconds_index_js__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format_formatters_index_js__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format_longFormatters_index_js__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_requiredArgs_index_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_defaultOptions_index_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_defaultLocale_index_js__ = __webpack_require__(745);










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  Object(__WEBPACK_IMPORTED_MODULE_8__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_9__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : __WEBPACK_IMPORTED_MODULE_10__lib_defaultLocale_index_js__["a" /* default */];
  var firstWeekContainsDate = Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a" /* default */])(dirtyDate);

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isValid_index_js__["a" /* default */])(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = Object(__WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(originalDate);
  var utcDate = Object(__WEBPACK_IMPORTED_MODULE_1__subMilliseconds_index_js__["a" /* default */])(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = __WEBPACK_IMPORTED_MODULE_4__lib_format_longFormatters_index_js__["a" /* default */][firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = __WEBPACK_IMPORTED_MODULE_3__lib_format_formatters_index_js__["a" /* default */][firstCharacter];

    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["b" /* isProtectedWeekYearToken */])(substring)) {
        Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(substring, dirtyFormatStr, String(dirtyDate));
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["a" /* isProtectedDayOfYearToken */])(substring)) {
        Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(substring, dirtyFormatStr, String(dirtyDate));
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(45);


function startOfUTCISOWeek(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var weekStartsOn = 1;
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultOptions_index_js__ = __webpack_require__(131);




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_3__defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var weekStartsOn = Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = nextTick;
} else {
  module.exports = process.nextTick;
}

function nextTick(fn) {
  var args = new Array(arguments.length - 1);
  var i = 0;
  while (i < args.length) {
    args[i++] = arguments[i];
  }
  process.nextTick(function afterTick() {
    fn.apply(null, args);
  });
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var buffer = __webpack_require__(19);
var Buffer = buffer.Buffer;
var SlowBuffer = buffer.SlowBuffer;
var MAX_LEN = buffer.kMaxLength || 2147483647;
exports.alloc = function alloc(size, fill, encoding) {
  if (typeof Buffer.alloc === 'function') {
    return Buffer.alloc(size, fill, encoding);
  }
  if (typeof encoding === 'number') {
    throw new TypeError('encoding must not be number');
  }
  if (typeof size !== 'number') {
    throw new TypeError('size must be a number');
  }
  if (size > MAX_LEN) {
    throw new RangeError('size is too large');
  }
  var enc = encoding;
  var _fill = fill;
  if (_fill === undefined) {
    enc = undefined;
    _fill = 0;
  }
  var buf = new Buffer(size);
  if (typeof _fill === 'string') {
    var fillBuf = new Buffer(_fill, enc);
    var flen = fillBuf.length;
    var i = -1;
    while (++i < size) {
      buf[i] = fillBuf[i % flen];
    }
  } else {
    buf.fill(_fill);
  }
  return buf;
}
exports.allocUnsafe = function allocUnsafe(size) {
  if (typeof Buffer.allocUnsafe === 'function') {
    return Buffer.allocUnsafe(size);
  }
  if (typeof size !== 'number') {
    throw new TypeError('size must be a number');
  }
  if (size > MAX_LEN) {
    throw new RangeError('size is too large');
  }
  return new Buffer(size);
}
exports.from = function from(value, encodingOrOffset, length) {
  if (typeof Buffer.from === 'function' && (!global.Uint8Array || Uint8Array.from !== Buffer.from)) {
    return Buffer.from(value, encodingOrOffset, length);
  }
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number');
  }
  if (typeof value === 'string') {
    return new Buffer(value, encodingOrOffset);
  }
  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    var offset = encodingOrOffset;
    if (arguments.length === 1) {
      return new Buffer(value);
    }
    if (typeof offset === 'undefined') {
      offset = 0;
    }
    var len = length;
    if (typeof len === 'undefined') {
      len = value.byteLength - offset;
    }
    if (offset >= value.byteLength) {
      throw new RangeError('\'offset\' is out of bounds');
    }
    if (len > value.byteLength - offset) {
      throw new RangeError('\'length\' is out of bounds');
    }
    return new Buffer(value.slice(offset, offset + len));
  }
  if (Buffer.isBuffer(value)) {
    var out = new Buffer(value.length);
    value.copy(out, 0, 0, value.length);
    return out;
  }
  if (value) {
    if (Array.isArray(value) || (typeof ArrayBuffer !== 'undefined' && value.buffer instanceof ArrayBuffer) || 'length' in value) {
      return new Buffer(value);
    }
    if (value.type === 'Buffer' && Array.isArray(value.data)) {
      return new Buffer(value.data);
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ' + 'ArrayBuffer, Array, or array-like object.');
}
exports.allocUnsafeSlow = function allocUnsafeSlow(size) {
  if (typeof Buffer.allocUnsafeSlow === 'function') {
    return Buffer.allocUnsafeSlow(size);
  }
  if (typeof size !== 'number') {
    throw new TypeError('size must be a number');
  }
  if (size >= MAX_LEN) {
    throw new RangeError('size is too large');
  }
  return new SlowBuffer(size);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/*<replacement>*/
var processNextTick = __webpack_require__(262);
/*</replacement>*/

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(162);
util.inherits = __webpack_require__(135);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(772)
};
/*</replacement>*/

/*<replacement>*/
var Stream;
(function () {
  try {
    Stream = __webpack_require__(85);
  } catch (_) {} finally {
    if (!Stream) Stream = __webpack_require__(84).EventEmitter;
  }
})();
/*</replacement>*/

var Buffer = __webpack_require__(19).Buffer;
/*<replacement>*/
var bufferShim = __webpack_require__(263);
/*</replacement>*/

util.inherits(Writable, Stream);

function nop() {}

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

var Duplex;
function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(110);

  options = options || {};

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~ ~this.highWaterMark;

  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function writableStateGetBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
    });
  } catch (_) {}
})();

var Duplex;
function Writable(options) {
  Duplex = Duplex || __webpack_require__(110);

  // Writable ctor is applied to Duplexes, though they're not
  // instanceof Writable, they're instanceof Readable.
  if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  processNextTick(cb, er);
}

// If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;
  // Always throw error if a null is written
  // if we are not in object mode then throw
  // if it is not a buffer, string, or undefined.
  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    processNextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (Buffer.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = bufferShim.from(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, cb) {
  chunk = decodeChunk(state, chunk, encoding);

  if (Buffer.isBuffer(chunk)) encoding = 'buffer';
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) processNextTick(cb, er);else cb(er);

  stream._writableState.errorEmitted = true;
  stream.emit('error', er);
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
        afterWrite(stream, state, finished, cb);
      }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    while (entry) {
      buffer[count] = entry;
      entry = entry.next;
      count += 1;
    }

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequestCount = 0;
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}

function prefinish(stream, state) {
  if (!state.prefinished) {
    state.prefinished = true;
    stream.emit('prefinish');
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    if (state.pendingcb === 0) {
      prefinish(stream, state);
      state.finished = true;
      stream.emit('finish');
    } else {
      prefinish(stream, state);
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;

  this.finish = function (err) {
    var entry = _this.entry;
    _this.entry = null;
    while (entry) {
      var cb = entry.callback;
      state.pendingcb--;
      cb(err);
      entry = entry.next;
    }
    if (state.corkedRequestsFree) {
      state.corkedRequestsFree.next = _this;
    } else {
      state.corkedRequestsFree = _this;
    }
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55), __webpack_require__(375).setImmediate))

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(110);

/*<replacement>*/
var util = __webpack_require__(162);
util.inherits = __webpack_require__(135);
/*</replacement>*/

util.inherits(Transform, Duplex);

function TransformState(stream) {
  this.afterTransform = function (er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
  this.writeencoding = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));

  ts.writechunk = null;
  ts.writecb = null;

  if (data !== null && data !== undefined) stream.push(data);

  cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = new TransformState(this);

  // when the writable side finishes, then flush out anything remaining.
  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  this.once('prefinish', function () {
    if (typeof this._flush === 'function') this._flush(function (er) {
      done(stream, er);
    });else done(stream);
  });
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('Not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

function done(stream, er) {
  if (er) return stream.emit('error', er);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var ts = stream._transformState;

  if (ws.length) throw new Error('Calling transform done when ws.length != 0');

  if (ts.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {
var createHash = __webpack_require__(132);
var inherits = __webpack_require__(42)

var Transform = __webpack_require__(85).Transform

var ZEROS = new Buffer(128)
ZEROS.fill(0)

function Hmac(alg, key) {
  Transform.call(this)
  alg = alg.toLowerCase()
  if (typeof key === 'string') {
    key = new Buffer(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = createHash(alg).update(key).digest()

  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = new Buffer(blocksize)
  var opad = this._opad = new Buffer(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = createHash(alg).update(ipad)
}

inherits(Hmac, Transform)

Hmac.prototype.update = function (data, enc) {
  this._hash.update(data, enc)

  return this
}

Hmac.prototype._transform = function (data, _, next) {
  this._hash.update(data)

  next()
}

Hmac.prototype._flush = function (next) {
  this.push(this.digest())

  next()
}

Hmac.prototype.digest = function (enc) {
  var h = this._hash.digest()

  return createHash(this._alg).update(this._opad).update(h).digest(enc)
}

module.exports = function createHmac(alg, key) {
  return new Hmac(alg, key)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(780);
exports.Cipher = __webpack_require__(781);
exports.DES = __webpack_require__(782);
exports.CBC = __webpack_require__(783);
exports.EDE = __webpack_require__(784);


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(785)
exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
var deciphers = __webpack_require__(787)
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
var modes = __webpack_require__(197)
function getCiphers () {
  return Object.keys(modes)
}
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(61);
var randomBytes = __webpack_require__(160);
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdtaDeviceStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAdtfDeviceStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDeviceHealthStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__ = __webpack_require__(51);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getAdtaDeviceStatus=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(macAddressList){var request,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),macAddressList:macAddressList};args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_35" /* ENDPOINT_GET_ADTA_STATUS */]);_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context.abrupt("return",_context.sent);case 5:case"end":return _context.stop();}}},_callee,this);}));return function getAdtaDeviceStatus(_x){return _ref.apply(this,arguments);};}();var getAdtfDeviceStatus=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(macAddressList){var request,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),macAddressList:macAddressList};args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_36" /* ENDPOINT_GET_ADTF_STATUS */]);_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context2.abrupt("return",_context2.sent);case 5:case"end":return _context2.stop();}}},_callee2,this);}));return function getAdtfDeviceStatus(_x2){return _ref2.apply(this,arguments);};}();var getDeviceHealthStatus=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(deviceDetailsList){var request,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),deviceDetailsList:deviceDetailsList};args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_48" /* ENDPOINT_GET_DEVICE_HEALTH_STATUS */]);_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context3.abrupt("return",_context3.sent);case 5:case"end":return _context3.stop();}}},_callee3,this);}));return function getDeviceHealthStatus(_x3){return _ref3.apply(this,arguments);};}();

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(853);
} else {
  module.exports = require("./prop-types");
}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAlignment = exports.parseFlexAlignment = exports.parseSpacing = void 0;

var _spacing = _interopRequireDefault(__webpack_require__(854));

var _token = __webpack_require__(113);

// Parses the value for a spacing prop. This turns a string of spacing names
// like "medium" or "small medium" into an array of spacing values like ["16px"]
// or ["8px", "16px"].
var parseSpacing = function parseSpacing(spacing) {
  return spacing ? spacing.split(" ").map(function (spacing) {
    return (0, _token.getToken)(_spacing["default"], "spacing", spacing) || 0;
  }) : [];
}; // Parses the value for a flex alignment prop. Given a valid flex alignment prop
// value this will return an array of two values representing vertical and
// horizontal flex alignment respectively.


exports.parseSpacing = parseSpacing;

var parseFlexAlignment = function parseFlexAlignment(alignment) {
  return alignment.split(" ");
}; // Parses the value for a alignment prop. Given a valid alignment prop value
// this will return an array of two values representing x and y alignment
// respectively.


exports.parseFlexAlignment = parseFlexAlignment;

var parseAlignment = function parseAlignment(alignment) {
  var values = alignment.split(" ");
  return {
    x: values[1],
    y: values[0]
  };
};

exports.parseAlignment = parseAlignment;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(167);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useTheme", {
  enumerable: true,
  get: function get() {
    return _theme.useTheme;
  }
});
Object.defineProperty(exports, "Style", {
  enumerable: true,
  get: function get() {
    return _theme.Style;
  }
});
exports["default"] = void 0;

__webpack_require__(858);

var _theme = _interopRequireWildcard(__webpack_require__(859));

var _default = _theme["default"];
exports["default"] = _default;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _transitionController = _interopRequireDefault(__webpack_require__(872));

var _default = _transitionController["default"];
exports["default"] = _default;

/***/ }),
/* 275 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    scrimBackgroundColor: tokens.themeBackgroundOverlayDefault,
    scrimMotionTiming: "150ms",
    scrimMotionFunction: "ease",
    scrimElevation: 60
  }
};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _inputBox = _interopRequireDefault(__webpack_require__(896));

var _default = _inputBox["default"];
exports["default"] = _default;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var inputReset = function inputReset(_ref) {
  var textColor = _ref.textColor,
      placeholderColor = _ref.placeholderColor,
      empty = _ref.empty;
  return {
    display: "block",
    backgroundColor: "transparent",
    border: "none",
    padding: 0,
    width: "100%",
    color: textColor,
    WebkitTextFillColor: empty ? placeholderColor : textColor,
    fontFamily: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    lineHeight: "inherit",
    outline: "none",
    // Base built-in style resets
    WebkitAppearance: "none",
    MozAppearance: "textfield",
    // Remove the clear button from search inputs
    "::-ms-clear": {
      display: "none"
    },
    "::-ms-reveal": {
      display: "none"
    },
    "::-webkit-search-decoration": {
      display: "none"
    },
    "::-webkit-search-cancel-button": {
      display: "none"
    },
    "::-webkit-search-results-button": {
      display: "none"
    },
    "::-webkit-search-results-decoration ": {
      display: "none"
    },
    // Remove the built-in error outline
    ":invalid": {
      boxShadow: "none"
    },
    ":-moz-submit-invalid": {
      boxShadow: "none"
    },
    ":-moz-ui-invalid": {
      boxShadow: "none"
    },
    // Remove the numeric input up/down buttons in webkit
    "::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: "0"
    },
    "::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: "0"
    },
    // Set the placeholder colors
    "::-moz-placeholder": {
      opacity: "1",
      color: placeholderColor
    },
    ":-moz-placeholder": {
      opacity: "1",
      color: placeholderColor
    },
    "::-ms-input-placeholder": {
      opacity: "1",
      color: placeholderColor
    },
    ":-ms-input-placeholder": {
      opacity: "1",
      color: placeholderColor
    },
    "::-webkit-input-placeholder": {
      opacity: "1",
      color: placeholderColor
    },
    "::placeholder": {
      opacity: "1",
      color: placeholderColor
    }
  };
};

var _default = inputReset;
exports["default"] = _default;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(905),
    baseKeys = __webpack_require__(914),
    isArrayLike = __webpack_require__(421);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 279 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(919),
    baseMatchesProperty = __webpack_require__(970),
    identity = __webpack_require__(980),
    isArray = __webpack_require__(90),
    property = __webpack_require__(981);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(140),
    root = __webpack_require__(89);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(935),
    mapCacheDelete = __webpack_require__(942),
    mapCacheGet = __webpack_require__(944),
    mapCacheHas = __webpack_require__(945),
    mapCacheSet = __webpack_require__(946);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(90),
    isSymbol = __webpack_require__(215);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _react = _interopRequireDefault(__webpack_require__(0));

var _meridianReactInputMask = _interopRequireDefault(__webpack_require__(985));

/**
 * This class can be used to instantiate an input mask object that can be passed
 * to the `mask` prop of the `Input` component. For example a basic US phone
 * number mask can be created like this:
 *
 * ```
 * import Input from "@amzn/meridian/input"
 * import InputMask from "@amzn/meridian/input/mask"
 *
 * const phoneMask = new InputMask("(###)###-####")
 * <Input mask={phoneMask} />
 * ```
 */
var InputMask = /*#__PURE__*/function () {
  function InputMask(mask) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, InputMask);
    var _options$placeholderC = options.placeholderChar,
        placeholderChar = _options$placeholderC === void 0 ? String.fromCharCode(8199) : _options$placeholderC,
        _options$formatChars = options.formatChars,
        formatChars = _options$formatChars === void 0 ? {
      "#": "[0-9]",
      x: "[A-Za-z]",
      "*": "[A-Za-z0-9]"
    } : _options$formatChars,
        _options$alwaysShow = options.alwaysShow,
        alwaysShow = _options$alwaysShow === void 0 ? false : _options$alwaysShow,
        _options$beforeMasked = options.beforeMaskedValueChange,
        beforeMaskedValueChange = _options$beforeMasked === void 0 ? undefined : _options$beforeMasked;
    this.alwaysShow = alwaysShow;
    this.mask = mask;
    this.placeholderChar = placeholderChar;
    this.formatChars = formatChars;
    this.beforeMaskedValueChange = beforeMaskedValueChange;
  }

  (0, _createClass2["default"])(InputMask, [{
    key: "getElement",
    value: function getElement(props) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$alwaysShow2 = options.alwaysShow,
          alwaysShow = _options$alwaysShow2 === void 0 ? this.alwaysShow : _options$alwaysShow2,
          _options$placeholderC2 = options.placeholderChar,
          placeholderChar = _options$placeholderC2 === void 0 ? this.placeholderChar : _options$placeholderC2,
          _options$formatChars2 = options.formatChars,
          formatChars = _options$formatChars2 === void 0 ? this.formatChars : _options$formatChars2,
          _options$beforeMasked2 = options.beforeMaskedValueChange,
          beforeMaskedValueChange = _options$beforeMasked2 === void 0 ? this.beforeMaskedValueChange : _options$beforeMasked2;
      return /*#__PURE__*/_react["default"].createElement(_meridianReactInputMask["default"], (0, _extends2["default"])({}, props, {
        alwaysShowMask: alwaysShow,
        maskChar: placeholderChar,
        formatChars: formatChars,
        beforeMaskedValueChange: beforeMaskedValueChange,
        mask: this.mask
      }));
    }
  }]);
  return InputMask;
}();

var _default = InputMask;
exports["default"] = _default;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _highlightSubstring = _interopRequireDefault(__webpack_require__(999));

var _default = _highlightSubstring["default"];
exports["default"] = _default;

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = parseISO;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_index_js__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(83);



/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, options) {
  var _options$additionalDi;

  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var additionalDigits = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both

  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["a" /* millisecondsInHour */] + minutes * __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["b" /* millisecondsInMinute */] + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["a" /* millisecondsInHour */] + minutes * __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["b" /* millisecondsInMinute */]);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(45);


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = endOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(45);


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    timePickerPopoverElevation: 70,
    timePickerPopoverBackgroundColor: tokens.themeBackgroundPrimaryDefault,
    timePickerPopoverBorderWidth: 1,
    timePickerPopoverBorderRadius: 4,
    timePickerPopoverBorderColor: tokens.themeBorderPrimaryDefault,
    timePickerPopoverDropShadowOffsetX: 0,
    timePickerPopoverDropShadowOffsetY: 2,
    timePickerPopoverDropShadowBlur: 4,
    timePickerPopoverDropShadowSpread: 0,
    timePickerPopoverDropShadowColor: "rgba(11, 12, 12, 0.16)",
    timePickerPopoverSpacingVertical: 8,
    timePickerOptionsBorderRadius: 4,
    timePickerOptionsSpacingVertical: 4,
    timePickerOptionsSpacingHorizontal: 2,
    timePickerErrorTooltipElevation: 80,
    timePickerInputValueLetterSpacing: 2,
    timePickerInputPlaceholderFontSize: 13,
    timePickerInputPlaceholderLineHeight: "18px",
    timePickerInputPlaceholderColorDefault: tokens.themeForegroundSecondaryDefault,
    timePickerInputPlaceholderColorDisabled: tokens.themeForegroundPrimaryDisabled
  }
};

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThinClientOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_ThinClientOverviewReducer__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var ThinClientOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var ThinClientOverviewContextProvider=function ThinClientOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},thinClientDeviceInformation:{},macAddressArray:[],loadingOverview:true,loadingStatusDevices:{}};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_ThinClientOverviewReducer__["a" /* ThinClientOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ThinClientOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (ThinClientOverviewContextProvider);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export metricProcessName */
/* unused harmony export extractLedControllerDeviceList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLedController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAisleTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getLedControllerTypes; });
/* unused harmony export getLedControllerTypesFromResponse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getLedControllerDeviceStatusDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setLEDControllerDisableMonitoringData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateLedControllerStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return postUpdatedRemarkToDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setDefaultValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getLedControllerAssetDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateLedControllerAssetData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getLedControllerDevices; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_LEDControllerUtil__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_RetryLogic__ = __webpack_require__(1059);
var fetchLedControllerDeviceStatusDetails=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher,showCustomAlert,isDataUpdated){for(var _len=arguments.length,isDataUpdatedArgs=Array(_len>3?_len-3:0),_key=3;_key<_len;_key++){isDataUpdatedArgs[_key-3]=arguments[_key];}return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7__util_RetryLogic__["a" /* fetchLatestDataWithRetry */])({fetchFn:function fetchFn(){return callGetLedControllerDeviceDetails(dispatcher);},conditionFn:function conditionFn(result){return isDataUpdated.apply(undefined,[result.ledControllerDeviceInformation].concat(_toConsumableArray(isDataUpdatedArgs)));},onSuccess:function onSuccess(result){return dispatchLedControllerDeviceStatusDetails(dispatcher,result);},onFailure:function onFailure(lastResult){return dispatchLedControllerDeviceStatusDetails(dispatcher,lastResult);},maxRetries:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_119" /* MAX_RETRIES */],interval:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_156" /* POLLING_INTERVAL */],onStart:function onStart(){return showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["v" /* ALERT_PAGE_REFRESH_MESSAGE */]);}});case 2:case"end":return _context.stop();}}},_callee,this);}));return function fetchLedControllerDeviceStatusDetails(_x,_x2,_x3){return _ref.apply(this,arguments);};}();var callAddAssetV2=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatcher,requestBody,showCustomAlert){var startTime,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:startTime=Date.now();_context3.next=3;return setLoadingStatus(dispatcher,true);case 3:_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["b" /* addAssetV2 */])(requestBody);case 5:response=_context3.sent;if(!(response.status===200)){_context3.next=13;break;}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addLedControllerAssetV2",true,false);showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["q" /* ALERT_CREATE_SUCCESS_ASSET_MESSAGE */]);_context3.next=11;return fetchLedControllerDeviceStatusDetails(dispatcher,showCustomAlert,__WEBPACK_IMPORTED_MODULE_6__util_LEDControllerUtil__["h" /* isAssetCreated */],requestBody.ledControllerConfig.macAddress);case 11:_context3.next=18;break;case 13:isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addLedControllerAssetV2",false,isFault);showCustomAlert(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(response.errorResponse.errorMessage).message;},__WEBPACK_IMPORTED_MODULE_2__util_Constants__["l" /* ALERT_ADD_ASSET_MESSAGE */]));_context3.next=18;return setLoadingStatus(dispatcher,false);case 18:case"end":return _context3.stop();}}},_callee3,this);}));return function callAddAssetV2(_x7,_x8,_x9){return _ref3.apply(this,arguments);};}();var setLoadingStatus=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatcher,status){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatcher({type:'SET_LOADING',data:{loadingOverview:status}});case 1:case"end":return _context4.stop();}}},_callee4,this);}));return function setLoadingStatus(_x10,_x11){return _ref4.apply(this,arguments);};}();var callGetAisleTypes=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatcher,request){var availableAisleTypes,response,startTime,args,isFault,modal;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:availableAisleTypes=[];response=void 0;startTime=Date.now();case 3:args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_55" /* ENDPOINT_GET_SITE_ASSET_CONFIG */]);_context6.next=6;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 6:response=_context6.sent;if(!(response.status===200)){_context6.next=20;break;}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAisleTypes",true,false);request.pageToken=response&&response.data&&response.data.pageToken||null;_context6.t0=[];_context6.t1=_toConsumableArray(availableAisleTypes);_context6.t2=_toConsumableArray;_context6.next=15;return getAisleTypesFromResponse(response.data);case 15:_context6.t3=_context6.sent;_context6.t4=(0,_context6.t2)(_context6.t3);availableAisleTypes=_context6.t0.concat.call(_context6.t0,_context6.t1,_context6.t4);_context6.next=22;break;case 20:isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAisleTypes",false,isFault);case 22:if(response.status===200&&response.data.pageToken){_context6.next=3;break;}case 23:modal={aisleTypes:new Set(availableAisleTypes)};dispatcher({type:"RECEIVE_AISLE_TYPES",data:modal});case 25:case"end":return _context6.stop();}}},_callee6,this);}));return function callGetAisleTypes(_x13,_x14){return _ref6.apply(this,arguments);};}();var getAisleTypesFromResponse=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(response){var aisleTypes;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:aisleTypes=[];if(response&&response.configItems){response.configItems.forEach(function(configItem){return aisleTypes.push(configItem);});}return _context7.abrupt("return",aisleTypes);case 3:case"end":return _context7.stop();}}},_callee7,this);}));return function getAisleTypesFromResponse(_x15){return _ref7.apply(this,arguments);};}();var callGetLedControllerTypes=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatcher,request){var startTime,args,response,modal,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_55" /* ENDPOINT_GET_SITE_ASSET_CONFIG */]);_context9.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:response=_context9.sent;if(!(response.status===200)){_context9.next=13;break;}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getLedControllerTypes",true,false);_context9.next=9;return getLedControllerTypesFromResponse(response.data);case 9:modal=_context9.sent;dispatcher({type:"RECEIVE_LED_CONTROLLER_TYPES",data:modal});_context9.next=15;break;case 13:isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getLedControllerTypes",false,isFault);case 15:case"end":return _context9.stop();}}},_callee9,this);}));return function callGetLedControllerTypes(_x17,_x18){return _ref9.apply(this,arguments);};}();var dispatchLedControllerDeviceStatusDetails=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatcher,model){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:dispatcher({type:"RECEIVE_DATA",data:model});_context11.next=3;return setLoadingStatus(dispatcher,false);case 3:case"end":return _context11.stop();}}},_callee11,this);}));return function dispatchLedControllerDeviceStatusDetails(_x20,_x21){return _ref11.apply(this,arguments);};}();var callGetLedControllerDeviceDetails=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(){var request,startTime,args,model,response,ledControllersConnectivity,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])()};startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_49" /* ENDPOINT_GET_LED_CONTROLLERS */]);model={};_context13.next=6;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 6:response=_context13.sent;if(!(response.status===200)){_context13.next=15;break;}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getLedControllerDeviceStatusDetails",true,false);_context13.next=11;return getLEDControllersConnectivity(request.nodeId,response);case 11:ledControllersConnectivity=_context13.sent;model=extractLedControllerDeviceList(request.nodeId,response,ledControllersConnectivity);_context13.next=17;break;case 15:isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getLedControllerDeviceStatusDetails",false,isFault);case 17:return _context13.abrupt("return",model);case 18:case"end":return _context13.stop();}}},_callee13,this);}));return function callGetLedControllerDeviceDetails(){return _ref13.apply(this,arguments);};}();var getLEDControllersConnectivity=function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(nodeId,result){var deviceIdentifierList,ledControllersConnectivity,ledControllerConnectivityMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:deviceIdentifierList=[];ledControllersConnectivity={};if(result.data&&result.data.ledControllerList){result.data.ledControllerList.forEach(function(ledControllerDeviceDetail){deviceIdentifierList.push(ledControllerDeviceDetail.mac);});}if(!(deviceIdentifierList&&deviceIdentifierList.length>0)){_context14.next=7;break;}_context14.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["i" /* getSiteDevicesConnectivity */])(nodeId,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_97" /* LED_CONTROLLER_ASSET_TYPE */]);case 6:ledControllersConnectivity=_context14.sent;case 7:ledControllerConnectivityMap={};if(ledControllersConnectivity.status===200&&ledControllersConnectivity.data.deviceConnectivityList){ledControllersConnectivity.data.deviceConnectivityList.forEach(function(connectivity){var identifier=connectivity.identifier.match(__WEBPACK_IMPORTED_MODULE_5__util_Validations__["j" /* PATTERNS */].MAC_MASK)[0];ledControllerConnectivityMap[identifier]=connectivity;});}return _context14.abrupt("return",ledControllerConnectivityMap);case 10:case"end":return _context14.stop();}}},_callee14,this);}));return function getLEDControllersConnectivity(_x23,_x24){return _ref14.apply(this,arguments);};}();var callSetAssetStatus=function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(dispatcher,assetLabel,status,assetType,showCustomAlert){var startTime,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:startTime=Date.now();_context18.next=3;return setLoadingStatus(dispatcher,true);case 3:_context18.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(assetLabel,status,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType);case 5:response=_context18.sent;if(!(response.status===200)){_context18.next=13;break;}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"setLedControllerAssetStatus",true,false);showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["s" /* ALERT_DELETE_SUCCESS_ASSET_MESSAGE */]);_context18.next=11;return fetchLedControllerDeviceStatusDetails(dispatcher,showCustomAlert,__WEBPACK_IMPORTED_MODULE_6__util_LEDControllerUtil__["i" /* isAssetStatusUpdated */],assetLabel.value);case 11:_context18.next=18;break;case 13:isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"setLedControllerAssetStatus",false,isFault);showCustomAlert(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(response.errorResponse.errorMessage).message;},__WEBPACK_IMPORTED_MODULE_2__util_Constants__["r" /* ALERT_DELETE_ASSET_MESSAGE */]));_context18.next=18;return setLoadingStatus(dispatcher,false);case 18:case"end":return _context18.stop();}}},_callee18,this);}));return function callSetAssetStatus(_x33,_x34,_x35,_x36,_x37){return _ref18.apply(this,arguments);};}();var callSetDefaultValues=function(){var _ref21=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee21(dispatcher,request,showCustomAlert){var startTime,args,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_61" /* ENDPOINT_SET_ASSET_DEFAULTS */]);_context21.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:response=_context21.sent;if(!(response.status===200)){_context21.next=12;break;}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"setLedControllerAssetDefaults",true,false);_context21.next=9;return getLedControllerDeviceStatusDetails(dispatcher);case 9:showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["C" /* ALERT_UPDATE_SUCCESS_ASSET_DEFAULTS_MESSAGE */]);_context21.next=15;break;case 12:isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"setLedControllerAssetDefaults",false,isFault);showCustomAlert(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(response.errorResponse.errorMessage).message;},__WEBPACK_IMPORTED_MODULE_2__util_Constants__["z" /* ALERT_UPDATE_ASSET_DEFAULTS_MESSAGE */]));case 15:case"end":return _context21.stop();}}},_callee21,this);}));return function callSetDefaultValues(_x44,_x45,_x46){return _ref21.apply(this,arguments);};}();var callGetAssetV2=function(){var _ref23=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee23(dispatcher,request){var startTime,args,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23){while(1){switch(_context23.prev=_context23.next){case 0:startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_43" /* ENDPOINT_GET_ASSET_V2 */]);_context23.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:response=_context23.sent;if(response.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getLedControllerAssetV2",true,false);dispatcher({type:"RECEIVE_ASSET_DETAIL",data:response.data.ledControllerConfig});}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getLedControllerAssetV2",false,isFault);}case 6:case"end":return _context23.stop();}}},_callee23,this);}));return function callGetAssetV2(_x49,_x50){return _ref23.apply(this,arguments);};}();var callBatchUpdateAssetV2=function(){var _ref25=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee25(dispatcher,request,showCustomAlert){var startTime,args,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25){while(1){switch(_context25.prev=_context25.next){case 0:startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_30" /* ENDPOINT_BATCH_UPDATE_ASSET_V2 */]);_context25.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:response=_context25.sent;if(!(response.status===200)){_context25.next=12;break;}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateLedControllerAssetV2",true,false);_context25.next=9;return getLedControllerAssetDetail(dispatcher,request.macAddress);case 9:showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["D" /* ALERT_UPDATE_SUCCESS_ASSET_MESSAGE */]);_context25.next=15;break;case 12:isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateLedControllerAssetV2",false,isFault);showCustomAlert(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(response.errorResponse.errorMessage).message;},__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]));case 15:case"end":return _context25.stop();}}},_callee25,this);}));return function callBatchUpdateAssetV2(_x55,_x56,_x57){return _ref25.apply(this,arguments);};}();var extractLedControllerMetadata=function(){var _ref27=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee27(response){var ledDevicesResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27){while(1){switch(_context27.prev=_context27.next){case 0:ledDevicesResponse={ledDevices:{}};if(response.data&&response.data.ledControllerList){response.data.ledControllerList.forEach(function(ledDetail){ledDevicesResponse.ledDevices[ledDetail.mac]={mac:ledDetail.mac,name:ledDetail.name,location:ledDetail.location};});}return _context27.abrupt("return",ledDevicesResponse);case 3:case"end":return _context27.stop();}}},_callee27,this);}));return function extractLedControllerMetadata(_x59){return _ref27.apply(this,arguments);};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="LED_CONTROLLER_DEVICE_DETAILS";var extractLedControllerDeviceList=function extractLedControllerDeviceList(nodeId,result,ledControllersConnectivity){var model={ledControllerDeviceInformation:{},selectedDefaultValues:{}};if(result.status===200){if(result.data.ledControllerList){result.data.ledControllerList.forEach(function(ledControllerDeviceDetail){var detail=ledControllersConnectivity[ledControllerDeviceDetail.mac];model.ledControllerDeviceInformation[ledControllerDeviceDetail.mac]={mac:ledControllerDeviceDetail.mac,ip:ledControllerDeviceDetail.ip,connectivity:detail?detail.status:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */],timestamp:detail?detail.lastUpdateTime:"",location:ledControllerDeviceDetail.location?ledControllerDeviceDetail.location:"Not Configured",startTime:ledControllerDeviceDetail.disableMonitoring?ledControllerDeviceDetail.disableMonitoring.startTime:"0",endTime:ledControllerDeviceDetail.disableMonitoring?ledControllerDeviceDetail.disableMonitoring.endTime:"0",reason:ledControllerDeviceDetail.disableMonitoring?ledControllerDeviceDetail.disableMonitoring.reason:"",remarks:ledControllerDeviceDetail.remarks?ledControllerDeviceDetail.remarks:""};});}if(result.data.defaultValues){model.selectedDefaultValues=result.data.defaultValues;}}return model;};var addLedController=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatcher,state,showCustomAlert){var requestBody;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:requestBody={ledControllerConfig:{macAddress:state.macAddress.toLowerCase(),aisleDetails:state.aisleDetails,nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])()},nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_97" /* LED_CONTROLLER_ASSET_TYPE */]};_context2.next=3;return callAddAssetV2(dispatcher,requestBody,showCustomAlert);case 3:case"end":return _context2.stop();}}},_callee2,this);}));return function addLedController(_x4,_x5,_x6){return _ref2.apply(this,arguments);};}();var getAisleTypes=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatcher){var request;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_97" /* LED_CONTROLLER_ASSET_TYPE */],configName:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["k" /* AISLE_TYPE_CONFIG */],pageToken:""};_context5.next=3;return callGetAisleTypes(dispatcher,request);case 3:case"end":return _context5.stop();}}},_callee5,this);}));return function getAisleTypes(_x12){return _ref5.apply(this,arguments);};}();var getLedControllerTypes=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatcher){var request;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_97" /* LED_CONTROLLER_ASSET_TYPE */],configName:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_98" /* LED_CONTROLLER_TYPE_CONFIG */]};_context8.next=3;return callGetLedControllerTypes(dispatcher,request);case 3:case"end":return _context8.stop();}}},_callee8,this);}));return function getLedControllerTypes(_x16){return _ref8.apply(this,arguments);};}();var getLedControllerTypesFromResponse=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(response){var modal;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:modal={ledControllerTypes:[]};if(response&&response.configItems){response.configItems.forEach(function(configItem){return modal.ledControllerTypes.push(configItem);});}return _context10.abrupt("return",modal);case 3:case"end":return _context10.stop();}}},_callee10,this);}));return function getLedControllerTypesFromResponse(_x19){return _ref10.apply(this,arguments);};}();var getLedControllerDeviceStatusDetails=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(dispatcher){var model;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return callGetLedControllerDeviceDetails();case 2:model=_context12.sent;dispatchLedControllerDeviceStatusDetails(dispatcher,model);case 4:case"end":return _context12.stop();}}},_callee12,this);}));return function getLedControllerDeviceStatusDetails(_x22){return _ref12.apply(this,arguments);};}();var setLEDControllerDisableMonitoringData=function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(dispatch,stateValues,mac){var _this=this;var request,startTime,args,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),macAddress:mac,startTime:stateValues.startTime,endTime:stateValues.endTime,reason:stateValues.reason};startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_68" /* ENDPOINT_UPDATE_DISABLE_MONITORING_SCHEDULE */]);_context16.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context16.sent;if(response.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateLEDControllerDisableMonitoringSchedule",true,false);setTimeout(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return getLedControllerDeviceStatusDetails(dispatch);case 2:dispatch({type:'SET_MONITORING_STATUS_LOADER',data:{mac:mac,monitoringStatusLoading:false}});case 3:case"end":return _context15.stop();}}},_callee15,_this);})),30000);}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateLEDControllerDisableMonitoringSchedule",false,isFault);}case 7:case"end":return _context16.stop();}}},_callee16,this);}));return function setLEDControllerDisableMonitoringData(_x25,_x26,_x27){return _ref15.apply(this,arguments);};}();var updateLedControllerStatus=function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(dispatcher,mac,assetType,status,showCustomAlert){var assetLabel;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:assetLabel={type:"MAC_ADDRESS",value:mac};_context17.next=3;return callSetAssetStatus(dispatcher,assetLabel,status,assetType,showCustomAlert);case 3:case"end":return _context17.stop();}}},_callee17,this);}));return function updateLedControllerStatus(_x28,_x29,_x30,_x31,_x32){return _ref17.apply(this,arguments);};}();var postUpdatedRemarkToDevice=function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(device,newRemark,dispatch){var request,args,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),macAddress:device.mac,remarks:newRemark};args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_69" /* ENDPOINT_UPDATE_LED_CONTROLLERS_REMARKS */]);_context19.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:response=_context19.sent;if(response.status!==200){alert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});}case 6:case"end":return _context19.stop();}}},_callee19,this);}));return function postUpdatedRemarkToDevice(_x38,_x39,_x40){return _ref19.apply(this,arguments);};}();var setDefaultValues=function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(dispatcher,defaultValues,showCustomAlert){var request;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:request={ledControllerDefaultValues:defaultValues.ledControllerDefaultValues,nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_97" /* LED_CONTROLLER_ASSET_TYPE */]};_context20.next=3;return callSetDefaultValues(dispatcher,request,showCustomAlert);case 3:case"end":return _context20.stop();}}},_callee20,this);}));return function setDefaultValues(_x41,_x42,_x43){return _ref20.apply(this,arguments);};}();var getLedControllerAssetDetail=function(){var _ref22=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee22(dispatcher,macAddress){var request;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22){while(1){switch(_context22.prev=_context22.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_97" /* LED_CONTROLLER_ASSET_TYPE */],deviceName:macAddress};_context22.next=3;return callGetAssetV2(dispatcher,request);case 3:case"end":return _context22.stop();}}},_callee22,this);}));return function getLedControllerAssetDetail(_x47,_x48){return _ref22.apply(this,arguments);};}();var updateLedControllerAssetData=function(){var _ref24=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee24(dispatcher,mac,aisleDetails,showCustomAlert){var request;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24){while(1){switch(_context24.prev=_context24.next){case 0:request={ledControllerConfigList:[{macAddress:mac,nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),aisleDetails:aisleDetails}],assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_97" /* LED_CONTROLLER_ASSET_TYPE */],nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])()};_context24.next=3;return callBatchUpdateAssetV2(dispatcher,request,showCustomAlert);case 3:case"end":return _context24.stop();}}},_callee24,this);}));return function updateLedControllerAssetData(_x51,_x52,_x53,_x54){return _ref24.apply(this,arguments);};}();var getLedControllerDevices=function(){var _ref26=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee26(dispatcher){var request,startTime,args,response,model,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26){while(1){switch(_context26.prev=_context26.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])()};startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_49" /* ENDPOINT_GET_LED_CONTROLLERS */]);_context26.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context26.sent;if(!(response.status===200)){_context26.next=14;break;}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getLedControllerMacAddresses",true,false);_context26.next=10;return extractLedControllerMetadata(response);case 10:model=_context26.sent;dispatcher({type:"RECEIVE_DEVICES",data:model});_context26.next=16;break;case 14:isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getLedControllerMacAddresses",false,isFault);case 16:case"end":return _context26.stop();}}},_callee26,this);}));return function getLedControllerDevices(_x58){return _ref26.apply(this,arguments);};}();

/***/ }),
/* 292 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    searchFieldSearchButtonForegroundColorActive: tokens.themeForegroundInvertedDefault,
    searchFieldSearchButtonBackgroundColorActiveDefault: tokens.themeForegroundAccentDefault,
    searchFieldSearchButtonBackgroundColorActiveHover: tokens.themeForegroundAccentHover,
    searchFieldSearchButtonBackgroundColorActivePressed: tokens.themeForegroundAccentPressed,
    searchFieldSearchButtonBorderLeftWidth: 1,
    searchFieldSearchButtonBorderLeftRadius: 0,
    searchFieldSearchButtonBorderLeftColorDefault: tokens.themeBorderPrimaryDefault,
    searchFieldSearchButtonBorderLeftColorDisabled: tokens.themeBorderPrimaryDisabled,
    searchFieldSuggestionListBackgroundColor: tokens.themeBackgroundPrimaryDefault,
    searchFieldSuggestionListBorderWidth: 1,
    searchFieldSuggestionListBorderRadius: 4,
    searchFieldSuggestionListBorderColor: tokens.themeBorderPrimaryDefault,
    searchFieldSuggestionListFontWeightDefault: 400,
    searchFieldSuggestionListFontWeightMatched: 600,
    searchFieldSuggestionListFooterBorderWidth: 1,
    searchFieldSuggestionListFooterBorderRadius: 0,
    searchFieldSuggestionListFooterBorderColor: tokens.themeBorderPrimaryDefault,
    searchFieldSuggestionListFooterSpacingHorizontal: 16,
    searchFieldSuggestionListFooterSpacingVertical: 8,
    searchFieldSuggestionListHeaderFontSize: 12,
    searchFieldSuggestionListHeaderLineHeight: "16px",
    searchFieldSuggestionListHeaderSpacingHorizontal: 16,
    searchFieldSuggestionListHeaderSpacingVertical: 4,
    searchFieldSuggestionListHeaderBorderWidth: 1,
    searchFieldSuggestionListHeaderBorderRadius: 0,
    searchFieldSuggestionListHeaderBorderColor: tokens.themeBorderPrimaryDefault,
    searchFieldSuggestionListPopoverElevation: 70,
    searchFieldSuggestionListPopoverOffsetVertical: 4
  }
};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

module.exports = Duplex;

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}
/*</replacement>*/


/*<replacement>*/
var util = __webpack_require__(87);
util.inherits = __webpack_require__(79);
/*</replacement>*/

var Readable = __webpack_require__(469);
var Writable = __webpack_require__(470);

util.inherits(Duplex, Readable);

forEach(objectKeys(Writable.prototype), function(method) {
  if (!Duplex.prototype[method])
    Duplex.prototype[method] = Writable.prototype[method];
});

function Duplex(options) {
  if (!(this instanceof Duplex))
    return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false)
    this.readable = false;

  if (options && options.writable === false)
    this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false)
    this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended)
    return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(this.end.bind(this));
}

function forEach (xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var tls = __webpack_require__(1139);

function buildBuilder (mqttClient, opts) {
  var connection;
  opts.port = opts.port || 8883;
  opts.host = opts.hostname || opts.host || 'localhost';

  opts.rejectUnauthorized = false !== opts.rejectUnauthorized;

  connection = tls.connect(opts);
  /*eslint no-use-before-define: [2, "nofunc"]*/
  connection.on('secureConnect', function () {
    if (opts.rejectUnauthorized && !connection.authorized) {
      connection.emit('error', new Error('TLS not authorized'));
    } else {
      connection.removeListener('error', handleTLSerrors);
    }
  });

  /*
   * to comply with strict rules, a function must be
   * declared before it can be used
   * so i moved it has to be  moved before its first call
   * later on maybe we can move all of them to the top of the file
   * for now i just suppressed the warning
   */
  /*jshint latedef:false*/
  function handleTLSerrors (err) {
    // How can I get verify this error is a tls error?
    if (opts.rejectUnauthorized) {
      mqttClient.emit('error', err);
    }

    // close this connection to match the behaviour of net
    // otherwise all we get is an error from the connection
    // and close event doesn't fire. This is a work around
    // to enable the reconnect code to work the same as with
    // net.createConnection
    connection.end();
  }
  /*jshint latedef:false*/

  connection.on('error', handleTLSerrors);
  return connection;
}

module.exports = buildBuilder;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),
/* 297 */
/***/ (function(module, exports) {

/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps

//npm deps

//app deps

//begin module
/**
 * This is the exposed module.
 * This method determines if an object is undefined.
 *
 * @param {Object} value
 * @access public
 */
module.exports = function(value) {
   return typeof value === 'undefined' || typeof value === null;
};


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProvisioningContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_ProvisioningReducer__ = __webpack_require__(1206);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var ProvisioningContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var ProvisioningContextProvider=function ProvisioningContextProvider(props){var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_ProvisioningReducer__["a" /* ProvisioningReducer */],__WEBPACK_IMPORTED_MODULE_1__reducer_ProvisioningReducer__["b" /* initialProvisioningState */]),_useReducer2=_slicedToArray(_useReducer,2),provisioningViewModel=_useReducer2[0],provisioningDispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProvisioningContext.Provider,{value:{provisioningViewModel:provisioningViewModel,provisioningDispatch:provisioningDispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (ProvisioningContextProvider);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PageFooterModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
var PageFooterModal=function PageFooterModal(props){var showAlert=props.showAlert,onCloseModalCallBack=props.onCloseModalCallBack,onClickConfirmCallBack=props.onClickConfirmCallBack;var onCloseModal=function onCloseModal(){onCloseModalCallBack();};var onClickConfirm=function onClickConfirm(){onClickConfirmCallBack();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"}))));};PageFooterModal.propTypes={showAlert:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,onCloseModalCallBack:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,onClickConfirmCallBack:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */])(PageFooterModal));

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var SearchableSelectModal=function SearchableSelectModal(props){var formatMessage=props.intl.formatMessage;var preSelectedValue=props.preSelectedValue,error=props.error,setError=props.setError,selectedValue=props.selectedValue,setSelectedValue=props.setSelectedValue,options=props.options,htmlId=props.htmlId,placeholderValue=props.placeholderValue,placeholderDefaultValue=props.placeholderDefaultValue;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(preSelectedValue||''),_useState2=_slicedToArray(_useState,2),searchText=_useState2[0],setSearchText=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([].concat(_toConsumableArray(options))||[]),_useState4=_slicedToArray(_useState3,2),filteredOptions=_useState4[0],setFilteredOptions=_useState4[1];var handleSelectChange=function handleSelectChange(value){setSearchText(value);setSelectedValue(value);setError(false);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(searchText===''){setFilteredOptions(options);}else if(searchText===preSelectedValue){setFilteredOptions(options);setSelectedValue(preSelectedValue);setError(false);}else{var filteredValues=options.filter(function(type){return type.includes(searchText);});setFilteredOptions(filteredValues);}},[searchText,options]);var generateDropDown=function generateDropDown(){return filteredOptions.map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:value});});};var handleBlur=function handleBlur(){if(searchText===''||searchText&&!selectedValue){setError(true);}else{setError(false);}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select___default.a,{id:htmlId,value:selectedValue||searchText,onChange:handleSelectChange,placeholder:placeholderValue&&placeholderDefaultValue?formatMessage({id:placeholderValue,defaultMessage:placeholderDefaultValue}):"",onBlur:handleBlur,onSearch:setSearchText,searchQuery:searchText,error:error},filteredOptions.length>0&&generateDropDown()));};SearchableSelectModal.propTypes={intl:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({formatMessage:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired}).isRequired,preSelectedValue:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,error:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,setError:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,selectedValue:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,setSelectedValue:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,options:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,htmlId:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,placeholderValue:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,placeholderDefaultValue:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(SearchableSelectModal));

/***/ }),
/* 301 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    tagFontSize: 14,
    tagHeight: 20,
    tagIndicatorDiameter: 12,
    tagCloseIconMotionDuration: "100ms",
    tagCloseIconMotionFunction: "ease",
    tagCloseIconSize: 16,
    tagCloseIconColorDismissibleThemeDefault: tokens.themeForegroundAccentDefault,
    tagCloseIconColorDismissibleThemeHover: tokens.themeForegroundAccentHover,
    tagCloseIconColorDismissibleThemePressed: tokens.themeForegroundAccentPressed,
    tagCloseIconColorDismissibleThemeFocus: tokens.themeForegroundAccentHover,
    tagCloseIconColorDismissibleNeutralDefault: tokens.themeForegroundTertiaryDefault,
    tagCloseIconColorDismissibleNeutralHover: tokens.themeForegroundTertiaryHover,
    tagCloseIconColorDismissibleNeutralPressed: tokens.themeForegroundTertiaryPressed,
    tagCloseIconColorDismissibleNeutralFocus: tokens.themeForegroundSecondaryDefault,
    tagSpacingInsetStatusRight: 12,
    tagSpacingInsetStatusLeft: 4,
    tagSpacingInsetDismissibleRight: 2,
    tagSpacingInsetDismissibleLeft: 8,
    tagSpacingHorizontal: 8,
    tagBackgroundColorDismissibleTheme: tokens.themeBackgroundAccentDefault,
    tagBackgroundColorDismissibleNeutral: tokens.themeBackgroundTertiaryDefault,
    tagBorderWidth: 1,
    tagBorderRadius: 13,
    tagBorderCompactWidth: 2,
    tagBorderCompactRadius: 999,
    tagBorderColorStatusSuccess: "#ADE422",
    tagBorderColorStatusWarning: "#FAD000",
    tagBorderColorStatusError: "#DE1B1B",
    tagBorderColorStatusNeutral: tokens.themeForegroundPrimaryDisabled,
    tagBorderColorStatusTheme: tokens.themeBorderAccentDefault,
    tagBorderColorDismissibleTheme: tokens.themeBorderAccentDefault,
    tagBorderColorDismissibleNeutral: tokens.themeForegroundPrimaryDisabled,
    tagBorderColorCompact: "#232F3E",
    tagFocusOutlineOffset: 4
  }
};

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hook__ = __webpack_require__(1231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__hook__["a"]; });
/* unused harmony reexport useUncontrolledProp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uncontrollable__ = __webpack_require__(1232);
/* unused harmony reexport uncontrollable */



/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1233);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createWithBsPrefix;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dom_helpers_camelize__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(49);







var pascalCase = function pascalCase(str) {
  return str[0].toUpperCase() + Object(__WEBPACK_IMPORTED_MODULE_3_dom_helpers_camelize__["a" /* default */])(str).slice(1);
};

function createWithBsPrefix(prefix, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$displayName = _ref.displayName,
      displayName = _ref$displayName === void 0 ? pascalCase(prefix) : _ref$displayName,
      _ref$Component = _ref.Component,
      Component = _ref$Component === void 0 ? 'div' : _ref$Component,
      defaultProps = _ref.defaultProps;

  var BsComponent = __WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef( // eslint-disable-next-line react/prop-types
  function (_ref2, ref) {
    var className = _ref2.className,
        bsPrefix = _ref2.bsPrefix,
        _ref2$as = _ref2.as,
        Tag = _ref2$as === void 0 ? Component : _ref2$as,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["className", "bsPrefix", "as"]);

    var resolvedPrefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, prefix);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      ref: ref,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, resolvedPrefix)
    }, props));
  });
  BsComponent.defaultProps = defaultProps;
  BsComponent.displayName = displayName;
  return BsComponent;
}

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useEventCallback;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useCommittedRef__ = __webpack_require__(1256);


function useEventCallback(fn) {
  var ref = Object(__WEBPACK_IMPORTED_MODULE_1__useCommittedRef__["a" /* default */])(fn);
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    return ref.current && ref.current.apply(ref, arguments);
  }, [ref]);
}

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeEventKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var SelectableContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();
var makeEventKey = function makeEventKey(eventKey, href) {
  if (eventKey != null) return String(eventKey);
  return href || null;
};
/* harmony default export */ __webpack_exports__["a"] = (SelectableContext);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createChainedFunction__ = __webpack_require__(500);





function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, DropdownItems, etc.
 */


var SafeAnchor = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'a' : _ref$as,
      disabled = _ref.disabled,
      onKeyDown = _ref.onKeyDown,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["as", "disabled", "onKeyDown"]);

  var handleClick = function handleClick(event) {
    var href = props.href,
        onClick = props.onClick;

    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };

  if (isTrivialHref(props.href)) {
    props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
    // otherwise, the cursor incorrectly styled (except with role='button')

    props.href = props.href || '#';
  }

  if (disabled) {
    props.tabIndex = -1;
    props['aria-disabled'] = true;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, props, {
    onClick: handleClick,
    onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_3__createChainedFunction__["a" /* default */])(handleKeyDown, onKeyDown)
  }));
});
SafeAnchor.displayName = 'SafeAnchor';
/* harmony default export */ __webpack_exports__["a"] = (SafeAnchor);

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);





var propTypes = {
  /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */
  type: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  as: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.elementType
};
var defaultProps = {
  type: 'valid'
};
var Feedback = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      type = _ref.type,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["as", "className", "type"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, type && type + "-feedback")
  }));
});
Feedback.displayName = 'Feedback';
Feedback.propTypes = propTypes;
Feedback.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Feedback);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PATHS */
/* unused harmony export API_NAMES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BIN_LABEL_STYLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BIN_ON_DURATION_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AISLE_ON_DURATION_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COLOR_MAP; });
var PATHS={allAisle:'/allAisle',aisleSequence:'/aisleSequence',bin:'/bin',ledController:'/ledController'};var API_NAMES={ledTesterApi:'ledTesterApi'};var BIN_LABEL_STYLES={EU:'eu',NA:'us',IN_SC:'IN_SC'};var COLOR_MAP={RED:'0xFFFF0000',GREEN:'0xFF00FF00',BLUE:'0xFF0000FF',CYAN:'0xFF00FFFF',MAGENTA:'0xFFFF00FF',YELLOW:'0xFFFFFF00',WHITE:'0xFFFFFFFF'};var BIN_ON_DURATION_MS=800;var AISLE_ON_DURATION_MS=1000;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// HumanizeDuration.js - https://git.io/j0HgmQ

/* global define, module */

(function () {
  // This has to be defined separately because of a bug: we want to alias
  // `gr` and `el` for backwards-compatiblity. In a breaking change, we can
  // remove `gr` entirely.
  // See https://github.com/EvanHahn/HumanizeDuration.js/issues/143 for more.
  var greek = {
    y: function (c) {
      return c === 1 ? "χρόνος" : "χρόνια";
    },
    mo: function (c) {
      return c === 1 ? "μήνας" : "μήνες";
    },
    w: function (c) {
      return c === 1 ? "εβδομάδα" : "εβδομάδες";
    },
    d: function (c) {
      return c === 1 ? "μέρα" : "μέρες";
    },
    h: function (c) {
      return c === 1 ? "ώρα" : "ώρες";
    },
    m: function (c) {
      return c === 1 ? "λεπτό" : "λεπτά";
    },
    s: function (c) {
      return c === 1 ? "δευτερόλεπτο" : "δευτερόλεπτα";
    },
    ms: function (c) {
      return (c === 1 ? "χιλιοστό" : "χιλιοστά") + " του δευτερολέπτου";
    },
    decimal: ","
  };

  var ARABIC_DIGITS = ["۰", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];

  var LANGUAGES = {
    af: {
      y: "jaar",
      mo: function (c) {
        return "maand" + (c === 1 ? "" : "e");
      },
      w: function (c) {
        return c === 1 ? "week" : "weke";
      },
      d: function (c) {
        return c === 1 ? "dag" : "dae";
      },
      h: function (c) {
        return c === 1 ? "uur" : "ure";
      },
      m: function (c) {
        return c === 1 ? "minuut" : "minute";
      },
      s: function (c) {
        return "sekonde" + (c === 1 ? "" : "s");
      },
      ms: function (c) {
        return "millisekonde" + (c === 1 ? "" : "s");
      },
      decimal: ","
    },
    ar: {
      y: function (c) {
        return ["سنة", "سنتان", "سنوات"][getArabicForm(c)];
      },
      mo: function (c) {
        return ["شهر", "شهران", "أشهر"][getArabicForm(c)];
      },
      w: function (c) {
        return ["أسبوع", "أسبوعين", "أسابيع"][getArabicForm(c)];
      },
      d: function (c) {
        return ["يوم", "يومين", "أيام"][getArabicForm(c)];
      },
      h: function (c) {
        return ["ساعة", "ساعتين", "ساعات"][getArabicForm(c)];
      },
      m: function (c) {
        return ["دقيقة", "دقيقتان", "دقائق"][getArabicForm(c)];
      },
      s: function (c) {
        return ["ثانية", "ثانيتان", "ثواني"][getArabicForm(c)];
      },
      ms: function (c) {
        return ["جزء من الثانية", "جزآن من الثانية", "أجزاء من الثانية"][
          getArabicForm(c)
        ];
      },
      decimal: ",",
      delimiter: " و ",
      _formatCount: function (count, decimal) {
        var replacements = assign(ARABIC_DIGITS, { ".": decimal });
        var characters = count.toString().split("");
        for (var i = 0; i < characters.length; i++) {
          var character = characters[i];
          if (has(replacements, character)) {
            characters[i] = replacements[character];
          }
        }
        return characters.join("");
      }
    },
    bg: {
      y: function (c) {
        return ["години", "година", "години"][getSlavicForm(c)];
      },
      mo: function (c) {
        return ["месеца", "месец", "месеца"][getSlavicForm(c)];
      },
      w: function (c) {
        return ["седмици", "седмица", "седмици"][getSlavicForm(c)];
      },
      d: function (c) {
        return ["дни", "ден", "дни"][getSlavicForm(c)];
      },
      h: function (c) {
        return ["часа", "час", "часа"][getSlavicForm(c)];
      },
      m: function (c) {
        return ["минути", "минута", "минути"][getSlavicForm(c)];
      },
      s: function (c) {
        return ["секунди", "секунда", "секунди"][getSlavicForm(c)];
      },
      ms: function (c) {
        return ["милисекунди", "милисекунда", "милисекунди"][getSlavicForm(c)];
      },
      decimal: ","
    },
    bn: {
      y: "বছর",
      mo: "মাস",
      w: "সপ্তাহ",
      d: "দিন",
      h: "ঘন্টা",
      m: "মিনিট",
      s: "সেকেন্ড",
      ms: "মিলিসেকেন্ড"
    },
    ca: {
      y: function (c) {
        return "any" + (c === 1 ? "" : "s");
      },
      mo: function (c) {
        return "mes" + (c === 1 ? "" : "os");
      },
      w: function (c) {
        return "setman" + (c === 1 ? "a" : "es");
      },
      d: function (c) {
        return "di" + (c === 1 ? "a" : "es");
      },
      h: function (c) {
        return "hor" + (c === 1 ? "a" : "es");
      },
      m: function (c) {
        return "minut" + (c === 1 ? "" : "s");
      },
      s: function (c) {
        return "segon" + (c === 1 ? "" : "s");
      },
      ms: function (c) {
        return "milisegon" + (c === 1 ? "" : "s");
      },
      decimal: ","
    },
    cs: {
      y: function (c) {
        return ["rok", "roku", "roky", "let"][getCzechOrSlovakForm(c)];
      },
      mo: function (c) {
        return ["měsíc", "měsíce", "měsíce", "měsíců"][getCzechOrSlovakForm(c)];
      },
      w: function (c) {
        return ["týden", "týdne", "týdny", "týdnů"][getCzechOrSlovakForm(c)];
      },
      d: function (c) {
        return ["den", "dne", "dny", "dní"][getCzechOrSlovakForm(c)];
      },
      h: function (c) {
        return ["hodina", "hodiny", "hodiny", "hodin"][getCzechOrSlovakForm(c)];
      },
      m: function (c) {
        return ["minuta", "minuty", "minuty", "minut"][getCzechOrSlovakForm(c)];
      },
      s: function (c) {
        return ["sekunda", "sekundy", "sekundy", "sekund"][
          getCzechOrSlovakForm(c)
        ];
      },
      ms: function (c) {
        return ["milisekunda", "milisekundy", "milisekundy", "milisekund"][
          getCzechOrSlovakForm(c)
        ];
      },
      decimal: ","
    },
    cy: {
      y: "flwyddyn",
      mo: "mis",
      w: "wythnos",
      d: "diwrnod",
      h: "awr",
      m: "munud",
      s: "eiliad",
      ms: "milieiliad"
    },
    da: {
      y: "år",
      mo: function (c) {
        return "måned" + (c === 1 ? "" : "er");
      },
      w: function (c) {
        return "uge" + (c === 1 ? "" : "r");
      },
      d: function (c) {
        return "dag" + (c === 1 ? "" : "e");
      },
      h: function (c) {
        return "time" + (c === 1 ? "" : "r");
      },
      m: function (c) {
        return "minut" + (c === 1 ? "" : "ter");
      },
      s: function (c) {
        return "sekund" + (c === 1 ? "" : "er");
      },
      ms: function (c) {
        return "millisekund" + (c === 1 ? "" : "er");
      },
      decimal: ","
    },
    de: {
      y: function (c) {
        return "Jahr" + (c === 1 ? "" : "e");
      },
      mo: function (c) {
        return "Monat" + (c === 1 ? "" : "e");
      },
      w: function (c) {
        return "Woche" + (c === 1 ? "" : "n");
      },
      d: function (c) {
        return "Tag" + (c === 1 ? "" : "e");
      },
      h: function (c) {
        return "Stunde" + (c === 1 ? "" : "n");
      },
      m: function (c) {
        return "Minute" + (c === 1 ? "" : "n");
      },
      s: function (c) {
        return "Sekunde" + (c === 1 ? "" : "n");
      },
      ms: function (c) {
        return "Millisekunde" + (c === 1 ? "" : "n");
      },
      decimal: ","
    },
    el: greek,
    en: {
      y: function (c) {
        return "year" + (c === 1 ? "" : "s");
      },
      mo: function (c) {
        return "month" + (c === 1 ? "" : "s");
      },
      w: function (c) {
        return "week" + (c === 1 ? "" : "s");
      },
      d: function (c) {
        return "day" + (c === 1 ? "" : "s");
      },
      h: function (c) {
        return "hour" + (c === 1 ? "" : "s");
      },
      m: function (c) {
        return "minute" + (c === 1 ? "" : "s");
      },
      s: function (c) {
        return "second" + (c === 1 ? "" : "s");
      },
      ms: function (c) {
        return "millisecond" + (c === 1 ? "" : "s");
      },
      decimal: "."
    },
    eo: {
      y: function (c) {
        return "jaro" + (c === 1 ? "" : "j");
      },
      mo: function (c) {
        return "monato" + (c === 1 ? "" : "j");
      },
      w: function (c) {
        return "semajno" + (c === 1 ? "" : "j");
      },
      d: function (c) {
        return "tago" + (c === 1 ? "" : "j");
      },
      h: function (c) {
        return "horo" + (c === 1 ? "" : "j");
      },
      m: function (c) {
        return "minuto" + (c === 1 ? "" : "j");
      },
      s: function (c) {
        return "sekundo" + (c === 1 ? "" : "j");
      },
      ms: function (c) {
        return "milisekundo" + (c === 1 ? "" : "j");
      },
      decimal: ","
    },
    es: {
      y: function (c) {
        return "año" + (c === 1 ? "" : "s");
      },
      mo: function (c) {
        return "mes" + (c === 1 ? "" : "es");
      },
      w: function (c) {
        return "semana" + (c === 1 ? "" : "s");
      },
      d: function (c) {
        return "día" + (c === 1 ? "" : "s");
      },
      h: function (c) {
        return "hora" + (c === 1 ? "" : "s");
      },
      m: function (c) {
        return "minuto" + (c === 1 ? "" : "s");
      },
      s: function (c) {
        return "segundo" + (c === 1 ? "" : "s");
      },
      ms: function (c) {
        return "milisegundo" + (c === 1 ? "" : "s");
      },
      decimal: ","
    },
    et: {
      y: function (c) {
        return "aasta" + (c === 1 ? "" : "t");
      },
      mo: function (c) {
        return "kuu" + (c === 1 ? "" : "d");
      },
      w: function (c) {
        return "nädal" + (c === 1 ? "" : "at");
      },
      d: function (c) {
        return "päev" + (c === 1 ? "" : "a");
      },
      h: function (c) {
        return "tund" + (c === 1 ? "" : "i");
      },
      m: function (c) {
        return "minut" + (c === 1 ? "" : "it");
      },
      s: function (c) {
        return "sekund" + (c === 1 ? "" : "it");
      },
      ms: function (c) {
        return "millisekund" + (c === 1 ? "" : "it");
      },
      decimal: ","
    },
    eu: {
      y: "urte",
      mo: "hilabete",
      w: "aste",
      d: "egun",
      h: "ordu",
      m: "minutu",
      s: "segundo",
      ms: "milisegundo",
      decimal: ","
    },
    fa: {
      y: "سال",
      mo: "ماه",
      w: "هفته",
      d: "روز",
      h: "ساعت",
      m: "دقیقه",
      s: "ثانیه",
      ms: "میلی ثانیه",
      decimal: "."
    },
    fi: {
      y: function (c) {
        return c === 1 ? "vuosi" : "vuotta";
      },
      mo: function (c) {
        return c === 1 ? "kuukausi" : "kuukautta";
      },
      w: function (c) {
        return "viikko" + (c === 1 ? "" : "a");
      },
      d: function (c) {
        return "päivä" + (c === 1 ? "" : "ä");
      },
      h: function (c) {
        return "tunti" + (c === 1 ? "" : "a");
      },
      m: function (c) {
        return "minuutti" + (c === 1 ? "" : "a");
      },
      s: function (c) {
        return "sekunti" + (c === 1 ? "" : "a");
      },
      ms: function (c) {
        return "millisekunti" + (c === 1 ? "" : "a");
      },
      decimal: ","
    },
    fo: {
      y: "ár",
      mo: function (c) {
        return c === 1 ? "mánaður" : "mánaðir";
      },
      w: function (c) {
        return c === 1 ? "vika" : "vikur";
      },
      d: function (c) {
        return c === 1 ? "dagur" : "dagar";
      },
      h: function (c) {
        return c === 1 ? "tími" : "tímar";
      },
      m: function (c) {
        return c === 1 ? "minuttur" : "minuttir";
      },
      s: "sekund",
      ms: "millisekund",
      decimal: ","
    },
    fr: {
      y: function (c) {
        return "an" + (c >= 2 ? "s" : "");
      },
      mo: "mois",
      w: function (c) {
        return "semaine" + (c >= 2 ? "s" : "");
      },
      d: function (c) {
        return "jour" + (c >= 2 ? "s" : "");
      },
      h: function (c) {
        return "heure" + (c >= 2 ? "s" : "");
      },
      m: function (c) {
        return "minute" + (c >= 2 ? "s" : "");
      },
      s: function (c) {
        return "seconde" + (c >= 2 ? "s" : "");
      },
      ms: function (c) {
        return "milliseconde" + (c >= 2 ? "s" : "");
      },
      decimal: ","
    },
    gr: greek,
    he: {
      y: function (c) {
        return c === 1 ? "שנה" : "שנים";
      },
      mo: function (c) {
        return c === 1 ? "חודש" : "חודשים";
      },
      w: function (c) {
        return c === 1 ? "שבוע" : "שבועות";
      },
      d: function (c) {
        return c === 1 ? "יום" : "ימים";
      },
      h: function (c) {
        return c === 1 ? "שעה" : "שעות";
      },
      m: function (c) {
        return c === 1 ? "דקה" : "דקות";
      },
      s: function (c) {
        return c === 1 ? "שניה" : "שניות";
      },
      ms: function (c) {
        return c === 1 ? "מילישנייה" : "מילישניות";
      },
      decimal: "."
    },
    hr: {
      y: function (c) {
        if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) {
          return "godine";
        }
        return "godina";
      },
      mo: function (c) {
        if (c === 1) {
          return "mjesec";
        } else if (c === 2 || c === 3 || c === 4) {
          return "mjeseca";
        }
        return "mjeseci";
      },
      w: function (c) {
        if (c % 10 === 1 && c !== 11) {
          return "tjedan";
        }
        return "tjedna";
      },
      d: function (c) {
        return c === 1 ? "dan" : "dana";
      },
      h: function (c) {
        if (c === 1) {
          return "sat";
        } else if (c === 2 || c === 3 || c === 4) {
          return "sata";
        }
        return "sati";
      },
      m: function (c) {
        var mod10 = c % 10;
        if ((mod10 === 2 || mod10 === 3 || mod10 === 4) && (c < 10 || c > 14)) {
          return "minute";
        }
        return "minuta";
      },
      s: function (c) {
        var mod10 = c % 10;
        if (mod10 === 5 || (Math.floor(c) === c && c >= 10 && c <= 19)) {
          return "sekundi";
        } else if (mod10 === 1) {
          return "sekunda";
        } else if (mod10 === 2 || mod10 === 3 || mod10 === 4) {
          return "sekunde";
        }
        return "sekundi";
      },
      ms: function (c) {
        if (c === 1) {
          return "milisekunda";
        } else if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) {
          return "milisekunde";
        }
        return "milisekundi";
      },
      decimal: ","
    },
    hi: {
      y: "साल",
      mo: function (c) {
        return c === 1 ? "महीना" : "महीने";
      },
      w: function (c) {
        return c === 1 ? "हफ़्ता" : "हफ्ते";
      },
      d: "दिन",
      h: function (c) {
        return c === 1 ? "घंटा" : "घंटे";
      },
      m: "मिनट",
      s: "सेकंड",
      ms: "मिलीसेकंड",
      decimal: "."
    },
    hu: {
      y: "év",
      mo: "hónap",
      w: "hét",
      d: "nap",
      h: "óra",
      m: "perc",
      s: "másodperc",
      ms: "ezredmásodperc",
      decimal: ","
    },
    id: {
      y: "tahun",
      mo: "bulan",
      w: "minggu",
      d: "hari",
      h: "jam",
      m: "menit",
      s: "detik",
      ms: "milidetik",
      decimal: "."
    },
    is: {
      y: "ár",
      mo: function (c) {
        return "mánuð" + (c === 1 ? "ur" : "ir");
      },
      w: function (c) {
        return "vik" + (c === 1 ? "a" : "ur");
      },
      d: function (c) {
        return "dag" + (c === 1 ? "ur" : "ar");
      },
      h: function (c) {
        return "klukkutím" + (c === 1 ? "i" : "ar");
      },
      m: function (c) {
        return "mínút" + (c === 1 ? "a" : "ur");
      },
      s: function (c) {
        return "sekúnd" + (c === 1 ? "a" : "ur");
      },
      ms: function (c) {
        return "millisekúnd" + (c === 1 ? "a" : "ur");
      },
      decimal: "."
    },
    it: {
      y: function (c) {
        return "ann" + (c === 1 ? "o" : "i");
      },
      mo: function (c) {
        return "mes" + (c === 1 ? "e" : "i");
      },
      w: function (c) {
        return "settiman" + (c === 1 ? "a" : "e");
      },
      d: function (c) {
        return "giorn" + (c === 1 ? "o" : "i");
      },
      h: function (c) {
        return "or" + (c === 1 ? "a" : "e");
      },
      m: function (c) {
        return "minut" + (c === 1 ? "o" : "i");
      },
      s: function (c) {
        return "second" + (c === 1 ? "o" : "i");
      },
      ms: function (c) {
        return "millisecond" + (c === 1 ? "o" : "i");
      },
      decimal: ","
    },
    ja: {
      y: "年",
      mo: "ヶ月",
      w: "週",
      d: "日",
      h: "時間",
      m: "分",
      s: "秒",
      ms: "ミリ秒",
      decimal: "."
    },
    km: {
      y: "ឆ្នាំ",
      mo: "ខែ",
      w: "សប្តាហ៍",
      d: "ថ្ងៃ",
      h: "ម៉ោង",
      m: "នាទី",
      s: "វិនាទី",
      ms: "មិល្លីវិនាទី"
    },
    kn: {
      y: function (c) {
        return c === 1 ? "ವರ್ಷ" : "ವರ್ಷಗಳು";
      },
      mo: function (c) {
        return c === 1 ? "ತಿಂಗಳು" : "ತಿಂಗಳುಗಳು";
      },
      w: function (c) {
        return c === 1 ? "ವಾರ" : "ವಾರಗಳು";
      },
      d: function (c) {
        return c === 1 ? "ದಿನ" : "ದಿನಗಳು";
      },
      h: function (c) {
        return c === 1 ? "ಗಂಟೆ" : "ಗಂಟೆಗಳು";
      },
      m: function (c) {
        return c === 1 ? "ನಿಮಿಷ" : "ನಿಮಿಷಗಳು";
      },
      s: function (c) {
        return c === 1 ? "ಸೆಕೆಂಡ್" : "ಸೆಕೆಂಡುಗಳು";
      },
      ms: function (c) {
        return c === 1 ? "ಮಿಲಿಸೆಕೆಂಡ್" : "ಮಿಲಿಸೆಕೆಂಡುಗಳು";
      }
    },
    ko: {
      y: "년",
      mo: "개월",
      w: "주일",
      d: "일",
      h: "시간",
      m: "분",
      s: "초",
      ms: "밀리 초",
      decimal: "."
    },
    ku: {
      y: "sal",
      mo: "meh",
      w: "hefte",
      d: "roj",
      h: "seet",
      m: "deqe",
      s: "saniye",
      ms: "mîlîçirk",
      decimal: ","
    },
    lo: {
      y: "ປີ",
      mo: "ເດືອນ",
      w: "ອາທິດ",
      d: "ມື້",
      h: "ຊົ່ວໂມງ",
      m: "ນາທີ",
      s: "ວິນາທີ",
      ms: "ມິນລິວິນາທີ",
      decimal: ","
    },
    lt: {
      y: function (c) {
        return c % 10 === 0 || (c % 100 >= 10 && c % 100 <= 20)
          ? "metų"
          : "metai";
      },
      mo: function (c) {
        return ["mėnuo", "mėnesiai", "mėnesių"][getLithuanianForm(c)];
      },
      w: function (c) {
        return ["savaitė", "savaitės", "savaičių"][getLithuanianForm(c)];
      },
      d: function (c) {
        return ["diena", "dienos", "dienų"][getLithuanianForm(c)];
      },
      h: function (c) {
        return ["valanda", "valandos", "valandų"][getLithuanianForm(c)];
      },
      m: function (c) {
        return ["minutė", "minutės", "minučių"][getLithuanianForm(c)];
      },
      s: function (c) {
        return ["sekundė", "sekundės", "sekundžių"][getLithuanianForm(c)];
      },
      ms: function (c) {
        return ["milisekundė", "milisekundės", "milisekundžių"][
          getLithuanianForm(c)
        ];
      },
      decimal: ","
    },
    lv: {
      y: function (c) {
        return getLatvianForm(c) ? "gads" : "gadi";
      },
      mo: function (c) {
        return getLatvianForm(c) ? "mēnesis" : "mēneši";
      },
      w: function (c) {
        return getLatvianForm(c) ? "nedēļa" : "nedēļas";
      },
      d: function (c) {
        return getLatvianForm(c) ? "diena" : "dienas";
      },
      h: function (c) {
        return getLatvianForm(c) ? "stunda" : "stundas";
      },
      m: function (c) {
        return getLatvianForm(c) ? "minūte" : "minūtes";
      },
      s: function (c) {
        return getLatvianForm(c) ? "sekunde" : "sekundes";
      },
      ms: function (c) {
        return getLatvianForm(c) ? "milisekunde" : "milisekundes";
      },
      decimal: ","
    },
    mk: {
      y: function (c) {
        return c === 1 ? "година" : "години";
      },
      mo: function (c) {
        return c === 1 ? "месец" : "месеци";
      },
      w: function (c) {
        return c === 1 ? "недела" : "недели";
      },
      d: function (c) {
        return c === 1 ? "ден" : "дена";
      },
      h: function (c) {
        return c === 1 ? "час" : "часа";
      },
      m: function (c) {
        return c === 1 ? "минута" : "минути";
      },
      s: function (c) {
        return c === 1 ? "секунда" : "секунди";
      },
      ms: function (c) {
        return c === 1 ? "милисекунда" : "милисекунди";
      },
      decimal: ","
    },
    mr: {
      y: function (c) {
        return c === 1 ? "वर्ष" : "वर्षे";
      },
      mo: function (c) {
        return c === 1 ? "महिना" : "महिने";
      },
      w: function (c) {
        return c === 1 ? "आठवडा" : "आठवडे";
      },
      d: "दिवस",
      h: "तास",
      m: function (c) {
        return c === 1 ? "मिनिट" : "मिनिटे";
      },
      s: "सेकंद",
      ms: "मिलिसेकंद"
    },
    ms: {
      y: "tahun",
      mo: "bulan",
      w: "minggu",
      d: "hari",
      h: "jam",
      m: "minit",
      s: "saat",
      ms: "milisaat",
      decimal: "."
    },
    nl: {
      y: "jaar",
      mo: function (c) {
        return c === 1 ? "maand" : "maanden";
      },
      w: function (c) {
        return c === 1 ? "week" : "weken";
      },
      d: function (c) {
        return c === 1 ? "dag" : "dagen";
      },
      h: "uur",
      m: function (c) {
        return c === 1 ? "minuut" : "minuten";
      },
      s: function (c) {
        return c === 1 ? "seconde" : "seconden";
      },
      ms: function (c) {
        return c === 1 ? "milliseconde" : "milliseconden";
      },
      decimal: ","
    },
    no: {
      y: "år",
      mo: function (c) {
        return "måned" + (c === 1 ? "" : "er");
      },
      w: function (c) {
        return "uke" + (c === 1 ? "" : "r");
      },
      d: function (c) {
        return "dag" + (c === 1 ? "" : "er");
      },
      h: function (c) {
        return "time" + (c === 1 ? "" : "r");
      },
      m: function (c) {
        return "minutt" + (c === 1 ? "" : "er");
      },
      s: function (c) {
        return "sekund" + (c === 1 ? "" : "er");
      },
      ms: function (c) {
        return "millisekund" + (c === 1 ? "" : "er");
      },
      decimal: ","
    },
    pl: {
      y: function (c) {
        return ["rok", "roku", "lata", "lat"][getPolishForm(c)];
      },
      mo: function (c) {
        return ["miesiąc", "miesiąca", "miesiące", "miesięcy"][
          getPolishForm(c)
        ];
      },
      w: function (c) {
        return ["tydzień", "tygodnia", "tygodnie", "tygodni"][getPolishForm(c)];
      },
      d: function (c) {
        return ["dzień", "dnia", "dni", "dni"][getPolishForm(c)];
      },
      h: function (c) {
        return ["godzina", "godziny", "godziny", "godzin"][getPolishForm(c)];
      },
      m: function (c) {
        return ["minuta", "minuty", "minuty", "minut"][getPolishForm(c)];
      },
      s: function (c) {
        return ["sekunda", "sekundy", "sekundy", "sekund"][getPolishForm(c)];
      },
      ms: function (c) {
        return ["milisekunda", "milisekundy", "milisekundy", "milisekund"][
          getPolishForm(c)
        ];
      },
      decimal: ","
    },
    pt: {
      y: function (c) {
        return "ano" + (c === 1 ? "" : "s");
      },
      mo: function (c) {
        return c === 1 ? "mês" : "meses";
      },
      w: function (c) {
        return "semana" + (c === 1 ? "" : "s");
      },
      d: function (c) {
        return "dia" + (c === 1 ? "" : "s");
      },
      h: function (c) {
        return "hora" + (c === 1 ? "" : "s");
      },
      m: function (c) {
        return "minuto" + (c === 1 ? "" : "s");
      },
      s: function (c) {
        return "segundo" + (c === 1 ? "" : "s");
      },
      ms: function (c) {
        return "milissegundo" + (c === 1 ? "" : "s");
      },
      decimal: ","
    },
    ro: {
      y: function (c) {
        return c === 1 ? "an" : "ani";
      },
      mo: function (c) {
        return c === 1 ? "lună" : "luni";
      },
      w: function (c) {
        return c === 1 ? "săptămână" : "săptămâni";
      },
      d: function (c) {
        return c === 1 ? "zi" : "zile";
      },
      h: function (c) {
        return c === 1 ? "oră" : "ore";
      },
      m: function (c) {
        return c === 1 ? "minut" : "minute";
      },
      s: function (c) {
        return c === 1 ? "secundă" : "secunde";
      },
      ms: function (c) {
        return c === 1 ? "milisecundă" : "milisecunde";
      },
      decimal: ","
    },
    ru: {
      y: function (c) {
        return ["лет", "год", "года"][getSlavicForm(c)];
      },
      mo: function (c) {
        return ["месяцев", "месяц", "месяца"][getSlavicForm(c)];
      },
      w: function (c) {
        return ["недель", "неделя", "недели"][getSlavicForm(c)];
      },
      d: function (c) {
        return ["дней", "день", "дня"][getSlavicForm(c)];
      },
      h: function (c) {
        return ["часов", "час", "часа"][getSlavicForm(c)];
      },
      m: function (c) {
        return ["минут", "минута", "минуты"][getSlavicForm(c)];
      },
      s: function (c) {
        return ["секунд", "секунда", "секунды"][getSlavicForm(c)];
      },
      ms: function (c) {
        return ["миллисекунд", "миллисекунда", "миллисекунды"][
          getSlavicForm(c)
        ];
      },
      decimal: ","
    },
    sq: {
      y: function (c) {
        return c === 1 ? "vit" : "vjet";
      },
      mo: "muaj",
      w: "javë",
      d: "ditë",
      h: "orë",
      m: function (c) {
        return "minut" + (c === 1 ? "ë" : "a");
      },
      s: function (c) {
        return "sekond" + (c === 1 ? "ë" : "a");
      },
      ms: function (c) {
        return "milisekond" + (c === 1 ? "ë" : "a");
      },
      decimal: ","
    },
    sr: {
      y: function (c) {
        return ["години", "година", "године"][getSlavicForm(c)];
      },
      mo: function (c) {
        return ["месеци", "месец", "месеца"][getSlavicForm(c)];
      },
      w: function (c) {
        return ["недељи", "недеља", "недеље"][getSlavicForm(c)];
      },
      d: function (c) {
        return ["дани", "дан", "дана"][getSlavicForm(c)];
      },
      h: function (c) {
        return ["сати", "сат", "сата"][getSlavicForm(c)];
      },
      m: function (c) {
        return ["минута", "минут", "минута"][getSlavicForm(c)];
      },
      s: function (c) {
        return ["секунди", "секунда", "секунде"][getSlavicForm(c)];
      },
      ms: function (c) {
        return ["милисекунди", "милисекунда", "милисекунде"][getSlavicForm(c)];
      },
      decimal: ","
    },
    ta: {
      y: function (c) {
        return c === 1 ? "வருடம்" : "ஆண்டுகள்";
      },
      mo: function (c) {
        return c === 1 ? "மாதம்" : "மாதங்கள்";
      },
      w: function (c) {
        return c === 1 ? "வாரம்" : "வாரங்கள்";
      },
      d: function (c) {
        return c === 1 ? "நாள்" : "நாட்கள்";
      },
      h: function (c) {
        return c === 1 ? "மணி" : "மணிநேரம்";
      },
      m: function (c) {
        return "நிமிட" + (c === 1 ? "ம்" : "ங்கள்");
      },
      s: function (c) {
        return "வினாடி" + (c === 1 ? "" : "கள்");
      },
      ms: function (c) {
        return "மில்லி விநாடி" + (c === 1 ? "" : "கள்");
      }
    },
    te: {
      y: function (c) {
        return "సంవత్స" + (c === 1 ? "రం" : "రాల");
      },
      mo: function (c) {
        return "నెల" + (c === 1 ? "" : "ల");
      },
      w: function (c) {
        return c === 1 ? "వారం" : "వారాలు";
      },
      d: function (c) {
        return "రోజు" + (c === 1 ? "" : "లు");
      },
      h: function (c) {
        return "గంట" + (c === 1 ? "" : "లు");
      },
      m: function (c) {
        return c === 1 ? "నిమిషం" : "నిమిషాలు";
      },
      s: function (c) {
        return c === 1 ? "సెకను" : "సెకన్లు";
      },
      ms: function (c) {
        return c === 1 ? "మిల్లీసెకన్" : "మిల్లీసెకన్లు";
      }
    },
    uk: {
      y: function (c) {
        return ["років", "рік", "роки"][getSlavicForm(c)];
      },
      mo: function (c) {
        return ["місяців", "місяць", "місяці"][getSlavicForm(c)];
      },
      w: function (c) {
        return ["тижнів", "тиждень", "тижні"][getSlavicForm(c)];
      },
      d: function (c) {
        return ["днів", "день", "дні"][getSlavicForm(c)];
      },
      h: function (c) {
        return ["годин", "година", "години"][getSlavicForm(c)];
      },
      m: function (c) {
        return ["хвилин", "хвилина", "хвилини"][getSlavicForm(c)];
      },
      s: function (c) {
        return ["секунд", "секунда", "секунди"][getSlavicForm(c)];
      },
      ms: function (c) {
        return ["мілісекунд", "мілісекунда", "мілісекунди"][getSlavicForm(c)];
      },
      decimal: ","
    },
    ur: {
      y: "سال",
      mo: function (c) {
        return c === 1 ? "مہینہ" : "مہینے";
      },
      w: function (c) {
        return c === 1 ? "ہفتہ" : "ہفتے";
      },
      d: "دن",
      h: function (c) {
        return c === 1 ? "گھنٹہ" : "گھنٹے";
      },
      m: "منٹ",
      s: "سیکنڈ",
      ms: "ملی سیکنڈ",
      decimal: "."
    },
    sk: {
      y: function (c) {
        return ["rok", "roky", "roky", "rokov"][getCzechOrSlovakForm(c)];
      },
      mo: function (c) {
        return ["mesiac", "mesiace", "mesiace", "mesiacov"][
          getCzechOrSlovakForm(c)
        ];
      },
      w: function (c) {
        return ["týždeň", "týždne", "týždne", "týždňov"][
          getCzechOrSlovakForm(c)
        ];
      },
      d: function (c) {
        return ["deň", "dni", "dni", "dní"][getCzechOrSlovakForm(c)];
      },
      h: function (c) {
        return ["hodina", "hodiny", "hodiny", "hodín"][getCzechOrSlovakForm(c)];
      },
      m: function (c) {
        return ["minúta", "minúty", "minúty", "minút"][getCzechOrSlovakForm(c)];
      },
      s: function (c) {
        return ["sekunda", "sekundy", "sekundy", "sekúnd"][
          getCzechOrSlovakForm(c)
        ];
      },
      ms: function (c) {
        return ["milisekunda", "milisekundy", "milisekundy", "milisekúnd"][
          getCzechOrSlovakForm(c)
        ];
      },
      decimal: ","
    },
    sl: {
      y: function (c) {
        if (c % 10 === 1) {
          return "leto";
        } else if (c % 100 === 2) {
          return "leti";
        } else if (
          c % 100 === 3 ||
          c % 100 === 4 ||
          (Math.floor(c) !== c && c % 100 <= 5)
        ) {
          return "leta";
        } else {
          return "let";
        }
      },
      mo: function (c) {
        if (c % 10 === 1) {
          return "mesec";
        } else if (c % 100 === 2 || (Math.floor(c) !== c && c % 100 <= 5)) {
          return "meseca";
        } else if (c % 10 === 3 || c % 10 === 4) {
          return "mesece";
        } else {
          return "mesecev";
        }
      },
      w: function (c) {
        if (c % 10 === 1) {
          return "teden";
        } else if (c % 10 === 2 || (Math.floor(c) !== c && c % 100 <= 4)) {
          return "tedna";
        } else if (c % 10 === 3 || c % 10 === 4) {
          return "tedne";
        } else {
          return "tednov";
        }
      },
      d: function (c) {
        return c % 100 === 1 ? "dan" : "dni";
      },
      h: function (c) {
        if (c % 10 === 1) {
          return "ura";
        } else if (c % 100 === 2) {
          return "uri";
        } else if (c % 10 === 3 || c % 10 === 4 || Math.floor(c) !== c) {
          return "ure";
        } else {
          return "ur";
        }
      },
      m: function (c) {
        if (c % 10 === 1) {
          return "minuta";
        } else if (c % 10 === 2) {
          return "minuti";
        } else if (
          c % 10 === 3 ||
          c % 10 === 4 ||
          (Math.floor(c) !== c && c % 100 <= 4)
        ) {
          return "minute";
        } else {
          return "minut";
        }
      },
      s: function (c) {
        if (c % 10 === 1) {
          return "sekunda";
        } else if (c % 100 === 2) {
          return "sekundi";
        } else if (c % 100 === 3 || c % 100 === 4 || Math.floor(c) !== c) {
          return "sekunde";
        } else {
          return "sekund";
        }
      },
      ms: function (c) {
        if (c % 10 === 1) {
          return "milisekunda";
        } else if (c % 100 === 2) {
          return "milisekundi";
        } else if (c % 100 === 3 || c % 100 === 4 || Math.floor(c) !== c) {
          return "milisekunde";
        } else {
          return "milisekund";
        }
      },
      decimal: ","
    },
    sv: {
      y: "år",
      mo: function (c) {
        return "månad" + (c === 1 ? "" : "er");
      },
      w: function (c) {
        return "veck" + (c === 1 ? "a" : "or");
      },
      d: function (c) {
        return "dag" + (c === 1 ? "" : "ar");
      },
      h: function (c) {
        return "timm" + (c === 1 ? "e" : "ar");
      },
      m: function (c) {
        return "minut" + (c === 1 ? "" : "er");
      },
      s: function (c) {
        return "sekund" + (c === 1 ? "" : "er");
      },
      ms: function (c) {
        return "millisekund" + (c === 1 ? "" : "er");
      },
      decimal: ","
    },
    sw: {
      y: function (c) {
        return c === 1 ? "mwaka" : "miaka";
      },
      mo: function (c) {
        return c === 1 ? "mwezi" : "miezi";
      },
      w: "wiki",
      d: function (c) {
        return c === 1 ? "siku" : "masiku";
      },
      h: function (c) {
        return c === 1 ? "saa" : "masaa";
      },
      m: "dakika",
      s: "sekunde",
      ms: "milisekunde",
      decimal: ".",
      _numberFirst: true
    },
    tr: {
      y: "yıl",
      mo: "ay",
      w: "hafta",
      d: "gün",
      h: "saat",
      m: "dakika",
      s: "saniye",
      ms: "milisaniye",
      decimal: ","
    },
    th: {
      y: "ปี",
      mo: "เดือน",
      w: "สัปดาห์",
      d: "วัน",
      h: "ชั่วโมง",
      m: "นาที",
      s: "วินาที",
      ms: "มิลลิวินาที",
      decimal: "."
    },
    vi: {
      y: "năm",
      mo: "tháng",
      w: "tuần",
      d: "ngày",
      h: "giờ",
      m: "phút",
      s: "giây",
      ms: "mili giây",
      decimal: ","
    },
    zh_CN: {
      y: "年",
      mo: "个月",
      w: "周",
      d: "天",
      h: "小时",
      m: "分钟",
      s: "秒",
      ms: "毫秒",
      decimal: "."
    },
    zh_TW: {
      y: "年",
      mo: "個月",
      w: "周",
      d: "天",
      h: "小時",
      m: "分鐘",
      s: "秒",
      ms: "毫秒",
      decimal: "."
    }
  };

  // You can create a humanizer, which returns a function with default
  // parameters.
  function humanizer(passedOptions) {
    var result = function humanizer(ms, humanizerOptions) {
      var options = assign({}, result, humanizerOptions || {});
      return doHumanization(ms, options);
    };

    return assign(
      result,
      {
        language: "en",
        spacer: " ",
        conjunction: "",
        serialComma: true,
        units: ["y", "mo", "w", "d", "h", "m", "s"],
        languages: {},
        round: false,
        unitMeasures: {
          y: 31557600000,
          mo: 2629800000,
          w: 604800000,
          d: 86400000,
          h: 3600000,
          m: 60000,
          s: 1000,
          ms: 1
        }
      },
      passedOptions
    );
  }

  // The main function is just a wrapper around a default humanizer.
  var humanizeDuration = humanizer({});

  // Build dictionary from options
  function getDictionary(options) {
    var languagesFromOptions = [options.language];

    if (has(options, "fallbacks")) {
      if (isArray(options.fallbacks) && options.fallbacks.length) {
        languagesFromOptions = languagesFromOptions.concat(options.fallbacks);
      } else {
        throw new Error("fallbacks must be an array with at least one element");
      }
    }

    for (var i = 0; i < languagesFromOptions.length; i++) {
      var languageToTry = languagesFromOptions[i];
      if (has(options.languages, languageToTry)) {
        return options.languages[languageToTry];
      } else if (has(LANGUAGES, languageToTry)) {
        return LANGUAGES[languageToTry];
      }
    }

    throw new Error("No language found.");
  }

  // doHumanization does the bulk of the work.
  function doHumanization(ms, options) {
    var i, len, piece;

    // Make sure we have a positive number.
    // Has the nice sideffect of turning Number objects into primitives.
    ms = Math.abs(ms);

    var dictionary = getDictionary(options);
    var pieces = [];

    // Start at the top and keep removing units, bit by bit.
    var unitName, unitMS, unitCount;
    for (i = 0, len = options.units.length; i < len; i++) {
      unitName = options.units[i];
      unitMS = options.unitMeasures[unitName];

      // What's the number of full units we can fit?
      if (i + 1 === len) {
        if (has(options, "maxDecimalPoints")) {
          // We need to use this expValue to avoid rounding functionality of toFixed call
          var expValue = Math.pow(10, options.maxDecimalPoints);
          var unitCountFloat = ms / unitMS;
          unitCount = parseFloat(
            (Math.floor(expValue * unitCountFloat) / expValue).toFixed(
              options.maxDecimalPoints
            )
          );
        } else {
          unitCount = ms / unitMS;
        }
      } else {
        unitCount = Math.floor(ms / unitMS);
      }

      // Add the string.
      pieces.push({
        unitCount: unitCount,
        unitName: unitName
      });

      // Remove what we just figured out.
      ms -= unitCount * unitMS;
    }

    var firstOccupiedUnitIndex = 0;
    for (i = 0; i < pieces.length; i++) {
      if (pieces[i].unitCount) {
        firstOccupiedUnitIndex = i;
        break;
      }
    }

    if (options.round) {
      var ratioToLargerUnit, previousPiece;
      for (i = pieces.length - 1; i >= 0; i--) {
        piece = pieces[i];
        piece.unitCount = Math.round(piece.unitCount);

        if (i === 0) {
          break;
        }

        previousPiece = pieces[i - 1];

        ratioToLargerUnit =
          options.unitMeasures[previousPiece.unitName] /
          options.unitMeasures[piece.unitName];
        if (
          piece.unitCount % ratioToLargerUnit === 0 ||
          (options.largest && options.largest - 1 < i - firstOccupiedUnitIndex)
        ) {
          previousPiece.unitCount += piece.unitCount / ratioToLargerUnit;
          piece.unitCount = 0;
        }
      }
    }

    var result = [];
    for (i = 0, pieces.length; i < len; i++) {
      piece = pieces[i];
      if (piece.unitCount) {
        result.push(
          render(piece.unitCount, piece.unitName, dictionary, options)
        );
      }

      if (result.length === options.largest) {
        break;
      }
    }

    if (result.length) {
      var delimiter;
      if (has(options, "delimiter")) {
        delimiter = options.delimiter;
      } else if (has(dictionary, "delimiter")) {
        delimiter = dictionary.delimiter;
      } else {
        delimiter = ", ";
      }

      if (!options.conjunction || result.length === 1) {
        return result.join(delimiter);
      } else if (result.length === 2) {
        return result.join(options.conjunction);
      } else if (result.length > 2) {
        return (
          result.slice(0, -1).join(delimiter) +
          (options.serialComma ? "," : "") +
          options.conjunction +
          result.slice(-1)
        );
      }
    } else {
      return render(
        0,
        options.units[options.units.length - 1],
        dictionary,
        options
      );
    }
  }

  function render(count, type, dictionary, options) {
    var decimal;
    if (has(options, "decimal")) {
      decimal = options.decimal;
    } else if (has(dictionary, "decimal")) {
      decimal = dictionary.decimal;
    } else {
      decimal = ".";
    }

    var countStr;
    if (typeof dictionary._formatCount === "function") {
      countStr = dictionary._formatCount(count, decimal);
    } else {
      countStr = count.toString().replace(".", decimal);
    }

    var dictionaryValue = dictionary[type];
    var word;
    if (typeof dictionaryValue === "function") {
      word = dictionaryValue(count);
    } else {
      word = dictionaryValue;
    }

    if (dictionary._numberFirst) {
      return word + options.spacer + countStr;
    }
    return countStr + options.spacer + word;
  }

  function assign(destination) {
    var source;
    for (var i = 1; i < arguments.length; i++) {
      source = arguments[i];
      for (var prop in source) {
        if (has(source, prop)) {
          destination[prop] = source[prop];
        }
      }
    }
    return destination;
  }

  function getArabicForm(c) {
    if (c === 1) {
      return 0;
    }
    if (c === 2) {
      return 1;
    }
    if (c > 2 && c < 11) {
      return 2;
    }
    return 0;
  }

  function getPolishForm(c) {
    if (c === 1) {
      return 0;
    } else if (Math.floor(c) !== c) {
      return 1;
    } else if (c % 10 >= 2 && c % 10 <= 4 && !(c % 100 > 10 && c % 100 < 20)) {
      return 2;
    } else {
      return 3;
    }
  }

  function getSlavicForm(c) {
    if (Math.floor(c) !== c) {
      return 2;
    } else if (
      (c % 100 >= 5 && c % 100 <= 20) ||
      (c % 10 >= 5 && c % 10 <= 9) ||
      c % 10 === 0
    ) {
      return 0;
    } else if (c % 10 === 1) {
      return 1;
    } else if (c > 1) {
      return 2;
    } else {
      return 0;
    }
  }

  function getCzechOrSlovakForm(c) {
    if (c === 1) {
      return 0;
    } else if (Math.floor(c) !== c) {
      return 1;
    } else if (c % 10 >= 2 && c % 10 <= 4 && c % 100 < 10) {
      return 2;
    } else {
      return 3;
    }
  }

  function getLithuanianForm(c) {
    if (c === 1 || (c % 10 === 1 && c % 100 > 20)) {
      return 0;
    } else if (
      Math.floor(c) !== c ||
      (c % 10 >= 2 && c % 100 > 20) ||
      (c % 10 >= 2 && c % 100 < 10)
    ) {
      return 1;
    } else {
      return 2;
    }
  }

  function getLatvianForm(c) {
    return c % 10 === 1 && c % 100 !== 11;
  }

  // We need to make sure we support browsers that don't have
  // `Array.isArray`, so we define a fallback here.
  var isArray =
    Array.isArray ||
    function (arg) {
      return Object.prototype.toString.call(arg) === "[object Array]";
    };

  function has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }

  humanizeDuration.getSupportedLanguages = function getSupportedLanguages() {
    var result = [];
    for (var language in LANGUAGES) {
      if (has(LANGUAGES, language) && language !== "gr") {
        result.push(language);
      }
    }
    return result;
  };

  humanizeDuration.humanizer = humanizer;

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return humanizeDuration;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module !== "undefined" && module.exports) {
    module.exports = humanizeDuration;
  } else {
    this.humanizeDuration = humanizeDuration;
  }
})();


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StageStatusView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ScrollableElementWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return filterBagInfoByDepartTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return filterBagInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return convertTimestampToLocaleString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setBagStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BagTrackingBanner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Constants__ = __webpack_require__(2);
/** StageStatusView publishes Bag information metrics such as total bags, bags outside of station **/var StageStatusView=function StageStatusView(data){var stageStatus=data.stageStatus?data.stageStatus:{};return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_column___default.a,{spacing:"small"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tooltip___default.a,{position:"right",title:stageStatus.tooltip?stageStatus.tooltip:""},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a,{type:"h100"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:stageStatus.title?stageStatus.title:"",defaultMessage:stageStatus.message?stageStatus.message:""})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a,{type:"d50"},data.stageStatus.value));};/** ScrollableElementWrapper allows a scrolling mechanism to be provided for overflowing boxes for it's children **/var ScrollableElementWrapper=function ScrollableElementWrapper(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{style:{overflowX:"auto",width:"100%"}},children);};/** Filters the bags based on departed time. It takes last 1 day as default filter. **/var filterBagInfoByDepartTime=function filterBagInfoByDepartTime(bagInfo,filters){var startDate=filters.startDate.split('-');var startTime=filters.startTime.split(':');var starTimeStamp=new Date(Date.UTC(startDate[0],startDate[1]-1,startDate[2],startTime[0],startTime[1],startTime[2]));return filters.length===0||bagInfo['departEventTime']&&bagInfo['departEventTime']>=starTimeStamp;};var filterBagInfo=function filterBagInfo(bagInfo,filter,key){return filter.length===0||bagInfo[key]&&bagInfo[key].toString().toLowerCase().startsWith(filter.toLowerCase());};/** TimeStamp to Human Readable date time **/var convertTimestampToLocaleString=function convertTimestampToLocaleString(dateTimeStamp,bagStatus,useCase){/**
     * Don't convert null or undefined timestamp into string.
     * Show both depart and receive time when bag is inside station but only show depart time if bag is outside station.
     */if(dateTimeStamp==null||bagStatus===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["V" /* BAG_TRACKING_CONSTANTS */].OUTSIDE_STATION&&useCase===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["V" /* BAG_TRACKING_CONSTANTS */].RECEIVE_TIME){return;}return new Date(dateTimeStamp).toLocaleString();};/** Set Bag Status. This function converts bag's event type into a more user friendly format. If event type is RECEIVE, then
 * it indicates that bag is received at the station which means currently the bag is inside the station. Similarly, if event
 * type i depart, then it indicates that bag is departed from the station which means currently bag is outside of the station.
 **/var setBagStatus=function setBagStatus(bag){if(bag.eventType===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["V" /* BAG_TRACKING_CONSTANTS */].RECEIVE){bag.eventType=__WEBPACK_IMPORTED_MODULE_6__util_Constants__["V" /* BAG_TRACKING_CONSTANTS */].INSIDE_STATION;}else if(bag.eventType===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["V" /* BAG_TRACKING_CONSTANTS */].DEPART){bag.eventType=__WEBPACK_IMPORTED_MODULE_6__util_Constants__["V" /* BAG_TRACKING_CONSTANTS */].OUTSIDE_STATION;}};var BagTrackingBanner=function BagTrackingBanner(){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_alert___default.a,{size:"large"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"banner.bagTracking"})));};

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InductCameraDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_InductCameraDeviceOverviewReducer__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var InductCameraDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var InductCameraDeviceOverviewContextProvider=function InductCameraDeviceOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},asmlComponentInformation:{},macAddressArray:[],loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_InductCameraDeviceOverviewReducer__["a" /* InductCameraDeviceOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InductCameraDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (InductCameraDeviceOverviewContextProvider);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrinterDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_PrinterDeviceOverviewReducer__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var PrinterDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var PrinterDeviceOverviewContextProvider=function PrinterDeviceOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},asmlComponentInformation:{},macAddressArray:[],loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_PrinterDeviceOverviewReducer__["a" /* PrinterDeviceOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrinterDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (PrinterDeviceOverviewContextProvider);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VerificationCameraDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_VerificationCameraDeviceOverviewReducer__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var VerificationCameraDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var VerificationCameraDeviceOverviewContextProvider=function VerificationCameraDeviceOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},asmlComponentInformation:{},macAddressArray:[],loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_VerificationCameraDeviceOverviewReducer__["a" /* VerificationCameraDeviceOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VerificationCameraDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (VerificationCameraDeviceOverviewContextProvider);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VaprDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_VaprDeviceOverviewReducer__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var VaprDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var VaprDeviceOverviewContextProvider=function VaprDeviceOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},vaprDeviceInformation:{},macAddressArray:[],loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_VaprDeviceOverviewReducer__["a" /* VaprDeviceOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VaprDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (VaprDeviceOverviewContextProvider);

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(533);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemoryRouter */
/* unused harmony export Prompt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Router; });
/* unused harmony export StaticRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Switch; });
/* unused harmony export generatePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return matchPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return withRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return context; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mini_create_react_context__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_0_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var context =
/*#__PURE__*/
createNamedContext("Router");

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Provider, {
      children: this.props.children || null,
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    });
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_5_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
    !context$$1 ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context$$1.staticContext) return null;
    var method = context$$1.history.block;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
    !context$$1 ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context$$1.history,
        staticContext = context$$1.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_5_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string") options = {
    path: options
  };
  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path) return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      if (typeof children === "function") {
        children = children(props);

        if (children === undefined) {
          if (false) {
            var path = _this.props.path;
            process.env.NODE_ENV !== "production" ? warning(false, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
          }

          children = null;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Provider, {
        value: props
      }, children && !isEmptyChildren(children) ? children : props.match ? component ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : render ? render(props) : null : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_5_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
     false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false);
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$$1.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context$$1.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context$$1, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}




/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(235);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(556);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(88),
    stubFalse = __webpack_require__(583);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(124)(module)))

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(584),
    baseUnary = __webpack_require__(326),
    nodeUtil = __webpack_require__(585);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 326 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(123),
    isObject = __webpack_require__(153);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(187),
    stackClear = __webpack_require__(598),
    stackDelete = __webpack_require__(599),
    stackGet = __webpack_require__(600),
    stackHas = __webpack_require__(601),
    stackSet = __webpack_require__(602);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 329 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(619),
    isObjectLike = __webpack_require__(104);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(242),
    arraySome = __webpack_require__(622),
    cacheHas = __webpack_require__(243);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 332 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(105),
    root = __webpack_require__(88);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(153);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(337),
    toKey = __webpack_require__(192);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(82),
    isKey = __webpack_require__(245),
    stringToPath = __webpack_require__(639),
    toString = __webpack_require__(106);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 338 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var upperFirst = function upperFirst(str) {
  return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
};

var _default = upperFirst;
exports["default"] = _default;

/***/ }),
/* 340 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports = {
  spacing100: 2,
  spacing200: 4,
  spacing300: 8,
  spacing400: 16,
  spacing450: 24,
  spacing500: 32,
  spacing600: 64,
  spacingNone: 0,
  spacingXxsmall: 2,
  spacingXsmall: 4,
  spacingSmall: 8,
  spacingMedium: 16,
  spacingLarge: 32,
  spacingXlarge: 64
};

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return publishCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return publishTime; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Util__ = __webpack_require__(5);
var publishCount=function publishCount(processName,metricName){var request=getMetricPublishRequest(processName,metricName,1,__WEBPACK_IMPORTED_MODULE_0__enums__["b" /* metricType */].COUNT);Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["h" /* publishClientSideMetrics */])(request);publishNodeLevelMetrics(request);};var publishTime=function publishTime(processName,metricName,startTime){var metricValue=Date.now()-startTime;var request=getMetricPublishRequest(processName,metricName,metricValue,__WEBPACK_IMPORTED_MODULE_0__enums__["b" /* metricType */].TIME);Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["h" /* publishClientSideMetrics */])(request);publishNodeLevelMetrics(request);};var getMetricPublishRequest=function getMetricPublishRequest(processName,metricName,metricValue,metricType){return{processName:processName,metricName:metricName,metricValue:metricValue,metricType:metricType};};var publishNodeLevelMetrics=function publishNodeLevelMetrics(request){var nodeId=Object(__WEBPACK_IMPORTED_MODULE_2__Util__["X" /* getNodeId */])();var nodeRequest=Object.assign({},request,{processName:request.processName+'_'+nodeId});Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["h" /* publishClientSideMetrics */])(nodeRequest);};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(343);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 343 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var buttonReset = {
  display: "inline-block",
  padding: 0,
  border: 0,
  outline: "none",
  backgroundColor: "transparent",
  textAlign: "inherit",
  color: "inherit",
  fontFamily: "inherit",
  fontSize: "inherit",
  fontWeight: "inherit",
  lineHeight: "inherit",
  WebkitAppearance: "none",
  WebkitMarginBefore: 0,
  WebkitMarginAfter: 0,
  WebkitMarginStart: 0,
  WebkitMarginEnd: 0,
  "::-moz-focus-inner": {
    border: 0
  }
};
var _default = buttonReset;
exports["default"] = _default;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(123),
    isArray = __webpack_require__(82),
    isObjectLike = __webpack_require__(104);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hoverStyles = exports.focusStyles = exports.disabledStyles = exports.defaultStyles = exports.activeStyles = void 0;

var _focusRing = _interopRequireDefault(__webpack_require__(73));

var getStyles = function getStyles(t, _ref) {
  var type = _ref.type,
      backdrop = _ref.backdrop,
      state = _ref.state;
  return {
    color: t("foregroundColor", [type, backdrop, state]),
    backgroundColor: t("backgroundColor", [type, backdrop, state]),
    borderColor: t("borderColor", [type, state])
  };
};

var activeStyles = function activeStyles(t, _ref2) {
  var type = _ref2.type,
      backdrop = _ref2.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "pressed"
  });
};

exports.activeStyles = activeStyles;

var hoverStyles = function hoverStyles(t, _ref3) {
  var type = _ref3.type,
      backdrop = _ref3.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "hover"
  });
};

exports.hoverStyles = hoverStyles;

var defaultStyles = function defaultStyles(t, _ref4) {
  var type = _ref4.type,
      backdrop = _ref4.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "default"
  });
};

exports.defaultStyles = defaultStyles;

var disabledStyles = function disabledStyles(t, _ref5) {
  var type = _ref5.type,
      backdrop = _ref5.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "disabled"
  });
};

exports.disabledStyles = disabledStyles;

var focusStyles = function focusStyles(t, _ref6) {
  var focus = _ref6.focus,
      borderWidth = _ref6.borderWidth,
      borderRadius = _ref6.borderRadius,
      backdropColor = _ref6.backdropColor,
      linkOrIcon = _ref6.linkOrIcon,
      outlineOffset = _ref6.outlineOffset;
  return (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderWidth: borderWidth,
    borderRadius: borderRadius,
    gapColor: backdropColor,
    dropShadow: !linkOrIcon,
    offset: outlineOffset !== undefined ? outlineOffset : t("focusOutlineOffset")
  });
};

exports.focusStyles = focusStyles;

/***/ }),
/* 347 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    focusRingWidth: 2,
    focusRingColorFocus: tokens.themeBorderPrimaryFocus,
    focusRingColorError: tokens.themeBorderPrimaryError,
    focusRingDropShadowOffsetX: 0,
    focusRingDropShadowOffsetY: 1,
    focusRingDropShadowBlur: 2,
    focusRingDropShadowSpread: 0,
    focusRingDropShadowColor: "rgba(11, 12, 12, 0.16)"
  }
};

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(686);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(255),
    baseIteratee = __webpack_require__(186),
    toInteger = __webpack_require__(130);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = fromIndex < 0
      ? nativeMax(length + index, 0)
      : nativeMin(index, length - 1);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}

module.exports = findLastIndex;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(690)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(697);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _emotion = __webpack_require__(11);

var _token = __webpack_require__(20);

var _noTextWrap = _interopRequireDefault(__webpack_require__(257));

/**
 * Pass in a token helper for text tokens
 * (e.g. getTokenHelper("text")(themedTextTokens)) and any text props.
 */
var getTextStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _ul, _ref2, _ol, _ref3, _css;

  var fontFamily = _ref.fontFamily,
      color = _ref.color,
      type = _ref.type,
      transform = _ref.transform,
      alignment = _ref.alignment,
      tag = _ref.tag,
      truncate = _ref.truncate,
      breakWord = _ref.breakWord,
      listStyle = _ref.listStyle;
  return (0, _emotion.css)( // DEFAULT: These are the default text styles - drop in a <Text /> tag in
  // with no parent and no props and this is what you'll get.
  {
    fontFamily: t("fontFamilyAmazonEmber"),
    fontWeight: t("fontWeightB300"),
    fontSize: t("fontSizeB300"),
    lineHeight: t("lineHeightB300"),
    color: t("colorPrimary")
  }, // INHERIT: These styles enable you to cascade <Text /> components - place a
  // <Text /> component inside another <Text /> component and the descendant
  // component will inherit from the ancestor instead of falling back to the
  // default styles.
  {
    "[mdn-text] &": {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      color: "inherit"
    }
  }, // OVERRIDE: These styles enable you to override any default or inherited
  // styles using the component's props. The :not() selector is added to
  // increase the specificity of the styles so they override everything else
  // without resorting to !important.
  {
    "&:not(#mdn-specificity-hack)": {
      fontFamily: fontFamily ? t("fontFamily", fontFamily) : undefined,
      fontWeight: type ? t("fontWeight", type) : undefined,
      fontSize: type ? t("fontSize", type) : undefined,
      lineHeight: type ? t("lineHeight", type) : undefined,
      color: color ? t("color", color) : undefined
    }
  }, (_css = {
    textTransform: transform,
    textAlign: alignment ? alignment : undefined,
    // Clear the default margin on tags like "p"
    margin: 0,
    // If a single word is too wide for the element then allow the browser
    // to break it up at an arbitrary location. A hyphen will not be
    // added. This won't look great, but is better than the word flowing
    // off the edge of the element and potentially getting
    // clipped/obscured.
    overflowWrap: breakWord ? "break-word" : undefined,
    // HACK: Overflow wrap for IE11
    wordWrap: breakWord ? "break-word" : undefined
  }, (0, _defineProperty2["default"])(_css, tag === "ul" ? "&" : "& ul", (_ref2 = {
    // HACK: IE11 does not support padding-inline-* so we have
    // to use directional padding-left/right. If/when we drop IE11
    // and we update the token names, we can simplify these styles to be:
    // {
    //   paddingInlineStart: t("listSpacingHorizontal")
    // }
    paddingLeft: t("listSpacingHorizontal")
  }, (0, _defineProperty2["default"])(_ref2, "[dir=\"rtl\"] &", {
    paddingLeft: 0,
    paddingRight: t("listSpacingHorizontal")
  }), (0, _defineProperty2["default"])(_ref2, "listStyleType", "disc"), (0, _defineProperty2["default"])(_ref2, "& ul", (_ul = {
    // HACK: IE11 does not support padding-inline-* so we have
    // to use directional padding-left/right. If/when we drop IE11
    // and we update the token names, we can simplify these styles to be:
    // {
    //   paddingInlineStart: t("listSpacingHorizontal")
    // }
    paddingLeft: t("listSpacingHorizontal")
  }, (0, _defineProperty2["default"])(_ul, "[dir=\"rtl\"] &", {
    paddingLeft: 0,
    paddingRight: t("listSpacingHorizontal")
  }), (0, _defineProperty2["default"])(_ul, "listStyleType", "circle"), (0, _defineProperty2["default"])(_ul, "& ul", {
    listStyleType: "square"
  }), _ul)), _ref2)), (0, _defineProperty2["default"])(_css, tag === "ol" ? "&" : "& ol", (_ref3 = {
    // HACK: IE11 does not support padding-inline-* so we have
    // to use directional padding-left/right. If/when we drop IE11
    // and we update the token names, we can simplify these styles to be:
    // {
    //   paddingInlineStart: t("listSpacingHorizontal")
    // }
    paddingLeft: t("listSpacingHorizontal")
  }, (0, _defineProperty2["default"])(_ref3, "[dir=\"rtl\"] &", {
    paddingLeft: 0,
    paddingRight: t("listSpacingHorizontal")
  }), (0, _defineProperty2["default"])(_ref3, "listStyleType", listStyle ? listStyle : "decimal"), (0, _defineProperty2["default"])(_ref3, "& ol", (_ol = {
    // HACK: IE11 does not support padding-inline-* so we have
    // to use directional padding-left/right. If/when we drop IE11
    // and we update the token names, we can simplify these styles to be:
    // {
    //   paddingInlineStart: t("listSpacingHorizontal")
    // }
    paddingLeft: t("listSpacingHorizontal")
  }, (0, _defineProperty2["default"])(_ol, "[dir=\"rtl\"] &", {
    paddingLeft: 0,
    paddingRight: t("listSpacingHorizontal")
  }), (0, _defineProperty2["default"])(_ol, "listStyleType", listStyle ? listStyle : "lower-alpha"), (0, _defineProperty2["default"])(_ol, "& ol", {
    listStyleType: listStyle ? listStyle : "lower-roman"
  }), _ol)), _ref3)), (0, _defineProperty2["default"])(_css, "".concat(tag === "ul" || tag === "ol" ? "& > * + *, " : "", "& ul > * + *, & ol > * + *"), {
    paddingTop: t("listSpacingVertical")
  }), _css), truncate ? _noTextWrap["default"] : undefined);
}, ["fontFamily", "color", "type", "transform", "alignment", "tag", "truncate", "breakWord", "listStyle"]);
var _default = getTextStyles;
exports["default"] = _default;

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports = {"external.logs":"Log Dashboard","external.dashboard":"Station Dashboard","asl.heading":"ASL Devices","thinclients.heading":"Thin Clients","adta.heading":"ADTA Devices","adtf.heading":"ADTF Devices","zancasort.heading":"ZancaSort Devices","tesseract.heading":"Tesseract Devices","autoretriever.heading":"Auto Retriever","destination.installationtype":"Installation Type","destination.locations":"Locations","common.data_last_updated":"Data last updated","common.data_created":"Last created","adta.connected":"Connected","sbl.heading":"SBL Devices","device.name":"Name","device.location":"Location","device.mac_ip":"MAC/IP Address","device.component_type":"Component Type","device.device_type":"Device Type","device.connection":"Connection Status","device.pingStatus":"Ping Status","device.add_only_device_button_modal":"Add Single Device Configuration","device.add_aisles_button_modal":"Add Aisles for an Led Controller","node.update_defaults_button_modal":"Update Default Settings","device.lidarconfiguration":"Lidar Controller Configuration","device.action":"Action","device.pick_stations":"Pick Stations","device.add_device_button_modal":"Add/Update Single Device Configuration","device.status":"Status","device.delete_device_button_modal":"Delete Single Device Configuration","device.update_device_status_button_modal":"Update Single Device Status","device.disable_obstruction_button_modal":"Disable Single Device Obstruction","device.enable_obstruction_button_modal":"Enable Single Device Obstruction","device.obstructiondisableduntil":"Obstruction will be disabled in 1 minute and remain off until","device.obstructionwillbeenabled":"Obstruction will be Enabled from now","device.edit_device_mac_modal":"Edit Single Device Mac Address","device.delete_config_button_modal":"Delete Sorter Destination Configuration","device.delete_config_button_modal_autoloader":"Delete AutoLoader Configuration","device.delete_divert_config_button_modal":"Delete Guided Divert Configuration","device.edit_config":"Add or Edit Configuration","device.device_category":"Device Category","device.offline_devices_locations":"Offline Devices Locations","asl.desc":"This page shows the real-time status of ASL devices along with the device and ASL Guided Divert Configuration","adta.desc":"This page shows the real-time status of ADTA devices along with the Sorter Destination and Sorter Test Package Configuration","sbl.desc":"This page shows the real-time status of LED Controllers along with the MAC/IP Address and Connectivity","thinclient.desc":"This page shows the real-time status of Thin Client devices along with the MAC/IP Address and health status","device.vlan":"VLAN","device.usecase":"Use Case","device.newstatus":"New Status","device.swstatus":"Software Status","device.remark":"Remark","device.monitoring":"Monitoring Status","device.controller_type":"Controller Type","device.monitoringEnabled":"Enabled","device.monitoringDisabled":"Disabled","device.invalidEntry":"Invalid Entry","device.editWarning":"You are about to make a change that will temporary affect these devices functioning. Please make sure no cycle is running on these devices before continuing","device.nodevice":"No Device","device.troubleshootwiki":"Troubleshoot wiki","device.configuration":"Device Configuration","lidarController.editWarning":"You are about to make a change in Lidar Controllers. Please make sure no cycle is running on these machines before continuing","device.index_interpretation":"Note: Nth device(column/sensor) index denotes Nth device from conveyor side","actions.deleteDevice":"Delete","actions.addDevice":"Edit","actions.edit":"Edit via JSON","actions.changeMac":"Change MAC address","actions.toggleStowStations":"Toggle Stow Stations","actions.monitoring_disable":"Disable Monitoring","actions.monitoring_enable":"Enable Monitoring","actions.deploydraft":"Deploy Draft","actions.discarddraft":"Discard Draft","actions.rollback":"Rollback","actions.deploy":"Deploy","actions.restart":"Restart Application","actions.deactivate":"Deactivate","actions.activate":"Activate","actions.disableObstruction":"Disable Obstruction","actions.enableObstruction":"Enable Obstruction","actions.viewConfiguration":"View Configuration","button.add":"Add/Edit via JSON","button.addcsv":"Add/Edit via CSV","button.delete":"Delete device","button.save":"Save","button.edit":"Edit","pickstation.label":"Pick Station","pickstation.no_resources":"No pick stations found for this station.","modal.adta_heading":"ADTA","modal.asl_heading":"ASL","modal.confirm":"Confirm","modal.confirmAdd":"Confirm add","modal.confirmEdit":"Confirm edit","modal.cancel":"Cancel","modal.lidar.activate.message":"Caution: Confirm that the last sensor in each aisle has been validated with the LiDAR tester before enabling Scanless. Enabling without validation will cause incorrect sensor-to-column mapping, leading to false obstructions and stow detection failures.","modal.copy":"Copy","modal.paste":"Paste","modal.remove":"Remove","modal.selectAisleType":"Select Aisle Type","modal.ledControllerType":"LED Controller Type","modal.defaultAisleType":"Default Aisle Type","modal.colorOrder":"Color Order","modal.selectLedControllerType":"Select LED Controller Type","modal.selectDefaultAisleType":"Select Default Aisle Type","modal.selectColorOrder":"Select Color Order","tab.testing":"Testing","tab.sbldashboard":"SBL Dashboard","tab.configuration":"Configuration","tab.aisleconfigfinder":"SBL Config Finder","tab.logstream":"Log Stream","tab.validation":"Protocol Validation","tab.overview":"Overview","tab.managebyexceptions":"Manage By Exceptions","tab.lidartester":"Lidar Tester","tab.trafficlight":"TrafficLight","deviceManagement.filters":"Select Device Type","deviceManagement.tag":"Device Type","deviceManagement.noresults":"No Results","modal.mac":"MAC Address","modal.startAisle":"Start Aisle","modal.startPort":"Start Port","modal.aisleCount":"Aisle Count","modal.endAisle":"End Aisle","modal.nonOVCartRecipe":"Non OV Column Type","modal.selectNonOVCartRecipe":"Select Non OV Column Type","modal.selectLidarControllerType":"Select Lidar Controller Type","modal.2tierOVCartRecipe":"2 Tier OV column type","modal.select2tierOVCartRecipe":"Select 2 Tier OV column type","modal.1tierOVCartRecipe":"1 Tier OV Column Type","modal.select1tierOVCartRecipe":"Select 1 Tier OV Column Type","modal.config":"Fill in the configuration JSON","modal.configcsv":"Upload the configuration CSV file.","modal.macdelete":"Please enter the MAC Address of the device you would like to remove.","modal.selectmacdelete":"Select MAC Address to be deleted.","modal.confirmmacdelete":"Please confirm that you wish to delete the following device:","modal.confirmmacstatusupdate":"Please confirm that you wish to change status of the following device:","modal.confirmdisableobstructionupdate":"Please confirm that you wish to disable obstruction for the following device:","modal.confirmenableobstructionupdate":"Please confirm that you wish to enable obstruction for the following device:","modal.confirmmacedit":"Please enter new mac address for the following device:","modal.deleteAll":"Delete All","modal.bayiddelete":"Please select the Bay Id you would like to remove:","modal.destinationiddelete":"Please select the Destination Id you would like to remove","modal.destinationdelete":"Please select the Destination you would like to remove","modal.selectbayid":"Select bay ID","modal.divertcodedelete":"Please enter the Divert Code you would like to remove","modal.select_divert_code":"Select divert code to be deleted.","modal.pick_stations":"Pick Stations","modal.pick_stations_desc":"Enter labels of associated pick stations separated with (;)","modal.device_id":"Device ID","modal.device_id_line_desc":"Unique local identifier for the device. eg. \"3\" for \"Line 3\"","modal.device_id_finger_desc":"Unique local identifier for the device. eg. \"A\" for \"Finger A\"","modal.device_id_cluster_desc":"Unique local identifier for the device. eg. \"A\" for \"Cluster A\"","modal.device_id_induct_line_desc":"Unique local identifier for the device. eg. \"1\" for \"Induct Line 1\"","modal.port":"Port","modal.protocol_msg":"Either \"sort\" or \"sort-2021-v1\"","modal.protocol":"Protocol","modal.induct_camera_mac":"Induct Camera MAC","modal.printer_mac":"Printer MAC","modal.verification_camera_mac":"Verification Camera MAC","modal.select_protocol":"Select a protocol","modal.select_induct_camera_mac":"Select Induct Camera MAC Address","modal.select_printer_mac":"Select Printer MAC Address","modal.select_verification_camera_mac":"Select Verification Camera MAC Address","modal.responsePort":"Response Port","modal.userId":"User Id","modal.inductLocation":"Induct Location","modal.name":"Device Name","modal.name_line_desc":"Display name of the device. e.g. \"Line 3\"","modal.no_device_available":"No devices available","modal.name_finger_desc":"Display name of the device. e.g. \"Finger A\"","modal.name_cluster_desc":"Display name of the device. e.g. \"Cluster A\"","modal.parent_asset_mac":"Parent Asset MAC Address","modal.parent_asset_mac_desc":"[Optional] MAC address of the parent ADTF that diverts to this cluster's stow stations.","modal.name_induct_line_desc":"Display name of the device. e.g. \"Induct Line 1\"","modal.name_matrix_desc":"Display name of the device. e.g. \"Matrix A\"","modal.device_type_asl":"Device Type (must be one of the following: slam, slam-2021-v1)","modal.ip":"IP Address","modal.sortzonedelete":"Please select the scannable you would like to remove.","modal.vendor":"Vendor","modal.select_vendor":"Select Vendor","modal.spec_version":"Hardware Specification Version","modal.select_version":"Select Hardware Specification Version","modal.sorter_type":"Sorter Technology","modal.select_sorter_type":"Select Sorter Technology","modal.hamper_vendor":"Hamper Vendor","modal.select_hamper_vendor":"Select Hamper Vendor","modal.hamper_version":"Hamper Version","modal.select_hamper_version":"Select Hamper Version","modal.incoming_auto_singulated":"Parcels are Auto-Singulated","modal.incoming_auto_sorted":"Parcels are Auto-Sorted to Finger","modal.select_incoming_auto_singulated":"Select Yes or No","modal.select_incoming_auto_sorted":"Select Yes or No","modal.selectusecase":"Select use case","modal.selectnewusecase":"Please select new use case for Thin Client.","modal.confirmchangeusecase":"Please confirm the new Thin Client use case you have selected.","modal.confirmUpdate":"Confirm update","devicemanagement.heading":"Device Management","devicemanagement.desc":"This page shows the real-time status of Automation devices, Thin Clients and SBL devices and helps you to set configuration of the selected device type.","actions.secondary":"Make Secondary Use Case","actions.primary":"Make Primary Use Case","actions.usecase":"Change Thin Client use case","bay.location":"Locations","bay.installlationtype":"Installation Type","bay.id":"Bay ID","destination.id":"Destination","location.id":"Location","location.type":"Location Type","bay.index":"Index","bay.scannables":"Scannables","bay.scannables_description":"Tracking/Shipment ID. Separate multiple values by semicolon (;)","bay.sortzone":"Sort Zone","bay.sortzone_description":"eg. EU: A1-1A, NA: A-1.1A","configtype.title":"Select Config Type","devicename.title":"Select Device","autoloadertestconfig.uploadCSV":"Upload AutoLoader Test Package Configuration CSV","autoloader.testconfig.delete":"Delete Test Package Configuration","message.noMatchingDestination":"No matching destination","message.noDestinationAvailable":"No destination  available","sorterconfig.addupdate":"Add/Update Sorter Destination Configuration","autoloaderconfig.addupdate":"Add/Update AutoLoader Configuration","sorterconfig.uploadCSV":"Upload Sorter Destination Configuration CSV","autoloaderconfig.uploadCSV":"Upload AutoLoader Configuration CSV","autoloadertestconfig.addupdate":"Add/Update AutoLoader Test Configuration","sortertestconfig.addupdatetest":"Add/Update Sorter Test Package Configuration","sortertestconfig.uploadCSV":"Upload Sorter Test Package Configuration CSV","sortertestconfig.delete":"Select test package to be deleted.","sortertestconfig.nomatch":"No matching test packages","sortertestconfig.notavailable":"No test packages available","config.delete":"Delete Configuration","config.deletetest":"Delete Sorter Test Package Configuration","config.download":"Download Config","upload.title":"Upload configuration through CSV","upload.subtitle":"Upload CSV file to overwrite the existing configuration.","upload.upload_file":"Upload file","upload.drag_here":"or drag file here","upload.download_sample":"Download sample CSV file","upload.file_length":"The uploaded file contains {length} rows.","upload.confirm_overwrite":"Press confirm to overwrite the configuration.","modal.bayid":"Bay ID","modal.cluster":"Cluster","modal.installationtype":"Installation Type","modal.location":"Locations","modal.tier":"Tier","modal.optional":"[Optional] ","modal.optional.example":"[Optional] Separate multiple aisles by semicolon - e.g.: J,1;J,2;J,3 ","modal.location_example":"Separate multiple aisles by semicolon - e.g.: J,1;J,2;J,3","modal.adtr_location_example":"Separate locations by semicolon - e.g.: A.L01;A.L02","modal.enter_value":"Enter value...","modal.fingerName":"Finger Name","modal.fingerName_desc":"[Optional field] These bays should be associated with their finger name to identify them in-case of multiple fingers within the same ADTA.","modal.addheading":"To edit an existing configuration, enter its Bay Id and type","modal.addheadingautoloader":"To edit an existing configuration , enter its Destination and type","modal.selectdestinationid":"Select Destination","modal.addheadingtest":"To edit an existing configuration, enter the Sort Zone.","modal.start":"Start Time in UTC Format: MM/DD/YYYY HH:MM:SS","modal.end":"End Time in UTC Format: MM/DD/YYYY HH:MM:SS","modal.reason":"Reason","device.active":"Active","device.inactive":"Inactive","device.delete":"Delete","device.vendor":"Vendor/Version","device.sorter_type":"Sorter Technology","device.hamper_vendor":"Hamper Vendor/Version","status.tooltip":"Healthy: Device is working correctly. Disconnected: Device is not properly connected to both internet and local network. Loading failed: Failed to fetch connection status of the device, something may be wrong.","radio.sorter":"Sorter Destination","radio.loader":"AutoLoader Destination","radio.test":"Sorter Test Package","alert.missingfields":"Please enter all fields in correct format!","destination.weight_description":"Enter weight in kilograms","destination.weight":"Weight (kg)","destination.height_description":"Enter height in centimeters","destination.height":"Height (cm)","destination.width_description":"Enter width in centimeters","destination.length":"Length (cm)","destination.width":"Width (cm)","destination.length_description":"Enter length in centimeters","alert.aisleduplicatefields":"Please enter unique Aisle Name!","alert.portduplicatefields":"Please enter unique Port Number!","alert.time":"Please make sure start time is lesser than or equal to end time!","alert.timenotentered":"Please make sure to provide date and time for which to execute the validation!","alert.longduration":"Please make sure the difference between start time and end time is not more than 12 hours!","alert.testing":"No Testing Setup present.","alert.device":"No device present for this station.","alert.configuration":"No Configuration Setup present.","config.addupdateasl":"Add/Update Guided Divert Configuration","config.addonerow":"Add one Row","config.addmultiplerows":"Add Multiple Rows","config.updateledcontroller":"Update LED Controller","modal.addheadingasl":"To edit an existing configuration, enter the same divert code again.","modal.divertcode":"Divert Code","modal.aislename":"Aisle Name","modal.aisletype":"Aisle Type","modal.actions":"Actions","modal.divertcode_desc":"Range: 10 to 99","slam.clusters":"Clusters","modal.clusters":"Clusters","modal.clusters_desc":"Separate multiple values by semicolon - e.g.: A;B;C","radio.guideddivert":"Guided Divert Configuration","tooltip.start_retrieval_test_desc":"Generate new test picklists and start test","tooltip.scrolltobottom":"Scroll to bottom","tooltip.connectionstatus":"Active: Device is working correctly. Inactive: Connected but unable to receive heart beat messages from the device. Unknown/Device Not Found: Unable to connect to the device ","tooltip.pingstatus":"Displays the ping reachability status of the device. Reachable: Device responds to ping. Unreachable: Device does not respond to ping.","tooltip.disconnectedipvlan":"IP/VLAN information may not be accurate as device is disconnected from the network","tooltip.isAuthorized":"Not authorized","tooltip.selectmacaddress":"Please Select a MAC Address first","loading.text":"Loading...","device.monitoring_modal":"Disable Monitoring","device.usecase_change_modal":"Change Thin Client use case","table.nodata":"No data present","alert.testconfig":"No Test Package Configurations present for this MAC Address.","tooltip.statusLoading":"Loading Status","bintester.errorMessage":"An error occurred while fetching the site config for this station","alert.asset_details_success":"Asset details updated successfully","alert.asset_delete_success":"Asset is deleted successfully","alert.asset_defaults_success":"Asset Default Settings updated successfully","alert.asset_details_fail":"Failed to update asset details. Try again!","alert.asset_delete_fail":"Failed to delete asset. Try again!","alert.asset_defaults_fail":"Failed to update asset defaults. Try again!","alert.asset_create_success":"Asset is created successfully","alert.createdOn":"created on: ","alert.byUser":" by user: ","device.mcm":"MCM ","device.ticket":"Ticket ","device.justification":"Other Justification ","device.linkPlaceHolder":"Enter MCM/Ticket link/ Other justification...","device.firmwareVersion":"Firmware Version","log.stopMonitoring":"Stop Monitoring Logs","log.startMonitoring":"Start Monitoring Logs","log.clear":"Clear","log.filterBySubstring":"Filter logs by sub-string...","log.filterByDeviceName":"Filter logs by device name...","log.messagesToCapture":"Messages to capture","log.error":"Something went wrong, please try again later...","log.messageCountError":"Message count cannot exceed 300","log.download":"Download Logs","mhelog.datetime":"Date/Time (UTC)","mhelog.protocol":"Protocol","mhelog.devicetype":"Device Type","mhelog.devicename":"Device Name","mhelog.macip":"MAC/IP","mhelog.mac":"MAC","mhelog.ip":"IP","mhelog.eventtype":"Event Type","mhelog.message":"Message","mhelog.payload":"Payload","mhevalidation.newvalidation":"New Validation","modal.validationstart":"Start Time in UTC Format: MM/DD/YYYY HH:MM","modal.validationend":"End Time in UTC Format: MM/DD/YYYY HH:MM","modal.validationremarks":"Remarks","validationactions.downloadreport":"Download report","validationactions.retry":"Retry","banner.peakPermission":"Access to admin functionality is limited during peak. You may be unable to perform certain edit functions on the website if you're not from RME/IT/Admin groups. For more details, read ","banner.wiki":"the device management wiki","banner.bagTracking":"This dashboard provides real-time tracking for DSP bags equipped with Smart Tags and resets daily at 8am site local time.","timepicker.placeholder":"Time","timepicker.invalidinput":"The value is not a valid time. The correct time format is hour:minute AM/PM.","timepicker.label":"Time","mhevalidation.starttime":"Start Time","mhevalidation.endtime":"End Time","mhevalidation.status":"Status","mhevalidation.result":"Result","mhevalidation.requestedby":"Requested By","mhevalidation.remarks":"Remarks","mhevalidation.action":"Action","table.index":"Index","test.scannables":"Scannables","test.tracking_id":"Tracking Id","test.alt_id":"Shipping Id","test.destination":"Destination","test.sortZone":"Sort Zone","test.bag_list":"Bags","test.scannables_description":"Tracking/Shipment ID. Separate multiple values by semicolon (;)","test.tracking_id_description":"Enter Package Tracking ID","test.alt_id_description":"Enter Package Shipping ID","test.destination_bag_description":"eg. EU: EU_ZZ-AM-1024_BLK , NA: AK-T-0103-503-BLK","test.destination_sort_zone_description":"Sort location, eg. EU: C21-1A , NA: A-1.1B","container.type":"Container Type","container.label":"Container Label","stowconfig.addupdate":"Add/Update Stow Package Configuration","stowconfig.uploadCSV":"Upload Stow Package Configuration CSV","stowconfig.delete":"Select container type to be deleted","stowconfig.deleteconfig":"Delete Configuration","stowconfig.nomatch":"No matching Id found","stowconfig.notavailable":"No configuration available","stowtestconfig.addupdate":"Add/Update Test Package Configuration","stowtestconfig.delete":"Select test package to be deleted.","stowtestconfig.deleteconfig":"Delete Test Package Configuration","stowtestconfig.uploadCSV":"Upload Stow Test Package Configuration CSV","locationconfig.addupdate":"Add/Update ZancaSort Location Configuration","locationconfig.uploadCSV":"Upload ZancaSort Location Configuration CSV","locationconfig.deleteconfig":"Delete ZancaSort Location Configuration","locationconfig.delete":"Select location ID","tierconfig.addupdate":"Add/Update ZancaSort Tier Configuration","tierconfig.uploadCSV":"Upload ZancaSort Tier Configuration CSV","tierconfig.deleteconfig":"Delete ZancaSort Tier Configuration","tierconfig.tierName":"Tier Name","tierconfig.capacity":"Capacity","tierconfig.startLevel":"Start Level (inclusive)","tierconfig.endLevel":"End Level (inclusive)","modal.addtierheading":"To edit an existing configuration, select the Tier Name.","modal.delete_tier_config":"Please select the Tier Name which you would like to remove","tierconfig.selectTier":"Select Tier Name","testconfig.nomatch":"No matching test packages","testconfig.notavailable":"No test packages available","testconfig.items_count":"Items Count","testconfig.pick_item":"Pick Item","testconfig.pick_item_type":"Item Type","testconfig.cluster":"Cluster","testconfig.pick_station":"Pick Station","testconfig.start":"Start Test","testconfig.error.duplicatescannables":"Duplicate scannables found: {scannableIds}","testconfig.error.duplicatebagtosz":"Bag {bagId} is already mapped to a different sort zone.","modal.delete_test_package":"Please select the scannable you would like to remove.","modal.headingtest":"To edit an existing configuration, enter the Destination BagId.","modal.tesseract_headingtest":"To edit an existing configuration, enter the Package Tracking Id","modal.tesseract_containerLabel_description":"Enter tesseract container label eg. EU: A1, NA: A-1","modal.tesseract_containerType_description":"Enter machine container type eg. SAMPL_01","modal.tesseract_headingconfig":"To edit an existing configuration, enter the Container Type","modal.tesseract_delete_stow_config":"Please select the container type you would like to remove","bagtracking.heading":"Bag Tracking","filter.heading":"Filter By Depart Time","bagTable.transporterId":"Transporter ID","bagTable.bagId":"Bag ID","bagTable.bagStatus":"Bag Status","bagTable.departTime":"Depart Time","bagTable.receiveTime":"Receive Time","lidarTester.select":"Select Lidar Controller","lidar.health_refresh_note":"Note: Device health data is synchronized every 40 seconds.","button.startProvision":"Start Provision","banner.dmwPermission":"You're not authorized to access this device. Please check the link given below to get access.","modal.delete_location_config":"Please select location ID which you would like to remove","modal.toggleStowStations.title":"Toggle Stow Stations","modal.toggleStowStations.topStation":"Top Stow Station","modal.toggleStowStations.bottomStation":"Bottom Stow Station","modal.toggleStowStations.updating":"Updating stow station configuration...","locationmapping.destination":"Pick Chute","locationmapping.type":"Item Type","locationmapping.locations":"Pick Point(s)","locationmapping.add":"Add Config","locationmapping.uploadCSV":"Upload Location Config CSV","locationmapping.destination.placeholder":"e.g. PC1","locationmapping.type.placeholder":"Select item type","locationmapping.locations.placeholder":"Select pick points","locationmapping.error.column_count":"Expected 3 columns but found {count}.","locationmapping.error.pick_point_not_found":"Pick point \"{pickPoint}\" does not exist at this station.","locationmapping.error.row_prefix":"Row {row}: {message}","locationmapping.delete_config":"Delete Config","locationmapping.delete_title":"Delete Location Mapping","locationmapping.delete_confirmation":"Are you sure you want to delete the entire location mapping configuration? This action will be applied when you deploy the draft.","locationmapping.no_pick_points":"No pick points found for this station.","locationmapping.modal.add_title":"Add Location Mapping","locationmapping.modal.edit_title":"Edit Location Mapping","locationmapping.error.destination_required":"Destination is required.","locationmapping.error.destination_invalid":"Destination must start with a letter, contain only letters, digits, underscore, hyphen, or period, and be at most 50 characters.","locationmapping.error.type_required":"Item type is required.","locationmapping.error.locations_required":"At least one pick point must be selected.","locationmapping.error.duplicate":"A mapping for \"{destination}\" with type \"{type}\" already exists.","locationmapping.error.conflict":"Pick point \"{pickPoint}\" is already mapped to \"{destination}\" for type \"{type}\"."}

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toRow = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _tableRow = _interopRequireDefault(__webpack_require__(258));

var _tableCell = _interopRequireDefault(__webpack_require__(355));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This can be used to create a header for a group of Row components. Use it
 * exactly like you would a normal Row. The only difference is that this takes
 * normal content children instead of Cell components.
 */
var TableSectionHeader = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TableSectionHeader, _React$Component);

  var _super = _createSuper(TableSectionHeader);

  function TableSectionHeader() {
    (0, _classCallCheck2["default"])(this, TableSectionHeader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(TableSectionHeader, [{
    key: "render",
    value: function render() {
      // This component is API sugar only, at render time it's replaced with `Row`
      // and `Cell` components
      return null;
    }
  }]);
  return TableSectionHeader;
}(_react["default"].Component);

TableSectionHeader.propTypes =  false ? {
  /**
   * The contents of the section header.
   *
   * Note that this does *not* support table cells as children, this is a
   * generic content area that spans the width of the table.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Set this to force the cell to span more than one column.
   *
   * NOTE: This helps build an accessible TableSectionHeader. However,
   * any provided columnSpan will be overwritten to 1 when a Table has a
   * [stickyHeaderColumn](https://meridian.a2z.com/components/table/?platform=react-web&detailsTab=api#api-Table-stickyHeaderColumn).
   *
   * @since 5.24.0
   */
  columnSpan: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Determines if rows that are children of this row are visible or hidden.
   */
  open: _propTypes["default"].bool,

  /**
   * Bind a click handler to the row. This will make the row focuseable via
   * keyboard. Avoid using this if the row contains clickable children (e.g.
   * a link or a button).
   */
  onClick: _propTypes["default"].func
} : {};

var toRow = function toRow(isRow, element, stickyHeaderColumn) {
  var children = _react["default"].Children.toArray(element.props.children); // The number of columns the header cell spans. Use the defined `columnSpan` if
  // defined else if the table has a sticky header column, fallback to 1, else 100.


  var columnSpan = stickyHeaderColumn ? 1 : element.props.columnSpan || 100;
  return /*#__PURE__*/_react["default"].createElement(_tableRow["default"], (0, _extends2["default"])({}, element.props, {
    id: undefined
  }), /*#__PURE__*/_react["default"].createElement(_tableCell["default"], {
    header: true,
    highlight: true,
    sectionHeader: true,
    id: element.props.id,
    columnSpan: columnSpan,
    scope: "colgroup"
  }, children.filter(function (child) {
    return !isRow(child);
  })), (!element.props.columnSpan || stickyHeaderColumn) && columnSpan < 100 && /*#__PURE__*/_react["default"].createElement(_tableCell["default"], {
    highlight: true,
    columnSpan: 100,
    sectionHeader: true,
    headers: element.props.id,
    scope: "colgroup"
  }), children.filter(isRow));
};

exports.toRow = toRow;
var _default = TableSectionHeader;
exports["default"] = _default;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _checkbox = _interopRequireDefault(__webpack_require__(356));

var _token = __webpack_require__(20);

var _functional = __webpack_require__(38);

var _isElementOfAny = _interopRequireDefault(__webpack_require__(194));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

var _rtl = __webpack_require__(80);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var unthemedCheckboxTokens = (0, _token.getUnthemedTokens)(_checkbox["default"]);
/**
 * Helpers
 */

var getCheckbox = function getCheckbox(checkboxComponents, elements) {
  if (checkboxComponents && typeof elements !== "string") {
    var isCheckbox = (0, _isElementOfAny["default"])(checkboxComponents);

    var child = _react["default"].Children.toArray(elements)[0];

    return isCheckbox(child) ? child : null;
  } else {
    return null;
  }
};

var getCheckboxWidth = (0, _functional.memoize)(function (size) {
  return (0, _token.getToken)(unthemedCheckboxTokens, "checkboxWidth", size);
});

var stretchCheckbox = function stretchCheckbox(checkbox) {
  return /*#__PURE__*/_react["default"].cloneElement(checkbox, {
    fillParent: true
  });
};
/**
 * Styles
 */


var styles = (0, _functional.memoize)(function (checkboxWidth) {
  return (0, _functional.memoizeByKeys)(function (_ref) {
    var _css;

    var alignmentHorizontal = _ref.alignmentHorizontal,
        alignmentVertical = _ref.alignmentVertical,
        width = _ref.width,
        height = _ref.height,
        backgroundColor = _ref.backgroundColor;
    return (0, _emotion.css)((_css = {
      textAlign: (0, _rtl.getHorizontalDirection)(alignmentHorizontal)
    }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
      textAlign: (0, _rtl.getRtl)(alignmentHorizontal)
    }), (0, _defineProperty2["default"])(_css, "verticalAlign", alignmentVertical === "center" ? "middle" : alignmentVertical), (0, _defineProperty2["default"])(_css, "width", width || checkboxWidth), (0, _defineProperty2["default"])(_css, "minWidth", width || checkboxWidth), (0, _defineProperty2["default"])(_css, "height", height || "inherit"), (0, _defineProperty2["default"])(_css, "boxSizing", width || height ? "border-box" : "content-box"), (0, _defineProperty2["default"])(_css, "&[mdn-cell-background-color-custom]", {
      backgroundColor: "".concat(backgroundColor, " !important")
    }), (0, _defineProperty2["default"])(_css, "&[mdn-hidden-cell]", {
      display: "none"
    }), (0, _defineProperty2["default"])(_css, "& > span", checkboxWidth ? {
      display: "block",
      height: "100%",
      position: "static"
    } : undefined), _css));
  }, ["alignmentHorizontal", "alignmentVertical", "width", "height", "backgroundColor"]);
});
/**
 * Component
 */

/**
 * Used to render a table cell. Can take any children. Place this as a child of
 * the TableRow component.
 *
 * Note that the Table component will automatically set some props on this
 * component (e.g. `header={true}` if the cell is in a header row). This means
 * that if you wrap this component in your own custom table cell component, you
 * should still pass all props through to this component. For example:
 *
 * // Correct
 * const MyCustomCell = ({ myCustomProp, ...extraProps }) =>
 *   <TableCell {...extraProps} />
 *
 * // Incorrect
 * const MyCustomCell = ({ myCustomProp, children }) =>
 *   <TableCell>{children}</TableCell>
 */

var TableCell = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TableCell, _React$Component);

  var _super = _createSuper(TableCell);

  function TableCell() {
    (0, _classCallCheck2["default"])(this, TableCell);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(TableCell, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var hexBgColor = props.backgroundColor && props.backgroundColor !== "primary" && props.backgroundColor !== "secondary" ? props.backgroundColor : undefined; // If the only child of the cell is a checkbox then stretch the checkbox to
      // fill the cell, making the entire cell clickable

      var checkbox = getCheckbox(props.checkboxComponents, props.children);
      var children = checkbox ? stretchCheckbox(checkbox) : props.children;
      var checkboxWidth = checkbox ? getCheckboxWidth(checkbox.props.size) : undefined;
      var tag = props.header ? "th" : "td";
      var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
      return /*#__PURE__*/_react["default"].createElement(tag, _objectSpread(_objectSpread({}, passThroughProps), {}, {
        className: styles(checkboxWidth)(props),
        colSpan: props.columnSpan,
        rowSpan: props.rowSpan,
        id: props.id,
        headers: props.headers,
        "aria-sort": props.sortDirection,
        "mdn-cell-background-color-primary": props.backgroundColor === "primary" ? "" : undefined,
        "mdn-cell-background-color-secondary": props.backgroundColor === "secondary" ? "" : undefined,
        "mdn-cell-background-color-custom": hexBgColor ? "" : undefined,
        "mdn-cell-highlight": props.highlight ? "" : undefined,
        "mdn-cell-selectable": checkbox ? "" : undefined,

        /* eslint-disable-next-line react/prop-types */
        "mdn-section-header": props.sectionHeader ? "" : undefined,
        "mdn-hidden-cell": !props.showCell ? "" : undefined,
        // HACK: Don't include `scope` in prop-types since we already take
        // care of setting scope in `table.js` and don't want users overwriting.
        // We could use context, but that would require potentially hundreds of
        // contexts for a single table so this is more performant.

        /* eslint-disable-next-line react/prop-types */
        scope: props.scope
      }),
      /*#__PURE__*/
      // An extra span is needed for the fancy nested headers style and for
      // the chevron icon placed on the left side of parent rows.
      _react["default"].createElement("span", null, children));
    }
  }]);
  return TableCell;
}(_react["default"].Component);

(0, _defineProperty2["default"])(TableCell, "defaultProps", {
  alignmentHorizontal: "start",
  alignmentVertical: "center",
  defaultSortDirection: "ascending",
  showCell: true
});
TableCell.propTypes =  false ? {
  /**
   * The horizontal alignment of content inside the cell.
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["left", "start", "center", "right", "end"]),

  /**
   * The vertical alignment of content inside the cell.
   */
  alignmentVertical: _propTypes["default"].oneOf(["top", "center", "bottom"]),

  /**
   * Set the cell's background color using a preset, or using a string
   * containing any valid CSS color. WARNING: AA accessibility requires
   * a color contrast ratio of 4.5:1 or higher. Please keep this in mind
   * when providing custom background colors, and be sure to check your
   * contrast ratios with a tool like https://contrastchecker.com/
   *
   * @since 5.x
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary"]), _propTypes["default"].string]),

  /**
   * The component or components that will be used to render checkboxes for
   * selectable tables. This can be set on the `Table` component itself, in
   * which case it is not necessary to set it here for each individual cell.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  checkboxComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * The contents of the cell. Any elements are allowed except for nested
   * Meridian tables.
   */
  children: _propTypes["default"].node,

  /**
   * Set this to force the cell to span more than one column.
   */
  columnSpan: _propTypes["default"].number,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Apply this to a header cell to specify the sort direction that should be
   * applied first when the user turns on sorting for the column.
   */
  defaultSortDirection: _propTypes["default"].oneOf(["ascending", "descending"]),

  /**
   * Set this to true if the cell is a header cell (either in a headerRow or
   * header column). Note that this is automatically set if the TableCell is
   * placed in a Table component, so in most cases you should not have to
   * touch this.
   */
  header: _propTypes["default"].bool,

  /**
   * A string of Table header id's with which to associate.
   *
   * See [Mozilla's documentation](https://developer.mozilla.org/en-US/docs/Learn/HTML/Tables/Advanced#using_column_and_row_headers)
   * to learn more (Note: the `scope` attribute is taken care of in Meridian.)
   *
   * @since 5.17.0
   */
  headers: _propTypes["default"].string,

  /**
   * The height of the cell. If left blank the browser will dynamically choose
   * a height based on the cell's contents and the other cells in the table.
   */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Highlight this cell.
   * @deprecated 5.x
   */
  highlight: _propTypes["default"].bool,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.17.0
   */
  id: _propTypes["default"].string,

  /**
   * Set this to force the cell to span more than one row.
   *
   * Use this in conjunction with `showCell={false}` to hide empty cells
   * covered by the spanned rows.
   *
   * @since 5.29.0
   */
  rowSpan: _propTypes["default"].number,

  /**
   * Set this to false to hide the cell completely, including from screen readers.
   *
   * This is useful in combination with the `rowSpan` prop, when you need to
   * hide empty cells that are covered by the spanned rows.
   *
   * @since 5.29.0
   */
  showCell: _propTypes["default"].bool,

  /**
   * Specify a key that the Table component can use to identify the cell when
   * determining which column should be sorted. If this prop is provided the
   * cell will be made clickable and a sort icon will be added to it.
   */
  sortColumn: _propTypes["default"].string,

  /**
   * Apply this to a header cell if the data in the cell's column is sorted.
   *
   * This is automatically set by the Table component, so in most cases you
   * should not have to touch this. See the docs for the corresponding
   * "sortDirection" column on the Table component.
   */
  sortDirection: _propTypes["default"].oneOf(["ascending", "descending"]),

  /**
   * The width of the cell. If left blank the browser will dynamically choose
   * a width based on the cell's contents and the other cells in the table.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
var _default = TableCell;
exports["default"] = _default;

/***/ }),
/* 356 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    checkboxMotionDuration: "100ms",
    checkboxMotionFunction: "ease",
    checkboxForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    checkboxForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    checkboxBackgroundColorSelectedDefault: tokens.themeForegroundAccentDefault,
    checkboxBackgroundColorSelectedHover: tokens.themeForegroundAccentHover,
    checkboxBackgroundColorSelectedPressed: tokens.themeForegroundAccentPressed,
    checkboxBackgroundColorSelectedDisabled: tokens.themeForegroundAccentDisabled,
    checkboxBackgroundColorUnselectedDefault: tokens.themeBackgroundPrimaryDefault,
    checkboxBackgroundColorUnselectedHover: tokens.themeForegroundAccentHover,
    checkboxBackgroundColorUnselectedPressed: tokens.themeForegroundAccentPressed,
    checkboxBackgroundColorUnselectedDisabled: tokens.themeBackgroundPrimaryDisabled,
    checkboxBorderWidth: 1,
    checkboxBorderRadius: 4,
    checkboxBorderColorSelectedDefault: "rgba(0, 0, 0, 0)",
    checkboxBorderColorSelectedDisabled: tokens.themeBorderPrimaryDisabled,
    checkboxBorderColorUnselectedDefault: tokens.themeBorderPrimaryDefault,
    checkboxBorderColorUnselectedHover: "rgba(0, 0, 0, 0)",
    checkboxBorderColorUnselectedPressed: "rgba(0, 0, 0, 0)",
    checkboxBorderColorUnselectedDisabled: tokens.themeBorderPrimaryDisabled,
    checkboxIndicatorColorSelectedDefault: tokens.themeForegroundInvertedDefault,
    checkboxIndicatorColorUnselectedDefault: "rgba(0, 0, 0, 0)",
    checkboxIndicatorColorUnselectedHover: tokens.themeForegroundAccentDefault,
    checkboxIndicatorColorUnselectedPressed: tokens.themeForegroundInvertedDefault,
    checkboxWidthMedium: 20,
    checkboxWidthLarge: 24,
    checkboxHeightMedium: 20,
    checkboxHeightLarge: 24,
    checkboxSpacingHorizontal: 12
  }
};

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _table = _interopRequireDefault(__webpack_require__(157));

var _chevronDownSmall = _interopRequireDefault(__webpack_require__(358));

var _chevronRightSmall = _interopRequireDefault(__webpack_require__(158));

var _stickyScrollTracker = _interopRequireDefault(__webpack_require__(713));

var _theme = __webpack_require__(24);

var _token = __webpack_require__(20);

var _functional = __webpack_require__(38);

var _getIconCss = _interopRequireDefault(__webpack_require__(156));

var _text = _interopRequireDefault(__webpack_require__(47));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var positionStickyElevation = {
  rowHeader: 1,
  columnHeader: 2,
  tableHeaderCell: 3
};
var chevronDownIcon = (0, _token.getIconFromTokens)(_chevronDownSmall["default"]);
var chevronRightIcon = (0, _token.getIconFromTokens)(_chevronRightSmall["default"]);
var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var spacing = _ref.spacing,
      showDividers = _ref.showDividers,
      showExpandedDividers = _ref.showExpandedDividers,
      showStripes = _ref.showStripes,
      nestedRows = _ref.nestedRows,
      layout = _ref.layout;
  return (0, _functional.memoize)(function (t) {
    var _trFirstChild;

    var borderColor = t("borderColor");
    var borderWidthHeader = t("borderWidthHeader");
    var borderWidthBody = t("borderWidthBody");
    var spacingHorizontal = t("spacingHorizontal");
    var spacingVerticalSmall = t("spacingVerticalSmall");
    var backgroundColorDefault = t("backgroundColorDefault");
    var backgroundColorHover = t("backgroundColorHover");
    var backgroundColorPressed = t("backgroundColorPressed");
    var backgroundColorHighlight = t("backgroundColorHighlight");
    var backgroundColorStripe = t("backgroundColorStripe");
    return (0, _emotion.css)(
    /**
     * Layout
     */
    {
      width: "100%",
      tableLayout: layout,
      "& tr": {
        // HACK: This, in combination with "height: inherit" on table cells, allows
        // cell contents to stretch to fill the cell height if necessary (e.g. a
        // checkbox with `fillParent={true}`). See:
        // https://stackoverflow.com/questions/3215553/make-a-div-fill-an-entire-table-cell
        height: 1
      },
      "& td, & th": {
        position: "relative"
      }
    },
    /**
     * Typography
     */
    (0, _text["default"])(t), {
      "& td": {
        fontWeight: t("fontWeightBody")
      },
      "& th": {
        fontWeight: t("fontWeightHeader")
      },
      // Highlighted header cells should use the normal font weight
      "& th[mdn-cell-highlight]": {
        fontWeight: t("fontWeightBody")
      },
      // Section headers have their own font size
      "& th[mdn-section-header]": (0, _defineProperty2["default"])({
        fontSize: t("fontSizeSectionHeader")
      }, "[dir=\"rtl\"] &", {
        // HACK: need the fix the section header right padding
        // in RTL layouts.
        paddingRight: "".concat(spacingHorizontal, "px !important")
      })
    },
    /**
     * Background colors
     */
    {
      "& td, & th": {
        backgroundColor: backgroundColorDefault,
        "&[mdn-cell-highlight]": {
          backgroundColor: backgroundColorHighlight
        },
        "&[mdn-cell-background-color-primary]": {
          backgroundColor: backgroundColorDefault
        },
        "&[mdn-cell-background-color-secondary]": {
          backgroundColor: backgroundColorHover
        }
      },
      "& tbody > tr[mdn-row-highlight] > *": {
        backgroundColor: backgroundColorHighlight
      },
      "& tbody > tr[mdn-row-background-color-primary] > *": {
        backgroundColor: backgroundColorDefault
      },
      "& tbody > tr[mdn-row-background-color-secondary] > *": {
        backgroundColor: backgroundColorHover
      },
      "& tbody > tr[mdn-row-highlight-on-hover]:hover > *": {
        backgroundColor: backgroundColorHover
      },
      "& tbody > tr[mdn-row-highlight-on-press]:active > *": {
        backgroundColor: backgroundColorPressed
      },
      "& tbody > tr:nth-child(even) > *": showStripes ? {
        backgroundColor: backgroundColorStripe
      } : undefined,
      transition: t.transitionCss("motion", "background-color")
    },
    /**
     * Borders
     */
    {
      borderCollapse: "separate",
      borderSpacing: 0,
      // Always add a border between the header and the body (if a header
      // exists)
      "& thead > tr:last-child > *": {
        borderBottomColor: borderColor,
        borderBottomStyle: "solid",
        borderBottomWidth: borderWidthHeader
      },
      // Add a thick border after the last row in a set of open child rows
      "& tbody > tr[mdn-row-last-child] + tr > *": {
        borderTopColor: borderColor,
        borderTopStyle: "solid",
        borderTopWidth: borderWidthHeader
      },
      "& tbody > tr[mdn-row-last-child]:last-child > *": {
        borderBottomColor: borderColor,
        borderBottomStyle: "solid",
        borderBottomWidth: borderWidthHeader
      },
      // Remove the borders between open child rows
      "& tbody > tr[mdn-row-child] > *": {
        borderTopColor: showExpandedDividers ? undefined : "transparent"
      }
    }, showDividers ? {
      // Add top borders to rows
      "& tbody > tr > *": {
        borderTopColor: borderColor,
        borderTopStyle: "solid",
        borderTopWidth: borderWidthBody
      },
      // Add a bottom border to the last row
      "& tbody > tr:last-child > *": {
        borderBottomColor: borderColor,
        borderBottomStyle: "solid",
        borderBottomWidth: borderWidthBody
      },
      // Remove the top border from the first row if a header exists (the
      // header will apply a special border to separate the header from the
      // body)
      "& thead + tbody > tr:first-child > *": {
        borderTop: "none"
      }
    } : undefined,
    /**
     * Padding
     */
    {
      "& td, & th": {
        // Add padding for half the horizontal spacing to each cell so that when
        // the cells are lined up in a row the space between the cell contents
        // adds up to the original horizontal spacing.
        padding: "".concat(t("spacingVertical", spacing), "px ").concat(spacingHorizontal / 2, "px"),
        // Show the full horizontal spacing on the left and right hand sides of
        // each row.
        "&:first-child": (0, _defineProperty2["default"])({
          // For tables with nested rows add extra padding for the chevron icon
          paddingLeft: nestedRows ? spacingHorizontal * 2 + chevronRightIcon.width : spacingHorizontal
        }, "[dir=\"rtl\"] &", {
          paddingRight: nestedRows ? "".concat(spacingHorizontal * 2 + chevronRightIcon.width, "px !important") : spacingHorizontal,
          // HACK: the above paddingLeft still gets applied, so
          // we need to override it and make it half the width for RTL layouts
          paddingLeft: spacingHorizontal / 2
        }),
        "&:last-child": (0, _defineProperty2["default"])({
          // HACK: IE11 does not support padding-inline-* so we have
          // to use directional padding-left/right. If/when we drop IE11 we can simplify
          // these styles to be:
          // {
          //   paddingInlineStart: spacingHorizontal,
          // }
          paddingRight: spacingHorizontal
        }, "[dir=\"rtl\"] &", {
          paddingLeft: spacingHorizontal,
          // HACK: the above `paddingRight: spacingHorizontal` still gets applied, so
          // we need to override it and make it half the width for RTL layouts
          paddingRight: spacingHorizontal / 2
        })
      },
      // Cells in the table header or header cells in the table body that span
      // the entire row (section header cells) use "small" vertical spacing,
      // regardless of the user's spacing setting.
      "& thead > tr > *, & tbody > tr > th:only-child": {
        paddingTop: spacingVerticalSmall,
        paddingBottom: spacingVerticalSmall
      }
    },
    /**
     * Nested header rows
     */
    {
      "& thead > tr:not(:last-child) > *": {
        fontSize: t("fontSizeNestedHeader"),
        paddingBottom: 0,
        // Shrink the span down to fit the cell contents so that it obscures the
        // horizontal stripe behind the contents but not across the entire cell.
        // Add pseudo elements to add a little padding between the contents and
        // the stripe
        "& > span": {
          display: "inline-block",
          position: "relative",
          backgroundColor: "inherit",
          "&:before, &:after": {
            content: "''",
            backgroundColor: "inherit",
            display: "block",
            height: "100%",
            width: spacingHorizontal,
            position: "absolute",
            top: 0
          },
          "&:before": {
            right: "100%"
          },
          "&:after": {
            left: "100%"
          }
        },
        // Add a horizontal stripe along the center of the cell
        "&:before": {
          content: "''",
          display: "block",
          height: t("borderWidthHeader"),
          left: 0,
          right: 0,
          backgroundColor: borderColor,
          position: "absolute",
          top: "calc(50% + ".concat(spacingVerticalSmall / 2, "px)"),
          transform: "translateY(-50%)"
        }
      }
    },
    /**
     * Expandable rows
     */
    {
      // Add a chevron icon as a pseudo-element to the first cell in the row
      "& tbody > tr[mdn-row-parent] > *:first-child": (0, _defineProperty2["default"])({
        backgroundImage: (0, _getIconCss["default"])(chevronRightIcon.data, t("foregroundColor")),
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center left ".concat(spacingHorizontal, "px")
      }, "[dir=\"rtl\"] &", {
        backgroundImage: (0, _getIconCss["default"])(chevronRightIcon.dataRtl, t("foregroundColor")),
        backgroundPosition: "center right ".concat(spacingHorizontal, "px")
      }),
      // Point the chevron icon down if the row is open
      "& tbody > tr[mdn-row-parent][mdn-row-open] > *:first-child": (0, _defineProperty2["default"])({
        backgroundImage: (0, _getIconCss["default"])(chevronDownIcon.data, t("foregroundColor")),
        // Scoot the down chevron, which is a tad wider than the right
        // chevron, to the left a bit so it is horizontally centered on the
        // same point that the right chevron was.
        backgroundPosition: "center left ".concat(spacingHorizontal - 0.5 * (chevronDownIcon.width - chevronRightIcon.width), "px")
      }, "[dir=\"rtl\"] &", {
        backgroundPosition: "center right ".concat(spacingHorizontal - 0.5 * (chevronDownIcon.width - chevronRightIcon.width), "px")
      })
    },
    /**
     * Clickable rows
     */
    {
      "& tr[tabindex]": {
        cursor: "pointer"
      },
      // TODO: We need an actual focus style for clickable rows. Right now we
      // just fall back to the default outline. See https://sim.amazon.com/issues/MRDN-127
      "& tr[tabindex]:not([mdn-row-focus])": {
        outline: "none"
      }
    },
    /**
     * Selectable cells
     */
    {
      // If we're dealing with a selectable table cell (a cell containing a
      // single checkbox that has been stretched to fill the entire cell) then
      // expand the cell padding (by taking padding from the cell to the right)
      // to maximize the clickable area.
      "& tr > *:first-child[mdn-cell-selectable]": (_trFirstChild = {
        // HACK: IE11 does not support padding-inline-* so we have
        // to use directional padding-left/right. If/when we drop IE11 we can simplify
        // these styles to be:
        // {
        //   paddingInlineEnd: spacingHorizontal,
        //   "& + *": {
        //     paddingInlineStart: 0,
        //   },
        // }
        paddingRight: spacingHorizontal
      }, (0, _defineProperty2["default"])(_trFirstChild, "[dir=\"rtl\"] &", {
        paddingLeft: spacingHorizontal
      }), (0, _defineProperty2["default"])(_trFirstChild, "& + *", (0, _defineProperty2["default"])({
        paddingLeft: 0
      }, "[dir=\"rtl\"] &", {
        // HACK: the above `paddingRight: spacingHorizontal` still gets applied, so
        // we need to reapply the half horizontal spacing to paddingLeft
        paddingLeft: spacingHorizontal / 2,
        paddingRight: 0
      })), _trFirstChild)
    });
  });
}, ["spacing", "showDividers", "showExpandedDividers", "showStripes", "nestedRows", "layout"]);
var stickyStyles = (0, _functional.memoizeByKeys)(function (_ref2) {
  var stickyHeaderColumn = _ref2.stickyHeaderColumn,
      stickyHeaderColumnOffset = _ref2.stickyHeaderColumnOffset,
      headerColumnStuck = _ref2.headerColumnStuck,
      stickyHeaderRow = _ref2.stickyHeaderRow,
      stickyHeaderRowOffset = _ref2.stickyHeaderRowOffset,
      headerRowStuck = _ref2.headerRowStuck;
  return (0, _functional.memoize)(function (t) {
    var _stickyHeaderCellStyl, _theadTrLastOfTyp;

    var stickyHeaderCellStyles = (_stickyHeaderCellStyl = {
      position: "sticky",
      left: stickyHeaderColumnOffset,
      zIndex: positionStickyElevation.columnHeader
    }, (0, _defineProperty2["default"])(_stickyHeaderCellStyl, "[dir=\"rtl\"] &", {
      left: "unset",
      right: stickyHeaderColumnOffset
    }), (0, _defineProperty2["default"])(_stickyHeaderCellStyl, "::after", {
      position: "absolute",
      content: "''",
      top: 0,
      right: 0,
      bottom: 0,
      width: 8,
      boxShadow: headerColumnStuck ? t.boxShadowCss("overflowStickyColumnShadow") : undefined
    }), _stickyHeaderCellStyl);
    return (0, _emotion.css)(
    /**
     * Sticky column header
     */
    stickyHeaderColumn ? {
      "tbody th": stickyHeaderCellStyles,
      "[mdn-row-child] > td:first-child": stickyHeaderCellStyles
    } : undefined,
    /**
     * Sticky row header
     */
    stickyHeaderRow ? {
      "thead tr:last-of-type th": {
        position: "sticky",
        top: stickyHeaderRowOffset,
        zIndex: positionStickyElevation.rowHeader,
        "::after": {
          position: "absolute",
          content: "''",
          bottom: 0,
          right: 0,
          left: 0,
          height: 8,
          boxShadow: headerRowStuck ? t.boxShadowCss("overflowStickyRowShadow") : undefined
        }
      }
    } : undefined,
    /**
     * Sticky row and column header (in LTR it's the top-left-most cell)
     */
    stickyHeaderRow && stickyHeaderColumn ? {
      "thead tr:last-of-type th:first-child": (_theadTrLastOfTyp = {
        left: stickyHeaderColumnOffset,
        top: stickyHeaderRowOffset,
        zIndex: positionStickyElevation.tableHeaderCell
      }, (0, _defineProperty2["default"])(_theadTrLastOfTyp, "[dir=\"rtl\"] &", {
        left: "unset",
        right: stickyHeaderColumnOffset
      }), (0, _defineProperty2["default"])(_theadTrLastOfTyp, "filter", headerColumnStuck ? "drop-shadow(".concat(t("overflowStickyColumnShadowOffsetX"), "px ").concat(t("overflowStickyColumnShadowOffsetY"), "px ").concat(t("overflowStickyColumnShadowBlur"), "px ").concat(t("overflowStickyColumnShadowColor"), ")") : undefined), _theadTrLastOfTyp)
    } : undefined);
  });
}, ["stickyHeaderColumn", "stickyHeaderColumnOffset", "headerColumnStuck", "stickyHeaderRow", "stickyHeaderRowOffset", "headerRowStuck"]);
/**
 * This component renders a `<table />` tag along with all the styles necessary to
 * property display rows and cells placed inside the tag. This is used under the
 * hood by the Table component which adds some nice APIs on top of it, so in
 * most cases you should not have to touch this.
 */

var TableContainer = function TableContainer(props) {
  var t = (0, _theme.useTheme)(_table["default"], "table");

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      headerColumnStuck = _useState2[0],
      setHeaderColumnStuck = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      headerRowStuck = _useState4[0],
      setHeaderRowStuck = _useState4[1];

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("table", (0, _extends2["default"])({}, passThroughProps, {
    className: (0, _emotion.cx)(props.className, styles(props)(t), stickyStyles(_objectSpread(_objectSpread({}, props), {}, {
      headerColumnStuck: headerColumnStuck,
      headerRowStuck: headerRowStuck
    }))(t)),
    "mdn-table-fixed": props.fixed ? "" : undefined
  }), props.children), props.stickyHeaderColumn || props.stickyHeaderRow ? /*#__PURE__*/_react["default"].createElement(_stickyScrollTracker["default"], {
    trackX: props.stickyHeaderColumn,
    trackY: props.stickyHeaderRow,
    onChangeX: setHeaderColumnStuck,
    onChangeY: setHeaderRowStuck
  }) : null);
};

TableContainer.displayName = "TableContainer";
TableContainer.propTypes =  false ? {
  children: _propTypes["default"].node.isRequired,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Set this to true if the table is being used to contain fixed content.
   */
  fixed: _propTypes["default"].bool,

  /**
   * Set this to true if the table contain nested rows (child rows that can be
   * expanded/collapsed by clicking on their parent row).
   */
  nestedRows: _propTypes["default"].bool,

  /**
   * This determines if horizontal dividers are shown between table rows.
   */
  showDividers: _propTypes["default"].bool,

  /**
   * This determines if horizontal dividers are shown between expanded rows.
   */
  showExpandedDividers: _propTypes["default"].bool,

  /**
   * This determines if table is striped using alternately highlighted rows.
   */
  showStripes: _propTypes["default"].bool,

  /**
   * This can be used to adjust the vertical spacing of the table.
   */
  spacing: _propTypes["default"].oneOf(["small", "medium"]),

  /**
   * Stick table header column to the beginning of the scroll container when the
   * user scrolls horizontally.
   *
   * NOTE: This feature is unsupported on IE11 because it uses `position: sticky`.
   *
   * @since 5.21.0
   */
  stickyHeaderColumn: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the "stickyHeaderColumn" prop if you don't want
   * to stick table header column to the very beginning of the scroll container.
   * Use this to specify the pixel offset at which the column should stick.
   *
   * @since 5.21.0
   */
  stickyHeaderColumnOffset: _propTypes["default"].number,

  /**
   * Stick table header column to the beginning of the scroll container when the
   * user scrolls vertically.
   *
   * NOTE: This feature is unsupported on IE11 because it uses `position: sticky`.
   *
   * @since 5.21.0
   */
  stickyHeaderRow: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the "stickyHeaderRow" prop if you don't want
   * to stick table header rows to the very beginning of the scroll container.
   * Use this to specify the pixel offset at which the rows should stick.
   *
   * @since 5.21.0
   */
  stickyHeaderRowOffset: _propTypes["default"].number
} : {};
var _default = TableContainer;
exports["default"] = _default;

/***/ }),
/* 358 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronDownSmallData: "data:image/svg+xml,%3csvg width='10' height='6' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 1l4 4 4-4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronDownSmallWidth: 10,
  iconChevronDownSmallHeight: 6
};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(239),
    isArrayLike = __webpack_require__(125),
    isIndex = __webpack_require__(237),
    isObject = __webpack_require__(153);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNodeBounds = exports.emptyNodeBounds = exports.compareNodeBounds = void 0;
var emptyNodeBounds = {
  top: 0,
  left: 0,
  width: 0,
  height: 0
};
exports.emptyNodeBounds = emptyNodeBounds;
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
/**
 * Check to see if two rectangles, defined by top/left origin and width/height,
 * are equal.
 */

var compareNodeBounds = function compareNodeBounds(a, b) {
  return a === b || a.top === b.top && a.left === b.left && a.width === b.width && a.height === b.height;
};
/**
 * This returns a rectangle from a DOM node that represents the size and
 * position of the node relative to the viewport. If the node does not exist
 * then an empty rectangle is returned. Note that the width and height do not
 * take any CSS scale transforms into account.
 */


exports.compareNodeBounds = compareNodeBounds;

var getNodeBounds = function getNodeBounds(node) {
  if (!canUseDOM) {
    return emptyNodeBounds;
  } else if (node === window) {
    var width = window.innerWidth;
    var height = window.innerHeight;
    return {
      top: 0,
      left: 0,
      width: width,
      height: height
    };
  } else if (node === document.documentElement) {
    // For the document element, getBoundingClientRect() will return scroll
    // offset instead of actual position for top/left values (in all browsers
    // except edge). This is inconsistent with the function's behavior for other
    // nodes (in all browsers except edge). Resolve this by just assuming the
    // top/left of the document element is 0/0 (true in all cases except for
    // when the "html" tag has been repositioned with CSS, which is rare).
    var _node$getBoundingClie = node.getBoundingClientRect(),
        _width = _node$getBoundingClie.width,
        _height = _node$getBoundingClie.height;

    return {
      top: 0,
      left: 0,
      width: _width,
      height: _height
    };
  } else if (node && node.getBoundingClientRect) {
    // For normal nodes, get the width and height from offsetWidth and
    // offsetHeight instead of getBoundingClientRect. This will ignore any CSS
    // scale transforms that are applied.
    var _width2 = node.offsetWidth;
    var _height2 = node.offsetHeight;

    var _node$getBoundingClie2 = node.getBoundingClientRect(),
        top = _node$getBoundingClie2.top,
        left = _node$getBoundingClie2.left;

    return {
      top: top,
      left: left,
      width: _width2,
      height: _height2
    };
  } else {
    return emptyNodeBounds;
  }
};

exports.getNodeBounds = getNodeBounds;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _checkbox = _interopRequireDefault(__webpack_require__(722));

var _default = _checkbox["default"];
exports["default"] = _default;

/***/ }),
/* 362 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCheckLargeData: "data:image/svg+xml,%3csvg width='13' height='9' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 4.017l3.996 3.998L12.006 1' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconCheckLargeWidth: 13,
  iconCheckLargeHeight: 9
};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _default = /*#__PURE__*/_react["default"].createContext({});

exports["default"] = _default;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(186),
    isArrayLike = __webpack_require__(125),
    keys = __webpack_require__(151);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _table = _interopRequireDefault(__webpack_require__(157));

var _close = _interopRequireDefault(__webpack_require__(154));

var _elevation = __webpack_require__(81);

var _row = _interopRequireDefault(__webpack_require__(10));

var _button = _interopRequireDefault(__webpack_require__(8));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _theme = _interopRequireWildcard(__webpack_require__(24));

var _isElementOfAny = _interopRequireDefault(__webpack_require__(194));

var _visuallyHidden = _interopRequireDefault(__webpack_require__(95));

var _functional = __webpack_require__(38);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = function styles(t) {
  return (0, _emotion.css)({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: _elevation.elevationForeground,
    color: t("foregroundColor"),
    backgroundColor: t("backgroundColor"),
    "& > [mdn-table-action-bar-overlay-label] > [mdn-table-action-bar-overlay-label-hidden]": _visuallyHidden["default"]
  });
};

var getOverrideTokens = (0, _functional.memoize)(function (t) {
  return {
    themeBorderPrimaryFocus: t("foregroundColor"),
    // Overlays in light mode
    buttonForegroundColorLinkDarkBackdropDefault: t("foregroundColor"),
    buttonForegroundColorLinkDarkBackdropHover: t("foregroundColor"),
    buttonForegroundColorLinkDarkBackdropPressed: t("foregroundColor"),
    buttonBackgroundColorLinkDarkBackdropHover: t("backgroundColorHover"),
    buttonBackgroundColorLinkDarkBackdropPressed: t("backgroundColorPressed"),
    buttonBackgroundColorIconDarkBackdropHover: t("backgroundColorHover"),
    buttonBackgroundColorIconDarkBackdropPressed: t("backgroundColorPressed"),
    // Overlays in dark mode
    buttonForegroundColorLinkLightBackdropDefault: t("foregroundColor"),
    buttonForegroundColorLinkLightBackdropHover: t("foregroundColor"),
    buttonForegroundColorLinkLightBackdropPressed: t("foregroundColor")
  };
});
/**
 * Used to render an overlay containing bulk actions over an action bar. Place
 * this as a child of the TableActionBar component.
 */

var TableActionBarOverlay = function TableActionBarOverlay(props) {
  var buttonComponents = props.buttonComponents;
  var isButton = (0, _react.useMemo)(function () {
    return (0, _isElementOfAny["default"])(buttonComponents);
  }, [buttonComponents]);

  var buttons = _react["default"].Children.toArray(props.children).filter(isButton);

  var t = (0, _theme.useTheme)(_table["default"], "tableActionBarOverlay");
  return /*#__PURE__*/_react["default"].createElement(_theme["default"], {
    tokens: getOverrideTokens(t)
  }, /*#__PURE__*/_react["default"].createElement(_row["default"], {
    className: styles(t),
    type: "fill",
    spacingInset: "medium",
    spacing: "small",
    widths: ["fill"]
  }, /*#__PURE__*/_react["default"].createElement("span", {
    "aria-live": "polite",
    "aria-atomic": "true",
    "mdn-table-action-bar-overlay-label": ""
  }, props.label, /*#__PURE__*/_react["default"].createElement("span", {
    "mdn-table-action-bar-overlay-label-hidden": ""
  }, props.openLabel)), buttons.map(function (button) {
    return /*#__PURE__*/_react["default"].cloneElement(button, {
      backdropColor: t("backgroundColor")
    });
  }), props.onClose ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: props.onClose,
    backdropColor: t("backgroundColor"),
    label: props.closeLabel
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _close["default"]
  })) : null));
};

TableActionBarOverlay.propTypes =  false ? {
  /**
   * The contents of the action bar overlay.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The component or components that will render as buttons. Defaults
   * to Meridian's Button.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  buttonComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * An accessible label for the overlay's close button.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * A label that is shown on the left hand side of the overlay. This label
   * should indicate the number of rows selected in the table (e.g. something
   * like "3 shipments selected" or "4 of 10 regions selected").
   */
  label: _propTypes["default"].node,

  /**
   * An accessible label read by screen readers after label when the overlay appears.
   * This label should indicate what new content is available within the overlay
   * (e.g. "new actions available").
   */
  openLabel: _propTypes["default"].string,

  /**
   * This is called when the user attempts to close the overlay.
   */
  onClose: _propTypes["default"].func
} : {};
TableActionBarOverlay.defaultProps = {
  label: null,
  closeLabel: "Close",
  openLabel: "new actions available",
  buttonComponents: [_button["default"]]
};
var _default = TableActionBarOverlay;
exports["default"] = _default;

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeek_index_js__ = __webpack_require__(260);



function getUTCISOWeekYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultOptions_index_js__ = __webpack_require__(131);





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_4__defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var firstWeekContainsDate = Object(__WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEmployeeTCPRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEmployeePermission; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(5);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getUserName=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var response,userName;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["f" /* getUserLoginFromParent */])();case 2:response=_context.sent;if(!(response===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_204" /* TIMEOUT_STRING */])){_context.next=7;break;}_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["g" /* getUserNameFromParent */])();case 6:response=_context.sent;case 7:userName=JSON.parse(response.name);if(!userName.endsWith(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["F" /* AMAZON_SUFFIX */])){userName+=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["F" /* AMAZON_SUFFIX */];}return _context.abrupt("return",userName);case 10:case"end":return _context.stop();}}},_callee,this);}));return function getUserName(){return _ref.apply(this,arguments);};}();var getEmployeeTCPRoles=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["e" /* getTcpRoles */])();case 2:response=_context2.sent;return _context2.abrupt("return",JSON.parse(response.roles));case 4:case"end":return _context2.stop();}}},_callee2,this);}));return function getEmployeeTCPRoles(){return _ref2.apply(this,arguments);};}();var getEmployeePermission=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var parent_response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["z" /* getAPIGatewayGetRequest */])(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_29" /* ENDPOINT_AUTH */]));case 2:parent_response=_context3.sent;return _context3.abrupt("return",parent_response.data.isAuthorized);case 4:case"end":return _context3.stop();}}},_callee3,this);}));return function getEmployeePermission(){return _ref3.apply(this,arguments);};}();

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(160)
exports.createHash = exports.Hash = __webpack_require__(132)
exports.createHmac = exports.Hmac = __webpack_require__(266)

var algos = __webpack_require__(377)
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__(378)
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__(778)

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__(789)

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__(793)

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__(829)

var publicEncrypt = __webpack_require__(830)

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

var helpers = __webpack_require__(760);

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */
function core_md5(x, len)
{
  /* append padding */
  x[len >> 5] |= 0x80 << ((len) % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var a =  1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d =  271733878;

  for(var i = 0; i < x.length; i += 16)
  {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;

    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);

    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);

    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);

    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }
  return Array(a, b, c, d);

}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5_cmn(q, a, b, x, s, t)
{
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
}
function md5_ff(a, b, c, d, x, s, t)
{
  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t)
{
  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t)
{
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t)
{
  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y)
{
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bit_rol(num, cnt)
{
  return (num << cnt) | (num >>> (32 - cnt));
}

module.exports = function md5(buf) {
  return helpers.hash(buf, core_md5, 16);
};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(42)
var Hash = __webpack_require__(133)

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = new Buffer(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var inherits = __webpack_require__(42)
var Hash = __webpack_require__(133)

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = new Buffer(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

module.exports = Readable;

/*<replacement>*/
var processNextTick = __webpack_require__(262);
/*</replacement>*/

/*<replacement>*/
var isArray = __webpack_require__(768);
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(84).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream;
(function () {
  try {
    Stream = __webpack_require__(85);
  } catch (_) {} finally {
    if (!Stream) Stream = __webpack_require__(84).EventEmitter;
  }
})();
/*</replacement>*/

var Buffer = __webpack_require__(19).Buffer;
/*<replacement>*/
var bufferShim = __webpack_require__(263);
/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(162);
util.inherits = __webpack_require__(135);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(769);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(770);
var StringDecoder;

util.inherits(Readable, Stream);

function prependListener(emitter, event, fn) {
  if (typeof emitter.prependListener === 'function') {
    return emitter.prependListener(event, fn);
  } else {
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
  }
}

var Duplex;
function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(110);

  options = options || {};

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~ ~this.highWaterMark;

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // when piping, we only care about 'readable' events that happen
  // after read()ing all the bytes and not getting any pushback.
  this.ranOut = false;

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(111).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

var Duplex;
function Readable(options) {
  Duplex = Duplex || __webpack_require__(110);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options && typeof options.read === 'function') this._read = options.read;

  Stream.call(this);
}

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;

  if (!state.objectMode && typeof chunk === 'string') {
    encoding = encoding || state.defaultEncoding;
    if (encoding !== state.encoding) {
      chunk = bufferShim.from(chunk, encoding);
      encoding = '';
    }
  }

  return readableAddChunk(this, state, chunk, encoding, false);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  var state = this._readableState;
  return readableAddChunk(this, state, chunk, '', true);
};

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

function readableAddChunk(stream, state, chunk, encoding, addToFront) {
  var er = chunkInvalid(state, chunk);
  if (er) {
    stream.emit('error', er);
  } else if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else if (state.objectMode || chunk && chunk.length > 0) {
    if (state.ended && !addToFront) {
      var e = new Error('stream.push() after EOF');
      stream.emit('error', e);
    } else if (state.endEmitted && addToFront) {
      var _e = new Error('stream.unshift() after end event');
      stream.emit('error', _e);
    } else {
      var skipAdd;
      if (state.decoder && !addToFront && !encoding) {
        chunk = state.decoder.write(chunk);
        skipAdd = !state.objectMode && chunk.length === 0;
      }

      if (!addToFront) state.reading = false;

      // Don't add to the buffer if we've decoded to an empty string chunk and
      // we're not in object mode
      if (!skipAdd) {
        // if we want the data now, just emit it.
        if (state.flowing && state.length === 0 && !state.sync) {
          stream.emit('data', chunk);
          stream.read(0);
        } else {
          // update the buffer info.
          state.length += state.objectMode ? 1 : chunk.length;
          if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

          if (state.needReadable) emitReadable(stream);
        }
      }

      maybeReadMore(stream, state);
    }
  } else if (!addToFront) {
    state.reading = false;
  }

  return needMoreData(state);
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(111).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function chunkInvalid(state, chunk) {
  var er = null;
  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    processNextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : cleanup;
  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable) {
    debug('onunpipe');
    if (readable === src) {
      cleanup();
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', cleanup);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var _i = 0; _i < len; _i++) {
      dests[_i].emit('unpipe', this);
    }return this;
  }

  // try to find the right one.
  var i = indexOf(state.pipes, dest);
  if (i === -1) return this;

  state.pipes.splice(i, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        processNextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this, state);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    processNextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
  forEach(events, function (ev) {
    stream.on(ev, self.emit.bind(self, ev));
  });

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = bufferShim.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    processNextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(771);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(265);

/*<replacement>*/
var util = __webpack_require__(162);
util.inherits = __webpack_require__(135);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {
exports['RSA-SHA224'] = exports.sha224WithRSAEncryption = {
  sign: 'rsa',
  hash: 'sha224',
  id: new Buffer('302d300d06096086480165030402040500041c', 'hex')
}
exports['RSA-SHA256'] = exports.sha256WithRSAEncryption = {
  sign: 'rsa',
  hash: 'sha256',
  id: new Buffer('3031300d060960864801650304020105000420', 'hex')
}
exports['RSA-SHA384'] = exports.sha384WithRSAEncryption = {
  sign: 'rsa',
  hash: 'sha384',
  id: new Buffer('3041300d060960864801650304020205000430', 'hex')
}
exports['RSA-SHA512'] = exports.sha512WithRSAEncryption = {
  sign: 'rsa',
  hash: 'sha512',
  id: new Buffer('3051300d060960864801650304020305000440', 'hex')
}
exports['RSA-SHA1'] = {
  sign: 'rsa',
  hash: 'sha1',
  id: new Buffer('3021300906052b0e03021a05000414', 'hex')
}
exports['ecdsa-with-SHA1'] = {
  sign: 'ecdsa',
  hash: 'sha1',
  id: new Buffer('', 'hex')
}

exports.DSA = exports['DSA-SHA1'] = exports['DSA-SHA'] = {
  sign: 'dsa',
  hash: 'sha1',
  id: new Buffer('', 'hex')
}
exports['DSA-SHA224'] = exports['DSA-WITH-SHA224'] = {
  sign: 'dsa',
  hash: 'sha224',
  id: new Buffer('', 'hex')
}
exports['DSA-SHA256'] = exports['DSA-WITH-SHA256'] = {
  sign: 'dsa',
  hash: 'sha256',
  id: new Buffer('', 'hex')
}
exports['DSA-SHA384'] = exports['DSA-WITH-SHA384'] = {
  sign: 'dsa',
  hash: 'sha384',
  id: new Buffer('', 'hex')
}
exports['DSA-SHA512'] = exports['DSA-WITH-SHA512'] = {
  sign: 'dsa',
  hash: 'sha512',
  id: new Buffer('', 'hex')
}
exports['DSA-RIPEMD160'] = {
  sign: 'dsa',
  hash: 'rmd160',
  id: new Buffer('', 'hex')
}
exports['RSA-RIPEMD160'] = exports.ripemd160WithRSA = {
  sign: 'rsa',
  hash: 'rmd160',
  id: new Buffer('3021300906052b2403020105000414', 'hex')
}
exports['RSA-MD5'] = exports.md5WithRSAEncryption = {
  sign: 'rsa',
  hash: 'md5',
  id: new Buffer('3020300c06082a864886f70d020505000410', 'hex')
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHmac = __webpack_require__(266)
var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

exports.pbkdf2 = pbkdf2
function pbkdf2 (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  if (typeof callback !== 'function') {
    throw new Error('No callback provided to pbkdf2')
  }

  var result = pbkdf2Sync(password, salt, iterations, keylen, digest)
  setTimeout(function () {
    callback(undefined, result)
  })
}

exports.pbkdf2Sync = pbkdf2Sync
function pbkdf2Sync (password, salt, iterations, keylen, digest) {
  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC) {
    throw new TypeError('Bad key length')
  }

  digest = digest || 'sha1'

  if (!Buffer.isBuffer(password)) password = new Buffer(password, 'binary')
  if (!Buffer.isBuffer(salt)) salt = new Buffer(salt, 'binary')

  var hLen
  var l = 1
  var DK = new Buffer(keylen)
  var block1 = new Buffer(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var r
  var T

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)
    var U = createHmac(digest, password).update(block1).digest()

    if (!hLen) {
      hLen = U.length
      T = new Buffer(hLen)
      l = Math.ceil(keylen / hLen)
      r = keylen - (l - 1) * hLen
    }

    U.copy(T, 0, 0, hLen)

    for (var j = 1; j < iterations; j++) {
      U = createHmac(digest, password).update(U).digest()

      for (var k = 0; k < hLen; k++) {
        T[k] ^= U[k]
      }
    }

    var destPos = (i - 1) * hLen
    var len = (i === l ? r : hLen)
    T.copy(DK, destPos, 0, len)
  }

  return DK
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(196)
var Transform = __webpack_require__(134)
var inherits = __webpack_require__(42)

inherits(StreamCipher, Transform)
module.exports = StreamCipher
function StreamCipher (mode, key, iv, decrypt) {
  if (!(this instanceof StreamCipher)) {
    return new StreamCipher(mode, key, iv)
  }
  Transform.call(this)
  this._cipher = new aes.AES(key)
  this._prev = new Buffer(iv.length)
  this._cache = new Buffer('')
  this._secCache = new Buffer('')
  this._decrypt = decrypt
  iv.copy(this._prev)
  this._mode = mode
}
StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}
StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(196)
var Transform = __webpack_require__(134)
var inherits = __webpack_require__(42)
var GHASH = __webpack_require__(786)
var xor = __webpack_require__(164)
inherits(StreamCipher, Transform)
module.exports = StreamCipher

function StreamCipher (mode, key, iv, decrypt) {
  if (!(this instanceof StreamCipher)) {
    return new StreamCipher(mode, key, iv)
  }
  Transform.call(this)
  this._finID = Buffer.concat([iv, new Buffer([0, 0, 0, 1])])
  iv = Buffer.concat([iv, new Buffer([0, 0, 0, 2])])
  this._cipher = new aes.AES(key)
  this._prev = new Buffer(iv.length)
  this._cache = new Buffer('')
  this._secCache = new Buffer('')
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  iv.copy(this._prev)
  this._mode = mode
  var h = new Buffer(4)
  h.fill(0)
  this._ghash = new GHASH(this._cipher.encryptBlock(h))
  this._authTag = null
  this._called = false
}
StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = new Buffer(rump)
      rump.fill(0)
      this._ghash.update(rump)
    }
  }
  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}
StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) {
    throw new Error('Unsupported state or unable to authenticate data')
  }
  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt) {
    if (xorTest(tag, this._authTag)) {
      throw new Error('Unsupported state or unable to authenticate data')
    }
  } else {
    this._authTag = tag
  }
  this._cipher.scrub()
}
StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (!this._decrypt && Buffer.isBuffer(this._authTag)) {
    return this._authTag
  } else {
    throw new Error('Attempting to get auth tag in unsupported state')
  }
}
StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (this._decrypt) {
    this._authTag = tag
  } else {
    throw new Error('Attempting to set auth tag in unsupported state')
  }
}
StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (!this._called) {
    this._ghash.update(buf)
    this._alen += buf.length
  } else {
    throw new Error('Attempting to set AAD in unsupported state')
  }
}
function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) {
    out++
  }
  var len = Math.min(a.length, b.length)
  var i = -1
  while (++i < len) {
    out += (a[i] ^ b[i])
  }
  return out
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 381 */
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}
exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(164)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(164)

exports.encrypt = function (self, data, decrypt) {
  var out = new Buffer('')
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = new Buffer('')
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}
function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam
  self._prev = Buffer.concat([self._prev.slice(1), new Buffer([decrypt ? byteParam : out])])
  return out
}
exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = new Buffer(len)
  var i = -1
  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }
  return out
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}
exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = new Buffer(len)
  var i = -1
  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }
  return out
}
function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = new Buffer(buffer.length)
  buffer = Buffer.concat([buffer, new Buffer([value])])
  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }
  return out
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(164)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(160);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(61);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(388);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(61);
var brorand = __webpack_require__(389);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._rand = function _rand(n) {
  var len = n.bitLength();
  var buf = this.rand.generate(Math.ceil(len / 8));

  // Set low bits
  buf[0] |= 3;

  // Mask high bits
  var mask = len & 0x7;
  if (mask !== 0)
    buf[buf.length - 1] >>= 7 - mask;

  return new bn(buf);
}

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  var n2 = n1.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._rand(n2);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  var n2 = n1.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._rand(n2);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

if (typeof window === 'object') {
  if (window.crypto && window.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      window.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (window.msCrypto && window.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      window.msCrypto.getRandomValues(arr);
      return arr;
    };
  } else {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker
  try {
    var crypto = __webpack_require__(370);

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
    // Emulate crypto API using randy
    Rand.prototype._rand = function _rand(n) {
      var res = new Uint8Array(n);
      for (var i = 0; i < res.length; i++)
        res[i] = this.rand.getByte();
      return res;
    };
  }
}


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports['1.3.132.0.10'] = 'secp256k1'

exports['1.3.132.0.33'] = 'p224'

exports['1.2.840.10045.3.1.1'] = 'p192'

exports['1.2.840.10045.3.1.7'] = 'p256'

exports['1.3.132.0.34'] = 'p384'

exports['1.3.132.0.35'] = 'p521'


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(42);
var Reporter = __webpack_require__(165).Reporter;
var Buffer = __webpack_require__(19).Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(821);


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(42);

var asn1 = __webpack_require__(136);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der');
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num >= 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(42);
var Buffer = __webpack_require__(19).Buffer;

var asn1 = __webpack_require__(136);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__(132)
var Buffer = __webpack_require__(161).Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__(61)
var Buffer = __webpack_require__(161).Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),
/* 398 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCloseMediumData: "data:image/svg+xml,%3csvg width='14' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.613.21l.094.083L7 5.585 12.293.293l.094-.083a1 1 0 011.32 1.497L8.415 7l5.292 5.293a1 1 0 01-1.32 1.497l-.094-.083L7 8.415l-5.293 5.292-.094.083a1 1 0 01-1.32-1.497L5.585 7 .293 1.707A1 1 0 011.613.21z' fill='currentColor' fill-rule='nonzero'/%3e%3c/svg%3e",
  iconCloseMediumWidth: 14,
  iconCloseMediumHeight: 14
};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = exports.Consumer = void 0;

var _react = __webpack_require__(0);

var _createContext = /*#__PURE__*/(0, _react.createContext)({}),
    Provider = _createContext.Provider,
    Consumer = _createContext.Consumer;

exports.Consumer = Consumer;
exports.Provider = Provider;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _box = _interopRequireDefault(__webpack_require__(851));

var _default = _box["default"];
exports["default"] = _default;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var upperFirst = function upperFirst(str) {
  return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
};

var _default = upperFirst;
exports["default"] = _default;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _close = _interopRequireDefault(__webpack_require__(154));

var _button2 = _interopRequireDefault(__webpack_require__(8));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _functional = __webpack_require__(38);

var styles = (0, _functional.memoize)(function (t) {
  return (0, _emotion.css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    fontWeight: t("headerFontWeight"),
    marginBottom: t("spacingInsetVerticalMedium"),
    "& > button": (0, _defineProperty2["default"])({
      marginTop: 4 - t("spacingInsetVerticalMedium"),
      marginRight: 4 - t("spacingInsetHorizontalMedium"),
      marginLeft: t("headerSpacingHorizontal")
    }, "[dir=\"rtl\"] &", {
      marginLeft: 4 - t("spacingInsetHorizontalMedium"),
      marginRight: t("headerSpacingHorizontal")
    })
  });
});
/**
 * This component can be used to render a title and close button for a popover.
 * Place this as a child of the Popover component.
 */

var PopoverHeader = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: styles(props.t
    /* eslint-disable-line react/prop-types */
    )
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: props.id
    /* eslint-disable-line react/prop-types */

  }, props.children), /*#__PURE__*/_react["default"].createElement(_button2["default"], {
    type: "icon",
    size: "small",
    onClick: props.onClose
    /* eslint-disable-line react/prop-types */

  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _close["default"]
  }, props.closeLabel)));
});

PopoverHeader.displayName = "PopoverHeader";
PopoverHeader.propTypes = {
  /**
   * The contents of the header. Plain text recommended.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * An accessible label for the close button.
   */
  closeLabel: _propTypes["default"].string
};
PopoverHeader.defaultProps = {
  closeLabel: "Close"
};
var _default = PopoverHeader;
exports["default"] = _default;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(404);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 404 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(868),
    hasUnicode = __webpack_require__(205),
    unicodeToArray = __webpack_require__(869);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

/**
 * This component groups option list items.
 *
 * @since 5.13.0
 */
var OptionListGroup = function OptionListGroup(props) {
  var label = props.label,
      children = props.children,
      disabled = props.disabled;
  var labelId = (0, _uniqueId["default"])("option-list-group-title-");
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]);
  var ariaLabel = passThroughProps["aria-label"];
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    role: "group",
    "aria-labelledby": labelId
  }, passThroughProps), /*#__PURE__*/_react["default"].createElement("span", {
    id: labelId,
    role: "presentation",
    disabled: disabled,
    "aria-label": ariaLabel
  }, label), children);
};

OptionListGroup.propTypes =  false ? {
  /**
   * A set of OptionListItem nodes. Nested groups not supported.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The label of the group.
   */
  label: _propTypes["default"].string.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive. Setting to `true` will also
   * disable all child options.
   */
  disabled: _propTypes["default"].bool
} : {};
var _default = OptionListGroup;
exports["default"] = _default;

/***/ }),
/* 407 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    modalMobileCloseButtonSpacingTop: 4,
    modalMobileCloseButtonSpacingRight: 2,
    modalMotionDuration: "300ms",
    modalMotionFunction: "ease",
    modalBorderWidth: 1,
    modalBorderRadius: 4,
    modalHeaderForegroundColor: "#FFFFFF",
    modalHeaderBackgroundColor: "#252829",
    modalHeaderFontWeight: 600,
    modalHeaderMinHeight: 48,
    modalHeaderSpacingInsetTop: 8,
    modalHeaderSpacingInsetRight: 40,
    modalHeaderSpacingInsetBottom: 8,
    modalHeaderSpacingInsetLeft: 16,
    modalCloseButtonSpacingTop: 8,
    modalCloseButtonSpacingRight: 8,
    modalBodyBackgroundColor: tokens.themeBackgroundPrimaryDefault,
    modalFooterSpacingInset: 16,
    modalFooterBorderWidth: 1,
    modalFooterBorderRadius: 0,
    modalFooterBorderColor: tokens.themeBorderTertiaryDefault,
    modalDropShadowOffsetX: 0,
    modalDropShadowOffsetY: 2,
    modalDropShadowBlur: 4,
    modalDropShadowSpread: 0,
    modalDropShadowColor: "rgba(11, 12, 12, 0.16)",
    modalFloatingBreakpoint: 721
  }
};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

/**
 * This component is used to render a footer in your Modal. It is meant to
 * be used with Modals of type "scrollableRegion," and without it modals of
 * those type will not render correctly.
 */
var ModalFooter = function ModalFooter(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("footer", null, children);
};

ModalFooter.propTypes =  false ? {
  /**
   * The contents of the footer. Can be any components, but we suggest you
   * include action buttons here (e.g. "Close" and "Cancel") so that they are
   * easily reachable by your customers
   */
  children: _propTypes["default"].node.isRequired
} : {};
var _default = ModalFooter;
exports["default"] = _default;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(410),
    isArrayLike = __webpack_require__(125),
    isString = __webpack_require__(345),
    toInteger = __webpack_require__(130),
    values = __webpack_require__(885);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(255),
    baseIsNaN = __webpack_require__(883),
    strictIndexOf = __webpack_require__(884);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _scrim = _interopRequireDefault(__webpack_require__(888));

var _default = _scrim["default"];
exports["default"] = _default;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AnimateFade", {
  enumerable: true,
  get: function get() {
    return _animateFade["default"];
  }
});
Object.defineProperty(exports, "AnimateFadeScale", {
  enumerable: true,
  get: function get() {
    return _animateFadeScale["default"];
  }
});
Object.defineProperty(exports, "AnimateSlideIn", {
  enumerable: true,
  get: function get() {
    return _animateSlideIn["default"];
  }
});
exports["default"] = void 0;

var _withAnimateMount = _interopRequireDefault(__webpack_require__(889));

var _animateFade = _interopRequireDefault(__webpack_require__(890));

var _animateSlideIn = _interopRequireDefault(__webpack_require__(891));

var _animateFadeScale = _interopRequireDefault(__webpack_require__(892));

var _default = _withAnimateMount["default"];
exports["default"] = _default;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * WHAT: This function makes it easy to detect a direct click on an element. It
 * will only trigger if both the mouse down and mouse up parts of the click
 * occurr directly on the element itself, and not the element's children.
 *
 * WHY: Listening for a direct click on an element, excluding its children, is
 * pretty tricky. You could try comparing event.target to event.currentTarget in
 * a click handler bound directly to the element, but that would still fire if
 * the click started on another element. For example if the user moused down on
 * a child element, moused over to the parent element, and released then a click
 * even would be fired on the parent where event.target was the same as
 * event.currentTarget. This same limitation applies to the method of trying to
 * call event.stopPropagation on click events from children to keep them from
 * bubbling up to parents. See https://sim.amazon.com/issues/MRDN-592 for why
 * triggering a click that started on another element can be problematic.

 * HOW: Usage of this utility is a little weird, but it's the only consistent
 * solution I could find to the problem. This function's only argument is the
 * onClick handler that should be called when a direct click is made. However
 * instead of returning some sort of more robust click handler it returns a
 * mouse down handler. This handler should be passed to the onMouseDown prop of
 * the element. For example:
 *
 * ```
 * const onClick = () => console.log("clicked directly on div!")
 *
 * // NOTE: onClick can't change after this point as onDirectClick stores it in
 * // memory. If onClick may change just inline this in your jsx (e.g.
 * // `onMouseDown={onDirectClick(onClick)}`).
 * const onMouseDown = onDirectClick(onClick)
 *
 * <div onMouseDown={onMouseDown}>
 *   <p>Clicking on this will not trigger a "direct" click on the parent</p>
 * </div>
 * ```
 *
 * Not super intuitive, but it works. This allows the utility to start listening
 * for clicks only when the user mouses down on the element, avoiding the
 * situation where a mousedown on another element, then a mouseover to our
 * element, then a mouse up would fire a click.
 */
var onDirectClick = function onDirectClick(callback) {
  // Listeners to add when the user mouses down on our element.
  var addListeners = function addListeners(node) {
    node.addEventListener("click", onClick);
    node.addEventListener("mouseout", onMouseOut);
  }; // Listeners to remove when the user finishes their click or mouses out of
  // the element.


  var removeListeners = function removeListeners(node) {
    node.removeEventListener("click", onClick);
    node.removeEventListener("mouseout", onMouseOut);
  }; // This is the final "direct" click handler.


  var onClick = function onClick(event) {
    removeListeners(event.target);
    callback(event);
  }; // If the user mouses out clear our listeners (and stop listening for a click
  // event, as it would no longer be directly on the element).


  var onMouseOut = function onMouseOut(event) {
    return removeListeners(event.target);
  }; // If the user mouses down directly on the element that this event is bound
  // to then start listening for a click event to finish things off.


  var onMouseDown = function onMouseDown(event) {
    if (event.target === event.currentTarget) {
      addListeners(event.target);
    }
  };

  return callback ? onMouseDown : undefined;
};

var _default = onDirectClick;
exports["default"] = _default;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _responsive = _interopRequireDefault(__webpack_require__(893));

var _default = _responsive["default"];
exports["default"] = _default;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _default = /*#__PURE__*/_react["default"].createContext({});

exports["default"] = _default;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(907),
    isObjectLike = __webpack_require__(173);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(89),
    stubFalse = __webpack_require__(910);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(124)(module)))

/***/ }),
/* 419 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(911),
    baseUnary = __webpack_require__(912),
    nodeUtil = __webpack_require__(913);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(422),
    isLength = __webpack_require__(279);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(172),
    isObject = __webpack_require__(210);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(211),
    stackClear = __webpack_require__(926),
    stackDelete = __webpack_require__(927),
    stackGet = __webpack_require__(928),
    stackHas = __webpack_require__(929),
    stackSet = __webpack_require__(930);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 424 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 425 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(947),
    isObjectLike = __webpack_require__(173);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(948),
    arraySome = __webpack_require__(951),
    cacheHas = __webpack_require__(952);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(210);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 429 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(431),
    toKey = __webpack_require__(216);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(90),
    isKey = __webpack_require__(283),
    stringToPath = __webpack_require__(972),
    toString = __webpack_require__(432);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(975);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var listReset = {
  listStyle: "none",
  padding: 0,
  margin: 0
};
var _default = listReset;
exports["default"] = _default;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOptionValueSelected = exports.isOption = exports.isGroup = exports.getOptionsFromChildren = exports.getNonOptionsFromChildren = exports.createOptionItemsAndGroups = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _selectOption = _interopRequireDefault(__webpack_require__(435));

var _selectOptionGroup = _interopRequireDefault(__webpack_require__(436));

var _optionList = __webpack_require__(169);

var _highlightSubstring = _interopRequireDefault(__webpack_require__(285));

var _isElementOf = _interopRequireDefault(__webpack_require__(94));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var isOption = (0, _isElementOf["default"])(_selectOption["default"]);
exports.isOption = isOption;
var isGroup = (0, _isElementOf["default"])(_selectOptionGroup["default"]);
exports.isGroup = isGroup;

var isOptionValueSelected = function isOptionValueSelected(selectedValue, optionValue) {
  return Array.isArray(selectedValue) ? selectedValue.indexOf(optionValue) !== -1 : selectedValue === optionValue;
};

exports.isOptionValueSelected = isOptionValueSelected;

var getOptionFromSelectOption = function getOptionFromSelectOption(_ref) {
  var selectOption = _ref.selectOption,
      index = _ref.index,
      groupDisabled = _ref.groupDisabled;
  return _objectSpread({
    index: index,
    label: selectOption.props.label.toString(),
    value: selectOption.props.value,
    children: selectOption.props.children,
    disabled: groupDisabled || selectOption.props.disabled
  }, (0, _filterPropsByPrefix["default"])(selectOption.props, ["data-"]));
};

var getOptionsFromChildren = function getOptionsFromChildren(children) {
  // The final list of options
  var options = []; // Rest option counter to 0

  var optionCounter = 0;

  _react["default"].Children.toArray(children).forEach(function (child) {
    // If we're parsing an option, push onto options
    if (isOption(child)) {
      var index = optionCounter;
      options.push(getOptionFromSelectOption({
        selectOption: child,
        index: index
      })); // Update option counter

      optionCounter += 1;
    } // If we're parsing a group, iterate over its children and add to options
    else if (isGroup(child)) {
      var groupDisabled = child.props.disabled;

      _react["default"].Children.toArray(child.props.children).forEach(function (child) {
        var index = optionCounter;

        if (isOption(child)) {
          options.push(getOptionFromSelectOption({
            selectOption: child,
            index: index,
            groupDisabled: groupDisabled
          })); // Update option counter

          optionCounter += 1;
        }
      });
    }
  });

  return options;
};

exports.getOptionsFromChildren = getOptionsFromChildren;

var createOptionItemFromSelectOption = function createOptionItemFromSelectOption(option, _ref2) {
  var selectValue = _ref2.selectValue,
      onClickOption = _ref2.onClickOption,
      searchQuery = _ref2.searchQuery,
      groupDisabled = _ref2.groupDisabled;
  var _option$props = option.props,
      label = _option$props.label,
      value = _option$props.value,
      disabled = _option$props.disabled;
  var key = option.key;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(option.props, ["data-"]);
  var children = searchQuery && option.props.children === undefined ? function () {
    return /*#__PURE__*/_react["default"].createElement(_highlightSubstring["default"], {
      match: searchQuery
    }, label);
  } : option.props.children;
  return /*#__PURE__*/_react["default"].createElement(_optionList.OptionListItem, _objectSpread({
    key: key !== null && key !== void 0 ? key : value,
    selected: isOptionValueSelected(selectValue, value),
    onClick: function onClick() {
      return onClickOption(value);
    },
    label: label.toString(),
    disabled: disabled || groupDisabled
  }, passThroughProps), children);
};

var createOptionGroupFromSelectOptionGroup = function createOptionGroupFromSelectOptionGroup(group, _ref3) {
  var selectValue = _ref3.selectValue,
      onClickOption = _ref3.onClickOption,
      searchQuery = _ref3.searchQuery;
  var _group$props = group.props,
      label = _group$props.label,
      disabled = _group$props.disabled;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(group.props, ["aria-", "data-"]);

  var children = _react["default"].Children.toArray(group.props.children).map(function (child) {
    if (isOption(child)) {
      return createOptionItemFromSelectOption(child, {
        selectValue: selectValue,
        onClickOption: onClickOption,
        searchQuery: searchQuery,
        groupDisabled: disabled
      });
    }
  });

  return /*#__PURE__*/_react["default"].createElement(_optionList.OptionListGroup, _objectSpread({
    key: label,
    label: label.toString(),
    disabled: disabled
  }, passThroughProps), children);
};

var createOptionItemsAndGroups = function createOptionItemsAndGroups(_ref4) {
  var children = _ref4.children,
      selectValue = _ref4.value,
      onClickOption = _ref4.onClickOption,
      searchQuery = _ref4.searchQuery;
  var optionsAndGroups = [];

  _react["default"].Children.toArray(children).forEach(function (child) {
    if (isOption(child)) {
      optionsAndGroups.push(createOptionItemFromSelectOption(child, {
        selectValue: selectValue,
        onClickOption: onClickOption,
        searchQuery: searchQuery
      }));
    } else if (isGroup(child)) {
      optionsAndGroups.push(createOptionGroupFromSelectOptionGroup(child, {
        selectValue: selectValue,
        onClickOption: onClickOption,
        searchQuery: searchQuery
      }));
    }
  });

  return optionsAndGroups;
};

exports.createOptionItemsAndGroups = createOptionItemsAndGroups;

var getNonOptionsFromChildren = function getNonOptionsFromChildren(children) {
  return _react["default"].Children.toArray(children).filter(function (child) {
    return child && !isOption(child) && !isGroup(child);
  });
};

exports.getNonOptionsFromChildren = getNonOptionsFromChildren;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Pass this as a child to the `Select` component to render it as an option of
 * the select.
 */
var SelectOption = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SelectOption, _React$Component);

  var _super = _createSuper(SelectOption);

  function SelectOption() {
    (0, _classCallCheck2["default"])(this, SelectOption);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SelectOption, [{
    key: "render",
    value: function render() {
      // The top-level OptionListItem component is used to render this. See
      // ./select-option-list for the implementation.
      return null;
    }
  }]);
  return SelectOption;
}(_react["default"].Component);

SelectOption.propTypes =  false ? {
  /**
   * The option's label.
   *
   * This is shown in the `Select` component's field when the option is
   * selected, and as the text for the option if no `children` prop is provided.
   */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,

  /**
   * The value of the option. This will be passed to the `Select` component's
   * `onChange` handler when this option is selected.
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,

  /**
   * Use this to render custom (non-plain-text) children in the option.
   *
   * This should be a function that returns the elements to render. It will
   * receive as its only argument an object containing the following keys:
   *   - `preselected` - a boolean that will be true if the user has
   *     focused on the option with their mouse or keyboard
   *   - `selected` - a boolean that will be true if the user has selected the
   *     option.
   * This data can be used to tailor the display of the custom option children
   * based on the state of the option.
   */
  children: _propTypes["default"].func,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool
} : {};
var _default = SelectOption;
exports["default"] = _default;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Pass this as a child to the `Select` component to render it as an option of
 * the select.
 *
 * @since 5.13.0
 */
var SelectOptionGroup = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SelectOptionGroup, _React$Component);

  var _super = _createSuper(SelectOptionGroup);

  function SelectOptionGroup() {
    (0, _classCallCheck2["default"])(this, SelectOptionGroup);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SelectOptionGroup, [{
    key: "render",
    value: function render() {
      // The top-level OptionListGroup component is used to render this. See
      // ./select-option-list for the implementation.
      return null;
    }
  }]);
  return SelectOptionGroup;
}(_react["default"].Component);

SelectOptionGroup.propTypes =  false ? {
  /**
   * A list of `SelectOption` elements. Nested groups are not supported.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The group's label.
   */
  label: _propTypes["default"].string.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive. Setting to `true` will also
   * disable all child options.
   */
  disabled: _propTypes["default"].bool
} : {};
var _default = SelectOptionGroup;
exports["default"] = _default;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _default = /*#__PURE__*/_react["default"].createContext({});

exports["default"] = _default;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _expanderController = _interopRequireDefault(__webpack_require__(1005));

var _default = _expanderController["default"];
exports["default"] = _default;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _datePicker = _interopRequireDefault(__webpack_require__(1012));

var _default = _datePicker["default"];
exports["default"] = _default;

/***/ }),
/* 440 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    datePickerInputValueLetterSpacing: 2,
    datePickerInputPlaceholderFontSize: 13,
    datePickerInputPlaceholderLineHeight: "18px",
    datePickerInputPlaceholderColorDefault: tokens.themeForegroundSecondaryDefault,
    datePickerInputPlaceholderColorDisabled: tokens.themeForegroundPrimaryDisabled,
    datePickerInputSpacingHorizontal: 8,
    datePickerPopoverElevation: 70,
    datePickerPopoverBackgroundColor: tokens.themeBackgroundAlternatePrimaryDefault,
    datePickerPopoverBorderWidth: 1,
    datePickerPopoverBorderRadius: 4,
    datePickerPopoverBorderColor: tokens.themeBorderTertiaryDefault,
    datePickerPopoverDropShadowOffsetX: 0,
    datePickerPopoverDropShadowOffsetY: 1,
    datePickerPopoverDropShadowBlur: 2,
    datePickerPopoverDropShadowSpread: 0,
    datePickerPopoverDropShadowColor: "rgba(11, 12, 12, 0.16)",
    datePickerPopoverSpacingInset: 32,
    datePickerPopoverSpacingVertical: 8,
    datePickerErrorTooltipElevation: 80,
    datePickerPresetsDividerWidth: 1,
    datePickerPresetsDividerColor: tokens.themeBorderSecondaryDefault
  }
};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _inputClearButton = _interopRequireDefault(__webpack_require__(1019));

var _default = _inputClearButton["default"];
exports["default"] = _default;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _inputMonospacePlaceholder["default"];
  }
});

var _inputMonospacePlaceholder = _interopRequireDefault(__webpack_require__(1020));

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(1023),
    hasUnicode = __webpack_require__(205),
    unicodeSize = __webpack_require__(1024);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = eachDayOfInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(45);


/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */

function eachDayOfInterval(dirtyInterval, options) {
  var _options$step;

  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(interval.start);
  var endDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');

  while (currentDate.getTime() <= endTime) {
    dates.push(Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }

  return dates;
}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronLeftSmallData: "data:image/svg+xml,%3csvg width='6' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5 1L1 5l4 4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronLeftSmallRtlSvg: "data:image/svg+xml,%3csvg width='6' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 9l4-4-4-4' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconChevronLeftSmallWidth: 6,
  iconChevronLeftSmallHeight: 10
};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _timePicker = _interopRequireDefault(__webpack_require__(1042));

var _default = _timePicker["default"];
exports["default"] = _default;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

// Create a custom validator for ref objects - { current: <Element> } - that
// won't explode when run in Node (where Element doesn't exist).
var refObject = _propTypes["default"].shape({
  current: typeof Element === "undefined" ? _propTypes["default"].object : _propTypes["default"].instanceOf(Element)
});

var _default = refObject;
exports["default"] = _default;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _textarea = _interopRequireDefault(__webpack_require__(1049));

var _default = _textarea["default"];
exports["default"] = _default;

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export metricProcessName */
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchThinClientStatusDetails;
/* harmony export (immutable) */ __webpack_exports__["i"] = setThinClientStatusDetailsToRestartedState;
/* harmony export (immutable) */ __webpack_exports__["h"] = setThinClientStatusDetailsToRestartInProgressState;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchThinClientDeviceDetails;
/* unused harmony export getPrimaryValue */
/* harmony export (immutable) */ __webpack_exports__["g"] = setThinClientDeviceDetails;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteThinClientDeviceDetails; });
/* unused harmony export extractThinClientDeviceList */
/* unused harmony export getThinClientDeviceSoftwareStatusDetails */
/* unused harmony export updateThinClientDeviceList */
/* unused harmony export getThinClientDeviceStatusDetails */
/* unused harmony export fetchThinClientAssetDetails */
/* unused harmony export getThinClientDeviceDetails */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return postUpdatedRemarkToDevice; });
/* unused harmony export deployThinClient */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return restartApplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return toggleThinClientUseCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeThinClientUseCase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ledcontroller_bintester_util_sleep__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_http_status_codes__ = __webpack_require__(450);
var _this=this;var updateThinClientDeviceDetails=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatcher,request,stateValues){var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:startTime=Date.now();Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetLabel).then(function(result){if(result.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateThinClientDeviceDetails",true,false);dispatcher({type:"RECEIVE_DATA",data:updateThinClientDeviceList(result.data.asset,stateValues,dispatcher)});}else{var isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(result.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateThinClientDeviceDetails",false,isFault);dispatcher({type:"RECEIVE_DATA",data:[]});}});case 2:case"end":return _context7.stop();}}},_callee7,this);}));return function updateThinClientDeviceDetails(_x14,_x15,_x16){return _ref7.apply(this,arguments);};}();var checkAndUpdateData=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(startTime,args,coreDeviceStatusResponse){var response,currentTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 2:response=_context10.sent;if(response.status===200&&response.data.updatedAt!==coreDeviceStatusResponse.data.updatedAt){_context10.next=13;break;}currentTime=Date.now();if(!(currentTime-startTime<__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_167" /* RESTART_APPLICATION_STATUS_TIMEOUT */])){_context10.next=12;break;}_context10.next=8;return Object(__WEBPACK_IMPORTED_MODULE_5__ledcontroller_bintester_util_sleep__["a" /* default */])(5000);case 8:_context10.next=10;return checkAndUpdateData(startTime,args,coreDeviceStatusResponse);case 10:_context10.next=13;break;case 12:alert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["x" /* ALERT_RESTART_APPLICATION_FAILED */]);case 13:case"end":return _context10.stop();}}},_callee10,this);}));return function checkAndUpdateData(_x22,_x23,_x24){return _ref10.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="THIN_CLIENT_DEVICE_DETAILS";function fetchThinClientStatusDetails(dispatcher,model){getThinClientDeviceStatusDetails(dispatcher,model);}function setThinClientStatusDetailsToRestartedState(dispatcher,model,mac){model.thinClientDeviceInformation[mac].swStatus=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_195" /* SW_STATUS */].RESTARTED;model.thinClientDeviceInformation[mac].swType=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_195" /* SW_STATUS */].DEPLOYED;}function setThinClientStatusDetailsToRestartInProgressState(dispatcher,model,mac){model.thinClientDeviceInformation[mac].swStatus=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_195" /* SW_STATUS */].RESTART_IN_PROGRESS;model.thinClientDeviceInformation[mac].swType=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_195" /* SW_STATUS */].RESTART_IN_PROGRESS;}function fetchThinClientDeviceDetails(dispatcher){var request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_201" /* THIN_CLIENT_ASSET_TYPE */]};getThinClientDeviceDetails(dispatcher,request);}var getPrimaryValue=function getPrimaryValue(assetAttributes){if(assetAttributes.useCase===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_171" /* SBL_ASSET_TYPE */]||assetAttributes.useCase===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_168" /* SBLV2_ASSET_TYPE */]||assetAttributes.useCase===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_86" /* IOT_AUTOMATION_ONLOGIC_ASSET_TYPE */]){return assetAttributes.primary||"false";}return"";};function setThinClientDeviceDetails(dispatcher,stateValues,mac){var request={assetLabel:{type:"MAC_ADDRESS",value:mac}};updateThinClientDeviceDetails(dispatcher,request,stateValues);}var deleteThinClientDeviceDetails=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher,mac){var request,startTime,args,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),macAddress:mac};startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_33" /* ENDPOINT_DELETE_THIN_CLIENT */]);_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context.sent;if(response.status===200){dispatcher({type:'LOAD_VIEW',data:{dispatcher:dispatcher}});Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteThinClient",true,false);}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteThinClient",false,isFault);}case 7:case"end":return _context.stop();}}},_callee,this);}));return function deleteThinClientDeviceDetails(_x,_x2){return _ref.apply(this,arguments);};}();var extractThinClientDeviceList=function extractThinClientDeviceList(result,model){if("data"in result&&"assetDetailsList"in result.data){result.data.assetDetailsList.forEach(function(thinClientDeviceDetail){if(thinClientDeviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]){model.gatewayNameList.push(thinClientDeviceDetail.assetAttributes.gatewayName);model.macAddressArray.push(thinClientDeviceDetail.assetLabel.value);model.thinClientDeviceInformation[thinClientDeviceDetail.assetLabel.value]={mac:thinClientDeviceDetail.assetLabel.value,ip:thinClientDeviceDetail.assetAttributes.ip,connection:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_110" /* LOADING_STRING */],swStatus:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_110" /* LOADING_STRING */],swType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_110" /* LOADING_STRING */],healthStatus:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_110" /* LOADING_STRING */],gatewayName:thinClientDeviceDetail.assetAttributes.gatewayName,vlan:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_16" /* getVlan */])(thinClientDeviceDetail.assetAttributes.ip),useCase:thinClientDeviceDetail.assetAttributes.useCase,primary:getPrimaryValue(thinClientDeviceDetail.assetAttributes),remark:!thinClientDeviceDetail.assetAttributes.remark?"":thinClientDeviceDetail.assetAttributes.remark,startTime:!thinClientDeviceDetail.assetAttributes.monitoring?"0":JSON.parse(thinClientDeviceDetail.assetAttributes.monitoring).startTime,endTime:!thinClientDeviceDetail.assetAttributes.monitoring?"0":JSON.parse(thinClientDeviceDetail.assetAttributes.monitoring).endTime,reason:!thinClientDeviceDetail.assetAttributes.monitoring?"":JSON.parse(thinClientDeviceDetail.assetAttributes.monitoring).reason};}});}};var getThinClientDeviceSoftwareStatusDetails=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatcher,model){var request,startTime,args,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:request={gatewayNameList:model.gatewayNameList};startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_57" /* ENDPOINT_GET_THIN_CLIENT_DEPLOYMENT_STATUS */]);_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context2.sent;if(response.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getThinClientDeviceSoftwareStatusDetails",true,false);mergeSoftwareStatusToModel(response,model);}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getThinClientDeviceSoftwareStatusDetails",false,isFault);model.macAddressArray.forEach(function(macAddress){model.thinClientDeviceInformation[macAddress].swStatus=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];model.thinClientDeviceInformation[macAddress].swType=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];});}dispatcher({type:"RECEIVE_DATA",data:model});case 8:case"end":return _context2.stop();}}},_callee2,_this);}));return function getThinClientDeviceSoftwareStatusDetails(_x3,_x4){return _ref2.apply(this,arguments);};}();var updateThinClientDeviceList=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(result,stateValues,dispatcher){var monitoring,responseSetAssetStatus,getAssetResult,responseUpdateAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:monitoring={startTime:stateValues.startTime,endTime:stateValues.endTime,reason:stateValues.reason};result.assetDetails.assetAttributes.monitoring=JSON.stringify(monitoring);_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["B" /* getAliasFromParent */])();case 4:result.assetDetails.alias=_context3.sent;_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(result.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);case 7:responseSetAssetStatus=_context3.sent;if(!(responseSetAssetStatus.status!==200)){_context3.next=12;break;}alert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);_context3.next=20;break;case 12:if(!(responseSetAssetStatus.status===200)){_context3.next=20;break;}_context3.next=15;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(result.assetDetails.assetLabel);case 15:getAssetResult=_context3.sent;_context3.next=18;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(result,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 18:responseUpdateAsset=_context3.sent;if(responseUpdateAsset.status!==200){alert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);}case 20:fetchThinClientDeviceDetails(dispatcher);case 21:case"end":return _context3.stop();}}},_callee3,_this);}));return function updateThinClientDeviceList(_x5,_x6,_x7){return _ref3.apply(this,arguments);};}();var getThinClientDeviceStatusDetails=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatcher,model){var request,startTime,args,result,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),deviceType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_201" /* THIN_CLIENT_ASSET_TYPE */]};startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_56" /* ENDPOINT_GET_SITE_DEVICES_CONNECTIVITY */]);_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:result=_context4.sent;if(result.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getThinClientDeviceStatusDetails",true,false);mergeStatusToModel(result,model);}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(result.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getThinClientDeviceStatusDetails",false,isFault);setAllStatusToFailed(model);}_context4.next=9;return getThinClientDeviceSoftwareStatusDetails(dispatcher,model);case 9:case"end":return _context4.stop();}}},_callee4,this);}));return function getThinClientDeviceStatusDetails(_x8,_x9){return _ref4.apply(this,arguments);};}();// Core function that only handles fetching and processing data
var fetchThinClientAssetDetails=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(nodeId,assetType){var startTime,pageToken,thinClientDetails,result,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:startTime=Date.now();pageToken=null;thinClientDetails={thinClientDeviceInformation:{},macAddressArray:[],gatewayNameList:[]};case 3:_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["g" /* getAssets */])(nodeId,assetType,pageToken);case 5:result=_context5.sent;if(!(result.status===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_81" /* HTTP_STATUS */].OK)){_context5.next=11;break;}extractThinClientDeviceList(result,thinClientDetails);pageToken=result.data&&result.data.pageToken?result.data.pageToken:null;_context5.next=14;break;case 11:isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(result.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getThinClientDeviceDetails",false,isFault);throw new Error("Failed to fetch assets: "+result.status);case 14:if(pageToken!==null){_context5.next=3;break;}case 15:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getThinClientDeviceDetails",true,false);return _context5.abrupt("return",thinClientDetails);case 17:case"end":return _context5.stop();}}},_callee5,this);}));return function fetchThinClientAssetDetails(_x10,_x11){return _ref5.apply(this,arguments);};}();// Wrapper function that handles dispatching and error handling
var getThinClientDeviceDetails=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatcher,request){var thinClientDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.prev=0;_context6.next=3;return fetchThinClientAssetDetails(request.nodeId,request.assetType);case 3:thinClientDetails=_context6.sent;_context6.next=6;return getThinClientDeviceStatusDetails(dispatcher,thinClientDetails);case 6:dispatcher({type:"RECEIVE_DATA",data:thinClientDetails});_context6.next=14;break;case 9:_context6.prev=9;_context6.t0=_context6["catch"](0);console.error('Error fetching thin client details:',_context6.t0);dispatcher({type:"RECEIVE_ERROR",error:_context6.t0.message});dispatcher({type:"RECEIVE_DATA",data:[]});case 14:case"end":return _context6.stop();}}},_callee6,this,[[0,9]]);}));return function getThinClientDeviceDetails(_x12,_x13){return _ref6.apply(this,arguments);};}();var postUpdatedRemarkToDevice=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(device,newRemark){var getAssetResult,newAsset,responseUpdateAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(device.mac));case 2:getAssetResult=_context8.sent;newAsset=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["q" /* convertTableJsonToEdgeGatewayAsset */])(Object.assign({},getAssetResult.data.asset.assetDetails.assetAttributes,{remark:newRemark}),__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_201" /* THIN_CLIENT_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */],device);_context8.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["B" /* getAliasFromParent */])();case 6:newAsset.assetDetails.alias=_context8.sent;_context8.next=9;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(newAsset,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 9:responseUpdateAsset=_context8.sent;if(responseUpdateAsset.status!==200){alert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);}case 11:case"end":return _context8.stop();}}},_callee8,this);}));return function postUpdatedRemarkToDevice(_x17,_x18){return _ref8.apply(this,arguments);};}();function setAllStatusToFailed(model){model.macAddressArray.forEach(function(macAddress){model.thinClientDeviceInformation[macAddress].connection=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];model.thinClientDeviceInformation[macAddress].healthStatus=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];model.thinClientDeviceInformation[macAddress].swStatus=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];});}function mergeStatusToModel(response,model){if("data"in response&&"deviceConnectivityList"in response.data){response.data.deviceConnectivityList.forEach(function(singleThinClientDeviceStatusDetail){var mac=singleThinClientDeviceStatusDetail.identifier;if(model.thinClientDeviceInformation[mac]){model.thinClientDeviceInformation[mac].connection=singleThinClientDeviceStatusDetail.status?singleThinClientDeviceStatusDetail.status:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];//This will always fail as above API only provide internet connectivity
model.thinClientDeviceInformation[mac].healthStatus=singleThinClientDeviceStatusDetail.deepHealthStatus?singleThinClientDeviceStatusDetail.deepHealthStatus:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];if(model.thinClientDeviceInformation[mac].swStatus===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_110" /* LOADING_STRING */])model.thinClientDeviceInformation[mac].swStatus=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];if(model.thinClientDeviceInformation[mac].swType===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_110" /* LOADING_STRING */])model.thinClientDeviceInformation[mac].swType=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];}});}model.macAddressArray.forEach(function(macAddress){if(model.thinClientDeviceInformation[macAddress].connection===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_110" /* LOADING_STRING */]){model.thinClientDeviceInformation[macAddress].connection=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];}if(model.thinClientDeviceInformation[macAddress].healthstatus===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_110" /* LOADING_STRING */]){model.thinClientDeviceInformation[macAddress].healthstatus=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];}});}function mergeSoftwareStatusToModel(response,model){if("data"in response&&"thinClientDeploymentList"in response.data){response.data.thinClientDeploymentList.forEach(function(singleThinClientDeviceSoftwareStatusDetail){// convert thingName tc-ababababab-DBE2_Core format to mac address ab:ab:ab:ab:ab
var mac=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_33" /* thingNameToMac */])(singleThinClientDeviceSoftwareStatusDetail.thingName);if(model.thinClientDeviceInformation[mac]){model.thinClientDeviceInformation[mac].swStatus=singleThinClientDeviceSoftwareStatusDetail.deploymentStatus?singleThinClientDeviceSoftwareStatusDetail.deploymentStatus:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];model.thinClientDeviceInformation[mac].swType=singleThinClientDeviceSoftwareStatusDetail.deploymentType?singleThinClientDeviceSoftwareStatusDetail.deploymentType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];}});}model.macAddressArray.forEach(function(macAddress){if(model.thinClientDeviceInformation[macAddress].swStatus===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_110" /* LOADING_STRING */]){model.thinClientDeviceInformation[macAddress].swStatus=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];}if(model.thinClientDeviceInformation[macAddress].swType===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_110" /* LOADING_STRING */]){model.thinClientDeviceInformation[macAddress].swType=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];}});}var deployThinClient=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatcher,mac,useCase){var deploymentInput,startTime,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:try{deploymentInput={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),macAddress:mac,thinClientUsecase:useCase};dispatcher({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'softwareStatusLoader',loaderVisible:true}});startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(deploymentInput,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_34" /* ENDPOINT_DEPLOY_THIN_CLIENT */]);Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args).then(function(response){if(response.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deployThinClient",true,false);setTimeout(function(){dispatcher({type:'LOAD_VIEW',data:{dispatcher:dispatcher}});dispatcher({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'softwareStatusLoader',loaderVisible:false}});},__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_188" /* SOFTWARE_STATUS_LOADER_TIMER */]);}else{var isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deployThinClient",false,isFault);dispatcher({type:'LOAD_VIEW',data:{dispatcher:dispatcher}});dispatcher({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'softwareStatusLoader',loaderVisible:false}});}});}catch(e){console.log("Mac Address "+mac+" deployment API failed due to ",e);dispatcher({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'softwareStatusLoader',loaderVisible:false}});alert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["m" /* ALERT_ASSET_DEPLOY_MESSAGE */]);}case 1:case"end":return _context9.stop();}}},_callee9,this);}));return function deployThinClient(_x19,_x20,_x21){return _ref9.apply(this,arguments);};}();var restartApplication=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(dispatcher,mac){var _this2=this;var coreDeviceName,request,args,coreDeviceStatusResponse,argsNew,startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:coreDeviceName=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["n" /* convertMacToCoreDeviceName */])(mac);request={thingName:coreDeviceName};dispatcher({type:'LOAD_VIEW_FOR_GREENGRASS_RESTART',data:{dispatcher:dispatcher,mac:mac}});_context12.prev=3;args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_3" /* getSDSAPIGatewayGetRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_47" /* ENDPOINT_GET_CORE_DEVICE_STATUS */]+coreDeviceName);_context12.next=7;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 7:coreDeviceStatusResponse=_context12.sent;argsNew=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_4" /* getSDSAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_32" /* ENDPOINT_CREATE_REDEPLOYMENT */]);startTime=Date.now();Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(argsNew).then(function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(response){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:if(!(response.status===200)){_context11.next=13;break;}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deployThinClient",true);_context11.next=4;return Object(__WEBPACK_IMPORTED_MODULE_5__ledcontroller_bintester_util_sleep__["a" /* default */])(30000);case 4:_context11.next=6;return checkAndUpdateData(startTime,args,coreDeviceStatusResponse);case 6:dispatcher({type:'LOAD_VIEW_FOR_GREENGRASS_RESTART_COMPLETE',data:{dispatcher:dispatcher,mac:mac}});dispatcher({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'softwareStatusLoader',loaderVisible:false}});_context11.next=10;return Object(__WEBPACK_IMPORTED_MODULE_5__ledcontroller_bintester_util_sleep__["a" /* default */])(15000);case 10:dispatcher({type:'LOAD_VIEW',data:{dispatcher:dispatcher}});_context11.next=17;break;case 13:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deployThinClient",false);alert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["x" /* ALERT_RESTART_APPLICATION_FAILED */]);dispatcher({type:'LOAD_VIEW',data:{dispatcher:dispatcher}});dispatcher({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'softwareStatusLoader',loaderVisible:false}});case 17:case"end":return _context11.stop();}}},_callee11,_this2);}));return function(_x27){return _ref12.apply(this,arguments);};}());_context12.next=18;break;case 13:_context12.prev=13;_context12.t0=_context12["catch"](3);console.log("Mac Address "+mac+" Redeployment API failed due to ",_context12.t0);dispatcher({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'softwareStatusLoader',loaderVisible:false}});alert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["x" /* ALERT_RESTART_APPLICATION_FAILED */]);case 18:case"end":return _context12.stop();}}},_callee12,this,[[3,13]]);}));return function restartApplication(_x25,_x26){return _ref11.apply(this,arguments);};}();var toggleThinClientUseCase=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(dispatcher,mac,useCase){var requestInput,startTime,args,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.prev=0;requestInput={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),macAddress:mac,thinClientUsecase:useCase};dispatcher({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'usecaseStatusLoader',loaderVisible:true}});startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(requestInput,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_64" /* ENDPOINT_SWITCH_OVER_THIN_CLIENT */]);_context13.next=7;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 7:response=_context13.sent;if(response.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"switchOverThinClient",true,false);setTimeout(function(){dispatcher({type:'LOAD_VIEW',data:{dispatcher:dispatcher}});dispatcher({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'usecaseStatusLoader',loaderVisible:false}});},__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_214" /* USECASE_STATUS_LOADER_TIMER */]);}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"switchOverThinClient",false,isFault);dispatcher({type:'LOAD_VIEW',data:{dispatcher:dispatcher}});dispatcher({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'usecaseStatusLoader',loaderVisible:false}});}_context13.next=16;break;case 11:_context13.prev=11;_context13.t0=_context13["catch"](0);console.log("Mac Address "+mac+" toggle thin client use case API failed due to ",_context13.t0);dispatcher({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'usecaseStatusLoader',loaderVisible:false}});alert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["p" /* ALERT_ASSET_USE_CASE_UPDATE */]);case 16:case"end":return _context13.stop();}}},_callee13,this,[[0,11]]);}));return function toggleThinClientUseCase(_x28,_x29,_x30){return _ref13.apply(this,arguments);};}();var changeThinClientUseCase=function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(dispatcher,mac,useCase,showCustomAlert){var requestInput,startTime,args,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.prev=0;requestInput={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),macAddress:mac,useCase:useCase};dispatcher({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'usecaseStatusLoader',loaderVisible:true}});startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(requestInput,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_31" /* ENDPOINT_CHANGE_THIN_CLIENT_USECASE */]);_context14.next=7;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 7:response=_context14.sent;if(response.status===__WEBPACK_IMPORTED_MODULE_6_http_status_codes__["a" /* default */].OK){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"changeThinClientUseCase",true,false);setTimeout(function(){dispatcher({type:'LOAD_VIEW',data:{dispatcher:dispatcher}});dispatcher({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'usecaseStatusLoader',loaderVisible:false}});},__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_214" /* USECASE_STATUS_LOADER_TIMER */]);}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"changeThinClientUseCase",false,isFault);dispatcher({type:'LOAD_VIEW',data:{dispatcher:dispatcher}});dispatcher({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'usecaseStatusLoader',loaderVisible:false}});showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["o" /* ALERT_ASSET_USE_CASE_CHANGE */]);}_context14.next=16;break;case 11:_context14.prev=11;_context14.t0=_context14["catch"](0);console.log("Mac Address "+mac+" change thin client use case API failed due to ",_context14.t0);dispatcher({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:'usecaseStatusLoader',loaderVisible:false}});showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["o" /* ALERT_ASSET_USE_CASE_CHANGE */]);case 16:case"end":return _context14.stop();}}},_callee14,this,[[0,11]]);}));return function changeThinClientUseCase(_x31,_x32,_x33,_x34){return _ref14.apply(this,arguments);};}();

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__legacy__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_functions__ = __webpack_require__(452);
/* unused harmony reexport getStatusCode */
/* unused harmony reexport getReasonPhrase */
/* unused harmony reexport getStatusText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__status_codes__ = __webpack_require__(1054);
/* unused harmony reexport StatusCodes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reason_phrases__ = __webpack_require__(1055);
/* unused harmony reexport ReasonPhrases */
/* unused harmony namespace reexport */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};






/* harmony default export */ __webpack_exports__["a"] = (__assign(__assign({}, __WEBPACK_IMPORTED_MODULE_0__legacy__["a" /* default */]), { getStatusCode: __WEBPACK_IMPORTED_MODULE_1__utils_functions__["a" /* getStatusCode */],
    getStatusText: __WEBPACK_IMPORTED_MODULE_1__utils_functions__["b" /* getStatusText */] }));


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ACCEPTED */
/* unused harmony export BAD_GATEWAY */
/* unused harmony export BAD_REQUEST */
/* unused harmony export CONFLICT */
/* unused harmony export CONTINUE */
/* unused harmony export CREATED */
/* unused harmony export EXPECTATION_FAILED */
/* unused harmony export FAILED_DEPENDENCY */
/* unused harmony export FORBIDDEN */
/* unused harmony export GATEWAY_TIMEOUT */
/* unused harmony export GONE */
/* unused harmony export HTTP_VERSION_NOT_SUPPORTED */
/* unused harmony export IM_A_TEAPOT */
/* unused harmony export INSUFFICIENT_SPACE_ON_RESOURCE */
/* unused harmony export INSUFFICIENT_STORAGE */
/* unused harmony export INTERNAL_SERVER_ERROR */
/* unused harmony export LENGTH_REQUIRED */
/* unused harmony export LOCKED */
/* unused harmony export METHOD_FAILURE */
/* unused harmony export METHOD_NOT_ALLOWED */
/* unused harmony export MOVED_PERMANENTLY */
/* unused harmony export MOVED_TEMPORARILY */
/* unused harmony export MULTI_STATUS */
/* unused harmony export MULTIPLE_CHOICES */
/* unused harmony export NETWORK_AUTHENTICATION_REQUIRED */
/* unused harmony export NO_CONTENT */
/* unused harmony export NON_AUTHORITATIVE_INFORMATION */
/* unused harmony export NOT_ACCEPTABLE */
/* unused harmony export NOT_FOUND */
/* unused harmony export NOT_IMPLEMENTED */
/* unused harmony export NOT_MODIFIED */
/* unused harmony export OK */
/* unused harmony export PARTIAL_CONTENT */
/* unused harmony export PAYMENT_REQUIRED */
/* unused harmony export PERMANENT_REDIRECT */
/* unused harmony export PRECONDITION_FAILED */
/* unused harmony export PRECONDITION_REQUIRED */
/* unused harmony export PROCESSING */
/* unused harmony export PROXY_AUTHENTICATION_REQUIRED */
/* unused harmony export REQUEST_HEADER_FIELDS_TOO_LARGE */
/* unused harmony export REQUEST_TIMEOUT */
/* unused harmony export REQUEST_TOO_LONG */
/* unused harmony export REQUEST_URI_TOO_LONG */
/* unused harmony export REQUESTED_RANGE_NOT_SATISFIABLE */
/* unused harmony export RESET_CONTENT */
/* unused harmony export SEE_OTHER */
/* unused harmony export SERVICE_UNAVAILABLE */
/* unused harmony export SWITCHING_PROTOCOLS */
/* unused harmony export TEMPORARY_REDIRECT */
/* unused harmony export TOO_MANY_REQUESTS */
/* unused harmony export UNAUTHORIZED */
/* unused harmony export UNPROCESSABLE_ENTITY */
/* unused harmony export UNSUPPORTED_MEDIA_TYPE */
/* unused harmony export USE_PROXY */
// Exporting constants directly to maintain compatability with v1
// These are deprecated. Please don't add any new codes here.
/**
 * @deprecated Please use StatusCodes.ACCEPTED
 *
 * */
var ACCEPTED = 202;
/**
 * @deprecated Please use StatusCodes.BAD_GATEWAY
 *
 * */
var BAD_GATEWAY = 502;
/**
 * @deprecated Please use StatusCodes.BAD_REQUEST
 *
 * */
var BAD_REQUEST = 400;
/**
 * @deprecated Please use StatusCodes.CONFLICT
 *
 * */
var CONFLICT = 409;
/**
 * @deprecated Please use StatusCodes.CONTINUE
 *
 * */
var CONTINUE = 100;
/**
 * @deprecated Please use StatusCodes.CREATED
 *
 * */
var CREATED = 201;
/**
 * @deprecated Please use StatusCodes.EXPECTATION_FAILED
 *
 * */
var EXPECTATION_FAILED = 417;
/**
 * @deprecated Please use StatusCodes.FAILED_DEPENDENCY
 *
 * */
var FAILED_DEPENDENCY = 424;
/**
 * @deprecated Please use StatusCodes.FORBIDDEN
 *
 * */
var FORBIDDEN = 403;
/**
 * @deprecated Please use StatusCodes.GATEWAY_TIMEOUT
 *
 * */
var GATEWAY_TIMEOUT = 504;
/**
 * @deprecated Please use StatusCodes.GONE
 *
 * */
var GONE = 410;
/**
 * @deprecated Please use StatusCodes.HTTP_VERSION_NOT_SUPPORTED
 *
 * */
var HTTP_VERSION_NOT_SUPPORTED = 505;
/**
 * @deprecated Please use StatusCodes.IM_A_TEAPOT
 *
 * */
var IM_A_TEAPOT = 418;
/**
 * @deprecated Please use StatusCodes.INSUFFICIENT_SPACE_ON_RESOURCE
 *
 * */
var INSUFFICIENT_SPACE_ON_RESOURCE = 419;
/**
 * @deprecated Please use StatusCodes.INSUFFICIENT_STORAGE
 *
 * */
var INSUFFICIENT_STORAGE = 507;
/**
 * @deprecated Please use StatusCodes.INTERNAL_SERVER_ERROR
 *
 * */
var INTERNAL_SERVER_ERROR = 500;
/**
 * @deprecated Please use StatusCodes.LENGTH_REQUIRED
 *
 * */
var LENGTH_REQUIRED = 411;
/**
 * @deprecated Please use StatusCodes.LOCKED
 *
 * */
var LOCKED = 423;
/**
 * @deprecated Please use StatusCodes.METHOD_FAILURE
 *
 * */
var METHOD_FAILURE = 420;
/**
 * @deprecated Please use StatusCodes.METHOD_NOT_ALLOWED
 *
 * */
var METHOD_NOT_ALLOWED = 405;
/**
 * @deprecated Please use StatusCodes.MOVED_PERMANENTLY
 *
 * */
var MOVED_PERMANENTLY = 301;
/**
 * @deprecated Please use StatusCodes.MOVED_TEMPORARILY
 *
 * */
var MOVED_TEMPORARILY = 302;
/**
 * @deprecated Please use StatusCodes.MULTI_STATUS
 *
 * */
var MULTI_STATUS = 207;
/**
 * @deprecated Please use StatusCodes.MULTIPLE_CHOICES
 *
 * */
var MULTIPLE_CHOICES = 300;
/**
 * @deprecated Please use StatusCodes.NETWORK_AUTHENTICATION_REQUIRED
 *
 * */
var NETWORK_AUTHENTICATION_REQUIRED = 511;
/**
 * @deprecated Please use StatusCodes.NO_CONTENT
 *
 * */
var NO_CONTENT = 204;
/**
 * @deprecated Please use StatusCodes.NON_AUTHORITATIVE_INFORMATION
 *
 * */
var NON_AUTHORITATIVE_INFORMATION = 203;
/**
 * @deprecated Please use StatusCodes.NOT_ACCEPTABLE
 *
 * */
var NOT_ACCEPTABLE = 406;
/**
 * @deprecated Please use StatusCodes.NOT_FOUND
 *
 * */
var NOT_FOUND = 404;
/**
 * @deprecated Please use StatusCodes.NOT_IMPLEMENTED
 *
 * */
var NOT_IMPLEMENTED = 501;
/**
 * @deprecated Please use StatusCodes.NOT_MODIFIED
 *
 * */
var NOT_MODIFIED = 304;
/**
 * @deprecated Please use StatusCodes.OK
 *
 * */
var OK = 200;
/**
 * @deprecated Please use StatusCodes.PARTIAL_CONTENT
 *
 * */
var PARTIAL_CONTENT = 206;
/**
 * @deprecated Please use StatusCodes.PAYMENT_REQUIRED
 *
 * */
var PAYMENT_REQUIRED = 402;
/**
 * @deprecated Please use StatusCodes.PERMANENT_REDIRECT
 *
 * */
var PERMANENT_REDIRECT = 308;
/**
 * @deprecated Please use StatusCodes.PRECONDITION_FAILED
 *
 * */
var PRECONDITION_FAILED = 412;
/**
 * @deprecated Please use StatusCodes.PRECONDITION_REQUIRED
 *
 * */
var PRECONDITION_REQUIRED = 428;
/**
 * @deprecated Please use StatusCodes.PROCESSING
 *
 * */
var PROCESSING = 102;
/**
 * @deprecated Please use StatusCodes.PROXY_AUTHENTICATION_REQUIRED
 *
 * */
var PROXY_AUTHENTICATION_REQUIRED = 407;
/**
 * @deprecated Please use StatusCodes.REQUEST_HEADER_FIELDS_TOO_LARGE
 *
 * */
var REQUEST_HEADER_FIELDS_TOO_LARGE = 431;
/**
 * @deprecated Please use StatusCodes.REQUEST_TIMEOUT
 *
 * */
var REQUEST_TIMEOUT = 408;
/**
 * @deprecated Please use StatusCodes.REQUEST_TOO_LONG
 *
 * */
var REQUEST_TOO_LONG = 413;
/**
 * @deprecated Please use StatusCodes.REQUEST_URI_TOO_LONG
 *
 * */
var REQUEST_URI_TOO_LONG = 414;
/**
 * @deprecated Please use StatusCodes.REQUESTED_RANGE_NOT_SATISFIABLE
 *
 * */
var REQUESTED_RANGE_NOT_SATISFIABLE = 416;
/**
 * @deprecated Please use StatusCodes.RESET_CONTENT
 *
 * */
var RESET_CONTENT = 205;
/**
 * @deprecated Please use StatusCodes.SEE_OTHER
 *
 * */
var SEE_OTHER = 303;
/**
 * @deprecated Please use StatusCodes.SERVICE_UNAVAILABLE
 *
 * */
var SERVICE_UNAVAILABLE = 503;
/**
 * @deprecated Please use StatusCodes.SWITCHING_PROTOCOLS
 *
 * */
var SWITCHING_PROTOCOLS = 101;
/**
 * @deprecated Please use StatusCodes.TEMPORARY_REDIRECT
 *
 * */
var TEMPORARY_REDIRECT = 307;
/**
 * @deprecated Please use StatusCodes.TOO_MANY_REQUESTS
 *
 * */
var TOO_MANY_REQUESTS = 429;
/**
 * @deprecated Please use StatusCodes.UNAUTHORIZED
 *
 * */
var UNAUTHORIZED = 401;
/**
 * @deprecated Please use StatusCodes.UNPROCESSABLE_ENTITY
 *
 * */
var UNPROCESSABLE_ENTITY = 422;
/**
 * @deprecated Please use StatusCodes.UNSUPPORTED_MEDIA_TYPE
 *
 * */
var UNSUPPORTED_MEDIA_TYPE = 415;
/**
 * @deprecated Please use StatusCodes.USE_PROXY
 *
 * */
var USE_PROXY = 305;
/* harmony default export */ __webpack_exports__["a"] = ({
    ACCEPTED: ACCEPTED,
    BAD_GATEWAY: BAD_GATEWAY,
    BAD_REQUEST: BAD_REQUEST,
    CONFLICT: CONFLICT,
    CONTINUE: CONTINUE,
    CREATED: CREATED,
    EXPECTATION_FAILED: EXPECTATION_FAILED,
    FORBIDDEN: FORBIDDEN,
    GATEWAY_TIMEOUT: GATEWAY_TIMEOUT,
    GONE: GONE,
    HTTP_VERSION_NOT_SUPPORTED: HTTP_VERSION_NOT_SUPPORTED,
    IM_A_TEAPOT: IM_A_TEAPOT,
    INSUFFICIENT_SPACE_ON_RESOURCE: INSUFFICIENT_SPACE_ON_RESOURCE,
    INSUFFICIENT_STORAGE: INSUFFICIENT_STORAGE,
    INTERNAL_SERVER_ERROR: INTERNAL_SERVER_ERROR,
    LENGTH_REQUIRED: LENGTH_REQUIRED,
    LOCKED: LOCKED,
    METHOD_FAILURE: METHOD_FAILURE,
    METHOD_NOT_ALLOWED: METHOD_NOT_ALLOWED,
    MOVED_PERMANENTLY: MOVED_PERMANENTLY,
    MOVED_TEMPORARILY: MOVED_TEMPORARILY,
    MULTI_STATUS: MULTI_STATUS,
    MULTIPLE_CHOICES: MULTIPLE_CHOICES,
    NETWORK_AUTHENTICATION_REQUIRED: NETWORK_AUTHENTICATION_REQUIRED,
    NO_CONTENT: NO_CONTENT,
    NON_AUTHORITATIVE_INFORMATION: NON_AUTHORITATIVE_INFORMATION,
    NOT_ACCEPTABLE: NOT_ACCEPTABLE,
    NOT_FOUND: NOT_FOUND,
    NOT_IMPLEMENTED: NOT_IMPLEMENTED,
    NOT_MODIFIED: NOT_MODIFIED,
    OK: OK,
    PARTIAL_CONTENT: PARTIAL_CONTENT,
    PAYMENT_REQUIRED: PAYMENT_REQUIRED,
    PERMANENT_REDIRECT: PERMANENT_REDIRECT,
    PRECONDITION_FAILED: PRECONDITION_FAILED,
    PRECONDITION_REQUIRED: PRECONDITION_REQUIRED,
    PROCESSING: PROCESSING,
    PROXY_AUTHENTICATION_REQUIRED: PROXY_AUTHENTICATION_REQUIRED,
    REQUEST_HEADER_FIELDS_TOO_LARGE: REQUEST_HEADER_FIELDS_TOO_LARGE,
    REQUEST_TIMEOUT: REQUEST_TIMEOUT,
    REQUEST_TOO_LONG: REQUEST_TOO_LONG,
    REQUEST_URI_TOO_LONG: REQUEST_URI_TOO_LONG,
    REQUESTED_RANGE_NOT_SATISFIABLE: REQUESTED_RANGE_NOT_SATISFIABLE,
    RESET_CONTENT: RESET_CONTENT,
    SEE_OTHER: SEE_OTHER,
    SERVICE_UNAVAILABLE: SERVICE_UNAVAILABLE,
    SWITCHING_PROTOCOLS: SWITCHING_PROTOCOLS,
    TEMPORARY_REDIRECT: TEMPORARY_REDIRECT,
    TOO_MANY_REQUESTS: TOO_MANY_REQUESTS,
    UNAUTHORIZED: UNAUTHORIZED,
    UNPROCESSABLE_ENTITY: UNPROCESSABLE_ENTITY,
    UNSUPPORTED_MEDIA_TYPE: UNSUPPORTED_MEDIA_TYPE,
    USE_PROXY: USE_PROXY,
});


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getReasonPhrase */
/* harmony export (immutable) */ __webpack_exports__["a"] = getStatusCode;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStatusText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(1053);

/**
 * Returns the reason phrase for the given status code.
 * If the given status code does not exist, an error is thrown.
 *
 * @param {number|string} statusCode The HTTP status code
 * @returns {string} The associated reason phrase (e.g. "Bad Request", "OK")
 * */
function getReasonPhrase(statusCode) {
    var result = __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* statusCodeToReasonPhrase */][statusCode.toString()];
    if (!result) {
        throw new Error("Status code does not exist: " + statusCode);
    }
    return result;
}
/**
 * Returns the status code for the given reason phrase.
 * If the given reason phrase does not exist, undefined is returned.
 *
 * @param {string} reasonPhrase The HTTP reason phrase (e.g. "Bad Request", "OK")
 * @returns {string} The associated status code
 * */
function getStatusCode(reasonPhrase) {
    var result = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* reasonPhraseToStatusCode */][reasonPhrase];
    if (!result) {
        throw new Error("Reason phrase does not exist: " + reasonPhrase);
    }
    return result;
}
/**
 * @deprecated
 *
 * Returns the reason phrase for the given status code.
 * If the given status code does not exist, undefined is returned.
 *
 * Deprecated in favor of getReasonPhrase
 *
 * @param {number|string} statusCode The HTTP status code
 * @returns {string|undefined} The associated reason phrase (e.g. "Bad Request", "OK")
 * */
var getStatusText = getReasonPhrase;


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FILE_INVALID_TYPE */
/* unused harmony export FILE_TOO_LARGE */
/* unused harmony export FILE_TOO_SMALL */
/* unused harmony export TOO_MANY_FILES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorCode; });
/* unused harmony export getInvalidTypeRejectionErr */
/* unused harmony export getTooLargeRejectionErr */
/* unused harmony export getTooSmallRejectionErr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOO_MANY_FILES_REJECTION; });
/* harmony export (immutable) */ __webpack_exports__["f"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["g"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["c"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["k"] = isPropagationStopped;
/* harmony export (immutable) */ __webpack_exports__["i"] = isEvtWithFiles;
/* unused harmony export isKindFile */
/* harmony export (immutable) */ __webpack_exports__["l"] = onDocumentDragOver;
/* harmony export (immutable) */ __webpack_exports__["j"] = isIeOrEdge;
/* harmony export (immutable) */ __webpack_exports__["e"] = composeEventHandlers;
/* harmony export (immutable) */ __webpack_exports__["d"] = canUseFileSystemAccessAPI;
/* harmony export (immutable) */ __webpack_exports__["h"] = filePickerOptionsTypes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

 // Error codes

var FILE_INVALID_TYPE = 'file-invalid-type';
var FILE_TOO_LARGE = 'file-too-large';
var FILE_TOO_SMALL = 'file-too-small';
var TOO_MANY_FILES = 'too-many-files';
var ErrorCode = {
  FileInvalidType: FILE_INVALID_TYPE,
  FileTooLarge: FILE_TOO_LARGE,
  FileTooSmall: FILE_TOO_SMALL,
  TooManyFiles: TOO_MANY_FILES
}; // File Errors

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(', ')) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? 'byte' : 'bytes')
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? 'byte' : 'bytes')
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: 'Too many files'
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    return accepted && sizeMatch;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}
function isKindFile(item) {
  return _typeof(item) === 'object' && item !== null && item.kind === 'file';
} // allow the entire document to be a drag target

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return 'showOpenFilePicker' in window;
}
/**
 * filePickerOptionsTypes returns the {types} option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 * based on the accept attr (see https://github.com/react-dropzone/attr-accept)
 * E.g: converts ['image/*', 'text/*'] to {'image/*': [], 'text/*': []}
 * @param {string|string[]} accept
 */

function filePickerOptionsTypes(accept) {
  accept = typeof accept === 'string' ? accept.split(',') : accept;
  return [{
    description: 'everything',
    // TODO: Need to handle filtering more elegantly than this!
    accept: Array.isArray(accept) // Accept just MIME types as per spec
    // NOTE: accept can be https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers
    ? accept.filter(function (item) {
      return item === 'audio/*' || item === 'video/*' || item === 'image/*' || item === 'text/*' || /\w+\/[-+.\w]+/g.test(item);
    }).reduce(function (a, b) {
      return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, b, []));
    }, {}) : {}
  }];
}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _pagination = _interopRequireDefault(__webpack_require__(1080));

var _default = _pagination["default"];
exports["default"] = _default;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(410);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 456 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(332),
    isFlattenable = __webpack_require__(1083);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(248),
    overRest = __webpack_require__(1084),
    setToString = __webpack_require__(1086);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(125),
    isObjectLike = __webpack_require__(104);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SearchSuggestion", {
  enumerable: true,
  get: function get() {
    return _searchSuggestion["default"];
  }
});
Object.defineProperty(exports, "SearchSuggestionFooter", {
  enumerable: true,
  get: function get() {
    return _searchSuggestionFooter["default"];
  }
});
Object.defineProperty(exports, "SearchSuggestionHeader", {
  enumerable: true,
  get: function get() {
    return _searchSuggestionHeader["default"];
  }
});
exports["default"] = void 0;

var _searchField = _interopRequireDefault(__webpack_require__(1103));

var _searchSuggestion = _interopRequireDefault(__webpack_require__(462));

var _searchSuggestionFooter = _interopRequireDefault(__webpack_require__(463));

var _searchSuggestionHeader = _interopRequireDefault(__webpack_require__(464));

var _default = _searchField["default"];
exports["default"] = _default;

/***/ }),
/* 461 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconSearchData: "data:image/svg+xml,%3csvg width='19' height='19' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M8 2a6 6 0 110 12A6 6 0 018 2zm0-2a8 8 0 100 16A8 8 0 008 0z' fill='currentColor' fill-rule='nonzero'/%3e%3cpath d='M13 13l5 5' stroke='currentColor' stroke-width='2' stroke-linecap='round'/%3e%3c/g%3e%3c/svg%3e",
  iconSearchWidth: 19,
  iconSearchHeight: 19
};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This can be passed as a child to the `SearchField` component to render a
 * selectable search suggestion in a popover below that component.
 */
var SearchSuggestion = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SearchSuggestion, _React$Component);

  var _super = _createSuper(SearchSuggestion);

  function SearchSuggestion() {
    (0, _classCallCheck2["default"])(this, SearchSuggestion);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SearchSuggestion, [{
    key: "render",
    value: function render() {
      // Actual rendering is done via the internal `OptionListItem` component. See
      // ./search-suggestion-popover.js for the implementation.
      return null;
    }
  }]);
  return SearchSuggestion;
}(_react["default"].Component);

SearchSuggestion.propTypes =  false ? {
  /**
   * The contents of the suggestion.
   *
   * If this is a plain string then matching substrings will automatically be
   * highlighted based on the value of the search field.
   *
   * If this is a function then it will receive an object containing the
   * following keys:
   * - `suggestion` - the value of the `suggestion` prop
   * - `query` - the current value of the search field
   * - `highlighted` - a boolean indicating whether or not the suggestion should
   *   be shown in a highlighted state (this will be true if the user focuses
   *   on the suggestion or if they select it).
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]).isRequired,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * A unique value representing the current suggestion.
   */
  suggestion: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This is called when the user selects the suggestion. The value of the
   * `suggestion` prop is passed as the only argument to this function.
   */
  onClick: _propTypes["default"].func
} : {};
var _default = SearchSuggestion;
exports["default"] = _default;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Pass this as a child to the `SearchField` component to render a footer below
 * the suggestions in the search suggestion popover.
 *
 * Use this to add any contextual information or actions to the suggestions
 * (e.g. an "X results" label or a "More suggestions" link).
 */
var SearchSuggestionFooter = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SearchSuggestionFooter, _React$Component);

  var _super = _createSuper(SearchSuggestionFooter);

  function SearchSuggestionFooter() {
    (0, _classCallCheck2["default"])(this, SearchSuggestionFooter);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SearchSuggestionFooter, [{
    key: "render",
    value: function render() {
      // Actual rendering is done in ./search-suggestion-popover.js
      return this.props.children;
    }
  }]);
  return SearchSuggestionFooter;
}(_react["default"].Component);

SearchSuggestionFooter.propTypes =  false ? {
  /**
   * The elements to show in the footer. Plain text and links recommended.
   */
  children: _propTypes["default"].node.isRequired
} : {};
var _default = SearchSuggestionFooter;
exports["default"] = _default;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Pass this as a child to the `SearchField` component to render a header above
 * the suggestions in the search suggestion popover.
 *
 * Use this to label a list of search suggestions.
 */
var SearchSuggestionHeader = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SearchSuggestionHeader, _React$Component);

  var _super = _createSuper(SearchSuggestionHeader);

  function SearchSuggestionHeader() {
    (0, _classCallCheck2["default"])(this, SearchSuggestionHeader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SearchSuggestionHeader, [{
    key: "render",
    value: function render() {
      // Actual rendering is done in ./search-suggestion-popover.js
      return null;
    }
  }]);
  return SearchSuggestionHeader;
}(_react["default"].Component);

SearchSuggestionHeader.propTypes =  false ? {
  /**
   * The label to show in the header.
   */
  children: _propTypes["default"].string.isRequired
} : {};
var _default = SearchSuggestionHeader;
exports["default"] = _default;

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogStoreAction; });
var LogStoreAction={FILTER_LOGS:"FILTER_LOGS",SET_MAX_MSG_COUNT:"SET_MAX_MSG_COUNT",ADD_LOG:"ADD_LOG",ROLLUP_LOG:"ROLLUP_LOG",CLEAR_LOGS:"CLEAR_LOGS",CLEAR_FILTERING:"CLEAR_FILTERING"};

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aws_iot_device_sdk__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aws_iot_device_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aws_iot_device_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__permissions_MQTTPermissionsContext__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constants__ = __webpack_require__(2);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var MQTTUtility=function MQTTUtility(props){var config=props.config,topic=props.topic,onMessage=props.onMessage,setError=props.setError,setIsSubscribing=props.setIsSubscribing;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__permissions_MQTTPermissionsContext__["a" /* MQTTPermissionsContext */]),refreshConnectionDetails=_useContext.refreshConnectionDetails;var _useState=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),connecting=_useState2[0],setConnecting=_useState2[1];var retryCount=0;var mqttClient=null;var connectToMQTT=function connectToMQTT(){refreshConnectionDetails().then(function(data){config.accessKeyId=data.loginId;config.secretKey=data.loginKey;config.sessionToken=data.sessionToken;setConnecting(true);if(!connecting){mqttClient=__WEBPACK_IMPORTED_MODULE_3_aws_iot_device_sdk___default.a.device(config);mqttClient.on('error',function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(error){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.error("Error occurred in MQTT connection : ",error);disconnectToMQTT();handleConnectionError();case 3:case"end":return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}());mqttClient.on('connect',function(){console.log("Connected to AWS IoT Client.",mqttClient);retryCount=0;if(mqttClient){mqttClient.subscribe(topic);}setError(false);setConnecting(false);});mqttClient.on('message',function(topic,message){if(mqttClient){onMessage(message);}});mqttClient.on('reconnect',_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(++retryCount>__WEBPACK_IMPORTED_MODULE_5__Constants__["_118" /* MAX_RECONNECT */]){console.error("Maximum attempts to connect to MQTT client reached, suspending re-connection.");disconnectToMQTT();handleConnectionError();}case 1:case"end":return _context2.stop();}}},_callee2,_this);})));}}).catch(function(error){console.error("Error connecting to MQTT client with config : ",config,error);disconnectToMQTT();handleConnectionError();});};var disconnectToMQTT=function disconnectToMQTT(){if(mqttClient){console.log("Disconnecting to AWS IoT Client");mqttClient.unsubscribe(topic);mqttClient.end();mqttClient=null;}};var handleConnectionError=function handleConnectionError(){setError(true);setIsSubscribing(false);};Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function(){connectToMQTT();return function(){disconnectToMQTT();};},[topic]);return true;};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(MQTTUtility));

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps
const events = __webpack_require__(84);
const inherits = __webpack_require__(222).inherits;

//npm deps
const mqtt = __webpack_require__(1114);
const crypto = __webpack_require__(1145);

//app deps
const exceptions = __webpack_require__(1169),
   isUndefined = __webpack_require__(297),
   tlsReader = __webpack_require__(1170);

//begin module
function makeTwoDigits(n) {
   if (n > 9) {
      return n;
   } else {
      return '0' + n;
   }
}

function getDateTimeString() {
   var d = new Date();

   //
   // The additional ''s are used to force JavaScript to interpret the
   // '+' operator as string concatenation rather than arithmetic.
   //
   return d.getUTCFullYear() + '' +
      makeTwoDigits(d.getUTCMonth() + 1) + '' +
      makeTwoDigits(d.getUTCDate()) + 'T' + '' +
      makeTwoDigits(d.getUTCHours()) + '' +
      makeTwoDigits(d.getUTCMinutes()) + '' +
      makeTwoDigits(d.getUTCSeconds()) + 'Z';
}

function getDateString(dateTimeString) {
   return dateTimeString.substring(0, dateTimeString.indexOf('T'));
}

function getSignatureKey(key, dateStamp, regionName, serviceName) {
   var kDate = crypto.HmacSHA256(dateStamp, 'AWS4' + key, {
      asBytes: true
   });
   var kRegion = crypto.HmacSHA256(regionName, kDate, {
      asBytes: true
   });
   var kService = crypto.HmacSHA256(serviceName, kRegion, {
      asBytes: true
   });
   var kSigning = crypto.HmacSHA256('aws4_request', kService, {
      asBytes: true
   });
   return kSigning;
}

function signUrl(method, scheme, hostname, path, queryParams, accessId, secretKey,
   region, serviceName, payload, today, now, debug, awsSTSToken) {

   var signedHeaders = 'host';

   var canonicalHeaders = 'host:' + hostname.toLowerCase() + '\n';

   var canonicalRequest = method + '\n' + // method
      path + '\n' + // path
      queryParams + '\n' + // query params
      canonicalHeaders + // headers
      '\n' + // required
      signedHeaders + '\n' + // signed header list
      crypto.SHA256(payload, {
         asBytes: true
      }); // hash of payload (empty string)

   if (debug === true) {
      console.log('canonical request: ' + canonicalRequest + '\n');
   }

   var hashedCanonicalRequest = crypto.SHA256(canonicalRequest, {
      asBytes: true
   });

   if (debug === true) {
      console.log('hashed canonical request: ' + hashedCanonicalRequest + '\n');
   }

   var stringToSign = 'AWS4-HMAC-SHA256\n' +
      now + '\n' +
      today + '/' + region + '/' + serviceName + '/aws4_request\n' +
      hashedCanonicalRequest;

   if (debug === true) {
      console.log('string to sign: ' + stringToSign + '\n');
   }

   var signingKey = getSignatureKey(secretKey, today, region, serviceName);

   if (debug === true) {
      console.log('signing key: ' + signingKey + '\n');
   }

   var signature = crypto.HmacSHA256(stringToSign, signingKey, {
      asBytes: true
   });

   if (debug === true) {
      console.log('signature: ' + signature + '\n');
   }

   var finalParams = queryParams + '&X-Amz-Signature=' + signature;

   if (!isUndefined(awsSTSToken)) {
      finalParams += '&X-Amz-Security-Token=' + encodeURIComponent(awsSTSToken);
   }

   var url = scheme + hostname + path + '?' + finalParams;

   if (debug === true) {
      console.log('url: ' + url + '\n');
   }

   return url;
}

function prepareWebSocketUrl(options, awsAccessId, awsSecretKey, awsSTSToken) {
   var now = getDateTimeString();
   var today = getDateString(now);
   var path = '/mqtt';
   var awsServiceName = 'iotdata';
   var queryParams = 'X-Amz-Algorithm=AWS4-HMAC-SHA256' +
      '&X-Amz-Credential=' + awsAccessId + '%2F' + today + '%2F' + options.region + '%2F' + awsServiceName + '%2Faws4_request' +
      '&X-Amz-Date=' + now +
      '&X-Amz-SignedHeaders=host';
   var hostName = options.host;

   // Include the port number in the hostname if it's not 
   // the standard wss port (443).
   //
   if (!isUndefined(options.port) && options.port !== 443) {
      hostName = options.host + ':' + options.port;
   }
   return signUrl('GET', 'wss://', hostName, path, queryParams,
      awsAccessId, awsSecretKey, options.region, awsServiceName, '', today, now, options.debug, awsSTSToken);
}
//
// This method is the exposed module; it validates the mqtt options,
// creates a secure mqtt connection via TLS, and returns the mqtt
// connection instance.
//
function DeviceClient(options) {
   //
   // Force instantiation using the 'new' operator; this will cause inherited
   // constructors (e.g. the 'events' class) to be called.
   //
   if (!(this instanceof DeviceClient)) {
      return new DeviceClient(options);
   }
   //
   // A copy of 'this' for use inside of closures
   //
   var that = this;

   //
   // Offline Operation
   //
   // The connection to AWS IoT can be in one of three states:
   //
   //   1) Inactive
   //   2) Established
   //   3) Stable
   //
   // During state 1), publish operations are placed in a queue
   // ("filling")
   //
   // During states 2) and 3), any operations present in the queue
   // are sent to the mqtt client for completion ("draining").
   //
   // In all states, subscriptions are tracked in a cache
   //
   // A "draining interval" is used to specify the rate at which
   // which operations are drained from the queue.
   //
   //    +- - - - - - - - - - - - - - - - - - - - - - - - +
   //    |                                                |
   //                                                      
   //    |                    FILLING                     |         
   //                                                      
   //    |                                                |
   //              +-----------------------------+         
   //    |         |                             |        |
   //              |                             |         
   //    |         v                             |        |
   //    +- - Established                     Inactive - -+
   //    |         |                             ^        |
   //              |                             |         
   //    |         |                             |        |
   //              +----------> Stable ----------+        
   //    |                                                |
   //                                                      
   //    |                     DRAINING                   |         
   //                                                      
   //    |                                                |
   //    +- - - - - - - - - - - - - - - - - - - - - - - - +
   //
   //
   // Draining Operation
   //
   // During draining, existing subscriptions are re-sent,
   // followed by any publishes which occurred while offline.
   //    

   //
   // Publish cache used during filling
   //
   var offlinePublishQueue = [];
   var offlineQueueing = true;
   var offlineQueueMaxSize = 0;
   var offlineQueueDropBehavior = 'oldest'; // oldest or newest
   offlinePublishQueue.length = 0;

   //
   // Subscription queue for subscribe/unsubscribe requests received when offline
   // We do not want an unbounded queue so for now limit to current max subs in AWS IoT
   //
   var offlineSubscriptionQueue = [];
   var offlineSubscriptionQueueMaxSize = 50;
   offlineSubscriptionQueue.length = 0;

   //
   // Subscription cache; active if autoResubscribe === true
   //
   var activeSubscriptions = [];
   var autoResubscribe = true;
   activeSubscriptions.length = 0;

   //
   // Cloned subscription cache; active during initial draining.
   //
   var clonedSubscriptions = [];
   clonedSubscriptions.length = 0;

   //
   // Contains the operational state of the connection
   //
   var connectionState = 'inactive';

   //
   // Used to time draining operations; active during draining.
   //
   var drainingTimer = null;
   var drainTimeMs = 250;

   //
   // These properties control the reconnect behavior of the MQTT Client.  If 
   // the MQTT client becomes disconnected, it will attempt to reconnect after 
   // a quiet period; this quiet period doubles with each reconnection attempt,
   // e.g. 1 seconds, 2 seconds, 2, 8, 16, 32, etc... up until a maximum 
   // reconnection time is reached.
   //
   // If a connection is active for the minimum connection time, the quiet 
   // period is reset to the initial value.
   //
   // baseReconnectTime: the time in seconds to wait before the first 
   //     reconnect attempt
   //
   // minimumConnectionTime: the time in seconds that a connection must be 
   //     active before resetting the current reconnection time to the base 
   //     reconnection time
   //
   // maximumReconnectTime: the maximum time in seconds to wait between 
   //     reconnect attempts
   //
   // The defaults for these values are:
   //
   // baseReconnectTime: 1 seconds
   // minimumConnectionTime: 20 seconds
   // maximumReconnectTime: 128 seconds
   //
   var baseReconnectTimeMs = 1000;
   var minimumConnectionTimeMs = 20000;
   var maximumReconnectTimeMs = 128000;
   var currentReconnectTimeMs;

   //
   // Used to measure the length of time the connection has been active to
   // know if it's stable or not.  Active beginning from receipt of a 'connect'
   // event (e.g. received CONNACK) until 'minimumConnectionTimeMs' has elapsed.
   //
   var connectionTimer = null;

   //
   // Credentials when authenticating via WebSocket/SigV4
   //
   var awsAccessId;
   var awsSecretKey;
   var awsSTSToken;

   //
   // Validate options, set default reconnect period if not specified.
   //
   if (isUndefined(options) ||
      Object.keys(options).length === 0) {
      throw new Error(exceptions.INVALID_CONNECT_OPTIONS);
   }
   if (!isUndefined(options.baseReconnectTimeMs)) {
      baseReconnectTimeMs = options.baseReconnectTimeMs;
   }
   if (!isUndefined(options.minimumConnectionTimeMs)) {
      minimumConnectionTimeMs = options.minimumConnectionTimeMs;
   }
   if (!isUndefined(options.maximumReconnectTimeMs)) {
      maximumReconnectTimeMs = options.maximumReconnectTimeMs;
   }
   if (!isUndefined(options.drainTimeMs)) {
      drainTimeMs = options.drainTimeMs;
   }
   if (!isUndefined(options.autoResubscribe)) {
      autoResubscribe = options.autoResubscribe;
   }
   if (!isUndefined(options.offlineQueueing)) {
      offlineQueueing = options.offlineQueueing;
   }
   if (!isUndefined(options.offlineQueueMaxSize)) {
      offlineQueueMaxSize = options.offlineQueueMaxSize;
   }
   if (!isUndefined(options.offlineQueueDropBehavior)) {
      offlineQueueDropBehavior = options.offlineQueueDropBehavior;
   }
   currentReconnectTimeMs = baseReconnectTimeMs;
   options.reconnectPeriod = currentReconnectTimeMs;
   options.fastDisconnectDetection = true;

   //
   // Verify that the reconnection timing parameters make sense.
   //
   if (options.baseReconnectTimeMs <= 0) {
      throw new Error(exceptions.INVALID_RECONNECT_TIMING);
   }
   if (maximumReconnectTimeMs < baseReconnectTimeMs) {
      throw new Error(exceptions.INVALID_RECONNECT_TIMING);
   }
   if (minimumConnectionTimeMs < baseReconnectTimeMs) {
      throw new Error(exceptions.INVALID_RECONNECT_TIMING);
   }
   //
   // Verify that the other optional parameters make sense.
   //
   if (offlineQueueDropBehavior !== 'newest' &&
      offlineQueueDropBehavior !== 'oldest') {
      throw new Error(exceptions.INVALID_OFFLINE_QUEUEING_PARAMETERS);
   }
   if (offlineQueueMaxSize < 0) {
      throw new Error(exceptions.INVALID_OFFLINE_QUEUEING_PARAMETERS);
   }

   // set protocol, do not override existing definitions if available
   if (isUndefined(options.protocol)) {
      options.protocol = 'mqtts';
   }

   if (isUndefined(options.host)) {
      if (!(isUndefined(options.region))) {
         options.host = 'data.iot.' + options.region + '.amazonaws.com';
      } else {
         throw new Error(exceptions.INVALID_CONNECT_OPTIONS);
      }
   }

   if (options.protocol === 'mqtts') {
      // set port, do not override existing definitions if available
      if (isUndefined(options.port)) {
         options.port = 8883;
      }

      //read and map certificates
      tlsReader(options);
   } else if (options.protocol === 'wss') {
      //
      // AWS access id and secret key must be available as either
      // options or in the environment.
      //
      if (!isUndefined(options.accessKeyId)) {
         awsAccessId = options.accessKeyId;
      } else {
         awsAccessId = Object({"NODE_ENV":"production","PUBLIC_URL":""}).AWS_ACCESS_KEY_ID;
      }
      if (!isUndefined(options.secretKey)) {
         awsSecretKey = options.secretKey;
      } else {
         awsSecretKey = Object({"NODE_ENV":"production","PUBLIC_URL":""}).AWS_SECRET_ACCESS_KEY;
      }
      if (!isUndefined(options.sessionToken)) {
         awsSTSToken = options.sessionToken;
      } else {
         awsSTSToken = Object({"NODE_ENV":"production","PUBLIC_URL":""}).AWS_SESSION_TOKEN;
      }
      // AWS region must be defined when connecting via WebSocket/SigV4
      if (isUndefined(options.region)) {
         console.log('AWS region must be defined when connecting via WebSocket/SigV4; see README.md');
         throw new Error(exceptions.INVALID_CONNECT_OPTIONS);
      }
      // AWS Access Key ID and AWS Secret Key must be defined
      if (isUndefined(awsAccessId) || (isUndefined(awsSecretKey))) {
         console.log('To connect via WebSocket/SigV4, AWS Access Key ID and AWS Secret Key must be passed either in options or as environment variables; see README.md');
         throw new Error(exceptions.INVALID_CONNECT_OPTIONS);
      }
      // set port, do not override existing definitions if available
      if (isUndefined(options.port)) {
         options.port = 443;
      }
      // check websocketOptions and ensure that the protocol is defined
      if (isUndefined(options.websocketOptions)) {
         options.websocketOptions = {
            protocol: 'mqttv3.1'
         };
      } else {
         options.websocketOptions.protocol = 'mqttv3.1';
      }
   }

   if ((!isUndefined(options)) && (options.debug === true)) {
      console.log(options);
      console.log('attempting new mqtt connection...');
   }
   //connect and return the client instance to map all mqttjs apis

   var protocols = {};
   protocols.mqtts = __webpack_require__(1172);
   protocols.wss = __webpack_require__(1173);

   function _addToSubscriptionCache(topic, options) {
      var matches = activeSubscriptions.filter(function(element) {
         return element.topic === topic;
      });
      //
      // Add the element only if it doesn't already exist.
      //
      if (matches.length === 0) {
         activeSubscriptions.push({
            topic: topic,
            options: options
         });
      }
   }

   function _deleteFromSubscriptionCache(topic, options) {
      var remaining = activeSubscriptions.filter(function(element) {
         return element.topic !== topic;
      });
      activeSubscriptions = remaining;
   }

   function _updateSubscriptionCache(operation, topics, options) {
      var opFunc = null;

      //
      // Don't cache subscriptions if auto-resubscribe is disabled
      // 
      if (autoResubscribe === false) {
         return;
      }
      if (operation === 'subscribe') {
         opFunc = _addToSubscriptionCache;
      } else if (operation === 'unsubscribe') {
         opFunc = _deleteFromSubscriptionCache;
      }
      //
      // Test to see if 'topics' is an array and if so, iterate.
      //
      if (Object.prototype.toString.call(topics) === '[object Array]') {
         topics.forEach(function(item, index, array) {
            opFunc(item, options);
         });
      } else {
         opFunc(topics, options);
      }
   }

   //
   // Return true if the connection is currently in a 'filling' 
   // state
   //
   function _filling() {
      return connectionState === 'inactive';
   }

   function _wrapper(client) {
      if (options.protocol === 'wss') {
         var url;
         //
         // If the access id and secret key are available, prepare the URL. 
         // Otherwise, set the url to an invalid value.
         //
         if (awsAccessId === '' || awsSecretKey === '') {
            url = 'wss://no-credentials-available';
         } else {
            url = prepareWebSocketUrl(options, awsAccessId, awsSecretKey, awsSTSToken);
         }

         if (options.debug === true) {
            console.log('using websockets, will connect to \'' + url + '\'...');
         }

         options.url = url;
      }
      return protocols[options.protocol](client, options);
   }

   const device = new mqtt.MqttClient(_wrapper, options);

   //handle events from the mqtt client

   //
   // Timeout expiry function for the connection timer; once a connection
   // is stable, reset the current reconnection time to the base value. 
   //
   function _markConnectionStable() {
      currentReconnectTimeMs = baseReconnectTimeMs;
      device.options.reconnectPeriod = currentReconnectTimeMs;
      //
      // Mark this timeout as expired
      //
      connectionTimer = null;
      connectionState = 'stable';
   }
   //
   // Trim the offline queue if required; returns true if another
   // element can be placed in the queue
   //
   function _trimOfflinePublishQueueIfNecessary() {
      var rc = true;

      if ((offlineQueueMaxSize > 0) &&
         (offlinePublishQueue.length >= offlineQueueMaxSize)) {
         //
         // The queue has reached its maximum size, trim it
         // according to the defined drop behavior.
         //
         if (offlineQueueDropBehavior === 'oldest') {
            offlinePublishQueue.shift();
         } else {
            rc = false;
         }
      }
      return rc;
   }

   //
   // Timeout expiry function for the drain timer; once a connection
   // has been established, begin draining cached transactions.
   //
   function _drainOperationQueue() {

      //
      // Handle our active subscriptions first, using a cloned
      // copy of the array.  We shift them out one-by-one until
      // all have been processed, leaving the official record
      // of active subscriptions untouched.
      // 
      var subscription = clonedSubscriptions.shift();

      if (!isUndefined(subscription)) {
         //
         // If the 3rd argument (namely callback) is not present, we will
         // use two-argument form to call mqtt.Client#subscribe(), which
         // supports both subscribe(topics, options) and subscribe(topics, callback).
         //
         if (!isUndefined(subscription.callback)) {
            device.subscribe(subscription.topic, subscription.options, subscription.callback);
         } else {
            device.subscribe(subscription.topic, subscription.options);
         }
      } else {
         //
         // If no remaining active subscriptions to process,
         // then handle subscription requests queued while offline.
         //
         var req = offlineSubscriptionQueue.shift();

         if (!isUndefined(req)) {
            _updateSubscriptionCache(req.type, req.topics, req.options);
            if (req.type === 'subscribe') {
               if (!isUndefined(req.callback)) {
                  device.subscribe(req.topics, req.options, req.callback);
               } else {
                  device.subscribe(req.topics, req.options);
               }
            } else if (req.type === 'unsubscribe') {
               device.unsubscribe(req.topics, req.callback);
            }
         } else {
            //
            // If no active or queued subscriptions remaining to process,
            // then handle queued publish operations.
            //
            var offlinePublishMessage = offlinePublishQueue.shift();

            if (!isUndefined(offlinePublishMessage)) {
               device.publish(offlinePublishMessage.topic,
                  offlinePublishMessage.message,
                  offlinePublishMessage.options,
                  offlinePublishMessage.callback);
            }
            if (offlinePublishQueue.length === 0) {
               //
               // The subscription and offlinePublishQueue queues are fully drained,
               // cancel the draining timer.
               //
               clearInterval(drainingTimer);
               drainingTimer = null;
            }
         }
      }
   }
   //
   // Event handling - *all* events generated by the mqtt.js client must be
   // handled here, *and* propagated upwards.
   //

   device.on('connect', function() {
      //
      // If not already running, start the connection timer.
      //
      if (connectionTimer === null) {
         connectionTimer = setTimeout(_markConnectionStable,
            minimumConnectionTimeMs);
      }
      connectionState = 'established';
      //
      // If not already running, start the draining timer and 
      // clone the active subscriptions.
      //
      if (drainingTimer === null) {
         clonedSubscriptions = activeSubscriptions.slice(0);
         drainingTimer = setInterval(_drainOperationQueue,
            drainTimeMs);
      }
      that.emit('connect');
   });
   device.on('close', function() {
      if ((!isUndefined(options)) && (options.debug === true)) {
         console.log('connection lost - will attempt reconnection in ' +
            device.options.reconnectPeriod / 1000 + ' seconds...');
      }
      //
      // Clear the connection and drain timers
      //
      clearTimeout(connectionTimer);
      connectionTimer = null;
      clearInterval(drainingTimer);
      drainingTimer = null;

      //
      // Mark the connection state as inactive
      //
      connectionState = 'inactive';

      that.emit('close');
   });
   device.on('reconnect', function() {
      //
      // Update the current reconnect timeout; this will be the
      // next timeout value used if this connect attempt fails.
      // 
      currentReconnectTimeMs = currentReconnectTimeMs * 2;
      currentReconnectTimeMs = Math.min(maximumReconnectTimeMs, currentReconnectTimeMs);
      device.options.reconnectPeriod = currentReconnectTimeMs;

      that.emit('reconnect');
   });
   device.on('offline', function() {
      that.emit('offline');
   });
   device.on('error', function(error) {
      that.emit('error', error);
   });
   device.on('message', function(topic, message, packet) {
      that.emit('message', topic, message, packet);
   });

   //
   // The signatures of these methods *must* match those of the mqtt.js
   // client.
   //
   this.publish = function(topic, message, options, callback) {
      //
      // If filling or still draining, push this publish operation 
      // into the offline operations queue; otherwise, perform it
      // immediately.
      //
      if (offlineQueueing === true && (_filling() || drainingTimer !== null)) {
         if (_trimOfflinePublishQueueIfNecessary()) {
            offlinePublishQueue.push({
               topic: topic,
               message: message,
               options: options,
               callback: callback
            });
         }
      } else {
         if (offlineQueueing === true || !_filling()) {
            device.publish(topic, message, options, callback);
         }
      }
   };
   this.subscribe = function(topics, options, callback) {
      if (!_filling() || autoResubscribe === false) {
         _updateSubscriptionCache('subscribe', topics, options); // we do not store callback in active cache
         //
         // If the 3rd argument (namely callback) is not present, we will
         // use two-argument form to call mqtt.Client#subscribe(), which
         // supports both subscribe(topics, options) and subscribe(topics, callback).
         //
         if (!isUndefined(callback)) {
            device.subscribe(topics, options, callback);
         } else {
            device.subscribe(topics, options);
         }
      } else {
         // we're offline - queue this subscription request
         if (offlineSubscriptionQueue.length < offlineSubscriptionQueueMaxSize) {
            offlineSubscriptionQueue.push({
               type: 'subscribe',
               topics: topics,
               options: options,
               callback: callback
            });
         } else {
            that.emit('error', new Error('Maximum queued offline subscription reached'));
         }
      }
   };
   this.unsubscribe = function(topics, callback) {
      if (!_filling() || autoResubscribe === false) {
         _updateSubscriptionCache('unsubscribe', topics);
         device.unsubscribe(topics, callback);
      } else {
         // we're offline - queue this unsubscribe request
         if (offlineSubscriptionQueue.length < offlineSubscriptionQueueMaxSize) {
            offlineSubscriptionQueue.push({
               type: 'unsubscribe',
               topics: topics,
               options: options,
               callback: callback
            });
         }
      }
   };
   this.end = function(force, callback) {
      device.end(force, callback);
   };
   this.handleMessage = function(packet, callback) {
      device.handleMessage(packet, callback);
   };
   //
   // Call this function to update the credentials used when
   // connecting via WebSocket/SigV4.
   //
   this.updateWebSocketCredentials = function(accessKeyId, secretKey, sessionToken, expiration) {
      awsAccessId = accessKeyId;
      awsSecretKey = secretKey;
      awsSTSToken = sessionToken;
   };
   //
   // Used for integration testing only
   //
   this.simulateNetworkFailure = function() {
      device.stream.emit('error', new Error('simulated connection error'));
      device.stream.end();
   };
}

//
// Allow instances to listen in on events that we produce for them
//
inherits(DeviceClient, events.EventEmitter);

module.exports = DeviceClient;
module.exports.DeviceClient = DeviceClient;

//
// Exported for unit testing only
//
module.exports.prepareWebSocketUrl = prepareWebSocketUrl;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var Stream = __webpack_require__(85); // hack to fix a circular dependency issue when used with browserify
exports = module.exports = __webpack_require__(469);
exports.Stream = Stream;
exports.Readable = exports;
exports.Writable = __webpack_require__(470);
exports.Duplex = __webpack_require__(293);
exports.Transform = __webpack_require__(471);
exports.PassThrough = __webpack_require__(1118);
if (!process.browser && Object({"NODE_ENV":"production","PUBLIC_URL":""}).READABLE_STREAM === 'disable') {
  module.exports = __webpack_require__(85);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(1117);
/*</replacement>*/


/*<replacement>*/
var Buffer = __webpack_require__(19).Buffer;
/*</replacement>*/

Readable.ReadableState = ReadableState;

var EE = __webpack_require__(84).EventEmitter;

/*<replacement>*/
if (!EE.listenerCount) EE.listenerCount = function(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

var Stream = __webpack_require__(85);

/*<replacement>*/
var util = __webpack_require__(87);
util.inherits = __webpack_require__(79);
/*</replacement>*/

var StringDecoder;

util.inherits(Readable, Stream);

function ReadableState(options, stream) {
  options = options || {};

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  this.highWaterMark = (hwm || hwm === 0) ? hwm : 16 * 1024;

  // cast to ints.
  this.highWaterMark = ~~this.highWaterMark;

  this.buffer = [];
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = false;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // In streams that never have any data, and do push(null) right away,
  // the consumer can miss the 'end' event if they do some I/O before
  // consuming the stream.  So, we don't emit('end') until some reading
  // happens.
  this.calledRead = false;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, becuase any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;


  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // when piping, we only care about 'readable' events that happen
  // after read()ing all the bytes and not getting any pushback.
  this.ranOut = false;

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder)
      StringDecoder = __webpack_require__(111).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  if (!(this instanceof Readable))
    return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  Stream.call(this);
}

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
  var state = this._readableState;

  if (typeof chunk === 'string' && !state.objectMode) {
    encoding = encoding || state.defaultEncoding;
    if (encoding !== state.encoding) {
      chunk = new Buffer(chunk, encoding);
      encoding = '';
    }
  }

  return readableAddChunk(this, state, chunk, encoding, false);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
  var state = this._readableState;
  return readableAddChunk(this, state, chunk, '', true);
};

function readableAddChunk(stream, state, chunk, encoding, addToFront) {
  var er = chunkInvalid(state, chunk);
  if (er) {
    stream.emit('error', er);
  } else if (chunk === null || chunk === undefined) {
    state.reading = false;
    if (!state.ended)
      onEofChunk(stream, state);
  } else if (state.objectMode || chunk && chunk.length > 0) {
    if (state.ended && !addToFront) {
      var e = new Error('stream.push() after EOF');
      stream.emit('error', e);
    } else if (state.endEmitted && addToFront) {
      var e = new Error('stream.unshift() after end event');
      stream.emit('error', e);
    } else {
      if (state.decoder && !addToFront && !encoding)
        chunk = state.decoder.write(chunk);

      // update the buffer info.
      state.length += state.objectMode ? 1 : chunk.length;
      if (addToFront) {
        state.buffer.unshift(chunk);
      } else {
        state.reading = false;
        state.buffer.push(chunk);
      }

      if (state.needReadable)
        emitReadable(stream);

      maybeReadMore(stream, state);
    }
  } else if (!addToFront) {
    state.reading = false;
  }

  return needMoreData(state);
}



// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended &&
         (state.needReadable ||
          state.length < state.highWaterMark ||
          state.length === 0);
}

// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
  if (!StringDecoder)
    StringDecoder = __webpack_require__(111).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
};

// Don't raise the hwm > 128MB
var MAX_HWM = 0x800000;
function roundUpToNextPowerOf2(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2
    n--;
    for (var p = 1; p < 32; p <<= 1) n |= n >> p;
    n++;
  }
  return n;
}

function howMuchToRead(n, state) {
  if (state.length === 0 && state.ended)
    return 0;

  if (state.objectMode)
    return n === 0 ? 0 : 1;

  if (n === null || isNaN(n)) {
    // only flow one buffer at a time
    if (state.flowing && state.buffer.length)
      return state.buffer[0].length;
    else
      return state.length;
  }

  if (n <= 0)
    return 0;

  // If we're asking for more than the target buffer level,
  // then raise the water mark.  Bump up to the next highest
  // power of 2, to prevent increasing it excessively in tiny
  // amounts.
  if (n > state.highWaterMark)
    state.highWaterMark = roundUpToNextPowerOf2(n);

  // don't have that much.  return null, unless we've ended.
  if (n > state.length) {
    if (!state.ended) {
      state.needReadable = true;
      return 0;
    } else
      return state.length;
  }

  return n;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
  var state = this._readableState;
  state.calledRead = true;
  var nOrig = n;
  var ret;

  if (typeof n !== 'number' || n > 0)
    state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 &&
      state.needReadable &&
      (state.length >= state.highWaterMark || state.ended)) {
    emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    ret = null;

    // In cases where the decoder did not receive enough data
    // to produce a full chunk, then immediately received an
    // EOF, state.buffer will contain [<Buffer >, <Buffer 00 ...>].
    // howMuchToRead will see this and coerce the amount to
    // read to zero (because it's looking at the length of the
    // first <Buffer > in state.buffer), and we'll end up here.
    //
    // This can only happen via state.decoder -- no other venue
    // exists for pushing a zero-length chunk into state.buffer
    // and triggering this behavior. In this case, we return our
    // remaining data and end the stream, if appropriate.
    if (state.length > 0 && state.decoder) {
      ret = fromList(n, state);
      state.length -= ret.length;
    }

    if (state.length === 0)
      endReadable(this);

    return ret;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;

  // if we currently have less than the highWaterMark, then also read some
  if (state.length - n <= state.highWaterMark)
    doRead = true;

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading)
    doRead = false;

  if (doRead) {
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0)
      state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
  }

  // If _read called its callback synchronously, then `reading`
  // will be false, and we need to re-evaluate how much data we
  // can return to the user.
  if (doRead && !state.reading)
    n = howMuchToRead(nOrig, state);

  if (n > 0)
    ret = fromList(n, state);
  else
    ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  }

  state.length -= n;

  // If we have nothing in the buffer, then we want to know
  // as soon as we *do* get something into the buffer.
  if (state.length === 0 && !state.ended)
    state.needReadable = true;

  // If we happened to read() exactly the remaining amount in the
  // buffer, and the EOF has been seen at this point, then make sure
  // that we emit 'end' on the very next tick.
  if (state.ended && !state.endEmitted && state.length === 0)
    endReadable(this);

  return ret;
};

function chunkInvalid(state, chunk) {
  var er = null;
  if (!Buffer.isBuffer(chunk) &&
      'string' !== typeof chunk &&
      chunk !== null &&
      chunk !== undefined &&
      !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}


function onEofChunk(stream, state) {
  if (state.decoder && !state.ended) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // if we've ended and we have some data left, then emit
  // 'readable' now to make sure it gets picked up.
  if (state.length > 0)
    emitReadable(stream);
  else
    endReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (state.emittedReadable)
    return;

  state.emittedReadable = true;
  if (state.sync)
    process.nextTick(function() {
      emitReadable_(stream);
    });
  else
    emitReadable_(stream);
}

function emitReadable_(stream) {
  stream.emit('readable');
}


// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(function() {
      maybeReadMore_(stream, state);
    });
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended &&
         state.length < state.highWaterMark) {
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
    else
      len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
  this.emit('error', new Error('not implemented'));
};

Readable.prototype.pipe = function(dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;

  var doEnd = (!pipeOpts || pipeOpts.end !== false) &&
              dest !== process.stdout &&
              dest !== process.stderr;

  var endFn = doEnd ? onend : cleanup;
  if (state.endEmitted)
    process.nextTick(endFn);
  else
    src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable) {
    if (readable !== src) return;
    cleanup();
  }

  function onend() {
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  function cleanup() {
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', cleanup);

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (!dest._writableState || dest._writableState.needDrain)
      ondrain();
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    unpipe();
    dest.removeListener('error', onerror);
    if (EE.listenerCount(dest, 'error') === 0)
      dest.emit('error', er);
  }
  // This is a brutally ugly hack to make sure that our error handler
  // is attached before any userland ones.  NEVER DO THIS.
  if (!dest._events || !dest._events.error)
    dest.on('error', onerror);
  else if (isArray(dest._events.error))
    dest._events.error.unshift(onerror);
  else
    dest._events.error = [onerror, dest._events.error];



  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    // the handler that waits for readable events after all
    // the data gets sucked out in flow.
    // This would be easier to follow with a .once() handler
    // in flow(), but that is too slow.
    this.on('readable', pipeOnReadable);

    state.flowing = true;
    process.nextTick(function() {
      flow(src);
    });
  }

  return dest;
};

function pipeOnDrain(src) {
  return function() {
    var dest = this;
    var state = src._readableState;
    state.awaitDrain--;
    if (state.awaitDrain === 0)
      flow(src);
  };
}

function flow(src) {
  var state = src._readableState;
  var chunk;
  state.awaitDrain = 0;

  function write(dest, i, list) {
    var written = dest.write(chunk);
    if (false === written) {
      state.awaitDrain++;
    }
  }

  while (state.pipesCount && null !== (chunk = src.read())) {

    if (state.pipesCount === 1)
      write(state.pipes, 0, null);
    else
      forEach(state.pipes, write);

    src.emit('data', chunk);

    // if anyone needs a drain, then we have to wait for that.
    if (state.awaitDrain > 0)
      return;
  }

  // if every destination was unpiped, either before entering this
  // function, or in the while loop, then stop flowing.
  //
  // NB: This is a pretty rare edge case.
  if (state.pipesCount === 0) {
    state.flowing = false;

    // if there were data event listeners added, then switch to old mode.
    if (EE.listenerCount(src, 'data') > 0)
      emitDataEvents(src);
    return;
  }

  // at this point, no one needed a drain, so we just ran out of data
  // on the next readable event, start it over again.
  state.ranOut = true;
}

function pipeOnReadable() {
  if (this._readableState.ranOut) {
    this._readableState.ranOut = false;
    flow(this);
  }
}


Readable.prototype.unpipe = function(dest) {
  var state = this._readableState;

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0)
    return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes)
      return this;

    if (!dest)
      dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    this.removeListener('readable', pipeOnReadable);
    state.flowing = false;
    if (dest)
      dest.emit('unpipe', this);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    this.removeListener('readable', pipeOnReadable);
    state.flowing = false;

    for (var i = 0; i < len; i++)
      dests[i].emit('unpipe', this);
    return this;
  }

  // try to find the right one.
  var i = indexOf(state.pipes, dest);
  if (i === -1)
    return this;

  state.pipes.splice(i, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1)
    state.pipes = state.pipes[0];

  dest.emit('unpipe', this);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data' && !this._readableState.flowing)
    emitDataEvents(this);

  if (ev === 'readable' && this.readable) {
    var state = this._readableState;
    if (!state.readableListening) {
      state.readableListening = true;
      state.emittedReadable = false;
      state.needReadable = true;
      if (!state.reading) {
        this.read(0);
      } else if (state.length) {
        emitReadable(this, state);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
  emitDataEvents(this);
  this.read(0);
  this.emit('resume');
};

Readable.prototype.pause = function() {
  emitDataEvents(this, true);
  this.emit('pause');
};

function emitDataEvents(stream, startPaused) {
  var state = stream._readableState;

  if (state.flowing) {
    // https://github.com/isaacs/readable-stream/issues/16
    throw new Error('Cannot switch to old mode now.');
  }

  var paused = startPaused || false;
  var readable = false;

  // convert to an old-style stream.
  stream.readable = true;
  stream.pipe = Stream.prototype.pipe;
  stream.on = stream.addListener = Stream.prototype.on;

  stream.on('readable', function() {
    readable = true;

    var c;
    while (!paused && (null !== (c = stream.read())))
      stream.emit('data', c);

    if (c === null) {
      readable = false;
      stream._readableState.needReadable = true;
    }
  });

  stream.pause = function() {
    paused = true;
    this.emit('pause');
  };

  stream.resume = function() {
    paused = false;
    if (readable)
      process.nextTick(function() {
        stream.emit('readable');
      });
    else
      this.read(0);
    this.emit('resume');
  };

  // now make it start, just in case it hadn't already.
  stream.emit('readable');
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function() {
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length)
        self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function(chunk) {
    if (state.decoder)
      chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    //if (state.objectMode && util.isNullOrUndefined(chunk))
    if (state.objectMode && (chunk === null || chunk === undefined))
      return;
    else if (!state.objectMode && (!chunk || !chunk.length))
      return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (typeof stream[i] === 'function' &&
        typeof this[i] === 'undefined') {
      this[i] = function(method) { return function() {
        return stream[method].apply(stream, arguments);
      }}(i);
    }
  }

  // proxy certain important events.
  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
  forEach(events, function(ev) {
    stream.on(ev, self.emit.bind(self, ev));
  });

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function(n) {
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};



// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
function fromList(n, state) {
  var list = state.buffer;
  var length = state.length;
  var stringMode = !!state.decoder;
  var objectMode = !!state.objectMode;
  var ret;

  // nothing in the list, definitely empty.
  if (list.length === 0)
    return null;

  if (length === 0)
    ret = null;
  else if (objectMode)
    ret = list.shift();
  else if (!n || n >= length) {
    // read it all, truncate the array.
    if (stringMode)
      ret = list.join('');
    else
      ret = Buffer.concat(list, length);
    list.length = 0;
  } else {
    // read just some of it.
    if (n < list[0].length) {
      // just take a part of the first list item.
      // slice is the same for buffers and strings.
      var buf = list[0];
      ret = buf.slice(0, n);
      list[0] = buf.slice(n);
    } else if (n === list[0].length) {
      // first list is a perfect match
      ret = list.shift();
    } else {
      // complex case.
      // we have enough to cover it, but it spans past the first buffer.
      if (stringMode)
        ret = '';
      else
        ret = new Buffer(n);

      var c = 0;
      for (var i = 0, l = list.length; i < l && c < n; i++) {
        var buf = list[0];
        var cpy = Math.min(n - c, buf.length);

        if (stringMode)
          ret += buf.slice(0, cpy);
        else
          buf.copy(ret, c, 0, cpy);

        if (cpy < buf.length)
          list[0] = buf.slice(cpy);
        else
          list.shift();

        c += cpy;
      }
    }
  }

  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0)
    throw new Error('endReadable called on non-empty stream');

  if (!state.endEmitted && state.calledRead) {
    state.ended = true;
    process.nextTick(function() {
      // Check that we didn't get one last unshift.
      if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
      }
    });
  }
}

function forEach (xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf (xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, cb), and it'll handle all
// the drain event emission and buffering.

module.exports = Writable;

/*<replacement>*/
var Buffer = __webpack_require__(19).Buffer;
/*</replacement>*/

Writable.WritableState = WritableState;


/*<replacement>*/
var util = __webpack_require__(87);
util.inherits = __webpack_require__(79);
/*</replacement>*/

var Stream = __webpack_require__(85);

util.inherits(Writable, Stream);

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
}

function WritableState(options, stream) {
  options = options || {};

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  this.highWaterMark = (hwm || hwm === 0) ? hwm : 16 * 1024;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  // cast to ints.
  this.highWaterMark = ~~this.highWaterMark;

  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, becuase any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function(er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.buffer = [];

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;
}

function Writable(options) {
  var Duplex = __webpack_require__(293);

  // Writable ctor is applied to Duplexes, though they're not
  // instanceof Writable, they're instanceof Readable.
  if (!(this instanceof Writable) && !(this instanceof Duplex))
    return new Writable(options);

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
  this.emit('error', new Error('Cannot pipe. Not readable.'));
};


function writeAfterEnd(stream, state, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  process.nextTick(function() {
    cb(er);
  });
}

// If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  if (!Buffer.isBuffer(chunk) &&
      'string' !== typeof chunk &&
      chunk !== null &&
      chunk !== undefined &&
      !state.objectMode) {
    var er = new TypeError('Invalid non-string/buffer chunk');
    stream.emit('error', er);
    process.nextTick(function() {
      cb(er);
    });
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function(chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (Buffer.isBuffer(chunk))
    encoding = 'buffer';
  else if (!encoding)
    encoding = state.defaultEncoding;

  if (typeof cb !== 'function')
    cb = function() {};

  if (state.ended)
    writeAfterEnd(this, state, cb);
  else if (validChunk(this, state, chunk, cb))
    ret = writeOrBuffer(this, state, chunk, encoding, cb);

  return ret;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode &&
      state.decodeStrings !== false &&
      typeof chunk === 'string') {
    chunk = new Buffer(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, cb) {
  chunk = decodeChunk(state, chunk, encoding);
  if (Buffer.isBuffer(chunk))
    encoding = 'buffer';
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret)
    state.needDrain = true;

  if (state.writing)
    state.buffer.push(new WriteReq(chunk, encoding, cb));
  else
    doWrite(stream, state, len, chunk, encoding, cb);

  return ret;
}

function doWrite(stream, state, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  if (sync)
    process.nextTick(function() {
      cb(er);
    });
  else
    cb(er);

  stream._writableState.errorEmitted = true;
  stream.emit('error', er);
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er)
    onwriteError(stream, state, sync, er, cb);
  else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(stream, state);

    if (!finished && !state.bufferProcessing && state.buffer.length)
      clearBuffer(stream, state);

    if (sync) {
      process.nextTick(function() {
        afterWrite(stream, state, finished, cb);
      });
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished)
    onwriteDrain(stream, state);
  cb();
  if (finished)
    finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}


// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;

  for (var c = 0; c < state.buffer.length; c++) {
    var entry = state.buffer[c];
    var chunk = entry.chunk;
    var encoding = entry.encoding;
    var cb = entry.callback;
    var len = state.objectMode ? 1 : chunk.length;

    doWrite(stream, state, len, chunk, encoding, cb);

    // if we didn't call the onwrite immediately, then
    // it means that we need to wait until it does.
    // also, that means that the chunk and cb are currently
    // being processed, so move the buffer counter past them.
    if (state.writing) {
      c++;
      break;
    }
  }

  state.bufferProcessing = false;
  if (c < state.buffer.length)
    state.buffer = state.buffer.slice(c);
  else
    state.buffer.length = 0;
}

Writable.prototype._write = function(chunk, encoding, cb) {
  cb(new Error('not implemented'));
};

Writable.prototype.end = function(chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (typeof chunk !== 'undefined' && chunk !== null)
    this.write(chunk, encoding);

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished)
    endWritable(this, state, cb);
};


function needFinish(stream, state) {
  return (state.ending &&
          state.length === 0 &&
          !state.finished &&
          !state.writing);
}

function finishMaybe(stream, state) {
  var need = needFinish(stream, state);
  if (need) {
    state.finished = true;
    stream.emit('finish');
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished)
      process.nextTick(cb);
    else
      stream.once('finish', cb);
  }
  state.ended = true;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.


// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

module.exports = Transform;

var Duplex = __webpack_require__(293);

/*<replacement>*/
var util = __webpack_require__(87);
util.inherits = __webpack_require__(79);
/*</replacement>*/

util.inherits(Transform, Duplex);


function TransformState(options, stream) {
  this.afterTransform = function(er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb)
    return stream.emit('error', new Error('no writecb in Transform class'));

  ts.writechunk = null;
  ts.writecb = null;

  if (data !== null && data !== undefined)
    stream.push(data);

  if (cb)
    cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}


function Transform(options) {
  if (!(this instanceof Transform))
    return new Transform(options);

  Duplex.call(this, options);

  var ts = this._transformState = new TransformState(options, this);

  // when the writable side finishes, then flush out anything remaining.
  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  this.once('finish', function() {
    if ('function' === typeof this._flush)
      this._flush(function(er) {
        done(stream, er);
      });
    else
      done(stream);
  });
}

Transform.prototype.push = function(chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
  throw new Error('not implemented');
};

Transform.prototype._write = function(chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform ||
        rs.needReadable ||
        rs.length < rs.highWaterMark)
      this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};


function done(stream, er) {
  if (er)
    return stream.emit('error', er);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var rs = stream._readableState;
  var ts = stream._transformState;

  if (ws.length)
    throw new Error('calling transform done when ws.length != 0');

  if (ts.transforming)
    throw new Error('calling transform done when still transforming');

  return stream.push(null);
}


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var once = __webpack_require__(1119);

var noop = function() {};

var isRequest = function(stream) {
	return stream.setHeader && typeof stream.abort === 'function';
};

var isChildProcess = function(stream) {
	return stream.stdio && Array.isArray(stream.stdio) && stream.stdio.length === 3
};

var eos = function(stream, opts, callback) {
	if (typeof opts === 'function') return eos(stream, null, opts);
	if (!opts) opts = {};

	callback = once(callback || noop);

	var ws = stream._writableState;
	var rs = stream._readableState;
	var readable = opts.readable || (opts.readable !== false && stream.readable);
	var writable = opts.writable || (opts.writable !== false && stream.writable);
	var cancelled = false;

	var onlegacyfinish = function() {
		if (!stream.writable) onfinish();
	};

	var onfinish = function() {
		writable = false;
		if (!readable) callback.call(stream);
	};

	var onend = function() {
		readable = false;
		if (!writable) callback.call(stream);
	};

	var onexit = function(exitCode) {
		callback.call(stream, exitCode ? new Error('exited with error code: ' + exitCode) : null);
	};

	var onerror = function(err) {
		callback.call(stream, err);
	};

	var onclose = function() {
		process.nextTick(onclosenexttick);
	};

	var onclosenexttick = function() {
		if (cancelled) return;
		if (readable && !(rs && (rs.ended && !rs.destroyed))) return callback.call(stream, new Error('premature close'));
		if (writable && !(ws && (ws.ended && !ws.destroyed))) return callback.call(stream, new Error('premature close'));
	};

	var onrequest = function() {
		stream.req.on('finish', onfinish);
	};

	if (isRequest(stream)) {
		stream.on('complete', onfinish);
		stream.on('abort', onclose);
		if (stream.req) onrequest();
		else stream.on('request', onrequest);
	} else if (writable && !ws) { // legacy streams
		stream.on('end', onlegacyfinish);
		stream.on('close', onlegacyfinish);
	}

	if (isChildProcess(stream)) stream.on('exit', onexit);

	stream.on('end', onend);
	stream.on('finish', onfinish);
	if (opts.error !== false) stream.on('error', onerror);
	stream.on('close', onclose);

	return function() {
		cancelled = true;
		stream.removeListener('complete', onfinish);
		stream.removeListener('abort', onclose);
		stream.removeListener('request', onrequest);
		if (stream.req) stream.req.removeListener('finish', onfinish);
		stream.removeListener('end', onlegacyfinish);
		stream.removeListener('close', onlegacyfinish);
		stream.removeListener('finish', onfinish);
		stream.removeListener('exit', onexit);
		stream.removeListener('end', onend);
		stream.removeListener('error', onerror);
		stream.removeListener('close', onclose);
	};
};

module.exports = eos;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(223);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(1125);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(84).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(474);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(224).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(__webpack_require__(87));
util.inherits = __webpack_require__(79);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(1126);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(1127);
var destroyImpl = __webpack_require__(475);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(119);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(111).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(119);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(111).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65), __webpack_require__(55)))

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(84).EventEmitter;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(223);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(223);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(__webpack_require__(87));
util.inherits = __webpack_require__(79);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(1129)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(474);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(224).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(475);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(119);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(119);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55), __webpack_require__(375).setImmediate, __webpack_require__(65)))

/***/ }),
/* 477 */
/***/ (function(module, exports) {

/* Protocol - protocol constants */

/* Command code => mnemonic */
module.exports.types = {
  0: 'reserved',
  1: 'connect',
  2: 'connack',
  3: 'publish',
  4: 'puback',
  5: 'pubrec',
  6: 'pubrel',
  7: 'pubcomp',
  8: 'subscribe',
  9: 'suback',
  10: 'unsubscribe',
  11: 'unsuback',
  12: 'pingreq',
  13: 'pingresp',
  14: 'disconnect',
  15: 'reserved'
};

/* Mnemonic => Command code */
module.exports.codes = {}
for(var k in module.exports.types) {
  var v = module.exports.types[k];
  module.exports.codes[v] = k;
}

/* Header */
module.exports.CMD_SHIFT = 4;
module.exports.CMD_MASK = 0xF0;
module.exports.DUP_MASK = 0x08;
module.exports.QOS_MASK = 0x03;
module.exports.QOS_SHIFT = 1;
module.exports.RETAIN_MASK = 0x01;

/* Length */
module.exports.LENGTH_MASK = 0x7F;
module.exports.LENGTH_FIN_MASK = 0x80;

/* Connack */
module.exports.SESSIONPRESENT_MASK = 0x01;

/* Connect */
module.exports.USERNAME_MASK = 0x80;
module.exports.PASSWORD_MASK = 0x40;
module.exports.WILL_RETAIN_MASK = 0x20;
module.exports.WILL_QOS_MASK = 0x18;
module.exports.WILL_QOS_SHIFT = 3;
module.exports.WILL_FLAG_MASK = 0x04;
module.exports.CLEAN_SESSION_MASK = 0x02;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(1133);
var util = __webpack_require__(1134);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(1135);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var net = __webpack_require__(1138);

/*
  variables port and host can be removed since
  you have all required information in opts object
*/
function buildBuilder (client, opts) {
  var port, host;
  opts.port = opts.port || 1883;
  opts.hostname = opts.hostname || opts.host || 'localhost';

  port = opts.port;
  host = opts.hostname;

  return net.createConnection(port, host);
}

module.exports = buildBuilder;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var websocket = __webpack_require__(482),
  _URL = __webpack_require__(478),
  wssProperties = [
    'rejectUnauthorized',
    'ca',
    'cert',
    'key',
    'pfx',
    'passphrase'
  ];

function buildBuilder (client, opts) {
  var wsOpt = {
      protocol: 'mqttv3.1'
    },
    host = opts.hostname || 'localhost',
    port = String(opts.port || 80),
    path = opts.path || '/',
    url = opts.protocol + '://' + host + ':' + port + path;

  if ('wss' === opts.protocol) {
    wssProperties.forEach(function (prop) {
      if (opts.hasOwnProperty(prop)) {
        wsOpt[prop] = opts[prop];
      }
    });
  }

  return websocket(url, wsOpt);
}

function buildBuilderBrowser (mqttClient, opts) {
  var url, parsed;
  if ('undefined' !== typeof (document)) { // for Web Workers! P.S: typeof(document) !== undefined may be becoming the faster one these days.
    parsed = _URL.parse(document.URL);
  } else {
    throw new Error('Could not determine host. Specify host manually.');
  }

  if (!opts.protocol) {
    if ('https:' === parsed.protocol) {
      opts.protocol = 'wss';
    } else {
      opts.protocol = 'ws';
    }
  }

  if (!opts.hostname) {
    opts.hostname = opts.host;
  }

  if (!opts.hostname) {
    opts.hostname = parsed.hostname;
    if (!opts.port) {
      opts.port = parsed.port;
    }
  }

  if (!opts.port) {
    if ('wss' === opts.protocol) {
      opts.port = 443;
    } else {
      opts.port = 80;
    }
  }

  if (!opts.path) {
    opts.path = '/';
  }

  url = opts.protocol + '://' + opts.hostname + ':' + opts.port + opts.path;

  return websocket(url, 'mqttv3.1');
}

if ('browser' !== process.title) {
  module.exports = buildBuilder;
} else {
  module.exports = buildBuilderBrowser;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global, Buffer) {

var through = __webpack_require__(1140)
var duplexify = __webpack_require__(1142)
var WS = __webpack_require__(1144)

module.exports = WebSocketStream

function WebSocketStream(target, protocols, options) {
  var stream, socket

  var isBrowser = process.title === 'browser'
  var isNative = !!global.WebSocket
  var socketWrite = isBrowser ? socketWriteBrowser : socketWriteNode
  var proxy = through.obj(socketWrite, socketEnd)

  if (protocols && !Array.isArray(protocols) && 'object' === typeof protocols) {
    // accept the "options" Object as the 2nd argument
    options = protocols
    protocols = null

    if (typeof options.protocol === 'string' || Array.isArray(options.protocol)) {
      protocols = options.protocol;
    }
  }

  if (!options) options = {}

  // browser only: sets the maximum socket buffer size before throttling
  var bufferSize = options.browserBufferSize || 1024 * 512

  // browser only: how long to wait when throttling
  var bufferTimeout = options.browserBufferTimeout || 1000

  // use existing WebSocket object that was passed in
  if (typeof target === 'object') {
    socket = target
  // otherwise make a new one
  } else {
    // special constructor treatment for native websockets in browsers, see
    // https://github.com/maxogden/websocket-stream/issues/82
    if (isNative && isBrowser) {
      socket = new WS(target, protocols)
    } else {
      socket = new WS(target, protocols, options)
    }

    socket.binaryType = 'arraybuffer'
  }

  // was already open when passed in
  if (socket.readyState === WS.OPEN) {
    stream = proxy
  } else {
    stream = duplexify.obj()
    socket.onopen = onopen
  }

  stream.socket = socket

  socket.onclose = onclose
  socket.onerror = onerror
  socket.onmessage = onmessage

  proxy.on('close', destroy)

  var coerceToBuffer = options.binary || options.binary === undefined

  function socketWriteNode(chunk, enc, next) {
    if (coerceToBuffer && typeof chunk === 'string') {
      chunk = new Buffer(chunk, 'utf8')
    }
    socket.send(chunk, next)
  }

  function socketWriteBrowser(chunk, enc, next) {
    if (socket.bufferedAmount > bufferSize) {
      setTimeout(socketWriteBrowser, bufferTimeout, chunk, enc, next)
      return
    }

    if (coerceToBuffer && typeof chunk === 'string') {
      chunk = new Buffer(chunk, 'utf8')
    }

    try {
      socket.send(chunk)
    } catch(err) {
      return next(err)
    }

    next()
  }

  function socketEnd(done) {
    socket.close()
    done()
  }

  function onopen() {
    stream.setReadable(proxy)
    stream.setWritable(proxy)
    stream.emit('connect')
  }

  function onclose() {
    stream.end()
    stream.destroy()
  }

  function onerror(err) {
    stream.destroy(err)
  }

  function onmessage(event) {
    var data = event.data
    if (data instanceof ArrayBuffer) data = new Buffer(new Uint8Array(data))
    else data = new Buffer(data)
    proxy.push(data)
  }

  function destroy() {
    socket.close()
  }

  return stream
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55), __webpack_require__(65), __webpack_require__(19).Buffer))

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(473);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(476);
exports.Duplex = __webpack_require__(119);
exports.Transform = __webpack_require__(484);
exports.PassThrough = __webpack_require__(1141);


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(119);

/*<replacement>*/
var util = Object.create(__webpack_require__(87));
util.inherits = __webpack_require__(79);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(225));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    var Wih = Wi.high = M[offset + i * 2]     | 0;
	                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    var Wil = gamma0l + Wi7l;
	                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    var Wil = Wil + gamma1l;
	                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    var Wil = Wil + Wi16l;
	                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	return CryptoJS.SHA512;

}));

/***/ }),
/* 487 */
/***/ (function(module, exports) {



/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MQTTPermissionsContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Constants__ = __webpack_require__(2);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var MQTTPermissionsContext=Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])();var MQTTPermissionsContextProvider=function MQTTPermissionsContextProvider(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({}),_useState2=_slicedToArray(_useState,2),config=_useState2[0],setConfig=_useState2[1];var refreshConnectionDetails=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var currentTime,expiredTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:currentTime=new Date();if(!(config.expirationTime!==undefined)){_context.next=12;break;}expiredTime=new Date(config.expirationTime);if(!(expiredTime-currentTime<__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_137" /* MQTT_CONNECTION_DETAILS_EXPIRY_TIMEOUT */])){_context.next=9;break;}_context.next=6;return fetchConnectionDetails();case 6:return _context.abrupt("return",_context.sent);case 9:return _context.abrupt("return",config);case 10:_context.next=15;break;case 12:_context.next=14;return fetchConnectionDetails();case 14:return _context.abrupt("return",_context.sent);case 15:case"end":return _context.stop();}}},_callee,_this);}));return function refreshConnectionDetails(){return _ref.apply(this,arguments);};}();var fetchConnectionDetails=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var request,args,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["X" /* getNodeId */])()};args=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_51" /* ENDPOINT_GET_MQTT_CONNECTION_DETAILS */]);_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:response=_context2.sent;if(!(response.status!==200)){_context2.next=9;break;}return _context2.abrupt("return",config);case 9:setConfig(response.data);return _context2.abrupt("return",response.data);case 11:case"end":return _context2.stop();}}},_callee2,_this);}));return function fetchConnectionDetails(){return _ref2.apply(this,arguments);};}();var value={refreshConnectionDetails:refreshConnectionDetails};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MQTTPermissionsContext.Provider,{value:value},props.children);};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(MQTTPermissionsContextProvider));

/***/ }),
/* 489 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconExportSmallData: "data:image/svg+xml,%3csvg width='15' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M13.5 10v2a1 1 0 01-1 1h-10a1 1 0 01-1-1V2a1 1 0 011-1h2M13.5 5V1h-4M7.67 6.83l5.66-5.66'/%3e%3c/g%3e%3c/svg%3e",
  iconExportSmallWidth: 15,
  iconExportSmallHeight: 14
};

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return metricProcessName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchLidarDeviceDetails; });
/* unused harmony export getStartEndAisleLabelFromAssetMappings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLidarController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateLidarController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateLidarControllerStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateLidarConfiguration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resources_NodeResource__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datamodel_LidarAssetModelResource__ = __webpack_require__(1191);
var _this=this;var getLidarDeviceDetails=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatcher,request){var startTime,deviceIdentifierList,assetsList,lidarConnectivity,pageToken,getAssetsResult,isFault,cartRecipesMap,model;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:startTime=Date.now();deviceIdentifierList=[];assetsList=[];lidarConnectivity={};pageToken=null;getAssetsResult=void 0;case 6:_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["g" /* getAssets */])(request.nodeId,request.assetType,pageToken);case 8:getAssetsResult=_context2.sent;if(!(getAssetsResult.status===200)){_context2.next=19;break;}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getLidarDeviceDetails",true,false);_context2.t0=assetsList;_context2.next=14;return getAssetByAssetlabel(getAssetsResult);case 14:_context2.t1=_context2.sent;assetsList=_context2.t0.concat.call(_context2.t0,_context2.t1);pageToken=getAssetsResult.data.pageToken;_context2.next=21;break;case 19:isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(getAssetsResult.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getLidarDeviceDetails",false,isFault);case 21:if(getAssetsResult.status===200&&getAssetsResult.data.pageToken){_context2.next=6;break;}case 22:assetsList.forEach(function(asset){deviceIdentifierList.push(asset.assetDetails.assetAttributes.ControllerIP);});if(!(deviceIdentifierList&&deviceIdentifierList.length>0)){_context2.next=27;break;}_context2.next=26;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["h" /* getAssetsConnectivity */])(request.nodeId,request.assetType,[].concat(_toConsumableArray(new Set(deviceIdentifierList))));case 26:lidarConnectivity=_context2.sent;case 27:_context2.next=29;return getCartRecipeMap();case 29:cartRecipesMap=_context2.sent;_context2.next=32;return extractLidarDeviceList(assetsList,lidarConnectivity,cartRecipesMap);case 32:model=_context2.sent;model.cartRecipesMap=cartRecipesMap;dispatcher({type:"RECEIVE_DATA",data:model});case 35:case"end":return _context2.stop();}}},_callee2,this);}));return function getLidarDeviceDetails(_x2,_x3){return _ref2.apply(this,arguments);};}();var extractLidarDeviceList=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(assetsList,lidarConnectivity,cartRecipesMap){var model,lidarConnectivityMap;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:model={lidarDeviceInformation:{},macAddressArray:[]};lidarConnectivityMap={};if(lidarConnectivity.data&&lidarConnectivity.data.assetConnectivityList){lidarConnectivity.data.assetConnectivityList.forEach(function(connectivity){lidarConnectivityMap[connectivity.identifier]=connectivity;});}assetsList.forEach(function(asset){if("assetDetails"in asset){var lidarDeviceDetail=asset.assetDetails;if(lidarDeviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]||lidarDeviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_82" /* INACTIVE */]){model.macAddressArray.push(lidarDeviceDetail.assetAttributes.mac);var detail=lidarConnectivityMap[lidarDeviceDetail.assetAttributes.ControllerIP];var lidarLocation=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["T" /* getLocationFromAssetMappings */])(asset.assetMappings);var startEndAisleLabel=getStartEndAisleLabelFromAssetMappings(asset.assetMappings);var columnTypes=getColumnTypes(asset.assetMappings[0]);var numberOfNonOVLidarSensors=getNumberOfLidarSensors(columnTypes.nonOvColumnType,cartRecipesMap);model.lidarDeviceInformation[lidarDeviceDetail.assetLabel.value]={mac:lidarDeviceDetail.assetLabel.value,ip:lidarDeviceDetail.assetAttributes.ControllerIP,lidarControllerType:lidarDeviceDetail.assetAttributes.ControllerType,status:lidarDeviceDetail.assetStatus,connectivity:detail?detail.status:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */],timestamp:detail?detail.lastUpdateTime:"",location:lidarLocation?lidarLocation:"Not Configured",startAisleLabel:startEndAisleLabel.startAisleLabel,endAisleLabel:startEndAisleLabel.endAisleLabel,nonOvColumnType:columnTypes.nonOvColumnType,numberOfNonOVLidarSensors:numberOfNonOVLidarSensors,oneTierOvColumnType:columnTypes.oneTierOvColumnType,twoTierOvColumnType:columnTypes.twoTierOvColumnType,aislesCount:asset.assetMappings.length,creationTime:lidarDeviceDetail.creationTime,obstructionDisabledUntil:Number(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return lidarDeviceDetail.assetAttributes.obstructionDisabledUntil;},0)),displayableAssetMappings:prepareDisplayableAssetMappingData(asset.assetMappings)};}}});return _context3.abrupt("return",model);case 5:case"end":return _context3.stop();}}},_callee3,this);}));return function extractLidarDeviceList(_x4,_x5,_x6){return _ref3.apply(this,arguments);};}();var getAssetByAssetlabel=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(getAssetsResult){var promises,startTime,getAssetByAssetLabelResultsList,assetList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:promises=[];startTime=Date.now();if(getAssetsResult.data&&getAssetsResult.data.assetDetailsList){getAssetsResult.data.assetDetailsList.forEach(function(lidarDeviceDetail){if(lidarDeviceDetail.assetLabel){promises.push(Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(lidarDeviceDetail.assetLabel));}});}_context4.next=5;return Promise.all(promises);case 5:getAssetByAssetLabelResultsList=_context4.sent;assetList=[];getAssetByAssetLabelResultsList.forEach(function(res){if(res.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAssetByAssetlabel",true,false);assetList.push(res.data.asset);}else{var isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(res.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAssetByAssetlabel",false,isFault);}});return _context4.abrupt("return",assetList);case 9:case"end":return _context4.stop();}}},_callee4,this);}));return function getAssetByAssetlabel(_x7){return _ref4.apply(this,arguments);};}();var getCartRecipeMap=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var eligibleCartRecipes;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:eligibleCartRecipes=[];if(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_15" /* getUTRRegion */])()==="NA"){eligibleCartRecipes=__WEBPACK_IMPORTED_MODULE_5__util_Validations__["n" /* SCANLESS_SUPPORTED_CART_RECIPES_NA */].NON_OV.concat(__WEBPACK_IMPORTED_MODULE_5__util_Validations__["n" /* SCANLESS_SUPPORTED_CART_RECIPES_NA */].TWO_TIER_OV).concat(__WEBPACK_IMPORTED_MODULE_5__util_Validations__["n" /* SCANLESS_SUPPORTED_CART_RECIPES_NA */].ONE_TIER_OV).concat(__WEBPACK_IMPORTED_MODULE_5__util_Validations__["n" /* SCANLESS_SUPPORTED_CART_RECIPES_NA */].FLEX_RACK);}else if(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_15" /* getUTRRegion */])()==="EU"){eligibleCartRecipes=__WEBPACK_IMPORTED_MODULE_5__util_Validations__["l" /* SCANLESS_SUPPORTED_CART_RECIPES_EU */].NON_OV.concat(__WEBPACK_IMPORTED_MODULE_5__util_Validations__["l" /* SCANLESS_SUPPORTED_CART_RECIPES_EU */].TWO_TIER_OV).concat(__WEBPACK_IMPORTED_MODULE_5__util_Validations__["l" /* SCANLESS_SUPPORTED_CART_RECIPES_EU */].ONE_TIER_OV).concat(__WEBPACK_IMPORTED_MODULE_5__util_Validations__["l" /* SCANLESS_SUPPORTED_CART_RECIPES_EU */].FLEX_RACK);}else if(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_15" /* getUTRRegion */])()==="FE"){eligibleCartRecipes=__WEBPACK_IMPORTED_MODULE_5__util_Validations__["m" /* SCANLESS_SUPPORTED_CART_RECIPES_JP */].NON_OV.concat(__WEBPACK_IMPORTED_MODULE_5__util_Validations__["m" /* SCANLESS_SUPPORTED_CART_RECIPES_JP */].TWO_TIER_OV).concat(__WEBPACK_IMPORTED_MODULE_5__util_Validations__["m" /* SCANLESS_SUPPORTED_CART_RECIPES_JP */].ONE_TIER_OV).concat(__WEBPACK_IMPORTED_MODULE_5__util_Validations__["m" /* SCANLESS_SUPPORTED_CART_RECIPES_JP */].FLEX_RACK);}_context5.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4__resources_NodeResource__["a" /* getCartRecipes */])(eligibleCartRecipes,metricProcessName);case 4:return _context5.abrupt("return",_context5.sent);case 5:case"end":return _context5.stop();}}},_callee5,this);}));return function getCartRecipeMap(){return _ref5.apply(this,arguments);};}();var callAddAssetV2=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatcher,requestBody,showCustomAlert){var startTime,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:startTime=Date.now();_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["b" /* addAssetV2 */])(requestBody);case 3:response=_context7.sent;if(response.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"AddAssetV2",true,false);showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["D" /* ALERT_UPDATE_SUCCESS_ASSET_MESSAGE */]);fetchLidarDeviceDetails(dispatcher);}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"AddAssetV2",false,isFault);showCustomAlert(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(response.errorResponse.errorMessage).message;},__WEBPACK_IMPORTED_MODULE_2__util_Constants__["l" /* ALERT_ADD_ASSET_MESSAGE */]));}case 5:case"end":return _context7.stop();}}},_callee7,this);}));return function callAddAssetV2(_x11,_x12,_x13){return _ref7.apply(this,arguments);};}();var callBatchUpdateAssetV2=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatcher,requestBody,showCustomAlert){var startTime,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:startTime=Date.now();_context9.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["c" /* batchUpdateAssetV2 */])(requestBody);case 3:response=_context9.sent;if(response.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"BatchUpdateAssetV2",true,false);showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["D" /* ALERT_UPDATE_SUCCESS_ASSET_MESSAGE */]);fetchLidarDeviceDetails(dispatcher);}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"BatchUpdateAssetV2",false,isFault);showCustomAlert(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(response.errorResponse.errorMessage).message;},__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]));}case 5:case"end":return _context9.stop();}}},_callee9,this);}));return function callBatchUpdateAssetV2(_x17,_x18,_x19){return _ref9.apply(this,arguments);};}();var callSetAssetStatus=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatcher,assetLabel,status,showCustomAlert){var startTime,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:startTime=Date.now();_context11.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(assetLabel,status);case 3:response=_context11.sent;if(response.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"SetAssetStatus",true,false);showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["D" /* ALERT_UPDATE_SUCCESS_ASSET_MESSAGE */]);}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"SetAssetStatus",false,isFault);showCustomAlert(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(response.errorResponse.errorMessage).message;},__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]));}case 5:case"end":return _context11.stop();}}},_callee11,this);}));return function callSetAssetStatus(_x24,_x25,_x26,_x27){return _ref11.apply(this,arguments);};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="LIDAR_DEVICE_DETAILS";var fetchLidarDeviceDetails=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher){var request;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_99" /* LIDAR_ASSET_TYPE */]};_context.next=3;return getLidarDeviceDetails(dispatcher,request);case 3:case"end":return _context.stop();}}},_callee,this);}));return function fetchLidarDeviceDetails(_x){return _ref.apply(this,arguments);};}();function getNumberOfLidarSensors(cartType,cartRecipesMap){var cartRecipe=cartType&&cartRecipesMap&&cartRecipesMap.get(cartType);return cartRecipe&&cartRecipe.numberOfLidarSensors||0;}function getColumnTypes(assetMapping){var columnTypes={};if(assetMapping&&assetMapping.mappingAttributes&&assetMapping.mappingAttributes.mappedColumns){try{var mappedColumns=JSON.parse(assetMapping.mappingAttributes.mappedColumns);if(Array.isArray(mappedColumns)){mappedColumns.forEach(function(mappedColumn){if(!mappedColumn.rowLabels){columnTypes.nonOvColumnType=mappedColumn.cartType;}else if(mappedColumn.rowLabels&&Array.isArray(mappedColumn.rowLabels)&&mappedColumn.rowLabels.length){if(mappedColumn.rowLabels.length===1){columnTypes.oneTierOvColumnType=mappedColumn.cartType;}else if(mappedColumn.rowLabels.length===2){columnTypes.twoTierOvColumnType=mappedColumn.cartType;}}});}}catch(error){console.error("Error parsing mappedColumns JSON:",error);}}return columnTypes;}function prepareDisplayableAssetMappingData(assetMappings){var displayableAssetMappingList=[];assetMappings.forEach(function(assetMapping,index){try{var mappedColumns=JSON.parse(assetMapping.mappingAttributes.mappedColumns);displayableAssetMappingList[index]={"aisleLabel":assetMapping.mappedResourceLabel,"columns":mappedColumns};}catch(error){console.error("Error parsing mappedColumns JSON in prepareDisplayableAssetMappingData:",error);// Add a placeholder entry with empty columns to avoid breaking the UI
displayableAssetMappingList[index]={"aisleLabel":assetMapping.mappedResourceLabel,"columns":[]};}});displayableAssetMappingList.sort(function(a,b){return a.aisleLabel.localeCompare(b.aisleLabel,undefined,{numeric:true,sensitivity:'base'});});return displayableAssetMappingList;}function getStartEndAisleLabelFromAssetMappings(assetMappings){var result=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_10" /* getStartEndAisleFromMappings */])(assetMappings);if(result){return result;}// Fallback: if can't determine from columnAddress, use sorted (old behavior)
var aisleLabels=assetMappings.map(function(m){return m.mappedResourceLabel;}).filter(Boolean);aisleLabels=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_31" /* sortAlphaNumeric */])(aisleLabels);return{"startAisleLabel":aisleLabels[0],"endAisleLabel":aisleLabels[aisleLabels.length-1]};}var addLidarController=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatcher,state,showCustomAlert){var requestBody;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:requestBody={lidarControllerConfig:state.lidarControllerConfig,nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_99" /* LIDAR_ASSET_TYPE */]};_context6.next=3;return callAddAssetV2(dispatcher,requestBody,showCustomAlert);case 3:case"end":return _context6.stop();}}},_callee6,this);}));return function addLidarController(_x8,_x9,_x10){return _ref6.apply(this,arguments);};}();var updateLidarController=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatcher,state,showCustomAlert){var requestBody;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:requestBody={lidarControllersConfigList:[state.lidarControllerConfig],nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_99" /* LIDAR_ASSET_TYPE */]};_context8.next=3;return callBatchUpdateAssetV2(dispatcher,requestBody,showCustomAlert);case 3:case"end":return _context8.stop();}}},_callee8,this);}));return function updateLidarController(_x14,_x15,_x16){return _ref8.apply(this,arguments);};}();var updateLidarControllerStatus=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatcher,mac,status,showCustomAlert){var assetLabel;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:assetLabel={type:"MAC_ADDRESS",value:mac};_context10.next=3;return callSetAssetStatus(dispatcher,assetLabel,status,showCustomAlert);case 3:case"end":return _context10.stop();}}},_callee10,this);}));return function updateLidarControllerStatus(_x20,_x21,_x22,_x23){return _ref10.apply(this,arguments);};}();var updateLidarConfiguration=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(dispatcher,configurations,mac,showCustomAlert){var getAssetResult,startTime,updatedAsset,updateResult,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 2:getAssetResult=_context12.sent;// Merge current configuration into existing configuration and update
startTime=Date.now();updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_6__datamodel_LidarAssetModelResource__["a" /* updateConfigurationsInLidarAssetObject */])(getAssetResult.data.asset,configurations);_context12.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(updatedAsset,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 7:updateResult=_context12.sent;if(updateResult.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"UpdateLidarConfiguration",true,false);showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["D" /* ALERT_UPDATE_SUCCESS_ASSET_MESSAGE */]);fetchLidarDeviceDetails(dispatcher);}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateResult.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"UpdateLidarConfiguration",false,isFault);showCustomAlert(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(updateResult.errorResponse.errorMessage).message;},__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]));}case 9:case"end":return _context12.stop();}}},_callee12,_this);}));return function updateLidarConfiguration(_x28,_x29,_x30,_x31){return _ref12.apply(this,arguments);};}();

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getResourcesV2; });
/* unused harmony export getCartRecipe */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCartRecipes; });
/* unused harmony export createRequest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Constants__ = __webpack_require__(2);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getResourcesV2=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(nodeId,resourceType){var args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:args=createRequest(__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_160" /* PROCESS_NODE_RESOURCE */],__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_53" /* ENDPOINT_GET_RESOURCES_V2 */],{nodeId:nodeId,resourceType:resourceType});_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["b" /* getCoralServiceDataFromParent */])(args,__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_160" /* PROCESS_NODE_RESOURCE */],__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_53" /* ENDPOINT_GET_RESOURCES_V2 */]);case 3:return _context.abrupt("return",_context.sent);case 4:case"end":return _context.stop();}}},_callee,this);}));return function getResourcesV2(_x,_x2){return _ref.apply(this,arguments);};}();var getCartRecipe=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(cartType){var args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:args=createRequest(__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_160" /* PROCESS_NODE_RESOURCE */],__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_46" /* ENDPOINT_GET_CART_RECIPE_BY_CART_TYPE */],{cartType:cartType});_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1__handler_ParentDataHandler__["b" /* getCoralServiceDataFromParent */])(args,__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_160" /* PROCESS_NODE_RESOURCE */],__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_46" /* ENDPOINT_GET_CART_RECIPE_BY_CART_TYPE */]);case 3:return _context2.abrupt("return",_context2.sent);case 4:case"end":return _context2.stop();}}},_callee2,this);}));return function getCartRecipe(_x3){return _ref2.apply(this,arguments);};}();var getCartRecipes=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(cartTypeList,metricProcessName){var promises,startTime,cartRecipeMap,getCartRecipeResultList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:promises=[];startTime=Date.now();cartRecipeMap=new Map();if(cartTypeList){cartTypeList.forEach(function(cartType){promises.push(getCartRecipe(cartType));});}_context3.next=6;return Promise.all(promises);case 6:getCartRecipeResultList=_context3.sent;getCartRecipeResultList.forEach(function(getCartRecipeResult,index){if(getCartRecipeResult.status===200){Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getCartRecipes",true,false);cartRecipeMap.set(getCartRecipeResult.data.cartRecipe.cartType,getCartRecipeResult.data.cartRecipe);}else{var isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(getCartRecipeResult.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getCartRecipes",false,isFault);}});return _context3.abrupt("return",cartRecipeMap);case 9:case"end":return _context3.stop();}}},_callee3,this);}));return function getCartRecipes(_x4,_x5){return _ref3.apply(this,arguments);};}();function createRequest(processName,endPoint,requestBody){return{processName:processName,endPoint:endPoint,request:JSON.stringify(requestBody)};}

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LidarTesterContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_LidarTesterReducer__ = __webpack_require__(1205);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var LidarTesterContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var LidarTesterContextProvider=function LidarTesterContextProvider(props){var data={controllerMacAddress:null,columnsList:[],sensorStateMap:{}};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_LidarTesterReducer__["a" /* LidarTesterReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),testerViewModel=_useReducer2[0],testerDispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LidarTesterContext.Provider,{value:{testerViewModel:testerViewModel,testerDispatch:testerDispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (LidarTesterContextProvider);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AisleRangeInputModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_LEDControllerUtil__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonui_SearchableSelectModal__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
var AisleRangeInputModal=function AisleRangeInputModal(props){var formatMessage=props.intl.formatMessage;var startAisle=props.startAisle,setStartAisle=props.setStartAisle,startAisleError=props.startAisleError,setStartAisleError=props.setStartAisleError,startPort=props.startPort,setStartPort=props.setStartPort,startPortError=props.startPortError,setStartPortError=props.setStartPortError,aisleCount=props.aisleCount,setAisleCount=props.setAisleCount,aisleCountError=props.aisleCountError,setAisleCountError=props.setAisleCountError,aisleType=props.aisleType,setAisleType=props.setAisleType,aisleTypeError=props.aisleTypeError,setAisleTypeError=props.setAisleTypeError,getAisleTypeOptions=props.getAisleTypeOptions,stateValues=props.stateValues;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"start-aisle-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.startAisle",defaultMessage:"Start Aisle"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_input___default.a,{id:"start-aisle-input",value:startAisle,onChange:setStartAisle,onBlur:function onBlur(){return setStartAisleError(!Object(__WEBPACK_IMPORTED_MODULE_5__util_Validations__["L" /* isValidEntry */])(stateValues.ledControllerConfig.startAisleLabel,Object(__WEBPACK_IMPORTED_MODULE_5__util_Validations__["E" /* getAisleNamePattern */])()));},error:startAisleError,placeholder:Object(__WEBPACK_IMPORTED_MODULE_6__util_LEDControllerUtil__["d" /* getAisleName */])()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"start-port-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.startPort",defaultMessage:"Start Port"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_input___default.a,{id:"start-port-input",value:startPort,onChange:setStartPort,onBlur:function onBlur(){return setStartPortError(!Object(__WEBPACK_IMPORTED_MODULE_5__util_Validations__["L" /* isValidEntry */])(stateValues.ledControllerConfig.startPortNumber,__WEBPACK_IMPORTED_MODULE_5__util_Validations__["j" /* PATTERNS */].PORT));},error:startPortError})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"aisle-count-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.aisleCount",defaultMessage:"Aisle Count"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_input___default.a,{id:"aisle-count-input",value:aisleCount,onChange:setAisleCount,onBlur:function onBlur(){return setAisleCountError(!Object(__WEBPACK_IMPORTED_MODULE_5__util_Validations__["L" /* isValidEntry */])(stateValues.ledControllerConfig.aisleCount,__WEBPACK_IMPORTED_MODULE_5__util_Validations__["j" /* PATTERNS */].INTEGER));},error:aisleCountError})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"searchable-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:formatMessage({id:"modal.aisletype"}),defaultMessage:"Aisle Type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonui_SearchableSelectModal__["a" /* default */],{preSelectedValue:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_8" /* DEFAULT_AISLE_TYPE */],error:aisleTypeError,setError:setAisleTypeError,selectedValue:aisleType,setSelectedValue:setAisleType,options:getAisleTypeOptions,htmlId:"searchable-input",placeholderValue:formatMessage({id:"modal.selectAisleType"}),placeholderDefaultValue:"Select Aisle Type"})));};AisleRangeInputModal.propTypes={intl:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape({formatMessage:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired}).isRequired,startAisle:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,setStartAisle:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,startAisleError:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool.isRequired,setStartAisleError:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,startPort:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,setStartPort:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,startPortError:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool.isRequired,setStartPortError:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,aisleCount:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,setAisleCount:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,aisleCountError:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool.isRequired,setAisleCountError:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,aisleType:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,setAisleType:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,aisleTypeError:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool.isRequired,setAisleTypeError:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,getAisleTypeOptions:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.array.isRequired,stateValues:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(AisleRangeInputModal));

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEDControllerConfigurationContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_LEDControllerConfigurationReducer__ = __webpack_require__(1211);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var LEDControllerConfigurationContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var LEDControllerConfigurationContextProvider=function LEDControllerConfigurationContextProvider(props){var data={ledDevices:{},aisleTypes:new Set(),ledAisleData:[],loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_LEDControllerConfigurationReducer__["a" /* LEDControllerConfigurationReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LEDControllerConfigurationContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (LEDControllerConfigurationContextProvider);

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = useSBLDashboard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_SBLDashboardReducer__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var SBLDashboardContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(null);var INITIAL_STATE={resourceDynamicAttributes:[],loading:true,sortPref:{column:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_14" /* DEFAULT_SORT_COLUMN */],direction:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["J" /* ASCENDING */]},percentileThreshold:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_13" /* DEFAULT_PERCENTILE */],error:null};function useSBLDashboard(){var context=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(SBLDashboardContext);if(!context){throw new Error("useSBLDashboard must be used within SBLDashboardContextProvider");}return context;}var SBLDashboardContextProvider=function SBLDashboardContextProvider(props){var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_SBLDashboardReducer__["a" /* SBLDashboardReducer */],INITIAL_STATE),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var value=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return{viewModel:viewModel,dispatch:dispatch};},[viewModel,dispatch]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SBLDashboardContext.Provider,{value:value},props.children);};/* harmony default export */ __webpack_exports__["a"] = (SBLDashboardContextProvider);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = uncontrolledPropTypes;
/* harmony export (immutable) */ __webpack_exports__["c"] = isProp;
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultKey;
/* harmony export (immutable) */ __webpack_exports__["a"] = canAcceptRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


var noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = noop;

    if (false) {
      var handler = controlledValues[prop];
      !(typeof handler === 'string' && handler.trim().length) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop) : invariant(false) : void 0;
      propTypes[prop] = readOnlyPropType(handler, displayName);
    }
  });
  return propTypes;
}
function isProp(props, prop) {
  return props[prop] !== undefined;
}
function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

function canAcceptRef(component) {
  return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getComputedStyle__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hyphenateStyle__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isTransform__ = __webpack_require__(1245);




function style(node, property) {
  var css = '';
  var transforms = '';

  if (typeof property === 'string') {
    return node.style.getPropertyValue(Object(__WEBPACK_IMPORTED_MODULE_1__hyphenateStyle__["a" /* default */])(property)) || Object(__WEBPACK_IMPORTED_MODULE_0__getComputedStyle__["a" /* default */])(node).getPropertyValue(Object(__WEBPACK_IMPORTED_MODULE_1__hyphenateStyle__["a" /* default */])(property));
  }

  Object.keys(property).forEach(function (key) {
    var value = property[key];

    if (!value && value !== 0) {
      node.style.removeProperty(Object(__WEBPACK_IMPORTED_MODULE_1__hyphenateStyle__["a" /* default */])(key));
    } else if (Object(__WEBPACK_IMPORTED_MODULE_2__isTransform__["a" /* default */])(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += Object(__WEBPACK_IMPORTED_MODULE_1__hyphenateStyle__["a" /* default */])(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += "transform: " + transforms + ";";
  }

  node.style.cssText += ";" + css;
}

/* harmony default export */ __webpack_exports__["a"] = (style);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transitionEnd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__css__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listen__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__triggerEvent__ = __webpack_require__(1250);




function parseDuration(node) {
  var str = Object(__WEBPACK_IMPORTED_MODULE_0__css__["a" /* default */])(node, 'transitionDuration') || '';
  var mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

function emulateTransitionEnd(element, duration, padding) {
  if (padding === void 0) {
    padding = 5;
  }

  var called = false;
  var handle = setTimeout(function () {
    if (!called) Object(__WEBPACK_IMPORTED_MODULE_2__triggerEvent__["a" /* default */])(element, 'transitionend', true);
  }, duration + padding);
  var remove = Object(__WEBPACK_IMPORTED_MODULE_1__listen__["a" /* default */])(element, 'transitionend', function () {
    called = true;
  }, {
    once: true
  });
  return function () {
    clearTimeout(handle);
    remove();
  };
}

function transitionEnd(element, handler, duration, padding) {
  if (duration == null) duration = parseDuration(element) || 0;
  var removeEmulate = emulateTransitionEnd(element, duration, padding);
  var remove = Object(__WEBPACK_IMPORTED_MODULE_1__listen__["a" /* default */])(element, 'transitionend', handler);
  return function () {
    removeEmulate();
    remove();
  };
}

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UNMOUNTED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EXITED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENTERING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENTERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EXITING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_PropTypes__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reflow__ = __webpack_require__(1254);









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) Object(__WEBPACK_IMPORTED_MODULE_8__utils_reflow__["a" /* forceReflow */])(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */].Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children), childProps))
    );
  };

  return Transition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Transition.contextType = __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */];
Transition.propTypes =  false ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ __webpack_exports__["e"] = (Transition);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) return f;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ __webpack_exports__["a"] = (createChainedFunction);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = triggerBrowserReflow;
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var NavContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);
/* harmony default export */ __webpack_exports__["a"] = (NavContext);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uncontrollable__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__restart_hooks_useEventCallback__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createWithBsPrefix__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__divWithClassName__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ThemeProvider__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Fade__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CloseButton__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__ = __webpack_require__(307);












var defaultProps = {
  show: true,
  transition: __WEBPACK_IMPORTED_MODULE_9__Fade__["a" /* default */],
  closeLabel: 'Close alert'
};
var controllables = {
  show: 'onClose'
};
var Alert = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (uncontrolledProps, ref) {
  var _useUncontrolled = Object(__WEBPACK_IMPORTED_MODULE_4_uncontrollable__["a" /* useUncontrolled */])(uncontrolledProps, controllables),
      bsPrefix = _useUncontrolled.bsPrefix,
      show = _useUncontrolled.show,
      closeLabel = _useUncontrolled.closeLabel,
      className = _useUncontrolled.className,
      children = _useUncontrolled.children,
      variant = _useUncontrolled.variant,
      onClose = _useUncontrolled.onClose,
      dismissible = _useUncontrolled.dismissible,
      Transition = _useUncontrolled.transition,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_useUncontrolled, ["bsPrefix", "show", "closeLabel", "className", "children", "variant", "onClose", "dismissible", "transition"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_8__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'alert');
  var handleClose = Object(__WEBPACK_IMPORTED_MODULE_5__restart_hooks_useEventCallback__["a" /* default */])(function (e) {
    onClose(false, e);
  });
  var alert = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "alert"
  }, Transition ? props : undefined, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, prefix, variant && prefix + "-" + variant, dismissible && prefix + "-dismissible")
  }), dismissible && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CloseButton__["a" /* default */], {
    onClick: handleClose,
    label: closeLabel
  }), children);
  if (!Transition) return show ? alert : null;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Transition, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    unmountOnExit: true
  }, props, {
    in: show
  }), alert);
});
var DivStyledAsH4 = Object(__WEBPACK_IMPORTED_MODULE_7__divWithClassName__["a" /* default */])('h4');
DivStyledAsH4.displayName = 'DivStyledAsH4';
Alert.displayName = 'Alert';
Alert.defaultProps = defaultProps;
Alert.Link = Object(__WEBPACK_IMPORTED_MODULE_6__createWithBsPrefix__["a" /* default */])('alert-link', {
  Component: __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__["a" /* default */]
});
Alert.Heading = Object(__WEBPACK_IMPORTED_MODULE_6__createWithBsPrefix__["a" /* default */])('alert-heading', {
  Component: DivStyledAsH4
});
/* harmony default export */ __webpack_exports__["a"] = (Alert);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(49);





var defaultProps = {
  vertical: false,
  toggle: false,
  role: 'group'
};
var ButtonGroup = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (props, ref) {
  var bsPrefix = props.bsPrefix,
      size = props.size,
      toggle = props.toggle,
      vertical = props.vertical,
      className = props.className,
      _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      rest = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["bsPrefix", "size", "toggle", "vertical", "className", "as"]);

  var prefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'btn-group');
  var baseClass = prefix;
  if (vertical) baseClass = prefix + "-vertical";
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, baseClass, size && prefix + "-" + size, toggle && prefix + "-toggle")
  }));
});
ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ButtonGroup);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types_extra_lib_all__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Feedback__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormCheckInput__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormCheckLabel__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormContext__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ThemeProvider__ = __webpack_require__(49);










var defaultProps = {
  type: 'checkbox',
  inline: false,
  disabled: false,
  isValid: false,
  isInvalid: false,
  title: ''
};
var FormCheck = __WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      inline = _ref.inline,
      disabled = _ref.disabled,
      isValid = _ref.isValid,
      isInvalid = _ref.isInvalid,
      feedback = _ref.feedback,
      className = _ref.className,
      style = _ref.style,
      title = _ref.title,
      type = _ref.type,
      label = _ref.label,
      children = _ref.children,
      propCustom = _ref.custom,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'input' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["id", "bsPrefix", "bsCustomPrefix", "inline", "disabled", "isValid", "isInvalid", "feedback", "className", "style", "title", "type", "label", "children", "custom", "as"]);

  var custom = type === 'switch' ? true : propCustom;

  var _ref2 = custom ? [bsCustomPrefix, 'custom-control'] : [bsPrefix, 'form-check'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_9__ThemeProvider__["a" /* useBootstrapPrefix */])(prefix, defaultPrefix);

  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__FormContext__["a" /* default */]),
      controlId = _useContext.controlId;

  var innerFormContext = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
    return {
      controlId: id || controlId,
      custom: custom
    };
  }, [controlId, custom, id]);
  var hasLabel = label != null && label !== false && !children;
  var input = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FormCheckInput__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    type: type === 'switch' ? 'checkbox' : type,
    ref: ref,
    isValid: isValid,
    isInvalid: isInvalid,
    isStatic: !hasLabel,
    disabled: disabled,
    as: as
  }));
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FormContext__["a" /* default */].Provider, {
    value: innerFormContext
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
    style: style,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix, custom && "custom-" + type, inline && bsPrefix + "-inline")
  }, children || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment, null, input, hasLabel && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FormCheckLabel__["a" /* default */], {
    title: title
  }, label), (isValid || isInvalid) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Feedback__["a" /* default */], {
    type: isValid ? 'valid' : 'invalid'
  }, feedback))));
});
FormCheck.displayName = 'FormCheck';
FormCheck.defaultProps = defaultProps;
FormCheck.Input = __WEBPACK_IMPORTED_MODULE_6__FormCheckInput__["a" /* default */];
FormCheck.Label = __WEBPACK_IMPORTED_MODULE_7__FormCheckLabel__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (FormCheck);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_sleep__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aisle_controller__ = __webpack_require__(507);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var COMMAND_INTERVAL_MS=100;var AllAisleTestRunner=function(){function AllAisleTestRunner(_ref){var _this=this;var siteId=_ref.siteId,portIdsByControllerIp=_ref.portIdsByControllerIp,callbackOnStart=_ref.callbackOnStart,callbackOnStop=_ref.callbackOnStop;_classCallCheck(this,AllAisleTestRunner);this.stop=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(_this.isRunning){_this.isRunning=false;}_this.callbackOnStop&&_this.callbackOnStop();_context.next=4;return _this._reset();case 4:case'end':return _context.stop();}}},_callee,_this);}));this.siteId=siteId;this.callbackOnStart=callbackOnStart;this.callbackOnStop=callbackOnStop;this.timeout=null;this.runEndtime=0;this.isRunning=false;this.aisleControllers={};this.aisles=[];for(var controllerIp in portIdsByControllerIp){this.aisleControllers[controllerIp]=new __WEBPACK_IMPORTED_MODULE_2__aisle_controller__["a" /* default */](siteId,controllerIp);var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=portIdsByControllerIp[controllerIp][Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var portId=_step.value;this.aisles.push({controllerIp:controllerIp,portId:portId});}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}}_createClass(AllAisleTestRunner,[{key:'start',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(patternId,durationMs){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.isRunning=true;_context2.prev=1;this.callbackOnStart&&this.callbackOnStart();_context2.next=5;return this._reset();case 5:_context2.next=7;return this._run(patternId,durationMs);case 7:_context2.next=12;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](1);console.log(_context2.t0);case 12:case'end':return _context2.stop();}}},_callee2,this,[[1,9]]);}));function start(_x,_x2){return _ref3.apply(this,arguments);}return start;}()},{key:'_run',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(patternId,durationMs){var portIdsMap,_iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_iterator2,_step2,aisle,ip;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0://we will make two calls one for each ledController in the cluster(Aisles : A1 to A52) to Light Up  Aisles with port ids list as parameter
portIdsMap={};_iteratorNormalCompletion2=true;_didIteratorError2=false;_iteratorError2=undefined;_context3.prev=4;for(_iterator2=this.aisles[Symbol.iterator]();!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){aisle=_step2.value;if(!portIdsMap[aisle.controllerIp]){portIdsMap[aisle.controllerIp]=[];}portIdsMap[aisle.controllerIp].push(aisle.portId);}_context3.next=12;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](4);_didIteratorError2=true;_iteratorError2=_context3.t0;case 12:_context3.prev=12;_context3.prev=13;if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}case 15:_context3.prev=15;if(!_didIteratorError2){_context3.next=18;break;}throw _iteratorError2;case 18:return _context3.finish(15);case 19:return _context3.finish(12);case 20:_context3.t1=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(portIdsMap);case 21:if((_context3.t2=_context3.t1()).done){_context3.next=30;break;}ip=_context3.t2.value;if(!this._shouldContinue()){_context3.next=28;break;}_context3.next=26;return this.aisleControllers[ip].start(portIdsMap[ip],patternId,durationMs);case 26:_context3.next=28;return Object(__WEBPACK_IMPORTED_MODULE_1__util_sleep__["a" /* default */])(COMMAND_INTERVAL_MS);case 28:_context3.next=21;break;case 30:if(!this._shouldContinue()){_context3.next=35;break;}this.timeout=setTimeout(this.stop,durationMs);this._setRunEndtime(durationMs);_context3.next=37;break;case 35:_context3.next=37;return this.stop();case 37:case'end':return _context3.stop();}}},_callee3,this,[[4,8,12,20],[13,,15,19]]);}));function _run(_x3,_x4){return _ref4.apply(this,arguments);}return _run;}()},{key:'_reset',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var stopPromises,controllerIp;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:clearTimeout(this.timeout);this.timeout=null;this.runEndtime=0;stopPromises=[];for(controllerIp in this.aisleControllers){stopPromises.push(this.aisleControllers[controllerIp].stopAll());}_context4.next=7;return Promise.all(stopPromises);case 7:_context4.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1__util_sleep__["a" /* default */])(COMMAND_INTERVAL_MS);case 9:case'end':return _context4.stop();}}},_callee4,this);}));function _reset(){return _ref5.apply(this,arguments);}return _reset;}()},{key:'_setRunEndtime',value:function _setRunEndtime(durationMs){this.runEndtime=Date.now()+parseInt(durationMs,10);}},{key:'_shouldContinue',value:function _shouldContinue(){return this.isRunning;}}]);return AllAisleTestRunner;}();/* harmony default export */ __webpack_exports__["a"] = (AllAisleTestRunner);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__ = __webpack_require__(51);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var AisleController=function(){function AisleController(siteId,controllerIp){_classCallCheck(this,AisleController);this.siteId=siteId;this.controllerIp=controllerIp;}_createClass(AisleController,[{key:"start",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(portIds,patternId,durationMs){var request,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:request={nodeId:this.siteId,assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_97" /* LED_CONTROLLER_ASSET_TYPE */],commandParams:{locationType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["j" /* AISLE */],state:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_146" /* ON_STATE */],color:patternId,durationMs:durationMs.toString(),controllerIp:this._getLedControllerId(),portIds:portIds}};args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_59" /* ENDPOINT_PUBLISH_LIGHT_COMMAND_TO_THIN_CLIENT */]);_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:case"end":return _context.stop();}}},_callee,this);}));function start(_x,_x2,_x3){return _ref.apply(this,arguments);}return start;}()},{key:"stopAll",value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var request,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:request={nodeId:this.siteId,assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_97" /* LED_CONTROLLER_ASSET_TYPE */],commandParams:{locationType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["j" /* AISLE */],state:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_144" /* OFF_STATE */],controllerIp:this._getLedControllerId()}};args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_59" /* ENDPOINT_PUBLISH_LIGHT_COMMAND_TO_THIN_CLIENT */]);_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:case"end":return _context2.stop();}}},_callee2,this);}));function stopAll(){return _ref2.apply(this,arguments);}return stopAll;}()},{key:"_getLedControllerId",value:function _getLedControllerId(){return this.controllerIp==null?'':this.controllerIp;}}]);return AisleController;}();/* harmony default export */ __webpack_exports__["a"] = (AisleController);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_TEST_DURATION_IN_MS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bootstrap_Form__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_duration__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_duration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_humanize_duration__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DEFAULT_TEST_DURATION_IN_MS=1*60*1000;// 1 min
var DURATIONS=[DEFAULT_TEST_DURATION_IN_MS,3*60*1000,// 3 mins
5*60*1000];var TestDurationPicker=function(_React$Component){_inherits(TestDurationPicker,_React$Component);function TestDurationPicker(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TestDurationPicker);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TestDurationPicker.__proto__||Object.getPrototypeOf(TestDurationPicker)).call.apply(_ref,[this].concat(args))),_this),_this.handleTestDurationChange=function(event){var testDuration=event.target.value;_this.props.onChange(testDuration);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TestDurationPicker,[{key:'renderTestDurationOptions',value:function renderTestDurationOptions(){return DURATIONS.map(function(value){var label=__WEBPACK_IMPORTED_MODULE_2_humanize_duration___default()(value);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:label,value:value},label);});}},{key:'render',value:function render(){var testDuration=this.props.testDuration;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_bootstrap_Form__["a" /* default */].Group,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_bootstrap_Form__["a" /* default */].Label,null,'Test Duration'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_bootstrap_Form__["a" /* default */].Control,{as:'select',value:testDuration,onChange:this.handleTestDurationChange,disabled:this.props.disabled},this.renderTestDurationOptions()));}}]);return TestDurationPicker;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["b"] = (TestDurationPicker);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CONFIG_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COLUMN_TYPES; });
/* unused harmony export canonicalizeTierOrder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return parseAisleConfigName; });
/* unused harmony export tokenizeAisleCode */
/* unused harmony export getVisualTokens */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getVisualColumns; });
/* unused harmony export filterAisleConfigs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALLOWED_COLUMN_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUILDER_COLUMN_MODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createInitialColumnModes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return cycleColumnMode; });
/* unused harmony export DEFAULT_FLEX_OV_LETTERS */
/* unused harmony export getSelectedFlexLabels */
/* unused harmony export chunkFlexFootprints */
/* unused harmony export resolveFlexOvPairs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BUILDER_VALIDATION_CODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return buildRackDescription; });
/* unused harmony export getVisualStructureSignature */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return findConfigsByRackDescription; });
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var CONFIG_NAME_PATTERN=/^(?:[0-9a-f]{32}_)?aisle-config-(na|eu|fe)-4tier-(?:(\d{4})-)?(.+)$/i;var MODERN_DUAL_MARKER=/^(.*?)-(?:split)?OVDflexrack-(.*)$/i;var LEGACY_PARTITIONED_SUFFIX=/^(.*?)-OVDflexrack[^-]*$/i;var LEGACY_DUAL_MARKER=/^(.*?)-OVD-(.*)$/i;var STANDARD_OV_SUFFIX=/^(.*?)-splitOVrack$/i;var LEGACY_OV_SUFFIX=/^(.*?)-OVD$/i;var UPLOAD_PREFIX=/^[0-9a-f]{32}_/i;var KNOWN_MODIFIERS=/-(?:6thLightDisabled)$/i;var CONFIG_TYPES={BAG:'bag',OV:'ov',FULL_HEIGHT_FLEX:'full-height-flex',PARTITIONED_FLEX:'partitioned-flex',LEGACY_DUAL:'legacy-dual'};var COLUMN_TYPES={BAG:'bag',OV:'ov',FLEX:'flex',PARTITIONED_FLEX:'partitioned-flex',PILLAR:'pillar'};var stripPathAndExtension=function stripPathAndExtension(value){var fileName=String(value||'').split('/').pop();return fileName.replace(UPLOAD_PREFIX,'').replace(/\.json$/i,'');};var stripKnownModifiers=function stripKnownModifiers(value){return String(value||'').replace(KNOWN_MODIFIERS,'');};/*
 * Tier digits are encoded as <tier><column> pairs, e.g. "3k4k3l4l". Both the canonicaliser and the
 * partitioned-group tokenizer need the same two primitives, so they live here once.
 */// Reads consecutive <tier><column> pairs starting at startIndex, stopping at the first non-pair.
var readTierColumnPairs=function readTierColumnPairs(code){var startIndex=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var pairs=[];var index=startIndex;while(/[1-4]/.test(code[index]||'')&&/[a-z]/.test(code[index+1]||'')){pairs.push({tier:Number(code[index]),column:code[index+1]});index+=2;}return{pairs:pairs,nextIndex:index};};// Groups pairs by column, preserving first-appearance order of the columns themselves.
var groupTiersByColumn=function groupTiersByColumn(pairs){var columnOrder=[];var tiersByColumn={};pairs.forEach(function(_ref){var tier=_ref.tier,column=_ref.column;if(!tiersByColumn[column]){tiersByColumn[column]=[];columnOrder.push(column);}tiersByColumn[column].push(tier);});return{columnOrder:columnOrder,tiersByColumn:tiersByColumn};};var canonicalizeTierOrder=function canonicalizeTierOrder(code){return String(code||'').replace(/(?:[1-4][a-z])+/g,function(group){var _readTierColumnPairs=readTierColumnPairs(group),pairs=_readTierColumnPairs.pairs;var _groupTiersByColumn=groupTiersByColumn(pairs),columnOrder=_groupTiersByColumn.columnOrder,tiersByColumn=_groupTiersByColumn.tiersByColumn;return columnOrder.map(function(column){return[].concat(_toConsumableArray(new Set(tiersByColumn[column]))).sort(function(left,right){return left-right;}).map(function(tier){return''+tier+column;}).join('');}).join('');});};var parseAisleConfigName=function parseAisleConfigName(configName){var normalizedName=stripPathAndExtension(configName);var match=normalizedName.match(CONFIG_NAME_PATTERN);if(!match){return null;}var _match=_slicedToArray(match,4),region=_match[1],year=_match[2],rawRemainder=_match[3];var remainder=stripKnownModifiers(rawRemainder);var aisleCode=remainder;var alternateCode=null;var configType=CONFIG_TYPES.BAG;var namingConvention='canonical';var modernDual=remainder.match(MODERN_DUAL_MARKER);var legacyPartitioned=remainder.match(LEGACY_PARTITIONED_SUFFIX);var legacyDual=remainder.match(LEGACY_DUAL_MARKER);var standardOv=remainder.match(STANDARD_OV_SUFFIX);var legacyOv=remainder.match(LEGACY_OV_SUFFIX);if(modernDual){alternateCode=modernDual[1];aisleCode=modernDual[2];configType=CONFIG_TYPES.FULL_HEIGHT_FLEX;}else if(legacyPartitioned){aisleCode=legacyPartitioned[1];configType=CONFIG_TYPES.PARTITIONED_FLEX;namingConvention='legacy';}else if(legacyDual){aisleCode=legacyDual[1];alternateCode=legacyDual[2];configType=CONFIG_TYPES.LEGACY_DUAL;namingConvention='legacy';}else if(standardOv){aisleCode=standardOv[1];configType=CONFIG_TYPES.OV;}else if(legacyOv){aisleCode=legacyOv[1];configType=CONFIG_TYPES.OV;namingConvention='legacy';}if(/[1-4][a-z]/.test(aisleCode)){configType=CONFIG_TYPES.PARTITIONED_FLEX;}else if(configType===CONFIG_TYPES.BAG&&/[A-Z]/.test(aisleCode)){configType=CONFIG_TYPES.OV;}return{name:configName,normalizedName:normalizedName,region:region.toUpperCase(),year:year||null,aisleCode:aisleCode,canonicalAisleCode:canonicalizeTierOrder(aisleCode),alternateCode:alternateCode,canonicalAlternateCode:alternateCode?canonicalizeTierOrder(alternateCode):null,configType:configType,namingConvention:namingConvention};};var tokenizePartitionedGroup=function tokenizePartitionedGroup(code,startIndex){var _readTierColumnPairs2=readTierColumnPairs(code,startIndex),pairs=_readTierColumnPairs2.pairs,tiersEndIndex=_readTierColumnPairs2.nextIndex;var _groupTiersByColumn2=groupTiersByColumn(pairs),columnOrder=_groupTiersByColumn2.columnOrder,tiersByColumn=_groupTiersByColumn2.tiersByColumn;var index=tiersEndIndex;var footprintCount=Math.ceil(columnOrder.length/2);var ovLabels=[];for(var footprint=0;footprint<footprintCount&&/[A-Z]/.test(code[index]||'');footprint+=1){ovLabels.push(code[index]);index+=1;}var tokens=[];for(var _footprint=0;_footprint<footprintCount;_footprint+=1){var columns=columnOrder.slice(_footprint*2,_footprint*2+2);tokens.push({type:COLUMN_TYPES.PARTITIONED_FLEX,columns:columns,tiersByColumn:tiersByColumn,ovLabel:ovLabels[_footprint]||''});}return{tokens:tokens,nextIndex:index};};var tokenizeAisleCode=function tokenizeAisleCode(code){var tokens=[];var index=0;while(index<String(code||'').length){var character=code[index];if(character==='_'){tokens.push({type:COLUMN_TYPES.PILLAR,label:'_'});index+=1;}else if(/[1-4]/.test(character)&&/[a-z]/.test(code[index+1]||'')){var partitioned=tokenizePartitionedGroup(code,index);tokens.push.apply(tokens,_toConsumableArray(partitioned.tokens));index=partitioned.nextIndex;}else if(/[a-z]/.test(character)){tokens.push({type:COLUMN_TYPES.BAG,label:character});index+=1;}else if(/[A-Z]/.test(character)){if(/[A-Z]/.test(code[index+1]||'')){tokens.push({type:COLUMN_TYPES.OV,labels:[character,code[index+1]],split:true});index+=2;}else{tokens.push({type:COLUMN_TYPES.OV,labels:[character],split:false});index+=1;}}else{index+=1;}}return tokens;};var getCommonEdges=function getCommonEdges(bagCode,ovCode){var prefixLength=0;while(prefixLength<bagCode.length&&prefixLength<ovCode.length&&bagCode[prefixLength]===ovCode[prefixLength]){prefixLength+=1;}var suffixLength=0;while(suffixLength<bagCode.length-prefixLength&&suffixLength<ovCode.length-prefixLength&&bagCode[bagCode.length-1-suffixLength]===ovCode[ovCode.length-1-suffixLength]){suffixLength+=1;}return{prefixLength:prefixLength,suffixLength:suffixLength};};var getVisualTokens=function getVisualTokens(parsedConfig){if(!parsedConfig){return[];}if(parsedConfig.configType!==CONFIG_TYPES.FULL_HEIGHT_FLEX||!parsedConfig.alternateCode){return tokenizeAisleCode(parsedConfig.aisleCode);}var bagCode=parsedConfig.aisleCode;var ovCode=parsedConfig.alternateCode;var _getCommonEdges=getCommonEdges(bagCode,ovCode),prefixLength=_getCommonEdges.prefixLength,suffixLength=_getCommonEdges.suffixLength;var suffixStartForBag=bagCode.length-suffixLength;var suffixStartForOv=ovCode.length-suffixLength;var bagFlex=bagCode.slice(prefixLength,suffixStartForBag).replace(/[^a-z]/g,'');var ovFlex=ovCode.slice(prefixLength,suffixStartForOv).replace(/[^A-Z]/g,'');var prefix=tokenizeAisleCode(bagCode.slice(0,prefixLength));var suffix=tokenizeAisleCode(bagCode.slice(suffixStartForBag));var flex=[];// One physical full-tier footprint contains two bag columns in bag mode and
// two vertically stacked OV bins in OV mode.
for(var index=0;index<Math.max(bagFlex.length,ovFlex.length);index+=2){flex.push({type:COLUMN_TYPES.FLEX,bagLabels:bagFlex.slice(index,index+2).split(''),ovLabels:ovFlex.slice(index,index+2).split('')});}return[].concat(_toConsumableArray(prefix),flex,_toConsumableArray(suffix));};// Column labels are structural tokens shared by the parse and builder paths (they feed the
// structural match signature); the view layer localizes any display wording separately.
var getVisualColumns=function getVisualColumns(parsedConfig){return getVisualTokens(parsedConfig).reduce(function(columns,token){if(token.type===COLUMN_TYPES.PILLAR){columns.push({type:COLUMN_TYPES.PILLAR,label:'Pillar'});}else if(token.type===COLUMN_TYPES.BAG){columns.push({type:COLUMN_TYPES.BAG,label:token.label,bagTiers:[1,2,3,4]});}else if(token.type===COLUMN_TYPES.OV){// One token = one physical column position: a split pair (top, bottom) or a full bin.
columns.push({type:COLUMN_TYPES.OV,label:token.labels.join(' / '),ovLabels:[].concat(_toConsumableArray(token.labels)),split:token.labels.length===2,bagTiers:[]});}else if(token.type===COLUMN_TYPES.FLEX){var bagLabels=token.bagLabels||[token.bagLabel].filter(Boolean);var ovLabels=token.ovLabels||[token.ovLabel].filter(Boolean);columns.push({type:COLUMN_TYPES.FLEX,label:bagLabels.join(' + ')||'?',bagLabels:bagLabels,ovLabels:ovLabels,bagTiers:[1,2,3,4]});}else if(token.type===COLUMN_TYPES.PARTITIONED_FLEX){token.columns.forEach(function(column){return columns.push({type:COLUMN_TYPES.PARTITIONED_FLEX,label:token.ovLabel?column+' / '+token.ovLabel:column,bagTiers:[].concat(_toConsumableArray(new Set(token.tiersByColumn[column]||[]))).sort(function(left,right){return left-right;})});});}return columns;},[]);};var filterAisleConfigs=function filterAisleConfigs(configNames){var _ref2=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},_ref2$query=_ref2.query,query=_ref2$query===undefined?'':_ref2$query,_ref2$region=_ref2.region,region=_ref2$region===undefined?'ALL':_ref2$region,_ref2$year=_ref2.year,year=_ref2$year===undefined?'ALL':_ref2$year;var normalizedQuery=query.trim().toLowerCase();return(configNames||[]).map(function(name){return{name:name,parsed:parseAisleConfigName(name)};}).filter(function(_ref3){var name=_ref3.name,parsed=_ref3.parsed;if(!parsed){return false;}var queryMatches=!normalizedQuery||[name,parsed.aisleCode,parsed.alternateCode||'',parsed.canonicalAisleCode,parsed.canonicalAlternateCode||''].some(function(value){return String(value).toLowerCase().includes(normalizedQuery);});return queryMatches&&(region==='ALL'||parsed.region===region)&&(year==='ALL'||parsed.year===year);}).sort(function(left,right){return String(left.name).localeCompare(String(right.name));}).map(function(_ref4){var name=_ref4.name;return name;});};var ALLOWED_COLUMN_LABELS=['a','b','c','d','e','g','h','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];var BUILDER_COLUMN_MODES={ABSENT:'absent',BAG:COLUMN_TYPES.BAG,OV:COLUMN_TYPES.OV,FLEX:COLUMN_TYPES.FLEX};var createInitialColumnModes=function createInitialColumnModes(){return ALLOWED_COLUMN_LABELS.reduce(function(modes,label){return Object.assign({},modes,_defineProperty({},label,BUILDER_COLUMN_MODES.ABSENT));},{});};var cycleColumnMode=function cycleColumnMode(mode){var _BUILDER_COLUMN_MODES;return(_BUILDER_COLUMN_MODES={},_defineProperty(_BUILDER_COLUMN_MODES,BUILDER_COLUMN_MODES.ABSENT,BUILDER_COLUMN_MODES.BAG),_defineProperty(_BUILDER_COLUMN_MODES,BUILDER_COLUMN_MODES.BAG,BUILDER_COLUMN_MODES.OV),_defineProperty(_BUILDER_COLUMN_MODES,BUILDER_COLUMN_MODES.OV,BUILDER_COLUMN_MODES.FLEX),_defineProperty(_BUILDER_COLUMN_MODES,BUILDER_COLUMN_MODES.FLEX,BUILDER_COLUMN_MODES.ABSENT),_BUILDER_COLUMN_MODES)[mode]||BUILDER_COLUMN_MODES.BAG;};var DEFAULT_FLEX_OV_LETTERS=['T','U','P','R','W','X','Y','Z','S','V','Q','N'];var getSelectedFlexLabels=function getSelectedFlexLabels(columnModes){return ALLOWED_COLUMN_LABELS.filter(function(label){return columnModes[label]===BUILDER_COLUMN_MODES.FLEX;});};// Generator ground truth: a full-tier flex zone is a chain of footprints, each made of
// exactly TWO bag columns that convert together into TWO stacked OV bins (top, bottom).
// The builder supports full-height flex only; half-height (partitioned) configs remain
// parse/preview-only for existing production filenames.
var chunkFlexFootprints=function chunkFlexFootprints(flexLabels){var footprints=[];for(var index=0;index<(flexLabels||[]).length;index+=2){footprints.push(flexLabels.slice(index,index+2));}return footprints;};var resolveFlexOvPairs=function resolveFlexOvPairs(footprintCount){var overridePairs=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var usedLetters=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var taken=new Set(usedLetters.map(function(letter){return String(letter||'').toUpperCase();}));overridePairs.forEach(function(pair){return(pair||[]).forEach(function(letter){return letter&&taken.add(String(letter).toUpperCase());});});var available=DEFAULT_FLEX_OV_LETTERS.filter(function(letter){return!taken.has(letter);});var pairs=[];for(var index=0;index<footprintCount;index+=1){var override=overridePairs[index];if(override&&override[0]&&override[1]){pairs.push([String(override[0]).toUpperCase(),String(override[1]).toUpperCase()]);}else{pairs.push([available.shift()||'?',available.shift()||'?']);}}return pairs;};var getModeCharacter=function getModeCharacter(label,mode){if(mode===BUILDER_COLUMN_MODES.BAG){return label;}if(mode===BUILDER_COLUMN_MODES.OV){return label.toUpperCase();}return'';};var appendPillarTo=function appendPillarTo(code,label,pillars){return pillars.includes(label)&&code?code+'_':code;};// Validation errors are machine-readable {code, params} descriptors: the model stays free
// of user-facing prose so the UI can localize every message (react-intl) from the code.
var BUILDER_VALIDATION_CODES={FLEX_PAIRS_REQUIRED:'FLEX_PAIRS_REQUIRED',FLEX_NOT_ADJACENT:'FLEX_NOT_ADJACENT',PILLAR_INSIDE_FLEX_ZONE:'PILLAR_INSIDE_FLEX_ZONE',FLEX_OV_LABELS_NOT_UNIQUE:'FLEX_OV_LABELS_NOT_UNIQUE',FLEX_OV_LABEL_REUSED:'FLEX_OV_LABEL_REUSED',NO_COLUMNS_SELECTED:'NO_COLUMNS_SELECTED'};var validateFlexSelection=function validateFlexSelection(_ref5){var flexLabels=_ref5.flexLabels,ovPairs=_ref5.ovPairs,columnModes=_ref5.columnModes,pillars=_ref5.pillars;if(flexLabels.length===0){return[];}var errors=[];if(flexLabels.length%2!==0){errors.push({code:BUILDER_VALIDATION_CODES.FLEX_PAIRS_REQUIRED,params:{count:flexLabels.length}});}var activeLabels=ALLOWED_COLUMN_LABELS.filter(function(label){return columnModes[label]!==BUILDER_COLUMN_MODES.ABSENT;});var zoneStart=activeLabels.indexOf(flexLabels[0]);if(!flexLabels.every(function(label,index){return activeLabels.indexOf(label)===zoneStart+index;})){errors.push({code:BUILDER_VALIDATION_CODES.FLEX_NOT_ADJACENT,params:{columns:flexLabels.join(', ')}});}var pillarsInsideZone=flexLabels.slice(0,-1).filter(function(label){return pillars.includes(label);});if(pillarsInsideZone.length>0){errors.push({code:BUILDER_VALIDATION_CODES.PILLAR_INSIDE_FLEX_ZONE,params:{columns:pillarsInsideZone.join(', ')}});}var flatLetters=ovPairs.reduce(function(letters,pair){return[].concat(_toConsumableArray(letters),_toConsumableArray(pair));},[]);if(ovPairs.some(function(pair){return pair[0]===pair[1];})||new Set(flatLetters).size!==flatLetters.length){errors.push({code:BUILDER_VALIDATION_CODES.FLEX_OV_LABELS_NOT_UNIQUE,params:{}});}var reusedLetters=flatLetters.filter(function(letter){var gridMode=columnModes[String(letter).toLowerCase()];return gridMode===BUILDER_COLUMN_MODES.BAG||gridMode===BUILDER_COLUMN_MODES.OV;});if(reusedLetters.length>0){errors.push({code:BUILDER_VALIDATION_CODES.FLEX_OV_LABEL_REUSED,params:{letters:[].concat(_toConsumableArray(new Set(reusedLetters))).join(', ')}});}return errors;};var buildRackCodes=function buildRackCodes(_ref6){var columnModes=_ref6.columnModes,pillars=_ref6.pillars,flexLabels=_ref6.flexLabels,ovPairs=_ref6.ovPairs;var footprints=chunkFlexFootprints(flexLabels);var lastFlexLabel=flexLabels[flexLabels.length-1];var bagCode='';var ovCode='';var zoneEmitted=false;ALLOWED_COLUMN_LABELS.forEach(function(label){var mode=columnModes[label];if(mode===BUILDER_COLUMN_MODES.ABSENT){return;}if(mode===BUILDER_COLUMN_MODES.FLEX){if(!zoneEmitted){bagCode+=flexLabels.join('');ovCode+=footprints.map(function(footprint,index){return(ovPairs[index]||[]).join('');}).join('');zoneEmitted=true;}if(label===lastFlexLabel){bagCode=appendPillarTo(bagCode,label,pillars);ovCode=appendPillarTo(ovCode,label,pillars);}return;}var character=getModeCharacter(label,mode);bagCode=appendPillarTo(''+bagCode+character,label,pillars);ovCode=appendPillarTo(''+ovCode+character,label,pillars);});if(flexLabels.length===0){return{aisleCode:bagCode,bagCode:null,ovCode:null};}return{aisleCode:bagCode,bagCode:bagCode,ovCode:ovCode};};var buildBuilderVisualColumns=function buildBuilderVisualColumns(_ref7){var columnModes=_ref7.columnModes,pillars=_ref7.pillars,flexLabels=_ref7.flexLabels,ovPairs=_ref7.ovPairs;var footprints=chunkFlexFootprints(flexLabels);var lastFlexLabel=flexLabels[flexLabels.length-1];var columns=[];var zoneEmitted=false;var ovRun=[];// Consecutive OV letters pair into split-OV columns (first letter = top bin, second =
// bottom bin); a trailing unpaired letter is one full-height OV bin. Pillars, bag
// columns, and flex zones break the pairing run, matching the generator tokenizer.
var flushOvRun=function flushOvRun(){for(var index=0;index<ovRun.length;index+=2){var binLabels=ovRun.slice(index,index+2);columns.push({type:COLUMN_TYPES.OV,label:binLabels.join(' / '),ovLabels:binLabels,split:binLabels.length===2,bagTiers:[]});}ovRun=[];};var pushPillar=function pushPillar(label){if(pillars.includes(label)){columns.push({type:COLUMN_TYPES.PILLAR,label:'Pillar'});}};ALLOWED_COLUMN_LABELS.forEach(function(label){var mode=columnModes[label];if(mode===BUILDER_COLUMN_MODES.ABSENT){return;}if(mode===BUILDER_COLUMN_MODES.OV){ovRun.push(label.toUpperCase());if(pillars.includes(label)){flushOvRun();pushPillar(label);}return;}flushOvRun();if(mode===BUILDER_COLUMN_MODES.FLEX){if(!zoneEmitted){footprints.forEach(function(footprint,index){columns.push({type:COLUMN_TYPES.FLEX,label:footprint.join(' + '),bagLabels:footprint,ovLabels:ovPairs[index]||['?','?'],bagTiers:[1,2,3,4]});});zoneEmitted=true;}if(label===lastFlexLabel){pushPillar(label);}return;}columns.push({type:COLUMN_TYPES.BAG,label:label,bagTiers:[1,2,3,4]});pushPillar(label);});flushOvRun();return columns;};var buildRackDescription=function buildRackDescription(_ref8){var region=_ref8.region,columnModes=_ref8.columnModes,_ref8$pillars=_ref8.pillars,pillars=_ref8$pillars===undefined?[]:_ref8$pillars,_ref8$flexOvLabels=_ref8.flexOvLabels,flexOvLabels=_ref8$flexOvLabels===undefined?[]:_ref8$flexOvLabels;var flexLabels=getSelectedFlexLabels(columnModes);var footprintCount=Math.ceil(flexLabels.length/2);var gridOvLetters=ALLOWED_COLUMN_LABELS.filter(function(label){return columnModes[label]===BUILDER_COLUMN_MODES.OV;}).map(function(label){return label.toUpperCase();});var ovPairs=flexLabels.length===0?[]:resolveFlexOvPairs(footprintCount,flexOvLabels,gridOvLetters);var errors=validateFlexSelection({flexLabels:flexLabels,ovPairs:ovPairs,columnModes:columnModes,pillars:pillars});var codes=buildRackCodes({columnModes:columnModes,pillars:pillars,flexLabels:flexLabels,ovPairs:ovPairs});var normalizedRegion=String(region||'').toUpperCase();// The generator stamps the current year into new filenames; matching ignores years.
var baseName='aisle-config-'+normalizedRegion.toLowerCase()+'-4tier-'+new Date().getFullYear();var candidateName=void 0;if(flexLabels.length>0){var marker=normalizedRegion==='EU'?'splitOVDflexrack':'SplitOVDflexrack';candidateName=baseName+'-'+codes.ovCode+'-'+marker+'-'+codes.bagCode;}else if(/[A-Z]/.test(codes.aisleCode)){candidateName=baseName+'-'+codes.aisleCode+'-splitOVrack';}else{candidateName=baseName+'-'+codes.aisleCode;}var columns=buildBuilderVisualColumns({columnModes:columnModes,pillars:pillars,flexLabels:flexLabels,ovPairs:ovPairs});if(columns.length===0){errors.push({code:BUILDER_VALIDATION_CODES.NO_COLUMNS_SELECTED,params:{}});}return{region:normalizedRegion,aisleCode:codes.aisleCode,bagCode:codes.bagCode,ovCode:codes.ovCode,candidateName:candidateName,columns:columns,flexLabels:flexLabels,footprints:chunkFlexFootprints(flexLabels).map(function(bagLabels,index){return{bagLabels:bagLabels,ovLabels:ovPairs[index]||[]};}),errors:errors};};var getVisualStructureSignature=function getVisualStructureSignature(columns){return JSON.stringify((columns||[]).map(function(column){return{type:column.type,label:column.label,bagLabels:[].concat(_toConsumableArray(column.bagLabels||[])),ovLabels:[].concat(_toConsumableArray(column.ovLabels||[])),bagTiers:[].concat(_toConsumableArray(column.bagTiers||[])).sort(function(left,right){return left-right;})};}));};// Year-agnostic on purpose: the same physical rack keeps matching a config generated in any
// prior year, and legacy names without a year segment are equally valid matches.
var findConfigsByRackDescription=function findConfigsByRackDescription(configNames,rackDescription){if(!rackDescription||rackDescription.errors.length>0){return[];}var requestedSignature=getVisualStructureSignature(rackDescription.columns);return(configNames||[]).filter(function(name){var parsed=parseAisleConfigName(name);return parsed&&parsed.region===rackDescription.region&&getVisualStructureSignature(getVisualColumns(parsed))===requestedSignature;}).sort(function(left,right){return String(left).localeCompare(String(right));});};

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RACK_ZONE_COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STATUS_COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getZoneFill; });
/*
 * Single source of truth for every raw colour value used by the aisle config builder and preview.
 *
 * The builder grid and the preview table must stay visually consistent: a Bag column painted in the
 * builder has to read as the same colour in the rack preview and in the preview legend. Keeping the
 * swatches here means a recolour is a one-file change instead of three files drifting apart.
 *
 * Meridian 4 (the version this package is pinned to) exposes no colour token module, so these are
 * literal hex values. When the package moves to Meridian 6, this file is the only place that has to
 * be swapped over to design tokens.
 */// Base swatches. Nothing outside this file should reference a hex value directly.
var SWATCH={GREEN:{backgroundColor:'#e6f4ea',borderColor:'#34a853',color:'#1e4620'},BLUE:{backgroundColor:'#e8f0fe',borderColor:'#4285f4',color:'#174ea6'},AMBER:{backgroundColor:'#fff4e5',borderColor:'#e77600',color:'#8a4b08'},GREY:{backgroundColor:'#f5f7f8',borderColor:'#d9e2e8',color:'#6b7a85'},SLATE:{backgroundColor:'#f1f3f4',borderColor:'#d5dbdb',color:'#5f6368'}};// Rack zone semantics: builder column tiles, preview cells, and the preview legend.
var RACK_ZONE_COLORS={BAG:SWATCH.GREEN,OV:SWATCH.BLUE,FLEX:SWATCH.AMBER,ABSENT:SWATCH.GREY,PILLAR:SWATCH.SLATE};// Match-status semantics, kept deliberately separate from the rack zones even though the swatches
// currently coincide, so that recolouring a rack zone cannot silently restyle the match chip.
var STATUS_COLORS={MATCHED:SWATCH.GREEN,UNMATCHED:SWATCH.AMBER};// Preview table cells paint fill and text only; their border comes from the shared cell style.
var getZoneFill=function getZoneFill(_ref){var backgroundColor=_ref.backgroundColor,color=_ref.color;return{backgroundColor:backgroundColor,color:color};};

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context_TrafficLightOverviewContext__ = __webpack_require__(121);
var UpdateDeviceDetailsResponse=function UpdateDeviceDetailsResponse(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__context_TrafficLightOverviewContext__["a" /* TrafficLightDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var getModalType=function getModalType(updateResponseModalType){if(updateResponseModalType===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_135" /* MODAL_SUCCESS */])return"success";else if(updateResponseModalType===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_133" /* MODAL_ERROR */])return"error";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default.a,{open:viewModel.showResponseModal===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_135" /* MODAL_SUCCESS */]||viewModel.showResponseModal===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_133" /* MODAL_ERROR */],closeLabel:"Close",describedById:"modal-description",width:"500"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert___default.a,{type:getModalType(viewModel.showResponseModal),size:"xlarge"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"message",defaultMessage:"{message}",values:{message:viewModel.modalMessageToDisplay}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{type:"secondary",size:"small",onClick:function onClick(){return dispatch({type:"SHOW_UPDATE_RESPONSE_MODAL",data:{modalState:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_134" /* MODAL_RESET */],message:''}});}},"Close"))));};/* harmony default export */ __webpack_exports__["a"] = (UpdateDeviceDetailsResponse);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchZancaSortDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["c"] = setZancaSortDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateZancaSortDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteZancaSortDeviceDetails;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateZancaSortDeviceMac; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateZancaSortConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateAssetAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateZancaSortMonitoringDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datamodel_ZancaSortAssetModelResource__ = __webpack_require__(1320);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var addZancaSortDeviceDetails=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatcher,request,showCustomAlert){var _this=this;var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:startTime=Date.now();_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_29" /* setAliasToRequest */])(request);case 3:Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["a" /* addAsset */])(request).then(function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(result){var isFault,getAssetResult,responseSetAssetStatus,responseUpdateAsset,isFaultInUpdateAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(!(result.status===200)){_context4.next=4;break;}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addZancaSortDeviceDetails",true,false);_context4.next=28;break;case 4:// 500 response status can be for any reason. One of those is : asset already exists so trying to update it.
// UpdateAsset only works on ACTIVE devices so first setting status as ACTIVE.
isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(result.status);_context4.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 7:getAssetResult=_context4.sent;if(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(getAssetResult.data.asset.assetDetails.assetStatus)){_context4.next=12;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["B" /* ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addZancaSortDeviceDetails",false,isFault);return _context4.abrupt("return");case 12:_context4.next=14;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);case 14:responseSetAssetStatus=_context4.sent;if(!(responseSetAssetStatus.status!==200)){_context4.next=19;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addZancaSortDeviceDetails",false,isFault);return _context4.abrupt("return");case 19:_context4.next=21;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 21:responseUpdateAsset=_context4.sent;if(!(responseUpdateAsset.status!==200)){_context4.next=27;break;}isFaultInUpdateAsset=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(responseUpdateAsset.status);showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addZancaSortDeviceDetails",false,isFaultInUpdateAsset);return _context4.abrupt("return");case 27:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addZancaSortDeviceDetails",true,false);case 28:fetchZancaSortDeviceDetails(dispatcher);case 29:case"end":return _context4.stop();}}},_callee4,_this);}));return function(_x17){return _ref5.apply(this,arguments);};}());case 4:case"end":return _context5.stop();}}},_callee5,this);}));return function addZancaSortDeviceDetails(_x14,_x15,_x16){return _ref4.apply(this,arguments);};}();var updateZancaSortAsset=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatcher,request,showCustomAlert){var setAssetStatusResponse,startTime,getAssetResult,updateAssetResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);case 2:setAssetStatusResponse=_context6.sent;if(!(setAssetStatusResponse.status!==200)){_context6.next=7;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);fetchZancaSortDeviceDetails(dispatcher);return _context6.abrupt("return");case 7:// Update asset details
startTime=Date.now();_context6.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_29" /* setAliasToRequest */])(request);case 10:_context6.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 12:getAssetResult=_context6.sent;_context6.next=15;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 15:updateAssetResponse=_context6.sent;isSuccess=updateAssetResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateAssetResponse.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateZancaSortDeviceDetails",isSuccess,isFault);fetchZancaSortDeviceDetails(dispatcher);case 20:case"end":return _context6.stop();}}},_callee6,this);}));return function updateZancaSortAsset(_x18,_x19,_x20){return _ref6.apply(this,arguments);};}();var getZancaSortDeviceDetails=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatcher,request){var model;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:model={zancaSortDeviceInformation:{},testConfig:{},locationConfig:{},tierConfig:{},macAddressArray:[]// Fetch static asset details
};_context7.next=3;return getZancaSortDeviceStaticDetails(dispatcher,model,request);case 3:case"end":return _context7.stop();}}},_callee7,this);}));return function getZancaSortDeviceDetails(_x21,_x22){return _ref7.apply(this,arguments);};}();var getZancaSortDeviceStaticDetails=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatcher,model,request){var pageToken,startTime,getAssetsResult,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:pageToken=null;// do-while loop until we get a valid pageToken
case 1:startTime=Date.now();_context8.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["g" /* getAssets */])(request.nodeId,request.assetType,pageToken);case 4:getAssetsResult=_context8.sent;isSuccess=getAssetsResult.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(getAssetsResult.status);// Log operation
Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getZancaSortDeviceDetails",isSuccess,isFault);if(isSuccess){addZancaSortDeviceStaticDetailsToModel(getAssetsResult,model);// modifying pageToken to fetch from the latest get assets' result
pageToken=getAssetsResult.data.pageToken;}else{dispatcher({type:"RECEIVE_DATA",data:[]});}case 9:if(pageToken){_context8.next=1;break;}case 10:dispatcher({type:"RECEIVE_DATA",data:model});case 11:case"end":return _context8.stop();}}},_callee8,this);}));return function getZancaSortDeviceStaticDetails(_x23,_x24,_x25){return _ref8.apply(this,arguments);};}();var setAssetLabelDeprecatedZancaSortDeviceDetails=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatcher,request){var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:startTime=Date.now();Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetLabel,request.assetStatus).then(function(result){if(result.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteZancaSortDeviceDetails",true,false);fetchZancaSortDeviceDetails(dispatcher);}else{var isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(result.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteZancaSortDeviceDetails",false,isFault);dispatcher({type:"RECEIVE_DATA",data:[]});}});case 2:case"end":return _context9.stop();}}},_callee9,this);}));return function setAssetLabelDeprecatedZancaSortDeviceDetails(_x26,_x27){return _ref11.apply(this,arguments);};}();var updateZancaSortMonitoringSchedule=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatcher,request){var startTime,getAssetResult,updateAssetInPlaceResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:// Update asset details
startTime=Date.now();_context11.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 3:getAssetResult=_context11.sent;_context11.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["l" /* updateAssetInPlace */])(request,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.lastUpdateTime;},null));case 6:updateAssetInPlaceResponse=_context11.sent;isSuccess=updateAssetInPlaceResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateAssetInPlaceResponse.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateZancaSortDeviceDetails",isSuccess,isFault);fetchZancaSortDeviceDetails(dispatcher);case 11:case"end":return _context11.stop();}}},_callee11,this);}));return function updateZancaSortMonitoringSchedule(_x31,_x32){return _ref13.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="ZANCASORT_DEVICE_DETAILS";function fetchZancaSortDeviceDetails(dispatcher){var request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_222" /* ZANCASORT_ASSET_TYPE */]};getZancaSortDeviceDetails(dispatcher,request);}function setZancaSortDeviceDetails(dispatcher,stateValues,showCustomAlert){stateValues.mac=stateValues.mac.toLowerCase();var request=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_222" /* ZANCASORT_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);addZancaSortDeviceDetails(dispatcher,request,showCustomAlert);}function updateZancaSortDeviceDetails(dispatcher,stateValues,showCustomAlert){var request=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_222" /* ZANCASORT_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);updateZancaSortAsset(dispatcher,request,showCustomAlert);}function deleteZancaSortDeviceDetails(dispatcher,mac){var request={assetLabel:{type:"MAC_ADDRESS",value:mac},assetStatus:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_19" /* DEPRECATED */]};setAssetLabelDeprecatedZancaSortDeviceDetails(dispatcher,request);}var updateZancaSortDeviceMac=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher,stateValues,mac,showCustomAlert){var startTime,assetLabel,assetResult,nodeId,assetStatus;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:startTime=Date.now();assetLabel=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(stateValues.mac.toLowerCase());_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(assetLabel);case 4:assetResult=_context.sent;nodeId=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.nodeId;},null);assetStatus=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.assetStatus;},null);if(assetStatus&&!Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(assetStatus)){showCustomAlert(Object(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_225" /* getUpdateAssetMessageAlertWithSite */])(nodeId));Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addZancaSortDeviceDetails",false,false);}else{deleteZancaSortDeviceDetails(dispatcher,mac);setZancaSortDeviceDetails(dispatcher,stateValues,showCustomAlert);}case 8:case"end":return _context.stop();}}},_callee,this);}));return function updateZancaSortDeviceMac(_x,_x2,_x3,_x4){return _ref.apply(this,arguments);};}();var updateZancaSortConfiguration=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatcher,configurations,mac,showCustomAlert){var getAssetResult,startTime,alias,updatedAsset,updateResult,isUpdateSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 2:getAssetResult=_context2.sent;// Merge current configuration into existing configuration and update
startTime=Date.now();_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["B" /* getAliasFromParent */])();case 6:alias=_context2.sent;updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_4__datamodel_ZancaSortAssetModelResource__["a" /* updateConfigurationsInZancaSortAssetObject */])(getAssetResult.data.asset,configurations,alias);_context2.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(updatedAsset,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 10:updateResult=_context2.sent;isUpdateSuccess=updateResult.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateResult.status);fetchZancaSortDeviceDetails(dispatcher);// Log operation
isUpdateSuccess?showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["D" /* ALERT_UPDATE_SUCCESS_ASSET_MESSAGE */]):showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateZancaSortConfiguration",isUpdateSuccess,isFault);case 16:case"end":return _context2.stop();}}},_callee2,this);}));return function updateZancaSortConfiguration(_x5,_x6,_x7,_x8){return _ref2.apply(this,arguments);};}();/**
 * Updates a specific asset attribute for a ZancaSort device.
 * Synchronous method that waits for server response to enable loader UI.
 */var updateAssetAttribute=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatcher,mac,attributeName,attributeValue,showCustomAlert){var startTime,getAssetResult,existingAsset,updatedAsset,alias,updateResult,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:startTime=Date.now();_context3.prev=1;_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 4:getAssetResult=_context3.sent;existingAsset=getAssetResult.data.asset;// Deep copy and update only the specified attribute
updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["t" /* deepCopyObject */])(existingAsset);_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["B" /* getAliasFromParent */])();case 9:alias=_context3.sent;updatedAsset.assetDetails.alias=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return alias.toString();},"");updatedAsset.assetDetails.assetAttributes[attributeName]=JSON.stringify(attributeValue);// Update asset
_context3.next=14;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(updatedAsset,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return existingAsset.assetDetails.creationTime;},null));case 14:updateResult=_context3.sent;isSuccess=updateResult.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateResult.status);// Refresh data and show alert
if(isSuccess){fetchZancaSortDeviceDetails(dispatcher);showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["D" /* ALERT_UPDATE_SUCCESS_ASSET_MESSAGE */]);}else{showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateZancaSortDeviceDetails",isSuccess,isFault);return _context3.abrupt("return",isSuccess);case 22:_context3.prev=22;_context3.t0=_context3["catch"](1);showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateZancaSortDeviceDetails",false,true);return _context3.abrupt("return",false);case 27:case"end":return _context3.stop();}}},_callee3,this,[[1,22]]);}));return function updateAssetAttribute(_x9,_x10,_x11,_x12,_x13){return _ref3.apply(this,arguments);};}();var addZancaSortDeviceStaticDetailsToModel=function addZancaSortDeviceStaticDetailsToModel(result,model){if("data"in result&&"assetDetailsList"in result.data){result.data.assetDetailsList.forEach(function(deviceDetail){if(deviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]){model.macAddressArray.push(deviceDetail.assetAttributes.mac);var mac=deviceDetail.assetAttributes.mac;var id=JSON.parse(deviceDetail.assetAttributes.deviceConfig).id;model.zancaSortDeviceInformation[mac]={name:deviceDetail.assetAttributes.name,mac:deviceDetail.assetAttributes.mac,ip:deviceDetail.assetAttributes.ip,id:id,port:deviceDetail.assetAttributes.port,vendorAttributes:deviceDetail.vendorAttributes||__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */],assetStatus:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_110" /* LOADING_STRING */],deviceType:deviceDetail.assetAttributes.deviceType,assetType:deviceDetail.assetType,startTime:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.monitoring).startTime;},"0"),endTime:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.monitoring).endTime;},"0"),reason:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.monitoring).reason;},""),stowStationState:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.stowStationState);},null),parentAssetLabel:deviceDetail.parentAssetLabel};model.testConfig[mac]=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.testConfig,[]);});model.locationConfig[mac]=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.locationConfig);},[]);model.tierConfig[mac]=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){var raw=JSON.parse(deviceDetail.assetAttributes.tierConfig);return Object.entries(raw).map(function(_ref9){var _ref10=_slicedToArray(_ref9,2),tierName=_ref10[0],val=_ref10[1];return{tierName:tierName,capacity:val.capacity,startLevel:parseInt(val.levels.split(':')[0],10),endLevel:parseInt(val.levels.split(':')[1],10)};});},[]);}});}return model;};var updateZancaSortMonitoringDetails=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatcher,stateValues,mac){var getAssetResult,updatedAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 2:getAssetResult=_context10.sent;updatedAsset=updateExistingAssetAttributes(getAssetResult.data.asset,stateValues);updateZancaSortMonitoringSchedule(dispatcher,updatedAsset);case 5:case"end":return _context10.stop();}}},_callee10,this);}));return function updateZancaSortMonitoringDetails(_x28,_x29,_x30){return _ref12.apply(this,arguments);};}();var updateExistingAssetAttributes=function updateExistingAssetAttributes(asset,stateValues){var updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["t" /* deepCopyObject */])(asset);updatedAsset.assetDetails.assetAttributes.monitoring=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(stateValues);},asset.assetDetails.assetAttributes.monitoring);return updatedAsset;};

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_escapeRegExp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_escapeRegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_escapeRegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl__ = __webpack_require__(4);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DeleteTestPackageConfigurationModel=function DeleteTestPackageConfigurationModel(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,deleteInstance=_useContext.deleteInstance,deleteAll=_useContext.deleteAll;var open=props.open,setOpen=props.setOpen,mac=props.mac,intl=props.intl,testConfig=props.testConfig;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),selectedScannables=_useState2[0],setSelectedScannables=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),searchQuery=_useState4[0],setSearchQuery=_useState4[1];var scannableKeyList=getDraftData({stateKey:testConfig,subKey:mac}).map(function(_ref){var scannables=_ref.scannables;return Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_13" /* getTestConfigKey */])(scannables);});var searchRegExp=new RegExp(__WEBPACK_IMPORTED_MODULE_12_lodash_escapeRegExp___default()(searchQuery),"i");var matchedKeys=scannableKeyList.filter(function(option){return!searchQuery||searchRegExp.test(option);});var deleteData=function deleteData(){deleteInstance({stateKey:testConfig,subKey:mac,keyComparator:function keyComparator(instance){return Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_13" /* getTestConfigKey */])(instance.scannables)===selectedScannables;}});};var onClickConfirm=function onClickConfirm(){deleteData();setOpen(false);resetInputState();};function resetInputState(){setSelectedScannables("");}var onCloseModal=function onCloseModal(){setOpen(false);resetInputState();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default.a,{title:Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowtestconfig.deleteconfig"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.delete_test_package"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_select___default.a,{value:selectedScannables,onChange:setSelectedScannables,searchQuery:searchQuery,onSearch:setSearchQuery,placeholder:Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowtestconfig.delete"}),width:"100%"},matchedKeys.map(function(scannable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_select__["SelectOption"],{key:scannable,value:scannable,label:scannable});}),!matchedKeys.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},scannableKeyList?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"testconfig.nomatch"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"testconfig.notavailable"}))):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{size:"small",className:"redBtn",onClick:function onClick(){deleteAll({stateKey:testConfig,subKey:mac});onCloseModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.deleteAll"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{type:"secondary",size:"small",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:onClickConfirm},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirm"})))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_intl__["d" /* injectIntl */])(DeleteTestPackageConfigurationModel));

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BagTrackingContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_BagTrackingReducer__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var BagTrackingContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var BagTrackingContextProvider=function BagTrackingContextProvider(props){var state={bagList:{},loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_BagTrackingReducer__["a" /* BagTrackingReducer */],state),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BagTrackingContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (BagTrackingContextProvider);

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _heading = _interopRequireDefault(__webpack_require__(1353));

var _default = _heading["default"];
exports["default"] = _default;

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HandsfreeCameraDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_HandsfreeCameraDeviceOverviewReducer__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var HandsfreeCameraDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var HandsfreeCameraDeviceOverviewContextProvider=function HandsfreeCameraDeviceOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},asmlComponentInformation:{},macAddressArray:[],loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_HandsfreeCameraDeviceOverviewReducer__["a" /* HandsfreeCameraDeviceOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HandsfreeCameraDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (HandsfreeCameraDeviceOverviewContextProvider);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createCameraDeviceOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
var createCameraDeviceOverviewReducer=function createCameraDeviceOverviewReducer(subAssetType){return function(state,action){switch(action.type){case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingOverview:false,timestamp:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_14" /* getTimestampNow */])()});case"LOAD_VIEW":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["b" /* fetchAsmlComponentDetails */])(action.data.dispatcher,subAssetType);return state;case"LOAD_STATUS":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["c" /* fetchAsmlComponentStatusDetails */])(action.data.dispatcher,state);return state;case"ADD_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["f" /* setAsmlComponentDetails */])(action.data.dispatcher,action.data.stateValues,subAssetType);return state;case"UPDATE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["h" /* updateAsmlComponentDetails */])(action.data.dispatcher,action.data.stateValues,subAssetType);return state;case"DELETE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["a" /* deleteAsmlComponentDetails */])(action.data.dispatcher,action.data.mac);return state;case"UPDATE_DEVICE_MAC":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["i" /* updateAsmlComponentMac */])(action.data.dispatcher,action.data.stateValues,action.data.mac,subAssetType);return state;case"UPDATE_MONITORING_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["j" /* updateAsmlComponentMonitoringDetails */])(action.data.dispatcher,action.data.stateValues,action.data.mac,subAssetType);return state;case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});default:return state;}};};

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__meridian_components_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal_AddCameraSingleDeviceModal__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__commonui_DeleteSingleDeviceModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commonui_DisableMonitoringModal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_Validations__ = __webpack_require__(15);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var CameraDeviceOverview=function CameraDeviceOverview(_ref){var intl=_ref.intl,deviceContext=_ref.deviceContext;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(deviceContext),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState2=_slicedToArray(_useState,2),openActionsMenu=_useState2[0],setOpenActionsMenu=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openAddModal=_useState4[0],setOpenAddModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),selected=_useState6[0],setSelected=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),openDeleteModal=_useState8[0],setOpenDeleteModal=_useState8[1];var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),openDisableMonitoringModal=_useState10[0],setOpenDisableMonitoringModal=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),mac=_useState12[0],setMac=_useState12[1];var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){setOpenActionsMenu(function(prev){return Object.assign({},prev,_defineProperty({},index,true));});},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){setOpenActionsMenu(function(prev){return Object.assign({},prev,_defineProperty({},index,false));});},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openAddModal&&!openDeleteModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["D" /* getAssetRefreshInterval */])());var statusInterval=setInterval(function(){if(!document.hidden){getStatusData();}},Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_11" /* getStatusRefreshInterval */])());return function(){clearInterval(interval);clearInterval(statusInterval);};}},[openAddModal,openDeleteModal]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,viewModel.asmlComponentInformation.length);},[viewModel.asmlComponentInformation]);var onSort=function onSort(sortDetails){dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};var sortedDeviceList=Object.values(viewModel.asmlComponentInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){var _viewModel$sortPref=viewModel.sortPref,column=_viewModel$sortPref.column,direction=_viewModel$sortPref.direction;var compareValue=void 0;if(Object.keys(__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */]).includes(column)){if(column==="vendor"){compareValue=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column]+a.vendorAttributes["spec_version"],b.vendorAttributes[column]+b.vendorAttributes["spec_version"]);}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column],b.vendorAttributes[column]);}}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_32" /* sortComparator */])(a[column],b[column]);}if(direction===__WEBPACK_IMPORTED_MODULE_11__util_Constants__["J" /* ASCENDING */]){return compareValue;}else{return-compareValue;}});var updateData=function updateData(stateValues,mac){dispatch({type:'UPDATE_MONITORING_DATA',data:{dispatcher:dispatch,stateValues:stateValues,mac:mac}});};var onClickDisableMonitoring=function onClickDisableMonitoring(mac){setMac(mac);setOpenDisableMonitoringModal(true);};var onClickEnableMonitoring=function onClickEnableMonitoring(startTime,reason,mac){var stateValues={"startTime":startTime,"endTime":Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["I" /* getCurrentDate */])().toString(),"reason":reason};updateData(stateValues,mac);getData();};var renderDeviceMonitoring=function renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{style:{color:monitoringStatusColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:monitoringStatusId,defaultMessage:monitoringStatusDefaultMessage}));};var getData=function getData(){setOpenAddModal(false);setOpenDeleteModal(false);setOpenDisableMonitoringModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var getStatusData=function getStatusData(){dispatch({type:'LOAD_STATUS',data:{dispatcher:dispatch}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var onClickAddEditDevice=function onClickAddEditDevice(){setSelected("");setOpenAddModal(true);};var onClickEditDevice=function onClickEditDevice(mac){setSelected(mac);setOpenAddModal(true);};var onClickRemove=function onClickRemove(mac){setSelected(mac);setOpenDeleteModal(true);};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__meridian_components_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default.a,{position:"top",title:intl.formatMessage({id:'tooltip.scrolltobottom',defaultMessage:'Scroll to bottom'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"alert.device",defaultMessage:"No device present for this station."})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],{sortColumn:"name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"device.name",defaultMessage:"Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"device.mac_ip",defaultMessage:"MAC/IP"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_21__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.connectionstatus'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],{sortColumn:"connection"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"device.connection",defaultMessage:"Connection Status"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"device.monitoring",defaultMessage:"Monitoring Status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],{sortColumn:"vendor"},Object(__WEBPACK_IMPORTED_MODULE_21__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'device.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"device.action",defaultMessage:"Action"}))),sortedDeviceList.map(function(device,index){var vendorAttributes=device.vendorAttributes;var monitoring=Object(__WEBPACK_IMPORTED_MODULE_23__util_Validations__["u" /* checkDeviceMonitoringEnabled */])(Number(device.startTime),Number(device.endTime));var _getMonitoringStatusD=Object(__WEBPACK_IMPORTED_MODULE_23__util_Validations__["F" /* getMonitoringStatusDetails */])(monitoring),monitoringStatusColor=_getMonitoringStatusD.monitoringStatusColor,monitoringStatusId=_getMonitoringStatusD.monitoringStatusId,monitoringStatusDefaultMessage=_getMonitoringStatusD.monitoringStatusDefaultMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableRow"],{key:index,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),device.deviceType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.mac),device.ip,":",device.port)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],null,device.assetStatus?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{color:device.assetStatus.toUpperCase()===__WEBPACK_IMPORTED_MODULE_11__util_Constants__["b" /* ACTIVE */]?__WEBPACK_IMPORTED_MODULE_11__util_Constants__["X" /* BLUE_COLOR */]:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_149" /* ORANGE_COLOR */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.assetStatus)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"loading.text",defaultMessage:"Loading..."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],null,renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_23__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][vendorAttributes.vendor]," ",__WEBPACK_IMPORTED_MODULE_23__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][vendorAttributes.spec_version])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"actions-menu-"+index,"aria-haspopup":"menu","aria-expanded":openActionsMenu[index]?"true":"false"},"..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu___default.a,{id:"actions-menu-"+index,anchorNode:actionButtonRefs.current[index],open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEditDevice(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"actions.addDevice",defaultMessage:"Edit"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickRemove(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"actions.deleteDevice",defaultMessage:"Delete"})),monitoring.isMonitoringEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDisableMonitoring(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_disable",defaultMessage:"Disable Monitoring"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEnableMonitoring(device.startTime,device.reason,device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_enable",defaultMessage:"Enable Monitoring"}))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{onClick:onClickAddEditDevice,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"device.add_device_button_modal",defaultMessage:"Add Device Configuration"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{onClick:function onClick(){return setOpenDeleteModal(true);},type:"tertiary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"button.delete",defaultMessage:"Delete device"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modal_AddCameraSingleDeviceModal__["a" /* default */],{deviceContext:deviceContext,open:openAddModal,setOpen:setOpenAddModal,selected:selected,setSelected:setSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__commonui_DeleteSingleDeviceModal__["a" /* default */],{open:openDeleteModal,setOpen:setOpenDeleteModal,selected:selected,setSelected:setSelected,macAddressArray:viewModel.macAddressArray,dispatch:dispatch}),openDisableMonitoringModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__commonui_DisableMonitoringModal__["a" /* default */],{mac:mac,state:openDisableMonitoringModal,onStateChange:setOpenDisableMonitoringModal,context:deviceContext,reducer:'UPDATE_MONITORING_DATA'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */])(CameraDeviceOverview));

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverheadCameraDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_OverheadCameraDeviceOverviewReducer__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var OverheadCameraDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var OverheadCameraDeviceOverviewContextProvider=function OverheadCameraDeviceOverviewContextProvider(props){var data={sortPref:{column:"name",direction:"ascending"},asmlComponentInformation:{},macAddressArray:[],loadingOverview:true};var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_OverheadCameraDeviceOverviewReducer__["a" /* OverheadCameraDeviceOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OverheadCameraDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* harmony default export */ __webpack_exports__["b"] = (OverheadCameraDeviceOverviewContextProvider);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
var AISLE_LABEL_STYLE={width:"50px",height:"25px",textAlign:"center"};var AisleLabel=function AisleLabel(props){var aisleLabel=props.aisleLabel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:AISLE_LABEL_STYLE},aisleLabel);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(AisleLabel));

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchVaprDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["b"] = setVaprDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateVaprDeviceDetails;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__ = __webpack_require__(56);
var getVaprDeviceDetails=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher,request){var model,pageToken,startTime,getAssetsResult,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:model={vaprDeviceInformation:{},macAddressArray:[]};pageToken=null;case 2:startTime=Date.now();_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["g" /* getAssets */])(request.nodeId,request.assetType,pageToken);case 5:getAssetsResult=_context.sent;isSuccess=getAssetsResult.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(getAssetsResult.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getVaprDeviceDetails",isSuccess,isFault);if(!isSuccess){_context.next=14;break;}addVaprDeviceDetailsToModel(getAssetsResult,model);pageToken=getAssetsResult.data.pageToken;_context.next=16;break;case 14:dispatcher({type:"RECEIVE_DATA",data:model});return _context.abrupt("return");case 16:if(pageToken){_context.next=2;break;}case 17:dispatcher({type:"RECEIVE_DATA",data:model});case 18:case"end":return _context.stop();}}},_callee,this);}));return function getVaprDeviceDetails(_x,_x2){return _ref.apply(this,arguments);};}();var addVaprDevice=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatcher,request,showCustomAlert){var startTime,result,isFault,getAssetResult,responseSetAssetStatus,responseUpdateAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:startTime=Date.now();_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_29" /* setAliasToRequest */])(request);case 3:_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["a" /* addAsset */])(request);case 5:result=_context2.sent;if(!(result.status===200)){_context2.next=10;break;}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addVaprDevice",true,false);_context2.next=36;break;case 10:isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(result.status);_context2.next=13;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 13:getAssetResult=_context2.sent;if(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.assetStatus;},null))){_context2.next=19;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["B" /* ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addVaprDevice",false,isFault);fetchVaprDeviceDetails(dispatcher);return _context2.abrupt("return");case 19:_context2.next=21;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);case 21:responseSetAssetStatus=_context2.sent;if(!(responseSetAssetStatus.status!==200)){_context2.next=27;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addVaprDevice",false,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(responseSetAssetStatus.status));fetchVaprDeviceDetails(dispatcher);return _context2.abrupt("return");case 27:_context2.next=29;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 29:responseUpdateAsset=_context2.sent;if(!(responseUpdateAsset.status!==200)){_context2.next=35;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addVaprDevice",false,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(responseUpdateAsset.status));fetchVaprDeviceDetails(dispatcher);return _context2.abrupt("return");case 35:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addVaprDevice",true,false);case 36:fetchVaprDeviceDetails(dispatcher);case 37:case"end":return _context2.stop();}}},_callee2,this);}));return function addVaprDevice(_x3,_x4,_x5){return _ref2.apply(this,arguments);};}();var updateVaprDevice=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatcher,request,showCustomAlert){var startTime,getAssetResult,creationTime,setAssetStatusResponse,updateAssetResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:startTime=Date.now();_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_29" /* setAliasToRequest */])(request);case 3:_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 5:getAssetResult=_context3.sent;creationTime=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null);if(creationTime){_context3.next=12;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateVaprDevice",false,true);fetchVaprDeviceDetails(dispatcher);return _context3.abrupt("return");case 12:_context3.next=14;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);case 14:setAssetStatusResponse=_context3.sent;if(!(setAssetStatusResponse.status!==200)){_context3.next=20;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateVaprDevice",false,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(setAssetStatusResponse.status));fetchVaprDeviceDetails(dispatcher);return _context3.abrupt("return");case 20:_context3.next=22;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,creationTime);case 22:updateAssetResponse=_context3.sent;isSuccess=updateAssetResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateAssetResponse.status);if(!isSuccess){showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateVaprDevice",isSuccess,isFault);fetchVaprDeviceDetails(dispatcher);case 28:case"end":return _context3.stop();}}},_callee3,this);}));return function updateVaprDevice(_x6,_x7,_x8){return _ref3.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="VAPR_DEVICE_DETAILS";function fetchVaprDeviceDetails(dispatcher){var request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_218" /* VAPR_ASSET_TYPE */]};return getVaprDeviceDetails(dispatcher,request);}var addVaprDeviceDetailsToModel=function addVaprDeviceDetailsToModel(result,model){if("data"in result&&"assetDetailsList"in result.data){result.data.assetDetailsList.forEach(function(deviceDetail){if(deviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]){var mac=deviceDetail.assetAttributes.mac;var deviceConfig=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.deviceConfig);},{});var detectionFov=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.detectionFov);},{});var projectionFov=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.projectionFov);},{});var monitoring=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.monitoring);},{});model.macAddressArray.push(mac);model.vaprDeviceInformation[mac]={name:deviceDetail.assetAttributes.name,mac:mac,ip:deviceDetail.assetAttributes.ip,port:deviceDetail.assetAttributes.port,deviceId:deviceConfig.id||"",deviceType:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return deviceDetail.assetAttributes.deviceType;},""),detectionFovLength:detectionFov.length||"",detectionFovBreadth:detectionFov.breadth||"",detectionFovUnit:detectionFov.unit||"mm",projectionFovLength:projectionFov.length||"",projectionFovBreadth:projectionFov.breadth||"",projectionFovUnit:projectionFov.unit||"mm",monitoringStartTime:monitoring.startTime||"0",monitoringEndTime:monitoring.endTime||"0",vendorAttributes:deviceDetail.vendorAttributes||__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */],connectionStatus:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_110" /* LOADING_STRING */]};}});}return model;};function setVaprDeviceDetails(dispatcher,stateValues,showCustomAlert){stateValues.mac=stateValues.mac.toLowerCase();var request=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_218" /* VAPR_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);return addVaprDevice(dispatcher,request,showCustomAlert);}function updateVaprDeviceDetails(dispatcher,stateValues,showCustomAlert){stateValues.mac=stateValues.mac.toLowerCase();var request=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_218" /* VAPR_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);return updateVaprDevice(dispatcher,request,showCustomAlert);}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(1591);

var iterableToArrayLimit = __webpack_require__(1592);

var unsupportedIterableToArray = __webpack_require__(523);

var nonIterableRest = __webpack_require__(1593);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(524);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;

/***/ }),
/* 524 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;

/***/ }),
/* 525 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Takes an object of props and filters them down to only the props with names
 * that start with one of a given set of prefixes.
 */
var filterPropsByPrefix = function filterPropsByPrefix(props, prefixes) {
  return Object.keys(props).filter(function (name) {
    return prefixes.some(function (prefix) {
      return name.indexOf(prefix) === 0;
    });
  }).reduce(function (result, name) {
    result[name] = props[name];
    return result;
  }, {});
};

var _default = filterPropsByPrefix;
exports["default"] = _default;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _text = _interopRequireDefault(__webpack_require__(1625));

var text = function text(t) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var tokens = (0, _text["default"])(t.tokens);
  return {
    color: t("foregroundColor", keys.color) || t.tokens.themeForegroundPrimaryDefault,
    fontFamily: t("fontFamily", keys.fontFamily) || tokens.textFontFamilyAmazonEmber,
    fontSize: t("fontSize", keys.fontSize) || tokens.textFontSizeB300,
    fontWeight: t("fontWeight", keys.fontWeight) || tokens.textFontWeightB300,
    lineHeight: t("lineHeight", keys.lineHeight) || tokens.textLineHeightB300
  };
};

var _default = text;
exports["default"] = _default;

/***/ }),
/* 528 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1634);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(531);
module.exports = __webpack_require__(537);


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(532).enable();
  window.Promise = __webpack_require__(534);
}

// fetch() polyfill for making API calls.
__webpack_require__(535);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(536);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(317);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(317);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 535 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_App__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__meridian_tokens_base_font_amazon_ember_css__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__meridian_tokens_base_font_amazon_ember_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__meridian_tokens_base_font_amazon_ember_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_katal_react__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_handler_LocaleHandler__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl_locale_data_en__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl_locale_data_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_intl_locale_data_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl_locale_data_ja__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl_locale_data_ja___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_intl_locale_data_ja__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl_locale_data_it__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl_locale_data_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_intl_locale_data_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl_locale_data_fr__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl_locale_data_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_intl_locale_data_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl_locale_data_es__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl_locale_data_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_intl_locale_data_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl_locale_data_de__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl_locale_data_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_intl_locale_data_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl_locale_data_ar__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_intl_locale_data_ar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_intl_locale_data_ar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_handler_errorHandler_ErrorBoundary__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_store_context_LogStoreContext__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_permissions_MQTTPermissionsContext__ = __webpack_require__(488);
Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_8_react_intl_locale_data_en___default.a);Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_9_react_intl_locale_data_ja___default.a);Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_10_react_intl_locale_data_it___default.a);Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_13_react_intl_locale_data_de___default.a);Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_11_react_intl_locale_data_fr___default.a);Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_12_react_intl_locale_data_es___default.a);Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["c" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_14_react_intl_locale_data_ar___default.a);// The Suspense component causes React to display the fallback KatSpinner until
// the i18n translation strings have been loaded.
Object(__WEBPACK_IMPORTED_MODULE_7__components_handler_LocaleHandler__["b" /* getLocale */])().then(function(locale){document.getElementsByTagName('html')[0].setAttribute("dir",Object(__WEBPACK_IMPORTED_MODULE_7__components_handler_LocaleHandler__["a" /* getDirection */])(locale));__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Suspense,{fallback:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_katal_react__["a" /* KatSpinner */],{size:'large'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* IntlProvider */],{locale:locale,messages:Object(__WEBPACK_IMPORTED_MODULE_7__components_handler_LocaleHandler__["c" /* getMessages */])(locale)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_global_context_GlobalStateContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_handler_errorHandler_ErrorBoundary__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_permissions_PermissionsContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_draftSave_context_DraftSaveContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_permissions_MQTTPermissionsContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_store_context_LogStoreContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_router_dom__["a" /* HashRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_App__["a" /* default */],null)))))))))),document.getElementById('root'));});

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(539),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(541),r=__webpack_require__(542);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
b>c?b:c;0===b&&(Fh=null);$h(a,b)}
function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(543);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__devicemanagement_DeviceManagementPage__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_RouteConstants__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function publishRoutePath(location){var metricProcessName="SCC_INDUCT";var metricName=location.pathname;Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_24" /* publishCountToCSM */])({processName:metricProcessName,metricName:metricName});}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;publishRoutePath(this.props.location);Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_23" /* publishAlchemyAnalytics */])(this.props.location.pathname);this.onRouteSwitch=this.props.history.listen(function(){// this.props.location still has old location because React hasn't updated props yet
publishRoutePath(_this2.props.location);Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_23" /* publishAlchemyAnalytics */])(_this2.props.history.location.pathname);});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.onRouteSwitch();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Switch */],null,Object.keys(__WEBPACK_IMPORTED_MODULE_5__util_RouteConstants__["m" /* DEFAULT_ROUTES */]).map(function(path,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */],{exact:true,path:path,key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Redirect */],{to:__WEBPACK_IMPORTED_MODULE_5__util_RouteConstants__["m" /* DEFAULT_ROUTES */][path]}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */],{path:'/devicemanagement',component:__WEBPACK_IMPORTED_MODULE_3__devicemanagement_DeviceManagementPage__["a" /* default */]}));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(App));

/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(185);






var MAX_SIGNED_31_BIT_INT = 1073741823;

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + __WEBPACK_IMPORTED_MODULE_3_gud___default()() + '__';

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer =
  /*#__PURE__*/
  function (_Component2) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 548 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(550);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(555)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(321);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_SelectLayout__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PageHeader__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var isPeakTime=false;var DeviceManagementPage=function(_Component){_inherits(DeviceManagementPage,_Component);function DeviceManagementPage(){_classCallCheck(this,DeviceManagementPage);return _possibleConstructorReturn(this,(DeviceManagementPage.__proto__||Object.getPrototypeOf(DeviceManagementPage)).apply(this,arguments));}_createClass(DeviceManagementPage,[{key:"render",value:function render(){var routes=Object(__WEBPACK_IMPORTED_MODULE_2__util_RouteConstants__["n" /* DEVICE_MANAGEMENT_ROUTES */])();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,{spacingInset:"small large",spacing:"medium"},isPeakTime&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_alert___default.a,{type:"warning"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"banner.peakPermission"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_link___default.a,{target:"_blank",rel:"noopener noreferrer",href:"https://w.amazon.com/bin/view/DeliveryStationTech/ConveyorAutomation/DeviceManagementSCC/#HWhyamInotabletoperformcertainfunctionsontheportalduringpeak3F"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */],{id:"banner.wiki"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__util_PageHeader__["a" /* default */],__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_151" /* PAGE_HEADERS */].DEVICE_MANAGEMENT," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_SelectLayout__["b" /* default */],{routes:routes.sort(function(a,b){return a.name.localeCompare(b.name);}),location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_SelectLayout__["a" /* NavigationRoutes */],{routes:routes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_SelectLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_2__util_RouteConstants__["A" /* TRAFFIC_LIGHT_ROUTES */]}));}}]);return DeviceManagementPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DeviceManagementPage);

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _reduce = _interopRequireDefault(__webpack_require__(572));

var _box = _interopRequireDefault(__webpack_require__(31));

var _propTypes2 = _interopRequireDefault(__webpack_require__(126));

var _parsers = __webpack_require__(128);

var _functional = __webpack_require__(38);

var _cxMemoized = _interopRequireDefault(__webpack_require__(107));

var _rtl = __webpack_require__(80);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = function styles(heights) {
  return (0, _functional.memoizeByKeys)(function (_ref) {
    var spacing = _ref.spacing,
        alignmentVertical = _ref.alignmentVertical,
        alignmentHorizontal = _ref.alignmentHorizontal;
    return (0, _emotion.css)({
      display: "flex",
      flexDirection: "column",
      justifyContent: {
        top: "flex-start",
        bottom: "flex-end",
        center: "center",
        justify: "space-between"
      }[alignmentVertical],
      alignItems: {
        left: "flex-start",
        right: "flex-end",
        center: "center",
        stretch: "stretch"
      }[(0, _rtl.getHorizontalDirection)(alignmentHorizontal)],
      // Set margins and heights on the children of the column. Use !important to
      // override any existing styles.
      "& > *": {
        // Make sure that any borders or padding applied to the child don't throw
        // of the heights that we apply
        boxSizing: "border-box !important",
        // Ensure that the correct bottom margin is set (and clear other margins)
        margin: "0 0 ".concat((0, _parsers.parseSpacing)(spacing)[0], "px 0 !important"),
        // Don't let the last child add extra space to the end of the column.
        ":last-child": {
          margin: "0 !important"
        }
      }
    }, // If we've got an array of heights, apply each height to the child
    // whose index in the dom matches the height's index in the array. If
    // we've got a single height, apply that to all children.
    Array.isArray(heights) ? (0, _reduce["default"])(heights, function (result, height, index) {
      return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2["default"])({}, "& > *:nth-child(".concat(parseInt(index) + 1, ")"), childStyles(height)));
    }, {}) : {
      "& > *": childStyles(heights)
    });
  }, ["spacing", "alignmentVertical", "alignmentHorizontal"]);
};

var stylesWithUniqueHeights = (0, _functional.memoizeArray)(styles);
var stylesWithUniformHeights = (0, _functional.memoize)(styles);

var childStyles = function childStyles(height) {
  return {
    flex: height === "fill" ? "1 !important" : undefined,
    flexShrink: height && height !== "fill" && height !== "auto" ? "0 !important" : undefined,
    height: height !== "fill" && height !== "fit" && height !== undefined && height !== null && height !== "" ? "".concat(height).concat(typeof height === "number" ? "px" : "", " !important") : undefined
  };
};
/**
 * The Column component stacks children up vertically in a column with even
 * spacing in-between them.
 */


var Column = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  // We need to memoize differently based on whether we got an array or scalar
  // for the "heights" property
  var stylesFunc = Array.isArray(props.heights) ? stylesWithUniqueHeights : stylesWithUniformHeights;
  var styles = stylesFunc(props.heights)(props);
  return /*#__PURE__*/_react["default"].createElement(_box["default"], _objectSpread(_objectSpread({}, props), {}, {
    className: (0, _cxMemoized["default"])(styles, props.className),
    ref: ref
  }));
});

Column.displayName = "Column";
Column.propTypes =  false ? {
  /**
   * Specify the horizontal alignment of the elements inside the column.
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["left", "start", "center", "right", "end", "stretch"]),

  /**
   * Specify the vertical alignment of the elements inside the column.
   */
  alignmentVertical: _propTypes["default"].oneOf(["top", "center", "bottom", "justify"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.18.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set the column's background color using a preset, or using a string
   * containing any valid CSS color.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary"]), _propTypes["default"].string]),

  /**
   * The elements to line up in a column. Any elements can be supplied here, although if
   * only one child is supplied the column will not add much value (it's meant
   * for aligning multiple elements). If you only have one child, consider using
   * the `Box` component instead.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Set the height of the column using a number (which will be treated as
   * pixels) or a string containing any valid CSS dimension.
   */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the height of each element in the column.
   *
   * If a single height is provided then it will be applied to every element in
   * the column. If an array of heights is provided then each height will be
   * applied to the element in the column that exists at the same index as the
   * height in the array (e.g. `[<element 0 height>, <element 1 height>, null, <element 3 height>]`).
   *
   * The possible values for each height are:
   *   - `number` - A fixed pixel height.
   *   - `string` - Any valid CSS height.
   *   - `"fit"` - The element's height will shrink to fit its contents.
   *   - `"fill"` - The element's height will fill all remaining space in the column.
   *     If this value is set on multiple elements, they will share the remaining
   *     space in the column equally.
   */
  heights: _propTypes["default"].oneOfType([_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]), _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),

  /**
   * Set the maximum height of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum width of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum height of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum width of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Controls the horizontal overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowX` can cause the `overflow-y` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   *
   * @since 5.21.0
   */
  overflowX: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * Controls the vertical overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowY` can cause the `overflow-x` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   */
  overflowY: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * Set the vertical spacing between elements in the column using a preset.
   */
  spacing: _propTypes2["default"].spacing(1),

  /**
   * Apply padding to the component.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"small medium"` for small padding on the top/bottom and
   * medium padding on the left/right, or `"100 none none none"` for 2px
   * padding on the top and 0px padding on the right, left, and bottom).
   *
   * For more information on available spacing tokens please visit the
   * [Spacing fundamentals page](https://meridian.a2z.com/fundamentals/spacing/).
   */
  spacingInset: _propTypes2["default"].spacing(4),

  /**
   * The HTML tag to use when rendering the component to the DOM.
   */
  tag: _propTypes["default"].string,

  /**
   * Set the style of the column using one of Meridian's Box component styles.
   * If omitted the column will not have any decorative visual style applied to
   * it.
   */
  type: _propTypes["default"].oneOf(["outline", "fill"]),

  /**
   * Set the width of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
Column.defaultProps = {
  spacing: "medium",
  alignmentVertical: "top",
  alignmentHorizontal: "stretch"
};
var _default = Column;
exports["default"] = _default;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(561);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_cache__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_serialize__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_utils__ = __webpack_require__(571);




function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_utils__["a" /* getRegisteredStyles */])(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_cache__["a" /* default */])(options); // $FlowFixMe

  cache.sheet.speedy = function (value) {
    if (false) {
      throw new Error('speedy must be changed before any rules are inserted');
    }

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered, this !== undefined ? this.mergedProps : undefined);
    Object(__WEBPACK_IMPORTED_MODULE_2__emotion_utils__["b" /* insertStyles */])(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = Object(__WEBPACK_IMPORTED_MODULE_1__emotion_serialize__["a" /* serializeStyles */])(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return merge(cache.registered, css, classnames(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: __WEBPACK_IMPORTED_MODULE_2__emotion_utils__["a" /* getRegisteredStyles */].bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
};

var classnames = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_weak_memoize__ = __webpack_require__(566);




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__["a" /* default */](stylisOptions);

  if (false) {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__["a" /* StyleSheet */]({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ __webpack_exports__["a"] = (createCache);


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleSheet; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();




/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (weakMemoize);


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializeStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_hash__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_memoize__ = __webpack_require__(570);




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_memoize__["a" /* default */])(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles;

          if (false) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }
      }
    // eslint-disable-next-line no-fallthrough

    default:
      {
        if (registered == null) {
          return interpolation;
        }

        var cached = registered[interpolation];

        if (false) {
          console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
          shouldWarnAboutInterpolatingClassNameFromCss = false;
        }

        return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
      }
  }
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_hash__["a" /* default */])(styles) + identifierName;

  if (false) {
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertStyles; });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(573),
    baseEach = __webpack_require__(574),
    baseIteratee = __webpack_require__(186),
    baseReduce = __webpack_require__(647),
    isArray = __webpack_require__(82);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 573 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(575),
    createBaseEach = __webpack_require__(590);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(576),
    keys = __webpack_require__(151);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(577);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(579),
    isArguments = __webpack_require__(236),
    isArray = __webpack_require__(82),
    isBuffer = __webpack_require__(324),
    isIndex = __webpack_require__(237),
    isTypedArray = __webpack_require__(325);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 579 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(123),
    isObjectLike = __webpack_require__(104);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(152);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 582 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 583 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(123),
    isLength = __webpack_require__(238),
    isObjectLike = __webpack_require__(104);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(323);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(124)(module)))

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(587),
    nativeKeys = __webpack_require__(588);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 587 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(589);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 589 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(125);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(592),
    getMatchData = __webpack_require__(636),
    matchesStrictComparable = __webpack_require__(335);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(328),
    baseIsEqual = __webpack_require__(330);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 593 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(188);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(188);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(188);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(188);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(187);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 599 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 600 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 601 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(187),
    Map = __webpack_require__(240),
    MapCache = __webpack_require__(241);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(327),
    isMasked = __webpack_require__(604),
    isObject = __webpack_require__(153),
    toSource = __webpack_require__(329);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(605);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(88);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 606 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(608),
    ListCache = __webpack_require__(187),
    Map = __webpack_require__(240);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(609),
    hashDelete = __webpack_require__(610),
    hashGet = __webpack_require__(611),
    hashHas = __webpack_require__(612),
    hashSet = __webpack_require__(613);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(189);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 610 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(189);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(189);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(189);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(190);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 615 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(190);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(190);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(190);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(328),
    equalArrays = __webpack_require__(331),
    equalByTag = __webpack_require__(623),
    equalObjects = __webpack_require__(626),
    getTag = __webpack_require__(632),
    isArray = __webpack_require__(82),
    isBuffer = __webpack_require__(324),
    isTypedArray = __webpack_require__(325);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 620 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 621 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 622 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(152),
    Uint8Array = __webpack_require__(624),
    eq = __webpack_require__(239),
    equalArrays = __webpack_require__(331),
    mapToArray = __webpack_require__(625),
    setToArray = __webpack_require__(244);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(88);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 625 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(627);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(628),
    getSymbols = __webpack_require__(629),
    keys = __webpack_require__(151);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(332),
    isArray = __webpack_require__(82);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(630),
    stubArray = __webpack_require__(631);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 630 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 631 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(633),
    Map = __webpack_require__(240),
    Promise = __webpack_require__(634),
    Set = __webpack_require__(333),
    WeakMap = __webpack_require__(635),
    baseGetTag = __webpack_require__(123),
    toSource = __webpack_require__(329);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(105),
    root = __webpack_require__(88);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(105),
    root = __webpack_require__(88);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(105),
    root = __webpack_require__(88);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(334),
    keys = __webpack_require__(151);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(330),
    get = __webpack_require__(638),
    hasIn = __webpack_require__(642),
    isKey = __webpack_require__(245),
    isStrictComparable = __webpack_require__(334),
    matchesStrictComparable = __webpack_require__(335),
    toKey = __webpack_require__(192);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(336);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(640);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(641);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(241);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(643),
    hasPath = __webpack_require__(644);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 643 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(337),
    isArguments = __webpack_require__(236),
    isArray = __webpack_require__(82),
    isIndex = __webpack_require__(237),
    isLength = __webpack_require__(238),
    toKey = __webpack_require__(192);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(338),
    basePropertyDeep = __webpack_require__(646),
    isKey = __webpack_require__(245),
    toKey = __webpack_require__(192);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(336);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 647 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _box = _interopRequireDefault(__webpack_require__(649));

var _propTypes2 = _interopRequireDefault(__webpack_require__(126));

var _theme = __webpack_require__(24);

var _cxMemoized = _interopRequireDefault(__webpack_require__(107));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

var _box2 = __webpack_require__(656);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * The Box component can also be used to visually separate part of the layout by
 * applying an outline or fill.
 *
 * It can also be used as a layout component (similar to the Row and Column
 * components) to apply width and inset padding to any part of the layout (with
 * or without an outline or fill).
 */
var Box = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return (// Only pull in theme tokens if we're styling the box
    props.backgroundColor || props.type ? /*#__PURE__*/_react["default"].createElement(ThemedBox, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }), props.children) : /*#__PURE__*/_react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"])), {}, {
      className: (0, _cxMemoized["default"])((0, _box2.styles)(props), props.className),
      id: props.id,
      tabIndex: props.tabIndex,
      ref: ref
    }), props.children)
  );
});

Box.displayName = "Box";
Box.propTypes = {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.18.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set the box's background color using a preset, or using a string
   * containing any valid CSS color.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary", "alternatePrimary", "alternateSecondary"]), _propTypes["default"].string]),

  /**
   * The elements to render inside the box.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Set the height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Adds an [id](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id) to the component.
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  id: _propTypes["default"].string,

  /**
   * Set the maximum height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Controls the horizontal overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowX` can cause the `overflow-y` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   *
   * @since 5.20.0
   */
  overflowX: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * Controls the vertical overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowY` can cause the `overflow-x` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   */
  overflowY: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * Apply padding to the component.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"small medium"` for small padding on the top/bottom and
   * medium padding on the left/right).
   */
  spacingInset: _propTypes2["default"].spacing(4),

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The HTML tag to use when rendering the component to the DOM.
   */
  tag: _propTypes["default"].string,

  /**
   * The type of visuals to apply to the box. If this is omitted the box will
   * not have any decorative styles and can be used purely for layout purposes.
   */
  type: _propTypes["default"].oneOf(["outline", "fill"]),

  /**
   * Set the width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Box.defaultProps = {
  tag: "div",
  spacingInset: "none"
};
/* eslint-disable react/prop-types */

/**
 * This component renders a themed box. This is only used if themed styles are
 * actually applied to the box. Otherwise we can skip all the extra work that
 * goes into theming.
 */

var ThemedBox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_box["default"], "box");
  return /*#__PURE__*/_react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"])), {}, {
    className: (0, _cxMemoized["default"])((0, _box2.themedStyles)(t)(props), props.className),
    id: props.id,
    tabIndex: props.tabIndex,
    ref: ref
  }), props.children);
});

ThemedBox.displayName = "ThemedBox";
/* eslint-enable react/prop-types */

var _default = Box;
exports["default"] = _default;

/***/ }),
/* 649 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    boxBackgroundColorOutline: tokens.themeBackgroundPrimaryDefault,
    boxBackgroundColorFill: tokens.themeBackgroundSecondaryDefault,
    boxBorderWidth: 1,
    boxBorderRadiusOutline: 4,
    boxBorderRadiusFill: 4,
    boxBorderColorOutline: tokens.themeBorderSecondaryDefault
  }
};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var shim = function shim() {};

shim.isRequired = shim;

var getShim = function getShim() {
  return shim;
}; // Important!
// Keep this list in sync with production version in `./_prop-types.js`.


var size = shim;
var flexAlignment = getShim;
var spacing = getShim;
var alignment = shim;
var _default = {
  size: size,
  flexAlignment: flexAlignment,
  spacing: spacing,
  alignment: alignment
};
exports["default"] = _default;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _emotion = __webpack_require__(11);

/**
 * Global styles
 */
(0, _emotion.injectGlobal)({
  /**
   * Set font smoothing technique
   *
   * On macOS the default font smoothing technique (subpixel antialiasing) is
   * optimized for dark text on light backgrounds. Unfortunately when applied to
   * light text on dark backgrounds this results in extra heavy, fuzzy text. The
   * following two properties turn off subpixel antialiasing in webkit browsers
   * and Firefox on macOS when the display's pixel density is high enough to
   * support full-pixel aliasing without decreasing text legibility.
   */
  "@media screen and (-webkit-min-device-pixel-ratio: 2), screen and (min-resolution: 2dppx)": {
    body: {
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale"
    }
  },

  /**
   * HACK: Fix html5 tags in IE11
   *
   * IE11 won't apply styles correctly to newer html5 tags that it doesn't
   * recognize unless they have a "display" property set.
   */
  "main, nav, header, footer": {
    display: "block"
  }
});

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Style = Style;
exports.useTheme = exports["default"] = exports.ThemeContext = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _blueLight = _interopRequireDefault(__webpack_require__(653));

var _token = __webpack_require__(20);

var _functional = __webpack_require__(38);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Context for passing theme tokens down the tree.
 */
var ThemeContext = /*#__PURE__*/(0, _react.createContext)(_blueLight["default"]);
/**
 * Merge two token objects together.
 */

exports.ThemeContext = ThemeContext;
var mergeTokens = (0, _functional.memoizeCurry)(function (a, b) {
  return _objectSpread(_objectSpread({}, a), b);
}, 1);
/**
 * Takes in an object of theme tokens and a function or object of tokens to
 * theme.
 */

var applyTheme = (0, _functional.memoizeCurry)(function (themeTokens, tokens) {
  return typeof tokens === "function" ? mergeTokens(tokens(themeTokens))(themeTokens) : tokens ? mergeTokens(tokens)(themeTokens) : themeTokens;
}, 1);
/**
 * A hook that grants access to theme tokens. Optionally pass in themeable
 * tokens as a function or non-themeable tokens as an object to mix with the
 * theme tokens. If tokens are provided, a prefixKey can be passed to allow easier
 * selection of tokens with a common prefix. For example:
 *   const t = useTheme(buttonTokens, "button")
 *   const buttonBgColor = t("backgroundColor")
 */

var useTheme = function useTheme(tokens) {
  var prefixKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  var _legacyHelperForBackwardsCompatibilityDoNotUse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var themeTokens = (0, _react.useContext)(ThemeContext);
  var currentTokens = applyTheme(themeTokens)(tokens);
  return typeof _legacyHelperForBackwardsCompatibilityDoNotUse === "function" ? _legacyHelperForBackwardsCompatibilityDoNotUse(currentTokens) : _legacyHelperForBackwardsCompatibilityDoNotUse ? currentTokens : (0, _token.getTokenHelper)(prefixKey)(currentTokens);
};
/**
 * Set the theme. Changes are applied to all the component's descendants.
 */


exports.useTheme = useTheme;

function Theme(_ref) {
  var tokens = _ref.tokens,
      children = _ref.children;
  var contextTokens = (0, _react.useContext)(ThemeContext);
  var currentTokens = mergeTokens(contextTokens)(tokens);
  return /*#__PURE__*/_react["default"].createElement(ThemeContext.Provider, {
    value: currentTokens
  }, children);
}

Theme.propTypes =  false ? {
  /**
   * The components to apply the theme to.
   */
  children: _propTypes["default"].element.isRequired,

  /**
   * An object of theme tokens imported from the Meridian token library.
   */
  tokens: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].string)])).isRequired
} : {};
/**
 * IMPORTANT: For backwards-compatibility only! Use the "useTheme" hook instead.
 */

function Style(_ref2) {
  var tokens = _ref2.tokens,
      map = _ref2.map,
      children = _ref2.children;
  return children(useTheme(tokens, "", map || true));
}

Style.propTypes = {
  children: _propTypes["default"].func.isRequired,
  map: _propTypes["default"].func,
  tokens: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])
};
var _default = Theme;
exports["default"] = _default;

/***/ }),
/* 653 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  themeForegroundPrimaryDefault: "#232F3E",
  themeForegroundPrimaryFocus: "#077398",
  themeForegroundPrimaryError: "#AD0A30",
  themeForegroundPrimaryDisabled: "#BBC0C1",
  themeForegroundSecondaryDefault: "#697576",
  themeForegroundSecondaryDisabled: "#E7E9E9",
  themeForegroundTertiaryDefault: "#697576",
  themeForegroundTertiaryHover: "#485050",
  themeForegroundTertiaryPressed: "#252829",
  themeForegroundTertiaryDisabled: "#ABB0B5",
  themeForegroundInvertedDefault: "#FFFFFF",
  themeForegroundAccentDefault: "#077398",
  themeForegroundAccentHover: "#055D7B",
  themeForegroundAccentPressed: "#03384B",
  themeForegroundAccentDisabled: "#C1DEE8",
  themeBorderPrimaryDefault: "#697576",
  themeBorderPrimaryDisabled: "#BBC0C1",
  themeBorderPrimaryFocus: "#077398",
  themeBorderPrimaryError: "#CC0C39",
  themeBorderPrimaryWarning: "#DCB700",
  themeBorderSecondaryDefault: "#BBC0C1",
  themeBorderSecondaryFocus: "#00A8E1",
  themeBorderTertiaryDefault: "#E7E9E9",
  themeBorderAlternateDefault: "rgba(0, 0, 0, 0)",
  themeBorderAccentDefault: "#00A8E1",
  themeBorderAccentHover: "#077398",
  themeBorderAccentPressed: "#055D7B",
  themeBorderAccentDisabled: "#90C5D7",
  themeBorderAccentPreselected: "#7CCEE9",
  themeBorderAlternateAccentDefault: "#055D7B",
  themeBackgroundPrimaryDefault: "#FFFFFF",
  themeBackgroundPrimaryDisabled: "#F0F1F2",
  themeBackgroundSecondaryDefault: "#F0F1F2",
  themeBackgroundSecondaryError: "#FF7494",
  themeBackgroundSecondaryWarning: "#FCDE4D",
  themeBackgroundTertiaryDefault: "#E7E9E9",
  themeBackgroundTertiaryHover: "#BBC0C1",
  themeBackgroundTertiaryPressed: "#949C9C",
  themeBackgroundTertiaryDisabled: "#ECEDED",
  themeBackgroundAlternatePrimaryDefault: "#FFFFFF",
  themeBackgroundAlternatePrimarySelected: "#F0F1F2",
  themeBackgroundAlternatePrimaryHover: "#E7E9E9",
  themeBackgroundAlternatePrimaryPressed: "#BBC0C1",
  themeBackgroundAlternateSecondaryDefault: "#F9FAFA",
  themeBackgroundAlternateTertiaryDefault: "#FFFFFF",
  themeBackgroundAlternateTertiaryFocus: "#F9FAFA",
  themeBackgroundAccentDefault: "#B9E8F7",
  themeBackgroundAccentDisabled: "#86A4AF",
  themeBackgroundInvertedDefault: "#0B0C0C",
  themeBackgroundOverlayDefault: "rgba(11, 12, 12, 0.5)",
  themeBackgroundOverlayPressed: "rgba(11, 12, 12, 0.04)",
  themePalette50: "#E5F6FB",
  themePalette100: "#B9E8F7",
  themePalette200: "#7CCEE9",
  themePalette300: "#47C2EC",
  themePalette400: "#00A8E1",
  themePalette500: "#077398",
  themePalette600: "#055D7B",
  themePalette700: "#03384B",
  themePalette800: "#01222D",
  themePaletteMuted100: "#C1DEE8",
  themePaletteMuted200: "#90C5D7",
  themePaletteMuted300: "#86A4AF",
  themePaletteMuted400: "#204B5A",
  themePaletteMuted500: "#24586A",
  themePaletteMuted600: "#14181D",
  _themeColorScaleCategorical: ["#36C2B4","#EB64D7","#FF8F00","#8169F8","#FCC201","#FF5A94","#708090"],
  _themeColorScaleComparison: ["#348118","#DE1B1B"],
  _themeColorScaleViolet: ["#DDC8FF","#C9A8FF","#A588FF","#8169F8","#614FD9","#3E36BB"],
  _themeColorScalePurple: ["#E9C6E4","#ECA8E0","#EC88DC","#EB64D7","#C54FB4","#8C297D"],
  _themeColorScalePink: ["#FFDBE5","#FFB5CA","#FF8CAF","#FF5A94","#DC3C71","#BA1750"],
  _themeColorScaleTangerine: ["#FFE5CB","#FFCB96","#FFAE5D","#FF8F00","#D4780C","#A45C0A"],
  _themeColorScaleGold: ["#FFF4D9","#FFE8B1","#FFDB86","#FCC201","#DAA500","#BF8E00"],
  _themeColorScaleTurquoise: ["#C3E9E7","#78D9CF","#36C2B4","#2C9F93","#227D74","#1B5F5B"],
  _themeColorScaleForest: ["#D6ECC9","#ABD994","#7EC55E","#47B120","#348118","#005C00"],
  _themeColorScaleCrimson: ["#FFD9CF","#FFB09F","#F98771","#EE5A46","#DE1B1B","#AF1F18"],
  _themeColorScaleSlate: ["#DADEE2","#B6BDC6","#929EAB","#708090","#596571","#434C54"],
  _themeColorScaleDiverging: ["#2C9F93","#36C2B4","#78D9CF","#C3E9E7","#FFF4D9","#FFE8B1","#FFDB86","#FCC201"],
  _themeColorScaleDivergingWithMiddle: ["#C54FB4","#EB64D7","#EC88DC","#ECA8E0","#FFF4D9","#78D9CF","#36C2B4","#2C9F93","#227D74"]
};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _upperFirst = _interopRequireDefault(__webpack_require__(339));

var pascalCase = function pascalCase(strings) {
  return strings.map(_upperFirst["default"]).join("");
};

var _default = pascalCase;
exports["default"] = _default;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var lowerFirst = function lowerFirst(str) {
  return str ? str.charAt(0).toLowerCase() + str.slice(1) : "";
};

var _default = lowerFirst;
exports["default"] = _default;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themedStyles = exports.styles = exports.cardStyles = void 0;

var _emotion = __webpack_require__(11);

var _text = _interopRequireDefault(__webpack_require__(47));

var _functional = __webpack_require__(38);

var _borderRadius = _interopRequireDefault(__webpack_require__(127));

var _token = __webpack_require__(20);

var _parsers = __webpack_require__(128);

var cardStyles = (0, _functional.memoize)(function (c) {
  var borderRadius = c("borderRadius");
  var imageBorderRadius = borderRadius - c("borderWidth");
  return (0, _emotion.css)((0, _text["default"])(c), {
    border: c.borderCss("border"),
    borderRadius: borderRadius,
    boxShadow: c.boxShadowCss("dropShadowDefault"),
    position: "relative",
    "& > *[role=img]": {
      borderRadius: (0, _borderRadius["default"])(imageBorderRadius, ["topLeft", "topRight"])
    }
  });
});
exports.cardStyles = cardStyles;
var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      borderColor = _ref.borderColor,
      borderWidth = _ref.borderWidth,
      borderRadius = _ref.borderRadius,
      width = _ref.width,
      height = _ref.height,
      minWidth = _ref.minWidth,
      minHeight = _ref.minHeight,
      maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight,
      overflowX = _ref.overflowX,
      overflowY = _ref.overflowY,
      spacingInset = _ref.spacingInset;
  return (0, _emotion.css)({
    boxSizing: "border-box",
    // If we have a border radius defined then clip content so that it doesn't
    // bleed out the corners
    overflow: borderRadius ? "hidden" : undefined,
    overflowX: overflowX ? overflowX : undefined,
    overflowY: overflowY ? overflowY : undefined,
    padding: (0, _parsers.parseSpacing)(spacingInset).map(function (value) {
      return "".concat(value, "px");
    }).join(" "),
    borderStyle: borderWidth && borderColor ? "solid" : undefined,
    borderWidth: borderWidth,
    borderColor: borderColor,
    borderRadius: borderRadius,
    backgroundColor: backgroundColor,
    width: width,
    height: height,
    minWidth: minWidth,
    maxWidth: maxWidth,
    minHeight: minHeight,
    maxHeight: maxHeight
  });
}, ["backgroundColor", "borderColor", "borderWidth", "borderRadius", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "overflowX", "overflowY", "spacingInset"]);
exports.styles = styles;
var themedStyles = (0, _functional.memoize)(function (t) {
  return (0, _functional.memoizeByKeys)(function (_ref2) {
    var type = _ref2.type,
        backgroundColor = _ref2.backgroundColor,
        width = _ref2.width,
        height = _ref2.height,
        minWidth = _ref2.minWidth,
        minHeight = _ref2.minHeight,
        maxWidth = _ref2.maxWidth,
        maxHeight = _ref2.maxHeight,
        overflowX = _ref2.overflowX,
        overflowY = _ref2.overflowY,
        spacingInset = _ref2.spacingInset;
    return styles({
      backgroundColor: backgroundColor ? (0, _token.getToken)(t.tokens, "themeBackground", [backgroundColor, "default"]) || backgroundColor : t("backgroundColor", type),
      borderColor: t("borderColor", type),
      borderWidth: t("borderWidth"),
      borderRadius: t("borderRadius", type),
      width: width,
      height: height,
      minWidth: minWidth,
      minHeight: minHeight,
      maxWidth: maxWidth,
      maxHeight: maxHeight,
      overflowX: overflowX,
      overflowY: overflowY,
      spacingInset: spacingInset
    });
  }, ["type", "backgroundColor", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "overflowX", "overflowY", "spacingInset"]);
});
exports.themedStyles = themedStyles;

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AdtaDeviceOverviewContext__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_FeatureUtility__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var AdtaDevicePage=function(_Component){_inherits(AdtaDevicePage,_Component);function AdtaDevicePage(){_classCallCheck(this,AdtaDevicePage);return _possibleConstructorReturn(this,(AdtaDevicePage.__proto__||Object.getPrototypeOf(AdtaDevicePage)).apply(this,arguments));}_createClass(AdtaDevicePage,[{key:"render",value:function render(){var getADTARoutes=function getADTARoutes(){return __WEBPACK_IMPORTED_MODULE_5__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_5__util_FeatureUtility__["a" /* FEATURES */].IS_MHE_VALIDATION_ENABLED)?[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["a" /* ADTA */]),[__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["E" /* adtaMheValidationRoute */]]):__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["a" /* ADTA */];};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_AdtaDeviceOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["b" /* default */],{routes:getADTARoutes(),location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["a" /* NavigationRoutes */],{routes:getADTARoutes()})));}}]);return AdtaDevicePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AdtaDevicePage);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdtaDeviceOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_AdtaDeviceOverviewNetworkAPI__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
var AdtaDeviceOverviewReducer=function AdtaDeviceOverviewReducer(state,action){switch(action.type){case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingOverview:false,timestamp:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_14" /* getTimestampNow */])()});case"LOAD_VIEW":Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtaDeviceOverviewNetworkAPI__["b" /* fetchAdtaDeviceDetails */])(action.data.dispatcher);return state;case"LOAD_STATUS":Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtaDeviceOverviewNetworkAPI__["c" /* fetchAdtaStatusDetails */])(action.data.dispatcher,state);return state;case"UPDATE_ADTA_CONFIGURATION":Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtaDeviceOverviewNetworkAPI__["e" /* updateAdtaConfiguration */])(action.data.dispatcher,action.data.configurations,action.data.mac,action.data.showCustomAlert);return state;case"ADD_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtaDeviceOverviewNetworkAPI__["d" /* setAdtaDeviceDetails */])(action.data.dispatcher,action.data.stateValues,action.data.showCustomAlert);return state;case"UPDATE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtaDeviceOverviewNetworkAPI__["f" /* updateAdtaDeviceDetails */])(action.data.dispatcher,action.data.stateValues,action.data.showCustomAlert);return state;case"UPDATE_DEVICE_MAC":Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtaDeviceOverviewNetworkAPI__["g" /* updateAdtaDeviceMac */])(action.data.dispatcher,action.data.stateValues,action.data.mac,action.data.showCustomAlert);return state;case"DELETE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtaDeviceOverviewNetworkAPI__["a" /* deleteAdtaDeviceDetails */])(action.data.dispatcher,action.data.mac);return state;case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});case"UPDATE_MONITORING_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtaDeviceOverviewNetworkAPI__["h" /* updateAdtaMonitoringDetails */])(action.data.dispatcher,action.data.stateValues,action.data.mac);return state;default:return state;}};

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAdtaDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAdtaStatusDetails;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteAdtaDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["d"] = setAdtaDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateAdtaDeviceDetails;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateAdtaDeviceMac; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateAdtaConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateAdtaMonitoringDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datamodel_AdtaAssetModelResource__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources_StatusResource__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_FeatureUtility__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonui_DeviceHealthStatusHelper__ = __webpack_require__(837);
var getAdtaDeviceDetails=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatcher,request){var model;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:model={adtaDeviceInformation:{},sorterConfig:{},sorterTestPackageConfig:{},macAddressArray:[]// Fetch static asset details
};_context2.next=3;return getADTADeviceStaticDetails(dispatcher,model,request);case 3:_context2.next=5;return getAdtaDeviceStatusDetails(dispatcher,model);case 5:case"end":return _context2.stop();}}},_callee2,this);}));return function getAdtaDeviceDetails(_x5,_x6){return _ref2.apply(this,arguments);};}();var getAdtaDeviceStatusDetails=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatcher,model){var useNewAPI,startTime,adtaStatusResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:useNewAPI=__WEBPACK_IMPORTED_MODULE_6__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_6__util_FeatureUtility__["a" /* FEATURES */].IS_ADTA_DEVICE_HEALTH_STATUS_API_ENABLED);if(!useNewAPI){_context3.next=7;break;}_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_7__commonui_DeviceHealthStatusHelper__["a" /* fetchAndMapDeviceHealthStatus */])(model,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["c" /* ADTA_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_1__util_Constants__["d" /* ADTA_DEVICE_INFO_KEY */],metricProcessName);case 4:dispatcher({type:"RECEIVE_DATA",data:model});_context3.next=16;break;case 7:// Existing legacy API path
startTime=Date.now();_context3.next=10;return Object(__WEBPACK_IMPORTED_MODULE_5__resources_StatusResource__["a" /* getAdtaDeviceStatus */])(model.macAddressArray);case 10:adtaStatusResponse=_context3.sent;isSuccess=adtaStatusResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(adtaStatusResponse.status);if(isSuccess){mergeStatusToModel(adtaStatusResponse,model);}else{model.macAddressArray.forEach(function(mac){model.adtaDeviceInformation[mac].assetStatus=__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_109" /* LOADING_FAILED */];});}dispatcher({type:"RECEIVE_DATA",data:model});// Log operation
Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAdtaDeviceStatusDetails",isSuccess,isFault);case 16:case"end":return _context3.stop();}}},_callee3,this);}));return function getAdtaDeviceStatusDetails(_x7,_x8){return _ref3.apply(this,arguments);};}();var getADTADeviceStaticDetails=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatcher,model,request){var pageToken,startTime,getAssetsResult,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:pageToken=null;// do-while loop until we get a valid pageToken
case 1:startTime=Date.now();_context4.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["g" /* getAssets */])(request.nodeId,request.assetType,pageToken);case 4:getAssetsResult=_context4.sent;isSuccess=getAssetsResult.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(getAssetsResult.status);// Log operation
Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAdtaDeviceDetails",isSuccess,isFault);if(isSuccess){addADTADeviceStaticDetailsToModel(getAssetsResult,model);// modifying pageToken to fetch from the latest get assets' result
pageToken=getAssetsResult.data.pageToken;}else{dispatcher({type:"RECEIVE_DATA",data:[]});}case 9:if(pageToken){_context4.next=1;break;}case 10:case"end":return _context4.stop();}}},_callee4,this);}));return function getADTADeviceStaticDetails(_x9,_x10,_x11){return _ref4.apply(this,arguments);};}();var setAssetLabelDeprecatedAdtaDeviceDetails=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatcher,request){var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:startTime=Date.now();Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetLabel,request.assetStatus).then(function(result){if(result.status===200){Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteAdtaDeviceDetails",true,false);fetchAdtaDeviceDetails(dispatcher);}else{var isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(result.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteAdtaDeviceDetails",false,isFault);dispatcher({type:"RECEIVE_DATA",data:[]});}});case 2:case"end":return _context5.stop();}}},_callee5,this);}));return function setAssetLabelDeprecatedAdtaDeviceDetails(_x12,_x13){return _ref5.apply(this,arguments);};}();var addAdtaDeviceDetails=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatcher,request,showCustomAlert){var _this=this;var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:startTime=Date.now();_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_29" /* setAliasToRequest */])(request);case 3:Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["a" /* addAsset */])(request).then(function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(result){var isFault,getAssetResult,responseSetAssetStatus,responseUpdateAsset,isFaultInUpdateAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(!(result.status===200)){_context7.next=4;break;}Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAdtaDeviceDetails",true,false);_context7.next=28;break;case 4:// 500 response status can be for any reason. One of those is : asset already exists so trying to update it.
// UpdateAsset only works on ACTIVE devices so first setting status as ACTIVE.
isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(result.status);_context7.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 7:getAssetResult=_context7.sent;if(Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(getAssetResult.data.asset.assetDetails.assetStatus)){_context7.next=12;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["B" /* ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET */]);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAdtaDeviceDetails",false,isFault);return _context7.abrupt("return");case 12:_context7.next=14;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]);case 14:responseSetAssetStatus=_context7.sent;if(!(responseSetAssetStatus.status!==200)){_context7.next=19;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAdtaDeviceDetails",false,isFault);return _context7.abrupt("return");case 19:_context7.next=21;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 21:responseUpdateAsset=_context7.sent;if(!(responseUpdateAsset.status!==200)){_context7.next=27;break;}isFaultInUpdateAsset=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(responseUpdateAsset.status);showCustomAlert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAdtaDeviceDetails",false,isFaultInUpdateAsset);return _context7.abrupt("return");case 27:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAdtaDeviceDetails",true,false);case 28:fetchAdtaDeviceDetails(dispatcher);case 29:case"end":return _context7.stop();}}},_callee7,_this);}));return function(_x21){return _ref8.apply(this,arguments);};}());case 4:case"end":return _context8.stop();}}},_callee8,this);}));return function addAdtaDeviceDetails(_x18,_x19,_x20){return _ref7.apply(this,arguments);};}();var updateAdtaAsset=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatcher,request,showCustomAlert){var setAssetStatusResponse,startTime,getAssetResult,updateAssetResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]);case 2:setAssetStatusResponse=_context9.sent;if(!(setAssetStatusResponse.status!==200)){_context9.next=7;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);fetchAdtaDeviceDetails(dispatcher);return _context9.abrupt("return");case 7:// Update asset details
startTime=Date.now();_context9.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_29" /* setAliasToRequest */])(request);case 10:_context9.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 12:getAssetResult=_context9.sent;_context9.next=15;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 15:updateAssetResponse=_context9.sent;isSuccess=updateAssetResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(updateAssetResponse.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAdtaDeviceDetails",isSuccess,isFault);fetchAdtaDeviceDetails(dispatcher);case 20:case"end":return _context9.stop();}}},_callee9,this);}));return function updateAdtaAsset(_x22,_x23,_x24){return _ref9.apply(this,arguments);};}();var updateAdtaMonitoringSchedule=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatcher,request){var startTime,getAssetResult,updateAssetInPlaceResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:// Update asset details
startTime=Date.now();_context10.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 3:getAssetResult=_context10.sent;_context10.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["l" /* updateAssetInPlace */])(request,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.lastUpdateTime;},null));case 6:updateAssetInPlaceResponse=_context10.sent;isSuccess=updateAssetInPlaceResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(updateAssetInPlaceResponse.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAdtaDeviceDetails",isSuccess,isFault);fetchAdtaDeviceDetails(dispatcher);case 11:case"end":return _context10.stop();}}},_callee10,this);}));return function updateAdtaMonitoringSchedule(_x25,_x26){return _ref10.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="ADTA_DEVICE_DETAILS";function fetchAdtaDeviceDetails(dispatcher){var request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["c" /* ADTA_ASSET_TYPE */]};getAdtaDeviceDetails(dispatcher,request);}function fetchAdtaStatusDetails(dispatcher,model){getAdtaDeviceStatusDetails(dispatcher,model);}function deleteAdtaDeviceDetails(dispatcher,mac){var request={assetLabel:{type:"MAC_ADDRESS",value:mac},assetStatus:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_19" /* DEPRECATED */]};setAssetLabelDeprecatedAdtaDeviceDetails(dispatcher,request);}function setAdtaDeviceDetails(dispatcher,stateValues,showCustomAlert){stateValues.mac=stateValues.mac.toLowerCase();var request=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["c" /* ADTA_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]);addAdtaDeviceDetails(dispatcher,request,showCustomAlert);}function updateAdtaDeviceDetails(dispatcher,stateValues,showCustomAlert){var request=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["c" /* ADTA_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]);updateAdtaAsset(dispatcher,request,showCustomAlert);}var updateAdtaDeviceMac=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher,stateValues,mac,showCustomAlert){var startTime,assetLabel,assetResult,nodeId,assetStatus;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:startTime=Date.now();assetLabel=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["C" /* getAssetLabelFromMac */])(stateValues.mac.toLowerCase());_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(assetLabel);case 4:assetResult=_context.sent;nodeId=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.nodeId;},null);assetStatus=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.assetStatus;},null);if(assetStatus&&!Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(assetStatus)){showCustomAlert(Object(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_225" /* getUpdateAssetMessageAlertWithSite */])(nodeId));Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAdtaDeviceDetails",false,false);}else{deleteAdtaDeviceDetails(dispatcher,mac);setAdtaDeviceDetails(dispatcher,stateValues,showCustomAlert);}case 8:case"end":return _context.stop();}}},_callee,this);}));return function updateAdtaDeviceMac(_x,_x2,_x3,_x4){return _ref.apply(this,arguments);};}();var addADTADeviceStaticDetailsToModel=function addADTADeviceStaticDetailsToModel(result,model){if("data"in result&&"assetDetailsList"in result.data){result.data.assetDetailsList.forEach(function(adtaDeviceDetail){if(adtaDeviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]){model.macAddressArray.push(adtaDeviceDetail.assetAttributes.mac);var mac=adtaDeviceDetail.assetAttributes.mac;var id=JSON.parse(adtaDeviceDetail.assetAttributes.deviceConfig).id;model.adtaDeviceInformation[mac]={name:adtaDeviceDetail.assetAttributes.name,mac:adtaDeviceDetail.assetAttributes.mac,ip:adtaDeviceDetail.assetAttributes.ip,id:id,port:adtaDeviceDetail.assetAttributes.port,vendorAttributes:getVendorAttributes(adtaDeviceDetail.vendorAttributes),assetStatus:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_110" /* LOADING_STRING */],pingStatus:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_110" /* LOADING_STRING */],lastConnectionTime:"",recentSuccessfulPingTime:"",troubleShootHint:"",deviceType:adtaDeviceDetail.assetAttributes.deviceType,assetType:adtaDeviceDetail.assetType,maxRecircPerPackage:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return parseInt(adtaDeviceDetail.assetAttributes.maxRecircPerPackage,10);},0),startTime:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(adtaDeviceDetail.assetAttributes.monitoring).startTime;},"0"),endTime:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(adtaDeviceDetail.assetAttributes.monitoring).endTime;},"0"),reason:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(adtaDeviceDetail.assetAttributes.monitoring).reason;},"")};model.sorterTestPackageConfig[mac]=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(adtaDeviceDetail.assetAttributes.sorterTestPackage,[]);});var sorterConfig=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(adtaDeviceDetail.assetAttributes.sorterConfig);},[]);model.sorterConfig[mac]=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["l" /* compressSorterConfig */])(sorterConfig);}});}return model;};var getVendorAttributes=function getVendorAttributes(vendorAttributes){var vendor=vendorAttributes.vendor||__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */].vendor;var spec_version=vendorAttributes.spec_version||__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */].spec_version;var sorter_type=vendorAttributes.sorter_type||__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */].sorter_type;var hamper_vendor=vendorAttributes.hamper_vendor||__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */].hamper_vendor;var hamper_version=vendorAttributes.hamper_version||__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */].hamper_version;var incoming_auto_singulated=vendorAttributes.incoming_auto_singulated||__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_77" /* FALSE_VALUE */];var incoming_auto_sorted=vendorAttributes.incoming_auto_sorted||__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_77" /* FALSE_VALUE */];return{vendor:vendor,spec_version:spec_version,sorter_type:sorter_type,hamper_vendor:hamper_vendor,hamper_version:hamper_version,incoming_auto_singulated:incoming_auto_singulated,incoming_auto_sorted:incoming_auto_sorted};};var updateAdtaConfiguration=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatcher,configurations,mac,showCustomAlert){var getAssetResult,startTime,alias,updatedAsset,updateResult,isUpdateSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 2:getAssetResult=_context6.sent;// Merge current configuration into existing configuration and update
startTime=Date.now();_context6.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["B" /* getAliasFromParent */])();case 6:alias=_context6.sent;updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_4__datamodel_AdtaAssetModelResource__["a" /* updateConfigurationsInAdtaAssetObject */])(getAssetResult.data.asset,configurations,alias);_context6.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(updatedAsset,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 10:updateResult=_context6.sent;isUpdateSuccess=updateResult.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(updateResult.status);fetchAdtaDeviceDetails(dispatcher);// Log operation
isUpdateSuccess?showCustomAlert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["D" /* ALERT_UPDATE_SUCCESS_ASSET_MESSAGE */]):showCustomAlert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAdtaConfiguration",isUpdateSuccess,isFault);case 16:case"end":return _context6.stop();}}},_callee6,this);}));return function updateAdtaConfiguration(_x14,_x15,_x16,_x17){return _ref6.apply(this,arguments);};}();function mergeStatusToModel(response,model){if("data"in response&&"adtaStatusList"in response.data){response.data.adtaStatusList.forEach(function(singleAdtaDeviceStatusDetail){model.adtaDeviceInformation[singleAdtaDeviceStatusDetail.mac].assetStatus=singleAdtaDeviceStatusDetail.status;});}}var updateExistingAssetAttributes=function updateExistingAssetAttributes(asset,stateValues){var updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["t" /* deepCopyObject */])(asset);updatedAsset.assetDetails.assetAttributes.monitoring=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(stateValues);},asset.assetDetails.assetAttributes.monitoring);return updatedAsset;};var updateAdtaMonitoringDetails=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatcher,stateValues,mac){var getAssetResult,updatedAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 2:getAssetResult=_context11.sent;updatedAsset=updateExistingAssetAttributes(getAssetResult.data.asset,stateValues);updateAdtaMonitoringSchedule(dispatcher,updatedAsset);case 5:case"end":return _context11.stop();}}},_callee11,this);}));return function updateAdtaMonitoringDetails(_x27,_x28,_x29){return _ref11.apply(this,arguments);};}();

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(661);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 661 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _alert = _interopRequireDefault(__webpack_require__(666));

var _alertErrorXlarge = _interopRequireDefault(__webpack_require__(667));

var _alertErrorLarge = _interopRequireDefault(__webpack_require__(668));

var _alertErrorSmall = _interopRequireDefault(__webpack_require__(252));

var _alertInformationalLarge = _interopRequireDefault(__webpack_require__(669));

var _alertInformationalSmall = _interopRequireDefault(__webpack_require__(670));

var _alertSuccessXlarge = _interopRequireDefault(__webpack_require__(671));

var _alertSuccessLarge = _interopRequireDefault(__webpack_require__(672));

var _alertSuccessSmall = _interopRequireDefault(__webpack_require__(673));

var _alertWarningXlarge = _interopRequireDefault(__webpack_require__(674));

var _alertWarningLarge = _interopRequireDefault(__webpack_require__(675));

var _alertWarningSmall = _interopRequireDefault(__webpack_require__(676));

var _close = _interopRequireDefault(__webpack_require__(154));

var _theme = __webpack_require__(24);

var _button = _interopRequireDefault(__webpack_require__(8));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

var _token = __webpack_require__(20);

var _focus = __webpack_require__(193);

var _getIconCss = _interopRequireDefault(__webpack_require__(156));

var _text = _interopRequireDefault(__webpack_require__(47));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var iconTokens = {
  small: {
    error: _alertErrorSmall["default"],
    informational: _alertInformationalSmall["default"],
    success: _alertSuccessSmall["default"],
    warning: _alertWarningSmall["default"]
  },
  medium: {
    error: _alertErrorSmall["default"],
    informational: _alertInformationalSmall["default"],
    success: _alertSuccessSmall["default"],
    warning: _alertWarningSmall["default"]
  },
  large: {
    error: _alertErrorLarge["default"],
    informational: _alertInformationalLarge["default"],
    success: _alertSuccessLarge["default"],
    warning: _alertWarningLarge["default"]
  },
  xlarge: {
    error: _alertErrorXlarge["default"],
    informational: _alertInformationalLarge["default"],
    success: _alertSuccessXlarge["default"],
    warning: _alertWarningXlarge["default"]
  }
};
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _css2;

  var size = _ref.size,
      type = _ref.type,
      toast = _ref.toast,
      width = _ref.width;
  var borderWidth = t("borderWidth", size);
  var icon = (0, _token.getIconFromTokens)(iconTokens[size][type]);
  return (0, _emotion.css)((_css2 = {
    /**
     * Container styles
     */
    boxSizing: "border-box",
    display: "flex",
    flexDirection: size === "xlarge" ? "column" : "row",
    alignItems: size === "xlarge" ? "center" : "flex-start",
    backgroundColor: t("backgroundColor", [size, type]),
    borderWidth: borderWidth,
    borderColor: t("borderColor", type),
    borderStyle: borderWidth ? "solid" : undefined,
    borderRadius: t("borderRadius"),
    padding: t("spacingInset", size),
    width: width,
    boxShadow: toast && (size === "medium" || size === "large") ? t.boxShadowCss("shadow") : undefined,
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // "& > * + *": {
    //   marginInlineStart: t("spacingHorizontal", size),
    // },
    "& > * + *": {
      marginLeft: t("spacingHorizontal", size),
      marginRight: "0"
    }
  }, (0, _defineProperty2["default"])(_css2, "[dir=\"rtl\"] & > * + *", {
    marginRight: t("spacingHorizontal", size),
    marginLeft: "0"
  }), (0, _defineProperty2["default"])(_css2, "& > [role=img]", {
    flexShrink: 0,
    alignSelf: size === "xlarge" ? "center" : "stretch",
    backgroundImage: (0, _getIconCss["default"])(icon.data, t("foregroundColor", [size, type])),
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: icon.width,
    // This ensures that the icon is vertically centered on the first line of
    // text for single-line alerts and on the first two lines of text for
    // multi-line alerts.
    minHeight: icon.height,
    maxHeight: icon.height * 2
  }), (0, _defineProperty2["default"])(_css2, "& [mdn-text]", (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: ["message", size],
    fontWeight: "body",
    // TODO: This token should be renamed to "message"
    lineHeight: ["message", size]
  }), {
    textAlign: size === "xlarge" ? "center" : "initial",
    color: t("foregroundColor", [size, type]),
    flex: "auto",
    display: "flex",
    flexDirection: size === "xlarge" ? "column" : "row",
    // Allow the message to wrap below the title if it's too long to fit.
    flexWrap: "wrap"
  })), (0, _defineProperty2["default"])(_css2, "& [mdn-alert-title]", (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: ["title", size],
    fontWeight: "title",
    lineHeight: ["title", size]
  }), (0, _defineProperty2["default"])({
    color: t("foregroundColor", [size, type]),
    flexShrink: 0,
    fontWeight: t("fontWeightTitle"),
    // Fallback to "0" for margin-top to cancel out default browser stylings
    // on heading elements
    marginTop: t("spacingVertical", size) || 0,
    marginBottom: 0,
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // marginInlineEnd: t("titleSpacingRight", size),
    marginRight: t("titleSpacingRight", size),
    marginLeft: 0
  }, "[dir=\"rtl\"] &", {
    marginLeft: t("titleSpacingRight", size),
    marginRight: 0
  }))), (0, _defineProperty2["default"])(_css2, "& [mdn-alert-message]", {
    margin: 0,
    marginTop: t("spacingVertical", size),
    // Make the message fill the whole width of the alert, but keep it on
    // the same line as the title until it has to wrap.
    flex: "auto",
    flexShrink: 0,
    maxWidth: "100%"
  }), (0, _defineProperty2["default"])(_css2, "& [mdn-link]", {
    color: "".concat(t("linkColor", [size]), " !important"),
    textDecoration: size === "medium" || size === "large" ? "underline !important" : undefined
  }), _css2));
}, ["size", "type", "toast", "width"]);

var closeButtonStyles = function closeButtonStyles(t, _ref2) {
  var size = _ref2.size;
  return (0, _emotion.css)(size === "xlarge" ? (0, _defineProperty2["default"])({
    position: "absolute",
    top: t("closeButtonSpacing", size),
    right: t("closeButtonSpacing", size)
  }, "[dir=\"rtl\"] &", {
    right: "auto",
    left: t("closeButtonSpacing", size)
  }) : (0, _defineProperty2["default"])({
    flexShrink: 0,
    margin: t("closeButtonSpacing", size) - t("spacingInset", size),
    // HACK: Since we specify marginLeft/Right for the & > * + * style above
    // to accommodate IE11 we have to overwrite them with !important here.
    // If/when we drop IE11 we can simplify these styles to be:
    // marginInlineStart: t("spacingHorizontal", size),
    marginLeft: "".concat(t("spacingHorizontal", size), "px !important"),
    marginRight: "".concat(t("closeButtonSpacing", size) - t("spacingInset", size), "px !important")
  }, "[dir=\"rtl\"] &", {
    marginRight: "".concat(t("spacingHorizontal", size), "px !important"),
    marginLeft: "".concat(t("closeButtonSpacing", size) - t("spacingInset", size), "px !important")
  }));
};

var AlertTitle = function AlertTitle(_ref5) {
  var level = _ref5.level,
      children = _ref5.children,
      id = _ref5.id;
  var Tag = level ? "h".concat(level) : "div";
  return /*#__PURE__*/_react["default"].createElement(Tag, {
    "mdn-alert-title": "",
    id: id
  }, children);
};
/**
 * Render a banner that communicates status, feedback, and severity to the
 * customer.
 */


function Alert(props) {
  var t = (0, _theme.useTheme)(_alert["default"], "alert");
  var idPrefix = (0, _react.useMemo)(function () {
    return props.id || (0, _uniqueId["default"])("alert-");
  }, [props.id]);
  var node = (0, _react.useRef)();
  var big = props.size === "large" || props.size === "xlarge";
  var title = big ? props.title : undefined;
  var titleId = title ? "".concat(idPrefix, "-title") : undefined;
  var childrenId = "".concat(idPrefix, "-children");
  var showCloseButton = props.onClose && props.size !== "small";
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]); // If autoFocus is true then focus on the first interactive element in the
  // alert. This'll either be the first action rendered by the user or the
  // alert's close button if there are no actions.

  var autoFocus = props.autoFocus,
      inaccessibleAutoFocus = props.inaccessibleAutoFocus;
  (0, _react.useEffect)(function () {
    if (autoFocus || inaccessibleAutoFocus) {
      var _getKeyboardFocusNode = (0, _focus.getKeyboardFocusNodes)(node.current),
          _getKeyboardFocusNode2 = (0, _slicedToArray2["default"])(_getKeyboardFocusNode, 1),
          firstFocusNode = _getKeyboardFocusNode2[0];

      if (firstFocusNode) {
        firstFocusNode.focus();
      }
    }
  }, [autoFocus, inaccessibleAutoFocus]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, {
    className: styles(t, props),
    ref: autoFocus || inaccessibleAutoFocus ? node : undefined,
    role: showCloseButton ? "alertdialog" : "alert",
    "aria-labelledby": titleId,
    "aria-describedby": childrenId,
    id: idPrefix
  }), /*#__PURE__*/_react["default"].createElement("div", {
    role: "img",
    "aria-hidden": "true"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-text": ""
  }, title ? /*#__PURE__*/_react["default"].createElement(AlertTitle, {
    id: titleId,
    level: props.titleLevel
  }, title) : null, /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-alert-message": "",
    id: childrenId
  }, props.children)), showCloseButton ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    size: big ? "medium" : "small",
    onClick: props.onClose,
    backdropColor: t("backgroundColor", [props.size, props.type]),
    className: closeButtonStyles(t, props),
    label: props.closeLabel
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _close["default"]
  })) : null);
}

Alert.propTypes =  false ? {
  /**
   * The main message to be shown in the alert. Any elements are allowed, but
   * plain text and links are recommended. Meridian [links](https://meridian.a2z.com/components/link/?platform=react-web)
   * will be underlined and use the primary font color.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Alert component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following properties,
   * they'll be ignored:
   *
   * aria-labelledby | aria-describedby
   *
   * @since 5.22.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * An accessible label for the alert's dismiss button. This is not shown in
   * the UI, but will be read by screen-readers.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.22.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.21.0
   */
  id: _propTypes["default"].string,

  /**
   * Automatically focus on the alert when it's presented. The first interactive
   * element rendered in the alert will be focused, otherwise the alert's close
   * button will be focused. This will have no effect if the alert does not
   * contain any interactive elements.
   *
   * Use this when presenting an urgent alert that should grab the user's focus.
   * This will disrupt the user's current task, so use this with caution.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * Sets the size of the component using a preset. Note that this also
   * affects the layout of the alert and the availability of other props (namely
   * `title` and `onClose`).
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * A text-only title to display before the main message. This is only
   * available for alerts with `size` set to `"large"` or `"xlarge"`.
   */
  title: _propTypes["default"].string,

  /**
   * The title heading level. This corresponds directly to the [6 HTML headings](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Heading_Elements)
   * and, if set, will render the Alert title in a heading component. For example,
   * setting `titleLevel={2}` will render the Alert title in an `<h2>` element.
   *
   * You should chose a level based on the Alerts markup position and the documents
   * current heading structure ([lean more](https://www.w3.org/TR/2016/REC-html51-20161101/sections.html#headings-and-sections)). This will make it easier for
   * screen reader users to quickly make sense of the page's structure.
   *
   * For example, if the Alert is intended for the entire page, a `titleLevel={1}`
   * could be warranted. If the Alert is only relevant to a particular section
   * that was titled with a `<Heading level={3}/>`, a `titleLevel={3}` would be
   * a better choice.
   *
   * Because we cannot safely presume the heading structure of your page we do not
   * set a default value. If `titleLevel` is left unset, the title will render
   * in a `<div>` element.
   *
   * @since 5.21.0
   */
  titleLevel: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]),

  /**
   * Use this to indicate that the Alert is being used to display a toast
   * message. A drop shadow will be rendered behind the alert's body. This is
   * only applicable to "medium" and "large" alerts.
   *
   * This prop is intended to be used in tandem with the [Toaster](https://meridian.a2z.com/components/toaster/?platform=react-web) component.
   */
  toast: _propTypes["default"].bool,

  /**
   * The type of message that is being communicated with the alert. See the
   * design guidelines for recommendations regarding which type to use.
   */
  type: _propTypes["default"].oneOf(["error", "warning", "success", "informational"]),

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * If a function is supplied here then a dismiss button will be rendered in
   * the alert. The function will be called when the dismiss button is clicked.
   * The function will not receive any arguments.
   *
   * This only applies to alerts that are not size small. For alert with `size`
   * set to `"xlarge"` the dismiss button will be placed in the top right of
   * the closest parent element of the alert with non-static positioning.
   */
  onClose: _propTypes["default"].func
} : {};
Alert.defaultProps = {
  size: "large",
  type: "informational",
  closeLabel: "Dismiss"
};
AlertTitle.propTypes =  false ? {
  children: Alert.propTypes.title,
  id: _propTypes["default"].string,
  level: Alert.propTypes.titleLevel
} : {};
var _default = Alert;
exports["default"] = _default;

/***/ }),
/* 663 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 664 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 665 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 666 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    alertMobileFontSizeTitleSmall: 14,
    alertMobileFontSizeTitleMedium: 14,
    alertMobileFontSizeTitleLarge: 16,
    alertMobileFontSizeTitleXlarge: 24,
    alertMobileFontSizeMessageSmall: 14,
    alertMobileFontSizeMessageMedium: 14,
    alertMobileFontSizeMessageLarge: 16,
    alertMobileFontSizeMessageXlarge: 16,
    alertMobileLineHeightTitleSmall: "16px",
    alertMobileLineHeightTitleMedium: "16px",
    alertMobileLineHeightTitleLarge: "24px",
    alertMobileLineHeightTitleXlarge: "32px",
    alertMobileLineHeightMessageSmall: "16px",
    alertMobileLineHeightMessageMedium: "16px",
    alertMobileLineHeightMessageLarge: "24px",
    alertMobileLineHeightMessageXlarge: "24px",
    alertMobileMessageSpacingInsetHorizontalLarge: 15,
    alertMobileMessageSpacingInsetVerticalLarge: 8,
    alertMobileCloseButtonSpacingLarge: 3,
    alertBackgroundColorMediumError: "#F9D5E2",
    alertBackgroundColorMediumWarning: "#FEF2B8",
    alertBackgroundColorMediumSuccess: "#DCF3A0",
    alertBackgroundColorMediumInformational: "#F0F1F2",
    alertBackgroundColorLargeError: "#F9D5E2",
    alertBackgroundColorLargeWarning: "#FEF2B8",
    alertBackgroundColorLargeSuccess: "#DCF3A0",
    alertBackgroundColorLargeInformational: "#F0F1F2",
    alertForegroundColorSmallDefault: tokens.themeForegroundPrimaryDefault,
    alertForegroundColorSmallError: tokens.themeForegroundPrimaryError,
    alertForegroundColorMediumDefault: "#232F3E",
    alertForegroundColorLargeDefault: "#232F3E",
    alertForegroundColorXlargeDefault: tokens.themeForegroundPrimaryDefault,
    alertLinkColorMedium: "#232F3E",
    alertLinkColorLarge: "#232F3E",
    alertFontSizeTitleSmall: 14,
    alertFontSizeTitleMedium: 14,
    alertFontSizeTitleLarge: 16,
    alertFontSizeTitleXlarge: 24,
    alertFontSizeMessageSmall: 14,
    alertFontSizeMessageMedium: 14,
    alertFontSizeMessageLarge: 16,
    alertFontSizeMessageXlarge: 16,
    alertFontWeightTitle: 600,
    alertFontWeightBody: 400,
    alertLineHeightTitleSmall: "16px",
    alertLineHeightTitleMedium: "16px",
    alertLineHeightTitleLarge: "24px",
    alertLineHeightTitleXlarge: "32px",
    alertLineHeightMessageSmall: "16px",
    alertLineHeightMessageMedium: "16px",
    alertLineHeightMessageLarge: "24px",
    alertLineHeightMessageXlarge: "24px",
    alertBorderWidthMedium: 1,
    alertBorderWidthLarge: 1,
    alertBorderRadius: 4,
    alertBorderColorError: "#CC0C39",
    alertBorderColorWarning: "#DCB700",
    alertBorderColorSuccess: "#98C91E",
    alertBorderColorInformational: "#BBC0C1",
    alertSpacingInsetMedium: 8,
    alertSpacingInsetLarge: 15,
    alertSpacingInsetXlarge: 15,
    alertSpacingHorizontalSmall: 8,
    alertSpacingHorizontalMedium: 8,
    alertSpacingHorizontalLarge: 16,
    alertSpacingHorizontalXlarge: 0,
    alertCloseButtonSpacingMedium: 0,
    alertCloseButtonSpacingLarge: 7,
    alertCloseButtonSpacingXlarge: 7,
    alertTitleSpacingRightDefault: 8,
    alertTitleSpacingRightXlarge: 0,
    alertSpacingVerticalXlarge: 24,
    alertMotionDuration: "200ms",
    alertMotionFunction: "ease",
    alertShadowColor: "rgba(11, 12, 12, 0.1)",
    alertShadowOffsetX: 0,
    alertShadowOffsetY: 8,
    alertShadowBlur: 16,
    alertShadowSpread: 0
  }
};

/***/ }),
/* 667 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertErrorXlargeData: "data:image/svg+xml,%3csvg width='88' height='88' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle stroke='%23CC0C39' stroke-width='8' fill='%23FF7494' cx='44' cy='44' r='40'/%3e%3cpath d='M44 58.667a5 5 0 100 10 5 5 0 000-10z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M44 23.333v18.334' stroke='%23232F3E' stroke-width='8' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertErrorXlargeWidth: 88,
  iconAlertErrorXlargeHeight: 88
};

/***/ }),
/* 668 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertErrorLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle stroke='%23CC0C39' stroke-width='2' fill='%23FF7494' cx='12' cy='12' r='11'/%3e%3cpath d='M12 16.273A1.364 1.364 0 1012 19a1.364 1.364 0 000-2.727z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M12 7v5' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertErrorLargeWidth: 24,
  iconAlertErrorLargeHeight: 24
};

/***/ }),
/* 669 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertInformationalLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23E7E9E9' cx='12' cy='12' r='11'/%3e%3cpath d='M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z' fill='%23BBC0C1' fill-rule='nonzero'/%3e%3cpath d='M12 11v6M13 17h-2M12 11h-1' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3ccircle fill='%23232F3E' fill-rule='nonzero' cx='12' cy='8' r='1'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertInformationalLargeWidth: 24,
  iconAlertInformationalLargeHeight: 24
};

/***/ }),
/* 670 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertInformationalSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23E7E9E9' fill-rule='nonzero' cx='8' cy='8' r='7.5'/%3e%3cpath d='M8 7.063v3.75M8 7.063h-.938M8.938 10.813H7.062' stroke='%23232F3E' stroke-width='2' stroke-linecap='round'/%3e%3ccircle fill='%23232F3E' fill-rule='nonzero' cx='8' cy='4.25' r='1'/%3e%3cpath d='M8 16A8 8 0 108 0a8 8 0 000 16zm0-1A7 7 0 118 1a7 7 0 010 14z' fill='%23BBC0C1' fill-rule='nonzero'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertInformationalSmallWidth: 16,
  iconAlertInformationalSmallHeight: 16
};

/***/ }),
/* 671 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertSuccessXlargeData: "data:image/svg+xml,%3csvg width='88' height='88' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23C3EB5E' cx='44' cy='44' r='40.333'/%3e%3cpath d='M44 88c24.3 0 44-19.7 44-44S68.3 0 44 0 0 19.7 0 44s19.7 44 44 44zm0-7.333C23.75 80.667 7.333 64.25 7.333 44S23.75 7.333 44 7.333 80.667 23.75 80.667 44 64.25 80.667 44 80.667z' fill='%2398C91E' fill-rule='nonzero'/%3e%3cpath stroke='%23232F3E' stroke-width='8' stroke-linecap='round' stroke-linejoin='round' d='M22 44.061l14.65 14.66L62.358 33'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertSuccessXlargeWidth: 88,
  iconAlertSuccessXlargeHeight: 88
};

/***/ }),
/* 672 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertSuccessLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23C3EB5E' cx='12' cy='12' r='11'/%3e%3cpath d='M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z' fill='%2398C91E' fill-rule='nonzero'/%3e%3cpath stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' d='M6 12.017l3.996 3.998L17.006 9'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertSuccessLargeWidth: 24,
  iconAlertSuccessLargeHeight: 24
};

/***/ }),
/* 673 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertSuccessSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23C3EB5E' fill-rule='nonzero' cx='7.97' cy='7.97' r='7.47'/%3e%3cpath d='M11.705 6.103l-4.669 4.669M7.036 10.772l-2.8-2.802' stroke='%23232F3E' stroke-width='2' stroke-linecap='round'/%3e%3cpath d='M7.97 15.94A7.97 7.97 0 107.97 0a7.97 7.97 0 000 15.94zm0-1A6.97 6.97 0 117.97 1a6.97 6.97 0 010 13.94z' fill='%2398C91E' fill-rule='nonzero'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertSuccessSmallWidth: 16,
  iconAlertSuccessSmallHeight: 16
};

/***/ }),
/* 674 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertWarningXlargeData: "data:image/svg+xml,%3csvg width='88' height='88' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M82.293 72.449L49.898 7.583A6.656 6.656 0 0043.996 4a6.656 6.656 0 00-5.902 3.583L5.699 72.449C1.756 80.29 7.605 84 11.273 84h65.67c3.494 0 9.29-3.814 5.35-11.551z' stroke='%23DCB700' stroke-width='8' fill='%23FCDE4D' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M43.57 62.333a4.583 4.583 0 100 9.167 4.583 4.583 0 000-9.167z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M43.57 36.667v14.666' stroke='%23232F3E' stroke-width='7.333' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertWarningXlargeWidth: 88,
  iconAlertWarningXlargeHeight: 88
};

/***/ }),
/* 675 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertWarningLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M22.532 19.823L13.623 1.985a1.83 1.83 0 00-3.246 0L1.468 19.823C.384 21.98 1.993 23 3.001 23h18.06c.96 0 2.554-1.049 1.47-3.177z' fill='%23FCDE4D'/%3e%3cpath d='M14.518 1.538A2.837 2.837 0 0012 0a2.83 2.83 0 00-2.51 1.523L.574 19.377C-.698 21.905.87 24 3 24h18.06c2.083 0 3.631-2.133 2.364-4.627L14.518 1.538zm7.123 18.74c.552 1.084.09 1.722-.58 1.722H3c-.732 0-1.196-.62-.64-1.727l8.91-17.841a.83.83 0 011.465.015l8.901 17.823.004.007z' fill='%23DCB700' fill-rule='nonzero'/%3e%3cpath d='M12 17a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M12 10v4' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertWarningLargeWidth: 24,
  iconAlertWarningLargeHeight: 24
};

/***/ }),
/* 676 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertWarningSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M15.205 13.08L9.11.994A1.254 1.254 0 008 .326c-.467 0-.895.257-1.111.668L.794 13.08c-.742 1.462.358 2.153 1.048 2.153h12.356c.658 0 1.748-.71 1.007-2.153z' fill='%23FCDE4D'/%3e%3cpath d='M9.557.942a1.757 1.757 0 00-3.11-.007L.302 13.12C-.506 14.71.468 16 1.797 16h12.448c1.296 0 2.258-1.312 1.452-2.882L9.557.942zm4.688 14.077H1.797c-.644 0-1.072-.566-.62-1.456L7.32 1.384A.77.77 0 018 .981c.29 0 .553.159.685.41l6.138 12.17c.45.879.027 1.458-.577 1.458z' fill='%23DCB700' fill-rule='nonzero'/%3e%3cpath d='M8 11.667a1 1 0 100 2 1 1 0 000-2z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M8 6v3' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertWarningSmallWidth: 16,
  iconAlertWarningSmallHeight: 16
};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _button = _interopRequireDefault(__webpack_require__(253));

var _theme = __webpack_require__(24);

var _clickable = _interopRequireDefault(__webpack_require__(108));

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _buttonStyles = __webpack_require__(346);

var _text = _interopRequireDefault(__webpack_require__(47));

var _token = __webpack_require__(20);

var _isColorDark = _interopRequireDefault(__webpack_require__(682));

var _isElementOf = _interopRequireDefault(__webpack_require__(94));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

var isIcon = (0, _isElementOf["default"])(_icon["default"]);
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _css;

  var size = _ref.size,
      type = _ref.type,
      focus = _ref.focus,
      disabled = _ref.disabled,
      minWidth = _ref.minWidth,
      _ref$backdropColor = _ref.backdropColor,
      backdropColor = _ref$backdropColor === void 0 ? t.tokens.themeBackgroundPrimaryDefault : _ref$backdropColor,
      iconOnly = _ref.iconOnly,
      circular = _ref.circular;
  var state = disabled ? "disabled" : "default";
  var linkOrIcon = type === "link" || type === "icon";
  var backdrop = linkOrIcon && (0, _isColorDark["default"])(backdropColor) ? "darkBackdrop" : linkOrIcon ? "lightBackdrop" : undefined;
  var borderColor = t("borderColor", [type, state]);
  var borderWidth = borderColor ? t("borderWidth") : 0;
  var borderStyle = borderColor ? "solid" : undefined;
  var borderRadius = circular && iconOnly ? 999 : t("borderRadius");
  return (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: size
  }), disabled ? (0, _buttonStyles.disabledStyles)(t, {
    type: type,
    backdrop: backdrop
  }) : (0, _buttonStyles.defaultStyles)(t, {
    type: type,
    backdrop: backdrop
  }), (_css = {
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    outline: "none",
    position: "relative",
    minWidth: minWidth,
    height: t("height", size),
    // Make icon-only buttons square w/ no padding and all other buttons
    // flexible with padding.
    width: iconOnly ? t("height", size) : undefined,
    flexShrink: iconOnly ? 0 : undefined,
    padding: iconOnly ? undefined : "0 ".concat(t("spacingInsetHorizontal", size), "px"),
    transition: t.transitionCss("motion", ["color", "background-color", "border-color"]),
    borderRadius: borderRadius,
    borderStyle: borderStyle,
    borderWidth: borderWidth,
    whiteSpace: "nowrap",
    // HACK: IE11 will only show a pseudo element on a button if
    // overflow is set to visible, and our focus ring is displayed with a
    // pseudo element.
    overflow: "visible",
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // "& > * + *": {
    //   marginInlineStart: t("spacingInsetHorizontal", size),
    // },
    "& > * + *": {
      marginLeft: t("spacingInsetHorizontal", size),
      marginRight: 0
    }
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] & > * + *", {
    marginLeft: 0,
    marginRight: t("spacingInsetHorizontal", size)
  }), (0, _defineProperty2["default"])(_css, ":hover", !disabled ? (0, _buttonStyles.hoverStyles)(t, {
    type: type,
    backdrop: backdrop
  }) : undefined), (0, _defineProperty2["default"])(_css, ":active", !disabled ? (0, _buttonStyles.activeStyles)(t, {
    type: type,
    backdrop: backdrop
  }) : undefined), _css), !disabled ? (0, _buttonStyles.focusStyles)(t, {
    focus: focus,
    borderWidth: borderWidth,
    borderRadius: borderRadius,
    backdropColor: backdropColor,
    linkOrIcon: linkOrIcon
  }) : undefined);
}, ["size", "type", "focus", "disabled", "backdropColor", "minWidth", "iconOnly", "circular"]); // Used to wrap button text in spans. This allows the margins applied by the
// button to take effect, since you can't apply a margin to a text node. This
// was implemented with the <Button><Icon /> text</Button> use case in mind
// where spacing needs to be applied between the icon and the text. Note that
// this is not applied if the button only has one child.

var wrapStringSiblingsInSpans = function wrapStringSiblingsInSpans(children) {
  var arr = _react["default"].Children.toArray(children);

  return arr.length > 1 ? arr.map(function (child, index) {
    return typeof child === "string" ? /*#__PURE__*/_react["default"].createElement("span", {
      key: index
    }, child) : child;
  }) : children;
};
/**
 * Render a button. Note that won't necessarily result in a "button" tag in the
 * DOM - if you provide an href attribute then an "a" tag will be used for
 * accessibility purposes.
 */


var Button = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_button["default"], "button"); // Does the button contain only an icon (no text)?

  var iconOnly = _react["default"].Children.count(props.children) === 1 && isIcon(props.children); // Pull popovers closer to icon/link buttons so that they're offset from the
  // edge of the icon/text (which is visible), not the edge of the button
  // element (which is not visible). The magic "24" for the icon variant is the
  // size of a standard icon. By subtracting that from the height of the button
  // and dividing by 2 we get the distance between the invisible edge of the
  // button and the visible edge of the icon.

  var popoverOffset = props.type === "icon" ? -(t("height", props.size) - 24) / 2 : props.type === "link" ? -(t("height", props.size) - t("fontSize", props.size)) / 2 : undefined;

  var _useFocus = (0, _useFocus2["default"])(props),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]);
  return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, {
    ref: ref,
    className: (0, _emotion.cx)(styles(t, {
      type: props.type,
      size: props.size,
      disabled: props.disabled,
      circular: props.circular,
      backdropColor: props.backdropColor,
      minWidth: props.minWidth,
      focus: focus && focusTrigger === "keyboard",
      iconOnly: iconOnly
    }), props.className),
    disabled: props.disabled,
    id: props.id,
    href: props.href,
    rel: props.rel,
    target: props.target,
    onClick: props.onClick,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    propagateClickEvent: props.propagateClickEvent,
    tabIndex: props.tabIndex,
    download: props.download,
    submit: props.submit // eslint-disable-next-line react/prop-types
    ,
    "aria-label": props["aria-label"] || props.label || undefined,
    form: props.form || undefined,
    "mdn-popover-offset": popoverOffset
  }, focusProps), wrapStringSiblingsInSpans(props.children));
});

Button.displayName = "Button";
Button.propTypes =  false ? {
  /**
   * The button's contents. This can be a string label, an Icon, or a
   * combination of a string label and an Icon.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.27.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * This optimizes the button for display when placed over a particular
   * background color. This is only helpful if the button is placed over a
   * background color other than the current theme's primary background color.
   */
  backdropColor: _propTypes["default"].string,

  /**
   * Render a circular button. This is only applicable to icon-only buttons.
   * Buttons with text labels cannot be circular.
   */
  circular: _propTypes["default"].bool,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the `href` prop to render a button that
   * triggers the download of a file. See docs for the [HTML download attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-download).
   */
  download: _propTypes["default"].string,

  /**
   * The form attribute specifies the form the button belongs to. The value of this
   * attribute must be equal to the id attribute of a <form> element in the same
   * document. Please refer to this [guide](https://www.w3schools.com/tags/att_button_form.asp) for details.
   *
   * @since 5.22.0
   */
  form: _propTypes["default"].string,

  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * An accessible label for the component. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   *
   */
  label: _propTypes["default"].string,

  /**
   * Sets the minimum width on the button. The button may grow wider than this
   * value depending on the length of its label, but it will not grow narrow
   * than this value.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Determines whether or not the click event will continue to bubble up
   * through the DOM. Read the [Event.stopPropagation() docs](https://developer.mozilla.org/en-US/docs/Web/API/Event/stopPropagation)
   * for details.
   */
  propagateClickEvent: _propTypes["default"].bool,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * If set to true the button will automatically trigger the submit action of
   * any `<form />` that it's placed in.
   */
  submit: _propTypes["default"].bool,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * This determines the visual style of the button.
   */
  type: _propTypes["default"].oneOf(["primary", "secondary", "tertiary", "link", "icon"]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=react-web)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves over the component. The [mouseenter event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseenter_event)
   * is passed as the first argument to the function.
   */
  onMouseEnter: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves off of the component. The [mouseleave event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseleave_event)
   * is passed as the first argument to the function.
   */
  onMouseLeave: _propTypes["default"].func
} : {};
Button.defaultProps = {
  propagateClickEvent: true,
  size: "medium",
  type: "primary"
};
var _default = Button;
exports["default"] = _default;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _keycode = _interopRequireDefault(__webpack_require__(72));

var _noop = _interopRequireDefault(__webpack_require__(59));

var _buttonReset = _interopRequireDefault(__webpack_require__(344));

var _linkReset = _interopRequireDefault(__webpack_require__(679));

var _functional = __webpack_require__(38);

var _cxMemoized = _interopRequireDefault(__webpack_require__(107));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var tag = _ref.tag,
      disabled = _ref.disabled;
  return (0, _emotion.css)({
    button: _objectSpread(_objectSpread({}, _buttonReset["default"]), {}, {
      // HACK: IE offsets the contents of buttons on mouse down (in the active
      // state) to create a faux 3D effect. These styles are applied to every
      // child of  the button in order to counter this effect so that we are
      // the masters of our own button-content-position-destiny.
      "& > *": {
        position: "relative"
      }
    }),
    a: _linkReset["default"]
  }[tag], {
    cursor: disabled ? "not-allowed" : "pointer",
    outline: "none"
  });
}, ["tag", "disabled"]);

var getPropsForNativeLink = function getPropsForNativeLink(props) {
  return {
    href: props.disabled ? undefined : props.href,
    target: props.target,
    rel: props.rel,
    "aria-disabled": props.disabled || undefined,
    role: props.role !== "link" ? props.role : undefined,
    tabIndex: props.disabled ? "-1" : props.tabIndex,
    onClick: props.onClick
  };
};

var getPropsForNativeButton = function getPropsForNativeButton(props) {
  return {
    disabled: props.disabled || undefined,
    type: props.submit ? "submit" : "button",
    role: props.role !== "button" ? props.role : undefined,
    tabIndex: props.tabIndex,
    onClick: props.onClick,
    form: props.form
  };
};

var getPropsForCustomClickable = function getPropsForCustomClickable(props) {
  return {
    href: props.disabled ? undefined : props.href,
    target: props.target,
    rel: props.rel,
    "aria-disabled": props.disabled || undefined,
    tabIndex: props.disabled ? "-1" : props.tabIndex || "0",
    role: props.role,
    onKeyDown: function onKeyDown(event) {
      var key = (0, _keycode["default"])(event);
      var focus = document.activeElement === event.currentTarget; // Trigger a click on enter-key-down for buttons and links

      if (focus && key === "enter") {
        props.onClick(event);
      } // Disable scrolling on space-key-down for buttons


      if (focus && key === "space" && props.role === "button") {
        event.preventDefault();
      }
    },
    onKeyUp: props.role === "button" ? function (event) {
      var key = (0, _keycode["default"])(event);
      var focus = document.activeElement === event.currentTarget; // Trigger a click on space-key-up for buttons

      if (focus && key === "space") {
        // NOTE: event.preventDefault() will have already been called at
        // this point to keep the space key from triggering a scroll
        // (see `onKeyDown` above), so instead of passing the original
        // event this will pass a mock event that looks like it hasn't
        // had preventDefault() called.
        props.onClick({
          defaultPrevented: false,
          preventDefault: _noop["default"]
        });
      }
    } : undefined,
    onClick: props.onClick
  };
};
/**
 * Simulate a link click by creating an anchor tag and clicking on it. This
 * allows features like the "rel" attribute to be used on Clickable that have
 * an href but aren't rendered as an "a" tag (e.g. a Card that might be rendered
 * as a div so it can contain action buttons/links).
 */


var simulateLinkClick = function simulateLinkClick(linkAttributes) {
  // Create a link element that we can click
  var link = document.createElement("a"); // Assign attributes to the link (e.g. href). Filter out undefined attributes.
  // React normally does this for us, but the DOM doesn't so we have to do it
  // manually to avoid things like `download="undefined"` in the DOM.

  Object.assign(link, Object.keys(linkAttributes).reduce(function (result, key) {
    if (linkAttributes[key] !== undefined) {
      result[key] = linkAttributes[key];
    }

    return result;
  }, {})); // Add the link to the DOM (necessary for this to work in some browsers like
  // FF)

  document.body.appendChild(link); // Trigger a click on the link

  link.click(); // Remove the link from the dom.

  document.body.removeChild(link);
};
/**
 * This component determines whether an `a` or `button` tag is most appropriate
 * given the props passed to it. It will render the element to the dom with its
 * styles completely reset. It also handles link disabling (not a native feature
 * of the web) and default event prevention for links with click handlers.
 *
 * The goal of this component is to provide a uniform API for clickable elements
 * while ensuring that we are always using the correct html element under the
 * hood. This allows us to can take advantage of default browser behavior and
 * maintain good accessibility.
 *
 * This component also allows nesting so that clickable parents can have
 * clickable children and the streams won't get crossed. For these use cases the
 * `tag` prop can be used to manually choose the html tag rendered by the
 * component, since clickable elements should not be nested inside native
 * buttons or links.
 */


var Clickable = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onClick = props.onClick,
      href = props.href,
      target = props.target,
      submit = props.submit,
      disabled = props.disabled,
      rel = props.rel,
      download = props.download,
      tabIndex = props.tabIndex,
      propagateClickEvent = props.propagateClickEvent; // Figure out the role of the clickable element and the tag to render to the
  // DOM

  var nativeRole = href && !submit ? "link" : "button";
  var role = props.role !== undefined ? props.role : nativeRole;
  var tag = props.tag ? props.tag : nativeRole === "link" ? "a" : "button";
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "mdn-", "aria-"]); // What happens when the Clickable is clicked. Pretty key.

  var onClickTag = (0, _react.useCallback)(function (event) {
    // If the default event behavior was already prevented (e.g. by a nested
    // Clickable inside this one) then don't do anything
    if (!event.defaultPrevented) {
      var nativeBehavior = tag === "a" && href || tag === "button" && submit; // Call `preventDefault` for elements that are either disabled, have a
      // custom onClick handler, or do not have any native browser behavior.
      // This keeps any parent Clickable elements higher up in the DOM tree from
      // also handling the event. This doesn't stop propagation though - other
      // elements may want to react to the event even if its default behavior
      // was cancelled.

      if (disabled || onClick || !nativeBehavior) {
        event.preventDefault();
      } // If we were explicitly told to stop propagation on the event then
      // do so now


      if (!propagateClickEvent) {
        event.stopPropagation();
      } // If we're not disabled then handle the click


      if (!disabled) {
        // If the element has native behavior and we don't have a custom
        // onClick handler, then fall back to the native behavior (and stop
        // propagation to keep anyone else from handling the click).
        if (nativeBehavior && !onClick) {
          event.stopPropagation();
        } // If we've got an element with an href and the user has attempted to
        // open it in a new tab (via control-click, command-click, or
        // middle-mouse-button click) then do that
        else if (href && (event.ctrlKey || event.metaKey || event.button === 1)) {
          simulateLinkClick({
            href: href,
            target: "_blank",
            rel: "noopener noreferrer",
            download: download
          });
        } // If we were given a custom onClick handle then call it and pass the
        // href (if we have one). This makes it easy to do html5-history-style
        // links like this:
        //   <Clickable href="/path" onClick={push}>
        //     my accessible html5 link
        //   </Clickable>
        else if (onClick) {
          onClick(href);
        } // For non-link elements with an href and no onClick handler we have
        // to manually navigate to the href
        else if (href) {
          simulateLinkClick({
            href: href,
            target: target,
            rel: rel,
            download: download
          });
        }
      }
    }
  }, [onClick, href, target, submit, disabled, tag, rel, download, propagateClickEvent]); // Generate props that are specific to the tag we're rendering (e.g. a link,
  // a button, and a div will all require different props in order to acheive
  // a particular behavior). Memoize these to reduce the number of large objects
  // created on each render.

  var clickableProps = (0, _react.useMemo)(function () {
    var props = {
      onClick: onClickTag,
      role: role,
      disabled: disabled,
      href: href,
      rel: rel,
      target: target,
      tabIndex: tabIndex,
      submit: submit
    };
    return tag === "a" && href ? getPropsForNativeLink(props) : tag === "button" ? getPropsForNativeButton(props) : getPropsForCustomClickable(props);
  }, [tag, onClickTag, role, disabled, href, rel, target, tabIndex, submit]); // HACK: Wrap string children in a span so that the IE positioning
  // hack (see the button styles above) can take effect

  var applyIE11StyleHack = tag === "button" && _react["default"].Children.toArray(props.children).filter(function (child) {
    return typeof child !== "string";
  }).length === 0;
  return /*#__PURE__*/_react["default"].createElement(tag, _objectSpread(_objectSpread(_objectSpread({}, passThroughProps), clickableProps), {}, {
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    onMouseMove: props.onMouseMove,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    onMouseDown: props.onMouseDown,
    onMouseUp: props.onMouseUp,
    id: props.id,
    download: props.download,
    title: props.title,
    className: (0, _cxMemoized["default"])(styles({
      tag: tag,
      disabled: props.disabled
    }), props.className),
    form: props.form,
    ref: ref
  }), applyIE11StyleHack ? /*#__PURE__*/_react["default"].createElement("span", null, props.children) : props.children);
});

Clickable.displayName = "Clickable";
Clickable.propTypes =  false ? {
  /**
   * All props prefixed with `aria-` are accepted. See the [W3C aria docs](https://w3c.github.io/using-aria/) for
   * relevant props.
   */
  "aria-*": _propTypes["default"].string,

  /**
   * The contents of the component.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * See docs for the [a tag's download attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-download).
   */
  download: _propTypes["default"].string,

  /**
   * The form attribute specifies the form the button belongs to. The value of this
   * attribute must be equal to the id attribute of a <form> element in the same
   * document. Please refer to this [guide](https://www.w3schools.com/tags/att_button_form.asp) for details.
   */
  form: _propTypes["default"].string,

  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * Determines whether or not the clickable propagates the click event.
   * Setting to false will run `event.stopPropagation()`.
   */
  propagateClickEvent: _propTypes["default"].bool,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,

  /**
   * See docs for the [aria role attribute](https://www.w3.org/TR/wai-aria/#host_general_role).
   */
  role: _propTypes["default"].string,

  /**
   * See docs for the "submit" value of the [button tag's type attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attr-type).
   */
  submit: _propTypes["default"].bool,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The tag used to render the component in the DOM. This defaults to either
   * `a` or `button`, whichever is the more appropriate choice given the other
   * props provided (e.g. `href` or `onClick`).
   */
  tag: _propTypes["default"].string,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * Add a title to the element. Read [the MDN docs on title](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/title)
   * for details.
   */
  title: _propTypes["default"].string,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the mouse is pressed down on the component. The [mousedown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mousedown_event)
   * is passed as the first argument to the function.
   */
  onMouseDown: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves over the component. The [mouseenter event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseenter_event)
   * is passed as the first argument to the function.
   */
  onMouseEnter: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves off of the component. The [mouseleave event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseleave_event)
   * is passed as the first argument to the function.
   */
  onMouseLeave: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves within the component. The [mousemove event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mousemove_event)
   * is passed as the first argument to the function.
   */
  onMouseMove: _propTypes["default"].func,

  /**
   * This is called when a mouse press is released on the component. The [mouseup event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseup_event)
   * is passed as the first argument to the function.
   */
  onMouseUp: _propTypes["default"].func
} : {};
Clickable.defaultProps = {
  propagateClickEvent: true
};
var _default = Clickable;
exports["default"] = _default;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var linkReset = {
  display: "inline-block",
  outline: "none",
  textDecoration: "none",
  color: "inherit",
  cursor: "default"
};
var _default = linkReset;
exports["default"] = _default;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _react = __webpack_require__(0);

var _noop = _interopRequireDefault(__webpack_require__(59));

/**
 * @callback focusEventCallback
 * @param {*} focusEvent
 * @returns *
 */

/**
 * Options for the useFocus hook
 *
 * @typedef focusOptions
 * @type {object}
 * @property {boolean} [disabled=false] - A bug in React means that onBlur is not called
 *   when an element with focus is disabled. This prop allows you to manually
 *   inform the Focus component when the element(s) that it manages are disabled
 *   so that it can turn off its internal focus state. See:
 *   https://github.com/facebook/react/issues/9142
 * @property {boolean} [multipleNodes=false] - Turn this on if you are tracking the focus
 *   of multiple DOM nodes (i.e. if you are applying the `focusProps` returned
 *   from this hook to multiple elements).
 * @property {focusEventCallback} [onBlur] - This is called when the component loses
 *   focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
 *   is passed as the first argument to the function.
 * @property {focusEventCallback} [onFocus] - This is called when the component gains
 *   focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
 *   is passed as the first argument to the function.
 */

/**
 * Focus state returned by the useFocus hook
 *
 * @typedef focusReturn
 * @type {object}
 * @property {boolean} focus - Are the tracked node(s) focused?
 * @property {('keyboard'|'mouse')} focusTrigger - The type of device that
 *   triggered the focus.
 * @property {Object} focusProps - An object containing onFocus and onBlur
 *   event handlers that can be bound to any node you want to track focus for.
 */

/**
 * This hook helps track the focus state of a DOM node or set of DOM nodes.
 *
 * When to use this component: if you need to make a distinction between mouse
 * focus and keyboard focus, or if you need to treat multiple focuseable dom
 * nodes as a single focuseable unit. If you don't need these features you
 * should probably just track focus using local state or style using the CSS
 * :focus selector.
 *
 * This component tracks focus state for its children, including the type of
 * device that triggered the focus (keyboard or pointer). This component
 * essentially takes the place of the CSS pseudo-selectors `:focus-within` and
 * `:focus-visible`, which are not well supported. It also allows you to
 * simulate something like `:focus-visible-within`, which doesn't exist in CSS
 * at all. See:
 *   - https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
 *   - https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo
 *
 * ```
 * // The button wrapper will be outlined in blue if the button or the div is
 * // focused with the keyboard, and will not be outlined if the elements are
 * // focused with the mouse (or if they are not focused at all).
 * const MyFocuseableButton = () => {
 *   const { focus, focusTrigger, focusProps } = useFocus()
 *   return (
 *     <div style={{
 *       outline: focus && focusTrigger === "keyboard" ? "1px solid blue" : "none"
 *     }}>
 *       <button {...focusProps}>Click me!</button>
 *       <div tabIndex={0}>Also click me!</div>
 *     </div>
 *   )
 * }
 * ```
 *
 * NOTE: Components that use this hook will re-render when the nodes that are
 * are being tracked by the hook are focused or blurred. To avoid re-rendering
 * an unnecessary amount of components on focus & blur, call this hook at the
 * lowest level possible. In other words, don't call this hook in a high-level
 * component that holds a ton of children just to track the focus on a single
 * child. Instead wrap the child in its own component and call the hook there,
 * limiting focus-related renders to just that child.
 *
 * @param {focusOptions} options - Options that determine how focus is tracked.
 * @returns {focusReturn}
 */
var useFocus = function useFocus() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      disabled = _ref.disabled,
      multipleNodes = _ref.multipleNodes,
      _ref$onBlur = _ref.onBlur,
      onBlurCallback = _ref$onBlur === void 0 ? _noop["default"] : _ref$onBlur,
      _ref$onFocus = _ref.onFocus,
      onFocusCallback = _ref$onFocus === void 0 ? _noop["default"] : _ref$onFocus;

  var _useState = (0, _react.useState)([false, null]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      _useState2$ = (0, _slicedToArray2["default"])(_useState2[0], 2),
      focus = _useState2$[0],
      focusDescendent = _useState2$[1],
      setFocus = _useState2[1];

  var focusedNode = (0, _react.useRef)();
  var blurTimeout = (0, _react.useRef)();
  var onFocus = (0, _react.useCallback)(function (event) {
    clearTimeout(blurTimeout.current);
    focusedNode.current = event ? event.target : undefined;
    var nextFocusDescendent = Boolean(event) && event.currentTarget !== focusedNode.current;

    if (!focus || focusDescendent !== nextFocusDescendent) {
      setFocus([true, nextFocusDescendent]);
    }

    if (!focus) {
      onFocusCallback(event, getInteractionDevice());
    }
  }, [onFocusCallback, focus, focusDescendent]);
  var onBlurComplete = (0, _react.useCallback)(function (event) {
    setFocus([false, false]);
    onBlurCallback(event, getInteractionDevice());
  }, [onBlurCallback]);
  var onBlur = (0, _react.useCallback)(function (event) {
    if (event && multipleNodes) {
      clearTimeout(blurTimeout.current); // Don't trigger `onBlurComplete` right away if we're managing focus for
      // multiple elements. Instead, wait briefly using setTimeout to see if
      // onFocus is called for another element we're tracking. If it is then
      // we consider the state to still be focused, otherwise we can move ahead
      // and call `onBlurComplete`.

      event.persist();
      blurTimeout.current = setTimeout(function () {
        if (event.target === focusedNode.current) {
          onBlurComplete(event);
        }
      }, 0);
    } else {
      onBlurComplete(event);
    }
  }, [onBlurComplete, multipleNodes]);
  var focusProps = (0, _react.useMemo)(function () {
    return {
      onFocus: onFocus,
      onBlur: onBlur
    };
  }, [onFocus, onBlur]);
  (0, _react.useEffect)(function () {
    // When the node(s) are focused and we flip from enabled to disabled, clear
    // the focus (see the docs for the disabled param re: why this is
    // necessary).
    if (focus && disabled) {
      setFocus([false, false]);
    } // Clear the timeout when unmounting


    return function () {
      return clearTimeout(blurTimeout.current);
    };
  }, [focus, disabled]);
  return {
    focus: focus,
    focusProps: focusProps,
    focusDescendent: focusDescendent,
    focusTrigger: getInteractionDevice()
  };
};
/**
 * This tracks whether the user is using their mouse or keyboard to interact
 * with the application. This state is tracked outside of React because it
 * updates on every mousedown or keydown in the window. Tracking this inside of
 * React using component state would trigger a re-render of every component
 * with useFocus for every one of these events, which would result in a ton of
 * unnecessary re-rendering. The value of this state is only relevant when a new
 * element is focused anyway, so `onFocus` can fetch the new value when that
 * happens.
 */


var getInteractionDevice = function () {
  var device = "keyboard";

  if (typeof window !== "undefined" && window.addEventListener) {
    window.addEventListener("mousedown", function () {
      return device = "mouse";
    }, true);
    window.addEventListener("keydown", function () {
      return device = "keyboard";
    }, true);
  }

  return function () {
    return device;
  };
}();

var _default = useFocus;
exports["default"] = _default;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _isString = _interopRequireDefault(__webpack_require__(345));

var _token = __webpack_require__(20);

var _functional = __webpack_require__(38);

var _css;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var spanStyles = (0, _functional.memoize)(function (size) {
  return (0, _emotion.css)({
    position: "relative",
    flexShrink: 0,
    display: "inline-block",
    width: size,
    height: size,
    verticalAlign: "middle"
  });
});
var imgSpanStyles = (0, _emotion.css)({
  // Don't show the icon's label
  fontSize: 0,
  // Center the icon image
  "& svg": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translateY(-50%) translateX(-50%)"
  }
}); // These RTL styles are applied to a parent span only when an icon contains an LTR and RTL version.

var rtlStyles = (0, _emotion.css)((_css = {}, (0, _defineProperty2["default"])(_css, "span:nth-child(1)", (0, _defineProperty2["default"])({}, "[dir=\"rtl\"] &", {
  display: "none"
})), (0, _defineProperty2["default"])(_css, "span:nth-child(2)", (0, _defineProperty2["default"])({
  display: "none"
}, "[dir=\"rtl\"] &", {
  display: "inline-block"
})), _css));

var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
  return nextProps.tokens === prevProps.tokens && nextProps.className === prevProps.className && nextProps.children === prevProps.children;
};

var decodeSvgString = function decodeSvgString(svgData) {
  return decodeURIComponent(svgData.replace(/^data:image\/svg\+xml,/, "") // Add aria-hidden="true" so that screen readers ignore the underlying svg
  // (we label the parent span) and focusable="false" because IE11 defaults
  // to adding SVGs to the tab order
  ).replace(/<svg/, "<svg aria-hidden=\"true\" focusable=\"false\"");
};

var Icon = /*#__PURE__*/_react["default"].memo( /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _getIconFromTokens = (0, _token.getIconFromTokens)(props.tokens),
      data = _getIconFromTokens.data,
      dataRtl = _getIconFromTokens.dataRtl,
      width = _getIconFromTokens.width,
      height = _getIconFromTokens.height;

  var svg = decodeSvgString(data); // Create an RTL version of the SVG to be used for the RTL icon if it exists, else null

  var svgRtl = dataRtl ? decodeSvgString(dataRtl) : null;
  var html = (0, _react.useMemo)(function () {
    return {
      __html: svg
    };
  }, [svg]); // Generate RTL html for the RTL version of an SVG

  var htmlRtl = (0, _react.useMemo)(function () {
    return {
      __html: svgRtl
    };
  }, [svgRtl]);
  var size = width > Icon.sizes.small || height > Icon.sizes.small ? Icon.sizes.large : Icon.sizes.small;
  var simpleChildren = props.children === undefined || typeof props.children === "string";

  var stringChild = _react["default"].Children.toArray(props.children).filter(_isString["default"]).join(" ");

  return /*#__PURE__*/_react["default"].createElement("span", {
    className: dataRtl ? (0, _emotion.cx)(rtlStyles, spanStyles(size), props.className) : (0, _emotion.cx)(spanStyles(size), props.className)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    role: "img",
    "aria-hidden": !props.children ? true : undefined,
    "aria-label": stringChild,
    className: imgSpanStyles,
    tabIndex: props.tabIndex,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    ref: ref,
    dangerouslySetInnerHTML: simpleChildren ? html : undefined
  }, simpleChildren ? null : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: html
  }), props.children)), dataRtl && /*#__PURE__*/_react["default"].createElement("span", {
    role: "img",
    "aria-hidden": !props.children ? true : undefined,
    "aria-label": simpleChildren ? props.children : undefined,
    className: imgSpanStyles,
    tabIndex: props.tabIndex,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    ref: ref,
    dangerouslySetInnerHTML: simpleChildren ? htmlRtl : undefined
  }, simpleChildren ? null : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: htmlRtl
  }), props.children)));
}), shouldNotUpdate);

Icon.sizes = {
  small: 16,
  large: 24
};
Icon.displayName = "Icon";
Icon.propTypes =  false ? {
  /**
   * An object of icon tokens imported from the Meridian token library.
   */
  tokens: _propTypes["default"].object.isRequired,

  /**
   * An accessible label for the icon (not visible in the UI). A Badge component
   * can be passed in along with the label in order to render a badge on the
   * icon (visible in the UI).
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   * This can be used for positioning the icon or setting the icon's color
   *
   * This should *not* be used to override other styles on the component.
   * Meridian's internal CSS and HTML are private APIs and may change at any
   * time, potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * If this is not specified the component will not be focuseable.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].number,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   *
   * Note that `tabIndex` must be specified in order for the component to be
   * focuseable.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   *
   * Note that `tabIndex` must be specified in order for the component to be
   * focuseable.
   */
  onFocus: _propTypes["default"].func
} : {};
Icon.sizes = {
  small: 16,
  large: 24
};
var _default = Icon;
exports["default"] = _default;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Thanks StackOverflow!
var getBrightness = function getBrightness(hex) {
  var decimal = parseInt(hex.substring(1), 16); // convert hex (rrggbb) to decimal

  var r = decimal >> 16 & 0xff; // extract red

  var g = decimal >> 8 & 0xff; // extract green

  var b = decimal >> 0 & 0xff; // extract blue

  return 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
};

var isColorDark = function isColorDark(hex) {
  return getBrightness(hex) < 128;
};

var _default = isColorDark;
exports["default"] = _default;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(343);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 684 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 685 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(687),
    isObject = __webpack_require__(153),
    isSymbol = __webpack_require__(191);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(688);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 688 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 689 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(691), src$en$$ = __webpack_require__(696);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(351), src$es5$$ = __webpack_require__(692), src$compiler$$ = __webpack_require__(693), intl$messageformat$parser$$ = __webpack_require__(694);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(351);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(695)['default'];
exports['default'] = exports;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 697 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(699)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(704);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* jslint esnext: true */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(700);
var en_1 = __webpack_require__(703);
core_1.default.__addLocaleData(en_1.default);
core_1.default.defaultLocale = 'en';
exports.default = core_1.default;
//# sourceMappingURL=main.js.map

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var intl_messageformat_1 = __webpack_require__(350);
var diff_1 = __webpack_require__(701);
var es5_1 = __webpack_require__(702);
exports.default = RelativeFormat;
// -----------------------------------------------------------------------------
var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];
// -- RelativeFormat -----------------------------------------------------------
function RelativeFormat(locales, options) {
    options = options || {};
    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (es5_1.isArray(locales)) {
        locales = locales.concat();
    }
    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
    es5_1.defineProperty(this, '_options', { value: {
            style: this._resolveStyle(options.style),
            units: this._isValidUnits(options.units) && options.units
        } });
    es5_1.defineProperty(this, '_locales', { value: locales });
    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}
// Define internal private properties for dealing with locale data.
es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
        for (var i = 0; i < arguments.length; i++) {
            var datum = arguments[i];
            if (!(datum && datum.locale)) {
                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
                    '`locale` property value');
            }
            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
            // Add data to IntlMessageFormat.
            intl_messageformat_1.default.__addLocaleData(datum);
        }
    } });
// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});
// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
es5_1.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,
    value: {
        second: 45, 'second-short': 45,
        minute: 45, 'minute-short': 45,
        hour: 22, 'hour-short': 22,
        day: 26, 'day-short': 26,
        month: 11, 'month-short': 11 // months to year
    }
});
RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style: this._options.style,
        units: this._options.units
    };
};
RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales = this._locales;
    var resolvedLocale = this._locale;
    var field = this._fields[units];
    var relativeTime = field.relativeTime;
    var future = '';
    var past = '';
    var i;
    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }
    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }
    var message = '{when, select, future {{0, plural, ' + future + '}}' +
        'past {{0, plural, ' + past + '}}}';
    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl_messageformat_1.default(message, locales);
};
RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;
    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }
    return messages[units];
};
RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];
    if (field.relative) {
        return field.relative[diff];
    }
};
RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale);
};
RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
    if (date === undefined) {
        date = now;
    }
    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    if (!isFinite(date)) {
        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    var diffReport = diff_1.default(now, date);
    var units = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];
    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }
    return this._getMessage(units).format({
        '0': Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};
RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }
    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion);
        }
    }
    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"');
};
RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);
    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');
        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale);
};
RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }
    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }
    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"');
};
RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function (field) {
        return field.indexOf('-short') < 1;
    });
    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];
        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }
    return units;
};
//# sourceMappingURL=core.js.map

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var round = Math.round;
function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}
// Thanks to date-fns
// https://github.com/date-fns/date-fns
// MIT © Sasha Koss
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_DAY = 86400000;
function startOfDay(dirtyDate) {
    var date = new Date(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    var startOfDayLeft = startOfDay(dirtyDateLeft);
    var startOfDayRight = startOfDay(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() -
        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    var timestampRight = startOfDayRight.getTime() -
        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
function default_1(from, to) {
    // Convert to ms timestamps.
    from = +from;
    to = +to;
    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
    // We expect a more precision in rounding when dealing with
    // days as it feels wrong when something happended 13 hours ago and
    // is regarded as "yesterday" even if the time was this morning.
    var day = differenceInCalendarDays(to, from);
    var week = round(day / 7);
    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
    return {
        millisecond: millisecond,
        second: second,
        'second-short': second,
        minute: minute,
        'minute-short': minute,
        hour: hour,
        'hour-short': hour,
        day: day,
        'day-short': day,
        week: week,
        'week-short': week,
        month: month,
        'month-short': month,
        year: year,
        'year-short': year
    };
}
exports.default = default_1;
//# sourceMappingURL=diff.js.map

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;
var realDefineProp = (function () {
    try {
        return !!Object.defineProperty({}, 'a', {});
    }
    catch (e) {
        return false;
    }
})();
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
var defineProperty = realDefineProp ? Object.defineProperty :
    function (obj, name, desc) {
        if ('get' in desc && obj.__defineGetter__) {
            obj.__defineGetter__(name, desc.get);
        }
        else if (!hop.call(obj, name) || 'value' in desc) {
            obj[name] = desc.value;
        }
    };
exports.defineProperty = defineProperty;
var objCreate = Object.create || function (proto, props) {
    var obj, k;
    function F() { }
    F.prototype = proto;
    obj = new F();
    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }
    return obj;
};
exports.objCreate = objCreate;
var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }
    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }
    return -1;
};
exports.arrIndexOf = arrIndexOf;
var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};
exports.isArray = isArray;
var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.dateNow = dateNow;
//# sourceMappingURL=es5.js.map

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* @generated */
exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord)
            return (n10 == 1 && n100 != 11) ? 'one'
                : (n10 == 2 && n100 != 12) ? 'two'
                    : (n10 == 3 && n100 != 13) ? 'few'
                        : 'other';
        return (n == 1 && v0) ? 'one' : 'other';
    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
//# sourceMappingURL=en.js.map

/***/ }),
/* 704 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(706);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(707);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
var RelativeTimeFormat;
// -- Utilities ----------------------------------------------------------------
function getCacheId(inputs) {
    return JSON.stringify(inputs.map(function (input) {
        return input && typeof input === 'object' ? orderedProps(input) : input;
    }));
}
function orderedProps(obj) {
    return Object.keys(obj)
        .sort()
        .map(function (k) {
        var _a;
        return (_a = {}, _a[k] = obj[k], _a);
    });
}
var memoizeFormatConstructor = function (FormatConstructor, cache) {
    if (cache === void 0) { cache = {}; }
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cacheId = getCacheId(args);
        var format = cacheId && cache[cacheId];
        if (!format) {
            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
            if (cacheId) {
                cache[cacheId] = format;
            }
        }
        return format;
    };
};
/* harmony default export */ __webpack_exports__["a"] = (memoizeFormatConstructor);
//# sourceMappingURL=index.js.map

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _text = _interopRequireDefault(__webpack_require__(249));

var _getTextStyles = _interopRequireDefault(__webpack_require__(352));

var _theme = __webpack_require__(24);

var _cxMemoized = _interopRequireDefault(__webpack_require__(107));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * This component can be used to apply Meridian text styles to the UI. Text
 * styles will cascade to descendant Text, Heading, and Link components as well
 * as native HTML elements, but not to other Meridian components that define
 * their own text styles.
 */
var Text = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children;
  var t = (0, _theme.useTheme)(_text["default"], "text");
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
  return /*#__PURE__*/_react["default"].createElement(props.tag, _objectSpread(_objectSpread({}, passThroughProps), {}, {
    id: props.id,
    className: (0, _cxMemoized["default"])((0, _getTextStyles["default"])(t, props), props.className),
    tabIndex: props.tabIndex,
    title: props.title === undefined && props.truncate && typeof children === "string" ? children : props.title,
    "mdn-text": "",
    ref: ref,
    role: props.role,
    htmlFor: props.htmlFor
  }), children);
});

Text.displayName = "Text";
Text.propTypes =  false ? {
  /**
   * The text.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The alignment of the text.
   */
  alignment: _propTypes["default"].oneOf(["left", "start", "center", "right", "end", "justify"]),

  /**
   * Set this to true to allow the browser to break text at any arbitrary
   * location - even in the middle of a word. This can be helpful when rendering
   * very long strings without natural breakpoints like spaces or hyphens. This
   * can also cause awkward breaks in text, so use sparingly. See the
   * "break-word" value of the [CSS overflow-wrap property](https://developer.mozilla.org/en-US/docs/Web/CSS/overflow-wrap)
   * for details.
   *
   * @since 5.x
   */
  breakWord: _propTypes["default"].bool,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * The color of the text. See the [Color Fundamentals page](https://meridian.a2z.com/fundamentals/color/?platform=react-web)
   * for information on the correct usage of these colors.
   */
  color: _propTypes["default"].oneOf(["primary", "secondary", "error", "inverted"]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * The font family of the heading's text. This is an advanced feature, and
   * generally should not be changed.
   *
   * Note that you must manually load the necessary web fonts before using this
   * prop.
   */
  fontFamily: _propTypes["default"].oneOf(["amazonEmber", "amazonEmberArabic", "amazonEmberDisplay", "amazonEmberMonospace", "bookerly", "bookerlyDisplay"]),

  /**
   * Sets the `for` attribute on the component's element. This is useful when
   * associating a label with an input.
   *
   * See docs to learn more about the [for attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/label#attr-for).
   * We use `htmlFor` to match [React's standard](https://reactjs.org/docs/dom-elements.html#htmlfor).
   *
   * ```
   * <Column>
   *   <Text tag="label" htmlFor="my-input">
   *     Phone number
   *   </Text>
   *   <Input id="my-input" value={value} onChange={setValue} />
   * </Column>
   * ```
   *
   * @since 5.x
   */
  htmlFor: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component's element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * Sets the list-style for digits in an ordered list.
   *
   * Use this to set digits for a locale.
   * See [list style types](https://www.w3.org/International/tests/html-css/list-style-type/results-list-style-type) for more information.
   */
  listStyle: _propTypes["default"].string,

  /**
   * An accessible ARIA role for the component.
   *
   * See docs for the [role attribute](https://www.w3.org/TR/wai-aria-1.0/roles)
   * for details on appropriate usage.
   *
   * @since 5.x
   */
  role: _propTypes["default"].string,

  /**
   * Setting tabIndex to "-1" allows the Text to be programmatically focused
   * without adding it to the tab order. Programmatically focusing is useful
   * when, for instance, a user presses an anchor link and expects to scroll
   * and focus on particular content.
   *
   * @since 5.23.0
   */
  tabIndex: _propTypes["default"].oneOf(["-1"]),

  /**
   * The HTML tag to use when rendering the component to the DOM.
   */
  tag: _propTypes["default"].string,

  /**
   * Add advisory information related to the element. See the [HTML title attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/title)
   * for details.
   *
   * If the `truncate` property is set to true, this prop will default to the
   * contents of the `Text` component *if* the contents are a plain string.
   * Otherwise this prop should be manually set to the non-truncated text to
   * ensure that the full text is accessible to readers.
   */
  title: _propTypes["default"].string,

  /**
   * Use this to apply a [CSS text transform](https://developer.mozilla.org/en-US/docs/Web/CSS/text-transform)
   * to the heading.
   */
  transform: _propTypes["default"].oneOf(["none", "capitalize", "uppercase", "lowercase"]),

  /**
   * Set this to true to truncate the text to a single line using ellipsis. If
   * the text already fits on a single line no truncation will be applied. This
   * relies on the CSS text-overflow property, refer to [the text-overflow documentation](https://developer.mozilla.org/en-US/docs/Web/CSS/text-overflow)
   * for details.
   */
  truncate: _propTypes["default"].bool,

  /**
   * This determines which entry from [Meridian's type scale](https://meridian.a2z.com/fundamentals/typography/?platform=reactjs&detailsTab=type-scale)
   * is used to render the heading text.
   */
  type: _propTypes["default"].oneOf(["d300", "d200", "d100", "d50", "h600", "h500", "h400", "h300", "h200", "h100", "b500", "b400", "b300", "b200", "b100"])
} : {};
Text.defaultProps = {
  tag: "p"
};
var _default = Text;
exports["default"] = _default;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _tableRow = _interopRequireDefault(__webpack_require__(258));

var _tableSectionHeader = _interopRequireWildcard(__webpack_require__(354));

var _tableContainer = _interopRequireDefault(__webpack_require__(357));

var _tableFixedHeaders = _interopRequireDefault(__webpack_require__(715));

var _checkbox = _interopRequireDefault(__webpack_require__(361));

var _tableSortToggle = _interopRequireDefault(__webpack_require__(723));

var _isElementOfAny = _interopRequireDefault(__webpack_require__(194));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var fullWidthStyles = (0, _emotion.css)({
  width: "100%",
  position: "relative"
});
/**
 * HACK that checks an element to see if it should have an explicit key set by
 * the user.
 *
 * This is dangerous because it delves into private React APIs. It is written in
 * such a way that if the private API is changed/removed then it will default to
 * `true` (indicating that a key is required) since adding explicit unique keys
 * can never hurt (other than being annoying) but omitting them can result in
 * tricky bugs.
 */

var dangerouslyCheckIfExplicitKeyIsRequired = function dangerouslyCheckIfExplicitKeyIsRequired(element) {
  return element && (!element._store || element._store.validated === undefined || element._store.validated === false);
};
/**
 * HACK that returns the key we should use for a row based on the row element
 * and its index in the table.
 *
 * ## Background
 *
 * Because we take the table rows provided by the user and then turn them into a
 * dynamic array, React thinks that explicit keys are always required (even for
 * static tables where row order will never change). We originally got around
 * this by setting each row key to the row index. This stopped the unnecessary
 * "key required" warnings for static tables, but also suppressed the necessary
 * "key required" warnings for dynamic tables (and made custom keys impossible).
 * In retrospect this was a poor choice and caused issues for tables with
 * dynamic rows that had internal state.
 *
 * ## Solution
 *
 * To address this problem we now a) always use the user's explicit keys if they
 * provide them and b) only use the row's index as a key for static tables (as
 * identified by elements where `dangerouslyCheckIfExplicitKeyIsRequired`
 * returns false). This is hacky, but makes our table behave just like any other
 * React component in terms of the key API (custom keys respected, warnings for
 * missing keys on dynamic elements, no warnings for missing keys on static
 * elements). Ultimately it was a poor choice to process all table rows as
 * arrays, but here we are.
 */


var getRowKey = function getRowKey(element, index) {
  return element.key || (dangerouslyCheckIfExplicitKeyIsRequired(element) ? undefined : index);
};
/**
 * Render a table - anything from advanced data tables with sorting and
 * filtering to simple static tables with basic content.
 */


var Table = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Table, _React$Component);

  var _super = _createSuper(Table);

  function Table() {
    var _this;

    (0, _classCallCheck2["default"])(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "rootRef", undefined);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateRootRef", function (rootRef) {
      _this.rootRef = rootRef; // If we're fixing table headers, re-render when the rootRef comes through

      if (_this.props.fixHeaderRows) {
        _this.forceUpdate();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isRow", (0, _isElementOfAny["default"])(_this.props.rowComponents));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isSectionHeader", (0, _isElementOfAny["default"])(_this.props.sectionHeaderComponents));
    return _this;
  }

  (0, _createClass2["default"])(Table, [{
    key: "getChildren",
    value:
    /**
     * This function takes the table children passed by the user, splits them into
     * non-rows, header rows, and body rows, and then transforms them based on the
     * props passed to this component (e.g. this component will set the `header`
     * prop on individual table cells based on the `headerRows` and
     * `headerColumns` props passed by the user).
     *
     * This function looks a bit messy because it prioritizes code performance
     * over code readability, accomplishing everything in a single pass over the
     * table cells.
     */
    function getChildren() {
      var _this2 = this;

      var props = this.props;
      var rowIndex = -1;
      var nestedRows = false;
      var nonRows = [];
      var headerRows = [];
      var bodyRows = []; // Walk through every child of the Table (mostly rows, but other children
      // such as a TableActionBar might be included).

      _react["default"].Children.forEach(props.children, function (child) {
        if (!_this2.isRow(child) && !_this2.isSectionHeader(child)) {
          // Gather all the elements that aren't rows together
          nonRows.push(child);
        } else {
          // Transform TableSectionHeader elements (syntactic sugar for users)
          // into actual TableRow elements (that we can render)
          var row = _this2.isSectionHeader(child) ? (0, _tableSectionHeader.toRow)(_this2.isRow, child, props.stickyHeaderColumn) : child;
          rowIndex += 1;
          var key = getRowKey(child, rowIndex); // Handle header rows

          if (rowIndex < props.headerRows) {
            // Add header={true} to every cell in every header row. Transform the
            // cell children into a TableSortToggle if the cell has a `sortColumn`
            // prop set.
            var headerRow = /*#__PURE__*/_react["default"].cloneElement(row, {
              key: key,
              children: _react["default"].Children.map(row.props.children, function (child, columnIndex) {
                return child && /*#__PURE__*/_react["default"].cloneElement(child, {
                  header: true,
                  scope: "col",
                  sortDirection: child.props.sortColumn !== undefined && child.props.sortColumn === props.sortColumn ? props.sortDirection || child.props.defaultSortDirection : undefined,
                  checkboxComponents: columnIndex === 0 ? props.checkboxComponents : undefined,
                  children: props.onSort && child.props.sortColumn ? _this2.renderSortButton(child) : child.props.children
                });
              })
            });

            headerRows.push(headerRow);
          } // Handle body rows. Add header={true} to body cells that are part of
          // a header column. Also keep track of nested rows for styling
          // purposes.
          else {
            var prevColumnIndex = -1;

            var bodyRow = /*#__PURE__*/_react["default"].cloneElement(row, {
              key: key,
              rowComponents: row.props.rowComponents || props.rowComponents,
              children: _react["default"].Children.map(row.props.children, function (child) {
                if (_this2.isRow(child)) {
                  nestedRows = true;
                  return child;
                } else if (child) {
                  // Clone header cells or cells that may contain a checkbox for
                  // selectable tables (we need to pass table-level data down to
                  // these cells).
                  var columnIndex = prevColumnIndex + 1;
                  var header = columnIndex < props.headerColumns;
                  var checkboxComponents = columnIndex === 0 ? props.checkboxComponents : undefined;
                  prevColumnIndex += 1;
                  return header || checkboxComponents ? /*#__PURE__*/_react["default"].cloneElement(child, {
                    header: child.props.header || header,
                    scope: child.props.sectionHeader ? "colgroup" : child.props.header || header ? "row" : undefined,
                    checkboxComponents: child.props.checkboxComponents || checkboxComponents
                  }) : child;
                } else {
                  return null;
                }
              })
            });

            bodyRows.push(bodyRow);
          }
        }
      });

      return {
        nonRows: nonRows,
        headerRows: headerRows,
        bodyRows: bodyRows,
        nestedRows: nestedRows
      };
    }
  }, {
    key: "renderSortButton",
    value: function renderSortButton(cell) {
      var _this$props = this.props,
          sortColumn = _this$props.sortColumn,
          sortDirection = _this$props.sortDirection,
          onSort = _this$props.onSort;
      return /*#__PURE__*/_react["default"].createElement(_tableSortToggle["default"], {
        sortColumn: cell.props.sortColumn,
        value: {
          sortColumn: sortColumn,
          sortDirection: sortDirection
        },
        defaultSortDirection: cell.props.defaultSortDirection,
        columnTextAlignment: cell.props.alignmentHorizontal,
        onChange: onSort
      }, cell.props.children);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;

      var _this$getChildren = this.getChildren(),
          nestedRows = _this$getChildren.nestedRows,
          nonRows = _this$getChildren.nonRows,
          headerRows = _this$getChildren.headerRows,
          bodyRows = _this$getChildren.bodyRows;

      var tableContainerProps = _objectSpread({
        nestedRows: nestedRows
      }, props);

      var renderHead = headerRows.length > 0;
      var renderBody = bodyRows.length > 0;
      var useFixedHeaders = props.fixHeaderRows && this.rootRef && renderHead && renderBody;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: fullWidthStyles,
        ref: this.updateRootRef
      }, !useFixedHeaders ? nonRows : /*#__PURE__*/_react["default"].createElement(_tableFixedHeaders["default"], {
        rootRef: this.rootRef,
        tableContainerProps: tableContainerProps,
        nonRows: nonRows,
        headerRows: headerRows,
        headerRowsOffset: props.fixHeaderRowsOffset,
        fullWidth: props.fixHeaderRowsFullWidth
      }), /*#__PURE__*/_react["default"].createElement(_tableContainer["default"], tableContainerProps, renderHead ? /*#__PURE__*/_react["default"].createElement("thead", {
        ref: this.updateHeadRef
      }, headerRows) : null, renderBody ? /*#__PURE__*/_react["default"].createElement("tbody", {
        ref: this.updateBodyRef
      }, bodyRows) : null));
    }
  }]);
  return Table;
}(_react["default"].Component);

(0, _defineProperty2["default"])(Table, "defaultProps", {
  spacing: "medium",
  headerRows: 0,
  headerColumns: 0,
  rowComponents: [_tableRow["default"]],
  sectionHeaderComponents: [_tableSectionHeader["default"]],
  checkboxComponents: [_checkbox["default"]],
  layout: "auto",
  stickyHeaderColumnOffset: 0,
  stickyHeaderRowOffset: 0
});
Table.propTypes =  false ? {
  /**
   * Place `TableActionBar`, `TableRow`, and `TableSectionHeader`, components
   * as children of this component.
   *
   * Any unrecognized children will be extracted and rendered as previous
   * siblings to the table.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The component or components that will be used to render checkboxes for
   * selectable tables. Defaults to Checkbox.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  checkboxComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Fix table header rows to the top of the scroll container when the user
   * scrolls down. This will also fix the TableActionBar if present.
   *
   * NOTE: We recommend turning on the `fixHeaderRowsFullWidth` property as
   * well, which is not enabled by default for backwards-compatibility
   * reasons.
   *
   * If you are not "fixing" an action bar, have a single header row, and are
   * not supporting IE11 we recommend using `stickyHeaderRow` which uses the
   * native CSS property `position: sticky`.
   */
  fixHeaderRows: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the `fixHeaderRows` prop if you want the
   * table header to expand to fill the full width of the scroll container
   * when fixed.
   */
  fixHeaderRowsFullWidth: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the "fixHeaderRows" prop if you don't want
   * to fix table header rows to the very top of the scroll container. Use
   * this to specify the pixel offset at which the rows should stick.
   */
  fixHeaderRowsOffset: _propTypes["default"].number,

  /**
   * This determines how many columns, starting on the left hand side of the
   * table, should be considered headers.
   */
  headerColumns: _propTypes["default"].number,

  /**
   * This determines how many rows, starting at the top of the table, should
   * be considered headers.
   *
   * NOTE: Expandable header rows are not supported.
   */
  headerRows: _propTypes["default"].number,

  /**
   * This determines how the browser will calculate the column widths of the
   * table. See the [table-layout CSS property](https://developer.mozilla.org/en-US/docs/Web/CSS/table-layout)
   * for details.
   */
  layout: _propTypes["default"].oneOf(["auto", "fixed"]),

  /**
   * Set this to true if the table contain nested rows (child rows that can be
   * expanded/collapsed by clicking on their parent row).
   *
   * NOTE: This prop is only necessary when creating nested rows whose children
   * are _not_ defined in the Table JSX. For instance, the following example
   * _does not_ require `nestedRows` to be defined since the `SelfContainedExpandableRow`'s
   * children are defined in the JSX defining `Table`.
   *
   * ```
   * const MyTable = () => (
   *   <Table rowComponents={[SelfContainedExpandableRow, TableRow]}>
   *     <SelfContainedExpandableRow>
   *       <TableCell>Data 1</TableCell>
   *       <TableCell>Data 2</TableCell>
   *       <TableRow>
   *         <TableCell>Nested 1</TableCell>
   *       </TableRow>
   *     </SelfContainedExpandableRow>
   *   </Table>
   * )
   *
   * const SelfContainedExpandableRow = ({ children, rowComponents }) => {
   *   const [open, setOpen] = useState(false)
   *   return (
   *     <TableRow
   *       open={open}
   *       onClick={() => setOpen(!open)}
   *       rowComponents={rowComponents}
   *     >
   *       {children}
   *     </TableRow>
   *   )
   * }
   * ```
   *
   * The following example, however, _does_ require `nestedRows` to be `true`
   * since `SelfContainedExpandableRow`'s children are defined outside the JSX
   * defining `Table`.
   *
   * ```
   * const SelfContainedExpandableRow = ({ rowComponents }) => {
   *   const [open, setOpen] = useState(false)
   *   return (
   *     <TableRow
   *       open={open}
   *       onClick={() => setOpen(!open)}
   *       rowComponents={rowComponents}
   *     >
   *       <TableCell>Data 1</TableCell>
   *       <TableCell>Data 2</TableCell>
   *       <TableRow>
   *         <TableCell>Nested 1</TableCell>
   *       </TableRow>
   *     </TableRow>
   *   )
   * }
   *
   * const MyTable = () => (
   *   <Table
   *     rowComponents={[SelfContainedExpandableRow, TableRow]}
   *     nestedRows={true}
   *   >
   *     <SelfContainedExpandableRow />
   *   </Table>
   * )
   * ```
   *
   * @since  5.x
   */
  nestedRows: _propTypes["default"].bool,

  /**
   * The component or components that will be used to render each table row.
   * Defaults to TableRow.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  rowComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * The component or components that will be used to render each table
   * section header. Defaults to TableSectionHeader.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  sectionHeaderComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),

  /**
   * This determines if horizontal dividers are shown between table rows.
   */
  showDividers: _propTypes["default"].bool,

  /**
   * This determines if horizontal dividers are shown between expanded rows.
   */
  showExpandedDividers: _propTypes["default"].bool,

  /**
   * This determines if table is striped using alternately highlighted rows.
   */
  showStripes: _propTypes["default"].bool,

  /**
   * This identifies which column is currently sorted. It is matched against
   * any "sortId" props set on TableCell elements in the table's header rows.
   */
  sortColumn: _propTypes["default"].string,

  /**
   * This identifies which direction the data column identified by
   * "sortColumn" is sorted.
   */
  sortDirection: _propTypes["default"].oneOf(["ascending", "descending"]),

  /**
   * This can be used to adjust the vertical spacing of the table.
   */
  spacing: _propTypes["default"].oneOf(["small", "medium"]),

  /**
   * Stick table header column to the beginning of the scroll container when the
   * user scrolls horizontally.
   *
   * NOTE: This feature is unsupported on IE11 because it uses `position: sticky`.
   *
   * NOTE: Currently stickyHeaderColumn only supports sticking one header column.
   *
   * NOTE: Enabling a stickyHeaderColumn will ignore any user-defined [colummSpan](https://meridian.a2z.com/components/table/?platform=react-web&detailsTab=api#api-TableSectionHeader-columnSpan)
   * prop on a TableSectionHeader.
   *
   * @since 5.21.0
   */
  stickyHeaderColumn: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the 'stickyHeaderColumn' prop if you don't want
   * to stick the table header column to the very beginning of the scroll container.
   * Use this to specify the pixel offset at which the column should stick.
   *
   * @since 5.21.0
   */
  stickyHeaderColumnOffset: _propTypes["default"].number,

  /**
   * Stick table header row to the beginning of the scroll container when the
   * user scrolls vertically. Only the last table header row will become stuck.
   *
   * NOTE: This feature is unsupported on IE11 because it uses `position: sticky`.
   * There is also a known issue with using this prop with multiple header rows
   * (`headerColumns > 1`) on Safari desktop.
   *
   * NOTE: Currently stickyHeaderRow only supports sticking one header row. If there
   * are multiple header rows it will stick the header row closest to the table body.
   *
   * @since 5.21.0
   */
  stickyHeaderRow: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the 'stickyHeaderRow' prop if you don't want
   * to stick the table header rows to the very beginning of the scroll container.
   * Use this to specify the pixel offset at which the rows should stick.
   *
   * @since 5.21.0
   */
  stickyHeaderRowOffset: _propTypes["default"].number,

  /**
   * When the user clicks on the header of a sortable column this is called
   * with an object containing two keys: "sortColumn" and "sortDirection".
   */
  onSort: _propTypes["default"].func
} : {};
var _default = Table;
exports["default"] = _default;

/***/ }),
/* 711 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _useFocus = _interopRequireDefault(__webpack_require__(66));

/**
 * NOTE: This component is deprecated. Use the useFocus hook instead.
 */
var Focus = function Focus(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      multipleTargets = _ref.multipleTargets,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus;
  var focus = (0, _useFocus["default"])({
    disabled: disabled,
    multipleNodes: multipleTargets,
    onBlur: onBlur,
    onFocus: onFocus
  });
  return children(focus);
};

Focus.displayName = "Focus";
Focus.propTypes = {
  children: _propTypes["default"].func.isRequired,

  /**
   * A bug in React means that onBlur is not called when an element with focus
   * is disabled. This prop allows you to manually inform the Focus component
   * when the element(s) that it manages are disabled so that it can turn off
   * its internal focus state. See: https://github.com/facebook/react/issues/9142
   */
  disabled: _propTypes["default"].bool,

  /**
   * Turn this on if you are using this component to track the focus of
   * multiple elements.
   */
  multipleTargets: _propTypes["default"].bool,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func
};
var _default = Focus;
exports["default"] = _default;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _stickyScrollTracker = _interopRequireDefault(__webpack_require__(714));

var _default = _stickyScrollTracker["default"];
exports["default"] = _default;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _noop = _interopRequireDefault(__webpack_require__(59));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _canUseDom = _interopRequireDefault(__webpack_require__(250));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = (0, _emotion.css)({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  pointerEvents: "none",
  "& > [mdn-tracker-x]": {
    width: 0,
    height: 0,
    position: "sticky",
    top: 0
  },
  "& > [mdn-tracker-y]": (0, _defineProperty2["default"])({
    width: 0,
    height: 0,
    position: "sticky",
    left: 0
  }, "[dir=\"rtl\"] &", {
    left: "unset",
    right: 0
  })
});
var canUseIntersectionObserver = _canUseDom["default"] && "IntersectionObserver" in window;
/**
 * Tracks when a user has scrolled a "relative" container in either direction.
 */

var StickyScrollTracker = function StickyScrollTracker(_ref) {
  var trackX = _ref.trackX,
      trackY = _ref.trackY,
      onChangeX = _ref.onChangeX,
      onChangeY = _ref.onChangeY;
  var xTrackerRef = (0, _react.useRef)();
  var yTrackerRef = (0, _react.useRef)(); // Set up the x-axis tracker. When it becomes partially hidden, the tracker
  // fires `onChangeX` with `true`. Once it becomes entirely uncovered, it calls
  // `onChangeX` with `false`.

  (0, _react.useEffect)(function () {
    if ( // We can use IntersectionObserver
    canUseIntersectionObserver && // We are tracking scrolling in the x direction
    trackX && // Tracker is in DOM
    xTrackerRef.current) {
      var observer = new IntersectionObserver(function (entries) {
        return onChangeX(!entries[0].isIntersecting);
      }, {
        threshold: 1
      });
      observer.observe(xTrackerRef.current);
      return function () {
        return observer.disconnect();
      };
    }
  }, [trackX, onChangeX]); // Set up the y-axis tracker. When it becomes partially hidden, the tracker
  // fires `onChangeY` with `true`. Once it becomes entirely uncovered, it calls
  // `onChangeY` with `false`.

  (0, _react.useEffect)(function () {
    if ( // We can use IntersectionObserver
    canUseIntersectionObserver && // We are tracking scrolling in the x direction
    trackY && // Tracker is in DOM
    yTrackerRef.current) {
      var observer = new IntersectionObserver(function (entries) {
        return onChangeY(!entries[0].isIntersecting);
      }, {
        threshold: 1
      });
      observer.observe(yTrackerRef.current);
      return function () {
        return observer.disconnect();
      };
    }
  }, [trackY, onChangeY]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": "true",
    className: styles
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-tracker-y": "",
    ref: yTrackerRef
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-tracker-x": "",
    ref: xTrackerRef
  }));
};

StickyScrollTracker.displayName = "StickyScrollTracker";
StickyScrollTracker.propTypes =  false ? {
  /**
   * If we should track scrolling in the x direction
   */
  trackX: _propTypes["default"].bool,

  /**
   * If we should track scrolling in the y direction
   */
  trackY: _propTypes["default"].bool,

  /**
   * Called when the x scroll state changes. Passes `true` if the container has
   * scrolled past the threshold in the x direction and `false` otherwise.
   */
  onChangeX: _propTypes["default"].func,

  /**
   * Called when the x scroll state changes. Passes `true` if the container has
   * scrolled past the threshold in the y direction and `false` otherwise.
   */
  onChangeY: _propTypes["default"].func
} : {};
StickyScrollTracker.defaultProps = {
  trackX: false,
  trackY: false,
  onChangeX: _noop["default"],
  onChangeY: _noop["default"]
};
var _default = StickyScrollTracker;
exports["default"] = _default;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _range = _interopRequireDefault(__webpack_require__(159));

var _table = _interopRequireDefault(__webpack_require__(157));

var _elevation = __webpack_require__(81);

var _tableContainer = _interopRequireDefault(__webpack_require__(357));

var _stickyContainer = _interopRequireDefault(__webpack_require__(718));

var _theme = __webpack_require__(24);

var _querySelectorArray = _interopRequireDefault(__webpack_require__(721));

var _token = __webpack_require__(20);

var _addDebouncedEventListener = _interopRequireDefault(__webpack_require__(195));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var fixedHeaderRowStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var stuckY = _ref.stuckY,
      fullWidth = _ref.fullWidth,
      containerWidth = _ref.containerWidth,
      columnWidths = _ref.columnWidths;
  return (0, _emotion.css)(_objectSpread({
    // Apply the primary background color to the fixed header so non-fixed
    // elements don't show through the cracks (e.g. the space between an action
    // bar and the table header)
    backgroundColor: t("backgroundColorPrimary"),
    // Set the box shadow here if we're not including the fullWidth prop
    boxShadow: !fullWidth && t.boxShadowCss("overflowShadow"),
    // If the table overflows its container's width (e.g. for a horizontally
    // scrolling table) then we want the table header to do the same. The only
    // way to make sure the header does this is to set its width explicitly
    // (setting individual column widths is not enough - the browser will just
    // squish them down to fit the table's container).
    width: columnWidths.length > 0 ? columnWidths[0].reduce(function (result, width) {
      return result + width;
    }, 0) : undefined,
    // Unset the max width set by StickyContainer
    maxWidth: "unset !important",
    // Constrain the action bar to the width of the table's container (instead
    // of matching the table width) so that actions floated to the right hand
    // side of the bar don't disappear out of view for horizontally scrollable
    // tables.
    "& [mdn-action-bar]": {
      maxWidth: containerWidth
    },
    // Make sure the stuck non-rows paints correctly on the z-axis
    "& > [mdn-table-stuck-non-rows]": {
      transform: "translateZ(0)"
    },
    // Display a backdrop that makes the header appear to expand the full
    // width of the scroll parent
    "&:before": fullWidth && {
      content: "''",
      position: "absolute",
      top: "0",
      left: "50%",
      transform: "translateX(-50%)",
      height: "100%",
      // Just go super super wide. We can't use something like 100% of the
      // viewport width in case we're in a horizontal scroller that is wider
      // than the viewport
      width: "10000px",
      boxSizing: "border-box",
      backgroundColor: t("backgroundColorPrimary"),
      borderBottomStyle: "solid",
      borderBottomWidth: t("borderWidthHeader"),
      borderBottomColor: t("borderColor"),
      boxShadow: t.boxShadowCss("overflowShadow"),
      opacity: stuckY ? 1 : 0,
      transition: t.transitionCss("motion", "opacity")
    },
    // When we override the width of the table cells (see below) we want to
    // make sure that the cell's padding doesn't affect the width that we set.
    "& th": {
      boxSizing: "border-box"
    }
  }, columnWidths.reduce(function (result, cellWidths, rowIndex) {
    result["& thead tr:nth-child(".concat(rowIndex + 1, ")")] = cellWidths.reduce(function (result, width, columnIndex) {
      result["& th:nth-child(".concat(columnIndex + 1, ")")] = {
        width: "".concat(width, "px !important")
      };
      return result;
    }, {});
    return result;
  }, {})));
}, ["stuckY", "fullWidth", "containerWidth", "columnWidths"]);
var initialState = {
  stuck: false,
  columnWidths: [],
  bodyHeight: 0
};

function reducer(state, action) {
  var type = action.type,
      columnWidths = action.columnWidths,
      bodyHeight = action.bodyHeight;

  switch (type) {
    case "WINDOW_RESIZED":
      return _objectSpread(_objectSpread({}, state), {}, {
        columnWidths: columnWidths,
        bodyHeight: bodyHeight
      });

    case "DOM_MUTATED":
      return _objectSpread(_objectSpread({}, state), {}, {
        columnWidths: columnWidths,
        bodyHeight: bodyHeight
      });

    case "STUCK":
      return _objectSpread(_objectSpread({}, state), {}, {
        stuck: true,
        columnWidths: columnWidths,
        bodyHeight: bodyHeight
      });

    case "UNSTUCK":
      return _objectSpread(_objectSpread({}, state), {}, {
        stuck: false
      });
  }
}
/**
 * This can be used to fix the table headers so that they don't scroll out of
 * view.
 */


var TableFixedHeaders = function TableFixedHeaders(_ref2) {
  var rootRef = _ref2.rootRef,
      headerRows = _ref2.headerRows,
      headerRowsOffset = _ref2.headerRowsOffset,
      tableContainerProps = _ref2.tableContainerProps,
      fullWidth = _ref2.fullWidth,
      nonRows = _ref2.nonRows;
  var t = (0, _theme.useTheme)(_table["default"], "table");

  var _useReducer = (0, _react.useReducer)(reducer, initialState),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      _useReducer2$ = _useReducer2[0],
      stuck = _useReducer2$.stuck,
      columnWidths = _useReducer2$.columnWidths,
      bodyHeight = _useReducer2$.bodyHeight,
      dispatch = _useReducer2[1]; // Measure the column widths (to fix the width of the header row cells) and the
  // table body height (to keep the fixed content from remaining stuck if the
  // user scrolls past the entire table).


  var headerRowCount = headerRows.length;
  var measureTable = (0, _react.useCallback)(function () {
    var bodyNode = rootRef.querySelector("tbody"); // Be sure to only query the columns that are in the "real" table

    var tableNode = rootRef.querySelector("table:not([mdn-table-fixed])");
    return {
      columnWidths: (0, _range["default"])(headerRowCount).map(function (_, rowIndex) {
        return (0, _querySelectorArray["default"])(tableNode, "thead tr:nth-child(".concat(rowIndex + 1, ") > *")).map(function (cell) {
          return cell.getBoundingClientRect().width;
        });
      }),
      bodyHeight: bodyNode ? bodyNode.getBoundingClientRect().height : 0
    };
  }, [headerRowCount, rootRef]); // When the header sticks update our internal "stuck" state and re-measure
  // the table to make sure we've got the latest dimensions

  var onStick = (0, _react.useCallback)(function () {
    return dispatch(_objectSpread({
      type: "STUCK"
    }, measureTable()));
  }, [measureTable]); // When the header unsticks update our internal "stuck" state.

  var onUnstick = (0, _react.useCallback)(function () {
    return dispatch({
      type: "UNSTUCK"
    });
  }, []); // When our internal "stuck" state flips to true, add a resize listener to the
  // window and a mutation observer to the table so we can re-measure the table
  // dimensions when it's likely that they've changed.

  (0, _react.useEffect)(function () {
    if (stuck) {
      var removeOnResizeListener = (0, _addDebouncedEventListener["default"])(window, "resize", function () {
        return dispatch(_objectSpread({
          type: "WINDOW_RESIZED"
        }, measureTable()));
      });
      var mutationObserver = new MutationObserver(function () {
        return dispatch(_objectSpread({
          type: "DOM_MUTATED"
        }, measureTable()));
      });
      mutationObserver.observe(rootRef.querySelector("table"), {
        childList: true,
        subtree: true
      });
      return function () {
        removeOnResizeListener();

        if (mutationObserver) {
          mutationObserver.disconnect();
        }
      };
    }
  }, [measureTable, rootRef, stuck]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": stuck ? "true" : undefined,
    style: {
      visibility: stuck ? "hidden" : undefined
    },
    key: stuck ? "stuck" : "unstuck"
  }, nonRows), /*#__PURE__*/_react["default"].createElement(_stickyContainer["default"], {
    offsetY: headerRowsOffset,
    maxOffsetY: bodyHeight,
    anchorNode: rootRef,
    onStick: onStick,
    onUnstick: onUnstick,
    zIndex: _elevation.elevationFixture
  }, function (_ref3) {
    var style = _ref3.style,
        stuckY = _ref3.stuckY;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: style,
      className: fixedHeaderRowStyles(t, {
        stuckY: stuckY,
        fullWidth: fullWidth,
        columnWidths: columnWidths,
        containerWidth: style.maxWidth
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      key: stuck ? "stuck" : "not-stuck",
      "mdn-table-stuck-non-rows": ""
    }, nonRows), /*#__PURE__*/_react["default"].createElement(_tableContainer["default"], (0, _extends2["default"])({}, tableContainerProps, {
      fixed: true
    }), /*#__PURE__*/_react["default"].createElement("thead", null, headerRows)));
  }));
};

TableFixedHeaders.displayName = "TableFixedHeaders";
TableFixedHeaders.propTypes =  false ? {
  /**
   * A ref pointing to the container around the table. This cannot be changed
   * once it's set.
   */
  rootRef: _propTypes["default"].object.isRequired,

  /**
   * The props set on the TableContainer element.
   */
  tableContainerProps: _propTypes["default"].object.isRequired,

  /*
   * Should the sticky header expand to fill the width of the scroll container
   * when it's displayed?
   */
  fullWidth: _propTypes["default"].bool,

  /**
   * Any header rows to fix.
   */
  headerRows: _propTypes["default"].arrayOf(_propTypes["default"].node),

  /**
   * The pixel offset from the top of the scroll container at which to fix the
   * header rows.
   */
  headerRowsOffset: _propTypes["default"].number,

  /**
   * Any non-row elements to fix along with the header rows.
   */
  nonRows: _propTypes["default"].arrayOf(_propTypes["default"].node)
} : {};
TableFixedHeaders.defaultProps = {
  headerRowsOffset: 0
};
var _default = TableFixedHeaders;
exports["default"] = _default;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(717),
    isIterateeCall = __webpack_require__(359),
    toFinite = __webpack_require__(348);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 717 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _stickyContainer = _interopRequireDefault(__webpack_require__(719));

var _default = _stickyContainer["default"];
exports["default"] = _default;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(155));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(77));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _noop = _interopRequireDefault(__webpack_require__(59));

var _addDebouncedEventListener = _interopRequireDefault(__webpack_require__(195));

var _getScrollParent = _interopRequireDefault(__webpack_require__(720));

var _nodeBounds = __webpack_require__(360);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// NOTE: This component does not use emotion because its styles are *highly*
// dynamic (updated on scroll). The emotion docs say that emotion is performant
// enough for highly dynamic styles, but using inline styles still seems to
// perform marginally better in this situation. Plus, using inline styles here
// isn't any worse from a dev perspective since we don't need any of the fancy
// css features enabled by emotion.

/**
 * The bounding box ensures that the sticky container is clipped as if it was a
 * sibling of the anchor node. Otherwise, because the sticky container is
 * position: fixed, it would flow outside of the anchor node's scroll parent.
 */
var boundingBoxStyle = function boundingBoxStyle(_ref) {
  var show = _ref.show,
      zIndex = _ref.zIndex,
      boundingBox = _ref.boundingBox;
  return {
    position: "fixed",
    top: 0,
    left: 0,
    overflow: "hidden",
    zIndex: zIndex,
    // This'll cover the same screen space as the scroll container, but we don't
    // want it to block interaction with elements underneath it.
    pointerEvents: "none",
    display: show ? undefined : "none",
    width: boundingBox.width,
    height: boundingBox.height,
    // NOTE: We could use "willChange: 'transform'" to optimize this a bit, but we
    // have chosen not to because that results in fuzzy text on non-retina
    // displays (at least in Chrome). The fuzzy text is the result of an
    // intentional optimization by the browser: https://googlechrome.github.io/samples/css-will-change-transform-rasterization/.
    transform: "translateY(".concat(boundingBox.top, "px) translateX(").concat(boundingBox.left, "px)")
  };
};
/**
 * The scroll box ensures that the sticky container scrolls normally when it's
 * not fixed.
 */


var scrollBoxStyle = function scrollBoxStyle(_ref2) {
  var top = _ref2.top,
      left = _ref2.left,
      width = _ref2.width,
      height = _ref2.height;
  return {
    position: "absolute",
    top: 0,
    left: 0,
    // Re-enable all the pointer events that we disabled for the parent bounding
    // box (see `boundingBoxStyle`).
    pointerEvents: "all",
    transform: "translateY(".concat(top, "px) translateX(").concat(left, "px)"),
    maxWidth: width,
    maxHeight: height
  };
};
/**
 * Nifty wrapper around Math.max to ignore undefined values
 */


var max = function max() {
  for (var _len = arguments.length, numbers = new Array(_len), _key = 0; _key < _len; _key++) {
    numbers[_key] = arguments[_key];
  }

  return Math.max.apply(Math, (0, _toConsumableArray2["default"])(numbers.filter(function (n) {
    return !isNaN(n);
  })));
};
/**
 * Nifty wrapper around Math.min to ignore undefined values
 */


var min = function min() {
  for (var _len2 = arguments.length, numbers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    numbers[_key2] = arguments[_key2];
  }

  return Math.min.apply(Math, (0, _toConsumableArray2["default"])(numbers.filter(function (n) {
    return !isNaN(n);
  })));
};
/**
 * Walk up the DOM tree from an element and find all the containers that are
 * scrollable along the given axis (or along either axis if no axis is
 * provided). This list may include the element itself if the element is
 * scrollable.
 *
 * Note that this doesn't check whether the scroll parent is currently
 * overflowing and has scrollbars, it just checks if it *would* have scrollbars
 * if its contents did overflow.
 */


var getAllScrollParents = function getAllScrollParents(element, axis) {
  var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var scrollParent = (0, _getScrollParent["default"])(element, axis);

  if (scrollParent === document.documentElement) {
    return result.concat(scrollParent);
  } else {
    return getAllScrollParents(scrollParent.parentNode, axis, result.concat(scrollParent));
  }
};
/**
 * Returns the pixel width of a node's border on one side. If no border is
 * present or the border is not defined in terms of pixels this will return 0.
 *
 * HACK: Requiring border widths as pixels feels a bit hacky, but all the sticky
 * container math assumes pixels so we can't really deal with other units. I
 * can't think of a last time I saw a border width specified as a non-pixel unit
 * anyway. This should be a pretty safe assumption, and worse-case scenario
 * non-pixel borders will result in the same behavior we had prior to this
 * addition (the sticky element overlapping the border).
 */


var getBorderPixelWidth = function getBorderPixelWidth(node, side) {
  var rawValue = window.getComputedStyle(node).getPropertyValue("border-".concat(side, "-width"));
  return rawValue && rawValue.indexOf("px") !== -1 ? parseFloat(rawValue) : 0;
};
/**
 * Use this to "stick" scrollable content to the screen when it's about to
 * scroll out of view (a la position: sticky). This component works by watching
 * an "anchor" node and displaying itself when the anchor node starts to scroll
 * out of view. This component will automatically pick up the position and
 * dimensions of the anchor node, but the actual content must be provided via
 * the children prop. Use something like React.cloneElement if you want to clone
 * the anchor node to make it appear as if it's transitioning from a scrollable
 * to a fixed state. This cloning requires a little extra work, but it makes the
 * component's internals less complicated and its usage more flexible (e.g. you
 * can use it for a fixed table header, which you can't really rip out of its
 * parent element and display on its own).
 */


var StickyContainer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(StickyContainer, _React$Component);

  var _super = _createSuper(StickyContainer);

  function StickyContainer() {
    var _this;

    (0, _classCallCheck2["default"])(this, StickyContainer);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      stuckX: false,
      stuckY: false,
      boundingBox: _nodeBounds.emptyNodeBounds,
      scrollBox: _nodeBounds.emptyNodeBounds
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "eventListeners", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "anchorNode", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollParentNodesX", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollParentNodesY", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "refresh", function () {
      var _this$props = _this.props,
          onStick = _this$props.onStick,
          onUnstick = _this$props.onUnstick;
      var state = _this.state;

      var boundingBox = _this.getBoundingBox();

      var _this$getScrollBox = _this.getScrollBox({
        boundingBox: boundingBox
      }),
          stuckX = _this$getScrollBox.stuckX,
          stuckY = _this$getScrollBox.stuckY,
          scrollBox = _this$getScrollBox.scrollBox;

      var stickyChange = state.stuckX !== stuckX || state.stuckY !== stuckY;

      var show = _this.show({
        stuckX: stuckX,
        stuckY: stuckY
      }); // Notify the user when the container sticks


      if (stuckX && !state.stuckX || stuckY && !state.stuckY) {
        onStick({
          stuckX: stuckX,
          stuckY: stuckY
        });
      } // Update the state if the container should be shown and anything has
      // changed


      if (show && (stickyChange || !(0, _nodeBounds.compareNodeBounds)(scrollBox, state.scrollBox) || !(0, _nodeBounds.compareNodeBounds)(boundingBox, state.boundingBox))) {
        _this.setState({
          stuckX: stuckX,
          stuckY: stuckY,
          scrollBox: scrollBox,
          boundingBox: boundingBox
        });
      } // Update the state if the container is unsticking


      if (!stuckX && !stuckY && stickyChange) {
        onUnstick();

        _this.setState({
          stuckX: false,
          stuckY: false
        });
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(StickyContainer, [{
    key: "setup",
    value: function setup() {
      /* eslint-disable-next-line react/no-find-dom-node */
      this.anchorNode = _reactDom["default"].findDOMNode(this.props.anchorNode);

      if (this.anchorNode) {
        this.scrollParentNodesX = getAllScrollParents(this.anchorNode, "x");
        this.scrollParentNodesY = getAllScrollParents(this.anchorNode, "y");
        this.addEventListeners();
        this.refresh();
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      // Remove any existing event listeners to ensure we don't accidentally stack
      // multiple listeners
      this.removeEventListeners(); // Listen for *any* scroll event in the document

      this.eventListeners.push((0, _addDebouncedEventListener["default"])(document, "scroll", this.refresh, true)); // Update on window resizes as well, since that will affect the size and
      // position of the elements we're tracking

      this.eventListeners.push((0, _addDebouncedEventListener["default"])(window, "resize", this.refresh, true));
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      this.eventListeners.forEach(function (removeListener) {
        return removeListener();
      });
      this.eventListeners = [];
    }
  }, {
    key: "show",
    value: function show(_ref3) {
      var stuckX = _ref3.stuckX,
          stuckY = _ref3.stuckY;
      return stuckX || stuckY || this.props.showAlways;
    }
    /**
     * This function refreshes the bounding box, scroll box, and "stuck" state
     * in response to the user's scrolling.
     */

  }, {
    key: "getBoundingBox",
    value:
    /**
     * This function returns the bounds of the visible area where we can show
     * sticky elements. These bounds represent the intersection of all scrollable
     * elements up the DOM tree from our anchor element. This rectangle can be
     * used to position a sticky element relative to the scroll parent(s) and to
     * clip the sticky element to make it appear as if it was a child of the
     * scroll parent(s).
     */
    function getBoundingBox() {
      var scrollParentNodesX = this.scrollParentNodesX,
          scrollParentNodesY = this.scrollParentNodesY; // Get the left and right edges of the intersection of all the scroll
      // containers (representing the horizontal space that is actually visible).

      var _scrollParentNodesX$r = scrollParentNodesX.reduce(function (result, node) {
        var _getNodeBounds = (0, _nodeBounds.getNodeBounds)(node),
            left = _getNodeBounds.left; // Add the container's left border width so the sticky element doesn't
        // overlap the left border


        // Add the container's left border width so the sticky element doesn't
        // overlap the left border
        result.left = max(left + getBorderPixelWidth(node, "left"), result.left); // Use the container's clientWidth which excludes borders and scrollbars

        // Use the container's clientWidth which excludes borders and scrollbars
        result.right = min(left + node.clientWidth, result.right);
        return result;
      }, {}),
          left = _scrollParentNodesX$r.left,
          right = _scrollParentNodesX$r.right; // Get the top and bottom edges of the intersection of all the scroll
      // containers (representing the vertical space that is actually visible).


      var _scrollParentNodesY$r = scrollParentNodesY.reduce(function (result, node) {
        var _getNodeBounds2 = (0, _nodeBounds.getNodeBounds)(node),
            top = _getNodeBounds2.top; // Add the container's top border height so the sticky element doesn't
        // overlap the top border


        // Add the container's top border height so the sticky element doesn't
        // overlap the top border
        result.top = max(top + getBorderPixelWidth(node, "top"), result.top); // Use the container's clientHeight which excludes borders and scrollbars

        // Use the container's clientHeight which excludes borders and scrollbars
        result.bottom = min(top + node.clientHeight, result.bottom);
        return result;
      }, {}),
          top = _scrollParentNodesY$r.top,
          bottom = _scrollParentNodesY$r.bottom;

      return {
        top: top,
        left: left,
        width: Math.max(right - left, 0),
        height: Math.max(bottom - top, 0)
      };
    }
    /**
     * This function returns a rectangle that can be used to position a sticky
     * element relative to the bounding box returned by `getBoundingBox`. It also
     * returns the "stuck" state of the element (whether it's fixed along the x or
     * y axis).
     */

  }, {
    key: "getScrollBox",
    value: function getScrollBox(_ref4) {
      var boundingBox = _ref4.boundingBox;
      var _this$props2 = this.props,
          offsetX = _this$props2.offsetX,
          maxOffsetX = _this$props2.maxOffsetX,
          offsetY = _this$props2.offsetY,
          maxOffsetY = _this$props2.maxOffsetY;
      var anchorBox = (0, _nodeBounds.getNodeBounds)(this.anchorNode);
      var anchorLeft = anchorBox.left - boundingBox.left;
      var anchorTop = anchorBox.top - boundingBox.top;
      var maxY = maxOffsetY !== undefined ? anchorTop + maxOffsetY : offsetY;
      var maxX = maxOffsetX !== undefined ? anchorLeft + maxOffsetX : offsetX;
      var stuckX = offsetX !== undefined && anchorLeft < offsetX;
      var stuckY = offsetY !== undefined && anchorTop < offsetY;
      var scrollBox = {
        top: stuckY ? Math.min(maxY, offsetY) : anchorTop,
        left: stuckX ? Math.min(maxX, offsetX) : anchorLeft,
        width: anchorBox.width,
        height: anchorBox.height
      };
      return {
        stuckX: stuckX,
        stuckY: stuckY,
        scrollBox: scrollBox
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setup();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If the anchor node changed then setup everything from scratch
      if (this.props.anchorNode !== prevProps.anchorNode) {
        this.setup();
      } // If a constraint changed then refresh


      if (this.props.offsetX !== prevProps.offsetX || this.props.offsetY !== prevProps.offsetY || this.props.maxOffsetX !== prevProps.maxOffsetX || this.props.maxOffsetY !== prevProps.maxOffsetY) {
        this.refresh();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEventListeners();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          zIndex = _this$props3.zIndex,
          children = _this$props3.children;
      var _this$state = this.state,
          stuckY = _this$state.stuckY,
          stuckX = _this$state.stuckX,
          scrollBox = _this$state.scrollBox,
          boundingBox = _this$state.boundingBox;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: boundingBoxStyle({
          show: this.show({
            stuckX: stuckX,
            stuckY: stuckY
          }),
          zIndex: zIndex,
          boundingBox: boundingBox
        })
      }, children({
        stuckY: stuckY,
        stuckX: stuckX,
        style: scrollBoxStyle(scrollBox)
      }));
    }
  }]);
  return StickyContainer;
}(_react["default"].Component);

(0, _defineProperty2["default"])(StickyContainer, "defaultProps", {
  onStick: _noop["default"],
  onUnstick: _noop["default"]
});
StickyContainer.propTypes =  false ? {
  /**
   * Specify children as a function. StickyContainer will pass an object
   * containing three keys that can be used to render the children: "style"
   * which contains an object of styles that must be set on a wrapper around
   * the children, "stuckX" which indicates whether or not the container is
   * stuck along the X axis, and "stuckY" which indicates whether or not the
   * container is stuck along the Y axis.
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * The node to track when showing, hiding, and positioning the sticky
   * container.
   */
  anchorNode: _propTypes["default"].object,

  /**
   * The offset from the left edge of the scroll viewport at which the
   * container should cease to stick. When the container reaches this offset
   * it will remain visible but will start to scroll left again with the rest
   * of the content.
   */
  maxOffsetX: _propTypes["default"].number,

  /**
   * The offset from the top edge of the scroll viewport at which the
   * container should cease to stick. When the container reaches this offset
   * it will remain visible but will start to scroll up again with the rest of
   * the content.
   */
  maxOffsetY: _propTypes["default"].number,

  /**
   * The offset from the top edge of the scroll viewport at which the
   * container will stick. An offset of 0 will cause the container to stick at
   * the top edge of the scroll viewport, an offset of 100 will cause it to
   * stick 100px down from the top, etc. If this is not provided the container
   * will not stick on the x axis.
   */
  offsetX: _propTypes["default"].number,

  /**
   * The offset from the left edge of the scroll viewport at which the
   * container will stick. An offset of 0 will cause the container to stick at
   * the left edge of the scroll viewport, an offset of 100 will cause it to
   * stick 100px right from the edge, etc. If this is not provided the
   * container will not stick on the y axis.
   */
  offsetY: _propTypes["default"].number,

  /**
   * Normally the sticky container is only rendered when it's stuck. Turn this
   * on to force it to render when unstuck as well.
   */
  showAlways: _propTypes["default"].bool,

  /**
   * Use this to determine how the sticky container is layered with other
   * elements.
   */
  zIndex: _propTypes["default"].number,

  /**
   * This is called when the container transitions from unstuck to stuck
   */
  onStick: _propTypes["default"].func,

  /**
   * This is called when the container transitions from stuck to unstuck
   */
  onUnstick: _propTypes["default"].func
} : {};
var _default = StickyContainer;
exports["default"] = _default;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isScrollable = function isScrollable(element, axis) {
  var style = window.getComputedStyle(element);
  return axis === "x" ? /(auto|scroll)/.test(style.overflowX) : axis === "y" ? /(auto|scroll)/.test(style.overflowY) : /(auto|scroll)/.test(style.overflow + style.overflowY + style.overflowX);
};
/**
 * Walk up the DOM tree from an element and find the closest container that is
 * scrollable along the given axis (or along either axis if no axis is
 * provided). This may return the element itself if the element is scrollable.
 *
 * Note that this doesn't check whether the scroll parent is currently
 * overflowing and has scrollbars, it just checks if it *would* have scrollbars
 * if its contents did overflow.
 */


var getScrollParent = function getScrollParent(element, axis) {
  return element && isScrollable(element, axis) ? element : element && element.parentElement ? getScrollParent(element.parentElement, axis) : document.documentElement;
};

var _default = getScrollParent;
exports["default"] = _default;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Identical to querySelectorAll, except the results are returned as an array
 */
var querySelectorArray = function querySelectorArray(element, query) {
  return Array.prototype.slice.call(element.querySelectorAll(query));
};

var _default = querySelectorArray;
exports["default"] = _default;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _checkbox = _interopRequireDefault(__webpack_require__(356));

var _checkLarge = _interopRequireDefault(__webpack_require__(362));

var _theme = __webpack_require__(24);

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _token = __webpack_require__(20);

var _focusRing = _interopRequireDefault(__webpack_require__(73));

var _text = _interopRequireDefault(__webpack_require__(47));

var _visuallyHidden = _interopRequireDefault(__webpack_require__(95));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

var _cardContext = _interopRequireDefault(__webpack_require__(363));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _labelSpan;

  var fillParent = _ref.fillParent,
      disabled = _ref.disabled,
      labelled = _ref.labelled,
      checked = _ref.checked,
      hover = _ref.hover,
      focus = _ref.focus,
      size = _ref.size,
      hoverDisabled = _ref.hoverDisabled;
  var textStyleObject = (0, _text["default"])(t);
  var modifier = checked ? "selected" : "unselected";
  var state = disabled ? "disabled" : "default";
  var borderWidth = t("borderWidth");
  var borderRadius = t("borderRadius");
  return (0, _emotion.css)({
    /**
     * Outer wrapper
     *
     * This outer wrapper makes the checkbox a block-level component without
     * stretching the clickable-area beyond the visible label.
     */
    // NOTE: Use "flex" instead of "block" to achieve block-level display while
    // fixing the min-height issue in IE11:
    // https://stackoverflow.com/questions/44700068/flexbox-min-height-and-ie11
    display: "flex",
    fontSize: 0,
    // Positioned this wrapper element statically if the checkbox is supposed
    // to fill its parent. The static positioning makes this wrapper disappear
    // when it comes to positioning so that the label (see "labelStyles" below)
    // is positioned relative to the parent of the checkbox, not this wrapper.
    position: fillParent ? "static" : undefined,
    // For IE11
    width: fillParent ? "100%" : undefined,
    height: fillParent ? "100%" : undefined,

    /**
     * Inner wrapper (the label element)
     */
    "& > label": _objectSpread(_objectSpread({}, textStyleObject), {}, {
      display: "inline-flex",
      flexDirection: "row",
      justifyContent: labelled ? "flex-start" : "center",
      alignItems: "center",
      position: fillParent ? "absolute" : "relative",
      top: fillParent ? 0 : undefined,
      right: fillParent ? 0 : undefined,
      bottom: fillParent ? 0 : undefined,
      left: fillParent ? 0 : undefined,
      color: t("foregroundColor", disabled ? "disabled" : "default"),
      cursor: disabled ? "not-allowed" : "pointer",
      userSelect: "none",
      minHeight: textStyleObject.lineHeight
    }),

    /**
     * Icon wrapper
     */
    "& > label > span": (_labelSpan = {
      // Vertically center icon
      display: "flex",
      alignItems: "center",
      // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
      // to use directional margin-left/right. If/when we drop IE11 we can simplify
      // these styles to be:
      // marginInlineEnd: labelled ? t("spacingHorizontal") : undefined,
      marginRight: labelled ? t("spacingHorizontal") : undefined,
      marginLeft: 0
    }, (0, _defineProperty2["default"])(_labelSpan, "[dir=\"rtl\"] &", {
      marginLeft: labelled ? t("spacingHorizontal") : undefined,
      marginRight: 0
    }), (0, _defineProperty2["default"])(_labelSpan, "width", t("width", size)), (0, _defineProperty2["default"])(_labelSpan, "height", t("height", size)), _labelSpan),

    /**
     * Visible checkbox (the Icon element)
     */
    "& > label > span > *[role=img]": (0, _emotion.css)({
      boxSizing: "border-box",
      flexShrink: 0,
      borderWidth: borderWidth,
      borderRadius: borderRadius,
      borderColor: t("borderColor", [modifier, state]),
      borderStyle: "solid",
      transition: t.transitionCss("motion", ["color", "background-color"]),
      color: t("indicatorColor", [modifier, state]),
      backgroundColor: t("backgroundColor", [modifier, state]),
      width: t("width", size),
      height: t("height", size)
    }, !disabled ? (0, _focusRing["default"])(t.tokens, {
      focus: focus,
      borderWidth: borderWidth,
      borderRadius: borderRadius,
      dropShadow: true,
      offset: 4,
      gapColor: t.themeBackgroundPrimaryDefault,
      hoverSelector: "*:hover > &"
    }) : undefined),
    "& > label:hover > span > *[role=img]": !disabled && !hoverDisabled ? {
      color: t("indicatorColor", [modifier, "hover"]),
      backgroundColor: t("backgroundColor", [modifier, "hover"]),
      borderColor: t("borderColor", [modifier, "hover"])
    } : undefined,
    "& > label:active > span > *[role=img]": !disabled ? {
      color: t("indicatorColor", [modifier, "pressed"]),
      backgroundColor: t("backgroundColor", [modifier, "pressed"]),
      borderColor: t("borderColor", [modifier, "pressed"])
    } : undefined
  }, hover && !hoverDisabled && !disabled ? {
    "& > label > span > *[role=img]": {
      color: t("indicatorColor", [modifier, "hover"]),
      backgroundColor: t("backgroundColor", [modifier, "hover"]),
      borderColor: t("borderColor", [modifier, "hover"])
    }
  } : undefined);
}, ["fillParent", "disabled", "labelled", "hover", "checked", "focus", "size", "hoverDisabled"]); // Styles for the actual HTML checkbox element that is hidden from the user

var hiddenCheckboxStyles = (0, _emotion.css)(_visuallyHidden["default"]);
/**
 * Render a form control that can be toggled on or off by the user. Usually
 * rendered in groups to allow one or more choices to be selected.
 */

var Checkbox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onChange = props.onChange;
  var t = (0, _theme.useTheme)(_checkbox["default"], "checkbox");
  var context = (0, _react.useContext)(_cardContext["default"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hoverDisabled = _useState2[0],
      setHoverDisabled = _useState2[1];

  var onMouseEnter = (0, _react.useCallback)(function () {
    return setHoverDisabled(false);
  }, [setHoverDisabled]);
  var handleChange = (0, _react.useCallback)(function (event) {
    if (onChange) onChange(event.target.checked);
    setHoverDisabled(true);
  }, [onChange, setHoverDisabled]);
  var labelled = Boolean(props.children);

  var _useFocus = (0, _useFocus2["default"])({
    onFocus: function onFocus(event) {
      if (props.onFocus) props.onFocus(event);
    },
    onBlur: function onBlur(event) {
      if (props.onBlur) props.onBlur(event);
    }
  }),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, {
      labelled: labelled,
      hover: context.hover,
      hoverDisabled: hoverDisabled,
      checked: props.checked,
      disabled: props.disabled,
      focus: focus && focusTrigger === "keyboard",
      size: props.size,
      fillParent: props.fillParent
    })
  }, /*#__PURE__*/_react["default"].createElement("label", {
    onMouseEnter: onMouseEnter
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, passThroughProps, focusProps, {
    id: props.id,
    className: hiddenCheckboxStyles,
    type: "checkbox",
    name: props.name,
    value: props.value,
    "aria-checked": props.checked !== "mixed" ? Boolean(props.checked) : "mixed",
    checked: // Cast `checked` to a boolean so that a value of `undefined`
    // doesn't flip the input into React's "uncontrolled" mode.
    Boolean(props.checked),
    disabled: props.disabled,
    tabIndex: props.tabIndex,
    onChange: handleChange,
    ref: ref
  })), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: props.iconTokens
  }), labelled ? /*#__PURE__*/_react["default"].createElement("div", null, props.children) : null));
});

Checkbox.displayName = "Checkbox";
Checkbox.propTypes =  false ? {
  /**
   * The checked state of the component. Use this in conjunction with the
   * `onChange` prop to make the component interactive.
   */
  checked: _propTypes["default"].oneOf([true, false, "mixed"]),

  /**
   * The component's label. Plain text is recommended. This will be displayed
   * next to the form control, and will trigger a state change when clicked.If
   * you're using an external label, be sure to associate them with an id and
   * [htmlFor](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLabelElement/htmlFor).
   */
  children: _propTypes["default"].node,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * If set to true the checkbox's clickable area will stretch to fill its
   * layout parent (the nearest ancestor with non-static positioning). The
   * checkbox's form control will be centered in the available space.
   *
   * This is currently used when checkboxes are rendered in table cells to make
   * table rows selectable.
   */
  fillParent: _propTypes["default"].bool,

  /**
   * Use this to customize the icon rendered in the checkbox. The value of this
   * prop should be an object of icon tokens imported directly from the Meridian
   * token library (e.g. `import checkTokens from "@amzn/meridian-tokens/base/icon/check-large`).
   *
   * The `"check-large"` icon is recommended for almost all checkboxes. The
   * `"minus"` icon is recommended for a checkbox that represents a partially
   * checked state (e.g. a "Select all" checkbox when only some items are
   * selected).
   *
   * See the [Iconography page](https://meridian.a2z.com/fundamentals/iconography/?platform=reactjs)
   * for a full list of the available icons.
   *
   * NOTE: This is deprecated and will be removed in 6.x.
   *
   * @deprecated 5.x
   */
  iconTokens: _propTypes["default"].object,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["medium", "large"]),

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The value of the underlying input element. This is used to populate the
   * form data when submitting a form. To change the on/off status of the
   * component use the `checked` prop.
   */
  value: _propTypes["default"].any,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * A function that will be called when the user attempts to change the checked
   * state of the component (e.g. by clicking on it). The new checked state will
   * be passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the checked state provided to this function somewhere in
   * your state and pass it back via the `checked` prop in order to make this
   * component interactive.
   */
  onChange: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func
} : {};
Checkbox.defaultProps = {
  size: "medium",
  iconTokens: _checkLarge["default"]
};
var _default = Checkbox;
exports["default"] = _default;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tableSortToggle = _interopRequireDefault(__webpack_require__(724));

var _default = _tableSortToggle["default"];
exports["default"] = _default;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _table = _interopRequireDefault(__webpack_require__(157));

var _arrowsUpAndDown = _interopRequireDefault(__webpack_require__(725));

var _arrowUpLarge = _interopRequireDefault(__webpack_require__(726));

var _arrowDownLarge = _interopRequireDefault(__webpack_require__(727));

var _clickable = _interopRequireDefault(__webpack_require__(108));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _theme = __webpack_require__(24);

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _focusRing = _interopRequireDefault(__webpack_require__(73));

var _text = _interopRequireDefault(__webpack_require__(47));

var _token = __webpack_require__(20);

var _rtl = __webpack_require__(80);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var sortDirection = _ref.sortDirection,
      focus = _ref.focus,
      columnTextAlignment = _ref.columnTextAlignment;
  return (0, _emotion.css)((0, _text["default"])(t), {
    fontWeight: t("fontWeightHeader"),
    // Add padding to the sort button to increase its clickable area, but add
    // the same amount of negative margin to ensure that the sort button
    // padding doesn't double up with the table cell padding. This assumes
    // that the toggle will be placed in a container with at least the same
    // amount of padding as "sortIndicatorSpacing" (e.g. a table cell).
    padding: t("sortIndicatorSpacing"),
    margin: -t("sortIndicatorSpacing"),
    // Inline flex so that the sort button moves left/right according to the
    // table cell's text alignment
    display: "inline-flex",
    alignItems: "center",
    flexDirection: (0, _rtl.getHorizontalDirection)(columnTextAlignment) === "right" ? "row-reverse" : "row",
    justifyContent: (0, _rtl.getHorizontalDirection)(columnTextAlignment) === "right" ? "flex-end" : "flex-start",
    "& > * + *": (0, _defineProperty2["default"])({}, (0, _rtl.getHorizontalDirection)(columnTextAlignment) === "right" ? "marginRight" : "marginLeft", t("sortIndicatorSpacing")),
    // Icon wrapper styles
    "& > span:nth-child(2)": {
      width: t("sortIndicatorWidth"),
      height: t("sortIndicatorHeight")
    },
    // Icon styles
    "& > span > *[role=img]": {
      color: focus ? t("sortIndicatorColorFocus") : sortDirection !== null ? t("sortIndicatorColorSorted") : t("sortIndicatorColorDefault"),
      // The focus ring doesn't have a transition (for performance reasons) so
      // don't transition the icon when showing the focus state (otherwise the
      // icon fades in after the focus ring appears and it looks a bit wonky).
      transition: !focus ? t.transitionCss("motion", "color") : undefined
    },
    "&:hover > span > *[role=img]": {
      color: t("sortIndicatorColorHover")
    },
    "&:active > span > *[role=img]": {
      color: t("sortIndicatorColorPressed")
    }
  }, (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: 2
  }));
}, ["sortDirection", "focus", "columnTextAlignment"]);
/**
 * Drop this in a table column's header cell to render a control that can be
 * used to change the sort direction of the column.
 */

var TableSortToggle = function TableSortToggle(_ref2) {
  var onChange = _ref2.onChange,
      sortColumn = _ref2.sortColumn,
      value = _ref2.value,
      defaultSortDirection = _ref2.defaultSortDirection,
      columnTextAlignment = _ref2.columnTextAlignment,
      children = _ref2.children;
  var t = (0, _theme.useTheme)(_table["default"], "table");
  var sortDirection = value && value.sortColumn === sortColumn ? value.sortDirection : null;
  var onClick = (0, _react.useCallback)(function () {
    return onChange({
      sortColumn: sortColumn,
      sortDirection: sortDirection === "ascending" ? "descending" : sortDirection === "descending" ? "ascending" : defaultSortDirection
    });
  }, [sortColumn, sortDirection, defaultSortDirection, onChange]);
  var iconDirection = sortDirection || defaultSortDirection;

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, focusProps, {
    onClick: onClick,
    className: styles(t, {
      focus: focus && focusTrigger === "keyboard",
      sortDirection: sortDirection,
      columnTextAlignment: columnTextAlignment
    })
  }), /*#__PURE__*/_react["default"].createElement("span", null, children), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: sortDirection === null ? _arrowsUpAndDown["default"] : iconDirection === "descending" ? _arrowDownLarge["default"] : _arrowUpLarge["default"]
  }));
};

TableSortToggle.displayName = "TableSortToggle";
TableSortToggle.propTypes =  false ? {
  /**
   * The table cell's text.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The column that this toggle sorts.
   */
  sortColumn: _propTypes["default"].string.isRequired,

  /**
   * This is called when the user attempts to sort the column. The toggle's new
   * value, either "ascending" or "descending", will be passed to the function.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * This should match the text alignment of the table column that
   * contains the sort button.
   */
  columnTextAlignment: _propTypes["default"].oneOf(["left", "start", "right", "end"]),

  /**
   * This is the value that the toggle will default to when first clicked by the
   * user.
   */
  defaultSortDirection: _propTypes["default"].oneOf(["ascending", "descending"]),

  /**
   * The column that is currently sorted and the direction that it's sorted.
   */
  value: _propTypes["default"].shape({
    sortColumn: _propTypes["default"].string,
    sortDirection: _propTypes["default"].PropTypes.oneOf(["ascending", "descending"])
  })
} : {};
TableSortToggle.defaultProps = {
  defaultSortDirection: "ascending"
};
var _default = TableSortToggle;
exports["default"] = _default;

/***/ }),
/* 725 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconArrowsUpAndDownData: "data:image/svg+xml,%3csvg width='18' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='currentColor' fill-rule='nonzero'%3e%3cpath d='M4 0a1 1 0 011 1v9.585l1.293-1.292a1 1 0 011.32-.083l.094.083a1 1 0 010 1.414l-3 3A1.003 1.003 0 014 14l.085-.004a1.003 1.003 0 01-.052.003L4 14a1.223 1.223 0 01-.149-.011 1.12 1.12 0 01-.222-.06 1.005 1.005 0 01-.336-.222l.09.08a1.003 1.003 0 01-.09-.08l-3-3a1 1 0 111.414-1.414L3 10.585V1a1 1 0 01.883-.993L4 0zM14 14a1 1 0 001-1V3.415l1.293 1.292a1 1 0 001.32.083l.094-.083a1 1 0 000-1.414l-3-3A1 1 0 0014 0l.085.004A1 1 0 0014.033 0L14 0a1.016 1.016 0 00-.52.146 1.045 1.045 0 00-.187.147l.09-.08a1 1 0 00-.09.08l-3 3a1 1 0 001.414 1.414L13 3.415V13a1 1 0 00.883.993L14 14z'/%3e%3c/g%3e%3c/svg%3e",
  iconArrowsUpAndDownWidth: 18,
  iconArrowsUpAndDownHeight: 14
};

/***/ }),
/* 726 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconArrowUpLargeData: "data:image/svg+xml,%3csvg width='10' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M9 5L5 1 1 5M5 1v12'/%3e%3c/g%3e%3c/svg%3e",
  iconArrowUpLargeWidth: 10,
  iconArrowUpLargeHeight: 14
};

/***/ }),
/* 727 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconArrowDownLargeData: "data:image/svg+xml,%3csvg width='10' height='14' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1 9l4 4 4-4M5 13V1'/%3e%3c/g%3e%3c/svg%3e",
  iconArrowDownLargeWidth: 10,
  iconArrowDownLargeHeight: 14
};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TableActionBarOverlay", {
  enumerable: true,
  get: function get() {
    return _tableActionBarOverlay["default"];
  }
});
exports["default"] = void 0;

var _tableActionBar = _interopRequireDefault(__webpack_require__(729));

var _tableActionBarOverlay = _interopRequireDefault(__webpack_require__(365));

var _default = _tableActionBar["default"];
exports["default"] = _default;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _find = _interopRequireDefault(__webpack_require__(96));

var _table = _interopRequireDefault(__webpack_require__(157));

var _elevation = __webpack_require__(81);

var _tableActionBarOverlay = _interopRequireDefault(__webpack_require__(365));

var _row = _interopRequireDefault(__webpack_require__(10));

var _button = _interopRequireDefault(__webpack_require__(8));

var _theme = __webpack_require__(24);

var _text = _interopRequireDefault(__webpack_require__(47));

var _isElementOf = _interopRequireDefault(__webpack_require__(94));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var isButton = (0, _isElementOf["default"])(_button["default"]);

var styles = function styles(t, _ref) {
  var stickyOffset = _ref.stickyOffset,
      withOverlay = _ref.withOverlay;
  return (0, _emotion.css)((0, _text["default"])(t), {
    // The action bar container adds whitespace between the action bar and the
    // table. It also ensures that the empty space is opaque (using the table's
    // background color) so that elements don't peak through between the action
    // bar and the table when the action bar is sticky.
    backgroundColor: t("backgroundColorDefault"),
    paddingBottom: t("spacingVerticalSmall"),
    "& > [mdn-action-bar]": {
      position: "relative"
    },
    // Hide the action bar's children when an overlay is shown (ensures that the
    // action bar's interactive children aren't focuseable when obscured by
    // an overlay).
    "& > [mdn-action-bar] > *:last-child": withOverlay && {
      visibility: "hidden"
    }
  }, stickyOffset !== undefined && {
    position: "sticky",
    top: stickyOffset,
    // Stack one higher than other fixtures to ensure that if the action bar
    // and table header conflict then the action bar is shown on top (this
    // happens when the user scrolls to the very bottom of an HTML table with
    // headers that are stuck using `position: sticky`).
    zIndex: _elevation.elevationFixture + 1
  });
};
/**
 * Used to render an action bar for a table. Usually placed as a child of the Table
 * component, but can be placed outside of the Table when necessary.
 */


var TableActionBar = function TableActionBar(_ref2) {
  var children = _ref2.children,
      alignmentHorizontal = _ref2.alignmentHorizontal,
      widths = _ref2.widths,
      stickyOffset = _ref2.stickyOffset,
      overlayComponent = _ref2.overlayComponent;

  var childrenArray = _react["default"].Children.toArray(children);

  var isOverlay = (0, _react.useMemo)(function () {
    return (0, _isElementOf["default"])(overlayComponent);
  }, [overlayComponent]);
  var isNotActionBarOverlay = (0, _react.useCallback)(function (child) {
    return !isOverlay(child);
  }, [isOverlay]);
  var overlay = (0, _find["default"])(children, isOverlay);
  var nonOverlayChildren = childrenArray.filter(isNotActionBarOverlay);
  var t = (0, _theme.useTheme)(_table["default"], "table");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, {
      stickyOffset: stickyOffset,
      withOverlay: Boolean(overlay)
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-action-bar": ""
  }, overlay, /*#__PURE__*/_react["default"].createElement(_row["default"], {
    widths: widths,
    type: "fill",
    spacingInset: "small medium",
    spacing: "small",
    alignmentHorizontal: alignmentHorizontal
  }, nonOverlayChildren.map(function (element) {
    return isButton(element) ? /*#__PURE__*/_react["default"].cloneElement(element, {
      backdropColor: t.tokens.themeBackgroundSecondaryDefault
    }) : element;
  }))));
};

TableActionBar.displayName = "TableActionBar";
TableActionBar.propTypes =  false ? {
  /**
   * The contents of the action bar.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Use this to determine how the children in the action bar are aligned
   * horizontally.
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["left", "start", "center", "right", "end", "justify"]),

  /**
   * The component that will render as an overlay. Defaults to Meridian's TableActionBarOverlay.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   *
   * @since  5.x
   */
  overlayComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),

  /**
   * This applies sticky positioning to the action bar so that it sticks to the
   * top of the viewport when the user scrolls. This is an experimental feature
   * that is not compatible with IE11. If you are using the TableActionBar with
   * Meridian's Table component, use the `fixHeaderRows` prop on the Table
   * component instead of this prop.
   */
  stickyOffset: _propTypes["default"].number,

  /**
   * Use this to determine the widths of the action bar's children. The action
   * bar uses the Row component under the hood - see the usage documentation of
   * the Row component for details on how to use this prop.
   */
  widths: _propTypes["default"].oneOfType([_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]), _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))])
} : {};
TableActionBar.defaultProps = {
  alignmentHorizontal: "start",
  overlayComponent: _tableActionBarOverlay["default"]
};
var _default = TableActionBar;
exports["default"] = _default;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridColumns = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _box = _interopRequireDefault(__webpack_require__(31));

var _propTypes2 = _interopRequireDefault(__webpack_require__(126));

var _parsers = __webpack_require__(128);

var _functional = __webpack_require__(38);

var _cxMemoized = _interopRequireDefault(__webpack_require__(107));

var _rtl = __webpack_require__(80);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var gridColumns = 12; // Turns a raw width value (a string or number) into an object with fields
// containing the type of width and the parsed width values

exports.gridColumns = gridColumns;

var parseWidth = function parseWidth(width) {
  return typeof width === "string" && /^grid-/.test(width) ? {
    type: "grid",
    // Turns "grid-X" into a numeric percentage w/ four significant digits (e.g.
    // "grid-4" to 0.3333)
    value: Math.floor(10000 * parseInt(width.substr(5)) / gridColumns) / 10000
  } : typeof width === "string" && /^[0-9.]+%\s*$/.test(width) ? {
    type: "percentage",
    // Turns "X%" into a numeric percentage w/ four significant digis (e.g. "33.33%"
    // to 0.3333)
    value: Math.floor(100 * parseFloat(width)) / 10000
  } : width === "fit" || width === "fill" ? {
    type: "flex",
    value: width
  } : width !== undefined && width !== null && width !== "" ? {
    type: "css",
    value: width
  } : {
    type: "empty",
    value: null
  };
}; // These styles stretch the inner div to fill the entire box so that a width or
// height applied to the box will also apply to the inner div. This is only
// necessary for rows that wrap (which have two containing divs in order to make
// the gutter spacing work correctly - see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Mastering_Wrapping_of_Flex_Items#Creating_gutters_between_items)


var wrapContainerStyles = (0, _emotion.css)({
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch"
});

var rowStyles = function rowStyles(widths) {
  return (0, _functional.memoizeByKeys)(function (_ref) {
    var _css;

    var wrap = _ref.wrap,
        spacing = _ref.spacing,
        alignmentHorizontal = _ref.alignmentHorizontal,
        alignmentVertical = _ref.alignmentVertical,
        reverse = _ref.reverse;
    var spacingValues = (0, _parsers.parseSpacing)(spacing);
    var verticalSpacing = spacingValues[0];
    var horizontalSpacing = spacingValues[1] || verticalSpacing;
    return (0, _emotion.css)((_css = {
      width: wrap === "none" ? undefined : "calc(100% + ".concat(horizontalSpacing, "px)"),
      display: "flex",
      flexDirection: reverse ? "row-reverse" : "row",
      flexWrap: wrap === "down" ? "wrap" : wrap === "up" ? "wrap-reverse" : undefined,
      alignItems: {
        top: "flex-start",
        bottom: "flex-end"
      }[alignmentVertical] || alignmentVertical,
      justifyContent: {
        left: "flex-start",
        right: "flex-end",
        justify: "space-between"
      }[(0, _rtl.getHorizontalDirection)(alignmentHorizontal)] || (0, _rtl.getHorizontalDirection)(alignmentHorizontal),
      // Reset the extra margins caused by the children on the right/bottom
      // edges. We can't do a simple reset on the first/last child because
      // there may be any number of children on the right/bottom edges if the
      // row wraps.
      margin: wrap === "none" ? undefined : "0 -".concat(horizontalSpacing, "px ").concat(wrap === "none" ? 0 : "-".concat(verticalSpacing, "px"), " 0")
    }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
      margin: wrap === "none" ? undefined : "0 0 ".concat(wrap === "none" ? 0 : "-".concat(verticalSpacing, "px"), " -").concat(horizontalSpacing, "px")
    }), (0, _defineProperty2["default"])(_css, "& > *", (0, _defineProperty2["default"])({
      // Make sure that any borders or padding applied to the child don't throw
      // of the widths that we apply
      boxSizing: "border-box !important",
      // Set margins for horizontal spacing and vertical spacing if the row is
      // allowed to wrap (and clear other margins)
      margin: "0 ".concat(horizontalSpacing, "px ").concat(wrap === "none" ? 0 : verticalSpacing, "px 0 !important")
    }, "[dir=\"rtl\"] &", {
      margin: "0 0 ".concat(wrap === "none" ? 0 : verticalSpacing, "px ").concat(horizontalSpacing, "px !important")
    })), (0, _defineProperty2["default"])(_css, "& > *:".concat(reverse ? "first" : "last", "-child"), wrap === "none" ? {
      marginRight: "0 !important"
    } : undefined), (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] & > *:".concat(reverse ? "first" : "last", "-child"), wrap === "none" ? {
      marginLeft: "0px !important"
    } : undefined), _css), // If we've got an array of widths, apply each width to the child whose
    // index in the dom matches the widths's index in the array. If we've
    // got a single height, apply that to all children.
    Array.isArray(widths) ? widths.reduce(function (result, width, index) {
      result["& > *:nth-child(".concat(parseInt(index) + 1, ")")] = childStyles({
        width: width,
        wrap: wrap,
        horizontalSpacing: horizontalSpacing
      });
      return result;
    }, {}) : {
      "& > *": childStyles({
        width: widths,
        wrap: wrap,
        horizontalSpacing: horizontalSpacing
      })
    });
  }, ["wrap", "spacing", "alignmentHorizontal", "alignmentVertical", "reverse"]);
};

var rowStylesWithUniqueWidths = (0, _functional.memoizeArray)(rowStyles);
var rowStylesWithUniformWidths = (0, _functional.memoize)(rowStyles);

var childStyles = function childStyles(_ref2) {
  var rawWidth = _ref2.width,
      wrap = _ref2.wrap,
      horizontalSpacing = _ref2.horizontalSpacing;
  var width = parseWidth(rawWidth);
  return {
    // Stretch the child to fill remaining space if the width is "fill"
    flex: width.type === "flex" && width.value === "fill" ? "1 !important" : undefined,
    // Ensure that the child isn't smashed by flexbox if it has an explicit
    // width set.
    flexShrink: width.type === "grid" || width.type === "percentage" || width.type === "flex" && width.value === "fit" || width.type === "css" && width.value !== "auto" ? "0 !important" : undefined,
    width: width.type === "grid" || width.type === "percentage" ? // For percentage widths (or grid widths), set the element to the
    // specified percentage of the row's width (e.g. 50%) but subtract the
    // gutter spacing from the width to ensure there's enough room for the
    // element and its gutter (e.g. 50% - 16px). For rows that wrap we can
    // subtract the full gutter width since each element has a full gutter
    // to its right (the extra gutter on the right edge of the row is
    // removed with a negative margin on the parent element). For rows
    // that don't wrap the last element doesn't have a gutter to its
    // right, so things are a bit more complicated. In this case there's
    // one less gutter than there are elements in the row (e.g. 3 elements
    // have 2 gutters between them) so subtracting a full gutter from each
    // element's width would be too much. We have to spread out this saved
    // saved gutter space proportional to the percentage of the row that
    // the element takes up. For example if a row has two elements that
    // each take up 50% of the row with a single 16px gutter between them,
    // then we'd subtract 50% of the 16px gutter from each element giving
    // us a final width of 50% - 8px for each element.
    "calc(".concat(width.value * 100, "% - ").concat(horizontalSpacing - (wrap === "none" ? width.value * horizontalSpacing : 0), "px) !important") : width.type === "css" ? // If the size is a plain CSS value then just use that directly
    "".concat(width.value).concat(typeof width.value === "number" ? "px" : "", " !important") : // And lastly for fit, fill, or empty values leave it up to flexbox
    undefined
  };
};
/**
 * The Row component lines children up horizontally in a row with even spacing
 * in-between them. If a value is provided for the `wrap` property then the Row
 * component can also be used to stack elements with even vertical spacing
 * between them.
 */


var Row = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  // A row with an explicit height cannot wrap
  var wrap = props.height === undefined ? props.wrap : "none"; // We need to memoize differently based on whether we got an array or scalar
  // for the "widths" property

  var rowStylesFunc = Array.isArray(props.widths) ? rowStylesWithUniqueWidths : rowStylesWithUniformWidths;
  var rowStyles = rowStylesFunc(props.widths)(_objectSpread(_objectSpread({}, props), {}, {
    wrap: wrap
  })); // Apply the row styles to an extra div inside the box so margins that are
  // applied to the box (e.g. if the row is nested in another row) don't
  // conflict with the margins that are applied by `rowStyles`.

  return /*#__PURE__*/_react["default"].createElement(_box["default"], _objectSpread(_objectSpread({}, props), {}, {
    className: wrap === "none" ? (0, _cxMemoized["default"])(rowStyles, props.className) : (0, _cxMemoized["default"])(wrapContainerStyles, props.className),
    ref: ref
  }), wrap === "none" ? props.children : /*#__PURE__*/_react["default"].createElement("div", {
    className: rowStyles
  }, props.children));
});

Row.displayName = "Row";
Row.propTypes =  false ? {
  /**
   * Specify the horizontal alignment of the elements inside the row.
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["left", "start", "center", "right", "end", "justify"]),

  /**
   * Specify the vertical alignment of the elements inside the row.
   *
   * @since 5.x
   */
  alignmentVertical: _propTypes["default"].oneOf(["top", "center", "bottom", "stretch", "baseline"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.18.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set the column's background color using a preset, or using a string
   * containing any valid CSS color.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary"]), _propTypes["default"].string]),

  /**
   * The elements to line up in a row. Any elements can be supplied here, although if
   * only one child is supplied the row will not add much value (it's meant
   * for aligning multiple elements). If you only have one child, consider using
   * the `Box` component instead.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Set the height of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum height of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum width of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum height of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum width of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Controls the horizontal overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowX` can cause the `overflow-y` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   *
   * @since 5.21.0
   */
  overflowX: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * Controls the vertical overflow behavior of the container. The container
   * can become scrollable by setting the prop to auto/scroll, or the overflow
   * can be hidden by setting the prop to hidden.
   *
   * NOTE: Setting `overflowY` can cause the `overflow-x` style to resolve to auto.
   * Be sure to test scrolling in both directions. Check out the [CSS Overflow spec](https://www.w3.org/TR/css-overflow-3/#overflow-properties)
   * for more information.
   */
  overflowY: _propTypes["default"].oneOf(["auto", "hidden", "scroll"]),

  /**
   * If set to true this will reverse the order in which the elements in the row
   * are rendered (the first element will be rendered where the last normally
   * would, and vice-versa).
   */
  reverse: _propTypes["default"].bool,

  /**
   * Set the spacing between elements in the row using a preset.
   *
   * Two spacing values are allowed (separated by a space) if the `wrap` prop is
   * set. In this case the first value will be used as the vertical spacing
   * between elements and the second value will be used as the horizontal
   * spacing.
   */
  spacing: _propTypes2["default"].spacing(2),

  /**
   * Apply padding to the component.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"small medium"` for small padding on the top/bottom and
   * medium padding on the left/right).
   */
  spacingInset: _propTypes2["default"].spacing(4),

  /**
   * The HTML tag to use when rendering the component to the DOM.
   */
  tag: _propTypes["default"].string,

  /**
   * Set the style of the row using one of Meridian's Box component styles.
   * If omitted the row will not have any decorative visual style applied to
   * it.
   */
  type: _propTypes["default"].oneOf(["outline", "fill"]),

  /**
   * Set the width of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the width of each element in the row.
   *
   * If a single width is provided then it will be applied to every element in
   * the row. If an array of widths is provided then each width will be
   * applied to the element in the row that exists at the same index as the
   * width in the array (e.g. `[<element 0 width>, <element 1 width>, null, <element 3 width>]`).
   *
   * The possible values for each width are:
   *   - `number` - A fixed pixel width.
   *   - `string` - Any valid CSS width.
   *   - `"fit"` - The element's width will shrink to fit its contents.
   *   - `"fill"` - The element's width will fill all remaining space in the row.
   *     If this value is set on multiple elements, they will share the remaining
   *     space in the row equally.
   *   - `"grid-<x>"` - The element will take up "x" grid units on a 12-column grid
   *     ("x" can be 1-12).
   */
  widths: _propTypes["default"].oneOfType([_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]), _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),

  /**
   * Set this to allow elements that overflow the width of the row to wrap. If
   * this is set to `"down"` then elements that overflow to the right will wrap
   * down below the other elements. If set to `"up"` then the overflowing
   * elements will wrap up above the other elements.
   *
   * NOTE: Negative margins are used internally in order to maintain the correct
   * gutter spacing between elements that wrap ([this technique is recommended by MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Mastering_Wrapping_of_Flex_Items#Creating_gutters_between_items)).
   * This can cause unwanted horizontal scrolling if the inset spacing of the
   * row is less than the gutter spacing *and* the row is placed in a parent that
   * allows overflow. To resolve this you can either increase the padding/margin
   * around the row (using the `insetSpacing` prop of the row or by applying
   * padding/margin to an element that wraps the row) or turn off the
   * overflow on the row's parent element (by applying an `overflow: hidden`
   * style). You can also turn off wrapping on the row or consider using custom
   * styles to build a layout with something like [CSS grid](https://css-tricks.com/snippets/css/complete-guide-grid/).
   */
  wrap: _propTypes["default"].oneOf(["up", "down", "none"])
} : {};
Row.defaultProps = {
  wrap: "none",
  spacing: "medium",
  alignmentVertical: "center",
  alignmentHorizontal: "start"
};
var _default = Row;
exports["default"] = _default;

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isDate_index_js__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(45);



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isDate_index_js__["a" /* default */])(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  return !isNaN(Number(date));
}

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(45);

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addMilliseconds_index_js__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(83);



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_0__addMilliseconds_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(45);



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var timestamp = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate).getTime();
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return new Date(timestamp + amount);
}

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_getUTCDayOfYear_index_js__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getUTCISOWeek_index_js__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeekYear_index_js__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_getUTCWeek_index_js__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_getUTCWeekYear_index_js__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__ = __webpack_require__(741);







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */
var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = Object(__WEBPACK_IMPORTED_MODULE_4__lib_getUTCWeekYear_index_js__["a" /* default */])(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = Object(__WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeekYear_index_js__["a" /* default */])(date); // Padding

    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = Object(__WEBPACK_IMPORTED_MODULE_3__lib_getUTCWeek_index_js__["a" /* default */])(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = Object(__WEBPACK_IMPORTED_MODULE_1__lib_getUTCISOWeek_index_js__["a" /* default */])(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = Object(__WEBPACK_IMPORTED_MODULE_0__lib_getUTCDayOfYear_index_js__["a" /* default */])(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(Math.floor(absOffset / 60), 2);
  var minutes = Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

/* harmony default export */ __webpack_exports__["a"] = (formatters);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCDayOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(45);


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(45);




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(date).getTime() - Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__["a" /* default */])(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__ = __webpack_require__(45);



function startOfUTCISOWeekYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__["a" /* default */])(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuary);
  return date;
}

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCWeek_index_js__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeekYear_index_js__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(45);




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCWeek_index_js__["a" /* default */])(date, options).getTime() - Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeekYear_index_js__["a" /* default */])(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getUTCWeekYear_index_js__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultOptions_index_js__ = __webpack_require__(131);





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_4__defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var firstWeekContainsDate = Object(__WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__getUTCWeekYear_index_js__["a" /* default */])(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeek, options);
  return date;
}

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__ = __webpack_require__(368);

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(fractionalSeconds, token.length);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (formatters);

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dateLongFormatter = function (pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};

var timeLongFormatter = function (pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};

var dateTimeLongFormatter = function (pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ __webpack_exports__["a"] = (longFormatters);

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isProtectedDayOfYearToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = isProtectedWeekYearToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = throwProtectedError;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__ = __webpack_require__(746);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__["a" /* default */]);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(753);






/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a" /* default */],
  formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a" /* default */],
  formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a" /* default */],
  localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a" /* default */],
  match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a" /* default */],
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ __webpack_exports__["a"] = (locale);

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (formatDistance);

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(749);

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (formatLong);

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildFormatLongFn;
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ __webpack_exports__["a"] = (formatRelative);

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(752);

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (localize);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildLocalizeFn;
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(755);


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a" /* default */])({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMatchFn;
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMatchPatternFn;
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var t,e;t=this,e=function(t){function e(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=Array(e);n<e;n++)r[n]=t[n];return r}function n(t,e,n,r,i,o,a){try{var s=t[o](a),c=s.value}catch(t){return void n(t)}s.done?e(c):Promise.resolve(c).then(r,i)}function r(t){return function(){var e=this,r=arguments;return new Promise((function(i,o){var a=t.apply(e,r);function s(t){n(a,i,o,s,c,"next",t)}function c(t){n(a,i,o,s,c,"throw",t)}s(void 0)}))}}function i(t,e,n){return e&&function(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,l(r.key),r)}}(t.prototype,e),Object.defineProperty(t,"prototype",{writable:!1}),t}function o(t,e,n){return(e=l(e))in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function a(t,e){if(t!==e)throw new TypeError("Cannot instantiate an arrow function")}function s(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function c(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?s(Object(n),!0).forEach((function(e){o(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function h(){h=function(){return e};var t,e={},n=Object.prototype,r=n.hasOwnProperty,i=Object.defineProperty||function(t,e,n){t[e]=n.value},o="function"==typeof Symbol?Symbol:{},a=o.iterator||"@@iterator",s=o.asyncIterator||"@@asyncIterator",c=o.toStringTag||"@@toStringTag";function u(t,e,n){return Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{u({},"")}catch(t){u=function(t,e,n){return t[e]=n}}function l(t,e,n,r){var o=e&&e.prototype instanceof v?e:v,a=Object.create(o.prototype),s=new T(r||[]);return i(a,"_invoke",{value:O(t,n,s)}),a}function f(t,e,n){try{return{type:"normal",arg:t.call(e,n)}}catch(t){return{type:"throw",arg:t}}}e.wrap=l;var d="suspendedStart",p="suspendedYield",y="executing",m="completed",g={};function v(){}function b(){}function w(){}var A={};u(A,a,(function(){return this}));var E=Object.getPrototypeOf,x=E&&E(E(C([])));x&&x!==n&&r.call(x,a)&&(A=x);var k=w.prototype=v.prototype=Object.create(A);function L(t){["next","throw","return"].forEach((function(e){u(t,e,(function(t){return this._invoke(e,t)}))}))}function S(t,e){function n(i,o,a,s){var c=f(t[i],t,o);if("throw"!==c.type){var h=c.arg,u=h.value;return u&&"object"==typeof u&&r.call(u,"__await")?e.resolve(u.__await).then((function(t){n("next",t,a,s)}),(function(t){n("throw",t,a,s)})):e.resolve(u).then((function(t){h.value=t,a(h)}),(function(t){return n("throw",t,a,s)}))}s(c.arg)}var o;i(this,"_invoke",{value:function(t,r){function i(){return new e((function(e,i){n(t,r,e,i)}))}return o=o?o.then(i,i):i()}})}function O(e,n,r){var i=d;return function(o,a){if(i===y)throw Error("Generator is already running");if(i===m){if("throw"===o)throw a;return{value:t,done:!0}}for(r.method=o,r.arg=a;;){var s=r.delegate;if(s){var c=j(s,r);if(c){if(c===g)continue;return c}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if(i===d)throw i=m,r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);i=y;var h=f(e,n,r);if("normal"===h.type){if(i=r.done?m:p,h.arg===g)continue;return{value:h.arg,done:r.done}}"throw"===h.type&&(i=m,r.method="throw",r.arg=h.arg)}}}function j(e,n){var r=n.method,i=e.iterator[r];if(i===t)return n.delegate=null,"throw"===r&&e.iterator.return&&(n.method="return",n.arg=t,j(e,n),"throw"===n.method)||"return"!==r&&(n.method="throw",n.arg=new TypeError("The iterator does not provide a '"+r+"' method")),g;var o=f(i,e.iterator,n.arg);if("throw"===o.type)return n.method="throw",n.arg=o.arg,n.delegate=null,g;var a=o.arg;return a?a.done?(n[e.resultName]=a.value,n.next=e.nextLoc,"return"!==n.method&&(n.method="next",n.arg=t),n.delegate=null,g):a:(n.method="throw",n.arg=new TypeError("iterator result is not an object"),n.delegate=null,g)}function B(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function P(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function T(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(B,this),this.reset(!0)}function C(e){if(e||""===e){var n=e[a];if(n)return n.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var i=-1,o=function n(){for(;++i<e.length;)if(r.call(e,i))return n.value=e[i],n.done=!1,n;return n.value=t,n.done=!0,n};return o.next=o}}throw new TypeError(typeof e+" is not iterable")}return b.prototype=w,i(k,"constructor",{value:w,configurable:!0}),i(w,"constructor",{value:b,configurable:!0}),b.displayName=u(w,c,"GeneratorFunction"),e.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===b||"GeneratorFunction"===(e.displayName||e.name))},e.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,w):(t.__proto__=w,u(t,c,"GeneratorFunction")),t.prototype=Object.create(k),t},e.awrap=function(t){return{__await:t}},L(S.prototype),u(S.prototype,s,(function(){return this})),e.AsyncIterator=S,e.async=function(t,n,r,i,o){void 0===o&&(o=Promise);var a=new S(l(t,n,r,i),o);return e.isGeneratorFunction(n)?a:a.next().then((function(t){return t.done?t.value:a.next()}))},L(k),u(k,c,"Generator"),u(k,a,(function(){return this})),u(k,"toString",(function(){return"[object Generator]"})),e.keys=function(t){var e=Object(t),n=[];for(var r in e)n.push(r);return n.reverse(),function t(){for(;n.length;){var r=n.pop();if(r in e)return t.value=r,t.done=!1,t}return t.done=!0,t}},e.values=C,T.prototype={constructor:T,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=t,this.done=!1,this.delegate=null,this.method="next",this.arg=t,this.tryEntries.forEach(P),!e)for(var n in this)"t"===n.charAt(0)&&r.call(this,n)&&!isNaN(+n.slice(1))&&(this[n]=t)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var n=this;function i(r,i){return s.type="throw",s.arg=e,n.next=r,i&&(n.method="next",n.arg=t),!!i}for(var o=this.tryEntries.length-1;o>=0;--o){var a=this.tryEntries[o],s=a.completion;if("root"===a.tryLoc)return i("end");if(a.tryLoc<=this.prev){var c=r.call(a,"catchLoc"),h=r.call(a,"finallyLoc");if(c&&h){if(this.prev<a.catchLoc)return i(a.catchLoc,!0);if(this.prev<a.finallyLoc)return i(a.finallyLoc)}else if(c){if(this.prev<a.catchLoc)return i(a.catchLoc,!0)}else{if(!h)throw Error("try statement without catch or finally");if(this.prev<a.finallyLoc)return i(a.finallyLoc)}}}},abrupt:function(t,e){for(var n=this.tryEntries.length-1;n>=0;--n){var i=this.tryEntries[n];if(i.tryLoc<=this.prev&&r.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var o=i;break}}o&&("break"===t||"continue"===t)&&o.tryLoc<=e&&e<=o.finallyLoc&&(o=null);var a=o?o.completion:{};return a.type=t,a.arg=e,o?(this.method="next",this.next=o.finallyLoc,g):this.complete(a)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),g},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.finallyLoc===t)return this.complete(n.completion,n.afterLoc),P(n),g}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.tryLoc===t){var r=n.completion;if("throw"===r.type){var i=r.arg;P(n)}return i}}throw Error("illegal catch attempt")},delegateYield:function(e,n,r){return this.delegate={iterator:C(e),resultName:n,nextLoc:r},"next"===this.method&&(this.arg=t),g}},e}function u(t,n){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null!=n){var r,i,o,a,s=[],c=!0,h=!1;try{if(o=(n=n.call(t)).next,0===e);else for(;!(c=(r=o.call(n)).done)&&(s.push(r.value),s.length!==e);c=!0);}catch(t){h=!0,i=t}finally{try{if(!c&&null!=n.return&&(a=n.return(),Object(a)!==a))return}finally{if(h)throw i}}return s}}(t,n)||function(t,n){if(t){if("string"==typeof t)return e(t,n);var r={}.toString.call(t).slice(8,-1);return"Object"===r&&t.constructor&&(r=t.constructor.name),"Map"===r||"Set"===r?Array.from(t):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?e(t,n):void 0}}(t,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function l(t){var e=function(t,e){if("object"!=typeof t||!t)return t;var n=t[Symbol.toPrimitive];if(void 0!==n){var r=n.call(t,e);if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return String(t)}(t,"string");return"symbol"==typeof e?e:e+""}function f(t){return f="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},f(t)}var d,p=new Uint8Array(16);function y(){if(!d&&!(d="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)))throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return d(p)}for(var m=[],g=0;g<256;++g)m.push((g+256).toString(16).slice(1));var v={randomUUID:"undefined"!=typeof crypto&&crypto.randomUUID&&crypto.randomUUID.bind(crypto)};function b(t,e,n){if(v.randomUUID&&!e&&!t)return v.randomUUID();var r=(t=t||{}).random||(t.rng||y)();return r[6]=15&r[6]|64,r[8]=63&r[8]|128,function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return m[t[e+0]]+m[t[e+1]]+m[t[e+2]]+m[t[e+3]]+"-"+m[t[e+4]]+m[t[e+5]]+"-"+m[t[e+6]]+m[t[e+7]]+"-"+m[t[e+8]]+m[t[e+9]]+"-"+m[t[e+10]]+m[t[e+11]]+m[t[e+12]]+m[t[e+13]]+m[t[e+14]]+m[t[e+15]]}(r)}var w={cipher:{},hash:{},keyexchange:{},mode:{},misc:{},codec:{},exception:{corrupt:function(t){this.toString=function(){return"CORRUPT: "+this.message},this.message=t},invalid:function(t){this.toString=function(){return"INVALID: "+this.message},this.message=t},bug:function(t){this.toString=function(){return"BUG: "+this.message},this.message=t},notReady:function(t){this.toString=function(){return"NOT READY: "+this.message},this.message=t}}};function A(t,e,n){if(4!==e.length)throw new w.exception.invalid("invalid aes block size");var r=t.b[n],i=e[0]^r[0],o=e[n?3:1]^r[1],a=e[2]^r[2];e=e[n?1:3]^r[3];var s,c,h,u,l=r.length/4-2,f=4,d=[0,0,0,0];t=(s=t.s[n])[0];var p=s[1],y=s[2],m=s[3],g=s[4];for(u=0;u<l;u++)s=t[i>>>24]^p[o>>16&255]^y[a>>8&255]^m[255&e]^r[f],c=t[o>>>24]^p[a>>16&255]^y[e>>8&255]^m[255&i]^r[f+1],h=t[a>>>24]^p[e>>16&255]^y[i>>8&255]^m[255&o]^r[f+2],e=t[e>>>24]^p[i>>16&255]^y[o>>8&255]^m[255&a]^r[f+3],f+=4,i=s,o=c,a=h;for(u=0;4>u;u++)d[n?3&-u:u]=g[i>>>24]<<24^g[o>>16&255]<<16^g[a>>8&255]<<8^g[255&e]^r[f++],s=i,i=o,o=a,a=e,e=s;return d}function E(t,e){var n,r,i,o=t.F,a=t.b,s=o[0],c=o[1],h=o[2],u=o[3],l=o[4],f=o[5],d=o[6],p=o[7];for(n=0;64>n;n++)16>n?r=e[n]:(r=e[n+1&15],i=e[n+14&15],r=e[15&n]=(r>>>7^r>>>18^r>>>3^r<<25^r<<14)+(i>>>17^i>>>19^i>>>10^i<<15^i<<13)+e[15&n]+e[n+9&15]|0),r=r+p+(l>>>6^l>>>11^l>>>25^l<<26^l<<21^l<<7)+(d^l&(f^d))+a[n],p=d,d=f,f=l,l=u+r|0,u=h,h=c,s=r+((c=s)&h^u&(c^h))+(c>>>2^c>>>13^c>>>22^c<<30^c<<19^c<<10)|0;o[0]=o[0]+s|0,o[1]=o[1]+c|0,o[2]=o[2]+h|0,o[3]=o[3]+u|0,o[4]=o[4]+l|0,o[5]=o[5]+f|0,o[6]=o[6]+d|0,o[7]=o[7]+p|0}function x(t,e){var n,r=w.random.K[t],i=[];for(n in r)r.hasOwnProperty(n)&&i.push(r[n]);for(n=0;n<i.length;n++)i[n](e)}function k(t,e){"undefined"!=typeof window&&window.performance&&"function"==typeof window.performance.now?t.addEntropy(window.performance.now(),e,"loadtime"):t.addEntropy((new Date).valueOf(),e,"loadtime")}function L(t){t.b=S(t).concat(S(t)),t.L=new w.cipher.aes(t.b)}function S(t){for(var e=0;4>e&&(t.h[e]=t.h[e]+1|0,!t.h[e]);e++);return t.L.encrypt(t.h)}function O(t,e){return function(){e.apply(t,arguments)}}w.cipher.aes=function(t){this.s[0][0][0]||this.O();var e,n,r,i,o=this.s[0][4],a=this.s[1],s=1;if(4!==(e=t.length)&&6!==e&&8!==e)throw new w.exception.invalid("invalid aes key size");for(this.b=[r=t.slice(0),i=[]],t=e;t<4*e+28;t++)n=r[t-1],(0==t%e||8===e&&4==t%e)&&(n=o[n>>>24]<<24^o[n>>16&255]<<16^o[n>>8&255]<<8^o[255&n],0==t%e&&(n=n<<8^n>>>24^s<<24,s=s<<1^283*(s>>7))),r[t]=r[t-e]^n;for(e=0;t;e++,t--)n=r[3&e?t:t-4],i[e]=4>=t||4>e?n:a[0][o[n>>>24]]^a[1][o[n>>16&255]]^a[2][o[n>>8&255]]^a[3][o[255&n]]},w.cipher.aes.prototype={encrypt:function(t){return A(this,t,0)},decrypt:function(t){return A(this,t,1)},s:[[[],[],[],[],[]],[[],[],[],[],[]]],O:function(){var t,e,n,r,i,o,a,s=this.s[0],c=this.s[1],h=s[4],u=c[4],l=[],f=[];for(t=0;256>t;t++)f[(l[t]=t<<1^283*(t>>7))^t]=t;for(e=n=0;!h[e];e^=r||1,n=f[n]||1)for(o=(o=n^n<<1^n<<2^n<<3^n<<4)>>8^255&o^99,h[e]=o,u[o]=e,a=16843009*(i=l[t=l[r=l[e]]])^65537*t^257*r^16843008*e,i=257*l[o]^16843008*o,t=0;4>t;t++)s[t][e]=i=i<<24^i>>>8,c[t][o]=a=a<<24^a>>>8;for(t=0;5>t;t++)s[t]=s[t].slice(0),c[t]=c[t].slice(0)}},w.bitArray={bitSlice:function(t,e,n){return t=w.bitArray.$(t.slice(e/32),32-(31&e)).slice(1),void 0===n?t:w.bitArray.clamp(t,n-e)},extract:function(t,e,n){var r=Math.floor(-e-n&31);return(-32&(e+n-1^e)?t[e/32|0]<<32-r^t[e/32+1|0]>>>r:t[e/32|0]>>>r)&(1<<n)-1},concat:function(t,e){if(0===t.length||0===e.length)return t.concat(e);var n=t[t.length-1],r=w.bitArray.getPartial(n);return 32===r?t.concat(e):w.bitArray.$(e,r,0|n,t.slice(0,t.length-1))},bitLength:function(t){var e=t.length;return 0===e?0:32*(e-1)+w.bitArray.getPartial(t[e-1])},clamp:function(t,e){if(32*t.length<e)return t;var n=(t=t.slice(0,Math.ceil(e/32))).length;return e&=31,0<n&&e&&(t[n-1]=w.bitArray.partial(e,t[n-1]&2147483648>>e-1,1)),t},partial:function(t,e,n){return 32===t?e:(n?0|e:e<<32-t)+1099511627776*t},getPartial:function(t){return Math.round(t/1099511627776)||32},equal:function(t,e){if(w.bitArray.bitLength(t)!==w.bitArray.bitLength(e))return!1;var n,r=0;for(n=0;n<t.length;n++)r|=t[n]^e[n];return 0===r},$:function(t,e,n,r){var i;for(i=0,void 0===r&&(r=[]);32<=e;e-=32)r.push(n),n=0;if(0===e)return r.concat(t);for(i=0;i<t.length;i++)r.push(n|t[i]>>>e),n=t[i]<<32-e;return i=t.length?t[t.length-1]:0,t=w.bitArray.getPartial(i),r.push(w.bitArray.partial(e+t&31,32<e+t?n:r.pop(),1)),r},i:function(t,e){return[t[0]^e[0],t[1]^e[1],t[2]^e[2],t[3]^e[3]]},byteswapM:function(t){var e,n;for(e=0;e<t.length;++e)n=t[e],t[e]=n>>>24|n>>>8&65280|(65280&n)<<8|n<<24;return t}},w.codec.utf8String={fromBits:function(t){var e,n,r="",i=w.bitArray.bitLength(t);for(e=0;e<i/8;e++)!(3&e)&&(n=t[e/4]),r+=String.fromCharCode(n>>>24),n<<=8;return decodeURIComponent(escape(r))},toBits:function(t){t=unescape(encodeURIComponent(t));var e,n=[],r=0;for(e=0;e<t.length;e++)r=r<<8|t.charCodeAt(e),!(3&~e)&&(n.push(r),r=0);return 3&e&&n.push(w.bitArray.partial(8*(3&e),r)),n}},w.codec.hex={fromBits:function(t){var e,n="";for(e=0;e<t.length;e++)n+=(0xf00000000000+(0|t[e])).toString(16).substr(4);return n.substr(0,w.bitArray.bitLength(t)/4)},toBits:function(t){var e,n,r=[];for(n=(t=t.replace(/\s|0x/g,"")).length,t+="00000000",e=0;e<t.length;e+=8)r.push(0^parseInt(t.substr(e,8),16));return w.bitArray.clamp(r,4*n)}},w.codec.base32={B:"ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",X:"0123456789ABCDEFGHIJKLMNOPQRSTUV",BITS:32,BASE:5,REMAINING:27,fromBits:function(t,e,n){var r=w.codec.base32.BASE,i=w.codec.base32.REMAINING,o="",a=0,s=w.codec.base32.B,c=0,h=w.bitArray.bitLength(t);for(n&&(s=w.codec.base32.X),n=0;o.length*r<h;)o+=s.charAt((c^t[n]>>>a)>>>i),a<r?(c=t[n]<<r-a,a+=i,n++):(c<<=r,a-=r);for(;7&o.length&&!e;)o+="=";return o},toBits:function(t,e){t=t.replace(/\s|=/g,"").toUpperCase();var n,r,i=w.codec.base32.BITS,o=w.codec.base32.BASE,a=w.codec.base32.REMAINING,s=[],c=0,h=w.codec.base32.B,u=0,l="base32";for(e&&(h=w.codec.base32.X,l="base32hex"),n=0;n<t.length;n++){if(0>(r=h.indexOf(t.charAt(n)))){if(!e)try{return w.codec.base32hex.toBits(t)}catch(t){}throw new w.exception.invalid("this isn't "+l+"!")}c>a?(c-=a,s.push(u^r>>>c),u=r<<i-c):u^=r<<i-(c+=o)}return 56&c&&s.push(w.bitArray.partial(56&c,u,1)),s}},w.codec.base32hex={fromBits:function(t,e){return w.codec.base32.fromBits(t,e,1)},toBits:function(t){return w.codec.base32.toBits(t,1)}},w.codec.base64={B:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",fromBits:function(t,e,n){var r="",i=0,o=w.codec.base64.B,a=0,s=w.bitArray.bitLength(t);for(n&&(o=o.substr(0,62)+"-_"),n=0;6*r.length<s;)r+=o.charAt((a^t[n]>>>i)>>>26),6>i?(a=t[n]<<6-i,i+=26,n++):(a<<=6,i-=6);for(;3&r.length&&!e;)r+="=";return r},toBits:function(t,e){t=t.replace(/\s|=/g,"");var n,r,i=[],o=0,a=w.codec.base64.B,s=0;for(e&&(a=a.substr(0,62)+"-_"),n=0;n<t.length;n++){if(0>(r=a.indexOf(t.charAt(n))))throw new w.exception.invalid("this isn't base64!");26<o?(o-=26,i.push(s^r>>>o),s=r<<32-o):s^=r<<32-(o+=6)}return 56&o&&i.push(w.bitArray.partial(56&o,s,1)),i}},w.codec.base64url={fromBits:function(t){return w.codec.base64.fromBits(t,1,1)},toBits:function(t){return w.codec.base64.toBits(t,1)}},w.hash.sha256=function(t){this.b[0]||this.O(),t?(this.F=t.F.slice(0),this.A=t.A.slice(0),this.l=t.l):this.reset()},w.hash.sha256.hash=function(t){return(new w.hash.sha256).update(t).finalize()},w.hash.sha256.prototype={blockSize:512,reset:function(){return this.F=this.Y.slice(0),this.A=[],this.l=0,this},update:function(t){"string"==typeof t&&(t=w.codec.utf8String.toBits(t));var e,n=this.A=w.bitArray.concat(this.A,t);if(e=this.l,9007199254740991<(t=this.l=e+w.bitArray.bitLength(t)))throw new w.exception.invalid("Cannot hash more than 2^53 - 1 bits");if("undefined"!=typeof Uint32Array){var r=new Uint32Array(n),i=0;for(e=512+e-(512+e&511);e<=t;e+=512)E(this,r.subarray(16*i,16*(i+1))),i+=1;n.splice(0,16*i)}else for(e=512+e-(512+e&511);e<=t;e+=512)E(this,n.splice(0,16));return this},finalize:function(){var t,e=this.A,n=this.F;for(t=(e=w.bitArray.concat(e,[w.bitArray.partial(1,1)])).length+2;15&t;t++)e.push(0);for(e.push(Math.floor(this.l/4294967296)),e.push(0|this.l);e.length;)E(this,e.splice(0,16));return this.reset(),n},Y:[],b:[],O:function(){function t(t){return 4294967296*(t-Math.floor(t))|0}for(var e,n,r=0,i=2;64>r;i++){for(n=!0,e=2;e*e<=i;e++)if(0==i%e){n=!1;break}n&&(8>r&&(this.Y[r]=t(Math.pow(i,.5))),this.b[r]=t(Math.pow(i,1/3)),r++)}}},w.mode.ccm={name:"ccm",G:[],listenProgress:function(t){w.mode.ccm.G.push(t)},unListenProgress:function(t){-1<(t=w.mode.ccm.G.indexOf(t))&&w.mode.ccm.G.splice(t,1)},fa:function(t){var e,n=w.mode.ccm.G.slice();for(e=0;e<n.length;e+=1)n[e](t)},encrypt:function(t,e,n,r,i){var o,a=e.slice(0),s=w.bitArray,c=s.bitLength(n)/8,h=s.bitLength(a)/8;if(i=i||64,r=r||[],7>c)throw new w.exception.invalid("ccm: iv must be at least 7 bytes");for(o=2;4>o&&h>>>8*o;o++);return o<15-c&&(o=15-c),n=s.clamp(n,8*(15-o)),e=w.mode.ccm.V(t,e,n,r,i,o),a=w.mode.ccm.C(t,a,n,e,i,o),s.concat(a.data,a.tag)},decrypt:function(t,e,n,r,i){i=i||64,r=r||[];var o=w.bitArray,a=o.bitLength(n)/8,s=o.bitLength(e),c=o.clamp(e,s-i),h=o.bitSlice(e,s-i);if(s=(s-i)/8,7>a)throw new w.exception.invalid("ccm: iv must be at least 7 bytes");for(e=2;4>e&&s>>>8*e;e++);if(e<15-a&&(e=15-a),n=o.clamp(n,8*(15-e)),c=w.mode.ccm.C(t,c,n,h,i,e),t=w.mode.ccm.V(t,c.data,n,r,i,e),!o.equal(c.tag,t))throw new w.exception.corrupt("ccm: tag doesn't match");return c.data},na:function(t,e,n,r,i,o){var a=[],s=w.bitArray,c=s.i;if(r=[s.partial(8,(e.length?64:0)|r-2<<2|o-1)],(r=s.concat(r,n))[3]|=i,r=t.encrypt(r),e.length)for(65279>=(n=s.bitLength(e)/8)?a=[s.partial(16,n)]:4294967295>=n&&(a=s.concat([s.partial(16,65534)],[n])),a=s.concat(a,e),e=0;e<a.length;e+=4)r=t.encrypt(c(r,a.slice(e,e+4).concat([0,0,0])));return r},V:function(t,e,n,r,i,o){var a=w.bitArray,s=a.i;if((i/=8)%2||4>i||16<i)throw new w.exception.invalid("ccm: invalid tag length");if(4294967295<r.length||4294967295<e.length)throw new w.exception.bug("ccm: can't deal with 4GiB or more data");for(n=w.mode.ccm.na(t,r,n,i,a.bitLength(e)/8,o),r=0;r<e.length;r+=4)n=t.encrypt(s(n,e.slice(r,r+4).concat([0,0,0])));return a.clamp(n,8*i)},C:function(t,e,n,r,i,o){var a,s=w.bitArray;a=s.i;var c=e.length,h=s.bitLength(e),u=c/50,l=u;if(n=s.concat([s.partial(8,o-1)],n).concat([0,0,0]).slice(0,4),r=s.bitSlice(a(r,t.encrypt(n)),0,i),!c)return{tag:r,data:[]};for(a=0;a<c;a+=4)a>u&&(w.mode.ccm.fa(a/c),u+=l),n[3]++,i=t.encrypt(n),e[a]^=i[0],e[a+1]^=i[1],e[a+2]^=i[2],e[a+3]^=i[3];return{tag:r,data:s.clamp(e,h)}}},w.mode.ocb2={name:"ocb2",encrypt:function(t,e,n,r,i,o){if(128!==w.bitArray.bitLength(n))throw new w.exception.invalid("ocb iv must be 128 bits");var a,s=w.mode.ocb2.S,c=w.bitArray,h=c.i,u=[0,0,0,0];n=s(t.encrypt(n));var l,f=[];for(r=r||[],i=i||64,a=0;a+4<e.length;a+=4)u=h(u,l=e.slice(a,a+4)),f=f.concat(h(n,t.encrypt(h(n,l)))),n=s(n);return l=e.slice(a),e=c.bitLength(l),a=t.encrypt(h(n,[0,0,0,e])),l=c.clamp(h(l.concat([0,0,0]),a),e),u=h(u,h(l.concat([0,0,0]),a)),u=t.encrypt(h(u,h(n,s(n)))),r.length&&(u=h(u,o?r:w.mode.ocb2.pmac(t,r))),f.concat(c.concat(l,c.clamp(u,i)))},decrypt:function(t,e,n,r,i,o){if(128!==w.bitArray.bitLength(n))throw new w.exception.invalid("ocb iv must be 128 bits");i=i||64;var a,s,c=w.mode.ocb2.S,h=w.bitArray,u=h.i,l=[0,0,0,0],f=c(t.encrypt(n)),d=w.bitArray.bitLength(e)-i,p=[];for(r=r||[],n=0;n+4<d/32;n+=4)a=u(f,t.decrypt(u(f,e.slice(n,n+4)))),l=u(l,a),p=p.concat(a),f=c(f);if(s=d-32*n,a=t.encrypt(u(f,[0,0,0,s])),a=u(a,h.clamp(e.slice(n),s).concat([0,0,0])),l=u(l,a),l=t.encrypt(u(l,u(f,c(f)))),r.length&&(l=u(l,o?r:w.mode.ocb2.pmac(t,r))),!h.equal(h.clamp(l,i),h.bitSlice(e,d)))throw new w.exception.corrupt("ocb: tag doesn't match");return p.concat(h.clamp(a,s))},pmac:function(t,e){var n,r=w.mode.ocb2.S,i=w.bitArray,o=i.i,a=[0,0,0,0],s=o(s=t.encrypt([0,0,0,0]),r(r(s)));for(n=0;n+4<e.length;n+=4)s=r(s),a=o(a,t.encrypt(o(s,e.slice(n,n+4))));return n=e.slice(n),128>i.bitLength(n)&&(s=o(s,r(s)),n=i.concat(n,[-2147483648,0,0,0])),a=o(a,n),t.encrypt(o(r(o(s,r(s))),a))},S:function(t){return[t[0]<<1^t[1]>>>31,t[1]<<1^t[2]>>>31,t[2]<<1^t[3]>>>31,t[3]<<1^135*(t[0]>>>31)]}},w.mode.gcm={name:"gcm",encrypt:function(t,e,n,r,i){var o=e.slice(0);return e=w.bitArray,r=r||[],t=w.mode.gcm.C(!0,t,o,r,n,i||128),e.concat(t.data,t.tag)},decrypt:function(t,e,n,r,i){var o=e.slice(0),a=w.bitArray,s=a.bitLength(o);if(r=r||[],(i=i||128)<=s?(e=a.bitSlice(o,s-i),o=a.bitSlice(o,0,s-i)):(e=o,o=[]),t=w.mode.gcm.C(!1,t,o,r,n,i),!a.equal(t.tag,e))throw new w.exception.corrupt("gcm: tag doesn't match");return t.data},ka:function(t,e){var n,r,i,o,a,s=w.bitArray.i;for(i=[0,0,0,0],o=e.slice(0),n=0;128>n;n++){for((r=!!(t[Math.floor(n/32)]&1<<31-n%32))&&(i=s(i,o)),a=!!(1&o[3]),r=3;0<r;r--)o[r]=o[r]>>>1|(1&o[r-1])<<31;o[0]>>>=1,a&&(o[0]^=-520093696)}return i},j:function(t,e,n){var r,i=n.length;for(e=e.slice(0),r=0;r<i;r+=4)e[0]^=4294967295&n[r],e[1]^=4294967295&n[r+1],e[2]^=4294967295&n[r+2],e[3]^=4294967295&n[r+3],e=w.mode.gcm.ka(e,t);return e},C:function(t,e,n,r,i,o){var a,s,c,h,u,l,f,d,p=w.bitArray;for(l=n.length,f=p.bitLength(n),d=p.bitLength(r),s=p.bitLength(i),a=e.encrypt([0,0,0,0]),96===s?(i=i.slice(0),i=p.concat(i,[1])):(i=w.mode.gcm.j(a,[0,0,0,0],i),i=w.mode.gcm.j(a,i,[0,0,Math.floor(s/4294967296),4294967295&s])),s=w.mode.gcm.j(a,[0,0,0,0],r),u=i.slice(0),r=s.slice(0),t||(r=w.mode.gcm.j(a,s,n)),h=0;h<l;h+=4)u[3]++,c=e.encrypt(u),n[h]^=c[0],n[h+1]^=c[1],n[h+2]^=c[2],n[h+3]^=c[3];return n=p.clamp(n,f),t&&(r=w.mode.gcm.j(a,s,n)),t=[Math.floor(d/4294967296),4294967295&d,Math.floor(f/4294967296),4294967295&f],r=w.mode.gcm.j(a,r,t),c=e.encrypt(i),r[0]^=c[0],r[1]^=c[1],r[2]^=c[2],r[3]^=c[3],{tag:p.bitSlice(r,0,o),data:n}}},w.misc.hmac=function(t,e){this.W=e=e||w.hash.sha256;var n,r=[[],[]],i=e.prototype.blockSize/32;for(this.w=[new e,new e],t.length>i&&(t=e.hash(t)),n=0;n<i;n++)r[0][n]=909522486^t[n],r[1][n]=1549556828^t[n];this.w[0].update(r[0]),this.w[1].update(r[1]),this.R=new e(this.w[0])},w.misc.hmac.prototype.encrypt=w.misc.hmac.prototype.mac=function(t){if(this.aa)throw new w.exception.invalid("encrypt on already updated hmac called!");return this.update(t),this.digest(t)},w.misc.hmac.prototype.reset=function(){this.R=new this.W(this.w[0]),this.aa=!1},w.misc.hmac.prototype.update=function(t){this.aa=!0,this.R.update(t)},w.misc.hmac.prototype.digest=function(){var t=this.R.finalize();return t=new this.W(this.w[1]).update(t).finalize(),this.reset(),t},w.misc.pbkdf2=function(t,e,n,r,i){if(n=n||1e4,0>r||0>n)throw new w.exception.invalid("invalid params to pbkdf2");"string"==typeof t&&(t=w.codec.utf8String.toBits(t)),"string"==typeof e&&(e=w.codec.utf8String.toBits(e)),t=new(i=i||w.misc.hmac)(t);var o,a,s,c,h=[],u=w.bitArray;for(c=1;32*h.length<(r||1);c++){for(i=o=t.encrypt(u.concat(e,[c])),a=1;a<n;a++)for(o=t.encrypt(o),s=0;s<o.length;s++)i[s]^=o[s];h=h.concat(i)}return r&&(h=u.clamp(h,r)),h},w.prng=function(t){this.c=[new w.hash.sha256],this.m=[0],this.P=0,this.H={},this.N=0,this.U={},this.Z=this.f=this.o=this.ha=0,this.b=[0,0,0,0,0,0,0,0],this.h=[0,0,0,0],this.L=void 0,this.M=t,this.D=!1,this.K={progress:{},seeded:{}},this.u=this.ga=0,this.I=1,this.J=2,this.ca=65536,this.T=[0,48,64,96,128,192,256,384,512,768,1024],this.da=3e4,this.ba=80},w.prng.prototype={randomWords:function(t,e){var n,r,i=[];if((n=this.isReady(e))===this.u)throw new w.exception.notReady("generator isn't seeded");if(n&this.J){n=!(n&this.I),r=[];var o,a=0;for(this.Z=r[0]=(new Date).valueOf()+this.da,o=0;16>o;o++)r.push(4294967296*Math.random()|0);for(o=0;o<this.c.length&&(r=r.concat(this.c[o].finalize()),a+=this.m[o],this.m[o]=0,n||!(this.P&1<<o));o++);for(this.P>=1<<this.c.length&&(this.c.push(new w.hash.sha256),this.m.push(0)),this.f-=a,a>this.o&&(this.o=a),this.P++,this.b=w.hash.sha256.hash(this.b.concat(r)),this.L=new w.cipher.aes(this.b),n=0;4>n&&(this.h[n]=this.h[n]+1|0,!this.h[n]);n++);}for(n=0;n<t;n+=4)0==(n+1)%this.ca&&L(this),r=S(this),i.push(r[0],r[1],r[2],r[3]);return L(this),i.slice(0,t)},setDefaultParanoia:function(t,e){if(0===t&&"Setting paranoia=0 will ruin your security; use it only for testing"!==e)throw new w.exception.invalid("Setting paranoia=0 will ruin your security; use it only for testing");this.M=t},addEntropy:function(t,e,n){n=n||"user";var r,i,o=(new Date).valueOf(),a=this.H[n],s=this.isReady(),c=0;switch(void 0===(r=this.U[n])&&(r=this.U[n]=this.ha++),void 0===a&&(a=this.H[n]=0),this.H[n]=(this.H[n]+1)%this.c.length,f(t)){case"number":void 0===e&&(e=1),this.c[a].update([r,this.N++,1,e,o,1,0|t]);break;case"object":if("[object Uint32Array]"===(n=Object.prototype.toString.call(t))){for(i=[],n=0;n<t.length;n++)i.push(t[n]);t=i}else for("[object Array]"!==n&&(c=1),n=0;n<t.length&&!c;n++)"number"!=typeof t[n]&&(c=1);if(!c){if(void 0===e)for(n=e=0;n<t.length;n++)for(i=t[n];0<i;)e++,i>>>=1;this.c[a].update([r,this.N++,2,e,o,t.length].concat(t))}break;case"string":void 0===e&&(e=t.length),this.c[a].update([r,this.N++,3,e,o,t.length]),this.c[a].update(t);break;default:c=1}if(c)throw new w.exception.bug("random: addEntropy only supports number, array of numbers or string");this.m[a]+=e,this.f+=e,s===this.u&&(this.isReady()!==this.u&&x("seeded",Math.max(this.o,this.f)),x("progress",this.getProgress()))},isReady:function(t){return t=this.T[void 0!==t?t:this.M],this.o&&this.o>=t?this.m[0]>this.ba&&(new Date).valueOf()>this.Z?this.J|this.I:this.I:this.f>=t?this.J|this.u:this.u},getProgress:function(t){return t=this.T[t||this.M],this.o>=t||this.f>t?1:this.f/t},startCollectors:function(){if(!this.D){if(this.a={loadTimeCollector:O(this,this.ma),mouseCollector:O(this,this.oa),keyboardCollector:O(this,this.la),accelerometerCollector:O(this,this.ea),touchCollector:O(this,this.qa)},window.addEventListener)window.addEventListener("load",this.a.loadTimeCollector,!1),window.addEventListener("mousemove",this.a.mouseCollector,!1),window.addEventListener("keypress",this.a.keyboardCollector,!1),window.addEventListener("devicemotion",this.a.accelerometerCollector,!1),window.addEventListener("touchmove",this.a.touchCollector,!1);else{if(!document.attachEvent)throw new w.exception.bug("can't attach event");document.attachEvent("onload",this.a.loadTimeCollector),document.attachEvent("onmousemove",this.a.mouseCollector),document.attachEvent("keypress",this.a.keyboardCollector)}this.D=!0}},stopCollectors:function(){this.D&&(window.removeEventListener?(window.removeEventListener("load",this.a.loadTimeCollector,!1),window.removeEventListener("mousemove",this.a.mouseCollector,!1),window.removeEventListener("keypress",this.a.keyboardCollector,!1),window.removeEventListener("devicemotion",this.a.accelerometerCollector,!1),window.removeEventListener("touchmove",this.a.touchCollector,!1)):document.detachEvent&&(document.detachEvent("onload",this.a.loadTimeCollector),document.detachEvent("onmousemove",this.a.mouseCollector),document.detachEvent("keypress",this.a.keyboardCollector)),this.D=!1)},addEventListener:function(t,e){this.K[t][this.ga++]=e},removeEventListener:function(t,e){var n,r,i=this.K[t],o=[];for(r in i)i.hasOwnProperty(r)&&i[r]===e&&o.push(r);for(n=0;n<o.length;n++)delete i[r=o[n]]},la:function(){k(this,1)},oa:function(t){var e,n;try{e=t.x||t.clientX||t.offsetX||0,n=t.y||t.clientY||t.offsetY||0}catch(t){n=e=0}0!=e&&0!=n&&this.addEntropy([e,n],2,"mouse"),k(this,0)},qa:function(t){t=t.touches[0]||t.changedTouches[0],this.addEntropy([t.pageX||t.clientX,t.pageY||t.clientY],1,"touch"),k(this,0)},ma:function(){k(this,2)},ea:function(t){if(t=t.accelerationIncludingGravity.x||t.accelerationIncludingGravity.y||t.accelerationIncludingGravity.z,window.orientation){var e=window.orientation;"number"==typeof e&&this.addEntropy(e,1,"accelerometer")}t&&this.addEntropy(t,2,"accelerometer"),k(this,0)}},w.random=new w.prng(6);t:try{var j,B,P,T;if(T="undefined"!=typeof module&&module.exports){var C;try{C=__webpack_require__(370)}catch(t){C=null}T=B=C}if(T&&B.randomBytes)j=B.randomBytes(128),j=new Uint32Array(new Uint8Array(j).buffer),w.random.addEntropy(j,1024,"crypto['randomBytes']");else if("undefined"!=typeof window&&"undefined"!=typeof Uint32Array){if(P=new Uint32Array(32),window.crypto&&window.crypto.getRandomValues)window.crypto.getRandomValues(P);else{if(!window.msCrypto||!window.msCrypto.getRandomValues)break t;window.msCrypto.getRandomValues(P)}w.random.addEntropy(P,1024,"crypto['getRandomValues']")}}catch(t){"undefined"!=typeof window&&window.console&&(console.log("There was an error collecting entropy from the browser:"),console.log(t))}w.json={defaults:{v:1,iter:1e4,ks:128,ts:64,mode:"ccm",adata:"",cipher:"aes"},ja:function(t,e,n,r){n=n||{},r=r||{};var i,o=w.json,a=o.g({iv:w.random.randomWords(4,0)},o.defaults);if(o.g(a,n),n=a.adata,"string"==typeof a.salt&&(a.salt=w.codec.base64.toBits(a.salt)),"string"==typeof a.iv&&(a.iv=w.codec.base64.toBits(a.iv)),!w.mode[a.mode]||!w.cipher[a.cipher]||"string"==typeof t&&100>=a.iter||64!==a.ts&&96!==a.ts&&128!==a.ts||128!==a.ks&&192!==a.ks&&256!==a.ks||2>a.iv.length||4<a.iv.length)throw new w.exception.invalid("json encrypt: invalid parameters");return"string"==typeof t?(t=(i=w.misc.cachedPbkdf2(t,a)).key.slice(0,a.ks/32),a.salt=i.salt):w.ecc&&t instanceof w.ecc.elGamal.publicKey&&(i=t.kem(),a.kemtag=i.tag,t=i.key.slice(0,a.ks/32)),"string"==typeof e&&(e=w.codec.utf8String.toBits(e)),"string"==typeof n&&(a.adata=n=w.codec.utf8String.toBits(n)),i=new w.cipher[a.cipher](t),o.g(r,a),r.key=t,a.ct="ccm"===a.mode&&w.arrayBuffer&&w.arrayBuffer.ccm&&e instanceof ArrayBuffer?w.arrayBuffer.ccm.encrypt(i,e,a.iv,n,a.ts):w.mode[a.mode].encrypt(i,e,a.iv,n,a.ts),a},encrypt:function(t,e,n,r){var i=w.json,o=i.ja.apply(i,arguments);return i.encode(o)},ia:function(t,e,n,r){n=n||{},r=r||{};var i,o,a=w.json;if(i=(e=a.g(a.g(a.g({},a.defaults),e),n,!0)).adata,"string"==typeof e.salt&&(e.salt=w.codec.base64.toBits(e.salt)),"string"==typeof e.iv&&(e.iv=w.codec.base64.toBits(e.iv)),!w.mode[e.mode]||!w.cipher[e.cipher]||"string"==typeof t&&100>=e.iter||64!==e.ts&&96!==e.ts&&128!==e.ts||128!==e.ks&&192!==e.ks&&256!==e.ks||!e.iv||2>e.iv.length||4<e.iv.length)throw new w.exception.invalid("json decrypt: invalid parameters");return"string"==typeof t?(t=(o=w.misc.cachedPbkdf2(t,e)).key.slice(0,e.ks/32),e.salt=o.salt):w.ecc&&t instanceof w.ecc.elGamal.secretKey&&(t=t.unkem(w.codec.base64.toBits(e.kemtag)).slice(0,e.ks/32)),"string"==typeof i&&(i=w.codec.utf8String.toBits(i)),o=new w.cipher[e.cipher](t),i="ccm"===e.mode&&w.arrayBuffer&&w.arrayBuffer.ccm&&e.ct instanceof ArrayBuffer?w.arrayBuffer.ccm.decrypt(o,e.ct,e.iv,e.tag,i,e.ts):w.mode[e.mode].decrypt(o,e.ct,e.iv,i,e.ts),a.g(r,e),r.key=t,1===n.raw?i:w.codec.utf8String.fromBits(i)},decrypt:function(t,e,n,r){var i=w.json;return i.ia(t,i.decode(e),n,r)},encode:function(t){var e,n="{",r="";for(e in t)if(t.hasOwnProperty(e)){if(!e.match(/^[a-z0-9]+$/i))throw new w.exception.invalid("json encode: invalid property name");switch(n+=r+'"'+e+'":',r=",",f(t[e])){case"number":case"boolean":n+=t[e];break;case"string":n+='"'+escape(t[e])+'"';break;case"object":n+='"'+w.codec.base64.fromBits(t[e],0)+'"';break;default:throw new w.exception.bug("json encode: unsupported type")}}return n+"}"},decode:function(t){if(!(t=t.replace(/\s/g,"")).match(/^\{.*\}$/))throw new w.exception.invalid("json decode: this isn't json!");t=t.replace(/^\{|\}$/g,"").split(/,/);var e,n,r={};for(e=0;e<t.length;e++){if(!(n=t[e].match(/^\s*(?:(["']?)([a-z][a-z0-9]*)\1)\s*:\s*(?:(-?\d+)|"([a-z0-9+\/%*_.@=\-]*)"|(true|false))$/i)))throw new w.exception.invalid("json decode: this isn't json!");null!=n[3]?r[n[2]]=parseInt(n[3],10):null!=n[4]?r[n[2]]=n[2].match(/^(ct|adata|salt|iv)$/)?w.codec.base64.toBits(n[4]):unescape(n[4]):null!=n[5]&&(r[n[2]]="true"===n[5])}return r},g:function(t,e,n){if(void 0===t&&(t={}),void 0===e)return t;for(var r in e)if(e.hasOwnProperty(r)){if(n&&void 0!==t[r]&&t[r]!==e[r])throw new w.exception.invalid("required parameter overridden");t[r]=e[r]}return t},sa:function(t,e){var n,r={};for(n in t)t.hasOwnProperty(n)&&t[n]!==e[n]&&(r[n]=t[n]);return r},ra:function(t,e){var n,r={};for(n=0;n<e.length;n++)void 0!==t[e[n]]&&(r[e[n]]=t[e[n]]);return r}},w.encrypt=w.json.encrypt,w.decrypt=w.json.decrypt,w.misc.pa={},w.misc.cachedPbkdf2=function(t,e){var n,r=w.misc.pa;return n=(e=e||{}).iter||1e3,(n=(r=r[t]=r[t]||{})[n]=r[n]||{firstSalt:e.salt&&e.salt.length?e.salt.slice(0):w.random.randomWords(2,0)})[r=void 0===e.salt?n.firstSalt:e.salt]=n[r]||w.misc.pbkdf2(t,r,e.iter),{key:n[r].slice(0),salt:r.slice(0)}};var I="https://api.pendo.aft.amazon.dev/staging/lookuphash",U="ptt4UGpW6Y1z9RCuMFqwa4dy6FBovtsjJG1xpf7g",_=function(){return i((function t(){var e,n=this,i=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{apikey:""};!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),o(this,"initialize",function(){var t=r(h().mark((function t(e){var r,i=this;return h().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(a(this,n),this.container&&this.container.performance){t.next=3;break}return t.abrupt("return");case 3:return this.collectPerformanceMetrics&&(this.observer=new PerformanceObserver(function(t){var e=this;a(this,i),t.getEntries().forEach(function(t){a(this,e),this.entryMap[t.entryType]&&this.entryMap[t.entryType](t)}.bind(this))}.bind(this)),this.container.performance.getEntriesByType("paint").forEach(function(t){a(this,i),this.processPaintTiming(t)}.bind(this)),this.observer.observe({entryTypes:this.entryTypes})),r=e.account&&e.account.id,t.next=7,this.getVisitor(e.visitor,r);case 7:e.visitor=t.sent,this.dev?this.log("Initialize",e):this.engine.initialize(e);case 9:case"end":return t.stop()}}),t,this)})));return function(e){return t.apply(this,arguments)}}().bind(this)),o(this,"updateOptions",function(){var t=r(h().mark((function t(e){var r;return h().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(a(this,n),r=e.account&&e.account.id||this.engine&&this.engine.getAccountId(),!e.visitor){t.next=6;break}return t.next=5,this.getVisitor(e.visitor,r);case 5:e.visitor=t.sent;case 6:this.dev?this.log("UpdateOptions",e):this.engine.updateOptions(e);case 7:case"end":return t.stop()}}),t,this)})));return function(e){return t.apply(this,arguments)}}().bind(this)),o(this,"getVisitor",function(){var t=r(h().mark((function t(e,r){var i,o,s,l,f,d,p=this;return h().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(a(this,n),o=localStorage.getItem("AlchemyAnalytics"),e&&this.dev&&(e=c({_id:e.id},e)),o&&(s=JSON.parse(o),i=s.id.length<36?b():s.id),!e){t.next=25;break}if(i=this.hash(e.id),l={id:i,language:e.language||this.language},r&&Object.entries(e).forEach(function(t){var e=u(t,2),n=e[0],i=e[1];a(this,p),"id"!==n&&"language"!==n&&(l["".concat(r,"_").concat(n)]=i)}.bind(this)),t.prev=8,!U){t.next=16;break}return t.next=12,fetch(I,{method:"PUT",headers:{"x-api-key":U,"Content-Type":"application/json"},body:JSON.stringify({identifier:e.id,hash:i})});case 12:if(f=t.sent,console.log("Response: "+this.sanitizeData(f)),f.ok){t.next=16;break}throw new Error("Network response was not ok");case 16:t.next=21;break;case 18:t.prev=18,t.t0=t.catch(8),console.error("Error:",t.t0);case 21:return localStorage.setItem("AlchemyAnalytics",JSON.stringify({id:i})),t.abrupt("return",l);case 25:return d="alchemy-".concat(i),localStorage.setItem("AlchemyAnalytics",JSON.stringify({id:d})),t.abrupt("return",{id:d,language:this.language});case 28:case"end":return t.stop()}}),t,this,[[8,18]])})));return function(e,n){return t.apply(this,arguments)}}().bind(this)),o(this,"processNavigationTiming",function(t){var e=this;a(this,n),setTimeout(function(){a(this,e),this.queue.push({name:"TTI",data:{time:t.domInteractive}}),this.queue.push({name:"download-time",data:{time:t.responseEnd-t.fetchStart}}),this.queue.push({name:"load-time",data:{time:t.loadEventEnd-t.loadEventStart}}),this.queue.push({name:"dom-complete",data:{time:t.domComplete}}),this.send()}.bind(this),0)}.bind(this)),o(this,"processResourceTiming",function(t){var e=this;a(this,n);var r=t,i={name:r.name,initiatorType:r.initiatorType,duration:r.duration};this.resourceFilters.some(function(t){return a(this,e),i.name.includes(t)}.bind(this))||setTimeout(function(){a(this,e),this.queue.push({name:"resource",data:{type:i.initiatorType,name:i.name,duration:i.duration}}),this.send()}.bind(this),0)}.bind(this)),o(this,"processPaintTiming",function(t){var e=this;a(this,n),(Array.isArray(t)?t:[t]).forEach(function(t){a(this,e);var n=t.name,r=t.startTime;this.queue.push({name:n,data:{time:r}}),this.send()}.bind(this))}.bind(this)),this.queue=[],this.timer=null,this.observer=null,this.container=i.container||window,this.container.pendo||(e=i.apikey,function(t,n,r,o,a){var s,c,h,u,l;for((a=t[o]=t[o]||{})._q=a._q||[],c=0,h=(s=["initialize","identify","updateOptions","pageLoad","track"]).length;c<h;++c)!function(t){a[t]=a[t]||function(){a._q[t===s[0]?"unshift":"push"]([t].concat([].slice.call(arguments,0)))}}(s[c]);(u=n.createElement(r)).async=!0,u.src=i.srcURL?i.srcURL:"".concat("https://content.pendo.aft.amazon.dev/agent/static/").concat(e,"/pendo.js"),(l=n.getElementsByTagName(r)[0])&&l.parentNode&&l.parentNode.insertBefore(u,l)}(window,document,"script","pendo")),this.engine=this.container.pendo,this.language=this.container.navigator.language,this.collectPerformanceMetrics=i.collectPerformanceMetrics||!1,this.log=i.logger||window.console.log,this.dev=i.dev||!1,U=i.lookupHashApiKey?i.lookupHashApiKey:this.dev?"ptt4UGpW6Y1z9RCuMFqwa4dy6FBovtsjJG1xpf7g":"x3AF2SJTTd8p9duRXU07DoEiIWf9OAe94mazumKf",(I=this.dev?"https://api.pendo.aft.amazon.dev/staging/lookuphash":"https://api.pendo.aft.amazon.dev/prod/lookuphash").startsWith("__")&&console.warn("Warning: LOOK_UP_HASH_API_URL contains placeholder value."),U.startsWith("__")&&console.warn("Warning: LOOK_UP_HASH_API_KEY contains placeholder value."),I||console.warn("Warning: LOOK_UP_HASH_API_URL is not set or is empty."),U||console.warn("Warning: LOOK_UP_HASH_API_KEY is not set or is empty."),this.entryMap={navigation:function(t){a(this,n);var e=t,r={domInteractive:e.domInteractive,responseEnd:e.responseEnd,fetchStart:e.fetchStart,loadEventEnd:e.loadEventEnd,loadEventStart:e.loadEventStart,domComplete:e.domComplete};this.processNavigationTiming(r)}.bind(this),resource:this.processResourceTiming,paint:this.processPaintTiming},this.entryTypes=i.entryTypes||["navigation"],this.resourceFilters=i.resourceFilters||["pendo","ico"],this.initialize(i)}),[{key:"sanitizeData",value:function(t){return"string"!=typeof t?JSON.stringify(t):t.replace(/[^a-zA-Z0-9- ]/g,"")}},{key:"hash",value:function(t){var e=w.hash.sha256.hash(t+"ALCHEMY");return w.codec.hex.fromBits(e)}},{key:"send",value:function(){var t=this;null!==this.timer&&clearInterval(this.timer),this.timer=setInterval(function(){a(this,t);var e=this.queue.pop();this.dev?this.log(e.name,e.data):this.engine.track(e.name,e.data),0===this.queue.length&&null!==this.timer&&clearInterval(this.timer)}.bind(this),1e3)}},{key:"track",value:function(t,e){this.queue.push({name:t,data:e}),this.send()}}])}();t.AlchemyAnalytics=_}, true?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).AlchemyUtils={});


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

function init () {
  var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  for (var i = 0, len = code.length; i < len; ++i) {
    lookup[i] = code[i]
    revLookup[code.charCodeAt(i)] = i
  }

  revLookup['-'.charCodeAt(0)] = 62
  revLookup['_'.charCodeAt(0)] = 63
}

init()

function toByteArray (b64) {
  var i, j, l, tmp, placeHolders, arr
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0

  // base64 is 4/3 + up to two characters of the original data
  arr = new Arr(len * 3 / 4 - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 758 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 759 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {
var intSize = 4;
var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
var chrsz = 8;

function toArray(buf, bigEndian) {
  if ((buf.length % intSize) !== 0) {
    var len = buf.length + (intSize - (buf.length % intSize));
    buf = Buffer.concat([buf, zeroBuffer], len);
  }

  var arr = [];
  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
  for (var i = 0; i < buf.length; i += intSize) {
    arr.push(fn.call(buf, i));
  }
  return arr;
}

function toBuffer(arr, size, bigEndian) {
  var buf = new Buffer(size);
  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
  for (var i = 0; i < arr.length; i++) {
    fn.call(buf, arr[i], i * 4, true);
  }
  return buf;
}

function hash(buf, fn, hashSize, bigEndian) {
  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
  return toBuffer(arr, hashSize, bigEndian);
}
exports.hash = hash;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
CryptoJS v3.1.2
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/
/** @preserve
(c) 2012 by Cédric Mesnil. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

// constants table
var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]
var hr = [0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]

function bytesToWords (bytes) {
  var words = []
  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
    words[b >>> 5] |= bytes[i] << (24 - b % 32)
  }
  return words
}

function wordsToBytes (words) {
  var bytes = []
  for (var b = 0; b < words.length * 32; b += 8) {
    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF)
  }
  return bytes
}

function processBlock (H, M, offset) {
  // swap endian
  for (var i = 0; i < 16; i++) {
    var offset_i = offset + i
    var M_offset_i = M[offset_i]

    // Swap
    M[offset_i] = (
      (((M_offset_i << 8) | (M_offset_i >>> 24)) & 0x00ff00ff) |
      (((M_offset_i << 24) | (M_offset_i >>> 8)) & 0xff00ff00)
    )
  }

  // Working variables
  var al, bl, cl, dl, el
  var ar, br, cr, dr, er

  ar = al = H[0]
  br = bl = H[1]
  cr = cl = H[2]
  dr = dl = H[3]
  er = el = H[4]

  // computation
  var t
  for (i = 0; i < 80; i += 1) {
    t = (al + M[offset + zl[i]]) | 0
    if (i < 16) {
      t += f1(bl, cl, dl) + hl[0]
    } else if (i < 32) {
      t += f2(bl, cl, dl) + hl[1]
    } else if (i < 48) {
      t += f3(bl, cl, dl) + hl[2]
    } else if (i < 64) {
      t += f4(bl, cl, dl) + hl[3]
    } else {// if (i<80) {
      t += f5(bl, cl, dl) + hl[4]
    }
    t = t | 0
    t = rotl(t, sl[i])
    t = (t + el) | 0
    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = t

    t = (ar + M[offset + zr[i]]) | 0
    if (i < 16) {
      t += f5(br, cr, dr) + hr[0]
    } else if (i < 32) {
      t += f4(br, cr, dr) + hr[1]
    } else if (i < 48) {
      t += f3(br, cr, dr) + hr[2]
    } else if (i < 64) {
      t += f2(br, cr, dr) + hr[3]
    } else {// if (i<80) {
      t += f1(br, cr, dr) + hr[4]
    }

    t = t | 0
    t = rotl(t, sr[i])
    t = (t + er) | 0
    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = t
  }

  // intermediate hash value
  t = (H[1] + cl + dr) | 0
  H[1] = (H[2] + dl + er) | 0
  H[2] = (H[3] + el + ar) | 0
  H[3] = (H[4] + al + br) | 0
  H[4] = (H[0] + bl + cr) | 0
  H[0] = t
}

function f1 (x, y, z) {
  return ((x) ^ (y) ^ (z))
}

function f2 (x, y, z) {
  return (((x) & (y)) | ((~x) & (z)))
}

function f3 (x, y, z) {
  return (((x) | (~(y))) ^ (z))
}

function f4 (x, y, z) {
  return (((x) & (z)) | ((y) & (~(z))))
}

function f5 (x, y, z) {
  return ((x) ^ ((y) | (~(z))))
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function ripemd160 (message) {
  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]

  if (typeof message === 'string') {
    message = new Buffer(message, 'utf8')
  }

  var m = bytesToWords(message)

  var nBitsLeft = message.length * 8
  var nBitsTotal = message.length * 8

  // Add padding
  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32)
  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
    (((nBitsTotal << 8) | (nBitsTotal >>> 24)) & 0x00ff00ff) |
    (((nBitsTotal << 24) | (nBitsTotal >>> 8)) & 0xff00ff00)
  )

  for (var i = 0; i < m.length; i += 16) {
    processBlock(H, m, i)
  }

  // swap endian
  for (i = 0; i < 5; i++) {
    // shortcut
    var H_i = H[i]

    // Swap
    H[i] = (((H_i << 8) | (H_i >>> 24)) & 0x00ff00ff) |
      (((H_i << 24) | (H_i >>> 8)) & 0xff00ff00)
  }

  var digestbytes = wordsToBytes(H)
  return new Buffer(digestbytes)
}

module.exports = ripemd160

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(763)
exports.sha1 = __webpack_require__(764)
exports.sha224 = __webpack_require__(765)
exports.sha256 = __webpack_require__(372)
exports.sha384 = __webpack_require__(766)
exports.sha512 = __webpack_require__(373)


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(42)
var Hash = __webpack_require__(133)

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = new Buffer(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(42)
var Hash = __webpack_require__(133)

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = new Buffer(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(42)
var Sha256 = __webpack_require__(372)
var Hash = __webpack_require__(133)

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = new Buffer(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var inherits = __webpack_require__(42)
var SHA512 = __webpack_require__(373)
var Hash = __webpack_require__(133)

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = new Buffer(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var Stream = (function (){
  try {
    return __webpack_require__(85); // hack to fix a circular dependency issue when used with browserify
  } catch(_){}
}());
exports = module.exports = __webpack_require__(374);
exports.Stream = Stream || exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(264);
exports.Duplex = __webpack_require__(110);
exports.Transform = __webpack_require__(265);
exports.PassThrough = __webpack_require__(376);

if (!process.browser && Object({"NODE_ENV":"production","PUBLIC_URL":""}).READABLE_STREAM === 'disable' && Stream) {
  module.exports = Stream;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 768 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 769 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(19).Buffer;
/*<replacement>*/
var bufferShim = __webpack_require__(263);
/*</replacement>*/

module.exports = BufferList;

function BufferList() {
  this.head = null;
  this.tail = null;
  this.length = 0;
}

BufferList.prototype.push = function (v) {
  var entry = { data: v, next: null };
  if (this.length > 0) this.tail.next = entry;else this.head = entry;
  this.tail = entry;
  ++this.length;
};

BufferList.prototype.unshift = function (v) {
  var entry = { data: v, next: this.head };
  if (this.length === 0) this.tail = entry;
  this.head = entry;
  ++this.length;
};

BufferList.prototype.shift = function () {
  if (this.length === 0) return;
  var ret = this.head.data;
  if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
  --this.length;
  return ret;
};

BufferList.prototype.clear = function () {
  this.head = this.tail = null;
  this.length = 0;
};

BufferList.prototype.join = function (s) {
  if (this.length === 0) return '';
  var p = this.head;
  var ret = '' + p.data;
  while (p = p.next) {
    ret += s + p.data;
  }return ret;
};

BufferList.prototype.concat = function (n) {
  if (this.length === 0) return bufferShim.alloc(0);
  if (this.length === 1) return this.head.data;
  var ret = bufferShim.allocUnsafe(n >>> 0);
  var p = this.head;
  var i = 0;
  while (p) {
    p.data.copy(ret, i);
    i += p.data.length;
    p = p.next;
  }
  return ret;
};

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65), __webpack_require__(55)))

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(264)


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(110)


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(265)


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(376)


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = toBuffer

var makeBuffer = Buffer.from && Buffer.from !== Uint8Array.from ? Buffer.from : bufferFrom

function bufferFrom (buf, enc) {
  return new Buffer(buf, enc)
}

function toBuffer (buf, enc) {
  if (Buffer.isBuffer(buf)) return buf
  if (typeof buf === 'string') return makeBuffer(buf, enc)
  if (Array.isArray(buf)) return makeBuffer(buf)
  throw new Error('Input should be a buffer or a string')
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__(779)
var aes = __webpack_require__(268)
var aesModes = __webpack_require__(197)
var desModes = __webpack_require__(788)
var ebtk = __webpack_require__(198)

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var CipherBase = __webpack_require__(134)
var des = __webpack_require__(267)
var inherits = __webpack_require__(42)

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return new Buffer(this._des.update(data))
}
DES.prototype._final = function () {
  return new Buffer(this._des.final())
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(163);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(163);
var inherits = __webpack_require__(42);

var des = __webpack_require__(267);
var utils = des.utils;
var Cipher = des.Cipher;

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(163);
var inherits = __webpack_require__(42);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(163);
var inherits = __webpack_require__(42);

var des = __webpack_require__(267);
var Cipher = des.Cipher;
var DES = des.DES;

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(196)
var Transform = __webpack_require__(134)
var inherits = __webpack_require__(42)
var modes = __webpack_require__(197)
var ebtk = __webpack_require__(198)
var StreamCipher = __webpack_require__(379)
var AuthCipher = __webpack_require__(380)
inherits(Cipher, Transform)
function Cipher (mode, key, iv) {
  if (!(this instanceof Cipher)) {
    return new Cipher(mode, key, iv)
  }
  Transform.call(this)
  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = new Buffer(iv.length)
  iv.copy(this._prev)
  this._mode = mode
  this._autopadding = true
}
Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}
Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  } else if (chunk.toString('hex') !== '10101010101010101010101010101010') {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}
Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  if (!(this instanceof Splitter)) {
    return new Splitter()
  }
  this.cache = new Buffer('')
}
Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}
Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = new Buffer(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }
  var out = Buffer.concat([this.cache, padBuff])
  return out
}
var modelist = {
  ECB: __webpack_require__(381),
  CBC: __webpack_require__(382),
  CFB: __webpack_require__(383),
  CFB8: __webpack_require__(384),
  CFB1: __webpack_require__(385),
  OFB: __webpack_require__(386),
  CTR: __webpack_require__(199),
  GCM: __webpack_require__(199)
}

function createCipheriv (suite, password, iv) {
  var config = modes[suite.toLowerCase()]
  if (!config) {
    throw new TypeError('invalid suite type')
  }
  if (typeof iv === 'string') {
    iv = new Buffer(iv)
  }
  if (typeof password === 'string') {
    password = new Buffer(password)
  }
  if (password.length !== config.key / 8) {
    throw new TypeError('invalid key length ' + password.length)
  }
  if (iv.length !== config.iv) {
    throw new TypeError('invalid iv length ' + iv.length)
  }
  if (config.type === 'stream') {
    return new StreamCipher(modelist[config.mode], password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(modelist[config.mode], password, iv)
  }
  return new Cipher(modelist[config.mode], password, iv)
}
function createCipher (suite, password) {
  var config = modes[suite.toLowerCase()]
  if (!config) {
    throw new TypeError('invalid suite type')
  }
  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var zeros = new Buffer(16)
zeros.fill(0)
module.exports = GHASH
function GHASH (key) {
  this.h = key
  this.state = new Buffer(16)
  this.state.fill(0)
  this.cache = new Buffer('')
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsb_Vi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - i % 8))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi = xor(Zi, Vi)
    }

    // Store the value of LSB(V_i)
    lsb_Vi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsb_Vi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}
GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}
GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, zeros], 16))
  }
  this.ghash(fromArray([
    0, abl,
    0, bl
  ]))
  return this.state
}

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}
function fromArray (out) {
  out = out.map(fixup_uint32)
  var buf = new Buffer(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}
var uint_max = Math.pow(2, 32)
function fixup_uint32 (x) {
  var ret, x_pos
  ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x
  return ret
}
function xor (a, b) {
  return [
    a[0] ^ b[0],
    a[1] ^ b[1],
    a[2] ^ b[2],
    a[3] ^ b[3]
  ]
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(196)
var Transform = __webpack_require__(134)
var inherits = __webpack_require__(42)
var modes = __webpack_require__(197)
var StreamCipher = __webpack_require__(379)
var AuthCipher = __webpack_require__(380)
var ebtk = __webpack_require__(198)

inherits(Decipher, Transform)
function Decipher (mode, key, iv) {
  if (!(this instanceof Decipher)) {
    return new Decipher(mode, key, iv)
  }
  Transform.call(this)
  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = new Buffer(iv.length)
  iv.copy(this._prev)
  this._mode = mode
  this._autopadding = true
}
Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}
Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}
Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}
function Splitter () {
  if (!(this instanceof Splitter)) {
    return new Splitter()
  }
  this.cache = new Buffer('')
}
Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }
  return null
}
Splitter.prototype.flush = function () {
  if (this.cache.length) {
    return this.cache
  }
}
function unpad (last) {
  var padded = last[15]
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) {
    return
  }
  return last.slice(0, 16 - padded)
}

var modelist = {
  ECB: __webpack_require__(381),
  CBC: __webpack_require__(382),
  CFB: __webpack_require__(383),
  CFB8: __webpack_require__(384),
  CFB1: __webpack_require__(385),
  OFB: __webpack_require__(386),
  CTR: __webpack_require__(199),
  GCM: __webpack_require__(199)
}

function createDecipheriv (suite, password, iv) {
  var config = modes[suite.toLowerCase()]
  if (!config) {
    throw new TypeError('invalid suite type')
  }
  if (typeof iv === 'string') {
    iv = new Buffer(iv)
  }
  if (typeof password === 'string') {
    password = new Buffer(password)
  }
  if (password.length !== config.key / 8) {
    throw new TypeError('invalid key length ' + password.length)
  }
  if (iv.length !== config.iv) {
    throw new TypeError('invalid iv length ' + iv.length)
  }
  if (config.type === 'stream') {
    return new StreamCipher(modelist[config.mode], password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(modelist[config.mode], password, iv, true)
  }
  return new Decipher(modelist[config.mode], password, iv)
}

function createDecipher (suite, password) {
  var config = modes[suite.toLowerCase()]
  if (!config) {
    throw new TypeError('invalid suite type')
  }
  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}
exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 788 */
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(387)
var primes = __webpack_require__(791)

var DH = __webpack_require__(792)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 790 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(61);
var MillerRabin = __webpack_require__(388);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(387);
var randomBytes = __webpack_require__(160);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var _algos = __webpack_require__(377)
var createHash = __webpack_require__(132)
var inherits = __webpack_require__(42)
var sign = __webpack_require__(794)
var stream = __webpack_require__(85)
var verify = __webpack_require__(828)

var algos = {}
Object.keys(_algos).forEach(function (key) {
  algos[key] = algos[key.toLowerCase()] = _algos[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algos[algorithm]
  if (!data) {
    throw new Error('Unknown message digest')
  }

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') {
    data = new Buffer(data, enc)
  }

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(Buffer.concat([this._tag, hash]), key, this._hashType, this._signType)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algos[algorithm]
  if (!data) {
    throw new Error('Unknown message digest')
  }

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)

  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') {
    data = new Buffer(data, enc)
  }

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') {
    sig = new Buffer(sig, enc)
  }

  this.end()
  var hash = this._hash.digest()

  return verify(sig, Buffer.concat([this._tag, hash]), key, this._signType)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__(266)
var crt = __webpack_require__(269)
var curves = __webpack_require__(390)
var elliptic = __webpack_require__(74)
var parseKeys = __webpack_require__(201)

var BN = __webpack_require__(61)
var EC = elliptic.ec

function sign (hash, key, hashType, signType) {
  var priv = parseKeys(key)
  if (priv.curve) {
    if (signType !== 'ecdsa') throw new Error('wrong private key type')

    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') {
      throw new Error('wrong private key type')
    }
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa') throw new Error('wrong private key type')
  }

  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) {
    pad.push(0xff)
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.genKeyPair()

  key._importPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (!s.cmpn(0)) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) {
    r = [ 0 ].concat(r)
  }
  // Pad values
  if (s[0] & 0x80) {
    s = [0].concat(s)
  }

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([zeros, x])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k)
    .update(v)
    .update(new Buffer([0]))
    .update(x)
    .update(hbits)
    .digest()
  v = createHmac(algo, k)
    .update(v)
    .digest()
  k = createHmac(algo, k)
    .update(v)
    .update(new Buffer([1]))
    .update(x)
    .update(hbits)
    .digest()
  v = createHmac(algo, k)
    .update(v)
    .digest()
  return {
    k: k,
    v: v
  }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) {
    bits.ishrn(shift)
  }
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([zeros, out])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t, k

  do {
    t = new Buffer('')

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k)
        .update(kv.v)
        .digest()
      t = Buffer.concat([t, kv.v])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k)
      .update(kv.v)
      .update(new Buffer([0]))
      .digest()
    kv.v = createHmac(algo, kv.k)
      .update(kv.v)
      .digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.2.3","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"coverage":"npm run unit --coverage","coveralls":"npm run coverage && cat ./coverage/lcov.info | coveralls","jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/*.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/*.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/*-test.js"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"coveralls":"^2.11.3","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"dependencies":{"bn.js":"^4.0.0","brorand":"^1.0.1","hash.js":"^1.0.0","inherits":"^2.0.1"}}

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__(61);

utils.assert = function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
};

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (!enc) {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  } else if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};

// Represent num in a w-NAF form
function getNAF(num, w) {
  var naf = [];
  var ws = 1 << (w + 1);
  var k = num.clone();
  while (k.cmpn(1) >= 0) {
    var z;
    if (k.isOdd()) {
      var mod = k.andln(ws - 1);
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }
    naf.push(z);

    // Optimization, shift by word if possible
    var shift = (k.cmpn(0) !== 0 && k.andln(ws - 1) === 0) ? (w + 1) : 1;
    for (var i = 1; i < shift; i++)
      naf.push(0);
    k.iushrn(shift);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, computer) {
  var name = computer.name;
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(112);
var elliptic = __webpack_require__(74);
var utils = elliptic.utils;
var assert = utils.assert;

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this.reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc);
  var nonce = utils.toArray(options.nonce, options.nonceEnc);
  var pers = utils.toArray(options.pers, options.persEnc);
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this.reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toBuffer(entropy, entropyEnc);
  add = utils.toBuffer(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this.reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this.reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc);
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this.reseed++;
  return utils.encode(res, enc);
};


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var utils = exports;
var inherits = __webpack_require__(42);

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi)
          res.push(hi, lo);
        else
          res.push(lo);
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (var i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
utils.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
utils.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
utils.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
utils.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
utils.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
utils.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
utils.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
utils.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
utils.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
utils.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
utils.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
utils.sum32_5 = sum32_5;

function assert(cond, msg) {
  if (!cond)
    throw new Error(msg || 'Assertion failed');
}
utils.assert = assert;

utils.inherits = inherits;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
};
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
};
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
};
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
};
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
};
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
};
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
};
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
};
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
};
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
};
exports.shr64_lo = shr64_lo;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var hash = __webpack_require__(112);
var utils = hash.utils;
var assert = utils.assert;

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var hash = __webpack_require__(112);
var utils = hash.utils;
var assert = utils.assert;

var rotr32 = utils.rotr32;
var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;
var BlockHash = hash.common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [ 0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
             0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19 ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
exports.sha256 = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [ 0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
             0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
exports.sha224 = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [ 0x6a09e667, 0xf3bcc908,
             0xbb67ae85, 0x84caa73b,
             0x3c6ef372, 0xfe94f82b,
             0xa54ff53a, 0x5f1d36f1,
             0x510e527f, 0xade682d1,
             0x9b05688c, 0x2b3e6c1f,
             0x1f83d9ab, 0xfb41bd6b,
             0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
exports.sha512 = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(c0_hi, c0_lo,
                      c1_hi, c1_lo,
                      c2_hi, c2_lo,
                      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(c0_hi, c0_lo,
                          c1_hi, c1_lo,
                          c2_hi, c2_lo,
                          c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(c0_hi, c0_lo,
                           c1_hi, c1_lo,
                           c2_hi, c2_lo,
                           c3_hi, c3_lo,
                           c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(c0_hi, c0_lo,
                           c1_hi, c1_lo,
                           c2_hi, c2_lo,
                           c3_hi, c3_lo,
                           c4_hi, c4_lo);

    var c0_hi = s0_512_hi(ah, al);
    var c0_lo = s0_512_lo(ah, al);
    var c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    var c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [ 0xcbbb9d5d, 0xc1059ed8,
             0x629a292a, 0x367cd507,
             0x9159015a, 0x3070dd17,
             0x152fecd8, 0xf70e5939,
             0x67332667, 0xffc00b31,
             0x8eb44a87, 0x68581511,
             0xdb0c2e0d, 0x64f98fa7,
             0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
exports.sha384 = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe,
             0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
exports.sha1 = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (var i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}

function p32(x, y, z) {
  return x ^ y ^ z;
}

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}

function ch64_hi(xh, xl, yh, yl, zh, zl) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh, zl) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var hash = __webpack_require__(112);
var utils = hash.utils;

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = hash.common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var hmac = exports;

var hash = __webpack_require__(112);
var utils = hash.utils;
var assert = utils.assert;

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (var i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (var i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(61);
var elliptic = __webpack_require__(74);
var utils = elliptic.utils;
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a]);
      naf[b] = getNAF(coeffs[b], wndWidth[b]);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;
  return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();
  if (bytes[0] === 0x04 && bytes.length - 1 === 2 * len) {
    return this.point(bytes.slice(1, 1 + len),
                      bytes.slice(1 + len, 1 + 2 * len));
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(200);
var elliptic = __webpack_require__(74);
var BN = __webpack_require__(61);
var inherits = __webpack_require__(42);
var Base = curve.base;

var assert = elliptic.utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);

  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(200);
var BN = __webpack_require__(61);
var inherits = __webpack_require__(42);
var Base = curve.base;

var elliptic = __webpack_require__(74);
var utils = elliptic.utils;

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(200);
var elliptic = __webpack_require__(74);
var BN = __webpack_require__(61);
var inherits = __webpack_require__(42);
var Base = curve.base;

var assert = elliptic.utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - 1) / (d y^2 + 1)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.one);
  var rhs = y2.redMul(this.d).redAdd(this.one);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
         this.y.cmp(this.z) === 0;
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.c.redMul(this.z)).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__(112);
var elliptic = __webpack_require__(74);

var assert = elliptic.utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new elliptic.curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new elliptic.curve.edwards(options);
  else
    this.curve = new elliptic.curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '0',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = __webpack_require__(808);
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});


/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(61);
var elliptic = __webpack_require__(74);
var utils = elliptic.utils;
var assert = utils.assert;

var KeyPair = __webpack_require__(810);
var Signature = __webpack_require__(811);

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(elliptic.curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = elliptic.curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof elliptic.curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new elliptic.hmacDRBG({
    hash: this.hash,
    pers: options.pers,
    entropy: options.entropy || elliptic.rand(this.hash.hmacStrength),
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new elliptic.hmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  var p = this.g.mulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  return p.getX().umod(this.n).cmp(r) === 0;
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var eNeg = n.sub(e);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  var rInv = signature.r.invm(n);
  return this.g.mulAdd(eNeg, r, s).mul(rInv);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(61);

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(61);

var elliptic = __webpack_require__(74);
var utils = elliptic.utils;
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;
  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
  }
  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0 && (r[1] & 0x80)) {
    r = r.slice(1);
  }
  if (s[0] === 0 && (s[1] & 0x80)) {
    s = s.slice(1);
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(112);
var elliptic = __webpack_require__(74);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(813);
var Signature = __webpack_require__(814);

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = elliptic.curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = __webpack_require__(74);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(61);
var elliptic = __webpack_require__(74);
var utils = elliptic.utils;
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.

var asn1 = __webpack_require__(136)

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})
var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey
var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(136);
var inherits = __webpack_require__(42);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__(817).runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var indexOf = __webpack_require__(818);

var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    forEach(Object_keys(ctx), function (key) {
        context[key] = ctx[key];
    });

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),
/* 818 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(42);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  Error.captureStackTrace(this, ReporterError);

  return this;
};


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__(165).Reporter;
var EncoderBuffer = __webpack_require__(165).EncoderBuffer;
var DecoderBuffer = __webpack_require__(165).DecoderBuffer;
var assert = __webpack_require__(163);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input));

  var result = state['default'];
  var present = true;

  var prevKey;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input);
        else
          this._decodeChoice(input);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input);
    else
      result = this._decodeChoice(input);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)._decode(data);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0]);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1]);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag);
  else if (tag === 'null_')
    return this._decodeNull(input);
  else if (tag === 'bool')
    return this._decodeBool(input);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0]);
  else if (state.use !== null)
    return this._getUse(state.use, input._reporterState.obj)._decode(input);
  else
    return input.error('unknown tag: ' + tag);

  return null;
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;
  var present = true;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // For error reporting
  var prevKey;

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be ommited only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__(392);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__(393);
decoders.pem = __webpack_require__(823);


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(42);
var Buffer = __webpack_require__(19).Buffer;

var asn1 = __webpack_require__(136);
var DERDecoder = __webpack_require__(393);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__(394);
encoders.pem = __webpack_require__(825);


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(42);
var Buffer = __webpack_require__(19).Buffer;

var asn1 = __webpack_require__(136);
var DEREncoder = __webpack_require__(394);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED\r?\nDEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)\r?\n\r?\n([0-9A-z\n\r\+\/\=]+)\r?\n/m
var startRegex = /^-----BEGIN (.*) KEY-----\r?\n/m
var fullRegex = /^-----BEGIN (.*) KEY-----\r?\n([0-9A-z\n\r\+\/\=]+)\r?\n-----END \1 KEY-----$/m
var evp = __webpack_require__(198)
var ciphers = __webpack_require__(268)
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/\r?\n/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = new Buffer(match[2], 'hex')
    var cipherText = new Buffer(match[3].replace(/\r?\n/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1] + ' KEY'
  return {
    tag: tag,
    data: decrypted
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var curves = __webpack_require__(390)
var elliptic = __webpack_require__(74)
var parseKeys = __webpack_require__(201)

var BN = __webpack_require__(61)
var EC = elliptic.ec

function verify (sig, hash, key, signType) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    if (signType !== 'ecdsa') {
      throw new Error('wrong public key type')
    }
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') {
      throw new Error('wrong public key type')
    }
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa') {
      throw new Error('wrong public key type')
    }
  }
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))

  sig = new Buffer(sig.fromRed().toArray())
  var out = 0
  if (padNum < 8) {
    out = 1
  }
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) {
    out = 1
  }

  i = -1
  while (++i < len) {
    out |= (sig[i] ^ pad[i])
  }
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(
      y.toRed(montp)
        .redPow(r.mul(w).mod(q))
        .fromRed()
  ).mod(p).mod(q)
  return !v.cmp(r)
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) {
    throw new Error('invalid sig')
  }
  if (b.cmp(q) >= q) {
    throw new Error('invalid sig')
  }
}

module.exports = verify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(74);
var BN = __webpack_require__(61);

module.exports = function createECDH(curve) {
	return new ECDH(curve);
};

var aliases = {
	secp256k1: {
		name: 'secp256k1',
		byteLength: 32
	},
	secp224r1: {
		name: 'p224',
		byteLength: 28
	},
	prime256v1: {
		name: 'p256',
		byteLength: 32
	},
	prime192v1: {
		name: 'p192',
		byteLength: 24
	},
	ed25519: {
		name: 'ed25519',
		byteLength: 32
	},
	secp384r1: {
		name: 'p384',
		byteLength: 48
	},
	secp521r1: {
		name: 'p521',
		byteLength: 66
	}
};

aliases.p224 = aliases.secp224r1;
aliases.p256 = aliases.secp256r1 = aliases.prime256v1;
aliases.p192 = aliases.secp192r1 = aliases.prime192v1;
aliases.p384 = aliases.secp384r1;
aliases.p521 = aliases.secp521r1;

function ECDH(curve) {
	this.curveType = aliases[curve];
	if (!this.curveType ) {
		this.curveType = {
			name: curve
		};
	}
	this.curve = new elliptic.ec(this.curveType.name);
	this.keys = void 0;
}

ECDH.prototype.generateKeys = function (enc, format) {
	this.keys = this.curve.genKeyPair();
	return this.getPublicKey(enc, format);
};

ECDH.prototype.computeSecret = function (other, inenc, enc) {
	inenc = inenc || 'utf8';
	if (!Buffer.isBuffer(other)) {
		other = new Buffer(other, inenc);
	}
	var otherPub = this.curve.keyFromPublic(other).getPublic();
	var out = otherPub.mul(this.keys.getPrivate()).getX();
	return formatReturnValue(out, enc, this.curveType.byteLength);
};

ECDH.prototype.getPublicKey = function (enc, format) {
	var key = this.keys.getPublic(format === 'compressed', true);
	if (format === 'hybrid') {
		if (key[key.length - 1] % 2) {
			key[0] = 7;
		} else {
			key [0] = 6;
		}
	}
	return formatReturnValue(key, enc);
};

ECDH.prototype.getPrivateKey = function (enc) {
	return formatReturnValue(this.keys.getPrivate(), enc);
};

ECDH.prototype.setPublicKey = function (pub, enc) {
	enc = enc || 'utf8';
	if (!Buffer.isBuffer(pub)) {
		pub = new Buffer(pub, enc);
	}
	this.keys._importPublic(pub);
	return this;
};

ECDH.prototype.setPrivateKey = function (priv, enc) {
	enc = enc || 'utf8';
	if (!Buffer.isBuffer(priv)) {
		priv = new Buffer(priv, enc);
	}
	var _priv = new BN(priv);
	_priv = _priv.toString(16);
	this.keys._importPrivate(_priv);
	return this;
};

function formatReturnValue(bn, enc, len) {
	if (!Array.isArray(bn)) {
		bn = bn.toArray();
	}
	var buf = new Buffer(bn);
	if (len && buf.length < len) {
		var zeros = new Buffer(len - buf.length);
		zeros.fill(0);
		buf = Buffer.concat([zeros, buf]);
	}
	if (!enc) {
		return buf;
	} else {
		return buf.toString(enc);
	}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(831)
exports.privateDecrypt = __webpack_require__(832)

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(201)
var randomBytes = __webpack_require__(160)
var createHash = __webpack_require__(132)
var mgf = __webpack_require__(395)
var xor = __webpack_require__(396)
var BN = __webpack_require__(61)
var withPublic = __webpack_require__(397)
var crt = __webpack_require__(269)
var Buffer = __webpack_require__(161).Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(201)
var mgf = __webpack_require__(395)
var xor = __webpack_require__(396)
var BN = __webpack_require__(61)
var crt = __webpack_require__(269)
var createHash = __webpack_require__(132)
var withPublic = __webpack_require__(397)
var Buffer = __webpack_require__(161).Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),
/* 833 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCheckCircleFilledData: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3e%3cpath d='M12 0a12 12 0 1012 12A12 12 0 0012 0zm5.71 9.71l-7 7a1 1 0 01-1.41 0l-4-4a1 1 0 010-1.41 1 1 0 011.42 0L10 14.6l6.3-6.31a1 1 0 011.41 0 1 1 0 010 1.42z' fill='currentColor'/%3e%3c/svg%3e",
  iconCheckCircleFilledWidth: 24,
  iconCheckCircleFilledHeight: 24
};

/***/ }),
/* 834 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconAlertData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M12 17a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z' fill='currentColor' fill-rule='nonzero'/%3e%3cpath d='M12 10v4M22.532 19.823L13.623 1.985a1.83 1.83 0 00-3.246 0L1.468 19.823C.384 21.98 1.993 23 3.001 23h18.06c.96 0 2.554-1.049 1.47-3.177z' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertWidth: 24,
  iconAlertHeight: 24
};

/***/ }),
/* 835 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconInfoData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' cx='12' cy='12' r='11'/%3e%3cpath d='M12 11v7' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3ccircle fill='currentColor' fill-rule='nonzero' cx='12' cy='7.25' r='1.25'/%3e%3c/g%3e%3c/svg%3e",
  iconInfoWidth: 24,
  iconInfoHeight: 24
};

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateConfigurationsInAdtaAssetObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Util__ = __webpack_require__(5);
var updateConfigurationsInAdtaAssetObject=function updateConfigurationsInAdtaAssetObject(asset,configurations,alias){var updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["t" /* deepCopyObject */])(asset);updatedAsset.assetDetails.alias=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return alias.toString();},"");updatedAsset.assetDetails.assetAttributes.sorterConfig=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(configurations.sorterConfig);},"[]");updatedAsset.assetDetails.assetAttributes.sorterTestPackage=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(configurations.sorterTestPackage);},"[]");return updatedAsset;};

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchAndMapDeviceHealthStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_StatusResource__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(5);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/**
 * Shared function to fetch device health status and map to model.
 * Reusable across ADTA, ADTF, ASL, ASML by passing deviceType.
 *
 * @param {Object} model - Device model with macAddressArray and deviceInformation map
 * @param {string} deviceType - e.g., "ADTA", "ADTF", "ASL", "ASML"
 * @param {string} deviceInfoKey - Key in model for device info map (e.g., "adtaDeviceInformation")
 * @param {string} metricProcessName - Metric name for logging
 * @returns {Object} { isSuccess, isFault }
 */var fetchAndMapDeviceHealthStatus=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(model,deviceType,deviceInfoKey,metricProcessName){var startTime,deviceDetailsList,response,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:startTime=Date.now();deviceDetailsList=buildDeviceDetailsList(model,deviceType,deviceInfoKey);_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__resources_StatusResource__["c" /* getDeviceHealthStatus */])(deviceDetailsList);case 4:response=_context.sent;isSuccess=response.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_17" /* isResponseCode5xx */])(response.status);if(isSuccess){parseAndMapResponse(response,model,deviceInfoKey);}else{handleHealthStatusError(model,deviceInfoKey);}Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getDeviceHealthStatusDetails",isSuccess,isFault);return _context.abrupt("return",{isSuccess:isSuccess,isFault:isFault});case 10:case"end":return _context.stop();}}},_callee,this);}));return function fetchAndMapDeviceHealthStatus(_x,_x2,_x3,_x4){return _ref.apply(this,arguments);};}();/**
 * Build deviceDetailsList from model for the GetDeviceHealthStatus request.
 * Each entry contains deviceIdentifier (mac), deviceType, and optional deviceSubType.
 */function buildDeviceDetailsList(model,deviceType,deviceInfoKey){return model.macAddressArray.map(function(mac){var device=model[deviceInfoKey][mac];var details={deviceIdentifier:mac,deviceType:deviceType};if(device&&device.deviceSubType){details.deviceSubType=device.deviceSubType;}return details;});}/**
 * Parse GetDeviceHealthStatus response and map to device model fields.
 */function parseAndMapResponse(response,model,deviceInfoKey){if(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_165" /* RESPONSE_KEY_DATA */] in response&&__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_166" /* RESPONSE_KEY_DEVICE_HEALTH_STATUS_LIST */] in response.data){response.data.deviceHealthStatusList.forEach(function(deviceStatus){var device=model[deviceInfoKey][deviceStatus.deviceIdentifier];if(device){device.assetStatus=deviceStatus.connectionStatus;device.pingStatus=deviceStatus.pingStatus;device.lastConnectionTime=deviceStatus.lastConnectionTime;device.recentSuccessfulPingTime=deviceStatus.recentSuccessfulPingTime;device.troubleShootHint=deviceStatus.troubleShootHint;}});}}/**
 * Set error state for all devices when API fails.
 */function handleHealthStatusError(model,deviceInfoKey){model.macAddressArray.forEach(function(mac){var device=model[deviceInfoKey][mac];if(device){device.assetStatus=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];device.pingStatus=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_109" /* LOADING_FAILED */];}});}

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TabGroup", {
  enumerable: true,
  get: function get() {
    return _tabGroup["default"];
  }
});
exports["default"] = void 0;

var _tab = _interopRequireDefault(__webpack_require__(839));

var _tabGroup = _interopRequireDefault(__webpack_require__(840));

var _default = _tab["default"];
exports["default"] = _default;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _keycode = _interopRequireDefault(__webpack_require__(72));

var _emotion = __webpack_require__(11);

var _context = __webpack_require__(399);

var _focus = _interopRequireDefault(__webpack_require__(109));

var _token = __webpack_require__(20);

var _focusRing = _interopRequireDefault(__webpack_require__(73));

var _text = _interopRequireDefault(__webpack_require__(47));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

var _borderRadius = _interopRequireDefault(__webpack_require__(127));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Styles
 */
var transparent = "rgba(0,0,0,0)"; // Root styles for the entire component

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var selected = _ref.selected,
      disabled = _ref.disabled,
      fill = _ref.fill,
      type = _ref.type;
  return (0, _emotion.css)((0, _text["default"])(t), {
    flexGrow: fill === "tabs" ? 1 : "initial",
    position: "relative",
    ":not(:last-child)": (0, _defineProperty2["default"])({
      // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
      // to use directional margin-left/right. If/when we drop IE11 we can simplify
      // these styles to be:
      // {
      //   marginInlineEnd: t("spacingHorizontal"),
      // }
      marginRight: t("spacingHorizontal")
    }, "[dir=\"rtl\"] &", {
      marginLeft: t("spacingHorizontal"),
      marginRight: 0
    }),
    cursor: disabled ? "not-allowed" : "pointer",
    transition: t.transitionCss("motion", "color"),
    color: t("foregroundColor", disabled ? "disabled" : selected ? "selected" : "default"),
    ":hover": !disabled && !selected && {
      color: t("foregroundColorHover")
    },
    ":active": !disabled && {
      color: t("foregroundColorPressed")
    }
  }, type === "classic" ? classicStyles(t, {
    selected: selected,
    disabled: disabled
  }) : {});
}, ["selected", "disabled", "fill", "type"]);

var classicStyles = function classicStyles(t, _ref2) {
  var disabled = _ref2.disabled;
  return {
    boxSizing: "border-box",
    border: "".concat(t("borderWidth"), "px solid ").concat(t("borderColor")),
    borderColor: "".concat(transparent, " ").concat(transparent, " ").concat(t("borderColor")),
    "&[mdn-tab-selected-previous]": (0, _defineProperty2["default"])({
      borderRadius: (0, _borderRadius["default"])(t("borderRadius"), ["bottomRight"])
    }, "[dir=\"rtl\"] &", {
      borderRadius: (0, _borderRadius["default"])(t("borderRadius"), ["bottomLeft"])
    }),
    "&[mdn-tab-selected-next]": (0, _defineProperty2["default"])({
      borderRadius: (0, _borderRadius["default"])(t("borderRadius"), ["bottomLeft"])
    }, "[dir=\"rtl\"] &", {
      borderRadius: (0, _borderRadius["default"])(t("borderRadius"), ["bottomRight"])
    }),
    "&[mdn-tab-selected]": {
      borderColor: transparent
    },
    "&[mdn-tab-selected]:after": {
      content: "\"\"",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      border: "".concat(t("borderWidth"), "px solid ").concat(t("borderColor")),
      borderBottomColor: transparent,
      borderRadius: (0, _borderRadius["default"])(t("borderRadius"), ["topLeft", "topRight"])
    },
    ":not(:last-child)": (0, _defineProperty2["default"])({
      // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
      // to use directional margin-left/right. If/when we drop IE11 we can simplify
      // these styles to be:
      // {
      //   marginInlineEnd: -3,
      // }
      marginRight: -3
    }, "[dir=\"rtl\"] &", {
      marginLeft: -3
    }),
    "&:not([mdn-tab-selected]) > div": {
      opacity: 0
    },
    "&:not([mdn-tab-selected]):hover > div": {
      opacity: !disabled ? 1 : undefined
    },
    padding: "".concat(t("spacingInsetClassicVertical"), "px ").concat(t("spacingInsetClassicHorizontal"), "px"),
    paddingBottom: 0
  };
}; // Styles for the tab (a psuedo-element) that's actually displayed to users


var visibleTabStyles = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var disabled = _ref3.disabled,
      focus = _ref3.focus,
      type = _ref3.type;
  return (0, _emotion.css)({
    width: "100%",
    textAlign: "center",
    position: "relative",
    boxSizing: "border-box",
    padding: "".concat(t("spacingInsetVertical"), "px ").concat(t("spacingInsetHorizontal"), "px")
  }, !disabled ? (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderRadius: type === "classic" ? // We decrease border radius by one here because the focus ring will appear inside
    // another rounded box. Visually, two concentric rounded boxes look better if the
    // border radius gets smaller from the outside in
    "".concat(parseInt(t("borderRadius") - 1), " ").concat(parseInt(t("borderRadius") - 1), " 0 0") : undefined,
    offset: 0
  }) : undefined);
}, ["disabled", "focus", "type"]);
var tabBaseLineStyles = (0, _token.memoizeTokenStyles)(function (t, _ref4) {
  var selected = _ref4.selected,
      disabled = _ref4.disabled,
      type = _ref4.type;
  return (0, _emotion.css)({
    // This magic number for classic is used to make the appearance of internal padding
    // between the edge of the activated tab and the indicator bar. It's derived by
    // (target padding - existing padding) * 2 (sides)
    width: type === "classic" ? "calc(100% - ".concat((parseInt(t("spacingInsetClassicBaseLine")) - parseInt(t("spacingInsetClassicHorizontal"))) * 2, "px)") : "100%",
    height: t("indicatorHeight"),
    borderRadius: t("indicatorRadius"),
    margin: "auto",
    marginTop: t("spacingVertical", type),
    transition: t.transitionCss("motion", "background-color", "opacity"),
    backgroundColor: t("indicatorColor", disabled ? "disabled" : selected ? "selected" : "default"),
    "*:hover > &": (0, _emotion.css)(!disabled && {
      backgroundColor: t("indicatorColorHover")
    }),
    "*:active > &": (0, _emotion.css)(!disabled && {
      backgroundColor: t("indicatorColorPressed")
    })
  });
}, ["selected", "disabled", "type"]); // Styles for the actual HTML tab element that is hidden from the user

var hiddenTabStyles = (0, _emotion.css)({
  clip: "rect(0 0 0 0)",
  overflow: "hidden",
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  opacity: 0
});
/**
 * Used to render a single tab in a group of tabs. Place this as a child of the
 * `TabGroup` component.
 */

var Tab = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Tab, _React$Component);

  var _super = _createSuper(Tab);

  function Tab() {
    var _this;

    (0, _classCallCheck2["default"])(this, Tab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "rootRef", undefined);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateRootRef", function (ref, _ref5) {
      var selected = _ref5.selected,
          setSelectedRef = _ref5.setSelectedRef;
      _this.rootRef = ref;

      if (selected && _this.rootRef) {
        setSelectedRef(_this.rootRef);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getScrollDelta", function (tab, tabGroup) {
      var _tab$getBoundingClien = tab.getBoundingClientRect(),
          tabWidth = _tab$getBoundingClien.width;

      var _tabGroup$getBounding = tabGroup.getBoundingClientRect(),
          tabGroupWidth = _tabGroup$getBounding.width;

      var tabLeftEdge = tab.offsetLeft;
      var tabRightEdge = tab.offsetLeft + tabWidth;
      var viewportLeftEdge = tabGroup.scrollLeft + Tab.viewportBuffer;
      var viewportRightEdge = tabGroup.scrollLeft + tabGroupWidth - Tab.viewportBuffer;
      var leftEdgeOverlap = tabLeftEdge - viewportLeftEdge;
      var rightEdgeOverlap = viewportRightEdge - tabRightEdge;
      return leftEdgeOverlap < 0 ? leftEdgeOverlap : rightEdgeOverlap < 0 ? Math.abs(rightEdgeOverlap) : 0;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (updateTabGroup) {
      var tabGroup = _this.rootRef.offsetParent;

      var scrollDelta = _this.getScrollDelta(_this.rootRef, tabGroup);

      if (scrollDelta !== 0) {
        tabGroup.scrollLeft = tabGroup.scrollLeft + scrollDelta;
      }

      updateTabGroup(_this.props.value);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyDown", function (e) {
      if ((0, _keycode["default"])(e) === "up" || (0, _keycode["default"])(e) === "down") {
        e.preventDefault();
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(Tab, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          disabled = _this$props.disabled,
          value = _this$props.value;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, ["data-"]);
      return /*#__PURE__*/_react["default"].createElement(_context.Consumer, null, function (_ref6) {
        var selectedValue = _ref6.value,
            updateTabGroup = _ref6.updateTabGroup,
            t = _ref6.t,
            name = _ref6.name,
            fill = _ref6.fill,
            type = _ref6.type,
            nextValue = _ref6.nextValue,
            previousValue = _ref6.previousValue,
            setSelectedRef = _ref6.setSelectedRef;
        var selected = selectedValue === value;
        var previous = value === previousValue;
        var next = value === nextValue; // Only allow tabbing to the selected tab. This is the normal behavior
        // for most browsers, but some (ahem IE11) need a little extra help.

        var tabIndex = selected ? 0 : -1;
        return /*#__PURE__*/_react["default"].createElement("label", {
          className: styles(t, {
            selected: selected,
            disabled: disabled,
            fill: fill,
            type: type
          }),
          onMouseEnter: _this2.onMouseEnter,
          ref: function ref(_ref8) {
            return _this2.updateRootRef(_ref8, {
              selected: selected,
              setSelectedRef: setSelectedRef
            });
          },
          "mdn-tab-selected": selected ? "" : undefined,
          "mdn-tab-selected-previous": previous ? "" : undefined,
          "mdn-tab-selected-next": next ? "" : undefined
        }, /*#__PURE__*/_react["default"].createElement(_focus["default"], null, function (_ref7) {
          var focus = _ref7.focus,
              focusTrigger = _ref7.focusTrigger,
              focusProps = _ref7.focusProps;
          return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("div", {
            className: visibleTabStyles(t, {
              disabled: disabled,
              focus: focus && focusTrigger === "keyboard",
              type: type
            })
          }, children), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, passThroughProps, focusProps, {
            className: hiddenTabStyles,
            type: "radio",
            role: "tab",
            name: name,
            value: value,
            checked: selected,
            tabIndex: tabIndex,
            disabled: disabled,
            onChange: disabled ? undefined : function () {
              return _this2.onChange(updateTabGroup);
            },
            onKeyDown: _this2.handleKeyDown
          })));
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: tabBaseLineStyles(t, {
            selected: selected,
            disabled: disabled,
            type: type
          })
        }));
      });
    }
  }]);
  return Tab;
}(_react["default"].Component);

(0, _defineProperty2["default"])(Tab, "viewportBuffer", 60);
Tab.propTypes =  false ? {
  /**
   * The tab's label. Plain text (and optionally badges) recommended.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The value of the tab. This is used by the parent `TabGroup` component to
   * track the selection of the tab.
   */
  value: _propTypes["default"].any.isRequired,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool
} : {};
var _default = Tab;
exports["default"] = _default;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(202));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _tab = _interopRequireDefault(__webpack_require__(842));

var _context = __webpack_require__(399);

var _theme = __webpack_require__(24);

var _token = __webpack_require__(20);

var _excluded = ["children", "fill", "onChange", "type"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = (0, _emotion.css)({
  position: "relative",
  whiteSpace: "nowrap",
  display: "flex",
  width: "100%",
  overflowX: "auto",
  overflowY: "hidden"
});

var fillLineStyle = function fillLineStyle(t, _ref) {
  var type = _ref.type;
  return (0, _emotion.css)({
    width: "100%"
  }, type === "classic" ? {
    borderBottom: t.borderCss("border")
  } : {
    height: t("indicatorHeight"),
    marginTop: t("spacingVertical"),
    backgroundColor: t("indicatorColorDefault"),
    borderRadius: t("indicatorRadius"),
    alignSelf: "flex-end"
  });
};
/**
 * Used to group a set of tabs.
 */


var TabGroup = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TabGroup, _React$Component);

  var _super = _createSuper(TabGroup);

  function TabGroup() {
    var _this;

    (0, _classCallCheck2["default"])(this, TabGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      nextValue: undefined,
      previousValue: undefined
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setSelectedRef", function (ref) {
      var previousSibling = ref.previousSibling,
          nextSibling = ref.nextSibling;

      var previousValue = _this.getLabelValue(previousSibling);

      var nextValue = _this.getLabelValue(nextSibling);

      if (previousValue !== _this.state.previousValue || nextValue !== _this.state.nextValue) {
        _this.setState({
          nextValue: nextValue,
          previousValue: previousValue
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", (0, _uniqueId["default"])("tabs-"));
    return _this;
  }

  (0, _createClass2["default"])(TabGroup, [{
    key: "getLabelValue",
    value: function getLabelValue(labelRef) {
      return labelRef && labelRef.getElementsByTagName("input")[0] ? labelRef.getElementsByTagName("input")[0].value : undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          nextValue = _this$state.nextValue,
          previousValue = _this$state.previousValue;
      var _this$props = this.props,
          children = _this$props.children,
          fill = _this$props.fill,
          onChange = _this$props.onChange,
          type = _this$props.type,
          props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _tab["default"],
        map: (0, _token.getTokenHelper)("tab")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(_context.Provider, {
          value: _objectSpread({
            updateTabGroup: onChange,
            name: _this2.id,
            t: t,
            fill: fill,
            type: type,
            nextValue: nextValue,
            previousValue: previousValue,
            setSelectedRef: _this2.setSelectedRef
          }, props)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: styles,
          role: "tablist"
        }, children, fill === "line" && /*#__PURE__*/_react["default"].createElement("div", {
          className: fillLineStyle(t, {
            type: type
          })
        })));
      });
    }
  }]);
  return TabGroup;
}(_react["default"].Component);

(0, _defineProperty2["default"])(TabGroup, "defaultProps", {
  fill: "none",
  type: "default"
});
TabGroup.propTypes =  false ? {
  /**
   * The Tab children for the TabGroup.
   * EG: `<TabGroup><Tab value="tab-1">My tab 1</Tab></TabGroup>`
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The value of the selected Tab.
   */
  value: _propTypes["default"].any.isRequired,

  /**
   * A function that will be called when the user attempts to change the
   * selected tab. The new value will be passed as the first argument to this
   * function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * Determines how the unused space in the Tab group is handled.
   *
   * `"none"` will not fill the space; the width of each Tab depends on the length of its label.
   * `"tabs"` uses an equal amount of padding for each Tab to span the total available width.
   * `"line"` does not add additional padding to each Tab and fills the available width with a line.
   */
  fill: _propTypes["default"].oneOf(["none", "tabs", "line"]),

  /**
   * The visual style of the Tab group.
   */
  type: _propTypes["default"].oneOf(["default", "classic"])
} : {};
var _default = TabGroup;
exports["default"] = _default;

/***/ }),
/* 841 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 842 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    tabMotionDuration: "150ms",
    tabMotionFunction: "ease",
    tabForegroundColorDefault: tokens.themeForegroundSecondaryDefault,
    tabForegroundColorSelected: tokens.themeForegroundPrimaryDefault,
    tabForegroundColorHover: tokens.themeForegroundPrimaryDefault,
    tabForegroundColorPressed: tokens.themeForegroundPrimaryDefault,
    tabForegroundColorDisabled: tokens.themeForegroundSecondaryDisabled,
    tabIndicatorHeight: 4,
    tabIndicatorRadius: 999,
    tabIndicatorColorDefault: tokens.themeBackgroundTertiaryDefault,
    tabIndicatorColorSelected: tokens.themeBorderAccentHover,
    tabIndicatorColorHover: tokens.themeBorderAccentPressed,
    tabIndicatorColorPressed: tokens.themeForegroundAccentPressed,
    tabIndicatorColorDisabled: tokens.themeBackgroundTertiaryDefault,
    tabBorderWidth: 1,
    tabBorderRadius: 4,
    tabBorderColor: tokens.themeBorderPrimaryDefault,
    tabSpacingHorizontal: 4,
    tabSpacingVerticalDefault: 2,
    tabSpacingVerticalClassic: 0,
    tabSpacingInsetHorizontal: 24,
    tabSpacingInsetVertical: 6,
    tabSpacingInsetClassicHorizontal: 3,
    tabSpacingInsetClassicVertical: 3,
    tabSpacingInsetClassicBaseLine: 16
  }
};

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AslDeviceOverviewContext__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_FeatureUtility__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var AslDevicePage=function(_Component){_inherits(AslDevicePage,_Component);function AslDevicePage(){_classCallCheck(this,AslDevicePage);return _possibleConstructorReturn(this,(AslDevicePage.__proto__||Object.getPrototypeOf(AslDevicePage)).apply(this,arguments));}_createClass(AslDevicePage,[{key:"render",value:function render(){var getASLRoutes=function getASLRoutes(){return __WEBPACK_IMPORTED_MODULE_5__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_5__util_FeatureUtility__["a" /* FEATURES */].IS_MHE_VALIDATION_ENABLED)?[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["g" /* ASL */]),[__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["F" /* aslMheValidationRoute */]]):__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["g" /* ASL */];};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_AslDeviceOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["b" /* default */],{routes:getASLRoutes(),location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["a" /* NavigationRoutes */],{routes:getASLRoutes()})));}}]);return AslDevicePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AslDevicePage);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AslDeviceOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_AslDeviceOverviewNetworkAPI__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
var AslDeviceOverviewReducer=function AslDeviceOverviewReducer(state,action){switch(action.type){case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingOverview:false,timestamp:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_14" /* getTimestampNow */])()});case"LOAD_VIEW":Object(__WEBPACK_IMPORTED_MODULE_0__network_AslDeviceOverviewNetworkAPI__["b" /* fetchAslDeviceDetails */])(action.data.dispatcher);return state;case"LOAD_STATUS":Object(__WEBPACK_IMPORTED_MODULE_0__network_AslDeviceOverviewNetworkAPI__["c" /* fetchAslStatusDetails */])(action.data.dispatcher,state);return state;case"ADD_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AslDeviceOverviewNetworkAPI__["d" /* setAslDeviceDetails */])(action.data.dispatcher,action.data.stateValues);return state;case"UPDATE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AslDeviceOverviewNetworkAPI__["f" /* updateAslDeviceDetails */])(action.data.dispatcher,action.data.stateValues);return state;case"DELETE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AslDeviceOverviewNetworkAPI__["a" /* deleteAslDeviceDetails */])(action.data.dispatcher,action.data.mac);return state;case"UPDATE_DEVICE_MAC":Object(__WEBPACK_IMPORTED_MODULE_0__network_AslDeviceOverviewNetworkAPI__["g" /* updateAslDeviceMac */])(action.data.dispatcher,action.data.stateValues,action.data.mac);return state;case"UPDATE_ASL_CONFIGURATION":Object(__WEBPACK_IMPORTED_MODULE_0__network_AslDeviceOverviewNetworkAPI__["e" /* updateAslConfiguration */])(action.data.dispatcher,action.data.configurations,action.data.mac);return state;case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});case"UPDATE_MONITORING_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AslDeviceOverviewNetworkAPI__["h" /* updateAslMonitoringDetails */])(action.data.dispatcher,action.data.stateValues,action.data.mac);return state;default:return state;}};

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAslDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAslStatusDetails;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteAslDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["d"] = setAslDeviceDetails;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateAslDeviceMac; });
/* harmony export (immutable) */ __webpack_exports__["f"] = updateAslDeviceDetails;
/* unused harmony export updateAslDivertConfig */
/* unused harmony export deleteAslDivertConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateAslConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateAslMonitoringDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datamodel_AslAssetModelResource__ = __webpack_require__(846);
var _this=this;var getAslDeviceStatusDetails=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatcher,model){var request,startTime,args,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["X" /* getNodeId */])(),macAddressList:model.macAddressArray};startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_37" /* ENDPOINT_GET_ASL_STATUS */]);_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 5:response=_context3.sent;if(response.status===200){Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAslDeviceStatusDetails",true,false);mergeStatusToModel(response,model);}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAslDeviceStatusDetails",false,isFault);request.macAddressList.forEach(function(macAddress){model.aslDeviceInformation[macAddress].assetStatus=__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_109" /* LOADING_FAILED */];});}dispatcher({type:"RECEIVE_DATA",data:model});case 8:case"end":return _context3.stop();}}},_callee3,this);}));return function getAslDeviceStatusDetails(_x7,_x8){return _ref3.apply(this,arguments);};}();var getAslDeviceDetails=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatcher,request){var startTime,response,isSuccess,isFault,aslDeviceInformation;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:// Get assets
startTime=Date.now();_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["g" /* getAssets */])(request.nodeId,request.assetType);case 3:response=_context4.sent;isSuccess=response.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(response.status);// Extract data
aslDeviceInformation=extractAslDeviceInformation(response);// Fork status call
if(!aslDeviceInformation.macAddressArray){_context4.next=10;break;}_context4.next=10;return getAslDeviceStatusDetails(dispatcher,aslDeviceInformation);case 10:// Return data to page
dispatcher({type:"RECEIVE_DATA",data:aslDeviceInformation});// Log operation
Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAslDeviceDetails",isSuccess,isFault);case 12:case"end":return _context4.stop();}}},_callee4,this);}));return function getAslDeviceDetails(_x9,_x10){return _ref4.apply(this,arguments);};}();var setAssetLabelDeprecatedAslDeviceDetails=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatcher,request){var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:startTime=Date.now();Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetLabel,request.assetStatus).then(function(result){if(result.status===200){Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteAslDeviceDetails",true,false);}else{var isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(result.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteAslDeviceDetails",false,isFault);dispatcher({type:"RECEIVE_DATA",data:[]});}});case 2:case"end":return _context5.stop();}}},_callee5,this);}));return function setAssetLabelDeprecatedAslDeviceDetails(_x11,_x12){return _ref5.apply(this,arguments);};}();var addAslDeviceDetails=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatcher,request){var _this2=this;var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:startTime=Date.now();_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_29" /* setAliasToRequest */])(request);case 3:Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["a" /* addAsset */])(request).then(function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(result){var isFault,getAssetResult,responseSetAssetStatus,responseUpdateAsset,isFaultInUpdate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(result.status);if(!(result.status===200)){_context6.next=5;break;}Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAslDeviceDetails",true,false);_context6.next=28;break;case 5:_context6.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 7:getAssetResult=_context6.sent;if(Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(getAssetResult.data.asset.assetDetails.assetStatus)){_context6.next=12;break;}alert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["B" /* ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET */]);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAslDeviceDetails",false,isFault);return _context6.abrupt("return");case 12:_context6.next=14;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]);case 14:responseSetAssetStatus=_context6.sent;if(!(responseSetAssetStatus.status!==200)){_context6.next=19;break;}alert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAslDeviceDetails",false,isFault);return _context6.abrupt("return");case 19:_context6.next=21;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 21:responseUpdateAsset=_context6.sent;if(!(responseUpdateAsset.status!==200)){_context6.next=27;break;}isFaultInUpdate=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(responseUpdateAsset.status);alert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAslDeviceDetails",false,isFaultInUpdate);return _context6.abrupt("return");case 27:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAslDeviceDetails",true,false);case 28:fetchAslDeviceDetails(dispatcher);case 29:case"end":return _context6.stop();}}},_callee6,_this2);}));return function(_x15){return _ref7.apply(this,arguments);};}());case 4:case"end":return _context7.stop();}}},_callee7,this);}));return function addAslDeviceDetails(_x13,_x14){return _ref6.apply(this,arguments);};}();var updateAslAsset=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatcher,request){var setAssetStatusResponse,startTime,getAssetResult,updateAssetResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]);case 2:setAssetStatusResponse=_context8.sent;if(!(setAssetStatusResponse.status!==200)){_context8.next=7;break;}alert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);fetchAslDeviceDetails(dispatcher);return _context8.abrupt("return");case 7:// Update asset details
startTime=Date.now();_context8.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_29" /* setAliasToRequest */])(request);case 10:_context8.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 12:getAssetResult=_context8.sent;_context8.next=15;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 15:updateAssetResponse=_context8.sent;isSuccess=updateAssetResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(updateAssetResponse.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAslDeviceDetails",isSuccess,isFault);fetchAslDeviceDetails(dispatcher);case 20:case"end":return _context8.stop();}}},_callee8,this);}));return function updateAslAsset(_x16,_x17){return _ref8.apply(this,arguments);};}();var updateAslMonitoringSchedule=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatcher,request){var startTime,getAssetResult,updateAssetInPlaceResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:// Update asset details
startTime=Date.now();_context9.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 3:getAssetResult=_context9.sent;_context9.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["l" /* updateAssetInPlace */])(request,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.lastUpdateTime;},null));case 6:updateAssetInPlaceResponse=_context9.sent;isSuccess=updateAssetInPlaceResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(updateAssetInPlaceResponse.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAslDeviceDetails",isSuccess,isFault);fetchAslDeviceDetails(dispatcher);case 11:case"end":return _context9.stop();}}},_callee9,this);}));return function updateAslMonitoringSchedule(_x18,_x19){return _ref9.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="ASL_DEVICE_DETAILS";function fetchAslDeviceDetails(dispatcher){var request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["K" /* ASL_ASSET_TYPE */]};getAslDeviceDetails(dispatcher,request);}function fetchAslStatusDetails(dispatcher,model){getAslDeviceStatusDetails(dispatcher,model);}function deleteAslDeviceDetails(dispatcher,mac){var request={assetLabel:{type:"MAC_ADDRESS",value:mac},assetStatus:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_19" /* DEPRECATED */]};setAssetLabelDeprecatedAslDeviceDetails(dispatcher,request);}function setAslDeviceDetails(dispatcher,stateValues){stateValues.mac=stateValues.mac.toLowerCase();var request=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["K" /* ASL_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]);addAslDeviceDetails(dispatcher,request);}var updateAslDeviceMac=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher,stateValues,mac){var startTime,assetLabel,assetResult,nodeId,assetStatus;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:startTime=Date.now();assetLabel=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["C" /* getAssetLabelFromMac */])(stateValues.mac.toLowerCase());_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(assetLabel);case 4:assetResult=_context.sent;nodeId=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.nodeId;},null);assetStatus=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.assetStatus;},null);if(assetStatus&&!Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(assetStatus)){alert(Object(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_225" /* getUpdateAssetMessageAlertWithSite */])(nodeId));Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAslDeviceDetails",false,false);}else{deleteAslDeviceDetails(dispatcher,mac);setAslDeviceDetails(dispatcher,stateValues);}case 8:case"end":return _context.stop();}}},_callee,this);}));return function updateAslDeviceMac(_x,_x2,_x3){return _ref.apply(this,arguments);};}();function updateAslDeviceDetails(dispatcher,stateValues){var request=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["K" /* ASL_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]);updateAslAsset(dispatcher,request);}var updateAslDivertConfig=function updateAslDivertConfig(result,divertConfig){var temp=[divertConfig];if(Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["i" /* checkNullAndUndefinedAttribute */])(result.assetDetails.assetAttributes.divertConfig)){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=JSON.parse(result.assetDetails.assetAttributes.divertConfig)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var object=_step.value;if(object.divertCode!==divertConfig.divertCode){temp.push(object);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}result.assetDetails.assetAttributes.divertConfig=JSON.stringify(temp);return result;};var deleteAslDivertConfig=function deleteAslDivertConfig(result,divertCode){var temp=[];if(divertCode!==__WEBPACK_IMPORTED_MODULE_1__util_Constants__["E" /* ALL_CONFIG */]){if(Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["i" /* checkNullAndUndefinedAttribute */])(result.assetDetails.assetAttributes.divertConfig)){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=JSON.parse(result.assetDetails.assetAttributes.divertConfig)[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var key=_step2.value;if(key.divertCode!==divertCode)temp.push(key);}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}}result.assetDetails.assetAttributes.divertConfig=JSON.stringify(temp);return result;};var updateAslConfiguration=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatcher,configurations,mac){var getAssetResult,startTime,alias,updatedAsset,updateResult,isUpdateSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 2:getAssetResult=_context2.sent;// Merge current configuration into existing configuration and update
startTime=Date.now();_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["B" /* getAliasFromParent */])();case 6:alias=_context2.sent;updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_5__datamodel_AslAssetModelResource__["a" /* updateConfigurationsInAslAssetObject */])(getAssetResult.data.asset,configurations,alias);_context2.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(updatedAsset,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 10:updateResult=_context2.sent;isUpdateSuccess=updateResult.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(updateResult.status);fetchAslDeviceDetails(dispatcher);// Log operation
isUpdateSuccess?alert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["D" /* ALERT_UPDATE_SUCCESS_ASSET_MESSAGE */]):alert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAslConfiguration",isUpdateSuccess,isFault);case 16:case"end":return _context2.stop();}}},_callee2,_this);}));return function updateAslConfiguration(_x4,_x5,_x6){return _ref2.apply(this,arguments);};}();var extractAslDeviceInformation=function extractAslDeviceInformation(result){var model={aslDeviceInformation:{},macAddressArray:[]};if("data"in result&&"assetDetailsList"in result.data){result.data.assetDetailsList.forEach(function(aslDeviceDetail){if(aslDeviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]){model.macAddressArray.push(aslDeviceDetail.assetAttributes.mac);var deviceConfig=JSON.parse(aslDeviceDetail.assetAttributes.deviceConfig);model.aslDeviceInformation[aslDeviceDetail.assetAttributes.mac]={name:aslDeviceDetail.assetAttributes.name,mac:aslDeviceDetail.assetAttributes.mac,ip:aslDeviceDetail.assetAttributes.ip,id:deviceConfig.id,responsePort:deviceConfig.responsePort,inductLocation:deviceConfig.inductLocation,userId:deviceConfig.userId,port:aslDeviceDetail.assetAttributes.port,vendorAttributes:aslDeviceDetail.vendorAttributes||__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */],assetStatus:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_110" /* LOADING_STRING */],deviceType:aslDeviceDetail.assetAttributes.deviceType,assetType:aslDeviceDetail.assetType,divertConfig:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(aslDeviceDetail.assetAttributes.divertConfig);},[]),startTime:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(aslDeviceDetail.assetAttributes.monitoring).startTime;},"0"),endTime:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(aslDeviceDetail.assetAttributes.monitoring).endTime;},"0"),reason:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(aslDeviceDetail.assetAttributes.monitoring).reason;},"")};}});}return model;};function mergeStatusToModel(response,model){if("data"in response&&"aslStatusList"in response.data){response.data.aslStatusList.forEach(function(singleAslDeviceStatusDetail){model.aslDeviceInformation[singleAslDeviceStatusDetail.mac].assetStatus=singleAslDeviceStatusDetail.status;});}}var updateExistingAssetAttributes=function updateExistingAssetAttributes(asset,stateValues){var updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["t" /* deepCopyObject */])(asset);updatedAsset.assetDetails.assetAttributes.monitoring=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(stateValues);},asset.assetDetails.assetAttributes.monitoring);return updatedAsset;};var updateAslMonitoringDetails=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatcher,stateValues,mac){var getAssetResult,updatedAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 2:getAssetResult=_context10.sent;updatedAsset=updateExistingAssetAttributes(getAssetResult.data.asset,stateValues);updateAslMonitoringSchedule(dispatcher,updatedAsset);case 5:case"end":return _context10.stop();}}},_callee10,this);}));return function updateAslMonitoringDetails(_x20,_x21,_x22){return _ref10.apply(this,arguments);};}();

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateConfigurationsInAslAssetObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Util__ = __webpack_require__(5);
var updateConfigurationsInAslAssetObject=function updateConfigurationsInAslAssetObject(asset,configurations,alias){var updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["t" /* deepCopyObject */])(asset);updatedAsset.assetDetails.alias=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return alias.toString();},"");updatedAsset.assetDetails.assetAttributes.divertConfig=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(configurations.divertConfig);},"[]");return updatedAsset;};

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AdtaDeviceOverviewContext__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modal_AddAdtaSingleDeviceModal__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_FeatureUtility__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__commonui_DeleteSingleDeviceModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__commonui_EditMacAddressModal__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__commonui_DisableMonitoringModal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__util_ConditionalWrapping__ = __webpack_require__(91);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AdtaDeviceOverview=function AdtaDeviceOverview(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_AdtaDeviceOverviewContext__["a" /* AdtaDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_27__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorized=_useContext2.isAuthorized;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),openAddModal=_useState2[0],setOpenAddModal=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openDeleteModal=_useState4[0],setOpenDeleteModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),openEditMacModal=_useState6[0],setOpenEditMaceModal=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState8=_slicedToArray(_useState7,2),openActionsMenu=_useState8[0],setOpenActionsMenu=_useState8[1];var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),selected=_useState10[0],setSelected=_useState10[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),openDisableMonitoringModal=_useState12[0],setOpenDisableMonitoringModal=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),mac=_useState14[0],setMac=_useState14[1];var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=true;setOpenActionsMenu(_open);},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=false;setOpenActionsMenu(_open);},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openAddModal&&!openDeleteModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["D" /* getAssetRefreshInterval */])());var statusInterval=setInterval(function(){if(!document.hidden){getStatusData();}},Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_11" /* getStatusRefreshInterval */])());return function(){clearInterval(interval);clearInterval(statusInterval);};}},[openAddModal,openDeleteModal]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,viewModel.adtaDeviceInformation.length);},[viewModel.adtaDeviceInformation]);var onSort=function onSort(sortDetails){dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};var updateData=function updateData(stateValues,mac){dispatch({type:'UPDATE_MONITORING_DATA',data:{dispatcher:dispatch,stateValues:stateValues,mac:mac}});};var onClickDisableMonitoring=function onClickDisableMonitoring(mac){setMac(mac);setOpenDisableMonitoringModal(true);};var onClickEnableMonitoring=function onClickEnableMonitoring(startTime,reason,mac){var stateValues={"startTime":startTime,"endTime":Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["I" /* getCurrentDate */])().toString(),"reason":reason};updateData(stateValues,mac);getData();};var renderDeviceMonitoring=function renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{style:{color:monitoringStatusColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:monitoringStatusId,defaultMessage:monitoringStatusDefaultMessage}));};var sortedDeviceList=Object.values(viewModel.adtaDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){var _viewModel$sortPref=viewModel.sortPref,column=_viewModel$sortPref.column,direction=_viewModel$sortPref.direction;var compareValue=void 0;if(Object.keys(__WEBPACK_IMPORTED_MODULE_13__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */]).includes(column)){if(column==="vendor"){compareValue=Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column]+a.vendorAttributes["spec_version"],b.vendorAttributes[column]+b.vendorAttributes["spec_version"]);}else if(column==="hamper_vendor"){compareValue=Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column]+a.vendorAttributes["hamper_version"],b.vendorAttributes[column]+b.vendorAttributes["hamper_version"]);}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column],b.vendorAttributes[column]);}}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_32" /* sortComparator */])(a[column],b[column]);}if(direction===__WEBPACK_IMPORTED_MODULE_13__util_Constants__["J" /* ASCENDING */]){return compareValue;}else{return-compareValue;}});var getData=function getData(){setOpenAddModal(false);setOpenDeleteModal(false);setOpenDisableMonitoringModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var getStatusData=function getStatusData(){dispatch({type:'LOAD_STATUS',data:{dispatcher:dispatch}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var onClickEditDevice=function onClickEditDevice(mac){setSelected(mac);setOpenAddModal(true);};var onClickRemove=function onClickRemove(mac){setSelected(mac);setOpenDeleteModal(true);};var onClickAddEditConfig=function onClickAddEditConfig(){setSelected("");setOpenAddModal(true);};var onClickChangeMac=function onClickChangeMac(mac){setSelected(mac);setOpenEditMaceModal(true);};var getAdtaStateValues=function getAdtaStateValues(mac){if(!mac)return{};var device=viewModel.adtaDeviceInformation[mac];if(!device)return{};var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};return{mac:mac,ip:device.ip,name:device.name,deviceType:device.deviceType,port:device.port,deviceConfig:JSON.stringify({type:__WEBPACK_IMPORTED_MODULE_10__util_Util__["e" /* assetTypeToConfigTypeDict */].typeADTA,id:device.id}),vendorAttributes:device.vendorAttributes,monitoring:JSON.stringify(deviceMonitoring),sorterConfig:JSON.stringify(viewModel.sorterConfig[mac]),sorterTestPackage:JSON.stringify(viewModel.sorterTestPackageConfig[mac])};};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default.a,{position:"top",title:intl.formatMessage({id:'tooltip.scrolltobottom',defaultMessage:'Scroll to bottom'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"alert.device",defaultMessage:"No device present for this station."})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"device.name",defaultMessage:"Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"device.mac_ip",defaultMessage:"MAC/IP"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_24__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.connectionstatus'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"connection",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"device.connection",defaultMessage:"Connection Status"})))),__WEBPACK_IMPORTED_MODULE_19__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_19__util_FeatureUtility__["a" /* FEATURES */].IS_ADTA_DEVICE_HEALTH_STATUS_API_ENABLED)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_24__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.pingstatus'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"pingStatus",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"device.pingStatus",defaultMessage:"Ping Status"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"device.monitoring",defaultMessage:"Monitoring Status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"vendor"},Object(__WEBPACK_IMPORTED_MODULE_24__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'device.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"sorter_type"},Object(__WEBPACK_IMPORTED_MODULE_24__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'device.sorter_type'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"hamper_vendor"},Object(__WEBPACK_IMPORTED_MODULE_24__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'device.hamper_vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"device.action",defaultMessage:"Action"}))),sortedDeviceList.map(function(device,index){var vendorAttributes=device.vendorAttributes;var monitoring=Object(__WEBPACK_IMPORTED_MODULE_26__util_Validations__["u" /* checkDeviceMonitoringEnabled */])(Number(device.startTime),Number(device.endTime));var _getMonitoringStatusD=Object(__WEBPACK_IMPORTED_MODULE_26__util_Validations__["F" /* getMonitoringStatusDetails */])(monitoring),monitoringStatusColor=_getMonitoringStatusD.monitoringStatusColor,monitoringStatusId=_getMonitoringStatusD.monitoringStatusId,monitoringStatusDefaultMessage=_getMonitoringStatusD.monitoringStatusDefaultMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{key:index,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),device.deviceType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.mac),device.ip,":",device.port)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"center"},device.assetStatus?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{color:device.assetStatus.toUpperCase()===__WEBPACK_IMPORTED_MODULE_13__util_Constants__["b" /* ACTIVE */]||device.assetStatus===__WEBPACK_IMPORTED_MODULE_13__util_Constants__["_6" /* CONNECTED */]?__WEBPACK_IMPORTED_MODULE_13__util_Constants__["X" /* BLUE_COLOR */]:__WEBPACK_IMPORTED_MODULE_13__util_Constants__["_149" /* ORANGE_COLOR */],textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.assetStatus),device.assetStatus===__WEBPACK_IMPORTED_MODULE_13__util_Constants__["_23" /* DISCONNECTED */]&&device.lastConnectionTime&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:"smaller",whiteSpace:"nowrap"}},Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["w" /* formatTimestampToReadable */])(device.lastConnectionTime))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"loading.text",defaultMessage:"Loading..."})),__WEBPACK_IMPORTED_MODULE_19__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_19__util_FeatureUtility__["a" /* FEATURES */].IS_ADTA_DEVICE_HEALTH_STATUS_API_ENABLED)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"center"},device.pingStatus?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{color:device.pingStatus===__WEBPACK_IMPORTED_MODULE_13__util_Constants__["_163" /* REACHABLE */]?__WEBPACK_IMPORTED_MODULE_13__util_Constants__["X" /* BLUE_COLOR */]:__WEBPACK_IMPORTED_MODULE_13__util_Constants__["_149" /* ORANGE_COLOR */],textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.pingStatus),device.pingStatus===__WEBPACK_IMPORTED_MODULE_13__util_Constants__["_213" /* UNREACHABLE */]&&device.recentSuccessfulPingTime&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:"smaller",whiteSpace:"nowrap"}},Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["w" /* formatTimestampToReadable */])(device.recentSuccessfulPingTime))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"loading.text",defaultMessage:"Loading..."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_26__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][vendorAttributes.vendor]," ",__WEBPACK_IMPORTED_MODULE_26__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][vendorAttributes.spec_version])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_26__util_Validations__["o" /* SORTER_TYPE_DISPLAY_VALUES */][vendorAttributes.sorter_type])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_26__util_Validations__["c" /* HAMPER_VENDOR_DISPLAY_VALUES */][vendorAttributes.hamper_vendor]," ",__WEBPACK_IMPORTED_MODULE_26__util_Validations__["d" /* HAMPER_VERSION_DISPLAY_VALUES */][vendorAttributes.hamper_version])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_28__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_24__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"left"},child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"my-menu","aria-haspopup":"menu","aria-expanded":"false",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_13__util_Constants__["_202" /* THREE_DOTS */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu___default.a,{anchorNode:actionButtonRefs.current[index],open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEditDevice(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"actions.addDevice",defaultMessage:"Edit Device"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickRemove(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"actions.deleteDevice",defaultMessage:"Delete Device"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickChangeMac(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"actions.changeMac",defaultMessage:"Change device mac-address"})),monitoring.isMonitoringEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDisableMonitoring(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_disable",defaultMessage:"Disable Monitoring"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEnableMonitoring(device.startTime,device.reason,device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_enable",defaultMessage:"Enable Monitoring"}))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_28__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_24__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"end"},child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{onClick:onClickAddEditConfig,type:"primary",size:"small",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"device.add_device_button_modal",defaultMessage:"Add Device Configuration"}))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_28__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_24__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"end"},child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{onClick:function onClick(){return setOpenDeleteModal(true);},type:"tertiary",size:"small",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_22__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"button.delete",defaultMessage:"Delete device"}))})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__modal_AddAdtaSingleDeviceModal__["a" /* default */],{open:openAddModal,setOpen:setOpenAddModal,selected:selected,setSelected:setSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__commonui_DeleteSingleDeviceModal__["a" /* default */],{open:openDeleteModal,setOpen:setOpenDeleteModal,selected:selected,setSelected:setSelected,macAddressArray:viewModel.macAddressArray,dispatch:dispatch}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__commonui_EditMacAddressModal__["a" /* default */],{open:openEditMacModal,setOpen:setOpenEditMaceModal,selectedMac:selected,setSelectedMac:setSelected,dispatch:dispatch,stateValues:getAdtaStateValues(selected)}),openDisableMonitoringModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__commonui_DisableMonitoringModal__["a" /* default */],{mac:mac,state:openDisableMonitoringModal,onStateChange:setOpenDisableMonitoringModal,context:__WEBPACK_IMPORTED_MODULE_2__context_AdtaDeviceOverviewContext__["a" /* AdtaDeviceOverviewContext */],reducer:'UPDATE_MONITORING_DATA'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_intl__["d" /* injectIntl */])(AdtaDeviceOverview));

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(166));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(97));

var _emotion = __webpack_require__(11);

var _box = _interopRequireDefault(__webpack_require__(400));

var _propTypes2 = _interopRequireDefault(__webpack_require__(271));

var _parsers = __webpack_require__(272);

var _functional = __webpack_require__(98);

var _cxMemoized = _interopRequireDefault(__webpack_require__(168));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Identifies if the given size follows the format "grid-X"
var isGridSize = function isGridSize(size) {
  return typeof size === "string" && /^grid-/.test(size);
}; // Identifies if the given size is a plain percentage


var isPercentageSize = function isPercentageSize(size) {
  return typeof size === "string" && /^[0-9.]+%\s*$/.test(size);
}; // Turns "grid-X" (e.g. "grid-6") into a string percentage (e.g. "50%")


var getGridPercentage = function getGridPercentage(size, gridColumns) {
  return "".concat(Math.floor(10000 * parseInt(size.substr(5)) / gridColumns) / 100, "%");
}; // These styles stretch the inner div to fill the entire box so that a width or
// height applied to the box will also apply to the inner div.


var styles = (0, _emotion.css)({
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch"
});

var rowStyles = function rowStyles(widths) {
  return (0, _functional.memoizeByKeys)(function (_ref) {
    var wrap = _ref.wrap,
        spacing = _ref.spacing,
        alignment = _ref.alignment,
        alignmentHorizontal = _ref.alignmentHorizontal,
        alignmentVertical = _ref.alignmentVertical,
        reverse = _ref.reverse;
    var spacingValues = (0, _parsers.parseSpacing)(spacing);
    var verticalSpacing = spacingValues[0];
    var horizontalSpacing = spacingValues[1] || verticalSpacing;
    var flexAlignment = alignment && (0, _parsers.parseFlexAlignment)(alignment);
    return (0, _emotion.css)({
      width: "calc(100% + ".concat(horizontalSpacing, "px)"),
      display: "flex",
      flexDirection: reverse ? "row-reverse" : "row",
      flexWrap: wrap === "down" ? "wrap" : wrap === "up" ? "wrap-reverse" : undefined,
      alignItems: {
        top: "flex-start",
        bottom: "flex-end",
        center: "center",
        stretch: "stretch"
      }[flexAlignment ? flexAlignment[0] : alignmentVertical],
      justifyContent: {
        left: "flex-start",
        right: "flex-end",
        center: "center",
        justify: "space-between"
      }[flexAlignment ? flexAlignment[1] : alignmentHorizontal],
      // Reset the extra margins caused by the children on the right/bottom
      // edges. We can't do a simple reset on the first/last child because
      // there may be any number of children on the right/bottom edges if the
      // row wraps.
      margin: "0 -".concat(horizontalSpacing, "px ").concat(wrap === "none" ? 0 : "-".concat(verticalSpacing, "px"), " 0"),
      // Set margins and widths on the children of the row. Use !important to
      // override any existing styles.
      "& > *": {
        // Make sure that any borders or padding applied to the child don't throw
        // of the widths that we apply
        boxSizing: "border-box !important",
        // Set margins for horizontal spacing and vertical spacing if the row is
        // allowed to wrap (and clear other margins)
        margin: "0 ".concat(horizontalSpacing, "px ").concat(wrap === "none" ? 0 : verticalSpacing, "px 0 !important")
      }
    }, // If we've got an array of widths, apply each width to the child whose
    // index in the dom matches the widths's index in the array. If we've
    // got a single height, apply that to all children.
    Array.isArray(widths) ? widths.reduce(function (result, width, index) {
      result["& > *:nth-child(".concat(parseInt(index) + 1, ")")] = childStyles({
        width: width,
        horizontalSpacing: horizontalSpacing
      });
      return result;
    }, {}) : {
      "& > *": childStyles({
        width: widths,
        horizontalSpacing: horizontalSpacing
      })
    });
  }, ["wrap", "spacing", "alignment", "alignmentHorizontal", "alignmentVertical", "reverse"]);
};

var rowStylesWithUniqueWidths = (0, _functional.memoizeArray)(rowStyles);
var rowStylesWithUniformWidths = (0, _functional.memoize)(rowStyles);

var childStyles = function childStyles(_ref2) {
  var width = _ref2.width,
      horizontalSpacing = _ref2.horizontalSpacing;
  return {
    flex: width === "fill" ? "1 !important" : undefined,
    flexShrink: width !== "fill" ? "0 !important" : undefined,
    // If size matches "grid-X" then set the width to `X/gridColumns`
    // percent, subtracting any horizontal spacing to ensure that the
    // element doesn't overflow the grid.
    width: isGridSize(width) ? "calc(".concat(getGridPercentage(width, Row.gridColumns), " - ").concat(horizontalSpacing, "px) !important") : // If size matches a percentage value then set the width to the percentage
    // minus any horizontal spacing. This ensures that a child set to 25% will
    // exactly match a child set to grid-3, and that four children set to 25%
    // will fit on the same row along with their horizontal spacing.
    isPercentageSize(width) ? "calc(".concat(width, " - ").concat(horizontalSpacing, "px) !important") : // If the size is a plain CSS value then just use that directly
    width !== "fill" && width !== "fit" && width !== undefined && width !== null && width !== "" ? "".concat(width).concat(typeof width === "number" ? "px" : "", " !important") : // And lastly for fit & fill values leave it up to flexbox
    undefined
  };
};
/**
 * The Row component lines children up horizontally in a row with even spacing
 * in-between them. If a value is provided for the `wrap` property then the Row
 * component can also be used to stack elements with even vertical spacing
 * between them.
 */


function Row(props) {
  // A row with an explicit height cannot wrap
  var wrap = props.height === undefined ? props.wrap : "none"; // We need to memoize differently based on whether we got an array, object,
  // or scalar for the "widths" property

  var rowStylesFunc = Array.isArray(props.widths) ? rowStylesWithUniqueWidths : rowStylesWithUniformWidths;
  var rowStyles = rowStylesFunc(props.widths)(_objectSpread(_objectSpread({}, props), {}, {
    wrap: wrap
  })); // Apply the row styles to an extra div inside the box so margins that are
  // applied to the box (e.g. if the row is nested in another row) don't
  // conflict with the margins that are applied by `rowStyles`.

  /* eslint-disable-next-line react/no-children-prop */

  return /*#__PURE__*/_react["default"].createElement(_box["default"], _objectSpread(_objectSpread({}, props), {}, {
    className: (0, _cxMemoized["default"])(styles, props.className),
    children: undefined
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: rowStyles
  }, props.children));
}

Row.propTypes =  false ? {
  /**
   * **Deprecated:** Use `alignmentHorizontal` or `alignmentVertical` instead.
   *
   * Specify the alignment of the elements inside the row. This should be
   * a string containing a vertical alignment value and a horizontal alignment
   * value separated by a space (e.g. "top center").
   *
   * @deprecated 4.x
   */
  alignment: _propTypes2["default"].flexAlignment("row"),

  /**
   * Specify the horizontal alignment of the elements inside the row.
   *
   * This should be used instead of the deprecated `alignment` prop. If the `alignment`
   * prop is set that will override this prop for backwards-compatibility
   * reasons.
   *
   * @since 4.x
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["left", "center", "right", "justify"]),

  /**
   * Specify the vertical alignment of the elements inside the row.
   *
   * This should be used instead of the deprecated `alignment` prop. If the `alignment`
   * prop is set that will override this prop for backwards-compatibility
   * reasons.
   *
   * @since 4.x
   */
  alignmentVertical: _propTypes["default"].oneOf(["top", "center", "bottom", "stretch"]),

  /**
   * Set the column's background color using a preset, or using a string
   * containing any valid CSS color.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary"]), _propTypes["default"].string]),

  /**
   * The elements to line up in a row. Any elements can be supplied here, although if
   * only one child is supplied the row will not add much value (it's meant
   * for aligning multiple elements). If you only have one child, consider using
   * the `Box` component instead.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * Set the height of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum height of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum width of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum height of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum width of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * If set to true this will reverse the order in which the elements in the row
   * are rendered (the first element will be rendered where the last normally
   * would, and vice-versa).
   */
  reverse: _propTypes["default"].bool,

  /**
   * Set the spacing between elements in the row using a preset.
   *
   * Two spacing values are allowed (separated by a space) if the `wrap` prop is
   * set. In this case the first value will be used as the vertical spacing
   * between elements and the second value will be used as the horizontal
   * spacing.
   */
  spacing: _propTypes2["default"].spacing(2),

  /**
   * Apply padding to the component.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"small medium"` for small padding on the top/bottom and
   * medium padding on the left/right).
   */
  spacingInset: _propTypes2["default"].spacing(4),

  /**
   * The HTML tag to use when rendering the component to the DOM.
   */
  tag: _propTypes["default"].string,

  /**
   * Set the style of the row using one of Meridian's Box component styles.
   * If omitted the row will not have any decorative visual style applied to
   * it.
   */
  type: _propTypes["default"].oneOf(["outline", "fill"]),

  /**
   * Set the width of the row using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the width of each element in the row.
   *
   * If a single width is provided then it will be applied to every element in
   * the row. If an array of widths is provided then each width will be
   * applied to the element in the row that exists at the same index as the
   * width in the array (e.g. `[<element 0 width>, <element 1 width>, null, <element 3 width>]`).
   *
   * The possible values for each width are:
   *   - `number` - A fixed pixel width.
   *   - `string` - Any valid CSS width.
   *   - `"fit"` - The element's width will shrink to fit its contents.
   *   - `"fill"` - The element's width will fill all remaining space in the row.
   *     If this value is set on multiple elements, they will share the remaining
   *     space in the row equally.
   *   - `"grid-<x>"` - The element will take up "x" grid units on a 12-column grid
   *     ("x" can be 1-12).
   */
  widths: _propTypes["default"].oneOfType([_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]), _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),

  /**
   * Set this to allow elements that overflow the width of the row to wrap. If
   * this is set to `"down"` then elements that overflow to the right will wrap
   * down below the other elements. If set to `"up"` then the overflowing
   * elements will wrap up above the other elements.
   */
  wrap: _propTypes["default"].oneOf(["up", "down", "none"])
} : {};
Row.defaultProps = {
  widths: "fit",
  wrap: "none",
  spacing: "medium",
  alignmentVertical: "center",
  alignmentHorizontal: "left"
};
Row.gridColumns = 12;
var _default = Row;
exports["default"] = _default;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(850);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(97));

var _box = _interopRequireDefault(__webpack_require__(852));

var _emotion = __webpack_require__(11);

var _propTypes2 = _interopRequireDefault(__webpack_require__(271));

var _parsers = __webpack_require__(272);

var _theme = __webpack_require__(273);

var _token = __webpack_require__(113);

var _functional = __webpack_require__(98);

var _cxMemoized = _interopRequireDefault(__webpack_require__(168));

var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      borderColor = _ref.borderColor,
      borderWidth = _ref.borderWidth,
      borderRadius = _ref.borderRadius,
      width = _ref.width,
      height = _ref.height,
      minWidth = _ref.minWidth,
      minHeight = _ref.minHeight,
      maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight,
      spacingInset = _ref.spacingInset;
  return (0, _emotion.css)({
    boxSizing: "border-box",
    // If we have a border radius defined then clip content so that it doesn't
    // bleed out the corners
    overflow: borderRadius ? "hidden" : undefined,
    padding: (0, _parsers.parseSpacing)(spacingInset).map(function (value) {
      return "".concat(value, "px");
    }).join(" "),
    borderStyle: borderWidth && borderColor ? "solid" : undefined,
    borderWidth: borderWidth,
    borderColor: borderColor,
    borderRadius: borderRadius,
    backgroundColor: backgroundColor,
    width: width,
    height: height,
    minWidth: minWidth,
    maxWidth: maxWidth,
    minHeight: minHeight,
    maxHeight: maxHeight
  });
}, ["backgroundColor", "borderColor", "borderWidth", "borderRadius", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "spacingInset"]);
var themedStyles = (0, _functional.memoize)(function (t) {
  return (0, _functional.memoizeByKeys)(function (_ref2) {
    var type = _ref2.type,
        backgroundColor = _ref2.backgroundColor,
        width = _ref2.width,
        height = _ref2.height,
        minWidth = _ref2.minWidth,
        minHeight = _ref2.minHeight,
        maxWidth = _ref2.maxWidth,
        maxHeight = _ref2.maxHeight,
        spacingInset = _ref2.spacingInset;
    return styles({
      backgroundColor: backgroundColor ? (0, _token.getToken)(t.tokens, "themeBackground", [backgroundColor, "default"]) || backgroundColor : t("backgroundColor", type),
      borderColor: t("borderColor", type),
      borderWidth: t("borderWidth"),
      borderRadius: t("borderRadius", type),
      width: width,
      height: height,
      minWidth: minWidth,
      minHeight: minHeight,
      maxWidth: maxWidth,
      maxHeight: maxHeight,
      spacingInset: spacingInset
    });
  }, ["type", "backgroundColor", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "spacingInset"]);
});
/**
 * The Box component can also be used to visually separate part of the layout by
 * applying an outline or fill.
 *
 * It can also be used as a layout component (similar to the Row and Column
 * components) to apply width and inset padding to any part of the layout (with
 * or without an outline or fill).
 */

function Box(props) {
  // Only pull in theme tokens if we're styling the box
  return props.backgroundColor || props.type ? /*#__PURE__*/_react["default"].createElement(ThemedBox, props, props.children) : /*#__PURE__*/_react["default"].createElement(props.tag, {
    className: (0, _cxMemoized["default"])(styles(props), props.className),
    id: props.id,
    tabIndex: props.tabIndex
  }, props.children);
}

Box.propTypes =  false ? {
  /**
   * Set the box's background color using a preset, or using a string
   * containing any valid CSS color.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary", "alternatePrimary", "alternateSecondary"]), _propTypes["default"].string]),

  /**
   * The elements to render inside the box.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * Set the height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Adds an [id](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id) to the component.
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   *
   * @since 4.x
   */
  id: _propTypes["default"].string,

  /**
   * Set the maximum height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum height of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Apply padding to the component.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"small medium"` for small padding on the top/bottom and
   * medium padding on the left/right).
   */
  spacingInset: _propTypes2["default"].spacing(4),

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The HTML tag to use when rendering the component to the DOM.
   */
  tag: _propTypes["default"].string,

  /**
   * The type of visuals to apply to the box. If this is omitted the box will
   * not have any decorative styles and can be used purely for layout purposes.
   */
  type: _propTypes["default"].oneOf(["outline", "fill"]),

  /**
   * Set the width of the box using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
Box.defaultProps = {
  tag: "div",
  spacingInset: "none"
};
/* eslint-disable react/prop-types */

/**
 * This component renders a themed box. This is only used if themed styles are
 * actually applied to the box. Otherwise we can skip all the extra work that
 * goes into theming.
 */

function ThemedBox(props) {
  var t = (0, _theme.useTheme)(_box["default"], "box");
  return /*#__PURE__*/_react["default"].createElement(props.tag, {
    className: (0, _cxMemoized["default"])(themedStyles(t)(props), props.className),
    id: props.id,
    tabIndex: props.tabIndex
  }, props.children);
}
/* eslint-enable react/prop-types */


var _default = Box;
exports["default"] = _default;

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = function(tokens) {
  return {
    boxBackgroundColorOutline: tokens.themeBackgroundPrimaryDefault,
    boxBackgroundColorFill: tokens.themeBackgroundSecondaryDefault,
    boxBorderWidth: 1,
    boxBorderRadiusOutline: 4,
    boxBorderRadiusFill: 4,
    boxBorderColorOutline: tokens.themeBorderSecondaryDefault
  }
};

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var shim = function shim() {};

shim.isRequired = shim;

var getShim = function getShim() {
  return shim;
}; // Important!
// Keep this list in sync with production version in `./prop-types.js`.


var size = shim;
var flexAlignment = getShim;
var spacing = getShim;
var alignment = shim;
var _default = {
  size: size,
  flexAlignment: flexAlignment,
  spacing: spacing,
  alignment: alignment
};
exports["default"] = _default;

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = {
  spacing100: 2,
  spacing200: 4,
  spacing300: 8,
  spacing400: 16,
  spacing450: 24,
  spacing500: 32,
  spacing600: 64,
  spacingNone: 0,
  spacingXxsmall: 2,
  spacingXsmall: 4,
  spacingSmall: 8,
  spacingMedium: 16,
  spacingLarge: 32,
  spacingXlarge: 64
};

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _upperFirst = _interopRequireDefault(__webpack_require__(401));

var pascalCase = function pascalCase(strings) {
  return strings.map(_upperFirst["default"]).join("");
};

var _default = pascalCase;
exports["default"] = _default;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var lowerFirst = function lowerFirst(str) {
  return str ? str.charAt(0).toLowerCase() + str.slice(1) : "";
};

var _default = lowerFirst;
exports["default"] = _default;

/***/ }),
/* 857 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _emotion = __webpack_require__(11);

/**
 * Global styles
 */
(0, _emotion.injectGlobal)({
  /**
   * Set font smoothing technique
   *
   * On macOS the default font smoothing technique (subpixel antialiasing) is
   * optimized for dark text on light backgrounds. Unfortunately when applied to
   * light text on dark backgrounds this results in extra heavy, fuzzy text. The
   * following two properties turn off subpixel antialiasing in webkit browsers
   * and Firefox on macOS when the display's pixel density is high enough to
   * support full-pixel aliasing without decreasing text legibility.
   */
  "@media screen and (-webkit-min-device-pixel-ratio: 2), screen and (min-resolution: 2dppx)": {
    body: {
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale"
    }
  },

  /**
   * HACK: Fix html5 tags in IE11
   *
   * IE11 won't apply styles correctly to newer html5 tags that it doesn't
   * recognize unless they have a "display" property set.
   */
  "main, nav, header, footer": {
    display: "block"
  }
});

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(167);

var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Style = Style;
exports.ThemeContext = exports.useTheme = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(166));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(97));

var _blueLight = _interopRequireDefault(__webpack_require__(860));

var _token = __webpack_require__(113);

var _functional = __webpack_require__(98);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Context for passing theme tokens down the tree.
 */
var ThemeContext = (0, _react.createContext)(_blueLight["default"]);
/**
 * Merge two token objects together.
 */

exports.ThemeContext = ThemeContext;
var mergeTokens = (0, _functional.memoizeCurry)(function (a, b) {
  return _objectSpread(_objectSpread({}, a), b);
}, 1);
/**
 * Takes in an object of theme tokens and a function or object of tokens to
 * theme.
 */

var applyTheme = (0, _functional.memoizeCurry)(function (themeTokens, tokens) {
  return typeof tokens === "function" ? mergeTokens(tokens(themeTokens))(themeTokens) : tokens ? mergeTokens(tokens)(themeTokens) : themeTokens;
}, 1);
/**
 * A hook that grants access to theme tokens. Optionally pass in themeable
 * tokens as a function or non-themeable tokens as an object to mix with the
 * theme tokens. If tokens are provided, a prefixKey can be passed to allow easier
 * selection of tokens with a common prefix. For example:
 *   const t = useTheme(buttonTokens, "button")
 *   const buttonBgColor = t("backgroundColor")
 */

var useTheme = function useTheme(tokens) {
  var prefixKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  var _legacyHelperForBackwardsCompatibilityDoNotUse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var themeTokens = (0, _react.useContext)(ThemeContext);
  var currentTokens = applyTheme(themeTokens)(tokens);
  return typeof _legacyHelperForBackwardsCompatibilityDoNotUse === "function" ? _legacyHelperForBackwardsCompatibilityDoNotUse(currentTokens) : _legacyHelperForBackwardsCompatibilityDoNotUse ? currentTokens : (0, _token.getTokenHelper)(prefixKey)(currentTokens);
};
/**
 * Set the theme. Changes are applied to all the component's descendants.
 */


exports.useTheme = useTheme;

function Theme(_ref) {
  var tokens = _ref.tokens,
      children = _ref.children;
  var contextTokens = (0, _react.useContext)(ThemeContext);
  var currentTokens = mergeTokens(contextTokens)(tokens);
  return /*#__PURE__*/_react["default"].createElement(ThemeContext.Provider, {
    value: currentTokens
  }, children);
}

Theme.propTypes =  false ? {
  /**
   * The components to apply the theme to.
   */
  children: _propTypes["default"].element.isRequired,

  /**
   * An object of theme tokens imported from the Meridian token library.
   */
  tokens: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])).isRequired
} : {};
/**
 * IMPORTANT: For backwards-compatibility only! Use the "useTheme" hook instead.
 */

function Style(_ref2) {
  var tokens = _ref2.tokens,
      map = _ref2.map,
      children = _ref2.children;
  return children(useTheme(tokens, "", map || true));
}

Style.propTypes = {
  children: _propTypes["default"].func.isRequired,
  map: _propTypes["default"].func,
  tokens: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])
};
var _default = Theme;
exports["default"] = _default;

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports = {
  themeForegroundPrimaryDefault: "#232F3E",
  themeForegroundPrimaryFocus: "#077398",
  themeForegroundPrimaryError: "#AD0A30",
  themeForegroundPrimaryDisabled: "#BBC0C1",
  themeForegroundSecondaryDefault: "#6C7778",
  themeForegroundSecondaryDisabled: "#E7E9E9",
  themeForegroundTertiaryDefault: "#949C9C",
  themeForegroundTertiaryHover: "#6C7778",
  themeForegroundTertiaryPressed: "#485050",
  themeForegroundTertiaryDisabled: "#ABB0B5",
  themeForegroundInvertedDefault: "#FFFFFF",
  themeForegroundAccentDefault: "#077398",
  themeForegroundAccentHover: "#055D7B",
  themeForegroundAccentPressed: "#03384B",
  themeForegroundAccentDisabled: "#C1DEE8",
  themeBorderPrimaryDefault: "#6C7778",
  themeBorderPrimaryDisabled: "#BBC0C1",
  themeBorderPrimaryFocus: "#00A8E1",
  themeBorderPrimaryError: "#CC0C39",
  themeBorderPrimaryWarning: "#DCB700",
  themeBorderSecondaryDefault: "#BBC0C1",
  themeBorderSecondaryFocus: "#00A8E1",
  themeBorderTertiaryDefault: "#E7E9E9",
  themeBorderAlternateDefault: "rgba(0, 0, 0, 0)",
  themeBorderAccentDefault: "#00A8E1",
  themeBorderAccentHover: "#077398",
  themeBorderAccentPressed: "#055D7B",
  themeBorderAccentDisabled: "#90C5D7",
  themeBorderAccentPreselected: "#7CCEE9",
  themeBorderAlternateAccentDefault: "#055D7B",
  themeBackgroundPrimaryDefault: "#FFFFFF",
  themeBackgroundPrimaryDisabled: "#F0F1F2",
  themeBackgroundSecondaryDefault: "#F0F1F2",
  themeBackgroundSecondaryError: "#FF7494",
  themeBackgroundSecondaryWarning: "#FCDE4D",
  themeBackgroundTertiaryDefault: "#E7E9E9",
  themeBackgroundTertiaryHover: "#BBC0C1",
  themeBackgroundTertiaryPressed: "#949C9C",
  themeBackgroundTertiaryDisabled: "#ECEDED",
  themeBackgroundAlternatePrimaryDefault: "#FFFFFF",
  themeBackgroundAlternatePrimarySelected: "#F0F1F2",
  themeBackgroundAlternatePrimaryHover: "#E7E9E9",
  themeBackgroundAlternatePrimaryPressed: "#BBC0C1",
  themeBackgroundAlternateSecondaryDefault: "#F9FAFA",
  themeBackgroundAlternateTertiaryDefault: "#FFFFFF",
  themeBackgroundAlternateTertiaryFocus: "#F9FAFA",
  themeBackgroundAccentDefault: "#B9E8F7",
  themeBackgroundAccentDisabled: "#86A4AF",
  themeBackgroundInvertedDefault: "#0B0C0C",
  themeBackgroundOverlayDefault: "rgba(11, 12, 12, 0.5)",
  themeBackgroundOverlayPressed: "rgba(11, 12, 12, 0.04)",
  themePalette50: "#E5F6FB",
  themePalette100: "#B9E8F7",
  themePalette200: "#7CCEE9",
  themePalette300: "#47C2EC",
  themePalette400: "#00A8E1",
  themePalette500: "#077398",
  themePalette600: "#055D7B",
  themePalette700: "#03384B",
  themePalette800: "#01222D",
  themePaletteMuted100: "#C1DEE8",
  themePaletteMuted200: "#90C5D7",
  themePaletteMuted300: "#86A4AF",
  themePaletteMuted400: "#204B5A",
  themePaletteMuted500: "#24586A",
  themePaletteMuted600: "#14181D"
};

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(77));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _popover = _interopRequireDefault(__webpack_require__(862));

var _optionList = _interopRequireWildcard(__webpack_require__(169));

var _rtl = __webpack_require__(80);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Renders a menu of options attached to another anchor element.
 *
 * NOTE: Do not mount a Menu inside an interactive element. The Menu's DOM
 * element will be rendered at the application root using a [React Portal](https://reactjs.org/docs/portals.html),
 * but events from the Menu will bubble up through the element where it was
 * mounted. If the element is interactive then this may result in unexpected
 * behavior (e.g. a click on the Menu being counted as a click on the element
 * where the Menu was mounted). The React team [recommends solving this](https://github.com/facebook/react/issues/11387#issuecomment-366142349)
 * by rendering the portal-based component *outside* of any interactive elements.
 */
var Menu = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Menu, _React$Component);

  var _super = _createSuper(Menu);

  function Menu() {
    var _this;

    (0, _classCallCheck2["default"])(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionListRef", undefined);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateOptionListRef", function (ref) {
      return _this.optionListRef = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOpen", function () {
      // Re-trigger the option list's "componentDidMount" when the option list is
      // actually visible. This is necessary because the things the option list
      // does on mount, like setting the scroll and transferring focus, only work
      // when it's visible.
      _this.optionListRef.componentDidMount();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClickItem", function (_ref) {
      var onClick = _ref.onClick,
          href = _ref.href,
          target = _ref.target;
      return function () {
        var anchorNode = _this.props.anchorNode; // Trigger the user-defined menu item action

        if (onClick) {
          onClick(href);
        } else if (href) {
          window.open(href, target || "_self");
        } // Transfer focus back to the menu anchor (this will close the menu)

        /* eslint-disable-next-line react/no-find-dom-node */


        _reactDom["default"].findDOMNode(anchorNode).focus(); // Clear the preselected menu item


        _this.setState({
          preselectedIndex: undefined
        });
      };
    });
    return _this;
  }

  (0, _createClass2["default"])(Menu, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.open || this.props.open;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props; // If a minWidth is not set and the menu is positioned above or below the
      // anchor node, set the minWidth to the width of the anchor node

      var minWidth = this.props.minWidth === undefined && (props.position === "top" || props.position === "bottom") ? "anchor" : this.props.minWidth;
      return /*#__PURE__*/_react["default"].createElement(_popover["default"], {
        indicatorArrow: false,
        open: props.open,
        onClose: props.onClose,
        onOpen: this.onOpen,
        anchorNode: props.anchorNode,
        minWidth: minWidth,
        position: (0, _rtl.getHorizontalDirection)(props.position),
        alignment: (0, _rtl.getHorizontalDirection)(props.alignment),
        spacingInset: "none",
        shrinkToFit: true,
        id: props.id
      }, /*#__PURE__*/_react["default"].createElement(_optionList["default"], {
        autoFocus: true,
        ref: this.updateOptionListRef,
        role: "menu"
      }, _react["default"].Children.map(props.children, function (option) {
        // It's important to accept falsey option because rendering null is
        // the standard way to "turn off" a conditional JSX element.
        if (!option) return null;
        var passThroughProps = (0, _filterPropsByPrefix["default"])(option.props, ["data-"]);
        return (
          /*#__PURE__*/
          // TODO: See https://sim.amazon.com/issues/MRDN-296 regarding the
          // empty label prop and the children-as-a-function below
          _react["default"].createElement(_optionList.OptionListItem, (0, _extends2["default"])({
            onClick: _this2.onClickItem(option.props),
            disabled: option.props.disabled,
            href: option.props.href,
            target: option.props.target,
            rel: option.props.rel,
            role: "menuitem",
            label: option.props["aria-label"] ? option.props["aria-label"] : ""
          }, passThroughProps), function () {
            return option.props.children;
          })
        );
      })));
    }
  }]);
  return Menu;
}(_react["default"].Component);

(0, _defineProperty2["default"])(Menu, "defaultProps", {
  alignment: "center"
});
Menu.propTypes =  false ? {
  /**
   * Drop MenuItem components in here.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Is the menu open?
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * This determines which side of the anchor node the menu appears on.
   */
  position: _propTypes["default"].oneOf(["top", "right", "end", "bottom", "left", "start"]).isRequired,

  /**
   * The menu will call this when it wants to close. The function provided
   * here should set the "open" prop to false.
   */
  onClose: _propTypes["default"].func.isRequired,

  /**
   * This determines how the menu is aligned with the anchor node. Note that
   * only certain values are valid depending on what the "position" prop is
   * set to. If the position is "top" or "bottom" then valid values here are
   * "left" or "start", "right" or "end", or "center". If the position is "left",
   * "start", "right", or "end" then valid values are "top", "bottom", or "center".
   */
  alignment: _propTypes["default"].oneOf(["top", "right", "end", "bottom", "left", "start", "center"]),

  /**
   * The node to anchor the menu to. This should be a focusable element. This
   * is not required to mount the menu, but it is required to open it.
   */
  anchorNode: _propTypes["default"].object,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.22.0
   */
  id: _propTypes["default"].string,

  /**
   * Define a minimum width for the menu. If the value of the "position" prop
   * is set to "top" or "bottom", this will default to the width of the anchor
   * node.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
} : {};
var _default = Menu;
exports["default"] = _default;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PopoverHeader", {
  enumerable: true,
  get: function get() {
    return _popoverHeader["default"];
  }
});
exports["default"] = void 0;

var _popover = _interopRequireDefault(__webpack_require__(863));

var _popoverHeader = _interopRequireDefault(__webpack_require__(402));

var _default = _popover["default"];
exports["default"] = _default;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(77));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _find = _interopRequireDefault(__webpack_require__(96));

var _noop = _interopRequireDefault(__webpack_require__(59));

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _keycode = _interopRequireDefault(__webpack_require__(72));

var _popover = _interopRequireDefault(__webpack_require__(203));

var _popoverHeader = _interopRequireDefault(__webpack_require__(402));

var _theme = __webpack_require__(24);

var _popoverBody = _interopRequireDefault(__webpack_require__(204));

var _popoverController = _interopRequireDefault(__webpack_require__(99));

var _utils = __webpack_require__(206);

var _useOnBlurContainer2 = _interopRequireDefault(__webpack_require__(873));

var _isElementOf = _interopRequireDefault(__webpack_require__(94));

var _focus = __webpack_require__(193);

var _rtl = __webpack_require__(80);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var isHeader = (0, _isElementOf["default"])(_popoverHeader["default"]);

var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
  return !prevProps.open && !nextProps.open;
};
/**
 * Renders a popover attached to another anchor element.
 *
 * NOTE: Do not mount a Popover inside an interactive element. The Popover's DOM
 * element will be rendered at the application root using a [React Portal](https://reactjs.org/docs/portals.html),
 * but events from the Popover will bubble up through the element where it was
 * mounted. If the element is interactive then this may result in unexpected
 * behavior (e.g. a click on the Popover being counted as a click on the element
 * where the Popover was mounted). The React team [recommends solving this](https://github.com/facebook/react/issues/11387#issuecomment-366142349)
 * by rendering the portal-based component *outside* of any interactive elements.
 */


var Popover = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var onOpenProp = _ref.onOpen,
      onKeyDownProp = _ref.onKeyDown,
      onClose = _ref.onClose,
      anchorNode = _ref.anchorNode,
      idProp = _ref.id,
      indicatorArrow = _ref.indicatorArrow,
      position = _ref.position,
      alignment = _ref.alignment,
      children = _ref.children,
      open = _ref.open,
      maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth,
      spacingInset = _ref.spacingInset,
      shrinkToFit = _ref.shrinkToFit;
  var popoverBody = (0, _react.useRef)();
  var id = (0, _react.useMemo)(function () {
    return idProp ? idProp : (0, _uniqueId["default"])("popover-");
  }, [idProp]);
  var t = (0, _theme.useTheme)(_popover["default"], "popover"); // HACK: For RTL, update position and alignment to horizontal terms.
  // eg: start -> left, end -> right.
  // The actual RTL swapping of left to right and right to left
  // happens in the popover-controller.
  // The RTL swapping will happen based on left/right values automatically
  // in the popover-controller.
  // This is needed because "top left" is handled better than "top start".
  // If the direction is not "start" or "end" the call to getHorizontalDirection
  // will simply return the direction passed into it.

  var popoverPosition = (0, _rtl.getHorizontalDirection)(position);
  var popoverAlignment = (0, _rtl.getHorizontalDirection)(alignment); // Handle setting aria-expanded to `false` and refocusing on the anchor node
  // and then fire the customer's `onClose` function

  var closeFunc = (0, _react.useCallback)(function () {
    try {
      anchorNode.setAttribute("aria-expanded", "false"); // Try to refocus back on the anchor node

      if (anchorNode.focus) {
        anchorNode.focus();
      } else {
        /* eslint-disable-next-line react/no-find-dom-node */
        _reactDom["default"].findDOMNode(anchorNode).focus();
      }
    } catch (_) {// Silent error
    }

    onClose();
  }, [anchorNode, onClose]); // Transfer focus back to the popover anchor. This will automatically close
  // the popover because of our usage of `useOnBlurContainer` below.

  var close = (0, _react.useCallback)(function () {
    if (anchorNode.focus) {
      anchorNode.focus();
    } else {
      /* eslint-disable-next-line react/no-find-dom-node */
      _reactDom["default"].findDOMNode(anchorNode).focus();
    }
  }, [anchorNode]); // Create focus/blur handlers that will trigger closeFunc when focus moves
  // outside of the popover

  var _useOnBlurContainer = (0, _useOnBlurContainer2["default"])(closeFunc),
      onBlur = _useOnBlurContainer.onBlur,
      onFocus = _useOnBlurContainer.onFocus;

  var onFocusFunc = (0, _react.useCallback)(function () {
    // If a user has not set an id for accessibility
    // use our own auto-generated one
    try {
      if (!anchorNode.hasAttribute("aria-controls")) {
        anchorNode.setAttribute("aria-controls", id);
      }
    } catch (_) {// Silent error
    } // If a user hasn't set aria-haspopup, we'll do it
    // for them.


    try {
      if (!anchorNode.hasAttribute("aria-haspopup")) {
        anchorNode.setAttribute("aria-haspopup", "dialog");
      }
    } catch (_) {// Silent error
    }

    onFocus();
  }, [anchorNode, id, onFocus]);
  var onOpen = (0, _react.useCallback)(function () {
    try {
      anchorNode.setAttribute("aria-expanded", "true");
    } catch (_) {// Silent error
    } // When the popover is opened, focus on the first enabled focuseable node inside
    // it *or* the popover itself if it doesn't contain any focuseable nodes.


    var firstEnabledFocusNode = (0, _focus.getKeyboardFocusNodes)(popoverBody.current).filter(function (node) {
      return !node.disabled;
    })[0];
    var firstFocusNode = firstEnabledFocusNode || popoverBody.current;
    firstFocusNode.focus();
    onOpenProp();
  }, [anchorNode, onOpenProp]); // If the user presses the escape key, close the popover.

  var onKeyDown = (0, _react.useCallback)(function (event) {
    if ((0, _keycode["default"])(event) === "esc") {
      // Stop propagating the event upwards. This ensures that a parent element
      // (e.g. a modal) won't also handle the escape key.
      event.stopPropagation();
      close();
    }

    onKeyDownProp(event);
  }, [onKeyDownProp, close]);
  var vertical = position === "top" || position === "bottom";

  var childrenArray = _react["default"].Children.toArray(children);

  var headerChild = (0, _find["default"])(childrenArray, isHeader);
  var nonHeaderChildren = childrenArray.filter(function (child) {
    return !isHeader(child);
  }); // Check if the anchor node has a special attribute set in order to
  // customize the distance a popover is placed from the element. This is
  // useful for elements whose visual edge is not the same as their layout
  // edge, in which case they'll want to scoot the popover around to make it
  // appear a reasonable distance from the element's visual edge.

  var customOffset = (0, _react.useMemo)(function () {
    /* eslint-disable-next-line react/no-find-dom-node */
    var anchorDomNode = anchorNode && _reactDom["default"].findDOMNode(anchorNode);

    var customOffset = parseInt(anchorDomNode && anchorDomNode.getAttribute("mdn-popover-offset"));
    return isNaN(customOffset) ? 0 : customOffset;
  }, [anchorNode]); // Calculate the final offset based on tokens, the presence of an indicator
  // arrow, and any custom offset specified by the anchor node (see above).

  var offset = (0, _react.useMemo)(function () {
    return Math.max(0, t("offset", indicatorArrow ? "withArrow" : "withoutArrow") + customOffset);
  }, [t, indicatorArrow, customOffset]);
  var headerId = headerChild ? "".concat(id, "-header") : undefined;
  return /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
    open: open,
    onOpen: onOpen,
    anchorNode: anchorNode,
    anchorOrigin: vertical ? "".concat(popoverPosition, " ").concat(popoverAlignment) : "".concat(popoverAlignment, " ").concat(popoverPosition),
    popoverOrigin: vertical ? "".concat((0, _utils.flipAlignment)(popoverPosition), " ").concat(popoverAlignment) : "".concat(popoverAlignment, " ").concat((0, _utils.flipAlignment)(popoverPosition)),
    offsetVertical: vertical ? offset : 0,
    offsetHorizontal: vertical ? 0 : offset,
    shrinkToFit: shrinkToFit,
    maxWidth: maxWidth
  }, function (_ref2) {
    var popoverStyle = _ref2.popoverStyle,
        popoverOrigin = _ref2.popoverOrigin,
        anchorOrigin = _ref2.anchorOrigin,
        anchorRect = _ref2.anchorRect;
    return /*#__PURE__*/_react["default"].createElement(_popoverBody["default"], (0, _extends2["default"])({}, indicatorArrow ? _objectSpread({}, _popoverBody["default"].generateArrowProps({
      popoverOrigin: popoverOrigin,
      anchorOrigin: anchorOrigin,
      anchorRect: anchorRect
    })) : null, {
      style: popoverStyle,
      minWidth: minWidth === "anchor" ? anchorRect.width : minWidth,
      maxWidth: maxWidth === "anchor" ? anchorRect.width : maxWidth,
      spacingInset: spacingInset,
      onKeyDown: onKeyDown,
      onBlur: onBlur,
      onFocus: onFocusFunc,
      tabIndex: "-1",
      ref: popoverBody,
      labelledById: headerId,
      allowOverflow: shrinkToFit,
      id: id
    }), headerChild ? /*#__PURE__*/_react["default"].cloneElement(headerChild, {
      onClose: close,
      t: t,
      id: headerId
    }) : null, nonHeaderChildren);
  });
}, shouldNotUpdate);

Popover.displayName = "Popover";
Popover.propTypes =  false ? {
  /**
   * The contents of the popover.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Is the popover open?
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * This determines which side of the anchor node the popover appears on.
   */
  position: _propTypes["default"].oneOf(["top", "right", "bottom", "left", "start", "end"]).isRequired,

  /**
   * The popover will call this when it wants to close. The function provided
   * here should set the "open" prop to false.
   */
  onClose: _propTypes["default"].func.isRequired,

  /**
   * This determines how the popover is aligned with the anchor node.
   *
   * Note that only certain values are valid depending on what the "position" prop
   * is set to. If the position is "top" or "bottom" then valid values here
   * are "left", "right", or "center". If the position is "left" or "right"
   * then valid values are "top", "bottom", or "center".
   */
  alignment: _propTypes["default"].oneOf(["top", "right", "bottom", "left", "start", "end", "center"]),

  /**
   * This must be an element that supports `onBlur` and `onFocus` properties.
   * This is not required to mount the popover, but it is required to open it.
   */
  anchorNode: _propTypes["default"].object,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.x
   */
  id: _propTypes["default"].string,

  /**
   * Used to turn the indicator arrow for the PopoverBody child component off
   * and on. This is an internal API currently used for the Menu component,
   * and we recommend that you use the default value of `true` in normal use.
   */
  indicatorArrow: _propTypes["default"].bool,

  /**
   * Define a maximum width for the popover. Any CSS width value is
   * acceptable The magic value `"anchor"` may be used to set the maximum width
   * of the popover to the width of the anchor node.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /**
   * Define a minimum width for the popover. Any CSS width value is
   * acceptable. The magic value `"anchor"` may be used to set the minimum width
   * of the popover to the width of the anchor node.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /**
   * Turn this on to allow the popover to resize to fit within the viewport if
   * necessary. This may cause contents within the popover to scroll.
   *
   * NOTE: We recommend turning this prop on. It is off by default for backwards
   * compatibility. In the next major version of Meridian this prop will most
   * likely be removed and the "resize to fit" behavior will become the default
   * for the component.
   *
   * @since 5.x
   */
  shrinkToFit: _propTypes["default"].bool,

  /**
   * Apply padding around the contents of the popover using a preset.
   */
  spacingInset: _propTypes["default"].oneOf(["none", "small", "medium", "300", "400"]),

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func,

  /**
   * This function will be called when the popover is opened (after the
   * popover has been added to the DOM).
   */
  onOpen: _propTypes["default"].func
} : {};
Popover.defaultProps = {
  spacingInset: "medium",
  onKeyDown: _noop["default"],
  onOpen: _noop["default"],
  indicatorArrow: true,
  alignment: "center"
};
var _default = Popover;
exports["default"] = _default;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(25));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _capitalize = _interopRequireDefault(__webpack_require__(865));

var _emotion = __webpack_require__(11);

var _popover = _interopRequireDefault(__webpack_require__(203));

var _elevation = __webpack_require__(81);

var _theme = __webpack_require__(24);

var _utils = __webpack_require__(206);

var _token = __webpack_require__(20);

var _cxMemoized = _interopRequireDefault(__webpack_require__(107));

var _text = _interopRequireDefault(__webpack_require__(47));

var _getUnthemedTokens = (0, _token.getUnthemedTokens)(_popover["default"]),
    popoverArrowWidth = _getUnthemedTokens.popoverArrowWidth; // Takes an edge (e.g. "top") and turns it into a CSS border property (e.g.
// "borderTop").


var edgeToBorder = function edgeToBorder(edge) {
  return "border".concat((0, _capitalize["default"])(edge));
}; // Takes an edge (e.g. "top") and a CSS length (e.g. "5px") and creates a
// CSS translation function (e.g. "translateY(5px)") that can be added to an
// element  via the CSS "transform" property.


var edgeToTransform = function edgeToTransform(edge, amount) {
  return "translate".concat(edge === "left" || edge === "right" ? "X" : "Y", "(").concat(amount, ")");
}; // These styles are used to create the little arrow that points away from the
// popover. The method used to create the triangles involves psuedo elements
// with different transparent borders applied to certain sides. A good demo of
// this method can be found here: https://codepen.io/chriscoyier/pen/lotjh. The
// benefit of this method is that it doesn't require any images, but the
// downside is that you can't apply a border to the triangle. To get around
// this a border is faked by placing a slightly offset background-colored
// triangle (the :after pseudo element) on top of a border-colored triangle (the
// :before pseudo element).


var arrowStyles = function arrowStyles(t, _ref) {
  var _afterBefore, _before, _after;

  var type = _ref.type,
      arrowPosition = _ref.arrowPosition,
      arrowAlignment = _ref.arrowAlignment,
      arrowOffset = _ref.arrowOffset;
  var backgroundColor = t("backgroundColor", type);
  var borderColor = t("borderColor", type);
  var borderWidth = t("borderWidth");
  var arrowHeight = t("arrowHeight");
  var arrowWidthHalf = t("arrowWidth") / 2; // This is the edge of the popover (either "top" or "left") that is parallel
  // to the direction the arrow is pointing.

  var arrowParallelEdge = arrowPosition === "top" || arrowPosition === "bottom" ? "left" : "top"; // This is the edge of the popover that is opposite the edge that the arrow
  // is positioned on.

  var arrowOppositeEdge = (0, _utils.flipAlignment)(arrowPosition); // This uses maths to determine how far we have to scoot the fill triangle
  // along its axis to reveal exactly `borderWidth` pixels of the border
  // triangle along a line that is perpendicular to the edges of both triangles.

  var fillTriangleOffset = borderWidth / Math.sin(Math.atan(arrowWidthHalf / arrowHeight)); // This translates the arrow in the direction orthogonal to the direction that
  // the arrow is pointing (i.e. left/right for an arrow pointing up/down or
  // up/down for an arrow pointing left/right).

  var orthogonalTransform = function orthogonalTransform(alignment) {
    return {
      top: ["".concat(arrowOffset, "px")],
      left: ["".concat(arrowOffset, "px")],
      right: ["-".concat(arrowOffset, "px"), "-100%"],
      bottom: ["-".concat(arrowOffset, "px"), "-100%"],
      center: ["".concat(arrowOffset, "px"), "-50%"]
    }[alignment].map(function (amount) {
      return edgeToTransform(arrowParallelEdge, amount);
    }).join(" ");
  };

  return (0, _emotion.css)({
    "&:after, &:before": (_afterBefore = {
      content: "''",
      position: "absolute",
      height: 0,
      width: 0
    }, (0, _defineProperty2["default"])(_afterBefore, arrowOppositeEdge, "100%"), (0, _defineProperty2["default"])(_afterBefore, arrowParallelEdge, {
      top: 0,
      left: 0,
      right: "100%",
      bottom: "100%",
      center: "50%"
    }[arrowAlignment]), (0, _defineProperty2["default"])(_afterBefore, edgeToBorder(arrowParallelEdge), "".concat(arrowWidthHalf, "px solid transparent")), (0, _defineProperty2["default"])(_afterBefore, edgeToBorder((0, _utils.flipAlignment)(arrowParallelEdge)), "".concat(arrowWidthHalf, "px solid transparent")), _afterBefore),
    // This creates a triangle with a background color that is the same color as
    // the popover's border.
    "&:before": (_before = {}, (0, _defineProperty2["default"])(_before, edgeToBorder(arrowOppositeEdge), "".concat(arrowHeight, "px solid ").concat(borderColor)), (0, _defineProperty2["default"])(_before, "transform", orthogonalTransform(arrowAlignment)), _before),
    // If the popover has a border then this creates a triangle that is the same
    // color as the popover's background color. This triangle is displayed on
    // top of the border colored triangle but is scooted back just a bit to
    // reveal enough of the border triangle to create a faux border around
    // itself.
    "&:after": (_after = {}, (0, _defineProperty2["default"])(_after, edgeToBorder(arrowOppositeEdge), "".concat(arrowHeight, "px solid ").concat(backgroundColor)), (0, _defineProperty2["default"])(_after, "transform", "".concat(orthogonalTransform(arrowAlignment), " ").concat(edgeToTransform(arrowOppositeEdge, "".concat(arrowOppositeEdge === "top" || arrowOppositeEdge === "left" ? "-" : "").concat(fillTriangleOffset, "px")))), _after)
  });
};

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var type = _ref2.type,
      spacingInset = _ref2.spacingInset,
      zIndex = _ref2.zIndex,
      minWidth = _ref2.minWidth,
      maxWidth = _ref2.maxWidth,
      arrowPosition = _ref2.arrowPosition,
      arrowAlignment = _ref2.arrowAlignment,
      arrowOffset = _ref2.arrowOffset,
      allowOverflow = _ref2.allowOverflow;
  var borderColor = t("borderColor", type);
  return (0, _emotion.css)((0, _text["default"])(t, {
    color: type
  }), {
    display: "inline-block",
    position: "relative",
    outline: "none",
    zIndex: zIndex,
    minWidth: minWidth,
    maxWidth: maxWidth,
    // Children wrapper styles
    "& > div": {
      // If this is used with the PopoverController component then a max
      // width and height will be set on the outer element of this
      // component. Setting the max width and height to "inherit" here will
      // constrain this inner element to the same width/height as its parent
      // (oddly enough max width/height "100%" won't work because CSS). This
      // ensures that scrollbars will be shown for content that overflows.
      // Without these styles this element just extends outside of its
      // parent.
      maxHeight: allowOverflow ? "inherit" : undefined,
      maxWidth: allowOverflow ? "inherit" : undefined,
      overflow: allowOverflow ? "auto" : "hidden",
      padding: spacingInset !== "none" ? "".concat(t("spacingInsetVertical", spacingInset), "px ").concat(t("spacingInsetHorizontal", spacingInset), "px") : undefined,
      backgroundColor: t("backgroundColor", type),
      borderColor: borderColor,
      borderWidth: borderColor ? t("borderWidth") : undefined,
      borderStyle: borderColor ? "solid" : undefined,
      borderRadius: t("borderRadius"),
      boxShadow: t.boxShadowCss("dropShadow")
    }
  }, arrowPosition ? arrowStyles(t, {
    type: type,
    arrowPosition: arrowPosition,
    arrowAlignment: arrowAlignment,
    arrowOffset: arrowOffset
  }) : undefined);
}, ["type", "spacingInset", "zIndex", "maxWidth", "minWidth", "arrowPosition", "arrowAlignment", "arrowOffset", "allowOverflow"]);

var PopoverBody = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_popover["default"], "popover");
  var style = (0, _typeof2["default"])(props.style) === "object" ? props.style : undefined;
  var className = "".concat((0, _cxMemoized["default"])(styles(t, props), props.className));

  if (typeof props.style === "string") {
    className = className.concat(" ".concat(props.style));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    onKeyDown: props.onKeyDown,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    tabIndex: props.tabIndex,
    className: className,
    style: style,
    role: props.tabIndex ? "dialog" : "tooltip",
    "aria-labelledby": props.labelledById,
    "aria-expanded": props.open,
    id: props.id,
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement("div", null, props.children));
}); // This helper generates the arrow props that are necessary to point a popover
// arrow at a particular anchor


PopoverBody.generateArrowProps = function (_ref3) {
  var popoverOrigin = _ref3.popoverOrigin,
      anchorOrigin = _ref3.anchorOrigin,
      anchorRect = _ref3.anchorRect,
      dir = _ref3.dir;
  var vertical = popoverOrigin.y !== anchorOrigin.y && popoverOrigin.y === (0, _utils.flipAlignment)(anchorOrigin.y);
  var arrowAlignment = vertical ? popoverOrigin.x : popoverOrigin.y; // Truncate the top and left values so that browsers can better handle
  // the positioning of the arrow relative to the anchor.
  // Without truncation we may get values like:
  // {
  //     "top": 39.09090805053711,
  //     "left": 387.2585144042969,
  //     "width": 137,
  //     "height": 40
  // }

  anchorRect.left = Math.trunc(anchorRect.left);
  anchorRect.top = Math.trunc(anchorRect.top);
  return {
    arrowAlignment: arrowAlignment,
    arrowPosition: vertical ? popoverOrigin.y : popoverOrigin.x === "end" && dir === "ltr" ? "left" : popoverOrigin.x === "end" ? "right" : popoverOrigin.x === "start" && dir === "ltr" ? "right" : popoverOrigin.x === "start" ? "left" : popoverOrigin.x,
    arrowOffset: arrowAlignment !== "center" ? anchorRect[vertical ? "width" : "height"] / 2 - popoverArrowWidth / 2 : 0
  };
};

PopoverBody.displayName = "PopoverBody";
PopoverBody.propTypes =  false ? {
  children: _propTypes["default"].node.isRequired,

  /**
   * Set this to true to allow content to overflow with scrollbars.
   *
   * NOTE: This was added in conjunction with the `shrinkToFit` prop on the
   * Popover component. Like that prop, this prop should probably be removed in
   * the next major version and the shrink/overflow behavior made to be the
   * default behavior.
   */
  allowOverflow: _propTypes["default"].bool,
  arrowAlignment: _propTypes["default"].oneOf(["top", "right", "bottom", "left", "center"]),
  arrowOffset: _propTypes["default"].number,

  /**
   * If this property is set then an arrow will be drawn pointing away from the
   * specified side of the popover body.
   */
  arrowPosition: _propTypes["default"].oneOf(["top", "right", "bottom", "left", "start", "end"]),

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * The id of an element that labels the popover body. See:
   * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
   */
  labelledById: _propTypes["default"].string,

  /**
   * Define a maximum width for the component. Any CSS width value is
   * acceptable.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /**
   * Define a minimum width for the component. Any CSS width value is
   * acceptable.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  open: _propTypes["default"].bool,
  spacingInset: _propTypes["default"].oneOf(["none", "small", "medium"]),

  /**
   * Can either be an object (applied directly to the element's `style` attribute)
   * or a class name string (appended to the element's `class` attribute). A style
   * object is generally faster but class name allows RTL magic ✨
   */
  style: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(["outline", "fill"]),
  zIndex: _propTypes["default"].number,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func
} : {};
PopoverBody.defaultProps = {
  open: true,
  type: "outline",
  arrowAlignment: "center",
  arrowOffset: 0,
  spacingInset: "small",
  zIndex: _elevation.elevationPopover
};
var _default = PopoverBody;
exports["default"] = _default;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(106),
    upperFirst = __webpack_require__(866);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(867);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(403),
    hasUnicode = __webpack_require__(205),
    stringToArray = __webpack_require__(405),
    toString = __webpack_require__(106);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 868 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 869 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(202));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(77));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _noop = _interopRequireDefault(__webpack_require__(59));

var _popover = _interopRequireDefault(__webpack_require__(203));

var _utils = __webpack_require__(206);

var _rtl = __webpack_require__(80);

var _portal = _interopRequireDefault(__webpack_require__(207));

var _transitionController = _interopRequireDefault(__webpack_require__(274));

var _propTypes2 = _interopRequireDefault(__webpack_require__(126));

var _parsers = __webpack_require__(128);

var _addDebouncedEventListener = _interopRequireDefault(__webpack_require__(195));

var _waitAnimationFrame = _interopRequireDefault(__webpack_require__(208));

var _nodeBounds = __webpack_require__(360);

var _token = __webpack_require__(20);

var _excluded = ["children"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// The closest a popover can be shown to the edge of the viewport
var viewportPadding = 16; // Grab the popover motion duration and function from our tokens.

var _getUnthemedTokens = (0, _token.getUnthemedTokens)(_popover["default"]),
    popoverMotionDuration = _getUnthemedTokens.popoverMotionDuration,
    popoverMotionFunction = _getUnthemedTokens.popoverMotionFunction,
    popoverClosedScale = _getUnthemedTokens.popoverClosedScale;
/**
 * Styles
 */
// NOTE: This component does not use emotion because its styles are *highly*
// dynamic (updated on scroll). The emotion docs say that emotion is performant
// enough for highly dynamic styles, but using inline styles still seems to
// perform marginally better in this situation. Plus, using inline styles here
// isn't any worse from a dev perspective since we don't need any of the fancy
// css features enabled by emotion.


var styles = function styles(_ref) {
  var shrinkToFit = _ref.shrinkToFit,
      offsetHorizontal = _ref.offsetHorizontal,
      offsetVertical = _ref.offsetVertical,
      maxHeight = _ref.maxHeight,
      maxWidth = _ref.maxWidth,
      anchorRect = _ref.anchorRect,
      viewportRect = _ref.viewportRect,
      state = _ref.state,
      anchorOrigin = _ref.anchorOrigin,
      popoverOrigin = _ref.popoverOrigin,
      availableSpace = _ref.availableSpace;

  // The distance to offset the popover from the anchor's left edge (changes
  // based on the anchor origin).
  var offsetFromAnchorLeft = function offsetFromAnchorLeft(_ref2) {
    var x = _ref2.x;
    return {
      left: -offsetHorizontal,
      center: anchorRect.width / 2 + offsetHorizontal,
      right: anchorRect.width + offsetHorizontal
    }[x];
  }; // The distance to offset the popover from the anchor's top edge (changes
  // based on the anchor origin).


  var offsetFromAnchorTop = {
    top: -offsetVertical,
    center: anchorRect.height / 2 + offsetVertical,
    bottom: anchorRect.height + offsetVertical
  }[anchorOrigin.y];
  return (0, _emotion.css)((0, _defineProperty2["default"])({
    position: "fixed !important",
    boxSizing: "border-box",
    // Anchor the popover's position from its bottom edge if it's anchored at
    // the bottom. This ensures long content forces the popover to expand
    // downwards.
    top: state !== "exited" && popoverOrigin.y !== "bottom" ? anchorRect.top + offsetFromAnchorTop - viewportPadding : undefined,
    // Anchor the popover's position from its bottom edge if it's anchored at
    // the bottom. This ensures long content forces the popover to expand
    // upwards.
    bottom: state !== "exited" && popoverOrigin.y === "bottom" ? viewportRect.height - anchorRect.top - offsetFromAnchorTop - viewportPadding : undefined,
    // Anchor the popover's position from its left edge if it's anchored at the
    // the left or center. This ensures long content forces the popover to
    // expand to the right.
    left: state !== "exited" && popoverOrigin.x === "left" || state !== "exited" && popoverOrigin.x === "end" || state !== "exited" && popoverOrigin.x === "center" ? anchorRect.left + offsetFromAnchorLeft({
      x: anchorOrigin.x === "end" ? "right" : anchorOrigin.x
    }) - viewportPadding : undefined,
    // Anchor the popover's position from its right edge if it's anchored at the
    // right. This ensures long content forces the popover to expand to the left.
    right: state !== "exited" && popoverOrigin.x === "right" || state !== "exited" && popoverOrigin.x === "start" ? viewportRect.width - anchorRect.left - offsetFromAnchorLeft({
      x: anchorOrigin.x === "start" ? "left" : anchorOrigin.x
    }) - viewportPadding : undefined,
    transformOrigin: "".concat(popoverOrigin.y, " ").concat(popoverOrigin.x),
    opacity: state === "exited" || state === "exiting" ? 0 : 1,
    // For popovers that are anchored at their center, apply a transform to
    // ensure that the popover is positioned correctly and that long content
    // forces it to expand from the center.
    transform: "translateY(".concat(popoverOrigin.y === "center" ? "-50%" : "0%", ") translateX(").concat(popoverOrigin.x === "center" ? "-50%" : "0%", ") scale(").concat(state === "exited" || state === "exiting" ? popoverClosedScale / 100 : 1, ")"),
    transition: state === "entering" || state === "entered" || state === "exiting" ? "transform ".concat(popoverMotionDuration, " ").concat(popoverMotionFunction, ", opacity ").concat(popoverMotionDuration, " ").concat(popoverMotionFunction) : undefined,
    visibility: state === "exited" ? "hidden" : "visible",
    // Add margin on every side to make sure that the viewport padding is
    // maintained
    margin: viewportPadding,
    // If the user has specified a maxHeight then use that. If the popover is
    // open and the `shrinkToFit` prop is set then also constrain by the
    // available vertical space.
    maxHeight: state !== "exited" && shrinkToFit ? Math.min(maxHeight || availableSpace.y, availableSpace.y) : maxHeight,
    // If the user has specified a maxWidth then use that. If the popover is
    // open and the `shrinkToFit` prop is set then also constrain by the
    // available horizontal space.
    maxWidth: state !== "exited" && shrinkToFit ? Math.min(maxWidth || availableSpace.x, availableSpace.x) : maxWidth
  }, "[dir=\"rtl\"] &", {
    left: state !== "exited" && popoverOrigin.x === "start" ? anchorRect.left + offsetFromAnchorLeft({
      x: "right"
    }) - viewportPadding : popoverOrigin.x === "end" ? "inherit" : undefined,
    right: state !== "exited" && popoverOrigin.x === "end" ? viewportRect.width - anchorRect.left - offsetFromAnchorLeft({
      x: "left"
    }) - viewportPadding : popoverOrigin.x === "start" ? "inherit" : undefined
  }));
};
/**
 * This component handles the positioning of popover content in relation to
 * another element (the "anchor" element). It allows you to "stick" the popover
 * to the anchor element.
 *
 * This component has two real benefits over a simple absolute-positing strategy
 * for popover content. First, it renders popover content at the root of the DOM
 * using portals. This allows popovers to break out of the anchor element's
 * parent containers regardless of any overflow/scroll styles on those
 * containers. Second, this component will automatically re-position and re-size
 * the popover content based on the available space in the viewport. This
 * ensures that the content in the popover will be as accessible to the user as
 * possible.
 *
 * This component does not actually render anything to the DOM. It simply
 * generates the styles necessary to correctly position the popover. The styles
 * are passed via render props to the component's children so that the user can
 * render the popover exactly how they want to. This requires that the user set
 * the style prop on their popover element to the `popoverStyle` render prop
 * returned by this component.
 */


var PopoverController = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(PopoverController, _React$Component);

  var _super = _createSuper(PopoverController);

  function PopoverController() {
    var _this;

    (0, _classCallCheck2["default"])(this, PopoverController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      // Should we render the popover's children? We don't when the popover is
      // closed to avoid unnecessary work.
      render: false,
      // The bounding rectangle for the anchor node.
      anchorRect: _nodeBounds.emptyNodeBounds,
      // The bounding rectangle for the popover node.
      popoverRect: _nodeBounds.emptyNodeBounds,
      // The bounding rectangle for the viewport.
      viewportRect: _nodeBounds.emptyNodeBounds
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "eventListeners", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateAnchorRect", function () {
      var _this$props = _this.props,
          open = _this$props.open,
          anchorNode = _this$props.anchorNode;

      if (open) {
        /* eslint-disable-next-line react/no-find-dom-node */
        var anchorDomNode = _reactDom["default"].findDOMNode(anchorNode);

        var anchorRect = (0, _nodeBounds.getNodeBounds)(anchorDomNode);

        if (!(0, _nodeBounds.compareNodeBounds)(anchorRect, _this.state.anchorRect)) {
          _this.setState({
            anchorRect: anchorRect
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateViewportRect", function () {
      var viewportRect = (0, _nodeBounds.getNodeBounds)(window);

      if (!(0, _nodeBounds.compareNodeBounds)(viewportRect, _this.state.viewportRect)) {
        _this.setState({
          viewportRect: viewportRect
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updatePopoverRect", function () {
      var popoverRect = (0, _nodeBounds.getNodeBounds)(_this.popoverNode);

      if (!(0, _nodeBounds.compareNodeBounds)(popoverRect, _this.state.popoverRect)) {
        _this.setState({
          popoverRect: popoverRect
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onResizeWindow", function () {
      _this.updateViewportRect();

      _this.updateAnchorRect();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onScroll", function (event) {
      var open = _this.props.open;

      var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this),
          popoverNode = _assertThisInitialize.popoverNode; // If the popover is open and the scroll event came from *outside* the
      // popover then assume the anchor element moved (and an update is needed for
      // the anchor rect).


      if (open && (!popoverNode || !popoverNode.contains(event.target))) {
        _this.updateAnchorRect();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeOpen", function (done) {
      _this.props.onBeforeOpen();

      _this.setState({
        render: true
      }, function () {
        // Give the children a chance to settle before poking through the DOM
        _this.cancelAnimationFrame = (0, _waitAnimationFrame["default"])(function () {
          /* eslint-disable-next-line react/no-find-dom-node */
          _this.popoverNode = _reactDom["default"].findDOMNode((0, _assertThisInitialized2["default"])(_this));

          _this.updateViewportRect();

          _this.updateAnchorRect();

          _this.updatePopoverRect();

          _this.addEventListeners();

          done();
        });
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOpen", function (done) {
      _this.props.onOpen(_this.popoverNode);

      done();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterClose", function () {
      _this.props.onClose(_this.popoverNode);

      _this.removeEventListeners();

      _this.setState({
        render: false
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(PopoverController, [{
    key: "addEventListeners",
    value: function addEventListeners() {
      // Remove any existing event listeners just to be safe
      this.removeEventListeners(); // Listen for *any* scroll event in the document

      this.eventListeners.push((0, _addDebouncedEventListener["default"])(document, "scroll", this.onScroll, true)); // Listen for resize events from the window

      this.eventListeners.push((0, _addDebouncedEventListener["default"])(window, "resize", this.onResizeWindow));
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      this.eventListeners.forEach(function (removeListener) {
        return removeListener();
      });
      this.eventListeners = [];
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.open && Boolean(this.props.anchorNode)) {
        /* eslint-disable-next-line react/no-find-dom-node */
        this.onBeforeOpen(function () {
          return _this2.onOpen(_noop["default"]);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEventListeners();

      if (this.cancelAnimationFrame) {
        this.cancelAnimationFrame();
      }

      clearTimeout(this.blurTimeout);
      clearTimeout(this.animationTimeout);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var anchorNode = this.props.anchorNode;

      if (anchorNode !== prevProps.anchorNode) {
        this.updateAnchorRect();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded); // HACK: 'dir' is used for RTL support to swap Popover to the opposite side.
      // Until we have a fully CSS-based solution for supporting RTL in the
      // Popover we have to take advantage of canUseDom. This dir prop
      // allows us to dynamically update start/end values to left/right
      // or right/left depending on the direction of the layout.

      var dir = (0, _rtl.getDOMDirection)(props.anchorNode); // HACK: For RTL, swap the anchorOrigin x direction.
      // EG: "center right" will become "center left".
      // Since we need to utilize canUseDom, the easiest way to swap
      // Popover in an RTL context (without doing a complete rewrite
      // to make the Popover entirely CSS-based using Emotion) is to
      // check whether the dom direction is RTL and if it is to
      // essentially swap all "left" to "right" and "right" to "left".

      var oppositeAnchorOriginXDirection = (0, _rtl.getHorizontalDirection)((0, _rtl.getRtl)(this.props.anchorOrigin.split(" ")[1]));
      var newAnchorOrigin = dir === "rtl" ? "".concat(this.props.anchorOrigin.split(" ")[0], " ").concat(oppositeAnchorOriginXDirection) : this.props.anchorOrigin; // HACK: For RTL, swap the popoverOrigin x direction.
      // EG: "center right" will become "center left"

      var oppositePopoverOriginXDirection = (0, _rtl.getHorizontalDirection)((0, _rtl.getRtl)(this.props.popoverOrigin.split(" ")[1]));
      var newPopoverOrigin = dir === "rtl" ? "".concat(this.props.popoverOrigin.split(" ")[0], " ").concat(oppositePopoverOriginXDirection) : this.props.popoverOrigin;
      var _this$state = this.state,
          anchorRect = _this$state.anchorRect,
          popoverRect = _this$state.popoverRect,
          viewportRect = _this$state.viewportRect,
          render = _this$state.render;

      var _getBestOrigin = (0, _utils.getBestOrigin)({
        anchorOrigin: (0, _parsers.parseAlignment)(newAnchorOrigin),
        popoverOrigin: (0, _parsers.parseAlignment)(newPopoverOrigin),
        extraSpace: {
          x: props.offsetHorizontal + viewportPadding,
          y: props.offsetVertical + viewportPadding
        },
        anchorRect: anchorRect,
        popoverRect: popoverRect,
        viewportRect: viewportRect
      }),
          anchorOrigin = _getBestOrigin.anchorOrigin,
          popoverOrigin = _getBestOrigin.popoverOrigin,
          availableSpace = _getBestOrigin.availableSpace;

      return /*#__PURE__*/_react["default"].createElement(_transitionController["default"], {
        "in": props.open && Boolean(props.anchorNode),
        duration: parseInt(popoverMotionDuration),
        onBeforeEnter: this.onBeforeOpen,
        onEnter: this.onOpen,
        onAfterExit: this.onAfterClose
      }, function (state) {
        return render ? /*#__PURE__*/_react["default"].createElement(_portal["default"], null, children({
          popoverState: state,
          popoverStyle: styles({
            shrinkToFit: props.shrinkToFit,
            offsetHorizontal: props.offsetHorizontal,
            offsetVertical: props.offsetVertical,
            maxHeight: props.maxHeight,
            maxWidth: props.maxWidth,
            state: state,
            anchorOrigin: anchorOrigin,
            popoverOrigin: popoverOrigin,
            anchorRect: anchorRect,
            popoverRect: popoverRect,
            viewportRect: viewportRect,
            availableSpace: availableSpace
          }),
          popoverOrigin: popoverOrigin,
          anchorOrigin: anchorOrigin,
          anchorRect: anchorRect
        })) : null;
      });
    }
  }]);
  return PopoverController;
}(_react["default"].Component);

(0, _defineProperty2["default"])(PopoverController, "defaultProps", {
  offsetHorizontal: 0,
  offsetVertical: 0,
  onBeforeOpen: _noop["default"],
  onOpen: _noop["default"],
  onClose: _noop["default"]
});
PopoverController.propTypes =  false ? {
  anchorOrigin: _propTypes2["default"].alignment.isRequired,
  children: _propTypes["default"].func.isRequired,
  popoverOrigin: _propTypes2["default"].alignment.isRequired,

  /**
   * Any dom node or React element is valid here, but it's recommended that
   * you add a ref to the React element you want to anchor the popover to and
   * then pass the result in here.
   *
   * This anchor node is required in order to open the popover, but is not
   * required to render a closed popover. This allows you to render an
   * instance of `<PopoverController />` while you're still waiting for a ref
   * to your anchor element.
   *
   * NOTE: When you add a callback ref to an element avoid using inline
   * functions, as they can result in the ref flipping to `null` which can
   * break popover positioning:
   * https://reactjs.org/docs/refs-and-the-dom.html#caveats-with-callback-refs
   */
  anchorNode: _propTypes["default"].object,
  maxHeight: _propTypes["default"].number,
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  offsetHorizontal: _propTypes["default"].number,
  offsetVertical: _propTypes["default"].number,
  open: _propTypes["default"].bool,

  /**
   * If set to true the controller will attempt to resize the popover if there
   * is not enough space to display it at its natural size.
   */
  shrinkToFit: _propTypes["default"].bool,
  onBeforeOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onOpen: _propTypes["default"].func
} : {};
var _default = PopoverController;
exports["default"] = _default;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _reactDom = _interopRequireDefault(__webpack_require__(77));

var _canUseDom = _interopRequireDefault(__webpack_require__(250));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Portal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal() {
    (0, _classCallCheck2["default"])(this, Portal);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Portal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }

      this.defaultNode = null;
    }
  }, {
    key: "render",
    value: function render() {
      if (!_canUseDom["default"]) {
        return null;
      }

      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement("div");
        document.body.appendChild(this.defaultNode);
      }

      return /*#__PURE__*/_reactDom["default"].createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);
  return Portal;
}(_react["default"].Component);

Portal.propTypes =  false ? {
  children: _propTypes["default"].node.isRequired,
  node: _propTypes["default"].any
} : {};
var _default = Portal;
exports["default"] = _default;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _noop = _interopRequireDefault(__webpack_require__(59));

var _waitAnimationFrame = _interopRequireDefault(__webpack_require__(208));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var noopWithCallback = function noopWithCallback(callback) {
  return callback();
};
/**
 * This component makes it easy to apply complex transitions to elements. You
 * tell it whether the children should be transitioned in or out and what the
 * duration of the transition should be. It will provide you with the state of
 * the transition via a render prop. The state may be one of four values:
 * "entering", "entered", "exiting", or "exited". Six lifecycle hooks are
 * available: onBeforeEnter, onEnter, onAfterEnter, onBeforeExit, onExit, and
 * onAfterExit.
 */


var TransitionController = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TransitionController, _React$Component);

  var _super = _createSuper(TransitionController);

  function TransitionController() {
    var _this;

    (0, _classCallCheck2["default"])(this, TransitionController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      state: _this.props["in"] ? "entered" : "exited"
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancelWait", _noop["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "callback", _noop["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "waitAnimationFrame", function (callback, skip) {
      if (skip) {
        callback();
      } else {
        _this.cancelWait();

        _this.cancelWait = (0, _waitAnimationFrame["default"])(callback);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "waitDuration", function (callback) {
      var timeout;

      _this.cancelWait();

      _this.cancelWait = function () {
        return clearTimeout(timeout);
      };

      timeout = setTimeout(callback, _this.props.duration);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "withCallback", function (func) {
      return function (callback) {
        _this.callback = callback;
        func(function () {
          if (_this.callback === callback) {
            callback();
          }
        });
      };
    });
    return _this;
  }

  (0, _createClass2["default"])(TransitionController, [{
    key: "transition",
    value:
    /**
     * This orchestrates a transition. The basic flow is:
     * 1) cancel any existing timeouts
     * 2) call onBefore
     * 3) wait for a single animation frame *if* onBefore is defined (so that the
     *    DOM has a chance to settle)
     * 4) update the state to transitioning
     * 5) wait for a single animation frame *if* onTransition is defined (so that
     *    the DOM has a chance to settle)
     * 6) call onTransition
     * 7) wait for the duration of the animation
     * 8) update the state to transitioned
     * 9) wait for a single animation frame
     * 10) call onAfter
     */
    function transition(_ref) {
      var _this2 = this;

      var onBefore = _ref.onBefore,
          onTransition = _ref.onTransition,
          onAfter = _ref.onAfter,
          stateDuring = _ref.stateDuring,
          stateAfter = _ref.stateAfter;
      var onBeforeWithCallback = this.withCallback(onBefore);
      var onTransitionWithCallback = this.withCallback(onTransition);
      this.cancelWait();
      onBeforeWithCallback(function () {
        return _this2.waitAnimationFrame(function () {
          return _this2.setState({
            state: stateDuring
          }, function () {
            return _this2.waitAnimationFrame(function () {
              return onTransitionWithCallback(function () {
                return _this2.waitDuration(function () {
                  return _this2.setState({
                    state: stateAfter
                  }, _this2.waitAnimationFrame(onAfter, onAfter === _noop["default"]));
                });
              });
            }, // Don't wait an extra animation frame if no onTransition hook is
            // provided
            onTransition === noopWithCallback);
          });
        }, // Don't wait an extra animation frame if no onBefore hook is provided
        onBefore === noopWithCallback);
      });
    }
  }, {
    key: "transitionIn",
    value: function transitionIn() {
      this.transition({
        onBefore: this.props.onBeforeEnter,
        onTransition: this.props.onEnter,
        onAfter: this.props.onAfterEnter,
        stateDuring: "entering",
        stateAfter: "entered"
      });
    }
  }, {
    key: "transitionOut",
    value: function transitionOut() {
      this.transition({
        onBefore: this.props.onBeforeExit,
        onTransition: this.props.onExit,
        onAfter: this.props.onAfterExit,
        stateDuring: "exiting",
        stateAfter: "exited"
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props["in"] && !prevProps["in"]) {
        this.transitionIn();
      } else if (!this.props["in"] && prevProps["in"]) {
        this.transitionOut();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelWait();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.state.state);
    }
  }]);
  return TransitionController;
}(_react["default"].Component);

(0, _defineProperty2["default"])(TransitionController, "defaultProps", {
  onBeforeEnter: noopWithCallback,
  onEnter: noopWithCallback,
  onAfterEnter: _noop["default"],
  onBeforeExit: noopWithCallback,
  onExit: noopWithCallback,
  onAfterExit: _noop["default"]
});
TransitionController.propTypes =  false ? {
  children: _propTypes["default"].func.isRequired,
  duration: _propTypes["default"].number.isRequired,
  "in": _propTypes["default"].bool.isRequired,

  /**
   * Called right after the state has changed to "entered".
   */
  onAfterEnter: _propTypes["default"].func,

  /**
   * Called right after the state has changed to "exited".
   */
  onAfterExit: _propTypes["default"].func,

  /**
   * Called right before the state will change from "exited" to "entering".
   * This can be syncronous or asyncronous, but either way it must accept a
   * callback as its first argument and execute that callback when it's
   * finished doing its thing.
   */
  onBeforeEnter: _propTypes["default"].func,

  /**
   * Called right before the state will change from "entered" to "exiting".
   * This can be syncronous or asyncronous, but either way it must accept a
   * callback as its first argument and execute that callback when it's
   * finished doing its thing.
   */
  onBeforeExit: _propTypes["default"].func,

  /**
   * Called right after the state has changed to "entering". This can be
   * syncronous or asyncronous, but either way it must accept a callback as
   * its first argument and execute that callback when it's finished doing its
   * thing.
   */
  onEnter: _propTypes["default"].func,

  /**
   * Called right after the state has changed to "exited". This can be
   * syncronous or asyncronous, but either way it must accept a callback as
   * its first argument and execute that callback when it's finished doing its
   * thing.
   */
  onExit: _propTypes["default"].func
} : {};
var _default = TransitionController;
exports["default"] = _default;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _useOnBlurContainer = _interopRequireDefault(__webpack_require__(874));

var _default = _useOnBlurContainer["default"];
exports["default"] = _default;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = __webpack_require__(0);

/**
 * Use this to detect when focus is leaving an element that contains other
 * focuseable elements. *Works with portals*.
 *
 * Elements receive blur events when they lose focus, but they also receive blur
 * events when the focus is transferred between elements that they contain. In
 * this case they'll get a blur event for the descendant losing focus followed
 * immediately by a focus event for the descendant receiving focus. This hook
 * allows you to listen only for the blur events where the focus is actually
 * moving outside the element, and is not just being transferred between
 * descendants of the element.
 */
var useOnBlurContainer = function useOnBlurContainer(onBlurContainer) {
  var blurTimeout = (0, _react.useRef)();
  var focus = (0, _react.useRef)(); // Clear the blur timeout when unmounting

  (0, _react.useEffect)(function () {
    return function () {
      return clearTimeout(blurTimeout.current);
    };
  }, []); // When we get a blur event, mark the focus ref as false, wait one cycle,
  // and then execute the final callback if the focus ref is *still* false
  // (i.e. if onFocus wasn't called).

  var onBlur = (0, _react.useCallback)(function () {
    focus.current = false;
    blurTimeout.current = setTimeout(function () {
      if (!focus.current) {
        onBlurContainer();
      }
    }, 0);
  }, [onBlurContainer, focus]); // Mark the focus ref as true whenever we get a focus event

  var onFocus = (0, _react.useCallback)(function () {
    focus.current = true;
  }, [focus]);
  return {
    onBlur: onBlur,
    onFocus: onFocus
  };
};

var _default = useOnBlurContainer;
exports["default"] = _default;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(155));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(77));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _keycode = _interopRequireDefault(__webpack_require__(72));

var _emotion = __webpack_require__(11);

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _findIndex = _interopRequireDefault(__webpack_require__(254));

var _noop = _interopRequireDefault(__webpack_require__(59));

var _optionList = _interopRequireDefault(__webpack_require__(876));

var _optionListGroup = _interopRequireDefault(__webpack_require__(406));

var _theme = __webpack_require__(24);

var _token = __webpack_require__(20);

var _functional = __webpack_require__(38);

var _text = _interopRequireDefault(__webpack_require__(47));

var _isElementOf = _interopRequireDefault(__webpack_require__(94));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var isGroup = (0, _isElementOf["default"])(_optionListGroup["default"]);
var styles = (0, _functional.memoize)(function (t) {
  var _lastChild;

  return (0, _emotion.css)((0, _text["default"])(t), {
    outline: "none",
    // Shared option and group header styles
    "& [mdn-option-list-item], & [role=presentation]": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      boxSizing: "border-box"
    },
    // Option styles
    "& [mdn-option-list-item]": {
      padding: "".concat(t("optionSpacingInsetVertical"), "px ").concat(t("optionSpacingInsetHorizontal"), "px"),
      transition: t.transitionCss("optionMotion", ["color", "background-color"]),
      // Foreground and background color
      backgroundColor: t("optionBackgroundColorDefault"),
      color: t("optionForegroundColorDefault"),
      // Set color of child <Text/> components
      "& p": {
        color: t("optionForegroundColorDefault")
      },
      "&[aria-selected=true]": {
        backgroundColor: t("optionBackgroundColorSelected"),
        color: t("optionForegroundColorSelected"),
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorSelected")
        }
      },
      "&[aria-current=true]": {
        backgroundColor: t("optionBackgroundColorPreselected"),
        color: t("optionForegroundColorPreselected"),
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorPreselected")
        }
      },
      "&:active": {
        backgroundColor: t("optionBackgroundColorPressed"),
        color: t("optionForegroundColorPressed"),
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorPressed")
        }
      },
      "&[disabled], &[aria-disabled]": {
        backgroundColor: t("optionBackgroundColorDisabled"),
        color: t("optionForegroundColorDisabled"),
        // Set color of child <Text/> components
        "& p": {
          color: t("optionForegroundColorDisabled")
        }
      }
    },
    // Group header styles
    "& [role=presentation]": {
      padding: "".concat(t("groupHeaderSpacingInsetVertical"), "px ").concat(t("groupHeaderSpacingInsetHorizontal"), "px"),
      // Foreground and background color
      backgroundColor: t("groupHeaderBackgroundColorDefault"),
      color: t("groupHeaderForegroundColorDefault"),
      fontWeight: t("groupHeaderFontWeight"),
      "&[disabled], &[aria-disabled]": {
        backgroundColor: t("groupHeaderBackgroundColorDisabled"),
        color: t("groupHeaderForegroundColorDisabled")
      }
    },
    // Group styles
    "& [role=group]": {
      borderBottom: t.borderCss("groupBorder")
    },
    // Children styles
    "& [mdn-option-list-item] > *:first-child": {
      flex: "auto"
    },
    // Selected indicator styles
    "&[aria-multiselectable=true] [mdn-option-list-item]": {
      "& > *:last-child": (_lastChild = {
        flexShrink: 0,
        // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
        // to use directional margin-left/right. If/when we drop IE11 we can simplify
        // these styles to be:
        // {
        //   marginInlineStart: t("optionSpacingHorizontal"),
        // },
        marginLeft: t("optionSpacingInsetHorizontal")
      }, (0, _defineProperty2["default"])(_lastChild, "[dir=\"rtl\"] &", {
        marginRight: t("optionSpacingInsetHorizontal"),
        marginLeft: 0
      }), (0, _defineProperty2["default"])(_lastChild, "color", t("optionIndicatorColorDefault")), (0, _defineProperty2["default"])(_lastChild, "transition", t.transitionCss("motion", "color")), _lastChild),
      "&[aria-current=true] > *:last-child": {
        color: t("optionIndicatorColorPreselected")
      },
      "&[aria-selected=true] > *:last-child": {
        color: t("optionIndicatorColorSelected")
      },
      "&:active > *:last-child": {
        color: t("optionIndicatorColorPressed")
      },
      "&[disabled] > *:last-child, &[aria-disabled] > *:last-child": {
        color: "transparent"
      },
      "&[disabled][aria-selected=true] > *:last-child, &[aria-disabled][aria-selected=true] > *:last-child": {
        color: t("optionIndicatorColorDisabled")
      }
    }
  });
});
/**
 * This component helps render a keyboard-friendly list of selectable options.
 */

var OptionList = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(OptionList, _React$Component);

  var _super = _createSuper(OptionList);

  function OptionList() {
    var _this;

    (0, _classCallCheck2["default"])(this, OptionList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      preselectedIndex: _this.props.preselectedIndex !== undefined ? _this.props.preselectedIndex : _this.props.defaultPreselectedIndex !== undefined ? _this.props.defaultPreselectedIndex : -1
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", (0, _uniqueId["default"])(_this.props.role === "listbox" ? "option-list-" : "".concat(_this.props.role, "-")));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionDomNodes", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "listDomNode", undefined);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "allOptions", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateListDomNode", function (node) {
      return _this.listDomNode = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSelectedIndex", function (options) {
      return (0, _findIndex["default"])(options, function (option) {
        return option && option.props.selected;
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPreselectedIndex", function () {
      return _this.props.preselectedIndex !== undefined ? _this.props.preselectedIndex : _this.state.preselectedIndex;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getNextPreselectedIndex", function (offset) {
      var options = _this.allOptions;

      var preselectedIndex = _this.getPreselectedIndex();

      var selectedIndex = _this.getSelectedIndex(options);

      var enabledIndices = options.reduce(function (result, option, index) {
        if (option && !option.props.disabled) {
          result.push(index);
        }

        return result;
      }, []);
      var firstIndex = enabledIndices[0];
      var lastIndex = enabledIndices[enabledIndices.length - 1]; // If we've got a preselected or a selected option then move to the prev or
      // next option in the list (depending on the value of offset).

      var currentIndex = preselectedIndex !== -1 ? preselectedIndex : selectedIndex;

      if (currentIndex !== -1) {
        var nextIndex = enabledIndices[enabledIndices.indexOf(currentIndex) + offset];
        return nextIndex !== undefined ? nextIndex : offset < 0 ? firstIndex : lastIndex; // If we don't have a preselected or selected option and we were trying to
        // move up, preselect the option at the bottom of the list.
      } else if (offset < 0) {
        return lastIndex; // If we don't have a preselected or selected option and we were trying to
        // move down, preselect the option at the top of the list.
      } else {
        return firstIndex;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusOptionByIndex", function (index) {
      var optionDomNode = _this.optionDomNodes[index];

      if (optionDomNode) {
        optionDomNode.focus();
        return true;
      } else {
        return false;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangePreselectedIndex", function (preselectedIndex) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        focus: true
      },
          focus = _ref.focus;

      if (_this.props.preselectedIndex === undefined) {
        _this.setState({
          preselectedIndex: preselectedIndex
        });

        if (focus) {
          _this.focusOptionByIndex(preselectedIndex);
        }
      }

      _this.props.onChangePreselectedIndex(preselectedIndex);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownContainer", function (event) {
      // Call the user's key down handler first. If they prevent the default event
      // behavior, don't run any of our code.
      _this.props.onKeyDown(event);

      if (!event.defaultPrevented) {
        var key = (0, _keycode["default"])(event);
        var keyUsed = false; // Move the preselection up or down in the list when the up arrow is pressed

        if (key === "up" || key === "down") {
          var preselectedIndex = _this.getNextPreselectedIndex(key === "up" ? -1 : 1);

          _this.onChangePreselectedIndex(preselectedIndex);

          _this.scrollOptionIntoView(preselectedIndex);

          keyUsed = true;
        } // Simulate a click on the current preselected option when enter or space is
        // pressed


        if (key === "enter" || key === "space") {
          var _preselectedIndex = _this.getPreselectedIndex();

          var option = _this.allOptions[_preselectedIndex];

          if (option && !option.props.disabled) {
            _this.allOptions[_preselectedIndex].props.onClick();
          }

          keyUsed = true;
        } // Don't perform the normal action associated with the key (i.e. scroll for
        // arrows) if the key was used for an option list action


        if (keyUsed) {
          event.preventDefault();
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "optionRef", function (index) {
      return function (domNode) {
        return (
          /* eslint-disable-next-line react/no-find-dom-node */
          _this.optionDomNodes[index] = _reactDom["default"].findDOMNode(domNode)
        );
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollOptionIntoView", function (index) {
      var optionDomNode = _this.optionDomNodes[index];

      if (optionDomNode) {
        optionDomNode.scrollIntoView(optionDomNode);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(OptionList, [{
    key: "focus",
    value: function focus() {
      return this.listDomNode.focus();
    }
  }, {
    key: "processChildren",
    value: function processChildren() {
      var _this2 = this;

      var preselectedIndex = this.state.preselectedIndex;
      var id = this.props.id || this.id;
      var processedChildren = []; // Rest option counter to 0

      var optionCounter = 0; // Reset allOptions which tracks option components (no group components)

      this.allOptions = [];

      _react["default"].Children.toArray(this.props.children).forEach(function (child) {
        if (!child) {
          return;
        } else if (isGroup(child)) {
          var _this2$allOptions;

          var updatedGroup = /*#__PURE__*/_react["default"].cloneElement(child, child.props, _react["default"].Children.map(child.props.children, function (option, i) {
            var index = optionCounter + i;
            return /*#__PURE__*/_react["default"].cloneElement(option, {
              ref: _this2.optionRef(index),
              id: "".concat(id, "-").concat(child.props.role, "-").concat(index),
              // If "child" (the group) is disabled then disable all of its options
              disabled: child.props.disabled || option.props.disabled,
              preselected: index === preselectedIndex,
              showIndicator: _this2.props.multiSelectable,
              onChangePreselected: function onChangePreselected(preselected) {
                return (// Don't shift focus on mouse over
                  _this2.onChangePreselectedIndex(preselected ? index : -1, {
                    focus: false
                  })
                );
              }
            });
          })); // Update allOptions tracker


          _this2.allOptions = (_this2$allOptions = _this2.allOptions).concat.apply(_this2$allOptions, (0, _toConsumableArray2["default"])(updatedGroup.props.children)); // Push onto array

          processedChildren.push(updatedGroup); // Update option counter

          optionCounter += updatedGroup.props.children.length;
        } else {
          var index = optionCounter;

          var updatedOption = /*#__PURE__*/_react["default"].cloneElement(child, {
            ref: _this2.optionRef(index),
            id: "".concat(id, "-").concat(child.props.role, "-").concat(index),
            preselected: index === preselectedIndex,
            showIndicator: _this2.props.multiSelectable,
            onChangePreselected: function onChangePreselected(preselected) {
              return (// Don't shift focus on mouse over
                _this2.onChangePreselectedIndex(preselected ? index : -1, {
                  focus: false
                })
              );
            }
          }); // Update allOptions tracker


          _this2.allOptions = _this2.allOptions.concat(updatedOption); // Push onto array

          processedChildren.push(updatedOption); // Update option counter

          optionCounter += 1;
        }
      });

      return processedChildren;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Scroll the preselected or selected option into view on mount
      var preselectedIndex = this.getPreselectedIndex();

      if (preselectedIndex !== -1) {
        this.scrollOptionIntoView(preselectedIndex);
      } else {
        this.scrollOptionIntoView(this.getSelectedIndex(this.allOptions));
      } // Focus on mount


      if (this.props.autoFocus || this.props.inaccessibleAutoFocus) {
        // NOTE: React guarantees that callback refs will be resolved before
        // componentDidMount is called, so this is safe.
        this.focus();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          preselectedIndex = _this$props.preselectedIndex,
          defaultPreselectedIndex = _this$props.defaultPreselectedIndex; // If the preselected index was changed via props, update the internal state

      if (preselectedIndex !== undefined && preselectedIndex !== prevProps.preselectedIndex) {
        this.setState({
          preselectedIndex: preselectedIndex
        });
        this.focusOptionByIndex(preselectedIndex);
      } else if (preselectedIndex === undefined && defaultPreselectedIndex !== undefined && defaultPreselectedIndex !== prevProps.defaultPreselectedIndex) {
        this.setState({
          preselectedIndex: defaultPreselectedIndex
        }); // If the default was changed then scroll it into view. We don't do this
        // if the `preselectedIndex` prop is changed because that means the parent
        // component is fully managing state and will need to be responsible for
        // managing scroll position as well.

        this.scrollOptionIntoView(defaultPreselectedIndex);

        if (this.props.recalculateFocusOnUpdate) {
          this.focusOptionByIndex(defaultPreselectedIndex);
        }
      } // Always refocus on update in case the options move around and between groups
      // which could break React's connection with the underlying elements
      else if (this.props.recalculateFocusOnUpdate) {
        var _preselectedIndex2 = this.state.preselectedIndex;

        if (_preselectedIndex2 >= 0) {
          var successfulFocus = this.focusOptionByIndex(_preselectedIndex2); // If focusing on the preselected index was not successful, see if it was
          // because the option list shrunk

          if (!successfulFocus) {
            var filteredDomNodeList = this.optionDomNodes.filter(function (option) {
              return option;
            }); // If the list shrank and the preselected index now exceeds the number
            // of valid options, focus on the last valid option

            if (_preselectedIndex2 > filteredDomNodeList.length - 1) {
              this.setState({
                preselectedIndex: filteredDomNodeList.length - 1
              });
            }
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var props = this.props;
      var id = props.id || this.id;
      var children = this.processChildren();
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _optionList["default"],
        map: (0, _token.getTokenHelper)("optionList")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: _this3.updateListDomNode,
          onKeyDown: _this3.onKeyDownContainer,
          tabIndex: "0",
          role: props.role,
          "aria-multiselectable": props.multiSelectable,
          onFocus: props.onFocus,
          onBlur: props.onBlur,
          className: styles(t),
          id: id
        }, children);
      });
    }
  }]);
  return OptionList;
}(_react["default"].Component);

(0, _defineProperty2["default"])(OptionList, "defaultProps", {
  role: "listbox",
  onKeyDown: _noop["default"],
  onChangePreselectedIndex: _noop["default"]
});
OptionList.propTypes =  false ? {
  /**
   * A set of OptionListItem nodes.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * The index of the default "preselected" option. The "preselected" option
   * is the option that is highlighted and will be selected if the user
   * presses enter or space on their keyboard.
   *
   * NOTE: This is an uncontrolled component by default. It tracks the
   * preselected index using internal state. If the value of this prop changes
   * the internal state will be updated to reflect the new value, but
   * subsequent user interaction with the component may change the internal
   * state. To use make this component behave like a controlled component, use
   * the "preselectedIndex" and "onChangePreselectedIndex" props below.
   *
   */
  defaultPreselectedIndex: _propTypes["default"].number,

  /**
   * Sets an `id` attribute on the listbox element.
   */
  id: _propTypes["default"].string,

  /**
   * If set to true then the option list will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * If set to true if more than one option may be selected at once.
   */
  multiSelectable: _propTypes["default"].bool,

  /**
   * Use this to fix the index of the "preselected" option. This will disable
   * the internal state used to track the preselected index.
   */
  preselectedIndex: _propTypes["default"].number,

  /**
   * Set to true to have the option list continuously recalculate which list item
   * to focus. Helpful when the list might have options move disappear or move.
   */
  recalculateFocusOnUpdate: _propTypes["default"].bool,
  role: _propTypes["default"].string,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called any time the OptionList wants to update the preselected
   * index
   */
  onChangePreselectedIndex: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   *
   * If `event.preventDefault()` is called from this handler then the option
   * list's default keyboard behavior will be prevented.
   */
  onKeyDown: _propTypes["default"].func
} : {};
var _default = OptionList;
exports["default"] = _default;

/***/ }),
/* 876 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    optionListOptionMobileSpacingInsetVertical: 16,
    optionListOptionMobileSpacingInsetHorizontal: 16,
    optionListOptionSpacingInsetVertical: 8,
    optionListOptionSpacingInsetHorizontal: 12,
    optionListOptionForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    optionListOptionForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    optionListOptionForegroundColorPreselected: tokens.themeForegroundInvertedDefault,
    optionListOptionForegroundColorPressed: tokens.themeForegroundInvertedDefault,
    optionListOptionForegroundColorSelected: tokens.themeForegroundInvertedDefault,
    optionListOptionBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
    optionListOptionBackgroundColorDisabled: tokens.themeBackgroundPrimaryDefault,
    optionListOptionBackgroundColorPreselected: tokens.themeForegroundAccentHover,
    optionListOptionBackgroundColorPressed: tokens.themeForegroundAccentPressed,
    optionListOptionBackgroundColorSelected: tokens.themeForegroundAccentDefault,
    optionListOptionIndicatorColorDefault: "rgba(0, 0, 0, 0)",
    optionListOptionIndicatorColorDisabled: tokens.themeForegroundPrimaryDisabled,
    optionListOptionIndicatorColorPreselected: tokens.themeForegroundAccentDefault,
    optionListOptionIndicatorColorPressed: tokens.themeForegroundInvertedDefault,
    optionListOptionIndicatorColorSelected: tokens.themeForegroundInvertedDefault,
    optionListOptionMotionDuration: "100ms",
    optionListOptionMotionFunction: "ease",
    optionListOptionLineHeight: "24px",
    optionListGroupHeaderSpacingInsetVertical: 8,
    optionListGroupHeaderSpacingInsetHorizontal: 12,
    optionListGroupHeaderForegroundColorDefault: tokens.themeForegroundSecondaryDefault,
    optionListGroupHeaderForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    optionListGroupHeaderBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
    optionListGroupHeaderBackgroundColorDisabled: tokens.themeBackgroundPrimaryDefault,
    optionListGroupHeaderFontWeight: 600,
    optionListGroupBorderColor: tokens.themeBorderSecondaryDefault,
    optionListGroupBorderWidth: 1
  }
};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _checkLarge = _interopRequireDefault(__webpack_require__(362));

var _clickable = _interopRequireDefault(__webpack_require__(108));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var OptionListItem = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(OptionListItem, _React$Component);

  var _super = _createSuper(OptionListItem);

  function OptionListItem() {
    var _this;

    (0, _classCallCheck2["default"])(this, OptionListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      preselected: _this.props.preselected,
      selected: _this.props.selected
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "mouseX", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "mouseY", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseMove", function (event) {
      if (!_this.props.preselected) {
        _this.props.onChangePreselected(true);
      } // Track the mouse position so we can detect whether `onMouseLeaveOption`
      // was triggered by a mouse move or by something else (e.g. scrolling).


      _this.mouseX = event.clientX;
      _this.mouseY = event.clientY;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseEnter", function (event) {
      // Track the mouse position so we can detect whether `onMouseLeaveOption`
      // was triggered by a mouse move or by something else (e.g. scrolling).
      _this.mouseX = event.clientX;
      _this.mouseY = event.clientY;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseLeave", function (event) {
      // If the user has moused out of an option by moving their mouse (and not by
      // scrolling the option out from under their mouse) then blur it. Don't blur
      // if they haven't moved their mouse. This allows the user to use keyboard
      // navigation while their mouse cursor is resting over the list (otherwise
      // the mouse and keyboard end up fighting over control).
      if (_this.props.preselected && (event.clientX !== _this.mouseX || event.clientY !== _this.mouseY)) {
        _this.props.onChangePreselected(false);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(OptionListItem, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.label !== this.props.label || nextProps.children !== this.props.children || nextProps.disabled !== this.props.disabled || nextProps.href !== this.props.href || nextProps.id !== this.props.id || nextState.selected !== this.state.selected || nextState.preselected !== this.state.preselected;
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var _this$state = this.state,
          selected = _this$state.selected,
          preselected = _this$state.preselected;
      var children = props.children ? props.children({
        selected: selected,
        preselected: preselected
      }) : props.label;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
      return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, {
        disabled: props.disabled,
        id: props.id,
        href: props.href,
        rel: props.rel,
        target: props.target,
        onClick: props.onClick,
        onMouseMove: props.disabled ? undefined : this.onMouseMove,
        onMouseEnter: props.disabled ? undefined : this.onMouseEnter,
        onMouseLeave: props.disabled ? undefined : this.onMouseLeave,
        role: props.role,
        "aria-selected": selected ? "true" : "false",
        "aria-current": preselected ? "true" : undefined,
        "aria-label": props.label,
        tabIndex: "-1",
        "mdn-option-list-item": ""
      }), /*#__PURE__*/_react["default"].createElement("div", null, children), props.showIndicator ? /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        tokens: _checkLarge["default"]
      }) : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var preselected = state.preselected,
          selected = state.selected;

      if (props.selected !== selected) {
        // If the option was just selected or deselected then don't show the
        // preselected state
        return {
          selected: props.selected,
          preselected: false
        };
      } else if (props.preselected !== preselected) {
        // If the preselected prop was changed from on high then update the
        // internal preselected state to stay in sync
        return {
          preselected: props.preselected
        };
      } else {
        return null;
      }
    }
  }]);
  return OptionListItem;
}(_react["default"].Component);

(0, _defineProperty2["default"])(OptionListItem, "defaultProps", {
  selected: false,
  preselected: false,
  role: "option"
});
OptionListItem.propTypes =  false ? {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  children: _propTypes["default"].func,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * IMPORTANT: This is provided by OptionList, do not set manually.
   */
  id: _propTypes["default"].string,

  /**
   * IMPORTANT: This is provided by OptionList, do not set manually.
   */
  preselected: _propTypes["default"].bool,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,
  role: _propTypes["default"].string,
  selected: _propTypes["default"].bool,

  /**
   * IMPORTANT: This is provided by OptionList, do not set manually.
   */
  showIndicator: _propTypes["default"].bool,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * IMPORTANT: This is provided by OptionList, do not set manually.
   */
  onChangePreselected: _propTypes["default"].func,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func
} : {};
var _default = OptionListItem;
exports["default"] = _default;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MenuItem = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MenuItem, _React$Component);

  var _super = _createSuper(MenuItem);

  function MenuItem() {
    (0, _classCallCheck2["default"])(this, MenuItem);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(MenuItem, [{
    key: "render",
    value: function render() {
      // This component is used to create a nice API, the OptionListItem
      // component is used to actually render the menu item
      return null;
    }
  }]);
  return MenuItem;
}(_react["default"].Component);

MenuItem.propTypes =  false ? {
  /**
   * The content of the menu item. Plain text and icons are recommended.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * An accessible label for the component. This will not be visible in the UI,
   * but will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   *
   * @since 5.11.0
   */
  "aria-label": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.13.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func
} : {};
var _default = MenuItem;
exports["default"] = _default;

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_AdtaDeviceOverviewContext__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddAdtaSingleDeviceModal=function AddAdtaSingleDeviceModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__context_AdtaDeviceOverviewContext__["a" /* AdtaDeviceOverviewContext */]),viewModel=_useContext2.viewModel,dispatch=_useContext2.dispatch;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),port=_useState4[0],setPort=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),deviceType=_useState6[0],setDeviceType=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),name=_useState8[0],setName=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),ip=_useState10[0],setIp=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),mac=_useState12[0],setMac=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),id=_useState14[0],setId=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),vendor=_useState16[0],setVendor=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),specVersion=_useState18[0],setSpecVersion=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState20=_slicedToArray(_useState19,2),sorterType=_useState20[0],setSorterType=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState22=_slicedToArray(_useState21,2),hamperVendor=_useState22[0],setHamperVendor=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState24=_slicedToArray(_useState23,2),hamperVersion=_useState24[0],setHamperVersion=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState26=_slicedToArray(_useState25,2),incomingAutoSingulated=_useState26[0],setIncomingAutoSingulated=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState28=_slicedToArray(_useState27,2),incomingAutoSorted=_useState28[0],setIncomingAutoSorted=_useState28[1];// Error
var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState30=_slicedToArray(_useState29,2),portErr=_useState30[0],setPortErr=_useState30[1];var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState32=_slicedToArray(_useState31,2),deviceTypeErr=_useState32[0],setDeviceTypeErr=_useState32[1];var _useState33=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState34=_slicedToArray(_useState33,2),nameErr=_useState34[0],setNameErr=_useState34[1];var _useState35=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState36=_slicedToArray(_useState35,2),ipErr=_useState36[0],setIpErr=_useState36[1];var _useState37=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState38=_slicedToArray(_useState37,2),macErr=_useState38[0],setMacErr=_useState38[1];var _useState39=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState40=_slicedToArray(_useState39,2),idErr=_useState40[0],setIdErr=_useState40[1];var _useState41=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState42=_slicedToArray(_useState41,2),vendorErr=_useState42[0],setVendorErr=_useState42[1];var _useState43=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState44=_slicedToArray(_useState43,2),specVersionErr=_useState44[0],setSpecVersionErr=_useState44[1];var _useState45=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState46=_slicedToArray(_useState45,2),sorterTypeErr=_useState46[0],setSorterTypeErr=_useState46[1];var _useState47=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState48=_slicedToArray(_useState47,2),hamperVendorErr=_useState48[0],setHamperVendorErr=_useState48[1];var _useState49=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState50=_slicedToArray(_useState49,2),hamperVersionErr=_useState50[0],setHamperVersionErr=_useState50[1];var _useState51=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState52=_slicedToArray(_useState51,2),incomingAutoSingulatedErr=_useState52[0],setIncomingAutoSingulatedErr=_useState52[1];var _useState53=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState54=_slicedToArray(_useState53,2),incomingAutoSortedErr=_useState54[0],setIncomingAutoSortedErr=_useState54[1];var initialMonitoringValue={startTime:"0",endTime:"0",reason:""};var _useState55=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(JSON.stringify(initialMonitoringValue)),_useState56=_slicedToArray(_useState55,2),monitoring=_useState56[0],setMonitoring=_useState56[1];var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext3.showCustomAlert;var stateValues={mac:mac,ip:ip,name:name,deviceType:deviceType,port:port,deviceConfig:{type:__WEBPACK_IMPORTED_MODULE_11__util_Util__["e" /* assetTypeToConfigTypeDict */].typeADTA,id:id},vendorAttributes:{vendor:vendor,spec_version:specVersion,sorter_type:sorterType,hamper_vendor:hamperVendor,hamper_version:hamperVersion,incoming_auto_singulated:incomingAutoSingulated,incoming_auto_sorted:incomingAutoSorted},monitoring:monitoring};var onCloseModal=function onCloseModal(){setOpen(false);setSelected("");resetInputState();setShowAlert(false);};var onClickConfirm=function onClickConfirm(stateValues){if(Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["Q" /* validateNewAdtaDevice */])(stateValues)){showWarning(formatMessage({id:"device.editWarning"}),function(){setShowAlert(false);stateValues.deviceConfig=JSON.stringify(stateValues.deviceConfig);if(selected){stateValues.sorterConfig=JSON.stringify(viewModel.sorterConfig[stateValues.mac]);stateValues.sorterTestPackage=JSON.stringify(viewModel.sorterTestPackageConfig[stateValues.mac]);updateData(stateValues);}else{stateValues.sorterConfig="[]";stateValues.sorterTestPackage="[]";addData(stateValues);}resetInputState();setOpen(false);});}else{setShowAlert(true);}};function resetInputState(){// setting state of input fields as empty to have empty inputs on clicking Add Device again
setMac("");setMacErr(false);setMonitoring(JSON.stringify(initialMonitoringValue));resetAssetDetails();resetAssetDetailErrors();}var resetAssetDetails=function resetAssetDetails(){setIp("");setId("");setPort("");setDeviceType("");setName("");setVendor("");setSpecVersion("");setSorterType("");setHamperVendor("");setHamperVersion("");setIncomingAutoSingulated("");setIncomingAutoSorted("");};var resetAssetDetailErrors=function resetAssetDetailErrors(){setIpErr(false);setIdErr(false);setPortErr(false);setDeviceTypeErr(false);setNameErr(false);setVendorErr(false);setSpecVersionErr(false);setSorterTypeErr(false);setHamperVendorErr(false);setHamperVersionErr(false);setIncomingAutoSingulatedErr(false);setIncomingAutoSortedErr(false);};var prefill=function prefill(value){if(viewModel.adtaDeviceInformation.hasOwnProperty(value)){setSelected(value);var device=viewModel.adtaDeviceInformation[value];var vendorAttributes=device.vendorAttributes;resetAssetDetailErrors();setMac(device.mac);setIp(device.ip);setId(device.id);setPort(device.port);setDeviceType(device.deviceType);setName(device.name);setVendor(vendorAttributes.vendor);setSpecVersion(vendorAttributes.spec_version);setSorterType(vendorAttributes.sorter_type);setHamperVendor(vendorAttributes.hamper_vendor);setHamperVersion(vendorAttributes.hamper_version);setIncomingAutoSingulated(vendorAttributes.incoming_auto_singulated);setIncomingAutoSorted(vendorAttributes.incoming_auto_sorted);var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};setMonitoring(JSON.stringify(deviceMonitoring));}else if(selected){setSelected("");resetAssetDetails();}};var addData=function addData(stateValues){dispatch({type:'ADD_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues,showCustomAlert:showCustomAlert}});};var updateData=function updateData(stateValues){dispatch({type:'UPDATE_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues,showCustomAlert:showCustomAlert}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.add_device_button_modal"}),open:open,onOpen:function onOpen(){return prefill(selected);},onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.mac",defaultMessage:"MAC Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"mac-input",value:mac,onChange:setMac,mask:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["i" /* MAC_MASK */],disabled:selected,onBlur:function onBlur(){setMacErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.mac,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].MAC));prefill(mac);},error:macErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"ip-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.ip",defaultMessage:"IP Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"ip-input",value:ip,onChange:setIp,onBlur:function onBlur(){return setIpErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.ip,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["g" /* IP_ADDRESS_PATTERN */]));},error:ipErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"port-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.port",defaultMessage:"Port"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"port-input",value:port,onChange:setPort,onBlur:function onBlur(){return setPortErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.port,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].PORT));},error:portErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.protocol",defaultMessage:"Protocol"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select___default.a,{id:"device-type-input",value:deviceType,onChange:function onChange(value){return setDeviceType(value);},onBlur:function onBlur(){return setDeviceTypeErr(!deviceType);},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.select_protocol",defaultMessage:"Select a protocol"}),error:deviceTypeErr,width:"100%"},__WEBPACK_IMPORTED_MODULE_10__util_Validations__["k" /* PROTOCOLS */].ADTA.map(function(protocol){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select__["SelectOption"],{key:protocol,value:protocol,label:protocol});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"name-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.name",defaultMessage:"Device Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"name-input",value:name,onChange:setName,onBlur:function onBlur(){return setNameErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.name,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].NAME));},error:nameErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.name_finger_desc",defaultMessage:"Display name of the device. e.g. \"Finger A\""})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"id-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.device_id",defaultMessage:"Device ID"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"id-input",value:id,onChange:setId,onBlur:function onBlur(){return setIdErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.deviceConfig.id,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].DEVICE_ID));},error:idErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.device_id_finger_desc",defaultMessage:"Unique local identifier for the device. eg. \"A\" for \"Finger A\""})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select___default.a,{id:"device-type-input",value:vendor,onChange:function onChange(value){return setVendor(value);},onBlur:function onBlur(){return setVendorErr(!vendor);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_vendor'}),error:vendorErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].VENDOR).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.spec_version'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select___default.a,{id:"device-type-input",value:specVersion,onChange:function onChange(value){return setSpecVersion(value);},onBlur:function onBlur(){return setSpecVersionErr(!specVersion);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_version'}),error:specVersionErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].SPEC_VERSION).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.sorter_type'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select___default.a,{id:"device-type-input",value:sorterType,onChange:function onChange(value){return setSorterType(value);},onBlur:function onBlur(){return setSorterTypeErr(!sorterType);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_sorter_type'}),error:sorterTypeErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].SORTER_TYPE).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["o" /* SORTER_TYPE_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.hamper_vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select___default.a,{id:"device-type-input",value:hamperVendor,onChange:function onChange(value){return setHamperVendor(value);},onBlur:function onBlur(){return setHamperVendorErr(!hamperVendor);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_hamper_vendor'}),error:hamperVendorErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].HAMPER_VENDOR).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["c" /* HAMPER_VENDOR_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.hamper_version'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select___default.a,{id:"device-type-input",value:hamperVersion,onChange:function onChange(value){return setHamperVersion(value);},onBlur:function onBlur(){return setHamperVersionErr(!hamperVersion);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_hamper_version'}),error:hamperVersionErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].HAMPER_VERSION).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["d" /* HAMPER_VERSION_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.incoming_auto_singulated'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select___default.a,{id:"device-type-input",value:incomingAutoSingulated,onChange:function onChange(value){return setIncomingAutoSingulated(value);},onBlur:function onBlur(){return setIncomingAutoSingulatedErr(!incomingAutoSingulated);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_incoming_auto_singulated'}),error:incomingAutoSingulatedErr,width:"100%"},__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].INCOMING_AUTO_SINGULATED.map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["e" /* INCOMING_AUTO_SINGULATED_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.incoming_auto_sorted'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select___default.a,{id:"device-type-input",value:incomingAutoSorted,onChange:function onChange(value){return setIncomingAutoSorted(value);},onBlur:function onBlur(){return setIncomingAutoSortedErr(!incomingAutoSorted);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_incoming_auto_sorted'}),error:incomingAutoSortedErr,width:"100%"},__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].INCOMING_AUTO_SORTED.map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["f" /* INCOMING_AUTO_SORTED_DISPLAY_VALUES */][value]});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stateValues);}},selected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmEdit",defaultMessage:"Confirm edit"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddAdtaSingleDeviceModal));

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _modal = _interopRequireDefault(__webpack_require__(407));

var _modalBox = _interopRequireWildcard(__webpack_require__(881));

var _theme = __webpack_require__(24);

var _scrim = _interopRequireDefault(__webpack_require__(411));

var _portal = _interopRequireDefault(__webpack_require__(207));

var _responsive = _interopRequireDefault(__webpack_require__(414));

var _animateMount = _interopRequireWildcard(__webpack_require__(412));

var _propTypes2 = _interopRequireDefault(__webpack_require__(126));

var _onDirectClick = _interopRequireDefault(__webpack_require__(413));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AnimateFadeScaleWithMount = (0, _animateMount["default"])(_animateMount.AnimateFadeScale);
/**
 * The scrim is the vertical scroll container, and uses flexbox to center the
 * modal in the viewport.
 */

var scrimStyles = (0, _emotion.css)({
  display: "flex",
  alignItems: "center",
  overflow: "auto"
});
/**
 * This wrapper uses margin "auto" to center the modal, but sets a max width and
 * height which force the modal to overflow to the bottom/right of the viewport
 * instead of oveflowing all sides (which looks funky and makes the top/left
 * content inaccessible). For details see:
 * https://stackoverflow.com/questions/33454533/cant-scroll-to-top-of-flex-item-that-is-overflowing-container
 */

var outerWrapperStyles = (0, _emotion.css)({
  maxWidth: "100%",
  maxHeight: "100%",
  margin: "auto"
});
/**
 * The inner wrapper applies a margin around the modal to ensure a certain
 * amount of scrim is always shown. Applying the margin here as opposed to on
 * the outer wrapper ensures that the margin below the modal is preserved even
 * if the modal overflows the viewport and requires scrolling (otherwise the
 * padding would disappear due to this problem:
 * https://www.brunildo.org/test/overscrollback.html).
 */

var innerWrapperStyles = (0, _emotion.css)({
  padding: "".concat(_modalBox.scrimSpacingVertical, "vh ").concat(_modalBox.scrimSpacingHorizontal, "vw"),
  // HACK: IE11 will only respect the max-height property of the modal if the
  // modal's parent is a flex column. See:
  // https://stackoverflow.com/questions/44635857/flexbox-max-height-issue-with-ie11
  display: "flex",
  flexDirection: "column"
});
/**
 * Don't bother updating the modal if it's persisting in a closed state.
 */

var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
  return !prevProps.open && !nextProps.open;
};
/**
 * Render a modal in the viewport. On desktop the modal will be shown with a
 * scrim behind it. On mobile the modal will be shown fullscreen. Only one modal
 * should be rendered at a time.
 *
 * NOTE: Do not mount a Modal inside an interactive element. The Modal's DOM
 * element will be rendered at the application root using a [React Portal](https://reactjs.org/docs/portals.html),
 * but events from the Modal will bubble up through the element where it was
 * mounted. If the element is interactive then this may result in unexpected
 * behavior (e.g. a click on the Modal being counted as a click on the element
 * where the Modal was mounted). The React team [recommends solving this](https://github.com/facebook/react/issues/11387#issuecomment-366142349)
 * by rendering the portal-based component *outside* of any interactive elements.
 */


var Modal = /*#__PURE__*/_react["default"].memo(function (props) {
  var t = (0, _theme.useTheme)(_modal["default"], "modal");
  var scrimRef = (0, _react.useRef)();
  var anchorRef = (0, _react.useRef)(); // We want an onClose callback, but only if props.onClose is defined

  var onCloseProp = props.onClose;
  var onCloseCallback = (0, _react.useCallback)(function () {
    if (anchorRef.current && anchorRef.current.focus) {
      anchorRef.current.focus();
    }

    onCloseProp();
  }, [onCloseProp, anchorRef]);
  var onCloseMaybe = onCloseProp ? onCloseCallback : undefined;
  (0, _react.useEffect)(function () {
    if (props.open) {
      // Remember the node that the modal was opened from. We'll try to focus on
      // this when the modal is closed. We put this logic in a side effect rather
      // then the `modalRef` callback b/c by the time that callback is called
      // it's too late and the `activeElement` might already be an auto-focused
      // element inside of the modal - negating the benefit of remembering which
      // node caused the modal to open.
      anchorRef.current = document.activeElement;
    }
  }, [props.open]);
  var modalRef = (0, _react.useCallback)(function (modalNode) {
    if (modalNode) {
      // Get the active element and check if it's inside of the modal
      var activeElementInsideModal = modalNode.contains(document.activeElement);

      if (!activeElementInsideModal) {
        // Focus the first node in the Modal
        modalNode.focus(); // Reset the scroll position of the scrim to counteract the browser
        // auto-scrolling to the focused node. Note that we have to wait one
        // event loop for this to work (otherwise we'd be resetting the scroll
        // *before* the browser auto-scrolls).
        // Prevent the browser from scrolling to the focused node to avoid a
        // jitter when the modal opens.
        // TODO: Update this to use the "preventScroll" focus option when Safari
        // implements that and we drop support for IE11.

        if (scrimRef.current) {
          setTimeout(function () {
            scrimRef.current.scrollTop = 0;
            scrimRef.current.scrollLeft = 0;
          }, 0);
        }
      }
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(AnimateFadeScaleWithMount, {
    open: props.open,
    duration: t("motionDuration"),
    easing: t("motionFunction"),
    onOpen: props.onOpen
  }, function (_ref) {
    var className = _ref.className,
        onTransitionEnd = _ref.onTransitionEnd,
        open = _ref.open;
    return /*#__PURE__*/_react["default"].createElement(_responsive["default"], {
      query: "min-width",
      props: {
        fullscreen: (0, _defineProperty2["default"])({
          "default": true
        }, "".concat(t("floatingBreakpoint"), "px"), false)
      }
    }, function (_ref2) {
      var fullscreen = _ref2.fullscreen;

      var modal = /*#__PURE__*/_react["default"].createElement(_modalBox["default"], (0, _extends2["default"])({}, props, {
        onClose: onCloseMaybe,
        t: t,
        scrollContainer: props.scrollContainer,
        fullscreen: fullscreen,
        className: className,
        onTransitionEnd: onTransitionEnd,
        ref: modalRef
      }));

      return /*#__PURE__*/_react["default"].createElement(_portal["default"], null, /*#__PURE__*/_react["default"].createElement(_scrim["default"], {
        open: props.open || open,
        className: scrimStyles,
        onClick: onCloseMaybe,
        ref: scrimRef
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: outerWrapperStyles
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: innerWrapperStyles,
        onMouseDown: // The inner wrapper has a little padding
        // applied to keep the modal away from the
        // edges of the viewport. This padding appears
        // as scrim space to the user, but it blocks
        // clicks to the scrim so we have to add the
        // click-to-close behavior here as well
        (0, _onDirectClick["default"])(onCloseMaybe)
      }, modal))));
    });
  });
}, shouldNotUpdate);

Modal.displayName = "Modal";
Modal.propTypes =  false ? {
  /**
   * The contents of the modal.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Is the modal open? If false the modal will not be mounted in the DOM. If
   * changed from false to true the modal will be mounted and will animate
   * open.
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.11.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Sets the padding on the body of the modal
   */
  bodySpacingInset: _propTypes2["default"].spacing(4),

  /**
   * Determines whether or not the click event for the close button will continue to bubble up
   * through the DOM. Read the [Event.stopPropagation() docs](https://developer.mozilla.org/en-US/docs/Web/API/Event/stopPropagation)
   * for details.
   *
   * @since 5.x
   */
  closeButtonPropagateClickEvent: _propTypes["default"].bool,

  /**
   * An accessibility label for the close button. This will be read by screen
   * readers, but will not be present in the UI.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * NOTE: This is deprecated, use `aria-describedby` instead.
   *
   * @deprecated 5.x
   */
  describedById: _propTypes["default"].string,

  /**
   * If the modal is a form (see `onSubmitForm`), this [action](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) will be passed
   * to the form element.
   */
  formAction: _propTypes["default"].string,

  /**
   * If the modal is a form (see `onSubmitForm`), this [method](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) will be passed
   * to the form element.
   */
  formMethod: _propTypes["default"].oneOf(["get", "post", "dialog"]),

  /**
   * This determines where the vertical scrollbar is placed for modals with
   * content that overflows vertically. If set to "modal", the scrollbar will
   * be placed inside the modal. The content will overflow inside the modal,
   * but the the modal itself will fit inside the viewport. If set to
   * "viewport", the scrollbar will be placed inside the viewport. The modal
   * will overflow the viewport, and the user will scroll the entire modal to
   * view the content.
   *
   * NOTE: This does not currently affect the horizontal scrollbar for content
   * which is too wide for the modal and cannot wrap. The horizontal scrollbar
   * will always be shown inside the modal.
   *
   * NOTE: This only applies to modals on desktop. On mobile modals are shown
   * fullscreen so there is no meaningful distinction between the modal
   * and the viewport.
   */
  scrollContainer: _propTypes["default"].oneOf(["modal", "viewport"]),

  /**
   * The title of the modal. This will be shown in the modal header. If no
   * title is provided, no header will be shown.
   */
  title: _propTypes["default"].string,

  /**
   * Set the width of the modal using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   *
   * This width only applies to desktop, as modals are displayed
   * full-screen on mobile.
   *
   * A max width is applied to the modal in
   * addition to this width to ensure that the modal is never too wide for the
   * viewport.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * If a callback is provided here, a close button will be rendered in the
   * modal. The user will be able to close the modal by clicking on the button
   * or the scrim behind the modal. The callback will be fired whent he user
   * performs either of these actions.
   *
   * If a callback is not provided here, no close button will be rendered and
   * nothing will happen when the user clicks the scrim. This can be helpful
   * for dialog modals that require an action from the user. Note that if
   * you do not provide a close handler here you *must* provide another way
   * for the user to close the modal (e.g. by confirming or denying a dialog
   * action). Otherwise the user will be stuck in the modal.
   */
  onClose: _propTypes["default"].func,

  /**
   * This callback will be fired after the Modal opens.
   */
  onOpen: _propTypes["default"].func,

  /**
   * If a callback is provided here the Modal will behave like a [form](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
   *
   * To set the [action and method](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) of the form, see `formAction` and `formMethod`.
   *
   * If using a Meridian [Button](https://meridian.a2z.com/components/button/?platform=react-web&detailsTab=api) in the footer for submission,
   * be sure to use set the button's `submit` prop to `true`.
   *
   * @since 4.x
   */
  onSubmitForm: _propTypes["default"].func
} : {};
Modal.defaultProps = {
  closeButtonPropagateClickEvent: true,
  closeLabel: "Close",
  bodySpacingInset: "medium",
  scrollContainer: "viewport"
};
var _default = Modal;
exports["default"] = _default;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrimSpacingVertical = exports.scrimSpacingHorizontal = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _keycode = _interopRequireDefault(__webpack_require__(72));

var _close = _interopRequireDefault(__webpack_require__(154));

var _elevation = __webpack_require__(81);

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _modalFooter = _interopRequireDefault(__webpack_require__(408));

var _button = _interopRequireDefault(__webpack_require__(8));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _focusTrap = _interopRequireDefault(__webpack_require__(170));

var _propTypes2 = _interopRequireDefault(__webpack_require__(126));

var _parsers = __webpack_require__(128);

var _isElementOf = _interopRequireDefault(__webpack_require__(94));

var _text = _interopRequireDefault(__webpack_require__(47));

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _focusRing = _interopRequireDefault(__webpack_require__(73));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var closeButtonWidth = 32; // px

var scrimSpacingVertical = 10; // vh

exports.scrimSpacingVertical = scrimSpacingVertical;
var scrimSpacingHorizontal = 10; //vw

exports.scrimSpacingHorizontal = scrimSpacingHorizontal;
var isFooter = (0, _isElementOf["default"])(_modalFooter["default"]);

var isNotFooter = function isNotFooter(child) {
  return !isFooter(child);
};

var styles = function styles(t, _ref) {
  var _css, _div;

  var focus = _ref.focus,
      scrollContainer = _ref.scrollContainer,
      fullscreen = _ref.fullscreen,
      width = _ref.width,
      bodySpacingInset = _ref.bodySpacingInset,
      showTitle = _ref.showTitle,
      showCloseButton = _ref.showCloseButton;
  var padding = (0, _parsers.parseSpacing)(bodySpacingInset);
  return (0, _emotion.css)(
  /**
   * Focus ring styles - important that these are first so subsequent styles
   * (like `position: fixed` for fullscreen modals) can overwrite the ring styles.
   */
  focus ? (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderRadius: t("borderRadius")
  }) : {},
  /**
   * Fullscreen vs non-fullscreen styles
   */
  fullscreen ? {
    // Fullscreen modals aren't shown in a scrim so we've got to handle
    // layout here
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: _elevation.elevationModal,
    // Use momentum scrolling on iOS. See:
    // https://css-tricks.com/snippets/css/momentum-scrolling-on-ios-overflow-elements/
    overflowY: "scroll",
    WebkitOverflowScrolling: "touch"
  } : {
    // Apply the user-provided width if we're not showing a fullscreen
    // modal
    width: width,
    // This allows the absolutely-positioned close button to anchor itself
    // to the modal
    position: "relative",
    boxShadow: t.boxShadowCss("dropShadow"),
    maxHeight: scrollContainer === "modal" ? "".concat(100 - scrimSpacingVertical * 2, "vh") : undefined,
    maxWidth: "".concat(100 - scrimSpacingHorizontal * 2, "vw"),
    borderRadius: t("borderRadius")
  }, {
    /**
     * Common styles
     */
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: t("bodyBackgroundColor"),
    outline: "none",

    /**
     * Header styles
     */
    "& > header": (0, _emotion.css)((0, _text["default"])(t), (_css = {
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      minHeight: t("headerMinHeight"),
      paddingTop: t("headerSpacingInsetTop"),
      paddingBottom: t("headerSpacingInsetBottom"),
      // HACK: IE11 does not support padding-inline-* so we have
      // to use directional padding-left/right. If/when we drop IE11
      // and we update the token names, we can simplify these styles to be:
      // {
      //   paddingInlineStart: t("headerSpacingInsetStart")
      //   paddingInlineEnd: t("headerSpacingInsetEnd")
      // }
      paddingRight: t("headerSpacingInsetRight"),
      paddingLeft: t("headerSpacingInsetLeft")
    }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
      paddingLeft: t("headerSpacingInsetRight"),
      paddingRight: t("headerSpacingInsetLeft")
    }), (0, _defineProperty2["default"])(_css, "backgroundColor", t("headerBackgroundColor")), (0, _defineProperty2["default"])(_css, "color", t("headerForegroundColor")), (0, _defineProperty2["default"])(_css, "fontWeight", t("headerFontWeight")), _css)),

    /**
     * Body styles
     */
    "& > div": (_div = {
      padding: (0, _parsers.parseSpacing)(bodySpacingInset).map(function (value) {
        return "".concat(value, "px");
      }).join(" "),
      // HACK: IE11 does not support padding-inline-* so we have
      // to use directional padding-left/right. If/when we drop IE11 we can simplify
      // these styles to be:
      // {
      //   paddingInlineEnd: showCloseButton && !showTitle
      //             ? `calc(${padding[1] || padding[0]}px + ${closeButtonWidth}px)`
      //             : undefined,
      // }
      // Add extra right-padding on modals with no title and a close button
      paddingRight: showCloseButton && !showTitle ? "calc(".concat(padding[1] || padding[0], "px + ").concat(closeButtonWidth, "px)") : undefined
    }, (0, _defineProperty2["default"])(_div, "[dir=\"rtl\"] &", {
      paddingLeft: showCloseButton && !showTitle ? "calc(".concat(padding[1] || padding[0], "px + ").concat(closeButtonWidth, "px)") : undefined,
      // HACK: Need to remove the additional right padding until we
      // update to use paddingInlineStart
      paddingRight: "".concat(t("headerSpacingInsetLeft"), "px !important")
    }), (0, _defineProperty2["default"])(_div, "overflowY", scrollContainer === "modal" ? "auto" : undefined), (0, _defineProperty2["default"])(_div, "overflowX", "auto"), (0, _defineProperty2["default"])(_div, "flex", fullscreen ? "auto" : undefined), _div),

    /**
     * Footer styles
     */
    "& > footer": {
      borderTop: t.borderCss("footerBorder"),
      padding: t("footerSpacingInset")
    }
  });
};

var closeButtonStyles = function closeButtonStyles(t) {
  var _css2;

  return (0, _emotion.css)((_css2 = {
    position: "absolute",
    top: t("closeButtonSpacingTop"),
    right: t("closeButtonSpacingRight")
  }, (0, _defineProperty2["default"])(_css2, "[dir=\"rtl\"] &", {
    left: t("closeButtonSpacingRight"),
    right: "auto"
  }), (0, _defineProperty2["default"])(_css2, "zIndex", _elevation.elevationForeground), _css2));
};
/* eslint-disable react/prop-types, react/display-name */
// The element we use at the root of the modal depends on
// the presence of an `onSubmit` prop. If the method
// is present, the modal uses a <form> element, else
// a <div>


var ModalBoxRoot = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(props.onSubmit ? "form" : "div", _objectSpread(_objectSpread({}, props), {}, {
    tabIndex: 0,
    ref: ref,
    role: "dialog"
  }));
});
/* eslint-enable react/prop-types, react/display-name */

/**
 * This component can be used to render a modal for your application
 */


var ModalBox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onClose = props.onClose,
      onSubmitForm = props.onSubmitForm,
      formAction = props.formAction,
      formMethod = props.formMethod;
  var id = (0, _react.useMemo)(function () {
    return (0, _uniqueId["default"])("modal-");
  }, []);
  var headerId = props.title ? "".concat(id, "-header") : undefined;

  var footer = _react["default"].Children.toArray(props.children).filter(isFooter)[0];

  var _useFocus = (0, _useFocus2["default"])(props),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps,
      focusDescendent = _useFocus.focusDescendent; // Call the onClose handler if the esc key is pressed


  var onKeyDownDocument = (0, _react.useCallback)(function (event) {
    if ((0, _keycode["default"])(event) === "esc") {
      onClose();
    }
  }, [onClose]); // Bind the onKeyDownDocument handler to the window

  (0, _react.useEffect)(function () {
    if (onClose) {
      window.addEventListener("keydown", onKeyDownDocument);
    }

    return function () {
      return window.removeEventListener("keydown", onKeyDownDocument);
    };
  }, [onClose, onKeyDownDocument]);
  var onSubmit = (0, _react.useCallback)(function (event) {
    if (!formAction && !formMethod) event.preventDefault();
    onSubmitForm();
  }, [formAction, formMethod, onSubmitForm]);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement(_focusTrap["default"], null, /*#__PURE__*/_react["default"].createElement(ModalBoxRoot, (0, _extends2["default"])({}, focusProps, {
    className: (0, _emotion.cx)(props.className, styles(props.t, {
      focus: focus && focusTrigger === "keyboard" && !focusDescendent,
      scrollContainer: props.scrollContainer,
      width: props.width,
      fullscreen: props.fullscreen,
      bodySpacingInset: props.bodySpacingInset,
      showTitle: Boolean(props.title),
      showCloseButton: Boolean(onClose)
    })),
    onTransitionEnd: props.onTransitionEnd,
    onSubmit: onSubmitForm ? onSubmit : undefined,
    action: props.formAction,
    method: props.formMethod,
    "aria-labelledby": headerId,
    "aria-describedby": props.describedById,
    "aria-modal": true,
    ref: ref
  }, passThroughProps), props.title ? /*#__PURE__*/_react["default"].createElement("header", {
    id: headerId
  }, props.title) : null, onClose ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    onClick: onClose,
    size: "small",
    type: "icon",
    backdropColor: props.title ? props.t("headerBackgroundColor") : props.t("bodyBackgroundColor"),
    className: closeButtonStyles(props.t),
    propagateClickEvent: props.closeButtonPropagateClickEvent
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _close["default"]
  }, props.closeLabel)) : null, /*#__PURE__*/_react["default"].createElement("div", null, _react["default"].Children.toArray(props.children).filter(isNotFooter)), footer ? footer : null));
});

ModalBox.displayName = "ModalBox";
ModalBox.propTypes =  false ? {
  closeLabel: _propTypes["default"].string.isRequired,
  bodySpacingInset: _propTypes2["default"].spacing(4),
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,
  closeButtonPropagateClickEvent: _propTypes["default"].bool,

  /**
   * NOTE: This is deprecated, use `aria-describedby` instead.
   *
   * @deprecated 5.x
   */
  describedById: _propTypes["default"].string,
  formAction: _propTypes["default"].string,
  formMethod: _propTypes["default"].oneOf(["get", "post", "dialog"]),
  fullscreen: _propTypes["default"].bool,
  scrollContainer: _propTypes["default"].oneOf(["modal", "viewport"]),
  t: _propTypes["default"].func,
  title: _propTypes["default"].string,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  onClose: _propTypes["default"].func,
  onSubmitForm: _propTypes["default"].func,
  onTransitionEnd: _propTypes["default"].func
} : {};
var _default = ModalBox;
exports["default"] = _default;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _reactDom = _interopRequireDefault(__webpack_require__(77));

var _keycode = _interopRequireDefault(__webpack_require__(72));

var _includes = _interopRequireDefault(__webpack_require__(409));

var _find = _interopRequireDefault(__webpack_require__(96));

var _findLast = _interopRequireDefault(__webpack_require__(887));

var _noop = _interopRequireDefault(__webpack_require__(59));

var _focus = __webpack_require__(193);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This component allows you to trap the keyboard focus within a particular
 * section of the DOM (the component's children). An optional onBeforeBlur event
 * handler can be defined that allows you to execute custom behavior when the
 * user attempts to move the focus outside of the trap by pressing the tab key.
 *
 * NOTE: This component only handles keyboard focus. If the mouse is used to
 * move focus outside of the trap then the trap will not prevent the focus
 * change and onBeforeBlur will not be called.
 *
 * NOTE: This component must be wrapped around a single element to work
 * properly.
 *
 * NOTE: This component only manages focus for elements that are
 * descendents in the real DOM. This means that it will ignore any portals
 * nested inside of it in the virtual DOM.
 */
var FocusTrap = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(FocusTrap, _React$Component);

  var _super = _createSuper(FocusTrap);

  function FocusTrap() {
    var _this;

    (0, _classCallCheck2["default"])(this, FocusTrap);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "rootNode", undefined);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDown", function (event) {
      if ((0, _keycode["default"])(event) === "tab") {
        var _getBoundingFocusNode = (0, _focus.getBoundingFocusNodes)(_this.rootNode),
            startNodes = _getBoundingFocusNode.startNodes,
            endNodes = _getBoundingFocusNode.endNodes;

        var willBlur = _this.willBlur(event, startNodes, endNodes);

        var allowBlur = willBlur && _this.props.onBeforeBlur(willBlur);

        var firstFocusNode = (0, _find["default"])(startNodes, _focus.canKeyboardFocusNode);
        var lastFocusNode = (0, _findLast["default"])(endNodes, _focus.canKeyboardFocusNode); // If onBeforeBlur returned nothing then loop the focus ourselves

        if (willBlur === -1 && allowBlur === undefined && lastFocusNode) {
          lastFocusNode.focus();
        }

        if (willBlur === 1 && allowBlur === undefined && firstFocusNode) {
          firstFocusNode.focus();
        } // If allowBlur was not explicitly set to true then cancel the default event
        // behavior


        if (willBlur && allowBlur !== true) {
          event.preventDefault();
        }
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(FocusTrap, [{
    key: "focus",
    value: function focus() {
      var node = (0, _focus.getKeyboardFocusNodes)(this.rootNode)[0];

      if (node) {
        node.focus();
      }
    }
  }, {
    key: "focusEnd",
    value: function focusEnd() {
      var nodes = (0, _focus.getKeyboardFocusNodes)(this.rootNode);
      var node = nodes[nodes.length - 1];

      if (node) {
        node.focus();
      }
    }
    /**
     * Takes in a keydown event, returns 0 if focus is not leaving, 1 if it's
     * leaving to the next node in the tab order, and -1 if it's leaving to the
     * previous node in the tab order.
     */

  }, {
    key: "willBlur",
    value: function willBlur(event, startNodes, endNodes) {
      var key = (0, _keycode["default"])(event);
      var target = event.target,
          shiftKey = event.shiftKey;
      return (0, _includes["default"])(endNodes, target) && key === "tab" && !shiftKey ? 1 : (0, _includes["default"])(startNodes, target) && key === "tab" && shiftKey ? -1 : 0;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      /* eslint-disable-next-line react/no-find-dom-node */
      this.rootNode = _reactDom["default"].findDOMNode(this);
      this.rootNode.addEventListener("keydown", this.onKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.rootNode.removeEventListener("keydown", this.onKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return FocusTrap;
}(_react["default"].Component);

(0, _defineProperty2["default"])(FocusTrap, "defaultProps", {
  onBeforeBlur: _noop["default"]
});
FocusTrap.propTypes =  false ? {
  children: _propTypes["default"].element.isRequired,

  /**
   * This is called when the focus trap is about to lose focus because of
   * keyboard input.
   *
   * If the function is not provided or does not return a value then the blur
   * will be blocked and focus will be looped within the trap. If the function
   * is provided and returns false then the blur will be blocked but the focus
   * will not automatically be looped. If the function is provided and returns
   * true then focus will be allowed to leave the trap.
   *
   * The function is called with a single argument that indicates the
   * direction of the tab change: -1 if the user is moving backwards in the
   * tab order, or 1 if the user is moving fowards in the tab order.
   *
   * IMPORTANT: As mentioned above, this will only be called when the trap is
   * about to lose focus due to keyboard input. This will not be called if
   * focus is moved outside the trap via mouse input.
   */
  onBeforeBlur: _propTypes["default"].func
} : {};
var _default = FocusTrap;
exports["default"] = _default;

/***/ }),
/* 883 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 884 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(886),
    keys = __webpack_require__(151);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(247);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(364),
    findLastIndex = __webpack_require__(349);

/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */
var findLast = createFind(findLastIndex);

module.exports = findLast;


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _scrim = _interopRequireDefault(__webpack_require__(275));

var _theme = __webpack_require__(24);

var _animateMount = _interopRequireWildcard(__webpack_require__(412));

var _onDirectClick = _interopRequireDefault(__webpack_require__(413));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AnimateFadeWithMount = (0, _animateMount["default"])(_animateMount.AnimateFade);

var styles = function styles(t) {
  return (0, _emotion.css)({
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: t("elevation"),
    backgroundColor: t("backgroundColor")
  });
};
/**
 * Don't bother updating the scrim if it's persisting in a closed state.
 */


var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
  return !prevProps.open && !nextProps.open;
};

var Scrim = /*#__PURE__*/_react["default"].memo( /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_scrim["default"], "scrim");
  return /*#__PURE__*/_react["default"].createElement(AnimateFadeWithMount, {
    open: props.open,
    onOpen: props.onOpen,
    duration: props.duration || t("motionTiming"),
    easing: props.easing || t("motionFunction"),
    type: "fade"
  }, function (_ref) {
    var className = _ref.className,
        onTransitionEnd = _ref.onTransitionEnd;
    return (
      /*#__PURE__*/
      // Regarding role=none, see:
      // https://www.scottohara.me/blog/2018/05/05/hidden-vs-none.html#what-does-rolenone-and-rolepresentation-do
      _react["default"].createElement("div", {
        role: "none",
        className: (0, _emotion.cx)(className, styles(t), props.className),
        onTransitionEnd: onTransitionEnd,
        onMouseDown: (0, _onDirectClick["default"])(props.onClick),
        ref: ref
      }, props.children)
    );
  });
}), shouldNotUpdate);

Scrim.displayName = "Scrim";
Scrim.propTypes =  false ? {
  open: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,
  duration: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  easing: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  onOpen: _propTypes["default"].func
} : {};
Scrim.defaultProps = {
  open: false,
  className: null
};
var _default = Scrim;
exports["default"] = _default;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Provides the WrappedComponent's displayName
// for easy debugging
var getsDisplayName = function getsDisplayName(WrappedComponent) {
  return WrappedComponent.getsDisplayName || WrappedComponent.name || "Component";
};

var withAnimateMount = function withAnimateMount(WrappedComponent) {
  var _class;

  /**
   * This is a higher order component that provides a consistent API to easily
   * create animations to be used for elements that need to be added and
   * removed to the DOM dynamically. Receives an animation component and returns a
   * wrapped, composed component.
   */
  return _class = /*#__PURE__*/function (_React$Component) {
    (0, _inherits2["default"])(WithAnimateMount, _React$Component);

    var _super = _createSuper(WithAnimateMount);

    function WithAnimateMount() {
      var _this;

      (0, _classCallCheck2["default"])(this, WithAnimateMount);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
        show: false
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function () {
        if (typeof _this.props.onOpen !== "undefined" && _this.state.show) {
          _this.props.onOpen();
        } // Remount the node when the open prop is true


        _this.setState({
          show: true
        });
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function () {
        if (!_this.props.open) {
          _this.setState({
            show: false
          });
        }
      });
      return _this;
    }

    (0, _createClass2["default"])(WithAnimateMount, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.open) {
          this.updateStateOnOpen();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (!prevProps.open && this.props.open) {
          this.updateStateOnOpen();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            duration = _this$props.duration,
            easing = _this$props.easing,
            open = _this$props.open,
            animateToHeight = _this$props.animateToHeight;
        var animateToHeightProps = typeof animateToHeight !== "undefined" ? {
          animateToHeight: animateToHeight
        } : null;
        return this.state.show && /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({
          duration: duration,
          easing: easing,
          open: open,
          updateStateOnOpen: this.updateStateOnOpen,
          transitionEnd: this.transitionEnd
        }, animateToHeightProps), children);
      }
    }]);
    return WithAnimateMount;
  }(_react["default"].Component), (0, _defineProperty2["default"])(_class, "propTypes", {
    /**
     * A function that returns the elements to animate.
     */
    children: _propTypes["default"].func.isRequired,

    /**
     * If true the children will be mounted, otherwise they will be unmounted.
     */
    open: _propTypes["default"].bool.isRequired,

    /**
     * Only applies to height based transitions. Allows for cases when the
     * desired effect is animating height to a value that's different than
     * the element's scrollHeight.
     */
    animateToHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

    /**
     * The duration of the animation. This should be a valid CSS animation
     * duration (e.g. `"100ms"` or `"1s"`).
     */
    duration: _propTypes["default"].string,

    /**
     * The easing function of the animation. This should be a valid CSS easing
     * function (e.g. `"linear"` or `"ease"`).
     */
    easing: _propTypes["default"].string,

    /**
     * The function provided here will be called if the component transitions
     * from a closed state to an open state, or if it is mounted in an open
     * state. Note that this is called as soon as the state changes, which
     * occurs *before* the elements being mounted are actually available in
     * the DOM.
     */
    onOpen: _propTypes["default"].func
  }), (0, _defineProperty2["default"])(_class, "defaultProps", {
    duration: "150ms",
    easing: "ease",
    open: false
  }), (0, _defineProperty2["default"])(_class, "displayName", "WithAnimateMount(".concat(getsDisplayName(WrappedComponent), ")")), _class;
};

var _default = withAnimateMount;
exports["default"] = _default;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var mountStyled = function mountStyled(opacity, duration, easing) {
  return (0, _emotion.css)({
    opacity: opacity,
    transition: "opacity ".concat(duration, " ").concat(easing)
  });
};

var AnimateFade = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AnimateFade, _React$Component);

  var _super = _createSuper(AnimateFade);

  function AnimateFade() {
    var _this;

    (0, _classCallCheck2["default"])(this, AnimateFade);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      opacity: 0
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "timer", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function () {
      // Tell the wrapper component to remount the node when the open prop is true
      _this.props.updateStateOnOpen(); // Set state to trigger intro animation


      _this.timer = setTimeout(_this.updateStateOnMount, 0);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function () {
      // Update state for unmount animation
      _this.setState({
        opacity: 0
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function () {
      // Update state for mount animation
      _this.setState({
        opacity: 1
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function () {
      if (!_this.props.open) {
        // Tell the wrapper component to remove the node on transition end when
        // the open prop is false
        _this.props.transitionEnd();
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(AnimateFade, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this.updateStateOnOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open && !this.props.open) {
        this.updateStateOnUnmount();
      } else if (!prevProps.open && this.props.open) {
        this.updateStateOnMount();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Clear our timer to prevent leaks
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var opacity = this.state.opacity;
      var _this$props = this.props,
          children = _this$props.children,
          duration = _this$props.duration,
          easing = _this$props.easing,
          className = _this$props.className;
      var styles = mountStyled(opacity, duration, easing);
      return children({
        className: (0, _emotion.cx)(className, styles),
        onTransitionEnd: this.transitionEnd
      });
    }
  }]);
  return AnimateFade;
}(_react["default"].Component);

(0, _defineProperty2["default"])(AnimateFade, "defaultProps", {
  duration: "150ms",
  easing: "ease"
});
AnimateFade.propTypes =  false ? {
  /**
   * A function that returns the elements to animate.
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * If true the children will be mounted, otherwise they will be unmounted.
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about unmounting the
   * component so we can focus on animation
   */
  transitionEnd: _propTypes["default"].func.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about mounting the
   * component so we can focus on animation
   */
  updateStateOnOpen: _propTypes["default"].func.isRequired,

  /**
   * Accepts the shared css class provided by the AnimateMount parent
   */
  className: _propTypes["default"].string,

  /**
   * The duration of the animation. This should be a valid CSS animation
   * duration (e.g. `"100ms"` or `"1s"`).
   */
  duration: _propTypes["default"].string,

  /**
   * The easing function of the animation. This should be a valid CSS easing
   * function (e.g. `"linear"` or `"ease"`).
   */
  easing: _propTypes["default"].string
} : {};
var _default = AnimateFade;
exports["default"] = _default;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _waitAnimationFrame = _interopRequireDefault(__webpack_require__(208));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var mountStyled = function mountStyled(_ref) {
  var open = _ref.open,
      height = _ref.height,
      duration = _ref.duration,
      easing = _ref.easing;
  return (0, _emotion.css)({
    transform: "translateY(".concat(open ? "0" : "100%", ")"),
    height: height,
    overflow: "auto",
    transition: "transform ".concat(duration, " ").concat(easing)
  });
};

var AnimateSlideIn = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AnimateSlideIn, _React$Component);

  var _super = _createSuper(AnimateSlideIn);

  function AnimateSlideIn() {
    var _this;

    (0, _classCallCheck2["default"])(this, AnimateSlideIn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      open: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isMounted", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function () {
      // Tell the wrapper component to remount the node when the open prop is true
      _this.props.updateStateOnOpen(); // Wait one animation frame so that the DOM can settle after mounting the
      // element, then set the state to trigger the mount animation


      (0, _waitAnimationFrame["default"])(_this.updateStateOnMount);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function () {
      return _this.setState({
        open: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function () {
      if (_this.isMounted) _this.setState({
        open: true
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(AnimateSlideIn, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isMounted = true;

      if (this.props.open) {
        this.updateStateOnOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.updateStateOnOpen();
      } else if (prevProps.open && !this.props.open) {
        this.updateStateOnUnmount();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var state = this.state;
      var props = this.props;
      var styles = mountStyled({
        open: state.open,
        duration: props.duration,
        easing: props.easing,
        height: props.animateToHeight
      });
      return props.children({
        open: state.open,
        className: (0, _emotion.cx)(props.className, styles),
        onTransitionEnd: this.props.transitionEnd
      });
    }
  }]);
  return AnimateSlideIn;
}(_react["default"].Component);

(0, _defineProperty2["default"])(AnimateSlideIn, "defaultProps", {
  duration: "150ms",
  easing: "ease"
});
AnimateSlideIn.propTypes =  false ? {
  /**
   * A function that returns the elements to animate.
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * If true the children will be mounted, otherwise they will be unmounted.
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about unmounting the
   * component so we can focus on animation
   */
  transitionEnd: _propTypes["default"].func.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about mounting the
   * component so we can focus on animation
   */
  updateStateOnOpen: _propTypes["default"].func.isRequired,

  /**
   * Allows for cases when the desired effect is animating height to
   * a value that's different than the element's scrollHeight
   */
  animateToHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Accepts the shared css class provided by the AnimateMount parent
   */
  className: _propTypes["default"].string,

  /**
   * The duration of the animation. This should be a valid CSS animation
   * duration (e.g. `"100ms"` or `"1s"`).
   */
  duration: _propTypes["default"].string,

  /**
   * The easing function of the animation. This should be a valid CSS easing
   * function (e.g. `"linear"` or `"ease"`).
   */
  easing: _propTypes["default"].string
} : {};
var _default = AnimateSlideIn;
exports["default"] = _default;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var mountStyled = function mountStyled(opacity, scale, duration, easing) {
  return (0, _emotion.css)({
    opacity: opacity,
    transform: scale ? "scale(".concat(scale, ")") : undefined,
    transition: "opacity ".concat(duration, " ").concat(easing, ", transform ").concat(duration, " ").concat(easing)
  });
};

var AnimateFadeScale = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AnimateFadeScale, _React$Component);

  var _super = _createSuper(AnimateFadeScale);

  function AnimateFadeScale() {
    var _this;

    (0, _classCallCheck2["default"])(this, AnimateFadeScale);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      opacity: 0,
      scale: 0.75,
      applyScale: true
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "timer", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnOpen", function () {
      // Tell the wrapper component to remount the node when the open prop is true
      _this.props.updateStateOnOpen(); // Set state to trigger intro animation


      _this.timer = setTimeout(_this.updateStateOnMount, 0);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnUnmount", function () {
      // Update state for unmount animation
      _this.setState({
        opacity: 0,
        scale: 0.75,
        applyScale: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStateOnMount", function () {
      // Update state for mount animation
      _this.setState({
        opacity: 1,
        scale: 1
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transitionEnd", function () {
      if (!_this.props.open) {
        // Tell the wrapper component to remove the node on transition end when
        // the open prop is false
        _this.props.transitionEnd();
      } // Clear opening timer if it exists


      clearTimeout(_this.timer); // HACK: turn off `transform: scale(X)` to workaround this Chromium issue https://bugs.chromium.org/p/chromium/issues/detail?id=20574
      // which can cause a `position: fixed` child to render improperly.

      _this.setState({
        applyScale: false
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(AnimateFadeScale, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this.updateStateOnOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open && !this.props.open) {
        this.updateStateOnUnmount();
      } else if (!prevProps.open && this.props.open) {
        // Set state to trigger intro animation
        this.timer = setTimeout(this.updateStateOnMount, 0);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Clear our timer to prevent leaks
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          opacity = _this$state.opacity,
          scale = _this$state.scale,
          applyScale = _this$state.applyScale;
      var _this$props = this.props,
          children = _this$props.children,
          duration = _this$props.duration,
          easing = _this$props.easing,
          className = _this$props.className;
      var styles = mountStyled(opacity, applyScale ? scale : undefined, duration, easing);
      return children({
        open: opacity !== 0,
        className: (0, _emotion.cx)(className, styles),
        onTransitionEnd: this.transitionEnd
      });
    }
  }]);
  return AnimateFadeScale;
}(_react["default"].Component);

(0, _defineProperty2["default"])(AnimateFadeScale, "defaultProps", {
  duration: "150ms",
  easing: "ease"
});
AnimateFadeScale.propTypes =  false ? {
  /**
   * A function that returns the elements to animate.
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * If true the children will be mounted, otherwise they will be unmounted.
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about unmounting the
   * component so we can focus on animation
   */
  transitionEnd: _propTypes["default"].func.isRequired,

  /**
   * Allows the parent AnimateMount component to worry about mounting the
   * component so we can focus on animation
   */
  updateStateOnOpen: _propTypes["default"].func.isRequired,

  /**
   * Accepts the shared css class provided by the AnimateMount parent
   */
  className: _propTypes["default"].string,

  /**
   * The duration of the animation. This should be a valid CSS animation
   * duration (e.g. `"100ms"` or `"1s"`).
   */
  duration: _propTypes["default"].string,

  /**
   * The easing function of the animation. This should be a valid CSS easing
   * function (e.g. `"linear"` or `"ease"`).
   */
  easing: _propTypes["default"].string
} : {};
var _default = AnimateFadeScale;
exports["default"] = _default;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _matchMedia = _interopRequireDefault(__webpack_require__(894));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This looks through an object of nested objects and returns a flat array
 * containing all the unique keys found in the nested objects.
 */
var getUniqueNestedObjectKeys = function getUniqueNestedObjectKeys(props) {
  return Object.keys(props) // Get the keys of each nested object
  .map(function (prop) {
    return Object.keys(props[prop]);
  }) // Flatten the keys into one array
  .reduce(function (result, keys) {
    return result.concat(keys);
  }, []) // Filter out duplicate keys
  .filter(function (value, index, keys) {
    return keys.indexOf(value) === index;
  });
};
/**
 * Sort an array according to it's numeric values
 */


var sortNumeric = function sortNumeric(arr, direction) {
  arr.sort(function (a, b) {
    return (parseFloat(a) - parseFloat(b)) * (direction === "descending" ? -1 : 1);
  });
  return arr;
};
/* eslint-disable react/prop-types */

/**
 * This component allows you to respond to the state of media features such as
 * viewport width, viewport aspect ratio, and device orientation. This is
 * similar to "media queries for JavaScript" (and it's even powered by media
 * queries behind the scenes), but it's a lot more powerful. Instead of only
 * allowing you to toggle something on or off based on a matching media query,
 * it allows you to set set any JavaScript variable based on the various states
 * of a media feature. You can use this functionality to do things that are not
 * possible with plain CSS media queries like:
 *   - render entirely different component trees based on viewport size
 *   - pass different props to a component based on viewport width
 *   - change the location of elements in the DOM based on device orientation
 *
 * NOTE: The props passed to this component cannot be changed after the
 * component is first instantiated.
 *
 * ```
 * // Renders "red" below the 1000px breakpoint, "blue" at or above the 1000px
 * // breakpoint but below the 1500px breakpoint, and "green" at or above the
 * // 1500px breakpoint. Renders 12px font below the 1500px breakpoint and 24px
 * // at or above the 1500px breakpoint.
 * <Responsive
 *   query="min-width"
 *   props={{
 *     color: { default: "red", "1000px": "blue", "1500px": "green" },
 *     fontSize: { default: 12, "1500px": 24 },
 *   }}
 * >
 *   {({ color, fontSize }) => (
 *     <div style={{ fontSize }}>My fav color is {color}</div>
 *.  )}
 * </Responsive>
 * ```
 */


var ResponsiveClass = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ResponsiveClass, _React$Component);

  var _super = _createSuper(ResponsiveClass);

  function ResponsiveClass(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ResponsiveClass);
    _this = _super.call(this, props); // Extract the media condition from the "query" prop

    var condition = /^min-/.test(props.query) ? "min" : /^max-/.test(props.query) ? "max" : null; // Extract the media feature from the "query" prop

    var feature = condition ? props.query.replace(new RegExp("^".concat(condition, "-")), "") : props.query; // Extract a list of unique breakpoints from the keys of the "props" prop.
    // Don't include the "default" since that's not something we can actually
    // query for (we'll fallback to that manually if no breakpoint matches)

    var breakpoints = getUniqueNestedObjectKeys(props.props).filter(function (key) {
      return key !== "default";
    }); // Sort the breakpoints according to the media query condition so that later
    // on we can just take the last matching breakpoint and know that that's the
    // min/max matching breakpoint

    var sortedBreakpoints = condition ? sortNumeric(breakpoints, condition === "min" ? "ascending" : "descending") : breakpoints; // This is an object of `MediaQueryList` instances (or mock instances - see
    // `matchMedia`) keyed by the breakpoints that they're matching against (e.g.
    // `{ "0px": mediaQueryA, "1000px": mediaQueryB }`).

    _this.mediaQueries = sortedBreakpoints.map(function (breakpoint) {
      var mediaQuery = (0, _matchMedia["default"])({
        feature: feature,
        condition: condition,
        fallback: props.fallback,
        breakpoint: breakpoint
      });

      var listener = function listener() {
        return _this.setState((0, _defineProperty2["default"])({}, breakpoint, mediaQuery.matches));
      };

      return {
        breakpoint: breakpoint,
        mediaQuery: mediaQuery,
        startListening: function startListening() {
          return mediaQuery.addListener(listener);
        },
        stopListening: function stopListening() {
          return mediaQuery.removeListener(listener);
        }
      };
    }); // Save off the list of prop names for each access later

    _this.propNames = Object.keys(props.props); // State is an object keyed by breakpoint that includes the match state of
    // the media query for that breakpoint (e.g. if the query is "min-width",
    // we're listening at the breakpoints "0px" and "1000px", adn the viewport
    // width is "500px" then the state object would be:
    // { "0px": true, "1000px": false }

    _this.state = _this.mediaQueries.reduce(function (result, _ref) {
      var breakpoint = _ref.breakpoint,
          mediaQuery = _ref.mediaQuery;
      // If a fallback prop is present, match against that for the intial
      // state. This ensures that that the same value is used during server
      // rendering and during the initial rehydrating render on the client.
      result[breakpoint] = _this.props.fallback ? mediaQuery.matchesFallback : mediaQuery.matches;
      return result;
    }, {});
    return _this;
  }

  (0, _createClass2["default"])(ResponsiveClass, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.mediaQueries.forEach(function (_ref2) {
        var mediaQuery = _ref2.mediaQuery,
            breakpoint = _ref2.breakpoint,
            startListening = _ref2.startListening;
        // Start listening for future state changes
        startListening(); // If we matched against the fallback prop on the initial render, but the
        // actual match is different, then update the state now and trigger a
        // re-render

        if (_this2.props.fallback && mediaQuery.matches !== mediaQuery.matchesFallback) {
          // Note: React batches state updates in lifecycle methods so we'll only
          // get one re-render no matter how many breakpoints we have to update.
          _this2.setState((0, _defineProperty2["default"])({}, breakpoint, mediaQuery.matches));
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mediaQueries.forEach(function (_ref3) {
        var stopListening = _ref3.stopListening;
        return stopListening();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      // Choose the best value from "props" based on the state of our media
      // queries. If no match is found then return the "default" value (or
      // undefined if there is no default).
      var props = this.propNames.reduce(function (result, propName) {
        var prop = _this3.props.props[propName];

        var value = _this3.mediaQueries.reduce(function (result, _ref4) {
          var breakpoint = _ref4.breakpoint;
          return _this3.state[breakpoint] && prop[breakpoint] !== undefined ? prop[breakpoint] : result;
        }, prop["default"]);

        result[propName] = value;
        return result;
      }, {});
      return this.props.children(props);
    }
  }]);
  return ResponsiveClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */
// Keep refs from being passed. We're doing this for 4.x - the
// most recent breaking change - so that we can change the
// _actual_ component to functional later without waiting
// for the next breaking change


var Responsive = function Responsive(props) {
  return /*#__PURE__*/_react["default"].createElement(ResponsiveClass, props);
};

Responsive.displayName = "Responsive";
Responsive.propTypes =  false ? {
  /**
   * A function that returns React elements. This will receive an object of
   * props based on the current state of the queried media feature and the
   * values passed to "props".
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * This is a nested object that allows you to define the prop values that
   * should be passed to the children function given any particular state of
   * the queried media feature. The special state "default" can be used to
   * indicate a value that should be returned if none of the other states are
   * matched. See the top-level documentation for this component for an
   * example.
   */
  props: _propTypes["default"].objectOf(_propTypes["default"].object).isRequired,

  /**
   * The media feature (e.g. width) and conditional (e.g. min) to watch for
   * changes and respond to.
   */
  query: _propTypes["default"].oneOf(["min-width", "max-width", "min-height", "max-height", "min-aspect-ratio", "max-aspect-ratio", "orientation"]).isRequired,

  /**
   * This is used as the fallback state of the queried media feature if the
   * component is rendered in an environment that doesn't support media
   * queries (e.g. NodeJS).
   *
   * Note that this does not have to match the states
   * found in the "props" object exactly to trigger a match. For example, if
   * "query" is set to "min-width", "fallback" is set to "1024px", and "props"
   * is set to `{ myValue: { default: "small", "800px": "medium", "1280px": "large" }}`,
   * then "myValue" would resolve to "medium" because "min-width: 800px"
   * passes when the width falls back to "1024px".
   *
   * IMPORTANT: This is required if you're server-rendering or pre-rendering this
   * component! Otherwise you may end up with a mismatch between your server
   * rendered markup and the markup that React tries to rehydrate with, and it
   * will literally shred the DOM.
   */
  fallback: _propTypes["default"].string
} : {};
var _default = Responsive;
exports["default"] = _default;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _noop = _interopRequireDefault(__webpack_require__(59));

var _functional = __webpack_require__(38);

/**
 * Attempt to convert a media query breakpoint to a number. If we received a
 * breakpoint like "5/10" (e.g. an aspect ratio) then run the math (e.g. "5/10"
 * => 0.5), otherwise just parse as a float (e.g. "5rem" => 5).
 */
var breakpointToNumber = function breakpointToNumber(str) {
  return /^\s?[0-9.]+\s?\/\s?[0-9.]+\s?$/.test(str) ? parseFloat(str.split("/")[0]) / parseFloat(str.split("/")[1]) : parseFloat(str);
};

var matchesFallback = function matchesFallback(_ref) {
  var condition = _ref.condition,
      breakpoint = _ref.breakpoint,
      fallback = _ref.fallback;
  return fallback === undefined ? false : condition === "min" ? breakpointToNumber(breakpoint) <= breakpointToNumber(fallback) : condition === "max" ? breakpointToNumber(breakpoint) >= breakpointToNumber(fallback) : breakpoint === fallback;
};
/**
 * A wrapper around `window.matchMedia`. If `window.matchMedia` is available
 * then a media query will be constructed and passed to `window.matchMedia` to
 * create a `MediaQueryList` instance. If we're in an env where
 * `window.matchMedia` is not available (e.g. NodeJS) then this will return a
 * mock MediaQueryList that matches against the provided fallback.
 */


var matchMedia = typeof window !== "undefined" && window.matchMedia ? (0, _functional.memoizeByKeys)(function (_ref2) {
  var condition = _ref2.condition,
      breakpoint = _ref2.breakpoint,
      feature = _ref2.feature,
      fallback = _ref2.fallback;
  // Build up a standard media query (e.g. `(min-width: 1000px)`) if
  // we have access to window.matchMedia
  var matchMedia = window.matchMedia("(".concat(condition ? "".concat(condition, "-") : "").concat(feature, ": ").concat(breakpoint, ")")); // Tack on the a property indicating whether the fallback matches.
  // This is helpful for situations where you're on the client, but want
  // to know what the match state would have been on the server (i.e.
  // when re-hydrating server-rendered markup on the client with React).

  matchMedia.matchesFallback = matchesFallback({
    condition: condition,
    breakpoint: breakpoint,
    fallback: fallback
  });
  return matchMedia;
}, ["feature", "condition", "breakpoint", "fallback"]) : function (args) {
  var matches = matchesFallback(args);
  return {
    // If we don't have access to `window.matchMedia` then "matches" will be
    // set statically based on the provided "fallback".
    matches: matches,
    // Mock out these functions for parity with the `MediaQueryList`
    // instance returned if `window.matchMedia` is available
    matchesFallback: matches,
    addListener: _noop["default"],
    removeListener: _noop["default"]
  };
};
var _default = matchMedia;
exports["default"] = _default;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _noop = _interopRequireDefault(__webpack_require__(59));

var _emotion = __webpack_require__(11);

var _input = _interopRequireDefault(__webpack_require__(171));

var _theme = __webpack_require__(24);

var _inputBox = _interopRequireDefault(__webpack_require__(276));

var _supportTextWrapper = _interopRequireDefault(__webpack_require__(138));

var _inputReset = _interopRequireDefault(__webpack_require__(277));

var _token = __webpack_require__(20);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

var _getSupportTextAriaDescribedby = _interopRequireDefault(__webpack_require__(139));

var _functional = __webpack_require__(38);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var widthStyles = (0, _functional.memoizeByKeys)(function (_ref) {
  var width = _ref.width;
  return (0, _emotion.css)({
    width: width,
    // If an explicit width is set then don't allow the input to flex
    flex: width ? "none !important" : undefined
  });
}, ["width"]);
var inputStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var size = _ref2.size,
      disabled = _ref2.disabled,
      empty = _ref2.empty;
  return (0, _emotion.css)((0, _inputReset["default"])({
    empty: empty,
    textColor: t("foregroundColor", disabled ? "disabled" : "default"),
    placeholderColor: t("placeholderColor", disabled ? "disabled" : "default")
  }), {
    height: t("lineHeight", size),
    lineHeight: t("lineHeight", size),
    textOverflow: "ellipsis"
  });
}, ["size", "disabled", "empty"]);
var inputModes = {
  email: "email",
  // TODO: Add number -> decimal in 6.x. We can't add inside 5.x because some mobile
  // browsers do not show the minus sign for inputmode="decimal" which could break
  // end-user interaction.
  // number: "decimal",
  search: "search",
  tel: "tel",
  text: "text",
  url: "url"
};

var Input = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_input["default"], "input");

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focusState = _useState2[0],
      setFocusState = _useState2[1];

  var inputRef = (0, _react.useRef)();
  var idProp = props.id;
  var id = (0, _react.useMemo)(function () {
    return idProp || (0, _uniqueId["default"])("input-");
  }, [idProp]);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]); // Make sure we never allow a value of `undefined` or `null`, which would put
  // the underlying input element in an uncontrolled state and allow the DOM and
  // the component to get out of sync.

  var value = props.value === undefined || props.value === null ? "" : props.value;
  var focus = props.focus !== undefined ? props.focus : focusState;
  var mask = props.type === "password" ? undefined : props.mask;
  var empty = value === "" && (!mask || !focus);
  var onChangeProp = props.onChange,
      onFocusProp = props.onFocus,
      onBlurProp = props.onBlur;
  var onChange = (0, _react.useCallback)(function (event) {
    var value = event.target.value;
    var pattern = mask ? undefined : props.pattern ? props.pattern : props.type === "number" ? /^(-?)([0-9]*)(\.?)([0-9]*)$/ : undefined;

    if (!props.disabled && (!pattern || value === "" || value.match(pattern))) {
      onChangeProp(value);
    }
  }, [props.pattern, props.type, props.disabled, mask, onChangeProp]);
  /**
   * Focus on the input anytime the user mouses down on the container. This
   * mimicks the default browser behavior when a user mouses down on an input.
   */

  var onMouseDownContainer = (0, _react.useCallback)(function (event) {
    if (inputRef.current && event.target !== inputRef.current) {
      event.preventDefault();
      inputRef.current.focus();
    }
  }, [inputRef]);
  var onFocus = (0, _react.useCallback)(function (event) {
    setFocusState(true);
    onFocusProp(event);
  }, [setFocusState, onFocusProp]);
  var onBlur = (0, _react.useCallback)(function (event) {
    setFocusState(false);
    onBlurProp(event);
  }, [setFocusState, onBlurProp]);
  var prefixId = props.prefix ? "".concat(id, "-prefix") : undefined;
  var suffixId = props.suffix ? "".concat(id, "-suffix") : undefined; // If there is not helperText, constraintText, errorMessage, prefix,
  // or suffix then the aria-describedby is empty.

  var ariaDescribedbyProp = {
    "aria-describedby": passThroughProps["aria-describedby"] ? passThroughProps["aria-describedby"] : props.helperText || props.constraintText || props.errorMessage || prefixId || suffixId ? [prefixId, suffixId, (0, _getSupportTextAriaDescribedby["default"])({
      id: id,
      hasHelperText: !!props.helperText,
      hasConstraintText: !!props.constraintText,
      hasErrorMessage: !!props.errorMessage,
      errorMessageFirst: props.size === "xlarge"
    })].filter(Boolean).join(" ") : undefined
  };

  var inputProps = _objectSpread(_objectSpread({
    "aria-label": props.label
  }, passThroughProps), {}, {
    onFocus: onFocus,
    onBlur: onBlur,
    className: (0, _emotion.cx)(inputStyles(t, _objectSpread(_objectSpread({}, props), {}, {
      empty: empty
    })), props.className),
    id: id,
    // HACK: https://sim.amazon.com/issues/P17584529
    type: props.type === "number" ? "text" : props.type,
    placeholder: props.placeholder,
    value: value,
    onChange: onChange,
    disabled: props.disabled,
    name: props.name,
    autoFocus: props.autoFocus || props.inaccessibleAutoFocus,
    autoComplete: props.autoFill ? undefined : "off",
    onKeyDown: props.onKeyDown,
    spellCheck: props.spellcheck,
    inputMode: props.inputMode || inputModes[props.type],
    role: props.role
  }, ariaDescribedbyProp); // react-input-mask only supports callback refs, so we have to wrap our object
  // ref in a callback to make it happy.


  var maskInputRef = (0, _react.useCallback)(function (node) {
    return inputRef.current = node;
  }, [inputRef]); // Pass our internal inputRef on up to the forwarded ref. This allows us to
  // use the input ref internally (e.g. see onMouseDownContainer) and still give
  // the parent access to it.

  (0, _react.useImperativeHandle)(ref, function () {
    return inputRef.current;
  }, [inputRef]);
  return /*#__PURE__*/_react["default"].createElement(_supportTextWrapper["default"], {
    id: id,
    helperText: props.helperText,
    constraintText: props.constraintText,
    errorMessage: props.errorMessage,
    helperBelowFormField: props.size === "xlarge",
    className: widthStyles({
      width: props.width
    })
  }, /*#__PURE__*/_react["default"].createElement(_inputBox["default"], {
    size: props.label ? "xlarge" : props.size,
    label: props.label,
    prefix: props.prefix,
    suffix: props.suffix,
    error: props.error,
    disabled: props.disabled,
    focus: focus,
    empty: empty,
    width: props.width,
    onMouseDown: onMouseDownContainer,
    htmlFor: id,
    cursor: "text",
    prefixIconTokens: props.prefixIconTokens,
    suffixIconTokens: props.suffixIconTokens,
    prefixId: prefixId,
    suffixId: suffixId
  }, mask ? mask.getElement(_objectSpread(_objectSpread({}, inputProps), {}, {
    inputRef: maskInputRef
  }), // If we're forcing focus on an input with a mask that only
  // shows on focus (!alwaysShow), then force the mask too.
  props.focus !== undefined && !mask.alwaysShow ? {
    alwaysShow: props.focus
  } : {}) : /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, inputProps, {
    ref: inputRef
  })), props.children));
});

Input.displayName = "Input";
Input.propTypes =  false ? {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * If adding a label with `aria-label`, first consider using the `label` prop
   * which will add a visible label and set the size to `xlarge`.
   *
   * @since 5.x
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Allow the browser to suggest auto-fill values for this input.
   *
   * Note that not all browsers respect this property. Some browsers (e.g.
   * Chrome 78) may choose to *always* allow auto-fill regardless of the value
   * of this property.
   */
  autoFill: _propTypes["default"].bool,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * Specify custom children that will be rendered as adjacent siblings to the
   * text input element.
   *
   * This is an advanced feature designed to allow custom overlays on an input.
   * You should not need this prop unless you are building an advanced component
   * on top of the input.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * Add constraint text to provide critical information regarding input content.
   *
   * @since 5.21.0
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with an `errorMessage`.
   */
  error: _propTypes["default"].bool,

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the Input.
   *
   * @since 5.21.0
   */
  errorMessage: _propTypes["default"].string,

  /**
   * This can be used to force the visible focus state of the input on or off.
   * This only affects the display of the focus ring, it does not change the
   * focus state of the input as far as the browser is concerned.
   *
   * Note that this should only be used when the input is still functionally
   * focused, despite not having the user's actual focus (e.g. typing would still
   * update the value of the input). This situation is only likely if you're
   * composing the Input with other components to build a more complex input
   * control.
   */
  focus: _propTypes["default"].bool,

  /**
   * Add helper text to provide additional instruction.
   *
   * @since 5.21.0
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * An id for the input that is unique among other inputs.
   *
   * This is only necessary if you need to use an input `size` other than xlarge
   * and want to add your own custom label for the specific input id,
   * eg: <Text tag="label" htmlFor="my-custom-id"/>
   *
   * It is recommended to use the `label` prop for almost all other cases,
   * which will set the `size` of the input to xlarge.
   *
   * @since 5.x
   */
  id: _propTypes["default"].string,

  /**
   * If set to true then the input will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * Useful for setting the keyboard for mobile browsers. For example, to display
   * a numeric keyboard:
   *
   * ```
   * // With decimal key
   * <Input type="number" inputMode="decimal" />
   *
   * // Without decimal
   * <Input type="number" inputMode="numeric" />
   * ```
   *
   * See docs for the [inputmode](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/inputmode)
   * for list of valid options, descriptions, and browser compatibility.
   *
   * Note: While `inputmode` is not "compatible" with all browsers no [supported
   * browsers](https://meridian.a2z.com/for-developers/react-web/getting-started/?platform=react-web#h4-browser-support)
   * will break or throw errors when the `inputmode` attribute is present.
   *
   * @since 5.14.0
   */
  inputMode: _propTypes["default"].string,

  /**
   * A label for the input.
   *
   * If this prop is provided the `size` prop will be ignored and set to `xlarge`.
   */
  label: _propTypes["default"].string,

  /**
   * Mask the input's value in order to force it to conform to a particular
   * format or template.
   *
   * This is helpful for things like formatting phone numbers:
   *
   * ```
   * import Input from "@amzn/meridian/input"
   * import InputMask from "@amzn/meridian/input/mask"
   *
   * const phoneMask = new InputMask("(###)###-####")
   * <Input type="tel" mask={phoneMask} />
   * ```
   *
   * The string passed to the mask accepts three special placeholder characters
   * by default:
   * - `"#"` - A placeholder for any digit [0-9]
   * - `"x"` - A placeholder for any latin character [A-Za-z]
   * - `"*"` - A placeholder for any latin character or digit [A-Za-z0-9]
   *
   * Custom placeholder characters can be set by passing an object of options as
   * the second argument to `InputMask`:
   *
   * ```
   * new InputMask("(^^^)^^^-^^^", { formatChars: { "^": "[1-8]" } })
   * ```
   *
   * Note that if the input type is "password" then this prop will be ignored.
   * Note that input masks should not be blank and should always include template
   * characters to indicate to the user that the input is masked.
   * Note that if custom placeholder characters are set, defaults are overridden.
   */
  mask: _propTypes["default"].object,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * This can be used to ensure that input matches a specific pattern defined
   * by a regular expression. If the user tries to enter a value that does not
   * match the pattern then `onChange` will simply not be triggered.
   *
   * Note that if the input type is `"password"` or an input mask is provided via the
   * `mask` prop then this prop will be ignored.
   */
  pattern: _propTypes["default"].instanceOf(RegExp),

  /**
   * Text that is shown in place of the input's value when the input is empty.
   *
   * This text is not visible when a value is entered in the input, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   */
  placeholder: _propTypes["default"].string,

  /**
   * Static text to show in an end-cap prepended to the component.
   *
   * To add a selectable prefix, see the `InputGroup` component.
   */
  prefix: _propTypes["default"].string,

  /**
   * Pass an object of icon tokens here (imported from `@amzn/meridian-tokens/base/icon/<icon-name>`)
   * in order to show an icon prepended to the input's text-entry area.
   */
  prefixIconTokens: _propTypes["default"].object,

  /**
   * An accessible ARIA role for the component.
   *
   * See docs for [permitted input roles](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#technical_summary)
   * for details on appropriate usage.
   *
   * @since 5.24.0
   */
  role: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   *
   * If the `label` prop is provided this prop will be ignored (the label
   * requires a particular amount of space which is not configurable).
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * Enable or disable spellchecking on the Input. See [the MDN documentation for `spellcheck`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck).
   *
   * @since 5.18.0
   */
  spellcheck: _propTypes["default"].bool,

  /**
   * Static text to show in an end-cap appended to the component.
   *
   * To add a selectable suffix, see the `InputGroup` component.
   */
  suffix: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Pass an object of icon tokens here (imported from `@amzn/meridian-tokens/base/icon/<icon-name>`)
   * in order to show an icon appended to the input's text-entry area.
   */
  suffixIconTokens: _propTypes["default"].object,

  /**
   * The data type of the input's value.
   */
  type: _propTypes["default"].oneOf(["date", "email", "number", "password", "search", "tel", "text", "url", "time"]),

  /**
   * The value of the input.
   *
   * Update this when `onChange` is called to ensure the component is interactive
   * (see the documentation for the `onChange` prop).
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by typing in the input). The new value will be
   * passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   *
   * Note: For Inputs with `type="number"`, the new value passed to `onChange`
   * will be a `string` _not_ a `number`. The `string` type is necessary for
   * allowing users to enter floats like `1.5`. To arrive at `1.5`, a user needs
   * to enter the partial value `1.`. At this point, parsing the partial value
   * with `parseFloat` or `parseInt` will remove the decimal point, effectively
   * blocking the user from completing their entry.
   */
  onChange: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func
} : {};
Input.defaultProps = {
  size: "medium",
  type: "text",
  onFocus: _noop["default"],
  onBlur: _noop["default"],
  children: null,
  value: "",
  autoFill: true
};
var _default = Input;
exports["default"] = _default;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _input = _interopRequireDefault(__webpack_require__(171));

var _context = _interopRequireDefault(__webpack_require__(415));

var _theme = __webpack_require__(24);

var _getIconCss = _interopRequireDefault(__webpack_require__(156));

var _token = __webpack_require__(20);

var _focusRing = _interopRequireDefault(__webpack_require__(73));

var _text = _interopRequireDefault(__webpack_require__(47));

var _noTextWrap = _interopRequireDefault(__webpack_require__(257));

var _rtl = __webpack_require__(80);

var _borderRadius = _interopRequireDefault(__webpack_require__(127));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Styles
 */

/* Styles for the root element */
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _css;

  var cursor = _ref.cursor,
      size = _ref.size,
      fontSize = _ref.fontSize,
      focus = _ref.focus,
      error = _ref.error,
      disabled = _ref.disabled,
      width = _ref.width,
      borderWidthLtr = _ref.borderWidthLtr,
      borderWidthRtl = _ref.borderWidthRtl,
      _ref$borderSides = _ref.borderSides,
      borderSides = _ref$borderSides === void 0 ? [] : _ref$borderSides,
      inputBorderRadius = _ref.inputBorderRadius;
  var state = disabled ? "disabled" : focus ? "focus" : error ? "error" : "default";
  return (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: fontSize || size,
    lineHeight: "default",
    color: disabled ? "disabled" : "default"
  }), (_css = {
    display: "flex",
    boxSizing: "border-box",
    flexDirection: "row",
    justifyContent: "stretch",
    cursor: disabled ? "not-allowed" : cursor,
    backgroundColor: t("backgroundColor", state),
    height: t("height", size),
    maxWidth: t("widthMax"),
    width: width,
    outline: "none",
    // If an explicit width is set then don't allow the input to flex
    flex: width ? "none !important" : undefined,
    borderWidth: borderWidthLtr ? borderWidthLtr : t("borderWidth"),
    borderRadius: borderSides.length > 0 ? (0, _borderRadius["default"])(inputBorderRadius, borderSides) : t("borderRadius")
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    borderRadius: borderSides.length > 0 ? (0, _borderRadius["default"])(inputBorderRadius, borderSides.map(function (borderSide) {
      return (0, _rtl.getRtl)(borderSide);
    })) : t("borderRadius"),
    borderWidth: borderWidthRtl ? borderWidthRtl : t("borderWidth")
  }), (0, _defineProperty2["default"])(_css, "borderColor", t("borderColor", state)), (0, _defineProperty2["default"])(_css, "borderStyle", "solid"), _css), !disabled ? (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    error: error,
    offset: 1,
    dropShadow: true,
    borderWidth: t("focusRingBorderWidth"),
    borderRadius: inputBorderRadius ? inputBorderRadius + 1 : t("borderRadius"),
    borderSides: borderSides
  }) : undefined);
}, ["cursor", "size", "fontSize", "focus", "error", "disabled", "width", "borderWidthLtr", "borderWidthRtl", "borderSides", "inputBorderRadius"]);
/* Styles for each segment of the input (e.g. an endcap, an icon, the input
container) */

var columnStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var size = _ref2.size,
      label = _ref2.label;
  var horizontalPadding = t("spacingInsetHorizontal");
  var verticalPadding = t("spacingInsetVertical", size); // If we have a label then reduce the top padding until the label is the same
  // number of pixels from the top as the original top padding when it's floated
  // down over the input

  var topPadding = label && verticalPadding > 0 ? verticalPadding - t("labelFloatDistance", size) : verticalPadding;
  return (0, _emotion.css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "".concat(topPadding, "px ").concat(horizontalPadding, "px ").concat(verticalPadding, "px ").concat(horizontalPadding, "px")
  });
}, ["size", "label"]);

var endcapBorderShadow = function endcapBorderShadow(t, _ref3) {
  var state = _ref3.state,
      side = _ref3.side;
  return side === "left" ? " 1px 0 0 0 ".concat(t("borderColor", state)) : "-1px 0 0 0 ".concat(t("borderColor", state));
};
/* Styles for the prefix/suffix caps on either end of the input */


var endcapStyles = (0, _token.memoizeTokenStyles)(function (t, _ref4) {
  var disabled = _ref4.disabled,
      side = _ref4.side,
      size = _ref4.size,
      label = _ref4.label;
  var state = disabled ? "disabled" : "default";
  return (0, _emotion.css)(columnStyles(t, {
    size: size,
    label: label
  }), (0, _defineProperty2["default"])({
    flexShrink: 0,
    backgroundColor: t("endcapBackgroundColor"),
    borderRadius: (0, _borderRadius["default"])(t("endcapBorderRadius"), side === "left" ? ["topLeft", "bottomLeft"] : ["topRight", "bottomRight"]),
    boxShadow: endcapBorderShadow(t, {
      state: state,
      side: side
    })
  }, "[dir=\"rtl\"] &", {
    borderRadius: (0, _borderRadius["default"])(t("endcapBorderRadius"), side === "left" ? ["topRight", "bottomRight"] : ["topLeft", "bottomLeft"]),
    boxShadow: endcapBorderShadow(t, {
      state: state,
      side: (0, _rtl.getRtl)(side)
    })
  }), _noTextWrap["default"]);
}, ["disabled", "side", "size", "label"]);
/* Styles for everything in-between the endcaps */
// since the aislestyle and columnstyle shares the same attributes
// we can memoize them together

var aisleStyles = (0, _token.memoizeTokenStyles)(function (t, _ref5) {
  var size = _ref5.size,
      label = _ref5.label;
  return (0, _emotion.css)(columnStyles(t, {
    size: size,
    label: label
  }), {
    flex: "auto",
    overflow: "hidden"
  });
}, ["size", "label"]);
var labelStyles = (0, _token.memoizeTokenStyles)(function (t, _ref6) {
  var _css3;

  var animated = _ref6.animated,
      focus = _ref6.focus,
      disabled = _ref6.disabled,
      floated = _ref6.floated,
      size = _ref6.size;
  var colorState = disabled ? "disabled" : focus ? "focus" : "default";
  return (0, _emotion.css)((_css3 = {
    display: "block",
    cursor: "inherit",
    color: t("labelColor", colorState),
    fontSize: t("labelFontSizeDefault"),
    marginBottom: t("spacingVertical"),
    transformOrigin: "top left"
  }, (0, _defineProperty2["default"])(_css3, "[dir=\"rtl\"] &", {
    transformOrigin: "top right"
  }), (0, _defineProperty2["default"])(_css3, "transform", floated ? "translateY(0px) scale(".concat(t("labelFontSizeFloated") / t("labelFontSizeDefault"), ")") : "translateY(".concat(t("labelFloatDistance", size), "px) scale(1)")), (0, _defineProperty2["default"])(_css3, "transition", animated ? t.transitionCss("labelMotion", ["color", "transform"]) : undefined), _css3), _noTextWrap["default"]);
}, ["animated", "focus", "disabled", "floated", "size"]);
var iconStyles = (0, _token.memoizeTokenStyles)(function (t, _ref7) {
  var _css4;

  var tokens = _ref7.tokens,
      disabled = _ref7.disabled,
      position = _ref7.position;
  var state = disabled ? "disabled" : "default";

  var _getIconFromTokens = (0, _token.getIconFromTokens)(tokens),
      width = _getIconFromTokens.width,
      data = _getIconFromTokens.data;

  return (0, _emotion.css)((_css4 = {
    flexShrink: 0,
    width: width,
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   marginInlineStart:
    //    position === "prefix"
    //      ? t("spacingInsetHorizontal")
    //      : 0,
    //   marginInlineEnd:
    //    position == "prefix"
    //      ? 0
    //      : t("spacingInsetHorizontal"),
    // },
    margin: position === "prefix" ? "0 0 0 ".concat(t("spacingInsetHorizontal"), "px") : "0 ".concat(t("spacingInsetHorizontal"), "px 0 0")
  }, (0, _defineProperty2["default"])(_css4, "[dir=\"rtl\"] &", {
    margin: position === "prefix" ? "0 ".concat(t("spacingInsetHorizontal"), "px 0 0") : "0 0 0 ".concat(t("spacingInsetHorizontal"), "px")
  }), (0, _defineProperty2["default"])(_css4, "backgroundImage", (0, _getIconCss["default"])(data, t("foregroundColor", state))), (0, _defineProperty2["default"])(_css4, "backgroundPosition", "center"), (0, _defineProperty2["default"])(_css4, "backgroundRepeat", "no-repeat"), _css4));
}, ["tokens", "disabled", "position"]);
var childrenStyles = (0, _token.memoizeTokenStyles)(function (t, _ref8) {
  var size = _ref8.size,
      disabled = _ref8.disabled,
      empty = _ref8.empty,
      label = _ref8.label,
      floated = _ref8.floated;
  var state = disabled ? "disabled" : "default";
  return (0, _emotion.css)({
    position: "relative",
    color: empty ? t("placeholderColor", state) : undefined,
    minHeight: t("lineHeight", size),
    lineHeight: t("lineHeight", size),
    opacity: label && !floated ? 0 : 1,
    pointerEvents: disabled ? "none" : undefined
  });
}, ["size", "disabled", "empty", "label", "floated"]);
/**
 * Component
 */

var InputBox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_input["default"], "input");

  var _useContext = (0, _react.useContext)(_context["default"]),
      onFocus = _useContext.onFocus,
      onBlur = _useContext.onBlur,
      borderWidthLtr = _useContext.borderWidthLtr,
      borderWidthRtl = _useContext.borderWidthRtl,
      borderSides = _useContext.borderSides,
      inputBorderRadius = _useContext.inputBorderRadius;

  var styleProps = _objectSpread(_objectSpread({}, props), {}, {
    // If we have a label then the size must be at least "xlarge"
    size: props.label && props.size !== "xlarge" && props.size !== "auto" ? "xlarge" : props.size,
    floated: !props.label || (props.labelFloated !== undefined ? props.labelFloated : !props.empty || props.focus),
    borderWidthLtr: borderWidthLtr,
    borderWidthRtl: borderWidthRtl,
    borderSides: borderSides,
    inputBorderRadius: inputBorderRadius
  });

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: styles(t, styleProps),
    onMouseDown: props.onMouseDown,
    onFocus: onFocus,
    onBlur: onBlur,
    "mdn-input-box": "",
    tabIndex: props.tabIndex
  }, passThroughProps, {
    role: props.role,
    ref: ref,
    id: props.id
  }), props.prefix ? /*#__PURE__*/_react["default"].createElement("div", {
    id: props.prefixId,
    className: endcapStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
      side: "left"
    }))
  }, props.prefix) : null, props.prefixIconTokens ? /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-input-box-prefix": "",
    "aria-hidden": "true",
    className: iconStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
      tokens: props.prefixIconTokens,
      position: "prefix"
    }))
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: aisleStyles(t, styleProps)
  }, props.label ? /*#__PURE__*/_react["default"].createElement("label", {
    className: labelStyles(t, styleProps),
    htmlFor: props.htmlFor,
    id: props.labelId,
    "aria-hidden": "true"
  }, props.label) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: childrenStyles(t, styleProps)
  }, props.children)), props.suffixIconTokens ? /*#__PURE__*/_react["default"].createElement("div", {
    "mdn-input-box-suffix": "",
    "aria-hidden": "true",
    className: iconStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
      tokens: props.suffixIconTokens,
      position: "suffix"
    }))
  }) : null, props.suffix ? typeof props.suffix === "string" ? /*#__PURE__*/_react["default"].createElement("div", {
    id: props.suffixId,
    className: endcapStyles(t, _objectSpread(_objectSpread({}, styleProps), {}, {
      side: "right"
    }))
  }, props.suffix) : props.suffix : null);
});

InputBox.displayName = "InputBox";
InputBox.propTypes =  false ? {
  animated: _propTypes["default"].bool,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * NOTE: This was added to improve the a11y of the Select component.
   *
   * @since 5.27.0
   */
  "aria-*": _propTypes["default"].string,
  children: _propTypes["default"].node,
  cursor: _propTypes["default"].oneOf(["default", "text", "pointer"]),

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,
  empty: _propTypes["default"].bool,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with a small error `Alert` component below
   * or to the right of the component explaining what the error is.
   */
  error: _propTypes["default"].bool,
  focus: _propTypes["default"].bool,
  fontSize: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),
  htmlFor: _propTypes["default"].string,
  id: _propTypes["default"].string,
  label: _propTypes["default"].string,

  /**
   * If this is set it will force the float state of the label. True = the
   * label is floated up above the input, false = the label is resting over
   * the input.
   */
  labelFloated: _propTypes["default"].bool,
  labelId: _propTypes["default"].string,

  /**
   * Static text to show in an end-cap prepended to the input.
   *
   * To add a selectable prefix to an input, see the `InputGroup` component.
   */
  prefix: _propTypes["default"].string,

  /**
   * Pass an object of icon tokens here (imported from `@amzn/meridian-tokens/base/icon/<icon-name>`)
   * in order to show an icon prepended to the input's text-entry area.
   */
  prefixIconTokens: _propTypes["default"].object,
  prefixId: _propTypes["default"].string,

  /**
   * An accessible ARIA role for the component.
   *
   * See docs for [permitted input roles](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#technical_summary)
   * for details on appropriate usage.
   *
   * NOTE: This was added to improve the a11y of Select by allowing a "combobox" role to be passed
   * to the InputBox.
   *
   * @since 5.27.0
   */
  role: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset. This will set the font-size
   * unless `fontSize` is also set.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge", "auto"]),

  /**
   * Static text to show in an end-cap appended to the input.
   *
   * To add a selectable suffix to an input, see the `InputGroup` component.
   */
  suffix: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Pass an object of icon tokens here (imported from `@amzn/meridian-tokens/base/icon/<icon-name>`)
   * in order to show an icon appended to the input's text-entry area.
   */
  suffixIconTokens: _propTypes["default"].object,
  suffixId: _propTypes["default"].string,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   *
   * Note: This was added to improve the a11y of Select.
   *
   * @since 5.27.0
   */
  tabIndex: _propTypes["default"].string,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  onMouseDown: _propTypes["default"].func
} : {};
InputBox.defaultProps = {
  size: "medium",
  cursor: "default",
  animated: true
};
var _default = InputBox;
exports["default"] = _default;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _text = _interopRequireDefault(__webpack_require__(9));

var _alert = _interopRequireDefault(__webpack_require__(13));

var _column = _interopRequireDefault(__webpack_require__(6));

var SupportTextWrapper = function SupportTextWrapper(props) {
  return /*#__PURE__*/_react["default"].createElement(_column["default"], {
    className: props.className,
    spacing: "200"
  }, props.helperText && !props.helperBelowFormField && /*#__PURE__*/_react["default"].createElement(_text["default"], {
    id: "".concat(props.id, "-helper-text"),
    type: "b200",
    color: "secondary"
  }, props.helperText), props.children, props.errorMessage && /*#__PURE__*/_react["default"].createElement(_column["default"], {
    spacingInset: "100 none none none"
  }, /*#__PURE__*/_react["default"].createElement(_alert["default"], {
    id: "".concat(props.id, "-error-message"),
    type: "error",
    size: "small"
  }, props.errorMessage)), props.helperText && props.helperBelowFormField && /*#__PURE__*/_react["default"].createElement(_text["default"], {
    id: "".concat(props.id, "-helper-text"),
    type: "b200",
    color: "secondary"
  }, props.helperText), props.constraintText && /*#__PURE__*/_react["default"].createElement(_text["default"], {
    id: "".concat(props.id, "-constraint-text"),
    type: "b200",
    color: "secondary"
  }, props.constraintText));
};

SupportTextWrapper.displayName = "SupportTextWrapper";
SupportTextWrapper.propTypes =  false ? {
  children: _propTypes["default"].node.isRequired,

  /**
   * The id used for the child form field component.
   * This will be used to generate the id's for the support text.
   * EG: "my-input" as an id will become "my-input-helper-text"
   * for the helper text's id.
   */
  id: _propTypes["default"].string.isRequired,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * Add constraint text to provide critical information regarding form field content.
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the form field.
   */
  errorMessage: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * When some form fields are xlarge we want the helper text to be below the
   * form field instead of above it, like Input or Select.
   * For form fields without a size prop (like InputGroup) we want the
   * helper text below regardless - so we use this boolean to dictate
   * whether or not the helper text is above or below the component
   * that the SupportTextWrapper wraps.
   */
  helperBelowFormField: _propTypes["default"].bool,

  /**
   * Add helper text to provide additional instruction.
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node])
} : {};
var _default = SupportTextWrapper;
exports["default"] = _default;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(166));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(97));

var _emotion = __webpack_require__(11);

var _reduce = _interopRequireDefault(__webpack_require__(899));

var _box = _interopRequireDefault(__webpack_require__(400));

var _propTypes2 = _interopRequireDefault(__webpack_require__(271));

var _parsers = __webpack_require__(272);

var _functional = __webpack_require__(98);

var _cxMemoized = _interopRequireDefault(__webpack_require__(168));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = function styles(heights) {
  return (0, _functional.memoizeByKeys)(function (_ref) {
    var spacing = _ref.spacing,
        alignment = _ref.alignment,
        alignmentVertical = _ref.alignmentVertical,
        alignmentHorizontal = _ref.alignmentHorizontal;
    return (0, _emotion.css)({
      display: "flex",
      flexDirection: "column",
      justifyContent: {
        top: "flex-start",
        bottom: "flex-end",
        center: "center",
        justify: "space-between"
      }[alignment ? (0, _parsers.parseFlexAlignment)(alignment)[0] : alignmentVertical],
      alignItems: {
        left: "flex-start",
        right: "flex-end",
        center: "center",
        stretch: "stretch"
      }[alignment ? (0, _parsers.parseFlexAlignment)(alignment)[1] : alignmentHorizontal],
      // Set margins and heights on the children of the column. Use !important to
      // override any existing styles.
      "& > *": {
        // Make sure that any borders or padding applied to the child don't throw
        // of the heights that we apply
        boxSizing: "border-box !important",
        // Ensure that the correct bottom margin is set (and clear other margins)
        margin: "0 0 ".concat((0, _parsers.parseSpacing)(spacing)[0], "px 0 !important"),
        // Don't let the last child add extra space to the end of the column.
        ":last-child": {
          margin: "0 !important"
        }
      }
    }, // If we've got an array of heights, apply each height to the child
    // whose index in the dom matches the height's index in the array. If
    // we've got a single height, apply that to all children.
    Array.isArray(heights) ? (0, _reduce["default"])(heights, function (result, height, index) {
      return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2["default"])({}, "& > *:nth-child(".concat(parseInt(index) + 1, ")"), childStyles(height)));
    }, {}) : {
      "& > *": childStyles(heights)
    });
  }, ["spacing", "alignment", "alignmentVertical", "alignmentHorizontal"]);
};

var stylesWithUniqueWidths = (0, _functional.memoizeArray)(styles);
var stylesWithUniformWidths = (0, _functional.memoize)(styles);

var childStyles = function childStyles(height) {
  return {
    flex: height === "fill" ? "1 !important" : undefined,
    flexShrink: height !== "fill" && height !== "fit" ? "0 !important" : undefined,
    height: height !== "fill" && height !== "fit" && height !== undefined && height !== null && height !== "" ? "".concat(height).concat(typeof height === "number" ? "px" : "", " !important") : undefined
  };
};
/**
 * The Column component stacks children up vertically in a column with even
 * spacing in-between them.
 */


function Column(props) {
  // We need to memoize differently based on whether we got an array or scalar
  // for the "heights" property
  var stylesFunc = Array.isArray(props.heights) ? stylesWithUniqueWidths : stylesWithUniformWidths;
  var styles = stylesFunc(props.heights)(props);
  return /*#__PURE__*/_react["default"].createElement(_box["default"], _objectSpread(_objectSpread({}, props), {}, {
    className: (0, _cxMemoized["default"])(styles, props.className)
  }));
}

Column.propTypes =  false ? {
  /**
   * **Deprecated:** Use `alignmentHorizontal` or `alignmentVertical` instead.
   *
   * Specify the alignment of the elements inside the column. This should be
   * a string containing a vertical alignment value and a horizontal alignment
   * value separated by a space (e.g. "top center").
   *
   * @deprecated 4.x
   */
  alignment: _propTypes2["default"].flexAlignment("column"),

  /**
   * Specify the horizontal alignment of the elements inside the column.
   *
   * This should be used instead of the deprecated `alignment` prop. If the `alignment`
   * prop is set that will override this prop for backwards-compatibility
   * reasons.
   *
   * @since 4.x
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["left", "center", "right", "stretch"]),

  /**
   * Specify the vertical alignment of the elements inside the column.
   *
   * This should be used instead of the deprecated `alignment` prop. If the `alignment`
   * prop is set that will override this prop for backwards-compatibility
   * reasons.
   *
   * @since 4.x
   */
  alignmentVertical: _propTypes["default"].oneOf(["top", "center", "bottom", "justify"]),

  /**
   * Set the column's background color using a preset, or using a string
   * containing any valid CSS color.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary"]), _propTypes["default"].string]),

  /**
   * The elements to line up in a column. Any elements can be supplied here, although if
   * only one child is supplied the column will not add much value (it's meant
   * for aligning multiple elements). If you only have one child, consider using
   * the `Box` component instead.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * Set the height of the column using a number (which will be treated as
   * pixels) or a string containing any valid CSS dimension.
   */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the height of each element in the column.
   *
   * If a single height is provided then it will be applied to every element in
   * the column. If an array of heights is provided then each height will be
   * applied to the element in the column that exists at the same index as the
   * height in the array (e.g. `[<element 0 height>, <element 1 height>, null, <element 3 height>]`).
   *
   * The possible values for each height are:
   *   - `number` - A fixed pixel height.
   *   - `string` - Any valid CSS height.
   *   - `"fit"` - The element's height will shrink to fit its contents.
   *   - `"fill"` - The element's height will fill all remaining space in the column.
   *     If this value is set on multiple elements, they will share the remaining
   *     space in the column equally.
   */
  heights: _propTypes["default"].oneOfType([_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]), _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),

  /**
   * Set the maximum height of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the maximum width of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum height of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the minimum width of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Set the vertical spacing between elements in the column using a preset.
   */
  spacing: _propTypes2["default"].spacing(1),

  /**
   * Apply padding to the component.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"small medium"` for small padding on the top/bottom and
   * medium padding on the left/right).
   */
  spacingInset: _propTypes2["default"].spacing(4),

  /**
   * The HTML tag to use when rendering the component to the DOM.
   */
  tag: _propTypes["default"].string,

  /**
   * Set the style of the column using one of Meridian's Box component styles.
   * If omitted the column will not have any decorative visual style applied to
   * it.
   */
  type: _propTypes["default"].oneOf(["outline", "fill"]),

  /**
   * Set the width of the column using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
Column.defaultProps = {
  heights: [],
  spacing: "medium",
  alignmentVertical: "top",
  alignmentHorizontal: "stretch"
};
var _default = Column;
exports["default"] = _default;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(900),
    baseEach = __webpack_require__(901),
    baseIteratee = __webpack_require__(280),
    baseReduce = __webpack_require__(984),
    isArray = __webpack_require__(90);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 900 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(902),
    createBaseEach = __webpack_require__(918);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(903),
    keys = __webpack_require__(278);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(904);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 904 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(906),
    isArguments = __webpack_require__(416),
    isArray = __webpack_require__(90),
    isBuffer = __webpack_require__(418),
    isIndex = __webpack_require__(419),
    isTypedArray = __webpack_require__(420);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 906 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(172),
    isObjectLike = __webpack_require__(173);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(209);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 909 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 910 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(172),
    isLength = __webpack_require__(279),
    isObjectLike = __webpack_require__(173);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 912 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(417);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(124)(module)))

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(915),
    nativeKeys = __webpack_require__(916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 915 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(917);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 917 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(421);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(920),
    getMatchData = __webpack_require__(969),
    matchesStrictComparable = __webpack_require__(429);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(423),
    baseIsEqual = __webpack_require__(426);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 921 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(212);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(212);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(212);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(212);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(211);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 927 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 928 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 929 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(211),
    Map = __webpack_require__(281),
    MapCache = __webpack_require__(282);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(422),
    isMasked = __webpack_require__(932),
    isObject = __webpack_require__(210),
    toSource = __webpack_require__(425);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(933);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(89);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 934 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(936),
    ListCache = __webpack_require__(211),
    Map = __webpack_require__(281);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(937),
    hashDelete = __webpack_require__(938),
    hashGet = __webpack_require__(939),
    hashHas = __webpack_require__(940),
    hashSet = __webpack_require__(941);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(213);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 938 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(213);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(213);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(213);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(214);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 943 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(214);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(214);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(214);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(423),
    equalArrays = __webpack_require__(427),
    equalByTag = __webpack_require__(953),
    equalObjects = __webpack_require__(957),
    getTag = __webpack_require__(964),
    isArray = __webpack_require__(90),
    isBuffer = __webpack_require__(418),
    isTypedArray = __webpack_require__(420);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(282),
    setCacheAdd = __webpack_require__(949),
    setCacheHas = __webpack_require__(950);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 949 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 950 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 951 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 952 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(209),
    Uint8Array = __webpack_require__(954),
    eq = __webpack_require__(424),
    equalArrays = __webpack_require__(427),
    mapToArray = __webpack_require__(955),
    setToArray = __webpack_require__(956);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(89);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 955 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 956 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(958);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(959),
    getSymbols = __webpack_require__(961),
    keys = __webpack_require__(278);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(960),
    isArray = __webpack_require__(90);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 960 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(962),
    stubArray = __webpack_require__(963);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 962 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 963 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(965),
    Map = __webpack_require__(281),
    Promise = __webpack_require__(966),
    Set = __webpack_require__(967),
    WeakMap = __webpack_require__(968),
    baseGetTag = __webpack_require__(172),
    toSource = __webpack_require__(425);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(140),
    root = __webpack_require__(89);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(140),
    root = __webpack_require__(89);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(140),
    root = __webpack_require__(89);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(140),
    root = __webpack_require__(89);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(428),
    keys = __webpack_require__(278);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(426),
    get = __webpack_require__(971),
    hasIn = __webpack_require__(977),
    isKey = __webpack_require__(283),
    isStrictComparable = __webpack_require__(428),
    matchesStrictComparable = __webpack_require__(429),
    toKey = __webpack_require__(216);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(430);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(973);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(974);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(282);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(209),
    arrayMap = __webpack_require__(976),
    isArray = __webpack_require__(90),
    isSymbol = __webpack_require__(215);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 976 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(978),
    hasPath = __webpack_require__(979);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 978 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(431),
    isArguments = __webpack_require__(416),
    isArray = __webpack_require__(90),
    isIndex = __webpack_require__(419),
    isLength = __webpack_require__(279),
    toKey = __webpack_require__(216);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 980 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(982),
    basePropertyDeep = __webpack_require__(983),
    isKey = __webpack_require__(283),
    toKey = __webpack_require__(216);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 982 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(430);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 984 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

if (true) {
  module.exports = __webpack_require__(986)
} else {
  module.exports = require("./lib/react-input-mask.development.js")
}


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e["default"]:e}var React=_interopDefault(__webpack_require__(0)),reactDom=__webpack_require__(77);function _defaults2(e,t){for(var n=Object.getOwnPropertyNames(t),a=0;a<n.length;a++){var r=n[a],o=Object.getOwnPropertyDescriptor(t,r);o&&o.configurable&&e[r]===undefined&&Object.defineProperty(e,r,o)}return e}function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_setPrototypeOf(e.prototype.constructor=e,t)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return _defaults2(e,t),e})(e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var n,a,r={},o=Object.keys(e);for(a=0;a<o.length;a++)n=o[a],0<=t.indexOf(n)||(r[n]=e[n]);return r}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var invariant=function(e,t,n,a,r,o,i,s){if(!e){var l;if(t===undefined)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var u=[n,a,r,o,i,s],c=0;(l=new Error(t.replace(/%s/g,function(){return u[c++]}))).name="Invariant Violation"}throw l.framesToPop=1,l}},invariant_1=invariant;function setInputSelection(e,t,n){if("selectionStart"in e&&"selectionEnd"in e)e.selectionStart=t,e.selectionEnd=n;else{var a=e.createTextRange();a.collapse(!0),a.moveStart("character",t),a.moveEnd("character",n-t),a.select()}}function getInputSelection(e){var t=0,n=0;if("selectionStart"in e&&"selectionEnd"in e)t=e.selectionStart,n=e.selectionEnd;else{var a=document.selection.createRange();a.parentElement()===e&&(t=-a.moveStart("character",-e.value.length),n=-a.moveEnd("character",-e.value.length))}return{start:t,end:n,length:n-t}}var defaultFormatChars={9:"[0-9]",a:"[A-Za-z]","*":"[A-Za-z0-9]"},defaultMaskChar="_";function parseMask(e,t,n){var a="",r="",o=null,i=[];if(t===undefined&&(t=defaultMaskChar),null==n&&(n=defaultFormatChars),!e||"string"!=typeof e)return{maskChar:t,formatChars:n,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};var s=!1;return e.split("").forEach(function(e){s=!s&&"\\"===e||(s||!n[e]?(i.push(a.length),a.length===i.length-1&&(r+=e)):o=a.length+1,a+=e,!1)}),{maskChar:t,formatChars:n,prefix:r,mask:a,lastEditablePosition:o,permanents:i}}function isPermanentCharacter(e,t){return-1!==e.permanents.indexOf(t)}function isAllowedCharacter(e,t,n){var a=e.mask,r=e.formatChars;if(!n)return!1;if(isPermanentCharacter(e,t))return a[t]===n;var o=r[a[t]];return new RegExp(o).test(n)}function isEmpty(n,e){return e.split("").every(function(e,t){return isPermanentCharacter(n,t)||!isAllowedCharacter(n,t,e)})}function getFilledLength(e,t){var n=e.maskChar,a=e.prefix;if(!n){for(;t.length>a.length&&isPermanentCharacter(e,t.length-1);)t=t.slice(0,t.length-1);return t.length}for(var r=a.length,o=t.length;o>=a.length;o--){var i=t[o];if(!isPermanentCharacter(e,o)&&isAllowedCharacter(e,o,i)){r=o+1;break}}return r}function isFilled(e,t){return getFilledLength(e,t)===e.mask.length}function formatValue(e,t){var n=e.maskChar,a=e.mask,r=e.prefix;if(!n){for((t=insertString(e,"",t,0)).length<r.length&&(t=r);t.length<a.length&&isPermanentCharacter(e,t.length);)t+=a[t.length];return t}if(t)return insertString(e,formatValue(e,""),t,0);for(var o=0;o<a.length;o++)isPermanentCharacter(e,o)?t+=a[o]:t+=n;return t}function clearRange(n,e,a,t){var r=a+t,o=n.maskChar,i=n.mask,s=n.prefix,l=e.split("");if(o)return l.map(function(e,t){return t<a||r<=t?e:isPermanentCharacter(n,t)?i[t]:o}).join("");for(var u=r;u<l.length;u++)isPermanentCharacter(n,u)&&(l[u]="");return a=Math.max(s.length,a),l.splice(a,r-a),e=l.join(""),formatValue(n,e)}function insertString(o,i,e,s){var l=o.mask,u=o.maskChar,c=o.prefix,t=e.split(""),f=isFilled(o,i);return!u&&s>i.length&&(i+=l.slice(i.length,s)),t.every(function(e){for(;r=e,isPermanentCharacter(o,a=s)&&r!==l[a];){if(s>=i.length&&(i+=l[s]),t=e,n=s,u&&isPermanentCharacter(o,n)&&t===u)return!0;if(++s>=l.length)return!1}var t,n,a,r;return!isAllowedCharacter(o,s,e)&&e!==u||(s<i.length?i=u||f||s<c.length?i.slice(0,s)+e+i.slice(s+1):(i=i.slice(0,s)+e+i.slice(s),formatValue(o,i)):u||(i+=e),++s<l.length)}),i}function getInsertStringLength(a,e,t,r){var o=a.mask,i=a.maskChar,n=t.split(""),s=r;return n.every(function(e){for(;n=e,isPermanentCharacter(a,t=r)&&n!==o[t];)if(++r>=o.length)return!1;var t,n;return(isAllowedCharacter(a,r,e)||e===i)&&r++,r<o.length}),r-s}function getLeftEditablePosition(e,t){for(var n=t;0<=n;--n)if(!isPermanentCharacter(e,n))return n;return null}function getRightEditablePosition(e,t){for(var n=e.mask,a=t;a<n.length;++a)if(!isPermanentCharacter(e,a))return a;return null}function getStringValue(e){return e||0===e?e+"":""}function processChange(e,t,n,a,r){var o=e.mask,i=e.prefix,s=e.lastEditablePosition,l=t,u="",c=0,f=0,h=Math.min(r.start,n.start);if(n.end>r.start?f=(c=getInsertStringLength(e,a,u=l.slice(r.start,n.end),h))?r.length:0:l.length<a.length&&(f=a.length-l.length),l=a,f){if(1===f&&!r.length)h=r.start===n.start?getRightEditablePosition(e,n.start):getLeftEditablePosition(e,n.start);l=clearRange(e,l,h,f)}return l=insertString(e,l,u,h),(h+=c)>=o.length?h=o.length:h<i.length&&!c?h=i.length:h>=i.length&&h<s&&c&&(h=getRightEditablePosition(e,h)),u||(u=null),{value:l=formatValue(e,l),enteredString:u,selection:{start:h,end:h}}}function isWindowsPhoneBrowser(){var e=new RegExp("windows","i"),t=new RegExp("phone","i"),n=navigator.userAgent;return e.test(n)&&t.test(n)}function isFunction(e){return"function"==typeof e}function getRequestAnimationFrame(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame}function getCancelAnimationFrame(){return window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame}function defer(e){return(!!getCancelAnimationFrame()?getRequestAnimationFrame():function(){return setTimeout(e,1e3/60)})(e)}function cancelDefer(e){(getCancelAnimationFrame()||clearTimeout)(e)}var _excluded=["mask","alwaysShowMask","maskChar","formatChars","inputRef","beforeMaskedValueChange","children"],InputElement=function(c){function e(e){var h=c.call(this,e)||this;h.focused=!1,h.mounted=!1,h.previousSelection=null,h.selectionDeferId=null,h.saveSelectionLoopDeferId=null,h.saveSelectionLoop=function(){h.previousSelection=h.getSelection(),h.saveSelectionLoopDeferId=defer(h.saveSelectionLoop)},h.runSaveSelectionLoop=function(){null===h.saveSelectionLoopDeferId&&h.saveSelectionLoop()},h.stopSaveSelectionLoop=function(){null!==h.saveSelectionLoopDeferId&&(cancelDefer(h.saveSelectionLoopDeferId),h.saveSelectionLoopDeferId=null,h.previousSelection=null)},h.getInputDOMNode=function(){if(!h.mounted)return null;var e=reactDom.findDOMNode(_assertThisInitialized(h)),t="undefined"!=typeof window&&e instanceof window.Element;if(e&&!t)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e},h.getInputValue=function(){var e=h.getInputDOMNode();return e?e.value:null},h.setInputValue=function(e){var t=h.getInputDOMNode();t&&(h.value=e,t.value=e)},h.setCursorToEnd=function(){var e=getFilledLength(h.maskOptions,h.value),t=getRightEditablePosition(h.maskOptions,e);null!==t&&h.setCursorPosition(t)},h.setSelection=function(e,t,n){void 0===n&&(n={});var a=h.getInputDOMNode(),r=h.isFocused();a&&r&&(n.deferred||setInputSelection(a,e,t),null!==h.selectionDeferId&&cancelDefer(h.selectionDeferId),h.previousSelection={start:e,end:t,length:Math.abs(t-e)})},h.getSelection=function(){return getInputSelection(h.getInputDOMNode())},h.getCursorPosition=function(){return h.getSelection().start},h.setCursorPosition=function(e){h.setSelection(e,e)},h.isFocused=function(){return h.focused},h.getBeforeMaskedValueChangeConfig=function(){var e=h.maskOptions,t=e.mask,n=e.maskChar,a=e.permanents,r=e.formatChars;return{mask:t,maskChar:n,permanents:a,alwaysShowMask:!!h.props.alwaysShowMask,formatChars:r}},h.isInputAutofilled=function(e,t,n,a){var r=h.getInputDOMNode();try{if(r.matches(":-webkit-autofill"))return!0}catch(o){}return!h.focused||a.end<n.length&&t.end===e.length},h.onChange=function(e){var t=_assertThisInitialized(h).beforePasteState,n=_assertThisInitialized(h).previousSelection,a=h.props.beforeMaskedValueChange,r=h.getInputValue(),o=h.value,i=h.getSelection();h.isInputAutofilled(r,i,o,n)&&(o=formatValue(h.maskOptions,""),n={start:0,end:0,length:0}),t&&(n=t.selection,o=t.value,i={start:n.start+r.length,end:n.start+r.length,length:0},r=o.slice(0,n.start)+r+o.slice(n.end),h.beforePasteState=null);var s=processChange(h.maskOptions,r,i,o,n),l=s.enteredString,u=s.selection,c=s.value;if(isFunction(a)){var f=a({value:c,selection:u},{value:o,selection:n},l,h.getBeforeMaskedValueChangeConfig());c=f.value,u=f.selection}h.setInputValue(c),isFunction(h.props.onChange)&&h.props.onChange(e),h.isWindowsPhoneBrowser?h.setSelection(u.start,u.end,{deferred:!0}):h.setSelection(u.start,u.end)},h.onFocus=function(e){var t=h.props.beforeMaskedValueChange,n=h.maskOptions,a=n.mask,r=n.prefix;if(h.focused=!0,h.mounted=!0,a){if(!h.value){var o=formatValue(h.maskOptions,r),i=formatValue(h.maskOptions,o),s=getFilledLength(h.maskOptions,i),l=getRightEditablePosition(h.maskOptions,s),u={start:l,end:l};if(isFunction(t)){var c=t({value:i,selection:u},{value:h.value,selection:null},null,h.getBeforeMaskedValueChangeConfig());i=c.value,u=c.selection}var f=i!==h.getInputValue();f&&h.setInputValue(i),f&&isFunction(h.props.onChange)&&h.props.onChange(e),h.setSelection(u.start,u.end)}h.runSaveSelectionLoop()}isFunction(h.props.onFocus)&&h.props.onFocus(e)},h.onBlur=function(e){var t=h.props.beforeMaskedValueChange,n=h.maskOptions.mask;if(h.stopSaveSelectionLoop(),h.focused=!1,n&&!h.props.alwaysShowMask&&isEmpty(h.maskOptions,h.value)){var a="";if(isFunction(t))a=t({value:a,selection:null},{value:h.value,selection:h.previousSelection},null,h.getBeforeMaskedValueChangeConfig()).value;var r=a!==h.getInputValue();r&&h.setInputValue(a),r&&isFunction(h.props.onChange)&&h.props.onChange(e)}isFunction(h.props.onBlur)&&h.props.onBlur(e)},h.onMouseDown=function(e){if(!h.focused&&document.addEventListener){h.mouseDownX=e.clientX,h.mouseDownY=e.clientY,h.mouseDownTime=(new Date).getTime();var o=function o(e){if(document.removeEventListener("mouseup",o),h.focused){var t=Math.abs(e.clientX-h.mouseDownX),n=Math.abs(e.clientY-h.mouseDownY),a=Math.max(t,n),r=(new Date).getTime()-h.mouseDownTime;(a<=10&&r<=200||a<=5&&r<=300)&&h.setCursorToEnd()}};document.addEventListener("mouseup",o)}isFunction(h.props.onMouseDown)&&h.props.onMouseDown(e)},h.onPaste=function(e){isFunction(h.props.onPaste)&&h.props.onPaste(e),e.defaultPrevented||(h.beforePasteState={value:h.getInputValue(),selection:h.getSelection()},h.setInputValue(""))},h.handleRef=function(e){null==h.props.children&&isFunction(h.props.inputRef)&&h.props.inputRef(e)};var t=e.mask,n=e.maskChar,a=e.formatChars,r=e.alwaysShowMask,o=e.beforeMaskedValueChange,i=e.defaultValue,s=e.value;h.maskOptions=parseMask(t,n,a),null==i&&(i=""),null==s&&(s=i);var l=getStringValue(s);if(h.maskOptions.mask&&(r||l)&&(l=formatValue(h.maskOptions,l),isFunction(o))){var u=e.value;null==e.value&&(u=i),l=o({value:l,selection:null},{value:u=getStringValue(u),selection:null},null,h.getBeforeMaskedValueChangeConfig()).value}return h.value=l,h}_inheritsLoose(e,c);var t=e.prototype;return t.componentDidMount=function(){this.mounted=!0,this.getInputDOMNode()&&(this.isWindowsPhoneBrowser=isWindowsPhoneBrowser(),this.maskOptions.mask&&this.getInputValue()!==this.value&&this.setInputValue(this.value))},t.componentDidUpdate=function(){var e=this.previousSelection,t=this.props,n=t.beforeMaskedValueChange,a=t.alwaysShowMask,r=t.mask,o=t.maskChar,i=t.formatChars,s=this.maskOptions,l=a||this.isFocused(),u=null!=this.props.value,c=u?getStringValue(this.props.value):this.value,f=e?e.start:null;if(this.maskOptions=parseMask(r,o,i),this.maskOptions.mask){!s.mask&&this.isFocused()&&this.runSaveSelectionLoop();var h=this.maskOptions.mask&&this.maskOptions.mask!==s.mask;if(s.mask||u||(c=this.getInputValue()),(h||this.maskOptions.mask&&(c||l))&&(c=formatValue(this.maskOptions,c)),h){var p=getFilledLength(this.maskOptions,c);(null===f||p<f)&&(f=isFilled(this.maskOptions,c)?p:getRightEditablePosition(this.maskOptions,p))}!this.maskOptions.mask||!isEmpty(this.maskOptions,c)||l||u&&this.props.value||(c="");var d={start:f,end:f};if(isFunction(n)){var m=n({value:c,selection:d},{value:this.value,selection:this.previousSelection},null,this.getBeforeMaskedValueChangeConfig());c=m.value,d=m.selection}this.value=c;var g=this.getInputValue()!==this.value;g?(this.setInputValue(this.value),this.forceUpdate()):h&&this.forceUpdate();var v=!1;null!=d.start&&null!=d.end&&(v=!e||e.start!==d.start||e.end!==d.end),(v||g)&&this.setSelection(d.start,d.end)}else s.mask&&(this.stopSaveSelectionLoop(),this.forceUpdate())},t.componentWillUnmount=function(){this.mounted=!1,null!==this.selectionDeferId&&cancelDefer(this.selectionDeferId),this.stopSaveSelectionLoop()},t.render=function(){var t,e=this.props,n=(e.mask,e.alwaysShowMask,e.maskChar,e.formatChars,e.inputRef,e.beforeMaskedValueChange,e.children),a=_objectWithoutPropertiesLoose(e,_excluded);if(n){isFunction(n)||invariant_1(!1);var r=["onChange","onPaste","onMouseDown","onFocus","onBlur","value","disabled","readOnly"],o=_extends({},a);r.forEach(function(e){return delete o[e]}),t=n(o),r.filter(function(e){return null!=t.props[e]&&t.props[e]!==a[e]}).length&&invariant_1(!1)}else t=React.createElement("input",_extends({ref:this.handleRef},a));var i={onFocus:this.onFocus,onBlur:this.onBlur};return this.maskOptions.mask&&(a.disabled||a.readOnly||(i.onChange=this.onChange,i.onPaste=this.onPaste,i.onMouseDown=this.onMouseDown),null!=a.value&&(i.value=this.value)),t=React.cloneElement(t,i)},e}(React.Component);module.exports=InputElement;


/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalStateReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initialState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Constants__ = __webpack_require__(2);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var GlobalStateReducer=function GlobalStateReducer(state,action){switch(action.type){case'RESTART_APP':return Object.assign({},state,{resetID:Math.random(),asyncError:''});case'SET_ASYNC_ERROR':return Object.assign({},state,{asyncError:action.data.asyncError});case'SET_WARNING':return Object.assign({},state,{warningMsg:action.data.warningMsg,warningAction:action.data.warningAction});case'SHOW_CUSTOM_ALERT':return Object.assign({},state,{toasts:[].concat(_toConsumableArray(state.toasts),[action.data.toast])});case'CLOSE_CUSTOM_ALERT':return Object.assign({},state,{toasts:state.toasts.filter(function(toast){return toast.id!==action.data.toastId;})});case'SET_LINK':return Object.assign({},state,{link:action.data.link});case'SET_LINK_TAB':return Object.assign({},state,{linkTab:action.data.linkTab});case'SET_LOADING_FEATURES':return Object.assign({},state,{loadingFeatures:action.data.loadingFeatures});default:return state;}};var initialState={asyncError:'',resetID:Math.random(),warningMsg:'',warningAction:function warningAction(){},toasts:[],link:"",linkTab:__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_120" /* MCM */],loadingFeatures:false};

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toaster = _interopRequireDefault(__webpack_require__(989));

var _default = _toaster["default"];
exports["default"] = _default;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _elevation = __webpack_require__(81);

var _toast = _interopRequireDefault(__webpack_require__(990));

var _portal = _interopRequireDefault(__webpack_require__(207));

var _listReset = _interopRequireDefault(__webpack_require__(433));

var _rtl = __webpack_require__(80);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = function styles(alignmentHorizontal, alignmentVertical, position) {
  var _css;

  return (0, _emotion.css)(_listReset["default"], (_css = {
    position: position
  }, (0, _defineProperty2["default"])(_css, alignmentVertical, 0), (0, _defineProperty2["default"])(_css, "left", 0), (0, _defineProperty2["default"])(_css, "right", 0), (0, _defineProperty2["default"])(_css, "zIndex", _elevation.elevationModal + 1), (0, _defineProperty2["default"])(_css, "pointerEvents", "none"), (0, _defineProperty2["default"])(_css, "display", "flex"), (0, _defineProperty2["default"])(_css, "flexDirection", alignmentVertical === "bottom" ? "column-reverse" : "column"), (0, _defineProperty2["default"])(_css, "& > li", {
    display: "flex",
    flexDirection: "column",
    alignItems: {
      left: "flex-start",
      center: "center",
      right: "flex-end"
    }[(0, _rtl.getHorizontalDirection)(alignmentHorizontal)]
  }), (0, _defineProperty2["default"])(_css, "& > li > *", {
    pointerEvents: "all"
  }), _css));
};
/**
 * Animate toasts in and out at the top of the viewport.
 */


var Toaster = function Toaster(props) {
  var toasts = props.toasts,
      onCloseToast = props.onCloseToast,
      children = props.children; // Keep mounted toasts in a ref (toasts will stay mounted after being removed
  // from the toasts prop while they animate out). Using a ref allows us to add
  // new toasts to the list of mounted toasts without an extra render (which
  // would be necessary if we used state to hold mounted toasts).

  var mountedToasts = (0, _react.useRef)([]); // Because mounted toasts are stored in a ref we have to manually update state
  // when we remove a toast from the list (after it animates out). This state
  // allows us to do that manual refresh.

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      refresh = _useState2[1]; // Keep a ref to the latest value of onCloseToast. This is really important
  // because onCloseToast probably looks something like this:
  //   `const onCloseToast = id => toasts.filter(t => t.id !== id)`
  // If we call outdated versions of that kind of onCloseToast we could end up
  // bringing old toasts back to life and wreaking havoc on the current state.


  var onCloseToastRef = (0, _react.useRef)(onCloseToast);
  onCloseToastRef.current = onCloseToast; // Add new toasts and update existing toasts in mountedToasts

  toasts.forEach(function (toast) {
    // If the toast is new then add it to the *end* of the array. This prevents
    // toasts from being re-ordered after they're mounted. Start a timeout if
    // the toast requires it.
    if (!mountedToasts.current.some(function (mountedToast) {
      return mountedToast.toast.id === toast.id;
    })) {
      mountedToasts.current.unshift({
        toast: _objectSpread(_objectSpread({}, toast), {}, {
          onClose: function onClose() {
            return onCloseToastRef.current(toast.id);
          }
        }),
        timeout: toast.timeout && setTimeout(function () {
          return onCloseToastRef.current(toast.id);
        }, toast.timeout)
      });
    }
  }); // Cleanup timeouts for any mounted toasts when the toaster unmounts.

  (0, _react.useEffect)(function () {
    return function () {
      return mountedToasts.current.forEach(function (_ref) {
        var timeout = _ref.timeout;
        return clearTimeout(timeout);
      });
    };
  }, []); // Put the Toaster in a wrapper when position is fixed to avoid potential
  // style clashes from ancestors

  var Wrapper = (0, _react.useMemo)(function () {
    return props.position === "fixed" ? _portal["default"] : _react["default"].Fragment;
  }, [props.position]);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement("ul", (0, _extends2["default"])({
    "aria-hidden": mountedToasts.current.length === 0 ? "true" : "false",
    className: styles(props.alignmentHorizontal, props.alignmentVertical, props.position)
  }, passThroughProps), mountedToasts.current.map(function (_ref2) {
    var toast = _ref2.toast,
        timeout = _ref2.timeout;
    return /*#__PURE__*/_react["default"].createElement(_toast["default"], {
      key: toast.id,
      exit: // If the toast is no longer being passed to us via `children` then
      // trigger the exit animation.
      !toasts.some(function (_ref3) {
        var id = _ref3.id;
        return id === toast.id;
      }),
      onAfterExit: function onAfterExit() {
        // After a toast is finished animating out, remove it from the
        // mounted toasts list and force a refresh.
        clearTimeout(timeout);
        mountedToasts.current = mountedToasts.current.filter(function (mountedToast) {
          return mountedToast.toast.id !== toast.id;
        });
        refresh({});
      },
      appearFrom: props.alignmentVertical
    }, children(toast));
  })));
};

Toaster.displayName = "Toaster";
Toaster.propTypes =  false ? {
  /**
   * This function will be called any time the Toaster wants to render a toast.
   * The Toaster will pass an element from the `toasts` array to the function,
   * which should return a React element.
   *
   * The object passed to this function will be an exact copy of an element from
   * the toasts array, except that an `onClose` function will be added. If your
   * toast has a dismiss or close button, tie the provided `onClose` function to
   * that button. For example:
   *
   * <Toaster onCloseToast={onCloseToast} toasts={[{ id: "my-toast" }]}>
   *   {toast => (
   *     <Alert toast={true} onClose={toast.onClose}>My toast</Alert>
   *   )}
   * </Toaster>
   */
  children: _propTypes["default"].func.isRequired,

  /**
   * The array of toasts to render. Each element should be an object with a
   * string `id` property as well as any other data that is required by the
   * custom `children` function. Each object will be passed as-is to the
   * `children` function in order to render the toast. The individual elements
   * in this array cannot be modified, they can only be added or removed.
   *
   * An optional `timeout` property can be set on any element in this array in
   * order to auto-close a toast after a particular period of time. Set the
   * `timeout` property to the number of milliseconds that the toast should be
   * visible. The Toaster's `onCloseToast` callback will be executed with the toast's
   * id after the toast expires.
   *
   * Note that when new toasts are added to this array they will be rendered in
   * the chronological order in which they were added, not in the order in which
   * they appear in the array.
   */
  toasts: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    timeout: _propTypes["default"].number
  })).isRequired,

  /**
   * This function will be called any time a toast should be closed (e.g. when
   * the toast times out, or when the user clicks a toast's dismiss button). It
   * will be passed the id of the toast to close.
   */
  onCloseToast: _propTypes["default"].func.isRequired,

  /**
   * The toasts' horizontal alignment within the viewport.
   */
  alignmentHorizontal: _propTypes["default"].oneOf(["left", "start", "center", "right", "end"]),

  /**
   * The toasts' vertical alignment within the viewport.
   *
   * @since 5.24.0
   */
  alignmentVertical: _propTypes["default"].oneOf(["top", "bottom"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.20.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   *
   * @since 5.20.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * By default, Toaster appears toast from the top of the viewport (position "fixed").
   * Setting position to "absolute" allows the Toaster to be positioned to the
   * top of its closest "relative" ancestor. Read more about [CSS `position`](https://developer.mozilla.org/en-US/docs/Web/CSS/position).
   *
   * For example:
   * ```
   *  // Toaster will now appear toast from the top of this div
   *  <div style={{ position: "relative" }}>
   *    <Toaster toasts={toasts} onCloseToast={onCloseToast} position="absolute">
   *      {toast => <Alert {...toast} toast={true} width="100%" />}
   *    </Toaster>
   *  </div>
   * ```
   *
   * @since  5.x
   */
  position: _propTypes["default"].oneOf(["fixed", "absolute"])
} : {};
Toaster.defaultProps = {
  alignmentHorizontal: "center",
  alignmentVertical: "top",
  position: "fixed"
};
var _default = Toaster;
exports["default"] = _default;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _spacing = __webpack_require__(340);

var _elevation = __webpack_require__(81);

var _transitionController = _interopRequireDefault(__webpack_require__(274));

var _functional = __webpack_require__(38);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var _css;

  var state = _ref.state,
      height = _ref.height,
      appearFrom = _ref.appearFrom,
      motionDuration = _ref.motionDuration;
  return (0, _emotion.css)((_css = {
    // Stick the contents of the toast container to the bottom of the container
    // so that when we animate the height of the container the contents appear
    // to undergo a slide animation instead of a reveal animation.
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    "& > *": {
      flexShrink: 0
    },
    // Fade in and out
    opacity: state === "exited" || state === "exiting" ? 0 : 1,
    // Animate the height in and out
    height: state === "exiting" || state === "exited" ? 0 : height
  }, (0, _defineProperty2["default"])(_css, appearFrom === "top" ? "paddingTop" : "paddingBottom", state === "exiting" || state === "exited" ? 0 : _spacing.spacingMedium), (0, _defineProperty2["default"])(_css, "paddingRight", _spacing.spacingMedium), (0, _defineProperty2["default"])(_css, "paddingLeft", _spacing.spacingMedium), (0, _defineProperty2["default"])(_css, "transition", "height ".concat(motionDuration, "ms ease, padding ").concat(motionDuration, "ms ease, opacity ").concat(motionDuration, "ms ease")), (0, _defineProperty2["default"])(_css, "zIndex", state === "exiting" || state === "entering" ? _elevation.elevationBackground : _elevation.elevationForeground), (0, _defineProperty2["default"])(_css, "position", "relative"), _css));
}, ["state", "height", "appearFrom", "motionDuration"]);
/**
 * An internal container that applies toasty animation to its contents.
 */

var Toast = function Toast(_ref2) {
  var children = _ref2.children,
      exit = _ref2.exit,
      motionDuration = _ref2.motionDuration,
      onAfterExit = _ref2.onAfterExit,
      appearFrom = _ref2.appearFrom;
  var ref = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      height = _useState4[0],
      setHeight = _useState4[1]; // Open the toast as soon as it's mounted


  (0, _react.useEffect)(function () {
    setOpen(true);
  }, []); // Close the toast when the exit prop flips to true

  (0, _react.useEffect)(function () {
    if (exit) {
      setOpen(false);
    }
  }, [exit]); // Fix the height of the toast before animating (it's the year 2045 and you
  // still can't animate a dynamic height with CSS)

  var onBeforeTransition = (0, _react.useCallback)(function (done) {
    setHeight(ref.current.firstElementChild.getBoundingClientRect().height);
    done();
  }, []); // Unfix the height of the toast after animating it in. This allows the
  // toast's content to change height after mounting without messing anything
  // up.

  var onAfterEnter = (0, _react.useCallback)(function () {
    return setHeight(undefined);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_transitionController["default"], {
    "in": open,
    duration: motionDuration,
    onBeforeEnter: onBeforeTransition,
    onBeforeExit: onBeforeTransition,
    onAfterEnter: onAfterEnter,
    onAfterExit: onAfterExit
  }, function (state) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: styles({
        state: state,
        height: height,
        appearFrom: appearFrom,
        motionDuration: motionDuration
      }),
      ref: ref
    }, children);
  });
};

Toast.displayName = "Toast";
Toast.propTypes =  false ? {
  appearFrom: _propTypes["default"].oneOf(["top", "bottom"]),
  children: _propTypes["default"].node,

  /**
   * Set this to true when the toast is supposed to be unmounted. Doing so will
   * trigger the toast's exit animation, after which it will call the
   * onAfterExit function so that the parent can safely unmount it without
   * interrupting the animation.
   */
  exit: _propTypes["default"].bool,
  motionDuration: _propTypes["default"].number,
  onAfterExit: _propTypes["default"].func
} : {};
Toast.defaultProps = {
  appearFrom: "top",
  motionDuration: 200
};
var _default = Toast;
exports["default"] = _default;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _radioButton = _interopRequireDefault(__webpack_require__(992));

var _default = _radioButton["default"];
exports["default"] = _default;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _keycode = _interopRequireDefault(__webpack_require__(72));

var _radioButton = _interopRequireDefault(__webpack_require__(993));

var _theme = __webpack_require__(24);

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _token = __webpack_require__(20);

var _focusRing = _interopRequireDefault(__webpack_require__(73));

var _text = _interopRequireDefault(__webpack_require__(47));

var _visuallyHidden = _interopRequireDefault(__webpack_require__(95));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

var _cardContext = _interopRequireDefault(__webpack_require__(363));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Root styles for the entire component. This makes it a block-level component
// without stretching the clickable-area beyond the visible label
var containerStyles = (0, _emotion.css)({
  // NOTE: Use "flex" instead of "block" to acheive block-level display while
  // fixing the min-height issue in IE11:
  // https://stackoverflow.com/questions/44700068/flexbox-min-height-and-ie11
  display: "flex",
  fontSize: 0
});
var labelStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var disabled = _ref.disabled;
  var textStyleObject = (0, _text["default"])(t);
  return (0, _emotion.css)(textStyleObject, {
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    position: "relative",
    color: t("foregroundColor", disabled ? "disabled" : "default"),
    cursor: disabled ? "not-allowed" : "pointer",
    userSelect: "none",
    minHeight: textStyleObject.lineHeight
  });
}, ["disabled"]); // Styles for the radio button (a psuedo-element) that's actually displayed to
// users

var visibleRadioButtonStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var _css;

  var checked = _ref2.checked,
      disabled = _ref2.disabled,
      focus = _ref2.focus,
      size = _ref2.size,
      hover = _ref2.hover,
      hoverDisabled = _ref2.hoverDisabled;
  var modifier = checked ? "selected" : "unselected";
  var state = disabled ? "disabled" : "default";
  var borderRadius = t("borderRadius");
  var borderWidth = t("borderWidth");
  return (0, _emotion.css)(hover && !hoverDisabled && !disabled ? {
    "* > &": !disabled && !hoverDisabled ? {
      backgroundColor: t("backgroundColor", [modifier, "hover"]),
      borderColor: t("borderColor", [modifier, "hover"]),
      "::before": {
        backgroundColor: t("indicatorColor", [modifier, "hover"])
      }
    } : undefined
  } : undefined, (_css = {
    position: "relative",
    boxSizing: "border-box",
    flexShrink: 0,
    transition: t.transitionCss("motion", "background-color"),
    borderRadius: borderRadius,
    borderWidth: borderWidth,
    borderStyle: "solid",
    borderColor: t("borderColor", [modifier, state]),
    backgroundColor: t("backgroundColor", [modifier, state]),
    width: t("diameter", size),
    height: t("diameter", size),
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   marginInlineStart: t("spacingHorizontal"),
    // },
    marginRight: t("spacingHorizontal")
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    marginLeft: t("spacingHorizontal"),
    marginRight: 0
  }), (0, _defineProperty2["default"])(_css, "::before", {
    content: "''",
    display: "block",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translateY(-50%) translateX(-50%)",
    borderRadius: borderRadius,
    width: t("indicatorDiameter", size),
    height: t("indicatorDiameter", size),
    transition: t.transitionCss("motion", "background-color"),
    backgroundColor: t("indicatorColor", [modifier, state])
  }), (0, _defineProperty2["default"])(_css, "*:hover > &", !disabled && !hoverDisabled ? {
    backgroundColor: t("backgroundColor", [modifier, "hover"]),
    borderColor: t("borderColor", [modifier, "hover"]),
    "::before": {
      backgroundColor: t("indicatorColor", [modifier, "hover"])
    }
  } : undefined), (0, _defineProperty2["default"])(_css, "*:active > &", !disabled && {
    backgroundColor: t("backgroundColor", [modifier, "pressed"]),
    borderColor: t("borderColor", [modifier, "pressed"]),
    "::before": {
      backgroundColor: t("indicatorColor", [modifier, "pressed"])
    }
  }), _css), !disabled ? (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderRadius: borderRadius,
    borderWidth: borderWidth,
    dropShadow: true,
    offset: 4,
    hoverSelector: "*:hover > &"
  }) : undefined);
}, ["checked", "disabled", "focus", "size", "hoverDisabled", "hover"]); // Styles for the actual HTML radio input element that is hidden from the user

var hiddenRadioButtonStyles = (0, _emotion.css)(_visuallyHidden["default"]);

var RadioButton = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var checked = props.checked,
      value = props.value,
      onChange = props.onChange;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hoverDisabled = _useState2[0],
      setHoverDisabled = _useState2[1];

  var t = (0, _theme.useTheme)(_radioButton["default"], "radioButton");
  var context = (0, _react.useContext)(_cardContext["default"]);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
  var onChangeInput = (0, _react.useCallback)(function () {
    if (onChange) onChange(value);
    setHoverDisabled(true);
  }, [onChange, setHoverDisabled, value]);
  var onKeyDown = (0, _react.useCallback)(function (event) {
    // HACK: If the radio button is already checked and the user hits the
    // spacebar, cancel the event. This prevents a bug in Chrome & Safari where
    // pressing spacebar on a checked radio button will cause the active state
    // of the radio button to stick, even after the radio has been unchecked.
    if (checked && (0, _keycode["default"])(event) === "space") {
      event.preventDefault();
    }
  }, [checked]);
  var onMouseEnter = (0, _react.useCallback)(function () {
    return setHoverDisabled(false);
  }, []);

  var _useFocus = (0, _useFocus2["default"])({
    onFocus: function onFocus(event) {
      if (props.onFocus) props.onFocus(event);
    },
    onBlur: function onBlur(event) {
      if (props.onBlur) props.onBlur(event);
    }
  }),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: containerStyles
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: labelStyles(t, props),
    onMouseEnter: onMouseEnter,
    onKeyDown: onKeyDown
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, passThroughProps, focusProps, {
    id: props.id,
    className: hiddenRadioButtonStyles,
    type: "radio",
    name: props.name,
    value: value,
    "aria-checked": Boolean(checked),
    checked: // Cast `checked` to a boolean so that a value of `undefined`
    // doesn't flip the input into React's "uncontrolled" mode.
    Boolean(checked),
    disabled: props.disabled,
    tabIndex: props.tabIndex,
    onChange: onChangeInput,
    ref: ref
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: visibleRadioButtonStyles(t, {
      checked: checked,
      disabled: props.disabled,
      hover: context.hover,
      focus: focus && focusTrigger === "keyboard",
      size: props.size,
      hoverDisabled: hoverDisabled
    })
  }), /*#__PURE__*/_react["default"].createElement("div", null, props.children)));
});

RadioButton.displayName = "RadioButton";
RadioButton.propTypes =  false ? {
  /**
   * The checked state of the component. Use this in conjunction with the
   * `onChange` prop to make the component interactive.
   */
  checked: _propTypes["default"].bool,

  /**
   * The component's label. Plain text is recommended. This will be displayed
   * next to the form control, and will trigger a state change when clicked. If
   * you're using an external label, be sure to associate them with an id and
   * [htmlFor](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLabelElement/htmlFor).
   */
  children: _propTypes["default"].node,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["medium", "large"]),

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The value of the underlying input element. This is used to populate the
   * form data when submitting a form. To change the on/off status of the
   * component use the `checked` prop.
   */
  value: _propTypes["default"].any,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * A function that will be called when the user attempts to change the
   * component (e.g. by clicking on it). The `value` prop will be passed as the
   * only argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the checked state provided to this function somewhere in
   * your state and pass it back via the `checked` prop in order to make this
   * component interactive.
   *
   * Note that this is *not* called when the user selects another radio button
   * in the same group. In that case it's up to you to set the `checked` prop of
   * this component to `false`.
   */
  onChange: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func
} : {};
RadioButton.defaultProps = {
  size: "medium"
};
var _default = RadioButton;
exports["default"] = _default;

/***/ }),
/* 993 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    radioButtonMotionDuration: "100ms",
    radioButtonMotionFunction: "ease",
    radioButtonForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    radioButtonForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    radioButtonBackgroundColorSelectedDefault: tokens.themeForegroundAccentDefault,
    radioButtonBackgroundColorSelectedHover: tokens.themeForegroundAccentHover,
    radioButtonBackgroundColorSelectedPressed: tokens.themeForegroundAccentPressed,
    radioButtonBackgroundColorSelectedDisabled: tokens.themeForegroundAccentDisabled,
    radioButtonBackgroundColorUnselectedDefault: tokens.themeBackgroundPrimaryDefault,
    radioButtonBackgroundColorUnselectedHover: tokens.themeForegroundAccentHover,
    radioButtonBackgroundColorUnselectedPressed: tokens.themeForegroundAccentPressed,
    radioButtonBackgroundColorUnselectedDisabled: tokens.themeBackgroundPrimaryDisabled,
    radioButtonBorderWidth: 1,
    radioButtonBorderRadius: 999,
    radioButtonBorderColorSelectedDefault: "rgba(0, 0, 0, 0)",
    radioButtonBorderColorSelectedDisabled: tokens.themeBorderPrimaryDisabled,
    radioButtonBorderColorUnselectedDefault: tokens.themeBorderPrimaryDefault,
    radioButtonBorderColorUnselectedHover: "rgba(0, 0, 0, 0)",
    radioButtonBorderColorUnselectedPressed: "rgba(0, 0, 0, 0)",
    radioButtonBorderColorUnselectedDisabled: tokens.themeBorderPrimaryDisabled,
    radioButtonIndicatorDiameterMedium: 8,
    radioButtonIndicatorDiameterLarge: 10,
    radioButtonIndicatorColorSelectedDefault: tokens.themeBackgroundPrimaryDefault,
    radioButtonIndicatorColorUnselectedDefault: tokens.themeBackgroundPrimaryDefault,
    radioButtonIndicatorColorUnselectedHover: tokens.themeForegroundAccentDefault,
    radioButtonIndicatorColorUnselectedPressed: tokens.themeBackgroundPrimaryDefault,
    radioButtonIndicatorColorUnselectedDisabled: tokens.themeBackgroundPrimaryDisabled,
    radioButtonDiameterMedium: 20,
    radioButtonDiameterLarge: 24,
    radioButtonSpacingHorizontal: 12
  }
};

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

/*! @license DOMPurify 2.4.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.7/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.DOMPurify = factory());
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }
  /* Add properties to a lookup table */

  function addToSet(set, array, transformCaseFunc) {
    var _transformCaseFunc;

    transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;

    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;

    while (l--) {
      var element = array[l];

      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);

        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }
  /* Shallow clone an object */

  function clone(object) {
    var newObject = create(null);
    var property;

    for (property in object) {
      if (apply(hasOwnProperty, object, [property]) === true) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }
  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */

  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);

      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']); // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.

  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']); // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.

  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };
  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */


  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    } // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.


    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';

    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };
    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */


    DOMPurify.version = '2.4.7';
    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */

    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }

    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode'); // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.

    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');

      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);

    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};

    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};
    /**
     * Expose whether this browser supports running the full DOMPurify.
     */

    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
        ERB_EXPR$1 = ERB_EXPR,
        TMPLIT_EXPR$1 = TMPLIT_EXPR,
        DATA_ATTR$1 = DATA_ATTR,
        ARIA_ATTR$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
    /* Allowed attribute names */

    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */

    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

    var FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

    var FORBID_ATTR = null;
    /* Decide if ARIA attributes are okay */

    var ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */

    var ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */

    var ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */

    var ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */

    var SAFE_FOR_TEMPLATES = false;
    /* Decide if document with <html>... should be returned */

    var WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */

    var SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */

    var FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */

    var RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */

    var RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */

    var RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */

    var SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */

    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */

    var KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */

    var IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */

    var USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */

    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
    /* Tags that are safe for data: URIs */

    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
    /* Attributes safe for values like "javascript:" */

    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */

    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */

    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
    /* Parsing of strict XHTML documents */

    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;
    /* Keep a reference to config to pass to hooks */

    var CONFIG = null;
    /* Ideally, do not touch anything below this line */

    /* ______________________________________________ */

    var formElement = document.createElement('form');

    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity


    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }
      /* Shield configuration object from tampering */


      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }
      /* Shield configuration object from prototype pollution */


      cfg = clone(cfg);
      PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.

      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
      /* Set configuration parameters */

      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

      ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true

      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

      RETURN_DOM = cfg.RETURN_DOM || false; // Default false

      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false

      FORCE_BODY = cfg.FORCE_BODY || false; // Default false

      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false

      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

      IN_PLACE = cfg.IN_PLACE || false; // Default false

      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
      CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }

      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }

      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }
      /* Parse profile info */


      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];

        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }
      /* Merge configuration parameters */


      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }

      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }

        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }
      /* Add #text in case KEEP_CONTENT is set to true */


      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }
      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }
      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */


      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      } // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.


      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']); // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.

    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */

    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */

    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.

      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        } // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.


        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        } // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.


        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        } // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points


        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        } // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.


        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        } // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace


        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      } // For XHTML and XML documents that support custom namespaces


      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      } // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.


      return false;
    };
    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */


    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });

      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };
    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */


    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes

      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };
    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */


    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */

      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }
      /* Use createHTMLDocument in case DOMParser is not available */


      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);

        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {// Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }
      /* Work on whole document or just its body */


      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */


    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };
    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */


    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };
    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */


    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };
    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */


    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };
    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */


    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeElements', currentNode, null);
      /* Check if element is clobbered or can clobber */


      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Check if tagname contains Unicode */


      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Now let's check the element's type and name */


      var tagName = transformCaseFunc(currentNode.nodeName);
      /* Execute a hook if present */

      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });
      /* Detect mXSS attempts abusing namespace confusion */


      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Mitigate a problem with templates inside select */


      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Remove element if anything forbids its presence */


      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }
        /* Keep content except for bad-listed elements */


        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);

        return true;
      }
      /* Check whether element has a valid namespace */


      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Make sure that older browsers don't get fallback-tag mXSS */


      if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);

        return true;
      }
      /* Sanitize element content to be template-safe */


      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');

        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };
    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity


    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }
      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */


      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if ( // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */

      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (value) {
        return false;
      } else ;

      return true;
    };
    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */


    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName.indexOf('-') > 0;
    };
    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */


    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */

      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;
      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;
      /* Go backwards over all attributes; safely remove bad ones */

      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);
        /* Execute a hook if present */

        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set

        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */

        if (hookEvent.forceKeepAttr) {
          continue;
        }
        /* Remove attribute */


        _removeAttribute(name, currentNode);
        /* Did the hooks approve of the attribute? */


        if (!hookEvent.keepAttr) {
          continue;
        }
        /* Work around a security issue in jQuery 3.0 */


        if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);

          continue;
        }
        /* Sanitize attribute content to be template-safe */


        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }
        /* Is `value` valid for this attribute? */


        var lcTag = transformCaseFunc(currentNode.nodeName);

        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }
        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */


        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value


          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }
        /* Handle attributes that require Trusted Types */


        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                {
                  value = trustedTypesPolicy.createHTML(value);
                  break;
                }

              case 'TrustedScriptURL':
                {
                  value = trustedTypesPolicy.createScriptURL(value);
                  break;
                }
            }
          }
        }
        /* Handle invalid data-* attribute set by try-catching it */


        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeAttributes', currentNode, null);
    };
    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */


    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;

      var shadowIterator = _createIterator(fragment);
      /* Execute a hook if present */


      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */


        if (_sanitizeElements(shadowNode)) {
          continue;
        }
        /* Deep shadow DOM detected */


        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(shadowNode);
      }
      /* Execute a hook if present */


      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };
    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity


    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */

      IS_EMPTY_INPUT = !dirty;

      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }
      /* Stringify, in case dirty is an object */


      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        if (typeof dirty.toString === 'function') {
          dirty = dirty.toString();

          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        } else {
          throw typeErrorCreate('toString is not a function');
        }
      }
      /* Check we can run. Otherwise fall back or ignore */


      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }
      /* Assign config vars */


      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }
      /* Clean up removed elements */


      DOMPurify.removed = [];
      /* Check if dirty is correctly typed for IN_PLACE */

      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);

          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);

        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }
        /* Initialize the document to work on */


        body = _initDocument(dirty);
        /* Check we have a DOM node from the data */

        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }
      /* Remove first element node (ours) if FORCE_BODY is set */


      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }
      /* Get node iterator */


      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
      /* Now start iterating over the created document */


      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }
        /* Sanitize tags and elements */


        if (_sanitizeElements(currentNode)) {
          continue;
        }
        /* Shadow DOM detected, sanitize it */


        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        /* Check attributes, sanitize if necessary */


        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;
      /* If we sanitized `dirty` in-place, return it. */

      if (IN_PLACE) {
        return dirty;
      }
      /* Return sanitized string or DOM */


      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
      /* Serialize doctype if allowed */

      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }
      /* Sanitize final string template-safe */


      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */


    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);

      SET_CONFIG = true;
    };
    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */


    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };
    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */


    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };
    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */


    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };
    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */


    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };
    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */


    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };
    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */


    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(155));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _keycode = _interopRequireDefault(__webpack_require__(72));

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _find = _interopRequireDefault(__webpack_require__(96));

var _noop = _interopRequireDefault(__webpack_require__(59));

var _escapeRegExp = _interopRequireDefault(__webpack_require__(75));

var _chevronSelect = _interopRequireDefault(__webpack_require__(996));

var _select = _interopRequireDefault(__webpack_require__(997));

var _selectOptionList = _interopRequireDefault(__webpack_require__(998));

var _selectOptionListContainer = _interopRequireDefault(__webpack_require__(1001));

var _utils = __webpack_require__(434);

var _inputBox = _interopRequireDefault(__webpack_require__(276));

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _theme = __webpack_require__(24);

var _responsive = _interopRequireDefault(__webpack_require__(414));

var _context = _interopRequireDefault(__webpack_require__(1006));

var _token = __webpack_require__(20);

var _text = _interopRequireDefault(__webpack_require__(47));

var _inputReset = _interopRequireDefault(__webpack_require__(277));

var _noTextWrap = _interopRequireDefault(__webpack_require__(257));

var _visuallyHidden = _interopRequireDefault(__webpack_require__(95));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

var _supportTextWrapper = _interopRequireDefault(__webpack_require__(138));

var _getSupportTextAriaDescribedby = _interopRequireDefault(__webpack_require__(139));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var width = _ref.width,
      minWidth = _ref.minWidth;
  return (0, _emotion.css)((0, _text["default"])(t), {
    outline: "none",
    position: "relative",
    width: width,
    // If an explicit width is set then don't allow the select to flex
    flex: width ? "none !important" : undefined,
    minWidth: minWidth
  });
}, ["width", "minWidth"]);
var customSearchInputStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var disabled = _ref2.disabled,
      open = _ref2.open,
      empty = _ref2.empty;
  return (0, _emotion.css)((0, _inputReset["default"])({
    empty: empty,
    textColor: t("searchInputForegroundColorDefault"),
    placeholderColor: t("searchInputPlaceholderColor", disabled ? "disabled" : "default")
  }), // If the select is open then hide the value label and show the input,
  // otherwise hide the input and show the label. Note that the input is
  // visually hidden but is still focuseable (so the user can tab to it).
  open ? {
    "& + div": {
      display: "none"
    }
  } : // Preserve the input's width so the Select doesn't change width on
  // focus/input reveal.
  _objectSpread(_objectSpread({}, _visuallyHidden["default"]), {}, {
    width: "auto",
    position: "initial"
  }));
}, ["disabled", "open", "empty"]);
var valueLabelStyles = (0, _emotion.css)(_noTextWrap["default"]);

var Select = /*#__PURE__*/_react["default"].forwardRef(function (props, forwardedRef) {
  // Are the select options open?
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1]; // This enables us to preselect an option in the option list. This is the
  // "default" because the internal state of the option list may change if the
  // user uses up/down arrow keys to manage the preselected index.


  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      defaultPreselectedIndex = _useState4[0],
      setDefaultPreselectedIndex = _useState4[1];

  var _useState5 = (0, _react.useState)(defaultPreselectedIndex),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      preselectedIndex = _useState6[0],
      setPreselectedIndex = _useState6[1]; // For this component, there are two types of searching:
  //   1) Custom searching is what happens when `onSearch` and `searchQuery`
  //      are passed in as props. This renders a search input inside the
  //      Select and allows the developer to filter options down according to
  //      any custom search algorithm.
  //   2) Native searching is what happens when no custom search props are
  //      passed. This search mimicks the behavior of native html selects -
  //      the search query is stored internally and the first option that
  //      matches the query (prefix matching only) is selected if the select
  //      is closed or "preselected" if the select is open.


  var _useState7 = (0, _react.useState)(""),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      nativeSearchQuery = _useState8[0],
      setNativeSearchQuery = _useState8[1]; // We don't actually use the focus prop but we DO set it down the line


  var _useState9 = (0, _react.useState)(),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      setFocusState = _useState10[1];

  var rootRef = (0, _react.useRef)(null);
  var optionListRef = (0, _react.useRef)(null);

  var updateOptionListRef = function updateOptionListRef(ref) {
    return optionListRef.current = ref;
  };

  var customSearchInputRef = (0, _react.useRef)(null);
  var onSearch = props.onSearch;
  var nativeSearchTimeoutDuration = 1000; // Generate a unique id that can be used to reference this element in the DOM

  var id = props.id || (0, _uniqueId["default"])("select-");
  var popupId = (0, _uniqueId["default"])("options-list-");
  var isMultiSelectable = Array.isArray(props.value);
  var isNativeSearching = /[\S]/.test(nativeSearchQuery);
  var isCustomSearchable = Boolean(props.onSearch);
  var nativeSearchTimeout = (0, _react.useRef)(); // Assign the local and prop ref (if it exists) to the target ref (select)

  var assignRefs = (0, _react.useCallback)(function (targetRef) {
    rootRef.current = targetRef;

    if (forwardedRef) {
      // Assign the ref with a function (Class components) or assigning .current
      // (modern functional components using the `useRef` hook)
      if (typeof forwardedRef === "function") {
        forwardedRef(targetRef);
      } else {
        forwardedRef.current = targetRef;
      }
    }
  }, [forwardedRef]);
  var options = (0, _utils.getOptionsFromChildren)(props.children);
  var selectedOptions = options.filter(function (option) {
    return (0, _utils.isOptionValueSelected)(props.value, option.value);
  });
  var valueLabel = props.valueLabel(selectedOptions) || "";
  var t = (0, _theme.useTheme)(_select["default"], "select");
  /**
   * Close the select, optionally retaining focus on the handle.
   */

  var close = (0, _react.useCallback)(function (_ref3) {
    var retainFocus = _ref3.retainFocus;
    setOpen(false);
    setFocusState(retainFocus);
    setDefaultPreselectedIndex(undefined);

    if (isCustomSearchable) {
      onSearch("");
    } else {
      clearTimeout(nativeSearchTimeout.current);
      setNativeSearchQuery("");
      setDefaultPreselectedIndex(undefined);
    } // Move focus back to the main node before closing the option list


    if (retainFocus) {
      if (isCustomSearchable) {
        customSearchInputRef.current.focus();
      } else {
        rootRef.current.focus();
      }
    }
  }, [isCustomSearchable, onSearch]);
  /**
   * Take the current search query and attempt to find and focus the matching
   * option
   */

  var nativeSearch = (0, _react.useCallback)(function (searchQuery) {
    var value = props.value,
        onChange = props.onChange,
        children = props.children;
    var options = (0, _utils.getOptionsFromChildren)(children).filter(function (_ref4) {
      var disabled = _ref4.disabled;
      return !disabled;
    });
    var selectedOption = (0, _find["default"])(options, function (option) {
      return (0, _utils.isOptionValueSelected)(value, option.value);
    }); // Look for the first option that starts with the full search query

    var searchQueryRegExp = new RegExp("^".concat((0, _escapeRegExp["default"])(searchQuery)), "i");
    var fullMatch = (0, _find["default"])(options, function (option) {
      return searchQueryRegExp.test(option.label);
    }); // Look for an option that starts with the last character typed. Sort the
    // options so that if the same character is typed repeatedly the focus
    // cycles through all matching options.

    var lastChar = searchQuery[searchQuery.length - 1];
    var lastCharRegExp = new RegExp("^".concat((0, _escapeRegExp["default"])(lastChar)), "i");
    var currentIndex = open ? defaultPreselectedIndex : selectedOption ? selectedOption.index : 0;
    var lastCharMatch = (0, _find["default"])([].concat((0, _toConsumableArray2["default"])(options.slice(currentIndex + 1)), (0, _toConsumableArray2["default"])(options.slice(0, currentIndex + 1))), function (option) {
      return lastCharRegExp.test(option.label);
    }); // Prefer a full match to a last character match

    var match = fullMatch || lastCharMatch; // If the select is expanded and we have a match then focus it

    if (match && open) {
      setDefaultPreselectedIndex(match.index);
    } // If the select is closed and we have a match then select it
    else if (match) {
      onChange(isMultiSelectable ? [match.value] : match.value);
    }
  }, [defaultPreselectedIndex, isMultiSelectable, open, props]);
  /**
   * Event handlers
   */

  var onClickOption = function onClickOption(value) {
    if (isMultiSelectable) {
      // If the value is selected then deselect it, otherwise select it
      if ((0, _utils.isOptionValueSelected)(props.value, value)) {
        props.onChange(props.value.filter(function (v) {
          return v !== value;
        }));
      } else {
        props.onChange([].concat((0, _toConsumableArray2["default"])(props.value), [value]));
      } // If the searchable, multi-Select contains groups, refocus
      // on the Select after an option has been clicked.


      if (isCustomSearchable && _react["default"].Children.toArray(props.children).some(function (child) {
        return (0, _utils.isGroup)(child);
      })) {
        customSearchInputRef.current.focus();
      }
    } else {
      close({
        retainFocus: true
      });
      props.onChange(value);
    }
  };

  var onKeyDown = function onKeyDown(event) {
    var disabled = props.disabled;
    var key = (0, _keycode["default"])(event); // HACK: Assume the key is "printable" (can be added to a search query) if
    // it's either of length 1 or a space.

    var printableKey = key && key.length === 1 ? key : key === "space" ? " " : undefined;
    var isNativeSearch = isNativeSearching;
    var keyUsed = false; // If any character is typed that doesn't trigger behavior in the option
    // list (as indicated by event.defaultPrevented set to true) then make sure
    // the custom search input is focused

    if (isCustomSearchable && !event.defaultPrevented && customSearchInputRef.current !== document.activeElement) {
      customSearchInputRef.current.focus();
    } // If no custom search behavior is defined and a printable key was typed,
    // trigger the "native" search functionality that mimics the browser


    if (!isCustomSearchable && printableKey) {
      var nativeSearchQueryPrintableKey = nativeSearchQuery + printableKey;
      setNativeSearchQuery(nativeSearchQueryPrintableKey);
      nativeSearch(nativeSearchQueryPrintableKey); // Reset the timeout that will the search query

      clearTimeout(nativeSearchTimeout.current);
      nativeSearchTimeout.current = window.setTimeout(function () {
        setNativeSearchQuery("");
        setDefaultPreselectedIndex(undefined);
      }, nativeSearchTimeoutDuration);
      keyUsed = true;
    } // If no custom search behavior is defined and backspace or delete was
    // pressed, clear the "native" search query


    if (!isCustomSearchable && (key === "backspace" || key === "delete")) {
      // Reset the timeout that will clear search query and instead clear the
      // query immediately
      clearTimeout(nativeSearchTimeout.current);
      setNativeSearchQuery("");
      setDefaultPreselectedIndex(undefined);
      keyUsed = true;
    } // If the user hits escape on an open select then close it


    if (open && key === "esc") {
      // Stop propagating the event upwards. This ensures that a parent element
      // (e.g. a modal) won't also handle the escape key.
      event.stopPropagation();
      close({
        retainFocus: true
      });
      keyUsed = true;
    } // If the user hits up, down, or backspace/delete/space (and they're not in
    // the middle of a search) on a collapsed select then open it


    if (!open && !disabled && (key === "up" || key === "down" || (key === "backspace" || key === "delete" || key === "space") && !isNativeSearch)) {
      setOpen(true);
      keyUsed = true;
    } // Disabled tabbing while the select is open


    if (open && key === "tab") {
      keyUsed = true;
    } // Don't perform the normal action associated with the key (e.g. scroll for
    // arrows/space) if the key was used for a select-related action


    if (keyUsed) {
      event.preventDefault();
    }
  };

  var onKeyDownOptionList = function onKeyDownOptionList(event) {
    // Prevent "space" from selecting an option when the user is searching
    if ((0, _keycode["default"])(event) === "space" && isNativeSearching) {
      event.preventDefault();
    }
  };

  var onKeyDownCustomSearchInput = function onKeyDownCustomSearchInput(event) {
    var key = (0, _keycode["default"])(event); // If the user presses an up/down arrow key when focused on an open
    // searchable select's search input, then transfer the focus to the option
    // list and immediately move the preselected index from the current option
    // to the next/previous option. This mimicks what would happen if the option
    // list was focused when the arrow key was pressed.

    if (open && (key === "down" || key === "up") && optionListRef.current) {
      setDefaultPreselectedIndex(optionListRef.current.getNextPreselectedIndex(key === "down" ? 1 : -1));
      optionListRef.current.focus();
      event.preventDefault();
    } // If the user presses enter when focused on an open searchable select's
    // search input, then select the  first item in the option list (which will
    // be the preselected option). This mimicks what would happen if the option
    // list was focused when the enter key was pressed.
    else if (open && key === "enter") {
      var firstOption = (0, _utils.getOptionsFromChildren)(props.children)[0]; // Only select the first option if there's a search query

      if (firstOption && props.searchQuery && !firstOption.disabled) {
        onClickOption(firstOption.value);
      } // Don't submit a form if the user presses enter on an open searchable
      // select


      event.preventDefault();
    }
  };

  var onChangeCustomSearchInput = function onChangeCustomSearchInput(event) {
    var value = event.target.value; // Make sure the select is open if the user is typing in a search query

    if (!open) {
      setOpen(true);
    } // If we have a query, presleect the first option if it isn't already


    if (value && defaultPreselectedIndex !== 0) {
      setDefaultPreselectedIndex(0);
    } // If we don't have a query, clear the preselected option


    if (!value && defaultPreselectedIndex !== -1) {
      setDefaultPreselectedIndex(-1);
    }

    props.onSearch(value);
  };

  var onMouseDownInputBox = function onMouseDownInputBox(event) {
    if (isCustomSearchable) {
      if (!open) {
        // If the user mouses down on a closed searchable select, open it
        setOpen(true);
      }

      if (event.target !== customSearchInputRef.current) {
        // If the user mouses down on the input box of a custom searchable
        // select, focus on the custom search input
        customSearchInputRef.current.focus();
        event.preventDefault();
      }
    } else {
      // If the user mouses down on a non-searchable select, toggle it
      setOpen(!open);
    }
  };
  /**
   * Re-trigger the option list's "componentDidMount" when the option list is
   * actually visible. This is necessary because the things the option list does
   * on mount (like setting the scroll and transferring focus) only work when
   * it's visible, but the PopoverController mounts it in an invisible state (in
   * order to fade it in). This is only done for the popover because the
   * BottomSheet's onOpen even fires before its children are mounted, so this
   * won't work.
   */


  var onOpenPopover = function onOpenPopover() {
    if (optionListRef.current) {
      optionListRef.current.componentDidMount();
    }
  };
  /**
   * Close and retain focus if the user attempts to close the bottom sheet (e.g.
   * by tapping outside of it). This isn't necessary for the popover which
   * doesn't initiate its own close events.
   */


  var onCloseBottomSheet = function onCloseBottomSheet() {
    return close({
      retainFocus: true
    });
  };
  /**
   * Close the select when it loses focus.
   */


  var onBlur = function onBlur(event) {
    close({
      retainFocus: false
    });

    if (props.onBlur) {
      props.onBlur(event);
    }
  };
  /**
   * Clear out the default preselected index when the option list changes its
   * internal state. This allows us to update the default later on and stomp the
   * option list's internal state when we need too. If we didn't reset the
   * default here and just left it at 0 (for example), then setting it to 0
   * again later on would have no effect.
   */


  var onChangePreselectedIndex = function onChangePreselectedIndex(index) {
    if (defaultPreselectedIndex !== undefined) {
      setDefaultPreselectedIndex(undefined);
    }

    setPreselectedIndex(index);
  };

  (0, _react.useEffect)(function () {
    if (props.autoFocus || props.inaccessibleAutoFocus) {
      // NOTE: React guarantees that callback refs will be resolved before
      // componentDidMount is called, so this is safe.
      if (isCustomSearchable) {
        customSearchInputRef.current.focus();
      } else {
        rootRef.current.focus();
      }
    } // NOTE: Only run this once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []); // Cleanup - formerly sat in componentWillUnmount

  (0, _react.useEffect)(function () {
    return function () {
      return clearInterval(clearTimeout(nativeSearchTimeout.current));
    };
  }, []);
  (0, _react.useEffect)(function () {
    var disabled = props.disabled; // Collapse the select if it was disabled while open

    if (disabled && open) {
      close({
        retainFocus: false
      });
    }
  }, [close, open, props.disabled]);

  var _useFocus = (0, _useFocus2["default"])({
    multipleNodes: true,
    onFocus: props.onFocus,
    onBlur: onBlur
  }),
      focusProps = _useFocus.focusProps,
      focus = _useFocus.focus;
  /**
   * When support text has been provided to Select, add an aria-describedby
   * prop to Select for better screen reader experiences
   */


  var ariaDescribedbySupportText = (0, _react.useMemo)(function () {
    return (0, _getSupportTextAriaDescribedby["default"])({
      id: id,
      hasHelperText: !!props.helperText,
      hasConstraintText: !!props.constraintText,
      hasErrorMessage: !!props.errorMessage,
      errorMessageFirst: props.size === "xlarge"
    });
  }, [id, props.helperText, props.constraintText, props.errorMessage, props.size]);

  var ariaProps = _objectSpread(_objectSpread({
    "aria-describedby": ariaDescribedbySupportText,
    "aria-label": props.label
  }, (0, _filterPropsByPrefix["default"])(props, ["aria-"])), {}, {
    role: "combobox",
    "aria-controls": popupId,
    "aria-haspopup": true,
    "aria-expanded": open,
    "aria-disabled": props.disabled,
    "aria-activedescendant": open && optionListRef.current ? "".concat(optionListRef.current.props.id, "-").concat(preselectedIndex) : undefined
  });

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
  return /*#__PURE__*/_react["default"].createElement(_supportTextWrapper["default"], {
    id: id,
    helperText: props.helperText,
    constraintText: props.constraintText,
    errorMessage: props.errorMessage,
    helperBelowFormField: props.size === "xlarge",
    className: styles(t, {
      width: props.width,
      minWidth: props.minWidth
    })
  }, /*#__PURE__*/_react["default"].createElement(_responsive["default"], {
    query: "min-width",
    fallback: "".concat(t("optionListPopoverBreakpoint"), "px"),
    props: {
      optionListContainerType: isCustomSearchable ? {
        "default": "popover"
      } : (0, _defineProperty2["default"])({
        "default": "bottom-sheet"
      }, "".concat(t("optionListPopoverBreakpoint"), "px"), "popover")
    }
  }, function (_ref6) {
    var optionListContainerType = _ref6.optionListContainerType;
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, focusProps, {
      onKeyDown: props.disabled ? undefined : onKeyDown
    }), /*#__PURE__*/_react["default"].createElement(_context["default"].Consumer, null, function (_ref7) {
      var _ref7$suffixIconToken = _ref7.suffixIconTokens,
          suffixIconTokens = _ref7$suffixIconToken === void 0 ? _chevronSelect["default"] : _ref7$suffixIconToken;
      return /*#__PURE__*/_react["default"].createElement(_inputBox["default"], (0, _extends2["default"])({
        label: props.label,
        labelId: "".concat(id, "-label"),
        htmlFor: id,
        empty: !valueLabel,
        focus: focus,
        suffixIconTokens: suffixIconTokens,
        animated: optionListContainerType === "popover",
        labelFloated: isCustomSearchable && open || Boolean(props.placeholder || valueLabel),
        disabled: props.disabled,
        size: props.size,
        prefix: props.prefix,
        suffix: props.suffix,
        error: props.error && !focus,
        cursor: isCustomSearchable && open ? "text" : "pointer",
        onMouseDown: props.disabled ? undefined : onMouseDownInputBox,
        tabIndex: props.disabled || isCustomSearchable ? undefined : "0"
      }, !isCustomSearchable ? ariaProps : {}, {
        ref: assignRefs,
        id: id
      }, passThroughProps, {
        onKeyDown: props.disabled ? undefined : onKeyDown
      }), isCustomSearchable ? /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, isCustomSearchable ? ariaProps : {}, {
        // HACK: Prepend the value id if it exists to aria-labelledby
        // so it's read by screen-readers. This is necessary because
        // the <input> value attribute resets to an empty string
        // after a user has selected a value so they can begin
        // typing a new query with a fresh start.
        "aria-labelledby": "".concat(id, "-value ").concat(ariaProps["aria-labelledby"] || "".concat(id, "-label")),
        "aria-autocomplete": "list",
        "aria-controls": popupId,
        type: "text",
        onKeyDown: onKeyDownCustomSearchInput,
        className: customSearchInputStyles(t, {
          empty: props.searchQuery === undefined || props.searchQuery === "",
          open: open,
          disabled: props.disabled
        }),
        placeholder: props.placeholder,
        value: props.searchQuery || "",
        ref: customSearchInputRef,
        onChange: onChangeCustomSearchInput,
        disabled: props.disabled,
        autoComplete: "off"
      })) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: valueLabelStyles,
        id: "".concat(id, "-value"),
        "mdn-select-value": ""
      }, valueLabel ? valueLabel : props.placeholder));
    }), /*#__PURE__*/_react["default"].createElement(_selectOptionListContainer["default"], {
      type: optionListContainerType,
      open: open,
      popoverAnchorNode: rootRef.current,
      popoverMaxHeight: props.popoverMaxHeight,
      onOpenPopover: onOpenPopover,
      onCloseBottomSheet: onCloseBottomSheet,
      t: t,
      closeLabel: props.closeLabel
    }, /*#__PURE__*/_react["default"].createElement(_selectOptionList["default"], (0, _extends2["default"])({
      open: open,
      autoFocus: !isCustomSearchable,
      value: props.value,
      searchQuery: props.searchQuery,
      defaultPreselectedIndex: defaultPreselectedIndex,
      onChangePreselectedIndex: onChangePreselectedIndex,
      onClickOption: onClickOption,
      onKeyDown: onKeyDownOptionList,
      ref: updateOptionListRef,
      id: popupId // Only recalculate focus if we're native searchable
      ,
      recalculateFocusOnUpdate: !isCustomSearchable
    }, focusProps), props.children)), props.name ? isMultiSelectable ? props.value.map(function (value) {
      return /*#__PURE__*/_react["default"].createElement("input", {
        type: "hidden",
        key: value,
        name: "".concat(props.name, "[]"),
        value: value
      });
    }) : /*#__PURE__*/_react["default"].createElement("input", {
      type: "hidden",
      name: props.name,
      value: props.value || ""
    }) : null);
  }));
});

Select.displayName = "Select";
Select.propTypes =  false ? {
  /**
   * A list of `SelectOption` elements that represent the choices to present to
   * the user.
   *
   * If no `SelectOption` elements are provided then any other elements passed here
   * will be rendered in place of them. This allows you to render things like a
   * loading indicator while waiting for asyncronously loaded options or a
   * message to the user when no options are available. Note that these elements
   * cannot contain anything interactive like links or buttons for accessibility
   * reasons.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Select component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following properties,
   * they'll be ignored:
   *
   * aria-controls | aria-haspopup | aria-expanded | aria-disabled | aria-autocomplete | aria-activedescendant
   *
   * If `constraintText`, `helperText`, and/or an `errorMessage` are provided to
   * the Select these will be used to generate the `aria-describedby` prop.
   * This can be overridden by explicitly setting `aria-describedby` on the Select.
   *
   * @since 5.21.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * An accessible label for the close icon Button that appears in the mobile
   * view of the SelectOptionListContainer.
   *
   * NOTE: The default value for this prop is in English. If you support
   * multiple locales you will need to provide this prop for each locale.
   *
   * @since 5.27.0
   *
   */
  closeLabel: _propTypes["default"].string,

  /**
   * Add constraint text to provide critical information regarding content.
   *
   * @since 5.22.0
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   *
   * @since 5.18.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with an `errorMessage`.
   */
  error: _propTypes["default"].bool,

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the Select.
   *
   * @since 5.22.0
   */
  errorMessage: _propTypes["default"].string,

  /**
   * Add helper text to provide additional instruction.
   *
   * @since 5.22.0
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * If set to true then the select will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since 5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * A label for the input.
   *
   * If this prop is provided the `size` prop will be ignored.
   */
  label: _propTypes["default"].string,

  /**
   * Set the minimum width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   *
   * @since 5.x
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * Text that is shown in place of the select's value when nothing is selected.
   *
   * This text is not visible when an option is selected, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   */
  placeholder: _propTypes["default"].string,

  /**
   * Sets the maximum height of the popover containing the select's options.
   * This is helpful if you have a very long list of options but don't want
   * to show a very tall popover. The option list is scrollable, so any
   * options that overflow the popover will still be accessible.
   */
  popoverMaxHeight: _propTypes["default"].number,

  /**
   * Static text to show in an end-cap prepended to the select.
   */
  prefix: _propTypes["default"].string,

  /**
   * Pass the query obtained via the `onSearch` handler back to this prop to
   * update the query rendered by the Select.
   */
  searchQuery: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   *
   * If the `label` prop is provided this prop will be ignored (the label
   * requires a particular amount of space which is not configurable).
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * Static text to show in an end-cap appended to the input.
   */
  suffix: _propTypes["default"].string,

  /**
   * This is the value of the currently selected option. Provide a number or
   * string value for a single-selectable Select, __or an array__ of numbers or
   * strings __for a multi-selectable Select__. The matching option will
   * automatically be highlighted in the select.
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),

  /**
   * This function generates the label that is shown in the Select's form
   * field to summarize the current value of the Select. This function
   * receives an array containing all of the selected options that are
   * provided as children to the Select component.
   *
   * The default function will return the selected option's label
   * if one selected option is found. If more than one selected option is
   * found it will return "X selected".
   *
   * If you are filtering the options in the Select (e.g. for a searchable
   * Select), you will have to provide your own function here that does not
   * rely on the array of options passed to this function. As stated above
   * that array will only include selected options *that are currently
   * rendered as children*, so it won't include any selected options that have
   * been filtered out of the current view.
   */
  valueLabel: _propTypes["default"].func,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by selecting an option). The new value will be
   * passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This function makes the select "searchable". A searchable select allows
   * the user to type a query into a text input to search through options.
   *
   * This function will be called with the user's latest query, which should
   * be passed back to the `searchQuery` prop. Note that this will not
   * automatically filter the options in the select. That responsibility is
   * still up to the developer.
   */
  onSearch: _propTypes["default"].func
} : {};
Select.defaultProps = {
  closeLabel: "Close",
  onChange: _noop["default"],
  size: "medium",
  valueLabel: function valueLabel(options) {
    return options.length === 1 ? options[0].label : options.length > 0 ? "".concat(options.length, " selected") : "";
  }
};
var _default = Select;
exports["default"] = _default;

/***/ }),
/* 996 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronSelectData: "data:image/svg+xml,%3csvg width='10' height='18' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill-rule='nonzero' stroke='currentColor' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1 13l4 4 4-4M9 5L5 1 1 5'/%3e%3c/g%3e%3c/svg%3e",
  iconChevronSelectWidth: 10,
  iconChevronSelectHeight: 18
};

/***/ }),
/* 997 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    selectIosToolbarHeight: 44,
    selectIosToolbarBackgroundColor: tokens.themeBackgroundAlternateTertiaryFocus,
    selectIosToolbarForegroundColor: tokens.themeForegroundAccentDefault,
    selectIosToolbarBorderWidth: 1,
    selectIosToolbarBorderRadius: 0,
    selectIosToolbarBorderColor: tokens.themeBorderSecondaryDefault,
    selectIosToolbarSpacingHorizontal: 16,
    selectIosPickerMotionDuration: "200ms",
    selectIosPickerMotionFunction: "ease",
    selectOptionListElevation: 70,
    selectOptionListBorderWidth: 1,
    selectOptionListBorderRadius: 4,
    selectOptionListBorderColor: tokens.themeBorderPrimaryDefault,
    selectOptionListShadowOffsetX: 0,
    selectOptionListShadowOffsetY: 2,
    selectOptionListShadowBlur: 4,
    selectOptionListShadowSpread: 0,
    selectOptionListShadowColor: "rgba(11, 12, 12, 0.16)",
    selectOptionListPopoverOffsetVertical: 4,
    selectOptionListPopoverBreakpoint: 721,
    selectOptionListBackgroundColor: tokens.themeBackgroundPrimaryDefault,
    selectOptionListForegroundColor: tokens.themeForegroundPrimaryDefault,
    selectSearchInputForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    selectSearchInputPlaceholderColorDefault: tokens.themeForegroundSecondaryDefault,
    selectSearchInputPlaceholderColorDisabled: tokens.themeForegroundPrimaryDisabled
  }
};

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _utils = __webpack_require__(434);

var _optionList = _interopRequireDefault(__webpack_require__(169));

var _highlightSubstring = _interopRequireDefault(__webpack_require__(285));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SelectOptionList = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SelectOptionList, _React$Component);

  var _super = _createSuper(SelectOptionList);

  function SelectOptionList() {
    var _this;

    (0, _classCallCheck2["default"])(this, SelectOptionList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseDownNonOptionChildren", function (event) {
      event.preventDefault();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderCustomSearchHighlightSubstring", function (option) {
      return function () {
        return /*#__PURE__*/_react["default"].createElement(_highlightSubstring["default"], {
          match: _this.props.searchQuery
        }, option.label);
      };
    });
    return _this;
  }

  (0, _createClass2["default"])(SelectOptionList, [{
    key: "shouldComponentUpdate",
    value:
    /**
     * Only update if the option list will continue to be open. This prevents the
     * list contents from changing while the Select is in the process of closing,
     * which can be jarring to the user.
     */
    function shouldComponentUpdate(nextProps) {
      return nextProps.open;
    }
    /**
     * Disable mouse interaction with any non-option children becase a) it would
     * blur the select and cause it to close and b) we really don't want anyone
     * including interactive elements here because they'll be innaccessible to
     * keyboard users.
     *
     * NOTE: a `pointerEvents: none` style on the non-option children container is
     * not enough to prevent a blur event on the option list, we have to actually
     * prevent the event's default behavior.
     */

  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var optionsAndGroups = (0, _utils.createOptionItemsAndGroups)(props);
      var nonOptionChildren = optionsAndGroups.length > 0 ? [] : (0, _utils.getNonOptionsFromChildren)(props.children);
      return optionsAndGroups.length ? /*#__PURE__*/_react["default"].createElement(_optionList["default"], {
        autoFocus: props.autoFocus || props.inaccessibleAutoFocus,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        onKeyDown: props.onKeyDown,
        defaultPreselectedIndex: props.defaultPreselectedIndex,
        onChangePreselectedIndex: props.onChangePreselectedIndex,
        multiSelectable: Array.isArray(props.value),
        recalculateFocusOnUpdate: props.recalculateFocusOnUpdate,
        id: props.id,
        ref: props.forwardedRef
      }, optionsAndGroups) : nonOptionChildren.length ? /*#__PURE__*/_react["default"].createElement("div", {
        onMouseDown: this.onMouseDownNonOptionChildren
      }, nonOptionChildren) : null;
    }
  }]);
  return SelectOptionList;
}(_react["default"].Component);

SelectOptionList.propTypes =  false ? {
  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  defaultPreselectedIndex: _propTypes["default"].number,
  forwardedRef: _propTypes["default"].func,
  id: _propTypes["default"].string,

  /**
   * If set to true then the input will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,
  open: _propTypes["default"].bool,

  /**
   * Set to true to have the option list continuously recalculate which list item
   * to focus. Helpful when the list might have options move disappear or move.
   */
  recalculateFocusOnUpdate: _propTypes["default"].bool,
  searchQuery: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,
  onChangePreselectedIndex: _propTypes["default"].func,
  onClickOption: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func
} : {};

function forwardRef(props, ref) {
  return /*#__PURE__*/_react["default"].createElement(SelectOptionList, (0, _extends2["default"])({}, props, {
    forwardedRef: ref
  }));
}

forwardRef.displayName = "SelectOptionList";

var _default = /*#__PURE__*/_react["default"].forwardRef(forwardRef);

exports["default"] = _default;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _escapeRegExp = _interopRequireDefault(__webpack_require__(75));

var _emotion = __webpack_require__(11);

var _typography = __webpack_require__(1000);

var maxMatchLength = 100;
var defaultMatchedStyles = (0, _emotion.css)({
  fontWeight: _typography.typographyFontWeightH300
});

var makeSubstringWithMatch = function makeSubstringWithMatch(text, match) {
  return {
    text: text,
    match: match
  };
};
/**
 * Parses string into an ordered array of objects with substrings
 * and if was a match or not.
 * getSubstringWithMatchBool(/abc/g, "abc def abc")
 * [ {text: "abc", match: true},
 *   {text: "def", match: false},
 *   {text: "abc", match: true} ]
 */


var getSubstringsWithMatchBool = function getSubstringsWithMatchBool(regexp, stringInput) {
  var substringsWithMatchBool = [];
  var startBeforeIndex = 0;
  var match;
  var string = typeof stringInput !== "string" ? stringInput.toString() : stringInput;

  do {
    match = regexp.exec(string);

    if (match) {
      var length = match[0].length;
      var matchText = string.substr(match.index, length);
      var beforeText = string.substr(startBeforeIndex, match.index - startBeforeIndex);

      if (beforeText) {
        substringsWithMatchBool.push(makeSubstringWithMatch(beforeText, false));
      }

      substringsWithMatchBool.push(makeSubstringWithMatch(matchText, true));
      startBeforeIndex = match.index + length;
    } // Keep looking for matches if we previously found a match
    // and our regular expression is global (i.e. get all matches)

  } while (match && regexp.global); // If there's still some text leftover at the end, gobble it up


  if (startBeforeIndex < string.length) {
    var restText = string.substr(startBeforeIndex);
    substringsWithMatchBool.push(makeSubstringWithMatch(restText, false));
  }

  return substringsWithMatchBool;
};

var HighlightSubstring = function HighlightSubstring(_ref) {
  var children = _ref.children,
      match = _ref.match,
      className = _ref.className;
  var string = Array.isArray(children) ? children.join("") : children;
  var regexp = match instanceof RegExp ? match : new RegExp((0, _escapeRegExp["default"])(match.substr(0, maxMatchLength)), "i");
  var substrings = getSubstringsWithMatchBool(regexp, string);
  return /*#__PURE__*/_react["default"].createElement("span", null, substrings.map(function (_ref2, index) {
    var text = _ref2.text,
        match = _ref2.match;
    return !match ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: index
    }, text) : /*#__PURE__*/_react["default"].createElement("span", {
      key: index,
      className: className
    }, text);
  }));
};

HighlightSubstring.propTypes =  false ? {
  /**
   * The string(s) to highlight.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]).isRequired,

  /**
   * A string or regular expression used to identify which substring(s) should
   * be highlighted.
   *
   * If a string is provided, the first substring that matches the string
   * exactly will be highlighted.
   *
   * If a regular expression is provided, any substring matching the regular
   * expression will be highlighted (use a greedy regular expression to
   * highlight all matches).
   */
  match: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(RegExp)]).isRequired,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string
} : {};
HighlightSubstring.defaultProps = {
  className: defaultMatchedStyles
};
var _default = HighlightSubstring;
exports["default"] = _default;

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports = {
  typographyFontSizeD300: 76,
  typographyFontSizeD200: 54,
  typographyFontSizeD100: 48,
  typographyFontSizeD50: 36,
  typographyFontSizeH600: 36,
  typographyFontSizeH500: 28,
  typographyFontSizeH400: 24,
  typographyFontSizeH300: 20,
  typographyFontSizeH200: 18,
  typographyFontSizeH100: 16,
  typographyFontSizeB500: 20,
  typographyFontSizeB400: 18,
  typographyFontSizeB300: 16,
  typographyFontSizeB200: 14,
  typographyFontSizeB100: 12,
  typographyFontWeightD300: 200,
  typographyFontWeightD200: 200,
  typographyFontWeightD100: 200,
  typographyFontWeightD50: 200,
  typographyFontWeightH600: 600,
  typographyFontWeightH500: 600,
  typographyFontWeightH400: 600,
  typographyFontWeightH300: 600,
  typographyFontWeightH200: 600,
  typographyFontWeightH100: 600,
  typographyFontWeightB500: 400,
  typographyFontWeightB400: 400,
  typographyFontWeightB300: 400,
  typographyFontWeightB200: 400,
  typographyFontWeightB100: 400,
  typographyLineHeightD300: "96px",
  typographyLineHeightD200: "64px",
  typographyLineHeightD100: "60px",
  typographyLineHeightD50: "48px",
  typographyLineHeightH600: "48px",
  typographyLineHeightH500: "36px",
  typographyLineHeightH400: "32px",
  typographyLineHeightH300: "24px",
  typographyLineHeightH200: "24px",
  typographyLineHeightH100: "20px",
  typographyLineHeightB500: "28px",
  typographyLineHeightB400: "28px",
  typographyLineHeightB300: "24px",
  typographyLineHeightB200: "20px",
  typographyLineHeightB100: "16px"
};

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _scrim = _interopRequireDefault(__webpack_require__(275));

var _closeMedium = _interopRequireDefault(__webpack_require__(398));

var _popoverController = _interopRequireDefault(__webpack_require__(99));

var _token = __webpack_require__(20);

var _text = _interopRequireDefault(__webpack_require__(47));

var _sheet = _interopRequireDefault(__webpack_require__(1002));

var _button = _interopRequireDefault(__webpack_require__(8));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _context = _interopRequireDefault(__webpack_require__(437));

var _theme = __webpack_require__(24);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SheetContextProvider = _context["default"].Provider;
var popoverStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var anchorWidth = _ref.anchorWidth;
  return (0, _emotion.css)((0, _text["default"])(t), {
    boxSizing: "border-box",
    minWidth: anchorWidth,
    overflowY: "auto",
    outline: "none",
    backgroundColor: t("optionListBackgroundColor"),
    borderRadius: t("optionListBorderRadius"),
    border: t.borderCss("optionListBorder"),
    boxShadow: t.boxShadowCss("optionListShadow"),
    zIndex: t("optionListElevation")
  });
}, ["anchorWidth"]); // NOTE: We reverse the column of the select options and the close icon Button
// for the mobile sheet. This allows the list options to be read before
// the close button is read, while keeping the position of the close icon Button
// top aligned with using an explicit position.

var sheetStyles = (0, _emotion.css)({
  display: "flex",
  flexDirection: "column-reverse",
  // Close icon button styles
  "& > *:nth-child(2)": {
    display: "flex",
    justifyContent: "end"
  }
});

var SelectOptionListContainer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SelectOptionListContainer, _React$Component);

  var _super = _createSuper(SelectOptionListContainer);

  function SelectOptionListContainer() {
    var _this;

    (0, _classCallCheck2["default"])(this, SelectOptionListContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderPopover", function () {
      return /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
        open: _this.props.open,
        anchorNode: _this.props.popoverAnchorNode,
        anchorOrigin: "bottom left",
        popoverOrigin: "top left",
        offsetVertical: _this.props.t("optionListPopoverOffsetVertical"),
        maxHeight: _this.props.popoverMaxHeight,
        shrinkToFit: true,
        onOpen: _this.props.onOpenPopover
      }, function (_ref2) {
        var popoverStyle = _ref2.popoverStyle,
            anchorRect = _ref2.anchorRect;
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: _this.props.id,
          className: "\n            ".concat(popoverStyles(_this.props.t, {
            anchorWidth: anchorRect.width
          }), "\n            ").concat(popoverStyle)
        }, _this.props.children);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderBottomSheet", function () {
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _scrim["default"],
        map: (0, _token.getTokenHelper)("scrim")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(SheetContextProvider, {
          value: {
            zIndex: t("elevation") + 2,
            // Turn off Sheet's onAfterClose which attempts to refocus to the
            // last active element before it was open which, in some cases, might
            // be other inputs.
            onAfterClose: function onAfterClose() {}
          }
        }, /*#__PURE__*/_react["default"].createElement(_sheet["default"], {
          id: _this.props.id,
          onClose: _this.props.onCloseBottomSheet,
          open: _this.props.open,
          type: "overlay",
          side: "bottom"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: sheetStyles
        }, _this.props.children, _this.props.closeLabel && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_button["default"], {
          label: _this.props.closeLabel,
          type: "icon",
          onClick: _this.props.onCloseBottomSheet
        }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
          tokens: _closeMedium["default"]
        }))))));
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(SelectOptionListContainer, [{
    key: "render",
    value: function render() {
      return this.props.type === "popover" ? this.renderPopover() : this.renderBottomSheet();
    }
  }]);
  return SelectOptionListContainer;
}(_react["default"].Component);

SelectOptionListContainer.propTypes =  false ? {
  children: _propTypes["default"].node,
  closeLabel: _propTypes["default"].string,
  id: _propTypes["default"].string,
  open: _propTypes["default"].bool,
  popoverAnchorNode: _propTypes["default"].object,
  popoverMaxHeight: _propTypes["default"].number,
  t: _propTypes["default"].func,
  type: _propTypes["default"].oneOf(["popover", "bottom-sheet"]),

  /**
   * NOTE: This is only available for the bottom sheet because the popover
   * does not trigger any close events on its own.
   */
  onCloseBottomSheet: _propTypes["default"].func,

  /**
   * NOTE: This is only available for the popover because the bottom sheet's
   * onOpen prop is executed before the bottom sheet is actually rendered to
   * the DOM.
   */
  onOpenPopover: _propTypes["default"].func
} : {};
var _default = SelectOptionListContainer;
exports["default"] = _default;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _sheet = _interopRequireDefault(__webpack_require__(1003));

var _default = _sheet["default"];
exports["default"] = _default;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _keycode = _interopRequireDefault(__webpack_require__(72));

var _emotion = __webpack_require__(11);

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _sheet = _interopRequireDefault(__webpack_require__(1004));

var _modal = _interopRequireDefault(__webpack_require__(407));

var _scrim = _interopRequireDefault(__webpack_require__(275));

var _context = _interopRequireDefault(__webpack_require__(437));

var _theme = __webpack_require__(24);

var _expanderController = _interopRequireDefault(__webpack_require__(438));

var _scrim2 = _interopRequireDefault(__webpack_require__(411));

var _portal = _interopRequireDefault(__webpack_require__(207));

var _focusTrap = _interopRequireDefault(__webpack_require__(170));

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _focus = __webpack_require__(193);

var _token = __webpack_require__(20);

var _parsers = __webpack_require__(128);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

var _rtl = __webpack_require__(80);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var borderSides = {
  left: "borderRight",
  right: "borderLeft",
  bottom: "borderTop"
};
var containerStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _css;

  var side = _ref.side,
      spacingInset = _ref.spacingInset,
      backgroundColor = _ref.backgroundColor;
  return (0, _emotion.css)((_css = {}, (0, _defineProperty2["default"])(_css, borderSides[side], t.borderCss("border")), (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", (0, _defineProperty2["default"])({}, (0, _rtl.getRtl)(borderSides[side]), t.borderCss("border"))), (0, _defineProperty2["default"])(_css, "& > div", {
    backgroundColor: backgroundColor,
    padding: "".concat((0, _parsers.parseSpacing)(spacingInset), "px"),
    outline: "none",
    overflowY: "auto",
    boxSizing: "border-box",
    maxHeight: side === "bottom" ? "calc(100vh - ".concat(t("minimumPageReveal"), "px)") : undefined
  }), _css));
}, ["side", "spacingInset", "backgroundColor"]);

var mediaQuery = function mediaQuery(floatingBreakpoint) {
  return "@media (max-width: ".concat(floatingBreakpoint, "px)");
};

var modalStyles = function modalStyles(tScrim, tModal, t, _ref2) {
  var _css2, _dirRtl2, _ref3;

  var side = _ref2.side,
      zIndex = _ref2.zIndex;
  return (0, _emotion.css)((_css2 = {
    zIndex: zIndex || tScrim("elevation")
  }, (0, _defineProperty2["default"])(_css2, mediaQuery(tModal.tokens.modalFloatingBreakpoint), {
    zIndex: zIndex || tScrim("elevation") - 1
  }), (0, _defineProperty2["default"])(_css2, "position", "fixed"), (0, _defineProperty2["default"])(_css2, "boxShadow", "".concat(t("shadowOffset", [side, "x"]), "px ").concat(t("shadowOffset", [side, "y"]), "px ").concat(t("shadow", "blur"), "px ").concat(t("shadow", "spread"), "px ").concat(t("shadow", "color"), "}")), _css2), side === "bottom" ? {
    bottom: 0,
    left: 0,
    right: 0
  } : (_ref3 = {
    top: 0,
    bottom: 0
  }, (0, _defineProperty2["default"])(_ref3, side, 0), (0, _defineProperty2["default"])(_ref3, "[dir=\"rtl\"] &", (_dirRtl2 = {}, (0, _defineProperty2["default"])(_dirRtl2, side, "auto"), (0, _defineProperty2["default"])(_dirRtl2, (0, _rtl.getRtl)(side), 0), _dirRtl2)), _ref3));
};

var overlayScrimStyles = function overlayScrimStyles(_ref4) {
  var tScrim = _ref4.tScrim,
      tModal = _ref4.tModal,
      zIndex = _ref4.zIndex;
  return (0, _emotion.css)((0, _defineProperty2["default"])({
    zIndex: zIndex ? zIndex - 1 : tScrim("elevation") - 1
  }, mediaQuery(tModal.tokens.modalFloatingBreakpoint), {
    zIndex: zIndex ? zIndex - 1 : tScrim("elevation") - 2
  }));
}; // Overlay expanders are put into a portal


var OverlayExpanderController = function OverlayExpanderController(props) {
  return /*#__PURE__*/_react["default"].createElement(_portal["default"], null, /*#__PURE__*/_react["default"].createElement(_expanderController["default"], props));
};
/**
 * This component renders a sheet that enters/exits on a particular side of
 * the screen. The sheet can appear as a overlay above other components or
 * displace surrounding components.
 *
 * @since 5.x
 */


var Sheet = function Sheet(props) {
  var open = props.open,
      side = props.side,
      onClose = props.onClose,
      spacingInset = props.spacingInset,
      onOpen = props.onOpen; // Always render children if closed size is set greater than 0 or
  // we're explicitly told via props

  var alwaysRenderChildren = props.closedSize !== undefined && props.closedSize > 0 || props.alwaysRenderChildren; // If we're always visible, force type to be push

  var type = alwaysRenderChildren ? "push" : props.type;
  var t = (0, _theme.useTheme)(_sheet["default"], "sheet"); // HACK: using modal floatingBreakpoint tokens - but we should really add this to the Sheet tokens and update this.

  var tModal = (0, _theme.useTheme)(_modal["default"], "modal");
  var tScrim = (0, _theme.useTheme)(_scrim["default"], "scrim");
  var hasMounted = (0, _react.useRef)(false);
  var contentRef = (0, _react.useRef)(); // DOM node wrapping sheet content

  var anchorRef = (0, _react.useRef)(); // DOM element that originally opened sheet

  var _useContext = (0, _react.useContext)(_context["default"]),
      zIndex = _useContext.zIndex,
      contextOnAfterClose = _useContext.onAfterClose; // An override z-index and custom onAfterClose method


  var initializeContentRef = (0, _react.useCallback)(function (contentProps) {
    return function (element) {
      contentRef.current = element;
      contentProps.ref(element);
    };
  }, []);
  var backgroundColor = (0, _react.useMemo)(function () {
    return (0, _token.getToken)(t.tokens, "themeBackground", [props.backgroundColor, "default"]) || props.backgroundColor;
  }, [t, props.backgroundColor]); // Put "overlay" sheets, which are essentially modals, in an expander that has built
  // in portal and focus trap.

  var Expander = (0, _react.useCallback)(function (props) {
    return /*#__PURE__*/_react["default"].createElement(type === "overlay" ? OverlayExpanderController : _expanderController["default"], props);
  }, [type]); // Put "overlay" sheets, which are essentially modals, in a focus trap

  var SheetWrapper = (0, _react.useCallback)(function (props) {
    return /*#__PURE__*/_react["default"].createElement(type === "overlay" ? _focusTrap["default"] : _react["default"].Fragment, props);
  }, [type]); // Overlay sheets are essentially modals. Here we add an keyboard listener
  // that closes the sheet when the user presses the "esc" key.
  // https://www.w3.org/TR/wai-aria-practices-1.1/#dialog_modal

  (0, _react.useEffect)(function () {
    if (type === "overlay" && onClose) {
      var onKeyDown = function onKeyDown(e) {
        if ((0, _keycode["default"])(e) === "esc") onClose();
      };

      window.addEventListener("keydown", onKeyDown);
      return function () {
        return window.removeEventListener("keydown", onKeyDown);
      };
    }
  }, [type, onClose]); // On open, move focus to the first focusable element. On close, move focus
  // back to the original element that opened the sheet.

  var onAfterOpen = (0, _react.useCallback)(function () {
    // Run this effect only after the component has mounted. Else, sheet
    // that load as `open` will immediately take over the active element.
    if (hasMounted.current && contentRef.current) {
      var firstFocusableNode = (0, _focus.getKeyboardFocusNodes)(contentRef.current)[0];
      if (firstFocusableNode) firstFocusableNode.focus();else contentRef.current.focus();
    }
  }, []); // On close, return focus to where it was before the bottom sheet was opened.

  var onAfterClose = function onAfterClose() {
    if (contextOnAfterClose) contextOnAfterClose();else if (anchorRef.current) anchorRef.current.focus();
  }; // When opening, record which element opened the sheet


  (0, _react.useEffect)(function () {
    if (open) anchorRef.current = document.activeElement;
    hasMounted.current = true;
  }, [open]);
  (0, _react.useEffect)(function () {
    if (open && onOpen) onOpen();
  }, [open, onOpen]);

  var _useFocus = (0, _useFocus2["default"])({
    multipleNodes: true,
    onFocus: props.onFocus,
    onBlur: props.onBlur
  }),
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
  return /*#__PURE__*/_react["default"].createElement(Expander, {
    open: open,
    direction: side === "bottom" ? "down" : side,
    motionDuration: props.motionDuration || parseInt(t("motionTiming")),
    motionFunction: props.motionFunction || t("motionFunction"),
    onAfterOpen: onAfterOpen,
    onAfterClose: onAfterClose,
    alwaysRenderChildren: alwaysRenderChildren,
    closedSize: props.closedSize
  }, function (_ref5) {
    var state = _ref5.state,
        containerProps = _ref5.containerProps,
        contentProps = _ref5.contentProps;
    // The children of a sheet might be interested in the state of the expander
    // to dynamically hide/show components for various stages. For example, skinny
    // SideMenu shows different links based on the expander state.
    var children = typeof props.children === "function" ? props.children({
      expanderState: state
    }) : props.children;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(SheetWrapper, null, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, containerProps, {
      className: (0, _emotion.cx)(props.className, containerStyles(t, {
        side: side,
        spacingInset: spacingInset,
        backgroundColor: backgroundColor
      }), type === "overlay" ? modalStyles(tScrim, tModal, t, {
        side: side,
        zIndex: zIndex
      }) : undefined, containerProps.className)
    }), /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, focusProps, {
      className: contentProps.className,
      id: props.id,
      ref: initializeContentRef(contentProps),
      role: type === "overlay" ? "dialog" : undefined,
      "aria-modal": type === "overlay" ? true : undefined,
      tabIndex: "-1",
      "aria-labelledby": props.labelledById,
      "aria-describedby": props.describedById,
      onKeyDown: props.onKeyDown
    }), children))), type === "overlay" ? /*#__PURE__*/_react["default"].createElement(_scrim2["default"], {
      className: overlayScrimStyles({
        tScrim: tScrim,
        tModal: tModal,
        zIndex: zIndex
      }),
      onClick: props.onClose,
      open: state === "entering" || state === "entered",
      duration: t("motionTiming")
    }) : null);
  });
};

Sheet.displayName = "Sheet";
Sheet.propTypes =  false ? {
  /**
   * Set this to true if children should be rendered even when the sheet
   * is closed. This can be helpful when, for example, you want the sheet
   * to retain vertical or horizontal layout space (for a horizontal or
   * vertical sheet, respectively) even after it's collapsed.
   */
  alwaysRenderChildren: _propTypes["default"].bool,

  /**
   * The sheet's background color. Any CSS color value is acceptable.
   *
   * Note that accessibility should be carefully considered when selecting a
   * background color. A [minimum contrast ratio of 4.5:1](https://www.w3.org/WAI/WCAG21/Understanding/contrast-minimum.html) between text and
   * background must be maintained. For large text a contrast ratio of 3:1 is acceptable.
   * You can use [a contrast checker](https://webaim.org/resources/contrastchecker/) to verify that your chosen background color
   * maintains an appropriate level of contrast. You can [read more here](https://meridian.a2z.com/guides/accessibility/?platform=react-web) about accessibility in Meridian.
   */
  backgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["primary", "secondary", "alternatePrimary", "alternateSecondary"]), _propTypes["default"].string]),

  /**
   * The contents of the sheet. When a sheet is opened (and alwaysRenderChildren and closedSize
   * are _not_ set), the first focusable element will gain focus. Ideally this element should be
   * a close button so users can quickly toggle the sheet off.
   *
   * Children can also be a function that receives as its only argument an object with a key
   * `expanderState`. Expander state describes the phase of sheet's animation: "entering"/"entered"
   * when `open` is set to `true`, and "exiting"/"exited" when `open` is set to `false`. This
   * can be useful to conditionally show different components in the sheet based on the sheet's
   * animation phase.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * Causes the sheet to close to a fixed pixel height/width value.
   *
   * Forces `alwaysRenderChildren` to be `true` and type to be `push`.
   */
  closedSize: _propTypes["default"].number,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * Sets the `aria-describedby` attribute on the dialog element. Use this prop to
   * give screen readers an accessible description of the contents of the sheet which
   * will be read on open.
   *
   * See the documentation for the [aria-describedby attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-describedby_attribute).
   */
  describedById: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component's outer DOM element.
   *
   * Use this for testing, for accessibility, or to target custom elements
   * inside the component. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * Sets the `aria-labelledby` attribute on the dialog element. Use this prop to
   * give screen readers an accessible title/label for the contents of the sheet which
   * will be read on open.
   *
   * See the documentation for the [aria-describedby attribute](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-describedby_attribute).
   */
  labelledById: _propTypes["default"].string,

  /**
   * The duration it should take to animate in milliseconds.
   */
  motionDuration: _propTypes["default"].number,

  /**
   * The animation function to use when animating. Learn more about [animation functions](https://developer.mozilla.org/en-US/docs/Web/CSS/animation-timing-function).
   */
  motionFunction: _propTypes["default"].string,

  /**
   * The state of the sheet. If true the sheet will be open, otherwise it will be closed.
   */
  open: _propTypes["default"].bool,

  /**
   * The side of the screen the sheet will appear. For type `overlay`, the sheet
   * is automatically fixed to the chosen side. For type `push`, however, setting
   * side _only_ affects how the sheet animates. Composing a `push` Sheet inside
   * the app's layout is the responsibility of the developer.
   */
  side: _propTypes["default"].oneOf(["left", "right", "bottom"]),

  /**
   * Apply padding around the contents of the sheet using a preset.
   */
  spacingInset: _propTypes["default"].oneOf(["none", "small", "medium", "300", "400"]),

  /**
   * sheets come in two flavors, push and overlay. Push displaces other elements on the
   * screen when it enters/exits. Overlay, on the other hand, enters/exits on top of the
   * application accompanied by a scrim (semi-transparent  overlay that covers the application
   * behind the sheet)
   */
  type: _propTypes["default"].oneOf(["push", "overlay"]),

  /**
   * This is called when the sheet loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * Required for type overlay. Called when a user presses the scrim (semi-transparent
   * overlay that covers the application behind the sheet) or hits the "escape" key.
   */
  onClose: _propTypes["default"].func,

  /**
   * This is called when the sheet gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func,

  /**
   * Called when the sheet is opened or when it is mounted open.
   */
  onOpen: _propTypes["default"].func
} : {};
Sheet.defaultProps = {
  type: "push",
  open: false,
  side: "right",
  spacingInset: "medium",
  backgroundColor: "alternatePrimary"
};
var _default = Sheet;
exports["default"] = _default;

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    sheetMinimumPageReveal: 40,
    sheetMotionTiming: "200ms",
    sheetMotionFunction: "ease",
    sheetBorderWidth: 1,
    sheetBorderRadius: 0,
    sheetBorderColor: tokens.themeBorderSecondaryDefault,
    sheetShadowColor: "rgba(11, 12, 12, 0.1)",
    sheetShadowBlur: 16,
    sheetShadowSpread: 0,
    sheetShadowOffsetBottomX: 0,
    sheetShadowOffsetBottomY: -8,
    sheetShadowOffsetLeftX: 8,
    sheetShadowOffsetLeftY: 0,
    sheetShadowOffsetRightX: -8,
    sheetShadowOffsetRightY: 0
  }
};

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(202));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _transitionController = _interopRequireDefault(__webpack_require__(274));

var _waitAnimationFrame = _interopRequireDefault(__webpack_require__(208));

var _functional = __webpack_require__(38);

var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getSizeProperty = function getSizeProperty(direction) {
  return {
    left: "width",
    right: "width",
    up: "height",
    down: "height"
  }[direction];
}; // The container element sets the width or height of the expander and handles
// the expanding and collapsing motion.


var containerStyles = (0, _functional.memoizeByKeys)(function (_ref) {
  var _css;

  var state = _ref.state,
      direction = _ref.direction,
      size = _ref.size,
      motionDuration = _ref.motionDuration,
      motionFunction = _ref.motionFunction,
      closedSize = _ref.closedSize;
  return (0, _emotion.css)({
    left: {
      // Horizontal expanders are inline-flex to ensure they shrink to fit
      // their children's width (vertical expanders shrink to fit by default
      // 'cause that's how CSS layout works).
      display: "inline-flex",
      // The up/left expanders use row/column-reverse so that content is fixed
      // to the bottom/right edges instead of top/left (the default).
      // NOTE: justifyContent: "flex-end" would work here instead *except* for
      // a bug in IE11: https://stackoverflow.com/questions/32885534/how-to-make-flex-end-work-in-ie11
      flexDirection: "row-reverse"
    },
    right: {
      display: "inline-flex",
      flexDirection: "row"
    },
    up: {
      display: "flex",
      flexDirection: "column-reverse"
    },
    down: {
      display: "flex",
      flexDirection: "column"
    }
  }[direction], (_css = {
    // Don't let a flex parent squish the expander
    flexShrink: 0
  }, (0, _defineProperty2["default"])(_css, getSizeProperty(direction), state === "entering" || state === "entered" ? size : closedSize), (0, _defineProperty2["default"])(_css, "overflow", "hidden"), (0, _defineProperty2["default"])(_css, "transition", motionDuration && motionFunction ? "".concat(getSizeProperty(direction), " ").concat(motionDuration, "ms ").concat(motionFunction) : undefined), (0, _defineProperty2["default"])(_css, "visibility", state === "exited" && closedSize === 0 ? "hidden" : undefined), (0, _defineProperty2["default"])(_css, "maxWidth", state === "exited" && (direction === "left" || direction === "right") ? closedSize : undefined), _css));
}, ["state", "direction", "size", "motionDuration", "motionFunction", "closedSize"]); // The content element automatically holds its dimensions, even when the
// container is collapsed, so that the container knows what size to animate to.

var contentStyles = (0, _functional.memoize)(function (direction) {
  var _css2;

  return (0, _emotion.css)((_css2 = {}, (0, _defineProperty2["default"])(_css2, getSizeProperty(direction), "max-content"), (0, _defineProperty2["default"])(_css2, "flexShrink", 0), (0, _defineProperty2["default"])(_css2, "transform", "translateZ(0)"), _css2));
});
/* eslint-disable react/prop-types */

/**
 * This component makes it easy to animate the size of a content block from 0 to
 * "auto" and back. It handles some nice things like expanding in various
 * directions, keeping children out of the tab order when collapsed, setting an
 * aria-hidden attribute when collapsed, and correctly handling situations when
 * the dimensions of the expander contents change on the fly.
 *
 * This component doesn't render anything to the DOM itself, but it needs at
 * least two nested elements to work. To make this happen it requires that you
 * pass in children as a function. It will call that function, passing it an
 * object containing two more objects keyed under "containerProps" and
 * "contentProps". These objects should be passed through as props to two nested
 * elements by your children function (with the container element as the root of
 * the expander and the content element as the only child of the container).
 * This allows you to take advantage of the expander functionality while
 * maintaining maximum control over the DOM. Example:
 *
 * ```
 * <ExpanderController>
 *   {({ containerProps, contentProps }) => (
 *     <div {...containerProps}>
 *       <div {...contentProps}>
 *         My expandable content here...
 *       <div>
 *     </div>
 *   )}
 * </ExpanderController>
 * ```
 *
 * NOTE: Horizontal ExpanderControllers are inline elements, so extra attention
 * may be needed to avoid unwanted whitespace around them. A couple tricks for
 * removing whitespace include setting `font-size: 0` or `display: flex` on an
 * inline element's parent.
 */

var ExpanderControllerClass = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ExpanderControllerClass, _React$Component);

  var _super = _createSuper(ExpanderControllerClass);

  function ExpanderControllerClass() {
    var _this;

    (0, _classCallCheck2["default"])(this, ExpanderControllerClass);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      size: undefined,
      render: _this.props.open || _this.props.alwaysRenderChildren
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateContentRef", function (node) {
      return _this.contentRef = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "cancelFixSize", function () {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "fixSize", function (done) {
      return _this.setState({
        size: _this.contentRef && _this.contentRef.getBoundingClientRect()[getSizeProperty(_this.props.direction)]
      }, done);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeOpen", function (done) {
      if (!_this.state.render) {
        // If the children aren't rendered yet, do so and then give them a chance
        // to settle before poking through the DOM
        _this.setState({
          render: true
        }, function () {
          _this.cancelFixSize = (0, _waitAnimationFrame["default"])(function () {
            return _this.fixSize(done);
          });
        });
      } else {
        _this.fixSize(done);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterOpen", function () {
      _this.setState({
        size: undefined
      });

      if (_this.props.onAfterOpen) _this.props.onAfterOpen();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeClose", function (done) {
      _this.cancelFixSize();

      _this.fixSize(done);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAfterClose", function () {
      if (!_this.props.alwaysRenderChildren) {
        _this.setState({
          render: false
        });
      }

      if (_this.props.onAfterClose) _this.props.onAfterClose();
    });
    return _this;
  }

  (0, _createClass2["default"])(ExpanderControllerClass, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelFixSize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var _this$state = this.state,
          size = _this$state.size,
          render = _this$state.render;
      return /*#__PURE__*/_react["default"].createElement(_transitionController["default"], {
        "in": props.open,
        duration: props.motionDuration && props.motionFunction ? props.motionDuration : 0,
        onBeforeEnter: this.onBeforeOpen,
        onAfterEnter: this.onAfterOpen,
        onBeforeExit: this.onBeforeClose,
        onAfterExit: this.onAfterClose
      }, function (state) {
        return render ? children({
          state: state,
          containerProps: {
            className: containerStyles(_objectSpread(_objectSpread({}, props), {}, {
              state: state,
              size: size
            })),
            "aria-hidden": !props.closedSize && !props.open
          },
          contentProps: {
            className: contentStyles(props.direction),
            ref: _this2.updateContentRef
          }
        }) : null;
      });
    }
  }]);
  return ExpanderControllerClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */
// Keep refs from being passed. We're doing this for 4.x - the
// most recent breaking change - so that we can change the
// _actual_ component to functional later without waiting
// for the next breaking change


var ExpanderController = function ExpanderController(props) {
  return /*#__PURE__*/_react["default"].createElement(ExpanderControllerClass, props);
};

ExpanderController.propTypes =  false ? {
  children: _propTypes["default"].func.isRequired,
  direction: _propTypes["default"].oneOf(["up", "down", "left", "right"]).isRequired,
  open: _propTypes["default"].bool.isRequired,

  /**
   * Set this to true if children should be rendered even when the expander
   * is closed. This can be helpful when, for example, you want the expander
   * to retain vertical or horizontal layout space (for a horizontal or
   * vertical expander, respectively) even after it's collapsed.
   */
  alwaysRenderChildren: _propTypes["default"].bool,

  /**
   * The value the expander should close to. Setting the value to > 0 will
   * keep the expander visible even when closed.
   */
  closedSize: _propTypes["default"].number,
  motionDuration: _propTypes["default"].number,
  motionFunction: _propTypes["default"].string,
  onAfterClose: _propTypes["default"].func,
  onAfterOpen: _propTypes["default"].func
} : {};
ExpanderController.defaultProps = {
  closedSize: 0
};
var _default = ExpanderController;
exports["default"] = _default;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = __webpack_require__(0);

var _default = /*#__PURE__*/(0, _react.createContext)({});

exports["default"] = _default;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _loader = _interopRequireDefault(__webpack_require__(1008));

var _linear = _interopRequireDefault(__webpack_require__(1009));

var _circular = _interopRequireDefault(__webpack_require__(1010));

var _theme = __webpack_require__(24);

var _token = __webpack_require__(20);

var _text = _interopRequireDefault(__webpack_require__(47));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var wrapperStyles = function wrapperStyles(t, _ref) {
  var type = _ref.type,
      size = _ref.size;
  return (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: type === "linear" ? type : size,
    lineHeight: type === "linear" ? type : size,
    fontWeight: "body"
  }));
};

var Loader = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Loader, _React$PureComponent);

  var _super = _createSuper(Loader);

  function Loader() {
    (0, _classCallCheck2["default"])(this, Loader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Loader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          type = _this$props.type,
          showPercentageText = _this$props.showPercentageText,
          label = _this$props.label;
      var percentage = this.props.percentage;
      percentage = percentage > 100 ? 100 : percentage < 0 ? 0 : percentage;
      var determinate = percentage !== undefined;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, ["data-"]);
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _loader["default"],
        map: (0, _token.getTokenHelper)("loader")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, {
          className: wrapperStyles(t, {
            size: size,
            type: type
          })
        }), type === "linear" ? /*#__PURE__*/_react["default"].createElement(_linear["default"], {
          label: label,
          percentage: percentage,
          showPercentageText: showPercentageText,
          size: size,
          determinate: determinate,
          t: t
        }) : /*#__PURE__*/_react["default"].createElement(_circular["default"], {
          label: label,
          percentage: percentage,
          showPercentageText: showPercentageText,
          size: size,
          determinate: determinate,
          t: t
        }));
      });
    }
  }]);
  return Loader;
}(_react["default"].PureComponent);

(0, _defineProperty2["default"])(Loader, "defaultProps", {
  size: "large",
  type: "circular",
  showPercentageText: true
});
Loader.propTypes =  false ? {
  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * An accessible label. This is not shown in the UI, but will be read by
   * screen-readers.
   *
   * @since 5.x
   */
  label: _propTypes["default"].string,

  /**
   * Set this to a number between `0` and `100` (inclusive) to show the loader
   * at a particular stage of completion.
   *
   * If this prop is not set the loader will indicate an "indefinite" loading
   * state using a cyclical animation.
   */
  percentage: _propTypes["default"].number,

  /**
   * This determines whether the value of the `percentage` prop is shown in
   * text-form in the UI.
   */
  showPercentageText: _propTypes["default"].bool,

  /**
   * Sets the size of the component using a preset.
   *
   * The `"medium"` sizes is only available if `type` is set to `"circular"`.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large"]),

  /**
   * Determines the shape of the loader.
   */
  type: _propTypes["default"].oneOf(["circular", "linear"])
} : {};
var _default = Loader;
exports["default"] = _default;

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    loaderIndicatorBackgroundColor: tokens.themeBorderAccentDefault,
    loaderIndicatorMotionIndeterminateDuration: "700ms",
    loaderIndicatorMotionIndeterminateFunction: "linear",
    loaderIndicatorMotionDeterminateDuration: "150ms",
    loaderIndicatorMotionDeterminateFunction: "linear",
    loaderTrackBackgroundColor: tokens.themeBackgroundTertiaryDefault,
    loaderTrackLinearLargeHeight: 8,
    loaderTrackLinearSmallHeight: 4,
    loaderTrackCircularLargeSize: 64,
    loaderTrackCircularLargeStrokeWidth: 4,
    loaderTrackCircularMediumSize: 32,
    loaderTrackCircularMediumStrokeWidth: 4,
    loaderTrackCircularSmallSize: 16,
    loaderTrackCircularSmallStrokeWidth: 2,
    loaderPercentageSpacing: 8,
    loaderBorderRadius: 999,
    loaderFontSizeLinear: 14,
    loaderFontSizeSmall: 12,
    loaderFontSizeMedium: 12,
    loaderFontSizeLarge: 14,
    loaderLineHeightLinear: "20px",
    loaderLineHeightSmall: "16px",
    loaderLineHeightMedium: "16px",
    loaderLineHeightLarge: "20px"
  }
};

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(11);

var _visuallyHidden = _interopRequireDefault(__webpack_require__(95));

var _token = __webpack_require__(20);

var indeterminateLinearAnimation = (0, _emotion.keyframes)({
  from: {
    transform: "scaleX(0.25) translateX(-100%)"
  },
  to: {
    transform: "scaleX(1) translateX(150%)"
  }
});
var indeterminateLinearAnimationRtl = (0, _emotion.keyframes)({
  from: {
    transform: "scaleX(1) translateX(150%)"
  },
  to: {
    transform: "scaleX(0.25) translateX(-100%)"
  }
});
var linearWrapperStyle = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var size = _ref.size;
  return (0, _emotion.css)({
    display: "flex",
    borderRadius: t("borderRadius"),
    width: "100%",
    minWidth: 100,
    height: t("trackLinear", [size, "height"]),
    backgroundColor: t("trackBackgroundColor"),
    position: "relative",
    overflow: "hidden",
    // HACK: This allows `overflow: hidden` + `position: relative` to work
    // as intended in Safari desktop
    zIndex: 0
  });
}, ["size"]);
var linearIndicatorStyle = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var determinate = _ref2.determinate,
      _ref2$percentage = _ref2.percentage,
      percentage = _ref2$percentage === void 0 ? 0 : _ref2$percentage;
  return (0, _emotion.css)({
    width: "".concat(percentage, "%"),
    height: "100%",
    backgroundColor: t("indicatorBackgroundColor"),
    transition: t.transitionCss("indicatorMotionDeterminate", "width")
  }, !determinate ? linearIndeterminateStyle(t) : undefined);
}, ["determinate", "percentage"]);

var linearIndeterminateStyle = function linearIndeterminateStyle(t) {
  return (0, _defineProperty2["default"])({
    width: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    borderRadius: t("borderRadius"),
    transformOrigin: "top left",
    animation: "".concat(indeterminateLinearAnimation, " ").concat(t("indicatorMotionIndeterminateDuration"), " ").concat(t("indicatorMotionIndeterminateFunction"), " infinite")
  }, "[dir=\"rtl\"] &", {
    animation: "".concat(indeterminateLinearAnimationRtl, " ").concat(t("indicatorMotionIndeterminateDuration"), " ").concat(t("indicatorMotionIndeterminateFunction"), " infinite")
  });
};

var linearPercentageStyle = (0, _token.memoizeTokenStyles)(function (t, _ref4) {
  var _css;

  var percentage = _ref4.percentage;
  return (0, _emotion.css)((_css = {
    width: "".concat(percentage, "%"),
    // HACK: IE11 does not support text-align "end" or "start" so we have
    // to use directional left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    //   textAlign: "end"
    textAlign: "right"
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    textAlign: "left"
  }), (0, _defineProperty2["default"])(_css, "marginTop", t("percentageSpacing")), (0, _defineProperty2["default"])(_css, "transition", t.transitionCss("indicatorMotionDeterminate", "width")), _css));
}, ["percentage"]);
var labelStyles = (0, _emotion.css)(_visuallyHidden["default"]);
/* eslint-disable react/prop-types */

var LinearLoader = function LinearLoader(_ref5) {
  var t = _ref5.t,
      percentage = _ref5.percentage,
      showPercentageText = _ref5.showPercentageText,
      size = _ref5.size,
      label = _ref5.label,
      determinate = _ref5.determinate;
  var useAriaLabel = !(determinate && showPercentageText);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "aria-label": useAriaLabel ? label : undefined
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: linearWrapperStyle(t, {
      size: size
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: linearIndicatorStyle(t, {
      determinate: determinate,
      percentage: percentage
    })
  })), !useAriaLabel ? /*#__PURE__*/_react["default"].createElement("div", {
    "aria-live": "polite",
    "aria-atomic": "true",
    className: linearPercentageStyle(t, {
      percentage: percentage
    })
  }, "".concat(percentage, "%"), /*#__PURE__*/_react["default"].createElement("span", {
    className: labelStyles
  }, label)) : null);
};
/* eslint-enable react/prop-types */


var _default = LinearLoader;
exports["default"] = _default;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(11);

var _token = __webpack_require__(20);

var _functional = __webpack_require__(38);

var _visuallyHidden = _interopRequireDefault(__webpack_require__(95));

var indeterminateCircularAnimation = (0, _emotion.keyframes)({
  "0%": {
    strokeDasharray: "100% 200%",
    transform: "rotate(100deg)"
  },
  "50%": {
    strokeDasharray: "30% 400%"
  },
  "100%": {
    strokeDasharray: "100% 200%",
    transform: "rotate(460deg)"
  }
});
var wrapperStyle = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var size = _ref.size;
  return (0, _emotion.css)({
    position: "relative"
  }, size === "small" ? {
    display: "flex",
    alignItems: "center"
  } : undefined);
}, ["size"]);

var svgStyle = function svgStyle(size) {
  return (0, _emotion.css)({
    width: size,
    height: size
  });
};

var pathStyle = (0, _functional.memoize)(function (t) {
  return (0, _emotion.css)({
    transition: t.transitionCss("indicatorMotionDeterminate", "stroke-dasharray")
  });
});
var indeterminatePathStyle = (0, _functional.memoize)(function (t) {
  return (0, _emotion.css)({
    transformOrigin: "center",
    animation: "".concat(indeterminateCircularAnimation, " ").concat(t("indicatorMotionIndeterminateDuration"), " ").concat(t("indicatorMotionDeterminateFunction"), " infinite")
  });
});
var percentageStyle = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var size = _ref2.size;
  return (0, _emotion.css)(size === "small" ? smallPercentageStyle : size === "medium" ? mediumPercentageStyle(t) : largePercentageStyle(t));
}, ["size"]);
var smallPercentageStyle = (0, _defineProperty2["default"])({
  // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
  // to use directional margin-left/right. If/when we drop IE11 we can simplify
  // these styles to be:
  // {
  //   marginInlineStart: 8,
  // }
  marginLeft: 8
}, "[dir=\"rtl\"] &", {
  marginLeft: 0,
  marginRight: 8
});

var mediumPercentageStyle = function mediumPercentageStyle(t) {
  return {
    width: t("trackCircularMediumSize"),
    textAlign: "center",
    marginTop: t("percentageSpacing")
  };
};

var largePercentageStyle = function largePercentageStyle(t) {
  return {
    position: "absolute",
    top: t("trackCircularLargeSize") / 2,
    width: t("trackCircularLargeSize"),
    lineHeight: 0,
    textAlign: "center"
  };
};

var labelStyles = (0, _emotion.css)(_visuallyHidden["default"]);
/**
 * To draw the right amount of stroke we need to know
 * the total length of the path. These path lengths were
 * derived once in Chrome console in order that they not
 * be calculated every time
 */

var pathLengths = {
  large: 188.5220947265625,
  medium: 87.97695922851562,
  small: 43.98847961425781
};
/* eslint-disable react/prop-types */

var CircularLoader = function CircularLoader(props) {
  var t = props.t,
      size = props.size,
      percentage = props.percentage,
      showPercentageText = props.showPercentageText,
      determinate = props.determinate,
      label = props.label;
  var box = t("trackCircular", [size, "size"]);
  var startX = box / 2;
  var startY = t("trackCircular", [size, "strokeWidth"]) / 2;
  var endX = 0;
  var endY = box - t("trackCircular", [size, "strokeWidth"]);
  var useAriaLabel = !(determinate && showPercentageText);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperStyle(t, {
      size: size
    })
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    role: "img",
    viewBox: "0 0 ".concat(box, " ").concat(box),
    className: svgStyle(box),
    "aria-hidden": label ? false : true,
    focusable: label ? true : false,
    "aria-label": useAriaLabel ? label : undefined
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: box / 2,
    cy: box / 2,
    r: endY / 2,
    stroke: t("track", "backgroundColor"),
    strokeWidth: t("trackCircular", [size, "strokeWidth"]),
    fill: "none"
  }), !determinate ? /*#__PURE__*/_react["default"].createElement("circle", {
    className: indeterminatePathStyle(t),
    cx: box / 2,
    cy: box / 2,
    r: endY / 2,
    stroke: t("indicatorBackgroundColor"),
    strokeWidth: t("trackCircular", [size, "strokeWidth"]),
    strokeLinecap: "round",
    strokeDasharray: "10% 100%",
    fill: "none"
  }) : /*#__PURE__*/_react["default"].createElement("path", {
    className: pathStyle(t),
    d: "M".concat(startX, ",").concat(startY, "\n              a 1 1 0 0 1 ").concat(endX, " ").concat(endY, "\n              a 1 1 0 0 1 ").concat(endX, " -").concat(endY),
    fill: "none",
    stroke: t("indicatorBackgroundColor"),
    strokeWidth: t("trackCircular", [size, "strokeWidth"]),
    strokeLinecap: "round",
    strokeDasharray: "".concat(pathLengths[size] * percentage / 100, ", ").concat(pathLengths[size])
  })), !useAriaLabel ? /*#__PURE__*/_react["default"].createElement("div", {
    "aria-live": "polite",
    "aria-atomic": "true",
    className: percentageStyle(t, {
      size: size
    })
  }, "".concat(percentage, "%"), /*#__PURE__*/_react["default"].createElement("span", {
    className: labelStyles
  }, label)) : null);
};
/* eslint-enable react/prop-types */


var _default = CircularLoader;
exports["default"] = _default;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(77));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _keycode = _interopRequireDefault(__webpack_require__(72));

var _popover = _interopRequireDefault(__webpack_require__(203));

var _elevation = __webpack_require__(81);

var _theme = __webpack_require__(24);

var _popoverBody = _interopRequireDefault(__webpack_require__(204));

var _popoverController = _interopRequireDefault(__webpack_require__(99));

var _utils = __webpack_require__(206);

var _token = __webpack_require__(20);

var _functional = __webpack_require__(38);

var _rtl = __webpack_require__(80);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = (0, _functional.memoize)(function (maxWidth) {
  return (0, _emotion.css)({
    overflowWrap: "break-word",
    pointerEvents: "none",
    maxWidth: maxWidth
  });
});
/**
 * Add a tooltip to an element. A note on accessibility: tooltips should only be
 * added to elements that are focusable. This allows keyboard users to open the
 * tooltip by tabbing to the tooltip's anchor node. Otherwise keyboard users
 * would not be able to open the tooltip. This means that *tooltips should not
 * be anchored to disabled elements directly*, since disabled elements generally
 * can't be focused. If you need to add context to a disabled element, consider
 * anchoring the tooltip to a help icon near the element:
 *
 * ```
 * <Row>
 *   <Button disabled={true}>Submit</Button>
 *   <Tooltip title="You can't perform this action, move along." position="right" id="submit-tooltip">
 *     <Icon tokens={helpIconTokens} tabIndex={0}>Help tooltip</Icon>
 *   </Tooltip>
 * </Row>
 * ```
 */

var Tooltip = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Tooltip, _React$Component);

  var _super = _createSuper(Tooltip);

  function Tooltip() {
    var _this;

    (0, _classCallCheck2["default"])(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      hover: false,
      focus: false,
      id: _this.props.id ? _this.props.id : (0, _uniqueId["default"])("tooltip-")
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isOpen", function () {
      return _this.props.open === undefined ? _this.state.hover || _this.state.focus : _this.props.open;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateAnchorNode", function (node) {
      if (node && node !== _this.anchorNode) {
        /* eslint-disable-next-line react/no-find-dom-node */
        _this.anchorNode = _reactDom["default"].findDOMNode(node); // If the Tooltip is managing state internally then bind the event
        // listeners that trigger internal state changes

        if (_this.props.open === undefined) {
          _this.addEventListeners();
        } // If the Tooltip is supposed to be open then force an update so it
        // re-renders with the anchor node


        if (_this.isOpen()) {
          _this.forceUpdate();
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addEventListeners", function () {
      // Remove any existing event listeners to ensure we don't accidentally stack
      // multiple listeners
      _this.removeEventListeners();

      if (_this.anchorNode) {
        _this.anchorNode.addEventListener("mouseenter", _this.onMouseEnterAnchor); // NOTE: This *must* be bound using a native event listener because of a bug
        // in React: https://github.com/facebook/react/issues/4251


        _this.anchorNode.addEventListener("mouseleave", _this.onMouseLeaveAnchor);

        _this.anchorNode.addEventListener("focus", _this.onFocusAnchor, true);

        _this.anchorNode.addEventListener("blur", _this.onBlurAnchor, true);

        _this.anchorNode.addEventListener("keydown", _this.onKeyDownAnchor);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "removeEventListeners", function () {
      if (_this.anchorNode) {
        _this.anchorNode.removeEventListener("mouseenter", _this.onMouseEnterAnchor);

        _this.anchorNode.removeEventListener("mouseleave", _this.onMouseLeaveAnchor);

        _this.anchorNode.removeEventListener("focus", _this.onFocusAnchor, true);

        _this.anchorNode.removeEventListener("blur", _this.onBlurAnchor, true);

        _this.anchorNode.removeEventListener("keydown", _this.onKeyDownAnchor);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseEnterAnchor", function () {
      return _this.setState({
        hover: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseLeaveAnchor", function () {
      return _this.setState({
        hover: false,
        focus: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocusAnchor", function () {
      var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this),
          anchorNode = _assertThisInitialize.anchorNode; // If a user has not set an id for accessibility
      // use our own auto-generated one


      try {
        if (!anchorNode.hasAttribute("aria-controls")) {
          anchorNode.setAttribute("aria-controls", _this.state.id);
        }

        if (!anchorNode.hasAttribute("aria-describedby")) {
          anchorNode.setAttribute("aria-describedby", _this.state.id);
        }
      } catch (_) {// Silent error
      }

      _this.setState({
        focus: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlurAnchor", function () {
      return _this.setState({
        focus: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownAnchor", function (event) {
      if (_this.isOpen && (event.key === "Esc" || (0, _keycode["default"])(event) === "esc")) {
        _this.setState({
          focus: false
        });
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(Tooltip, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If we're moving from state being managed via the `open` prop to state
      // being managed internally, bind the event listeners that trigger internal
      // state changes
      if (prevProps.open === undefined && this.props.open !== undefined) {
        this.addEventListeners();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEventListeners();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          maxWidth = _this$props.maxWidth,
          children = _this$props.children;
      var position = (0, _rtl.getHorizontalDirection)(this.props.position);
      var anchorNode = this.anchorNode;
      var oppositePosition = (0, _utils.flipAlignment)(position);
      var vertical = position === "top" || position === "bottom";

      var popover = /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _popover["default"],
        map: (0, _token.getTokenHelper)("popover"),
        key: "popover"
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
          open: _this2.isOpen(),
          anchorNode: anchorNode,
          anchorOrigin: vertical ? "".concat(position, " center") : "center ".concat(position),
          popoverOrigin: vertical ? "".concat(oppositePosition, " center") : "center ".concat(oppositePosition),
          offsetVertical: vertical ? t("offsetWithArrow") : 0,
          offsetHorizontal: vertical ? 0 : t("offsetWithArrow")
        }, function (_ref) {
          var popoverStyle = _ref.popoverStyle,
              popoverOrigin = _ref.popoverOrigin,
              anchorOrigin = _ref.anchorOrigin,
              anchorRect = _ref.anchorRect;
          return /*#__PURE__*/_react["default"].createElement(_popoverBody["default"], (0, _extends2["default"])({
            type: "fill",
            spacingInset: "small",
            zIndex: _elevation.elevationTooltip,
            className: "".concat(styles(maxWidth), " ").concat(popoverStyle),
            id: _this2.props.id ? _this2.props.id : (0, _uniqueId["default"])("tooltip-")
          }, _popoverBody["default"].generateArrowProps({
            popoverOrigin: popoverOrigin,
            anchorOrigin: anchorOrigin,
            anchorRect: anchorRect
          })), title);
        });
      });

      var child = _react["default"].Children.only(children);

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].cloneElement(child, {
        ref: this.updateAnchorNode
      }), popover);
    }
  }]);
  return Tooltip;
}(_react["default"].Component);

Tooltip.propTypes =  false ? {
  /**
   * The element that the tooltip should reference.
   *
   * The tooltip will point at this element, and will be triggered when the
   * user hovers over this element or focuses on it.
   *
   * This element must accept a [ref](https://reactjs.org/docs/refs-and-the-dom.html),
   * and should be focuseable to ensure that the tooltip is accessible to keyboard
   * users.
   */
  children: _propTypes["default"].element.isRequired,

  /**
   * The position of the tooltip relative to the anchor element (provided via
   * `children`).
   *
   * Note that the tooltip may reposition itself to the opposite side of the
   * element if there is not enough screen space to display itself in the
   * position identified here.
   */
  position: _propTypes["default"].oneOf(["top", "right", "end", "bottom", "left", "start"]).isRequired,

  /**
   * The text shown in the tooltip.
   */
  title: _propTypes["default"].string.isRequired,

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.x
   */
  id: _propTypes["default"].string,

  /**
   * Set the maximum width of the tooltip using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * If defined this will determine whether the tooltip is open or closed. If
   * omitted the tooltip will manage it's own state.
   *
   * Use this sparingly, in most cases the tooltip's internal state management
   * will correctly determine when it should open and close.
   */
  open: _propTypes["default"].bool
} : {};
Tooltip.defaultProps = {
  maxWidth: 300
};
var _default = Tooltip;
exports["default"] = _default;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _parseISO = _interopRequireDefault(__webpack_require__(286));

var _startOfMonth = _interopRequireDefault(__webpack_require__(287));

var _endOfMonth = _interopRequireDefault(__webpack_require__(288));

var _noop = _interopRequireDefault(__webpack_require__(59));

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _emotion = __webpack_require__(11);

var _datePickerPopover = _interopRequireDefault(__webpack_require__(1014));

var _datePickerPresets = _interopRequireDefault(__webpack_require__(1015));

var _dateInputField = _interopRequireDefault(__webpack_require__(1016));

var _dateInputCalendar = _interopRequireDefault(__webpack_require__(1025));

var _supportTextWrapper = _interopRequireDefault(__webpack_require__(138));

var _dateString = __webpack_require__(174);

var _dateLocales = _interopRequireDefault(__webpack_require__(116));

var _getSupportTextAriaDescribedby = _interopRequireDefault(__webpack_require__(139));

var _functional = __webpack_require__(38);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var widthStyles = (0, _functional.memoizeByKeys)(function (_ref) {
  var width = _ref.width;
  return (0, _emotion.css)({
    width: width,
    // If an explicit width is set then don't allow the textarea to flex
    flex: width ? "none !important" : undefined
  });
}, ["width"]);
/**
 * A form control for selecting dates. Uses the Input, DateInputCalendar, and
 * PopoverController components to create a nice interface for quickly selecting
 * a single date.
 */

var DatePicker = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onChange = props.onChange,
      defaultViewDate = props.defaultViewDate,
      value = props.value,
      now = props.now,
      popoverIdProp = props.popoverId,
      idProp = props.id;
  var popoverId = (0, _react.useMemo)(function () {
    return popoverIdProp ? popoverIdProp : (0, _uniqueId["default"])("datepicker-popover-");
  }, [popoverIdProp]);
  var id = (0, _react.useMemo)(function () {
    return idProp || (0, _uniqueId["default"])("datepicker-");
  }, [idProp]);
  /**
   * Return the date that the calendar popup should be initialized to show. If
   * a view date was explicitly set via props then use that, otherwise use the
   * selected date if there is a valid one, otherwise fallback to the current
   * date.
   */

  var getCalendarViewDate = (0, _react.useCallback)(function () {
    return defaultViewDate || (0, _dateString.parseDateString)(value) && value || now;
  }, [defaultViewDate, value, now]);

  var _useState = (0, _react.useState)(getCalendarViewDate()),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      calendarViewDate = _useState2[0],
      setCalendarViewDate = _useState2[1];
  /**
   * Change the months shown by the calendar picker to include a given date.
   * This handler ignores empty dates and doesn't do anything if the provided
   * date is already visible in the calendar picker.
   */


  var onChangeCalendarViewDate = (0, _react.useCallback)(function (date) {
    var parsedCalendarViewDate = (0, _parseISO["default"])(calendarViewDate);
    var firstDate = (0, _dateString.toDateString)((0, _startOfMonth["default"])(parsedCalendarViewDate));
    var lastDate = (0, _dateString.toDateString)((0, _endOfMonth["default"])(parsedCalendarViewDate));

    if (date && !(0, _dateString.isWithinRange)(date, firstDate, lastDate)) {
      setCalendarViewDate(date);
    }
  }, [calendarViewDate]);
  var onChangeField = (0, _react.useCallback)(function (value) {
    onChange(value); // Update the view to ensure that the new date is visible

    onChangeCalendarViewDate(value);
  }, [onChange, onChangeCalendarViewDate]);
  /**
   * Before opening the popover, make sure that the view date is correct (in
   * case the selected date was changed since the last time the popover was
   * opened or the user messed with the view date before previously closing the
   * popover).
   */

  var onBeforeOpenPopover = (0, _react.useCallback)(function () {
    return onChangeCalendarViewDate(getCalendarViewDate());
  }, [onChangeCalendarViewDate, getCalendarViewDate]); // If there is not helperText, constraintText, or errorMessage
  // then the aria-describedby is empty.

  var ariaDescribedbyValue = (0, _getSupportTextAriaDescribedby["default"])({
    id: id,
    hasHelperText: !!props.helperText,
    hasConstraintText: !!props.constraintText,
    hasErrorMessage: !!props.errorMessage,
    errorMessageFirst: props.size === "xlarge"
  });
  return /*#__PURE__*/_react["default"].createElement(_supportTextWrapper["default"], {
    id: id,
    helperText: props.helperText,
    constraintText: props.constraintText,
    errorMessage: props.errorMessage,
    helperBelowFormField: props.size === "xlarge",
    className: widthStyles({
      width: props.width
    })
  }, /*#__PURE__*/_react["default"].createElement(_datePickerPopover["default"], {
    valueFilled: Boolean(props.value),
    disabled: props.disabled,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    id: popoverId,
    anchor: function anchor(_ref2) {
      var onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          popoverIsOpen = _ref2.popoverIsOpen;
      return /*#__PURE__*/_react["default"].createElement(_dateInputField["default"], {
        size: props.size,
        value: props.value,
        onChange: onChangeField,
        focus: popoverIsOpen ? true : undefined,
        disabled: props.disabled,
        disabledDates: props.disabledDates,
        label: props.label,
        placeholder: props.placeholder,
        onFocus: onFocus,
        onBlur: onBlur,
        invalidInputMessage: props.invalidInputMessage,
        error: props.error,
        locale: props.locale,
        autoFocus: props.autoFocus || props.inaccessibleAutoFocus,
        autoFill: false,
        ref: ref,
        clearButton: props.clearButton,
        clearButtonLabel: props.clearButtonLabel,
        onClear: props.onClear,
        id: id,
        "aria-describedby": ariaDescribedbyValue
      });
    },
    onBeforeOpen: onBeforeOpenPopover
  }, function (_ref3) {
    var t = _ref3.t,
        popoverIsOpen = _ref3.popoverIsOpen,
        closePopover = _ref3.closePopover;
    return [/*#__PURE__*/_react["default"].createElement(_dateInputCalendar["default"], {
      key: "calendar",
      locale: props.locale,
      disabledDates: props.disabledDates,
      value: props.value,
      onChange: function onChange(value) {
        props.onChange(value);
        closePopover();
      },
      viewDate: calendarViewDate,
      onChangeViewDate: onChangeCalendarViewDate,
      now: props.now,
      monthsInView: props.monthsInView,
      monthWidth: props.monthWidth,
      previousMonthLabel: props.previousMonthLabel,
      nextMonthLabel: props.nextMonthLabel,
      renderDay: props.renderDay,
      renderDate: props.renderDate,
      dateLabel: props.dateLabel,
      animateMonthChange: popoverIsOpen
    }), props.presets.length > 0 ? /*#__PURE__*/_react["default"].createElement(_datePickerPresets["default"], {
      key: "presets",
      t: t,
      presets: props.presets,
      label: props.presetsLabel,
      onChange: function onChange(value) {
        props.onChange(value);
        closePopover();
      },
      disabledDates: props.disabledDates
    }) : null];
  }), " ");
});

DatePicker.displayName = "DatePicker";
DatePicker.propTypes =  false ? {
  /**
   * Called any time the user enters a full, valid, enabled date into the date
   * picker. The new date will be provided to the function as a date string
   * in the format YYYY-MM-DD.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * Appends a button to the input that the user can click to clear the input.
   * This will trigger the `onChange` callback with a value of `""`.
   *
   * @since  5.x
   */
  clearButton: _propTypes["default"].bool,

  /**
   * An accessible label for the clear button. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * @since  5.x
   */
  clearButtonLabel: _propTypes["default"].string,

  /**
   * Add constraint text to provide critical information regarding content.
   *
   * @since 5.22.0
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * A function that can be used to construct a screen-reader label for a particular
   * day. The function will be passed an object with the following properties.
   *
   * `date`: `string` of date in the format YYYY-MM-DD
   *
   * `label`: `string` of the localized day of the month (e.g. "Thursday, Nov 22, 2018")
   *
   * `current`: `boolean` set to `true` if the date is today's date
   *
   * `selected`: `boolean` set to `true` if date is selected
   *
   * `disabled`: `boolean` set to `true` if date is disabled
   *
   * `range`: `boolean` set to `true` if date is in the range of selected dates
   *
   * @since 5.20.0
   */
  dateLabel: _propTypes["default"].func,

  /**
   * This date is used to determine which month the calendar should display
   * by default. The date must be provided in the format YYYY-MM-DD. If not
   * provided then the calendar will display the month of `value`, or
   * `now` if no value is provided.
   */
  defaultViewDate: _propTypes["default"].string,

  /**
   * Determines if the entire date picker is disabled. If you want to disable
   * specific dates then use the `disabledDates` prop.
   */
  disabled: _propTypes["default"].bool,

  /**
   * A function that can be used to disable specific dates. The function will
   * be passed date strings in the format YYYY-MM-DD and is expected to return
   * true for disabled dates and false otherwise.
   */
  disabledDates: _propTypes["default"].func,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with an `errorMessage`.
   */
  error: _propTypes["default"].bool,

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the DatePicker.
   *
   * @since 5.22.0
   */
  errorMessage: _propTypes["default"].string,

  /**
   * Add helper text to provide additional instruction.
   *
   * @since 5.22.0
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.x
   */
  id: _propTypes["default"].string,

  /**
   * If set to true then the input will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * A function that returns a message for invalid or disabled dates.
   * The function must return a localized string. The string will be displayed
   * to the user to help guide them.
   *
   * Two arguments will be passed to the function. The first argument will be an error code - either
   * "INVALID_DATE" if the user's date doesn't exist (e.g. 2018-40-40) or
   * "DISABLED_DATE" if the user's date has been disabled via the
   * `disabledDates` prop. The second argument will be the date entered by the
   * user in the format YYYY-MM-DD. This argument will only be provided for
   * the "DISABLED_DATE" error code (the "INVALID_DATE" code means we couldn't
   * actually construct a date).
   */
  invalidInputMessage: _propTypes["default"].func,

  /**
   * The label for the date input field.
   *
   * __Note__: Setting a label will effectively hide the `placeholder` value.
   */
  label: _propTypes["default"].string,

  /**
   * The locale to use when rendering the component (e.g. month names, names of
   * days of the week, etc.). See the [Intl API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl).
   */
  locale: _propTypes["default"].oneOf(Object.keys(_dateLocales["default"])),

  /**
   * Set the width of a single month.
   */
  monthWidth: _propTypes["default"].number,

  /**
   * The number of calendar months to display at a time.
   */
  monthsInView: _propTypes["default"].number,

  /**
   * A localized label for the next month button.
   */
  nextMonthLabel: _propTypes["default"].string,

  /**
   * Define today's date (in the format YYYY-MM-DD). This date will be
   * marked in the calendar with a special indicator.
   */
  now: _propTypes["default"].string,

  /**
   * Text that is shown in place of the input's value when the input is empty.
   *
   * This text is not visible when a value is entered in the input, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   *
   * __Note__: Placeholder will not appear if `label` is defined.
   */
  placeholder: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the popover container.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.x
   */
  popoverId: _propTypes["default"].string,

  /**
   * A list of presets to allow quick selection of common dates.
   *
   * If provided, these presets will be shown as buttons in the date picker's
   * calendar popover.
   */
  presets: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string
  })),

  /**
   * A localized label to be shown above the list of presets.
   */
  presetsLabel: _propTypes["default"].string,

  /**
   * A localized label for the previous month button.
   */
  previousMonthLabel: _propTypes["default"].string,

  /**
   * A function that can be used to customize the rendering of a single day. The
   * function is passed an object which contains the following props.
   *
   * `date`: `string` of date in the format YYYY-MM-DD
   *
   * `label`: `string` of the localized day of the month (e.g. "21")
   *
   * `current`: `boolean` set to `true` if the date is today's date
   *
   * `selected`: `boolean` set to `true` if date is selected
   *
   * `disabled`: `boolean` set to `true` if date is disabled
   *
   * `range`: `boolean` set to `true` if date is in the range of selected dates
   *
   * @since 5.20.0
   */
  renderDate: _propTypes["default"].func,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `renderDate` instead.
   *
   * @deprecated 5.20.0
   */
  renderDay: _propTypes["default"].func,

  /**
   * Sets the size of the component using a preset.
   *
   * If the `label` prop is provided this prop will be ignored (the label
   * requires a particular amount of space which is not configurable).
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * The currently selected date as formatted as a YYYY-MM-DD date string.
   *
   * Update this when `onChange` is called to ensure the component is interactive
   * (see the documentation for the `onChange` prop).
   */
  value: _propTypes["default"].string,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   *
   * @since 5.x
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This is called when the entire component (input + popover calendar) loses focus.
   * The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event) is passed as the first argument to the function.
   *
   * @since 5.x
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the clear button is clicked (be sure to set `clearButton`
   * to `true`). No arguments are passed to this callback.
   *
   * @since 5.x
   */
  onClear: _propTypes["default"].func,

  /**
   * This is called when the entire component (input + popover calendar) gains focus.
   * The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event) is passed as the first argument to the function.
   *
   * @since 5.x
   */
  onFocus: _propTypes["default"].func
} : {};
DatePicker.defaultProps = {
  locale: "en-US",
  disabledDates: _noop["default"],
  now: (0, _dateString.toDateString)(new Date()),
  presets: [],
  size: "medium",
  invalidInputMessage: function invalidInputMessage(code) {
    return {
      INVALID_DATE: "This value is not a valid date.",
      DISABLED_DATE: "This date is not available."
    }[code];
  },
  error: false
};
var _default = DatePicker;
exports["default"] = _default;

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export daysInWeek */
/* unused harmony export daysInYear */
/* unused harmony export maxTime */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return millisecondsInMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return millisecondsInHour; });
/* unused harmony export millisecondsInSecond */
/* unused harmony export minTime */
/* unused harmony export minutesInHour */
/* unused harmony export monthsInQuarter */
/* unused harmony export monthsInYear */
/* unused harmony export quartersInYear */
/* unused harmony export secondsInHour */
/* unused harmony export secondsInMinute */
/* unused harmony export secondsInDay */
/* unused harmony export secondsInWeek */
/* unused harmony export secondsInYear */
/* unused harmony export secondsInMonth */
/* unused harmony export secondsInQuarter */
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;
/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */

var daysInYear = 365.2425;
/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */

var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;
/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInSecond = 1000;
/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */

var minTime = -maxTime;
/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */

var minutesInHour = 60;
/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var monthsInQuarter = 3;
/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */

var monthsInYear = 12;
/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */

var quartersInYear = 4;
/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */

var secondsInHour = 3600;
/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var secondsInMinute = 60;
/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */

var secondsInDay = secondsInHour * 24;
/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */

var secondsInWeek = secondsInDay * 7;
/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */

var secondsInYear = secondsInDay * daysInYear;
/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */

var secondsInMonth = secondsInYear / 12;
/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var secondsInQuarter = secondsInMonth * 3;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _keycode = _interopRequireDefault(__webpack_require__(72));

var _noop = _interopRequireDefault(__webpack_require__(59));

var _datePicker = _interopRequireDefault(__webpack_require__(440));

var _popoverController = _interopRequireDefault(__webpack_require__(99));

var _focusTrap = _interopRequireDefault(__webpack_require__(170));

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _theme = __webpack_require__(24);

var _token = __webpack_require__(20);

var _functional = __webpack_require__(38);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var width = _ref.width;
  return (0, _emotion.css)({
    display: "flex",
    flexDirection: "row",
    width: width,
    "& > *": {
      width: "100%",
      flex: "auto"
    },
    "& > * + *": {
      marginLeft: t("inputSpacingHorizontal")
    }
  });
}, ["width"]);
var popoverStyles = (0, _functional.memoize)(function (t) {
  return (0, _emotion.css)({
    outline: "none",
    border: t.borderCss("popoverBorder"),
    borderRadius: t("popoverBorderRadius"),
    boxShadow: t.boxShadowCss("popoverDropShadow"),
    backgroundColor: t("popoverBackgroundColor"),
    display: "flex",
    flexDirection: "row",
    zIndex: t("popoverElevation")
  });
});
/**
 * A helper for rendering the date picker popover. The main value add of this
 * component is that it handles all the low-level popover, focus, and keyboard
 * behavior (e.g. tab from date picker input to date picker calendar).
 */

var DatePickerPopover = function DatePickerPopover(props) {
  var rootRef = (0, _react.useRef)();
  var popoverRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      popoverIsOpen = _useState2[0],
      setPopoverIsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      shouldFocusPopover = _useState4[0],
      setShouldFocusPopover = _useState4[1];

  var t = (0, _theme.useTheme)(_datePicker["default"], "datePicker");
  var id = props.id,
      onFocus = props.onFocus; // Determines if the user is focused anywhere in the date picker's popover

  var popoverHasFocus = (0, _react.useCallback)(function () {
    return popoverRef.current && popoverRef.current.contains(document.activeElement);
  }, [popoverRef]); // Transfers focus to the first mini calendar date within the date picker's popover

  var focusMiniCalendar = (0, _react.useCallback)(function () {
    try {
      var firstTable = popoverRef.current.querySelector("table:not([aria-hidden='true'])");
      var firstVisibleDate = firstTable.querySelector('td:not([aria-hidden="true"])');
      firstVisibleDate.focus();
    } catch (_) {// Silent error
    }
  }, [popoverRef]); // Closes the popover and transfers focus back to the date input field if
  // necessary

  var closePopover = (0, _react.useCallback)(function () {
    // If the popover has focus, transfer focus back to the last date input
    // field.
    if (popoverHasFocus() && rootRef.current) {
      var inputs = rootRef.current.querySelectorAll("input");
      inputs[inputs.length - 1].focus();
    } // Close the popover


    setPopoverIsOpen(false);
  }, [popoverHasFocus]); // Called when the popover opens. Transfers focus to the mini calendar if
  // desired.

  var onOpen = (0, _react.useCallback)(function () {
    if (shouldFocusPopover) {
      focusMiniCalendar();
    }
  }, [shouldFocusPopover, focusMiniCalendar]); // Closes the popover when the user moves focus away from both the date
  // picker's popover and date input field

  var onBlurProp = props.onBlur;
  var onBlur = (0, _react.useCallback)(function (event) {
    onBlurProp(event);
    closePopover();
  }, [onBlurProp, closePopover]);
  var onFocusFunc = (0, _react.useCallback)(function () {
    setShouldFocusPopover(false);
    setPopoverIsOpen(true);
    onFocus();
  }, [onFocus]); // Opens the popover when the user mouses down on the date picker

  var onMouseDown = (0, _react.useCallback)(function (event) {
    if (!popoverIsOpen && event.target !== rootRef.current && !props.disabled) {
      setShouldFocusPopover(false);
      setPopoverIsOpen(true);
    }
  }, [popoverIsOpen, rootRef, setPopoverIsOpen, setShouldFocusPopover, props.disabled]); // Listens to key presses in order to:
  // - Close the popover when the "esc" key is pressed
  // - Close the popover when the "enter" key is pressed after a date has been
  //   typed in the date input field
  // - Open the popover and transfer focus to it when the "down" key is pressed

  var valueFilled = props.valueFilled;
  var onKeyDown = (0, _react.useCallback)(function (event) {
    var key = (0, _keycode["default"])(event); // If the user hits escape then close the date picker

    if (key === "esc" && popoverIsOpen) {
      closePopover(); // Stop propagating the event upwards. This ensures that a parent element
      // (e.g. a modal) won't also handle the escape key.

      event.stopPropagation();
    } // If user hits the enter key after supplying a value via the input field
    // then close the popover
    else if (key === "enter" && valueFilled && popoverIsOpen && !popoverHasFocus()) {
      closePopover();
      event.preventDefault();
    } // If the down arrow key is pressed make sure the popover is open and it has
    // focus
    else if (key === "down") {
      // If the popover is closed then open it (focus will be transferred
      // afterwards when the popover ref is ready).
      if (!popoverIsOpen) {
        setShouldFocusPopover(true);
        setPopoverIsOpen(true);
      } // If the popover is open but not focused then move focus to the day
      // picker.
      else if (!popoverHasFocus()) {
        focusMiniCalendar();
      }

      event.preventDefault();
    }
  }, [popoverIsOpen, popoverHasFocus, setShouldFocusPopover, valueFilled, setPopoverIsOpen, closePopover, focusMiniCalendar]);

  var _useFocus = (0, _useFocus2["default"])({
    onFocus: onFocusFunc,
    onBlur: onBlur,
    multipleNodes: true
  }),
      focusProps = _useFocus.focusProps;

  return /*#__PURE__*/_react["default"].createElement("div", {
    onKeyDown: onKeyDown,
    onMouseDown: onMouseDown,
    className: styles(t, props),
    ref: rootRef,
    "aria-expanded": popoverIsOpen,
    "aria-controls": popoverIsOpen ? id : undefined
  }, props.anchor(_objectSpread(_objectSpread({}, focusProps), {}, {
    popoverIsOpen: popoverIsOpen
  })), /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
    open: popoverIsOpen,
    anchorNode: rootRef.current,
    anchorOrigin: "bottom left",
    popoverOrigin: "top left",
    offsetVertical: t("popoverSpacingVertical"),
    onOpen: onOpen,
    onBeforeOpen: props.onBeforeOpen
  }, function (_ref2) {
    var popoverStyle = _ref2.popoverStyle;
    return /*#__PURE__*/_react["default"].createElement(_focusTrap["default"], null, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
      id: id
    }, focusProps, {
      tabIndex: "-1",
      className: "".concat(popoverStyles(t), " ").concat(popoverStyle),
      ref: popoverRef
    }), props.children({
      t: t,
      closePopover: closePopover,
      popoverIsOpen: popoverIsOpen
    })));
  }));
};

DatePickerPopover.displayName = "DatePickerPopover";
DatePickerPopover.propTypes =  false ? {
  anchor: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].func.isRequired,
  valueFilled: _propTypes["default"].bool.isRequired,
  disabled: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  onBeforeOpen: _propTypes["default"].func,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func
} : {};
DatePickerPopover.defaultProps = {
  disabled: false,
  onFocus: _noop["default"],
  onBlur: _noop["default"]
};
var _default = DatePickerPopover;
exports["default"] = _default;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _noop = _interopRequireDefault(__webpack_require__(59));

var _button = _interopRequireDefault(__webpack_require__(253));

var _button2 = _interopRequireDefault(__webpack_require__(8));

var _functional = __webpack_require__(38);

var _text = _interopRequireDefault(__webpack_require__(47));

var _listReset = _interopRequireDefault(__webpack_require__(433));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = (0, _functional.memoize)(function (t) {
  var _buttonTokens = (0, _button["default"])(t.tokens),
      buttonSpacingInsetHorizontalMedium = _buttonTokens.buttonSpacingInsetHorizontalMedium;

  return (0, _emotion.css)((0, _text["default"])(t), {
    position: "relative",
    padding: "".concat(t("popoverSpacingInset"), "px ").concat(t("popoverSpacingInset") - buttonSpacingInsetHorizontalMedium, "px"),
    "&:before": {
      content: "''",
      position: "absolute",
      top: t("popoverSpacingInset"),
      bottom: t("popoverSpacingInset"),
      left: 0,
      width: t("presetsDividerWidth"),
      backgroundColor: t("presetsDividerColor")
    },
    // Label
    "& > div": {
      marginLeft: buttonSpacingInsetHorizontalMedium
    },
    // List
    "& > ul": (0, _emotion.css)(_listReset["default"], {
      marginTop: t("popoverSpacingVertical")
    })
  });
});
/**
 * This component provides a way for users to select a date via a list of
 * presets.
 */

var DatePickerPresets = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DatePickerPresets, _React$Component);

  var _super = _createSuper(DatePickerPresets);

  function DatePickerPresets() {
    (0, _classCallCheck2["default"])(this, DatePickerPresets);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(DatePickerPresets, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          label = _this$props.label,
          presets = _this$props.presets,
          onChange = _this$props.onChange,
          disabledDates = _this$props.disabledDates;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: styles(t)
      }, /*#__PURE__*/_react["default"].createElement("div", null, label), /*#__PURE__*/_react["default"].createElement("ul", null, presets.map(function (preset, index) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: index
        }, /*#__PURE__*/_react["default"].createElement(_button2["default"], {
          type: "link",
          onClick: function onClick() {
            return onChange(preset.value);
          },
          disabled: Array.isArray(preset.value) ? disabledDates(preset.value[0]) || disabledDates(preset.value[1]) : disabledDates(preset.value)
        }, preset.label));
      })));
    }
  }]);
  return DatePickerPresets;
}(_react["default"].Component);

(0, _defineProperty2["default"])(DatePickerPresets, "defaultProps", {
  label: "Presets",
  disabledDates: _noop["default"]
});
DatePickerPresets.propTypes =  false ? {
  presets: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)])
  })).isRequired,

  /**
   * This is called when the user chooses a preset. The value of the preset
   * will be passed as the first argument to the function as a string with the
   * format YYYY-MM-DD.
   */
  onChange: _propTypes["default"].func.isRequired,
  disabledDates: _propTypes["default"].func,
  label: _propTypes["default"].string,
  t: _propTypes["default"].func
} : {};
var _default = DatePickerPresets;
exports["default"] = _default;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dateInputField = _interopRequireDefault(__webpack_require__(1017));

var _default = _dateInputField["default"];
exports["default"] = _default;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _noop = _interopRequireDefault(__webpack_require__(59));

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _format = _interopRequireDefault(__webpack_require__(259));

var _calendar = _interopRequireDefault(__webpack_require__(1018));

var _alertErrorSmall = _interopRequireDefault(__webpack_require__(252));

var _datePicker = _interopRequireDefault(__webpack_require__(440));

var _input = _interopRequireDefault(__webpack_require__(171));

var _input2 = _interopRequireDefault(__webpack_require__(22));

var _mask = _interopRequireDefault(__webpack_require__(284));

var _theme = __webpack_require__(24);

var _popoverController = _interopRequireDefault(__webpack_require__(99));

var _focus = _interopRequireDefault(__webpack_require__(109));

var _popoverBody = _interopRequireDefault(__webpack_require__(204));

var _inputClearButton = _interopRequireDefault(__webpack_require__(441));

var _context = _interopRequireDefault(__webpack_require__(415));

var _inputMonospacePlaceholder = _interopRequireDefault(__webpack_require__(442));

var _token = __webpack_require__(20);

var _dateString = __webpack_require__(174);

var _dateLocales = _interopRequireWildcard(__webpack_require__(116));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var focus = _ref.focus,
      empty = _ref.empty;
  return (0, _emotion.css)({
    letterSpacing: focus || !empty ? t("inputValueLetterSpacing") : undefined,
    // HACK: We only accept dates in English numerals for now - since we don't yet
    // support other locale numerals, eg: ١،٢،٣،٤،٥،٦،٨،٩،٠ 一，二，三，四，五, etc.
    // Dates entered in English numerals are read and typed LTR.
    direction: "ltr"
  });
}, ["focus", "empty"]);
/* eslint-disable react/prop-types */

/**
 * A form control for selecting dates via a numeric input field. This input is
 * unique from other input components in that it tracks the user's partial input
 * via internal state and only triggers onChange once the user has entered a
 * complete, valid date. If the user moves focus away from the input before
 * entering a complete, valid date then the input is cleared automatically.
 */

var DateInputFieldClass = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DateInputFieldClass, _React$Component);

  var _super = _createSuper(DateInputFieldClass);

  function DateInputFieldClass() {
    var _this;

    (0, _classCallCheck2["default"])(this, DateInputFieldClass);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "localRef", /*#__PURE__*/_react["default"].createRef());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "lastErrorCode", /*#__PURE__*/_react["default"].createRef(""));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setSelectionRangeTimeout", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "assignRefs", function (inputNode) {
      var forwardedRef = _this.props.forwardedRef;
      _this.localRef.current = inputNode;

      if (forwardedRef) {
        // Assign the ref with a function (Class components) or assigning .current
        // (modern functional components using the `useRef` hook)
        if (typeof forwardedRef === "function") {
          forwardedRef(inputNode);
        } else {
          forwardedRef.current = inputNode;
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDisplayFormat", function () {
      return (0, _dateLocales.getDateLocale)(_this.props.locale).format;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDisplayValue", function (value) {
      var date = (0, _dateString.parseDateString)(value);
      return date ? (0, _format["default"])(date, _this.getDisplayFormat()) : "";
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getValue", function (displayValue) {
      var date = (0, _dateString.parseDateString)(displayValue, _this.getDisplayFormat());
      return date ? (0, _dateString.toDateString)(date) : "";
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      displayValue: _this.getDisplayValue(_this.props.value),
      focus: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getMask", function () {
      return new _mask["default"](_this.getDisplayFormat().replace(/[MDY]/gi, "#"));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isEmpty", function () {
      return !/[0-9]/.test(_this.state.displayValue);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocus", function (event) {
      _this.setState({
        focus: true
      });

      _this.props.onFocus(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlur", function (event) {
      var _this$props = _this.props,
          value = _this$props.value,
          onBlur = _this$props.onBlur;

      _this.setState({
        displayValue: _this.getDisplayValue(value),
        focus: false
      });

      onBlur(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClear", function () {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          onClear = _this$props2.onClear; // Tell owner date was cleared, clear display, and call onClear prop

      onChange("");
      onClear();

      _this.setState({
        displayValue: ""
      }); // Move focus back to input so user can begin typing new date


      if (_this.localRef.current) {
        _this.localRef.current.focus({
          preventScroll: true
        }); // HACK: Move cursor to beginning.
        // This _should_ be doable in React input mask but, sadly, is not working 😢 https://github.com/sanniassin/react-input-mask/tree/2.0.4#beforemaskedvaluechange--function
        // This waits a beat for input mask to add its value before moving the cursor.


        _this.setSelectionRangeTimeout = setTimeout(function () {
          return _this.localRef.current.setSelectionRange(0, 0);
        }, 10);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (displayValue) {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          disabledDates = _this$props3.disabledDates,
          value = _this$props3.value;

      var date = _this.getValue(displayValue);

      _this.setState({
        displayValue: displayValue
      }); // If a valid date was entered then notify the owner


      if (date && !disabledDates(date)) {
        onChange(date);
      } else if (value) {
        // Otherwise tell the owner that the date was cleared (but don't clear the
        // display value so the user can keep editing towards a valid date)
        onChange(undefined);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(DateInputFieldClass, [{
    key: "getErrorCode",
    value: function getErrorCode(_ref2) {
      var mask = _ref2.mask;
      // Only validate if the input is in focus
      if (!this.state.focus) return "";
      var full = !this.isEmpty() && !new RegExp(mask.placeholderChar).test(this.state.displayValue);
      var value = this.getValue(this.state.displayValue);
      return full && !value ? "INVALID_DATE" : full && this.props.disabledDates(value) ? "DISABLED_DATE" : "";
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
          locale = _this$props4.locale,
          value = _this$props4.value; // If a new value was passed in via props then reset the display value
      // *unless* it's a situation where the user is editing the input and the
      // value was cleared out because the user's partial input resulted in an
      // invalid date

      if (value !== prevProps.value && !(this.state.focus && !value)) {
        this.setState({
          displayValue: this.getDisplayValue(value)
        });
      } // If a new locale was passed in via props then reset the input's display
      // value


      if (locale !== prevProps.locale) {
        this.setState({
          displayValue: this.getDisplayValue(value)
        });
      } // Call `onInvalidDate` if it exists and the error code, indeed, changed.


      if (this.props.onInvalidDate) {
        var errorCode = this.getErrorCode({
          mask: this.getMask()
        }); // HACK: Because refs are initialized with `null` - fallback to an empty string

        if ((this.lastErrorCode.current || "") !== errorCode) {
          this.props.onInvalidDate(errorCode, this.getValue(this.state.displayValue));
          this.lastErrorCode.current = errorCode;
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.setSelectionRangeTimeout);
    }
  }, {
    key: "renderInvalidInputMessage",
    value: function renderInvalidInputMessage(t, _ref3) {
      var mask = _ref3.mask;
      var errorCode = this.getErrorCode({
        mask: mask
      });
      var invalidInputMessage = errorCode ? this.props.invalidInputMessage(errorCode, this.getValue(this.state.displayValue)) : ""; // Traverse the DOM looking for the little calendar icon that we've added to
      // the input (that's where we want to anchor the error message). This is
      // pretty brittle, but we definitely don't want to update the Input
      // component to provide direct refs to it's various pieces, so this
      // works for me.

      var anchorNode = this.localRef.current ? this.localRef.current.parentNode.parentNode.parentNode.querySelector("[mdn-input-box-suffix]") : undefined;
      return /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
        open: Boolean(invalidInputMessage),
        anchorNode: anchorNode,
        anchorOrigin: "center right",
        popoverOrigin: "bottom center",
        offsetVertical: -18,
        offsetHorizontal: -10
      }, function (_ref4) {
        var popoverStyle = _ref4.popoverStyle;
        return /*#__PURE__*/_react["default"].createElement(_popoverBody["default"], {
          className: popoverStyle,
          type: "fill",
          spacingInset: "small",
          zIndex: t("errorTooltipElevation"),
          arrowAlignment: "center",
          arrowPosition: "bottom"
        }, invalidInputMessage);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var state = this.state;
      var focus = props.focus !== undefined ? props.focus : state.focus;
      var empty = this.isEmpty();
      var mask = this.getMask();
      var displayFormat = this.getDisplayFormat().toLocaleUpperCase();
      var errorCode = this.getErrorCode({
        mask: mask
      });
      var showClearButton = props.clearButton && !empty;
      var dateInputFieldId = props.id || (0, _uniqueId["default"])("dateinputfield-");

      var ariaProps = _objectSpread({}, (0, _filterPropsByPrefix["default"])(props, ["aria-"]));

      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _datePicker["default"],
        map: (0, _token.getTokenHelper)("datePicker")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(_focus["default"], {
          onFocus: _this2.onFocus,
          onBlur: _this2.onBlur,
          multipleTargets: true
        }, function (_ref5) {
          var focusProps = _ref5.focusProps;
          return /*#__PURE__*/_react["default"].createElement(_context["default"].Consumer, {
            value: focusProps
          }, function (existingValues) {
            return /*#__PURE__*/_react["default"].createElement(_context["default"].Provider, {
              value: _objectSpread(_objectSpread({}, focusProps), existingValues)
            }, /*#__PURE__*/_react["default"].createElement(_input2["default"], (0, _extends2["default"])({
              ref: _this2.assignRefs,
              className: styles(t, {
                focus: focus,
                empty: empty
              }),
              type: "text" // We can set mobile keyboards to numeric here because we
              // take care of date separators ("/", "-", ".", etc)
              ,
              inputMode: "numeric",
              value: state.displayValue,
              suffixIconTokens: showClearButton || !props.showIcon ? undefined : {
                // HACK: Keep the calendar icon width & height to ensure the input
                // size doesn't change when switching icons.
                iconWidth: _calendar["default"].iconCalendarWidth,
                iconHeight: _calendar["default"].iconCalendarHeight,
                iconData: errorCode ? _alertErrorSmall["default"].iconAlertErrorSmallData : _calendar["default"].iconCalendarData
              },
              mask: mask,
              disabled: props.disabled,
              focus: props.focus,
              "aria-placeholder": props.placeholder,
              placeholder: focus ? undefined : props.placeholder,
              size: props.size,
              label: props.label,
              error: props.error,
              width: props.width,
              suffix: showClearButton ? /*#__PURE__*/_react["default"].createElement(_inputClearButton["default"], {
                onClick: _this2.onClear,
                label: props.clearButtonLabel // HACK: Shrink the radius by 1 so the button radius fits inside the input
                // radius
                ,
                borderRadiusRight: (0, _input["default"])(t.tokens).inputBorderRadius - 1
              }) : null,
              onChange: _this2.onChange,
              onKeyDown: props.onKeyDown,
              autoFocus: props.autoFocus || props.inaccessibleAutoFocus,
              autoFill: props.autoFill,
              id: dateInputFieldId,
              constraintText: props.constraintText,
              helperText: props.helperText,
              errorMessage: props.errorMessage
            }, ariaProps), focus || !empty ? /*#__PURE__*/_react["default"].createElement(_inputMonospacePlaceholder["default"], {
              t: t,
              mask: mask,
              disabled: props.disabled,
              value: state.displayValue,
              displayFormat: displayFormat
            }) : undefined, _this2.renderInvalidInputMessage(t, {
              mask: mask
            })));
          });
        });
      });
    }
  }]);
  return DateInputFieldClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */
// Forward ref to class component. TODO: update class component
// to functional component.


var DateInputField = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(DateInputFieldClass, (0, _extends2["default"])({}, props, {
    forwardedRef: ref
  }));
});

DateInputField.displayName = "DateInputField";
DateInputField.propTypes = {
  /**
   * A function that will be called when the value of the date input is
   * changed by the user. The new date will be passed to the function as a
   * string with the format YYYY-MM-DD.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * If `constraintText`, `helperText`, and/or an `errorMessage` are provided to
   * the DateInputeField these will be used to generate the `aria-describedby` prop.
   * This can be overridden by explicitly setting `aria-describedby` on the DateInputField.
   *
   * @since 5.22.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Allow the browser to suggest auto-fill values for this input.
   *
   * Note that not all browsers respect this property. Some browsers (e.g.
   * Chrome 78) may choose to *always* allow auto-fill regardless of the value
   * of this property.
   */
  autoFill: _propTypes["default"].bool,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * Appends a button to the input that the user can click to clear the input.
   * This will trigger the `onChange` callback with a value of `""`.
   *
   * @since  5.x
   */
  clearButton: _propTypes["default"].bool,

  /**
   * An accessible label for the clear button. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * @since  5.x
   */
  clearButtonLabel: _propTypes["default"].string,

  /**
   * Add constraint text to provide critical information regarding content.
   *
   * @since 5.22.0
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * This disables interaction with the entire date picker. If you want to
   * disable the selection of specific dates then use the `disabledDates` prop.
   */
  disabled: _propTypes["default"].bool,

  /**
   * A function that can be used to disable specific dates. The function will
   * be passed date strings in the format YYYY-MM-DD and is expected to return
   * true for disabled dates and false otherwise.
   */
  disabledDates: _propTypes["default"].func,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with an `errorMessage`.
   */
  error: _propTypes["default"].bool,

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the DateInputField.
   *
   * @since 5.22.0
   */
  errorMessage: _propTypes["default"].string,

  /**
   * This can be used to force the visible focus state of the input on or
   * off. This only affects the display of the focus ring and the date format
   * placeholder, it does not change the focus state of the actual DOM element
   * as far as the browser is concerned.
   */
  focus: _propTypes["default"].bool,

  /**
   * Add helper text to provide additional instruction.
   *
   * @since 5.22.0
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.x
   */
  id: _propTypes["default"].string,

  /**
   * If set to true then the input will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * A function that returns a message for invalid or disabled dates.
   * The function must return a localized string. The string will be displayed
   * to the user to help guide them.
   *
   * Two arguments will be passed to the function. The first argument will be an error code - either
   * "INVALID_DATE" if the user's date doesn't exist (e.g. 2018-40-40) or
   * "DISABLED_DATE" if the user's date has been disabled via the
   * `disabledDates` prop. The second argument will be the date entered by the
   * user in the format YYYY-MM-DD. This argument will only be provided for
   * the "DISABLED_DATE" error code (the "INVALID_DATE" code means we couldn't
   * actually construct a date).
   */
  invalidInputMessage: _propTypes["default"].func,

  /**
   * A label for the input.
   *
   * If this prop is provided the `size` prop will be ignored.
   */
  label: _propTypes["default"].string,

  /**
   * The locale to use when rendering the input (e.g. input date format,
   * month names, names of days of the week, etc.).
   */
  locale: _propTypes["default"].oneOf(Object.keys(_dateLocales["default"])),

  /**
   * Text that is shown in place of the input's value when the input is empty.
   *
   * This text is not visible when a value is entered in the input, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   */
  placeholder: _propTypes["default"].string,

  /**
   * Show a calendar or error icon in the input. If set to `false`, be sure to use
   * `onInvalidDate` to display an error message to user's when they input an invalid
   * or disabled date.
   *
   * @since 5.17.0
   */
  showIcon: _propTypes["default"].bool,

  /**
   * Sets the size of the component using a preset.
   *
   * If the `label` prop is provided this prop will be ignored (the label
   * requires a particular amount of space which is not configurable).
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * The currently selected date in the format YYYY-MM-DD. Do not pass partial
   * or invalid dates.
   *
   * Update this when `onChange` is called to ensure the component is interactive
   * (see the documentation for the `onChange` prop).
   */
  value: _propTypes["default"].string,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the clear button is clicked (be sure to set `clearButton`
   * to `true`). No arguments are passed to this callback.
   *
   * @since 5.x
   */
  onClear: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * A function that will be called when the user types in an invalid or disabled
   * date. Like `invalidInputMessage`, the function will be called with the error
   * code (`"INVALID_DATE"` for invalid dates like 2018-40-40 or `"DISABLED_DATE"`
   * if the user types in a date disabled by the `disabledDates` prop) as an argument.
   *
   * Unlike `invalidInputMessage`, `onInvalidDate` will be called with an empty error
   * code `""` when the input is corrected.
   *
   * @since 5.17.0
   */
  onInvalidDate: _propTypes["default"].func,

  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func
};
DateInputField.defaultProps = {
  locale: "en-US",
  onClear: _noop["default"],
  onFocus: _noop["default"],
  onBlur: _noop["default"],
  clearButton: false,
  disabledDates: _noop["default"],
  size: "medium",
  invalidInputMessage: function invalidInputMessage(code) {
    return {
      INVALID_DATE: "This value is not a valid date.",
      DISABLED_DATE: "This date is not available."
    }[code];
  },
  error: false,
  autoFill: true,
  showIcon: true
};
var _default = DateInputField;
exports["default"] = _default;

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCalendarData: "data:image/svg+xml,%3csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M18 4v13.89H2V4h16zm0-2H2a2 2 0 00-2 2v13.9a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2z' fill='currentColor' fill-rule='nonzero'/%3e%3cpath d='M7 7v12M13 7v12M19 7H1M19 13H1' stroke='currentColor' stroke-width='2' stroke-linejoin='round'/%3e%3cpath d='M7 3V1M13 3V1' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconCalendarWidth: 20,
  iconCalendarHeight: 20
};

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _close = _interopRequireDefault(__webpack_require__(154));

var _button = _interopRequireDefault(__webpack_require__(253));

var _elevation = __webpack_require__(81);

var _button2 = _interopRequireDefault(__webpack_require__(8));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _theme = __webpack_require__(24);

var _token = __webpack_require__(20);

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _buttonStyles = __webpack_require__(346);

var _borderRadius = _interopRequireDefault(__webpack_require__(127));

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var hidden = _ref.hidden,
      borderRadiusRight = _ref.borderRadiusRight,
      focus = _ref.focus;
  return (0, _emotion.css)((0, _defineProperty2["default"])({
    height: "100%",
    visibility: hidden ? "hidden" : undefined,
    // Bring the clear button up over the search button when focused so that its
    // focus ring isn't clipped
    "&:focus": {
      zIndex: _elevation.elevationForeground
    },
    // Set the button border radius
    borderRadius: (0, _borderRadius["default"])(borderRadiusRight, ["topRight", "bottomRight"])
  }, "[dir=\"rtl\"] &", {
    borderRadius: (0, _borderRadius["default"])(borderRadiusRight, ["topLeft", "bottomLeft"])
  }), // Set the focus ring border radius
  (0, _buttonStyles.focusStyles)(t, {
    focus: focus,
    borderRadius: (0, _borderRadius["default"])(borderRadiusRight, ["topRight", "bottomRight"]),
    outlineOffset: 1
  }), (0, _defineProperty2["default"])({}, "[dir=\"rtl\"] &", (0, _buttonStyles.focusStyles)(t, {
    focus: focus,
    borderRadius: (0, _borderRadius["default"])(borderRadiusRight, ["topLeft", "bottomLeft"]),
    outlineOffset: 1
  })));
}, ["hidden", "borderRadiusRight", "focus"]);

var InputClearButton = function InputClearButton(props) {
  var hidden = props.hidden,
      borderRadiusRight = props.borderRadiusRight;
  var t = (0, _theme.useTheme)(_button["default"], "button");

  var _useFocus = (0, _useFocus2["default"])(props),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  return /*#__PURE__*/_react["default"].createElement(_button2["default"], (0, _extends2["default"])({
    type: "icon",
    onClick: props.onClick,
    disabled: props.disabled,
    className: styles(t, {
      hidden: hidden,
      borderRadiusRight: borderRadiusRight,
      focus: focus && focusTrigger === "keyboard"
    }),
    "aria-hidden": hidden,
    label: props.label
  }, focusProps), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _close["default"]
  }));
};

InputClearButton.propTypes =  false ? {
  borderRadiusRight: _propTypes["default"].number,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,
  hidden: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  onClick: _propTypes["default"].func
} : {};
InputClearButton.defaultProps = {
  label: "Clear input"
};
var _default = InputClearButton;
exports["default"] = _default;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _emotion = __webpack_require__(11);

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _token = __webpack_require__(20);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// All of the complicated CSS here is required in order to make the characters
// in the placeholder (e.g. Y, M, D, -, and separators) line up with the numeric
// characters in the user's input, which do not have the same character widths.
var placeholderStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var disabled = _ref.disabled;
  return (0, _emotion.css)({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    // HACK: We only accept dates in English numerals for now - since we don't yet
    // support other locale numerals, eg: ١،٢،٣،٤،٥،٦،٨،٩،٠ 一，二，三，四，五, etc.
    // Dates entered in English numerals are read and typed LTR.
    direction: "ltr !important",
    textAlign: "left !important",
    pointerEvents: "none",
    color: t("inputPlaceholderColor", disabled ? "disabled" : "default"),
    whiteSpace: "pre",
    // Apply the same letter spacing that the input has to the inline blocks
    // that hold each placeholder character
    "& > * + *": {
      marginLeft: t("inputValueLetterSpacing")
    }
  });
}, ["disabled"]);
var placeholderCharStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var placeholderChar = _ref2.placeholderChar,
      empty = _ref2.empty,
      separator = _ref2.separator,
      actualChar = _ref2.actualChar;
  return (0, _emotion.css)({
    position: "relative",
    display: "inline-block",
    // This pseudo element reserves an approximate amount of space for the
    // placeholder character that an actual character in the input would take
    // up. It does this by using for its contents the actual character (if
    // filled) or a "0" when it is placeholding for empty characters (all digit
    // chars are the same width) or an identical separator char (e.g. a ":"
    // for US times) when it lines up with one of those. This ensures that the
    // placeholder characters line up fully with the input characters, even
    // if they have different character widths.
    "&:before": {
      color: "transparent",
      content: separator ? "'".concat(placeholderChar, "'") : empty ? "'0'" : "'".concat(actualChar, "'")
    }
  }, // For non-separator characters use the after psuedo element to show a shrunk-
  // down  version of the character exactly centered in the character box where
  // the corresponding input char would be rendered. This allows a placeholder
  // character that is much wider than a digit (e.g. the "M") to still line
  // up with the digit.
  separator ? undefined : {
    "&:after": {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translateY(-50%) translateX(-50%)",
      opacity: empty ? 1 : 0,
      content: "'".concat(placeholderChar, "'"),
      fontSize: t("inputPlaceholderFontSize"),
      lineHeight: t("inputPlaceholderLineHeight")
    }
  });
}, ["placeholderChar", "empty", "separator", "actualChar"]);

var InputMonospacePlaceholder = function InputMonospacePlaceholder(props) {
  var t = props.t,
      mask = props.mask,
      disabled = props.disabled,
      value = props.value; // If given a display format (like "YYYY/MM/DD") via props, use that.
  // Otherwise, construct from the mask replacing all non-literals with "–"

  var displayFormat = (0, _react.useMemo)(function () {
    return props.displayFormat || mask.mask.replace(/[#*]/gi, "–");
  }, [mask, props.displayFormat]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: placeholderStyles(t, {
      disabled: disabled
    }),
    "aria-hidden": "true"
  }, displayFormat.split("").map(function (_, index) {
    var placeholderChar = displayFormat[index];
    var empty = !value[index] || value[index] === mask.placeholderChar;
    var separator = !mask.formatChars[mask.mask[index]];
    var actualChar = value[index];
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: placeholderCharStyles(t, {
        placeholderChar: placeholderChar,
        empty: empty,
        separator: separator,
        actualChar: actualChar
      })
    });
  }));
};

InputMonospacePlaceholder.propTypes =  false ? {
  mask: _propTypes["default"].object.isRequired,

  /**
   * Tokens should have the following keys (values can obviously vary)
   * input: {
   *   valueLetterSpacing: "2px",
   *   placeholder: {
   *     fontSize: "13px",
   *     lineHeight: "18px",
   *     color: {
   *       default: "theme-foreground-secondary-default",
   *       disabled: "theme-foreground-primary-disabled",
   *     },
   *   },
   * }
   **/
  t: _propTypes["default"].func.isRequired,
  value: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  displayFormat: _propTypes["default"].string
} : {};
var _default = InputMonospacePlaceholder;
exports["default"] = _default;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var baseRepeat = __webpack_require__(1022),
    baseToString = __webpack_require__(246),
    castSlice = __webpack_require__(403),
    hasUnicode = __webpack_require__(205),
    stringSize = __webpack_require__(443),
    stringToArray = __webpack_require__(405);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil;

/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */
function createPadding(length, chars) {
  chars = chars === undefined ? ' ' : baseToString(chars);

  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? baseRepeat(chars, length) : chars;
  }
  var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
  return hasUnicode(chars)
    ? castSlice(stringToArray(result), 0, length).join('')
    : result.slice(0, length);
}

module.exports = createPadding;


/***/ }),
/* 1022 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor;

/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */
function baseRepeat(string, n) {
  var result = '';
  if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
    return result;
  }
  // Leverage the exponentiation by squaring algorithm for a faster repeat.
  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
  do {
    if (n % 2) {
      result += string;
    }
    n = nativeFloor(n / 2);
    if (n) {
      string += string;
    }
  } while (n);

  return result;
}

module.exports = baseRepeat;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(338);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),
/* 1024 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dateInputCalendar = _interopRequireDefault(__webpack_require__(1026));

var _default = _dateInputCalendar["default"];
exports["default"] = _default;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _miniCalendar = _interopRequireDefault(__webpack_require__(1027));

var _dateLocales = _interopRequireDefault(__webpack_require__(116));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This component provides a nice way for a user to input a single date. The UI
 * is a month calendar that allows the user to either select a day in the
 * current month or to browse other months. If the "name" prop is provided a
 * normal html input is rendered under the hood so this component can be used
 * like any other form control.
 */
var DateInputCalendar = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DateInputCalendar, _React$Component);

  var _super = _createSuper(DateInputCalendar);

  function DateInputCalendar() {
    (0, _classCallCheck2["default"])(this, DateInputCalendar);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(DateInputCalendar, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/_react["default"].createElement(_miniCalendar["default"], {
        selectedDates: function selectedDates(date) {
          return date === props.value;
        },
        onClickDate: props.onChange,
        viewDate: props.viewDate,
        onChangeViewDate: props.onChangeViewDate,
        now: props.now,
        disabledDates: props.disabledDates,
        locale: props.locale,
        monthsInView: props.monthsInView,
        monthWidth: props.monthWidth,
        previousMonthLabel: props.previousMonthLabel,
        nextMonthLabel: props.nextMonthLabel,
        renderDate: props.renderDate,
        renderDay: props.renderDay,
        dateLabel: props.dateLabel,
        animateMonthChange: props.animateMonthChange
      }, props.name ? /*#__PURE__*/_react["default"].createElement("input", {
        type: "hidden",
        name: props.name,
        value: props.value
      }) : null);
    }
  }]);
  return DateInputCalendar;
}(_react["default"].Component);

DateInputCalendar.propTypes =  false ? {
  /**
   * This date is used to determine which month the calendar should display
   * by default. The date must be provided in the format YYYY-MM-DD.
   */
  viewDate: _propTypes["default"].string.isRequired,

  /**
   * A function that will be called when the value of the date input is
   * changed by the user. The new date will be passed to the function as a
   * string with the format YYYY-MM-DD.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * A function that will be called whenever the calendar wants to update the
   * view date itself.
   */
  onChangeViewDate: _propTypes["default"].func.isRequired,

  /**
   * Determines whether changing months is animated with a sliding motion.
   */
  animateMonthChange: _propTypes["default"].bool,

  /**
   * A function that can be used to construct a screen-reader label for a particular
   * day. The function will be passed an object with the following properties.
   * ```
   * date:      `string` of date in the format YYYY-MM-DD
   * label:     `string` of the localized day of the month (e.g. "Thursday, Nov 22, 2018")
   * current:   `boolean` set to `true` if the date is today's date
   * selected:  `boolean` set to `true` if date is selected
   * disabled:  `boolean` set to `true` if date is disabled
   * range:     `boolean` set to `true` if date is in the range of selected dates
   * ```
   *
   * @since 5.20.0
   */
  dateLabel: _propTypes["default"].func,

  /**
   * A function that can be used to disable specific dates. The function will
   * be passed date strings in the format YYYY-MM-DD and is expected to return
   * true for disabled dates and false otherwise.
   */
  disabledDates: _propTypes["default"].func,

  /**
   * The locale to use when rendering the input (e.g. month names, names of
   * days of the week, etc.). See the [Intl API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl).
   */
  locale: _propTypes["default"].oneOf(Object.keys(_dateLocales["default"])),

  /**
   * Set the width of a single month.
   */
  monthWidth: _propTypes["default"].number,

  /**
   * The number of calendar months to display at a time.
   */
  monthsInView: _propTypes["default"].number,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * A localized label for the next month button.
   */
  nextMonthLabel: _propTypes["default"].string,

  /**
   * Define today's date (in the format YYYY-MM-DD). This date will be
   * marked in the calendar with a special indicator.
   */
  now: _propTypes["default"].string,

  /**
   * A localized label for the previous month button.
   */
  previousMonthLabel: _propTypes["default"].string,

  /**
   * A function that can be used to customize the rendering of a single day. The
   * function is passed an object which contains the following properties.
   *
   * ```
   * date:      `string` of date in the format YYYY-MM-DD
   * label:     `string` of the localized day of the month (e.g. "21")
   * current:   `boolean` set to `true` if the date is today's date
   * selected:  `boolean` set to `true` if date is selected
   * disabled:  `boolean` set to `true` if date is disabled
   * range:     `boolean` set to `true` if date is in the range of selected dates
   * ```
   */
  renderDate: _propTypes["default"].func,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `renderDate` instead.
   *
   * @deprecated 5.20.0
   */
  renderDay: _propTypes["default"].func,

  /**
   * The value of the input in the format YYYY-MM-DD.
   *
   * Update this when `onChange` is called to ensure the component is interactive
   * (see the documentation for the `onChange` prop).
   */
  value: _propTypes["default"].string
} : {};
var _default = DateInputCalendar;
exports["default"] = _default;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _miniCalendar = _interopRequireDefault(__webpack_require__(1028));

var _default = _miniCalendar["default"];
exports["default"] = _default;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _keycode = _interopRequireDefault(__webpack_require__(72));

var _addMonths = _interopRequireDefault(__webpack_require__(1029));

var _addDays = _interopRequireDefault(__webpack_require__(218));

var _startOfMonth = _interopRequireDefault(__webpack_require__(287));

var _endOfMonth = _interopRequireDefault(__webpack_require__(288));

var _parseISO = _interopRequireDefault(__webpack_require__(286));

var _eachDayOfInterval = _interopRequireDefault(__webpack_require__(444));

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _noop = _interopRequireDefault(__webpack_require__(59));

var _miniCalendar = _interopRequireDefault(__webpack_require__(1030));

var _chevronRightSmall = _interopRequireDefault(__webpack_require__(158));

var _chevronLeftSmall = _interopRequireDefault(__webpack_require__(445));

var _elevation = __webpack_require__(81);

var _miniCalendarPage = _interopRequireDefault(__webpack_require__(1031));

var _button = _interopRequireDefault(__webpack_require__(8));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _focus = _interopRequireDefault(__webpack_require__(109));

var _carouselController = _interopRequireDefault(__webpack_require__(1040));

var _theme = __webpack_require__(24);

var _token = __webpack_require__(20);

var _dateString = __webpack_require__(174);

var _dateLocales = _interopRequireDefault(__webpack_require__(116));

var _intlDateTimeFormat = __webpack_require__(219);

var _visuallyHidden = _interopRequireDefault(__webpack_require__(95));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var monthFormat = {
  month: "long",
  year: "numeric"
};
var justMonthFormat = {
  month: "long"
};
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var monthsInView = _ref.monthsInView,
      monthWidth = _ref.monthWidth;
  return (0, _emotion.css)({
    boxSizing: "border-box",
    width: (monthWidth || t("monthWidth")) * monthsInView + t("spacingInset") * (monthsInView + 1),
    position: "relative",
    "& > span": _visuallyHidden["default"],
    // Month navigation buttons
    "& > button": {
      position: "absolute",
      // NOTE: Scoot the nav buttons up by half the difference between the height
      // of the button (32px) and the height of the DayInput month header (24px).
      // The resulting 4px shift will ensure that the button and the header are
      // vertically aligned. A simpler flex-box based solution can't be used
      // because the button and the header can't be siblings (becuse the header
      // must shift left/right as the user changes the view but the button must
      // remain fixed).
      top: t("spacingInset") - 4,
      zIndex: _elevation.elevationForeground,
      "&:nth-of-type(1)": (0, _defineProperty2["default"])({
        left: t("spacingInset")
      }, "[dir=\"rtl\"] &", {
        right: t("spacingInset"),
        left: "auto"
      }),
      "&:nth-of-type(2)": (0, _defineProperty2["default"])({
        right: t("spacingInset")
      }, "[dir=\"rtl\"] &", {
        left: t("spacingInset"),
        right: "auto"
      })
    }
  });
}, ["monthsInView", "monthWidth"]);
var containerStyles = (0, _emotion.css)({
  outline: "none"
});
/**
 * This component renders a month calendar and allows the user to either select
 * a day in the current month or to browse other months.
 */

var MiniCalendar = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MiniCalendar, _React$Component);

  var _super = _createSuper(MiniCalendar);

  function MiniCalendar() {
    var _this;

    (0, _classCallCheck2["default"])(this, MiniCalendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      focusDate: (0, _dateString.toDateString)((0, _startOfMonth["default"])((0, _parseISO["default"])(_this.props.viewDate)))
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", (0, _uniqueId["default"])("mini-cal-"));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getNextDate", function (date, step) {
      return (0, _dateString.toDateString)((0, _addDays["default"])((0, _parseISO["default"])(date), step));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onShiftViewDate", function (months) {
      if (months !== 0) {
        var _this$props = _this.props,
            viewDate = _this$props.viewDate,
            onChangeViewDate = _this$props.onChangeViewDate,
            monthsInView = _this$props.monthsInView;
        onChangeViewDate((0, _dateString.toDateString)((0, _addMonths["default"])((0, _parseISO["default"])(viewDate), months)));
        var focusDate = _this.state.focusDate;
        var startOfView = (0, _startOfMonth["default"])((0, _parseISO["default"])(viewDate));
        var endOfView = (0, _endOfMonth["default"])((0, _addMonths["default"])((0, _parseISO["default"])(viewDate), monthsInView - 1)); // Make sure the focused day is in view when the user focuses on the input

        var focusInView = focusDate && (0, _dateString.isWithinRange)(focusDate, (0, _dateString.toDateString)(startOfView), (0, _dateString.toDateString)(endOfView)); // If the focus date is no longer in view, set focus date to first date in
        // the new view

        if (!focusInView) {
          _this.setState({
            focusDate: (0, _dateString.toDateString)(startOfView)
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClickDate", function (date) {
      if (_this.props.onClickDate) {
        _this.props.onClickDate(date);
      }

      _this.setState({
        focusDate: date
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusDayElement", function (date) {
      try {
        var dayElement = document.getElementById("".concat(_this.id, "-").concat(date));
        dayElement.focus();
      } catch (_) {// Silent error
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownCalendarPage", function (event) {
      var _this$props2 = _this.props,
          viewDate = _this$props2.viewDate,
          monthsInView = _this$props2.monthsInView,
          onClickDate = _this$props2.onClickDate;
      var focusDate = _this.state.focusDate;
      var key = (0, _keycode["default"])(event);
      var dayChange = {
        up: -7,
        right: 1,
        down: 7,
        left: -1
      }[key];
      var nextFocusDate = focusDate && dayChange ? _this.getNextDate(focusDate, dayChange) : undefined;
      var keyUsed = false; // Move the focus to a new date when the user navigates with arrow keys

      if (nextFocusDate && nextFocusDate !== focusDate) {
        _this.setState({
          focusDate: nextFocusDate
        });

        _this.focusDayElement(nextFocusDate); // If the user focused a date outside of the view then change the view


        var differenceInMonths = (0, _dateString.differenceInMonthsFromRange)(nextFocusDate, viewDate, (0, _dateString.toDateString)((0, _addMonths["default"])((0, _parseISO["default"])(viewDate), monthsInView - 1)));

        _this.onShiftViewDate(differenceInMonths);

        keyUsed = true;
      } // Select the focused date when the user hits enter or space


      if (focusDate && (key === "enter" || key === "space")) {
        if (!_this.props.disabledDates(focusDate)) {
          onClickDate(focusDate);
          keyUsed = true;
        }
      } // Don't perform the normal action associated with the key (e.g. scroll for
      // arrows/space) if the key was used for an input-related action


      if (keyUsed) {
        event.preventDefault();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocusCalendarPage", function () {
      var _this$props3 = _this.props,
          viewDate = _this$props3.viewDate,
          monthsInView = _this$props3.monthsInView,
          disabledDates = _this$props3.disabledDates;
      var focusDate = _this.state.focusDate;
      var startOfView = (0, _startOfMonth["default"])((0, _parseISO["default"])(viewDate));
      var endOfView = (0, _endOfMonth["default"])((0, _addMonths["default"])((0, _parseISO["default"])(viewDate), monthsInView - 1)); // Make sure the focused day is in view when the user focuses on the input

      var focusInView = focusDate && (0, _dateString.isWithinRange)(focusDate, (0, _dateString.toDateString)(startOfView), (0, _dateString.toDateString)(endOfView));
      var nextFocusDate = !focusInView ? (0, _eachDayOfInterval["default"])({
        start: startOfView,
        end: endOfView
      }).map(function (date) {
        return (0, _dateString.toDateString)(date);
      }).filter(function (date) {
        return !disabledDates(date);
      })[0] : undefined;

      if (nextFocusDate) {
        _this.setState({
          focusDate: nextFocusDate
        });

        _this.focusDayElement(nextFocusDate);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(MiniCalendar, [{
    key: "renderNavButton",
    value: function renderNavButton(direction) {
      var _this2 = this;

      var _this$props4 = this.props,
          previousMonthLabel = _this$props4.previousMonthLabel,
          nextMonthLabel = _this$props4.nextMonthLabel,
          viewDate = _this$props4.viewDate,
          locale = _this$props4.locale;
      var _left$right$direction = {
        left: {
          icon: _chevronLeftSmall["default"],
          change: -1,
          label: previousMonthLabel
        },
        right: {
          icon: _chevronRightSmall["default"],
          change: 1,
          label: nextMonthLabel
        }
      }[direction],
          icon = _left$right$direction.icon,
          change = _left$right$direction.change,
          label = _left$right$direction.label; // Get a formatted localized string for the target month and add it to the label
      // e.g. "Next month, November 2018"

      var targetMonthLabel = (0, _intlDateTimeFormat.intlDateTimeFormat)((0, _addMonths["default"])((0, _parseISO["default"])(viewDate), change), monthFormat, locale);
      return /*#__PURE__*/_react["default"].createElement(_button["default"], {
        type: "icon",
        size: "small",
        onClick: function onClick() {
          return _this2.onShiftViewDate(change);
        },
        label: "".concat(label, ", ").concat(targetMonthLabel)
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        tokens: icon
      }));
    }
  }, {
    key: "getScreenReaderMonthLabel",
    value: function getScreenReaderMonthLabel() {
      var props = this.props;
      var currentMonth = (0, _parseISO["default"])(props.viewDate);
      var nextMonth = (0, _addMonths["default"])((0, _parseISO["default"])(props.viewDate), 1); // If we're showing two months, return the current month by itself plus the
      // next month including year
      // e.g. "October & November 2018"

      if (props.monthsInView > 1) {
        return "".concat((0, _intlDateTimeFormat.intlDateTimeFormat)(currentMonth, justMonthFormat, props.locale), " & ").concat((0, _intlDateTimeFormat.intlDateTimeFormat)(nextMonth, monthFormat, props.locale));
      } // Else, return the current month plus the year
      // e.g. "October 2018"
      else {
        return (0, _intlDateTimeFormat.intlDateTimeFormat)(currentMonth, monthFormat, props.locale);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var props = this.props;
      var state = this.state;
      var viewDateIndex = (0, _dateString.differenceInCalendarMonths)(props.viewDate, props.now);
      var screenReaderMonthLabel = this.getScreenReaderMonthLabel();
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _miniCalendar["default"],
        map: (0, _token.getTokenHelper)("miniCalendar")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: styles(t, {
            monthsInView: props.monthsInView,
            monthWidth: props.monthWidth
          })
        }, _this3.renderNavButton("left"), /*#__PURE__*/_react["default"].createElement("span", {
          "aria-live": "polite"
        }, screenReaderMonthLabel), _this3.renderNavButton("right"), /*#__PURE__*/_react["default"].createElement(_focus["default"], {
          onFocus: _this3.onFocusCalendarPage
        }, function (_ref2) {
          var focusProps = _ref2.focusProps,
              focusTrigger = _ref2.focusTrigger;
          return /*#__PURE__*/_react["default"].createElement(_carouselController["default"], {
            renderContainer: function renderContainer(_ref3) {
              var containerProps = _ref3.props;
              return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, containerProps, {
                className: (0, _emotion.cx)(containerProps.className, containerStyles),
                onKeyDown: _this3.onKeyDownCalendarPage
              }, focusProps));
            },
            renderSlide: function renderSlide(_ref4) {
              var slideProps = _ref4.props,
                  index = _ref4.index;
              return /*#__PURE__*/_react["default"].createElement(_miniCalendarPage["default"], (0, _extends2["default"])({}, slideProps, {
                hidden: slideProps["aria-hidden"],
                t: t,
                focusDate: state.focusDate,
                showFocusRing: focusTrigger === "keyboard",
                viewDate: (0, _dateString.toDateString)((0, _addMonths["default"])((0, _parseISO["default"])(props.now), index)),
                now: props.now,
                selectedDates: props.selectedDates,
                rangeDates: props.rangeDates,
                disabledDates: props.disabledDates,
                dateIds: function dateIds(date) {
                  return "".concat(_this3.id, "-").concat(date);
                },
                locale: props.locale,
                onClickDate: _this3.onClickDate,
                onMouseEnterDate: props.onMouseEnterDate,
                renderDate: props.renderDate,
                renderDay: props.renderDay,
                dateLabel: props.dateLabel
              }));
            },
            slideIndex: viewDateIndex,
            slidesInView: props.monthsInView,
            motionDuration: props.animateMonthChange ? parseInt(t("monthMotionDuration")) : 0,
            motionFunction: t("monthMotionFunction"),
            spacingInset: t("spacingInset"),
            spacingHorizontal: t("spacingInset")
          });
        }), props.children);
      });
    }
  }]);
  return MiniCalendar;
}(_react["default"].Component);

(0, _defineProperty2["default"])(MiniCalendar, "defaultProps", {
  locale: "en-US",
  previousMonthLabel: "Previous month",
  nextMonthLabel: "Next month",
  monthsInView: 1,
  now: (0, _dateString.toDateString)(new Date()),
  onClick: _noop["default"],
  selectedDates: function selectedDates() {
    return false;
  },
  rangeDates: function rangeDates() {
    return false;
  },
  disabledDates: function disabledDates() {
    return false;
  },
  animateMonthChange: true
});
MiniCalendar.propTypes =  false ? {
  /**
   * This date is used to determine which month the calendar should display
   * by default. The date must be provided in the format YYYY-MM-DD.
   */
  viewDate: _propTypes["default"].string.isRequired,

  /**
   * A function that will be called whenever the calendar wants to update the
   * view date itself.
   */
  onChangeViewDate: _propTypes["default"].func.isRequired,

  /**
   * Determines whether changing months is animated with a sliding motion.
   */
  animateMonthChange: _propTypes["default"].bool,

  /**
   * Children to be rendered in the container div, after the calendar itself.
   * This is an advanced feature meant for internal use.
   */
  children: _propTypes["default"].node,

  /**
   * A function that can be used to construct a screen-reader label for a particular
   * day. The function will be passed an object with the following properties.
   * ```
   * date:      `string` of date in the format YYYY-MM-DD
   * label:     `string` of the localized day of the month (e.g. "Thursday, Nov 22, 2018")
   * current:   `boolean` set to `true` if the date is today's date
   * selected:  `boolean` set to `true` if date is selected
   * disabled:  `boolean` set to `true` if date is disabled
   * range:     `boolean` set to `true` if date is in the range of selected dates
   * ```
   *
   * @since 5.20.0
   */
  dateLabel: _propTypes["default"].func,

  /**
   * A function that can be used to disable specific dates. The function will
   * be passed date strings in the format YYYY-MM-DD and is expected to return
   * true for disabled dates and false otherwise.
   */
  disabledDates: _propTypes["default"].func,

  /**
   * The locale to use when rendering the input (e.g. month names, names of
   * days of the week, etc.). See the [Intl API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl)
   * for more information about date internationalization in JS.
   */
  locale: _propTypes["default"].oneOf(Object.keys(_dateLocales["default"])),

  /**
   * Set the width of a single month.
   */
  monthWidth: _propTypes["default"].number,

  /**
   * The number of calendar months to display at a time.
   */
  monthsInView: _propTypes["default"].number,

  /**
   * A localized label for the next month button.
   */
  nextMonthLabel: _propTypes["default"].string,

  /**
   * Define today's date (in the format YYYY-MM-DD). This date will be
   * marked in the calendar with a special indicator.
   */
  now: _propTypes["default"].string,

  /**
   * A localized label for the previous month button.
   */
  previousMonthLabel: _propTypes["default"].string,

  /**
   * A function that can be used to display specific dates as part of a range.
   * The function will be passed date strings in the format YYYY-MM-DD and is
   * expected to return true for dates in the range and false otherwise.
   */
  rangeDates: _propTypes["default"].func,

  /**
   * A function that can be used to customize the rendering of a single day. The
   * function is passed an object which contains the following properties.
   * ```
   * date:      `string` of date in the format YYYY-MM-DD
   * label:     `string` of the localized day of the month (e.g. "21")
   * current:   `boolean` set to `true` if the date is today's date
   * selected:  `boolean` set to `true` if date is selected
   * disabled:  `boolean` set to `true` if date is disabled
   * range:     `boolean` set to `true` if date is in the range of selected dates
   * ```
   */
  renderDate: _propTypes["default"].func,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `renderDate` instead.
   *
   * @deprecated 5.20.0
   */
  renderDay: _propTypes["default"].func,

  /**
   * A function that can be used to display specific dates as selected. The
   * function will be passed date strings in the format YYYY-MM-DD and is
   * expected to return true for selected dates and false otherwise.
   */
  selectedDates: _propTypes["default"].func,

  /**
   * A function that will be called when the user clicks on a date in the
   * calendar. The date will be passed to the function as a string with the
   * the format YYYY-MM-DD.
   */
  onClickDate: _propTypes["default"].func,

  /**
   * A function that will be called when the user hovers over a date in the
   * calendar. The date will be passed to the function as a string with the
   * format YYYY-MM-DD.
   */
  onMouseEnterDate: _propTypes["default"].func
} : {};
var _default = MiniCalendar;
exports["default"] = _default;

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(45);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    miniCalendarMonthHeaderFontWeight: 600,
    miniCalendarMonthHeaderFontSize: 20,
    miniCalendarMonthWidth: 280,
    miniCalendarMonthMotionDuration: "200ms",
    miniCalendarMonthMotionFunction: "ease",
    miniCalendarDayOfWeekHeaderFontWeight: 600,
    miniCalendarDayOfWeekHeaderFontSize: 14,
    miniCalendarDayBackgroundColorSelected: tokens.themeForegroundAccentDefault,
    miniCalendarDayBackgroundColorHover: tokens.themeForegroundAccentHover,
    miniCalendarDayBackgroundColorPressed: tokens.themeForegroundAccentPressed,
    miniCalendarDayBackgroundColorHighlighted: tokens.themeBackgroundAccentDefault,
    miniCalendarDayForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    miniCalendarDayForegroundColorSelected: tokens.themeForegroundInvertedDefault,
    miniCalendarDayForegroundColorHover: tokens.themeForegroundInvertedDefault,
    miniCalendarDayForegroundColorPressed: tokens.themeForegroundInvertedDefault,
    miniCalendarDayForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    miniCalendarDayBorderRadius: 4,
    miniCalendarDayMotionDuration: "100ms",
    miniCalendarDayMotionFunction: "ease",
    miniCalendarIndicatorColor: tokens.themeForegroundAccentDefault,
    miniCalendarIndicatorWidth: 24,
    miniCalendarIndicatorHeight: 2,
    miniCalendarIndicatorBorderRadius: 999,
    miniCalendarIndicatorSpacingVertical: 4,
    miniCalendarSpacingInset: 32,
    miniCalendarSpacingVertical: 8
  }
};

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _range2 = _interopRequireDefault(__webpack_require__(159));

var _chunk = _interopRequireDefault(__webpack_require__(1032));

var _elevation = __webpack_require__(81);

var _addDays = _interopRequireDefault(__webpack_require__(218));

var _getCalendarMonth = _interopRequireDefault(__webpack_require__(1033));

var _dateString = __webpack_require__(174);

var _token = __webpack_require__(20);

var _text = _interopRequireDefault(__webpack_require__(47));

var _focusRing = _interopRequireDefault(__webpack_require__(73));

var _dateLocales = __webpack_require__(116);

var _intlDateTimeFormat = __webpack_require__(219);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var daysInWeek = 7;
var dateFormat = {
  weekday: "long",
  day: "numeric",
  month: "short",
  year: "numeric"
}; // HACK: Grid column styles for IE11 because IE11 doesn't automatically assign
// row/column placement based on DOM placement - you have to manually set row
// and column numbers for each item.

var msWeekGridStyles = _objectSpread({
  display: "-ms-grid",
  msGridColumns: "(1fr)[".concat(daysInWeek, "]")
}, (0, _range2["default"])(daysInWeek).reduce(function (gridItemStyles, index) {
  gridItemStyles["& > *:nth-of-type(".concat(index + 1, ")")] = {
    display: "block",
    msGridColumn: index + 1
  };
  return gridItemStyles;
}, {}));

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var renderingCustomDate = _ref.renderingCustomDate,
      showFocusRing = _ref.showFocusRing;
  var dayBorderRadius = t("dayBorderRadius");
  return (0, _emotion.css)((0, _text["default"])(t), // HACK: CSS "grid" for IE11
  {
    tr: msWeekGridStyles
  }, {
    borderCollapse: "separate",
    borderSpacing: 0,
    tr: {
      display: "grid",
      gridTemplateColumns: "repeat(".concat(daysInWeek, ", 1fr)")
    },

    /**
     * Month header styles
     */
    "& > thead > tr:first-child > th": {
      display: "block",
      textAlign: "center",
      fontWeight: t("monthHeaderFontWeight"),
      fontSize: t("monthHeaderFontSize"),
      margin: 0,
      gridColumn: "1 / -1",
      // HACK: CSS "grid" for IE11
      msGridRow: 1,
      msGridColumn: 1,
      msGridColumnSpan: daysInWeek,
      padding: 0
    },

    /**
     * Day of week header styles
     */
    "& > thead > tr > th": {
      fontWeight: t("dayOfWeekHeaderFontWeight"),
      fontSize: t("dayOfWeekHeaderFontSize"),
      position: "relative",
      textAlign: "center",
      marginTop: t("spacingVertical") * 2,
      marginBottom: t("spacingVertical"),
      padding: 0
    },

    /**
     * Day styles
     */
    "& > tbody > tr > td:not([aria-hidden])": {
      position: "relative",
      textAlign: "center",
      cursor: "pointer",
      borderRadius: dayBorderRadius,
      color: t("dayForegroundColorDefault"),
      backgroundColor: t("dayBackgroundColorDefault"),
      zIndex: _elevation.elevationBackground,
      transition: t.transitionCss("dayMotion", ["color", "background-color", "border-radius"]),
      // If we're *not* rendering a custom day then fix the aspect ratio at
      // 0.85, otherwise leave the aspect ratio up to the custom day renderer.
      height: renderingCustomDate ? undefined : 34,
      "& > span": renderingCustomDate ? undefined : {
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      // Selected
      "&[mdn-mini-cal-state=selected]": {
        color: t("dayForegroundColorSelected"),
        backgroundColor: t("dayBackgroundColorSelected")
      },
      // Highlighted
      "&[mdn-mini-cal-state=highlighted]": {
        color: t("dayForegroundColorHighlighted"),
        backgroundColor: t("dayBackgroundColorHighlighted")
      },
      // Disabled
      "&[mdn-mini-cal-state=disabled]": {
        color: t("dayForegroundColorDisabled"),
        backgroundColor: t("dayBackgroundColorDisabled"),
        cursor: "not-allowed",
        "& > span": {
          textDecoration: "line-through"
        }
      },
      // Hover/pressed
      "&:not([mdn-mini-cal-state=disabled])": {
        "&:hover": {
          color: t("dayForegroundColorHover"),
          backgroundColor: t("dayBackgroundColorHover")
        },
        "&:active": {
          color: t("dayForegroundColorPressed"),
          backgroundColor: t("dayBackgroundColorPressed")
        }
      },
      // Current day indicator
      "&[aria-current='date']:before": {
        content: "\"\"",
        position: "absolute",
        width: t("indicatorWidth"),
        height: t("indicatorHeight"),
        backgroundColor: t("indicatorColor"),
        borderRadius: t("indicatorBorderRadius"),
        left: "50%",
        bottom: t("indicatorSpacingVertical"),
        transform: "translateX(-50%)"
      },
      // When rendering custom days, add padding to the bottom
      // so the indicator does not clash with the content. Add
      // padding to top to get vertical centering.
      padding: renderingCustomDate ? "".concat(t("indicatorHeight") + t("indicatorSpacingVertical"), "px 0") : 0,
      // Focus ring
      "&:focus": showFocusRing ? _objectSpread({
        // Turn off default focus ring
        outline: "none",
        // This is used to ensure that the focus ring is shown above all adjacent
        // elements. Revisit this once we move from an outline-based focus ring to
        // a psuedo-element-based focus ring.
        zIndex: _elevation.elevationForeground
      }, (0, _focusRing["default"])(t.tokens, {
        focus: true,
        borderRadius: dayBorderRadius,
        gapColor: t.tokens.themeBackgroundPrimaryDefault,
        offset: 4
      })) : undefined,
      // Left cap
      "&:not([mdn-mini-cal-left-cap])": {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      // Right cap
      "&:not([mdn-mini-cal-right-cap])": {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    }
  });
}, ["renderingCustomDate", "showFocusRing"]);

var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
  return prevProps.hidden && nextProps.hidden;
};

var MiniCalendarPage = /*#__PURE__*/_react["default"].memo( /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var viewDate = props.viewDate,
      locale = props.locale,
      showFocusRing = props.showFocusRing,
      dateLabel = props.dateLabel;

  var _useMemo = (0, _react.useMemo)(function () {
    return (0, _getCalendarMonth["default"])({
      date: viewDate,
      locale: locale,
      monthLabelFormat: {
        month: "long",
        year: "numeric"
      },
      headerLabelFormat: {
        weekday: (0, _dateLocales.getDateLocale)(locale).compactDayOfWeekFormat
      }
    });
  }, [viewDate, locale]),
      days = _useMemo.days,
      dayOfWeekLabels = _useMemo.dayOfWeekLabels,
      monthLabel = _useMemo.monthLabel;

  var renderingCustomDate = props.renderDate !== undefined || props.renderDay !== undefined;
  var weeks = (0, _chunk["default"])(days, daysInWeek);
  return /*#__PURE__*/_react["default"].createElement("table", {
    ref: ref,
    className: (0, _emotion.cx)(styles(props.t, {
      renderingCustomDate: renderingCustomDate,
      showFocusRing: showFocusRing
    }), props.className),
    "aria-hidden": props.hidden,
    "mdn-mini-cal-page": ""
  }, /*#__PURE__*/_react["default"].createElement("thead", {
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement("tr", {
    dateTime: "".concat((0, _dateString.getYear)(viewDate), "-").concat((0, _dateString.getMonth)(viewDate))
  }, /*#__PURE__*/_react["default"].createElement("th", null, monthLabel)), /*#__PURE__*/_react["default"].createElement("tr", null, dayOfWeekLabels.map(function (_ref2) {
    var label = _ref2.label,
        _long = _ref2["long"];
    return /*#__PURE__*/_react["default"].createElement("th", {
      key: _long,
      title: _long
    }, label);
  }))), /*#__PURE__*/_react["default"].createElement("tbody", null, weeks.map(function (week, index) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      role: "row",
      key: index
    }, week.map(function (_ref3) {
      var dateObject = _ref3.dateObject,
          dateString = _ref3.dateString,
          label = _ref3.label,
          inMonth = _ref3.inMonth;

      // If the day falls within the given month, render
      if (inMonth) {
        var selected = props.selectedDates(dateString);
        var disabled = props.disabledDates(dateString);

        var _range = props.rangeDates(dateString);

        var current = dateString === props.now;
        var leftCap = !_range || !props.rangeDates((0, _dateString.toDateString)((0, _addDays["default"])(dateObject, -1)));
        var rightCap = !_range || !props.rangeDates((0, _dateString.toDateString)((0, _addDays["default"])(dateObject, 1)));
        var state = selected ? "selected" : disabled ? "disabled" : _range ? "highlighted" : undefined;
        var formattedDate = (0, _intlDateTimeFormat.intlDateTimeFormat)(dateObject, dateFormat, locale);
        var screenReaderLabel = dateLabel ? dateLabel({
          date: dateString,
          label: formattedDate,
          current: current,
          selected: selected,
          disabled: disabled,
          range: _range
        }) : formattedDate;
        return (
          /*#__PURE__*/
          // NOTE: mdn-text is used to tell any Text components dropped into the
          // calendar via the `renderDay` function to inherit the text styles of the
          // calendar by default.
          // NOTE: keyboard interaction is handled up at the calendar level
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events
          _react["default"].createElement("td", {
            key: dateString,
            "aria-current": current ? "date" : undefined,
            "mdn-mini-cal-state": state,
            "mdn-mini-cal-left-cap": leftCap ? "" : undefined,
            "mdn-mini-cal-right-cap": rightCap ? "" : undefined,
            "mdn-text": "",
            onClick: props.onClickDate && !disabled ? function () {
              return props.onClickDate(dateString);
            } : undefined,
            id: props.dateIds(dateString),
            onMouseEnter: props.onMouseEnterDate ? function () {
              return props.onMouseEnterDate(disabled ? undefined : dateString);
            } : undefined,
            onMouseLeave: props.onMouseEnterDate ? function () {
              return props.onMouseEnterDate(undefined);
            } : undefined,
            tabIndex: dateString === props.focusDate ? "0" : "-1" // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
            ,
            role: "button",
            "aria-label": screenReaderLabel,
            "aria-disabled": disabled
          }, renderingCustomDate ? props.renderDate ? props.renderDate({
            label: "".concat(label),
            date: dateString,
            current: current,
            selected: selected,
            disabled: disabled,
            range: _range
          }) : props.renderDay({
            label: "".concat(label),
            date: dateString,
            current: current,
            selected: selected,
            disabled: disabled,
            range: _range
          }) : /*#__PURE__*/_react["default"].createElement("span", {
            "aria-hidden": "true"
          }, label))
        );
      } else {
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: dateString,
          "aria-hidden": "true",
          tabIndex: "-1"
        });
      }
    }));
  })));
}), shouldNotUpdate);

MiniCalendarPage.propTypes =  false ? {
  dateIds: _propTypes["default"].func.isRequired,
  disabledDates: _propTypes["default"].func.isRequired,
  locale: _propTypes["default"].string.isRequired,
  now: _propTypes["default"].string.isRequired,
  rangeDates: _propTypes["default"].func.isRequired,
  selectedDates: _propTypes["default"].func.isRequired,
  t: _propTypes["default"].func.isRequired,
  viewDate: _propTypes["default"].string.isRequired,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,
  dateLabel: _propTypes["default"].func,
  focusDate: _propTypes["default"].string,
  hidden: _propTypes["default"].bool,
  renderDate: _propTypes["default"].func,
  // TODO: Remove in 6.x
  renderDay: _propTypes["default"].func,
  showFocusRing: _propTypes["default"].bool,
  onClickDate: _propTypes["default"].func,
  onMouseEnterDate: _propTypes["default"].func
} : {};
MiniCalendarPage.displayName = "MiniCalendarPage";
var _default = MiniCalendarPage;
exports["default"] = _default;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(404),
    isIterateeCall = __webpack_require__(359),
    toInteger = __webpack_require__(130);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _eachDayOfInterval = _interopRequireDefault(__webpack_require__(444));

var _endOfWeek = _interopRequireDefault(__webpack_require__(1034));

var _startOfWeek = _interopRequireDefault(__webpack_require__(1035));

var _startOfMonth = _interopRequireDefault(__webpack_require__(287));

var _endOfMonth = _interopRequireDefault(__webpack_require__(288));

var _parseISO = _interopRequireDefault(__webpack_require__(286));

var _getDay = _interopRequireDefault(__webpack_require__(1036));

var _dateLocales = __webpack_require__(116);

var _intlDateTimeFormat = __webpack_require__(219);

var _dateString = __webpack_require__(174);

var weekDays = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
/**
 * Return all the days in a calendar month along with localized labels for the
 * month and days of the week.
 */

var getCalendarMonth = function getCalendarMonth(_ref) {
  var date = _ref.date,
      locale = _ref.locale,
      monthLabelFormat = _ref.monthLabelFormat,
      _ref$headerLabelForma = _ref.headerLabelFormat,
      headerLabelFormat = _ref$headerLabelForma === void 0 ? {
    weekday: "short"
  } : _ref$headerLabelForma;
  var dateObject = (0, _parseISO["default"])(date);
  var weekStartsOn = (0, _dateLocales.getDateLocale)(locale).weekStart;
  var days = (0, _eachDayOfInterval["default"])({
    start: (0, _startOfWeek["default"])((0, _startOfMonth["default"])(dateObject), {
      weekStartsOn: weekStartsOn
    }),
    end: (0, _endOfWeek["default"])((0, _endOfMonth["default"])(dateObject), {
      weekStartsOn: weekStartsOn
    })
  }).map(function (dateObject) {
    var dateString = (0, _dateString.toDateString)(dateObject);
    return {
      dateObject: dateObject,
      dateString: dateString,
      label: (0, _dateString.getDay)(dateString),
      "long": (0, _intlDateTimeFormat.intlDateTimeFormat)(dateObject, {
        month: "long",
        day: "numeric",
        year: "numeric"
      }, locale),
      inMonth: (0, _dateString.isSameMonth)(dateString, date)
    };
  });
  var dayOfWeekLabels = days.slice(0, 7).map(function (_ref2) {
    var dateObject = _ref2.dateObject;
    // We add this normalized, English weekday value to pass to renderHeader
    // so developers customizing the header won't need to write logic for
    // each locale.
    var weekday = weekDays[(0, _getDay["default"])(dateObject)];
    return {
      label: (0, _intlDateTimeFormat.intlDateTimeFormat)(dateObject, headerLabelFormat, locale),
      "long": (0, _intlDateTimeFormat.intlDateTimeFormat)(dateObject, {
        weekday: "long"
      }, locale),
      weekday: weekday
    };
  });
  var monthLabel = monthLabelFormat && (0, _intlDateTimeFormat.intlDateTimeFormat)(dateObject, monthLabelFormat, locale);
  return {
    days: days,
    dayOfWeekLabels: dayOfWeekLabels,
    monthLabel: monthLabel
  };
};

var _default = getCalendarMonth;
exports["default"] = _default;

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = endOfWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(45);





/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var weekStartsOn = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_defaultOptions_index_js__ = __webpack_require__(131);




/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_3__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var weekStartsOn = Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(45);


/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = date.getDay();
  return day;
}

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isSameYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(45);


/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isSameDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(45);


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeftStartOfDay = Object(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRightStartOfDay = Object(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["a" /* default */])(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(45);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _carouselController = _interopRequireDefault(__webpack_require__(1041));

var _default = _carouselController["default"];
exports["default"] = _default;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(77));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _range = _interopRequireDefault(__webpack_require__(159));

var _addDebouncedEventListener = _interopRequireDefault(__webpack_require__(195));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles(_ref) {
  var slideMaxHeight = _ref.slideMaxHeight,
      spacingInset = _ref.spacingInset,
      animate = _ref.animate,
      motionDuration = _ref.motionDuration,
      motionFunction = _ref.motionFunction,
      width = _ref.width;
  return (0, _emotion.css)({
    boxSizing: "border-box",
    height: slideMaxHeight ? slideMaxHeight + spacingInset * 2 : undefined,
    width: width,
    // Display block to make sure we fill all available width by default. This
    // will help avoid zero width carousels when using a container that's inline
    // by default (the children are absolutely positioned so they won't
    // contribute to the container's width).
    display: "block",
    position: "relative",
    overflow: "hidden",
    transition: animate ? "height ".concat(motionDuration, "ms ").concat(motionFunction) : undefined
  });
};

var slideStyles = function slideStyles(_ref2) {
  var _css;

  var slidesInView = _ref2.slidesInView,
      spacingHorizontal = _ref2.spacingHorizontal,
      slideWidthPercentage = _ref2.slideWidthPercentage,
      spacingInset = _ref2.spacingInset,
      index = _ref2.index,
      slideIndex = _ref2.slideIndex,
      animate = _ref2.animate,
      motionDuration = _ref2.motionDuration,
      motionFunction = _ref2.motionFunction;
  var offset = index - slideIndex; // Calculate the number of pixels we need to subtract from each slide in order
  // to fit them all in the carousel along with the requested horizontal
  // spacing. Round up to ensure that we don't clip subpixels off the last
  // slide.

  var spacingHorizontalWidthReduction = Math.ceil(spacingHorizontal * (slidesInView - 1) / slidesInView); // Positions the slide based on its offset

  var slidePosition = "".concat(offset * 100, "%");
  var slidePositionRtl = "".concat(offset * -100 + (slidesInView - 1) * 100, "%"); // Nudges based on the horizontal space between slides

  var spacingNudge = "".concat(spacingHorizontal * offset, "px");
  var spacingNudgeRtl = "".concat(spacingHorizontal * (offset - (slidesInView - 1)) * -1, "px"); // Nudges based on the percentage width of each slide

  var percentageWidthNudge = slideWidthPercentage ? "".concat((1 - slideWidthPercentage * slidesInView) * 100 / 2 * (1 / slideWidthPercentage), "%") : "0px";
  return (0, _emotion.css)((_css = {
    boxSizing: "border-box",
    position: "absolute",
    top: spacingInset,
    left: spacingInset,
    width: slideWidthPercentage ? "calc((".concat(slideWidthPercentage * 100, "% - ").concat(spacingInset * 2, "px) - ").concat(spacingHorizontalWidthReduction, "px)") : "calc(((100% - ".concat(spacingInset * 2, "px) / ").concat(slidesInView, ") - ").concat(spacingHorizontalWidthReduction, "px)"),
    transform: "translateX(".concat(slidePosition, ") translateX(").concat(spacingNudge, ") translateX(").concat(percentageWidthNudge, ")")
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    transform: " translateX(".concat(slidePositionRtl, ") translateX(").concat(spacingNudgeRtl, ") translateX(").concat(percentageWidthNudge, ")")
  }), (0, _defineProperty2["default"])(_css, "transition", animate ? "transform ".concat(motionDuration, "ms ").concat(motionFunction) : undefined), _css));
};
/**
 * This component handles the display and animation of content in carousel
 * slides. It uses a render prop for slides, which allows it to lazily render
 * them only when necessary for smoother animation and infinite lists.
 */


var CarouselController = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(CarouselController, _React$Component);

  var _super = _createSuper(CarouselController);

  function CarouselController() {
    var _this;

    (0, _classCallCheck2["default"])(this, CarouselController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "postAnimationTimeout", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "canAnimate", function () {
      return Boolean(_this.props.motionDuration && _this.props.motionFunction);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      // Track the slide index that we'll render separately from the user-provided
      // slide index. This allows us to intelligently pre-render slides when we're
      // not animating, and wait to add new slides or remove old slides until
      // animations have finished.
      renderIndex: _this.props.slideIndex,
      canAnimate: _this.canAnimate(),
      slideHeights: {}
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateSlideHeight", function (index) {
      return function (node) {
        /* eslint-disable-next-line react/no-find-dom-node */
        var domNode = _reactDom["default"].findDOMNode(node);

        if (domNode && domNode.offsetHeight && _this.state.slideHeights[index] === undefined) {
          // NOTE: offsetHeight height is used here (as opposed to
          // getBoundingClientRect) so that any css transforms (e.g. scale) are
          // ignored and the height used by the carousel is the actual height the
          // slide takes up in the layout.
          _this.setState(function (state) {
            return {
              slideHeights: _objectSpread(_objectSpread({}, state.slideHeights), {}, (0, _defineProperty2["default"])({}, index, domNode.offsetHeight))
            };
          });
        }
      };
    });
    return _this;
  }

  (0, _createClass2["default"])(CarouselController, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Clear all cached slide heights when the window is resized since the new
      // layout may cause the slide heights to change.
      this.removeWindowResizeListener = (0, _addDebouncedEventListener["default"])(window, "resize", function () {
        return _this2.setState({
          slideHeights: {}
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.postAnimationTimeout);
      this.removeWindowResizeListener();
    } // Set the height for a single slide

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      // Did the user change the index of the current slide?
      var indexChanged = this.props.slideIndex !== prevProps.slideIndex; // Is the slide index that we're rendering falling too far behind the slide
      // index provided by the user? This can happen if the user is advancing
      // slides faster than we can animate

      var renderIndexBehind = indexChanged && this.state.renderIndex !== prevProps.slideIndex; // Did a motion prop change?

      var motionChanged = this.props.motionDuration !== prevProps.motionDuration || this.props.motionFunction !== prevProps.motionFunction; // If the user is navigating too fast for us to keep up with animation then
      // turn animation off.

      if (renderIndexBehind && this.state.animate) {
        this.setState({
          canAnimate: false
        });
      } else if (motionChanged) {
        // If the user changed a motion prop then re-evaluate our animatability
        this.setState({
          canAnimate: this.canAnimate()
        });
      } // Once the current animation is complete then add/remove slides behind the
      // scenes and make sure animation is turned back on if it was turned off
      // (see above)


      if (indexChanged) {
        clearTimeout(this.postAnimationTimeout);
        this.postAnimationTimeout = setTimeout(function () {
          _this3.setState({
            renderIndex: _this3.props.slideIndex,
            canAnimate: _this3.canAnimate()
          }, _this3.props.onTransitionEnd);
        }, // Wait until 100ms after the animation has completed to ensure things
        // have settled down before rendering new slides behind-the-scenes.
        this.props.motionDuration + 100);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var props = this.props;
      var state = this.state; // Calculate the range of indices that will be in view. When the slides are
      // a percentage width of the carousel (i.e. the next/prev are "peeking"),
      // render yet another two slides so they'll be ready to enter the scene.

      var visibleIndices = (0, _range["default"])(props.slideIndex - (props.slideWidthPercentage ? 1 : 0), props.slideIndex + props.slidesInView + (props.slideWidthPercentage ? 1 : 0)); // Keep track of which slides are peeking so they are correctly set to aria-hidden

      var peekIndices = props.slideWidthPercentage ? [visibleIndices[0], visibleIndices[visibleIndices.length - 1]] : []; // Animate if we can according to the current state *and* if the render
      // index is proximate to the slide index. If the render index is far away
      // from the slide index we want to skip animation to avoid animating across
      // unrendered slides.

      var animate = state.canAnimate && Math.abs(state.renderIndex - props.slideIndex) <= 1; // If we've got animation turned on then intelligently render slides behind
      // the scenes for the smoothest animation, otherwise just render the visible
      // slides. In addition, when the slides are a percentage width of the carousel
      // (i.e. the next/prev are "peeking"), render yet another two slides so they'll
      // be ready to enter the scene.

      var renderIndices = animate ? (0, _range["default"])(state.renderIndex - (props.slideWidthPercentage ? 2 : 1), state.renderIndex + props.slidesInView + (props.slideWidthPercentage ? 2 : 1)) : visibleIndices; // Render one slide before the first visible slide, all the visible slides,
      // and one slide after the last visible slide. This will allow slides just
      // out of view to animate smoothly into view when the slideIndex is changed.

      var slides = renderIndices.map(function (index) {
        return props.renderSlide({
          index: index,
          props: {
            key: index,
            ref: _this4.updateSlideHeight(index),
            // Hide slides from screen readers if they are not visible
            // or only partially visible.
            "aria-hidden": visibleIndices.indexOf(index) === -1 || peekIndices.indexOf(index) !== -1 ? true : undefined,
            className: slideStyles({
              slidesInView: props.slidesInView,
              slideWidthPercentage: props.slideWidthPercentage,
              spacingHorizontal: props.spacingHorizontal,
              spacingInset: props.spacingInset,
              slideIndex: props.slideIndex,
              motionFunction: props.motionFunction,
              motionDuration: props.motionDuration,
              animate: animate,
              index: index
            })
          }
        });
      }); // Render at the max height of any of the visible slides

      var slideMaxHeight = visibleIndices.reduce(function (result, index) {
        return state.slideHeights[index] > result ? state.slideHeights[index] : result;
      }, 0) || undefined;
      return props.renderContainer({
        props: {
          className: styles({
            spacingInset: props.spacingInset,
            motionFunction: props.motionFunction,
            motionDuration: props.motionDuration,
            width: props.width,
            animate: animate,
            slideMaxHeight: slideMaxHeight
          }),
          children: slides
        }
      });
    }
  }]);
  return CarouselController;
}(_react["default"].Component);

(0, _defineProperty2["default"])(CarouselController, "defaultProps", {
  slidesInView: 1,
  spacingHorizontal: 0,
  spacingInset: 0,
  width: "100%"
});
CarouselController.propTypes =  false ? {
  /**
   * The function used to render the carousel's container element. The only
   * argument passed to this function is an object with a "props" field. These
   * props should be passed through to the element.
   */
  renderContainer: _propTypes["default"].func.isRequired,

  /**
   * The function used to render a slide element in the carousel. The only
   * argument passed to this function is an object with a "props" field and an
   * "index" field. The props should be passed through to the slide element.
   * The index can be used to determine what the contents of the slide should
   * be.
   */
  renderSlide: _propTypes["default"].func.isRequired,

  /**
   * The index of the current slide.
   */
  slideIndex: _propTypes["default"].number.isRequired,

  /**
   * The duration it should take to animate from one slide to the next in
   * milliseconds.
   */
  motionDuration: _propTypes["default"].number,

  /**
   * The animation function to use when animating from one slide to the next.
   */
  motionFunction: _propTypes["default"].string,

  /**
   * The percentage width each slide takes up relative to the carousel. Use this to
   * create a "peek" of prev/next slides. Use float between 0 ~ 1 e.g. 0.4 for 40%.
   */
  slideWidthPercentage: _propTypes["default"].number,

  /**
   * The number of slides to show at a time.
   */
  slidesInView: _propTypes["default"].number,

  /**
   * The horizontal "gutter" spacing between each slide.
   */
  spacingHorizontal: _propTypes["default"].number,

  /**
   * The inset "padding" spacing for each slide.
   */
  spacingInset: _propTypes["default"].number,

  /**
   * The width of the carousel. Defaults to "100%" so that it fills its
   * parent element.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * A callback to run any time the carousel has finished transitioning to new
   * slide(s).
   */
  onTransitionEnd: _propTypes["default"].func
} : {};
var _default = CarouselController;
exports["default"] = _default;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _emotion = __webpack_require__(11);

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _find2 = _interopRequireDefault(__webpack_require__(96));

var _padStart = _interopRequireDefault(__webpack_require__(217));

var _timePicker = _interopRequireDefault(__webpack_require__(289));

var _clock = _interopRequireDefault(__webpack_require__(1043));

var _alertErrorSmall = _interopRequireDefault(__webpack_require__(252));

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _timeParts = __webpack_require__(1044);

var _input = _interopRequireDefault(__webpack_require__(22));

var _mask = _interopRequireDefault(__webpack_require__(284));

var _timePickerPopover = _interopRequireDefault(__webpack_require__(1046));

var _timePickerOptions = _interopRequireDefault(__webpack_require__(1047));

var _timePickerInvalidPopover = _interopRequireDefault(__webpack_require__(1048));

var _inputMonospacePlaceholder = _interopRequireDefault(__webpack_require__(442));

var _theme = __webpack_require__(24);

var _dateLocales = _interopRequireDefault(__webpack_require__(116));

var _token = __webpack_require__(20);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

var _supportTextWrapper = _interopRequireDefault(__webpack_require__(138));

var _getSupportTextAriaDescribedby = _interopRequireDefault(__webpack_require__(139));

var _functional = __webpack_require__(38);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var inputStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var focus = _ref.focus,
      filled = _ref.filled;
  return (0, _emotion.css)({
    letterSpacing: focus || filled ? t("inputValueLetterSpacing") : undefined,
    // HACK: We only accept dates in English numerals for now - since we don't yet
    // support other locale numerals, eg: ١،٢،٣،٤،٥،٦،٨،٩،٠ 一，二，三，四，五, etc.
    // Dates entered in English numerals are read and typed LTR.
    direction: "ltr"
  });
}, ["focus", "filled"]);
var widthStyles = (0, _functional.memoizeByKeys)(function (_ref2) {
  var width = _ref2.width;
  return (0, _emotion.css)({
    width: width,
    // If an explicit width is set then don't allow the textarea to flex
    flex: width ? "none !important" : undefined
  });
}, ["width"]);
var placeholderChar = "\u2007"; // "99:23:14" -> true
// "--:a3:14" -> false

var validTimeStringFormat = function validTimeStringFormat(timeString) {
  return /\d{2}:\d{2}:\d{2}/g.test(timeString);
};

var partsToMask = function partsToMask(parts) {
  // Get the mask string by iterating over the ordered array of parts
  var maskString = parts.map(function (_ref3) {
    var type = _ref3.type,
        value = _ref3.value,
        options = _ref3.options;

    switch (type) {
      case "hour":
        return "##";

      case "minute":
        return "##";

      case "second":
        return "##";

      case "dayPeriod":
        // Assume each day period option is the same length
        return "*".repeat(options[0].length);

      case "literal":
        return value;
    }
  }).join("");
  return new _mask["default"](maskString, {
    formatChars: {
      "#": "[0-9]",
      "*": "."
    },
    placeholderChar: placeholderChar
  });
}; // The TimePicker requires 2-digit format for hours, minutes, and seconds. We
// could force the "2-digit" setting on in the format object we pass to the
// Intl.DateTime APIs, but some browsers and versions of Node ignore the 2-digit
// format option for the "hour" field when in 12 hour mode.


var forceTwoDigit = function forceTwoDigit(part) {
  return part.type === "hour" || part.type === "minute" || part.type === "second" ? _objectSpread(_objectSpread({}, part), {}, {
    value: part.value ? (0, _padStart["default"])(part.value, 2, "0") : undefined,
    options: part.options ? part.options.map(function (option) {
      return (0, _padStart["default"])(option, 2, "0");
    }) : undefined
  }) : part;
};

var TimePicker = /*#__PURE__*/_react["default"].forwardRef(function (props, forwardedRef) {
  var value = props.value,
      format = props.format,
      onChange = props.onChange,
      idProp = props.id;
  var id = (0, _react.useMemo)(function () {
    return idProp || (0, _uniqueId["default"])("timepicker-");
  }, [idProp]); // HACK: Until we are able to localize Arabic numbers
  // we'll set Arabic to en-US. Currently the hours and AM/PM
  // are being localized into Arabic.

  var locale = props.locale == "ar-AE" ? "en-US" : props.locale;
  var inputRef = (0, _react.useRef)();
  var t = (0, _theme.useTheme)(_timePicker["default"], "timePicker");

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1]; // [{ type: "hour", options: ["12", "01",...]}, { type: "literal", value: ":" }]


  var partOptions = (0, _react.useMemo)(function () {
    return (0, _timeParts.getPartOptions)(locale, format).map(forceTwoDigit);
  }, [locale, format]); // Position each part will appear in a formatted string
  // { hour: { start: 0, end: 1 }, dayPeriod: { start: 7, end: 8 } }

  var partPositions = (0, _react.useMemo)(function () {
    return (0, _timeParts.getPartPositions)(partOptions);
  }, [partOptions]); // All non literal options (used by TimePickerOptions)

  var nonLiteralOptions = (0, _react.useMemo)(function () {
    return partOptions.filter(function (_ref4) {
      var type = _ref4.type;
      return type !== "literal";
    });
  }, [partOptions]); // An "empty" string fallback. Used in onSelectOption to ensure we slice updated
  // values into the correct positions for the input value

  var placeholderInput = (0, _react.useMemo)(function () {
    return partOptions.map(function (_ref5) {
      var value = _ref5.value,
          options = _ref5.options;
      return value || placeholderChar.repeat(options[0].length);
    }).join("");
  }, [partOptions]); // The value of the Input

  var _useState3 = (0, _react.useState)(function () {
    if (value && validTimeStringFormat(value)) {
      return (0, _timeParts.timeStringToParts)(value, format, locale).map(forceTwoDigit).map(function (_ref6) {
        var value = _ref6.value;
        return value;
      }).join("");
    } else return "";
  }),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1]; // Ref memory of whether the last input was valid. Used in useEffect to determine
  // if we should clear the Input because of an outside state change, or keep the
  // invalid Input alive because it is still being updated


  var inputWasValid = (0, _react.useRef)(true);
  var mask = (0, _react.useMemo)(function () {
    return partsToMask(partOptions);
  }, [partOptions]); // Object of part values parsed from the current input
  // { hour: "10", minute: "--", second: "A3" }

  var partValues = (0, _react.useMemo)(function () {
    return (0, _timeParts.getPartValues)(inputValue, partPositions);
  }, [inputValue, partPositions]); // Check if every part's value exist in its given options

  var validInput = (0, _react.useMemo)(function () {
    var valid = true;

    var _loop = function _loop(part) {
      var _find = (0, _find2["default"])(partOptions, ["type", part]),
          options = _find.options;

      var partValue = partValues[part];
      var validOption = options.some(function (option) {
        return option.toLocaleLowerCase(locale) === partValue.toLocaleLowerCase(locale);
      });

      if (!validOption) {
        valid = false;
        return "break";
      }
    };

    for (var part in partValues) {
      var _ret = _loop(part);

      if (_ret === "break") break;
    }

    inputWasValid.current = valid;
    return valid;
  }, [partValues, partOptions, locale]); // If the _prop value_ changes and is valid, parse into parts and update
  // _input value_

  var previousValue = (0, _react.useRef)(value);
  (0, _react.useEffect)(function () {
    if (value !== previousValue.current) {
      if (value && validTimeStringFormat(value)) {
        var parts = (0, _timeParts.timeStringToParts)(value, format, locale).map(forceTwoDigit);
        var next = parts.map(function (_ref7) {
          var value = _ref7.value;
          return value;
        }).join("");
        setInputValue(next);
      } // If the last _input value_ was valid, but the current _prop value_ is
      // not, clear input value. Else, let the input value ride until it _is_
      // valid.
      else if (inputWasValid.current) {
        setInputValue("");
      }

      previousValue.current = value;
    }
  }, [value, format, locale]); // If the _input value_ changes and is valid, parse into parts and update
  // _state value_

  var previousInputValue = (0, _react.useRef)(inputValue);
  (0, _react.useEffect)(function () {
    if (inputValue !== previousInputValue.current) {
      if (validInput) {
        onChange((0, _timeParts.partsToTimeString)(partValues, partOptions, format, locale));
      } else if (value) {
        onChange("");
      }

      previousInputValue.current = inputValue;
    }
  }, [partValues, partOptions, format, locale, validInput, onChange, inputValue, value]); // Update input string when a user selects an option

  var onSelectOption = (0, _react.useCallback)(function (type, value) {
    // Fall back to the placeholder input so we slice the values into the correct spots
    var string = inputValue || placeholderInput;
    var _partPositions$type = partPositions[type],
        start = _partPositions$type.start,
        end = _partPositions$type.end;
    setInputValue("".concat(string.slice(0, start)).concat(value).concat(string.slice(end)));
  }, [partPositions, inputValue, placeholderInput]); // Clear input if the user changes focus and without constructing a valid time

  var onBlur = (0, _react.useCallback)(function () {
    setFocus(false);
    if (!validInput) setInputValue("");
  }, [validInput]);
  var onFocus = (0, _react.useCallback)(function () {
    setFocus(true); // HACK: Move cursor to beginning on focus if the value is empty.
    // This _should_ be doable in React input mask but, sadly, is not working 😢 https://github.com/sanniassin/react-input-mask/tree/2.0.4#beforemaskedvaluechange--function
    // This waits a beat for input mask to add its value before moving the cursor.

    if (!value) setTimeout(function () {
      return inputRef.current.setSelectionRange(0, 0);
    }, 0);
  }, [value]);
  var assignRefs = (0, _react.useCallback)(function (inputNode) {
    inputRef.current = inputNode;
    if (forwardedRef) forwardedRef.current = inputNode;
  }, [forwardedRef]);
  var invalidPopoverOpen = focus && inputValue && !inputValue.includes(placeholderChar) && !validInput;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]); // If there is not helperText, constraintText, or errorMessage
  // then the aria-describedby is empty.

  var ariaDescribedbyValue = (0, _getSupportTextAriaDescribedby["default"])({
    id: id,
    hasHelperText: !!props.helperText,
    hasConstraintText: !!props.constraintText,
    hasErrorMessage: !!props.errorMessage,
    errorMessageFirst: props.size === "xlarge"
  });
  return /*#__PURE__*/_react["default"].createElement(_supportTextWrapper["default"], {
    id: id,
    helperText: props.helperText,
    constraintText: props.constraintText,
    errorMessage: props.errorMessage,
    helperBelowFormField: props.size === "xlarge",
    className: widthStyles({
      width: props.width
    })
  }, /*#__PURE__*/_react["default"].createElement(_timePickerPopover["default"], {
    valueFilled: Boolean(value),
    onBlur: onBlur,
    onFocus: onFocus,
    width: props.width,
    disabled: props.disabled,
    anchor: function anchor(_ref8) {
      var onFocus = _ref8.onFocus,
          onBlur = _ref8.onBlur,
          popoverIsOpen = _ref8.popoverIsOpen;
      return /*#__PURE__*/_react["default"].createElement(_input["default"], (0, _extends2["default"])({
        ref: assignRefs,
        value: inputValue,
        onChange: setInputValue,
        disabled: props.disabled,
        error: props.error,
        placeholder: props.placeholder,
        focus: popoverIsOpen ? true : undefined,
        label: props.label,
        id: id,
        size: props.size,
        mask: mask,
        width: props.width,
        minWidth: props.minWidth,
        onBlur: onBlur,
        onFocus: onFocus,
        className: inputStyles(t, {
          filled: Boolean(inputValue),
          focus: focus
        }),
        suffix: props.suffix,
        suffixIconTokens: {
          // HACK: Keep the clock icon width & height to ensure the input
          // size doesn't change when switching icons.
          iconWidth: _clock["default"].iconClockWidth,
          iconHeight: _clock["default"].iconClockHeight,
          iconData: invalidPopoverOpen ? _alertErrorSmall["default"].iconAlertErrorSmallData : props.showIcon ? _clock["default"].iconClockData : undefined
        },
        "aria-describedby": ariaDescribedbyValue
      }, passThroughProps), focus ? /*#__PURE__*/_react["default"].createElement(_inputMonospacePlaceholder["default"], {
        t: t,
        mask: mask,
        disabled: props.disabled,
        value: inputValue
      }) : undefined, /*#__PURE__*/_react["default"].createElement(_timePickerInvalidPopover["default"], {
        inputRef: inputRef,
        t: t,
        open: Boolean(invalidPopoverOpen)
      }, props.invalidInputMessage));
    }
  }, function (_ref9) {
    var anchorRect = _ref9.anchorRect;
    return /*#__PURE__*/_react["default"].createElement(_timePickerOptions["default"], {
      options: nonLiteralOptions,
      values: partValues,
      onSelectOption: onSelectOption,
      minWidth: anchorRect.width
    });
  }), " ");
});

TimePicker.displayName = "TimePicker";
TimePicker.propTypes =  false ? {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * If adding a label with `aria-label`, first consider using the `label` prop
   * which will add a visible label and set the size to `xlarge`.
   *
   * If `constraintText`, `helperText`, and/or an `errorMessage` are provided to
   * the TimePicker these will be used to generate the `aria-describedby` prop.
   * This can be overridden by explicitly setting `aria-describedby` on the TimePicker.
   *
   * @since 5.10.1
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Add constraint text to provide critical information regarding time picker content.
   *
   * @since 5.22.0
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   *
   * @since 5.10.1
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with an `errorMessage`.
   */
  error: _propTypes["default"].bool,

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the TimePicker.
   *
   * @since 5.22.0
   */
  errorMessage: _propTypes["default"].string,

  /**
   * The format of the time. See [Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat) for available values.
   *
   * NOTE: The "hour", "minute", and "second" fields will all be formatted as
   * "2-digit" regardless of the format passed in here.
   *
   * NOTE: This cannot be changed after the component is mounted.
   */
  format: _propTypes["default"].object,

  /**
   * Add helper text to provide additional instruction.
   *
   * @since 5.22.0
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * The message that appears when a user inputs an invalid time. We recommend including the field name and details on how to correct the error for improved accessibility for screen-reader users.
   */
  invalidInputMessage: _propTypes["default"].string,

  /**
   * A label for the input.
   *
   * If this prop is provided the `size` prop will be ignored and set to `xlarge`.
   */
  label: _propTypes["default"].string,

  /**
   * The locale to use when rendering times. See the [Intl API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl) for more information
   * about date internationalization in JS.
   */
  locale: _propTypes["default"].oneOf(Object.keys(_dateLocales["default"])),

  /**
   * Set the minimum width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * Text that is shown in place of the select's value when nothing is selected.
   *
   * This text is not visible when an option is selected, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   */
  placeholder: _propTypes["default"].string,

  /**
   * Sets the maximum height of the popover containing the select's options.
   * This is helpful if you have a very long list of options but don't want
   * to show a very tall popover. The option list is scrollable, so any
   * options that overflow the popover will still be accessible.
   */
  popoverMaxHeight: _propTypes["default"].number,

  /**
   * Set to false to hide the clock icon from the input.
   */
  showIcon: _propTypes["default"].bool,

  /**
   * Sets the size of the component using a preset.
   *
   * If the `label` prop is provided this prop will be ignored (the label
   * requires a particular amount of space which is not configurable).
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * Static text to show in an end-cap appended to the component.
   *
   * To add a selectable suffix, see the `InputGroup` component.
   */
  suffix: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * The value of the currently selected time option in the format HH:mm:ss (ex. "23:50:10")
   *
   * Update this when `onChange` is called to ensure the component is interactive
   * (see the documentation for the `onChange` prop).
   */
  value: _propTypes["default"].string,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by selecting an option). The new value will be
   * passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func
} : {};
TimePicker.defaultProps = {
  format: {
    hour: "2-digit",
    minute: "2-digit"
  },
  showIcon: true,
  size: "medium",
  locale: "en-US",
  invalidInputMessage: "This value is not a valid time."
};
var _default = TimePicker;
exports["default"] = _default;

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconClockData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3ccircle cx='12' cy='12' r='11'/%3e%3cpath d='M12 6v6l4 4'/%3e%3c/g%3e%3c/svg%3e",
  iconClockWidth: 24,
  iconClockHeight: 24
};

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeStringToParts = exports.partsToTimeString = exports.getPartValues = exports.getPartPositions = exports.getPartOptions = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _padStart = _interopRequireDefault(__webpack_require__(217));

var _range = _interopRequireDefault(__webpack_require__(159));

var _includes = _interopRequireDefault(__webpack_require__(409));

var _find = _interopRequireDefault(__webpack_require__(96));

var _timeString = __webpack_require__(1045);

var _intlDateTimeFormat = __webpack_require__(219);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// The hours of the day formatted "HH:00:00"
var hours = (0, _range["default"])(0, 24).map(function (hour) {
  return "".concat((0, _padStart["default"])(hour, 2, 0), ":00:00");
}); // Used for minutes or seconds formatted "##" (ex. "59")

var zeroToSixty = (0, _range["default"])(0, 60).map(function (i) {
  return "".concat((0, _padStart["default"])(i, 2, 0));
});
var defaultFormat = {
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
};
/**
 * Returns an array of "time part" options formatted to a locale and format object.
 * Array is ordered how a localized time string would be constructed.
 *
 * getPartOptions("zh-CN") ->
 * [
 *   { type: "dayPeriod", options: ["上午", "下午"] },
 *   { type: "hour", options: ["12", "01", "02",..., "11"] },
 *   { type: "literal", value: ":" },
 *   { type: "minute", options: ["00", "01",..., "59"] }
 * ]
 */

var getPartOptions = function getPartOptions(locale) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFormat;
  // Get the parts (hour, minute, second, dayPeriod or whatever else is in format)
  // for each hour
  var partsPerHour = hours.map(_timeString.createDateAtTime).map(function (hour) {
    return (0, _intlDateTimeFormat.intlDateTimeFormatToParts)(hour, format, locale);
  });

  var _partsPerHour = (0, _slicedToArray2["default"])(partsPerHour, 1),
      sampleHour = _partsPerHour[0]; // Record which parts exists and the order they appear


  var parts = sampleHour.map(function (_ref) {
    var type = _ref.type;
    return type;
  }); // Defer to hardcoded values for seconds and minutes and ignore literals

  var lookupParts = parts.filter(function (part) {
    return part !== "second" && part !== "minute" && part !== "literal";
  }); // For each hour, add unique values for each part to our collection of values

  var values = partsPerHour.reduce(function (values, hourParts) {
    var _iterator = _createForOfIteratorHelper(lookupParts),
        _step;

    try {
      var _loop = function _loop() {
        var part = _step.value;

        var _ref2 = (0, _find["default"])(hourParts, function (_ref3) {
          var type = _ref3.type;
          return type === part;
        }) || {},
            value = _ref2.value;

        if (value && !(0, _includes["default"])(values[part], value)) {
          values[part] = values[part] ? values[part].concat(value) : [value];
        }
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return values;
  }, {
    minute: zeroToSixty,
    second: zeroToSixty
  });
  return parts.map(function (type, index) {
    return type === "literal" ? {
      type: type,
      value: sampleHour[index].value
    } : {
      type: type,
      options: values[type]
    };
  });
};
/**
 * Given an array of parts, returns an object whose keys are the part types
 * with options (non literals) and whose values are an object of the start/end
 * position. Useful when updating the formatted time string ("04:-- PM") or
 * constructing the ISO time string ("04:55:55")
 *
 * getPartPositions([
 *   { type: "hour", options: ["12",...]},
 *   { type: "literal", value: ":" },
 *   { type: "minute", options: ["01", ...]}
 * ]) ->
 * { hour: { start: 0, end: 1 }, minute: { start: 3, end: 4 }}
 */


exports.getPartOptions = getPartOptions;

var getPartPositions = function getPartPositions(parts) {
  var cursor = 0;
  return parts.reduce(function (partPositions, _ref4) {
    var type = _ref4.type,
        options = _ref4.options,
        value = _ref4.value;

    var _ref5 = options ? options[0] : value,
        length = _ref5.length;

    if (options) partPositions[type] = {
      start: cursor,
      end: cursor + length
    };
    cursor += length;
    return partPositions;
  }, {});
};
/**
 * Parses a formatted time string with the help of part positions.
 *
 * getPartPositions("10:--:A3 PM", { hour: { start: 0, end: 1 }, ...}) ->
 * { hour: "10", minute: "--", second: "A3", dayPeriod: "PM" }
 */


exports.getPartPositions = getPartPositions;

var getPartValues = function getPartValues(string, partPositions) {
  var partValues = {};

  for (var part in partPositions) {
    var _partPositions$part = partPositions[part],
        start = _partPositions$part.start,
        end = _partPositions$part.end;
    partValues[part] = string.slice(start, end);
  }

  return partValues;
};
/**
 * Returns parts given a time string "HH:mm:ss", format, and locale.
 * timeStringToParts("23:59:59", { hour: "2-digit", minute: "2-digit" },"en-US") ->
 * [
 *   { "type": "hour", "value": "11" },
 *   { "type": "literal", "value": ":" },
 *   { "type": "minute", "value": "59" },
 *   { "type": "literal", "value": " " },
 *   { "type": "dayPeriod", "value": "PM" }
 * ]
 */


exports.getPartValues = getPartValues;

var timeStringToParts = function timeStringToParts(timeString, format, locale) {
  return (0, _intlDateTimeFormat.intlDateTimeFormatToParts)((0, _timeString.createDateAtTime)(timeString), format, locale);
}; // Resolves a formatted hour (ex. the 8 in "08:30 PM") to the hour cycle and an
// evening flag.
// resolveHourToCycle(8, "h12", true) -> 20
// Read more on hourCycle https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle


exports.timeStringToParts = timeStringToParts;

var resolveHourToCycle = function resolveHourToCycle(hour, hourCycle, evening) {
  switch (hourCycle) {
    case "h24":
      return hour === 24 ? 0 : hour;

    case "h23":
      return hour;

    case "h12":
      return hour === 12 && !evening ? 0 : hour < 12 && evening ? hour + 12 : hour;

    case "h11":
      return hour === 0 && evening ? 12 : evening ? hour + 12 : hour;
  }
};
/**
 * Constructs a time string "HH:mm:ss" out of part values, part options, format
 * and locale.
 */


var partsToTimeString = function partsToTimeString(partValues, partOptions, format, locale) {
  // Get numeric value of each time part
  var hour = Number(partValues["hour"]);
  var minute = Number(partValues["minute"]);
  var second = Number(partValues["second"] || 0); // Determine if we are in the evening and need to resolve hours to get ISO time

  var _intlDateTimeFormatRe = (0, _intlDateTimeFormat.intlDateTimeFormatResolvedOptions)(format, locale),
      hourCycle = _intlDateTimeFormatRe.hourCycle;

  var _ref6 = (0, _find["default"])(partOptions, ["type", "dayPeriod"]) || {},
      dayPeriodOptions = _ref6.options;

  var dayPeriod = partValues["dayPeriod"];
  var evening = dayPeriod && dayPeriodOptions[1] && dayPeriod.toLocaleLowerCase(locale) === dayPeriodOptions[1].toLocaleLowerCase(locale); // Resolve hour to hour cycle and if we are in the evening

  var resolvedHour = resolveHourToCycle(hour, hourCycle, evening); // Construct final time string

  return "".concat((0, _padStart["default"])(resolvedHour, 2, 0), ":").concat((0, _padStart["default"])(minute, 2, 0), ":").concat((0, _padStart["default"])(second, 2, 0));
};

exports.partsToTimeString = partsToTimeString;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toDateTimeString = exports.parseTimeString = exports.getTimeLabel = exports.createDateAtTime = exports.addHours = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _padStart = _interopRequireDefault(__webpack_require__(217));

/**
 * This module contains utilities that work with time strings in the format
 * "HH:mm"
 */

/**
 * Convert a date object into a date + time string (e.g. "2018-12-31 03:20").
 */
var toDateTimeString = function toDateTimeString(dateObject) {
  return "".concat((0, _padStart["default"])(dateObject.getFullYear(), 4, "0"), "-").concat((0, _padStart["default"])(dateObject.getMonth() + 1, 2, "0"), "-").concat((0, _padStart["default"])(dateObject.getDate(), 2, "0"), " ").concat((0, _padStart["default"])(dateObject.getHours(), 2, "0"), ":").concat((0, _padStart["default"])(dateObject.getMinutes(), 2, "0"));
};
/**
 * Returns hour, minutes, and seconds as numbers time string
 * parseTimeString("02:30") -> { hour: 2, minute: 30, seconds: 0 }
 * parseTimeString("02:30:55") -> { hour: 2, minute: 30, seconds: 55 }
 */


exports.toDateTimeString = toDateTimeString;

var parseTimeString = function parseTimeString(timeString) {
  var _$exec = /([\d]+):([\d]+):?([\d]+)?/.exec(timeString),
      _$exec2 = (0, _slicedToArray2["default"])(_$exec, 4),
      hourString = _$exec2[1],
      minutesString = _$exec2[2],
      _$exec2$ = _$exec2[3],
      secondsString = _$exec2$ === void 0 ? "00" : _$exec2$; // We use Number over parseInt here because parseInt will assume
  // an 🤖 octal number if there's a leading zero (which will be the
  // case for time strings like "02:00")
  // https://stackoverflow.com/a/4090577


  return {
    hour: Number(hourString),
    minutes: Number(minutesString),
    seconds: Number(secondsString)
  };
};
/*
 * Create a date object at a specific time
 */


exports.parseTimeString = parseTimeString;

var createDateAtTime = function createDateAtTime(timeString) {
  var _parseTimeString = parseTimeString(timeString),
      hour = _parseTimeString.hour,
      minutes = _parseTimeString.minutes,
      seconds = _parseTimeString.seconds;

  var date = new Date();
  date.setHours(hour);
  date.setMinutes(minutes);
  date.setSeconds(seconds);
  return date;
};
/*
 * Adds hours to a time string by an increment. Returns time string
 * addHours("12:33", -3) // returns "09:33"
 */


exports.createDateAtTime = createDateAtTime;

var addHours = function addHours(timeString, increment) {
  var _parseTimeString2 = parseTimeString(timeString),
      hour = _parseTimeString2.hour,
      minutes = _parseTimeString2.minutes;

  return "".concat((0, _padStart["default"])(hour + increment, 2, "0"), ":").concat((0, _padStart["default"])(minutes, 2, "0"));
};
/**
 * Returns localized time label from a time string.
 * getTimeLabel({ time: "14:00", locale: "zh-CN" }) // returns 下午02:00
 */


exports.addHours = addHours;

var getTimeLabel = function getTimeLabel(_ref) {
  var time = _ref.time,
      locale = _ref.locale,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? {
    hour: "2-digit",
    minute: "2-digit"
  } : _ref$format;
  return createDateAtTime(time).toLocaleTimeString(locale, format);
};

exports.getTimeLabel = getTimeLabel;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _keycode = _interopRequireDefault(__webpack_require__(72));

var _noop = _interopRequireDefault(__webpack_require__(59));

var _timePicker = _interopRequireDefault(__webpack_require__(289));

var _popoverController = _interopRequireDefault(__webpack_require__(99));

var _focusTrap = _interopRequireDefault(__webpack_require__(170));

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _theme = __webpack_require__(24);

var _token = __webpack_require__(20);

var _functional = __webpack_require__(38);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var width = _ref.width;
  return (0, _emotion.css)({
    display: "flex",
    flexDirection: "row",
    width: width,
    "& > *": {
      width: "100%",
      flex: "auto"
    }
  });
}, ["width"]);
var popoverStyles = (0, _functional.memoize)(function (t) {
  return (0, _emotion.css)({
    outline: "none",
    border: t.borderCss("popoverBorder"),
    borderRadius: t("popoverBorderRadius"),
    boxShadow: t.boxShadowCss("popoverDropShadow"),
    backgroundColor: t("popoverBackgroundColor"),
    overflow: "hidden",
    display: "flex",
    flexDirection: "row",
    zIndex: t("popoverElevation"),
    // HACK: We only accept dates in English numerals for now - since we don't yet
    // support other locale numerals, eg: ١،٢،٣،٤،٥،٦،٨،٩،٠ 一，二，三，四，五, etc.
    // Dates entered in English numerals are read and typed LTR.
    direction: "ltr"
  });
});
/**
 * A helper for rendering the time picker popover. The main value add of this
 * component is that it handles all the low-level popover, focus, and keyboard
 * behavior (e.g. tab from time picker input to time picker calendar).
 */

var TimePickerPopover = function TimePickerPopover(props) {
  var rootRef = (0, _react.useRef)();
  var popoverRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      popoverIsOpen = _useState2[0],
      setPopoverIsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      shouldFocusPopover = _useState4[0],
      setShouldFocusPopover = _useState4[1];

  var t = (0, _theme.useTheme)(_timePicker["default"], "timePicker"); // Determines if the user is focused anywhere in the time picker's popover

  var popoverHasFocus = (0, _react.useCallback)(function () {
    return popoverRef.current && popoverRef.current.contains(document.activeElement);
  }, [popoverRef]); // Transfers focus to the mini calendar within the time picker's popover

  var focusOptionList = (0, _react.useCallback)(function () {
    return popoverRef.current.querySelector('[role="listbox"]:first-child').focus();
  }, [popoverRef]); // Closes the popover and transfers focus back to the time input field if
  // necessary

  var closePopover = (0, _react.useCallback)(function () {
    // If the popover has focus, transfer focus back to the last time input
    // field.
    if (popoverHasFocus()) {
      var inputs = rootRef.current.querySelectorAll("input");
      inputs[inputs.length - 1].focus();
    } // Close the popover


    setPopoverIsOpen(false);
  }, [popoverHasFocus, rootRef, setPopoverIsOpen]); // Called when the popover opens. Transfers focus to the mini calendar if
  // desired.

  var onOpen = (0, _react.useCallback)(function () {
    if (shouldFocusPopover) {
      focusOptionList();
    }
  }, [shouldFocusPopover, focusOptionList]); // Closes the popover when the user moves focus away from both the time
  // picker's popover and time input field

  var onBlurProp = props.onBlur;
  var onBlur = (0, _react.useCallback)(function (event) {
    onBlurProp(event);
    closePopover();
  }, [onBlurProp, closePopover]); // Opens the popover when the user mouses down on the time picker

  var onMouseDown = (0, _react.useCallback)(function (event) {
    if (!popoverIsOpen && event.target !== rootRef.current && !props.disabled) {
      setShouldFocusPopover(false);
      setPopoverIsOpen(true);
    }
  }, [popoverIsOpen, rootRef, setPopoverIsOpen, setShouldFocusPopover, props.disabled]); // Listens to key presses in order to:
  // - Close the popover when the "esc" key is pressed
  // - Close the popover when the "enter" key is pressed after a time has been
  //   typed in the time input field
  // - Open the popover and transfer focus to it when the "down" key is pressed

  var valueFilled = props.valueFilled;
  var onKeyDown = (0, _react.useCallback)(function (event) {
    var key = (0, _keycode["default"])(event);
    var printableKey = key && key.length === 1 ? key : undefined; // If the user hits escape then close the time picker

    if (key === "esc" && popoverIsOpen) {
      closePopover(); // Stop propagating the event upwards. This ensures that a parent element
      // (e.g. a modal) won't also handle the escape key.

      event.stopPropagation();
    } // If user hits the enter key after supplying a value via the input field
    // then close the popover
    else if (key === "enter" && valueFilled && popoverIsOpen && !popoverHasFocus()) {
      closePopover();
      event.preventDefault();
    } // If the down arrow key is pressed make sure the popover is open and it has
    // focus
    else if (key === "down") {
      // If the popover is closed then open it (focus will be transferred
      // afterwards when the popover ref is ready).
      if (!popoverIsOpen) {
        setShouldFocusPopover(true);
        setPopoverIsOpen(true);
      } // If the popover is open but not focused then move focus to the day
      // picker.
      else if (!popoverHasFocus()) {
        focusOptionList();
      }

      event.preventDefault();
    } // If the user presses a printable key or backspace, make sure the input
    // is in focus to receive those key strokes.
    else if (printableKey || key === "backspace") {
      var inputs = rootRef.current.querySelectorAll("input");
      inputs[inputs.length - 1].focus();
    }
  }, [popoverIsOpen, popoverHasFocus, setShouldFocusPopover, valueFilled, setPopoverIsOpen, closePopover, focusOptionList]);

  var _useFocus = (0, _useFocus2["default"])({
    onFocus: props.onFocus,
    onBlur: onBlur,
    multipleNodes: true
  }),
      focusProps = _useFocus.focusProps;

  return /*#__PURE__*/_react["default"].createElement("div", {
    onKeyDown: onKeyDown,
    onMouseDown: onMouseDown,
    className: styles(t, props),
    ref: rootRef
  }, props.anchor(_objectSpread(_objectSpread({}, focusProps), {}, {
    popoverIsOpen: popoverIsOpen
  })), /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
    open: popoverIsOpen,
    anchorNode: rootRef.current,
    anchorOrigin: "bottom left",
    popoverOrigin: "top left",
    offsetVertical: t("popoverSpacingVertical"),
    onOpen: onOpen,
    maxHeight: 180
  }, function (_ref2) {
    var popoverStyle = _ref2.popoverStyle,
        anchorRect = _ref2.anchorRect;
    return /*#__PURE__*/_react["default"].createElement(_focusTrap["default"], null, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, focusProps, {
      tabIndex: "-1",
      className: "".concat(popoverStyles(t), " ").concat(popoverStyle),
      ref: popoverRef
    }), props.children({
      closePopover: closePopover,
      popoverIsOpen: popoverIsOpen,
      anchorRect: anchorRect
    })));
  }));
};

TimePickerPopover.displayName = "TimePickerPopover";
TimePickerPopover.propTypes =  false ? {
  anchor: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].func.isRequired,
  valueFilled: _propTypes["default"].bool.isRequired,
  disabled: _propTypes["default"].bool,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func
} : {};
TimePickerPopover.defaultProps = {
  disabled: false,
  onFocus: _noop["default"],
  onBlur: _noop["default"]
};
var _default = TimePickerPopover;
exports["default"] = _default;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _emotion = __webpack_require__(11);

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _timePicker = _interopRequireDefault(__webpack_require__(289));

var _optionList = _interopRequireWildcard(__webpack_require__(169));

var _theme = __webpack_require__(24);

var _token = __webpack_require__(20);

var _text = _interopRequireDefault(__webpack_require__(47));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var wrapperStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var minWidth = _ref.minWidth;
  return (0, _emotion.css)((0, _text["default"])(t), {
    boxSizing: "border-box",
    minWidth: minWidth,
    overflowY: "auto",
    display: "flex",
    flexDirection: "row",
    padding: "0 ".concat(t("optionsSpacingHorizontal"), "px"),
    "& > [role=listbox]": {
      flex: 1,
      overflowY: "auto",
      padding: "0 ".concat(t("optionsSpacingHorizontal"), "px")
    },
    "& [role=option]": {
      margin: "".concat(t("optionsSpacingVertical"), "px 0"),
      borderRadius: t("optionsBorderRadius"),
      textAlign: "center"
    }
  });
}, ["minWidth"]); // The option you know and love, but only shows preselected stylings on focus.

var OptionListPreselectedFocus = function OptionListPreselectedFocus(props) {
  var _useState = (0, _react.useState)(undefined),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      preselectedIndex = _useState2[0],
      setPreselectedIndex = _useState2[1];

  var lastIndex = (0, _react.useRef)(0);
  var onBlur = (0, _react.useCallback)(function () {
    return setPreselectedIndex(null);
  }, []);
  var onFocus = (0, _react.useCallback)(function () {
    return setPreselectedIndex(lastIndex.current || 0);
  }, []);
  var onChangePreselectedIndex = (0, _react.useCallback)(function (index) {
    setPreselectedIndex(index);
    lastIndex.current = index;
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_optionList["default"], (0, _extends2["default"])({}, props, {
    onBlur: onBlur,
    onFocus: onFocus,
    preselectedIndex: preselectedIndex,
    onChangePreselectedIndex: onChangePreselectedIndex
  }));
};

var TimePickerOptions = function TimePickerOptions(props) {
  var options = props.options,
      values = props.values,
      onSelectOption = props.onSelectOption;
  var t = (0, _theme.useTheme)(_timePicker["default"], "timePicker");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperStyles(t, props)
  }, options.map(function (_ref2) {
    var options = _ref2.options,
        type = _ref2.type;
    var selectedValue = values[type];
    return /*#__PURE__*/_react["default"].createElement(OptionListPreselectedFocus, {
      key: type
    }, options.map(function (value, index) {
      return /*#__PURE__*/_react["default"].createElement(_optionList.OptionListItem, {
        key: index,
        selected: value === selectedValue,
        label: value,
        onClick: function onClick() {
          return onSelectOption(type, value);
        }
      });
    }));
  }));
};

TimePickerOptions.displayName = "TimePickerOptions";
TimePickerOptions.propTypes =  false ? {
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    type: _propTypes["default"].string.isRequired,
    options: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired
  })),
  values: _propTypes["default"].object,
  onSelectOption: _propTypes["default"].func
} : {};
TimePickerOptions.defaultProps = {};
var _default = TimePickerOptions;
exports["default"] = _default;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _popoverController = _interopRequireDefault(__webpack_require__(99));

var _popoverBody = _interopRequireDefault(__webpack_require__(204));

var _refObject = _interopRequireDefault(__webpack_require__(447));

var TimePickerInvalidPopover = function TimePickerInvalidPopover(props) {
  var inputRef = props.inputRef,
      children = props.children,
      open = props.open,
      t = props.t;
  var anchorNode = inputRef.current ? inputRef.current.parentNode.parentNode.parentNode.parentNode.querySelector("[mdn-input-box-suffix]") : undefined;
  return /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
    open: open,
    anchorNode: anchorNode,
    anchorOrigin: "center right",
    popoverOrigin: "bottom center",
    offsetVertical: -18,
    offsetHorizontal: -10
  }, function (_ref) {
    var popoverStyle = _ref.popoverStyle;
    return /*#__PURE__*/_react["default"].createElement(_popoverBody["default"], {
      className: popoverStyle,
      type: "fill",
      spacingInset: "small",
      zIndex: t("errorTooltipElevation"),
      arrowAlignment: "center",
      arrowPosition: "bottom"
    }, children);
  });
};

TimePickerInvalidPopover.displayName = "TimePickerInvalidPopover";
TimePickerInvalidPopover.propTypes =  false ? {
  children: _propTypes["default"].node.isRequired,
  inputRef: _refObject["default"].isRequired,
  open: _propTypes["default"].bool.isRequired,
  t: _propTypes["default"].func.isRequired
} : {};
var _default = TimePickerInvalidPopover;
exports["default"] = _default;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _noop = _interopRequireDefault(__webpack_require__(59));

var _endsWith = _interopRequireDefault(__webpack_require__(1050));

var _emotion = __webpack_require__(11);

var _input = _interopRequireDefault(__webpack_require__(171));

var _theme = __webpack_require__(24);

var _inputBox = _interopRequireDefault(__webpack_require__(276));

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _token = __webpack_require__(20);

var _inputReset = _interopRequireDefault(__webpack_require__(277));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

var _supportTextWrapper = _interopRequireDefault(__webpack_require__(138));

var _getSupportTextAriaDescribedby = _interopRequireDefault(__webpack_require__(139));

var _functional = __webpack_require__(38);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var sizeStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var label = _ref.label;
  var insetHorizontal = t("spacingInsetHorizontal");
  var insetVertical = t("spacingInsetVerticalAuto");
  return (0, _emotion.css)({
    lineHeight: t("lineHeightAuto"),
    minHeight: t("lineHeightAuto"),
    // Clear out the padding applied by input-box (except for the top padding
    // if we have a label)
    margin: "".concat(label ? 0 : -insetVertical, "px -").concat(insetHorizontal, "px -").concat(insetVertical, "px -").concat(insetHorizontal, "px"),
    // Re-apply the input-box padding inside the textarea. This ensures that
    // the textarea resize handle fits snug in the corner of the input-box and
    // that when scrolling the textarea content can go right up to the bottom
    // of the input-box.
    padding: "".concat(label ? 0 : insetVertical, "px ").concat(insetHorizontal, "px ").concat(insetVertical, "px ").concat(insetHorizontal, "px")
  });
}, ["label"]);
var textareaStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var disabled = _ref2.disabled,
      empty = _ref2.empty,
      label = _ref2.label,
      resize = _ref2.resize;
  return (0, _emotion.css)((0, _inputReset["default"])({
    empty: empty,
    textColor: t("foregroundColor", disabled ? "disabled" : "default"),
    placeholderColor: t("placeholderColor", disabled ? "disabled" : "default")
  }), {
    position: resize === "auto" ? "absolute" : undefined,
    height: resize === "auto" ? "100%" : undefined,
    boxSizing: resize === "auto" ? "border-box" : undefined,
    resize: "none",
    overflow: resize === "auto" ? "hidden" : "auto",
    overflowWrap: "break-word",
    // For IE, Edge, & Safari
    wordWrap: "break-word"
  }, sizeStyles(t, {
    label: label
  }));
}, ["disabled", "empty", "label", "resize"]);
var autoResizeContainerStyles = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var label = _ref3.label,
      rows = _ref3.rows;
  return (0, _emotion.css)({
    position: "relative",
    "& > div": {
      overflowWrap: "break-word",
      // For IE, Edge, & Safari
      wordWrap: "break-word",
      whiteSpace: "pre-wrap",
      pointerEvents: "none",
      opacity: 0,
      minHeight: "".concat(parseInt(t("lineHeightAuto")) * rows, "px")
    }
  }, sizeStyles(t, {
    label: label
  }));
}, ["label", "rows"]);
var widthStyles = (0, _functional.memoizeByKeys)(function (_ref4) {
  var width = _ref4.width;
  return (0, _emotion.css)({
    width: width,
    // If an explicit width is set then don't allow the textarea to flex
    flex: width ? "none !important" : undefined
  });
}, ["width"]); // This returns a value that will ensure the component always stays in a
// controlled state. Without this the underlying textarea element might end
// up in an uncontrolled state and the DOM and the component could get out of
// sync.

var getControlledValue = function getControlledValue(value) {
  return value === null || value === undefined ? "" : value;
}; // This returns a value that, when placed in the auto resize container, will
// force the component to the exact height needed to fit the textarea without
// scrolling.


var getAutoResizeValue = function getAutoResizeValue(value) {
  return (// The `white-space: pre-wrap` CSS property will not actually render a
    // trailing newline, but a textarea will. To ensure that our resize
    // container matches the textarea we have to add an extra newline if the
    // value ends in a newline.
    (0, _endsWith["default"])(value, "\n") ? "".concat(value, "\n") : value
  );
};

var Textarea = /*#__PURE__*/_react["default"].forwardRef(function (props, forwardedRef) {
  var disabled = props.disabled,
      onChange = props.onChange;
  var t = (0, _theme.useTheme)(_input["default"], "input"); // Generate a unique id that can be used to reference this element in the DOM

  var id = (0, _react.useMemo)(function () {
    return props.id || (0, _uniqueId["default"])("textarea-");
  }, [props.id]);
  var localRef = (0, _react.useRef)();
  var value = getControlledValue(props.value);
  var empty = value === "";
  var onChangeTextarea = (0, _react.useCallback)(function (event) {
    if (!disabled) onChange(event.target.value);
  }, [onChange, disabled]); // Focus on the input anytime the user mouses down on the container. This
  // mimicks the default browser behavior when a user mouses down on an input.

  var onMouseDownContainer = (0, _react.useCallback)(function (event) {
    if (localRef.current && event.target !== localRef.current) {
      event.preventDefault();
      localRef.current.focus();
    }
  }, [localRef]); // Assign the local and prop ref (if it exists) to the target ref (textarea)

  var assignRefs = (0, _react.useCallback)(function (targetRef) {
    localRef.current = targetRef;

    if (forwardedRef) {
      // Assign the ref with a function (Class components) or assigning .current
      // (modern functional components using the `useRef` hook)
      if (typeof forwardedRef === "function") {
        forwardedRef(targetRef);
      } else {
        forwardedRef.current = targetRef;
      }
    }
  }, [forwardedRef]);

  var _useFocus = (0, _useFocus2["default"])(props),
      focus = _useFocus.focus,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);

  var textarea = /*#__PURE__*/_react["default"].createElement("textarea", (0, _extends2["default"])({
    "aria-label": props.label,
    "aria-describedby": (0, _getSupportTextAriaDescribedby["default"])({
      id: id,
      hasHelperText: !!props.helperText,
      hasConstraintText: !!props.constraintText,
      hasErrorMessage: !!props.errorMessage,
      errorMessageFirst: props.size === "medium"
    })
  }, passThroughProps, focusProps, {
    className: textareaStyles(t, _objectSpread(_objectSpread({}, props), {}, {
      empty: empty
    })),
    id: id,
    name: props.name,
    ref: assignRefs,
    value: value,
    rows: props.rows,
    placeholder: props.placeholder,
    disabled: props.disabled,
    autoFocus: props.autoFocus || props.inaccessibleAutoFocus,
    onChange: onChangeTextarea,
    wrap: "on",
    autoComplete: props.autoFill ? undefined : "off",
    spellCheck: props.spellcheck
  }));

  return /*#__PURE__*/_react["default"].createElement(_supportTextWrapper["default"], {
    id: id,
    helperText: props.helperText,
    constraintText: props.constraintText,
    errorMessage: props.errorMessage,
    helperBelowFormField: !!props.label,
    className: widthStyles({
      width: props.width
    })
  }, /*#__PURE__*/_react["default"].createElement(_inputBox["default"], {
    size: "auto",
    fontSize: props.label ? undefined : props.size,
    label: props.label,
    error: props.error,
    disabled: props.disabled,
    focus: focus,
    empty: empty,
    onMouseDown: onMouseDownContainer,
    htmlFor: id,
    cursor: "text"
  }, props.resize === "auto" ? /*#__PURE__*/_react["default"].createElement("div", {
    className: autoResizeContainerStyles(t, props)
  }, textarea, /*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": "true"
  }, getAutoResizeValue(value))) : textarea));
});

Textarea.displayName = "Textarea";
Textarea.propTypes =  false ? {
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by typing in the textarea). The new value will be
   * passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.10.1
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Allow the browser to suggest auto-fill values for this input.
   *
   * Note that not all browsers respect this property. Some browsers (e.g.
   * Chrome 78) may choose to *always* allow auto-fill regardless of the value
   * of this property.
   */
  autoFill: _propTypes["default"].bool,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * Add constraint text to provide critical information regarding textarea content.
   *
   * @since 5.22.0
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with a small error `Alert` component below
   * or to the right of the component explaining what the error is.
   */
  error: _propTypes["default"].bool,

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the Textarea.
   *
   * @since 5.22.0
   */
  errorMessage: _propTypes["default"].string,

  /**
   * Add helper text to provide additional instruction.
   *
   * @since 5.22.0
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * If set to true then the textarea will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since 5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * A label for the textarea.
   */
  label: _propTypes["default"].string,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * Text that is shown in place of the textarea's value when the textarea is empty.
   *
   * This text is not visible when a value is entered in the textarea, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   */
  placeholder: _propTypes["default"].string,

  /**
   * Determines the behavior of the textarea when the text it contains
   * overflows.
   *
   * If this is set to `"auto"` the textarea will expand vertically to ensure
   * that it can contain text without requiring a scrollbar. If this is set to
   * `"none"` the textarea's height will be fixed and a scrollbar will be shown
   * when its text overflows vertically.
   */
  resize: _propTypes["default"].oneOf(["auto", "none"]),

  /**
   * The height of the text area specified in terms of a number of rows of text.
   *
   * If `resize` is set to `"auto"` the text area may grow taller than this
   * value, but it will never be shorter.
   */
  rows: _propTypes["default"].number,

  /**
   * Sets the size of the component using a preset.
   *
   * If the `label` prop is provided this prop will be ignored (the label
   * requires a particular amount of space which is not configurable).
   */
  size: _propTypes["default"].oneOf(["small", "medium"]),

  /**
   * Enable or disable spellchecking on the Textarea. See [the MDN documentation for `spellcheck`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck).
   *
   * @since 5.23.0
   */
  spellcheck: _propTypes["default"].bool,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func
} : {};
Textarea.defaultProps = {
  resize: "auto",
  rows: 2,
  onFocus: _noop["default"],
  onBlur: _noop["default"],
  autoFill: true,
  size: "medium"
};
var _default = Textarea;
exports["default"] = _default;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(1051),
    baseToString = __webpack_require__(246),
    toInteger = __webpack_require__(130),
    toString = __webpack_require__(106);

/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */
function endsWith(string, target, position) {
  string = toString(string);
  target = baseToString(target);

  var length = string.length;
  position = position === undefined
    ? length
    : baseClamp(toInteger(position), 0, length);

  var end = position;
  position -= target.length;
  return position >= 0 && string.slice(position, end) == target;
}

module.exports = endsWith;


/***/ }),
/* 1051 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThinClientOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_ThinClientOverviewNetworkAPI__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ThinClientOverviewReducer=function ThinClientOverviewReducer(state,action){switch(action.type){case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingOverview:false,timestamp:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_14" /* getTimestampNow */])()});case"LOAD_VIEW":Object(__WEBPACK_IMPORTED_MODULE_0__network_ThinClientOverviewNetworkAPI__["c" /* fetchThinClientDeviceDetails */])(action.data.dispatcher);return state;case"LOAD_STATUS":Object(__WEBPACK_IMPORTED_MODULE_0__network_ThinClientOverviewNetworkAPI__["d" /* fetchThinClientStatusDetails */])(action.data.dispatcher,state);return state;case"DELETE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_ThinClientOverviewNetworkAPI__["b" /* deleteThinClientDeviceDetails */])(action.data.dispatcher,action.data.mac);return state;case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});case"ADD_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_ThinClientOverviewNetworkAPI__["g" /* setThinClientDeviceDetails */])(action.data.dispatcher,action.data.stateValues,action.data.mac);return state;case"DEPLOY_THIN_CLIENT":Object(__WEBPACK_IMPORTED_MODULE_0__network_ThinClientOverviewNetworkAPI__["f" /* restartApplication */])(action.data.dispatcher,action.data.mac);return state;case"TOGGLE_USECASE":Object(__WEBPACK_IMPORTED_MODULE_0__network_ThinClientOverviewNetworkAPI__["j" /* toggleThinClientUseCase */])(action.data.dispatcher,action.data.mac,action.data.useCase);return state;case"CHANGE_USECASE":Object(__WEBPACK_IMPORTED_MODULE_0__network_ThinClientOverviewNetworkAPI__["a" /* changeThinClientUseCase */])(action.data.dispatcher,action.data.mac,action.data.useCase,action.data.showCustomAlert);return state;case"UPDATE_STATUS_LOADER":return Object.assign({},state,{loadingStatusDevices:Object.assign({},state.loadingStatusDevices,_defineProperty({},action.data.mac,Object.assign({},state.loadingStatusDevices[action.data.mac],_defineProperty({},action.data.loadingField,action.data.loaderVisible))))});case"LOAD_VIEW_FOR_GREENGRASS_RESTART_COMPLETE":Object(__WEBPACK_IMPORTED_MODULE_0__network_ThinClientOverviewNetworkAPI__["i" /* setThinClientStatusDetailsToRestartedState */])(action.data.dispatcher,state,action.data.mac);return state;case"LOAD_VIEW_FOR_GREENGRASS_RESTART":Object(__WEBPACK_IMPORTED_MODULE_0__network_ThinClientOverviewNetworkAPI__["h" /* setThinClientStatusDetailsToRestartInProgressState */])(action.data.dispatcher,state,action.data.mac);return state;default:return state;}};

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return statusCodeToReasonPhrase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reasonPhraseToStatusCode; });
// Generated file. Do not edit
var statusCodeToReasonPhrase = {
    "202": "Accepted",
    "502": "Bad Gateway",
    "400": "Bad Request",
    "409": "Conflict",
    "100": "Continue",
    "201": "Created",
    "417": "Expectation Failed",
    "424": "Failed Dependency",
    "403": "Forbidden",
    "504": "Gateway Timeout",
    "410": "Gone",
    "505": "HTTP Version Not Supported",
    "418": "I'm a teapot",
    "419": "Insufficient Space on Resource",
    "507": "Insufficient Storage",
    "500": "Internal Server Error",
    "411": "Length Required",
    "423": "Locked",
    "420": "Method Failure",
    "405": "Method Not Allowed",
    "301": "Moved Permanently",
    "302": "Moved Temporarily",
    "207": "Multi-Status",
    "300": "Multiple Choices",
    "511": "Network Authentication Required",
    "204": "No Content",
    "203": "Non Authoritative Information",
    "406": "Not Acceptable",
    "404": "Not Found",
    "501": "Not Implemented",
    "304": "Not Modified",
    "200": "OK",
    "206": "Partial Content",
    "402": "Payment Required",
    "308": "Permanent Redirect",
    "412": "Precondition Failed",
    "428": "Precondition Required",
    "102": "Processing",
    "103": "Early Hints",
    "426": "Upgrade Required",
    "407": "Proxy Authentication Required",
    "431": "Request Header Fields Too Large",
    "408": "Request Timeout",
    "413": "Request Entity Too Large",
    "414": "Request-URI Too Long",
    "416": "Requested Range Not Satisfiable",
    "205": "Reset Content",
    "303": "See Other",
    "503": "Service Unavailable",
    "101": "Switching Protocols",
    "307": "Temporary Redirect",
    "429": "Too Many Requests",
    "401": "Unauthorized",
    "451": "Unavailable For Legal Reasons",
    "422": "Unprocessable Entity",
    "415": "Unsupported Media Type",
    "305": "Use Proxy",
    "421": "Misdirected Request"
};
var reasonPhraseToStatusCode = {
    "Accepted": 202,
    "Bad Gateway": 502,
    "Bad Request": 400,
    "Conflict": 409,
    "Continue": 100,
    "Created": 201,
    "Expectation Failed": 417,
    "Failed Dependency": 424,
    "Forbidden": 403,
    "Gateway Timeout": 504,
    "Gone": 410,
    "HTTP Version Not Supported": 505,
    "I'm a teapot": 418,
    "Insufficient Space on Resource": 419,
    "Insufficient Storage": 507,
    "Internal Server Error": 500,
    "Length Required": 411,
    "Locked": 423,
    "Method Failure": 420,
    "Method Not Allowed": 405,
    "Moved Permanently": 301,
    "Moved Temporarily": 302,
    "Multi-Status": 207,
    "Multiple Choices": 300,
    "Network Authentication Required": 511,
    "No Content": 204,
    "Non Authoritative Information": 203,
    "Not Acceptable": 406,
    "Not Found": 404,
    "Not Implemented": 501,
    "Not Modified": 304,
    "OK": 200,
    "Partial Content": 206,
    "Payment Required": 402,
    "Permanent Redirect": 308,
    "Precondition Failed": 412,
    "Precondition Required": 428,
    "Processing": 102,
    "Early Hints": 103,
    "Upgrade Required": 426,
    "Proxy Authentication Required": 407,
    "Request Header Fields Too Large": 431,
    "Request Timeout": 408,
    "Request Entity Too Large": 413,
    "Request-URI Too Long": 414,
    "Requested Range Not Satisfiable": 416,
    "Reset Content": 205,
    "See Other": 303,
    "Service Unavailable": 503,
    "Switching Protocols": 101,
    "Temporary Redirect": 307,
    "Too Many Requests": 429,
    "Unauthorized": 401,
    "Unavailable For Legal Reasons": 451,
    "Unprocessable Entity": 422,
    "Unsupported Media Type": 415,
    "Use Proxy": 305,
    "Misdirected Request": 421
};


/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StatusCodes */
// Generated file. Do not edit
var StatusCodes;
(function (StatusCodes) {
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.2.1
     *
     * This interim response indicates that everything so far is OK and that the client should continue with the request or ignore it if it is already finished.
     */
    StatusCodes[StatusCodes["CONTINUE"] = 100] = "CONTINUE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.2.2
     *
     * This code is sent in response to an Upgrade request header by the client, and indicates the protocol the server is switching too.
     */
    StatusCodes[StatusCodes["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.1
     *
     * This code indicates that the server has received and is processing the request, but no response is available yet.
     */
    StatusCodes[StatusCodes["PROCESSING"] = 102] = "PROCESSING";
    /**
     * Official Documentation @ https://www.rfc-editor.org/rfc/rfc8297#page-3
     *
     * This code indicates to the client that the server is likely to send a final response with the header fields included in the informational response.
     */
    StatusCodes[StatusCodes["EARLY_HINTS"] = 103] = "EARLY_HINTS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.1
     *
     * The request has succeeded. The meaning of a success varies depending on the HTTP method:
     * GET: The resource has been fetched and is transmitted in the message body.
     * HEAD: The entity headers are in the message body.
     * POST: The resource describing the result of the action is transmitted in the message body.
     * TRACE: The message body contains the request message as received by the server
     */
    StatusCodes[StatusCodes["OK"] = 200] = "OK";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.2
     *
     * The request has succeeded and a new resource has been created as a result of it. This is typically the response sent after a PUT request.
     */
    StatusCodes[StatusCodes["CREATED"] = 201] = "CREATED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.3
     *
     * The request has been received but not yet acted upon. It is non-committal, meaning that there is no way in HTTP to later send an asynchronous response indicating the outcome of processing the request. It is intended for cases where another process or server handles the request, or for batch processing.
     */
    StatusCodes[StatusCodes["ACCEPTED"] = 202] = "ACCEPTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.4
     *
     * This response code means returned meta-information set is not exact set as available from the origin server, but collected from a local or a third party copy. Except this condition, 200 OK response should be preferred instead of this response.
     */
    StatusCodes[StatusCodes["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.5
     *
     * There is no content to send for this request, but the headers may be useful. The user-agent may update its cached headers for this resource with the new ones.
     */
    StatusCodes[StatusCodes["NO_CONTENT"] = 204] = "NO_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.6
     *
     * This response code is sent after accomplishing request to tell user agent reset document view which sent this request.
     */
    StatusCodes[StatusCodes["RESET_CONTENT"] = 205] = "RESET_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7233#section-4.1
     *
     * This response code is used because of range header sent by the client to separate download into multiple streams.
     */
    StatusCodes[StatusCodes["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.2
     *
     * A Multi-Status response conveys information about multiple resources in situations where multiple status codes might be appropriate.
     */
    StatusCodes[StatusCodes["MULTI_STATUS"] = 207] = "MULTI_STATUS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.1
     *
     * The request has more than one possible responses. User-agent or user should choose one of them. There is no standardized way to choose one of the responses.
     */
    StatusCodes[StatusCodes["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.2
     *
     * This response code means that URI of requested resource has been changed. Probably, new URI would be given in the response.
     */
    StatusCodes[StatusCodes["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.3
     *
     * This response code means that URI of requested resource has been changed temporarily. New changes in the URI might be made in the future. Therefore, this same URI should be used by the client in future requests.
     */
    StatusCodes[StatusCodes["MOVED_TEMPORARILY"] = 302] = "MOVED_TEMPORARILY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.4
     *
     * Server sent this response to directing client to get requested resource to another URI with an GET request.
     */
    StatusCodes[StatusCodes["SEE_OTHER"] = 303] = "SEE_OTHER";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7232#section-4.1
     *
     * This is used for caching purposes. It is telling to client that response has not been modified. So, client can continue to use same cached version of response.
     */
    StatusCodes[StatusCodes["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    /**
     * @deprecated
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.6
     *
     * Was defined in a previous version of the HTTP specification to indicate that a requested response must be accessed by a proxy. It has been deprecated due to security concerns regarding in-band configuration of a proxy.
     */
    StatusCodes[StatusCodes["USE_PROXY"] = 305] = "USE_PROXY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.7
     *
     * Server sent this response to directing client to get requested resource to another URI with same method that used prior request. This has the same semantic than the 302 Found HTTP response code, with the exception that the user agent must not change the HTTP method used: if a POST was used in the first request, a POST must be used in the second request.
     */
    StatusCodes[StatusCodes["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7538#section-3
     *
     * This means that the resource is now permanently located at another URI, specified by the Location: HTTP Response header. This has the same semantics as the 301 Moved Permanently HTTP response code, with the exception that the user agent must not change the HTTP method used: if a POST was used in the first request, a POST must be used in the second request.
     */
    StatusCodes[StatusCodes["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.1
     *
     * This response means that server could not understand the request due to invalid syntax.
     */
    StatusCodes[StatusCodes["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7235#section-3.1
     *
     * Although the HTTP standard specifies "unauthorized", semantically this response means "unauthenticated". That is, the client must authenticate itself to get the requested response.
     */
    StatusCodes[StatusCodes["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.2
     *
     * This response code is reserved for future use. Initial aim for creating this code was using it for digital payment systems however this is not used currently.
     */
    StatusCodes[StatusCodes["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.3
     *
     * The client does not have access rights to the content, i.e. they are unauthorized, so server is rejecting to give proper response. Unlike 401, the client's identity is known to the server.
     */
    StatusCodes[StatusCodes["FORBIDDEN"] = 403] = "FORBIDDEN";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.4
     *
     * The server can not find requested resource. In the browser, this means the URL is not recognized. In an API, this can also mean that the endpoint is valid but the resource itself does not exist. Servers may also send this response instead of 403 to hide the existence of a resource from an unauthorized client. This response code is probably the most famous one due to its frequent occurence on the web.
     */
    StatusCodes[StatusCodes["NOT_FOUND"] = 404] = "NOT_FOUND";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.5
     *
     * The request method is known by the server but has been disabled and cannot be used. For example, an API may forbid DELETE-ing a resource. The two mandatory methods, GET and HEAD, must never be disabled and should not return this error code.
     */
    StatusCodes[StatusCodes["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.6
     *
     * This response is sent when the web server, after performing server-driven content negotiation, doesn't find any content following the criteria given by the user agent.
     */
    StatusCodes[StatusCodes["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7235#section-3.2
     *
     * This is similar to 401 but authentication is needed to be done by a proxy.
     */
    StatusCodes[StatusCodes["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.7
     *
     * This response is sent on an idle connection by some servers, even without any previous request by the client. It means that the server would like to shut down this unused connection. This response is used much more since some browsers, like Chrome, Firefox 27+, or IE9, use HTTP pre-connection mechanisms to speed up surfing. Also note that some servers merely shut down the connection without sending this message.
     */
    StatusCodes[StatusCodes["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.8
     *
     * This response is sent when a request conflicts with the current state of the server.
     */
    StatusCodes[StatusCodes["CONFLICT"] = 409] = "CONFLICT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.9
     *
     * This response would be sent when the requested content has been permenantly deleted from server, with no forwarding address. Clients are expected to remove their caches and links to the resource. The HTTP specification intends this status code to be used for "limited-time, promotional services". APIs should not feel compelled to indicate resources that have been deleted with this status code.
     */
    StatusCodes[StatusCodes["GONE"] = 410] = "GONE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.10
     *
     * The server rejected the request because the Content-Length header field is not defined and the server requires it.
     */
    StatusCodes[StatusCodes["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7232#section-4.2
     *
     * The client has indicated preconditions in its headers which the server does not meet.
     */
    StatusCodes[StatusCodes["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.11
     *
     * Request entity is larger than limits defined by server; the server might close the connection or return an Retry-After header field.
     */
    StatusCodes[StatusCodes["REQUEST_TOO_LONG"] = 413] = "REQUEST_TOO_LONG";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.12
     *
     * The URI requested by the client is longer than the server is willing to interpret.
     */
    StatusCodes[StatusCodes["REQUEST_URI_TOO_LONG"] = 414] = "REQUEST_URI_TOO_LONG";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.13
     *
     * The media format of the requested data is not supported by the server, so the server is rejecting the request.
     */
    StatusCodes[StatusCodes["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7233#section-4.4
     *
     * The range specified by the Range header field in the request can't be fulfilled; it's possible that the range is outside the size of the target URI's data.
     */
    StatusCodes[StatusCodes["REQUESTED_RANGE_NOT_SATISFIABLE"] = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.14
     *
     * This response code means the expectation indicated by the Expect request header field can't be met by the server.
     */
    StatusCodes[StatusCodes["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2324#section-2.3.2
     *
     * Any attempt to brew coffee with a teapot should result in the error code "418 I'm a teapot". The resulting entity body MAY be short and stout.
     */
    StatusCodes[StatusCodes["IM_A_TEAPOT"] = 418] = "IM_A_TEAPOT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.6
     *
     * The 507 (Insufficient Storage) status code means the method could not be performed on the resource because the server is unable to store the representation needed to successfully complete the request. This condition is considered to be temporary. If the request which received this status code was the result of a user action, the request MUST NOT be repeated until it is requested by a separate user action.
     */
    StatusCodes[StatusCodes["INSUFFICIENT_SPACE_ON_RESOURCE"] = 419] = "INSUFFICIENT_SPACE_ON_RESOURCE";
    /**
     * @deprecated
     * Official Documentation @ https://tools.ietf.org/rfcdiff?difftype=--hwdiff&url2=draft-ietf-webdav-protocol-06.txt
     *
     * A deprecated response used by the Spring Framework when a method has failed.
     */
    StatusCodes[StatusCodes["METHOD_FAILURE"] = 420] = "METHOD_FAILURE";
    /**
     * Official Documentation @ https://datatracker.ietf.org/doc/html/rfc7540#section-9.1.2
     *
     * Defined in the specification of HTTP/2 to indicate that a server is not able to produce a response for the combination of scheme and authority that are included in the request URI.
     */
    StatusCodes[StatusCodes["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.3
     *
     * The request was well-formed but was unable to be followed due to semantic errors.
     */
    StatusCodes[StatusCodes["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.4
     *
     * The resource that is being accessed is locked.
     */
    StatusCodes[StatusCodes["LOCKED"] = 423] = "LOCKED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.5
     *
     * The request failed due to failure of a previous request.
     */
    StatusCodes[StatusCodes["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
    /**
     * Official Documentation @ https://datatracker.ietf.org/doc/html/rfc7231#section-6.5.15
     *
     * The server refuses to perform the request using the current protocol but might be willing to do so after the client upgrades to a different protocol.
     */
    StatusCodes[StatusCodes["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-3
     *
     * The origin server requires the request to be conditional. Intended to prevent the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict.
     */
    StatusCodes[StatusCodes["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-4
     *
     * The user has sent too many requests in a given amount of time ("rate limiting").
     */
    StatusCodes[StatusCodes["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-5
     *
     * The server is unwilling to process the request because its header fields are too large. The request MAY be resubmitted after reducing the size of the request header fields.
     */
    StatusCodes[StatusCodes["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7725
     *
     * The user-agent requested a resource that cannot legally be provided, such as a web page censored by a government.
     */
    StatusCodes[StatusCodes["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.1
     *
     * The server encountered an unexpected condition that prevented it from fulfilling the request.
     */
    StatusCodes[StatusCodes["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.2
     *
     * The request method is not supported by the server and cannot be handled. The only methods that servers are required to support (and therefore that must not return this code) are GET and HEAD.
     */
    StatusCodes[StatusCodes["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.3
     *
     * This error response means that the server, while working as a gateway to get a response needed to handle the request, got an invalid response.
     */
    StatusCodes[StatusCodes["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.4
     *
     * The server is not ready to handle the request. Common causes are a server that is down for maintenance or that is overloaded. Note that together with this response, a user-friendly page explaining the problem should be sent. This responses should be used for temporary conditions and the Retry-After: HTTP header should, if possible, contain the estimated time before the recovery of the service. The webmaster must also take care about the caching-related headers that are sent along with this response, as these temporary condition responses should usually not be cached.
     */
    StatusCodes[StatusCodes["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.5
     *
     * This error response is given when the server is acting as a gateway and cannot get a response in time.
     */
    StatusCodes[StatusCodes["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.6
     *
     * The HTTP version used in the request is not supported by the server.
     */
    StatusCodes[StatusCodes["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.6
     *
     * The server has an internal configuration error: the chosen variant resource is configured to engage in transparent content negotiation itself, and is therefore not a proper end point in the negotiation process.
     */
    StatusCodes[StatusCodes["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-6
     *
     * The 511 status code indicates that the client needs to authenticate to gain network access.
     */
    StatusCodes[StatusCodes["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(StatusCodes || (StatusCodes = {}));


/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReasonPhrases */
// Generated file. Do not edit
var ReasonPhrases;
(function (ReasonPhrases) {
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.3
     *
     * The request has been received but not yet acted upon. It is non-committal, meaning that there is no way in HTTP to later send an asynchronous response indicating the outcome of processing the request. It is intended for cases where another process or server handles the request, or for batch processing.
     */
    ReasonPhrases["ACCEPTED"] = "Accepted";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.3
     *
     * This error response means that the server, while working as a gateway to get a response needed to handle the request, got an invalid response.
     */
    ReasonPhrases["BAD_GATEWAY"] = "Bad Gateway";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.1
     *
     * This response means that server could not understand the request due to invalid syntax.
     */
    ReasonPhrases["BAD_REQUEST"] = "Bad Request";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.8
     *
     * This response is sent when a request conflicts with the current state of the server.
     */
    ReasonPhrases["CONFLICT"] = "Conflict";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.2.1
     *
     * This interim response indicates that everything so far is OK and that the client should continue with the request or ignore it if it is already finished.
     */
    ReasonPhrases["CONTINUE"] = "Continue";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.2
     *
     * The request has succeeded and a new resource has been created as a result of it. This is typically the response sent after a PUT request.
     */
    ReasonPhrases["CREATED"] = "Created";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.14
     *
     * This response code means the expectation indicated by the Expect request header field can't be met by the server.
     */
    ReasonPhrases["EXPECTATION_FAILED"] = "Expectation Failed";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.5
     *
     * The request failed due to failure of a previous request.
     */
    ReasonPhrases["FAILED_DEPENDENCY"] = "Failed Dependency";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.3
     *
     * The client does not have access rights to the content, i.e. they are unauthorized, so server is rejecting to give proper response. Unlike 401, the client's identity is known to the server.
     */
    ReasonPhrases["FORBIDDEN"] = "Forbidden";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.5
     *
     * This error response is given when the server is acting as a gateway and cannot get a response in time.
     */
    ReasonPhrases["GATEWAY_TIMEOUT"] = "Gateway Timeout";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.9
     *
     * This response would be sent when the requested content has been permenantly deleted from server, with no forwarding address. Clients are expected to remove their caches and links to the resource. The HTTP specification intends this status code to be used for "limited-time, promotional services". APIs should not feel compelled to indicate resources that have been deleted with this status code.
     */
    ReasonPhrases["GONE"] = "Gone";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.6
     *
     * The HTTP version used in the request is not supported by the server.
     */
    ReasonPhrases["HTTP_VERSION_NOT_SUPPORTED"] = "HTTP Version Not Supported";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2324#section-2.3.2
     *
     * Any attempt to brew coffee with a teapot should result in the error code "418 I'm a teapot". The resulting entity body MAY be short and stout.
     */
    ReasonPhrases["IM_A_TEAPOT"] = "I'm a teapot";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.6
     *
     * The 507 (Insufficient Storage) status code means the method could not be performed on the resource because the server is unable to store the representation needed to successfully complete the request. This condition is considered to be temporary. If the request which received this status code was the result of a user action, the request MUST NOT be repeated until it is requested by a separate user action.
     */
    ReasonPhrases["INSUFFICIENT_SPACE_ON_RESOURCE"] = "Insufficient Space on Resource";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.6
     *
     * The server has an internal configuration error: the chosen variant resource is configured to engage in transparent content negotiation itself, and is therefore not a proper end point in the negotiation process.
     */
    ReasonPhrases["INSUFFICIENT_STORAGE"] = "Insufficient Storage";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.1
     *
     * The server encountered an unexpected condition that prevented it from fulfilling the request.
     */
    ReasonPhrases["INTERNAL_SERVER_ERROR"] = "Internal Server Error";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.10
     *
     * The server rejected the request because the Content-Length header field is not defined and the server requires it.
     */
    ReasonPhrases["LENGTH_REQUIRED"] = "Length Required";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.4
     *
     * The resource that is being accessed is locked.
     */
    ReasonPhrases["LOCKED"] = "Locked";
    /**
     * @deprecated
     * Official Documentation @ https://tools.ietf.org/rfcdiff?difftype=--hwdiff&url2=draft-ietf-webdav-protocol-06.txt
     *
     * A deprecated response used by the Spring Framework when a method has failed.
     */
    ReasonPhrases["METHOD_FAILURE"] = "Method Failure";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.5
     *
     * The request method is known by the server but has been disabled and cannot be used. For example, an API may forbid DELETE-ing a resource. The two mandatory methods, GET and HEAD, must never be disabled and should not return this error code.
     */
    ReasonPhrases["METHOD_NOT_ALLOWED"] = "Method Not Allowed";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.2
     *
     * This response code means that URI of requested resource has been changed. Probably, new URI would be given in the response.
     */
    ReasonPhrases["MOVED_PERMANENTLY"] = "Moved Permanently";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.3
     *
     * This response code means that URI of requested resource has been changed temporarily. New changes in the URI might be made in the future. Therefore, this same URI should be used by the client in future requests.
     */
    ReasonPhrases["MOVED_TEMPORARILY"] = "Moved Temporarily";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.2
     *
     * A Multi-Status response conveys information about multiple resources in situations where multiple status codes might be appropriate.
     */
    ReasonPhrases["MULTI_STATUS"] = "Multi-Status";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.1
     *
     * The request has more than one possible responses. User-agent or user should choose one of them. There is no standardized way to choose one of the responses.
     */
    ReasonPhrases["MULTIPLE_CHOICES"] = "Multiple Choices";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-6
     *
     * The 511 status code indicates that the client needs to authenticate to gain network access.
     */
    ReasonPhrases["NETWORK_AUTHENTICATION_REQUIRED"] = "Network Authentication Required";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.5
     *
     * There is no content to send for this request, but the headers may be useful. The user-agent may update its cached headers for this resource with the new ones.
     */
    ReasonPhrases["NO_CONTENT"] = "No Content";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.4
     *
     * This response code means returned meta-information set is not exact set as available from the origin server, but collected from a local or a third party copy. Except this condition, 200 OK response should be preferred instead of this response.
     */
    ReasonPhrases["NON_AUTHORITATIVE_INFORMATION"] = "Non Authoritative Information";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.6
     *
     * This response is sent when the web server, after performing server-driven content negotiation, doesn't find any content following the criteria given by the user agent.
     */
    ReasonPhrases["NOT_ACCEPTABLE"] = "Not Acceptable";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.4
     *
     * The server can not find requested resource. In the browser, this means the URL is not recognized. In an API, this can also mean that the endpoint is valid but the resource itself does not exist. Servers may also send this response instead of 403 to hide the existence of a resource from an unauthorized client. This response code is probably the most famous one due to its frequent occurence on the web.
     */
    ReasonPhrases["NOT_FOUND"] = "Not Found";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.2
     *
     * The request method is not supported by the server and cannot be handled. The only methods that servers are required to support (and therefore that must not return this code) are GET and HEAD.
     */
    ReasonPhrases["NOT_IMPLEMENTED"] = "Not Implemented";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7232#section-4.1
     *
     * This is used for caching purposes. It is telling to client that response has not been modified. So, client can continue to use same cached version of response.
     */
    ReasonPhrases["NOT_MODIFIED"] = "Not Modified";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.1
     *
     * The request has succeeded. The meaning of a success varies depending on the HTTP method:
     * GET: The resource has been fetched and is transmitted in the message body.
     * HEAD: The entity headers are in the message body.
     * POST: The resource describing the result of the action is transmitted in the message body.
     * TRACE: The message body contains the request message as received by the server
     */
    ReasonPhrases["OK"] = "OK";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7233#section-4.1
     *
     * This response code is used because of range header sent by the client to separate download into multiple streams.
     */
    ReasonPhrases["PARTIAL_CONTENT"] = "Partial Content";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.2
     *
     * This response code is reserved for future use. Initial aim for creating this code was using it for digital payment systems however this is not used currently.
     */
    ReasonPhrases["PAYMENT_REQUIRED"] = "Payment Required";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7538#section-3
     *
     * This means that the resource is now permanently located at another URI, specified by the Location: HTTP Response header. This has the same semantics as the 301 Moved Permanently HTTP response code, with the exception that the user agent must not change the HTTP method used: if a POST was used in the first request, a POST must be used in the second request.
     */
    ReasonPhrases["PERMANENT_REDIRECT"] = "Permanent Redirect";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7232#section-4.2
     *
     * The client has indicated preconditions in its headers which the server does not meet.
     */
    ReasonPhrases["PRECONDITION_FAILED"] = "Precondition Failed";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-3
     *
     * The origin server requires the request to be conditional. Intended to prevent the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict.
     */
    ReasonPhrases["PRECONDITION_REQUIRED"] = "Precondition Required";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.1
     *
     * This code indicates that the server has received and is processing the request, but no response is available yet.
     */
    ReasonPhrases["PROCESSING"] = "Processing";
    /**
     * Official Documentation @ https://www.rfc-editor.org/rfc/rfc8297#page-3
     *
     * This code indicates to the client that the server is likely to send a final response with the header fields included in the informational response.
     */
    ReasonPhrases["EARLY_HINTS"] = "Early Hints";
    /**
     * Official Documentation @ https://datatracker.ietf.org/doc/html/rfc7231#section-6.5.15
     *
     * The server refuses to perform the request using the current protocol but might be willing to do so after the client upgrades to a different protocol.
     */
    ReasonPhrases["UPGRADE_REQUIRED"] = "Upgrade Required";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7235#section-3.2
     *
     * This is similar to 401 but authentication is needed to be done by a proxy.
     */
    ReasonPhrases["PROXY_AUTHENTICATION_REQUIRED"] = "Proxy Authentication Required";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-5
     *
     * The server is unwilling to process the request because its header fields are too large. The request MAY be resubmitted after reducing the size of the request header fields.
     */
    ReasonPhrases["REQUEST_HEADER_FIELDS_TOO_LARGE"] = "Request Header Fields Too Large";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.7
     *
     * This response is sent on an idle connection by some servers, even without any previous request by the client. It means that the server would like to shut down this unused connection. This response is used much more since some browsers, like Chrome, Firefox 27+, or IE9, use HTTP pre-connection mechanisms to speed up surfing. Also note that some servers merely shut down the connection without sending this message.
     */
    ReasonPhrases["REQUEST_TIMEOUT"] = "Request Timeout";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.11
     *
     * Request entity is larger than limits defined by server; the server might close the connection or return an Retry-After header field.
     */
    ReasonPhrases["REQUEST_TOO_LONG"] = "Request Entity Too Large";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.12
     *
     * The URI requested by the client is longer than the server is willing to interpret.
     */
    ReasonPhrases["REQUEST_URI_TOO_LONG"] = "Request-URI Too Long";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7233#section-4.4
     *
     * The range specified by the Range header field in the request can't be fulfilled; it's possible that the range is outside the size of the target URI's data.
     */
    ReasonPhrases["REQUESTED_RANGE_NOT_SATISFIABLE"] = "Requested Range Not Satisfiable";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.3.6
     *
     * This response code is sent after accomplishing request to tell user agent reset document view which sent this request.
     */
    ReasonPhrases["RESET_CONTENT"] = "Reset Content";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.4
     *
     * Server sent this response to directing client to get requested resource to another URI with an GET request.
     */
    ReasonPhrases["SEE_OTHER"] = "See Other";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.6.4
     *
     * The server is not ready to handle the request. Common causes are a server that is down for maintenance or that is overloaded. Note that together with this response, a user-friendly page explaining the problem should be sent. This responses should be used for temporary conditions and the Retry-After: HTTP header should, if possible, contain the estimated time before the recovery of the service. The webmaster must also take care about the caching-related headers that are sent along with this response, as these temporary condition responses should usually not be cached.
     */
    ReasonPhrases["SERVICE_UNAVAILABLE"] = "Service Unavailable";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.2.2
     *
     * This code is sent in response to an Upgrade request header by the client, and indicates the protocol the server is switching too.
     */
    ReasonPhrases["SWITCHING_PROTOCOLS"] = "Switching Protocols";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.7
     *
     * Server sent this response to directing client to get requested resource to another URI with same method that used prior request. This has the same semantic than the 302 Found HTTP response code, with the exception that the user agent must not change the HTTP method used: if a POST was used in the first request, a POST must be used in the second request.
     */
    ReasonPhrases["TEMPORARY_REDIRECT"] = "Temporary Redirect";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc6585#section-4
     *
     * The user has sent too many requests in a given amount of time ("rate limiting").
     */
    ReasonPhrases["TOO_MANY_REQUESTS"] = "Too Many Requests";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7235#section-3.1
     *
     * Although the HTTP standard specifies "unauthorized", semantically this response means "unauthenticated". That is, the client must authenticate itself to get the requested response.
     */
    ReasonPhrases["UNAUTHORIZED"] = "Unauthorized";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7725
     *
     * The user-agent requested a resource that cannot legally be provided, such as a web page censored by a government.
     */
    ReasonPhrases["UNAVAILABLE_FOR_LEGAL_REASONS"] = "Unavailable For Legal Reasons";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc2518#section-10.3
     *
     * The request was well-formed but was unable to be followed due to semantic errors.
     */
    ReasonPhrases["UNPROCESSABLE_ENTITY"] = "Unprocessable Entity";
    /**
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.5.13
     *
     * The media format of the requested data is not supported by the server, so the server is rejecting the request.
     */
    ReasonPhrases["UNSUPPORTED_MEDIA_TYPE"] = "Unsupported Media Type";
    /**
     * @deprecated
     * Official Documentation @ https://tools.ietf.org/html/rfc7231#section-6.4.6
     *
     * Was defined in a previous version of the HTTP specification to indicate that a requested response must be accessed by a proxy. It has been deprecated due to security concerns regarding in-band configuration of a proxy.
     */
    ReasonPhrases["USE_PROXY"] = "Use Proxy";
    /**
     * Official Documentation @ https://datatracker.ietf.org/doc/html/rfc7540#section-9.1.2
     *
     * Defined in the specification of HTTP/2 to indicate that a server is not able to produce a response for the combination of scheme and authority that are included in the request URI.
     */
    ReasonPhrases["MISDIRECTED_REQUEST"] = "Misdirected Request";
})(ReasonPhrases || (ReasonPhrases = {}));


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _link = _interopRequireDefault(__webpack_require__(1057));

var _text = _interopRequireDefault(__webpack_require__(249));

var _focusRing = _interopRequireDefault(__webpack_require__(347));

var _getTextStyles = _interopRequireDefault(__webpack_require__(352));

var _theme = __webpack_require__(24);

var _clickable = _interopRequireDefault(__webpack_require__(108));

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _token = __webpack_require__(20);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var type = _ref.type,
      focus = _ref.focus,
      disabled = _ref.disabled;

  var _focusRingTokens = (0, _focusRing["default"])(t.tokens),
      focusRingWidth = _focusRingTokens.focusRingWidth,
      focusRingColorFocus = _focusRingTokens.focusRingColorFocus;

  return (0, _emotion.css)({
    display: "inline",
    // HACK: Use !important to override the color set by the text styles
    color: "".concat(t("foregroundColor", disabled ? "disabled" : "default"), " !important"),
    textDecoration: type === "primary" ? "underline" : "none",
    transition: t.transitionCss("motion", "color"),
    // Use custom focus rings styles that will work even if the link wraps
    // across multiple lines.
    // NOTE: IE11 doesn't support outline-offset so the focus ring will
    // be tighter in that browser. The alternative would be to use our
    // previous multiple-box-shadow approach, but that has other issues
    // because it has to make an assumption about the background color
    // behind the link.
    outline: focus ? "".concat(focusRingWidth, "px solid ").concat(focusRingColorFocus) : undefined,
    outlineOffset: 2,
    ":hover": !disabled && {
      color: "".concat(t("foregroundColorHover"), " !important"),
      textDecoration: type === "secondary" ? "underline" : undefined
    },
    ":active": !disabled && {
      color: "".concat(t("foregroundColorPressed"), " !important")
    }
  }, (0, _getTextStyles["default"])((0, _token.getTokenHelper)("text")((0, _text["default"])(t.tokens)), {}));
}, ["type", "focus", "disabled"]);

var Link = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_link["default"], "link");

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["aria-", "data-"]);
  return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, focusProps, passThroughProps, {
    className: styles(t, {
      type: props.type,
      disabled: props.disabled,
      focus: focus && focusTrigger === "keyboard"
    }),
    target: props.target,
    rel: props.rel,
    disabled: props.disabled,
    href: props.href,
    onClick: props.onClick,
    tabIndex: props.tabIndex,
    download: props.download,
    propagateClickEvent: props.propagateClickEvent,
    tag: "a",
    ref: ref,
    "mdn-link": ""
  }), props.children);
});

Link.displayName = "Link";
Link.propTypes =  false ? {
  /**
   * The contents of the link. Plain text recommended.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.21.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * See the [MDN docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-download) for details.
   * This string should be the file name which should be downloaded. If set to an empty string the browser
   * will default to file name (e.g. a file downloaded from `site.com/picture.jpg` will be named `picture.jpg`).
   */
  download: _propTypes["default"].string,

  /**
   * The URL that the link points to.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * Determines whether or not the click event will continue to bubble up
   * through the DOM. Read the [Event.stopPropagation() docs](https://developer.mozilla.org/en-US/docs/Web/API/Event/stopPropagation)
   * for details.
   */
  propagateClickEvent: _propTypes["default"].bool,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * This determines the visual style of the link.
   */
  type: _propTypes["default"].oneOf(["primary", "secondary"]),

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func
} : {};
Link.defaultProps = {
  type: "primary"
};
var _default = Link;
exports["default"] = _default;

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    linkForegroundColorDefault: tokens.themeForegroundAccentDefault,
    linkForegroundColorHover: tokens.themeForegroundAccentHover,
    linkForegroundColorPressed: tokens.themeForegroundAccentPressed,
    linkForegroundColorDisabled: tokens.themeBorderAccentDisabled,
    linkMotionDuration: "100ms",
    linkMotionFunction: "ease"
  }
};

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEDControllerOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_LEDControllerOverviewNetworkAPI__ = __webpack_require__(291);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var LEDControllerOverviewReducer=function LEDControllerOverviewReducer(state,action){switch(action.type){case"RECEIVE_DATA":return Object.assign({},state,action.data);case"LOAD_VIEW":Object(__WEBPACK_IMPORTED_MODULE_0__network_LEDControllerOverviewNetworkAPI__["d" /* getLedControllerDeviceStatusDetails */])(action.data.dispatcher);return state;case"LOAD_AISLE_TYPES":Object(__WEBPACK_IMPORTED_MODULE_0__network_LEDControllerOverviewNetworkAPI__["b" /* getAisleTypes */])(action.data.dispatcher);return state;case"RECEIVE_AISLE_TYPES":return Object.assign({},state,action.data);case"LOAD_LED_CONTROLLER_TYPES":Object(__WEBPACK_IMPORTED_MODULE_0__network_LEDControllerOverviewNetworkAPI__["f" /* getLedControllerTypes */])(action.data.dispatcher);return state;case"RECEIVE_LED_CONTROLLER_TYPES":return Object.assign({},state,action.data);case"SET_LOADING":return Object.assign({},state,action.data);case"SET_DEFAULT_VALUES":Object(__WEBPACK_IMPORTED_MODULE_0__network_LEDControllerOverviewNetworkAPI__["h" /* setDefaultValues */])(action.data.dispatcher,action.data.defaultValues,action.data.showCustomAlert);return state;case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});case"ADD_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_LEDControllerOverviewNetworkAPI__["i" /* setLEDControllerDisableMonitoringData */])(action.data.dispatcher,action.data.stateValues,action.data.mac);return state;case"ADD_NEW_DEVICE":Object(__WEBPACK_IMPORTED_MODULE_0__network_LEDControllerOverviewNetworkAPI__["a" /* addLedController */])(action.data.dispatcher,action.data.model,action.data.showCustomAlert);return state;case"DELETE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_LEDControllerOverviewNetworkAPI__["k" /* updateLedControllerStatus */])(action.data.dispatcher,action.data.mac,action.data.assetType,"DEPRECATED",action.data.showCustomAlert);return state;case"SET_MONITORING_STATUS_LOADER":return Object.assign({},state,{monitoringStatusLoadingDevices:Object.assign({},state.monitoringStatusLoadingDevices,_defineProperty({},action.data.mac,action.data.monitoringStatusLoading))});default:return state;}};

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchLatestDataWithRetry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/**
 * React component for fetching latest data with linear retry logic.
 * @param fetchFn the function which will return the data to be fetched
 * @param conditionFn the function which will return true if the fetched data is latest
 * @param onSuccess the function which will be called if the fetched data is latest
 * @param onFailure the function which will be called if the fetched data is not latest
 * @param maxRetries the maximum number of retries
 * @param interval the interval between retries in milliseconds
 * @param onStart the function which will be called when the fetch starts
 * @returns {Promise<void>} the promise which will be resolved when the fetch is complete
 */var fetchLatestDataWithRetry=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref){var fetchFn=_ref.fetchFn,conditionFn=_ref.conditionFn,onSuccess=_ref.onSuccess,onFailure=_ref.onFailure,maxRetries=_ref.maxRetries,interval=_ref.interval,onStart=_ref.onStart;var retryCount,latestResult,delay;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:retryCount=0;latestResult=void 0;onStart();delay=function delay(ms){return new Promise(function(resolve){return setTimeout(resolve,ms);});};case 4:if(!(retryCount<maxRetries)){_context.next=20;break;}_context.next=7;return fetchFn();case 7:latestResult=_context.sent;_context.next=10;return conditionFn(latestResult);case 10:if(!_context.sent){_context.next=14;break;}_context.next=13;return onSuccess(latestResult);case 13:return _context.abrupt("return");case 14:retryCount++;if(!(retryCount<maxRetries)){_context.next=18;break;}_context.next=18;return delay(interval);case 18:_context.next=4;break;case 20:_context.next=22;return onFailure(latestResult);case 22:case"end":return _context.stop();}}},_callee,this);}));return function fetchLatestDataWithRetry(_x){return _ref2.apply(this,arguments);};}();

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_AdtaDeviceOverviewContext__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modal_AddAdtaSorterConfigurationModal__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_arrow_right_large__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_arrow_right_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_arrow_right_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modal_DeleteAdtaSorterConfigurationModal__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_upload_small__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_upload_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_upload_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modal_AddAdtaSorterTestPackageModal__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modal_DeleteAdtaSorterTestPackageModal__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__commonui_UploadFileModal__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_Parsers__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__commonui_ConfigurationTabHeader__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__commonui_PaginatedTable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__rollback_RollbackModal__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__util_ConditionalWrapping__ = __webpack_require__(91);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var AdtaDeviceConfiguration=function AdtaDeviceConfiguration(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__context_AdtaDeviceOverviewContext__["a" /* AdtaDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_23__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext2.getDraftData,setDraftData=_useContext2.setDraftData,resetDraftData=_useContext2.resetDraftData,getFilteredDraftData=_useContext2.getFilteredDraftData,isDataEdited=_useContext2.isDataEdited;var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_32__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorized=_useContext3.isAuthorized;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),openAddModal=_useState2[0],setOpenAddModal=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openDeleteModal=_useState4[0],setOpenDeleteModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),openCSVModal=_useState6[0],setOpenCSVModal=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),valueConfiguration=_useState8[0],setValueConfiguration=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),selectedMac=_useState10[0],setSelectedMac=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),showRollbackModal=_useState12[0],setShowRollbackModal=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),isVersionsLoading=_useState14[0],setIsVersionsLoading=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),selectedVersion=_useState16[0],setSelectedVersion=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),_useState18=_slicedToArray(_useState17,2),rollBackVersions=_useState18[0],setRollbackVersions=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])("scannables"),_useState20=_slicedToArray(_useState19,2),sorterTestPackageSortColumn=_useState20[0],setSorterTestPackageSortColumn=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_22__util_Constants__["J" /* ASCENDING */]),_useState22=_slicedToArray(_useState21,2),sorterTestPackageSortOrder=_useState22[0],setSorterTestPackageSortOrder=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])("bayId"),_useState24=_slicedToArray(_useState23,2),sorterDestinationSortColumn=_useState24[0],setSorterDestinationSortColumn=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_22__util_Constants__["J" /* ASCENDING */]),_useState26=_slicedToArray(_useState25,2),sorterDestinationSortOrder=_useState26[0],setSorterDestinationSortOrder=_useState26[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);var _useState27=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState28=_slicedToArray(_useState27,2),scannablesSearchInput=_useState28[0],setScannablesSearchInput=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState30=_slicedToArray(_useState29,2),sortZoneSearchInput=_useState30[0],setSortZoneSearchInput=_useState30[1];var _useContext4=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_30__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext4.showCustomAlert;var PAGE_CONFIGURATION_KEYS=[__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_TEST_PACKAGE,__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION];var searchDataForTestConfigTable=function searchDataForTestConfigTable(){var data=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_TEST_PACKAGE,subKey:selectedMac});data=data.filter(function(item){return Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_13" /* getTestConfigKey */])(item.scannables).toLowerCase().includes(scannablesSearchInput.toLowerCase());}).filter(function(item){return item.sortZone.toLowerCase().includes(sortZoneSearchInput.toLowerCase());});data=data.sort(function(a,b){return sortTestConfigColumns[sorterTestPackageSortColumn](a,b,sorterTestPackageSortOrder===__WEBPACK_IMPORTED_MODULE_22__util_Constants__["J" /* ASCENDING */]);});return data;};var getModalContent=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var versionsData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setIsVersionsLoading(true);_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_27__resources_AssetResource__["f" /* getAssetVersions */])(selectedMac);case 3:versionsData=_context.sent;setRollbackVersions(versionsData.data.assetVersionDetailsList);setIsVersionsLoading(false);case 6:case"end":return _context.stop();}}},_callee,_this);}));return function getModalContent(){return _ref2.apply(this,arguments);};}();var loadRollbackDataToDraft=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var rollbackData,sortTestPackageData,sorterConfigData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_27__resources_AssetResource__["e" /* getAssetByVersion */])(selectedMac,selectedVersion);case 2:rollbackData=_context2.sent;sortTestPackageData=Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.sorterTestPackage);},[]);sorterConfigData=Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.sorterConfig);},[]);if(sortTestPackageData.length){setDraftData({data:sortTestPackageData,stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_TEST_PACKAGE,subKey:selectedMac,allRowsAdded:true,override:true});}if(sorterConfigData.length){setDraftData({data:sorterConfigData,stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION,subKey:selectedMac,allRowsAdded:true,override:true});}case 7:case"end":return _context2.stop();}}},_callee2,_this);}));return function loadRollbackDataToDraft(){return _ref3.apply(this,arguments);};}();Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(!openAddModal&&!openDeleteModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["D" /* getAssetRefreshInterval */])());return function(){return clearInterval(interval);};}},[openAddModal,openDeleteModal]);Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return viewModel.sorterTestPackageConfig[selectedMac];},[]),stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_TEST_PACKAGE,subKey:selectedMac});setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return viewModel.sorterConfig[selectedMac];},[]),stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION,subKey:selectedMac});},[selectedMac]);var getSortedDeviceList=function getSortedDeviceList(){var sortedDeviceList=Object.values(viewModel.adtaDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){if(a.name<b.name){return-1;}else if(b.name>a.name){return 1;}return 0;});return sortedDeviceList;};var getData=function getData(){if(isDataEdited(PAGE_CONFIGURATION_KEYS))return;setOpenAddModal(false);setOpenDeleteModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var updateDestinationConfigDraftData=function updateDestinationConfigDraftData(sorterConfig){var compressedSorterConfig=Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["l" /* compressSorterConfig */])(sorterConfig);setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return compressedSorterConfig;},[]),stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION,subKey:selectedMac,allRowsAdded:true,override:true});};var updateTestConfigDraftData=function updateTestConfigDraftData(sorterTestPackage){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return sorterTestPackage;},[]),stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_TEST_PACKAGE,subKey:selectedMac,allRowsAdded:true,override:true});};var deployDraftADTAAsset=function deployDraftADTAAsset(){var sorterDestinationList=getFilteredDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION,subKey:selectedMac});var testPackageList=getFilteredDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_TEST_PACKAGE,subKey:selectedMac});dispatch({type:'UPDATE_ADTA_CONFIGURATION',data:{dispatcher:dispatch,showCustomAlert:showCustomAlert,configurations:{sorterTestPackage:testPackageList,sorterConfig:sorterDestinationList},mac:selectedMac}});setDraftData({data:sorterDestinationList,stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION,subKey:selectedMac,override:true});setDraftData({data:testPackageList,stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_TEST_PACKAGE,subKey:selectedMac,override:true});};function onClickUploadCSV(){setOpenCSVModal(true);}function onClickAddSingle(){setOpenAddModal(true);}function onClickDeleteConfiguration(){setOpenDeleteModal(true);}var getDataStringFromConfig=function getDataStringFromConfig(config){return['miss','jackpot','recirculation','problem_solve'].includes(config.installation.type)?config.fingerName?config.fingerName:"":config.installation.locations.join(' ');};var renderSorterConfigTableRow=function renderSorterConfigTableRow(config,index){var dataString=getDataStringFromConfig(config);var prevDataString=Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return getDataStringFromConfig(config.prev);},null);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:true,key:index,backgroundColor:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_148" /* OPERATION_COLOR */][config.operation]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,{spacingInset:"200 none none"},config.bayId)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,config.installation.type),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,null,prevDataString&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_text___default.a,null," ",prevDataString," "),prevDataString&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_text___default.a,null," ",dataString," "))));};var sortDestinationConfigColumns={bayId:function bayId(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.bayId,b.bayId):-Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.bayId,b.bayId);},installationType:function installationType(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.installation.type,b.installation.type):-Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.installation.type,b.installation.type);},location:function location(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(getDataStringFromConfig(a),getDataStringFromConfig(b)):-Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(getDataStringFromConfig(a),getDataStringFromConfig(b));}};var sortTestConfigColumns={scannables:function scannables(a,b,ascending){var scannableFirst=Array.isArray(a.scannables)?a.scannables.join(' '):a.scannables;var scannableSecond=Array.isArray(b.scannables)?b.scannables.join(' '):b.scannables;return ascending?Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(scannableFirst,scannableSecond):-Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(scannableFirst,scannableSecond);},sortZone:function sortZone(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.sortZone,b.sortZone):-Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.sortZone,b.sortZone);}};var renderSorterConfigTableHeader=function renderSorterConfigTableHeader(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"bayId"},Object(__WEBPACK_IMPORTED_MODULE_31__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.id"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"installationType"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.installationtype",defaultMessage:"Installation Type"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"location"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.location",defaultMessage:"Locations"})));};var getHeaderProps=function getHeaderProps(){return{selectedMac:selectedMac,setSelectedMac:setSelectedMac,valueConfiguration:valueConfiguration,setValueConfiguration:setValueConfiguration,isSorterConfig:valueConfiguration===__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION,isAuthorized:isAuthorized,intl:intl,defaultSelection:"",resetDraftData:resetDraftData,deployDraft:deployDraftADTAAsset,scrollToBottom:scrollToBottom,sortedDeviceList:getSortedDeviceList(),configurationKeys:PAGE_CONFIGURATION_KEYS,refreshDeps:[viewModel.timestamp],isDeployDisabled:!isDataEdited(PAGE_CONFIGURATION_KEYS),isRollbackDisabled:!selectedMac||isDataEdited(PAGE_CONFIGURATION_KEYS),rollbackClickHandler:function rollbackClickHandler(){getModalContent();setShowRollbackModal(true);}};};var renderTestConfigTableHeader=function renderTestConfigTableHeader(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.index",defaultMessage:"Index"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"scannables"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.scannables",defaultMessage:"Scannables"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"sortZone"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.sortzone",defaultMessage:"Sort Zone"})));};var renderTestConfigTableRow=function renderTestConfigTableRow(config,serialNumber){var dataString=config.sortZone;var prevDataString=Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return config.prev.sortZone;},null);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:true,backgroundColor:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_148" /* OPERATION_COLOR */][config.operation]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,serialNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,Array.isArray(config.scannables)?config.scannables.join(' '):config.scannables),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,prevDataString&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_text___default.a,null," ",prevDataString," "),prevDataString&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_text___default.a,null," ",dataString," ")));};var renderSearchRow=function renderSearchRow(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{backgroundColor:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_177" /* SEARCH_ROW_COLOR */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_input___default.a,{className:"input-search-class",value:scannablesSearchInput,onChange:setScannablesSearchInput,type:"text",placeholder:"Search",width:"70%",size:"small"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_input___default.a,{className:"input-search-class",value:sortZoneSearchInput,onChange:setSortZoneSearchInput,type:"text",placeholder:"Search",width:"70%",size:"small"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null));};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__commonui_ConfigurationTabHeader__["a" /* default */],getHeaderProps()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__rollback_RollbackModal__["a" /* default */],{showRollbackModal:showRollbackModal,setShowRollbackModal:setShowRollbackModal,isVersionsLoading:isVersionsLoading,selectedVersion:selectedVersion,setSelectedVersion:setSelectedVersion,rollBackVersions:rollBackVersions,loadRollbackDataToDraft:loadRollbackDataToDraft,intl:intl}),valueConfiguration===__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION&&selectedMac&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__commonui_PaginatedTable__["a" /* default */],{data:getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION,subKey:selectedMac}).sort(function(a,b){return sortDestinationConfigColumns[sorterDestinationSortColumn](a,b,sorterDestinationSortOrder===__WEBPACK_IMPORTED_MODULE_22__util_Constants__["J" /* ASCENDING */]);}),renderRow:renderSorterConfigTableRow,renderHeader:renderSorterConfigTableHeader,sortColumn:sorterDestinationSortColumn,sortDirection:sorterDestinationSortOrder,onSort:function onSort(_ref4){var sortColumn=_ref4.sortColumn,sortDirection=_ref4.sortDirection;setSorterDestinationSortColumn(sortColumn);setSorterDestinationSortOrder(sortDirection);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",widths:["100","100","fill","100"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_33__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_31__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"top"},child:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{onClick:onClickAddSingle,type:"primary",size:"small",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"sorterconfig.addupdate",defaultMessage:"Add/Update Sorter Destination Configuration"}))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_33__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_31__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"top"},child:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{onClick:onClickUploadCSV,type:"primary",size:"small",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_upload_small___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"sorterconfig.uploadCSV",defaultMessage:"Upload Sorter Destination Configuration CSV"}))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_33__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_31__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"top"},child:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{onClick:onClickDeleteConfiguration,size:"small",type:"tertiary",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"config.delete",defaultMessage:"Delete Configuration"}))})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__commonui_UploadFileModal__["a" /* default */],{mac:selectedMac,open:openCSVModal,setOpen:setOpenCSVModal,parser:__WEBPACK_IMPORTED_MODULE_21__util_Parsers__["h" /* SorterConfigCSVParser */],updateConfig:updateDestinationConfigDraftData}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__modal_AddAdtaSorterConfigurationModal__["a" /* default */],{mac:selectedMac,open:openAddModal,setOpen:setOpenAddModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__modal_DeleteAdtaSorterConfigurationModal__["a" /* default */],{mac:selectedMac,open:openDeleteModal,setOpen:setOpenDeleteModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{ref:tableEndRef})),valueConfiguration===__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_TEST_PACKAGE&&selectedMac&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__commonui_PaginatedTable__["a" /* default */],{data:searchDataForTestConfigTable(),renderRow:renderTestConfigTableRow,renderHeader:renderTestConfigTableHeader,renderSearchRow:renderSearchRow,sortColumn:sorterTestPackageSortColumn,sortDirection:sorterTestPackageSortOrder,onSort:function onSort(_ref5){var sortColumn=_ref5.sortColumn,sortDirection=_ref5.sortDirection;setSorterTestPackageSortColumn(sortColumn);setSorterTestPackageSortOrder(sortDirection);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",widths:["100","100","fill","100"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{onClick:onClickAddSingle,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"sortertestconfig.addupdatetest",defaultMessage:"Add/Update Sorter Test Package Configuration"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{onClick:onClickUploadCSV,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_upload_small___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"sortertestconfig.uploadCSV",defaultMessage:"Upload Sorter Test Package Configuration CSV"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{onClick:onClickDeleteConfiguration,size:"small",type:"tertiary"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"config.deletetest",defaultMessage:"Delete Sorter Test Package Configuration"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__commonui_UploadFileModal__["a" /* default */],{mac:selectedMac,open:openCSVModal,setOpen:setOpenCSVModal,parser:__WEBPACK_IMPORTED_MODULE_21__util_Parsers__["k" /* TestConfigCSVParser */],updateConfig:updateTestConfigDraftData}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__modal_AddAdtaSorterTestPackageModal__["a" /* default */],{mac:selectedMac,open:openAddModal,setOpen:setOpenAddModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__modal_DeleteAdtaSorterTestPackageModal__["a" /* default */],{mac:selectedMac,open:openDeleteModal,setOpen:setOpenDeleteModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AdtaDeviceConfiguration));

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_FeatureUtility__ = __webpack_require__(63);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddAdtaSorterConfigurationModal=function AddAdtaSorterConfigurationModal(props){var formatMessage=props.intl.formatMessage;var mac=props.mac,intl=props.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,addInstance=_useContext.addInstance,editInstance=_useContext.editInstance;var installationType=Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["R" /* getInstallationTypes */])();// Visual controls
var open=props.open,setOpen=props.setOpen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),show=_useState2[0],setShow=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),edit=_useState4[0],setEdit=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),showFinger=_useState6[0],setShowFinger=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState8=_slicedToArray(_useState7,2),showLocation=_useState8[0],setShowLocation=_useState8[1];// Values
var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),locations=_useState10[0],setLocations=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),type=_useState12[0],setType=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),bayId=_useState14[0],setBayId=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),fingerName=_useState16[0],setFingerName=_useState16[1];// Error
var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState18=_slicedToArray(_useState17,2),locationsErr=_useState18[0],setLocationsErr=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState20=_slicedToArray(_useState19,2),typeErr=_useState20[0],setTypeErr=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),bayIdErr=_useState22[0],setBayIdErr=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),fingerNameErr=_useState24[0],setFingerNameErr=_useState24[1];var onCloseModal=function onCloseModal(){setShow(false);setOpen(false);resetInputState();};var modalSorterConfig={bayId:bayId,fingerName:fingerName,installation:{type:type,locations:locations}/* Filling a map: sorterConfigMap with bayId as key in case of an update of existing asset */};var sorterConfigMap={};getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION,subKey:mac}).forEach(function(value){var key=Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["_8" /* getSorterConfigKey */])(value.bayId,value.installation.type);sorterConfigMap[key]={locations:value.installation.locations,fingerName:value.fingerName,type:value.installation.type};});var onClickConfirm=function onClickConfirm(modalSorterConfig,mac){if(Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["x" /* checkModalValidationsForConfig */])(modalSorterConfig,mac,__WEBPACK_IMPORTED_MODULE_10__util_Constants__["c" /* ADTA_ASSET_TYPE */])){setConfigData(modalSorterConfig,mac);setOpen(false);resetInputState();setShow(false);}else{setShow(true);}};function resetInputState(){setBayId("");setBayIdErr(false);setType("");setTypeErr(false);resetConfigDetails();resetConfigErrorDetails();}var resetConfigDetails=function resetConfigDetails(){setLocations("");setFingerName("");setShowFinger(false);setShowLocation(true);};var resetConfigErrorDetails=function resetConfigErrorDetails(){setTypeErr(false);setLocationsErr(false);setFingerNameErr(false);};var processType=function processType(type){if(['miss','jackpot','recirculation','problem_solve'].includes(type)){setShowFinger(true);setShowLocation(false);}else{setShowFinger(false);setShowLocation(true);}};var prefill=function prefill(){var key=Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["_8" /* getSorterConfigKey */])(bayId,type);if(sorterConfigMap.hasOwnProperty(key)){setEdit(true);resetConfigErrorDetails();setLocations(Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["_9" /* getSorterConfigLocationStringForm */])(sorterConfigMap[key].locations));setFingerName(sorterConfigMap[key].fingerName);}else if(edit){setEdit(false);resetConfigDetails();}};var setConfigData=function setConfigData(modalSorterConfig,mac){if(__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_1" /* CATCH_ALL_INSTALLATION_TYPES */].includes(modalSorterConfig.installation.type)&&modalSorterConfig.installation.locations.length===0){modalSorterConfig.installation.locations=[""];}else if(modalSorterConfig.installation.locations){modalSorterConfig.installation.locations=modalSorterConfig.installation.locations.replace(/\s/g,'').split(';').filter(Boolean);}else{modalSorterConfig.installation.locations=[];}/* sorter config are stored and passed as map with bayId as key */if(edit){editInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION,subKey:mac,instance:modalSorterConfig,keyComparator:function keyComparator(config1,config2){return Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["_8" /* getSorterConfigKey */])(config1.bayId,config1.installation.type)===Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["_8" /* getSorterConfigKey */])(config2.bayId,config2.installation.type);},valueComparator:function valueComparator(config1,config2){return JSON.stringify(config1.fingerName)===JSON.stringify(config2.fingerName)&&JSON.stringify(config1.installation.locations)===JSON.stringify(config2.installation.locations);}});}else{addInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION,subKey:mac,instance:modalSorterConfig});}};var generateHelperText=function generateHelperText(){return(__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_1" /* CATCH_ALL_INSTALLATION_TYPES */].includes(type)?Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.optional"}):"")+(__WEBPACK_IMPORTED_MODULE_15__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_15__util_FeatureUtility__["a" /* FEATURES */].IS_SSD3_ENABLED)?Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.adtr_location_example"}):Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.location_example"}));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"sorterconfig.addupdate"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.addheading",defaultMessage:"To edit an existing configuration, enter the Bay Id."}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.id"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"bay-id-input",value:bayId,onChange:setBayId,onBlur:function onBlur(){setBayIdErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(bayId,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].BAY_ID));prefill();},error:bayIdErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.installationtype",defaultMessage:"Installation Type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default.a,{id:"type-input",value:type,onChange:setType,onBlur:function onBlur(){processType(type);prefill();},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.enter_value",defaultMessage:"Enter value..."}),width:"100%",error:typeErr},Object.values(installationType).map(function(_ref,index){var label=_ref.label,value=_ref.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__["SelectOption"],{key:index,value:value,label:label});}))),showLocation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.location",defaultMessage:"Locations"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"location-input",value:locations,onChange:setLocations,onBlur:function onBlur(){setLocationsErr(!(__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_1" /* CATCH_ALL_INSTALLATION_TYPES */].includes(type)&&Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(locations,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].CATCH_ALL_LOCATION)||Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(locations,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].LOCATION)));},error:locationsErr,helperText:generateHelperText()})),showFinger&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.fingerName",defaultMessage:"Finger Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"finger-name-input",value:fingerName,onChange:setFingerName,onBlur:function onBlur(){setFingerNameErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(fingerName,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].SHORT_STRING));},error:fingerNameErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.fingerName_desc",defaultMessage:"[Optional field] These bays should be associated with their finger name to identify them in-case of multiple fingers within the same ADTA."})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["x" /* checkModalValidationsForConfig */])(modalSorterConfig,mac,__WEBPACK_IMPORTED_MODULE_10__util_Constants__["c" /* ADTA_ASSET_TYPE */])&&show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(modalSorterConfig,mac);}},edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmUpdate",defaultMessage:"Confirm update"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddAdtaSorterConfigurationModal));

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DraftSaveReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initialState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var DraftSaveReducer=function DraftSaveReducer(state,action){var _action$data=action.data,data=_action$data.data,stateKey=_action$data.stateKey,subKey=_action$data.subKey,newInstance=_action$data.newInstance,keyComparator=_action$data.keyComparator,valueComparator=_action$data.valueComparator,allRowsAdded=_action$data.allRowsAdded;switch(action.type){case'SET_DATA':{return Object.assign({},state,_defineProperty({},stateKey,Object.assign({},state[stateKey],_defineProperty({},subKey,{initialData:allRowsAdded?state[stateKey][subKey].initialData:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["t" /* deepCopyObject */])(data),data:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["t" /* deepCopyObject */])(data)}))));}case'RESET_DATA':return Object.assign({},state,_defineProperty({},stateKey,Object.assign({},state[stateKey],_defineProperty({},subKey,Object.assign({},state[stateKey][subKey],{data:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["t" /* deepCopyObject */])(state[stateKey][subKey].initialData)})))));case'ADD_INSTANCE':return Object.assign({},state,_defineProperty({},stateKey,Object.assign({},state[stateKey],_defineProperty({},subKey,Object.assign({},state[stateKey][subKey],{data:[].concat(_toConsumableArray(state[stateKey][subKey].data),[newInstance])})))));case'EDIT_INSTANCE':return Object.assign({},state,_defineProperty({},stateKey,Object.assign({},state[stateKey],_defineProperty({},subKey,Object.assign({},state[stateKey][subKey],{data:state[stateKey][subKey].data.map(function(instance){if(keyComparator(newInstance,instance)){var op=__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_147" /* OPERATIONS */].EDIT;if(valueComparator(newInstance,instance)){op=instance.operation;}else if(instance.operation===__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_147" /* OPERATIONS */].ADD){op=__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_147" /* OPERATIONS */].ADD;}if(op===__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_147" /* OPERATIONS */].EDIT)return Object.assign({},newInstance,{operation:op,prev:instance});else return Object.assign({},newInstance,{operation:op});}return instance;})})))));case'DELETE_INSTANCE':return Object.assign({},state,_defineProperty({},stateKey,Object.assign({},state[stateKey],_defineProperty({},subKey,Object.assign({},state[stateKey][subKey],{data:state[stateKey][subKey].data.filter(function(instance){if(keyComparator(instance)){return instance.operation!==__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_147" /* OPERATIONS */].ADD;}return true;}).map(function(instance){if(keyComparator(instance)){instance.operation=__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_147" /* OPERATIONS */].DELETE;}return instance;})})))));case'DELETE_ALL':return Object.assign({},state,_defineProperty({},stateKey,Object.assign({},state[stateKey],_defineProperty({},subKey,Object.assign({},state[stateKey][subKey],{data:state[stateKey][subKey].data.map(function(instance){return Object.assign({},instance,{operation:__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_147" /* OPERATIONS */].DELETE});})})))));default:return state;}};var initialState={};// Add state key in list for maintaining a new state
Object.values(__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_4" /* CONFIG_TYPE */]).forEach(function(key){initialState[key]={};});

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var DeleteAdtaSorterConfigurationModal=function DeleteAdtaSorterConfigurationModal(props){var formatMessage=props.intl.formatMessage;var mac=props.mac;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,deleteInstance=_useContext.deleteInstance,deleteAll=_useContext.deleteAll;var open=props.open,setOpen=props.setOpen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),bayId=_useState2[0],setBayId=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),searchQuery=_useState4[0],setSearchQuery=_useState4[1];var onCloseModal=function onCloseModal(){setOpen(false);resetInputState();};var stateValues={bayId:bayId,mac:mac};var sorterConfigList=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION,subKey:mac}).map(function(_ref){var bayId=_ref.bayId;return bayId;});var searchRegExp=new RegExp(__WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp___default()(searchQuery),"i");// Converting to set to remove non-unique bay ids from DDB form
var matchedOptions=[].concat(_toConsumableArray(new Set(sorterConfigList.filter(function(option){return!searchQuery||searchRegExp.test(option);}))));var onClickConfirm=function onClickConfirm(stateValues){deleteData(stateValues);setOpen(false);resetInputState();};function resetInputState(){setBayId("");}var deleteData=function deleteData(stateValues){deleteInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION,subKey:stateValues.mac,keyComparator:function keyComparator(instance){return instance.bayId===stateValues.bayId;}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.delete_config_button_modal"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.bayiddelete",defaultMessage:"Please select the Bay Id you would like to remove:"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default.a,{value:bayId,onChange:setBayId,searchQuery:searchQuery,onSearch:setSearchQuery,placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.selectbayid",defaultMessage:"Select bay ID"}),width:"100%"},matchedOptions.map(function(bayId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__["SelectOption"],{key:bayId,value:bayId,label:bayId});}),!matchedOptions.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},sorterConfigList?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," No matching bay IDs "):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," No bay IDs available ")):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{size:"small",className:"redBtn",onClick:function onClick(){deleteAll({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_DESTINATION,subKey:stateValues.mac});onCloseModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.deleteAll",defaultMessage:"Delete All"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"secondary",size:"small",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:function onClick(){return onClickConfirm(stateValues);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.confirm",defaultMessage:"Confirm"})))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(DeleteAdtaSorterConfigurationModal));

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_Util__ = __webpack_require__(5);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddAdtaSorterTestPackageModal=function AddAdtaSorterTestPackageModal(props){var formatMessage=props.intl.formatMessage;var mac=props.mac;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,addInstance=_useContext.addInstance,editInstance=_useContext.editInstance;// Visual controls
var open=props.open,setOpen=props.setOpen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),show=_useState2[0],setShow=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),edit=_useState4[0],setEdit=_useState4[1];// Values
var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),scannables=_useState6[0],setScannables=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),sortZone=_useState8[0],setSortZone=_useState8[1];// Error
var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),scannablesErr=_useState10[0],setScannablesErr=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),sortZoneErr=_useState12[0],setSortZoneErr=_useState12[1];function onCloseModal(){setShow(false);setOpen(false);resetInputState();}var sorterTestPackage={scannables:scannables.split(';').filter(Boolean),sortZone:sortZone};var testConfigMap={};getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_TEST_PACKAGE,subKey:mac}).forEach(function(value){var key=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_13" /* getTestConfigKey */])(value.scannables);testConfigMap[key]={sortZone:value.sortZone};});var onClickConfirm=function onClickConfirm(sorterTestPackage,mac){if(Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["z" /* checkModalValidationsForTestPackage */])(sorterTestPackage)){setConfigData(sorterTestPackage,mac);setOpen(false);resetInputState();setShow(false);}else{setShow(true);}};var prefill=function prefill(){var key=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_13" /* getTestConfigKey */])(sorterTestPackage.scannables);if(testConfigMap.hasOwnProperty(key)){setEdit(true);resetConfigErrorDetails();setSortZone(testConfigMap[key].sortZone);}else if(edit){setEdit(false);resetConfigDetails();}};function resetInputState(){setScannables("");resetConfigDetails();resetConfigErrorDetails();}var resetConfigDetails=function resetConfigDetails(){setSortZone("");};var resetConfigErrorDetails=function resetConfigErrorDetails(){setSortZoneErr(false);};var setConfigData=function setConfigData(sorterTestPackage,mac){if(edit){editInstance({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_TEST_PACKAGE,subKey:mac,instance:sorterTestPackage,keyComparator:function keyComparator(config1,config2){return Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_13" /* getTestConfigKey */])(config1.scannables)===Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_13" /* getTestConfigKey */])(config2.scannables);},valueComparator:function valueComparator(config1,config2){return config1.sortZone===config2.sortZone;}});}else{addInstance({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_TEST_PACKAGE,subKey:mac,instance:sorterTestPackage});}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"sortertestconfig.addupdatetest"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.addheadingtest",defaultMessage:"To edit an existing configuration, enter its Sort Zone."}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.scannables",defaultMessage:"Scannables"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"scannables-input",value:scannables,onChange:function onChange(value){setScannables(value.replace(/\s/g,''));},onBlur:function onBlur(){setScannablesErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(scannables,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].TEST_SCANNABLE));prefill();},error:scannablesErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.scannables_description",defaultMessage:"Tracking/Shipment ID. Separate multiple values by semicolon (;)"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.sortzone",defaultMessage:"Sort Zone"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"sort-zone-input",value:sortZone,onChange:setSortZone,onBlur:function onBlur(){setSortZoneErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(sortZone,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].SORT_ZONE));},error:sortZoneErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.sortzone_description",defaultMessage:"eg. EU: A1-1A, NA: A-1.1A"})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["z" /* checkModalValidationsForTestPackage */])(sorterTestPackage)&&show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(sorterTestPackage,mac);}},edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmUpdate",defaultMessage:"Confirm update"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddAdtaSorterTestPackageModal));

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_trash__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DeleteAdtaSorterTestPackageModal=function DeleteAdtaSorterTestPackageModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,mac=props.mac;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,deleteInstance=_useContext.deleteInstance,deleteAll=_useContext.deleteAll;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),selectedScannables=_useState2[0],setSelectedScannables=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),searchQuery=_useState4[0],setSearchQuery=_useState4[1];var onCloseModal=function onCloseModal(){setOpen(false);resetInputState();};var scannableKeyList=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_TEST_PACKAGE,subKey:mac}).map(function(_ref){var scannables=_ref.scannables;return Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_13" /* getTestConfigKey */])(scannables);});var searchRegExp=new RegExp(__WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp___default()(searchQuery),"i");var matchedKeys=scannableKeyList.filter(function(option){return!searchQuery||searchRegExp.test(option);});var onClickConfirm=function onClickConfirm(){deleteData();setOpen(false);resetInputState();};function resetInputState(){setSelectedScannables("");}var deleteData=function deleteData(){deleteInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_TEST_PACKAGE,subKey:mac,keyComparator:function keyComparator(instance){return Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_13" /* getTestConfigKey */])(instance.scannables)===selectedScannables;}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default.a,{title:formatMessage({id:"config.deletetest"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.sortzonedelete",defaultMessage:"Please select the scannable you would like to remove."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default.a,{value:selectedScannables,onChange:setSelectedScannables,searchQuery:searchQuery,onSearch:setSearchQuery,placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"sortertestconfig.delete",defaultMessage:"Select test package to be deleted."}),width:"100%"},matchedKeys.map(function(scannable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__["SelectOption"],{key:scannable,value:scannable,label:scannable});}),!matchedKeys.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},scannableKeyList?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"sortertestconfig.nomatch",defaultMessage:"No matching test packages"}),"  "):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"sortertestconfig.notavailable",defaultMessage:"No test packages available"})," ")):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{size:"small",className:"redBtn",onClick:function onClick(){deleteAll({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].SORTER_TEST_PACKAGE,subKey:mac});onCloseModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.deleteAll",defaultMessage:"Delete All"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"secondary",size:"small",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:onClickConfirm},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.confirm",defaultMessage:"Confirm"})))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(DeleteAdtaSorterTestPackageModal));

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FileDetails", {
  enumerable: true,
  get: function get() {
    return _fileDetails["default"];
  }
});
exports["default"] = void 0;

var _fileInput = _interopRequireDefault(__webpack_require__(1067));

var _fileDetails = _interopRequireDefault(__webpack_require__(1076));

var _default = _fileInput["default"];
exports["default"] = _default;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _reactDropzone = __webpack_require__(1068);

var _emotion = __webpack_require__(11);

var _uploadLarge = _interopRequireDefault(__webpack_require__(1074));

var _uploadSmall = _interopRequireDefault(__webpack_require__(117));

var _fileInput = _interopRequireDefault(__webpack_require__(1075));

var _button = _interopRequireDefault(__webpack_require__(8));

var _column = _interopRequireDefault(__webpack_require__(6));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _row = _interopRequireDefault(__webpack_require__(10));

var _text = _interopRequireDefault(__webpack_require__(9));

var _theme = __webpack_require__(24);

var _token = __webpack_require__(20);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var fileDetailsStyles = function fileDetailsStyles(t) {
  return (0, _emotion.css)({
    "& > *": {
      paddingLeft: t("fileSpacingInset"),
      paddingRight: t("fileSpacingInset")
    },
    "& > *:not(:last-child)": {
      paddingBottom: t("fileSpacingInset"),
      borderBottomWidth: t("fileBorderWidth"),
      borderBottomColor: t("fileBorderColor"),
      borderBottomStyle: "solid"
    }
  });
};

var dropZoneStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var showDropZone = _ref.showDropZone,
      isDragActive = _ref.isDragActive;
  return (0, _emotion.css)({
    transition: "opacity ".concat(t("dragOverlayContainerMotionDuration"), " ").concat(t("dragOverlayContainerMotionFunction")),
    // HACK: Disable pointer events on all the children of the container
    // (the upload button and drop zone label) when dragging because
    // dragging over those will cancel the drag operation. This behavior
    // seems to be an issue with react-dropzone.
    "& > *": {
      pointerEvents: isDragActive ? "none" : undefined
    }
  }, showDropZone ? {
    borderRadius: t("borderRadius"),
    borderWidth: t("borderWidth"),
    borderColor: t("borderColor"),
    borderStyle: "dashed"
  } : {});
}, ["showDropZone", "isDragActive"]);

var dropZoneOverlayStyles = function dropZoneOverlayStyles(t, _ref2) {
  var isDragActive = _ref2.isDragActive;
  return (0, _emotion.css)({
    borderRadius: t("borderRadius"),
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    backgroundColor: t("dragOverlayContainerBackgroundColor"),
    opacity: isDragActive ? 1 : 0,
    transition: "opacity ".concat(t("dragOverlayContainerMotionDuration"), " ").concat(t("dragOverlayContainerMotionFunction")),
    pointerEvents: "none"
  });
};

var regionStyles = (0, _emotion.css)({
  position: "relative"
});
/* eslint-disable react/prop-types */

var RowOrColumn = function RowOrColumn(_ref3) {
  var direction = _ref3.direction,
      children = _ref3.children;
  return direction === "column" ? /*#__PURE__*/_react["default"].createElement(_column["default"], {
    alignmentHorizontal: "center"
  }, children) : /*#__PURE__*/_react["default"].createElement(_row["default"], null, children);
};
/* eslint-enable react/prop-types */

/**
 * Render a component to handle the front-end interactions
 * and rendering for uploading files. It's important to note
 * that FileInput does **not** provide the services for
 * actually uploading files to a back-end.
 */


var FileInput = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_fileInput["default"], "fileInput");
  var type = props.type,
      fileDetails = props.children,
      onFileAttached = props.onFileAttached,
      accept = props.accept;
  var dropZoneLabel = props.dropZoneLabel || props.supplementalLabel || "or drag file".concat(type === "multiple" ? "s" : "", " here");
  var dropZoneActiveLabel = props.dropZoneActiveLabel || props.activeLabel || "Drop file".concat(type === "multiple" ? "s" : "", " to upload");
  var onDrop = (0, _react.useCallback)(function (acceptedFiles) {
    onFileAttached(acceptedFiles);
  }, [onFileAttached]); // TODO: Change the default to this to plain ole false in the next major
  // version (doesn't make sense to tie drop zone to single/multiple)

  var showDropZone = props.showDropZone === undefined ? type === "multiple" : props.showDropZone;

  var _useDropzone = (0, _reactDropzone.useDropzone)({
    multiple: type === "multiple",
    noClick: !showDropZone,
    noDrag: !showDropZone,
    // We disable keyboard here because we handle focus on our own.
    noKeyboard: true,
    accept: accept,
    onDrop: onDrop
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive,
      open = _useDropzone.open; // Only show the file details when at least one exists to prevent the parent
  // Row from adding unnecessary spacing


  var showFileDetails = (0, _react.useMemo)(function () {
    return _react["default"].Children.toArray(fileDetails).some(Boolean);
  }, [fileDetails]);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
  return /*#__PURE__*/_react["default"].createElement(_row["default"], {
    alignmentVertical: "top"
  }, /*#__PURE__*/_react["default"].createElement("div", getRootProps({
    role: "region",
    className: regionStyles,
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement(_column["default"], {
    spacingInset: showDropZone ? "large" : "none",
    className: dropZoneStyles(t, {
      showDropZone: showDropZone,
      isDragActive: isDragActive
    })
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, passThroughProps, getInputProps())), /*#__PURE__*/_react["default"].createElement(RowOrColumn, {
    direction: props.dropZoneDirection
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    onClick: // If we've got a drop zone that'll handle all the click events
    showDropZone ? undefined : open,
    label: "".concat(props.uploadButtonLabel).concat(showDropZone ? " " + dropZoneLabel : ""),
    type: props.uploadButtonType,
    size: props.uploadButtonSize,
    disabled: props.uploadButtonDisabled,
    ref: props.buttonRef
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: props.uploadButtonSize === "small" ? _uploadSmall["default"] : _uploadLarge["default"]
  }), props.uploadButtonLabel), showDropZone ? /*#__PURE__*/_react["default"].createElement(_text["default"], null, dropZoneLabel) : null)), showDropZone ? /*#__PURE__*/_react["default"].createElement(_column["default"], {
    className: dropZoneOverlayStyles(t, {
      isDragActive: isDragActive
    }),
    alignmentHorizontal: "center",
    alignmentVertical: "center"
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _uploadLarge["default"]
  }), isDragActive ? /*#__PURE__*/_react["default"].createElement(_text["default"], {
    color: "inverted",
    type: "h100",
    tag: "div"
  }, dropZoneActiveLabel) : null) : null), showFileDetails ? /*#__PURE__*/_react["default"].createElement(_column["default"], {
    className: fileDetailsStyles(t),
    minWidth: 0
  }, fileDetails) : null);
});

FileInput.propTypes =  false ? {
  /**
   * Callback function that fires after files have been uploaded.
   * Returns an array of files that contains file name and local path.
   */
  onFileAttached: _propTypes["default"].func.isRequired,

  /**
   * Defines what file types the file input should accept.`accept="image/*,.pdf"`,
   * for example, will force users to select image or .pdf files.
   *
   * See the [MDN docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept)
   * for more details and examples.
   *
   * @since  5.x
   */
  accept: _propTypes["default"].string,

  /**
   * The label that displays on the overlay that shows when files are dragged
   * onto the FileInput. Only applicable when `showDropZone` is on.
   *
   * NOTE: This is deprecated and will be removed in the next major version.
   * Please use dropZoneActiveLabel instead.
   *
   * @deprecated 5.x
   */
  activeLabel: _propTypes["default"].string,

  /**
   * Ref that will be passed to the file input button.
   *
   * @since 5.20.0
   */
  buttonRef: _propTypes["default"].object,

  /**
   * Expects FileDetails components. Will build a list of
   * FileDetails component.
   */
  children: _propTypes["default"].node,

  /**
   * All props prefaced with `data-` are accepted. These props will be passed
   * through to the underlying `input[type=file]` element. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * The label that displays on the overlay that shows when files are dragged
   * onto the FileInput. Only applicable when `showDropZone` is on.
   *
   * @since 5.x
   */
  dropZoneActiveLabel: _propTypes["default"].string,

  /**
   * Set the drop zone (upload button + drop zone label) direction. By default the
   * drop zone is arranged in a row with the upload button before the label.
   *
   * @since 5.10.0
   */
  dropZoneDirection: _propTypes["default"].oneOf(["row", "column"]),

  /**
   * The label displayed in the drop zone when `showDropZone` is on.
   *
   * @since 5.x
   */
  dropZoneLabel: _propTypes["default"].string,

  /**
   * Determines whether a "drop zone" is shown around the upload button to make
   * it easy to upload files by dragging and dropping them.
   *
   * NOTE: This defaults to `true` when `type="multiple"` and `false` when
   * `type="single"`. In the future this will default to `false` for both types,
   * so we recommend always setting this prop to `true` if you want this
   * feature enabled.
   *
   * @since 5.x
   */
  showDropZone: _propTypes["default"].bool,

  /**
   * The label displayed in the drop zone when `showDropZone` is on.
   *
   * NOTE: This is deprecated and will be removed in the next major version.
   * Please use dropZoneLabel instead.
   *
   * @deprecated 5.x
   */
  supplementalLabel: _propTypes["default"].string,

  /**
   * Determines whether or not the FileInput will accept multiple files.
   */
  type: _propTypes["default"].oneOf(["single", "multiple"]),

  /**
   * This disables interaction with the upload button and applies special visual
   * styles to indicate that it's not interactive.
   *
   * @since 5.x
   */
  uploadButtonDisabled: _propTypes["default"].bool,

  /**
   * The label for the upload button.
   */
  uploadButtonLabel: _propTypes["default"].string,

  /**
   * The size of the upload button. See the [Button](https://meridian.a2z.com/components/button?platform=react-web)
   * component documentation for details.
   *
   * @since 5.x
   */
  uploadButtonSize: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * The type of the upload button. See the [Button](https://meridian.a2z.com/components/button?platform=react-web)
   * component documentation for details.
   *
   * @since 5.x
   */
  uploadButtonType: _propTypes["default"].oneOf(["primary", "secondary", "tertiary", "link"])
} : {};
FileInput.defaultProps = {
  type: "single",
  uploadButtonLabel: "Upload file",
  uploadButtonDisabled: false,
  dropZoneDirection: "row"
};
FileInput.displayName = "FileInput";
var _default = FileInput;
exports["default"] = _default;

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["useDropzone"] = useDropzone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_selector__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_index__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(453);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorCode", function() { return __WEBPACK_IMPORTED_MODULE_4__utils__["a"]; });
var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint prefer-template: 0 */




/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useImperativeHandle"])(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = 'Dropzone'; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: __WEBPACK_IMPORTED_MODULE_2_file_selector__["a" /* fromEvent */],
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Custom validation function
   * @param {File} file
   * @returns {FileError|FileError[]}
   */
  validator: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["default"] = (Dropzone);
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */

function useDropzone() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$options = _objectSpread(_objectSpread({}, defaultProps), options),
      accept = _defaultProps$options.accept,
      disabled = _defaultProps$options.disabled,
      getFilesFromEvent = _defaultProps$options.getFilesFromEvent,
      maxSize = _defaultProps$options.maxSize,
      minSize = _defaultProps$options.minSize,
      multiple = _defaultProps$options.multiple,
      maxFiles = _defaultProps$options.maxFiles,
      onDragEnter = _defaultProps$options.onDragEnter,
      onDragLeave = _defaultProps$options.onDragLeave,
      onDragOver = _defaultProps$options.onDragOver,
      onDrop = _defaultProps$options.onDrop,
      onDropAccepted = _defaultProps$options.onDropAccepted,
      onDropRejected = _defaultProps$options.onDropRejected,
      onFileDialogCancel = _defaultProps$options.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$options.onFileDialogOpen,
      useFsAccessApi = _defaultProps$options.useFsAccessApi,
      preventDropOnDocument = _defaultProps$options.preventDropOnDocument,
      noClick = _defaultProps$options.noClick,
      noKeyboard = _defaultProps$options.noKeyboard,
      noDrag = _defaultProps$options.noDrag,
      noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling,
      validator = _defaultProps$options.validator;

  var onFileDialogOpenCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return typeof onFileDialogOpen === 'function' ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return typeof onFileDialogCancel === 'function' ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  var rootRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var inputRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);

  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (useFsAccessApi && Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["d" /* canUseFileSystemAccessAPI */])()) {
      return function () {};
    }

    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, useFsAccessApi]);
  var dragTargetsRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_3__utils_index__["l" /* onDocumentDragOver */], false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_3__utils_index__["l" /* onDocumentDragOver */]);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* isEvtWithFiles */])(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["k" /* isPropagationStopped */])(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* isEvtWithFiles */])(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* isEvtWithFiles */])(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["f" /* fileAccepted */])(file, accept),
          _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["g" /* fileMatchSize */])(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [__WEBPACK_IMPORTED_MODULE_3__utils_index__["b" /* TOO_MANY_FILES_REJECTION */]]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: 'setFiles'
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, accept, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* isEvtWithFiles */])(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["k" /* isPropagationStopped */])(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      });
    }

    dispatch({
      type: 'reset'
    });
  }, [getFilesFromEvent, setFiles, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    if (useFsAccessApi && Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["d" /* canUseFileSystemAccessAPI */])()) {
      dispatch({
        type: 'openDialog'
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["h" /* filePickerOptionsTypes */])(accept)
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        return setFiles(files, null);
      }).catch(function (e) {
        return onFileDialogCancelCb(e);
      }).finally(function () {
        return dispatch({
          type: 'closeDialog'
        });
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, accept, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["j" /* isIeOrEdge */])()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onBlur, onBlurCb)),
        onClick: composeHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onClick, onClickCb)),
        onDragEnter: composeDragHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onDrop, onDropCb)),
        role: typeof role === 'string' && role !== '' ? role : 'button'
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = _defineProperty({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onChange, onDropCb)),
        onClick: composeHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* allFilesAccepted */])({
    files: draggedFiles,
    accept: accept,
    minSize: minSize,
    maxSize: maxSize,
    multiple: multiple,
    maxFiles: maxFiles
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread(_objectSpread({}, state), {}, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });

    case 'blur':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });

    case 'openDialog':
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread(_objectSpread({}, state), {}, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case 'reset':
      return _objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop() {}



/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__file_selector__ = __webpack_require__(1070);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__file_selector__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__file__ = __webpack_require__(1072);


var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */])(this, void 0, void 0, function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */])(this, function (_a) {
            if (isObject(evt) && isDataTransfer(evt)) {
                return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 /*return*/, getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 /*return*/, getFsHandleFiles(evt)];
            }
            return [2 /*return*/, []];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value.dataTransfer);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return Object(__WEBPACK_IMPORTED_MODULE_1__file__["a" /* toFileWithPath */])(file); });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */])(this, void 0, void 0, function () {
        var files;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (file) { return Object(__WEBPACK_IMPORTED_MODULE_1__file__["a" /* toFileWithPath */])(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */])(this, void 0, void 0, function () {
        var items, files;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (dt === null) {
                        return [2 /*return*/, []];
                    }
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return Object(__WEBPACK_IMPORTED_MODULE_1__file__["a" /* toFileWithPath */])(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */])(acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = Object(__WEBPACK_IMPORTED_MODULE_1__file__["a" /* toFileWithPath */])(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */])(this, void 0, void 0, function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */])(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */])(_this, void 0, void 0, function () {
                var files, err_1, items;
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */])(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */])(this, void 0, void 0, function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */])(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = Object(__WEBPACK_IMPORTED_MODULE_1__file__["a" /* toFileWithPath */])(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}
//# sourceMappingURL=file-selector.js.map

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* unused harmony export __assign */
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["a"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["b"] = __generator;
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* harmony export (immutable) */ __webpack_exports__["c"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/* unused harmony export __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export COMMON_MIME_TYPES */
/* harmony export (immutable) */ __webpack_exports__["a"] = toFileWithPath;
var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    // Others
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}
//# sourceMappingURL=file.js.map

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconUploadLargeData: "data:image/svg+xml,%3csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round'%3e%3cpath d='M1 15v2.88A1.12 1.12 0 002.12 19h15.76A1.12 1.12 0 0019 17.88V15'/%3e%3cpath stroke-linejoin='round' d='M14 5l-4-4-4 4'/%3e%3cpath d='M10 1v14'/%3e%3c/g%3e%3c/svg%3e",
  iconUploadLargeWidth: 20,
  iconUploadLargeHeight: 20
};

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    fileInputBackgroundColorDefault: tokens.themeForegroundAccentDefault,
    fileInputBorderWidth: 2,
    fileInputBorderRadius: 4,
    fileInputBorderColor: tokens.themeForegroundAccentDefault,
    fileInputDragOverlayContainerBackgroundColor: tokens.themeForegroundAccentDefault,
    fileInputDragOverlayContainerBackgroundColorDefault: tokens.themeForegroundAccentDefault,
    fileInputDragOverlayContainerMotionDuration: "150ms",
    fileInputDragOverlayContainerMotionFunction: "ease",
    fileInputDragOverlayContainerElevation: 20,
    fileInputFileBorderWidth: 1,
    fileInputFileBorderRadius: 0,
    fileInputFileBorderColor: tokens.themeForegroundPrimaryDisabled,
    fileInputFileSpacingInset: 16
  }
};

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(11);

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _closeSmall = _interopRequireDefault(__webpack_require__(1077));

var _trash = _interopRequireDefault(__webpack_require__(40));

var _alert = _interopRequireDefault(__webpack_require__(13));

var _button = _interopRequireDefault(__webpack_require__(8));

var _column = _interopRequireDefault(__webpack_require__(6));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _link = _interopRequireDefault(__webpack_require__(141));

var _loader = _interopRequireDefault(__webpack_require__(86));

var _row = _interopRequireDefault(__webpack_require__(10));

var _text = _interopRequireDefault(__webpack_require__(9));

var _formatBytes = _interopRequireDefault(__webpack_require__(1078));

/* eslint-disable react/prop-types */
var FileUploadingDetails = function FileUploadingDetails(_ref) {
  var uploadPercentage = _ref.uploadPercentage,
      connectionSpeed = _ref.connectionSpeed;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_loader["default"], {
    type: "linear",
    size: "small",
    showPercentageText: false,
    percentage: uploadPercentage
  }), /*#__PURE__*/_react["default"].createElement(_row["default"], {
    width: "100%",
    widths: "fill"
  }, uploadPercentage ? /*#__PURE__*/_react["default"].createElement(_text["default"], {
    type: "b200"
  }, uploadPercentage, "%") : null, connectionSpeed ? /*#__PURE__*/_react["default"].createElement(_text["default"], {
    alignment: "right",
    type: "b200"
  }, connectionSpeed) : null));
};
/* eslint-enable react/prop-types */


var fileLinkWrapperStyles = (0, _emotion.css)({
  display: "inline-grid",
  a: {
    maxWidth: "100%",
    overflow: "hidden",
    display: "inline-block",
    textOverflow: "ellipsis"
  }
});
/**
 * Render a list item to display file information
 * such as name, size, and uploaded path, as well as
 * optional information such as upload progress and
 * speed.
 */

var FileDetails = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var cancelUploadButtonLabel = props.cancelUploadButtonLabel,
      connectionSpeed = props.connectionSpeed,
      error = props.error,
      file = props.file,
      uploadPercentage = props.uploadPercentage,
      uploadComplete = props.uploadComplete,
      uploadCompleteLabel = props.uploadCompleteLabel,
      uploadedFileDownload = props.uploadedFileDownload,
      uploadedFileHref = props.uploadedFileHref;
  var uploadSuccessful = uploadComplete && !error;
  return /*#__PURE__*/_react["default"].createElement(_row["default"], {
    widths: ["fill", "fit"]
  }, /*#__PURE__*/_react["default"].createElement(_column["default"], {
    spacing: "small",
    minWidth: 0,
    "aria-live": "polite"
  }, /*#__PURE__*/_react["default"].createElement(_row["default"], null, uploadSuccessful && uploadedFileHref ? /*#__PURE__*/_react["default"].createElement(_text["default"], {
    tag: "div",
    className: fileLinkWrapperStyles
  }, /*#__PURE__*/_react["default"].createElement(_link["default"], {
    href: uploadedFileHref,
    download: uploadedFileDownload,
    ref: ref
  }, file.name)) : /*#__PURE__*/_react["default"].createElement(_text["default"], {
    type: uploadSuccessful ? "b300" : "h100",
    truncate: true,
    tag: "div",
    ref: ref
  }, file.name), /*#__PURE__*/_react["default"].createElement(_text["default"], {
    tag: "div"
  }, isNaN(file.size) ? file.size : (0, _formatBytes["default"])(file.size))), !uploadComplete ? /*#__PURE__*/_react["default"].createElement(FileUploadingDetails, {
    uploadPercentage: uploadPercentage,
    connectionSpeed: connectionSpeed
  }) : uploadComplete && !error ? /*#__PURE__*/_react["default"].createElement(_alert["default"], {
    type: "success",
    size: "small"
  }, uploadCompleteLabel) : error ? /*#__PURE__*/_react["default"].createElement(_alert["default"], {
    type: "error",
    size: "small"
  }, props.errorMessage) : null), uploadComplete && props.onClickRemoveFile && !error ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    size: "small",
    type: "secondary",
    label: props.removeFileButtonLabel,
    onClick: props.onClickRemoveFile
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _trash["default"]
  })) : props.onClickCancel ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    size: "small",
    type: "secondary",
    label: cancelUploadButtonLabel,
    onClick: props.onClickCancel
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _closeSmall["default"]
  })) : null);
});

FileDetails.displayName = "FileDetails";
FileDetails.propTypes =  false ? {
  /**
   * Object that contains a name and size property. If the size is a number then
   * it will be treated as bytes and auto-formatted using the en-US locale. If
   * it is not a number (e.g. a string that has already been localized) then it
   * will be displayed as-is.
   */
  file: _propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired
  }).isRequired,

  /**
   * Label for the cancel upload button, we recommend including the file name for improved accessibility for screen-reader users.
   */
  cancelUploadButtonLabel: _propTypes["default"].string,

  /**
   * Connection speed for the file's upload.
   */
  connectionSpeed: _propTypes["default"].string,

  /**
   * Boolean to indicate whether the file's upload is in an error state
   */
  error: _propTypes["default"].bool,

  /**
   * String describing potential error states for file, we recommend including the file name for improved accessibility for screen-reader users.
   */
  errorMessage: _propTypes["default"].string,

  /**
   * Label for the delete file button, we recommend including the file name for improved accessibility for screen-reader users.
   */
  removeFileButtonLabel: _propTypes["default"].string,

  /**
   * Indicates if the file's finished being uploaded.
   */
  uploadComplete: _propTypes["default"].bool,

  /**
   * The success message to display when the file is finished
   * uploading.
   */
  uploadCompleteLabel: _propTypes["default"].string,

  /**
   * Set this to a number between `0` and `100` (inclusive) to show the loader
   * at a particular stage of completion.
   *
   * If this prop is not set the loader will indicate an "indefinite" loading
   * state using a cyclical animation.
   */
  uploadPercentage: _propTypes["default"].number,

  /**
   * Tells browser link should be downloaded rather than navigated to. Be sure to pass download link to `uploadedFileHref`.
   * Passing a string will define the file's name when downloaded.  If set to true the browser will default to file name
   * (e.g. a file downloaded from `site.com/picture.jpg` will be named `picture.jpg`).
   *
   * [Read more](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-download) about `download` attribute.
   */
  uploadedFileDownload: _propTypes["default"].string,

  /**
   * The file's uploaded path
   */
  uploadedFileHref: _propTypes["default"].string,

  /**
   * If a function is supplied here then a close button will
   * be rendered while the file uploads. The function will be
   * called when the button is clicked.
   */
  onClickCancel: _propTypes["default"].func,

  /**
   * If a function is supplied here then a remove button will
   * be rendered after the file is finished uploading.
   * The function will be called when the button is clicked.
   */
  onClickRemoveFile: _propTypes["default"].func
} : {};
FileDetails.defaultProps = {
  cancelUploadButtonLabel: "Cancel",
  removeFileButtonLabel: "Delete file",
  error: false,
  errorMessage: "Error uploading file",
  uploadCompleteLabel: "Complete"
};
var _default = FileDetails;
exports["default"] = _default;

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCloseSmallData: "data:image/svg+xml,%3csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.053 1.053a1 1 0 011.414 0L6 4.585l3.533-3.532a1 1 0 011.32-.083l.094.083a1 1 0 010 1.414L7.415 6l3.532 3.533a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.414 0L6 7.415l-3.533 3.532a1 1 0 01-1.32.083l-.094-.083a1 1 0 010-1.414L4.585 6 1.053 2.467a1 1 0 01-.083-1.32z' fill='currentColor' fill-rule='nonzero'/%3e%3c/svg%3e",
  iconCloseSmallWidth: 12,
  iconCloseSmallHeight: 12
};

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Utility function to format bytes into whatever increment
 * that we need.
 * @param {*} bytes
 * @param {*} decimals
 */
var formatBytes = function formatBytes(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (bytes === 0) return "0 Bytes";
  var k = 1024;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
};

var _default = formatBytes;
exports["default"] = _default;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

(function(window) {
    var re = {
        not_string: /[^s]/,
        number: /[diefg]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijosuxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[\+\-]/
    }

    function sprintf() {
        var key = arguments[0], cache = sprintf.cache
        if (!(cache[key] && cache.hasOwnProperty(key))) {
            cache[key] = sprintf.parse(key)
        }
        return sprintf.format.call(null, cache[key], arguments)
    }

    sprintf.format = function(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, node_type = "", arg, output = [], i, k, match, pad, pad_character, pad_length, is_positive = true, sign = ""
        for (i = 0; i < tree_length; i++) {
            node_type = get_type(parse_tree[i])
            if (node_type === "string") {
                output[output.length] = parse_tree[i]
            }
            else if (node_type === "array") {
                match = parse_tree[i] // convenience purposes only
                if (match[2]) { // keyword argument
                    arg = argv[cursor]
                    for (k = 0; k < match[2].length; k++) {
                        if (!arg.hasOwnProperty(match[2][k])) {
                            throw new Error(sprintf("[sprintf] property '%s' does not exist", match[2][k]))
                        }
                        arg = arg[match[2][k]]
                    }
                }
                else if (match[1]) { // positional argument (explicit)
                    arg = argv[match[1]]
                }
                else { // positional argument (implicit)
                    arg = argv[cursor++]
                }

                if (get_type(arg) == "function") {
                    arg = arg()
                }

                if (re.not_string.test(match[8]) && re.not_json.test(match[8]) && (get_type(arg) != "number" && isNaN(arg))) {
                    throw new TypeError(sprintf("[sprintf] expecting number but found %s", get_type(arg)))
                }

                if (re.number.test(match[8])) {
                    is_positive = arg >= 0
                }

                switch (match[8]) {
                    case "b":
                        arg = arg.toString(2)
                    break
                    case "c":
                        arg = String.fromCharCode(arg)
                    break
                    case "d":
                    case "i":
                        arg = parseInt(arg, 10)
                    break
                    case "j":
                        arg = JSON.stringify(arg, null, match[6] ? parseInt(match[6]) : 0)
                    break
                    case "e":
                        arg = match[7] ? arg.toExponential(match[7]) : arg.toExponential()
                    break
                    case "f":
                        arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg)
                    break
                    case "g":
                        arg = match[7] ? parseFloat(arg).toPrecision(match[7]) : parseFloat(arg)
                    break
                    case "o":
                        arg = arg.toString(8)
                    break
                    case "s":
                        arg = ((arg = String(arg)) && match[7] ? arg.substring(0, match[7]) : arg)
                    break
                    case "u":
                        arg = arg >>> 0
                    break
                    case "x":
                        arg = arg.toString(16)
                    break
                    case "X":
                        arg = arg.toString(16).toUpperCase()
                    break
                }
                if (re.json.test(match[8])) {
                    output[output.length] = arg
                }
                else {
                    if (re.number.test(match[8]) && (!is_positive || match[3])) {
                        sign = is_positive ? "+" : "-"
                        arg = arg.toString().replace(re.sign, "")
                    }
                    else {
                        sign = ""
                    }
                    pad_character = match[4] ? match[4] === "0" ? "0" : match[4].charAt(1) : " "
                    pad_length = match[6] - (sign + arg).length
                    pad = match[6] ? (pad_length > 0 ? str_repeat(pad_character, pad_length) : "") : ""
                    output[output.length] = match[5] ? sign + arg + pad : (pad_character === "0" ? sign + pad + arg : pad + sign + arg)
                }
            }
        }
        return output.join("")
    }

    sprintf.cache = {}

    sprintf.parse = function(fmt) {
        var _fmt = fmt, match = [], parse_tree = [], arg_names = 0
        while (_fmt) {
            if ((match = re.text.exec(_fmt)) !== null) {
                parse_tree[parse_tree.length] = match[0]
            }
            else if ((match = re.modulo.exec(_fmt)) !== null) {
                parse_tree[parse_tree.length] = "%"
            }
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1
                    var field_list = [], replacement_field = match[2], field_match = []
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list[field_list.length] = field_match[1]
                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== "") {
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                field_list[field_list.length] = field_match[1]
                            }
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                field_list[field_list.length] = field_match[1]
                            }
                            else {
                                throw new SyntaxError("[sprintf] failed to parse named argument key")
                            }
                        }
                    }
                    else {
                        throw new SyntaxError("[sprintf] failed to parse named argument key")
                    }
                    match[2] = field_list
                }
                else {
                    arg_names |= 2
                }
                if (arg_names === 3) {
                    throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported")
                }
                parse_tree[parse_tree.length] = match
            }
            else {
                throw new SyntaxError("[sprintf] unexpected placeholder")
            }
            _fmt = _fmt.substring(match[0].length)
        }
        return parse_tree
    }

    var vsprintf = function(fmt, argv, _argv) {
        _argv = (argv || []).slice(0)
        _argv.splice(0, 0, fmt)
        return sprintf.apply(null, _argv)
    }

    /**
     * helpers
     */
    function get_type(variable) {
        return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase()
    }

    function str_repeat(input, multiplier) {
        return Array(multiplier + 1).join(input)
    }

    /**
     * export to either browser or node.js
     */
    if (true) {
        exports.sprintf = sprintf
        exports.vsprintf = vsprintf
    }
    else {
        window.sprintf = sprintf
        window.vsprintf = vsprintf

        if (typeof define === "function" && define.amd) {
            define(function() {
                return {
                    sprintf: sprintf,
                    vsprintf: vsprintf
                }
            })
        }
    }
})(typeof window === "undefined" ? this : window);


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(202));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(155));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _range = _interopRequireDefault(__webpack_require__(159));

var _difference = _interopRequireDefault(__webpack_require__(1081));

var _find = _interopRequireDefault(__webpack_require__(96));

var _union = _interopRequireDefault(__webpack_require__(1091));

var _pagination = _interopRequireDefault(__webpack_require__(1094));

var _token = __webpack_require__(20);

var _theme = __webpack_require__(24);

var _row = _interopRequireDefault(__webpack_require__(10));

var _arrowControls = _interopRequireDefault(__webpack_require__(1095));

var _pageButton = _interopRequireDefault(__webpack_require__(1098));

var _ellipse = _interopRequireDefault(__webpack_require__(1099));

var _excluded = ["pageNumbers", "currentPage", "t"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/** Constants */
var BREAK = "BREAK";
var MEDIUM_SET_SPACES = 5;
/** Helpers */

var isShortSet = function isShortSet(val) {
  return val <= 5;
};

var isMediumSet = function isMediumSet(val) {
  return val > 5 && val <= 8;
};

var isLongSet = function isLongSet(val) {
  return val > 8;
};

var insertIf = function insertIf(condition) {
  for (var _len = arguments.length, elements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    elements[_key - 1] = arguments[_key];
  }

  return condition ? elements : [];
}; // Lodash doesn't include the end value in the array which
// is confusing. This method simply adds +1 to the end value
// which makes the code easier to understand


var getRange = function getRange(start, end, step) {
  return (0, _range["default"])(start, end + 1, step);
}; // Get surrounding numbers around an anchor and return them as an array


var getSurroundingNumbers = function getSurroundingNumbers(_ref) {
  var anchor = _ref.anchor,
      setLength = _ref.setLength,
      ceiling = _ref.ceiling,
      _ref$floor = _ref.floor,
      floor = _ref$floor === void 0 ? 0 : _ref$floor;
  var surroundingNumbers = [anchor];
  var i = 1; // While we still have spaces to fill

  while (surroundingNumbers.length < setLength) {
    // If we can, put an even smaller number at the start of the array
    if (anchor - i > floor) surroundingNumbers.unshift(anchor - i); // If we can, put an even larger number at the end of the array

    if (anchor + i <= ceiling) surroundingNumbers.push(anchor + i);
    i += 1;
  }

  return surroundingNumbers;
};

var getNumberOfEdgePages = function getNumberOfEdgePages(_ref2) {
  var closeTrunc = _ref2.closeTrunc,
      farTrunc = _ref2.farTrunc,
      surroundingPages = _ref2.surroundingPages,
      farRange = _ref2.farRange;
  return farTrunc ? closeTrunc ? 1 // if truncating on both sides, display 1
  : 3 // else display 3
  : // if the further edge doesn't need truncation,
  // calculate how many slots remain. This is done
  // by calculating the difference in the total number
  // of slots (6) and how many numbers are being used
  // in the far set (eg. [1, 2, 3, 4, 5])
  6 - (0, _union["default"])(farRange, surroundingPages).length;
};
/** Sets */


var shortSet = {
  check: isShortSet,
  pageNumbers: function pageNumbers(_ref3) {
    var numberOfPages = _ref3.numberOfPages;
    return getRange(1, numberOfPages);
  }
};
var mediumSet = {
  check: isMediumSet,
  pageNumbers: function pageNumbers(_ref4) {
    var numberOfPages = _ref4.numberOfPages,
        currentPage = _ref4.currentPage;
    return getSurroundingNumbers({
      anchor: currentPage,
      setLength: MEDIUM_SET_SPACES,
      ceiling: numberOfPages
    });
  }
};
var longSet = {
  check: isLongSet,
  pageNumbers: function pageNumbers(_ref5) {
    var numberOfPages = _ref5.numberOfPages,
        currentPage = _ref5.currentPage;
    var surroundingPages = getSurroundingNumbers({
      anchor: currentPage,
      setLength: 3,
      ceiling: numberOfPages
    }); // If the outer surrounding numbers are more then 3 away from
    // their respective extreme, add a truncation/ellipse

    var needsBeginningTrunc = surroundingPages[0] - 3 >= 1;
    var needsEndingTrunc = surroundingPages[2] + 3 <= numberOfPages;
    var numberOfEndingPages = getNumberOfEdgePages({
      closeTrunc: needsEndingTrunc,
      farTrunc: needsBeginningTrunc,
      farRange: getRange(1, 3),
      surroundingPages: surroundingPages
    });
    var numberOfBegginningPages = getNumberOfEdgePages({
      closeTrunc: needsBeginningTrunc,
      farTrunc: needsEndingTrunc,
      farRange: getRange(numberOfPages - 2, numberOfPages),
      surroundingPages: surroundingPages
    });
    var beginningPages = getRange(1, numberOfBegginningPages); // We add + 1 to numberOfPages because we are starting
    // with the assumption if numberOfEndingPages = 1 the
    // range should only include that number.
    // e.g. numberOfPages = 10, numberOfEndingPages = 1
    // getRange(10 + 1 - 1, 10) = [10]
    // e.g. numberOfPages = 10, numberOfEndingPages = 2
    // getRange(10 + 1 - 2, 10) = [9, 10]

    var endPages = getRange(numberOfPages + 1 - numberOfEndingPages, numberOfPages);
    return [].concat((0, _toConsumableArray2["default"])((0, _difference["default"])(beginningPages, surroundingPages)), (0, _toConsumableArray2["default"])(insertIf(needsBeginningTrunc, BREAK)), (0, _toConsumableArray2["default"])(surroundingPages), (0, _toConsumableArray2["default"])(insertIf(needsEndingTrunc, BREAK)), (0, _toConsumableArray2["default"])((0, _difference["default"])(endPages, surroundingPages)));
  }
};

var buildPageNumbers = function buildPageNumbers(numberOfPages, currentPage) {
  return (0, _find["default"])([shortSet, mediumSet, longSet], function (_ref6) {
    var check = _ref6.check;
    return check(numberOfPages);
  }).pageNumbers({
    numberOfPages: numberOfPages,
    currentPage: currentPage
  });
};

var buildPageButtons = function buildPageButtons(_ref7) {
  var pageNumbers = _ref7.pageNumbers,
      currentPage = _ref7.currentPage,
      t = _ref7.t,
      props = (0, _objectWithoutProperties2["default"])(_ref7, _excluded);
  return pageNumbers.map(function (value, index) {
    return value !== BREAK ? /*#__PURE__*/_react["default"].createElement(_pageButton["default"], (0, _extends2["default"])({}, props, {
      t: t,
      selected: value === currentPage,
      key: value
    }), value) : /*#__PURE__*/_react["default"].createElement(_ellipse["default"], {
      key: "ellipse-".concat(index),
      t: t,
      disabled: props.disabled
    });
  });
};

var Pagination = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Pagination, _React$Component);

  var _super = _createSuper(Pagination);

  function Pagination() {
    (0, _classCallCheck2["default"])(this, Pagination);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Pagination, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          showSkipArrows = _this$props.showSkipArrows,
          label = _this$props.label,
          locale = _this$props.locale;
      var _this$props2 = this.props,
          numberOfPages = _this$props2.numberOfPages,
          currentPage = _this$props2.currentPage;
      if (!numberOfPages || numberOfPages <= 0) numberOfPages = 1;

      if (!currentPage || currentPage <= 0) {
        currentPage = 1;
      } else if (currentPage > numberOfPages) {
        currentPage = numberOfPages;
      }

      var pageNumbers = buildPageNumbers(numberOfPages, currentPage);
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _pagination["default"],
        map: (0, _token.getTokenHelper)("pagination")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("nav", {
          role: "navigation",
          "aria-label": label
        }, /*#__PURE__*/_react["default"].createElement(_row["default"], {
          spacing: "none"
        }, /*#__PURE__*/_react["default"].createElement(_arrowControls["default"], (0, _extends2["default"])({}, _this.props, {
          currentPage: currentPage,
          numberOfPages: numberOfPages,
          showSkipArrows: showSkipArrows && !isShortSet(numberOfPages),
          arrowColor: t("arrowColor"),
          direction: "left"
        })), buildPageButtons(_objectSpread(_objectSpread({}, _this.props), {}, {
          currentPage: currentPage,
          numberOfPages: numberOfPages,
          pageNumbers: pageNumbers,
          t: t,
          locale: locale
        })), /*#__PURE__*/_react["default"].createElement(_arrowControls["default"], (0, _extends2["default"])({}, _this.props, {
          currentPage: currentPage,
          numberOfPages: numberOfPages,
          showSkipArrows: showSkipArrows && !isShortSet(numberOfPages),
          arrowColor: t("arrowColor"),
          direction: "right"
        }))));
      });
    }
  }]);
  return Pagination;
}(_react["default"].Component);

(0, _defineProperty2["default"])(Pagination, "defaultProps", {
  showSkipArrows: false,
  label: "Pagination navigation",
  locale: "en-US",
  pageLabel: function pageLabel(pageNumber) {
    return "Go to page ".concat(pageNumber);
  },
  currentPageLabel: function currentPageLabel(nextPageNumber) {
    return "Current page, page ".concat(nextPageNumber);
  },
  previousPageLabel: function previousPageLabel(prevPageNumber) {
    return "Go to previous page, page ".concat(prevPageNumber);
  },
  nextPageLabel: function nextPageLabel(nextPageNumber) {
    return "Go to next page, page ".concat(nextPageNumber);
  },
  firstPageLabel: function firstPageLabel(firstPageNumber) {
    return "Go to first page, page ".concat(firstPageNumber);
  },
  lastPageLabel: function lastPageLabel(lastPageNumber) {
    return "Go to last page, page ".concat(lastPageNumber);
  }
});
Pagination.propTypes =  false ? {
  /**
   * The number of the currently selected page, where `1` is the first page
   * (*not* 0-indexed).
   */
  currentPage: _propTypes["default"].number.isRequired,

  /**
   * The total number of pages in the list being paginated.
   */
  numberOfPages: _propTypes["default"].number.isRequired,

  /**
   * A function that will be called when the user attempts to change the current
   * page (e.g. by clicking on the "Next page" button). The new page number
   * will be passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `currentPage` prop in order to make this
   * component interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * A function that generates an accessible label for the current page.
   *
   * This receives the current page's number as its only argument, and should return a string.
   */
  currentPageLabel: _propTypes["default"].func,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * A function that generates an accessible label for the skip-to-first-page button.
   *
   * This receives the first page's number as its only argument, and should return a string.
   */
  firstPageLabel: _propTypes["default"].func,

  /**
   * An accessible label for the component. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   */
  label: _propTypes["default"].string,

  /**
   * A function that generates an accessible label for the skip-to-last-page button.
   *
   * This receives the last page's number as its only argument, and should return a string.
   */
  lastPageLabel: _propTypes["default"].func,

  /**
   * The locale used to display the numbers in the page buttons. Any local supported by
   * the [Number.toLocaleString API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString)
   * will work.
   */
  locale: _propTypes["default"].string,

  /**
   * A function that generates an accessible label for the go-to-next-page button.
   *
   * This receives the next page's number as its only argument, and should return a string.
   */
  nextPageLabel: _propTypes["default"].func,

  /**
   * A function that generates an accessible label for any page.
   *
   * This receives a page number as its only argument, and should return a string.
   */
  pageLabel: _propTypes["default"].func,

  /**
   * A function that generates an accessible label for the go-to-previous-page button.
   *
   * This receives the previous page's number as its only argument, and should return a string.
   */
  previousPageLabel: _propTypes["default"].func,

  /**
   * Use this to shop skip-to-first-page and skip-to-last-page buttons.
   */
  showSkipArrows: _propTypes["default"].bool
} : {};
var _default = Pagination;
exports["default"] = _default;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(1082),
    baseFlatten = __webpack_require__(457),
    baseRest = __webpack_require__(458),
    isArrayLikeObject = __webpack_require__(459);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(242),
    arrayIncludes = __webpack_require__(455),
    arrayIncludesWith = __webpack_require__(456),
    arrayMap = __webpack_require__(247),
    baseUnary = __webpack_require__(326),
    cacheHas = __webpack_require__(243);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(152),
    isArguments = __webpack_require__(236),
    isArray = __webpack_require__(82);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1085);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 1085 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1087),
    shortOut = __webpack_require__(1090);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1088),
    defineProperty = __webpack_require__(1089),
    identity = __webpack_require__(248);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1088 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(105);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 1090 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(457),
    baseRest = __webpack_require__(458),
    baseUniq = __webpack_require__(1092),
    isArrayLikeObject = __webpack_require__(459);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(242),
    arrayIncludes = __webpack_require__(455),
    arrayIncludesWith = __webpack_require__(456),
    cacheHas = __webpack_require__(243),
    createSet = __webpack_require__(1093),
    setToArray = __webpack_require__(244);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(333),
    noop = __webpack_require__(59),
    setToArray = __webpack_require__(244);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1094 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    paginationNumberWidth: 24,
    paginationNumberHeight: 24,
    paginationNumberColorDefault: tokens.themeForegroundAccentDefault,
    paginationNumberColorSelected: tokens.themeForegroundPrimaryDefault,
    paginationNumberColorDisabled: tokens.themeForegroundPrimaryDisabled,
    paginationNumberSpacingInsetVertical: 2,
    paginationNumberSpacingInsetHorizontal: 8,
    paginationIndicatorBorderWidth: 2,
    paginationIndicatorBorderRadius: 999,
    paginationIndicatorHeight: 4,
    paginationIndicatorColorDefault: tokens.themeForegroundAccentDefault,
    paginationIndicatorColorHover: tokens.themeBorderAccentHover,
    paginationIndicatorColorPressed: tokens.themeBorderAccentPressed,
    paginationArrowColor: tokens.themeForegroundAccentDefault,
    paginationEllipseWidth: 24,
    paginationEllipseHeight: 14,
    paginationEllipseColorDefault: tokens.themeForegroundAccentDefault,
    paginationEllipseColorDisabled: tokens.themeForegroundPrimaryDisabled,
    paginationMotionDuration: "100ms",
    paginationMotionFunction: "ease"
  }
};

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _chevronRightSmall = _interopRequireDefault(__webpack_require__(158));

var _chevronLeftSmall = _interopRequireDefault(__webpack_require__(445));

var _chevronDoubleRight = _interopRequireDefault(__webpack_require__(1096));

var _chevronDoubleLeft = _interopRequireDefault(__webpack_require__(1097));

var _theme = _interopRequireDefault(__webpack_require__(24));

var _row = _interopRequireDefault(__webpack_require__(10));

var _button = _interopRequireDefault(__webpack_require__(8));

var _icon = _interopRequireDefault(__webpack_require__(16));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/prop-types */
var ArrowControls = function ArrowControls(_ref) {
  var direction = _ref.direction,
      numberOfPages = _ref.numberOfPages,
      showSkipArrows = _ref.showSkipArrows,
      disabled = _ref.disabled,
      currentPage = _ref.currentPage,
      onChange = _ref.onChange,
      arrowColor = _ref.arrowColor,
      nextPageLabel = _ref.nextPageLabel,
      previousPageLabel = _ref.previousPageLabel,
      lastPageLabel = _ref.lastPageLabel,
      firstPageLabel = _ref.firstPageLabel;
  var overrideTokens = (0, _react.useMemo)(function () {
    return {
      buttonForegroundColorIconLightBackdropDefault: arrowColor,
      buttonForegroundColorIconDarkBackdropDefault: arrowColor
    };
  }, [arrowColor]);
  return direction === "right" ? /*#__PURE__*/_react["default"].createElement(_theme["default"], {
    tokens: overrideTokens
  }, /*#__PURE__*/_react["default"].createElement(_row["default"], {
    spacing: "none"
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChange(currentPage + 1);
    },
    disabled: disabled || currentPage === numberOfPages
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronRightSmall["default"]
  }, nextPageLabel(currentPage + 1))), showSkipArrows && /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChange(numberOfPages);
    },
    disabled: disabled || currentPage >= numberOfPages - 1
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronDoubleRight["default"]
  }, lastPageLabel(numberOfPages))))) : /*#__PURE__*/_react["default"].createElement(_theme["default"], {
    tokens: overrideTokens
  }, /*#__PURE__*/_react["default"].createElement(_row["default"], {
    spacing: "none"
  }, showSkipArrows && /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChange(1);
    },
    disabled: disabled || currentPage <= 2
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronDoubleLeft["default"]
  }, firstPageLabel(1))), /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    onClick: function onClick() {
      return onChange(currentPage - 1);
    },
    disabled: disabled || currentPage === 1
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronLeftSmall["default"]
  }, previousPageLabel(currentPage - 1)))));
};

var _default = ArrowControls;
exports["default"] = _default;

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronDoubleRightData: "data:image/svg+xml,%3csvg width='13' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1 9l4-4-4-4M8 9l4-4-4-4'/%3e%3c/g%3e%3c/svg%3e",
  iconChevronDoubleRightRtlSvg: "data:image/svg+xml,%3csvg width='13' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M5 1L1 5l4 4M12 1L8 5l4 4'/%3e%3c/g%3e%3c/svg%3e",
  iconChevronDoubleRightWidth: 13,
  iconChevronDoubleRightHeight: 10
};

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconChevronDoubleLeftData: "data:image/svg+xml,%3csvg width='13' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M5 1L1 5l4 4M12 1L8 5l4 4'/%3e%3c/g%3e%3c/svg%3e",
  iconChevronDoubleLeftRtlSvg: "data:image/svg+xml,%3csvg width='13' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1 9l4-4-4-4M8 9l4-4-4-4'/%3e%3c/g%3e%3c/svg%3e",
  iconChevronDoubleLeftWidth: 13,
  iconChevronDoubleLeftHeight: 10
};

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(11);

var _clickable = _interopRequireDefault(__webpack_require__(108));

var _focus = _interopRequireDefault(__webpack_require__(109));

var _text = _interopRequireDefault(__webpack_require__(47));

var _focusRing = _interopRequireDefault(__webpack_require__(73));

var indicatorStyle = function indicatorStyle(t, _ref) {
  var selected = _ref.selected,
      disabled = _ref.disabled;
  return (0, _emotion.css)({
    position: "absolute !important",
    display: "inline-block",
    height: t("indicatorHeight"),
    left: t("numberSpacingInsetHorizontal"),
    right: t("numberSpacingInsetHorizontal"),
    borderRadius: t("indicatorBorderRadius"),
    backgroundColor: selected ? t("indicatorColor", "default") : "transparent",
    "button:hover &": !disabled && {
      backgroundColor: t("indicatorColorHover")
    },
    "button:active &": !disabled && {
      backgroundColor: t("indicatorColorPressed")
    },
    transition: t.transitionCss("motion", "background-color")
  });
};

var pageButtonStyle = function pageButtonStyle(t) {
  return (0, _emotion.css)({
    position: "relative",
    // HACK: This is necessary for the absolutely positioned indicator to show
    // up in IE11. See https://stackoverflow.com/questions/38235418/div-inside-button-not-working-as-expected-in-ie
    overflow: "visible",
    padding: "0 ".concat(t("numberSpacingInsetHorizontal"), "px"),
    textAlign: "center",
    "& > span": {
      display: "block"
    }
  });
};

var textStyle = function textStyle(t, _ref2) {
  var focus = _ref2.focus,
      selected = _ref2.selected,
      disabled = _ref2.disabled;
  return (0, _emotion.css)((0, _text["default"])(t), {
    // We check for selected first because selected numbers still appear
    // enabled even if the button itself is disabled
    color: t("numberColor", selected ? "selected" : disabled ? "disabled" : "default"),
    transition: t.transitionCss("motion", "color"),
    margin: "".concat(t("numberSpacingInsetVertical"), "px 0"),
    minWidth: t("numberWidth"),
    outline: "none",
    width: "100%"
  }, (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: 1
  }));
};
/* eslint-disable react/prop-types */


var PageButton = function PageButton(_ref3) {
  var value = _ref3.children,
      onChange = _ref3.onChange,
      selected = _ref3.selected,
      disabled = _ref3.disabled,
      pageLabel = _ref3.pageLabel,
      currentPageLabel = _ref3.currentPageLabel,
      locale = _ref3.locale,
      t = _ref3.t;
  return /*#__PURE__*/_react["default"].createElement(_focus["default"], null, function (_ref4) {
    var focus = _ref4.focus,
        focusTrigger = _ref4.focusTrigger,
        focusProps = _ref4.focusProps;
    return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, focusProps, {
      onClick: function onClick() {
        return !disabled && onChange(value);
      },
      className: pageButtonStyle(t),
      disabled: selected ? false : disabled,
      "aria-current": selected ? "page" : undefined,
      "aria-label": selected ? currentPageLabel(value) : pageLabel(value)
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: textStyle(t, {
        selected: selected,
        disabled: disabled,
        focus: focus && focusTrigger === "keyboard"
      })
    }, value.toLocaleString(locale)), /*#__PURE__*/_react["default"].createElement("div", {
      className: indicatorStyle(t, {
        selected: selected,
        disabled: disabled
      })
    }));
  });
};
/* eslint-enable react/prop-types */


var _default = PageButton;
exports["default"] = _default;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(11);

var _menuMeatball = _interopRequireDefault(__webpack_require__(1100));

var _token = __webpack_require__(20);

var _getIconCss = _interopRequireDefault(__webpack_require__(156));

var menuMeatball = (0, _token.getIconFromTokens)(_menuMeatball["default"]);

var ellipseStyle = function ellipseStyle(t, _ref) {
  var disabled = _ref.disabled;
  var state = disabled ? "disabled" : "default";
  return (0, _emotion.css)({
    backgroundImage: (0, _getIconCss["default"])(menuMeatball.data, t("ellipseColor", state)),
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: t("ellipseWidth"),
    height: t("ellipseHeight")
  });
};
/* eslint-disable react/prop-types */


var Ellipse = function Ellipse(_ref2) {
  var t = _ref2.t,
      disabled = _ref2.disabled;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: ellipseStyle(t, {
      disabled: disabled
    })
  });
};
/* eslint-enable react/prop-types */


var _default = Ellipse;
exports["default"] = _default;

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconMenuMeatballData: "data:image/svg+xml,%3csvg width='20' height='4' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='currentColor' fill-rule='nonzero'%3e%3ccircle transform='rotate(90 18 2)' cx='18' cy='2' r='2'/%3e%3ccircle transform='rotate(90 10 2)' cx='10' cy='2' r='2'/%3e%3ccircle transform='rotate(90 2 2)' cx='2' cy='2' r='2'/%3e%3c/g%3e%3c/svg%3e",
  iconMenuMeatballWidth: 20,
  iconMenuMeatballHeight: 4
};

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_AdtaDeviceOverviewContext__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonui_CommonDeviceLogstream__ = __webpack_require__(102);
var AdtaDeviceLogstream=function AdtaDeviceLogstream(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__context_AdtaDeviceOverviewContext__["a" /* AdtaDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var deviceList=Object.values(viewModel.adtaDeviceInformation);var props={protocols:__WEBPACK_IMPORTED_MODULE_3__util_Validations__["k" /* PROTOCOLS */].ADTA,dispatch:dispatch,deviceList:deviceList,deviceType:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["c" /* ADTA_ASSET_TYPE */],intl:intl};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonui_CommonDeviceLogstream__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(AdtaDeviceLogstream));

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_search_field__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_search_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_search_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_context_LogStoreContext__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DownloadFile__ = __webpack_require__(1109);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var LogstreamTabHeader=function LogstreamTabHeader(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_5_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__store_context_LogStoreContext__["a" /* LogStoreContext */]),logData=_useContext.logData,setMaxMessageCount=_useContext.setMaxMessageCount,filterLogs=_useContext.filterLogs,clearLogs=_useContext.clearLogs;var _useState=Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_116" /* MAX_LOGS_COUNT */]),_useState2=_slicedToArray(_useState,2),messageCount=_useState2[0],setMessageCount=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_25" /* EMPTY_STRING */]),_useState4=_slicedToArray(_useState3,2),errorMsg=_useState4[0],setErrorMsg=_useState4[1];var intl=props.intl,isSubscribing=props.isSubscribing,setIsSubscribing=props.setIsSubscribing,deviceList=props.deviceList,eventType=props.eventType,deviceType=props.deviceType,setError=props.setError;var toggleText=function toggleText(){setIsSubscribing(!isSubscribing);setError(false);};var downloadFileProps={downloadButtonName:Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'log.download'}),data:logData.filteredLogs,eventType:eventType,deviceType:deviceType,prefix:deviceType+__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_212" /* UNDERSCORE */]+__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_112" /* LOGS */]};return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_box___default.a,{type:"fill",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",widths:["fill"],spacing:"400"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,{alignmentHorizontal:"start"},isSubscribing?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default.a,{size:"small",onClick:toggleText},Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'log.stopMonitoring'})):__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default.a,{size:"small",onClick:toggleText},Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'log.startMonitoring'})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default.a,{size:"small",onClick:clearLogs,type:"tertiary"},Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'log.clear'}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,{alignmentHorizontal:"end"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__DownloadFile__["a" /* default */],downloadFileProps))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_box___default.a,{type:"fill",spacingInset:"small"}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",width:"100%",widths:["50%","30%","20%"],spacing:"400"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_search_field___default.a,{value:logData.filterQuery,onChange:function onChange(value){logData.filterQuery=value;filterLogs();},placeholder:Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'log.filterBySubstring'}),size:"small"}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{value:logData.deviceNameQuery,onChange:function onChange(value){logData.deviceNameQuery=value;filterLogs();},placeholder:Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'log.filterByDeviceName'}),width:300,size:"small"},deviceList.map(function(device){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{value:device.name,label:device.name});}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{value:__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_25" /* EMPTY_STRING */],label:__WEBPACK_IMPORTED_MODULE_7__util_Constants__["E" /* ALL_CONFIG */]})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,{alignmentHorizontal:"end"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_input___default.a,{value:messageCount,onChange:function onChange(value){if(!isNaN(value)){setMessageCount(value);setMaxMessageCount(value);}value>300?setErrorMsg(Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'log.messageCountError'})):setErrorMsg(__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_25" /* EMPTY_STRING */]);},type:"number",placeholder:Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'log.messagesToCapture'}),size:"small",errorMessage:errorMsg,width:170})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(LogstreamTabHeader));

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(77));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _noop = _interopRequireDefault(__webpack_require__(59));

var _keycode = _interopRequireDefault(__webpack_require__(72));

var _searchField = _interopRequireDefault(__webpack_require__(292));

var _search = _interopRequireDefault(__webpack_require__(461));

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _searchFieldSuffix = _interopRequireDefault(__webpack_require__(1104));

var _searchSuggestionPopover = _interopRequireDefault(__webpack_require__(1106));

var _utils = __webpack_require__(1107);

var _input = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(24);

var _focus = _interopRequireDefault(__webpack_require__(109));

var _supportTextWrapper = _interopRequireDefault(__webpack_require__(138));

var _token = __webpack_require__(20);

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

var _getSupportTextAriaDescribedby = _interopRequireDefault(__webpack_require__(139));

var _functional = __webpack_require__(38);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = (0, _emotion.css)({
  position: "relative"
});
var widthStyles = (0, _functional.memoizeByKeys)(function (_ref) {
  var width = _ref.width;
  return (0, _emotion.css)({
    width: width,
    // If an explicit width is set then don't allow the textarea to flex
    flex: width ? "none !important" : undefined
  });
}, ["width"]);
/* eslint-disable react/prop-types */

var SearchFieldClass = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SearchFieldClass, _React$Component);

  var _super = _createSuper(SearchFieldClass);

  function SearchFieldClass() {
    var _this;

    (0, _classCallCheck2["default"])(this, SearchFieldClass);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      open: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onInputKeyDown", function (event) {
      var _this$props = _this.props,
          onSubmit = _this$props.onSubmit,
          value = _this$props.value;
      var key = (0, _keycode["default"])(event);

      if (key === "enter") {
        onSubmit(value);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateRootRef", function (ref) {
      if (ref) {
        _this.rootRef = ref;
        _this.inputDomNode = _this.rootRef.querySelector("input"); // If we are forwarding a ref, assign forwarded ref to input element

        if (_this.props.forwardedRef) {
          var forwardedRef = _this.props.forwardedRef; // Assign the ref with a function (Class components) or assigning .current
          // (modern functional components using the `useRef` hook)

          if (typeof forwardedRef === "function") {
            forwardedRef(_this.inputDomNode);
          } else {
            forwardedRef.current = _this.inputDomNode;
          }
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateOptionListRef", function (optionListRef) {
      if (optionListRef && optionListRef !== _this.optionListRef) {
        _this.optionListRef = optionListRef;
        /* eslint-disable-next-line react/no-find-dom-node */

        _this.optionListNode = _reactDom["default"].findDOMNode(optionListRef);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateCloseNodeRef", function (ref) {
      return _this.closeNodeRef = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getLastInputFieldDomNode", function () {
      var inputFields = _this.rootRef.querySelectorAll("input, button:not([aria-hidden])");

      return inputFields[inputFields.length - 1];
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (value) {
      // Call the onClear callback if this change clears out the input value
      if (_this.props.value && !value) {
        _this.props.onClear();
      }

      _this.props.onChange(value);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClose", function () {
      _this.closeNodeRef.focus({
        preventScroll: true
      });

      _this.closeNodeRef.blur();

      _this.setState({
        open: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClickSuggestion", function () {
      // If closeOnClickSuggestion is false, focus back to the input element
      if (!_this.props.closeOnClickSuggestion) {
        _this.inputDomNode.focus({
          preventScroll: true
        });
      } else {
        _this.onClose();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSearchFieldKeyDown", function (event) {
      var children = _this.props.children;
      var suggestions = (0, _utils.getSuggestions)(children); // Only handle the keypress if we have search suggestions and the event
      // wasn't already handled by the option list (as indicated by the
      // "defaultPrevented" property on the event)

      if (suggestions.length > 0 && !event.defaultPrevented) {
        var key = (0, _keycode["default"])(event);

        if (key === "esc") {
          // Stop propagating the event upwards. This ensures that a parent element
          // (e.g. a modal) won't also handle the escape key.
          event.stopPropagation(); // If the user hits escape then close the suggestions and focus
          // back on the input

          _this.inputDomNode.focus();
        } else if (key === "tab" && !event.shiftKey && document.activeElement === _this.getLastInputFieldDomNode()) {
          // If the user hits tab on the text input then transfer the focus to the
          // option list and preselect the first option
          _this.optionListNode.focus();

          _this.optionListRef.onChangePreselectedIndex(0);

          _this.optionListRef.scrollOptionIntoView(0);

          event.preventDefault();
        } else if (key === "down") {
          // If the user hits the down arrow on the text input then transfer the
          // focus to the option list and preselect the first option
          _this.optionListNode.focus();

          _this.optionListRef.onChangePreselectedIndex(0);

          _this.optionListRef.scrollOptionIntoView(0);

          event.preventDefault();
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocus", function (event) {
      if (!_this.state.open) {
        _this.props.onFocus(event);

        _this.setState({
          open: true
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlur", function (event) {
      return _this.setState({
        open: false
      }, function () {
        return _this.props.onBlur(event);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBeforeBlurPopover", function (direction) {
      // Close the popover if the user tabs forward out of it
      if (direction === 1) {
        _this.onClose(); // Focus on the search field if the user tabs backwards out of the popover

      } else if (direction === -1) {
        _this.getLastInputFieldDomNode().focus();
      } // Prevent the blur's default behavior because we're going to handle focus
      // ourselves


      return false;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangePreselectedIndex", function (index) {
      _this.setState({
        preselectedIndex: "".concat(_this.optionListRef.id, "-option-").concat(index)
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(SearchFieldClass, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var _this$state = this.state,
          open = _this$state.open,
          preselectedIndex = _this$state.preselectedIndex;
      var suggestions = (0, _utils.getSuggestions)(props.children);

      var _getNonSuggestions = (0, _utils.getNonSuggestions)(props.children),
          footer = _getNonSuggestions.footer,
          header = _getNonSuggestions.header,
          message = _getNonSuggestions.message;

      var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
      var id = props.id || (0, _uniqueId["default"])("search-field-");
      var popoverId = (0, _uniqueId["default"])("search-field-popover-"); // If there is not helperText or constraintText then the
      // aria-describedby is empty.

      var ariaDescribedbyValue = (0, _getSupportTextAriaDescribedby["default"])({
        id: id,
        hasHelperText: !!props.helperText,
        hasConstraintText: !!props.constraintText,
        hasErrorMessage: false,
        errorMessageFirst: props.size === "xlarge"
      }); // We have to use a SupportTextWrapper around the entire SearchField
      // instead of just passing the constraintText and helperText to the
      // <Input> above in order to ensure that the search suggestion
      // popover renders directly below the <Input> instead of below
      // the support text.

      return /*#__PURE__*/_react["default"].createElement(_supportTextWrapper["default"], {
        id: id,
        helperText: props.helperText,
        constraintText: props.constraintText,
        helperBelowFormField: props.size === "xlarge",
        className: widthStyles({
          width: props.width
        })
      }, /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _searchField["default"],
        map: (0, _token.getTokenHelper)("search-field")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_focus["default"], {
          onFocus: _this2.onFocus,
          onBlur: _this2.onBlur,
          multipleTargets: true
        }, function (_ref2) {
          var focusProps = _ref2.focusProps;
          return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
            className: styles,
            ref: _this2.updateRootRef,
            onKeyDown: _this2.onSearchFieldKeyDown
          }, focusProps, passThroughProps), /*#__PURE__*/_react["default"].createElement(_input["default"], {
            size: props.label ? "xlarge" : props.size,
            label: props.label,
            type: props.type,
            placeholder: props.placeholder,
            value: props.value,
            width: props.width,
            disabled: props.disabled,
            spellcheck: props.spellcheck,
            onChange: _this2.onChange,
            onKeyDown: _this2.onInputKeyDown,
            prefixIconTokens: !props.searchButton ? _search["default"] : undefined,
            suffix: /*#__PURE__*/_react["default"].createElement(_searchFieldSuffix["default"], (0, _extends2["default"])({
              t: t,
              inputRef: {
                current: _this2.inputDomNode
              }
            }, _this2.props)),
            autoFocus: props.autoFocus || props.inaccessibleAutoFocus,
            id: id,
            autoFill: false,
            "aria-describedby": ariaDescribedbyValue,
            "aria-autocomplete": suggestions.length ? "list" : undefined,
            "aria-controls": suggestions.length ? popoverId : undefined,
            "aria-haspopup": suggestions.length ? "true" : undefined,
            "aria-expanded": suggestions.length ? open : undefined,
            role: suggestions.length ? "combobox" : undefined,
            "aria-activedescendant": suggestions.length && open ? preselectedIndex : undefined
          }), /*#__PURE__*/_react["default"].createElement(_searchSuggestionPopover["default"], {
            open: open && (suggestions.length > 0 || message.length > 0),
            id: popoverId,
            anchorNode: _this2.rootRef,
            suggestions: suggestions,
            query: props.value,
            header: header,
            footer: footer,
            message: message,
            optionListRef: _this2.updateOptionListRef,
            onBeforeBlur: _this2.onBeforeBlurPopover,
            onChangePreselectedIndex: _this2.onChangePreselectedIndex,
            onClickSuggestion: _this2.onClickSuggestion,
            maxHeight: props.popoverMaxHeight
          }));
        }), /*#__PURE__*/_react["default"].createElement("span", {
          tabIndex: "-1",
          ref: _this2.updateCloseNodeRef
        }));
      }), " ");
    }
  }]);
  return SearchFieldClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */
// Forward ref to class component. TODO: update class component
// to functional component.


var SearchField = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(SearchFieldClass, (0, _extends2["default"])({}, props, {
    forwardedRef: ref
  }));
});

SearchField.displayName = "SearchField";
SearchField.propTypes = {
  /**
   * The value of the search field.
   *
   * Update this when `onChange` is called to ensure the component is interactive
   * (see the documentation for the `onChange` prop).
   */
  value: _propTypes["default"].any.isRequired,

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by typing in the input). The new value will be
   * passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * This function is called when the user presses the "enter" key while focused
   * on the search field or when they click the search button (see the
   * `searchButton` prop).
   */
  onSubmit: _propTypes["default"].func.isRequired,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * A list of `SearchSuggestion` elements that represent suggestions to present to
   * the user.
   *
   * If no `SearchSuggestion` elements are provided then any other elements passed here
   * will be rendered in place of them. This allows you to render things like a
   * loading indicator while waiting for asynchronously loaded suggestions or a
   * message to the user when no suggestions are available.
   */
  children: _propTypes["default"].node,

  /**
   * Appends a button to the input that the user can click to clear the input.
   * This will trigger the `onChange` callback with a value of `""`.
   */
  clearButton: _propTypes["default"].bool,

  /**
   * An accessible label for the clear button. This will not be visible in the UI, but
   * will be read by screen readers.
   */
  clearButtonLabel: _propTypes["default"].string,

  /**
   * By default, selecting a suggestion will close the suggestion popover and remove
   * focus from the SearchField. If set to `false`, selecting a suggestion will instead
   * move focus back to the SearchField's input allowing a user to quickly edit
   * the suggestion.
   *
   * @since 5.x
   */
  closeOnClickSuggestion: _propTypes["default"].bool,

  /**
   * Add constraint text to provide critical information regarding content.
   *
   * @since 5.22.0
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   *
   * @since 5.18.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Add helper text to provide additional instruction.
   *
   * @since 5.22.0
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 5.x
   */
  id: _propTypes["default"].string,

  /**
   * If set to true then the input will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since  5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * A label for the search field's input.
   *
   * If this prop is provided the `size` prop will be ignored and set to `xlarge`.
   */
  label: _propTypes["default"].string,

  /**
   * Text that is shown in place of the input's value when the input is empty.
   *
   * This text is not visible when a value is entered in the input, so it should
   * not contain essential information that should be persisted.
   */
  placeholder: _propTypes["default"].string,

  /**
   * Sets the maximum height of the popover containing any search suggestions.
   *
   * This is helpful if you have a very long list of suggestions, or suggestions
   * that take up a significant amount of vertical space. The popover is
   * scrollable, so any suggestions that overflow the popover will still be
   * accessible.
   */
  popoverMaxHeight: _propTypes["default"].number,

  /**
   * Appends a search button to the input that the user can click to trigger the
   * `onSubmit` callback.
   */
  searchButton: _propTypes["default"].bool,

  /**
   * An accessible label for the search button. This will not be visible in the UI, but
   * will be read by screen readers.
   */
  searchButtonLabel: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "xlarge"]),

  /**
   * Enable or disable spellchecking on the Search field
   *
   * @since 5.18.0
   */
  spellcheck: _propTypes["default"].bool,

  /**
   * The data type of the search field's value.
   */
  type: _propTypes["default"].oneOf(["text", "number"]),

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the clear button is clicked *or* when the search
   * field's text value is manually cleared out (e.g. by selecting the current
   * text value and pressing backspace).
   *
   * No arguments are passed to this callback.
   */
  onClear: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   *
   * Note that the target of the focus event passed to this function may not
   * always reference the search field's text input. If the user first focuses
   * on the search field's search button or clear button the event target may
   * reference that element.
   */
  onFocus: _propTypes["default"].func
};
SearchField.defaultProps = {
  size: "medium",
  type: "text",
  onFocus: _noop["default"],
  onBlur: _noop["default"],
  onClear: _noop["default"],
  clearButton: true,
  searchButton: false,
  searchButtonLabel: "Search",
  clearButtonLabel: "Clear search",

  /**
   * We derive 165 by picking the value that will show 4 search
   * suggestions (36px height) + half the height (18px) to show a
   * "peak" of the next value so that users know there are more
   * options to scroll too. NOTE: this is just our best guess because
   * suggestion cells might wrap / be taller then 36px
   */
  popoverMaxHeight: 165,
  closeOnClickSuggestion: true,
  spellcheck: false
};
var _default = SearchField;
exports["default"] = _default;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _input = _interopRequireDefault(__webpack_require__(171));

var _searchButton = _interopRequireDefault(__webpack_require__(1105));

var _inputClearButton = _interopRequireDefault(__webpack_require__(441));

var _row = _interopRequireDefault(__webpack_require__(10));

var _refObject = _interopRequireDefault(__webpack_require__(447));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SearchFieldSuffix = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SearchFieldSuffix, _React$Component);

  var _super = _createSuper(SearchFieldSuffix);

  function SearchFieldSuffix() {
    (0, _classCallCheck2["default"])(this, SearchFieldSuffix);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SearchFieldSuffix, [{
    key: "render",
    value: function render() {
      var props = this.props; // HACK: Shrink the radius by 1 so the button radius fits inside the input
      // radius

      var borderRadiusRight = (0, _input["default"])(props.t.tokens).inputBorderRadius - 1;
      var clearButton = props.clearButton ? /*#__PURE__*/_react["default"].createElement(_inputClearButton["default"], {
        hidden: !props.value,
        disabled: props.disabled,
        borderRadiusRight: props.searchButton ? 0 : borderRadiusRight,
        onClick: function onClick() {
          props.onClear();
          props.onChange("");

          if (props.inputRef.current) {
            props.inputRef.current.focus({
              preventScroll: true
            });
          }
        },
        label: props.clearButtonLabel
      }) : null;
      var searchButton = props.searchButton ? /*#__PURE__*/_react["default"].createElement(_searchButton["default"], {
        active: Boolean(props.value),
        disabled: props.disabled,
        borderRadiusRight: borderRadiusRight,
        onClick: function onClick() {
          return props.onSubmit(props.value);
        }
      }, props.searchButtonLabel) : null; // If we're rendering both buttons put them in a row, otherwise just return
      // the one button (or no buttons).

      return searchButton && clearButton ? /*#__PURE__*/_react["default"].createElement(_row["default"], {
        spacing: "none"
      }, clearButton, searchButton) : searchButton || clearButton;
    }
  }]);
  return SearchFieldSuffix;
}(_react["default"].Component);

SearchFieldSuffix.propTypes =  false ? {
  clearButton: _propTypes["default"].bool.isRequired,
  searchButton: _propTypes["default"].bool.isRequired,
  t: _propTypes["default"].func.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  onClear: _propTypes["default"].func.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  clearButtonLabel: _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,
  inputRef: _refObject["default"],
  searchButtonLabel: _propTypes["default"].string,
  value: _propTypes["default"].any
} : {};
var _default = SearchFieldSuffix;
exports["default"] = _default;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _search = _interopRequireDefault(__webpack_require__(461));

var _searchField = _interopRequireDefault(__webpack_require__(292));

var _button = _interopRequireDefault(__webpack_require__(8));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _theme = _interopRequireWildcard(__webpack_require__(24));

var _token = __webpack_require__(20);

var _borderRadius = _interopRequireDefault(__webpack_require__(127));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var state = _ref.state,
      borderRadiusRight = _ref.borderRadiusRight;
  return (0, _emotion.css)((0, _defineProperty2["default"])({
    position: "relative",
    height: "100%",
    // When the button is *not* focused, draw a border to the left (when it is
    // focused a focus outline is shown and we don't want the border to render
    // on top of the outline).
    "&:not(:focus):before": {
      content: "''",
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: t("borderLeftWidth"),
      backgroundColor: t("borderLeftColor", state)
    },
    borderRadius: (0, _borderRadius["default"])(borderRadiusRight, ["topRight", "bottomRight"])
  }, "[dir=\"rtl\"] &", {
    borderRadius: (0, _borderRadius["default"])(borderRadiusRight, ["topLeft", "bottomLeft"])
  }));
}, ["state", "borderRadiusRight"]);
var getOverrideTokens = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var active = _ref2.active;
  var activeColorTokens = {};

  if (active) {
    var fg = t("foregroundColorActive");
    var bgDefault = t("backgroundColorActiveDefault");
    var bgHover = t("backgroundColorActiveHover");
    var bgPressed = t("backgroundColorActivePressed");
    activeColorTokens = {
      buttonForegroundColorIconLightBackdropDefault: fg,
      buttonForegroundColorIconLightBackdropHover: fg,
      buttonForegroundColorIconLightBackdropPressed: fg,
      buttonBackgroundColorIconLightBackdropDefault: bgDefault,
      buttonBackgroundColorIconLightBackdropHover: bgHover,
      buttonBackgroundColorIconLightBackdropPressed: bgPressed,
      buttonForegroundColorIconDarkBackdropDefault: fg,
      buttonForegroundColorIconDarkBackdropHover: fg,
      buttonForegroundColorIconDarkBackdropPressed: fg,
      buttonBackgroundColorIconDarkBackdropDefault: bgDefault,
      buttonBackgroundColorIconDarkBackdropHover: bgHover,
      buttonBackgroundColorIconDarkBackdropPressed: bgPressed
    };
  }

  return _objectSpread({
    buttonFocusOutlineOffset: 1
  }, activeColorTokens);
}, ["active"]);

var SearchButton = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SearchButton, _React$Component);

  var _super = _createSuper(SearchButton);

  function SearchButton() {
    (0, _classCallCheck2["default"])(this, SearchButton);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SearchButton, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var state = props.disabled ? "disabled" : props.active ? "active" : "empty";
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _searchField["default"],
        map: (0, _token.getTokenHelper)("searchFieldSearchButton")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(_theme["default"], {
          tokens: getOverrideTokens(t, props)
        }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
          type: "icon",
          onClick: props.onClick,
          disabled: props.disabled,
          className: styles(t, {
            state: state,
            borderRadiusRight: props.borderRadiusRight
          }),
          label: props.children
        }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
          tokens: _search["default"]
        })));
      });
    }
  }]);
  return SearchButton;
}(_react["default"].Component);

SearchButton.propTypes =  false ? {
  active: _propTypes["default"].bool,
  borderRadiusRight: _propTypes["default"].number,
  children: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
} : {};
var _default = SearchButton;
exports["default"] = _default;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));

var _createClass2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(48));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _searchField = _interopRequireDefault(__webpack_require__(292));

var _find = _interopRequireDefault(__webpack_require__(96));

var _focus = _interopRequireDefault(__webpack_require__(109));

var _focusTrap = _interopRequireDefault(__webpack_require__(170));

var _theme = __webpack_require__(24);

var _popoverController = _interopRequireDefault(__webpack_require__(99));

var _optionList = _interopRequireWildcard(__webpack_require__(169));

var _highlightSubstring = _interopRequireDefault(__webpack_require__(285));

var _focusRing = _interopRequireDefault(__webpack_require__(73));

var _text = _interopRequireDefault(__webpack_require__(47));

var _token = __webpack_require__(20);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles(t, _ref) {
  var width = _ref.anchorRect.width,
      focus = _ref.focus;
  return (0, _emotion.css)((0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: 1,
    borderRadius: t("borderRadius"),
    borderWidth: t("borderWidth")
  }), {
    zIndex: t("popoverElevation"),
    background: t("backgroundColor"),
    border: t.borderCss("border"),
    borderRadius: t("borderRadius"),
    // HACK: we set overflow to hidden to make sure the
    // suggestions' boxy corners don't bleed outside the
    // popover's nice rounded corners. But we only do when
    // the popover is not in focus because when it IS in
    // focus we want to see that nice focus ring which appears
    // on the outside edge of the popover
    overflow: !focus ? "hidden" : undefined,
    outline: "none",
    width: width
  });
};

var optionListWrapperStyles = function optionListWrapperStyles(_ref2) {
  var maxHeight = _ref2.maxHeight;
  return (0, _emotion.css)({
    maxHeight: maxHeight,
    overflowX: "hidden",
    overflowY: "auto"
  });
};

var headerStyles = function headerStyles(t) {
  return (0, _emotion.css)((0, _text["default"])(t), (0, _defineProperty2["default"])({
    padding: "".concat(t("headerSpacingVertical"), "px ").concat(t("headerSpacingHorizontal"), "px"),
    borderBottom: t.borderCss("headerBorder"),
    borderColor: t("headerBorderColor"),
    fontSize: t("headerFontSize"),
    lineHeight: t("headerLineHeight"),
    // HACK: IE11 does not support text-align "end" or "start" so we have
    // to use directional left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    //   textAlign: "end"
    textAlign: "right"
  }, "[dir=\"rtl\"] &", {
    textAlign: "left"
  }));
};

var footerStyles = function footerStyles(t) {
  return (0, _emotion.css)({
    borderTop: t.borderCss("footerBorder"),
    borderColor: t("footerBorderColor"),
    padding: "".concat(t("footerSpacingVertical"), "px ").concat(t("footerSpacingHorizontal"), "px")
  });
};

var SearchSuggestionPopover = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SearchSuggestionPopover, _React$Component);

  var _super = _createSuper(SearchSuggestionPopover);

  function SearchSuggestionPopover() {
    var _this;

    (0, _classCallCheck2["default"])(this, SearchSuggestionPopover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      selectedValue: undefined,
      defaultPreselectedIndex: undefined
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocusOptionList", function () {
      return _this.setState({
        defaultPreselectedIndex: undefined
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlurOptionList", function () {
      return _this.setState({
        defaultPreselectedIndex: -1
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClickSuggestion", function (suggestion) {
      return function () {
        _this.setState({
          selectedValue: suggestion.value
        });

        suggestion.onClick(suggestion.label);

        _this.props.onClickSuggestion();
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseDownNonOptionChildren", function (event) {
      event.preventDefault();
    });
    return _this;
  }

  (0, _createClass2["default"])(SearchSuggestionPopover, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          suggestions = _this$props.suggestions,
          query = _this$props.query; // If the query has been updated and it does not exists in suggestions,
      // clear the selected Value

      if (prevProps.query !== query && !(0, _find["default"])(suggestions, function (suggestion) {
        return suggestion.label === query;
      })) {
        this.setState({
          selectedValue: undefined
        });
      }
    }
    /**
     * Disable mouse interaction with any non-option children because a) it would
     * blur the select and cause it to close and b) we really don't want anyone
     * including interactive elements here because they'll be inaccessible to
     * keyboard users.
     *
     * NOTE: a `pointerEvents: none` style on the non-option children container is
     * not enough to prevent a blur event on the option list, we have to actually
     * prevent the event's default behavior.
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var state = this.state;
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _searchField["default"],
        map: (0, _token.getTokenHelper)("searchFieldSuggestionList")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
          open: props.open,
          anchorNode: props.anchorNode,
          anchorOrigin: "bottom center",
          popoverOrigin: "top center",
          offsetVertical: t("popoverOffsetVertical")
        }, function (_ref3) {
          var popoverStyle = _ref3.popoverStyle,
              anchorRect = _ref3.anchorRect;
          return /*#__PURE__*/_react["default"].createElement(_focus["default"], {
            onFocus: _this2.onFocusOptionList,
            onBlur: _this2.onBlurOptionList,
            multipleTargets: true
          }, function (_ref4) {
            var focusProps = _ref4.focusProps,
                focus = _ref4.focus,
                focusTrigger = _ref4.focusTrigger;
            return /*#__PURE__*/_react["default"].createElement(_focusTrap["default"], {
              onBeforeBlur: props.onBeforeBlur
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: "\n                        ".concat(styles(t, {
                anchorRect: anchorRect,
                focus: focus && focusTrigger === "keyboard"
              }), "\n                        ").concat(popoverStyle)
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: headerStyles(t),
              onMouseDown: _this2.onMouseDownNonOptionChildren
            }, props.header), props.suggestions.length ? /*#__PURE__*/_react["default"].createElement("div", {
              className: optionListWrapperStyles(props)
            }, /*#__PURE__*/_react["default"].createElement(_optionList["default"], (0, _extends2["default"])({}, focusProps, {
              id: props.popoverId,
              ref: props.optionListRef,
              defaultPreselectedIndex: state.defaultPreselectedIndex,
              onChangePreselectedIndex: props.onChangePreselectedIndex
            }), props.suggestions.map(function (suggestion) {
              return /*#__PURE__*/_react["default"].createElement(_optionList.OptionListItem, {
                key: suggestion.value,
                label: suggestion.label,
                onClick: _this2.onClickSuggestion(suggestion),
                disabled: suggestion.disabled,
                selected: suggestion.value === state.selectedValue
              }, function (_ref5) {
                var preselected = _ref5.preselected;
                return suggestion.render ? suggestion.render({
                  query: props.query,
                  highlighted: preselected || suggestion.value === state.selectedValue
                }) : /*#__PURE__*/_react["default"].createElement(_highlightSubstring["default"], {
                  match: props.query
                }, suggestion.label);
              });
            }))) : props.message.length ? /*#__PURE__*/_react["default"].createElement("div", {
              onMouseDown: _this2.onMouseDownNonOptionChildren
            }, props.message) : null, props.footer && /*#__PURE__*/_react["default"].createElement("div", {
              className: footerStyles(t)
            }, props.footer)));
          });
        });
      });
    }
  }]);
  return SearchSuggestionPopover;
}(_react["default"].Component);

SearchSuggestionPopover.propTypes =  false ? {
  header: _propTypes["default"].string.isRequired,
  open: _propTypes["default"].bool.isRequired,
  optionListRef: _propTypes["default"].func.isRequired,
  query: _propTypes["default"].string.isRequired,
  suggestions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].number,
    onClick: _propTypes["default"].func.isRequired,
    label: _propTypes["default"].string,
    render: _propTypes["default"].func
  })).isRequired,

  /**
   * See FocusTrap for details on how this works.
   */
  onBeforeBlur: _propTypes["default"].func.isRequired,
  onClickSuggestion: _propTypes["default"].func.isRequired,
  anchorNode: _propTypes["default"].object,
  footer: _propTypes["default"].node,
  maxHeight: _propTypes["default"].number,

  /**
   * A message to show in the popover when no suggestions are present.
   */
  message: _propTypes["default"].node,
  popoverId: _propTypes["default"].string,
  onChangePreselectedIndex: _propTypes["default"].func
} : {};
var _default = SearchSuggestionPopover;
exports["default"] = _default;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSuggestions = exports.getNonSuggestions = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(62));

var _react = _interopRequireDefault(__webpack_require__(0));

var _searchSuggestion = _interopRequireDefault(__webpack_require__(462));

var _searchSuggestionFooter = _interopRequireDefault(__webpack_require__(463));

var _searchSuggestionHeader = _interopRequireDefault(__webpack_require__(464));

var _isElementOf = _interopRequireDefault(__webpack_require__(94));

var getSuggestions = function getSuggestions(children) {
  return _react["default"].Children.toArray(children).filter((0, _isElementOf["default"])(_searchSuggestion["default"])).map(function (child, index) {
    var _child$props = child.props,
        children = _child$props.children,
        onClick = _child$props.onClick,
        disabled = _child$props.disabled;

    var _ref = typeof children === "function" ? [children({}).props.suggestion, children] : [children, null],
        _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        label = _ref2[0],
        render = _ref2[1];

    return {
      value: index,
      disabled: disabled,
      render: render,
      label: label,
      onClick: onClick
    };
  });
};

exports.getSuggestions = getSuggestions;

var getFooter = function getFooter(children) {
  return children.filter((0, _isElementOf["default"])(_searchSuggestionFooter["default"]))[0];
};

var getHeader = function getHeader(children) {
  var header = children.filter((0, _isElementOf["default"])(_searchSuggestionHeader["default"]))[0];
  return header ? header.props.children : "Search suggestions";
};

var getMessage = function getMessage(children) {
  return children.filter(function (child) {
    return !(0, _isElementOf["default"])(_searchSuggestion["default"])(child) && !(0, _isElementOf["default"])(_searchSuggestionFooter["default"])(child) && !(0, _isElementOf["default"])(_searchSuggestionHeader["default"])(child);
  });
};

var getNonSuggestions = function getNonSuggestions(children) {
  var childrenArray = _react["default"].Children.toArray(children);

  var footer = getFooter(childrenArray);
  var header = getHeader(childrenArray);
  var message = getMessage(childrenArray);
  return {
    footer: footer,
    header: header,
    message: message
  };
};

exports.getNonSuggestions = getNonSuggestions;

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogStoreReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initialState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_LogStoreAction__ = __webpack_require__(465);
var LogStoreReducer=function LogStoreReducer(state,action){switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__action_LogStoreAction__["a" /* LogStoreAction */].FILTER_LOGS:{var filteredItems=state.rawLogs.filter(function(log){return shouldDisplayLog(log,state);});return Object.assign({},state,{filteredLogs:filteredItems});}case __WEBPACK_IMPORTED_MODULE_1__action_LogStoreAction__["a" /* LogStoreAction */].CLEAR_LOGS:{return Object.assign({},state,{rawLogs:[],filteredLogs:[]});}case __WEBPACK_IMPORTED_MODULE_1__action_LogStoreAction__["a" /* LogStoreAction */].CLEAR_FILTERING:{return Object.assign({},state,{filterQuery:'',deviceNameQuery:'',maxMessageCount:__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_116" /* MAX_LOGS_COUNT */]});}case __WEBPACK_IMPORTED_MODULE_1__action_LogStoreAction__["a" /* LogStoreAction */].SET_MAX_MSG_COUNT:{if(action.data.maxMessageCount.length===0){return Object.assign({},state,{maxMessageCount:__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_116" /* MAX_LOGS_COUNT */],rawLogs:state.rawLogs.slice(0,__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_116" /* MAX_LOGS_COUNT */]),filteredLogs:state.filteredLogs.slice(0,__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_116" /* MAX_LOGS_COUNT */])});}else{var count=parseInt(action.data.maxMessageCount,10);if(count>__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_116" /* MAX_LOGS_COUNT */]){count=__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_116" /* MAX_LOGS_COUNT */];}return Object.assign({},state,{maxMessageCount:count,rawLogs:state.rawLogs.slice(0,__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_116" /* MAX_LOGS_COUNT */]),filteredLogs:state.rawLogs.slice(0,count)});}}case __WEBPACK_IMPORTED_MODULE_1__action_LogStoreAction__["a" /* LogStoreAction */].ADD_LOG:{if(shouldDisplayLog(action.data.event,state)){state.filteredLogs.unshift(action.data.event);}state.rawLogs.unshift(action.data.event);return Object.assign({},state);}case __WEBPACK_IMPORTED_MODULE_1__action_LogStoreAction__["a" /* LogStoreAction */].ROLLUP_LOG:{if(state.rawLogs.length>state.maxMessageCount){state.rawLogs.pop();}if(state.filteredLogs.length>state.maxMessageCount){state.filteredLogs.pop();}return Object.assign({},state);}default:return state;}};var shouldDisplayLog=function shouldDisplayLog(log,state){return log.name.toLowerCase().includes(state.deviceNameQuery.toLowerCase())&&Object.values(log).some(function(value){return JSON.stringify(value).toLowerCase().includes(state.filterQuery.toLowerCase());});};var initialState={rawLogs:[],filteredLogs:[],maxMessageCount:__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_116" /* MAX_LOGS_COUNT */],filterQuery:'',deviceNameQuery:''};

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tokens_base_icon_download_small__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tokens_base_icon_download_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tokens_base_icon_download_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Parsers__ = __webpack_require__(100);
var DownloadFile=function DownloadFile(props){var downloadButtonName=props.downloadButtonName,eventType=props.eventType,data=props.data,deviceType=props.deviceType,prefix=props.prefix;var downloadFile=function downloadFile(){var fileName=Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["x" /* generateFileName */])(prefix);var result=getParsedData();Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["s" /* createDownloadableFile */])(fileName,result);};var getParsedData=function getParsedData(){if(eventType===__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_74" /* EVENT_TYPE */].MHE_LOG_DATA){return __WEBPACK_IMPORTED_MODULE_8__util_Parsers__["f" /* MHELogsCSVParser */].STRINGIFY(props.intl,data,deviceType);}else{return __WEBPACK_IMPORTED_MODULE_7__util_Constants__["_25" /* EMPTY_STRING */];}};return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{size:"small",onClick:function onClick(){downloadFile();}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_tokens_base_icon_download_small___default.a}),downloadButtonName));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["d" /* injectIntl */])(DownloadFile));

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_context_LogStoreContext__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_MQTTUtility__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__);
var LogstreamTabBody=function LogstreamTabBody(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__store_context_LogStoreContext__["a" /* LogStoreContext */]),logData=_useContext.logData;var isSubscribing=props.isSubscribing,topic=props.topic,config=props.config,setError=props.setError,intl=props.intl,onMessage=props.onMessage,deviceType=props.deviceType,setIsSubscribing=props.setIsSubscribing;var headerProps={topic:topic,config:config,onMessage:onMessage,setError:setError,setIsSubscribing:setIsSubscribing,isSubscribing:isSubscribing};return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null,isSubscribing&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__util_MQTTUtility__["a" /* default */],headerProps),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",width:"100%",widths:"fill"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_box___default.a,{type:"outline",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table___default.a,{headerRows:1,showDividers:true,spacing:"small",stickyHeaderRow:true,layout:"fixed"},Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_26" /* renderMHELogsTableHeader */])(intl),logData.filteredLogs.map(function(log){return Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_27" /* renderMHELogsTableRow */])(log,deviceType);})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(LogstreamTabBody));

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

/*
 * Expose AWS IoT Embedded Javascript SDK modules
 */
module.exports.device = __webpack_require__(467);
module.exports.thingShadow = __webpack_require__(1174);


/***/ }),
/* 1112 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
var MqttClient = __webpack_require__(1115),
  url = __webpack_require__(478),
  xtend = __webpack_require__(479),
  protocols = {},
  protocolList = [];

if ('browser' !== process.title) {
  protocols.mqtt = __webpack_require__(480);
  protocols.tcp = __webpack_require__(480);
  protocols.ssl = __webpack_require__(294);
  protocols.tls = __webpack_require__(294);
  protocols.mqtts = __webpack_require__(294);
}

protocols.ws = __webpack_require__(481);
protocols.wss = __webpack_require__(481);

protocolList = [
  'mqtt',
  'mqtts',
  'ws',
  'wss'
];


/**
 * Parse the auth attribute and merge username and password in the options object.
 *
 * @param {Object} [opts] option object
 */
function parseAuthOptions (opts) {
  var matches;
  if (opts.auth) {
    matches = opts.auth.match(/^(.+):(.+)$/);
    if (matches) {
      opts.username = matches[1];
      opts.password = matches[2];
    } else {
      opts.username = opts.auth;
    }
  }
}

/**
 * connect - connect to an MQTT broker.
 *
 * @param {String} [brokerUrl] - url of the broker, optional
 * @param {Object} opts - see MqttClient#constructor
 */
function connect (brokerUrl, opts) {

  if (('object' === typeof brokerUrl) && !opts) {
    opts = brokerUrl;
    brokerUrl = null;
  }

  opts = opts || {};

  if (brokerUrl) {
    opts = xtend(url.parse(brokerUrl, true), opts);
    opts.protocol = opts.protocol.replace(/\:$/, '');
  }

  // merge in the auth options if supplied
  parseAuthOptions(opts);

  // support clientId passed in the query string of the url
  if (opts.query && 'string' === typeof opts.query.clientId) {
    opts.clientId = opts.query.clientId;
  }

  if (opts.cert && opts.key) {
    if (opts.protocol) {
      if (-1 === ['mqtts', 'wss'].indexOf(opts.protocol)) {
        /*
         * jshint and eslint
         * complains that break from default cannot be reached after throw
         * it is a foced exit from a control structure
         * maybe add a check after switch to see if it went through default
         * and then throw the error
        */
        /*jshint -W027*/
        /*eslint no-unreachable:1*/
        switch (opts.protocol) {
          case 'mqtt':
            opts.protocol = 'mqtts';
            break;
          case 'ws':
            opts.protocol = 'wss';
            break;
          default:
            throw new Error('Unknown protocol for secure conenction: "' + opts.protocol + '"!');
            break;
        }
        /*eslint no-unreachable:0*/
        /*jshint +W027*/
      }
    } else {
      // don't know what protocol he want to use, mqtts or wss
      throw new Error('Missing secure protocol key');
    }
  }

  if (!protocols[opts.protocol]) {
    opts.protocol = protocolList.filter(function (key) {
      return 'function' === typeof protocols[key];
    })[0];
  }

  if (false === opts.clean && !opts.clientId) {
    throw new Error('Missing clientId for unclean clients');
  }


  function wrapper (client) {
    if (opts.servers) {
      if (!client._reconnectCount || client._reconnectCount === opts.servers.length) {
        client._reconnectCount = 0;
      }

      opts.host = opts.servers[client._reconnectCount].host;
      opts.port = opts.servers[client._reconnectCount].port;
      opts.hostname = opts.host;

      client._reconnectCount++;
    }

    return protocols[opts.protocol](client, opts);
  }

  return new MqttClient(wrapper, opts);
}

module.exports = connect;
module.exports.connect = connect;
module.exports.MqttClient = MqttClient;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {
/**
 * Module dependencies
 */
/*global setImmediate:true*/
var events = __webpack_require__(84),
  Store = __webpack_require__(1116),
  eos = __webpack_require__(472),
  mqttPacket = __webpack_require__(1121),
  Writable = __webpack_require__(468).Writable,
  inherits = __webpack_require__(79),
  reInterval = __webpack_require__(1132),
  setImmediate = global.setImmediate || function (callback) {
    // works in node v0.8
    process.nextTick(callback);
  },
  defaultConnectOptions = {
    keepalive: 10,
    reschedulePings: true,
    protocolId: 'MQTT',
    protocolVersion: 4,
    reconnectPeriod: 1000,
    connectTimeout: 30 * 1000,
    clean: true
  };

function defaultId () {
  return 'mqttjs_' + Math.random().toString(16).substr(2, 8);
}

function sendPacket (client, packet, cb) {
  try {
    var buf = mqttPacket.generate(packet);

    client.emit('packetsend', packet);

    if (client.stream.write(buf) && cb) {
      cb();
    } else if (cb) {
      client.stream.once('drain', cb);
    }
  } catch (err) {
    if (cb) {
      cb(err);
    } else {
      client.emit('error', err);
    }
  }
}

function storeAndSend (client, packet, cb) {
  client.outgoingStore.put(packet, function storedPacket (err) {
    if (err) {
      return cb && cb(err);
    }
    sendPacket(client, packet, cb);
  });
}

function nop () {}

/**
 * MqttClient constructor
 *
 * @param {Stream} stream - stream
 * @param {Object} [options] - connection options
 * (see Connection#connect)
 */
function MqttClient (streamBuilder, options) {
  var k,
    that = this;

  if (!(this instanceof MqttClient)) {
    return new MqttClient(streamBuilder, options);
  }

  this.options = options || {};

  // Defaults
  for (k in defaultConnectOptions) {
    if ('undefined' === typeof this.options[k]) {
      this.options[k] = defaultConnectOptions[k];
    } else {
      this.options[k] = options[k];
    }
  }

  this.options.clientId = this.options.clientId || defaultId();

  this.streamBuilder = streamBuilder;

  // Inflight message storages
  this.outgoingStore = this.options.outgoingStore || new Store();
  this.incomingStore = this.options.incomingStore || new Store();

  // Should QoS zero messages be queued when the connection is broken?
  this.queueQoSZero = null == this.options.queueQoSZero ? true : this.options.queueQoSZero;

  // Ping timer, setup in _setupPingTimer
  this.pingTimer = null;
  // Is the client connected?
  this.connected = false;
  // Are we disconnecting?
  this.disconnecting = false;
  // Packet queue
  this.queue = [];
  // connack timer
  this.connackTimer = null;
  // Reconnect timer
  this.reconnectTimer = null;
  // MessageIDs starting with 1
  this.nextId = Math.floor(Math.random() * 65535);

  // Inflight callbacks
  this.outgoing = {};

  // Mark connected on connect
  this.on('connect', function () {
    this.connected = true;
    var outStore = null;
    outStore = this.outgoingStore.createStream();

    // Control of stored messages
    outStore.once('readable', function () {
      function storeDeliver () {
        var packet = outStore.read(1),
          cb;
        if (!packet) {
          return;
        }
        // Avoid unnecesary stream read operations when disconnected
        if (!that.disconnecting && !that.reconnectTimer && (0 < that.options.reconnectPeriod)) {
          outStore.read(0);
          cb = that.outgoing[packet.messageId];
          that.outgoing[packet.messageId] = function () {
            // Ensure that the original callback passed in to publish gets invoked
            if (cb) {
              cb();
            }
            // Ensure that the next message will only be read after callback is issued
            storeDeliver();
          };
          that._sendPacket(packet);
        } else if (outStore.destroy) {
          outStore.destroy();
        }
      }
      storeDeliver();
    })
    .on('error', this.emit.bind(this, 'error'));
  });

  // Mark disconnected on stream close
  this.on('close', function () {
    this.connected = false;
    clearTimeout(this.connackTimer);
  });

  // Setup ping timer
  this.on('connect', this._setupPingTimer);

  // Send queued packets
  this.on('connect', function () {
    var queue = this.queue;

    function deliver () {
      var entry = queue.shift(),
        packet = null;

      if (!entry) {
        return;
      }

      packet = entry.packet;

      that._sendPacket(
        packet,
        function (err) {
          if (entry.cb) {
            entry.cb(err);
          }
          deliver();
        }
      );
    }

    deliver();
  });


  // Clear ping timer
  this.on('close', function () {
    if (null !== that.pingTimer) {
      that.pingTimer.clear();
      that.pingTimer = null;
    }
  });

  // Setup reconnect timer on disconnect
  this.on('close', this._setupReconnect);

  events.EventEmitter.call(this);

  this._setupStream();
}
inherits(MqttClient, events.EventEmitter);

/**
 * setup the event handlers in the inner stream.
 *
 * @api private
 */
MqttClient.prototype._setupStream = function () {
  var connectPacket,
    that = this,
    writable = new Writable(),
    parser = mqttPacket.parser(this.options),
    completeParse = null,
    packets = [];

  this._clearReconnect();

  this.stream = this.streamBuilder(this);

  parser.on('packet', function (packet) {
    packets.push(packet);
  });

  function process () {
    var packet = packets.shift(),
      done = completeParse;
    if (packet) {
      that._handlePacket(packet, process);
    } else {
      completeParse = null;
      done();
    }
  }

  writable._write = function (buf, enc, done) {
    completeParse = done;
    parser.parse(buf);
    process();
  };

  this.stream.pipe(writable);

  // Suppress connection errors
  this.stream.on('error', nop);

  // Echo stream close
  eos(this.stream, this.emit.bind(this, 'close'));

  // Send a connect packet
  connectPacket = Object.create(this.options);
  connectPacket.cmd = 'connect';
  // avoid message queue
  sendPacket(this, connectPacket);

  // Echo connection errors
  parser.on('error', this.emit.bind(this, 'error'));

  // many drain listeners are needed for qos 1 callbacks if the connection is intermittent
  this.stream.setMaxListeners(1000);

  clearTimeout(this.connackTimer);
  this.connackTimer = setTimeout(function () {
    that._cleanUp(true);
  }, this.options.connectTimeout);
};

MqttClient.prototype._handlePacket = function (packet, done) {
  this.emit('packetreceive', packet);

  switch (packet.cmd) {
    case 'publish':
      this._handlePublish(packet, done);
      break;
    case 'puback':
    case 'pubrec':
    case 'pubcomp':
    case 'suback':
    case 'unsuback':
      this._handleAck(packet);
      done();
      break;
    case 'pubrel':
      this._handlePubrel(packet, done);
      break;
    case 'connack':
      this._handleConnack(packet);
      done();
      break;
    case 'pingresp':
      this._handlePingresp(packet);
      done();
      break;
    default:
      // do nothing
      // maybe we should do an error handling
      // or just log it
      break;
  }
};

MqttClient.prototype._checkDisconnecting = function (callback) {
  if (this.disconnecting) {
    if (callback) {
      callback(new Error('client disconnecting'));
    } else {
      this.emit('error', new Error('client disconnecting'));
    }
  }
  return this.disconnecting;
};

/**
 * publish - publish <message> to <topic>
 *
 * @param {String} topic - topic to publish to
 * @param {String, Buffer} message - message to publish
 * @param {Object} [opts] - publish options, includes:
 *    {Number} qos - qos level to publish on
 *    {Boolean} retain - whether or not to retain the message
 * @param {Function} [callback] - function(err){}
 *    called when publish succeeds or fails
 * @returns {MqttClient} this - for chaining
 * @api public
 *
 * @example client.publish('topic', 'message');
 * @example
 *     client.publish('topic', 'message', {qos: 1, retain: true});
 * @example client.publish('topic', 'message', console.log);
 */
MqttClient.prototype.publish = function (topic, message, opts, callback) {
  var packet;

  // .publish(topic, payload, cb);
  if ('function' === typeof opts) {
    callback = opts;
    opts = null;
  }

  // Default opts
  if (!opts) {
    opts = {qos: 0, retain: false};
  }

  if (this._checkDisconnecting(callback)) {
    return this;
  }

  packet = {
    cmd: 'publish',
    topic: topic,
    payload: message,
    qos: opts.qos,
    retain: opts.retain,
    messageId: this._nextId()
  };

  switch (opts.qos) {
    case 1:
    case 2:

      // Add to callbacks
      this.outgoing[packet.messageId] = callback || nop;
      this._sendPacket(packet);
      break;
    default:
      this._sendPacket(packet, callback);
      break;
  }

  return this;
};

/**
 * subscribe - subscribe to <topic>
 *
 * @param {String, Array, Object} topic - topic(s) to subscribe to, supports objects in the form {'topic': qos}
 * @param {Object} [opts] - optional subscription options, includes:
 *    {Number} qos - subscribe qos level
 * @param {Function} [callback] - function(err, granted){} where:
 *    {Error} err - subscription error (none at the moment!)
 *    {Array} granted - array of {topic: 't', qos: 0}
 * @returns {MqttClient} this - for chaining
 * @api public
 * @example client.subscribe('topic');
 * @example client.subscribe('topic', {qos: 1});
 * @example client.subscribe({'topic': 0, 'topic2': 1}, console.log);
 * @example client.subscribe('topic', console.log);
 */
MqttClient.prototype.subscribe = function () {
  var packet,
    args = Array.prototype.slice.call(arguments),
    subs = [],
    obj = args.shift(),
    callback = args.pop() || nop,
    opts = args.pop();

  if ('string' === typeof obj) {
    obj = [obj];
  }

  if ('function' !== typeof callback) {
    opts = callback;
    callback = nop;
  }

  if (this._checkDisconnecting(callback)) {
    return this;
  }

  if (!opts) {
    opts = { qos: 0 };
  }

  if (Array.isArray(obj)) {
    obj.forEach(function (topic) {
      subs.push({
        topic: topic,
        qos: opts.qos
      });
    });
  } else {
    Object
      .keys(obj)
      .forEach(function (k) {
        subs.push({
          topic: k,
          qos: obj[k]
        });
      });
  }

  packet = {
    cmd: 'subscribe',
    subscriptions: subs,
    qos: 1,
    retain: false,
    dup: false,
    messageId: this._nextId()
  };

  this.outgoing[packet.messageId] = callback;

  this._sendPacket(packet);

  return this;
};

/**
 * unsubscribe - unsubscribe from topic(s)
 *
 * @param {String, Array} topic - topics to unsubscribe from
 * @param {Function} [callback] - callback fired on unsuback
 * @returns {MqttClient} this - for chaining
 * @api public
 * @example client.unsubscribe('topic');
 * @example client.unsubscribe('topic', console.log);
 */
MqttClient.prototype.unsubscribe = function (topic, callback) {
  var packet = {
    cmd: 'unsubscribe',
    qos: 1,
    messageId: this._nextId()
  };

  callback = callback || nop;

  if (this._checkDisconnecting(callback)) {
    return this;
  }

  if ('string' === typeof topic) {
    packet.unsubscriptions = [topic];
  } else if ('object' === typeof topic && topic.length) {
    packet.unsubscriptions = topic;
  }

  this.outgoing[packet.messageId] = callback;

  this._sendPacket(packet);

  return this;
};

/**
 * end - close connection
 *
 * @returns {MqttClient} this - for chaining
 * @param {Boolean} force - do not wait for all in-flight messages to be acked
 * @param {Function} cb - called when the client has been closed
 *
 * @api public
 */
MqttClient.prototype.end = function (force, cb) {
  var that = this;

  if ('function' === typeof force) {
    cb = force;
    force = false;
  }

  function closeStores () {
    that.incomingStore.close(function () {
      that.outgoingStore.close(cb);
    });
  }

  function finish () {
    that._cleanUp(force, closeStores);
  }

  if (this.disconnecting) {
    return true;
  }

  this.disconnecting = true;

  if (!force && 0 < Object.keys(this.outgoing).length) {
    // wait 10ms, just to be sure we received all of it
    this.once('outgoingEmpty', setTimeout.bind(null, finish, 10));
  } else {
    finish();
  }

  return this;
};

/**
 * _reconnect - implement reconnection
 * @api privateish
 */
MqttClient.prototype._reconnect = function () {
  this.emit('reconnect');
  this._setupStream();
};

/**
 * _setupReconnect - setup reconnect timer
 */
MqttClient.prototype._setupReconnect = function () {
  var that = this;

  if (!that.disconnecting && !that.reconnectTimer && (0 < that.options.reconnectPeriod)) {
    this.emit('offline');
    that.reconnectTimer = setInterval(function () {
      that._reconnect();
    }, that.options.reconnectPeriod);
  }
};

/**
 * _clearReconnect - clear the reconnect timer
 */
MqttClient.prototype._clearReconnect = function () {
  if (this.reconnectTimer) {
    clearInterval(this.reconnectTimer);
    this.reconnectTimer = false;
  }
};


/**
 * _cleanUp - clean up on connection end
 * @api private
 */
MqttClient.prototype._cleanUp = function (forced, done) {

  if (done) {
    this.stream.on('close', done);
  }

  if (forced) {
    this.stream.destroy();
  } else {
    this._sendPacket(
      { cmd: 'disconnect' },
      setImmediate.bind(
        null,
        this.stream.end.bind(this.stream)
      )
    );
  }

  if (this.reconnectTimer) {
    this._clearReconnect();
    this._setupReconnect();
  }

  if (null !== this.pingTimer) {
    this.pingTimer.clear();
    this.pingTimer = null;
  }
};

/**
 * _sendPacket - send or queue a packet
 * @param {String} type - packet type (see `protocol`)
 * @param {Object} packet - packet options
 * @param {Function} cb - callback when the packet is sent
 * @api private
 */
MqttClient.prototype._sendPacket = function (packet, cb) {
  if (!this.connected) {
    if (0 < packet.qos || 'publish' !== packet.cmd || this.queueQoSZero) {
      this.queue.push({ packet: packet, cb: cb });
    } else if (cb) {
      cb(new Error('No connection to broker'));
    }

    return;
  }

  // When sending a packet, reschedule the ping timer
  this._shiftPingInterval();

  switch (packet.qos) {
    case 2:
    case 1:
      storeAndSend(this, packet, cb);
      break;
    /**
     * no need of case here since it will be caught by default
     * and jshint comply that before default it must be a break
     * anyway it will result in -1 evaluation
     */
    case 0:
      /* falls through */
    default:
      sendPacket(this, packet, cb);
      break;
  }
};

/**
 * _setupPingTimer - setup the ping timer
 *
 * @api private
 */
MqttClient.prototype._setupPingTimer = function () {
  var that = this;

  if (!this.pingTimer && this.options.keepalive) {
    this.pingResp = true;
    this.pingTimer = reInterval(function () {
      that._checkPing();
    }, this.options.keepalive * 1000);
  }
};

/**
 * _shiftPingInterval - reschedule the ping interval
 *
 * @api private
 */
MqttClient.prototype._shiftPingInterval = function () {
  if (this.pingTimer && this.options.keepalive && this.options.reschedulePings) {
    this.pingTimer.reschedule(this.options.keepalive * 1000);
  }
};
/**
 * _checkPing - check if a pingresp has come back, and ping the server again
 *
 * @api private
 */
MqttClient.prototype._checkPing = function () {
  if (this.pingResp) {
    this.pingResp = false;
    this._sendPacket({ cmd: 'pingreq' });
  } else {
    // do a forced cleanup since socket will be in bad shape
    this._cleanUp(true);
  }
};

/**
 * _handlePingresp - handle a pingresp
 *
 * @api private
 */
MqttClient.prototype._handlePingresp = function () {
  this.pingResp = true;
};

/**
 * _handleConnack
 *
 * @param {Object} packet
 * @api private
 */

MqttClient.prototype._handleConnack = function (packet) {
  var rc = packet.returnCode,
    // TODO: move to protocol
    errors = [
      '',
      'Unacceptable protocol version',
      'Identifier rejected',
      'Server unavailable',
      'Bad username or password',
      'Not authorized'
    ];

  clearTimeout(this.connackTimer);

  if (0 === rc) {
    this.emit('connect', packet);
  } else if (0 < rc) {
    this.emit('error',
        new Error('Connection refused: ' + errors[rc]));
  }
};

/**
 * _handlePublish
 *
 * @param {Object} packet
 * @api private
 */
/*
those late 2 case should be rewrite to comply with coding style:

case 1:
case 0:
  // do not wait sending a puback
  // no callback passed
  if (1 === qos) {
    this._sendPacket({
      cmd: 'puback',
      messageId: mid
    });
  }
  // emit the message event for both qos 1 and 0
  this.emit('message', topic, message, packet);
  this.handleMessage(packet, done);
  break;
default:
  // do nothing but every switch mus have a default
  // log or throw an error about unknown qos
  break;

for now i just suppressed the warnings
*/
MqttClient.prototype._handlePublish = function (packet, done) {
  var topic = packet.topic.toString(),
    message = packet.payload,
    qos = packet.qos,
    mid = packet.messageId,
    that = this;

  switch (qos) {
    case 2:
      this.incomingStore.put(packet, function () {
        that._sendPacket({cmd: 'pubrec', messageId: mid}, done);
      });
      break;
    case 1:
      // do not wait sending a puback
      // no callback passed
      this._sendPacket({
        cmd: 'puback',
        messageId: mid
      });
      /* falls through */
    case 0:
      // emit the message event for both qos 1 and 0
      this.emit('message', topic, message, packet);
      this.handleMessage(packet, done);
      break;
    default:
      // do nothing
      // log or throw an error about unknown qos
      break;
  }
};

/**
 * Handle messages with backpressure support, one at a time.
 * Override at will.
 *
 * @param Packet packet the packet
 * @param Function callback call when finished
 * @api public
 */
MqttClient.prototype.handleMessage = function (packet, callback) {
  callback();
};

/**
 * _handleAck
 *
 * @param {Object} packet
 * @api private
 */

MqttClient.prototype._handleAck = function (packet) {
  var mid = packet.messageId,
    type = packet.cmd,
    response = null,
    cb = this.outgoing[mid],
    that = this;

  if (!cb) {
    // Server sent an ack in error, ignore it.
    return;
  }

  // Process
  switch (type) {
    case 'pubcomp':
      // same thing as puback for QoS 2
    case 'puback':
      // Callback - we're done
      delete this.outgoing[mid];
      this.outgoingStore.del(packet, cb);
      break;
    case 'pubrec':
      response = {
        cmd: 'pubrel',
        qos: 2,
        messageId: mid
      };

      this._sendPacket(response);
      break;
    case 'suback':
      delete this.outgoing[mid];
      this.outgoingStore.del(packet, function (err, original) {
        if (err) {
          // missing packet, what should we do?
          return that.emit('error', err);
        }

        var i,
          origSubs = original.subscriptions,
          granted = packet.granted;

        for (i = 0; i < granted.length; i += 1) {
          origSubs[i].qos = granted[i];
        }

        cb(null, origSubs);
      });
      break;
    case 'unsuback':
      delete this.outgoing[mid];
      this.outgoingStore.del(packet, cb);
      break;
    default:
      that.emit('error', new Error('unrecognized packet type'));
  }

  if (this.disconnecting &&
      0 === Object.keys(this.outgoing).length) {
    this.emit('outgoingEmpty');
  }
};

/**
 * _handlePubrel
 *
 * @param {Object} packet
 * @api private
 */

MqttClient.prototype._handlePubrel = function (packet, callback) {
  var mid = packet.messageId,
    that = this;

  that.incomingStore.get(packet, function (err, pub) {
    if (err) {
      return that.emit('error', err);
    }

    if ('pubrel' !== pub.cmd) {
      that.emit('message', pub.topic, pub.payload, pub);
      that.incomingStore.put(packet);
    }

    that._sendPacket({cmd: 'pubcomp', messageId: mid}, callback);
  });
};

/**
 * _nextId
 */
MqttClient.prototype._nextId = function () {
  var id = this.nextId++;
  // Ensure 16 bit unsigned int:
  if (65535 === id) {
    this.nextId = 1;
  }
  return id;
};

module.exports = MqttClient;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65), __webpack_require__(55)))

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
var Readable = __webpack_require__(468).Readable,
  streamsOpts = { objectMode: true };

/**
 * In-memory implementation of the message store
 * This can actually be saved into files.
 *
 */
function Store () {
  if (!(this instanceof Store)) {
    return new Store();
  }

  this._inflights = {};
}

/**
 * Adds a packet to the store, a packet is
 * anything that has a messageId property.
 *
 */
Store.prototype.put = function (packet, cb) {
  this._inflights[packet.messageId] = packet;

  if (cb) {
    cb();
  }

  return this;
};

/**
 * Creates a stream with all the packets in the store
 *
 */
Store.prototype.createStream = function () {
  var stream = new Readable(streamsOpts),
    inflights = this._inflights,
    ids = Object.keys(this._inflights),
    destroyed = false,
    i = 0;

  stream._read = function () {
    if (!destroyed && i < ids.length) {
      this.push(inflights[ids[i++]]);
    } else {
      this.push(null);
    }
  };

  stream.destroy = function () {
    if (destroyed) {
      return;
    }

    var self = this;

    destroyed = true;

    process.nextTick(function () {
      self.emit('close');
    });
  };

  return stream;
};

/**
 * deletes a packet from the store.
 */
Store.prototype.del = function (packet, cb) {
  packet = this._inflights[packet.messageId];
  if (packet) {
    delete this._inflights[packet.messageId];
    cb(null, packet);
  } else if (cb) {
    cb(new Error('missing packet'));
  }

  return this;
};

/**
 * get a packet from the store.
 */
Store.prototype.get = function (packet, cb) {
  packet = this._inflights[packet.messageId];
  if (packet) {
    cb(null, packet);
  } else if (cb) {
    cb(new Error('missing packet'));
  }

  return this;
};

/**
 * Close the store
 */
Store.prototype.close = function (cb) {
  this._inflights = null;
  if (cb) {
    cb();
  }
};

module.exports = Store;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

module.exports = PassThrough;

var Transform = __webpack_require__(471);

/*<replacement>*/
var util = __webpack_require__(87);
util.inherits = __webpack_require__(79);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough))
    return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function(chunk, encoding, cb) {
  cb(null, chunk);
};


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var wrappy = __webpack_require__(1120)
module.exports = wrappy(once)
module.exports.strict = wrappy(onceStrict)

once.proto = once(function () {
  Object.defineProperty(Function.prototype, 'once', {
    value: function () {
      return once(this)
    },
    configurable: true
  })

  Object.defineProperty(Function.prototype, 'onceStrict', {
    value: function () {
      return onceStrict(this)
    },
    configurable: true
  })
})

function once (fn) {
  var f = function () {
    if (f.called) return f.value
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  f.called = false
  return f
}

function onceStrict (fn) {
  var f = function () {
    if (f.called)
      throw new Error(f.onceError)
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  var name = fn.name || 'Function wrapped with `once`'
  f.onceError = name + " shouldn't be called more than once"
  f.called = false
  return f
}


/***/ }),
/* 1120 */
/***/ (function(module, exports) {

// Returns a wrapper function that returns a wrapped callback
// The wrapper function should do some stuff, and return a
// presumably different callback function.
// This makes sure that own properties are retained, so that
// decorations and such are not lost along the way.
module.exports = wrappy
function wrappy (fn, cb) {
  if (fn && cb) return wrappy(fn)(cb)

  if (typeof fn !== 'function')
    throw new TypeError('need wrapper function')

  Object.keys(fn).forEach(function (k) {
    wrapper[k] = fn[k]
  })

  return wrapper

  function wrapper() {
    var args = new Array(arguments.length)
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i]
    }
    var ret = fn.apply(this, args)
    var cb = args[args.length-1]
    if (typeof ret === 'function' && ret !== cb) {
      Object.keys(cb).forEach(function (k) {
        ret[k] = cb[k]
      })
    }
    return ret
  }
}


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



exports.parser          = __webpack_require__(1122)
exports.generate        = __webpack_require__(1131)


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {


var bl        = __webpack_require__(1123)
  , inherits  = __webpack_require__(79)
  , EE        = __webpack_require__(84).EventEmitter
  , Packet    = __webpack_require__(1130)
  , constants = __webpack_require__(477)

function Parser() {
  if (!(this instanceof Parser)) {
    return new Parser()
  }

  this._states = [
      '_parseHeader'
    , '_parseLength'
    , '_parsePayload'
    , '_newPacket'
  ]

  this._resetState()
}

inherits(Parser, EE)

Parser.prototype._resetState = function () {
  this.packet = new Packet()
  this.error = null
  this._list = bl()
  this._stateCounter = 0
}

Parser.prototype.parse = function (buf) {
  if (this.error) {
    this._resetState()
  }

  this._list.append(buf)

  while ((this.packet.length != -1 || this._list.length > 0) &&
         this[this._states[this._stateCounter]]() &&
         !this.error) {
    this._stateCounter++

    if (this._stateCounter >= this._states.length) {
      this._stateCounter = 0
    }
  }

  return this._list.length
}

Parser.prototype._parseHeader = function () {

  // there is at least one byte in the buffer
  var zero = this._list.readUInt8(0)
  this.packet.cmd = constants.types[zero >> constants.CMD_SHIFT]
  this.packet.retain = (zero & constants.RETAIN_MASK) !== 0
  this.packet.qos = (zero >> constants.QOS_SHIFT) & constants.QOS_MASK
  this.packet.dup = (zero & constants.DUP_MASK) !== 0

  this._list.consume(1)

  return true
}


Parser.prototype._parseLength = function () {
  // there is at least one byte in the list
  var bytes    = 0
    , mul      = 1
    , length   = 0
    , result   = true
    , current

  while (bytes < 5) {
    current = this._list.readUInt8(bytes++)
    length += mul * (current & constants.LENGTH_MASK)
    mul *= 0x80

    if ((current & constants.LENGTH_FIN_MASK) === 0) {
      break
    }

    if (this._list.length <= bytes) {
      result = false
      break
    }
  }

  if (result) {
    this.packet.length = length
    this._list.consume(bytes)
  }

  return result
}

Parser.prototype._parsePayload = function () {
  var result = false

  // Do we have a payload? Do we have enough data to complete the payload?
  // PINGs have no payload
  if (this.packet.length === 0 || this._list.length >= this.packet.length) {

    this._pos = 0

    switch (this.packet.cmd) {
      case 'connect':
        this._parseConnect()
        break
      case 'connack':
        this._parseConnack()
        break
      case 'publish':
        this._parsePublish()
        break
      case 'puback':
      case 'pubrec':
      case 'pubrel':
      case 'pubcomp':
        this._parseMessageId()
        break
      case 'subscribe':
        this._parseSubscribe()
        break
      case 'suback':
        this._parseSuback()
        break
      case 'unsubscribe':
        this._parseUnsubscribe()
        break
      case 'unsuback':
        this._parseUnsuback()
        break
      case 'pingreq':
      case 'pingresp':
      case 'disconnect':
        // these are empty, nothing to do
        break
      default:
        this._emitError(new Error('not supported'))
    }

    result = true
  }

  return result
}

Parser.prototype._parseConnect = function () {
  var protocolId // constants id
    , clientId // Client id
    , topic // Will topic
    , payload // Will payload
    , password // Password
    , username // Username
    , flags = {}
    , packet = this.packet

  // Parse constants id
  protocolId = this._parseString()
  if (protocolId === null)
    return this._emitError(new Error('cannot parse protocol id'))

  if (protocolId != 'MQTT' && protocolId != 'MQIsdp') {

    return this._emitError(new Error('invalid protocol id'))
  }

  packet.protocolId = protocolId

  // Parse constants version number
  if(this._pos >= this._list.length)
    return this._emitError(new Error('packet too short'))

  packet.protocolVersion = this._list.readUInt8(this._pos)

  if(packet.protocolVersion != 3 && packet.protocolVersion != 4) {

    return this._emitError(new Error('invalid protocol version'))
  }

  this._pos++
  if(this._pos >= this._list.length)
    return this._emitError(new Error('packet too short'))

  // Parse connect flags
  flags.username  = (this._list.readUInt8(this._pos) & constants.USERNAME_MASK)
  flags.password  = (this._list.readUInt8(this._pos) & constants.PASSWORD_MASK)
  flags.will      = (this._list.readUInt8(this._pos) & constants.WILL_FLAG_MASK)

  if (flags.will) {
    packet.will         = {}
    packet.will.retain  = (this._list.readUInt8(this._pos) & constants.WILL_RETAIN_MASK) !== 0
    packet.will.qos     = (this._list.readUInt8(this._pos) &
                          constants.WILL_QOS_MASK) >> constants.WILL_QOS_SHIFT
  }

  packet.clean = (this._list.readUInt8(this._pos) & constants.CLEAN_SESSION_MASK) !== 0
  this._pos++

  // Parse keepalive
  packet.keepalive = this._parseNum()
  if(packet.keepalive === -1)
    return this._emitError(new Error('packet too short'))

  // Parse client ID
  clientId = this._parseString()
  if(clientId === null)
    return this._emitError(new Error('packet too short'))
  packet.clientId = clientId

  if (flags.will) {
    // Parse will topic
    topic = this._parseString()
    if (topic === null)
      return this._emitError(new Error('cannot parse will topic'))
    packet.will.topic = topic

    // Parse will payload
    payload = this._parseBuffer()
    if (payload === null)
      return this._emitError(new Error('cannot parse will payload'))
    packet.will.payload = payload
  }

  // Parse username
  if (flags.username) {
    username = this._parseString()
    if(username === null)
      return this._emitError(new Error('cannot parse username'))
    packet.username = username
  }

  // Parse password
  if(flags.password) {
    password = this._parseBuffer()
    if(password === null)
      return this._emitError(new Error('cannot parse username'))
    packet.password = password
  }

  return packet
}

Parser.prototype._parseConnack = function () {
  var packet = this.packet
  if (this._list.length < 2)
    return null
  packet.sessionPresent = !!(this._list.readUInt8(this._pos++) & constants.SESSIONPRESENT_MASK)
  packet.returnCode = this._list.readUInt8(this._pos)
  if(packet.returnCode === -1)
    return this._emitError(new Error('cannot parse return code'))
}

Parser.prototype._parsePublish = function () {
  var packet = this.packet
  packet.topic = this._parseString()

  if(packet.topic === null)
    return this._emitError(new Error('cannot parse topic'))

  // Parse message ID
  if (packet.qos > 0) {
    if (!this._parseMessageId()) { return }
  }

  packet.payload = this._list.slice(this._pos, packet.length)
}

Parser.prototype._parseSubscribe = function() {
  var packet = this.packet
    , topic
    , qos

  if (packet.qos != 1) {
    return this._emitError(new Error('wrong subscribe header'))
  }

  packet.subscriptions = []

  if (!this._parseMessageId()) { return }

  while (this._pos < packet.length) {

    // Parse topic
    topic = this._parseString()
    if (topic === null)
      return this._emitError(new Error('Parse error - cannot parse topic'))

    if (this._pos >= packet.length) return this._emitError(new Error('Malformed Subscribe Payload'))
    qos = this._list.readUInt8(this._pos++)

    // Push pair to subscriptions
    packet.subscriptions.push({ topic: topic, qos: qos });
  }
}

Parser.prototype._parseSuback = function() {
  this.packet.granted = []

  if (!this._parseMessageId()) { return }

  // Parse granted QoSes
  while (this._pos < this.packet.length) {
    this.packet.granted.push(this._list.readUInt8(this._pos++));
  }
}

Parser.prototype._parseUnsubscribe = function() {
  var packet = this.packet

  packet.unsubscriptions = []

  // Parse message ID
  if (!this._parseMessageId()) { return }

  while (this._pos < packet.length) {
    var topic;

    // Parse topic
    topic = this._parseString()
    if (topic === null)
      return this._emitError(new Error('cannot parse topic'))

    // Push topic to unsubscriptions
    packet.unsubscriptions.push(topic);
  }
}

Parser.prototype._parseUnsuback = function() {
  if (!this._parseMessageId())
    return this._emitError(new Error('cannot parse message id'))
}

Parser.prototype._parseMessageId = function() {
  var packet = this.packet

  packet.messageId = this._parseNum()

  if(packet.messageId === null) {
    this._emitError(new Error('cannot parse message id'))
    return false
  }

  return true
}

Parser.prototype._parseString = function(maybeBuffer) {
  var length = this._parseNum()
    , result
    , end = length + this._pos

  if(length === -1 || end > this._list.length || end > this.packet.length)
    return null

  result = this._list.toString('utf8', this._pos, end)

  this._pos += length

  return result
}

Parser.prototype._parseBuffer = function() {
  var length = this._parseNum()
    , result
    , end = length + this._pos

  if(length === -1 || end > this._list.length || end > this.packet.length)
    return null

  result = this._list.slice(this._pos, end)

  this._pos += length

  return result
}

Parser.prototype._parseNum = function() {
  if(this._list.length - this._pos < 2) return -1

  var result = this._list.readUInt16BE(this._pos)
  this._pos += 2
  return result
}

Parser.prototype._newPacket = function () {
  if (this.packet) {
    this._list.consume(this.packet.length)
    this.emit('packet', this.packet)
  }

  this.packet = new Packet()

  return true
}

Parser.prototype._emitError = function(err) {
  this.error = err
  this.emit('error', err)
}

module.exports = Parser


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

var DuplexStream = __webpack_require__(1124)
  , util         = __webpack_require__(222)
  , Buffer       = __webpack_require__(224).Buffer


function BufferList (callback) {
  if (!(this instanceof BufferList))
    return new BufferList(callback)

  this._bufs  = []
  this.length = 0

  if (typeof callback == 'function') {
    this._callback = callback

    var piper = function piper (err) {
      if (this._callback) {
        this._callback(err)
        this._callback = null
      }
    }.bind(this)

    this.on('pipe', function onPipe (src) {
      src.on('error', piper)
    })
    this.on('unpipe', function onUnpipe (src) {
      src.removeListener('error', piper)
    })
  } else {
    this.append(callback)
  }

  DuplexStream.call(this)
}


util.inherits(BufferList, DuplexStream)


BufferList.prototype._offset = function _offset (offset) {
  var tot = 0, i = 0, _t
  if (offset === 0) return [ 0, 0 ]
  for (; i < this._bufs.length; i++) {
    _t = tot + this._bufs[i].length
    if (offset < _t || i == this._bufs.length - 1)
      return [ i, offset - tot ]
    tot = _t
  }
}


BufferList.prototype.append = function append (buf) {
  var i = 0

  if (Buffer.isBuffer(buf)) {
    this._appendBuffer(buf);
  } else if (Array.isArray(buf)) {
    for (; i < buf.length; i++)
      this.append(buf[i])
  } else if (buf instanceof BufferList) {
    // unwrap argument into individual BufferLists
    for (; i < buf._bufs.length; i++)
      this.append(buf._bufs[i])
  } else if (buf != null) {
    // coerce number arguments to strings, since Buffer(number) does
    // uninitialized memory allocation
    if (typeof buf == 'number')
      buf = buf.toString()

    this._appendBuffer(Buffer.from(buf));
  }

  return this
}


BufferList.prototype._appendBuffer = function appendBuffer (buf) {
  this._bufs.push(buf)
  this.length += buf.length
}


BufferList.prototype._write = function _write (buf, encoding, callback) {
  this._appendBuffer(buf)

  if (typeof callback == 'function')
    callback()
}


BufferList.prototype._read = function _read (size) {
  if (!this.length)
    return this.push(null)

  size = Math.min(size, this.length)
  this.push(this.slice(0, size))
  this.consume(size)
}


BufferList.prototype.end = function end (chunk) {
  DuplexStream.prototype.end.call(this, chunk)

  if (this._callback) {
    this._callback(null, this.slice())
    this._callback = null
  }
}


BufferList.prototype.get = function get (index) {
  return this.slice(index, index + 1)[0]
}


BufferList.prototype.slice = function slice (start, end) {
  if (typeof start == 'number' && start < 0)
    start += this.length
  if (typeof end == 'number' && end < 0)
    end += this.length
  return this.copy(null, 0, start, end)
}


BufferList.prototype.copy = function copy (dst, dstStart, srcStart, srcEnd) {
  if (typeof srcStart != 'number' || srcStart < 0)
    srcStart = 0
  if (typeof srcEnd != 'number' || srcEnd > this.length)
    srcEnd = this.length
  if (srcStart >= this.length)
    return dst || Buffer.alloc(0)
  if (srcEnd <= 0)
    return dst || Buffer.alloc(0)

  var copy   = !!dst
    , off    = this._offset(srcStart)
    , len    = srcEnd - srcStart
    , bytes  = len
    , bufoff = (copy && dstStart) || 0
    , start  = off[1]
    , l
    , i

  // copy/slice everything
  if (srcStart === 0 && srcEnd == this.length) {
    if (!copy) { // slice, but full concat if multiple buffers
      return this._bufs.length === 1
        ? this._bufs[0]
        : Buffer.concat(this._bufs, this.length)
    }

    // copy, need to copy individual buffers
    for (i = 0; i < this._bufs.length; i++) {
      this._bufs[i].copy(dst, bufoff)
      bufoff += this._bufs[i].length
    }

    return dst
  }

  // easy, cheap case where it's a subset of one of the buffers
  if (bytes <= this._bufs[off[0]].length - start) {
    return copy
      ? this._bufs[off[0]].copy(dst, dstStart, start, start + bytes)
      : this._bufs[off[0]].slice(start, start + bytes)
  }

  if (!copy) // a slice, we need something to copy in to
    dst = Buffer.allocUnsafe(len)

  for (i = off[0]; i < this._bufs.length; i++) {
    l = this._bufs[i].length - start

    if (bytes > l) {
      this._bufs[i].copy(dst, bufoff, start)
      bufoff += l
    } else {
      this._bufs[i].copy(dst, bufoff, start, start + bytes)
      bufoff += l
      break
    }

    bytes -= l

    if (start)
      start = 0
  }

  // safeguard so that we don't return uninitialized memory
  if (dst.length > bufoff) return dst.slice(0, bufoff)

  return dst
}

BufferList.prototype.shallowSlice = function shallowSlice (start, end) {
  start = start || 0
  end = end || this.length

  if (start < 0)
    start += this.length
  if (end < 0)
    end += this.length

  var startOffset = this._offset(start)
    , endOffset = this._offset(end)
    , buffers = this._bufs.slice(startOffset[0], endOffset[0] + 1)

  if (endOffset[1] == 0)
    buffers.pop()
  else
    buffers[buffers.length-1] = buffers[buffers.length-1].slice(0, endOffset[1])

  if (startOffset[1] != 0)
    buffers[0] = buffers[0].slice(startOffset[1])

  return new BufferList(buffers)
}

BufferList.prototype.toString = function toString (encoding, start, end) {
  return this.slice(start, end).toString(encoding)
}

BufferList.prototype.consume = function consume (bytes) {
  // first, normalize the argument, in accordance with how Buffer does it
  bytes = Math.trunc(bytes)
  // do nothing if not a positive number
  if (Number.isNaN(bytes) || bytes <= 0) return this

  while (this._bufs.length) {
    if (bytes >= this._bufs[0].length) {
      bytes -= this._bufs[0].length
      this.length -= this._bufs[0].length
      this._bufs.shift()
    } else {
      this._bufs[0] = this._bufs[0].slice(bytes)
      this.length -= bytes
      break
    }
  }
  return this
}


BufferList.prototype.duplicate = function duplicate () {
  var i = 0
    , copy = new BufferList()

  for (; i < this._bufs.length; i++)
    copy.append(this._bufs[i])

  return copy
}


BufferList.prototype.destroy = function destroy () {
  this._bufs.length = 0
  this.length = 0
  this.push(null)
}


;(function () {
  var methods = {
      'readDoubleBE' : 8
    , 'readDoubleLE' : 8
    , 'readFloatBE'  : 4
    , 'readFloatLE'  : 4
    , 'readInt32BE'  : 4
    , 'readInt32LE'  : 4
    , 'readUInt32BE' : 4
    , 'readUInt32LE' : 4
    , 'readInt16BE'  : 2
    , 'readInt16LE'  : 2
    , 'readUInt16BE' : 2
    , 'readUInt16LE' : 2
    , 'readInt8'     : 1
    , 'readUInt8'    : 1
  }

  for (var m in methods) {
    (function (m) {
      BufferList.prototype[m] = function (offset) {
        return this.slice(offset, offset + methods[m])[m](0)
      }
    }(m))
  }
}())


module.exports = BufferList


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(119);


/***/ }),
/* 1125 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1126 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(224).Buffer;
var util = __webpack_require__(1128);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),
/* 1130 */
/***/ (function(module, exports) {


function Packet() {
  this.cmd = null
  this.retain = false
  this.qos = 0
  this.dup = false
  this.length = -1
  this.topic = null
  this.payload = null
}

module.exports = Packet


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {


var protocol = __webpack_require__(477)
  , empty = new Buffer(0)

function generate(packet) {

  switch (packet.cmd) {
    case 'connect':
      return connect(packet)
    case 'connack':
      return connack(packet)
    case 'publish':
      return publish(packet)
    case 'puback':
    case 'pubrec':
    case 'pubrel':
    case 'pubcomp':
    case 'unsuback':
      return confirmation(packet)
    case 'subscribe':
      return subscribe(packet)
    case 'suback':
      return suback(packet)
    case 'unsubscribe':
      return unsubscribe(packet)
    case 'pingreq':
    case 'pingresp':
    case 'disconnect':
      return emptyPacket(packet)
    default:
      throw new Error('unknown command')
  }
}

function connect(opts) {
  var opts = opts || {}
    , protocolId = opts.protocolId || 'MQTT'
    , protocolVersion = opts.protocolVersion || 4
    , will = opts.will
    , clean = opts.clean
    , keepalive = opts.keepalive || 0
    , clientId = opts.clientId || ""
    , username = opts.username
    , password = opts.password

  if (clean === undefined) {
    clean = true
  }

  var length = 0

  // Must be a string and non-falsy
  if (!protocolId ||
     (typeof protocolId !== "string" && !Buffer.isBuffer(protocolId))) {
    throw new Error('Invalid protocol id')
  } else {
    length += protocolId.length + 2
  }

  // Must be a 1 byte number
  if (!protocolVersion ||
      'number' !== typeof protocolVersion ||
      protocolVersion > 255 ||
      protocolVersion < 0) {

    throw new Error('Invalid protocol version')
  } else {
    length += 1
  }

  // ClientId might be omitted in 3.1.1, but only if cleanSession is set to 1
  if ((typeof clientId === "string" || Buffer.isBuffer(clientId)) &&
     (clientId || protocolVersion == 4) &&
     (clientId || clean)) {

    length += clientId.length + 2
  } else {

    if(protocolVersion < 4) {

      throw new Error('clientId must be supplied before 3.1.1');
    }

    if(clean == 0) {

      throw new Error('clientId must be given if cleanSession set to 0');
    }
  }

  // Must be a two byte number
  if ('number' !== typeof keepalive ||
      keepalive < 0 ||
      keepalive > 65535) {
    throw new Error('Invalid keepalive')
  } else {
    length += 2
  }

  // Connect flags
  length += 1

  // If will exists...
  if (will) {
    // It must be an object
    if ('object' !== typeof will) {
      throw new Error('Invalid will')
    }
    // It must have topic typeof string
    if (!will.topic || 'string' !== typeof will.topic) {
      throw new Error('Invalid will topic')
    } else {
      length += Buffer.byteLength(will.topic) + 2
    }

    // Payload
    if (will.payload && will.payload) {
      if (will.payload.length >= 0) {
        if ('string' === typeof will.payload) {
          length += Buffer.byteLength(will.payload) + 2
        } else {
          length += will.payload.length + 2
        }
      } else {
        throw new Error('Invalid will payload')
      }
    } else {
      length += 2
    }
  }

  // Username
  if (username) {
    if (username.length) {
      length += Buffer.byteLength(username) + 2
    } else {
      throw new Error('Invalid username')
    }
  }

  // Password
  if (password) {
    if (password.length) {
      length += byteLength(password) + 2
    } else {
      throw new Error('Invalid password')
    }
  }

  var buffer = new Buffer(1 + calcLengthLength(length) + length)
    , pos = 0

  // Generate header
  buffer.writeUInt8(protocol.codes['connect'] << protocol.CMD_SHIFT, pos++, true)

  // Generate length
  pos += writeLength(buffer, pos, length)

  // Generate protocol ID
  pos += writeStringOrBuffer(buffer, pos, protocolId)
  buffer.writeUInt8(protocolVersion, pos++, true)

  // Connect flags
  var flags = 0
  flags |= username ? protocol.USERNAME_MASK : 0
  flags |= password ? protocol.PASSWORD_MASK : 0
  flags |= (will && will.retain) ? protocol.WILL_RETAIN_MASK : 0
  flags |= (will && will.qos) ?
    will.qos << protocol.WILL_QOS_SHIFT : 0
  flags |= will ? protocol.WILL_FLAG_MASK : 0
  flags |= clean ? protocol.CLEAN_SESSION_MASK : 0

  buffer.writeUInt8(flags, pos++, true)

  // Keepalive
  pos += writeNumber(buffer, pos, keepalive)

  // Client ID
  pos += writeStringOrBuffer(buffer, pos, clientId)

  // Will
  if (will) {
  	pos += writeString(buffer, pos, will.topic)
    pos += writeStringOrBuffer(buffer, pos, will.payload)
  }

  // Username and password
  if (username)
    pos += writeStringOrBuffer(buffer, pos, username)

  if (password)
    pos += writeStringOrBuffer(buffer, pos, password)

  return buffer
}

function connack(opts) {
  var opts = opts || {}
    , rc = opts.returnCode;

  // Check return code
  if ('number' !== typeof rc)
    throw new Error('Invalid return code');

  var buffer = new Buffer(4)
    , pos = 0;

  buffer.writeUInt8(protocol.codes['connack'] << protocol.CMD_SHIFT, pos++, true);
  pos += writeLength(buffer, pos, 2);
  buffer.writeUInt8(opts.sessionPresent && protocol.SESSIONPRESENT_MASK || 0, pos++, true);
  buffer.writeUInt8(rc, pos++, true);

  return buffer;
}

function publish(opts) {
  var opts = opts || {}
    , dup = opts.dup ? protocol.DUP_MASK : 0
    , qos = opts.qos
    , retain = opts.retain ? protocol.RETAIN_MASK : 0
    , topic = opts.topic
    , payload = opts.payload || empty
    , id = opts.messageId;

  var length = 0;

  // Topic must be a non-empty string or Buffer
  if (typeof topic === "string")
    length += Buffer.byteLength(topic) + 2;
  else if (Buffer.isBuffer(topic))
    length += topic.length + 2;
  else
    throw new Error('Invalid topic');

  // get the payload length
  if (!Buffer.isBuffer(payload)) {
    length += Buffer.byteLength(payload);
  } else {
    length += payload.length;
  }

  // Message id must a number if qos > 0
  if (qos && 'number' !== typeof id) {
    throw new Error('Invalid message id')
  } else if (qos) {
    length += 2;
  }

  var buffer = new Buffer(1 + calcLengthLength(length) + length)
    , pos = 0;

  // Header
  buffer.writeUInt8(
    protocol.codes['publish'] << protocol.CMD_SHIFT |
    dup |
    qos << protocol.QOS_SHIFT |
    retain, pos++, true);

  // Remaining length
  pos += writeLength(buffer, pos, length);

  // Topic
  pos += writeStringOrBuffer(buffer, pos, topic);

  // Message ID
  if (qos > 0) {
    pos += writeNumber(buffer, pos, id);
  }

  // Payload
  if (!Buffer.isBuffer(payload)) {
    writeStringNoPos(buffer, pos, payload);
  } else {
    writeBuffer(buffer, pos, payload);
  }

  return buffer;
}

/* Puback, pubrec, pubrel and pubcomp */
function confirmation(opts) {
  var opts = opts || {}
    , type = opts.cmd || 'puback'
    , id = opts.messageId
    , dup = (opts.dup && type === 'pubrel') ? protocol.DUP_MASK : 0
    , qos = 0

  if (type === 'pubrel')
    qos = 1

  // Check message ID
  if ('number' !== typeof id)
    throw new Error('Invalid message id');

  var buffer = new Buffer(4)
    , pos = 0;

  // Header
  buffer[pos++] =
    protocol.codes[type] << protocol.CMD_SHIFT |
    dup |
    qos << protocol.QOS_SHIFT;

  // Length
  pos += writeLength(buffer, pos, 2);

  // Message ID
  pos += writeNumber(buffer, pos, id);

  return buffer;
}

function subscribe(opts) {
  var opts = opts || {}
    , dup = opts.dup ? protocol.DUP_MASK : 0
    , qos = opts.qos || 0
    , id = opts.messageId
    , subs = opts.subscriptions;

  var length = 0;

  // Check mid
  if ('number' !== typeof id) {
    throw new Error('Invalid message id');
  } else {
    length += 2;
  }
  // Check subscriptions
  if ('object' === typeof subs && subs.length) {
    for (var i = 0; i < subs.length; i += 1) {
      var topic = subs[i].topic
        , qos = subs[i].qos;

      if ('string' !== typeof topic) {
        throw new Error('Invalid subscriptions - invalid topic');
      }
      if ('number' !== typeof qos) {
        throw new Error('Invalid subscriptions - invalid qos');
      }

      length += Buffer.byteLength(topic) + 2 + 1;
    }
  } else {
    throw new Error('Invalid subscriptions');
  }

  var buffer = new Buffer(1 + calcLengthLength(length) + length)
    , pos = 0;

  // Generate header
  buffer.writeUInt8(
    protocol.codes['subscribe'] << protocol.CMD_SHIFT |
    dup |
    1 << protocol.QOS_SHIFT, pos++, true);

  // Generate length
  pos += writeLength(buffer, pos, length);

  // Generate message ID
  pos += writeNumber(buffer, pos, id);

  // Generate subs
  for (var i = 0; i < subs.length; i++) {
    var sub = subs[i]
      , topic = sub.topic
      , qos = sub.qos;

    // Write topic string
    pos += writeString(buffer, pos, topic);
    // Write qos
    buffer.writeUInt8(qos, pos++, true);
  }

  return buffer;
}

function suback(opts) {
  var opts = opts || {}
    , id = opts.messageId
    , granted = opts.granted;

  var length = 0;

  // Check message id
  if ('number' !== typeof id) {
    throw new Error('Invalid message id');
  } else {
    length += 2;
  }
  // Check granted qos vector
  if ('object' === typeof granted && granted.length) {
    for (var i = 0; i < granted.length; i += 1) {
      if ('number' !== typeof granted[i]) {
        throw new Error('Invalid qos vector');
      }
      length += 1;
    }
  } else {
    throw new Error('Invalid qos vector');
  }

  var buffer = new Buffer(1 + calcLengthLength(length) + length)
    , pos = 0;

  // Header
  buffer.writeUInt8(protocol.codes['suback'] << protocol.CMD_SHIFT, pos++, true);

  // Length
  pos += writeLength(buffer, pos, length);

  // Message ID
  pos += writeNumber(buffer, pos, id);

  // Subscriptions
  for (var i = 0; i < granted.length; i++) {
    buffer.writeUInt8(granted[i], pos++, true);
  }

  return buffer;
}

function unsubscribe(opts) {
  var opts = opts || {}
    , id = opts.messageId
    , dup = opts.dup ? protocol.DUP_MASK : 0
    , unsubs = opts.unsubscriptions;

  var length = 0;

  // Check message id
  if ('number' !== typeof id) {
    throw new Error('Invalid message id');
  } else {
    length += 2;
  }
  // Check unsubs
  if ('object' === typeof unsubs && unsubs.length) {
    for (var i = 0; i < unsubs.length; i += 1) {
      if ('string' !== typeof unsubs[i]) {
        throw new Error('Invalid unsubscriptions');
      }
      length += Buffer.byteLength(unsubs[i]) + 2;
    }
  } else {
    throw new Error('Invalid unsubscriptions');
  }

  var buffer = new Buffer(1 + calcLengthLength(length) + length)
    , pos = 0;

  // Header
  buffer[pos++] =
    protocol.codes['unsubscribe'] << protocol.CMD_SHIFT |
    dup |
    1 << protocol.QOS_SHIFT;

  // Length
  pos += writeLength(buffer, pos, length);

  // Message ID
  pos += writeNumber(buffer, pos, id);

  // Unsubs
  for (var i = 0; i < unsubs.length; i++) {
    pos += writeString(buffer, pos, unsubs[i]);
  }

  return buffer;
}

function emptyPacket(opts) {
  var buf = new Buffer(2);
  buf[0] = protocol.codes[opts.cmd] << 4;
  buf[1] = 0;
  return buf;
}

/**
 * calcLengthLength - calculate the length of the remaining
 * length field
 *
 * @api private
 */
function calcLengthLength(length) {
  if (length >= 0 && length < 128) {
    return 1
  } else if (length >= 128 && length < 16384) {
    return 2
  } else if (length >= 16384 && length < 2097152) {
    return 3
  } else if (length >= 2097152 && length < 268435456) {
    return 4
  } else {
    return 0
  }
}

/**
 * writeLength - write an MQTT style length field to the buffer
 *
 * @param <Buffer> buffer - destination
 * @param <Number> pos - offset
 * @param <Number> length - length (>0)
 * @returns <Number> number of bytes written
 *
 * @api private
 */

function writeLength(buffer, pos, length) {
  var digit = 0
    , origPos = pos

  do {
    digit = length % 128 | 0
    length = length / 128 | 0
    if (length > 0) {
        digit = digit | 0x80
    }
    buffer.writeUInt8(digit, pos++, true)
  } while (length > 0)

  return pos - origPos
}

/**
 * writeString - write a utf8 string to the buffer
 *
 * @param <Buffer> buffer - destination
 * @param <Number> pos - offset
 * @param <String> string - string to write
 * @return <Number> number of bytes written
 *
 * @api private
 */

function writeString(buffer, pos, string) {
  var strlen = Buffer.byteLength(string)
  writeNumber(buffer, pos, strlen)

  writeStringNoPos(buffer, pos + 2, string)

  return strlen + 2
}

function writeStringNoPos(buffer, pos, string) {
  buffer.write(string, pos)
}

/**
 * write_buffer - write buffer to buffer
 *
 * @param <Buffer> buffer - dest buffer
 * @param <Number> pos - offset
 * @param <Buffer> src - source buffer
 * @return <Number> number of bytes written
 *
 * @api private
 */

function writeBuffer(buffer, pos, src) {
  src.copy(buffer, pos)
  return src.length
}

/**
 * writeNumber - write a two byte number to the buffer
 *
 * @param <Buffer> buffer - destination
 * @param <Number> pos - offset
 * @param <String> number - number to write
 * @return <Number> number of bytes written
 *
 * @api private
 */
function writeNumber(buffer, pos, number) {
  buffer.writeUInt8(number >> 8, pos, true)
  buffer.writeUInt8(number & 0x00FF, pos + 1, true)

  return 2
}

/**
 * writeStringOrBuffer - write a String or Buffer with the its length prefix
 *
 * @param <Buffer> buffer - destination
 * @param <Number> pos - offset
 * @param <String> toWrite - String or Buffer
 * @return <Number> number of bytes written
 */
function writeStringOrBuffer(buffer, pos, toWrite) {
  var written = 0

  if (toWrite && typeof toWrite === 'string') {
    written += writeString(buffer, pos + written, toWrite)
  } else if (toWrite) {
    written += writeNumber(buffer, pos + written, toWrite.length)
    written += writeBuffer(buffer, pos + written, toWrite)
  } else {
    written += writeNumber(buffer, pos + written, 0)
  }

  return written
}

function byteLength(bufOrString) {
  if (Buffer.isBuffer(bufOrString)) {
    return bufOrString.length
  } else {
    return Buffer.byteLength(bufOrString)
  }
}

module.exports = generate

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ReInterval (callback, interval, args) {
  var self = this;

  this._callback = callback;
  this._args = args;

  this._interval = setInterval(callback, interval, this._args);

  this.reschedule = function (interval) {
    // if no interval entered, use the interval passed in on creation
    if (!interval)
      interval = self._interval;

    if (self._interval)
      clearInterval(self._interval);
    self._interval = setInterval(self._callback, interval, self._args);
  };

  this.clear = function () {
    if (self._interval) {
      clearInterval(self._interval);
      self._interval = undefined;
    }
  };
  
  this.destroy = function () {
    if (self._interval) {
      clearInterval(self._interval);
    }
    self._callback = undefined;
    self._interval = undefined;
    self._args = undefined;
  };
}

function reInterval () {
  if (typeof arguments[0] !== 'function')
    throw new Error('callback needed');
  if (typeof arguments[1] !== 'number')
    throw new Error('interval needed');

  var args;

  if (arguments.length > 0) {
    args = new Array(arguments.length - 2);

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i + 2];
    }
  }

  return new ReInterval(arguments[0], arguments[1], args);
}

module.exports = reInterval;


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(124)(module), __webpack_require__(65)))

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(1136);
exports.encode = exports.stringify = __webpack_require__(1137);


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 1138 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var Transform = __webpack_require__(483).Transform
  , inherits  = __webpack_require__(222).inherits
  , xtend     = __webpack_require__(479)

function DestroyableTransform(opts) {
  Transform.call(this, opts)
  this._destroyed = false
}

inherits(DestroyableTransform, Transform)

DestroyableTransform.prototype.destroy = function(err) {
  if (this._destroyed) return
  this._destroyed = true
  
  var self = this
  process.nextTick(function() {
    if (err)
      self.emit('error', err)
    self.emit('close')
  })
}

// a noop _transform function
function noop (chunk, enc, callback) {
  callback(null, chunk)
}


// create a new export function, used by both the main export and
// the .ctor export, contains common logic for dealing with arguments
function through2 (construct) {
  return function (options, transform, flush) {
    if (typeof options == 'function') {
      flush     = transform
      transform = options
      options   = {}
    }

    if (typeof transform != 'function')
      transform = noop

    if (typeof flush != 'function')
      flush = null

    return construct(options, transform, flush)
  }
}


// main export, just make me a transform stream!
module.exports = through2(function (options, transform, flush) {
  var t2 = new DestroyableTransform(options)

  t2._transform = transform

  if (flush)
    t2._flush = flush

  return t2
})


// make me a reusable prototype that I can `new`, or implicitly `new`
// with a constructor call
module.exports.ctor = through2(function (options, transform, flush) {
  function Through2 (override) {
    if (!(this instanceof Through2))
      return new Through2(override)

    this.options = xtend(options, override)

    DestroyableTransform.call(this, this.options)
  }

  inherits(Through2, DestroyableTransform)

  Through2.prototype._transform = transform

  if (flush)
    Through2.prototype._flush = flush

  return Through2
})


module.exports.obj = through2(function (options, transform, flush) {
  var t2 = new DestroyableTransform(xtend({ objectMode: true, highWaterMark: 16 }, options))

  t2._transform = transform

  if (flush)
    t2._flush = flush

  return t2
})

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(484);

/*<replacement>*/
var util = Object.create(__webpack_require__(87));
util.inherits = __webpack_require__(79);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, process) {var stream = __webpack_require__(483)
var eos = __webpack_require__(472)
var inherits = __webpack_require__(79)
var shift = __webpack_require__(1143)

var SIGNAL_FLUSH = (Buffer.from && Buffer.from !== Uint8Array.from)
  ? Buffer.from([0])
  : new Buffer([0])

var onuncork = function(self, fn) {
  if (self._corked) self.once('uncork', fn)
  else fn()
}

var autoDestroy = function (self, err) {
  if (self._autoDestroy) self.destroy(err)
}

var destroyer = function(self, end) {
  return function(err) {
    if (err) autoDestroy(self, err.message === 'premature close' ? null : err)
    else if (end && !self._ended) self.end()
  }
}

var end = function(ws, fn) {
  if (!ws) return fn()
  if (ws._writableState && ws._writableState.finished) return fn()
  if (ws._writableState) return ws.end(fn)
  ws.end()
  fn()
}

var toStreams2 = function(rs) {
  return new (stream.Readable)({objectMode:true, highWaterMark:16}).wrap(rs)
}

var Duplexify = function(writable, readable, opts) {
  if (!(this instanceof Duplexify)) return new Duplexify(writable, readable, opts)
  stream.Duplex.call(this, opts)

  this._writable = null
  this._readable = null
  this._readable2 = null

  this._autoDestroy = !opts || opts.autoDestroy !== false
  this._forwardDestroy = !opts || opts.destroy !== false
  this._forwardEnd = !opts || opts.end !== false
  this._corked = 1 // start corked
  this._ondrain = null
  this._drained = false
  this._forwarding = false
  this._unwrite = null
  this._unread = null
  this._ended = false

  this.destroyed = false

  if (writable) this.setWritable(writable)
  if (readable) this.setReadable(readable)
}

inherits(Duplexify, stream.Duplex)

Duplexify.obj = function(writable, readable, opts) {
  if (!opts) opts = {}
  opts.objectMode = true
  opts.highWaterMark = 16
  return new Duplexify(writable, readable, opts)
}

Duplexify.prototype.cork = function() {
  if (++this._corked === 1) this.emit('cork')
}

Duplexify.prototype.uncork = function() {
  if (this._corked && --this._corked === 0) this.emit('uncork')
}

Duplexify.prototype.setWritable = function(writable) {
  if (this._unwrite) this._unwrite()

  if (this.destroyed) {
    if (writable && writable.destroy) writable.destroy()
    return
  }

  if (writable === null || writable === false) {
    this.end()
    return
  }

  var self = this
  var unend = eos(writable, {writable:true, readable:false}, destroyer(this, this._forwardEnd))

  var ondrain = function() {
    var ondrain = self._ondrain
    self._ondrain = null
    if (ondrain) ondrain()
  }

  var clear = function() {
    self._writable.removeListener('drain', ondrain)
    unend()
  }

  if (this._unwrite) process.nextTick(ondrain) // force a drain on stream reset to avoid livelocks

  this._writable = writable
  this._writable.on('drain', ondrain)
  this._unwrite = clear

  this.uncork() // always uncork setWritable
}

Duplexify.prototype.setReadable = function(readable) {
  if (this._unread) this._unread()

  if (this.destroyed) {
    if (readable && readable.destroy) readable.destroy()
    return
  }

  if (readable === null || readable === false) {
    this.push(null)
    this.resume()
    return
  }

  var self = this
  var unend = eos(readable, {writable:false, readable:true}, destroyer(this))

  var onreadable = function() {
    self._forward()
  }

  var onend = function() {
    self.push(null)
  }

  var clear = function() {
    self._readable2.removeListener('readable', onreadable)
    self._readable2.removeListener('end', onend)
    unend()
  }

  this._drained = true
  this._readable = readable
  this._readable2 = readable._readableState ? readable : toStreams2(readable)
  this._readable2.on('readable', onreadable)
  this._readable2.on('end', onend)
  this._unread = clear

  this._forward()
}

Duplexify.prototype._read = function() {
  this._drained = true
  this._forward()
}

Duplexify.prototype._forward = function() {
  if (this._forwarding || !this._readable2 || !this._drained) return
  this._forwarding = true

  var data

  while (this._drained && (data = shift(this._readable2)) !== null) {
    if (this.destroyed) continue
    this._drained = this.push(data)
  }

  this._forwarding = false
}

Duplexify.prototype.destroy = function(err) {
  if (this.destroyed) return
  this.destroyed = true

  var self = this
  process.nextTick(function() {
    self._destroy(err)
  })
}

Duplexify.prototype._destroy = function(err) {
  if (err) {
    var ondrain = this._ondrain
    this._ondrain = null
    if (ondrain) ondrain(err)
    else this.emit('error', err)
  }

  if (this._forwardDestroy) {
    if (this._readable && this._readable.destroy) this._readable.destroy()
    if (this._writable && this._writable.destroy) this._writable.destroy()
  }

  this.emit('close')
}

Duplexify.prototype._write = function(data, enc, cb) {
  if (this.destroyed) return cb()
  if (this._corked) return onuncork(this, this._write.bind(this, data, enc, cb))
  if (data === SIGNAL_FLUSH) return this._finish(cb)
  if (!this._writable) return cb()

  if (this._writable.write(data) === false) this._ondrain = cb
  else cb()
}

Duplexify.prototype._finish = function(cb) {
  var self = this
  this.emit('preend')
  onuncork(this, function() {
    end(self._forwardEnd && self._writable, function() {
      // haxx to not emit prefinish twice
      if (self._writableState.prefinished === false) self._writableState.prefinished = true
      self.emit('prefinish')
      onuncork(self, cb)
    })
  })
}

Duplexify.prototype.end = function(data, enc, cb) {
  if (typeof data === 'function') return this.end(null, null, data)
  if (typeof enc === 'function') return this.end(data, null, enc)
  this._ended = true
  if (data) this.write(data)
  if (!this._writableState.ending) this.write(SIGNAL_FLUSH)
  return stream.Writable.prototype.end.call(this, cb)
}

module.exports = Duplexify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer, __webpack_require__(55)))

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

module.exports = shift

function shift (stream) {
  var rs = stream._readableState
  if (!rs) return null
  return (rs.objectMode || typeof stream._duplexState === 'number') ? stream.read() : stream.read(getStateLength(rs))
}

function getStateLength (state) {
  if (state.buffer.length) {
    var idx = state.bufferIndex || 0
    // Since node 6.3.0 state.buffer is a BufferList not an array
    if (state.buffer.head) {
      return state.buffer.head.data.length
    } else if (state.buffer.length - idx > 0 && state.buffer[idx]) {
      return state.buffer[idx].length
    }
  }

  return state.length
}


/***/ }),
/* 1144 */
/***/ (function(module, exports) {


var ws = null

if (typeof WebSocket !== 'undefined') {
  ws = WebSocket
} else if (typeof MozWebSocket !== 'undefined') {
  ws = MozWebSocket
} else {
  ws = window.WebSocket || window.MozWebSocket
}

module.exports = ws


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(225), __webpack_require__(1146), __webpack_require__(1147), __webpack_require__(145), __webpack_require__(146), __webpack_require__(295), __webpack_require__(485), __webpack_require__(1148), __webpack_require__(486), __webpack_require__(1149), __webpack_require__(1150), __webpack_require__(1151), __webpack_require__(296), __webpack_require__(1152), __webpack_require__(147), __webpack_require__(67), __webpack_require__(1153), __webpack_require__(1154), __webpack_require__(1155), __webpack_require__(1156), __webpack_require__(1157), __webpack_require__(1158), __webpack_require__(1159), __webpack_require__(1160), __webpack_require__(1161), __webpack_require__(1162), __webpack_require__(1163), __webpack_require__(1164), __webpack_require__(1165), __webpack_require__(1166), __webpack_require__(1167), __webpack_require__(1168));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS;

}));

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	return CryptoJS.enc.Utf16;

}));

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(485));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	return CryptoJS.SHA224;

}));

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(225), __webpack_require__(486));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./sha512"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	return CryptoJS.SHA384;

}));

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(225));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	return CryptoJS.RIPEMD160;

}));

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(295), __webpack_require__(296));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.PBKDF2;

}));

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            var keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            var keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	return CryptoJS.mode.CFB;

}));

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	return CryptoJS.mode.CTR;

}));

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	return CryptoJS.mode.CTRGladman;

}));

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	return CryptoJS.mode.OFB;

}));

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Ansix923;

}));

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Iso10126;

}));

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	return CryptoJS.pad.Iso97971;

}));

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	            i--;
	        }
	        data.sigBytes = i + 1;
	    }
	};


	return CryptoJS.pad.ZeroPadding;

}));

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	return CryptoJS.pad.NoPadding;

}));

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	return CryptoJS.format.Hex;

}));

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(145), __webpack_require__(146), __webpack_require__(147), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(145), __webpack_require__(146), __webpack_require__(147), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
	            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
	            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	return CryptoJS.TripleDES;

}));

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(145), __webpack_require__(146), __webpack_require__(147), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	return CryptoJS.RC4;

}));

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(145), __webpack_require__(146), __webpack_require__(147), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	return CryptoJS.Rabbit;

}));

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(37), __webpack_require__(145), __webpack_require__(146), __webpack_require__(147), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	return CryptoJS.RabbitLegacy;

}));

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps

//npm deps

//app deps

//begin module
module.exports = {
   INVALID_CONNECT_OPTIONS: 'Invalid connect options supplied.',
   INVALID_CLIENT_ID_OPTION: 'Invalid "clientId" (mqtt client id) option supplied.',
   INVALID_RECONNECT_TIMING: 'Invalid reconnect timing options supplied.',
   INVALID_OFFLINE_QUEUEING_PARAMETERS: 'Invalid offline queueing options supplied.'
};


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps
const filesys = __webpack_require__(487);

//npm deps

//app deps
const isUndefined = __webpack_require__(297);
const exceptions = __webpack_require__(1171);

//begin module
/**
 * This method is the exposed module; it validates and prepares the tls
 * options as required for connection to the AWS IoT service.
 *
 * @param {Object} options
 * @access public
 */
module.exports = function(options) {

   // verify certificate paths
   if (isUndefined(options.keyPath) && isUndefined(options.privateKey)) {
      throw new Error(exceptions.NO_KEY_OPTION);
   }
   if (isUndefined(options.certPath) && isUndefined(options.clientCert)) {
      throw new Error(exceptions.NO_CERT_OPTION);
   }
   if (isUndefined(options.caPath) && isUndefined(options.caCert)) {
      throw new Error(exceptions.NO_CA_OPTION);
   }
   //
   // Certificates and private keys may be passed in files using options
   // ending in 'Path', e.g. 'keyPath', 'certPath', and 'caPath'.  In addition,
   // they can also be passed in as buffers or files using the options
   // 'privateKey', 'clientCert', and 'caCert'.  This second set is the one
   // that the AWS Console generates a JSON configuration document for.
   //
   if (!isUndefined(options.caCert)) {
      if (Buffer.isBuffer(options.caCert)) {
         options.ca = options.caCert;
      } else {
         if (filesys.existsSync(options.caCert)) {
            options.ca = filesys.readFileSync(options.caCert);
         } else {
            throw new Error(exceptions.INVALID_CA_CERT_OPTION);
         }
      }
   }
   if (!isUndefined(options.privateKey)) {
      if (Buffer.isBuffer(options.privateKey)) {
         options.key = options.privateKey;
      } else {
         if (filesys.existsSync(options.privateKey)) {
            options.key = filesys.readFileSync(options.privateKey);
         } else {
            throw new Error(exceptions.INVALID_PRIVATE_KEY_OPTION);
         }
      }
   }
   if (!isUndefined(options.clientCert)) {
      if (Buffer.isBuffer(options.clientCert)) {
         options.cert = options.clientCert;
      } else {
         if (filesys.existsSync(options.clientCert)) {
            options.cert = filesys.readFileSync(options.clientCert);
         } else {
            throw new Error(exceptions.INVALID_CLIENT_CERT_OPTION);
         }
      }
   }

   // Parse PEM files.  Options ending in 'Path' must be files
   // and will override options which do not end in 'Path'.

   if (filesys.existsSync(options.keyPath)) {
      options.key = filesys.readFileSync(options.keyPath);
   } else if (!isUndefined(options.keyPath)) {
      throw new Error(exceptions.INVALID_KEY_PATH_OPTION);
   }
   if (filesys.existsSync(options.certPath)) {
      options.cert = filesys.readFileSync(options.certPath);
   } else if (!isUndefined(options.certPath)) {
      throw new Error(exceptions.INVALID_CERT_PATH_OPTION);
   }
   if (filesys.existsSync(options.caPath)) {
      options.ca = filesys.readFileSync(options.caPath);
   } else if (!isUndefined(options.caPath)) {
      throw new Error(exceptions.INVALID_CA_PATH_OPTION);
   }

   // request certificate from partner
   options.requestCert = true;

   // require certificate authentication
   options.rejectUnauthorized = true;

};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19).Buffer))

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps

//npm deps

//app deps

//begin module
module.exports = {
   NO_KEY_OPTION: 'No "keyPath" or "privateKey" option supplied.',
   NO_CERT_OPTION: 'No "certPath" or "clientCert" option supplied.',
   NO_CA_OPTION: 'No "caPath" or "caCert" option supplied.',
   INVALID_KEY_PATH_OPTION: 'Invalid "keyPath" option supplied.',
   INVALID_CERT_PATH_OPTION: 'Invalid "certPath" option supplied.',
   INVALID_CA_PATH_OPTION: 'Invalid "caPath" option supplied.',
   INVALID_CLIENT_CERT_OPTION: 'Invalid "clientCert" option supplied.',
   INVALID_PRIVATE_KEY_OPTION: 'Invalid "privateKey" option supplied.',
   INVALID_CA_CERT_OPTION: 'Invalid "caCert" option supplied.'
};


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps
var tls = __webpack_require__(487);

//npm deps

//app deps

function buildBuilder(mqttClient, opts) {
   var connection;

   connection = tls.connect(opts);

   function handleTLSerrors(err) {
      mqttClient.emit('error', err);
      connection.end();
   }

   connection.on('secureConnect', function() {
      if (!connection.authorized) {
         connection.emit('error', new Error('TLS not authorized'));
      } else {
         connection.removeListener('error', handleTLSerrors);
      }
   });

   connection.on('error', handleTLSerrors);
   return connection;
}

module.exports = buildBuilder;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps

//npm deps
const websocket = __webpack_require__(482);

//app deps

function buildBuilder(client, opts) {
   return websocket(opts.url, ['mqttv3.1'], opts.websocketOptions);
}

module.exports = buildBuilder;


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright 2010-2015 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

//node.js deps
const events = __webpack_require__(84);
const inherits = __webpack_require__(222).inherits;

//npm deps

//app deps
const deviceModule = __webpack_require__(467);
const isUndefined = __webpack_require__(297);

//
// private functions
//
function buildThingShadowTopic(thingName, operation, type) {
   if (!isUndefined(type)) {
      return '$aws/things/' + thingName + '/shadow/' + operation + '/' + type;
   }
   return '$aws/things/' + thingName + '/shadow/' + operation;
}

function isReservedTopic(topic) {
   if (topic.substring(0, 12) === '$aws/things/') {
      return true;
   }
   return false;
}

function isThingShadowTopic(topicTokens, direction) {
   var rc = false;
   if (topicTokens[0] === '$aws') {
      //
      // Thing shadow topics have the form:
      //
      //      $aws/things/{thingName}/shadow/{Operation}/{Status}
      //
      // Where {Operation} === update|get|delete
      //   And    {Status} === accepted|rejected|delta
      //
      if ((topicTokens[1] === 'things') &&
         (topicTokens[3] === 'shadow') &&
         ((topicTokens[4] === 'update') ||
            (topicTokens[4] === 'get') ||
            (topicTokens[4] === 'delete'))) {
         //
         // Looks good so far; now check the direction and see if
         // still makes sense.
         //
         if (direction === 'subscribe') {
            if (((topicTokens[5] === 'accepted') ||
                  (topicTokens[5] === 'rejected') ||
                  (topicTokens[5] === 'delta')) &&
               (topicTokens.length === 6)) {
               rc = true;
            }
         } else // direction === 'publish'
         {
            if (topicTokens.length === 5) {
               rc = true;
            }
         }
      }
   }
   return rc;
}

//begin module

function ThingShadowsClient(deviceOptions, thingShadowOptions) {
   //
   // Force instantiation using the 'new' operator; this will cause inherited
   // constructors (e.g. the 'events' class) to be called.
   //
   if (!(this instanceof ThingShadowsClient)) {
      return new ThingShadowsClient(deviceOptions, thingShadowOptions);
   }

   //
   // A copy of 'this' for use inside of closures
   //
   var that = this;

   //
   // Track Thing Shadow registrations in here.
   //
   var thingShadows = [{}];

   //
   // Implements for every operation, used to construct clientToken.
   //
   var operationCount = 0;

   //
   // Operation timeout (milliseconds).  If no accepted or rejected response
   // to a thing operation is received within this time, subscriptions
   // to the accepted and rejected sub-topics for a thing are cancelled.
   //
   var operationTimeout = 10000; /* milliseconds */

   //
   // Variable used by the testing API setConnectionStatus() to simulate
   // network connectivity failures.
   //
   var connected = true;

   //
   // Instantiate the device.
   //
   const device = deviceModule.DeviceClient(deviceOptions);

   if (!isUndefined(thingShadowOptions)) {
      if (!isUndefined(thingShadowOptions.operationTimeout)) {
         operationTimeout = thingShadowOptions.operationTimeout;
      }
   }

   //
   // Private function to subscribe and unsubscribe from topics.
   //
   this._handleSubscriptions = function(thingName, topicSpecs, devFunction, callback) {
      var topics = [];

      //
      // Build an array of topic names.
      //
      for (var i = 0, topicsLen = topicSpecs.length; i < topicsLen; i++) {
         for (var j = 0, opsLen = topicSpecs[i].operations.length; j < opsLen; j++) {
            for (var k = 0, statLen = topicSpecs[i].statii.length; k < statLen; k++) {
               topics.push(buildThingShadowTopic(thingName,
                  topicSpecs[i].operations[j],
                  topicSpecs[i].statii[k]));
            }
         }
      }

      if (thingShadows[thingName].debug === true) {
         console.log(devFunction + ' on ' + topics);
      }
      //
      // Subscribe/unsubscribe from the topics and perform callback when complete.
      //
      var args = [];
      args.push(topics);
      if (devFunction === 'subscribe') {
         // QoS only applicable for subscribe
         args.push({
            qos: thingShadows[thingName].qos
         });
         // add our callback to check the SUBACK response for granted subscriptions
         args.push(function(err, granted) {
            if (!isUndefined(callback)) {
               if (err) {
                  callback(err);
                  return;
               }
               //
               // Check to see if we got all topic subscriptions granted.
               //
               var failedTopics = [];
               for (var k = 0, grantedLen = granted.length; k < grantedLen; k++) {
                  //
                  // 128 is 0x80 - Failure from the MQTT lib.
                  //
                  if (granted[k].qos === 128) {
                     failedTopics.push(granted[k]);
                  }
               }

               if (failedTopics.length > 0) {
                  callback('Not all subscriptions were granted', failedTopics);
                  return;
               }

               // all subscriptions were granted
               callback();
            }
         });
      } else {
         if (!isUndefined(callback)) {
            args.push(callback);
         }
      }

      device[devFunction].apply(device, args);
   };

   //
   // Private function to handle messages and dispatch them accordingly.
   //
   this._handleMessages = function(thingName, operation, operationStatus, payload) {
      var stateObject = {};
      try {
         stateObject = JSON.parse(payload.toString());
      } catch (err) {
         if (deviceOptions.debug === true) {
            console.error('failed parsing JSON \'' + payload.toString() + '\', ' + err);
         }
         return;
      }
      var clientToken = stateObject.clientToken;
      var version = stateObject.version;
      //
      // Remove the properties 'clientToken' and 'version' from the stateObject;
      // these properties are internal to this class.
      //
      delete stateObject.clientToken;
      delete stateObject.version;
      //
      // Update the thing version on every accepted or delta message which 
      // contains it.
      //
      if ((!isUndefined(version)) && (operationStatus !== 'rejected')) {
         //
         // The thing shadow version is incremented by AWS IoT and should always
         // increase.  Do not update our local version if the received version is
         // less than our version.  
         //
         if ((isUndefined(thingShadows[thingName].version)) ||
            (version >= thingShadows[thingName].version)) {
            thingShadows[thingName].version = version;
         } else {
            //
            // We've received a message from AWS IoT with a version number lower than
            // we would expect.  There are two things that can cause this:
            //
            //  1) The shadow has been deleted (version # reverts to 1 in this case.)
            //  2) The message has arrived out-of-order.
            //
            // For case 1) we can look at the operation to determine that this
            // is the case and notify the client if appropriate.  For case 2, 
            // we will not process it unless the client has specifically expressed
            // an interested in these messages by setting 'discardStale' to false.
            //
            if (operation !== 'delete' && thingShadows[thingName].discardStale === true) {
               if (deviceOptions.debug === true) {
                  console.warn('out-of-date version \'' + version + '\' on \'' +
                     thingName + '\' (local version \'' +
                     thingShadows[thingName].version + '\')');
               }
               return;
            }
         }
      }
      //
      // If this is a 'delta' message, emit an event for it and return.
      //
      if (operationStatus === 'delta') {
         this.emit('delta', thingName, stateObject);
         return;
      }
      //
      // only accepted/rejected messages past this point
      // ===============================================
      // If this is an unkown clientToken (e.g., it doesn't have a corresponding
      // client token property, the shadow has been modified by another client.
      // If it's an update/accepted or delete/accepted, update the shadow and
      // notify the client.
      //
      if (isUndefined(thingShadows[thingName].clientToken) ||
         thingShadows[thingName].clientToken !== clientToken) {
         if ((operationStatus === 'accepted') && (operation !== 'get')) {
            //
            // This is a foreign update or delete accepted, update our
            // shadow with the latest state and send a notification.
            //
            this.emit('foreignStateChange', thingName, operation, stateObject);
         }
         return;
      }
      //
      // A response has been received, so cancel any outstanding timeout on this
      // thingName/clientToken, delete the timeout handle, and unsubscribe from
      // all sub-topics.
      //
      clearTimeout(
         thingShadows[thingName].timeout);

      delete thingShadows[thingName].timeout;
      //
      // Delete the operation's client token.
      //
      delete thingShadows[thingName].clientToken;
      //
      // Mark this operation as complete.
      //
      thingShadows[thingName].pending = false;

      //
      // Unsubscribe from the 'accepted' and 'rejected' sub-topics unless we are
      // persistently subscribed to this thing shadow.
      //
      if (thingShadows[thingName].persistentSubscribe === false) {
         this._handleSubscriptions(thingName, [{
            operations: [operation],
            statii: ['accepted', 'rejected']
         }], 'unsubscribe');
      }

      //
      // Emit an event detailing the operation status; the clientToken is included
      // as an argument so that the application can correlate status events to
      // the operations they are associated with.
      //
      this.emit('status', thingName, operationStatus, clientToken, stateObject);
   };

   device.on('connect', function() {
      that.emit('connect');
   });
   device.on('close', function() {
      that.emit('close');
   });
   device.on('reconnect', function() {
      that.emit('reconnect');
   });
   device.on('offline', function() {
      that.emit('offline');
   });
   device.on('error', function(error) {
      that.emit('error', error);
   });
   device.on('message', function(topic, payload) {

      if (connected === true) {
         //
         // Parse the topic to determine what to do with it.
         //
         var topicTokens = topic.split('/');
         //
         // First, do a rough check to see if we should continue or not.
         //
         if (isThingShadowTopic(topicTokens, 'subscribe')) {
            //
            // This looks like a valid Thing topic, so see if the Thing is in the
            // registered Thing table.
            //
            if (thingShadows.hasOwnProperty(topicTokens[2])) {
               //
               // This is a registered Thing, so perform message handling on it.
               //
               that._handleMessages(topicTokens[2], // thingName
                  topicTokens[4], // operation
                  topicTokens[5], // status
                  payload);
            }
            //
            // Any messages received for unregistered Things fall here and are ignored.
            //
         } else {
            //
            // This isn't a Thing topic, so pass it along to the instance if they have
            // indicated they want to handle it.
            //
            that.emit('message', topic, payload);
         }
      }
   });

   this._thingOperation = function(thingName, operation, stateObject) {
      var rc = null;

      if (thingShadows.hasOwnProperty(thingName)) {
         //
         // Don't allow a new operation if an existing one is still in process.
         //
         if (thingShadows[thingName].pending === false) {
            //
            // Starting a new operation
            //
            thingShadows[thingName].pending = true;
            //
            // If not provided, construct a clientToken from the clientId and a rolling 
            // operation count.  The clientToken is transmitted in any published stateObject 
            // and is returned to the caller for each operation.  Applications can use
            // clientToken values to correlate received responses or timeouts with
            // the original operations.
            //
            var clientToken;

            if (isUndefined(stateObject.clientToken)) {
               //
               // AWS IoT restricts client tokens to 64 bytes, so use only the last 48
               // characters of the client ID when constructing a client token.
               //
               var clientIdLength = deviceOptions.clientId.length;

               if (clientIdLength > 48) {
                  clientToken = deviceOptions.clientId.substr(clientIdLength - 48) + '-' + operationCount++;
               } else {
                  clientToken = deviceOptions.clientId + '-' + operationCount++;
               }
            } else {
               clientToken = stateObject.clientToken;
            }
            //
            // Remember the client token for this operation; it will be
            // deleted when the operation completes or times out.
            //
            thingShadows[thingName].clientToken = clientToken;

            var publishTopic = buildThingShadowTopic(thingName,
               operation);
            //
            // Subscribe to the 'accepted' and 'rejected' sub-topics for this get
            // operation and set a timeout beyond which they will be unsubscribed if 
            // no messages have been received for either of them.
            //
            thingShadows[thingName].timeout = setTimeout(
               function(thingName, clientToken) {
                  //
                  // Timed-out.  Unsubscribe from the 'accepted' and 'rejected' sub-topics unless
                  // we are persistently subscribing to this thing shadow.
                  //
                  if (thingShadows[thingName].persistentSubscribe === false) {
                     that._handleSubscriptions(thingName, [{
                        operations: [operation],
                        statii: ['accepted', 'rejected']
                     }], 'unsubscribe');
                  }
                  //
                  // Mark this operation as complete.
                  //
                  thingShadows[thingName].pending = false;
                  //
                  // Emit an event for the timeout; the clientToken is included as an argument
                  // so that the application can correlate timeout events to the operations
                  // they are associated with.
                  //
                  that.emit('timeout', thingName, clientToken);
                  //
                  // Delete the timeout handle and client token for this thingName.
                  //
                  delete thingShadows[thingName].timeout;
                  delete thingShadows[thingName].clientToken;
               }, operationTimeout,
               thingName, clientToken);
            //
            // Subscribe to the 'accepted' and 'rejected' sub-topics unless we are
            // persistently subscribing, in which case we can publish to the topic immediately
            // since we are already subscribed to all applicable sub-topics.
            //
            if (thingShadows[thingName].persistentSubscribe === false) {
               this._handleSubscriptions(thingName, [{
                     operations: [operation],
                     statii: ['accepted', 'rejected'],
                  }], 'subscribe',
                  function(err, failedTopics) {
                     if (!isUndefined(err) || !isUndefined(failedTopics)) {
                        console.warn('failed subscription to accepted/rejected topics');
                        return;
                     }

                     //
                     // If 'stateObject' is defined, publish it to the publish topic for this
                     // thingName+operation.
                     //
                     if (!isUndefined(stateObject)) {
                        //
                        // Add the version # (if known and versioning is enabled) and 
                        // 'clientToken' properties to the stateObject.
                        //
                        if (!isUndefined(thingShadows[thingName].version) &&
                           thingShadows[thingName].enableVersioning) {
                           stateObject.version = thingShadows[thingName].version;
                        }
                        stateObject.clientToken = clientToken;

                        device.publish(publishTopic,
                           JSON.stringify(stateObject), {
                              qos: thingShadows[thingName].qos
                           });
                        if (!(isUndefined(thingShadows[thingName])) &&
                           thingShadows[thingName].debug === true) {
                           console.log('publishing \'' + JSON.stringify(stateObject) +
                              ' on \'' + publishTopic + '\'');
                        }
                     }
                  });
            } else {
               //
               // Add the version # (if known and versioning is enabled) and 
               // 'clientToken' properties to the stateObject.
               //
               if (!isUndefined(thingShadows[thingName].version) &&
                  thingShadows[thingName].enableVersioning) {
                  stateObject.version = thingShadows[thingName].version;
               }
               stateObject.clientToken = clientToken;

               device.publish(publishTopic,
                  JSON.stringify(stateObject), {
                     qos: thingShadows[thingName].qos
                  });
               if (thingShadows[thingName].debug === true) {
                  console.log('publishing \'' + JSON.stringify(stateObject) +
                     ' on \'' + publishTopic + '\'');
               }
            }
            rc = clientToken; // return the clientToken to the caller
         } else {
            if (deviceOptions.debug === true) {
               console.error(operation + ' still in progress on thing: ', thingName);
            }
         }
      } else {
         if (deviceOptions.debug === true) {
            console.error('attempting to ' + operation + ' unknown thing: ', thingName);
         }
      }
      return rc;
   };

   this.register = function(thingName, options, callback) {
      if (!thingShadows.hasOwnProperty(thingName)) {
         //
         // Initialize the registration entry for this thing; because the version # is 
         // not yet known, do not add the property for it yet. The version number 
         // property will be added after the first accepted update from AWS IoT.
         //
         var ignoreDeltas = false;
         var topicSpecs = [];
         thingShadows[thingName] = {
            persistentSubscribe: true,
            debug: false,
            discardStale: true,
            enableVersioning: true,
            qos: 0,
            pending: true
         };

         if (!isUndefined(options)) {
            if (!isUndefined(options.ignoreDeltas)) {
               ignoreDeltas = options.ignoreDeltas;
            }
            if (!isUndefined(options.persistentSubscribe)) {
               thingShadows[thingName].persistentSubscribe = options.persistentSubscribe;
            }
            if (!isUndefined(options.debug)) {
               thingShadows[thingName].debug = options.debug;
            }
            if (!isUndefined(options.discardStale)) {
               thingShadows[thingName].discardStale = options.discardStale;
            }
            if (!isUndefined(options.enableVersioning)) {
               thingShadows[thingName].enableVersioning = options.enableVersioning;
            }
            if (!isUndefined(options.qos)) {
               thingShadows[thingName].qos = options.qos;
            }
         }
         //
         // Always listen for deltas unless requested otherwise.
         //
         if (ignoreDeltas === false) {
            topicSpecs.push({
               operations: ['update'],
               statii: ['delta']
            });
         }
         //
         // If we are persistently subscribing, we subscribe to everything we could ever
         // possibly be interested in.  This will provide us the ability to publish
         // without waiting at the cost of potentially increased irrelevant traffic
         // which the application will need to filter out.
         //
         if (thingShadows[thingName].persistentSubscribe === true) {
            topicSpecs.push({
               operations: ['update', 'get', 'delete'],
               statii: ['accepted', 'rejected']
            });
         }

         if (topicSpecs.length > 0) {
            this._handleSubscriptions(thingName, topicSpecs, 'subscribe', function(err, failedTopics) {
               if (isUndefined(err) && isUndefined(failedTopics)) {
                  thingShadows[thingName].pending = false;
               }
               if (!isUndefined(callback)) {
                  callback(err, failedTopics);
               }
            });
         } else {
            thingShadows[thingName].pending = false;
            if (!isUndefined(callback)) {
               callback();
            }
         }

      } else {
         if (deviceOptions.debug === true) {
            console.error('thing already registered: ', thingName);
         }
      }
   };

   this.unregister = function(thingName) {
      if (thingShadows.hasOwnProperty(thingName)) {
         var topicSpecs = [];

         //
         // If an operation is outstanding, it will have a timeout set; when it
         // expires any accept/reject sub-topic subscriptions for the thing will be 
         // deleted.  If any messages arrive after the thing has been deleted, they
         // will simply be ignored as it no longer exists in the thing registrations.
         // The only sub-topic we need to unsubscribe from is the delta sub-topic,
         // which is always active.
         //
         topicSpecs.push({
            operations: ['update'],
            statii: ['delta']
         });
         //
         // If we are persistently subscribing, we subscribe to everything we could ever
         // possibly be interested in; this means that when it's time to unregister
         // interest in a thing, we need to unsubscribe from all of these topics.
         //
         if (thingShadows[thingName].persistentSubscribe === true) {
            topicSpecs.push({
               operations: ['update', 'get', 'delete'],
               statii: ['accepted', 'rejected']
            });
         }

         this._handleSubscriptions(thingName, topicSpecs, 'unsubscribe');

         //
         // Delete any pending timeout
         //
         if (!isUndefined(thingShadows[thingName].timeout)) {
            clearTimeout(thingShadows[thingName].timeout);
         }
         //
         // Delete the thing from the Thing registrations.
         //
         delete thingShadows[thingName];
      } else {
         if (deviceOptions.debug === true) {
            console.error('attempting to unregister unknown thing: ', thingName);
         }
      }
   };

   //
   // Perform an update operation on the given thing shadow.
   //
   this.update = function(thingName, stateObject) {
      var rc = null;
      //
      // Verify that the message does not contain a property named 'version',
      // as these property is reserved for use within this class.
      //
      if (isUndefined(stateObject.version)) {
         rc = that._thingOperation(thingName, 'update', stateObject);
      } else {
         console.error('message can\'t contain \'version\' property');
      }
      return rc;
   };

   //
   // Perform a get operation on the given thing shadow; allow the user
   // to specify their own client token if they don't want to use the
   // default.
   //
   this.get = function(thingName, clientToken) {
      var stateObject = {};
      if (!isUndefined(clientToken)) {
         stateObject.clientToken = clientToken;
      }
      return that._thingOperation(thingName, 'get', stateObject);
   };

   //
   // Perform a delete operation on the given thing shadow.
   //
   this.delete = function(thingName, clientToken) {
      var stateObject = {};
      if (!isUndefined(clientToken)) {
         stateObject.clientToken = clientToken;
      }
      return that._thingOperation(thingName, 'delete', stateObject);
   };
   //
   // Publish on non-thing topics.
   //
   this.publish = function(topic, message, options, callback) {
      if (!isReservedTopic(topic)) {
         device.publish(topic, message, options, callback);
      } else {
         throw ('cannot publish to reserved topic \'' + topic + '\'');
      }
   };

   //
   // Subscribe to non-thing topics.
   //
   this.subscribe = function(topics, options, callback) {
      var topicsArray = [];
      if (typeof topics === 'string') {
         topicsArray.push(topics);
      } else if (typeof topics === 'object' && topics.length) {
         topicsArray = topics;
      }
      for (var i = 0; i < topicsArray.length; i++) {
         if (isReservedTopic(topicsArray[i])) {
            throw ('cannot subscribe to topic array since one of them is a reserved topic \'' + topicsArray[i] + '\'');
         }
      }
      device.subscribe(topicsArray, options, callback);
   };
   //
   // Unsubscribe from non-thing topics.
   //
   this.unsubscribe = function(topics, callback) {
      var topicsArray = [];
      if (typeof topics === 'string') {
         topicsArray.push(topics);
      } else if (typeof topics === 'object' && topics.length) {
         topicsArray = topics;
      }
      for (var i = 0; i < topicsArray.length; i++) {
         if (isReservedTopic(topicsArray[i])) {
            throw ('cannot unsubscribe from topic array since one of them is a reserved topic \'' + topicsArray[i] + '\'');
         }
      }
      device.unsubscribe(topicsArray, callback);
   };
   //
   // Close the device connection; this will be passed through to
   // the device class.
   //
   this.end = function(force, callback) {
      device.end(force, callback);
   };
   //
   // Call this function to update the credentials used when
   // connecting via WebSocket/SigV4; this will be passed through
   // to the device class.
   //
   this.updateWebSocketCredentials = function(accessKeyId, secretKey, sessionToken, expiration) {
      device.updateWebSocketCredentials(accessKeyId, secretKey, sessionToken, expiration);
   };

   //
   // This is an unpublished API used for testing.
   //
   this.setConnectionStatus = function(connectionStatus) {
      connected = connectionStatus;
   };
   events.EventEmitter.call(this);
}

//
// Allow instances to listen in on events that we produce for them
//
inherits(ThingShadowsClient, events.EventEmitter);

module.exports = ThingShadowsClient;


/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AslDeviceOverviewContext__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modal_AddAslSingleDeviceModal__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__commonui_DeleteSingleDeviceModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commonui_EditMacAddressModal__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__commonui_DisableMonitoringModal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__ = __webpack_require__(91);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AslDeviceOverview=function AslDeviceOverview(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_AslDeviceOverviewContext__["a" /* AslDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_26__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorized=_useContext2.isAuthorized;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState2=_slicedToArray(_useState,2),openActionsMenu=_useState2[0],setOpenActionsMenu=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openAddModal=_useState4[0],setOpenAddModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),openEditMacModal=_useState6[0],setOpenEditMaceModal=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),selected=_useState8[0],setSelected=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),openDeleteModal=_useState10[0],setOpenDeleteModal=_useState10[1];var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),openDisableMonitoringModal=_useState12[0],setOpenDisableMonitoringModal=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),mac=_useState14[0],setMac=_useState14[1];var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=true;setOpenActionsMenu(_open);},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=false;setOpenActionsMenu(_open);},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openAddModal&&!openDeleteModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["D" /* getAssetRefreshInterval */])());var statusInterval=setInterval(function(){if(!document.hidden){getStatusData();}},Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_11" /* getStatusRefreshInterval */])());return function(){clearInterval(interval);clearInterval(statusInterval);};}},[openAddModal,openDeleteModal]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,viewModel.aslDeviceInformation.length);},[viewModel.aslDeviceInformation]);var onSort=function onSort(sortDetails){dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};var sortedDeviceList=Object.values(viewModel.aslDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){var _viewModel$sortPref=viewModel.sortPref,column=_viewModel$sortPref.column,direction=_viewModel$sortPref.direction;var compareValue=void 0;if(Object.keys(__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */]).includes(column)){if(column==="vendor"){compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column]+a.vendorAttributes["spec_version"],b.vendorAttributes[column]+b.vendorAttributes["spec_version"]);}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column],b.vendorAttributes[column]);}}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a[column],b[column]);}if(direction===__WEBPACK_IMPORTED_MODULE_12__util_Constants__["J" /* ASCENDING */]){return compareValue;}else{return-compareValue;}});var updateData=function updateData(stateValues,mac){dispatch({type:'UPDATE_MONITORING_DATA',data:{dispatcher:dispatch,stateValues:stateValues,mac:mac}});};var onClickDisableMonitoring=function onClickDisableMonitoring(mac){setMac(mac);setOpenDisableMonitoringModal(true);};var onClickEnableMonitoring=function onClickEnableMonitoring(startTime,reason,mac){var stateValues={"startTime":startTime,"endTime":Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["I" /* getCurrentDate */])().toString(),"reason":reason};updateData(stateValues,mac);getData();};var renderDeviceMonitoring=function renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{style:{color:monitoringStatusColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:monitoringStatusId,defaultMessage:monitoringStatusDefaultMessage}));};var getData=function getData(){setOpenAddModal(false);setOpenDeleteModal(false);setOpenDisableMonitoringModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var getStatusData=function getStatusData(){dispatch({type:'LOAD_STATUS',data:{dispatcher:dispatch}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var onClickAddEditDevice=function onClickAddEditDevice(){setSelected("");setOpenAddModal(true);};var onClickEditDevice=function onClickEditDevice(mac){setSelected(mac);setOpenAddModal(true);};var onClickRemove=function onClickRemove(mac){setSelected(mac);setOpenDeleteModal(true);};var onClickChangeMac=function onClickChangeMac(mac){setSelected(mac);setOpenEditMaceModal(true);};var getAslStateValues=function getAslStateValues(mac){if(!mac)return{};var device=viewModel.aslDeviceInformation[mac];if(!device)return{};var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};var stateValues=void 0;if(device.deviceType==='slam'){stateValues={mac:mac,ip:device.ip,name:device.name,deviceType:device.deviceType,port:device.port,vendorAttributes:device.vendorAttributes,deviceConfig:{responsePort:device.responsePort,inductLocation:device.inductLocation,userId:device.userId},monitoring:JSON.stringify(deviceMonitoring)};}else{stateValues={mac:mac,ip:device.ip,name:device.name,deviceType:device.deviceType,port:device.port,deviceConfig:{type:__WEBPACK_IMPORTED_MODULE_4__util_Util__["e" /* assetTypeToConfigTypeDict */].typeASL,id:device.id},vendorAttributes:device.vendorAttributes,monitoring:JSON.stringify(deviceMonitoring)};}stateValues.deviceConfig=JSON.stringify(stateValues.deviceConfig);stateValues.divertConfig=JSON.stringify(viewModel.aslDeviceInformation[mac].divertConfig);return stateValues;};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default.a,{position:"top",title:intl.formatMessage({id:'tooltip.scrolltobottom',defaultMessage:'Scroll to bottom'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.device",defaultMessage:"No device present for this station."})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.name",defaultMessage:"Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.mac_ip",defaultMessage:"MAC/IP"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_23__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.connectionstatus'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"connection"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.connection",defaultMessage:"Connection Status"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.monitoring",defaultMessage:"Monitoring Status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"vendor"},Object(__WEBPACK_IMPORTED_MODULE_23__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'device.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.action",defaultMessage:"Action"}))),sortedDeviceList.map(function(device,index){var vendorAttributes=device.vendorAttributes;var monitoring=Object(__WEBPACK_IMPORTED_MODULE_25__util_Validations__["u" /* checkDeviceMonitoringEnabled */])(Number(device.startTime),Number(device.endTime));var _getMonitoringStatusD=Object(__WEBPACK_IMPORTED_MODULE_25__util_Validations__["F" /* getMonitoringStatusDetails */])(monitoring),monitoringStatusColor=_getMonitoringStatusD.monitoringStatusColor,monitoringStatusId=_getMonitoringStatusD.monitoringStatusId,monitoringStatusDefaultMessage=_getMonitoringStatusD.monitoringStatusDefaultMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableRow"],{key:index,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),device.deviceType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.mac),device.ip,":",device.port)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,device.assetStatus?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{color:device.assetStatus.toUpperCase()===__WEBPACK_IMPORTED_MODULE_12__util_Constants__["b" /* ACTIVE */]?__WEBPACK_IMPORTED_MODULE_12__util_Constants__["X" /* BLUE_COLOR */]:__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_149" /* ORANGE_COLOR */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.assetStatus)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"loading.text",defaultMessage:"Loading..."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_25__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][vendorAttributes.vendor]," ",__WEBPACK_IMPORTED_MODULE_25__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][vendorAttributes.spec_version])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_23__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"left"},child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"my-menu","aria-haspopup":"menu","aria-expanded":"false",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_202" /* THREE_DOTS */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu___default.a,{anchorNode:actionButtonRefs.current[index],open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEditDevice(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.addDevice",defaultMessage:"Edit"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickRemove(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.deleteDevice",defaultMessage:"Delete"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickChangeMac(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.changeMac",defaultMessage:"Change MAC address"})),monitoring.isMonitoringEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDisableMonitoring(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_disable",defaultMessage:"Disable Monitoring"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEnableMonitoring(device.startTime,device.reason,device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_enable",defaultMessage:"Enable Monitoring"}))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_23__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"end"},child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:onClickAddEditDevice,type:"primary",size:"small",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.add_device_button_modal",defaultMessage:"Add Device Configuration"}))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_23__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"end"},child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:function onClick(){return setOpenDeleteModal(true);},type:"tertiary",size:"small",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"button.delete",defaultMessage:"Delete device"}))})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__modal_AddAslSingleDeviceModal__["a" /* default */],{open:openAddModal,setOpen:setOpenAddModal,selected:selected,setSelected:setSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__commonui_DeleteSingleDeviceModal__["a" /* default */],{open:openDeleteModal,setOpen:setOpenDeleteModal,selected:selected,setSelected:setSelected,macAddressArray:viewModel.macAddressArray,dispatch:dispatch}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__commonui_EditMacAddressModal__["a" /* default */],{open:openEditMacModal,setOpen:setOpenEditMaceModal,selectedMac:selected,setSelectedMac:setSelected,dispatch:dispatch,stateValues:getAslStateValues(selected)}),openDisableMonitoringModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__commonui_DisableMonitoringModal__["a" /* default */],{mac:mac,state:openDisableMonitoringModal,onStateChange:setOpenDisableMonitoringModal,context:__WEBPACK_IMPORTED_MODULE_2__context_AslDeviceOverviewContext__["a" /* AslDeviceOverviewContext */],reducer:'UPDATE_MONITORING_DATA'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AslDeviceOverview));

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_AslDeviceOverviewContext__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddAslSingleDeviceModal=function AddAslSingleDeviceModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__context_AslDeviceOverviewContext__["a" /* AslDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_13__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext2.showWarning;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),port=_useState4[0],setPort=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),responsePort=_useState6[0],setResponsePort=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),inductLocation=_useState8[0],setInductLocation=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),userId=_useState10[0],setUserId=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),deviceType=_useState12[0],setDeviceType=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),name=_useState14[0],setName=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),ip=_useState16[0],setIp=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),mac=_useState18[0],setMac=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState20=_slicedToArray(_useState19,2),id=_useState20[0],setId=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState22=_slicedToArray(_useState21,2),vendor=_useState22[0],setVendor=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState24=_slicedToArray(_useState23,2),specVersion=_useState24[0],setSpecVersion=_useState24[1];// Error states
var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),portErr=_useState26[0],setPortErr=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),responsePortErr=_useState28[0],setResponsePortErr=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState30=_slicedToArray(_useState29,2),inductLocationErr=_useState30[0],setInductLocationErr=_useState30[1];var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState32=_slicedToArray(_useState31,2),userIdErr=_useState32[0],setUserIdErr=_useState32[1];var _useState33=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState34=_slicedToArray(_useState33,2),deviceTypeErr=_useState34[0],setDeviceTypeErr=_useState34[1];var _useState35=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState36=_slicedToArray(_useState35,2),nameErr=_useState36[0],setNameErr=_useState36[1];var _useState37=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState38=_slicedToArray(_useState37,2),ipErr=_useState38[0],setIpErr=_useState38[1];var _useState39=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState40=_slicedToArray(_useState39,2),macErr=_useState40[0],setMacErr=_useState40[1];var _useState41=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState42=_slicedToArray(_useState41,2),idErr=_useState42[0],setIdErr=_useState42[1];var _useState43=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState44=_slicedToArray(_useState43,2),vendorErr=_useState44[0],setVendorErr=_useState44[1];var _useState45=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState46=_slicedToArray(_useState45,2),specVersionErr=_useState46[0],setSpecVersionErr=_useState46[1];var initialMonitoringValue={startTime:"0",endTime:"0",reason:""};var _useState47=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(JSON.stringify(initialMonitoringValue)),_useState48=_slicedToArray(_useState47,2),monitoring=_useState48[0],setMonitoring=_useState48[1];var stateValues={mac:mac,ip:ip,name:name,deviceType:deviceType,port:port,deviceConfig:{type:__WEBPACK_IMPORTED_MODULE_11__util_Util__["e" /* assetTypeToConfigTypeDict */].typeASL,id:id},vendorAttributes:{vendor:vendor,spec_version:specVersion},monitoring:monitoring};if(deviceType==='slam'){stateValues={mac:mac,ip:ip,name:name,deviceType:deviceType,port:port,deviceConfig:{responsePort:responsePort,inductLocation:inductLocation,userId:userId},vendorAttributes:{vendor:vendor,spec_version:specVersion},monitoring:monitoring};}var onCloseModal=function onCloseModal(){setOpen(false);setSelected("");resetInputState();setShowAlert(false);};var onClickConfirm=function onClickConfirm(stateValues){if(Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["S" /* validateNewAslDevice */])(stateValues)){showWarning(formatMessage({id:"device.editWarning"}),function(){setShowAlert(false);stateValues.deviceConfig=JSON.stringify(stateValues.deviceConfig);if(selected){stateValues.divertConfig=JSON.stringify(viewModel.aslDeviceInformation[stateValues.mac].divertConfig);updateData(stateValues);}else{addData(stateValues);}setOpen(false);resetInputState();});}else{setShowAlert(true);}};function resetInputState(){setMac("");setMacErr(false);setMonitoring(JSON.stringify(initialMonitoringValue));setVendor("");setSpecVersion("");resetAssetDetails();clearAssetDetailErrors();}function resetAssetDetails(){setIp("");setId("");setPort("");setDeviceType("");setVendorErr(false);setSpecVersionErr(false);setName("");}function clearAssetDetailErrors(){setIpErr(false);setIdErr(false);setPortErr(false);setDeviceTypeErr(false);setNameErr(false);}var prefill=function prefill(value){if(viewModel.aslDeviceInformation.hasOwnProperty(value)){setSelected(value);var device=viewModel.aslDeviceInformation[value];var vendorAttributes=device.vendorAttributes;clearAssetDetailErrors();setMac(device.mac);setIp(device.ip);setId(device.id||"");setPort(device.port);setDeviceType(device.deviceType);setName(device.name);setResponsePort(device.responsePort||"");setInductLocation(device.inductLocation||"");setUserId(device.userId);setVendor(vendorAttributes.vendor);setSpecVersion(vendorAttributes.spec_version);var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};setMonitoring(JSON.stringify(deviceMonitoring));}else if(selected){setSelected(false);resetAssetDetails();}};var resetDeviceConfigFields=function resetDeviceConfigFields(){setId("");setResponsePort("");setInductLocation("");setUserId("");};var addData=function addData(stateValues){dispatch({type:'ADD_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues}});};var updateData=function updateData(stateValues){dispatch({type:'UPDATE_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.add_device_button_modal"}),open:open,onOpen:function onOpen(){return prefill(selected);},onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.mac",defaultMessage:"MAC Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"mac-input",value:mac,onChange:setMac,mask:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["i" /* MAC_MASK */],disabled:selected,onBlur:function onBlur(){setMacErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.mac,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].MAC));prefill(mac);},error:macErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"id-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.ip",defaultMessage:"IP Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"ip-input",value:ip,onChange:setIp,onBlur:function onBlur(){return setIpErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.ip,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["g" /* IP_ADDRESS_PATTERN */]));},error:ipErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"port-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.port",defaultMessage:"Port"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"port-input",value:port,onChange:setPort,onBlur:function onBlur(){return setPortErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.port,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].PORT));},error:portErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"name-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.name",defaultMessage:"Device Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"name-input",value:name,onChange:setName,onBlur:function onBlur(){return setNameErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.name,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].NAME));},error:nameErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.name_line_desc",defaultMessage:"Display name of the device. e.g. \"Line 3\""})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.protocol",defaultMessage:"Protocol"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default.a,{value:deviceType,onChange:function onChange(value){setDeviceType(value);resetDeviceConfigFields();},onBlur:function onBlur(){return setDeviceTypeErr(!deviceType);},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.select_protocol",defaultMessage:"Select a protocol"}),error:deviceTypeErr,width:"100%"},__WEBPACK_IMPORTED_MODULE_10__util_Validations__["k" /* PROTOCOLS */].ASL.map(function(protocol){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__["SelectOption"],{key:protocol,value:protocol,label:protocol});}))),deviceType==='slam'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.responsePort",defaultMessage:"Response Port"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"port-input",value:responsePort,onChange:setResponsePort,onBlur:function onBlur(){return setResponsePortErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.deviceConfig.responsePort,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].PORT));},error:responsePortErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.inductLocation",defaultMessage:"Induct Location"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"port-input",value:inductLocation,onChange:setInductLocation,onBlur:function onBlur(){return setInductLocationErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.deviceConfig.inductLocation,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].SHORT_STRING));},error:inductLocationErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.userId",defaultMessage:"User ID"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"port-input",value:userId,onChange:setUserId,onBlur:function onBlur(){return setUserIdErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.deviceConfig.userId,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].SHORT_STRING));},error:userIdErr}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"id-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.device_id",defaultMessage:"Device ID"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"id-input",value:id,onChange:setId,onBlur:function onBlur(){return setIdErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.deviceConfig.id,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].DEVICE_ID));},error:idErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.device_id_line_desc",defaultMessage:"Unique local identifier for the device. eg. \"3\" for \"Line 3\""})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default.a,{id:"device-type-input",value:vendor,onChange:function onChange(value){return setVendor(value);},onBlur:function onBlur(){return setVendorErr(!vendor);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_vendor'}),error:vendorErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].VENDOR).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.spec_version'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default.a,{id:"device-type-input",value:specVersion,onChange:function onChange(value){return setSpecVersion(value);},onBlur:function onBlur(){return setSpecVersionErr(!specVersion);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_version'}),error:specVersionErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].SPEC_VERSION).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][value]});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stateValues);}},selected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmEdit",defaultMessage:"Confirm edit"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddAslSingleDeviceModal));

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_AddAslGuidedDivertConfigurationModal__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__context_AslDeviceOverviewContext__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_DeleteAslGuidedDivertConfigurationModal__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonui_ConfigurationTabHeader__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__commonui_PaginatedTable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_arrow_right_large__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_arrow_right_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_arrow_right_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__rollback_RollbackModal__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__util_ConditionalWrapping__ = __webpack_require__(91);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var AslDeviceConfiguration=function AslDeviceConfiguration(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__context_AslDeviceOverviewContext__["a" /* AslDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_18__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext2.getDraftData,setDraftData=_useContext2.setDraftData,resetDraftData=_useContext2.resetDraftData,getFilteredDraftData=_useContext2.getFilteredDraftData,isDataEdited=_useContext2.isDataEdited;var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_24__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorized=_useContext3.isAuthorized;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION),_useState2=_slicedToArray(_useState,2),valueConfiguration=_useState2[0],setValueConfiguration=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openAddModal=_useState4[0],setOpenAddModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),openDeleteModal=_useState6[0],setOpenDeleteModal=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),selectedMac=_useState8[0],setSelectedMac=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),showRollbackModal=_useState10[0],setShowRollbackModal=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),isVersionsLoading=_useState12[0],setIsVersionsLoading=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),selectedVersion=_useState14[0],setSelectedVersion=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),_useState16=_slicedToArray(_useState15,2),rollBackVersions=_useState16[0],setRollbackVersions=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])("divertCode"),_useState18=_slicedToArray(_useState17,2),guidedDivertConfigColumn=_useState18[0],setGuidedDivertConfigColumn=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_17__util_Constants__["J" /* ASCENDING */]),_useState20=_slicedToArray(_useState19,2),guidedDivertConfigOrder=_useState20[0],setGuidedDivertConfigOrder=_useState20[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);var PAGE_CONFIGURATION_KEYS=[__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION];Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(!openAddModal&&!openDeleteModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["D" /* getAssetRefreshInterval */])());return function(){return clearInterval(interval);};}},[openAddModal,openDeleteModal]);var getModalContent=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var versionsData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setIsVersionsLoading(true);_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_22__resources_AssetResource__["f" /* getAssetVersions */])(selectedMac);case 3:versionsData=_context.sent;setRollbackVersions(versionsData.data.assetVersionDetailsList);setIsVersionsLoading(false);case 6:case"end":return _context.stop();}}},_callee,_this);}));return function getModalContent(){return _ref2.apply(this,arguments);};}();var loadRollbackDataToDraft=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var rollbackData,divertConfigData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_22__resources_AssetResource__["e" /* getAssetByVersion */])(selectedMac,selectedVersion);case 2:rollbackData=_context2.sent;divertConfigData=Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.divertConfig);},[]);if(divertConfigData.length){setDraftData({data:divertConfigData,stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION,subKey:selectedMac,allRowsAdded:true,override:true});}case 5:case"end":return _context2.stop();}}},_callee2,_this);}));return function loadRollbackDataToDraft(){return _ref3.apply(this,arguments);};}();var getSortedDeviceList=function getSortedDeviceList(){var sortedDeviceList=Object.values(viewModel.aslDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){if(a.name<b.name){return-1;}else if(b.name>a.name){return 1;}return 0;});return sortedDeviceList;};var getData=function getData(){setOpenAddModal(false);setOpenDeleteModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};function onClickAddSingle(){setOpenAddModal(true);}function onClickDeleteConfiguration(){setOpenDeleteModal(true);}Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return viewModel.aslDeviceInformation[selectedMac].divertConfig;},[]),stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION,subKey:selectedMac});},[selectedMac]);var deployDraftASLAsset=function deployDraftASLAsset(){var divertConfigList=getFilteredDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION,subKey:selectedMac});dispatch({type:'UPDATE_ASL_CONFIGURATION',data:{dispatcher:dispatch,configurations:{divertConfig:divertConfigList},mac:selectedMac}});setDraftData({data:divertConfigList,stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION,subKey:selectedMac,override:true});};var headerProps={selectedMac:selectedMac,setSelectedMac:setSelectedMac,valueConfiguration:valueConfiguration,setValueConfiguration:setValueConfiguration,isSorterConfig:valueConfiguration===__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION,intl:intl,resetDraftData:resetDraftData,deployDraft:deployDraftASLAsset,scrollToBottom:scrollToBottom,defaultSelection:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION,sortedDeviceList:getSortedDeviceList(),configurationKeys:PAGE_CONFIGURATION_KEYS,refreshDeps:[viewModel.timestamp],isDeployDisabled:!isDataEdited(PAGE_CONFIGURATION_KEYS),isRollbackDisabled:!selectedMac||isDataEdited(PAGE_CONFIGURATION_KEYS),rollbackClickHandler:function rollbackClickHandler(){getModalContent();setShowRollbackModal(true);}};var renderTableHeader=function renderTableHeader(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"divertCode"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.divertcode",defaultMessage:"Divert Code"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"clusters"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"slam.clusters",defaultMessage:"Clusters"})));};var renderTableRow=function renderTableRow(config){var dataString=config.clusters.join(" ");var prevDataString=Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return config.prev.clusters.join(" ");},"");return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:true,backgroundColor:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_148" /* OPERATION_COLOR */][config.operation]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,config.divertCode),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,prevDataString&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_text___default.a,null," ",prevDataString," "),prevDataString&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_text___default.a,null," ",dataString," ")));};var sortGuidedDivertConfigColumns={divertCode:function divertCode(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.divertCode,b.divertCode):-Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.divertCode,b.divertCode);},clusters:function clusters(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.clusters.join(" "),b.clusters.join(" ")):-Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.clusters.join(" "),b.clusters.join(" "));}};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__loader_Loader__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__commonui_ConfigurationTabHeader__["a" /* default */],Object.assign({},headerProps,{isAuthorized:isAuthorized})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__rollback_RollbackModal__["a" /* default */],{showRollbackModal:showRollbackModal,setShowRollbackModal:setShowRollbackModal,isVersionsLoading:isVersionsLoading,selectedVersion:selectedVersion,setSelectedVersion:setSelectedVersion,rollBackVersions:rollBackVersions,loadRollbackDataToDraft:loadRollbackDataToDraft,intl:intl}),valueConfiguration===__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION&&selectedMac&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__commonui_PaginatedTable__["a" /* default */],{data:getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION,subKey:selectedMac}).sort(function(a,b){return sortGuidedDivertConfigColumns[guidedDivertConfigColumn](a,b,guidedDivertConfigOrder===__WEBPACK_IMPORTED_MODULE_17__util_Constants__["J" /* ASCENDING */]);}),renderRow:renderTableRow,renderHeader:renderTableHeader,sortColumn:guidedDivertConfigColumn,sortDirection:guidedDivertConfigOrder,onSort:function onSort(_ref4){var sortColumn=_ref4.sortColumn,sortDirection=_ref4.sortDirection;setGuidedDivertConfigColumn(sortColumn);setGuidedDivertConfigOrder(sortDirection);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_26__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"end"},child:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{onClick:onClickAddSingle,type:"primary",size:"small",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"config.addupdateasl",defaultMessage:"Add/Update Guided Divert Configuration"}))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_26__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"end"},child:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{onClick:onClickDeleteConfiguration,type:"tertiary",size:"small",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"config.delete",defaultMessage:"Delete Configuration"}))})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__modal_AddAslGuidedDivertConfigurationModal__["a" /* default */],{mac:selectedMac,open:openAddModal,setOpen:setOpenAddModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__modal_DeleteAslGuidedDivertConfigurationModal__["a" /* default */],{mac:selectedMac,open:openDeleteModal,setOpen:setOpenDeleteModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{ref:tableEndRef})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AslDeviceConfiguration));

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddAslGuidedDivertConfigurationModal=function AddAslGuidedDivertConfigurationModal(props){var formatMessage=props.intl.formatMessage;var mac=props.mac;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,addInstance=_useContext.addInstance,editInstance=_useContext.editInstance;// Visual controls
var open=props.open,setOpen=props.setOpen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),show=_useState2[0],setShow=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),edit=_useState4[0],setEdit=_useState4[1];// Values
var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),divertCode=_useState6[0],setDivertCode=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),clusters=_useState8[0],setClusters=_useState8[1];// Errors
var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),divertCodeErr=_useState10[0],setDivertCodeErr=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),clustersErr=_useState12[0],setClustersErr=_useState12[1];function onCloseModal(){setShow(false);setOpen(false);resetInputState();}var divertConfig={divertCode:divertCode,clusters:clusters.replace(/\s/g,'').split(';')};var divertConfigMap={};getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION,subKey:mac}).forEach(function(value){divertConfigMap[value.divertCode]=value.clusters;});var onClickConfirm=function onClickConfirm(divertConfig,mac){if(Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["N" /* validateAddDivertConfigModal */])(divertConfig,mac,__WEBPACK_IMPORTED_MODULE_10__util_Constants__["K" /* ASL_ASSET_TYPE */])){setConfigData();setOpen(false);resetInputState();setShow(false);}else{setShow(true);}};function resetInputState(){setDivertCode("");setDivertCodeErr(false);setClusters("");setClustersErr(false);}var prefill=function prefill(){if(divertConfigMap.hasOwnProperty(divertCode)){setEdit(true);setClusters(divertConfigMap[divertCode].join(';'));}else if(edit){setEdit(false);setClusters("");}};var setConfigData=function setConfigData(){if(edit){editInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION,subKey:mac,instance:divertConfig,keyComparator:function keyComparator(config1,config2){return config1.divertCode===config2.divertCode;},valueComparator:function valueComparator(config1,config2){return config1.clusters.join(';')===config2.clusters.join(';');}});}else{addInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION,subKey:mac,instance:divertConfig});}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"config.addupdateasl"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.addheadingasl",defaultMessage:"To edit an existing configuration, enter the same divert code again."}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.divertcode",defaultMessage:"Divert Code"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"divert-code-input",value:divertCode,onChange:setDivertCode,mask:__WEBPACK_IMPORTED_MODULE_9__util_Validations__["b" /* DIVERT_CODE_MASK */],onBlur:function onBlur(){setDivertCodeErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(divertCode,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].DIVERT_CODE));prefill();},error:divertCodeErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.divertcode_desc",defaultMessage:"Range: 10 to 99"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.clusters",defaultMessage:"Clusters"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"cluster-input",value:clusters,onChange:setClusters,onBlur:function onBlur(){setClustersErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(clusters,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].CLUSTERS));},error:clustersErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.clusters_desc",defaultMessage:"Separate multiple values by semicolon - e.g.: A;B;C"})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["x" /* checkModalValidationsForConfig */])(divertConfig,props.mac,__WEBPACK_IMPORTED_MODULE_10__util_Constants__["K" /* ASL_ASSET_TYPE */])&&show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(divertConfig,props.mac);}},edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmUpdate",defaultMessage:"Confirm update"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddAslGuidedDivertConfigurationModal));

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DeleteAslGuidedDivertConfigurationModal=function DeleteAslGuidedDivertConfigurationModal(props){var formatMessage=props.intl.formatMessage;var mac=props.mac;var open=props.open,setOpen=props.setOpen;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,deleteInstance=_useContext.deleteInstance,deleteAll=_useContext.deleteAll;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),valueDivertCode=_useState2[0],setValueDivertCode=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),searchQuery=_useState4[0],setSearchQuery=_useState4[1];var onCloseModal=function onCloseModal(){setOpen(false);setInputState();};var stateValues={divertCode:valueDivertCode,mac:mac};var divertConfigList=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION,subKey:mac}).map(function(_ref){var divertCode=_ref.divertCode;return divertCode;});var searchRegExp=new RegExp(__WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp___default()(searchQuery),"i");var matchedOptions=divertConfigList.filter(function(option){return!searchQuery||searchRegExp.test(option);});var onClickConfirm=function onClickConfirm(stateValues){deleteData(stateValues);setOpen(false);setInputState();};function setInputState(){setValueDivertCode("");}var deleteData=function deleteData(){deleteInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION,subKey:mac,keyComparator:function keyComparator(instance){return instance.divertCode===stateValues.divertCode;}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.delete_divert_config_button_modal"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.divertcodedelete",defaultMessage:"Please enter the Divert Code you would like to remove"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default.a,{value:valueDivertCode,onChange:setValueDivertCode,searchQuery:searchQuery,onSearch:setSearchQuery,placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.select_divert_code",defaultMessage:"Select divert code to be deleted."}),width:"100%"},matchedOptions.map(function(divertCode){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__["SelectOption"],{key:divertCode,value:divertCode,label:divertCode});}),!matchedOptions.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},divertConfigList?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," No matching divert codes "):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," No divert codes available ")):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{size:"small",className:"redBtn",onClick:function onClick(){deleteAll({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].DIVERT_CONFIGURATION,subKey:mac});onCloseModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.deleteAll",defaultMessage:"Delete All"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"secondary",size:"small",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:function onClick(){return onClickConfirm(stateValues);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.confirm",defaultMessage:"Confirm"}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(DeleteAslGuidedDivertConfigurationModal));

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_AslDeviceOverviewContext__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonui_CommonDeviceLogstream__ = __webpack_require__(102);
var AslDeviceLogstream=function AslDeviceLogstream(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__context_AslDeviceOverviewContext__["a" /* AslDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var deviceList=Object.values(viewModel.aslDeviceInformation);var props={protocols:__WEBPACK_IMPORTED_MODULE_3__util_Validations__["k" /* PROTOCOLS */].ASL,dispatch:dispatch,deviceList:deviceList,deviceType:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["K" /* ASL_ASSET_TYPE */],intl:intl};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonui_CommonDeviceLogstream__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(AslDeviceLogstream));

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_ThinClientOverviewContext__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__meridian_components_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_edit__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__network_ThinClientOverviewNetworkAPI__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__commonui_DeleteSingleDeviceModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commonui_DisableMonitoringModal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__amzn_meridian_link__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__amzn_meridian_tokens_base_icon_export_small__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__amzn_meridian_tokens_base_icon_export_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_tokens_base_icon_export_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__util_ConditionalPlaceholder__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__commonui_ChangeDeviceUseCaseModal__ = __webpack_require__(1183);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var ThinClientOverview=function ThinClientOverview(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__context_ThinClientOverviewContext__["a" /* ThinClientOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({}),_useState2=_slicedToArray(_useState,2),openActionsMenu=_useState2[0],setOpenActionsMenu=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openAddModal=_useState4[0],setOpenAddModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),openTCUseCaseChangeModal=_useState6[0],setOpenTCUseCaseChangeModal=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),selected=_useState8[0],setSelected=_useState8[1];var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])([]);var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),mac=_useState10[0],setMac=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),_useState12=_slicedToArray(_useState11,2),remark=_useState12[0],setRemark=_useState12[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);var _useState13=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),editRemark=_useState14[0],setEditRemark=_useState14[1];var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=true;setOpenActionsMenu(_open);},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=false;setOpenActionsMenu(_open);},[]);Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(!openAddModal){getData();var assetInterval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["D" /* getAssetRefreshInterval */])());var statusInterval=setInterval(function(){if(!document.hidden){getStatusData();}},Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["_11" /* getStatusRefreshInterval */])());return function(){clearInterval(assetInterval);clearInterval(statusInterval);};}},[openAddModal]);var sortedDeviceList=Object.values(viewModel.thinClientDeviceInformation);Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,viewModel.thinClientDeviceInformation.length);if(!editRemark){setRemark(sortedDeviceList.map(function(value){return{value:value.remark,close:true};}));}},[sortedDeviceList]);var onSort=function onSort(sortDetails){setEditRemark(false);dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};sortedDeviceList&&sortedDeviceList.sort(function(a,b){if(a[viewModel.sortPref.column]<b[viewModel.sortPref.column]){return viewModel.sortPref.direction==="ascending"?-1:1;}if(a[viewModel.sortPref.column]>b[viewModel.sortPref.column]){return viewModel.sortPref.direction==="ascending"?1:-1;}return 0;});var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var setStatusLoader=function setStatusLoader(mac,loadingField,loaderVisible){dispatch({type:'UPDATE_STATUS_LOADER',data:{mac:mac,loadingField:loadingField,loaderVisible:loaderVisible}});};var showStatusLoader=function showStatusLoader(mac,loadingField){return Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["f" /* chainWalk */])(function(){return viewModel.loadingStatusDevices[mac][loadingField];},false);};var onClickDisableMonitoring=function onClickDisableMonitoring(mac){setMac(mac);setOpenAddModal(true);};var onClickEnableMonitoring=function onClickEnableMonitoring(startTime,reason,mac){var stateValues={"startTime":startTime,"endTime":Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["I" /* getCurrentDate */])().toString(),"reason":reason};setStatusLoader(mac,'monitoringStatusLoader',true);addData(stateValues,mac);setTimeout(function(){getData();setStatusLoader(mac,'monitoringStatusLoader',false);},__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_136" /* MONITORING_STATUS_LOADER_TIMER */]);};var onClickRestartApplication=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(mac,useCase){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setOpenAddModal(false);dispatch({type:'DEPLOY_THIN_CLIENT',data:{dispatcher:dispatch,mac:mac,useCase:useCase}});case 2:case"end":return _context.stop();}}},_callee,_this);}));return function onClickRestartApplication(_x,_x2){return _ref2.apply(this,arguments);};}();var addData=function addData(stateValues,mac){dispatch({type:'ADD_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues,mac:mac}});};var onClickToggleUsecase=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(device){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// function to make that tc primary and rest all secondary
setOpenAddModal(false);dispatch({type:'TOGGLE_USECASE',data:{dispatcher:dispatch,mac:device.mac,useCase:device.useCase}});case 2:case"end":return _context2.stop();}}},_callee2,_this);}));return function onClickToggleUsecase(_x3){return _ref3.apply(this,arguments);};}();var onClickChangeUsecase=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(device){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0://function to change the device use case i.e. deploymentGroup
setSelected(device);setOpenTCUseCaseChangeModal(true);case 2:case"end":return _context3.stop();}}},_callee3,_this);}));return function onClickChangeUsecase(_x4){return _ref4.apply(this,arguments);};}();var handleKeyDown=function handleKeyDown(index,row,event){if(event.key==="Enter"){onClickConfirmRemark(index,row);}};var onClickConfirmRemark=function onClickConfirmRemark(index,row){// function to send the updated remark to post request in db
var temp=[].concat(_toConsumableArray(remark));temp[index]=Object.assign({},temp[index],{close:true});setRemark(temp);Object(__WEBPACK_IMPORTED_MODULE_17__network_ThinClientOverviewNetworkAPI__["e" /* postUpdatedRemarkToDevice */])(row,remark[index].value).then(function(r){getData();});};var onClickEditRemark=function onClickEditRemark(index){setEditRemark(true);var temp=[].concat(_toConsumableArray(remark));temp[index]=Object.assign({},temp[index],{close:false});setRemark(temp);};var getData=function getData(){setOpenAddModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var getStatusData=function getStatusData(){dispatch({type:'LOAD_STATUS',data:{dispatcher:dispatch,state:viewModel}});};var handleInputChange=function handleInputChange(index,value){var temp=[].concat(_toConsumableArray(remark));temp[index]=Object.assign({},temp[index],{value:value});setRemark(temp);};var getDeviceHealthStatus=function getDeviceHealthStatus(_ref5){var connection=_ref5.connection,healthStatus=_ref5.healthStatus,useCase=_ref5.useCase;if(connection&&connection.toLowerCase()===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_145" /* ONLINE_OK */]){return __WEBPACK_IMPORTED_MODULE_8__util_Constants__["_80" /* HEALTH_STATUS */].HEALTHY;}else if(connection===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_110" /* LOADING_STRING */]){return __WEBPACK_IMPORTED_MODULE_8__util_Constants__["_80" /* HEALTH_STATUS */].LOADING;}else if(connection===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_109" /* LOADING_FAILED */]){return __WEBPACK_IMPORTED_MODULE_8__util_Constants__["_80" /* HEALTH_STATUS */].LOADING_FAILED;}else{return __WEBPACK_IMPORTED_MODULE_8__util_Constants__["_80" /* HEALTH_STATUS */].DISCONNECTED;}};var getSoftwareStatus=function getSoftwareStatus(_ref6){var swStatus=_ref6.swStatus,swType=_ref6.swType;if(__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_17" /* DEPLOYMENT_STATUS */].SUCCESS.includes(swStatus)){return __WEBPACK_IMPORTED_MODULE_8__util_Constants__["_18" /* DEPLOYMENT_TYPE */].DEPLOYMENT.includes(swType)?__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_195" /* SW_STATUS */].DEPLOYED:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_195" /* SW_STATUS */].CLEAN;}else if(__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_17" /* DEPLOYMENT_STATUS */].IN_PROGRESS.includes(swStatus)){return __WEBPACK_IMPORTED_MODULE_8__util_Constants__["_18" /* DEPLOYMENT_TYPE */].DEPLOYMENT.includes(swType)?__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_195" /* SW_STATUS */].DEPLOYMENT_IN_PROGRESS:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_195" /* SW_STATUS */].RESET_IN_PROGRESS;}else if(__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_17" /* DEPLOYMENT_STATUS */].QUEUED.includes(swStatus)){return __WEBPACK_IMPORTED_MODULE_8__util_Constants__["_195" /* SW_STATUS */].QUEUED;}else if(swStatus===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_109" /* LOADING_FAILED */]){return __WEBPACK_IMPORTED_MODULE_8__util_Constants__["_195" /* SW_STATUS */].LOADING_FAILED;}else if(swStatus===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_110" /* LOADING_STRING */]){return __WEBPACK_IMPORTED_MODULE_8__util_Constants__["_195" /* SW_STATUS */].LOADING;}else if(swStatus===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_195" /* SW_STATUS */].RESTARTED){return __WEBPACK_IMPORTED_MODULE_8__util_Constants__["_195" /* SW_STATUS */].RESTARTED;}else if(swStatus===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_195" /* SW_STATUS */].RESTART_IN_PROGRESS){return __WEBPACK_IMPORTED_MODULE_8__util_Constants__["_195" /* SW_STATUS */].RESTART_IN_PROGRESS;}else{return __WEBPACK_IMPORTED_MODULE_8__util_Constants__["_195" /* SW_STATUS */].ERROR;}};var renderRemark=function renderRemark(device,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_row___default.a,null,remark[index]&&remark[index].close===true&&(remark[index].value===""?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text___default.a,{truncate:"true"}," ",device.remark," "):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text___default.a,{truncate:"true",value:remark[index].value},remark[index].value," ")),remark[index]&&remark[index].close===false?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_row___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_input___default.a,{onChange:function onChange(value){return handleInputChange(index,value);},value:remark[index].value,placeholder:"Enter remark",size:"small",autoFill:"true",focus:"true",resize:"vertical",onKeyDown:function onKeyDown(event){return handleKeyDown(index,device,event);},rows:1}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{onClick:function onClick(){return onClickConfirmRemark(index,device);},size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"modal.confirm",defaultMessage:"Confirm"}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{type:"link",onClick:function onClick(){return onClickEditRemark(index);},size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_edit___default.a})));};var renderDeviceIp=function renderDeviceIp(healthStatus,ip){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text___default.a,{color:healthStatus===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_80" /* HEALTH_STATUS */].DISCONNECTED.string?"secondary":"primary"},ip);};var renderDeviceVLAN=function renderDeviceVLAN(healthStatus,vlan){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text___default.a,{color:healthStatus===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_80" /* HEALTH_STATUS */].DISCONNECTED.string?"secondary":"primary"},"VLAN "+vlan);};var checkPrimaryUseCase=function checkPrimaryUseCase(useCase,isPrimary){return(useCase===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_171" /* SBL_ASSET_TYPE */]||useCase===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_168" /* SBLV2_ASSET_TYPE */]||useCase===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_86" /* IOT_AUTOMATION_ONLOGIC_ASSET_TYPE */])&&isPrimary===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_209" /* TRUE_VALUE */]&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text___default.a,{type:"b200"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{color:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["X" /* BLUE_COLOR */]}},__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_157" /* PRIMARY */]));};var renderDeviceMonitoring=function renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",{style:{color:monitoringStatusColor}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:monitoringStatusId,defaultMessage:monitoringStatusDefaultMessage}));};var deleteThinClient=function deleteThinClient(device){dispatch({type:"DELETE_DEVICE_DATA",data:{dispatcher:dispatch,mac:device.mac}});};var renderTableRow=function renderTableRow(device,index){var _useCaseTextMap;var _getDeviceHealthStatu=getDeviceHealthStatus(device),healthStatus=_getDeviceHealthStatu.string,healthColor=_getDeviceHealthStatu.color;var _getSoftwareStatus=getSoftwareStatus(device),swStatus=_getSoftwareStatus.string,swColor=_getSoftwareStatus.color;var monitoring=Object(__WEBPACK_IMPORTED_MODULE_24__util_Validations__["u" /* checkDeviceMonitoringEnabled */])(device.startTime,device.endTime);var _getMonitoringStatusD=Object(__WEBPACK_IMPORTED_MODULE_24__util_Validations__["F" /* getMonitoringStatusDetails */])(monitoring),monitoringStatusColor=_getMonitoringStatusD.monitoringStatusColor,monitoringStatusId=_getMonitoringStatusD.monitoringStatusId,monitoringStatusDefaultMessage=_getMonitoringStatusD.monitoringStatusDefaultMessage;var isIOTOrMHEAutomationAsset=[__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_168" /* SBLV2_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_8__util_Constants__["M" /* AUTOMATION_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_86" /* IOT_AUTOMATION_ONLOGIC_ASSET_TYPE */]].includes(device.useCase);var isIOTAutomationAsset=[__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_171" /* SBL_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_168" /* SBLV2_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_86" /* IOT_AUTOMATION_ONLOGIC_ASSET_TYPE */]].includes(device.useCase);var useCaseTextMap=(_useCaseTextMap={},_defineProperty(_useCaseTextMap,__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_171" /* SBL_ASSET_TYPE */],device.useCase.toUpperCase()),_defineProperty(_useCaseTextMap,__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_168" /* SBLV2_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_169" /* SBLV2_TEXT */]),_defineProperty(_useCaseTextMap,__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_86" /* IOT_AUTOMATION_ONLOGIC_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_170" /* SBLV3_TEXT */]),_useCaseTextMap);var useCaseText=useCaseTextMap[device.useCase]||__WEBPACK_IMPORTED_MODULE_8__util_Constants__["P" /* AUTOMATION_TEXT */];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableRow"],{key:device.mac,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_link___default.a,{target:"_blank",rel:"noopener noreferrer",type:"secondary",href:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_196" /* TAKA_CLIENT_LINK_PREFIX */]+"/"+Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["X" /* getNodeId */])().toLowerCase()+"/"+Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["W" /* getMacWithoutColon */])(device.mac)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null," ",device.mac," ")," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_tokens_base_icon_export_small___default.a})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:healthStatus===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_80" /* HEALTH_STATUS */].DISCONNECTED.string,wrapper:__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_28__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.disconnectedipvlan"}),position:"top"},child:renderDeviceIp(healthStatus,device.ip)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:healthStatus===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_80" /* HEALTH_STATUS */].DISCONNECTED.string,wrapper:__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_28__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.disconnectedipvlan"}),position:"top"},child:renderDeviceVLAN(healthStatus,device.vlan)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,useCaseText,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__util_ConditionalPlaceholder__["a" /* ConditionalPlaceholder */],{placeholder:showStatusLoader(device.mac,'usecaseStatusLoader'),args:{tooltipTitle:Object(__WEBPACK_IMPORTED_MODULE_28__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.statusLoading'}),tooltipPosition:"start",loaderSize:"small"},view:checkPrimaryUseCase(device.useCase,device.primary)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{style:{color:healthColor}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,healthStatus))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{style:{color:swColor}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__util_ConditionalPlaceholder__["a" /* ConditionalPlaceholder */],{placeholder:showStatusLoader(device.mac,'softwareStatusLoader'),args:{tooltipTitle:Object(__WEBPACK_IMPORTED_MODULE_28__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.statusLoading'}),tooltipPosition:"start",loaderSize:"medium"},view:swStatus})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__util_ConditionalPlaceholder__["a" /* ConditionalPlaceholder */],{placeholder:showStatusLoader(device.mac,'monitoringStatusLoader'),args:{tooltipTitle:Object(__WEBPACK_IMPORTED_MODULE_28__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.monitoringStatusLoading'}),tooltipPosition:"start",loaderSize:"medium"},view:renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{width:"400px"},renderRemark(device,index)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"my-menu","aria-haspopup":"menu","aria-expanded":"false"},"..."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_menu___default.a,{anchorNode:actionButtonRefs.current[index],id:"my-menu",open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},isIOTOrMHEAutomationAsset&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickRestartApplication(device.mac,device.useCase);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"actions.restart",defaultMessage:"Restart Application"})),monitoring.isMonitoringEnabled?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDisableMonitoring(device.mac);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_disable",defaultMessage:"Disable Monitoring"})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEnableMonitoring(device.startTime,device.reason,device.mac);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_enable",defaultMessage:"Enable Monitoring"})),isIOTAutomationAsset&&device.primary===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_77" /* FALSE_VALUE */]&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickToggleUsecase(device);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"actions.primary",defaultMessage:"Make Primary Use Case"})),device.useCase!==__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_171" /* SBL_ASSET_TYPE */]&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickChangeUsecase(device);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"actions.usecase",defaultMessage:"Change Thin Client use case"})),Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["g" /* checkHealthStatusForDeletion */])(healthStatus)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return deleteThinClient(device);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.delete",defaultMessage:"Delete"}))),openAddModal&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__commonui_DisableMonitoringModal__["a" /* default */],{mac:mac,state:openAddModal,onStateChange:setOpenAddModal,context:__WEBPACK_IMPORTED_MODULE_3__context_ThinClientOverviewContext__["a" /* ThinClientOverviewContext */],reducer:'ADD_DEVICE_DATA'}))));};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_RefreshTimer__["a" /* default */],{deps:[viewModel.timestamp]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tooltip___default.a,{position:"top",title:intl.formatMessage({id:'tooltip.scrolltobottom',defaultMessage:'Scroll to bottom!'})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"alert.device",defaultMessage:"No device present for this station."})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.mac_ip",defaultMessage:"MAC/IP"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"vlan"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.vlan",defaultMessage:"VLAN"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"useCase"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.useCase",defaultMessage:"Use Case"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"connection"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tooltip___default.a,{position:"top",title:intl.formatMessage({id:'status.tooltip',defaultMessage:'Healthy: Device is working correctly. '+'Disconnected: Device is not properly connected to both internet and local network.'+'Loading failed: Failed to fetch connection status of the device, something may be wrong.'})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.status",defaultMessage:"Status"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"swstatus"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.swstatus",defaultMessage:"Software Status"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"monitoring"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.monitoring",defaultMessage:"Monitoring Status"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"remark"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.remark",defaultMessage:"Remark"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.action",defaultMessage:"Action"}))),sortedDeviceList.map(function(device,index){return renderTableRow(device,index);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_row___default.a,{width:"100%",widths:["fill","100"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__commonui_DeleteSingleDeviceModal__["a" /* default */],{macAddressArray:viewModel.macAddressArray,dispatch:dispatch})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_row___default.a,{width:"100%",widths:["fill","100"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__commonui_ChangeDeviceUseCaseModal__["a" /* default */],{open:openTCUseCaseChangeModal,setOpen:setOpenTCUseCaseChangeModal,selectedDevice:selected,setSelectedDevice:setSelected,dispatch:dispatch})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_intl__["d" /* injectIntl */])(ThinClientOverview));

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConditionalPlaceholder; });
/* unused harmony export loaderTooltipPlaceholder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_loader__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_loader__);
var ConditionalPlaceholder=function ConditionalPlaceholder(_ref){var placeholder=_ref.placeholder,args=_ref.args,view=_ref.view;return placeholder?loaderTooltipPlaceholder(args):view;};var loaderTooltipPlaceholder=function loaderTooltipPlaceholder(_ref2){var tooltipTitle=_ref2.tooltipTitle,tooltipPosition=_ref2.tooltipPosition,loaderSize=_ref2.loaderSize;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_tooltip___default.a,{title:tooltipTitle,position:tooltipPosition},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_loader___default.a,{size:loaderSize}));};

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_context_GlobalStateContext__ = __webpack_require__(33);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var ChangeDeviceUseCaseModal=function ChangeDeviceUseCaseModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,selectedDevice=props.selectedDevice,setSelectedDevice=props.setSelectedDevice,dispatch=props.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),_useState2=_slicedToArray(_useState,2),selectedUseCase=_useState2[0],setSelectedUseCase=_useState2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning,showCustomAlert=_useContext.showCustomAlert;var onClickConfirm=function onClickConfirm(){if(selectedUseCase){showWarning("Are you sure you want to change use case to "+selectedUseCase.displayText+" for device with "+selectedDevice.mac+" MAC address",function(){changeUseCase(selectedDevice.mac,selectedUseCase.useCase);onCloseModal();});}};var onCloseModal=function onCloseModal(){setOpen(false);setSelectedDevice('');resetInputState();};function resetInputState(){setSelectedUseCase('');}var changeUseCase=function changeUseCase(mac,targetUseCase){dispatch({type:'CHANGE_USECASE',data:{dispatcher:props.dispatch,mac:mac,useCase:targetUseCase,showCustomAlert:showCustomAlert}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.usecase_change_modal"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row___default.a,{width:"40%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,{width:"fill",spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},selectedUseCase?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmchangeusecase",defaultMessage:"Please confirm the new Thin Client use case you have selected."}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.selectnewusecase",defaultMessage:"Please select new use case for Thin Client."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,{spacing:"500"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_select___default.a,{id:"select.usecase",placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.selectusecase",defaultMessage:"Select use case"}),value:selectedUseCase,onChange:setSelectedUseCase,width:300},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:""},"Change Use Case"),Object.keys(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_216" /* USE_CASE_MAP */]).filter(function(useCase){return selectedDevice.useCase!==__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_216" /* USE_CASE_MAP */][useCase].assetUseCase;}).map(function(useCase){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_select__["SelectOption"],{key:useCase,value:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_216" /* USE_CASE_MAP */][useCase],label:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_216" /* USE_CASE_MAP */][useCase].displayText});}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.confirm",defaultMessage:"Confirm"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */])(ChangeDeviceUseCaseModal));

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_SblDeviceOverviewContext__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row__);
var SblDeviceOverview=function SblDeviceOverview(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_SblDeviceOverviewContext__["a" /* SblDeviceOverviewContext */]),viewModel=_useContext.viewModel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{widths:["grid-12"],alignmentVertical:"top",spacingInset:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}));};/* harmony default export */ __webpack_exports__["a"] = (SblDeviceOverview);

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SblDeviceOverviewContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_SblDeviceOverviewReducer__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__ = __webpack_require__(71);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var SblDeviceOverviewContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();var SblDeviceOverviewContextProvider=function SblDeviceOverviewContextProvider(props){var data=[];var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(__WEBPACK_IMPORTED_MODULE_1__reducer_SblDeviceOverviewReducer__["a" /* SblDeviceOverviewReducer */],data),_useReducer2=_slicedToArray(_useReducer,2),viewModel=_useReducer2[0],dispatch=_useReducer2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorised=_useContext.isAuthorised;if(!isAuthorised){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PermissionAlertBanner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SblDeviceOverviewContext.Provider,{value:{viewModel:viewModel,dispatch:dispatch}},props.children);};/* unused harmony default export */ var _unused_webpack_default_export = (SblDeviceOverviewContextProvider);

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SblDeviceOverviewReducer; });
var SblDeviceOverviewReducer=function SblDeviceOverviewReducer(state,action){switch(action.type){default:return state;}};

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
var SblDeviceConfiguration=function SblDeviceConfiguration(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_Util__["a" /* AlertConfiguration */],null);};/* harmony default export */ __webpack_exports__["a"] = (SblDeviceConfiguration);

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_ThinClientOverviewContext__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var ThinClientPage=function(_Component){_inherits(ThinClientPage,_Component);function ThinClientPage(){_classCallCheck(this,ThinClientPage);return _possibleConstructorReturn(this,(ThinClientPage.__proto__||Object.getPrototypeOf(ThinClientPage)).apply(this,arguments));}_createClass(ThinClientPage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_ThinClientOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["y" /* THIN_CLIENTS */],location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["y" /* THIN_CLIENTS */]})));}}]);return ThinClientPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ThinClientPage);

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_LidarOverviewContext__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__thinclient_banner_LidarControllerBanner__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modal_AddEditSingleLidarControllerModal__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modal_LidarConfigurationModal__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commonui_DeleteSingleDeviceModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__commonui_UpdateDeviceStatusModal__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modal_ManageObstructionModal__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__global_context_GlobalStateContext__ = __webpack_require__(33);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var LidarOverview=function LidarOverview(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_LidarOverviewContext__["a" /* LidarOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_25__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext2.showCustomAlert;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),openAddModal=_useState2[0],setOpenAddModal=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openManageObstructionModal=_useState4[0],setOpenManageObstructionModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),openConfigModal=_useState6[0],setOpenConfigModal=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState8=_slicedToArray(_useState7,2),selected=_useState8[0],setSelected=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),openDeleteModal=_useState10[0],setOpenDeleteModal=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),openUpdateStatusModal=_useState12[0],setOpenUpdateStatusModal=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),enableObstruction=_useState14[0],setEnableObstruction=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),status=_useState16[0],setStatus=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),deviceLocation=_useState18[0],setDeviceLocation=_useState18[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState20=_slicedToArray(_useState19,2),openActionsMenu=_useState20[0],setOpenActionsMenu=_useState20[1];var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=true;setOpenActionsMenu(_open);},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=false;setOpenActionsMenu(_open);},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openAddModal&&!openDeleteModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["D" /* getAssetRefreshInterval */])());return function(){return clearInterval(interval);};}},[openAddModal,openDeleteModal]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,viewModel.lidarDeviceInformation.length);},[viewModel.lidarDeviceInformation]);var onSort=function onSort(sortDetails){dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};var sortedDeviceList=Object.values(viewModel.lidarDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){if(a[viewModel.sortPref.column]<b[viewModel.sortPref.column]){return viewModel.sortPref.direction==="ascending"?-1:1;}if(a[viewModel.sortPref.column]>b[viewModel.sortPref.column]){return viewModel.sortPref.direction==="ascending"?1:-1;}return 0;});var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var getData=function getData(){setOpenAddModal(false);setOpenDeleteModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var onClickAddEditDevice=function onClickAddEditDevice(){setSelected(null);setOpenAddModal(true);};var onClickEditDevice=function onClickEditDevice(mac){setSelected(mac);setOpenAddModal(true);};var onClickViewConfiguration=function onClickViewConfiguration(mac){setSelected(mac);setOpenConfigModal(true);};var onClickDisableObstruction=function onClickDisableObstruction(mac,obstructionDisabledUntil){if(obstructionDisabledUntil&&obstructionDisabledUntil>Date.now()){showCustomAlert("Obstruction is already disabled until "+new Date(obstructionDisabledUntil).toUTCString());}else{setSelected(mac);setEnableObstruction(false);setOpenManageObstructionModal(true);}};var onClickEnableObstruction=function onClickEnableObstruction(mac){setSelected(mac);setEnableObstruction(true);setOpenManageObstructionModal(true);};var onClickDeactivate=function onClickDeactivate(mac,location){setSelected(mac);setStatus(__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_82" /* INACTIVE */]);setDeviceLocation(location);setOpenUpdateStatusModal(true);};var onClickActivate=function onClickActivate(mac,location){setSelected(mac);setStatus(__WEBPACK_IMPORTED_MODULE_7__util_Constants__["b" /* ACTIVE */]);setDeviceLocation(location);setOpenUpdateStatusModal(true);};var onClickDeleteDevice=function onClickDeleteDevice(mac){setSelected(mac);setOpenDeleteModal(true);};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tooltip___default.a,{position:"top",title:intl.formatMessage({id:'tooltip.scrolltobottom',defaultMessage:'Scroll to bottom!'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"alert.device",defaultMessage:"No device present for this station."})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"device.mac_ip",defaultMessage:"MAC/IP"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],{sortColumn:"connectivity"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"device.connectivity",defaultMessage:"Connection Status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],{sortColumn:"location"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"device.location",defaultMessage:"Locations"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],{sortColumn:"status"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"device.status",defaultMessage:"Status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],{sortColumn:"controller_type"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"device.controller_type",defaultMessage:"Controller Type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"device.action",defaultMessage:"Action"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__thinclient_banner_LidarControllerBanner__["a" /* default */],null),sortedDeviceList.map(function(device,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableRow"],{key:device.mac,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.mac),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),device.ip),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{style:{color:device.connectivity.toLowerCase()===__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_145" /* ONLINE_OK */]?__WEBPACK_IMPORTED_MODULE_7__util_Constants__["X" /* BLUE_COLOR */]:__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_149" /* ORANGE_COLOR */]}},device.connectivity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),device.timestamp),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.location)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.status)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.lidarControllerType)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"my-menu","aria-haspopup":"menu","aria-expanded":"false"},__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_202" /* THREE_DOTS */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu___default.a,{anchorNode:actionButtonRefs.current[index],open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEditDevice(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"actions.addDevice",defaultMessage:"Edit Device"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickViewConfiguration(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"actions.viewConfiguration",defaultMessage:"View Configuration"})),device.status===__WEBPACK_IMPORTED_MODULE_7__util_Constants__["b" /* ACTIVE */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDeactivate(device.mac,device.location);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"actions.deactivate",defaultMessage:"Deactivate"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickActivate(device.mac,device.location);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"actions.activate",defaultMessage:"Activate"})),device.obstructionDisabledUntil!==null&&device.obstructionDisabledUntil<=Date.now()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDisableObstruction(device.mac,device.obstructionDisabledUntil);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"actions.disableObstruction",defaultMessage:"Disable Obstruction"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEnableObstruction(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"actions.enableObstruction",defaultMessage:"Enable Obstruction"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDeleteDevice(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"button.delete",defaultMessage:"Delete device"}))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{onClick:onClickAddEditDevice,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"device.add_device_button_modal",defaultMessage:"Add/Update Single Device Configuration"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__modal_AddEditSingleLidarControllerModal__["a" /* default */],{open:openAddModal,setOpen:setOpenAddModal,selected:selected,setSelected:setSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__modal_ManageObstructionModal__["a" /* default */],{open:openManageObstructionModal,setOpen:setOpenManageObstructionModal,selected:selected,setSelected:setSelected,enableObstruction:enableObstruction}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__modal_LidarConfigurationModal__["a" /* default */],{open:openConfigModal,setOpen:setOpenConfigModal,selected:selected,setSelected:setSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__commonui_DeleteSingleDeviceModal__["a" /* default */],{open:openDeleteModal,setOpen:setOpenDeleteModal,selected:selected,setSelected:setSelected,macAddressArray:viewModel.macAddressArray,dispatch:dispatch}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__commonui_UpdateDeviceStatusModal__["a" /* default */],{open:openUpdateStatusModal,setOpen:setOpenUpdateStatusModal,selected:selected,setSelected:setSelected,status:status,dispatch:dispatch,deviceLocation:deviceLocation,additionalConfirmationMessage:status===__WEBPACK_IMPORTED_MODULE_7__util_Constants__["b" /* ACTIVE */]?intl.formatMessage({id:"modal.lidar.activate.message",defaultMessage:"Caution: Confirm that the last sensor in each aisle has been validated with the LiDAR tester before enabling Scanless. Enabling without validation will cause incorrect sensor-to-column mapping, leading to false obstructions and stow detection failures."}):null}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["d" /* injectIntl */])(LidarOverview));

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LidarOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_LidarOverviewNetworkAPI__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__network_LidarManageByExceptionsNetworkAPI__ = __webpack_require__(1192);
var LidarOverviewReducer=function LidarOverviewReducer(state,action){switch(action.type){case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingOverview:false});case"LOAD_VIEW":Object(__WEBPACK_IMPORTED_MODULE_0__network_LidarOverviewNetworkAPI__["b" /* fetchLidarDeviceDetails */])(action.data.dispatcher);return state;case"LOAD_MANAGE_BY_EXCEPTIONS_VIEW":Object(__WEBPACK_IMPORTED_MODULE_1__network_LidarManageByExceptionsNetworkAPI__["a" /* fetchScanlessOfflineDeviceDetails */])(action.data.dispatcher);return state;case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});case"ADD_LIDAR_CONTROLLER":Object(__WEBPACK_IMPORTED_MODULE_0__network_LidarOverviewNetworkAPI__["a" /* addLidarController */])(action.data.dispatcher,action.data.stateValues,action.data.showCustomAlert);return state;case"UPDATE_LIDAR_CONTROLLER":Object(__WEBPACK_IMPORTED_MODULE_0__network_LidarOverviewNetworkAPI__["e" /* updateLidarController */])(action.data.dispatcher,action.data.stateValues,action.data.showCustomAlert);return state;case"UPDATE_DEVICE_STATUS":Object(__WEBPACK_IMPORTED_MODULE_0__network_LidarOverviewNetworkAPI__["f" /* updateLidarControllerStatus */])(action.data.dispatcher,action.data.mac,action.data.status,action.data.showCustomAlert);return state;case"DELETE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_LidarOverviewNetworkAPI__["f" /* updateLidarControllerStatus */])(action.data.dispatcher,action.data.mac,"DEPRECATED",action.data.showCustomAlert);return state;case"UPDATE_LIDAR_CONFIG":Object(__WEBPACK_IMPORTED_MODULE_0__network_LidarOverviewNetworkAPI__["d" /* updateLidarConfiguration */])(action.data.dispatcher,action.data.configurations,action.data.mac,action.data.showCustomAlert);return state;default:return state;}};

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateConfigurationsInLidarAssetObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Util__ = __webpack_require__(5);
var updateConfigurationsInLidarAssetObject=function updateConfigurationsInLidarAssetObject(asset,configurations){var updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["t" /* deepCopyObject */])(asset);if(configurations.obstructionDisabledUntil){updatedAsset.assetDetails.assetAttributes.obstructionDisabledUntil=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(configurations.obstructionDisabledUntil);},"0");}return updatedAsset;};

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchScanlessOfflineDeviceDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LidarOverviewNetworkAPI__ = __webpack_require__(490);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var fetchScanlessOfflineDeviceDetails=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher){var request,startTime,result,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),deviceType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_99" /* LIDAR_ASSET_TYPE */],filters:[{connectivityFilterKey:"useCase",connectivityFilterValue:"SCANLESS"}]};startTime=Date.now();_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["i" /* getSiteDevicesConnectivity */])(request.nodeId,request.deviceType,request.filters);case 4:result=_context.sent;if(result.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,__WEBPACK_IMPORTED_MODULE_4__LidarOverviewNetworkAPI__["c" /* metricProcessName */],"getSiteDevicesConnectivity",true,false);dispatcher({type:"RECEIVE_DATA",data:result.data});}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(result.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,__WEBPACK_IMPORTED_MODULE_4__LidarOverviewNetworkAPI__["c" /* metricProcessName */],"getSiteDevicesConnectivity",false,isFault);dispatcher({type:"RECEIVE_DATA",data:{deviceConnectivityList:[]}});}case 6:case"end":return _context.stop();}}},_callee,this);}));return function fetchScanlessOfflineDeviceDetails(_x){return _ref.apply(this,arguments);};}();

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__banner_css__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__banner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__banner_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
var LidarControllerBanner=function LidarControllerBanner(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Please ignore below status - '),' Refer Scanless troubleshooting',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://w.amazon.com/bin/view/Last_Mile_Team/Smart-Station/Scanless/Lidar_Mechlite_Alpha_Launch_Plan/Maintenance_and_Troubleshooting'},' guide '),'and use commissioning tool.'))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(LidarControllerBanner));

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_LidarOverviewContext__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddEditSingleLidarControllerModal=function AddEditSingleLidarControllerModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__context_LidarOverviewContext__["a" /* LidarOverviewContext */]),viewModel=_useContext2.viewModel,dispatch=_useContext2.dispatch;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),ip=_useState4[0],setIp=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState6=_slicedToArray(_useState5,2),mac=_useState6[0],setMac=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState8=_slicedToArray(_useState7,2),startAisle=_useState8[0],setStartAisle=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState10=_slicedToArray(_useState9,2),endAisle=_useState10[0],setEndAisle=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState12=_slicedToArray(_useState11,2),nonOVCartRecipe=_useState12[0],setNonOVCartRecipe=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState14=_slicedToArray(_useState13,2),oneTierOVCartRecipe=_useState14[0],setOneTierOVCartRecipe=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState16=_slicedToArray(_useState15,2),twoTierOVCartRecipe=_useState16[0],setTwoTierOVCartRecipe=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState18=_slicedToArray(_useState17,2),creationTime=_useState18[0],setCreationTime=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState20=_slicedToArray(_useState19,2),lidarControllerType=_useState20[0],setLidarControllerType=_useState20[1];// Error
var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),ipErr=_useState22[0],setIpErr=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),macErr=_useState24[0],setMacErr=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),startAisleErr=_useState26[0],setStartAisleErr=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),endAisleErr=_useState28[0],setEndAisleErr=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState30=_slicedToArray(_useState29,2),nonOVCartRecipeErr=_useState30[0],setNonOVCartRecipeErr=_useState30[1];var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState32=_slicedToArray(_useState31,2),oneTierOVCartRecipeErr=_useState32[0],setOneTierOVCartRecipeErr=_useState32[1];var _useState33=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState34=_slicedToArray(_useState33,2),twoTierOVCartRecipeErr=_useState34[0],setTwoTierOVCartRecipeErr=_useState34[1];var _useState35=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState36=_slicedToArray(_useState35,2),lidarControllerTypeErr=_useState36[0],setLidarControllerTypeErr=_useState36[1];var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext3.showCustomAlert;var stateValues={lidarControllerConfig:{lidarControllerType:lidarControllerType,macAddress:mac,ipAddress:ip,startAisleLabel:startAisle,endAisleLabel:endAisle,nonOVCartRecipe:nonOVCartRecipe,oneTierOVCartRecipe:oneTierOVCartRecipe,twoTierOVCartRecipe:twoTierOVCartRecipe,creationTime:creationTime}};var onCloseModal=function onCloseModal(){setOpen(false);setSelected(null);resetInputState();setShowAlert(false);};var onClickConfirm=function onClickConfirm(stateValues){if(Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["Z" /* validateNewLidarController */])(stateValues)){showWarning(formatMessage({id:"lidarController.editWarning"}),function(){setShowAlert(false);if(selected){updateData(stateValues);}else{addData(stateValues);}resetInputState();setOpen(false);});}else{setShowAlert(true);}};function resetInputState(){// setting state of input fields as empty to have empty inputs on clicking Add Device again
setMac(null);setMacErr(false);resetAssetDetails();resetAssetDetailErrors();}var resetAssetDetails=function resetAssetDetails(){setLidarControllerType(null);setIp(null);setStartAisle(null);setEndAisle(null);setNonOVCartRecipe(null);setOneTierOVCartRecipe(null);setTwoTierOVCartRecipe(null);setCreationTime(null);};var resetAssetDetailErrors=function resetAssetDetailErrors(){setLidarControllerTypeErr(false);setIpErr(false);setStartAisleErr(false);setEndAisleErr(false);setNonOVCartRecipeErr(false);setOneTierOVCartRecipeErr(false);setTwoTierOVCartRecipeErr(false);};var prefill=function prefill(value){if(viewModel.lidarDeviceInformation&&viewModel.lidarDeviceInformation.hasOwnProperty(value)){setSelected(value);var device=viewModel.lidarDeviceInformation[value];resetAssetDetailErrors();setLidarControllerType(device.lidarControllerType);setMac(device.mac);setIp(device.ip);setStartAisle(device.startAisleLabel);setEndAisle(device.endAisleLabel);setNonOVCartRecipe(device.nonOvColumnType);setOneTierOVCartRecipe(device.oneTierOvColumnType);setTwoTierOVCartRecipe(device.twoTierOvColumnType);setCreationTime(device.creationTime);}else if(!selected){resetAssetDetails();}};var addData=function addData(stateValues){dispatch({type:'ADD_LIDAR_CONTROLLER',data:{dispatcher:dispatch,stateValues:stateValues,showCustomAlert:showCustomAlert}});};var updateData=function updateData(stateValues){dispatch({type:'UPDATE_LIDAR_CONTROLLER',data:{dispatcher:dispatch,stateValues:stateValues,showCustomAlert:showCustomAlert}});};var generateCartTypesSelectOptions=function generateCartTypesSelectOptions(cartTypes){return cartTypes.map(function(cartType){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select__["SelectOption"],{key:cartType,value:cartType,label:viewModel.cartRecipesMap&&viewModel.cartRecipesMap.has(cartType)&&viewModel.cartRecipesMap.get(cartType).displayName?viewModel.cartRecipesMap.get(cartType).displayName:cartType});});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.add_device_button_modal"}),open:open,onOpen:function onOpen(){return prefill(selected);},onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"lidar-controller-type-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.controller_type",defaultMessage:"Controller Type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select___default.a,{id:"lidar-controller-type-input",value:lidarControllerType,onChange:setLidarControllerType,placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.selectLidarControllerType",defaultMessage:"Select Lidar Controller Type"}),onBlur:function onBlur(){return setLidarControllerTypeErr(!lidarControllerType);},error:lidarControllerTypeErr},__WEBPACK_IMPORTED_MODULE_10__util_Validations__["h" /* LIDAR_CONTROLLER_TYPES */].map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:value});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.mac",defaultMessage:"MAC Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"mac-input",value:mac,onChange:setMac,mask:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["i" /* MAC_MASK */],disabled:selected,onBlur:function onBlur(){setMacErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.lidarControllerConfig.macAddress,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].MAC));prefill(mac);},error:macErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"ip-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.ip",defaultMessage:"IP Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"ip-input",value:ip,onChange:setIp,onBlur:function onBlur(){return setIpErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.lidarControllerConfig.ipAddress,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["g" /* IP_ADDRESS_PATTERN */]));},error:ipErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"start-aisle-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.startAisle",defaultMessage:"Start Aisle"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"start-aisle-input",value:startAisle,onChange:setStartAisle,onBlur:function onBlur(){return setStartAisleErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.lidarControllerConfig.startAisleLabel,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].AISLE));},error:startAisleErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"end-aisle-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.endAisle",defaultMessage:"End Aisle"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"end-aisle-input",value:endAisle,onChange:setEndAisle,onBlur:function onBlur(){return setEndAisleErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.lidarControllerConfig.endAisleLabel,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].AISLE));},error:endAisleErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"nonov-cart-recipe-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.nonOVCartRecipe",defaultMessage:"Non OV Column Type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select___default.a,{id:"nonov-cart-recipe-input",value:nonOVCartRecipe,onChange:function onChange(value){return setNonOVCartRecipe(value);},onBlur:function onBlur(){return setNonOVCartRecipeErr(!nonOVCartRecipe);},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.selectNonOVCartRecipe",defaultMessage:"Select Non OV Column Type"}),error:nonOVCartRecipeErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_15" /* getUTRRegion */])()==="NA"?generateCartTypesSelectOptions(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["n" /* SCANLESS_SUPPORTED_CART_RECIPES_NA */].NON_OV):Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_15" /* getUTRRegion */])()==="EU"?generateCartTypesSelectOptions(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["l" /* SCANLESS_SUPPORTED_CART_RECIPES_EU */].NON_OV):generateCartTypesSelectOptions(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["m" /* SCANLESS_SUPPORTED_CART_RECIPES_JP */].NON_OV))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"2tier-ov-cart-recipe-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.2tierOVCartRecipe",defaultMessage:"2 Tier OV column type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select___default.a,{id:"2tier-ov-cart-recipe-input",value:twoTierOVCartRecipe,onChange:function onChange(value){return setTwoTierOVCartRecipe(value);},onBlur:function onBlur(){return setTwoTierOVCartRecipeErr(!twoTierOVCartRecipe);},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.select2tierOVCartRecipe",defaultMessage:"Select 2 Tier OV column type"}),error:twoTierOVCartRecipeErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_15" /* getUTRRegion */])()==="NA"?generateCartTypesSelectOptions(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["n" /* SCANLESS_SUPPORTED_CART_RECIPES_NA */].TWO_TIER_OV):Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_15" /* getUTRRegion */])()==="EU"?generateCartTypesSelectOptions(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["l" /* SCANLESS_SUPPORTED_CART_RECIPES_EU */].TWO_TIER_OV):generateCartTypesSelectOptions(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["m" /* SCANLESS_SUPPORTED_CART_RECIPES_JP */].TWO_TIER_OV))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"1tier-ov-cart-recipe-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.1tierOVCartRecipe",defaultMessage:"1 Tier OV Column Type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_select___default.a,{id:"1tier-ov-cart-recipe-input",value:oneTierOVCartRecipe,onChange:function onChange(value){return setOneTierOVCartRecipe(value);},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.select1tierOVCartRecipe",defaultMessage:"Select 1 Tier OV Column Type"}),error:oneTierOVCartRecipeErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_15" /* getUTRRegion */])()==="NA"?generateCartTypesSelectOptions(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["n" /* SCANLESS_SUPPORTED_CART_RECIPES_NA */].ONE_TIER_OV):Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_15" /* getUTRRegion */])()==="EU"?generateCartTypesSelectOptions(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["l" /* SCANLESS_SUPPORTED_CART_RECIPES_EU */].ONE_TIER_OV):generateCartTypesSelectOptions(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["m" /* SCANLESS_SUPPORTED_CART_RECIPES_JP */].ONE_TIER_OV)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stateValues);}},selected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmEdit",defaultMessage:"Confirm edit"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddEditSingleLidarControllerModal));

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__meridian_components_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__context_LidarOverviewContext__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_expander__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_expander___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_expander__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_modal__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var LidarConfigurationModal=function LidarConfigurationModal(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__context_LidarOverviewContext__["a" /* LidarOverviewContext */]),viewModel=_useContext.viewModel;var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(new Set([])),_useState2=_slicedToArray(_useState,2),expanded=_useState2[0],setExpanded=_useState2[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var formatMessage=props.intl.formatMessage;var expand=function expand(expanderName){var newExpanded=new Set(expanded);if(newExpanded.has(expanderName)){newExpanded.delete(expanderName);}else{newExpanded.add(expanderName);}setExpanded(newExpanded);};var isExpanded=function isExpanded(expanderName){return expanded.has(expanderName);};var getColumnLabels=function getColumnLabels(assetMapping){return assetMapping.columns&&assetMapping.columns.reduce(function(columnLabels,column){columnLabels.push(getDisplayableColumnLabel(column.columnLabel));return columnLabels;},[]);};var getDisplayableColumnLabel=function getDisplayableColumnLabel(columnLabel){return /[A-Z]+$/.exec(columnLabel);};var device=open?viewModel.lidarDeviceInformation[selected]:null;var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var getLidarControllerExpanderTitle=function getLidarControllerExpanderTitle(device){return"Controller:"+device.mac+"\u2003 \u2003 \u2003 Aisle:"+device.startAisleLabel+"-"+device.endAisleLabel+"(total "+device.aislesCount+")";};var onCloseModal=function onCloseModal(){setOpen(false);setSelected(null);};var getAisleExpanderTitle=function getAisleExpanderTitle(assetMapping){return assetMapping.aisleLabel+"\u2003 \u2003 \u2003"+getColumnLabels(assetMapping);};if(open){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.configuration"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__meridian_components_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tooltip___default.a,{position:"top",title:formatMessage({id:'tooltip.scrolltobottom',defaultMessage:'Scroll to bottom!'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_expander___default.a,{open:isExpanded(device.mac),onChange:function onChange(){return expand(device.mac);},title:getLidarControllerExpanderTitle(device),type:"box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),device.displayableAssetMappings.map(function(assetMapping){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_expander___default.a,{open:isExpanded(assetMapping.aisleLabel),onChange:function onChange(){return expand(assetMapping.aisleLabel);},title:getAisleExpanderTitle(assetMapping),type:"box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,"Column"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,"Column Type")),assetMapping.columns.map(function(column){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,getDisplayableColumnLabel(column.columnLabel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,viewModel.cartRecipesMap.has(column.cartType)&&viewModel.cartRecipesMap.get(column.cartType).displayName?viewModel.cartRecipesMap.get(column.cartType).displayName:column.cartType));})));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef}))));}else{return null;}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */])(LidarConfigurationModal));

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _expander = _interopRequireDefault(__webpack_require__(1198));

var _default = _expander["default"];
exports["default"] = _default;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _expander = _interopRequireDefault(__webpack_require__(1199));

var _chevronRightSmall = _interopRequireDefault(__webpack_require__(158));

var _uniqueId = _interopRequireDefault(__webpack_require__(68));

var _theme = __webpack_require__(24);

var _clickable = _interopRequireDefault(__webpack_require__(108));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _expanderController = _interopRequireDefault(__webpack_require__(438));

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _focusRing = _interopRequireDefault(__webpack_require__(73));

var _token = __webpack_require__(20);

var _functional = __webpack_require__(38);

var _text = _interopRequireDefault(__webpack_require__(47));

var _cxMemoized = _interopRequireDefault(__webpack_require__(107));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var type = _ref.type;
  return (0, _emotion.css)((0, _text["default"])(t), {
    position: "relative",
    borderBottom: type === "section" ? t.borderCss("border") : undefined,
    border: type === "box" ? t.borderCss("border") : undefined,
    borderRadius: t("borderRadius", type),
    backgroundColor: t("backgroundColor", type)
  });
}, ["type"]);
var iconStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var _css;

  var open = _ref2.open,
      focus = _ref2.focus;
  return (0, _emotion.css)((_css = {
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   marginInlineStart: t("spacingHorizontal"),
    //   transform: `rotate(${open ? 90 : 0}deg)`,
    //   [`[dir="rtl"] &`]: {
    //       transform: `rotate(${open ? -90 : 0}deg)`,
    //   },
    // },
    marginRight: t("spacingHorizontal"),
    marginLeft: 0,
    transform: "rotate(".concat(open ? 90 : 0, "deg)")
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    marginLeft: t("spacingHorizontal"),
    marginRight: 0,
    transform: "rotate(".concat(open ? -90 : 0, "deg)")
  }), (0, _defineProperty2["default"])(_css, "transition", "transform ".concat(t("motionDuration"), " ").concat(t("motionIconFunction"))), _css), (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: 8
  }));
}, ["open", "focus"]);
var handleStyles = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var type = _ref3.type;
  var colorType = type === "section" || type === "list" ? "default" : "inline";
  var spacingV = t("spacingVertical");
  var spacingH = t("spacingHorizontal");
  return (0, _emotion.css)((0, _defineProperty2["default"])({
    // Make the whole width of the expander clickable for block-level expanders,
    // otherwise only make the visible content clickable
    display: type === "box" || type === "section" ? "flex" : "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    color: t("foregroundColor", [colorType, "default"]),
    ":hover": {
      color: t("foregroundColor", [colorType, "hover"])
    },
    ":active": {
      color: t("foregroundColor", [colorType, "pressed"])
    },
    padding: type === "box" ? "".concat(spacingV, "px ").concat(spacingH, "px") : type === "section" ? "".concat(spacingV, "px ").concat(spacingH, "px ").concat(spacingV, "px 0") : "".concat(spacingV, "px 0")
  }, "[dir=\"rtl\"] &", {
    padding: type === "box" ? "".concat(spacingV, "px ").concat(spacingH, "px") : type === "section" ? "".concat(spacingV, "px 0 ").concat(spacingV, "px ").concat(spacingH, "px") : "".concat(spacingV, "px 0")
  }));
}, ["type"]);
var childrenStyles = (0, _token.memoizeTokenStyles)(function (t, _ref4) {
  var _css3;

  var type = _ref4.type,
      open = _ref4.open;
  var spacingV = t("spacingVertical");
  var spacingH = t("spacingHorizontal");
  var spacingEnd = type === "section" || type === "box" ? spacingH : 0;
  var spacingStart = spacingH * (type === "box" ? 2 : 1) + _icon["default"].sizes.small;
  return (0, _emotion.css)((_css3 = {
    boxSizing: "border-box",
    paddingTop: 0,
    paddingBottom: "".concat(spacingV, "px"),
    // HACK: IE11 does not support padding-inline-* so we have to use
    // directional padding-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   paddingInlineStart: `${spacingStart}px`,
    //   paddingInlineEnd: `${spacingEnd}px`,
    // },
    paddingLeft: "".concat(spacingStart, "px"),
    paddingRight: "".concat(spacingEnd, "px")
  }, (0, _defineProperty2["default"])(_css3, "[dir=\"rtl\"] &", {
    paddingLeft: "".concat(spacingEnd, "px"),
    paddingRight: "".concat(spacingStart, "px")
  }), (0, _defineProperty2["default"])(_css3, "opacity", open ? 1 : 0), (0, _defineProperty2["default"])(_css3, "transition", "opacity ".concat(t("motionDuration"), " ").concat(t("motionChildContentFunction"))), _css3));
}, ["type", "open"]);
var titleStyles = (0, _functional.memoize)(function (type) {
  return type === "box" || type === "section" ? (0, _emotion.css)({
    flex: "auto"
  }) : undefined;
});

function Expander(props) {
  var title = props.title,
      children = props.children,
      open = props.open,
      id = props.id,
      type = props.type,
      alwaysRenderChildren = props.alwaysRenderChildren,
      onChange = props.onChange;
  var t = (0, _theme.useTheme)(_expander["default"], "expander");
  var expandableId = (0, _react.useMemo)(function () {
    return (0, _uniqueId["default"])("expandable-");
  }, []);
  var handleOnChange = (0, _react.useCallback)(function () {
    onChange(!open);
  }, [open, onChange]);

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, {
      type: type
    })
  }, /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, focusProps, {
    tag: "div",
    id: id,
    onClick: handleOnChange,
    "aria-expanded": open,
    "aria-controls": expandableId,
    className: handleStyles(t, {
      type: type
    })
  }, passThroughProps), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronRightSmall["default"],
    open: open,
    className: iconStyles(t, {
      open: open,
      focus: focus && focusTrigger === "keyboard"
    })
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: titleStyles(type)
  }, title)), /*#__PURE__*/_react["default"].createElement(_expanderController["default"], {
    open: open,
    direction: "down",
    motionDuration: parseInt(t("motionDuration")),
    motionDelay: t("motionDelay"),
    motionFunction: t("motionChildContentFunction"),
    alwaysRenderChildren: alwaysRenderChildren
  }, function (_ref5) {
    var containerProps = _ref5.containerProps,
        contentProps = _ref5.contentProps;
    return /*#__PURE__*/_react["default"].createElement("div", containerProps, /*#__PURE__*/_react["default"].createElement("div", {
      id: expandableId,
      ref: contentProps.ref,
      className: (0, _cxMemoized["default"])(contentProps.className, childrenStyles(t, {
        type: type,
        open: open
      }))
    }, children));
  }));
}

Expander.propTypes =  false ? {
  /**
   * The contents of the expander. Any elements are acceptable.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The state of the expander. If true the expander will be open, otherwise it
   * will be closed.
   */
  open: _propTypes["default"].bool.isRequired,

  /**
   * The contents of the expander's clickable header.
   *
   * A plain string is recommended, although any static (non-interactive)
   * elements are allowed. Interactive elements are not allowed as they would
   * interfere with the built-in interactive behavior of the title.
   */
  title: _propTypes["default"].node.isRequired,

  /**
   * A function that will be called when the user attempts to open or close the
   * expander (e.g. by clicking on the title). A boolean representing the new
   * open state of the expander will be passed as the first argument to this
   * function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `open` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * Normally children of the expander will not be mounted/rendered when the
   * expander is closed. Set this to `true` if the children should be rendered
   * behind the scenes even when the expander is closed and the children are not
   * visible. This is helpful if the children have local state that should be
   * preserved when the expander is closed. In most other cases this prop should
   * be left off to avoid the performance penalty of rendering UI that is not
   * visible to the user.
   *
   * @since 5.x
   */
  alwaysRenderChildren: _propTypes["default"].bool,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   *
   * @since 5.13.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component's outer DOM element.
   *
   * Use this for testing, for accessibility, or to target custom elements
   * inside the component. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * The type of expander. See the expander design guidelines for details.
   */
  type: _propTypes["default"].oneOf(["section", "inline", "list", "box"])
} : {};
Expander.defaultProps = {
  type: "section",
  open: false
};
var _default = Expander;
exports["default"] = _default;

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    expanderMobileSpacingInset: 16,
    expanderMobileTitleHeight: 48,
    expanderMobileTitleFontSize: 16,
    expanderMobileTitleBackgroundColorPressed: tokens.themeBackgroundOverlayPressed,
    expanderMobileTitleBackgroundOpacityPressed: 16,
    expanderMobileValueFontSize: 14,
    expanderMobileForegroundColorDefaultDefault: tokens.themeForegroundPrimaryDefault,
    expanderMobileForegroundColorDefaultDisabled: tokens.themeBorderSecondaryDefault,
    expanderMobileForegroundColorInlineDefault: tokens.themeForegroundAccentDefault,
    expanderMobileForegroundColorInlinePressed: tokens.themeForegroundAccentPressed,
    expanderMobileForegroundColorInlineDisabled: tokens.themeBorderAccentDisabled,
    expanderSpacingVertical: 10,
    expanderSpacingHorizontal: 20,
    expanderForegroundColorDefaultDefault: tokens.themeForegroundPrimaryDefault,
    expanderForegroundColorDefaultHover: tokens.themeForegroundAccentHover,
    expanderForegroundColorDefaultPressed: tokens.themeForegroundAccentPressed,
    expanderForegroundColorDefaultDisabled: tokens.themeBorderAccentDisabled,
    expanderForegroundColorInlineDefault: tokens.themeForegroundAccentDefault,
    expanderForegroundColorInlineHover: tokens.themeForegroundAccentHover,
    expanderForegroundColorInlinePressed: tokens.themeForegroundAccentPressed,
    expanderForegroundColorInlineDisabled: tokens.themeBorderAccentDisabled,
    expanderBackgroundColorBox: tokens.themeBackgroundPrimaryDefault,
    expanderBorderWidth: 1,
    expanderBorderColor: tokens.themeBorderSecondaryDefault,
    expanderBorderRadius: 0,
    expanderBorderRadiusBox: 4,
    expanderMotionDelay: "100ms",
    expanderMotionDuration: "200ms",
    expanderMotionIconFunction: "ease",
    expanderMotionChildContentFunction: "ease"
  }
};

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_context_GlobalStateContext__ = __webpack_require__(33);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var UpdateDeviceStatusModal=function UpdateDeviceStatusModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected,status=props.status,additionalConfirmationMessage=props.additionalConfirmationMessage,deviceLocation=props.deviceLocation;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),valueMacAddress=_useState2[0],setValueMacAddress=_useState2[1];var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext2.showCustomAlert;var onCloseModal=function onCloseModal(){setOpen(false);setSelected("");resetInputState();};var onClickConfirm=function onClickConfirm(mac,status){showWarning(formatMessage({id:"device.editWarning"}),function(){updateStatus(mac,status);setOpen(false);resetInputState();getData();});};function resetInputState(){setValueMacAddress("");}var prefill=function prefill(){if(!selected)return;setValueMacAddress(selected);};var updateStatus=function updateStatus(mac,status){props.dispatch({type:'UPDATE_DEVICE_STATUS',data:{dispatcher:props.dispatch,mac:mac,status:status,showCustomAlert:showCustomAlert}});};var getData=function getData(){props.dispatch({type:'LOAD_VIEW',data:{dispatcher:props.dispatch}});};if(open){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.update_device_status_button_modal"}),open:open,onOpen:prefill,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},additionalConfirmationMessage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{marginBottom:'16px',padding:'16px',backgroundColor:'#fff8e1',border:'1px solid #ffcc02',borderRadius:'6px',display:'flex',alignItems:'flex-start',gap:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{role:"img","aria-label":"Warning",style:{fontSize:'16px',marginTop:'1px'}},"\u26A0\uFE0F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"span",type:"b300",style:{color:'#b7791f',fontWeight:'600',lineHeight:'1.4',margin:0,fontSize:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"CAUTION:")," ",additionalConfirmationMessage.replace(/^Caution:\s*/i,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmmacstatusupdate",defaultMessage:"Please confirm that you wish to change status of the following device:"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{type:"b300",style:{fontSize:'14px',color:'#666'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Controller Location:")," ",deviceLocation?deviceLocation:valueMacAddress),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{type:"b300",style:{fontSize:'14px',color:'#666'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"device.new Status",defaultMessage:"New Status"}),":")," ",status)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(valueMacAddress,status);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.confirm",defaultMessage:"Confirm"})))));}else{return null;}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(UpdateDeviceStatusModal));

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context_LidarOverviewContext__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Constants__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var ManageObstructionModal=function ManageObstructionModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected,enableObstruction=props.enableObstruction;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning,showCustomAlert=_useContext.showCustomAlert;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__context_LidarOverviewContext__["a" /* LidarOverviewContext */]),viewModel=_useContext2.viewModel,dispatch=_useContext2.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(Date.now()),_useState2=_slicedToArray(_useState,2),obstructionDisabledUntil=_useState2[0],setObstructionDisabledUntil=_useState2[1];var lidarControllerConfig=viewModel.lidarDeviceInformation[selected];var onCloseModal=function onCloseModal(){setOpen(false);setSelected(null);};var onClickConfirm=function onClickConfirm(obstructionDisabledUntil){showWarning(formatMessage({id:"lidarController.editWarning"}),function(){updateData({obstructionDisabledUntil:obstructionDisabledUntil});setOpen(false);});};var updateData=function updateData(configurations){dispatch({type:'UPDATE_LIDAR_CONFIG',data:{dispatcher:dispatch,configurations:configurations,mac:lidarControllerConfig.mac,showCustomAlert:showCustomAlert}});};var prefill=function prefill(){if(!selected)return;if(enableObstruction){setObstructionDisabledUntil(Date.now());}else{setObstructionDisabledUntil(Date.now()+__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_132" /* MILLISECONDS_IN_A_DAY */]);// disable obstruction for next 24 hours
}};var getTitleId=function getTitleId(){if(enableObstruction){return"device.enable_obstruction_button_modal";}else{return"device.disable_obstruction_button_modal";}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:getTitleId()}),open:open,onOpen:prefill,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},enableObstruction?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmenableobstructionupdate",defaultMessage:"Please confirm that you wish to enable obstruction for the following device:"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmdisableobstructionupdate",defaultMessage:"Please confirm that you wish to disable obstruction for the following device:"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{type:"h300"},selected),enableObstruction?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{type:"h300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"device.obstructionwillbeenabled",defaultMessage:"Obstruction will be Enabled from now"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{type:"h300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"device.obstructiondisableduntil",defaultMessage:"Obstruction will be disabled in 1 minute and remain off until"}),": ",new Date(obstructionDisabledUntil).toUTCString())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(obstructionDisabledUntil);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.confirm",defaultMessage:"Confirm"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */])(ManageObstructionModal));

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__meridian_components_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__context_LidarOverviewContext__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_link__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_text__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var LidarManageByExceptions=function LidarManageByExceptions(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_13__context_LidarOverviewContext__["a" /* LidarOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),openAddModal=_useState2[0],setOpenAddModal=_useState2[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var renderingOrder=[__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_21" /* DEVICE_TYPE */].LIDAR_CONTROLLER,__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_21" /* DEVICE_TYPE */].BRANCH_NODE,__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_21" /* DEVICE_TYPE */].LEAF_NODE,__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_21" /* DEVICE_TYPE */].LIDAR_SENSOR];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openAddModal&&Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["f" /* chainWalk */])(function(){return Object.keys(viewModel.lidarDeviceInformation).length;},0)>0){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["S" /* getLidarControllerManageByExceptionsRefreshInterval */])());return function(){return clearInterval(interval);};}},[openAddModal,viewModel.lidarDeviceInformation]);var offlineDevicesList=Object.values(viewModel.deviceConnectivityList);//sort offline devices based on location label.
offlineDevicesList.sort(function(a,b){if(!a.locationLabel){return 1;}if(!b.locationLabel){return-1;}var locationLabelComparisonResult=a.locationLabel.localeCompare(b.locationLabel,undefined,{numeric:true,sensitivity:'base'});if(locationLabelComparisonResult===0&&a.deviceType===b.deviceType){if(__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_21" /* DEVICE_TYPE */].LIDAR_SENSOR===a.deviceType){return a.locationMappingAttributesMap[__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_111" /* LOCATION_MAPPING_ATTR */].LIDAR_SENSOR_INDEX].localeCompare(b.locationMappingAttributesMap[__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_111" /* LOCATION_MAPPING_ATTR */].LIDAR_SENSOR_INDEX],undefined,{numeric:true,sensitivity:'base'});}else if(__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_21" /* DEVICE_TYPE */].LEAF_NODE===a.deviceType){return a.locationMappingAttributesMap[__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_111" /* LOCATION_MAPPING_ATTR */].LEAF_NODE_INDEX]&&a.locationMappingAttributesMap[__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_111" /* LOCATION_MAPPING_ATTR */].LEAF_NODE_INDEX].localeCompare(b.locationMappingAttributesMap[__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_111" /* LOCATION_MAPPING_ATTR */].LEAF_NODE_INDEX],undefined,{numeric:true,sensitivity:'base'});}}return locationLabelComparisonResult;});//Group offline devices based on device category
var groups=offlineDevicesList&&offlineDevicesList.reduce(function(groups,item){var group=groups[item.deviceType]||[];group.push(item);groups[item.deviceType]=group;return groups;},new Map());var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var getData=function getData(){setOpenAddModal(false);dispatch({type:'LOAD_MANAGE_BY_EXCEPTIONS_VIEW',data:{dispatcher:dispatch}});};//Based on device category, logic to compute location is different
var renderDeviceLocation=function renderDeviceLocation(device){if(__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_21" /* DEVICE_TYPE */].LIDAR_SENSOR===device.deviceType&&device.locationMappingAttributesMap&&device.locationMappingAttributesMap[__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_111" /* LOCATION_MAPPING_ATTR */].LIDAR_SENSOR_INDEX]){var deviceIndex=device.locationMappingAttributesMap[__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_111" /* LOCATION_MAPPING_ATTR */].LIDAR_SENSOR_INDEX];var ordinal=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["Z" /* getOrdinal */])(deviceIndex);return device.locationLabel+" ("+deviceIndex+ordinal+")";}else if(__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_21" /* DEVICE_TYPE */].LEAF_NODE===device.deviceType&&(__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_72" /* EU_OV_LOCATION_LABEL_REGEX */].test(device.locationLabel)||__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_139" /* NA_OV_LOCATION_LABEL_REGEX */].test(device.locationLabel)||__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_73" /* EU_OV_LOCATION_LABEL_REGEX_WITH_OVD */].test(device.locationLabel)||__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_140" /* NA_OV_LOCATION_LABEL_REGEX_WITH_OVD */].test(device.locationLabel))&&device.locationMappingAttributesMap&&device.locationMappingAttributesMap[__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_111" /* LOCATION_MAPPING_ATTR */].LEAF_NODE_INDEX]){var _deviceIndex=device.locationMappingAttributesMap[__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_111" /* LOCATION_MAPPING_ATTR */].LEAF_NODE_INDEX];var _ordinal=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["Z" /* getOrdinal */])(_deviceIndex);return device.locationLabel+" ("+_deviceIndex+_ordinal+")";}else if(__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_21" /* DEVICE_TYPE */].LIDAR_CONTROLLER===device.deviceType){return device.locationLabel.at(0)+" ("+device.locationLabel+")";}return device.locationLabel;};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__meridian_components_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_text___default.a,{type:"b200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"lidar.health_refresh_note",defaultMessage:"Note: Device health data is synchronized every 40 seconds."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tooltip___default.a,{position:"top",title:intl.formatMessage({id:'tooltip.scrolltobottom',defaultMessage:'Scroll to bottom!'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.device_category",defaultMessage:"Device Category"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.offline_devices_locations",defaultMessage:"Offline Devices Locations"}))),renderingOrder.map(function(deviceType){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table__["TableRow"],{key:deviceType,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_14__util_Constants__["_22" /* DEVICE_TYPE_RENDER_STRING */][deviceType])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_table__["TableCell"],null,groups[deviceType]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__meridian_components_row___default.a,{spacing:"small",wrap:"down"},groups[deviceType].map(function(device){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tooltip___default.a,{position:"top",title:device.identifier,key:device.identifier},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box___default.a,{type:"outline",spacingInset:"small"},renderDeviceLocation(device)));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.nodevice",defaultMessage:"No Device"})));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.index_interpretation",defaultMessage:"Note: Nth device(column/sensor) index denotes Nth device from conveyor side"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_link___default.a,{href:"https://w.amazon.com/bin/view/Last_Mile_Team/Smart-Station/Scanless/Lidar_Mechlite_Alpha_Launch_Plan/Maintenance_and_Troubleshooting"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.troubleshootwiki",defaultMessage:"Troubleshoot wiki"}))));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(LidarManageByExceptions));

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_LidarContextProvider__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var LidarPage=function(_Component){_inherits(LidarPage,_Component);function LidarPage(){_classCallCheck(this,LidarPage);return _possibleConstructorReturn(this,(LidarPage.__proto__||Object.getPrototypeOf(LidarPage)).apply(this,arguments));}_createClass(LidarPage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_LidarContextProvider__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["u" /* LIDARS */],location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["u" /* LIDARS */]})));}}]);return LidarPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LidarPage);

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LidarOverviewContext__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LidarTesterContext__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProvisioningContext__ = __webpack_require__(298);
/**
 * Consolidated context provider that wraps all Lidar-related contexts
 * This simplifies the component structure and provides a single entry point
 * for all Lidar contexts as suggested in the code review
 *
 * Note: This provider requires PermissionsContext to be available in the component tree
 * since LidarOverviewContextProvider depends on it for authorization checks.
 */var LidarContextProvider=function LidarContextProvider(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__LidarOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LidarTesterContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ProvisioningContext__["b" /* default */],null,children)));};/* harmony default export */ __webpack_exports__["a"] = (LidarContextProvider);

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LidarTesterReducer; });
/* unused harmony export initialSensorState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_LidarTesterUtil__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Validations__ = __webpack_require__(15);
/**
 * Validates if a LidarTester message has all required fields
 * @param {Object} message - The LidarTester message
 * @returns {boolean} - Whether the message is valid
 */var isValidLidarTesterMessage=function isValidLidarTesterMessage(message){return message&&message.aisleLabel&&message.columnLabel&&message.address!==undefined&&message.sensorIndex!==undefined;};/**
 * LidarTesterReducer - Manages sensor state mapping for Lidar testing system
 * 
 * SENSOR STATE MAP STRUCTURE:
 * sensorStateMap = {
 *   [aisleLabel]: {           // e.g., "A-1", "B2"
 *     [columnLabel]: {        // e.g., "A", "B", "AB", "TU", "WX"
 *       [columnAddress]: {    // e.g., "1.1", "1.2", "1.3"
 *         [sensorIndex]: {    // "0" or "1" (SENSOR_INDEX_ZERO/ONE)
 *           state: number,    // LIDAR_TESTER_SENSOR_STATES enum value
 *           time: number,     // timestamp
 *           value: string     // sensor reading value
 *         }
 *       }
 *     }
 *   }
 * }
 * 
 */var LidarTesterReducer=function LidarTesterReducer(state,action){switch(action.type){case"LOAD_STATE_MAP":// Check if we already have data for this controller to avoid unnecessary updates
if(state.controllerMacAddress===action.data.macAddress&&state.sensorStateMap&&Object.keys(state.sensorStateMap).length>0){return state;}return Object.assign({},state,{sensorStateMap:createMap(action.data.sortedAssetByAisle,action.data.isSensorLevelConfigEnabled,action.data.cartRecipesMap),controllerMacAddress:action.data.macAddress,columnsList:action.data.columnsList/**
         * Updates individual sensor states from incoming MQTT messages
         * 
         * COLUMN MATCHING LOGIC:
         * 1. Exact match: message.columnLabel === state column
         * 2. Component match: state column contains message.columnLabel (for unified columns)
         * 
         * SENSOR VALUE CALCULATION:
         * - OV bins (tier === -1): Use columnLabel directly
         * - Multi-column displays: Include tier + columnLabel for differentiation
         * - Single columns: Use tier value only
         */});case"UPDATE_STATE_MAP":try{// Check if this is a provisioning message (has nodeType field)
if(action.data.message.nodeType){return state;}// Validate required fields
if(!isValidLidarTesterMessage(action.data.message)){return state;}var aisleLabel=Object(__WEBPACK_IMPORTED_MODULE_1__util_LidarTesterUtil__["f" /* formatAisleLabel */])(action.data.message.aisleLabel);// Find the column that matches the incoming message (no slash notation)
var matchingColumn=null;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=state.columnsList[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var col=_step.value;// Check if column exists in state map and is not anomalous
if(!isAnomaly(state.sensorStateMap,aisleLabel,col)){// For unified columns, check if message column is a component
if(col.length>1&&col.includes(action.data.message.columnLabel)){matchingColumn=col;break;}// For exact matches
if(col===action.data.message.columnLabel){matchingColumn=col;break;}}}// If no match found in columnsList, check sensor state map directly for combined columns
// This handles cases where flex columns are marked as 'mixed' and split in UI but still exist as combined in sensor map
}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(!matchingColumn&&state.sensorStateMap[aisleLabel]){var availableColumns=Object.keys(state.sensorStateMap[aisleLabel]);var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=availableColumns[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _col=_step2.value;// Check for combined columns that contain the message column as a component
if(_col.length>1&&_col.includes(action.data.message.columnLabel)){matchingColumn=_col;break;}// Check for exact matches
if(_col===action.data.message.columnLabel){matchingColumn=_col;break;}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}if(!matchingColumn){console.log("No matching column found for LidarTester message, ignoring");return state;}if(Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return getSensorState(state.sensorStateMap,action.data.message,matchingColumn,aisleLabel);},false)){state.sensorStateMap[aisleLabel][matchingColumn][action.data.message.address][action.data.message.sensorIndex.toString()]=Object.assign({},getUpdatedSensorState(action.data.message.timestamp,action.data.message.tier,action.data.message.columnLabel,matchingColumn));}return Object.assign({},state);}catch(error){console.error("Error processing LidarTester message:",error);return state;}default:return state;}};var containsMultipleColumn=function containsMultipleColumn(displayColumnLabel){return displayColumnLabel&&displayColumnLabel.length>1;};var getSensorValue=function getSensorValue(tier,columnLabel,displayColumnLabel){//Tier value is -1 in case of OV bin label.
if(tier===-1)return columnLabel;//If displayColumnLabel is AB then sensor value should have column Label to differentiate between A or B column event.
//It is currently required for Flex rack.
return containsMultipleColumn(displayColumnLabel)?tier+columnLabel:tier;};var getUpdatedSensorState=function getUpdatedSensorState(timestamp,tier,columnLabel,displayColumnLabel){return{state:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_106" /* LIDAR_TESTER_SENSOR_STATES */].STOW_DETECTED,time:timestamp,value:getSensorValue(tier,columnLabel,displayColumnLabel)};};var getSensorState=function getSensorState(sensorStateMap,message,columnLabel,aisleLabel){return sensorStateMap[aisleLabel][columnLabel][message.address][message.sensorIndex.toString()];};var initialSensorState={state:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_106" /* LIDAR_TESTER_SENSOR_STATES */].DEFAULT,time:Date.now(),value:""};var isAnomaly=function isAnomaly(sensorStateMap,aisleLabel,label){return Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return!sensorStateMap[aisleLabel][label];},false);};/**
 * Example sensor state initialization:
 * initializeSensorStates(map, "A-1", "AB", "1.1", false)
 * Creates: map["A-1"]["AB"]["1.1"]["0"] = initialSensorState
 *         map["A-1"]["AB"]["1.1"]["1"] = initialSensorState
 */var initializeSensorStates=function initializeSensorStates(map,aisleLabel,columnLabel,columnAddress,isSensorLevelConfigEnabled){if(!map[aisleLabel][columnLabel]){map[aisleLabel][columnLabel]={};}map[aisleLabel][columnLabel][columnAddress]={};map[aisleLabel][columnLabel][columnAddress][__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_180" /* SENSOR_INDEX_ZERO */]]=initialSensorState;if(!isSensorLevelConfigEnabled){map[aisleLabel][columnLabel][columnAddress][__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_179" /* SENSOR_INDEX_ONE */]]=initialSensorState;}};/**
 * Creates the complete sensor state map from asset configuration
 * 
 * PROCESSING FLOW:
 * 1. Initialize empty aisle structures
 * 2. Separate flex vs non-flex columns per aisle
 * 3. Process flex columns with sensor sharing logic
 * 4. Process non-flex columns through label unification
 * 
 * FLEX COLUMN LOGIC:
 * - For 2-char combined labels (e.g., "JK"): Creates separate J,K columns with shared middle sensor
 * - For unified labels: Creates single combined column for all sensors
 * 
 * @param {Array} sortedAsset - Asset mappings by aisle
 * @param {boolean} isSensorLevelConfigEnabled - Controls sensor index creation
 * @param {Map} cartRecipesMap - Cart recipe configurations for flex processing
 * @returns {Object} Complete sensor state map structure
 */var createMap=function createMap(sortedAsset,isSensorLevelConfigEnabled,cartRecipesMap){var map={};if(!sortedAsset||sortedAsset.length===0)return map;// Initialize aisle maps
sortedAsset.forEach(function(assetMapping){var aisleLabel=Object(__WEBPACK_IMPORTED_MODULE_1__util_LidarTesterUtil__["f" /* formatAisleLabel */])(assetMapping.aisleLabel);map[aisleLabel]={};});// Process each aisle individually to handle mixed configurations
sortedAsset.forEach(function(assetMapping){var aisleLabel=Object(__WEBPACK_IMPORTED_MODULE_1__util_LidarTesterUtil__["f" /* formatAisleLabel */])(assetMapping.aisleLabel);if(!assetMapping.columns)return;// Separate flex and non-flex columns for this aisle
var flexColumns=[],nonFlexColumns=[];assetMapping.columns.forEach(function(column){if(__WEBPACK_IMPORTED_MODULE_3__util_Validations__["s" /* WW_FLEX_CART_RECIPES */].includes(column.cartType)){flexColumns.push(column);}else{nonFlexColumns.push(column);}});// Process flex columns for this aisle with shared middle sensor logic
if(flexColumns.length>0){Object(__WEBPACK_IMPORTED_MODULE_1__util_LidarTesterUtil__["r" /* processFlexColumns */])(flexColumns,cartRecipesMap).forEach(function(_ref){var combinedLabel=_ref.combinedLabel,group=_ref.group;// SENSOR SHARING FOR MIXED FLEX CONFIGURATIONS:
// When combinedLabel.length === 2 (e.g., "JK"):
// - Sensor 0: Left column only (J)
// - Sensor 1: Both columns (J and K) - SHARED
// - Sensor 2: Right column only (K)
// This allows one physical sensor to serve multiple logical columns
if(combinedLabel.length===2){// e.g., "JK"
var leftLabel=combinedLabel[0];// "J"
var rightLabel=combinedLabel[1];// "K"
group.forEach(function(column,index){if(index===0){// First sensor: Left column only
initializeSensorStates(map,aisleLabel,leftLabel,column.columnAddress,isSensorLevelConfigEnabled);}else if(index===1){// Middle sensor: Both columns (shared)
initializeSensorStates(map,aisleLabel,leftLabel,column.columnAddress,isSensorLevelConfigEnabled);initializeSensorStates(map,aisleLabel,rightLabel,column.columnAddress,isSensorLevelConfigEnabled);}else if(index===2){// Last sensor: Right column only
initializeSensorStates(map,aisleLabel,rightLabel,column.columnAddress,isSensorLevelConfigEnabled);}});}else{// Unified column (all aisles have flex) - use combined label
group.forEach(function(column){initializeSensorStates(map,aisleLabel,combinedLabel,column.columnAddress,isSensorLevelConfigEnabled);});}});}// Process non-flex columns through unification
if(nonFlexColumns.length>0){var device={displayableAssetMappings:[{columns:nonFlexColumns}]};var _createColumnLabelMap=Object(__WEBPACK_IMPORTED_MODULE_1__util_LidarTesterUtil__["d" /* createColumnLabelMapping */])(device),labelMapping=_createColumnLabelMap.labelMapping;nonFlexColumns.forEach(function(column){try{var originalLabel=Object(__WEBPACK_IMPORTED_MODULE_1__util_LidarTesterUtil__["i" /* getDisplayableColumnLabel */])(column.columnLabel,column.rowLabels,column.cartType);var targetLabel=labelMapping[originalLabel]||originalLabel;// DYNAMIC LABEL UNIFICATION:
// Check if this single label should be unified with adjacent labels
// Example: If labelMapping contains "TU" -> ["T", "U"], then single "T" or "U" 
// columns should use unified "TU" label for consistency across aisles
var unifiedLabel=Object.keys(labelMapping).find(function(key){return labelMapping[key]&&labelMapping[key].includes(originalLabel)&&labelMapping[key]!==originalLabel;});if(unifiedLabel&&labelMapping[originalLabel]!==unifiedLabel){// Use the unified label when other aisles have the unified version
targetLabel=unifiedLabel;}initializeSensorStates(map,aisleLabel,targetLabel,column.columnAddress,isSensorLevelConfigEnabled);}catch(error){console.error("Error processing non-flex column:",error);}});}});return map;};

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProvisioningReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initialProvisioningState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Constants__ = __webpack_require__(2);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/**
 * Validates if the provisioning message has all required fields
 * @param {Object} data - The provisioning message data
 * @returns {boolean} - Whether the message is valid
 */var isValidProvisioningMessage=function isValidProvisioningMessage(data){return data&&data.nodeType&&(data.nodeType===__WEBPACK_IMPORTED_MODULE_0__util_Constants__["Y" /* BRANCH */]||data.parentNodeIndex!==undefined)&&data.expectedNodeCount!==undefined&&data.detectedNodeCount!==undefined;};/**
 * Handles timeout for provisioning operations
 * @param {Object} state - Current state
 * @returns {Object} - New state with timeout status if applicable
 */var checkProvisioningTimeout=function checkProvisioningTimeout(state){// If provisioning is triggered but no status after timeout period, consider it timed out
if(state.provisioningTriggered&&state.provisioningStartTime&&!state.clusterStatus&&Date.now()-state.provisioningStartTime>30000){return Object.assign({},state,{clusterStatus:__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_204" /* TIMEOUT_STRING */]});}return state;};var ProvisioningReducer=function ProvisioningReducer(state,action){// First check for timeout in any operation
var currentState=checkProvisioningTimeout(state);switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__util_Constants__["_187" /* SKYLARK_PROVISIONING_ACTIONS */].INIT_PROVISIONING:return Object.assign({},currentState,{provisioningTriggered:true,provisioningData:[],clusterStatus:null,provisioningStartTime:Date.now(),lastUpdated:Date.now(),expectedBranchNodeCount:null,detectedBranchNodeCount:null});case __WEBPACK_IMPORTED_MODULE_0__util_Constants__["_187" /* SKYLARK_PROVISIONING_ACTIONS */].RESET_PROVISIONING:return Object.assign({},currentState,{provisioningTriggered:false,provisioningData:[],clusterStatus:null,provisioningStartTime:null,lastUpdated:Date.now(),expectedBranchNodeCount:null,detectedBranchNodeCount:null});case __WEBPACK_IMPORTED_MODULE_0__util_Constants__["_187" /* SKYLARK_PROVISIONING_ACTIONS */].SET_CLUSTER_STATUS:return Object.assign({},currentState,{clusterStatus:action.data.status,lastUpdated:Date.now()});case __WEBPACK_IMPORTED_MODULE_0__util_Constants__["_187" /* SKYLARK_PROVISIONING_ACTIONS */].UPDATE_PROVISIONING_DATA:try{var parsedData=action.data.message;// Validate the required fields
if(!isValidProvisioningMessage(parsedData)){console.error("Invalid provisioning data format:",parsedData);return currentState;}// If provisioning hasn't been triggered yet but we're receiving messages,
// auto-initialize the provisioning state
var newState=void 0;if(!currentState.provisioningTriggered){newState=Object.assign({},currentState,{provisioningTriggered:true,provisioningData:[],provisioningStartTime:Date.now()});}else{newState=Object.assign({},currentState);}// Handle branch provisioning status
if(parsedData.nodeType===__WEBPACK_IMPORTED_MODULE_0__util_Constants__["Y" /* BRANCH */]){// Update cluster status based on whether expected matches detected
var isSuccess=parsedData.expectedNodeCount===parsedData.detectedNodeCount;newState.clusterStatus=isSuccess?__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_194" /* SUCCESS_STRING */]:__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_71" /* ERROR_STRING */];newState.expectedBranchNodeCount=parsedData.expectedNodeCount;newState.detectedBranchNodeCount=parsedData.detectedNodeCount;}// Add the new data to our state
var existingIndex=currentState.provisioningData.findIndex(function(item){return item.nodeType===parsedData.nodeType&&(parsedData.nodeType===__WEBPACK_IMPORTED_MODULE_0__util_Constants__["Y" /* BRANCH */]||item.parentNodeIndex===parsedData.parentNodeIndex);});if(existingIndex>=0){// Update existing entry
var newData=[].concat(_toConsumableArray(currentState.provisioningData));newData[existingIndex]=Object.assign({},parsedData,{timestamp:Date.now()// Add timestamp for tracking
});newState.provisioningData=newData;}else{// Add new entry
newState.provisioningData=[].concat(_toConsumableArray(currentState.provisioningData),[Object.assign({},parsedData,{timestamp:Date.now()// Add timestamp for tracking
})]);}newState.lastUpdated=Date.now();return newState;}catch(error){console.error("Error in UPDATE_PROVISIONING_DATA:",error);return currentState;}default:return currentState;}};var initialProvisioningState={provisioningTriggered:false,provisioningData:[],clusterStatus:null,// null, 'success', 'error', 'timeout'
provisioningStartTime:null,lastUpdated:null,expectedBranchNodeCount:null,detectedBranchNodeCount:null};

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_LEDControllerOverviewContext__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__meridian_components_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_edit__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__commonui_DisableMonitoringModal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_loader__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__network_LEDControllerOverviewNetworkAPI__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__commonui_DeleteSingleDeviceModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__modal_AddSingleLedControllerModal__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__modal_UpdateDefaultSettingsModal__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__util_FeatureUtility__ = __webpack_require__(63);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var LEDControllerOverview=function LEDControllerOverview(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__context_LEDControllerOverviewContext__["a" /* LEDControllerOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),openAddModal=_useState2[0],setOpenAddModal=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({}),_useState4=_slicedToArray(_useState3,2),openActionsMenu=_useState4[0],setOpenActionsMenu=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),openMonitoringModal=_useState6[0],setOpenMonitoringModal=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),openUpdateDefaultModal=_useState8[0],setOpenUpdateDefaultModal=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),openDeleteModal=_useState10[0],setOpenDeleteModal=_useState10[1];var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])([]);var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),mac=_useState12[0],setMac=_useState12[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);var _useState13=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),_useState14=_slicedToArray(_useState13,2),remark=_useState14[0],setRemark=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),editRemark=_useState16[0],setEditRemark=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(true),_useState18=_slicedToArray(_useState17,2),isButtonDisabled=_useState18[0],setIsButtonDisabled=_useState18[1];Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(!openMonitoringModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["D" /* getAssetRefreshInterval */])());return function(){clearInterval(interval);};}},[openMonitoringModal]);var sortedDeviceList=Object.values(viewModel.ledControllerDeviceInformation);Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,viewModel.ledControllerDeviceInformation.length);if(!editRemark){setRemark(sortedDeviceList.map(function(value){return{value:value.remarks,close:true};}));}},[sortedDeviceList]);Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){var disabled=!Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["f" /* chainWalk */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_22__util_Validations__["G" /* hasAllNonNullFields */])(viewModel.selectedDefaultValues);},false);setIsButtonDisabled(disabled);},[viewModel.selectedDefaultValues]);var addData=function addData(stateValues,mac){dispatch({type:'ADD_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues,mac:mac}});};var setMonitoringStatusLoader=function setMonitoringStatusLoader(mac){dispatch({type:'SET_MONITORING_STATUS_LOADER',data:{mac:mac,monitoringStatusLoading:true}});};var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=true;setOpenActionsMenu(_open);},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=false;setOpenActionsMenu(_open);},[]);var onClickDisableMonitoring=function onClickDisableMonitoring(mac){setMac(mac);setOpenMonitoringModal(true);};var onClickDeleteDevice=function onClickDeleteDevice(mac){setMac(mac);setOpenDeleteModal(true);};var onClickEnableMonitoring=function onClickEnableMonitoring(startTime,reason,mac){var stateValues={"startTime":startTime,"endTime":Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["I" /* getCurrentDate */])().toString(),"reason":reason};setMonitoringStatusLoader(mac);addData(stateValues,mac);getData();};var onSort=function onSort(sortDetails){setEditRemark(false);dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};sortedDeviceList&&sortedDeviceList.sort(function(a,b){if(a[viewModel.sortPref.column]<b[viewModel.sortPref.column]){return viewModel.sortPref.direction==="ascending"?-1:1;}if(a[viewModel.sortPref.column]>b[viewModel.sortPref.column]){return viewModel.sortPref.direction==="ascending"?1:-1;}return 0;});var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var onClickAddDevice=function onClickAddDevice(){setOpenAddModal(true);};var onClickUpdateDefaults=function onClickUpdateDefaults(){setOpenUpdateDefaultModal(true);};var getData=function getData(){setOpenMonitoringModal(false);setOpenDeleteModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var handleInputChange=function handleInputChange(index,value){var temp=[].concat(_toConsumableArray(remark));temp[index]=Object.assign({},temp[index],{value:value});setRemark(temp);};var handleKeyDown=function handleKeyDown(index,row,event){if(event.key==="Enter"){onClickConfirmRemark(index,row);}};var onClickConfirmRemark=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(index,row){var temp;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// function to send the updated remark to post request in db
temp=[].concat(_toConsumableArray(remark));temp[index]=Object.assign({},temp[index],{close:true});setRemark(temp);_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_26__network_LEDControllerOverviewNetworkAPI__["g" /* postUpdatedRemarkToDevice */])(row,remark[index].value,dispatch);case 5:case"end":return _context.stop();}}},_callee,_this);}));return function onClickConfirmRemark(_x,_x2){return _ref2.apply(this,arguments);};}();var onClickEditRemark=function onClickEditRemark(index){setEditRemark(true);var temp=[].concat(_toConsumableArray(remark));temp[index]=Object.assign({},temp[index],{close:false});setRemark(temp);};var renderRemark=function renderRemark(device,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_row___default.a,null,remark[index]&&remark[index].close===true&&(remark[index].value===""?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_text___default.a,{truncate:"true"}," ",device.remark," "):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_text___default.a,{truncate:"true",value:remark[index].value},remark[index].value," ")),remark[index]&&remark[index].close===false?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_row___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_input___default.a,{onChange:function onChange(value){return handleInputChange(index,value);},value:remark[index].value,placeholder:"Enter remark",size:"small",autoFill:"true",focus:"true",resize:"vertical",onKeyDown:function onKeyDown(event){return handleKeyDown(index,device,event);},rows:1}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_button___default.a,{onClick:function onClick(){return onClickConfirmRemark(index,device);},size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"modal.confirm",defaultMessage:"Confirm"}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_button___default.a,{type:"link",onClick:function onClick(){return onClickEditRemark(index);},size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_edit___default.a})));};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default.a,{position:"top",title:intl.formatMessage({id:'tooltip.scrolltobottom',defaultMessage:'Scroll to bottom!'})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"alert.device",defaultMessage:"No device present for this station."})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.mac_ip",defaultMessage:"MAC/IP"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{sortColumn:"connectivity"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.connectivity",defaultMessage:"Connection Status"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{sortColumn:"location"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.location",defaultMessage:"Location"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.monitoring",defaultMessage:"Monitoring Status"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{sortColumn:"remarks"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.remarks",defaultMessage:"Remarks"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.action",defaultMessage:"Action"}))),sortedDeviceList.map(function(device,index){var monitoring=Object(__WEBPACK_IMPORTED_MODULE_22__util_Validations__["u" /* checkDeviceMonitoringEnabled */])(Number(device.startTime),Number(device.endTime));var _getMonitoringStatusD=Object(__WEBPACK_IMPORTED_MODULE_22__util_Validations__["F" /* getMonitoringStatusDetails */])(monitoring),monitoringStatusColor=_getMonitoringStatusD.monitoringStatusColor,monitoringStatusId=_getMonitoringStatusD.monitoringStatusId,monitoringStatusDefaultMessage=_getMonitoringStatusD.monitoringStatusDefaultMessage;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableRow"],{key:device.mac,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,device.mac),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),device.ip),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",{style:{color:device.connectivity.toLowerCase()===__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_145" /* ONLINE_OK */]?__WEBPACK_IMPORTED_MODULE_8__util_Constants__["X" /* BLUE_COLOR */]:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_149" /* ORANGE_COLOR */]}},device.connectivity),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),device.timestamp),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,device.location)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,viewModel.monitoringStatusLoadingDevices[device.mac]?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default.a,{position:"start",title:Object(__WEBPACK_IMPORTED_MODULE_24__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.monitoringStatusLoading'})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_loader___default.a,{size:"medium"})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",{style:{color:monitoringStatusColor}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:monitoringStatusId,defaultMessage:monitoringStatusDefaultMessage}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{width:"400px"},renderRemark(device,index)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"my-menu","aria-haspopup":"menu","aria-expanded":"false"},"..."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu___default.a,{anchorNode:actionButtonRefs.current[index],id:"my-menu",open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},monitoring.isMonitoringEnabled?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDisableMonitoring(device.mac);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_disable",defaultMessage:"Disable Monitoring"})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEnableMonitoring(device.startTime,device.reason,device.mac);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_enable",defaultMessage:"Enable Monitoring"})),__WEBPACK_IMPORTED_MODULE_30__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_30__util_FeatureUtility__["a" /* FEATURES */].IS_LED_CONTROLLER_ENHANCEMENT_ENABLED)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDeleteDevice(device.mac);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"actions.delete",defaultMessage:"Delete device"}))),openMonitoringModal&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__commonui_DisableMonitoringModal__["a" /* default */],{mac:mac,state:openMonitoringModal,onStateChange:setOpenMonitoringModal,context:__WEBPACK_IMPORTED_MODULE_3__context_LEDControllerOverviewContext__["a" /* LEDControllerOverviewContext */],reducer:'ADD_DEVICE_DATA'}),openDeleteModal&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__commonui_DeleteSingleDeviceModal__["a" /* default */],{open:openDeleteModal,setOpen:setOpenDeleteModal,selected:mac,setSelected:setMac,assetType:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_97" /* LED_CONTROLLER_ASSET_TYPE */],macAddressArray:viewModel.macAddressArray,dispatch:dispatch}))));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{ref:tableEndRef}),__WEBPACK_IMPORTED_MODULE_30__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_30__util_FeatureUtility__["a" /* FEATURES */].IS_LED_CONTROLLER_ENHANCEMENT_ENABLED)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_row___default.a,{width:"50%",widths:["auto","auto","auto"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_button___default.a,{onClick:onClickAddDevice,type:"primary",size:"small",disabled:isButtonDisabled},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"device.add_only_device_button_modal",defaultMessage:"Add Single Device Configuration"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_button___default.a,{onClick:onClickUpdateDefaults,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_edit___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"node.update_defaults_button_modal",defaultMessage:"Update Default Settings"}))),openAddModal&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__modal_AddSingleLedControllerModal__["a" /* default */],{open:openAddModal,setOpen:setOpenAddModal,context:__WEBPACK_IMPORTED_MODULE_3__context_LEDControllerOverviewContext__["a" /* LEDControllerOverviewContext */]}),openUpdateDefaultModal&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__modal_UpdateDefaultSettingsModal__["a" /* default */],{open:openUpdateDefaultModal,setOpen:setOpenUpdateDefaultModal,context:__WEBPACK_IMPORTED_MODULE_3__context_LEDControllerOverviewContext__["a" /* LEDControllerOverviewContext */]})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_intl__["d" /* injectIntl */])(LEDControllerOverview));

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonui_PageFooterModal__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__context_LEDControllerOverviewContext__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_LEDControllerUtil__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AisleRangeInputModal__ = __webpack_require__(493);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var AddSingleLedControllerModal=function AddSingleLedControllerModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__context_LEDControllerOverviewContext__["a" /* LEDControllerOverviewContext */]),viewModel=_useContext2.viewModel,dispatch=_useContext2.dispatch;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),mac=_useState4[0],setMac=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState6=_slicedToArray(_useState5,2),startAisle=_useState6[0],setStartAisle=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState8=_slicedToArray(_useState7,2),startPort=_useState8[0],setStartPort=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState10=_slicedToArray(_useState9,2),aisleCount=_useState10[0],setAisleCount=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState12=_slicedToArray(_useState11,2),aisleType=_useState12[0],setAisleType=_useState12[1];// Errors
var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),macError=_useState14[0],setMacError=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),startAisleError=_useState16[0],setStartAisleError=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState18=_slicedToArray(_useState17,2),startPortError=_useState18[0],setStartPortError=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState20=_slicedToArray(_useState19,2),aisleCountError=_useState20[0],setAisleCountError=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),aisleTypeError=_useState22[0],setAisleTypeError=_useState22[1];var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext3.showCustomAlert;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){getAisleTypes();},[]);var stateValues={ledControllerConfig:{macAddress:mac,startAisleLabel:startAisle,startPortNumber:startPort,aisleCount:aisleCount,aisleType:aisleType}};var resetAssetDetails=function resetAssetDetails(){setMac(null);setStartAisle(null);setStartPort(null);setAisleCount(null);setAisleType(null);};var resetAssetDetailErrors=function resetAssetDetailErrors(){setMacError(false);setStartAisleError(false);setStartPortError(false);setAisleCountError(false);};var resetInputState=function resetInputState(){resetAssetDetails();resetAssetDetailErrors();};var onCloseModal=function onCloseModal(){setOpen(false);resetAssetDetails();setShowAlert(false);};var addData=function addData(stateValues){var aisleDetails=Object(__WEBPACK_IMPORTED_MODULE_11__util_LEDControllerUtil__["c" /* createNextAisleConfigs */])(stateValues.ledControllerConfig,0);var model={aisleDetails:aisleDetails,macAddress:stateValues.ledControllerConfig.macAddress};dispatch({type:'ADD_NEW_DEVICE',data:{dispatcher:dispatch,model:model,showCustomAlert:showCustomAlert}});};var getAisleTypes=function getAisleTypes(){if(viewModel.aisleTypes.size===0){dispatch({type:'LOAD_AISLE_TYPES',data:{dispatcher:dispatch}});}};var onClickConfirm=function onClickConfirm(stateValues){if(Object(__WEBPACK_IMPORTED_MODULE_7__util_Validations__["Y" /* validateNewLedController */])(stateValues)){showWarning(formatMessage({id:"device.editWarning"}),function(){setShowAlert(false);addData(stateValues);resetInputState();setOpen(false);});}else{setShowAlert(true);}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.add_only_device_button_modal"}),open:open,onOpen:resetInputState,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.mac",defaultMessage:"MAC Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_input___default.a,{id:"mac-input",value:mac,onChange:setMac,mask:__WEBPACK_IMPORTED_MODULE_7__util_Validations__["i" /* MAC_MASK */],onBlur:function onBlur(){setMacError(!Object(__WEBPACK_IMPORTED_MODULE_7__util_Validations__["L" /* isValidEntry */])(stateValues.ledControllerConfig.macAddress,__WEBPACK_IMPORTED_MODULE_7__util_Validations__["j" /* PATTERNS */].MAC));},error:macError})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__AisleRangeInputModal__["a" /* default */],{startAisle:startAisle,setStartAisle:setStartAisle,startAisleError:startAisleError,setStartAisleError:setStartAisleError,startPort:startPort,setStartPort:setStartPort,startPortError:startPortError,setStartPortError:setStartPortError,aisleCount:aisleCount,setAisleCount:setAisleCount,aisleCountError:aisleCountError,setAisleCountError:setAisleCountError,aisleType:aisleType,setAisleType:setAisleType,aisleTypeError:aisleTypeError,setAisleTypeError:setAisleTypeError,getAisleTypeOptions:[].concat(_toConsumableArray(viewModel.aisleTypes),[__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_8" /* DEFAULT_AISLE_TYPE */]])||[],stateValues:stateValues})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonui_PageFooterModal__["a" /* default */],{showAlert:showAlert,onCloseModalCallBack:onCloseModal,onClickConfirmCallBack:function onClickConfirmCallBack(){return onClickConfirm(stateValues);}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */])(AddSingleLedControllerModal));

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_LEDControllerOverviewContext__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonui_PageFooterModal__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_enums__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonui_SearchableSelectModal__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var UpdateDefaultSettingsModal=function UpdateDefaultSettingsModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_LEDControllerOverviewContext__["a" /* LEDControllerOverviewContext */]),viewModel=_useContext2.viewModel,dispatch=_useContext2.dispatch;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),ledControllerType=_useState4[0],setLedControllerType=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState6=_slicedToArray(_useState5,2),aisleType=_useState6[0],setAisleType=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState8=_slicedToArray(_useState7,2),colorOrder=_useState8[0],setColorOrder=_useState8[1];// Errors
var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),ledControllerTypeError=_useState10[0],setLedControllerTypeError=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),aisleTypeError=_useState12[0],setAisleTypeError=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),colorOrderError=_useState14[0],setColorOrderError=_useState14[1];var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext3.showCustomAlert;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){getAisleTypes();dispatch({type:'LOAD_LED_CONTROLLER_TYPES',data:{dispatcher:dispatch}});},[]);var defaultValues={ledControllerDefaultValues:{ledControllerType:ledControllerType,aisleType:aisleType,colorOrder:colorOrder}};var onCloseModal=function onCloseModal(){setOpen(false);setShowAlert(false);};var generateSelectOptions=function generateSelectOptions(types){return types.map(function(type){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{key:type,value:type,label:type});});};var getAisleTypes=function getAisleTypes(){if(viewModel.aisleTypes.size===0){dispatch({type:'LOAD_AISLE_TYPES',data:{dispatcher:dispatch}});}};var setSelectedDefaultValues=function setSelectedDefaultValues(){setLedControllerType(Object(__WEBPACK_IMPORTED_MODULE_9__util_Util__["f" /* chainWalk */])(function(){return viewModel.selectedDefaultValues.ledControllerType;},''));setColorOrder(Object(__WEBPACK_IMPORTED_MODULE_9__util_Util__["f" /* chainWalk */])(function(){return viewModel.selectedDefaultValues.colorOrder;},''));};var onClickConfirm=function onClickConfirm(defaultValues){if(Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["O" /* validateLedDefaultValues */])(defaultValues)){showWarning(formatMessage({id:"device.editWarning"}),function(){setShowAlert(false);addData(defaultValues);resetInputState();setOpen(false);});}else{setShowAlert(true);}};var addData=function addData(defaultValues){dispatch({type:'SET_DEFAULT_VALUES',data:{dispatcher:dispatch,defaultValues:defaultValues,showCustomAlert:showCustomAlert}});};var resetDefaultValues=function resetDefaultValues(){setLedControllerType(null);setAisleType(null);setColorOrder(null);};var resetDefaultValueErrors=function resetDefaultValueErrors(){setLedControllerTypeError(null);setAisleTypeError(null);setColorOrderError(null);};var resetInputState=function resetInputState(){resetDefaultValues();resetDefaultValueErrors();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default.a,{title:formatMessage({id:"node.update_defaults_button_modal"}),open:open,onOpen:setSelectedDefaultValues,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"led-controller-type-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"modal.ledControllerType",defaultMessage:"LED Controller Type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{id:"led-controller-type-input",value:ledControllerType,onChange:function onChange(value){return setLedControllerType(value);},onBlur:function onBlur(){return setLedControllerTypeError(!ledControllerType);},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"modal.selectLedControllerType",defaultMessage:"Select LED Controller Type"}),error:ledControllerTypeError,width:"100%"},generateSelectOptions(viewModel.ledControllerTypes))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"searchable-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:formatMessage({id:"modal.aisletype"}),defaultMessage:"Aisle Type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonui_SearchableSelectModal__["a" /* default */],{preSelectedValue:Object(__WEBPACK_IMPORTED_MODULE_9__util_Util__["f" /* chainWalk */])(function(){return viewModel.selectedDefaultValues.aisleType;},''),error:aisleTypeError,setError:setAisleTypeError,selectedValue:aisleType,setSelectedValue:setAisleType,htmlId:"searchable-input",options:[].concat(_toConsumableArray(viewModel.aisleTypes))||[],placeholderValue:formatMessage({id:"modal.selectDefaultAisleType"}),placeholderDefaultValue:"Select Default Aisle Type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"color-order-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"modal.colorOrder",defaultMessage:"Color Order"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{id:"color-order-input",value:colorOrder,onChange:function onChange(value){return setColorOrder(value);},onBlur:function onBlur(){return setColorOrderError(!colorOrder);},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"modal.selectColorOrder",defaultMessage:"Select Color Order"}),error:colorOrderError,width:"100%"},generateSelectOptions(Object.keys(__WEBPACK_IMPORTED_MODULE_11__util_enums__["a" /* ledControllerColorOrder */]))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonui_PageFooterModal__["a" /* default */],{showAlert:showAlert,onCloseModalCallBack:onCloseModal,onClickConfirmCallBack:function onClickConfirmCallBack(){return onClickConfirm(defaultValues);}}));};UpdateDefaultSettingsModal.propTypes={intl:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.shape({formatMessage:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func.isRequired}).isRequired,open:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.bool.isRequired,setOpen:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */])(UpdateDefaultSettingsModal));

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_LEDControllerConfigurationContext__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonui_ConfigurationTabHeader__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonui_PaginatedTable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_ConditionalWrapping__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_edit__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modal_AisleRowModal__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_LEDControllerUtil__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modal_AddMultipleAisleRowsModal__ = __webpack_require__(1213);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var LEDControllerConfiguration=function LEDControllerConfiguration(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__context_LEDControllerConfigurationContext__["a" /* LEDControllerConfigurationContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext2.getDraftData,setDraftData=_useContext2.setDraftData;var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorized=_useContext3.isAuthorized;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_4" /* CONFIG_TYPE */].LED_CONTROLLER_CONFIGURATION),_useState2=_slicedToArray(_useState,2),valueConfiguration=_useState2[0],setValueConfiguration=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openAddRowsModal=_useState4[0],setOpenAddRowsModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),selectedMac=_useState6[0],setSelectedMac=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState8=_slicedToArray(_useState7,2),clipboard=_useState8[0],setClipBoard=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState10=_slicedToArray(_useState9,2),tableData=_useState10[0],setTableData=_useState10[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useContext4=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_21__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext4.showCustomAlert;var _useContext5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_21__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext5.showWarning;// Visual controls
var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),showMissingAlert=_useState12[0],setShowMissingAlert=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),showAisleDuplicateAlert=_useState14[0],setShowAisleDuplicateAlert=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),showPortDuplicateAlert=_useState16[0],setShowPortDuplicateAlert=_useState16[1];var PAGE_CONFIGURATION_KEYS=[__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_4" /* CONFIG_TYPE */].LED_CONTROLLER_CONFIGURATION];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){getAisleTypes();},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openAddRowsModal){loadDevices();var interval=setInterval(function(){if(!document.hidden){loadDevices();}},Object(__WEBPACK_IMPORTED_MODULE_8__util_Util__["D" /* getAssetRefreshInterval */])());return function(){return clearInterval(interval);};}},[openAddRowsModal]);var getAisleTypes=function getAisleTypes(){if(viewModel.aisleTypes.size===0){dispatch({type:'LOAD_AISLE_TYPES',data:{dispatcher:dispatch}});}};var loadDevices=function loadDevices(){setOpenAddRowsModal(false);dispatch({type:'LOAD_DEVICES',data:{dispatcher:dispatch}});};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(selectedMac){setDraftData({data:[],stateKey:__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_4" /* CONFIG_TYPE */].LED_CONTROLLER_CONFIGURATION,subKey:selectedMac,override:true});dispatch({type:'LOAD_ASSET_DETAIL',data:{dispatcher:dispatch,mac:selectedMac}});}else{viewModel.ledAisleData=[];}},[selectedMac]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_8__util_Util__["f" /* chainWalk */])(function(){return viewModel.ledAisleData;},[]),stateKey:__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_4" /* CONFIG_TYPE */].LED_CONTROLLER_CONFIGURATION,subKey:selectedMac,override:true});},[viewModel.ledAisleData]);var getLedDraft=function getLedDraft(){return getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_4" /* CONFIG_TYPE */].LED_CONTROLLER_CONFIGURATION,subKey:selectedMac});};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var d=getLedDraft();setTableData(d);},[getLedDraft()]);var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var getSortedDevices=function getSortedDevices(){var updatedDevices=Object.values(viewModel.ledDevices).map(function(device){return Object.assign({},device,{name:device.location});});return Object(__WEBPACK_IMPORTED_MODULE_24__util_LEDControllerUtil__["g" /* getSortedData */])(updatedDevices);};var headerProps={selectedMac:selectedMac,setSelectedMac:setSelectedMac,valueConfiguration:valueConfiguration,setValueConfiguration:setValueConfiguration,isSorterConfig:valueConfiguration===__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_4" /* CONFIG_TYPE */].LED_CONTROLLER_CONFIGURATION,intl:intl,scrollToBottom:scrollToBottom,defaultSelection:__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_4" /* CONFIG_TYPE */].LED_CONTROLLER_CONFIGURATION,sortedDeviceList:getSortedDevices(),configurationKeys:PAGE_CONFIGURATION_KEYS,refreshDeps:[viewModel.timestamp],shouldNotRenderConfigSelection:true,isViewOnly:true};var renderTableRow=function renderTableRow(config){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_table__["TableRow"],{highlightOnHover:true,key:config.index,backgroundColor:__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_148" /* OPERATION_COLOR */][config.operation]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__modal_AisleRowModal__["a" /* default */],{config:config,mac:selectedMac,getDraftData:getLedDraft,setDraftData:setDraftData,aisleTypes:[].concat(_toConsumableArray(viewModel.aisleTypes),[__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_8" /* DEFAULT_AISLE_TYPE */]])||[],clipBoard:clipboard,setClipBoard:setClipBoard}));};var renderTableHeader=function renderTableHeader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_table__["TableCell"],{sortColumn:'name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'modal.aislename',defaultMessage:'Aisle Name'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_table__["TableCell"],{sortColumn:'port'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'modal.port',defaultMessage:'Port'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_table__["TableCell"],{sortColumn:'aisleType'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'modal.aisletype',defaultMessage:'Aisle Type'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_table__["TableCell"],{sortColumn:'actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'modal.actions',defaultMessage:'Actions'})));};var onClickAddOneRow=function onClickAddOneRow(){var lastAisleConfig=Object(__WEBPACK_IMPORTED_MODULE_24__util_LEDControllerUtil__["e" /* getLastAisleConfig */])(getLedDraft());var draftData=getLedDraft();var newAisleConfig=lastAisleConfig?Object(__WEBPACK_IMPORTED_MODULE_24__util_LEDControllerUtil__["b" /* createNextAisleConfig */])(lastAisleConfig,__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_8" /* DEFAULT_AISLE_TYPE */]):Object(__WEBPACK_IMPORTED_MODULE_24__util_LEDControllerUtil__["a" /* createFirstAisleConfig */])(__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_8" /* DEFAULT_AISLE_TYPE */]);draftData=[].concat(_toConsumableArray(draftData),[newAisleConfig]);setDraftData({data:draftData,stateKey:__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_4" /* CONFIG_TYPE */].LED_CONTROLLER_CONFIGURATION,subKey:selectedMac,override:true});};var onClickAddMultipleRows=function onClickAddMultipleRows(){setOpenAddRowsModal(true);};var updateData=function updateData(stateValues){dispatch({type:'UPDATE_ASSET_DETAIL',data:{dispatcher:dispatch,mac:selectedMac,aisleDetails:stateValues,showCustomAlert:showCustomAlert}});};var onClickUpdateLEDController=function onClickUpdateLEDController(){if(!Object(__WEBPACK_IMPORTED_MODULE_20__util_Validations__["_3" /* validateUpdateLedController */])(getLedDraft(),selectedMac)){setShowMissingAlert(true);setShowAisleDuplicateAlert(false);setShowPortDuplicateAlert(false);}else if(!Object(__WEBPACK_IMPORTED_MODULE_20__util_Validations__["_2" /* validateUniqueEntries */])(Object.values(getLedDraft()).map(function(item){return item.aisleName;}))){setShowAisleDuplicateAlert(true);setShowMissingAlert(false);setShowPortDuplicateAlert(false);}else if(!Object(__WEBPACK_IMPORTED_MODULE_20__util_Validations__["_2" /* validateUniqueEntries */])(Object.values(getLedDraft()).map(function(item){return item.portNumber;}))){setShowPortDuplicateAlert(true);setShowMissingAlert(false);setShowAisleDuplicateAlert(false);}else{showWarning(intl.formatMessage({id:"ledController.editWarning"}),function(){setShowMissingAlert(false);setShowAisleDuplicateAlert(false);setShowPortDuplicateAlert(false);updateData(getLedDraft());});}};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonui_ConfigurationTabHeader__["a" /* default */],Object.assign({},headerProps,{isAuthorized:isAuthorized})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonui_PaginatedTable__["a" /* default */],{data:tableData,renderRow:renderTableRow,renderHeader:renderTableHeader}),showMissingAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_alert___default.a,{type:'warning',size:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'alert.missingfields',defaultMessage:'Please enter all fields in correct format!'})),showAisleDuplicateAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_alert___default.a,{type:'warning',size:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'alert.aisleduplicatefields',defaultMessage:'Please enter unique Aisle Name!'})),showPortDuplicateAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_alert___default.a,{type:'warning',size:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'alert.portduplicatefields',defaultMessage:'Please enter unique Port Number!'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:'100%',widths:["100","100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!selectedMac,wrapper:__WEBPACK_IMPORTED_MODULE_12__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.selectmacaddress"}),position:"top"},child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_button___default.a,{onClick:onClickAddOneRow,type:'primary',size:'small',disabled:!selectedMac},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'config.addonerow',defaultMessage:'Add One Row'}))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!selectedMac,wrapper:__WEBPACK_IMPORTED_MODULE_12__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.selectmacaddress"}),position:"top"},child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_button___default.a,{onClick:onClickAddMultipleRows,type:'primary',size:'small',disabled:!selectedMac},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'config.addmultiplerows',defaultMessage:'Add Multiple Rows'}))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!selectedMac,wrapper:__WEBPACK_IMPORTED_MODULE_12__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.selectmacaddress"}),position:"top"},child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_button___default.a,{onClick:onClickUpdateLEDController,size:'small',type:'primary',disabled:!selectedMac},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_edit___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:'config.updateledcontroller',defaultMessage:'Update LED Controller'}))})),openAddRowsModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__modal_AddMultipleAisleRowsModal__["a" /* default */],{open:openAddRowsModal,setOpen:setOpenAddRowsModal,getDraftData:getLedDraft,setDraftData:setDraftData,mac:selectedMac,aisleTypes:[].concat(_toConsumableArray(viewModel.aisleTypes),[__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_8" /* DEFAULT_AISLE_TYPE */]])||[]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(LEDControllerConfiguration));

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEDControllerConfigurationReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_LEDControllerOverviewNetworkAPI__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var LEDControllerConfigurationReducer=function LEDControllerConfigurationReducer(state,action){switch(action.type){case"RECEIVE_DEVICES":return Object.assign({},state,action.data,{loadingOverview:false});case"LOAD_DEVICES":Object(__WEBPACK_IMPORTED_MODULE_0__network_LEDControllerOverviewNetworkAPI__["e" /* getLedControllerDevices */])(action.data.dispatcher);return state;case"LOAD_AISLE_TYPES":Object(__WEBPACK_IMPORTED_MODULE_0__network_LEDControllerOverviewNetworkAPI__["b" /* getAisleTypes */])(action.data.dispatcher);return state;case"RECEIVE_AISLE_TYPES":return Object.assign({},state,action.data);case"LOAD_ASSET_DETAIL":Object(__WEBPACK_IMPORTED_MODULE_0__network_LEDControllerOverviewNetworkAPI__["c" /* getLedControllerAssetDetail */])(action.data.dispatcher,action.data.mac);return state;case"RECEIVE_ASSET_DETAIL":var fetchedLedAisleData=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return[].concat(_toConsumableArray(action.data.aisleDetails));},[]);return Object.assign({},state,{ledAisleData:fetchedLedAisleData.map(function(aisle,index){return Object.assign({},aisle,{index:index+1});})});case"UPDATE_ASSET_DETAIL":Object(__WEBPACK_IMPORTED_MODULE_0__network_LEDControllerOverviewNetworkAPI__["j" /* updateLedControllerAssetData */])(action.data.dispatcher,action.data.mac,action.data.aisleDetails,action.data.showCustomAlert);return state;default:return state;}};

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonui_SearchableSelectModal__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_LEDControllerUtil__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AisleRowModal=function AisleRowModal(props){var formatMessage=props.intl.formatMessage;var config=props.config,mac=props.mac,getDraftData=props.getDraftData,setDraftData=props.setDraftData,aisleTypes=props.aisleTypes;// States
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(config.aisleName?config.aisleName:null),_useState2=_slicedToArray(_useState,2),aisleName=_useState2[0],setAisleName=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(config.portNumber?config.portNumber:null),_useState4=_slicedToArray(_useState3,2),portNumber=_useState4[0],setPortNumber=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(config.aisleType?config.aisleType:null),_useState6=_slicedToArray(_useState5,2),aisleType=_useState6[0],setAisleType=_useState6[1];// Errors
var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),aisleNameErr=_useState8[0],setAisleNameErr=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),portNumberErr=_useState10[0],setPortNumberErr=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),aisleTypeErr=_useState12[0],setAisleTypeErr=_useState12[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var draftData=getDraftData();if(draftData&&draftData.length>0&&aisleType){var aisleConfig=Object(__WEBPACK_IMPORTED_MODULE_9__util_LEDControllerUtil__["f" /* getObjectByIndex */])(draftData,config.index);if(aisleConfig){aisleConfig.aisleType=aisleType;setDraftDataForLed(draftData);}}},[aisleType]);var setDraftDataForLed=function setDraftDataForLed(data){setDraftData({data:data,stateKey:__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_4" /* CONFIG_TYPE */].LED_CONTROLLER_CONFIGURATION,subKey:mac,override:true});};var onChangeAisleName=function onChangeAisleName(value){setAisleName(value);var draftData=getDraftData();var aisleConfig=Object(__WEBPACK_IMPORTED_MODULE_9__util_LEDControllerUtil__["f" /* getObjectByIndex */])(draftData,config.index);aisleConfig.aisleName=value;setDraftDataForLed(draftData);};var onChangePortNumber=function onChangePortNumber(value){var portNumber=parseInt(value,10);setPortNumber(value);var draftData=getDraftData();var aisleConfig=Object(__WEBPACK_IMPORTED_MODULE_9__util_LEDControllerUtil__["f" /* getObjectByIndex */])(draftData,config.index);aisleConfig.portNumber=portNumber;setDraftDataForLed(draftData);};var onRemove=function onRemove(){var draftData=getDraftData();draftData=draftData.filter(function(item){return item.index!==config.index;});setDraftDataForLed(draftData);};return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{className:"aisle-name-input",value:aisleName,onChange:onChangeAisleName,type:"text",placeholder:"Search",width:"70%",onBlur:function onBlur(){setAisleNameErr(!Object(__WEBPACK_IMPORTED_MODULE_3__util_Validations__["L" /* isValidEntry */])(aisleName,Object(__WEBPACK_IMPORTED_MODULE_3__util_Validations__["E" /* getAisleNamePattern */])())||!Object(__WEBPACK_IMPORTED_MODULE_3__util_Validations__["_2" /* validateUniqueEntries */])(Object.values(getDraftData()).map(function(item){return item.aisleName;})));},error:aisleNameErr,size:"small"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{className:"port-number-input",value:portNumber,onChange:onChangePortNumber,type:"text",placeholder:"Search",width:"70%",size:"small",onBlur:function onBlur(){setPortNumberErr(!Object(__WEBPACK_IMPORTED_MODULE_3__util_Validations__["L" /* isValidEntry */])(portNumber,__WEBPACK_IMPORTED_MODULE_3__util_Validations__["j" /* PATTERNS */].PORT)||!Object(__WEBPACK_IMPORTED_MODULE_3__util_Validations__["_2" /* validateUniqueEntries */])(Object.values(getDraftData()).map(function(item){return item.portNumber;})));},error:portNumberErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,{width:"80%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonui_SearchableSelectModal__["a" /* default */],{preSelectedValue:aisleType?aisleType:__WEBPACK_IMPORTED_MODULE_7__util_Constants__["_8" /* DEFAULT_AISLE_TYPE */],error:aisleTypeErr,setError:setAisleTypeErr,selectedValue:aisleType,setSelectedValue:setAisleType,options:aisleTypes,htmlId:"searchable-input",placeholderValue:formatMessage({id:"modal.selectAisleType"}),placeholderDefaultValue:"Select Aisle Type"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{type:"tertiary",size:"small",onClick:onRemove},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */],{id:"modal.remove",defaultMessage:"Remove"})))];};AisleRowModal.propTypes={intl:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape({formatMessage:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired}).isRequired,config:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object,mac:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string.isRequired,getDraftData:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,setDraftData:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,aisleTypes:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(AisleRowModal));

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_PageFooterModal__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AisleRangeInputModal__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_LEDControllerUtil__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var AddMultipleAisleRowsModal=function AddMultipleAisleRowsModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,getDraftData=props.getDraftData,setDraftData=props.setDraftData,mac=props.mac,aisleTypes=props.aisleTypes;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),startAisle=_useState4[0],setStartAisle=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState6=_slicedToArray(_useState5,2),startPort=_useState6[0],setStartPort=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState8=_slicedToArray(_useState7,2),aisleCount=_useState8[0],setAisleCount=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState10=_slicedToArray(_useState9,2),aisleType=_useState10[0],setAisleType=_useState10[1];// Errors
var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),startAisleError=_useState12[0],setStartAisleError=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),startPortError=_useState14[0],setStartPortError=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),aisleCountError=_useState16[0],setAisleCountError=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState18=_slicedToArray(_useState17,2),aisleTypeError=_useState18[0],setAisleTypeError=_useState18[1];var stateValues={ledControllerConfig:{startAisleLabel:startAisle,startPortNumber:startPort,aisleCount:aisleCount,aisleType:aisleType}};var resetAssetDetails=function resetAssetDetails(){setStartAisle(null);setStartPort(null);setAisleCount(null);setAisleType(null);};var resetAssetDetailErrors=function resetAssetDetailErrors(){setStartAisleError(false);setStartPortError(false);setAisleCountError(false);};var resetInputState=function resetInputState(){resetAssetDetails();resetAssetDetailErrors();};var onCloseModal=function onCloseModal(){setOpen(false);resetAssetDetails();setShowAlert(false);};var addData=function addData(aisleConfigs){setDraftData({data:aisleConfigs,stateKey:__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_4" /* CONFIG_TYPE */].LED_CONTROLLER_CONFIGURATION,subKey:mac,override:true});};var onClickConfirm=function onClickConfirm(stateValues){if(Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["M" /* validateAddAislesForLedController */])(stateValues)){setShowAlert(false);var lastAisleConfig=Object(__WEBPACK_IMPORTED_MODULE_8__util_LEDControllerUtil__["e" /* getLastAisleConfig */])(getDraftData());var nextAisleConfigs=Object(__WEBPACK_IMPORTED_MODULE_8__util_LEDControllerUtil__["c" /* createNextAisleConfigs */])(stateValues.ledControllerConfig,lastAisleConfig?lastAisleConfig.index:1);addData([].concat(_toConsumableArray(getDraftData()),_toConsumableArray(nextAisleConfigs)));resetInputState();setOpen(false);}else{setShowAlert(true);}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.add_aisles_button_modal"}),open:open,onOpen:resetInputState,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__AisleRangeInputModal__["a" /* default */],{startAisle:startAisle,setStartAisle:setStartAisle,startAisleError:startAisleError,setStartAisleError:setStartAisleError,startPort:startPort,setStartPort:setStartPort,startPortError:startPortError,setStartPortError:setStartPortError,aisleCount:aisleCount,setAisleCount:setAisleCount,aisleCountError:aisleCountError,setAisleCountError:setAisleCountError,aisleType:aisleType,setAisleType:setAisleType,aisleTypeError:aisleTypeError,setAisleTypeError:setAisleTypeError,getAisleTypeOptions:aisleTypes,stateValues:stateValues})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_PageFooterModal__["a" /* default */],{showAlert:showAlert,onCloseModalCallBack:onCloseModal,onClickConfirmCallBack:function onClickConfirmCallBack(){return onClickConfirm(stateValues);}}));};AddMultipleAisleRowsModal.propTypes={intl:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape({formatMessage:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired}).isRequired,open:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool.isRequired,setOpen:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,getDraftData:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,setDraftData:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,mac:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,aisleTypes:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(AddMultipleAisleRowsModal));

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_SBLDashboardContext__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_tokens_base_icon_download_small__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_tokens_base_icon_download_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_tokens_base_icon_download_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_checkbox__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ledcontrollerstag_CartFilterPanel__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ledcontrollerstag_CartFilterUtils__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ledcontrollerstag_SBLCommandUtils__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__network_SBLDashboardNetworkAPI__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__commonui_SearchFilterBar__ = __webpack_require__(1226);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var getBatteryColor=function getBatteryColor(battery){var value=parseInt(battery,10);if(isNaN(value))return __WEBPACK_IMPORTED_MODULE_15__util_Constants__["_149" /* ORANGE_COLOR */];return value<__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_113" /* LOW_BATTERY_THRESHOLD */]?__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_149" /* ORANGE_COLOR */]:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["X" /* BLUE_COLOR */];};var SBLDashboard=function SBLDashboard(){var _useSBLDashboard=Object(__WEBPACK_IMPORTED_MODULE_2__context_SBLDashboardContext__["b" /* useSBLDashboard */])(),viewModel=_useSBLDashboard.viewModel,dispatch=_useSBLDashboard.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isFiltered=_useState2[0],setIsFiltered=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(new Set()),_useState4=_slicedToArray(_useState3,2),selectedCarts=_useState4[0],setSelectedCarts=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_15__util_Constants__["H" /* ANDON_COLORS */][0].value),_useState6=_slicedToArray(_useState5,2),color=_useState6[0],setColor=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_11" /* DEFAULT_DURATION */]),_useState8=_slicedToArray(_useState7,2),duration=_useState8[0],setDuration=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),sending=_useState10[0],setSending=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState12=_slicedToArray(_useState11,2),commandResult=_useState12[0],setCommandResult=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([{key:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_14" /* DEFAULT_SORT_COLUMN */],value:''}]),_useState14=_slicedToArray(_useState13,2),searchFilters=_useState14[0],setSearchFilters=_useState14[1];Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_172" /* SBL_DASHBOARD_ACTIONS */].LOAD_VIEW});Object(__WEBPACK_IMPORTED_MODULE_20__network_SBLDashboardNetworkAPI__["b" /* initStationConfig */])(dispatch);Object(__WEBPACK_IMPORTED_MODULE_20__network_SBLDashboardNetworkAPI__["a" /* fetchSBLDashboardData */])(dispatch);},[dispatch]);var onSort=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function(sortDetails){dispatch({type:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_172" /* SBL_DASHBOARD_ACTIONS */].SORT_DATA,data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});},[dispatch]);var _useMemo=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])(function(){var allData=viewModel.resourceDynamicAttributes||[];var displayData=isFiltered?Object(__WEBPACK_IMPORTED_MODULE_18__ledcontrollerstag_CartFilterUtils__["a" /* applyPercentileFilter */])(allData,viewModel.percentileThreshold):allData;var searchedData=displayData.filter(function(item){return searchFilters.every(function(_ref){var key=_ref.key,value=_ref.value;if(!value)return true;var query=value.toLowerCase();var itemValue=key===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_14" /* DEFAULT_SORT_COLUMN */]?item.scannableId:(item.dynamicAttributes||{})[key];if(!itemValue)return false;var normalizedItem=itemValue.toLowerCase();if(normalizedItem.includes(query))return true;if(key===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_14" /* DEFAULT_SORT_COLUMN */]){var cartNumber=itemValue.split('-').pop();return cartNumber===query.replace(/^0+/,'')||cartNumber===query;}return false;});});var _viewModel$sortPref=viewModel.sortPref,column=_viewModel$sortPref.column,direction=_viewModel$sortPref.direction;var sorted=[].concat(_toConsumableArray(searchedData)).sort(function(a,b){var valA=void 0,valB=void 0;if(column===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["W" /* BATTERY_COLUMN */]){valA=parseInt((a.dynamicAttributes||{})[__WEBPACK_IMPORTED_MODULE_15__util_Constants__["W" /* BATTERY_COLUMN */]],10)||0;valB=parseInt((b.dynamicAttributes||{})[__WEBPACK_IMPORTED_MODULE_15__util_Constants__["W" /* BATTERY_COLUMN */]],10)||0;}else if(column===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_78" /* FLOOR_LOCATION_COLUMN */]){valA=(a.dynamicAttributes||{})[__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_78" /* FLOOR_LOCATION_COLUMN */]]||"";valB=(b.dynamicAttributes||{})[__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_78" /* FLOOR_LOCATION_COLUMN */]]||"";}else{valA=a[column]||"";valB=b[column]||"";}if(valA<valB)return direction===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["J" /* ASCENDING */]?-1:1;if(valA>valB)return direction===__WEBPACK_IMPORTED_MODULE_15__util_Constants__["J" /* ASCENDING */]?1:-1;return 0;});var ids=sorted.map(function(d){return d.scannableId;});var allSel=ids.length>0&&ids.every(function(id){return selectedCarts.has(id);});return{filteredData:sorted,filteredIds:ids,allSelected:allSel};},[viewModel.resourceDynamicAttributes,viewModel.percentileThreshold,viewModel.sortPref,isFiltered,selectedCarts,searchFilters]),filteredData=_useMemo.filteredData,filteredIds=_useMemo.filteredIds,allSelected=_useMemo.allSelected;var handleSendOn=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var ids,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:ids=Array.from(selectedCarts);if(!(ids.length===0)){_context.next=3;break;}return _context.abrupt("return");case 3:setSending(true);setCommandResult(null);_context.prev=5;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_19__ledcontrollerstag_SBLCommandUtils__["b" /* sendOnCommand */])(ids,color,duration);case 8:result=_context.sent;setCommandResult(Object.assign({command:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_108" /* LIGHT_COMMAND_ON */]},result));_context.next=15;break;case 12:_context.prev=12;_context.t0=_context["catch"](5);setCommandResult({command:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_108" /* LIGHT_COMMAND_ON */],succeeded:0,failed:ids.length,total:ids.length});case 15:_context.prev=15;setSending(false);return _context.finish(15);case 18:case"end":return _context.stop();}}},_callee,_this,[[5,12,15,18]]);})),[selectedCarts,color,duration]);var handleSendOff=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var ids,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:ids=Array.from(selectedCarts);if(!(ids.length===0)){_context2.next=3;break;}return _context2.abrupt("return");case 3:setSending(true);setCommandResult(null);_context2.prev=5;_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_19__ledcontrollerstag_SBLCommandUtils__["a" /* sendOffCommand */])(ids);case 8:result=_context2.sent;setCommandResult(Object.assign({command:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_107" /* LIGHT_COMMAND_OFF */]},result));_context2.next=15;break;case 12:_context2.prev=12;_context2.t0=_context2["catch"](5);setCommandResult({command:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_107" /* LIGHT_COMMAND_OFF */],succeeded:0,failed:ids.length,total:ids.length});case 15:_context2.prev=15;setSending(false);return _context2.finish(15);case 18:case"end":return _context2.stop();}}},_callee2,_this,[[5,12,15,18]]);})),[selectedCarts]);var toggleCartSelection=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function(scannableId){setSelectedCarts(function(prev){var next=new Set(prev);if(next.has(scannableId))next.delete(scannableId);else next.add(scannableId);return next;});},[]);var toggleSelectAll=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function(ids){setSelectedCarts(function(prev){var allSel=ids.every(function(id){return prev.has(id);});if(allSel)return new Set();return new Set(ids);});},[]);var handleDownload=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function(){var headers=['Cart ID','Battery (%)','Location','Dev EUI','Version','Is Charging'];var rows=filteredData.map(function(item){var attrs=item.dynamicAttributes||{};return[item.scannableId,attrs[__WEBPACK_IMPORTED_MODULE_15__util_Constants__["W" /* BATTERY_COLUMN */]]||'',attrs[__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_78" /* FLOOR_LOCATION_COLUMN */]]||'',attrs.dev_eui||'',attrs.version||'',attrs.is_charging||''].join(',');});var csv=[headers.join(',')].concat(_toConsumableArray(rows)).join('\n');Object(__WEBPACK_IMPORTED_MODULE_16__util_Util__["s" /* createDownloadableFile */])(Object(__WEBPACK_IMPORTED_MODULE_16__util_Util__["x" /* generateFileName */])('SBL_Dashboard_'+(Object(__WEBPACK_IMPORTED_MODULE_16__util_Util__["X" /* getNodeId */])()||'')),csv);},[filteredData]);var allData=viewModel.resourceDynamicAttributes||[];var percentile=viewModel.percentileThreshold;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacing:"medium"},viewModel.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__loader_Loader__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,viewModel.error&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_alert___default.a,{type:"error",size:"small"},viewModel.error),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ledcontrollerstag_CartFilterPanel__["a" /* default */],{percentileThreshold:percentile,isFiltered:isFiltered,onToggleFilter:function onToggleFilter(){return setIsFiltered(function(prev){return!prev;});},matchCount:filteredData.length,totalCount:allData.length}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__commonui_SearchFilterBar__["a" /* default */],{filters:searchFilters,onFiltersChange:setSearchFilters,filterColumns:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_174" /* SBL_FILTER_COLUMNS */]}),commandResult&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_alert___default.a,{type:commandResult.failed===0?"success":"warning",size:"small",onClose:function onClose(){return setCommandResult(null);}},commandResult.command," command: ",commandResult.succeeded,"/",commandResult.total," succeeded",commandResult.failed>0&&", "+commandResult.failed+" failed"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default.a,{alignmentVertical:"bottom",alignmentHorizontal:"justify",spacing:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default.a,{alignmentVertical:"bottom",spacing:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacing:"xsmall"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{type:"b200"},"Color"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default.a,{value:color,onChange:setColor,size:"small"},__WEBPACK_IMPORTED_MODULE_15__util_Constants__["H" /* ANDON_COLORS */].map(function(c){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__["SelectOption"],{key:c.value,value:c.value,label:c.label});}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacing:"xsmall"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{type:"b200"},"Timer"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default.a,{value:duration,onChange:setDuration,size:"small"},__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_205" /* TIMER_OPTIONS */].map(function(t){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__["SelectOption"],{key:t.value,value:t.value,label:t.label});}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:handleSendOn,disabled:sending||selectedCarts.size===0},"Send ON (",selectedCarts.size,")"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{type:"secondary",size:"small",onClick:handleSendOff,disabled:sending||selectedCarts.size===0},"Send OFF (",selectedCarts.size,")"),selectedCarts.size>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{type:"tertiary",size:"small",onClick:function onClick(){return setSelectedCarts(new Set());}},"Clear Selection")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{type:"tertiary",size:"small",onClick:handleDownload,disabled:filteredData.length===0},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_tokens_base_icon_download_small___default.a}),"Download CSV")),filteredData.length===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */],{id:"sbl.dashboard.nodata",defaultMessage:"No data available."})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_checkbox___default.a,{checked:allSelected,onChange:function onChange(){return toggleSelectAll(filteredIds);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],{sortColumn:"scannableId"},"Cart ID"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],{sortColumn:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["W" /* BATTERY_COLUMN */]},"Battery (%)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],{sortColumn:__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_78" /* FLOOR_LOCATION_COLUMN */]},"Location"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,"Dev EUI"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,"Version"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,"Is Charging")),filteredData.map(function(item){var attrs=item.dynamicAttributes||{};var batteryColor=getBatteryColor(attrs[__WEBPACK_IMPORTED_MODULE_15__util_Constants__["W" /* BATTERY_COLUMN */]]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableRow"],{key:item.scannableId,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_checkbox___default.a,{checked:selectedCarts.has(item.scannableId),onChange:function onChange(){return toggleCartSelection(item.scannableId);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",null,item.scannableId)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b",{style:{color:batteryColor}},attrs[__WEBPACK_IMPORTED_MODULE_15__util_Constants__["W" /* BATTERY_COLUMN */]]||__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_26" /* EMPTY_STRING_PLACEHOLDER */])),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,attrs[__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_78" /* FLOOR_LOCATION_COLUMN */]]||__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_26" /* EMPTY_STRING_PLACEHOLDER */]),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,attrs.dev_eui||__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_26" /* EMPTY_STRING_PLACEHOLDER */]),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,attrs.version||__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_26" /* EMPTY_STRING_PLACEHOLDER */]),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,attrs.is_charging||__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_26" /* EMPTY_STRING_PLACEHOLDER */]));})))));};/* harmony default export */ __webpack_exports__["a"] = (SBLDashboard);

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SBLDashboardReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Constants__ = __webpack_require__(2);
var SBLDashboardReducer=function SBLDashboardReducer(state,action){switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__util_Constants__["_172" /* SBL_DASHBOARD_ACTIONS */].LOAD_VIEW:return Object.assign({},state,{loading:true,error:null});case __WEBPACK_IMPORTED_MODULE_0__util_Constants__["_172" /* SBL_DASHBOARD_ACTIONS */].RECEIVE_CONFIG:return Object.assign({},state,{percentileThreshold:action.data||__WEBPACK_IMPORTED_MODULE_0__util_Constants__["_13" /* DEFAULT_PERCENTILE */]});case __WEBPACK_IMPORTED_MODULE_0__util_Constants__["_172" /* SBL_DASHBOARD_ACTIONS */].RECEIVE_DATA:return Object.assign({},state,{resourceDynamicAttributes:action.data,loading:false,error:null});case __WEBPACK_IMPORTED_MODULE_0__util_Constants__["_172" /* SBL_DASHBOARD_ACTIONS */].RECEIVE_ERROR:return Object.assign({},state,{resourceDynamicAttributes:[],loading:false,error:action.data});case __WEBPACK_IMPORTED_MODULE_0__util_Constants__["_172" /* SBL_DASHBOARD_ACTIONS */].SORT_DATA:return Object.assign({},state,{sortPref:action.data});default:return state;}};

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tag__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Constants__ = __webpack_require__(2);
var CartFilterPanel=function CartFilterPanel(_ref){var percentileThreshold=_ref.percentileThreshold,isFiltered=_ref.isFiltered,onToggleFilter=_ref.onToggleFilter,matchCount=_ref.matchCount,totalCount=_ref.totalCount;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_box___default.a,{type:"outline",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{alignmentVertical:"center",spacing:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default.a,{type:isFiltered?"primary":"secondary",size:"small",onClick:onToggleFilter,"aria-pressed":isFiltered,"aria-label":__WEBPACK_IMPORTED_MODULE_8__util_Constants__["Z" /* CART_FILTER_PANEL_STRINGS */].TOGGLE_FILTER_ARIA_DEFAULT},isFiltered?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["Z" /* CART_FILTER_PANEL_STRINGS */].SHOW_ALL,defaultMessage:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["Z" /* CART_FILTER_PANEL_STRINGS */].SHOW_ALL_DEFAULT}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["Z" /* CART_FILTER_PANEL_STRINGS */].SELECT_BOTTOM,defaultMessage:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["Z" /* CART_FILTER_PANEL_STRINGS */].SELECT_BOTTOM_DEFAULT,values:{threshold:percentileThreshold}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_tag___default.a,{type:"theme"},isFiltered?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["Z" /* CART_FILTER_PANEL_STRINGS */].CART_COUNT_FILTERED,defaultMessage:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["Z" /* CART_FILTER_PANEL_STRINGS */].CART_COUNT_FILTERED_DEFAULT,values:{matchCount:matchCount,totalCount:totalCount}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["Z" /* CART_FILTER_PANEL_STRINGS */].CART_COUNT,defaultMessage:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["Z" /* CART_FILTER_PANEL_STRINGS */].CART_COUNT_DEFAULT,values:{matchCount:matchCount,totalCount:totalCount}})),!isFiltered&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_text___default.a,{type:"b200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["Z" /* CART_FILTER_PANEL_STRINGS */].PERCENTILE_THRESHOLD,defaultMessage:__WEBPACK_IMPORTED_MODULE_8__util_Constants__["Z" /* CART_FILTER_PANEL_STRINGS */].PERCENTILE_THRESHOLD_DEFAULT,values:{threshold:percentileThreshold}}))));};CartFilterPanel.propTypes={percentileThreshold:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,isFiltered:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onToggleFilter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,matchCount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,totalCount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};CartFilterPanel.defaultProps={percentileThreshold:0,isFiltered:false,matchCount:0,totalCount:0};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(CartFilterPanel));

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tag = _interopRequireDefault(__webpack_require__(1218));

var _default = _tag["default"];
exports["default"] = _default;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _statusTag = _interopRequireDefault(__webpack_require__(1219));

var _dismissibleTag = _interopRequireDefault(__webpack_require__(1221));

var Tag = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return props.onClose && (props.type === "theme" || props.type === "neutral") && props.children ? /*#__PURE__*/_react["default"].createElement(_dismissibleTag["default"], {
    onClose: props.onClose,
    closeLabel: props.closeLabel,
    type: props.type,
    ref: ref,
    tabIndex: props.tabIndex,
    "aria-label": props["aria-label"]
  }, props.children) : /*#__PURE__*/_react["default"].createElement(_statusTag["default"], {
    type: props.type,
    ref: ref,
    tabIndex: props.tabIndex,
    "aria-label": props["aria-label"]
  }, props.children);
});

Tag.displayName = "Tag";
Tag.propTypes = {
  /**
   * An accessible label for the component. This will not be visible in the UI,
   * but will be read by screen readers. This is particularly helpful for
   * compact tags which don't have textual content.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   */
  "aria-label": _propTypes["default"].string,

  /**
   * The tag's label. Omit this to render a compact tag.
   */
  children: _propTypes["default"].string,

  /**
   * An accessible label for the tag's dismiss button. This is not shown in
   * the UI, but will be read by screen-readers.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * If this is not specified the component will not be focuseable.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   *
   * @since 5.14.0
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The visual style of the tag.
   */
  type: _propTypes["default"].oneOf(["theme", "neutral", "success", "warning", "error"]),

  /**
   * If `type` is set to `"theme"` or `"neutral"`, a function can be provided
   * here to render a dismissable tag.
   *
   * This prop will be ignored for compact tags (if `children` is not set) or
   * for tags that are not of type `"theme"` or `"neutral"`.
   */
  onClose: _propTypes["default"].func
};
Tag.defaultProps = {
  type: "theme"
};
var _default = Tag;
exports["default"] = _default;

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _tag = _interopRequireDefault(__webpack_require__(301));

var _theme = __webpack_require__(24);

var _buttonReset = _interopRequireDefault(__webpack_require__(344));

var _token = __webpack_require__(20);

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _text = _interopRequireDefault(__webpack_require__(47));

var _focusRing = _interopRequireDefault(__webpack_require__(73));

var _indicator = _interopRequireDefault(__webpack_require__(1220));

/**
 * Styles
 */
var wrapperStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var focus = _ref.focus;
  return (0, _emotion.css)({
    // HACK: This is necessary to keep IE11 from allowing the tag's text to overflow
    // the boundaries of the tag. When we drop IE11 support this wrapper can be
    // removed and the "display" property of the styles below can be changed from
    // "inline-block" to "inline-flex" and other styles can move to `styles`.
    display: "inline-block"
  }, {
    outline: "none",
    "& > div > div": (0, _focusRing["default"])(t.tokens, {
      focus: focus,
      offset: t("focusOutlineOffset"),
      borderRadius: t("borderRadius"),
      borderWidth: t("borderWidth"),
      dropShadow: t.boxShadowCss("dropShadowHover")
    })
  });
}, ["focus"]);
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var type = _ref2.type,
      children = _ref2.children;
  return (0, _emotion.css)(_buttonReset["default"], (0, _text["default"])(t), {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: t("height"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
  }, children === undefined ? {
    width: t("height"),
    "& > div": {
      borderRadius: t("borderCompactRadius"),
      borderWidth: t("borderCompactWidth"),
      borderStyle: "solid",
      borderColor: t("borderColorCompact"),
      boxSizing: "border-box"
    }
  } : (0, _defineProperty2["default"])({
    borderRadius: t("borderRadius"),
    borderWidth: t("borderWidth"),
    borderStyle: "solid",
    borderColor: t("borderColorStatus", type),
    // HACK: IE11 does not support padding-inline-* so we have to use
    // directional padding-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   paddingInlineStart: t("spacingInsetStatusLeft"),
    //   paddingInlineEnd: t("spacingInsetStatusRight"),
    // },
    paddingRight: t("spacingInsetStatusRight"),
    paddingLeft: t("spacingInsetStatusLeft")
  }, "[dir=\"rtl\"] &", {
    paddingLeft: t("spacingInsetStatusRight"),
    paddingRight: t("spacingInsetStatusLeft")
  }));
}, ["type", "children"]);
/**
 * Component
 */

var StatusTag = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_tag["default"], "tag");

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var compact = typeof props.children === "undefined" ? true : false;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: wrapperStyles(t, {
      focus: focus && focusTrigger === "keyboard"
    }),
    ref: ref,
    "aria-label": props["aria-label"],
    tabIndex: props.tabIndex
  }, focusProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, props)
  }, /*#__PURE__*/_react["default"].createElement(_indicator["default"], {
    type: props.type,
    compact: compact
  }), /*#__PURE__*/_react["default"].createElement("span", null, props.children)));
});

StatusTag.displayName = "StatusTag";
StatusTag.propTypes =  false ? {
  "aria-label": _propTypes["default"].string,
  children: _propTypes["default"].string,
  tabIndex: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(["success", "warning", "error", "theme", "neutral"])
} : {};
StatusTag.defaultProps = {
  type: "theme"
};
var _default = StatusTag;
exports["default"] = _default;

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(11);

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _tag = _interopRequireDefault(__webpack_require__(301));

var _theme = __webpack_require__(24);

/**
 * Styles
 */
var styles = function styles(t, _ref) {
  var _css;

  var type = _ref.type,
      compact = _ref.compact;
  return (0, _emotion.css)((_css = {
    display: "inline-block",
    width: t("indicatorDiameter"),
    height: t("indicatorDiameter"),
    backgroundColor: t("borderColorStatus", type),
    borderRadius: t("indicatorDiameter") / 2,
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   marginInlineStart: compact ? 0 : t("spacingHorizontal"),
    // },
    marginRight: compact ? 0 : t("spacingHorizontal")
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    marginRight: 0,
    marginLeft: compact ? 0 : t("spacingHorizontal")
  }), (0, _defineProperty2["default"])(_css, "flexShrink", 0), _css));
};
/**
 * Component
 */


function Indicator(props) {
  var t = (0, _theme.useTheme)(_tag["default"], "tag");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, props)
  });
}

Indicator.propTypes =  false ? {
  compact: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(["success", "warning", "error", "theme", "neutral"])
} : {};
Indicator.defaultProps = {
  type: "theme"
};
var _default = Indicator;
exports["default"] = _default;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireDefault(__webpack_require__(0));

var _emotion = __webpack_require__(11);

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _tag = _interopRequireDefault(__webpack_require__(301));

var _closeKnockout = _interopRequireDefault(__webpack_require__(1222));

var _theme = __webpack_require__(24);

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _clickable = _interopRequireDefault(__webpack_require__(108));

var _icon = _interopRequireDefault(__webpack_require__(16));

var _token = __webpack_require__(20);

var _focusRing = _interopRequireDefault(__webpack_require__(73));

var _text = _interopRequireDefault(__webpack_require__(47));

/**
 * Styles
 */
var clickTargetSize = 20;
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var _button, _css;

  var type = _ref.type;
  // This is the horizontal distance between the end of the icon and the end of the clickable,
  // on both the left and right side.
  var iconClickableXDelta = (clickTargetSize - t("closeIconSize")) / 2;
  return (0, _emotion.css)((0, _text["default"])(t), (_css = {
    backgroundColor: t("backgroundColorDismissible", type),
    borderRadius: t("borderRadius"),
    // HACK: IE11 does not support padding-inline-* so we have to use
    // directional padding-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   paddingInlineStart: t("spacingInsetDismissibleLeft"),
    //   paddingInlineEnd: `calc(${iconClickableXDelta}px - ${t(
    //           "spacingInsetDismissibleRight"
    //         )}px) `,
    // },
    paddingRight: "calc(".concat(iconClickableXDelta, "px - ").concat(t("spacingInsetDismissibleRight"), "px) "),
    paddingLeft: t("spacingInsetDismissibleLeft")
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    paddingRight: t("spacingInsetDismissibleLeft"),
    paddingLeft: "calc(".concat(iconClickableXDelta, "px - ").concat(t("spacingInsetDismissibleRight"), "px)")
  }), (0, _defineProperty2["default"])(_css, "display", "inline-flex"), (0, _defineProperty2["default"])(_css, "alignItems", "center"), (0, _defineProperty2["default"])(_css, "justifyContent", "center"), (0, _defineProperty2["default"])(_css, "height", t("height")), (0, _defineProperty2["default"])(_css, "lineHeight", "".concat(t("height"), "px")), (0, _defineProperty2["default"])(_css, "whiteSpace", "nowrap"), (0, _defineProperty2["default"])(_css, "& > button", (_button = {
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   marginInlineStart: `calc(${t("spacingHorizontal")}px - ${iconClickableXDelta}px)`,
    // },
    marginLeft: "calc(".concat(t("spacingHorizontal"), "px - ").concat(iconClickableXDelta, "px)")
  }, (0, _defineProperty2["default"])(_button, "[dir=\"rtl\"] &", {
    marginRight: "calc(".concat(t("spacingHorizontal"), "px - ").concat(iconClickableXDelta, "px)"),
    marginLeft: 0
  }), (0, _defineProperty2["default"])(_button, "lineHeight", 0), _button)), _css));
}, ["type"]);
var buttonStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var focus = _ref2.focus;
  var iconClickableXDelta = (clickTargetSize - t("closeIconSize")) / 2;
  return (0, _emotion.css)((0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderRadius: 999,
    offset: 4 - iconClickableXDelta
  }), {
    width: clickTargetSize,
    height: clickTargetSize,
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center"
  });
}, ["focus"]);
var closeIconStyles = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var type = _ref3.type;
  return (0, _emotion.css)({
    width: t("closeIconSize"),
    height: t("closeIconSize"),
    color: t("closeIconColorDismissible", [type, "default"]),
    "button:hover &": {
      color: t("closeIconColorDismissible", [type, "hover"])
    },
    "button:active &": {
      color: t("closeIconColorDismissible", [type, "pressed"])
    },
    transition: t.transitionCss("closeIconMotion", "color")
  });
}, ["type"]);
/**
 * Component
 */

var DissmissibleTag = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_tag["default"], "tag");

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, {
      type: props.type
    }),
    ref: ref,
    "aria-label": props["aria-label"]
  }, /*#__PURE__*/_react["default"].createElement("span", null, props.children), /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({
    onClick: props.onClose,
    className: buttonStyles(t, {
      focus: focus && focusTrigger === "keyboard"
    })
  }, focusProps, {
    tabIndex: props.tabIndex,
    "aria-label": props.closeLabel
  }), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: closeIconStyles(t, props),
    tokens: _closeKnockout["default"]
  })));
});

DissmissibleTag.displayName = "DissmissibleTag";
DissmissibleTag.propTypes =  false ? {
  children: _propTypes["default"].string.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  "aria-label": _propTypes["default"].string,
  closeLabel: _propTypes["default"].string,
  tabIndex: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(["theme", "neutral"])
} : {};
DissmissibleTag.defaultProps = {
  type: "theme"
};
var _default = DissmissibleTag;
exports["default"] = _default;

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCloseKnockoutData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M9.411 8.003l2.126-2.126a1 1 0 10-1.414-1.414L7.998 6.588l-2.12-2.124a1 1 0 10-1.416 1.412l2.122 2.126-2.121 2.12a1 1 0 001.414 1.415l2.12-2.12 2.115 2.12a1 1 0 101.416-1.413L9.41 8.004zM8 16A8 8 0 118 0a8 8 0 010 16z' fill='currentColor' fill-rule='nonzero'/%3e%3c/svg%3e",
  iconCloseKnockoutWidth: 16,
  iconCloseKnockoutHeight: 16
};

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyPercentileFilter; });
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function getBattery(item){var val=parseInt((item.dynamicAttributes||{}).battery,10);return isNaN(val)?0:val;}function applyPercentileFilter(data,percentile){if(!percentile||!data||data.length===0)return data||[];var sorted=[].concat(_toConsumableArray(data)).sort(function(a,b){return getBattery(a)-getBattery(b);});var cutoff=Math.ceil(sorted.length*(percentile/100));return sorted.slice(0,cutoff);}

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getColorHex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendOnCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sendOffCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_MetricUtility__ = __webpack_require__(341);
var publishLightCommand=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(cartId,command,color,durationMinutes){var startTime,commandParams,request,args,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:startTime=Date.now();commandParams={locationType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_0" /* CART_RESOURCE_TYPE */],state:command===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_108" /* LIGHT_COMMAND_ON */]?__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_146" /* ON_STATE */]:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_144" /* OFF_STATE */],scannable:cartId};if(command===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_108" /* LIGHT_COMMAND_ON */]){commandParams.color=color;commandParams.durationMs=String(durationMinutes*60*1000);}request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_97" /* LED_CONTROLLER_ASSET_TYPE */],commandParams:commandParams};args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_59" /* ENDPOINT_PUBLISH_LIGHT_COMMAND_TO_THIN_CLIENT */]);_context.prev=5;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 8:response=_context.sent;Object(__WEBPACK_IMPORTED_MODULE_4__util_MetricUtility__["b" /* publishTime */])(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["I" /* ANDON_PROCESS_NAME */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_126" /* METRIC_PUBLISH_LIGHT_COMMAND */],startTime);return _context.abrupt("return",response);case 13:_context.prev=13;_context.t0=_context["catch"](5);Object(__WEBPACK_IMPORTED_MODULE_4__util_MetricUtility__["a" /* publishCount */])(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["I" /* ANDON_PROCESS_NAME */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_126" /* METRIC_PUBLISH_LIGHT_COMMAND */]+__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_70" /* ERROR_METRIC_SUFFIX */]);throw _context.t0;case 17:case"end":return _context.stop();}}},_callee,this,[[5,13]]);}));return function publishLightCommand(_x,_x2,_x3,_x4){return _ref.apply(this,arguments);};}();var sendCommandInBatches=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(cartIds,commandFn){var batchSize=arguments.length>2&&arguments[2]!==undefined?arguments[2]:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_9" /* DEFAULT_ANDON_BATCH_SIZE */];var allResults,i,batch,results;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:allResults=[];i=0;case 2:if(!(i<cartIds.length)){_context2.next=11;break;}batch=cartIds.slice(i,i+batchSize);_context2.next=6;return Promise.allSettled(batch.map(commandFn));case 6:results=_context2.sent;allResults.push.apply(allResults,_toConsumableArray(results));case 8:i+=batchSize;_context2.next=2;break;case 11:return _context2.abrupt("return",aggregateResults(allResults));case 12:case"end":return _context2.stop();}}},_callee2,this);}));return function sendCommandInBatches(_x6,_x7){return _ref2.apply(this,arguments);};}();var sendOnCommand=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(cartIds,color,durationMinutes){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(!cartIds||!cartIds.length)){_context3.next=2;break;}return _context3.abrupt("return",{succeeded:0,failed:0,total:0});case 2:return _context3.abrupt("return",sendCommandInBatches(cartIds,function(id){return publishLightCommand(id,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_108" /* LIGHT_COMMAND_ON */],color,durationMinutes);}));case 3:case"end":return _context3.stop();}}},_callee3,this);}));return function sendOnCommand(_x8,_x9,_x10){return _ref3.apply(this,arguments);};}();var sendOffCommand=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(cartIds){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(!(!cartIds||!cartIds.length)){_context4.next=2;break;}return _context4.abrupt("return",{succeeded:0,failed:0,total:0});case 2:return _context4.abrupt("return",sendCommandInBatches(cartIds,function(id){return publishLightCommand(id,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_107" /* LIGHT_COMMAND_OFF */]);}));case 3:case"end":return _context4.stop();}}},_callee4,this);}));return function sendOffCommand(_x11){return _ref4.apply(this,arguments);};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function getColorHex(colorValue){var found=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["H" /* ANDON_COLORS */].find(function(c){return c.value===colorValue;});return found?found.hex:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_10" /* DEFAULT_ANDON_COLOR_HEX */];}function aggregateResults(results){var succeeded=results.filter(function(r){return r.status===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_161" /* PROMISE_FULFILLED */]&&r.value&&r.value.status===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_81" /* HTTP_STATUS */].OK;}).length;return{succeeded:succeeded,failed:results.length-succeeded,total:results.length};}

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = initStationConfig;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchSBLDashboardData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__ = __webpack_require__(51);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function initStationConfig(dispatcher){dispatcher({type:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_172" /* SBL_DASHBOARD_ACTIONS */].RECEIVE_CONFIG,data:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_13" /* DEFAULT_PERCENTILE */]});}var fetchSBLDashboardData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher){var startTime,request,args,response,data,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:startTime=Date.now();_context.prev=1;request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),resourceType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_0" /* CART_RESOURCE_TYPE */]};args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_54" /* ENDPOINT_GET_RESOURCE_DYNAMIC_ATTRIBUTES */]);_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 6:response=_context.sent;if(response.status===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_81" /* HTTP_STATUS */].OK){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_173" /* SBL_DASHBOARD_METRIC_PROCESS_NAME */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_125" /* METRIC_GET_RESOURCE_DYNAMIC_ATTRIBUTES */],true,false);data=response.data&&response.data[__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_164" /* RESOURCE_DYNAMIC_ATTRIBUTES_KEY */]]||[];dispatcher({type:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_172" /* SBL_DASHBOARD_ACTIONS */].RECEIVE_DATA,data:data});}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);console.error("fetchSBLDashboardData failed with status:",response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_173" /* SBL_DASHBOARD_METRIC_PROCESS_NAME */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_125" /* METRIC_GET_RESOURCE_DYNAMIC_ATTRIBUTES */],false,isFault);dispatcher({type:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_172" /* SBL_DASHBOARD_ACTIONS */].RECEIVE_ERROR,data:"Failed to load cart data. Please try refreshing."});}_context.next=15;break;case 10:_context.prev=10;_context.t0=_context["catch"](1);console.error("fetchSBLDashboardData exception:",_context.t0);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_173" /* SBL_DASHBOARD_METRIC_PROCESS_NAME */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_125" /* METRIC_GET_RESOURCE_DYNAMIC_ATTRIBUTES */],false,true);dispatcher({type:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_172" /* SBL_DASHBOARD_ACTIONS */].RECEIVE_ERROR,data:"Failed to load cart data. Please try refreshing."});case 15:case"end":return _context.stop();}}},_callee,this,[[1,10]]);}));return function fetchSBLDashboardData(_x){return _ref.apply(this,arguments);};}();

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_search_field__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_search_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_search_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Util__ = __webpack_require__(5);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var SearchFilterBar=function SearchFilterBar(_ref){var filters=_ref.filters,onFiltersChange=_ref.onFiltersChange,filterColumns=_ref.filterColumns;var activeKeys=filters.map(function(f){return f.key;});var getAvailableColumns=function getAvailableColumns(currentKey){return filterColumns.filter(function(col){return col.key===currentKey||!activeKeys.includes(col.key);});};var updateFilter=function updateFilter(index,field,value){var updated=[].concat(_toConsumableArray(filters));if(field==='key'){updated[index]={key:value,value:''};}else{updated[index]=Object.assign({},updated[index],{value:value});}onFiltersChange(updated);};var addFilter=function addFilter(){var available=filterColumns.filter(function(col){return!activeKeys.includes(col.key);});if(available.length>0){onFiltersChange([].concat(_toConsumableArray(filters),[{key:available[0].key,value:''}]));}};var removeFilter=function removeFilter(index){onFiltersChange(filters.filter(function(_,i){return i!==index;}));};var canAddFilter=filterColumns.filter(function(col){return!activeKeys.includes(col.key);}).length>0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{wrap:"down",spacing:"small",alignmentVertical:"bottom"},filters.map(function(filter,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{key:filter.key,spacing:"xsmall",alignmentVertical:"bottom"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,{spacing:"xsmall"},index===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{type:"b200"},"Search"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select___default.a,{value:filter.key,onChange:function onChange(value){return updateFilter(index,'key',value);},size:"small",width:140},getAvailableColumns(filter.key).map(function(col){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_select__["SelectOption"],{key:col.key,value:col.key,label:col.label});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,{spacing:"xsmall"},index===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{type:"b200"},"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_search_field___default.a,{value:filter.value,onChange:function onChange(value){return updateFilter(index,'value',value);},onSubmit:function onSubmit(){},placeholder:"Filter by "+Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return filterColumns.find(function(c){return c.key===filter.key;}).label;},'')+"...",size:"small"})),index>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default.a,{type:"tertiary",size:"small",onClick:function onClick(){return removeFilter(index);}},"\u2715"));}),canAddFilter&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default.a,{type:"tertiary",size:"small",onClick:addFilter},"+ Add Filter"));};/* harmony default export */ __webpack_exports__["a"] = (SearchFilterBar);

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_LEDControllerOverviewContext__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_LEDControllerConfigurationContext__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_FeatureUtility__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var LEDControllerPage=function(_Component){_inherits(LEDControllerPage,_Component);function LEDControllerPage(){_classCallCheck(this,LEDControllerPage);return _possibleConstructorReturn(this,(LEDControllerPage.__proto__||Object.getPrototypeOf(LEDControllerPage)).apply(this,arguments));}_createClass(LEDControllerPage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_6__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_6__util_FeatureUtility__["a" /* FEATURES */].IS_LED_CONTROLLER_ENHANCEMENT_ENABLED)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_LEDControllerOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__context_LEDControllerConfigurationContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__util_TabLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_5__util_RouteConstants__["s" /* LED_CONTROLLERS_WITH_CONFIG */],location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__util_TabLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_5__util_RouteConstants__["s" /* LED_CONTROLLERS_WITH_CONFIG */]})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_LEDControllerOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__util_TabLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_5__util_RouteConstants__["r" /* LED_CONTROLLERS */],location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__util_TabLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_5__util_RouteConstants__["r" /* LED_CONTROLLERS */]})));}}]);return LEDControllerPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LEDControllerPage);

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_navbar__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_bin_tester_page__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_aisle_tester_page__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_controller_tester_page__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_alert__);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var BinTester=function BinTester(_ref){var intl=_ref.intl;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["X" /* getNodeId */])()),_useState2=_slicedToArray(_useState,2),siteId=_useState2[0],setSiteId=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({}),_useState4=_slicedToArray(_useState3,2),siteConfig=_useState4[0],setSiteConfig=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(true),_useState6=_slicedToArray(_useState5,2),binShowFlag=_useState6[0],setBinShowFlag=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),controllerShowFlag=_useState8[0],setControllerShowFlag=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),clusterShowFlag=_useState10[0],setClusterShowFlag=_useState10[1];Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["D" /* getAssetRefreshInterval */])());return function(){return clearInterval(interval);};},[siteId]);var updateSiteConfig=function updateSiteConfig(siteConfig){setSiteConfig(siteConfig);};var updateSiteId=function updateSiteId(siteId){setSiteId(siteId);};var getData=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var siteConfig;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_8__config__["b" /* loadSiteConfig */])();case 2:siteConfig=_context.sent;setSiteConfig(siteConfig);case 4:case"end":return _context.stop();}}},_callee,_this);}));return function getData(){return _ref2.apply(this,arguments);};}();var onNavChange=function onNavChange(type){if(type==="bin"){setBinShowFlag(true);setClusterShowFlag(false);setControllerShowFlag(false);}else if(type==='cluster'){setBinShowFlag(false);setClusterShowFlag(true);setControllerShowFlag(false);}else if(type==='controller'){setBinShowFlag(false);setClusterShowFlag(false);setControllerShowFlag(true);}};if(!siteConfig.data){if(siteConfig.status&&siteConfig.status!==200){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"bintester.errorMessage",defaultMessage:"An error occurred while fetching the site config for this station"}));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__loader_Loader__["a" /* default */],null);}}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__component_navbar__["a" /* default */],{siteId:siteId,siteConfig:siteConfig,onSiteIdChange:updateSiteId,onSiteConfigChange:updateSiteConfig,onNavChange:onNavChange})),controllerShowFlag&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__view_controller_tester_page__["a" /* default */],{siteId:siteId,siteConfig:siteConfig}),binShowFlag&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__view_bin_tester_page__["a" /* default */],{siteId:siteId,siteConfig:siteConfig}),clusterShowFlag&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__view_aisle_tester_page__["a" /* default */],{siteId:siteId,siteConfig:siteConfig}));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(BinTester));

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Navbar__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Nav__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_Container__ = __webpack_require__(177);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LedTesterNavBar=function(_React$Component){_inherits(LedTesterNavBar,_React$Component);function LedTesterNavBar(props){_classCallCheck(this,LedTesterNavBar);var _this=_possibleConstructorReturn(this,(LedTesterNavBar.__proto__||Object.getPrototypeOf(LedTesterNavBar)).call(this,props));_this.selectedTitle="Bin";_this.state={siteId:Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["X" /* getNodeId */])()};return _this;}_createClass(LedTesterNavBar,[{key:'updateSiteId',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(siteId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({siteId:siteId});_context.t0=this.props;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4__config__["b" /* loadSiteConfig */])(siteId);case 4:_context.t1=_context.sent;_context.t0.onSiteConfigChange.call(_context.t0,_context.t1);this.props.onSiteIdChange(siteId);case 7:case'end':return _context.stop();}}},_callee,this);}));function updateSiteId(_x){return _ref.apply(this,arguments);}return updateSiteId;}()},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Navbar__["a" /* default */],{bg:'dark',variant:'dark'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Navbar__["a" /* default */].Brand,null,this.selectedTitle),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Nav__["a" /* default */],{className:'mr-auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Nav__["a" /* default */].Link,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:function onClick(){_this2.props.onNavChange('cluster');_this2.selectedTitle="Cluster";}},'Cluster')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Nav__["a" /* default */].Link,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:function onClick(){_this2.props.onNavChange('controller');_this2.selectedTitle="Led Controller";}},'Led Controller')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Nav__["a" /* default */].Link,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:function onClick(){_this2.props.onNavChange('bin');_this2.selectedTitle="Bin";}},'Bin')))));}}]);return LedTesterNavBar;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (LedTesterNavBar);

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uncontrollable__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createWithBsPrefix__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavbarBrand__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavbarCollapse__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NavbarToggle__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ThemeProvider__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavbarContext__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SelectableContext__ = __webpack_require__(306);












var defaultProps = {
  expand: true,
  variant: 'light',
  collapseOnSelect: false
};
var Navbar = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (props, ref) {
  var _useUncontrolled = Object(__WEBPACK_IMPORTED_MODULE_4_uncontrollable__["a" /* useUncontrolled */])(props, {
    expanded: 'onToggle'
  }),
      bsPrefix = _useUncontrolled.bsPrefix,
      expand = _useUncontrolled.expand,
      variant = _useUncontrolled.variant,
      bg = _useUncontrolled.bg,
      fixed = _useUncontrolled.fixed,
      sticky = _useUncontrolled.sticky,
      className = _useUncontrolled.className,
      children = _useUncontrolled.children,
      _useUncontrolled$as = _useUncontrolled.as,
      Component = _useUncontrolled$as === void 0 ? 'nav' : _useUncontrolled$as,
      expanded = _useUncontrolled.expanded,
      _onToggle = _useUncontrolled.onToggle,
      onSelect = _useUncontrolled.onSelect,
      collapseOnSelect = _useUncontrolled.collapseOnSelect,
      controlledProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_useUncontrolled, ["bsPrefix", "expand", "variant", "bg", "fixed", "sticky", "className", "children", "as", "expanded", "onToggle", "onSelect", "collapseOnSelect"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_9__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'navbar');
  var handleCollapse = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function () {
    if (onSelect) onSelect.apply(void 0, arguments);

    if (collapseOnSelect && expanded) {
      _onToggle(false);
    }
  }, [onSelect, collapseOnSelect, expanded, _onToggle]); // will result in some false positives but that seems better
  // than false negatives. strict `undefined` check allows explicit
  // "nulling" of the role if the user really doesn't want one

  if (controlledProps.role === undefined && Component !== 'nav') {
    controlledProps.role = 'navigation';
  }

  var expandClass = bsPrefix + "-expand";
  if (typeof expand === 'string') expandClass = expandClass + "-" + expand;
  var navbarContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
    return {
      onToggle: function onToggle() {
        return _onToggle(!expanded);
      },
      bsPrefix: bsPrefix,
      expanded: expanded
    };
  }, [bsPrefix, expanded, _onToggle]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__NavbarContext__["a" /* default */].Provider, {
    value: navbarContext
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SelectableContext__["a" /* default */].Provider, {
    value: handleCollapse
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, controlledProps, {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix, expand && expandClass, variant && bsPrefix + "-" + variant, bg && "bg-" + bg, sticky && "sticky-" + sticky, fixed && "fixed-" + fixed)
  }), children)));
});
Navbar.defaultProps = defaultProps;
Navbar.displayName = 'Navbar';
Navbar.Brand = __WEBPACK_IMPORTED_MODULE_6__NavbarBrand__["a" /* default */];
Navbar.Toggle = __WEBPACK_IMPORTED_MODULE_8__NavbarToggle__["a" /* default */];
Navbar.Collapse = __WEBPACK_IMPORTED_MODULE_7__NavbarCollapse__["a" /* default */];
Navbar.Text = Object(__WEBPACK_IMPORTED_MODULE_5__createWithBsPrefix__["a" /* default */])('navbar-text', {
  Component: 'span'
});
/* harmony default export */ __webpack_exports__["a"] = (Navbar);

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useUncontrolledProp */
/* harmony export (immutable) */ __webpack_exports__["a"] = useUncontrolled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(496);



function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }




function useUncontrolledProp(propValue, defaultValue, handler) {
  var wasPropRef = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(propValue !== undefined);

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(defaultValue),
      stateValue = _useState[0],
      setState = _useState[1];

  var isProp = propValue !== undefined;
  var wasProp = wasPropRef.current;
  wasPropRef.current = isProp;
  /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */

  if (!isProp && wasProp && stateValue !== defaultValue) {
    setState(defaultValue);
  }

  return [isProp ? propValue : stateValue, Object(__WEBPACK_IMPORTED_MODULE_2_react__["useCallback"])(function (value) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (handler) handler.apply(void 0, [value].concat(args));
    setState(value);
  }, [handler])];
}


function useUncontrolled(props, config) {
  return Object.keys(config).reduce(function (result, fieldName) {
    var _extends2;

    var _ref = result,
        defaultValue = _ref[__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* defaultKey */](fieldName)],
        propsValue = _ref[fieldName],
        rest = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, [__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* defaultKey */](fieldName), fieldName].map(_toPropertyKey));

    var handlerName = config[fieldName];

    var _useUncontrolledProp = useUncontrolledProp(propsValue, defaultValue, props[handlerName]),
        value = _useUncontrolledProp[0],
        handler = _useUncontrolledProp[1];

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
  }, props);
}

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(496);



var _jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";




function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var canAcceptRef = __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* canAcceptRef */](Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* defaultKey */]);
  !(canAcceptRef || !methods.length) ?  false ? invariant(false, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', ')) : __WEBPACK_IMPORTED_MODULE_5_invariant___default()(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          if (!_this.unmounted) _this.setState(function (_ref) {
            var _extends2;

            var values = _ref.values;
            return {
              values: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
            };
          });
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (methods.length) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      var values = Object.create(null);
      controlledProps.forEach(function (key) {
        values[key] = _this.props[__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* defaultKey */](key)];
      });
      _this.state = {
        values: values,
        prevProps: {}
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let setState trigger the update
      return !this._notifying;
    };

    UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
      var values = _ref2.values,
          prevProps = _ref2.prevProps;
      var nextState = {
        values: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(Object.create(null), values),
        prevProps: {}
      };
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        nextState.prevProps[key] = props[key];

        if (!__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* isProp */](props, key) && __WEBPACK_IMPORTED_MODULE_6__utils__["c" /* isProp */](prevProps, key)) {
          nextState.values[key] = props[__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* defaultKey */](key)];
        }
      });
      return nextState;
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.render = function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          innerRef = _this$props2.innerRef,
          props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["innerRef"]);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this2.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, newProps, this.handlers, {
        ref: innerRef || this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

  Object(__WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__["a" /* polyfill */])(UncontrolledComponent);
  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    innerRef: function innerRef() {}
  }, __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* uncontrolledPropTypes */](controlledValues, displayName));
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _this$inner;

      return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
    };
  });
  var WrappedComponent = UncontrolledComponent;

  if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef) {
    WrappedComponent = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (props, ref) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(UncontrolledComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
        innerRef: ref,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128
        },
        __self: this
      }));
    });
    WrappedComponent.propTypes = UncontrolledComponent.propTypes;
  }

  WrappedComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  WrappedComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, controlledValues, additions), nextMethods);
  };

  return WrappedComponent;
}

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = camelize;
var rHyphen = /-(.)/g;
function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = forwardRef;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function forwardRef(renderFn, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      propTypes = _ref.propTypes,
      defaultProps = _ref.defaultProps,
      _ref$allowFallback = _ref.allowFallback,
      allowFallback = _ref$allowFallback === void 0 ? false : _ref$allowFallback,
      _ref$displayName = _ref.displayName,
      displayName = _ref$displayName === void 0 ? renderFn.name || renderFn.displayName : _ref$displayName;

  var render = function render(props, ref) {
    return renderFn(props, ref);
  };

  return Object.assign(_react.default.forwardRef || !allowFallback ? _react.default.forwardRef(render) : function (props) {
    return render(props, null);
  }, {
    displayName: displayName,
    propTypes: propTypes,
    defaultProps: defaultProps
  });
}

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(49);





var NavbarBrand = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      as = _ref.as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "as"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'navbar-brand');
  var Component = as || (props.href ? 'a' : 'span');
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix)
  }));
});
NavbarBrand.displayName = 'NavbarBrand';
/* harmony default export */ __webpack_exports__["a"] = (NavbarBrand);

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Collapse__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavbarContext__ = __webpack_require__(227);






var NavbarCollapse = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      bsPrefix = _ref.bsPrefix,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["children", "bsPrefix"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'navbar-collapse');
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__NavbarContext__["a" /* default */].Consumer, null, function (context) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Collapse__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      in: !!(context && context.expanded)
    }, props), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      ref: ref,
      className: bsPrefix
    }, children));
  });
});
NavbarCollapse.displayName = 'NavbarCollapse';
/* harmony default export */ __webpack_exports__["a"] = (NavbarCollapse);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_css__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_transitionEnd__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group_Transition__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__createChainedFunction__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__triggerBrowserReflow__ = __webpack_require__(501);




var _collapseStyles;








var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

function getDimensionValue(dimension, elem) {
  var offset = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
  var value = elem[offset];
  var margins = MARGINS[dimension];
  return value + parseInt(Object(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_css__["a" /* default */])(elem, margins[0]), 10) + parseInt(Object(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_css__["a" /* default */])(elem, margins[1]), 10);
}

var collapseStyles = (_collapseStyles = {}, _collapseStyles[__WEBPACK_IMPORTED_MODULE_7_react_transition_group_Transition__["c" /* EXITED */]] = 'collapse', _collapseStyles[__WEBPACK_IMPORTED_MODULE_7_react_transition_group_Transition__["d" /* EXITING */]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_7_react_transition_group_Transition__["b" /* ENTERING */]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_7_react_transition_group_Transition__["a" /* ENTERED */]] = 'collapse show', _collapseStyles);
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Collapse, _React$Component);

  function Collapse() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleEnter = function (elem) {
      elem.style[_this.getDimension()] = '0';
    };

    _this.handleEntering = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
    };

    _this.handleEntered = function (elem) {
      elem.style[_this.getDimension()] = null;
    };

    _this.handleExit = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this.props.getDimensionValue(dimension, elem) + "px";
      Object(__WEBPACK_IMPORTED_MODULE_9__triggerBrowserReflow__["a" /* default */])(elem);
    };

    _this.handleExiting = function (elem) {
      elem.style[_this.getDimension()] = null;
    };

    return _this;
  }

  var _proto = Collapse.prototype;

  _proto.getDimension = function getDimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  }
  /* -- Expanding -- */
  ;

  // for testing
  _proto._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    var scroll = "scroll" + dimension[0].toUpperCase() + dimension.slice(1);
    return elem[scroll] + "px";
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        onEnter = _this$props.onEnter,
        onEntering = _this$props.onEntering,
        onEntered = _this$props.onEntered,
        onExit = _this$props.onExit,
        onExiting = _this$props.onExiting,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "className", "children"]);

    delete props.dimension;
    delete props.getDimensionValue;
    var handleEnter = Object(__WEBPACK_IMPORTED_MODULE_8__createChainedFunction__["a" /* default */])(this.handleEnter, onEnter);
    var handleEntering = Object(__WEBPACK_IMPORTED_MODULE_8__createChainedFunction__["a" /* default */])(this.handleEntering, onEntering);
    var handleEntered = Object(__WEBPACK_IMPORTED_MODULE_8__createChainedFunction__["a" /* default */])(this.handleEntered, onEntered);
    var handleExit = Object(__WEBPACK_IMPORTED_MODULE_8__createChainedFunction__["a" /* default */])(this.handleExit, onExit);
    var handleExiting = Object(__WEBPACK_IMPORTED_MODULE_8__createChainedFunction__["a" /* default */])(this.handleExiting, onExiting);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group_Transition__["e" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      addEndListener: __WEBPACK_IMPORTED_MODULE_5_dom_helpers_transitionEnd__["a" /* default */]
    }, props, {
      "aria-expanded": props.role ? props.in : null,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting
    }), function (state, innerProps) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, children.props.className, collapseStyles[state], _this2.getDimension() === 'width' && 'width')
      }));
    });
  };

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Collapse.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getComputedStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ownerWindow__ = __webpack_require__(1241);

/**
 * Returns one or all computed style properties of an element.
 * 
 * @param node the element
 * @param psuedoElement the style property
 */

function getComputedStyle(node, psuedoElement) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__ownerWindow__["a" /* default */])(node).getComputedStyle(node, psuedoElement);
}

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownerWindow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ownerDocument__ = __webpack_require__(1242);

/**
 * Returns the owner window of a given element.
 * 
 * @param node the element
 */

function ownerWindow(node) {
  var doc = Object(__WEBPACK_IMPORTED_MODULE_0__ownerDocument__["a" /* default */])(node);
  return doc && doc.defaultView || window;
}

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownerDocument;
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hyphenateStyleName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hyphenate__ = __webpack_require__(1244);
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */

var msPattern = /^ms-/;
function hyphenateStyleName(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__hyphenate__["a" /* default */])(string).replace(msPattern, '-ms-');
}

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hyphenate;
var rUpper = /([A-Z])/g;
function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function isTransform(value) {
  return !!(value && supportedTransforms.test(value));
}

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addEventListener__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__removeEventListener__ = __webpack_require__(1249);



function listen(node, eventName, handler, options) {
  Object(__WEBPACK_IMPORTED_MODULE_0__addEventListener__["a" /* default */])(node, eventName, handler, options);
  return function () {
    Object(__WEBPACK_IMPORTED_MODULE_1__removeEventListener__["a" /* default */])(node, eventName, handler, options);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (listen);

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export optionsSupported */
/* unused harmony export onceSupported */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__canUseDOM__ = __webpack_require__(1248);
/* eslint-disable no-return-assign */

var optionsSupported = false;
var onceSupported = false;

try {
  var options = {
    get passive() {
      return optionsSupported = true;
    },

    get once() {
      // eslint-disable-next-line no-multi-assign
      return onceSupported = optionsSupported = true;
    }

  };

  if (__WEBPACK_IMPORTED_MODULE_0__canUseDOM__["a" /* default */]) {
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, true);
  }
} catch (e) {
  /* */
}

/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function addEventListener(node, eventName, handler, options) {
  if (options && typeof options !== 'boolean' && !onceSupported) {
    var once = options.once,
        capture = options.capture;
    var wrappedHandler = handler;

    if (!onceSupported && once) {
      wrappedHandler = handler.__once || function onceHandler(event) {
        this.removeEventListener(eventName, onceHandler, capture);
        handler.call(this, event);
      };

      handler.__once = wrappedHandler;
    }

    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
  }

  node.addEventListener(eventName, handler, options);
}

/* harmony default export */ __webpack_exports__["a"] = (addEventListener);

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function removeEventListener(node, eventName, handler, options) {
  var capture = options && typeof options !== 'boolean' ? options.capture : options;
  node.removeEventListener(eventName, handler, capture);

  if (handler.__once) {
    node.removeEventListener(eventName, handler.__once, capture);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (removeEventListener);

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = triggerEvent;
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */
function triggerEvent(node, eventName, bubbles, cancelable) {
  if (bubbles === void 0) {
    bubbles = false;
  }

  if (cancelable === void 0) {
    cancelable = true;
  }

  if (node) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent(eventName, bubbles, cancelable);
    node.dispatchEvent(event);
  }
}

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  disabled: false
});

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timeoutsShape */
/* unused harmony export classNamesShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var timeoutsShape =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape =  false ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null));

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return forceReflow; });
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__restart_hooks_useEventCallback__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavbarContext__ = __webpack_require__(227);







var defaultProps = {
  label: 'Toggle navigation'
};
var NavbarToggle = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      label = _ref.label,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'button' : _ref$as,
      onClick = _ref.onClick,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "children", "label", "as", "onClick"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'navbar-toggler');

  var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__NavbarContext__["a" /* default */]) || {},
      onToggle = _ref2.onToggle,
      expanded = _ref2.expanded;

  var handleClick = Object(__WEBPACK_IMPORTED_MODULE_4__restart_hooks_useEventCallback__["a" /* default */])(function (e) {
    if (onClick) onClick(e);
    if (onToggle) onToggle();
  });

  if (Component === 'button') {
    props.type = 'button';
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    onClick: handleClick,
    "aria-label": label,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix, !expanded && 'collapsed')
  }), children || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
    className: bsPrefix + "-icon"
  }));
});
NavbarToggle.displayName = 'NavbarToggle';
NavbarToggle.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavbarToggle);

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded befor being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */

function useCommittedRef(value) {
  var ref = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(value);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    ref.current = value;
  }, [value]);
  return ref;
}

/* harmony default export */ __webpack_exports__["a"] = (useCommittedRef);

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types_extra_lib_all__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uncontrollable__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThemeProvider__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavbarContext__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CardContext__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AbstractNav__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavItem__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NavLink__ = __webpack_require__(1266);












var defaultProps = {
  justify: false,
  fill: false
};
var Nav = __WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (uncontrolledProps, ref) {
  var _classNames;

  var _useUncontrolled = Object(__WEBPACK_IMPORTED_MODULE_5_uncontrollable__["a" /* useUncontrolled */])(uncontrolledProps, {
    activeKey: 'onSelect'
  }),
      _useUncontrolled$as = _useUncontrolled.as,
      as = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as,
      bsPrefix = _useUncontrolled.bsPrefix,
      variant = _useUncontrolled.variant,
      fill = _useUncontrolled.fill,
      justify = _useUncontrolled.justify,
      navbar = _useUncontrolled.navbar,
      className = _useUncontrolled.className,
      children = _useUncontrolled.children,
      activeKey = _useUncontrolled.activeKey,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_useUncontrolled, ["as", "bsPrefix", "variant", "fill", "justify", "navbar", "className", "children", "activeKey"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_6__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'nav');
  var navbarBsPrefix, cardHeaderBsPrefix;
  var navbarContext = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__NavbarContext__["a" /* default */]);
  var cardContext = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__CardContext__["a" /* default */]);

  if (navbarContext) {
    navbarBsPrefix = navbarContext.bsPrefix;
    navbar = navbar == null ? true : navbar;
  } else if (cardContext) {
    cardHeaderBsPrefix = cardContext.cardHeaderBsPrefix;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__AbstractNav__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    as: as,
    ref: ref,
    activeKey: activeKey,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_classNames = {}, _classNames[bsPrefix] = !navbar, _classNames[navbarBsPrefix + "-nav"] = navbar, _classNames[cardHeaderBsPrefix + "-" + variant] = !!cardHeaderBsPrefix, _classNames[bsPrefix + "-" + variant] = !!variant, _classNames[bsPrefix + "-fill"] = fill, _classNames[bsPrefix + "-justified"] = justify, _classNames))
  }, props), children);
});
Nav.displayName = 'Nav';
Nav.defaultProps = defaultProps;
Nav.Item = __WEBPACK_IMPORTED_MODULE_10__NavItem__["a" /* default */];
Nav.Link = __WEBPACK_IMPORTED_MODULE_11__NavLink__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Nav);

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null));

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dom_helpers_querySelectorAll__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__restart_hooks_useForceUpdate__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__restart_hooks_useMergedRefs__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavContext__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelectableContext__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TabContext__ = __webpack_require__(1264);










var noop = function noop() {};

var AbstractNav = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'ul' : _ref$as,
      onSelect = _ref.onSelect,
      activeKey = _ref.activeKey,
      role = _ref.role,
      onKeyDown = _ref.onKeyDown,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["as", "onSelect", "activeKey", "role", "onKeyDown"]);

  // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
  // and don't want to reset the set in the effect
  var forceUpdate = Object(__WEBPACK_IMPORTED_MODULE_4__restart_hooks_useForceUpdate__["a" /* default */])();
  var needsRefocusRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(false);
  var parentOnSelect = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__SelectableContext__["a" /* default */]);
  var tabContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__TabContext__["a" /* default */]);
  var getControlledId, getControllerId;

  if (tabContext) {
    role = role || 'tablist';
    activeKey = tabContext.activeKey;
    getControlledId = tabContext.getControlledId;
    getControllerId = tabContext.getControllerId;
  }

  var listNode = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(null);

  var getNextActiveChild = function getNextActiveChild(offset) {
    if (!listNode.current) return null;
    var items = Object(__WEBPACK_IMPORTED_MODULE_2_dom_helpers_querySelectorAll__["a" /* default */])(listNode.current, '[data-rb-event-key]:not(.disabled)');
    var activeChild = listNode.current.querySelector('.active');
    var index = items.indexOf(activeChild);
    if (index === -1) return null;
    var nextIndex = index + offset;
    if (nextIndex >= items.length) nextIndex = 0;
    if (nextIndex < 0) nextIndex = items.length - 1;
    return items[nextIndex];
  };

  var handleSelect = function handleSelect(key, event) {
    if (key == null) return;
    if (onSelect) onSelect(key, event);
    if (parentOnSelect) parentOnSelect(key, event);
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (onKeyDown) onKeyDown(event);
    var nextActiveChild;

    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        nextActiveChild = getNextActiveChild(-1);
        break;

      case 'ArrowRight':
      case 'ArrowDown':
        nextActiveChild = getNextActiveChild(1);
        break;

      default:
        return;
    }

    if (!nextActiveChild) return;
    event.preventDefault();
    handleSelect(nextActiveChild.dataset.rbEventKey, event);
    needsRefocusRef.current = true;
    forceUpdate();
  };

  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    if (listNode.current && needsRefocusRef.current) {
      var activeChild = listNode.current.querySelector('[data-rb-event-key].active');
      if (activeChild) activeChild.focus();
    }

    needsRefocusRef.current = false;
  });
  var mergedRef = Object(__WEBPACK_IMPORTED_MODULE_5__restart_hooks_useMergedRefs__["a" /* default */])(ref, listNode);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SelectableContext__["a" /* default */].Provider, {
    value: handleSelect
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NavContext__["a" /* default */].Provider, {
    value: {
      role: role,
      // used by NavLink to determine it's role
      activeKey: Object(__WEBPACK_IMPORTED_MODULE_7__SelectableContext__["b" /* makeEventKey */])(activeKey),
      getControlledId: getControlledId || noop,
      getControllerId: getControllerId || noop
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    onKeyDown: handleKeyDown,
    ref: mergedRef,
    role: role
  }))));
});
/* harmony default export */ __webpack_exports__["a"] = (AbstractNav);

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = qsa;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
/**
 * Runs `querySelectorAll` on a given element.
 * 
 * @param element the element
 * @param selector the selector
 */

function qsa(element, selector) {
  return toArray(element.querySelectorAll(selector));
}

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useForceUpdate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Returns a function that triggers a component update. the hook equivalent to
 * `this.forceUpdate()` in a class component. In most cases using a state value directly
 * is preferable but may be required in some advanced usages of refs for interop or
 * when direct DOM manipulation is required.
 *
 * ```ts
 * const forceUpdate = useForceUpdate();
 *
 * const updateOnClick = useCallback(() => {
 *  forceUpdate()
 * }, [forceUpdate])
 *
 * return <button type="button" onClick={updateOnClick}>Hi there</button>
 * ```
 */

function useForceUpdate() {
  // The toggling state value is designed to defeat React optimizations for skipping
  // updates when they are stricting equal to the last state value
  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(function (state) {
    return !state;
  }, false),
      dispatch = _useReducer[1];

  return dispatch;
}

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mergeRefs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var toFnRef = function toFnRef(ref) {
  return !ref || typeof ref === 'function' ? ref : function (value) {
    ref.current = value;
  };
};

function mergeRefs(refA, refB) {
  var a = toFnRef(refA);
  var b = toFnRef(refB);
  return function (value) {
    if (a) a(value);
    if (b) b(value);
  };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */

function useMergedRefs(refA, refB) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return mergeRefs(refA, refB);
  }, [refA, refB]);
}

/* harmony default export */ __webpack_exports__["a"] = (useMergedRefs);

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var TabContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);
/* harmony default export */ __webpack_exports__["a"] = (TabContext);

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(49);





var NavItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "children", "as"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'nav-item');
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix)
  }), children);
});
NavItem.displayName = 'NavItem';
/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SafeAnchor__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AbstractNavItem__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThemeProvider__ = __webpack_require__(49);







var defaultProps = {
  disabled: false,
  as: __WEBPACK_IMPORTED_MODULE_4__SafeAnchor__["a" /* default */]
};
var NavLink = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      disabled = _ref.disabled,
      className = _ref.className,
      href = _ref.href,
      eventKey = _ref.eventKey,
      onSelect = _ref.onSelect,
      as = _ref.as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "disabled", "className", "href", "eventKey", "onSelect", "as"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_6__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'nav-link');
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AbstractNavItem__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    href: href,
    ref: ref,
    eventKey: eventKey,
    as: as,
    disabled: disabled,
    onSelect: onSelect,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix, disabled && 'disabled')
  }));
});
NavLink.displayName = 'NavLink';
NavLink.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__restart_hooks_useEventCallback__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavContext__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelectableContext__ = __webpack_require__(306);








var defaultProps = {
  disabled: false
};
var AbstractNavItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var active = _ref.active,
      className = _ref.className,
      tabIndex = _ref.tabIndex,
      eventKey = _ref.eventKey,
      onSelect = _ref.onSelect,
      onClick = _ref.onClick,
      Component = _ref.as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["active", "className", "tabIndex", "eventKey", "onSelect", "onClick", "as"]);

  var navKey = Object(__WEBPACK_IMPORTED_MODULE_7__SelectableContext__["b" /* makeEventKey */])(eventKey, props.href);
  var parentOnSelect = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__SelectableContext__["a" /* default */]);
  var navContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__NavContext__["a" /* default */]);
  var isActive = active;

  if (navContext) {
    if (!props.role && navContext.role === 'tablist') props.role = 'tab';
    var contextControllerId = navContext.getControllerId(navKey);
    var contextControlledId = navContext.getControlledId(navKey);
     false ? warning(!contextControllerId || !props.id, "[react-bootstrap] The provided id '" + props.id + "' was overwritten by the current navContext with '" + contextControllerId + "'.") : void 0;
     false ? warning(!contextControlledId || !props['aria-controls'], "[react-bootstrap] The provided aria-controls value '" + props['aria-controls'] + "' was overwritten by the current navContext with '" + contextControlledId + "'.") : void 0;
    props['data-rb-event-key'] = navKey;
    props.id = contextControllerId || props.id;
    props['aria-controls'] = contextControlledId || props['aria-controls'];
    isActive = active == null && navKey != null ? navContext.activeKey === navKey : active;
  }

  if (props.role === 'tab') {
    props.tabIndex = isActive ? tabIndex : -1;
    props['aria-selected'] = isActive;
  }

  var handleOnclick = Object(__WEBPACK_IMPORTED_MODULE_4__restart_hooks_useEventCallback__["a" /* default */])(function (e) {
    if (onClick) onClick(e);
    if (navKey == null) return;
    if (onSelect) onSelect(navKey, e);
    if (parentOnSelect) parentOnSelect(navKey, e);
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    onClick: handleOnclick,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, isActive && 'active')
  }));
});
AbstractNavItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (AbstractNavItem);

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_bin_tester_with_site_config__ = __webpack_require__(1269);
var BinTesterPage=function BinTesterPage(props){if(props.siteId==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Select a site');}if(props.siteConfig.status!==200){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Failed to load site configuration for ',props.siteId,'. Please contact SBL tech team.');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_bin_tester_with_site_config__["a" /* default */],props);};/* harmony default export */ __webpack_exports__["a"] = (BinTesterPage);

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Alert__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_ButtonGroup__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Container__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_Row__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_Form__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__business_bin_cotroller__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_sleep__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_constant__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Util__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var INITIAL_STATE={isAutoButtonPressed:false,colorByBin:new Map(),queryMap:{}};var BIN_BUTTON_STYLE={minWidth:'65px',maxWidth:'80px',minHeight:'50px',textShadow:'-1px -1px 0 #FFFFFF, 1px -1px 0 #FFFFFF, -1px 1px 0 #FFFFFF, 1px 1px 0 #FFFFFF',color:'#000000'};var BIN_BUTTON_CLASS_NAME='p-0';var OV_BUTTON_STYLE={minWidth:'100px',maxWidth:'125px',minHeight:'60px',textShadow:'-1px -1px 0 #FFFFFF, 1px -1px 0 #FFFFFF, -1px 1px 0 #FFFFFF, 1px 1px 0 #FFFFFF',color:'#000000'};var OV_BUTTON_CLASS_NAME='p-0';var GREY_RGB_COLOR='#DDDDDD';var RANDOM_COLOR_NAME='RANDOM';var COLOR_NAMES=[RANDOM_COLOR_NAME].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_12__util_constant__["d" /* COLOR_MAP */])));var DEFAULT_COLOR_NAME=RANDOM_COLOR_NAME;var QUERY_PARAMETERS={color:'color',aisle:'aisle'};var BinTesterWithSiteConfig=function(_React$Component){_inherits(BinTesterWithSiteConfig,_React$Component);function BinTesterWithSiteConfig(props){_classCallCheck(this,BinTesterWithSiteConfig);var _this=_possibleConstructorReturn(this,(BinTesterWithSiteConfig.__proto__||Object.getPrototypeOf(BinTesterWithSiteConfig)).call(this,props));_this.config=Object(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* getConfig */])();_this.state=Object.assign({color:'RANDOM'},INITIAL_STATE);_this.isAutoRunning=false;//this.verifyQueryParametersAndRedirect();
_this.initializeBinController();return _this;}_createClass(BinTesterWithSiteConfig,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){//this.verifyQueryParametersAndRedirect();
if(this.props.siteId!==prevProps.siteId){this.setState(INITIAL_STATE);this.isAutoRunning=false;//this.setQueryParameter(QUERY_PARAMETERS.aisle, undefined);
var map=this.state.queryMap;map[QUERY_PARAMETERS.aisle]=undefined;this.setState({queryMap:map});return;}// if site config becomes available or when site config is available and color or aisle changes, re-create bin controller
var validAisles=BinTesterWithSiteConfig.getAisles(this.props);var color=this.getColor(this.props);var aisle=this.getAisle(this.props);var prevValidAisles=BinTesterWithSiteConfig.getAisles(prevProps);var prevColor=this.getColor(prevProps);var prevAisle=this.getAisle(prevProps);if(validAisles!==prevValidAisles||color!==prevColor||aisle!==prevAisle){this.initializeBinController();}}},{key:'getAisle',value:function getAisle(){// parse query param and get aisle
return this.state.queryMap[QUERY_PARAMETERS.aisle]?this.state.queryMap[QUERY_PARAMETERS.aisle]:null;}},{key:'getColor',value:function getColor(){return this.state.queryMap[QUERY_PARAMETERS.color]?this.state.queryMap[QUERY_PARAMETERS.color]:DEFAULT_COLOR_NAME;}},{key:'initializeBinController',value:function initializeBinController(){var validAisles=BinTesterWithSiteConfig.getAisles(this.props);var color=this.getColor(this.props);var aisle=this.getAisle(this.props);var binLabelStyle=BinTesterWithSiteConfig.getBinLabelStyle(this.props,this.config.binLabelStyle);if(validAisles!=null&&aisle!=null&&color!=null){this.binController=new __WEBPACK_IMPORTED_MODULE_9__business_bin_cotroller__["a" /* default */](this.props.siteId,color,aisle,binLabelStyle);}else{this.binController=null;}}},{key:'verifyQueryParametersAndRedirect',value:function verifyQueryParametersAndRedirect(){var color=this.getColor(this.props);var aisle=this.getAisle(this.props);var validAisles=BinTesterWithSiteConfig.getAisles(this.props);var map=this.state.queryMap;if(!COLOR_NAMES.includes(color)){map[QUERY_PARAMETERS.color]=DEFAULT_COLOR_NAME;this.setState({queryMap:map});}if(validAisles!=null&&aisle!=null&&!validAisles.includes(aisle)){map[QUERY_PARAMETERS.aisle]=undefined;this.setState({queryMap:map});}}},{key:'setBinOn',value:function setBinOn(bin,color){var colorByBin=this.state.colorByBin;colorByBin.set(bin,color);this.setState({colorByBin:colorByBin});}},{key:'setBinOff',value:function setBinOff(bin){var colorByBin=this.state.colorByBin;colorByBin.delete(bin);this.setState({colorByBin:colorByBin});}},{key:'blinkBin',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(bin){var _this2=this;var colorRgb;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.binController.blink(bin);case 2:colorRgb=_context.sent;this.setBinOn(bin,'#'+colorRgb);setTimeout(function(){_this2.setBinOff(bin);},__WEBPACK_IMPORTED_MODULE_12__util_constant__["c" /* BIN_ON_DURATION_MS */]);case 5:case'end':return _context.stop();}}},_callee,this);}));function blinkBin(_x){return _ref.apply(this,arguments);}return blinkBin;}()},{key:'changeAisle',value:function changeAisle(aisle){this.isAutoRunning=false;var map=this.state.queryMap;map[QUERY_PARAMETERS.aisle]=aisle;this.setState({queryMap:map});}},{key:'handleColorSelection',value:function handleColorSelection(event){var color=event.target.value;var map=this.state.queryMap;map[QUERY_PARAMETERS.color]=color;this.setState({queryMap:map});}},{key:'handleAisleSelection',value:function handleAisleSelection(event){var aisle=event.target.value===''?null:event.target.value;this.changeAisle(aisle);}},{key:'handleAutoButtonClick',value:function handleAutoButtonClick(){if(!this.isAutoRunning){this.startAutoRun();}else{this.stopAutoRun();}}},{key:'startAutoRun',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var aisle,bins,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,bin;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:aisle=this.getAisle(this.props);this.isAutoRunning=true;this.setState({isAutoButtonPressed:true});bins=this.getBins();_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context2.prev=7;_iterator=bins[Symbol.iterator]();case 9:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context2.next=19;break;}bin=_step.value;if(!(!this.isAutoRunning||this.getAisle(this.props)!==aisle)){_context2.next=13;break;}return _context2.abrupt('return');case 13:this.blinkBin(bin);_context2.next=16;return Object(__WEBPACK_IMPORTED_MODULE_11__util_sleep__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__util_constant__["c" /* BIN_ON_DURATION_MS */]);case 16:_iteratorNormalCompletion=true;_context2.next=9;break;case 19:_context2.next=25;break;case 21:_context2.prev=21;_context2.t0=_context2['catch'](7);_didIteratorError=true;_iteratorError=_context2.t0;case 25:_context2.prev=25;_context2.prev=26;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 28:_context2.prev=28;if(!_didIteratorError){_context2.next=31;break;}throw _iteratorError;case 31:return _context2.finish(28);case 32:return _context2.finish(25);case 33:this.stopAutoRun();case 34:case'end':return _context2.stop();}}},_callee2,this,[[7,21,25,33],[26,,28,32]]);}));function startAutoRun(){return _ref2.apply(this,arguments);}return startAutoRun;}()},{key:'stopAutoRun',value:function stopAutoRun(){this.isAutoRunning=false;this.setState({isAutoButtonPressed:false});}},{key:'getBins',value:function getBins(){if(this.getAisle(this.props)!=null){var binConfig=BinTesterWithSiteConfig.getBinsByAisleConfig(this.props);var aisle=this.getAisle(this.props);return binConfig[aisle]?binConfig[aisle].flat(1):[];}return[];}},{key:'getAisleIndex',value:function getAisleIndex(aisle){var aisles=BinTesterWithSiteConfig.getAisles(this.props);if(aisles!=null){var aisleIndex=aisles.indexOf(aisle);return aisleIndex===-1?null:aisleIndex;}return null;}},{key:'getConnectivityByAisle',value:function getConnectivityByAisle(){var connectivityByAisle={};if(this.props.siteConfig.status===200&&this.props.siteConfig.data.controllerConfig&&this.props.siteConfig.data.controllerConfig.ledControllers){var ledControllers=this.props.siteConfig.data.controllerConfig.ledControllers;for(var controller in ledControllers){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=ledControllers[controller].aisles[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var aisle=_step2.value;connectivityByAisle[aisle.aisle]=aisle.isOnline;}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}return connectivityByAisle;}return null;}},{key:'isAutoReady',value:function isAutoReady(){if(this.props.siteId==null||this.getAisle(this.props)==null){return false;}else if(!this.isAutoRunning&&this.state.colorByBin.size>0){return false;}return true;}},{key:'generateAisleOptions',value:function generateAisleOptions(){var aisles=BinTesterWithSiteConfig.getAisles(this.props);var aisleOptions=[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:'',value:''},'Choose an aisle')];if(aisles){for(var i=0;i<aisles.length;i+=1){var aisleLabel=aisles[i];aisleOptions.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:aisleLabel,value:aisleLabel},aisleLabel));}}return aisleOptions;}},{key:'generateColorOptions',value:function generateColorOptions(){return COLOR_NAMES.map(function(colorName,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:index},colorName);});}},{key:'generateConnectivityWarning',value:function generateConnectivityWarning(){var connectivityByAisle=this.getConnectivityByAisle();var aisleLabel=this.getAisle(this.props);if(aisleLabel==null){return null;}else if(connectivityByAisle==null||connectivityByAisle[aisleLabel]==null){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Alert__["a" /* default */],{variant:'warning'},'Connectivity info is not available');}else if(!connectivityByAisle[aisleLabel]){var macAddress=connectivityByAisle[aisleLabel].macAddress;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Alert__["a" /* default */],{variant:'danger'},'LED controller for '+aisleLabel+' is offline. Controller MAC address is '+macAddress+'.');}return null;}},{key:'generateRacks',value:function generateRacks(){var binConfig=BinTesterWithSiteConfig.getBinsByAisleConfig(this.props);var aisleLabel=this.getAisle(this.props);if(aisleLabel==null){return{racks:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Select a aisle to begin')};}else if(binConfig[aisleLabel]==null){return{racks:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Cannot find bin configuration for aisle ',aisleLabel,'. Please contact SBL team.')};}var binsForAisle=binConfig[aisleLabel];var binButtonRows=[];var _generateGridByLabelT=this.generateGridByLabelType(binsForAisle),regButtons=_generateGridByLabelT.regButtons,ovButtons=_generateGridByLabelT.ovButtons;for(var i=0;i<regButtons.length;i+=1){var buttonsInRow=regButtons[regButtons.length-i-1];binButtonRows.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_ButtonGroup__["a" /* default */],{key:i},buttonsInRow));}return{racks:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_ButtonGroup__["a" /* default */],{vertical:true},binButtonRows),ovRacks:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_ButtonGroup__["a" /* default */],null,ovButtons)};}},{key:'generateGridByLabelType',value:function generateGridByLabelType(binsForAisle){if(BinTesterWithSiteConfig.getBinLabelStyle(this.props)===__WEBPACK_IMPORTED_MODULE_12__util_constant__["b" /* BIN_LABEL_STYLES */].IN_SC){var _BinTesterWithSiteCon=BinTesterWithSiteConfig.getRackType(this.props),row=_BinTesterWithSiteCon.Row,column=_BinTesterWithSiteCon.Column;return this.generateGridByRack(binsForAisle,row,column);}else{var bins=binsForAisle.sort();return this.generateGrid(bins);}}// Temp solution for IN SC use case.
},{key:'generateGridByRack',value:function generateGridByRack(bins,numOfRow,numOfCol){var button=void 0;var maxLength=void 0;var buttonsInRow=[];var regButtons=[];var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=bins[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var bin=_step3.value;var index=bins.indexOf(bin);maxLength=bins.length<=numOfCol?numOfCol:Math.ceil(bins.length/numOfRow);if(index%maxLength===0&&buttonsInRow.length>0){regButtons[numOfRow-1-Math.floor((index-1)/maxLength)]=buttonsInRow;buttonsInRow=[];}// use oversize button instead as can have long label
button=this.generateOversizeButton(bin);buttonsInRow.push(button);}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}if(buttonsInRow.length>0){regButtons[numOfRow-1-Math.floor((bins.length-1)/maxLength)]=buttonsInRow;}for(var i=0;i<regButtons.length;i+=1){var row=regButtons[i];while(row&&row.length<maxLength){row.push(this.generateEmptyOVButton(i+'-'+row.length));}}return{regButtons:regButtons};}},{key:'generateGrid',value:function generateGrid(bins){var button=void 0;var rowIndex=void 0;var curIndex=0;var buttonsInRow=[];var regButtons=[];var ovButtons=[];var maxLength=0;var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=bins[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var bin=_step4.value;if(bin.toUpperCase().startsWith('OV')){button=this.generateOversizeButton(bin);ovButtons.push(button);}else{rowIndex=bin.split(/[.-]/).slice(-1)[0].slice(0,-1);if(curIndex!==rowIndex){if(buttonsInRow.length>0){regButtons.push(buttonsInRow);maxLength=maxLength<buttonsInRow.length?buttonsInRow.length:maxLength;buttonsInRow=[];}curIndex=rowIndex;}button=this.generateBinButton(bin);buttonsInRow.push(button);}}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}if(buttonsInRow.length>0){regButtons.push(buttonsInRow);}for(var i=0;i<regButtons.length;i+=1){var row=regButtons[i];while(row.length<maxLength){row.push(this.generateEmptyButton(i+'-'+row.length));}}return{regButtons:regButtons,ovButtons:ovButtons,maxLength:maxLength};}},{key:'generateEmptyButton',value:function generateEmptyButton(key){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:BIN_BUTTON_CLASS_NAME,style:BIN_BUTTON_STYLE,key:key,variant:'link',disabled:true});}},{key:'generateEmptyOVButton',value:function generateEmptyOVButton(key){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:OV_BUTTON_CLASS_NAME,style:OV_BUTTON_STYLE,key:key,variant:'link',disabled:true});}},{key:'generateBinLabelForSC',value:function generateBinLabelForSC(bin){var _this3=this;var lst=bin.split(new RegExp('-|_'));var label=lst.filter(function(ele){return ele.match('^^[A-Z0-9]{4}$')&&ele!==_this3.props.siteId;});return label.join('_');}},{key:'generateBinButton',value:function generateBinButton(bin){var _this4=this;var backgroundColor=this.state.colorByBin.get(bin)||GREY_RGB_COLOR;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:BIN_BUTTON_CLASS_NAME,style:Object.assign({},BIN_BUTTON_STYLE,{backgroundColor:backgroundColor}),variant:'outline-dark',key:bin,name:bin,onClick:function onClick(){return _this4.blinkBin(bin);}},bin);}},{key:'generateOversizeButton',value:function generateOversizeButton(bin){var _this5=this;var backgroundColor=this.state.colorByBin.get(bin)||GREY_RGB_COLOR;var label=bin;if(BinTesterWithSiteConfig.getBinLabelStyle(this.props)===__WEBPACK_IMPORTED_MODULE_12__util_constant__["b" /* BIN_LABEL_STYLES */].IN_SC){label=this.generateBinLabelForSC(bin);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:OV_BUTTON_CLASS_NAME,style:Object.assign({},OV_BUTTON_STYLE,{backgroundColor:backgroundColor}),variant:'outline-dark',key:bin,name:bin,onClick:function onClick(){return _this5.blinkBin(bin);}},label);}},{key:'generateAutoButton',value:function generateAutoButton(){var variant=this.state.isAutoButtonPressed?'danger':'outline-success';var buttonLabel=this.state.isAutoButtonPressed?'Stop':'Auto';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:'ml-2 mr-2',variant:variant,onClick:this.handleAutoButtonClick.bind(this),disabled:!this.isAutoReady()},buttonLabel);}},{key:'generatePrevAisleButton',value:function generatePrevAisleButton(){var _this6=this;var aisles=BinTesterWithSiteConfig.getAisles(this.props);var currentAisle=this.getAisle(this.props);var aisleIndex=this.getAisleIndex(currentAisle);if(aisleIndex==null||aisleIndex===0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:'ml-2 mr-2',variant:'link',disabled:true,active:false});}var prevAisleIndex=aisleIndex-1;var prevAisleLabel=aisles[prevAisleIndex];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:'ml-2 mr-2',variant:'warning',onClick:function onClick(){return _this6.changeAisle(prevAisleLabel);}},'< '+prevAisleLabel);}},{key:'generateNextAisleButton',value:function generateNextAisleButton(){var _this7=this;var aisles=BinTesterWithSiteConfig.getAisles(this.props);var currentAisle=this.getAisle(this.props);var aisleIndex=this.getAisleIndex(currentAisle);if(aisles!=null&&aisleIndex===aisles.length-1){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:'ml-2 mr-2',variant:'link',disabled:true,active:false});}var nextAisleIndex=aisleIndex==null?0:aisleIndex+1;var nextAisleLabel=aisles?aisles[nextAisleIndex]:"";return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:'ml-2 mr-2',variant:'warning',onClick:function onClick(){return _this7.changeAisle(nextAisleLabel);}},nextAisleLabel+' >');}},{key:'render',value:function render(){var _generateRacks=this.generateRacks(),racks=_generateRacks.racks,ovRacks=_generateRacks.ovRacks;var aisle=this.getAisle(this.props);var aisles=this.generateAisleOptions();var colors=this.generateColorOptions();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_Row__["a" /* default */],{className:'mt-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_Form__["a" /* default */].Group,{controlId:'color'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_Form__["a" /* default */].Label,null,'Color'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_Form__["a" /* default */].Control,{as:'select',name:'color',value:this.getColor(this.props),onChange:this.handleColorSelection.bind(this)},colors))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_Form__["a" /* default */].Group,{controlId:'aisle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_Form__["a" /* default */].Label,null,'Aisle'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_Form__["a" /* default */].Control,{as:'select',name:'aisle',value:aisle==null?'':aisle,onChange:this.handleAisleSelection.bind(this)},aisles)))),this.generateConnectivityWarning(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_Row__["a" /* default */],{style:{overflowX:'auto',whiteSpace:'nowrap'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__["a" /* default */],null,racks)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_Row__["a" /* default */],{className:'justify-content-center mt-3 mb-3 p-0'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__["a" /* default */],{className:'m-0 p-0'},ovRacks)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_Row__["a" /* default */],{className:'justify-content-md-center mt-3 mb-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__["a" /* default */],null,this.generatePrevAisleButton(),this.generateAutoButton(),this.generateNextAisleButton()))));}}],[{key:'getAisles',value:function getAisles(props){var binConfig=BinTesterWithSiteConfig.getBinsByAisleConfig(props);return binConfig==null?null:Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["_31" /* sortAlphaNumeric */])(Object.keys(binConfig));}},{key:'getBinsByAisleConfig',value:function getBinsByAisleConfig(props){if(props.siteConfig.status===200&&props.siteConfig.data.binConfig!=null){return props.siteConfig.data.binConfig.binsByAisle;}return null;}// Temp solution for IN SC use case
},{key:'getBinLabelStyle',value:function getBinLabelStyle(props,defaultType){if(props.siteConfig.status===200&&props.siteConfig.data.binLabelStyle!=null){return props.siteConfig.data.binLabelStyle;}return defaultType;}// Temp solution for IN SC use case
},{key:'getRackType',value:function getRackType(props){if(props.siteConfig.status===200&&props.siteConfig.data.rackType!=null){return props.siteConfig.data.rackType;}return{Row:2,Column:3};}}]);return BinTesterWithSiteConfig;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BinTesterWithSiteConfig);

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);



/* harmony default export */ __webpack_exports__["a"] = (function (className) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(function (p, ref) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, p, {
      ref: ref,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(p.className, className)
    }));
  });
});

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dom_helpers_transitionEnd__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group_Transition__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__triggerBrowserReflow__ = __webpack_require__(501);



var _fadeStyles;






var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var fadeStyles = (_fadeStyles = {}, _fadeStyles[__WEBPACK_IMPORTED_MODULE_5_react_transition_group_Transition__["b" /* ENTERING */]] = 'show', _fadeStyles[__WEBPACK_IMPORTED_MODULE_5_react_transition_group_Transition__["a" /* ENTERED */]] = 'show', _fadeStyles);
var Fade = __WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["className", "children"]);

  var handleEnter = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useCallback"])(function (node) {
    Object(__WEBPACK_IMPORTED_MODULE_6__triggerBrowserReflow__["a" /* default */])(node);
    if (props.onEnter) props.onEnter(node);
  }, [props]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_transition_group_Transition__["e" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    addEndListener: __WEBPACK_IMPORTED_MODULE_3_dom_helpers_transitionEnd__["a" /* default */]
  }, props, {
    onEnter: handleEnter
  }), function (status, innerProps) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('fade', className, children.props.className, fadeStyles[status])
    }));
  });
});
Fade.defaultProps = defaultProps;
Fade.displayName = 'Fade';
/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);





var propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
var defaultProps = {
  label: 'Close'
};
var CloseButton = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var label = _ref.label,
      onClick = _ref.onClick,
      className = _ref.className,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["label", "onClick", "className"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("button", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    type: "button",
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('close', className),
    onClick: onClick
  }, props), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
    className: "sr-only"
  }, label));
});
CloseButton.displayName = 'CloseButton';
CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CloseButton);

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormContext__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(49);






var defaultProps = {
  type: 'checkbox'
};
var FormCheckInput = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      className = _ref.className,
      isValid = _ref.isValid,
      isInvalid = _ref.isInvalid,
      isStatic = _ref.isStatic,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'input' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["id", "bsPrefix", "bsCustomPrefix", "className", "isValid", "isInvalid", "isStatic", "as"]);

  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__FormContext__["a" /* default */]),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  var _ref2 = custom ? [bsCustomPrefix, 'custom-control-input'] : [bsPrefix, 'form-check-input'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* useBootstrapPrefix */])(prefix, defaultPrefix);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    id: id || controlId,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid', isStatic && 'position-static')
  }));
});
FormCheckInput.displayName = 'FormCheckInput';
FormCheckInput.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (FormCheckInput);

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormContext__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(49);






var FormCheckLabel = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      className = _ref.className,
      htmlFor = _ref.htmlFor,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "bsCustomPrefix", "className", "htmlFor"]);

  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__FormContext__["a" /* default */]),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  var _ref2 = custom ? [bsCustomPrefix, 'custom-control-label'] : [bsPrefix, 'form-check-label'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* useBootstrapPrefix */])(prefix, defaultPrefix);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("label", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    htmlFor: htmlFor || controlId,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix)
  }));
});
FormCheckLabel.displayName = 'FormCheckLabel';
/* harmony default export */ __webpack_exports__["a"] = (FormCheckLabel);

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types_extra_lib_all__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Feedback__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormFileInput__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormFileLabel__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormContext__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ThemeProvider__ = __webpack_require__(49);










var defaultProps = {
  disabled: false,
  isValid: false,
  isInvalid: false
};
var FormFile = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      disabled = _ref.disabled,
      isValid = _ref.isValid,
      isInvalid = _ref.isInvalid,
      feedback = _ref.feedback,
      className = _ref.className,
      style = _ref.style,
      label = _ref.label,
      children = _ref.children,
      custom = _ref.custom,
      lang = _ref.lang,
      dataBrowse = _ref['data-browse'],
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      _ref$inputAs = _ref.inputAs,
      inputAs = _ref$inputAs === void 0 ? 'input' : _ref$inputAs,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["id", "bsPrefix", "bsCustomPrefix", "disabled", "isValid", "isInvalid", "feedback", "className", "style", "label", "children", "custom", "lang", "data-browse", "as", "inputAs"]);

  var _ref2 = custom ? [bsCustomPrefix, 'custom'] : [bsPrefix, 'form-file'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_9__ThemeProvider__["a" /* useBootstrapPrefix */])(prefix, defaultPrefix);
  var type = 'file';

  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__FormContext__["a" /* default */]),
      controlId = _useContext.controlId;

  var innerFormContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
    return {
      controlId: id || controlId,
      custom: custom
    };
  }, [controlId, custom, id]);
  var hasLabel = label != null && label !== false && !children;
  var input = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FormFileInput__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    isValid: isValid,
    isInvalid: isInvalid,
    disabled: disabled,
    as: inputAs,
    lang: lang
  }));
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FormContext__["a" /* default */].Provider, {
    value: innerFormContext
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, {
    style: style,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix, custom && "custom-" + type)
  }, children || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment, null, custom ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment, null, input, hasLabel && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FormFileLabel__["a" /* default */], {
    "data-browse": dataBrowse
  }, label)) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment, null, hasLabel && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FormFileLabel__["a" /* default */], null, label), input), (isValid || isInvalid) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Feedback__["a" /* default */], {
    type: isValid ? 'valid' : 'invalid'
  }, feedback))));
});
FormFile.displayName = 'FormFile';
FormFile.defaultProps = defaultProps;
FormFile.Input = __WEBPACK_IMPORTED_MODULE_6__FormFileInput__["a" /* default */];
FormFile.Label = __WEBPACK_IMPORTED_MODULE_7__FormFileLabel__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (FormFile);

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormContext__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(49);






var FormFileInput = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      className = _ref.className,
      isValid = _ref.isValid,
      isInvalid = _ref.isInvalid,
      lang = _ref.lang,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'input' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["id", "bsPrefix", "bsCustomPrefix", "className", "isValid", "isInvalid", "lang", "as"]);

  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__FormContext__["a" /* default */]),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  var type = 'file';

  var _ref2 = custom ? [bsCustomPrefix, 'custom-file-input'] : [bsPrefix, 'form-control-file'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* useBootstrapPrefix */])(prefix, defaultPrefix);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    id: id || controlId,
    type: type,
    lang: lang,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
  }));
});
FormFileInput.displayName = 'FormFileInput';
/* harmony default export */ __webpack_exports__["a"] = (FormFileInput);

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormContext__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(49);






var FormFileLabel = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      className = _ref.className,
      htmlFor = _ref.htmlFor,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "bsCustomPrefix", "className", "htmlFor"]);

  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__FormContext__["a" /* default */]),
      controlId = _useContext.controlId,
      custom = _useContext.custom;

  var _ref2 = custom ? [bsCustomPrefix, 'custom-file-label'] : [bsPrefix, 'form-file-label'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* useBootstrapPrefix */])(prefix, defaultPrefix);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("label", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    htmlFor: htmlFor || controlId,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix),
    "data-browse": props['data-browse']
  }));
});
FormFileLabel.displayName = 'FormFileLabel';
/* harmony default export */ __webpack_exports__["a"] = (FormFileLabel);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types_extra_lib_all__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Feedback__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormContext__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ThemeProvider__ = __webpack_require__(49);









var FormControl = __WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      bsCustomPrefix = _ref.bsCustomPrefix,
      type = _ref.type,
      size = _ref.size,
      id = _ref.id,
      className = _ref.className,
      isValid = _ref.isValid,
      isInvalid = _ref.isInvalid,
      plaintext = _ref.plaintext,
      readOnly = _ref.readOnly,
      custom = _ref.custom,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'input' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "bsCustomPrefix", "type", "size", "id", "className", "isValid", "isInvalid", "plaintext", "readOnly", "custom", "as"]);

  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__FormContext__["a" /* default */]),
      controlId = _useContext.controlId;

  var _ref2 = custom ? [bsCustomPrefix, 'custom'] : [bsPrefix, 'form-control'],
      prefix = _ref2[0],
      defaultPrefix = _ref2[1];

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_8__ThemeProvider__["a" /* useBootstrapPrefix */])(prefix, defaultPrefix);
  var classes;

  if (plaintext) {
    var _classes;

    classes = (_classes = {}, _classes[bsPrefix + "-plaintext"] = true, _classes);
  } else if (type === 'file') {
    var _classes2;

    classes = (_classes2 = {}, _classes2[bsPrefix + "-file"] = true, _classes2);
  } else if (type === 'range') {
    var _classes3;

    classes = (_classes3 = {}, _classes3[bsPrefix + "-range"] = true, _classes3);
  } else if (Component === 'select' && custom) {
    var _classes4;

    classes = (_classes4 = {}, _classes4[bsPrefix + "-select"] = true, _classes4[bsPrefix + "-select-" + size] = size, _classes4);
  } else {
    var _classes5;

    classes = (_classes5 = {}, _classes5[bsPrefix] = true, _classes5[bsPrefix + "-" + size] = size, _classes5);
  }

   false ? warning(controlId == null || !id, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    type: type,
    ref: ref,
    readOnly: readOnly,
    id: id || controlId,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, classes, isValid && "is-valid", isInvalid && "is-invalid")
  }));
});
FormControl.displayName = 'FormControl';
FormControl.Feedback = __WEBPACK_IMPORTED_MODULE_6__Feedback__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (FormControl);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormContext__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(49);






var FormGroup = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      controlId = _ref.controlId,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "children", "controlId", "as"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'form-group');
  var context = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
    return {
      controlId: controlId
    };
  }, [controlId]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FormContext__["a" /* default */].Provider, {
    value: context
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix)
  }), children));
});
FormGroup.displayName = 'FormGroup';
/* harmony default export */ __webpack_exports__["a"] = (FormGroup);

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Col__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormContext__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThemeProvider__ = __webpack_require__(49);








var defaultProps = {
  column: false,
  srOnly: false
};
var FormLabel = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'label' : _ref$as,
      bsPrefix = _ref.bsPrefix,
      column = _ref.column,
      srOnly = _ref.srOnly,
      className = _ref.className,
      htmlFor = _ref.htmlFor,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["as", "bsPrefix", "column", "srOnly", "className", "htmlFor"]);

  var _useContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__FormContext__["a" /* default */]),
      controlId = _useContext.controlId;

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_7__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'form-label');
  var columnClass = 'col-form-label';
  if (typeof column === 'string') columnClass = columnClass + "-" + column;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix, srOnly && 'sr-only', column && columnClass);
   false ? warning(controlId == null || !htmlFor, '`controlId` is ignored on `<FormLabel>` when `htmlFor` is specified.') : void 0;
  htmlFor = htmlFor || controlId;
  if (column) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Col__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    as: "label",
    className: classes,
    htmlFor: htmlFor
  }, props));
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      ref: ref,
      className: classes,
      htmlFor: htmlFor
    }, props))
  );
});
FormLabel.displayName = 'FormLabel';
FormLabel.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (FormLabel);

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThemeProvider__ = __webpack_require__(49);





var FormText = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'small' : _ref$as,
      muted = _ref.muted,
      props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["bsPrefix", "className", "as", "muted"]);

  bsPrefix = Object(__WEBPACK_IMPORTED_MODULE_4__ThemeProvider__["a" /* useBootstrapPrefix */])(bsPrefix, 'form-text');
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, bsPrefix, muted && 'text-muted')
  }));
});
FormText.displayName = 'FormText';
/* harmony default export */ __webpack_exports__["a"] = (FormText);

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormCheck__ = __webpack_require__(505);



var Switch = __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(function (props, ref) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FormCheck__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    ref: ref,
    type: "switch"
  }));
});
Switch.displayName = 'Switch';
Switch.Input = __WEBPACK_IMPORTED_MODULE_2__FormCheck__["a" /* default */].Input;
Switch.Label = __WEBPACK_IMPORTED_MODULE_2__FormCheck__["a" /* default */].Label;
/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_constant__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__ = __webpack_require__(51);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var COLOR_ARRAY=Object.keys(__WEBPACK_IMPORTED_MODULE_1__util_constant__["d" /* COLOR_MAP */]).map(function(colorName){return __WEBPACK_IMPORTED_MODULE_1__util_constant__["d" /* COLOR_MAP */][colorName];});var BinController=function(){// TODO: add bin label style (US: aisle.bin; EU: aisle-bin)
function BinController(siteId,color,aisle,binLabelStyle){_classCallCheck(this,BinController);console.log("BinController siteId="+siteId);this.siteId=siteId;this.color=color;this.aisle=aisle;this.binLabelStyle=binLabelStyle;}/**
     * Start LED blinking for a bin
     * @param {String} bin label of a bin(A-1.1A for NA, A1-1A for EU)
     * @returns {String} rgb color encoding
     */_createClass(BinController,[{key:"blink",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(bin){var request,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:request={nodeId:this.siteId,assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_97" /* LED_CONTROLLER_ASSET_TYPE */],commandParams:{locationType:"BIN",state:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_146" /* ON_STATE */],color:BinController._getColor(this.color),binLocation:this._generateBinLabel(bin)}};args=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_59" /* ENDPOINT_PUBLISH_LIGHT_COMMAND_TO_THIN_CLIENT */]);_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context.abrupt("return",BinController._getColor(this.color).slice(4));case 5:case"end":return _context.stop();}}},_callee,this);}));function blink(_x){return _ref.apply(this,arguments);}return blink;}()},{key:"_generateBinLabel",value:function _generateBinLabel(bin){if(bin.includes('-')||bin.includes('.')){return bin;}switch(this.binLabelStyle){case __WEBPACK_IMPORTED_MODULE_1__util_constant__["b" /* BIN_LABEL_STYLES */].EU:return this.aisle+"-"+bin;case __WEBPACK_IMPORTED_MODULE_1__util_constant__["b" /* BIN_LABEL_STYLES */].NA:return this.aisle+"."+bin;case __WEBPACK_IMPORTED_MODULE_1__util_constant__["b" /* BIN_LABEL_STYLES */].IN_SC:return bin;default:return this.aisle+"."+bin;}}/**
     * Generate MQTT command to blink a bin
     * @param {String} bin label of a bin(A-1.1A for NA, A1-1A for EU)
     * @returns {Object} MQTT command
     */},{key:"_generateMqttCommand",value:function _generateMqttCommand(bin){var binLabel=this._generateBinLabel(bin);return{commands:[{state:'ON',color:BinController._getColor(this.color),duty:15,period:400,count:Math.ceil(__WEBPACK_IMPORTED_MODULE_1__util_constant__["c" /* BIN_ON_DURATION_MS */]/400),delay:0,tagLocationIds:[binLabel],tagLabels:[binLabel],sensor:'led'}]};}}],[{key:"_getColor",value:function _getColor(color){if(!color||!__WEBPACK_IMPORTED_MODULE_1__util_constant__["d" /* COLOR_MAP */][color]){return COLOR_ARRAY[Math.round(Math.random()*6)];}return __WEBPACK_IMPORTED_MODULE_1__util_constant__["d" /* COLOR_MAP */][color];}}]);return BinController;}();/* harmony default export */ __webpack_exports__["a"] = (BinController);

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_aisle_tester_with_site_config__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_aisle_tester_without_site_config__ = __webpack_require__(1286);
var AisleTesterPage=function AisleTesterPage(props){if(props.siteId==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Select a site');}if(props.siteConfig==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__component_aisle_tester_without_site_config__["a" /* default */],props);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_aisle_tester_with_site_config__["a" /* default */],props);};/* harmony default export */ __webpack_exports__["a"] = (AisleTesterPage);

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Row__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Col__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Container__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Form__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__business_all_aisle_test_runner__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_humanize_duration__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_humanize_duration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_humanize_duration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__test_duration_picker__ = __webpack_require__(508);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var REFRESH_INTERVAL_IN_MS=1*60*1000;// 1 min
var CLUSTER_BUTTON_STYLE={margin:'1rem'};var CLUSTER_BUTTON_PER_ROW=2;var DEFAULT_PATTERN_ID='green';var PATTERN_IDS=['red','green','blue','grey'];var QUERY_PARAMETERS={patternId:'patternId'};var AllAisleTester=function(_React$Component){_inherits(AllAisleTester,_React$Component);function AllAisleTester(props){_classCallCheck(this,AllAisleTester);//this.validateQueryParameterAndRedirect();
var _this=_possibleConstructorReturn(this,(AllAisleTester.__proto__||Object.getPrototypeOf(AllAisleTester)).call(this,props));_this.updateTimeNow=function(){// To trigger re-render of the buttons to show the updated remaining time of running tests
if(_this.isAnyClusterRunning()){_this.setState({timeNow:Date.now()});}};_this.handleClusterClick=function(event){var cluster=event.target.dataset.cluster;var runner=_this.runnerByCluster[cluster];var testDuration=_this.state.testDuration;var patternId=_this.getPatternId(_this.props);if(runner){if(!runner.isRunning){runner.start(patternId,testDuration);}else{runner.stop();}}};_this.handleAllClustersOn=function(){var clusterConfig=_this.getClusterConfig();var testDuration=_this.state.testDuration;var patternId=_this.getPatternId(_this.props);var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=clusterConfig.clusters[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _ref=_step.value;var cluster=_ref.cluster;_this.runnerByCluster[cluster].start(patternId,testDuration);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}};_this.handleStop=function(){for(var cluster in _this.runnerByCluster){var runner=_this.runnerByCluster[cluster];runner.stop();}};_this.handlePatternChange=function(event){var patternId=event.target.value;var map=_this.state.queryMap;map[QUERY_PARAMETERS.patternId]=patternId;_this.setState({queryMap:map});};_this.handleTestDurationChange=function(testDuration){_this.setState({testDuration:testDuration});};_this.state={isOnByCluster:_this.createInitialRunningState(),testDuration:__WEBPACK_IMPORTED_MODULE_8__test_duration_picker__["a" /* DEFAULT_TEST_DURATION_IN_MS */],timeNow:Date.now(),queryMap:{}};_this.resetRunners();return _this;}_createClass(AllAisleTester,[{key:'componentDidMount',value:function componentDidMount(){this.intervalTimer=setInterval(this.updateTimeNow,REFRESH_INTERVAL_IN_MS);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){this.validateQueryParameterAndRedirect();if(prevProps.siteId!==this.props.siteId){this.resetRunners();this.setState({isOnByCluster:this.createInitialRunningState()});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.resetRunners();clearInterval(this.intervalTimer);}},{key:'getPatternId',value:function getPatternId(props){return this.state.queryMap[QUERY_PARAMETERS.patternId]?this.state.queryMap[QUERY_PARAMETERS.patternId]:DEFAULT_PATTERN_ID;}},{key:'createInitialRunningState',value:function createInitialRunningState(){var isOnByCluster={};var clusterConfig=this.getClusterConfig();var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=clusterConfig.clusters[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _ref2=_step2.value;var cluster=_ref2.cluster;isOnByCluster[cluster]=false;}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}return isOnByCluster;}},{key:'resetRunners',value:function resetRunners(){var _this2=this;for(var cluster in this.runnerByCluster){var runner=this.runnerByCluster[cluster];if(runner.isRunning){runner.stop();}}this.runnerByCluster={};// one runner per cluster
var clusterConfig=this.getClusterConfig();var _loop=function _loop(_ref3){var cluster=_ref3.cluster,ledControllers=_ref3.ledControllers;var portIdsByControllerIp={};var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=ledControllers[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var _ref4=_step4.value;var ip=_ref4.ip,portIds=_ref4.portIds;portIdsByControllerIp[ip]=portIds;}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}_this2.runnerByCluster[cluster]=new __WEBPACK_IMPORTED_MODULE_6__business_all_aisle_test_runner__["a" /* default */]({siteId:_this2.props.siteId,portIdsByControllerIp:portIdsByControllerIp,callbackOnStart:function callbackOnStart(){return _this2.setRunningStatus(cluster,true);},callbackOnStop:function callbackOnStop(){return _this2.setRunningStatus(cluster,false);}});};var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=clusterConfig.clusters[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var _ref3=_step3.value;_loop(_ref3);}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}}},{key:'setRunningStatus',value:function setRunningStatus(cluster,isRunning){var isOnByCluster=this.state.isOnByCluster;isOnByCluster[cluster]=isRunning;this.setState({isOnByCluster:isOnByCluster});}},{key:'validateQueryParameterAndRedirect',value:function validateQueryParameterAndRedirect(){var patternId=this.getPatternId(this.props);if(!PATTERN_IDS.includes(patternId)){var map=this.state.queryMap;map[QUERY_PARAMETERS.patternId]=DEFAULT_PATTERN_ID;this.setState({queryMap:map});}}},{key:'getClusterConfig',value:function getClusterConfig(){if(this.props.siteConfig.status===200){return this.props.siteConfig.data.clusterConfig;}return null;}},{key:'isAnyClusterRunning',value:function isAnyClusterRunning(){return Object.values(this.state.isOnByCluster).some(Boolean);}},{key:'isAllClustersRunning',value:function isAllClustersRunning(){return Object.values(this.state.isOnByCluster).every(Boolean);}},{key:'generateClusterButtonLabel',value:function generateClusterButtonLabel(cluster){var _state=this.state,isOnByCluster=_state.isOnByCluster,testDuration=_state.testDuration;var buttonLabel=cluster;if(isOnByCluster[cluster]){var testEndTime=this.runnerByCluster[cluster].runEndtime;// testEndTime is not set until all aisles are started, which can take a few seconds
// fallback to display the user picked testDuration if testEndTime is not calculated yet
var remainingTime=testEndTime?testEndTime-Date.now():testDuration;var humanizedRemainingTime=__WEBPACK_IMPORTED_MODULE_7_humanize_duration___default()(remainingTime,{units:['d','h','m'],round:true});buttonLabel+=' ('+humanizedRemainingTime+' remaining)';}return buttonLabel;}},{key:'renderClusterButton',value:function renderClusterButton(cluster){var isOnByCluster=this.state.isOnByCluster;var variant=isOnByCluster[cluster]?'primary':'outline-primary';var buttonLabel=this.generateClusterButtonLabel(cluster);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Col__["a" /* default */],{key:cluster},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{variant:variant,'data-cluster':cluster,onClick:this.handleClusterClick,className:'w-75',style:CLUSTER_BUTTON_STYLE},buttonLabel));}},{key:'renderClusterButtonGrid',value:function renderClusterButtonGrid(){var clusterConfig=this.getClusterConfig();var buttons=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Row__["a" /* default */],{key:'clusters'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Col__["a" /* default */],null,'Clusters'))];var columns=[];var rowCount=0;var _iteratorNormalCompletion5=true;var _didIteratorError5=false;var _iteratorError5=undefined;try{for(var _iterator5=clusterConfig.clusters[Symbol.iterator](),_step5;!(_iteratorNormalCompletion5=(_step5=_iterator5.next()).done);_iteratorNormalCompletion5=true){var _ref5=_step5.value;var cluster=_ref5.cluster;var button=this.renderClusterButton(cluster);columns.push(button);if(columns.length>=CLUSTER_BUTTON_PER_ROW){buttons.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Row__["a" /* default */],{className:'justify-content-md-center',key:rowCount},columns));rowCount+=1;columns=[];}}}catch(err){_didIteratorError5=true;_iteratorError5=err;}finally{try{if(!_iteratorNormalCompletion5&&_iterator5.return){_iterator5.return();}}finally{if(_didIteratorError5){throw _iteratorError5;}}}if(columns.length>0){var i=0;while(columns.length<CLUSTER_BUTTON_PER_ROW){columns.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Col__["a" /* default */],{key:'placeholder-'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{variant:'link',disabled:true,active:false,className:'w-50',style:CLUSTER_BUTTON_STYLE})));i+=1;}buttons.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Row__["a" /* default */],{key:rowCount},columns));}return buttons;}},{key:'renderPatternIdOptions',value:function renderPatternIdOptions(){return PATTERN_IDS.map(function(patternId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:patternId},patternId);});}},{key:'renderConfigSection',value:function renderConfigSection(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Col__["a" /* default */],{md:{span:2,offset:4}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Form__["a" /* default */].Group,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Form__["a" /* default */].Label,null,'Pattern'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Form__["a" /* default */].Control,{as:'select',value:this.getPatternId(this.props),onChange:this.handlePatternChange},this.renderPatternIdOptions()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Col__["a" /* default */],{md:{span:2}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__test_duration_picker__["b" /* default */],{testDuration:this.state.testDuration,onChange:this.handleTestDurationChange})));}},{key:'renderBulkActionButtons',value:function renderBulkActionButtons(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Col__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:'mr-3',size:'lg',variant:this.isAllClustersRunning()?'success':'outline-success',onClick:this.handleAllClustersOn},'ALL ON'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{variant:'outline-danger',size:'lg',onClick:this.handleStop},'ALL OFF'));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb-1',style:{marginTop:'6rem'}},this.renderConfigSection()),this.renderClusterButtonGrid(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_Row__["a" /* default */],{className:'mt-3'},this.renderBulkActionButtons()));}}]);return AllAisleTester;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AllAisleTester);

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Button__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Container__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__business_all_aisle_test_runner__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_Row__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__test_duration_picker__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_humanize_duration__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_humanize_duration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_humanize_duration__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var REFRESH_INTERVAL_IN_MS=1*60*1000;// 1 min
var DEFAULT_PATTERN_ID='red';var DEFAULT_AISLE_COUNT=48;var DEFAULT_STATE={controllerIp:null,isBroadcast:true,patternId:DEFAULT_PATTERN_ID,isRunning:false,aisleCount:DEFAULT_AISLE_COUNT,testDuration:__WEBPACK_IMPORTED_MODULE_8__test_duration_picker__["a" /* DEFAULT_TEST_DURATION_IN_MS */],timeNow:Date.now()};var AllAisleTester=function(_React$Component){_inherits(AllAisleTester,_React$Component);function AllAisleTester(props){var _this2=this;_classCallCheck(this,AllAisleTester);var _this=_possibleConstructorReturn(this,(AllAisleTester.__proto__||Object.getPrototypeOf(AllAisleTester)).call(this,props));_this.updateTimeNow=function(){// To trigger re-render of the buttons to show the updated remaining time of running tests
if(_this.state.isRunning){_this.setState({timeNow:Date.now()});}};_this.handleStart=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$state,patternId,testDuration;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$state=_this.state,patternId=_this$state.patternId,testDuration=_this$state.testDuration;_this.runner=_this.createRunner();console.log('startRunner');_this.runner.start(patternId,testDuration);case 4:case'end':return _context.stop();}}},_callee,_this2);}));_this.handleStopCluster=function(){if(_this.runner==null){_this.runner=_this.createRunner();}_this.clearRunner();};_this.handleIpChange=function(event){var controllerIp=event.target.value===''?null:event.target.value;_this.setState({controllerIp:controllerIp});};_this.handleIsBroadcastChange=function(event){var isBroadcast=event.target.checked;console.log("handleIsBroadcastChange braodcast="+isBroadcast);if(isBroadcast){_this.setState({controllerIp:null,clusterLabel:null});}_this.setState({isBroadcast:isBroadcast});};_this.handlePatternChange=function(event){var patternId=event.target.value;_this.setState({patternId:patternId});};_this.handleTestDurationChange=function(testDuration){_this.setState({testDuration:testDuration});};_this.runner=null;_this.state=DEFAULT_STATE;return _this;}_createClass(AllAisleTester,[{key:'componentDidMount',value:function componentDidMount(){this.intervalTimer=setInterval(this.updateTimeNow,REFRESH_INTERVAL_IN_MS);}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.intervalTimer);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.siteId!==this.props.siteId){this.clearRunner();this.setState(DEFAULT_STATE);}}},{key:'getPortIdsByControllerIp',value:function getPortIdsByControllerIp(){var portIdsByControllerIp={};// generate from port count and controllerIp
var ip=this.state.controllerIp||'';portIdsByControllerIp[ip]=[];for(var i=0;i<DEFAULT_AISLE_COUNT;i+=1){portIdsByControllerIp[ip].push(i);}return portIdsByControllerIp;}},{key:'isReady',value:function isReady(){return this.state.isBroadcast||this.state.controllerIp!=null;}},{key:'createRunner',value:function createRunner(){var _this3=this;return new __WEBPACK_IMPORTED_MODULE_5__business_all_aisle_test_runner__["a" /* default */]({siteId:this.props.siteId,portIdsByControllerIp:this.getPortIdsByControllerIp(),callbackOnStart:function callbackOnStart(){return _this3.setRunningStatus(true);},callbackOnStop:function callbackOnStop(){return _this3.setRunningStatus(false);}});}},{key:'setRunningStatus',value:function setRunningStatus(isRunning){this.setState({isRunning:isRunning});}},{key:'clearRunner',value:function clearRunner(){if(this.runner!=null){this.runner.stop();}this.runner=null;}},{key:'generateOnButtonLabel',value:function generateOnButtonLabel(){var _state=this.state,isRunning=_state.isRunning,testDuration=_state.testDuration;var buttonLabel='ON';if(isRunning){var testEndTime=this.runner.runEndtime;// testEndTime is not set until all aisles are started, which can take a few seconds
// fallback to display the user picked testDuration if testEndTime is not calculated yet
var remainingTime=testEndTime?testEndTime-Date.now():testDuration;var humanizedRemainingTime=__WEBPACK_IMPORTED_MODULE_9_humanize_duration___default()(remainingTime,{units:['d','h','m'],round:true});buttonLabel+=' ('+humanizedRemainingTime+' remaining)';}return buttonLabel;}},{key:'renderConfigSection',value:function renderConfigSection(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_Row__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__["a" /* default */],{md:{span:2,offset:4}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form__["a" /* default */].Group,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form__["a" /* default */].Label,null,'Pattern'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form__["a" /* default */].Control,{as:'select',value:this.state.patternId,disabled:this.state.isRunning,onChange:this.handlePatternChange},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',null,'red'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',null,'green'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',null,'blue'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',null,'grey'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',null,'disco')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__["a" /* default */],{md:{span:2}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__test_duration_picker__["b" /* default */],{testDuration:this.state.testDuration,onChange:this.handleTestDurationChange,disabled:this.state.isRunning})));}},{key:'renderActionButtons',value:function renderActionButtons(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Button__["a" /* default */],{className:'mr-3',size:'lg',variant:this.state.isRunning?'success':'outline-success',disabled:this.state.isRunning||!this.isReady(),onClick:this.handleStart},this.generateOnButtonLabel()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Button__["a" /* default */],{variant:'outline-danger',size:'lg',disabled:!this.isReady(),onClick:this.handleStopCluster},'OFF'));}},{key:'renderInputSection',value:function renderInputSection(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form__["a" /* default */].Group,{as:__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form__["a" /* default */].Col},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form__["a" /* default */].Label,null,'Controller IP address'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form__["a" /* default */].Control,{disabled:this.state.isBroadcast||this.state.isRunning,value:this.state.controllerIp||'',onChange:this.handleIpChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_Form__["a" /* default */].Check,{className:'mt-1',type:'checkbox',disabled:this.state.isRunning,checked:this.state.isBroadcast,label:'Broadcast ?',onChange:this.handleIsBroadcastChange})));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'mb-3',style:{marginTop:'6rem'}},this.renderConfigSection()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_Row__["a" /* default */],{className:'mb-3'},this.renderActionButtons()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_Row__["a" /* default */],null,this.renderInputSection())));}}]);return AllAisleTester;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AllAisleTester);

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_controller_tester_with_site_config__ = __webpack_require__(1288);
var ControllerTesterPage=function ControllerTesterPage(props){if(props.siteId==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Select a site');}if(props.siteConfig.status!==200){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Failed to load site configuration for ',props.siteId,'. Please contact SBL tech team.');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__component_controller_tester_with_site_config__["a" /* default */],props);};/* harmony default export */ __webpack_exports__["a"] = (ControllerTesterPage);

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Alert__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_ButtonGroup__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Container__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_Row__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_Form__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__business_aisle_controller__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_sleep__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_constant__ = __webpack_require__(310);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var INITIAL_STATE={isAutoButtonPressed:false,colorByAisle:new Map(),queryMap:{}};var AISLE_BUTTON_STYLE={minWidth:'65px',maxWidth:'80px',minHeight:'50px',textShadow:'-1px -1px 0 #FFFFFF, 1px -1px 0 #FFFFFF, -1px 1px 0 #FFFFFF, 1px 1px 0 #FFFFFF',color:'#000000'};var AISLE_BUTTON_CLASS_NAME='p-0';var GREY_RGB_COLOR='#DDDDDD';var COLOR_MAP={red:'FF0000',green:'00FF00',blue:'0000FF',grey:'FFFFFF'};var COLOR_NAMES=Object.keys(COLOR_MAP);var DEFAULT_COLOR_NAME='green';var QUERY_PARAMETERS={color:'color',ledController:'ledController'};var DEFAULT_ROW_LENGTH=4;var DEFAULT_TOTAL_PORTS=48;var ControllerTesterWithSiteConfig=function(_React$Component){_inherits(ControllerTesterWithSiteConfig,_React$Component);function ControllerTesterWithSiteConfig(props){_classCallCheck(this,ControllerTesterWithSiteConfig);var _this=_possibleConstructorReturn(this,(ControllerTesterWithSiteConfig.__proto__||Object.getPrototypeOf(ControllerTesterWithSiteConfig)).call(this,props));_this.config=Object(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* getConfig */])();_this.state=Object.assign({color:DEFAULT_COLOR_NAME},INITIAL_STATE);_this.isAutoRunning=false;_this.initializeAisleController();return _this;}_createClass(ControllerTesterWithSiteConfig,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.siteId!==prevProps.siteId){this.setState(INITIAL_STATE);this.isAutoRunning=false;this.setQueryParameter(QUERY_PARAMETERS.ledController,undefined);return;}// if site config becomes available or when site config is available and color or aisle changes, re-create aisle controller
var validControllers=ControllerTesterWithSiteConfig.getLedControllerList(this.props);var color=this.getColor(this.props);var controller=this.getController(this.props);var prevValidControllers=ControllerTesterWithSiteConfig.getLedControllerList(prevProps);var prevColor=this.getColor(prevProps);var prevController=this.getController(prevProps);if(validControllers!==prevValidControllers||color!==prevColor||controller!==prevController){this.initializeAisleController();}}},{key:'getController',value:function getController(){return this.state.queryMap[QUERY_PARAMETERS.ledController];}},{key:'getColor',value:function getColor(){return this.state.queryMap[QUERY_PARAMETERS.color]?this.state.queryMap[QUERY_PARAMETERS.color]:DEFAULT_COLOR_NAME;}},{key:'initializeAisleController',value:function initializeAisleController(){var validControllers=ControllerTesterWithSiteConfig.getControllerConfig(this.props);var color=this.getColor(this.props);var controller=this.getController(this.props);var ledController=validControllers[controller];if(validControllers!=null&&ledController!=null&&color!=null){this.aisleController=new __WEBPACK_IMPORTED_MODULE_9__business_aisle_controller__["a" /* default */](this.props.siteId,ledController.ip);}else{this.aisleController=null;}}},{key:'verifyQueryParametersAndRedirect',value:function verifyQueryParametersAndRedirect(){var color=this.getColor(this.props);var controller=this.getController(this.props);var validControllers=ControllerTesterWithSiteConfig.getLedControllerList(this.props);if(!COLOR_NAMES.includes(color)){this.setQueryParameter(QUERY_PARAMETERS.color,DEFAULT_COLOR_NAME);}if(validControllers!=null&&controller!=null&&!validControllers.includes(controller)){this.setQueryParameter(QUERY_PARAMETERS.ledController,undefined);}}},{key:'setQueryParameter',value:function setQueryParameter(parameter,value){var map=this.state.queryMap;map[parameter]=value;this.setState({queryMap:map});}},{key:'setAisleOn',value:function setAisleOn(portId,color){var colorByAisle=this.state.colorByAisle;colorByAisle.set(portId,color);this.setState({colorByAisle:colorByAisle});}},{key:'setAisleOff',value:function setAisleOff(portId){var colorByAisle=this.state.colorByAisle;colorByAisle.delete(portId);this.setState({colorByAisle:colorByAisle});}},{key:'blinkAisle',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(portId){var _this2=this;var color,colorRgb;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:color=this.getColor(this.props);colorRgb=COLOR_MAP[color];_context.next=4;return this.aisleController.start([portId],color,__WEBPACK_IMPORTED_MODULE_12__util_constant__["a" /* AISLE_ON_DURATION_MS */]);case 4:this.setAisleOn(portId,'#'+colorRgb);setTimeout(function(){_this2.setAisleOff(portId);},__WEBPACK_IMPORTED_MODULE_12__util_constant__["a" /* AISLE_ON_DURATION_MS */]);case 6:case'end':return _context.stop();}}},_callee,this);}));function blinkAisle(_x){return _ref.apply(this,arguments);}return blinkAisle;}()},{key:'changeController',value:function changeController(controller){this.isAutoRunning=false;this.setQueryParameter(QUERY_PARAMETERS.ledController,controller);}},{key:'handleColorSelection',value:function handleColorSelection(event){var color=event.target.value;this.setQueryParameter('color',color);}},{key:'handleControllerSelection',value:function handleControllerSelection(event){var controller=event.target.value===''?null:event.target.value;this.changeController(controller);}},{key:'handleAutoButtonClick',value:function handleAutoButtonClick(){if(!this.isAutoRunning){this.startAutoRun();}else{this.stopAutoRun();}}},{key:'startAutoRun',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var controller,aisles,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,aisle;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:controller=this.getController(this.props);this.isAutoRunning=true;this.setState({isAutoButtonPressed:true});aisles=this.getAisles();_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context2.prev=7;_iterator=aisles[Symbol.iterator]();case 9:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context2.next=19;break;}aisle=_step.value;if(!(!this.isAutoRunning||this.getController(this.props)!==controller)){_context2.next=13;break;}return _context2.abrupt('return');case 13:this.blinkAisle(aisle.portId);_context2.next=16;return Object(__WEBPACK_IMPORTED_MODULE_11__util_sleep__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__util_constant__["a" /* AISLE_ON_DURATION_MS */]);case 16:_iteratorNormalCompletion=true;_context2.next=9;break;case 19:_context2.next=25;break;case 21:_context2.prev=21;_context2.t0=_context2['catch'](7);_didIteratorError=true;_iteratorError=_context2.t0;case 25:_context2.prev=25;_context2.prev=26;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 28:_context2.prev=28;if(!_didIteratorError){_context2.next=31;break;}throw _iteratorError;case 31:return _context2.finish(28);case 32:return _context2.finish(25);case 33:this.stopAutoRun();case 34:case'end':return _context2.stop();}}},_callee2,this,[[7,21,25,33],[26,,28,32]]);}));function startAutoRun(){return _ref2.apply(this,arguments);}return startAutoRun;}()},{key:'stopAutoRun',value:function stopAutoRun(){this.isAutoRunning=false;this.setState({isAutoButtonPressed:false});}},{key:'getAisles',value:function getAisles(){if(this.getController(this.props)!=null){var controllerConfig=ControllerTesterWithSiteConfig.getControllerConfig(this.props);var controller=this.getController(this.props);return controllerConfig[controller].aisles?controllerConfig[controller].aisles.flat(1):this.generateDefaultAisles();}return[];}},{key:'getControllerIndex',value:function getControllerIndex(controller){var controllers=ControllerTesterWithSiteConfig.getLedControllerList(this.props);if(controller!=null){var controllerIndex=controllers.indexOf(controller);return controllerIndex===-1?null:controllerIndex;}return null;}},{key:'isAutoReady',value:function isAutoReady(){if(this.props.siteId==null||this.getController(this.props)==null){return false;}else if(!this.isAutoRunning&&this.state.colorByAisle.size>0){return false;}return true;}},{key:'generateControllerOptions',value:function generateControllerOptions(){var controllers=ControllerTesterWithSiteConfig.getLedControllerList(this.props);var controllerConfig=ControllerTesterWithSiteConfig.getControllerConfig(this.props);var controllerOptions=[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:'',value:''},'Choose a Led Controller')];for(var i=0;i<controllers.length;i+=1){var controller=controllers[i];var controllerLabel=controller;if(controllerConfig[controller].aisles){var aisles=controllerConfig[controller].aisles;controllerLabel=controllerLabel+' ('+aisles[0].aisle+'-'+aisles[aisles.length-1].aisle+')';}controllerOptions.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:controller,value:controller},controllerLabel));}return controllerOptions;}},{key:'generateColorOptions',value:function generateColorOptions(){return COLOR_NAMES.map(function(colorName,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:index},colorName);});}},{key:'generateConnectivityWarning',value:function generateConnectivityWarning(){var controllerConfig=ControllerTesterWithSiteConfig.getControllerConfig(this.props);var controller=this.getController(this.props);if(controller==null){return null;}else if(controllerConfig==null||controllerConfig[controller]==null){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Alert__["a" /* default */],{variant:'warning'},'Connectivity info is not available');}else if(controllerConfig[controller].ip==null){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_Alert__["a" /* default */],{variant:'danger'},'LED controller '+controller+' is offline.');}return null;}},{key:'generateAislesGrid',value:function generateAislesGrid(){var controllerConfig=ControllerTesterWithSiteConfig.getControllerConfig(this.props);var controller=this.getController(this.props);if(controller==null){return{aislesGrid:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Select a led controller to begin')};}else if(controllerConfig[controller]==null){return{aislesGrid:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Cannot find configuration for controller ',controller,'. Please contact SBL team.')};}var aisles=controllerConfig[controller].aisles;var aisleButtonRows=[];if(aisles==null){aisles=this.generateDefaultAisles();}var _generateGrid=this.generateGrid(aisles),regButtons=_generateGrid.regButtons;for(var i=0;i<regButtons.length;i+=1){var buttonsInRow=regButtons[i];aisleButtonRows.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_ButtonGroup__["a" /* default */],{key:i},buttonsInRow));}return{aislesGrid:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_ButtonGroup__["a" /* default */],{vertical:true},aisleButtonRows)};}},{key:'generateDefaultAisles',value:function generateDefaultAisles(){var aisles=[];for(var i=0;i<DEFAULT_TOTAL_PORTS;i++){var aisle={portId:i+1};aisles.push(aisle);}return aisles;}},{key:'generateGrid',value:function generateGrid(aisles){var button=void 0;var curIndex=0;var buttonsInRow=[];var regButtons=[];var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=aisles[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var aisle=_step2.value;if(curIndex%DEFAULT_ROW_LENGTH===0){if(buttonsInRow.length>0){regButtons.push(buttonsInRow);buttonsInRow=[];}}button=this.generateAisleButton(aisle);buttonsInRow.push(button);curIndex+=1;}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}if(buttonsInRow.length>0){while(buttonsInRow.length<DEFAULT_ROW_LENGTH){buttonsInRow.push(this.generateEmptyButton(''+buttonsInRow.length));}regButtons.push(buttonsInRow);}return{regButtons:regButtons};}},{key:'generateEmptyButton',value:function generateEmptyButton(key){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:AISLE_BUTTON_CLASS_NAME,style:AISLE_BUTTON_STYLE,key:key,variant:'link',disabled:true});}},{key:'generateAisleButton',value:function generateAisleButton(aisle){var _this3=this;var backgroundColor=this.state.colorByAisle.get(aisle.portId)||GREY_RGB_COLOR;var buttonLabel=aisle.aisle?''+aisle.aisle:'Port'+aisle.portId;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:AISLE_BUTTON_CLASS_NAME,style:Object.assign({},AISLE_BUTTON_STYLE,{backgroundColor:backgroundColor}),variant:'outline-dark',key:buttonLabel,name:buttonLabel,onClick:function onClick(){return _this3.blinkAisle(aisle.portId);}},buttonLabel);}},{key:'generateAutoButton',value:function generateAutoButton(){var variant=this.state.isAutoButtonPressed?'danger':'outline-success';var buttonLabel=this.state.isAutoButtonPressed?'Stop':'Auto';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:'ml-2 mr-2',variant:variant,onClick:this.handleAutoButtonClick.bind(this),disabled:!this.isAutoReady()},buttonLabel);}},{key:'generatePrevControllerButton',value:function generatePrevControllerButton(){var _this4=this;var controllers=ControllerTesterWithSiteConfig.getLedControllerList(this.props);var currentController=this.getController(this.props);var controllerIndex=this.getControllerIndex(currentController);if(controllerIndex==null||controllerIndex===0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:'ml-2 mr-2',variant:'link',disabled:true,active:false});}var prevControllerIndex=controllerIndex-1;var prevControllerLabel=controllers[prevControllerIndex];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:'ml-2 mr-2',variant:'warning',onClick:function onClick(){return _this4.changeController(prevControllerLabel);}},'< prev controller');}},{key:'generateNextControllerButton',value:function generateNextControllerButton(){var _this5=this;var controllers=ControllerTesterWithSiteConfig.getLedControllerList(this.props);var currentController=this.getController(this.props);var controllerIndex=this.getControllerIndex(currentController);if(controllerIndex===controllers.length-1){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:'ml-2 mr-2',variant:'link',disabled:true,active:false});}var nextControllerIndex=controllerIndex==null?0:controllerIndex+1;var nextControllerLabel=controllers[nextControllerIndex];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_Button__["a" /* default */],{className:'ml-2 mr-2',variant:'warning',onClick:function onClick(){return _this5.changeController(nextControllerLabel);}},'next controller >');}},{key:'render',value:function render(){var _generateAislesGrid=this.generateAislesGrid(),aislesGrid=_generateAislesGrid.aislesGrid;var controller=this.getController(this.props);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_Row__["a" /* default */],{className:'mt-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_Form__["a" /* default */].Group,{controlId:'color'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_Form__["a" /* default */].Label,null,'Color'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_Form__["a" /* default */].Control,{as:'select',name:'color',value:this.getColor(this.props),onChange:this.handleColorSelection.bind(this)},this.generateColorOptions()))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_Form__["a" /* default */].Group,{controlId:'aisle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_Form__["a" /* default */].Label,null,'Led Controller'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_Form__["a" /* default */].Control,{as:'select',name:'controller',value:controller==null?'':controller,onChange:this.handleControllerSelection.bind(this)},this.generateControllerOptions())))),this.generateConnectivityWarning(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_Row__["a" /* default */],{style:{overflowX:'auto',whiteSpace:'nowrap'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__["a" /* default */],null,aislesGrid)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_Row__["a" /* default */],{className:'justify-content-md-center mt-3 mb-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Col__["a" /* default */],null,this.generatePrevControllerButton(),this.generateAutoButton(),this.generateNextControllerButton()))));}}],[{key:'getLedControllerList',value:function getLedControllerList(props){var ledControllers=ControllerTesterWithSiteConfig.getControllerConfig(props);return Object.keys(ledControllers);}},{key:'getControllerConfig',value:function getControllerConfig(props){if(props.siteConfig.status===200){return props.siteConfig.data.controllerConfig.ledControllers;}return null;}}]);return ControllerTesterWithSiteConfig;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ControllerTesterWithSiteConfig);

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RackPreview */
/* unused harmony export AisleConfigFinderView */
/* unused harmony export AisleConfigFinder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__context_LEDControllerOverviewContext__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__VisualRackBuilder__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AisleConfigColors__ = __webpack_require__(510);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _CONFIG_TYPE_MESSAGES,_TIER_CELL_RENDERERS,_COLUMN_HEADER_RENDER,_this=this;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var TIERS=[4,3,2,1];var OV_LETTER_OPTIONS=__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["a" /* ALLOWED_COLUMN_LABELS */].map(function(label){return label.toUpperCase();});var getMessage=function getMessage(intl,id,defaultMessage,values){return intl.formatMessage({id:id,defaultMessage:defaultMessage},values);};// The model exposes machine-readable config types; the display wording is localized here.
var CONFIG_TYPE_MESSAGES=(_CONFIG_TYPE_MESSAGES={},_defineProperty(_CONFIG_TYPE_MESSAGES,__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["e" /* CONFIG_TYPES */].BAG,{id:'aisleconfig.type.bag',defaultMessage:'Bag rack'}),_defineProperty(_CONFIG_TYPE_MESSAGES,__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["e" /* CONFIG_TYPES */].OV,{id:'aisleconfig.type.ov',defaultMessage:'OV rack'}),_defineProperty(_CONFIG_TYPE_MESSAGES,__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["e" /* CONFIG_TYPES */].FULL_HEIGHT_FLEX,{id:'aisleconfig.type.fullheightflex',defaultMessage:'Full-height flex rack'}),_defineProperty(_CONFIG_TYPE_MESSAGES,__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["e" /* CONFIG_TYPES */].PARTITIONED_FLEX,{id:'aisleconfig.type.partitionedflex',defaultMessage:'Partitioned flex rack'}),_defineProperty(_CONFIG_TYPE_MESSAGES,__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["e" /* CONFIG_TYPES */].LEGACY_DUAL,{id:'aisleconfig.type.legacydual',defaultMessage:'Legacy dual-code rack'}),_CONFIG_TYPE_MESSAGES);var getConfigTypeMessage=function getConfigTypeMessage(intl,configType){var definition=CONFIG_TYPE_MESSAGES[configType]||{id:'aisleconfig.type.generic',defaultMessage:'Aisle configuration'};return getMessage(intl,definition.id,definition.defaultMessage);};var styles={panel:{border:'1px solid #d9e2e8',borderRadius:'12px',padding:'18px',backgroundColor:'#ffffff',boxShadow:'0 2px 8px rgba(15, 41, 61, 0.08)'},metadataGrid:{display:'grid',gridTemplateColumns:'repeat(auto-fit, minmax(160px, 1fr))',gap:'12px'},metadataItem:{border:'1px solid #eaeded',borderRadius:'6px',padding:'10px',overflowWrap:'anywhere'},tableContainer:{overflowX:'auto',width:'100%'},rackTable:{borderCollapse:'collapse',width:'max-content',minWidth:'100%'},cell:{border:'1px solid #d5dbdb',minWidth:'74px',padding:'8px',textAlign:'center'},tierCell:{border:'1px solid #d5dbdb',minWidth:'58px',padding:'8px',textAlign:'center',fontWeight:600,backgroundColor:'#f3f3f3'},bagCell:Object(__WEBPACK_IMPORTED_MODULE_12__AisleConfigColors__["c" /* getZoneFill */])(__WEBPACK_IMPORTED_MODULE_12__AisleConfigColors__["a" /* RACK_ZONE_COLORS */].BAG),ovCell:Object(__WEBPACK_IMPORTED_MODULE_12__AisleConfigColors__["c" /* getZoneFill */])(__WEBPACK_IMPORTED_MODULE_12__AisleConfigColors__["a" /* RACK_ZONE_COLORS */].OV),flexCell:Object(__WEBPACK_IMPORTED_MODULE_12__AisleConfigColors__["c" /* getZoneFill */])(__WEBPACK_IMPORTED_MODULE_12__AisleConfigColors__["a" /* RACK_ZONE_COLORS */].FLEX),flexCellCaption:{marginBottom:'4px',fontSize:'10px',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.4px',color:__WEBPACK_IMPORTED_MODULE_12__AisleConfigColors__["a" /* RACK_ZONE_COLORS */].FLEX.color},pillarCell:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_12__AisleConfigColors__["c" /* getZoneFill */])(__WEBPACK_IMPORTED_MODULE_12__AisleConfigColors__["a" /* RACK_ZONE_COLORS */].PILLAR),{minWidth:'42px'}),code:{display:'block',padding:'8px',borderRadius:'4px',backgroundColor:'#f3f3f3',overflowWrap:'anywhere'}};// Dispatch on column type via a lookup map rather than a long if-chain. The tier checks *inside*
// each renderer stay conditional on purpose: they decide which physical bin a tier row spans
// (rowSpan geometry), which is not a type dispatch and does not flatten into a map.
var TIER_CELL_RENDERERS=(_TIER_CELL_RENDERERS={},_defineProperty(_TIER_CELL_RENDERERS,__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["d" /* COLUMN_TYPES */].PILLAR,function(){return{label:'\u2502',style:styles.pillarCell};}),_defineProperty(_TIER_CELL_RENDERERS,__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["d" /* COLUMN_TYPES */].FLEX,function(intl,column,tier){var _ref=column.ovLabels||[],_ref2=_slicedToArray(_ref,2),_ref2$=_ref2[0],topOvLabel=_ref2$===undefined?'?':_ref2$,_ref2$2=_ref2[1],bottomOvLabel=_ref2$2===undefined?'?':_ref2$2;if(tier===4){return{label:getMessage(intl,'aisleconfig.preview.ovtop','{label} (top OV)',{label:topOvLabel}),style:styles.flexCell,rowSpan:2,testId:'flex-ov-top',flexSlot:0};}if(tier===2){return{label:getMessage(intl,'aisleconfig.preview.ovbottom','{label} (bottom OV)',{label:bottomOvLabel}),style:styles.flexCell,rowSpan:2,testId:'flex-ov-bottom',flexSlot:1};}return{skip:true};}),_defineProperty(_TIER_CELL_RENDERERS,__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["d" /* COLUMN_TYPES */].BAG,function(intl){return{label:getMessage(intl,'aisleconfig.preview.bag','Bag'),style:styles.bagCell};}),_defineProperty(_TIER_CELL_RENDERERS,__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["d" /* COLUMN_TYPES */].OV,function(intl,column,tier){var ovLabels=column.ovLabels||[column.label];// A split OV column is two stacked bins; a trailing unpaired letter is one full-height bin.
if(ovLabels.length===2){if(tier===4){return{label:getMessage(intl,'aisleconfig.preview.ovtop','{label} (top OV)',{label:ovLabels[0]}),style:styles.ovCell,rowSpan:2,testId:'ov-top'};}if(tier===2){return{label:getMessage(intl,'aisleconfig.preview.ovbottom','{label} (bottom OV)',{label:ovLabels[1]}),style:styles.ovCell,rowSpan:2,testId:'ov-bottom'};}return{skip:true};}if(tier===4){return{label:getMessage(intl,'aisleconfig.preview.ovfull','{label} (full OV)',{label:ovLabels[0]}),style:styles.ovCell,rowSpan:4,testId:'ov-full'};}return{skip:true};}),_defineProperty(_TIER_CELL_RENDERERS,__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["d" /* COLUMN_TYPES */].PARTITIONED_FLEX,function(intl,column,tier){return column.bagTiers.includes(tier)?{label:getMessage(intl,'aisleconfig.preview.bag','Bag'),style:styles.bagCell}:{label:getMessage(intl,'aisleconfig.preview.ov','OV'),style:styles.ovCell};}),_TIER_CELL_RENDERERS);var getTierCell=function getTierCell(intl,column,tier){var renderTierCell=TIER_CELL_RENDERERS[column.type];return renderTierCell?renderTierCell(intl,column,tier):{label:'',style:{}};};var COLUMN_HEADER_RENDERERS=(_COLUMN_HEADER_RENDER={},_defineProperty(_COLUMN_HEADER_RENDER,__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["d" /* COLUMN_TYPES */].PILLAR,function(intl){return getMessage(intl,'aisleconfig.preview.pillar','Pillar');}),_defineProperty(_COLUMN_HEADER_RENDER,__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["d" /* COLUMN_TYPES */].FLEX,function(intl,column){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{'data-testid':'flex-footprint-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,getMessage(intl,'aisleconfig.preview.flexfootprint','Flex footprint')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',null,getMessage(intl,'aisleconfig.preview.bagmode','Bag mode: {labels}',{labels:(column.bagLabels||[]).join(' + ')})));}),_defineProperty(_COLUMN_HEADER_RENDER,__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["d" /* COLUMN_TYPES */].OV,function(intl,column){return(column.ovLabels||[]).length===0?column.label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{'data-testid':'ov-column-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,column.label),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',null,column.ovLabels.length===2?getMessage(intl,'aisleconfig.preview.splitov','Split OV'):getMessage(intl,'aisleconfig.preview.fullov','Full OV')));}),_COLUMN_HEADER_RENDER);var getColumnHeader=function getColumnHeader(intl,column){var renderHeader=COLUMN_HEADER_RENDERERS[column.type];return renderHeader?renderHeader(intl,column):column.label;};var RackPreview=function RackPreview(_ref3){var parsedConfig=_ref3.parsedConfig,providedColumns=_ref3.columns,onFlexOvLabelChange=_ref3.onFlexOvLabelChange,intl=_ref3.intl;var columns=providedColumns||Object(__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["j" /* getVisualColumns */])(parsedConfig);if(columns.length===0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_alert___default.a,{type:'informational'},getMessage(intl,'aisleconfig.preview.notvisualizable','The selected filename does not contain a visualizable aisle code.'));}// Number the flex footprints in render order so inline edits target the right one.
var flexOrdinal=-1;var decoratedColumns=columns.map(function(column){if(column.type===__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["d" /* COLUMN_TYPES */].FLEX){flexOrdinal+=1;return Object.assign({},column,{flexIndex:flexOrdinal});}return column;});var renderFlexOvSelect=function renderFlexOvSelect(column,slot){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.flexCellCaption},slot===0?getMessage(intl,'aisleconfig.preview.topov','Top OV'):getMessage(intl,'aisleconfig.preview.bottomov','Bottom OV')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default.a,{id:'flex-ov-'+(slot===0?'top':'bottom')+'-'+column.flexIndex,value:(column.ovLabels||[])[slot],width:84,onChange:function onChange(value){return onFlexOvLabelChange(column.flexIndex,slot,value);}},OV_LETTER_OPTIONS.map(function(letter){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__["SelectOption"],{key:letter,value:letter,label:letter});})));};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.tableContainer,'data-testid':'rack-preview'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{style:styles.rackTable,'aria-label':getMessage(intl,'aisleconfig.preview.arialabel','Aisle configuration preview')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{style:styles.tierCell},getMessage(intl,'aisleconfig.preview.tier','Tier')),decoratedColumns.map(function(column,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{key:column.label+'-'+index,style:Object.assign({},styles.cell,column.type===__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["d" /* COLUMN_TYPES */].PILLAR?styles.pillarCell:{})},getColumnHeader(intl,column));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,TIERS.map(function(tier){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:tier},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{style:styles.tierCell},tier),decoratedColumns.map(function(column,index){var tierCell=getTierCell(intl,column,tier);if(tierCell.skip){return null;}var editableFlexCell=onFlexOvLabelChange&&column.type===__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["d" /* COLUMN_TYPES */].FLEX&&tierCell.flexSlot!==undefined;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{key:tier+'-'+column.label+'-'+index,rowSpan:tierCell.rowSpan,'data-testid':tierCell.testId,style:Object.assign({},styles.cell,tierCell.style)},editableFlexCell?renderFlexOvSelect(column,tierCell.flexSlot):tierCell.label);}));}))));};var AisleConfigFinderView=function AisleConfigFinderView(_ref4){var configs=_ref4.configs,intl=_ref4.intl;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState2=_slicedToArray(_useState,2),selectedConfig=_useState2[0],setSelectedConfig=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),copyStatus=_useState4[0],setCopyStatus=_useState4[1];var selectedParsed=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])(function(){return Object(__WEBPACK_IMPORTED_MODULE_11__AisleConfigModel__["k" /* parseAisleConfigName */])(selectedConfig);},[selectedConfig]);var detailsRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(selectedConfig&&!configs.includes(selectedConfig)){setSelectedConfig('');}},[configs,selectedConfig]);// Bring the selected config's details into view — the panel renders below the builder
// and would otherwise land off-screen after "Use matched config".
Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(selectedParsed&&detailsRef.current&&typeof detailsRef.current.scrollIntoView==='function'){detailsRef.current.scrollIntoView({behavior:'smooth',block:'start'});}},[selectedParsed]);var copyConfigName=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var unavailableMessage;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setCopyStatus(null);unavailableMessage=getMessage(intl,'aisleconfig.copy.unavailable','Clipboard access is unavailable. Select the config name and copy it manually.');if(!(navigator.clipboard&&navigator.clipboard.writeText)){_context.next=14;break;}_context.prev=3;_context.next=6;return navigator.clipboard.writeText(selectedConfig);case 6:setCopyStatus({type:'success',message:getMessage(intl,'aisleconfig.copy.success','Config name copied.')});_context.next=12;break;case 9:_context.prev=9;_context.t0=_context['catch'](3);setCopyStatus({type:'informational',message:unavailableMessage});case 12:_context.next=15;break;case 14:setCopyStatus({type:'informational',message:unavailableMessage});case 15:case'end':return _context.stop();}}},_callee,_this,[[3,9]]);}));return function copyConfigName(){return _ref5.apply(this,arguments);};}();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacing:'400'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__VisualRackBuilder__["a" /* default */],{configs:configs,intl:intl,RackPreviewComponent:RackPreview,onSelectConfig:function onSelectConfig(value){setSelectedConfig(value);setCopyStatus(null);}}),!selectedParsed&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_alert___default.a,{type:'informational'},getMessage(intl,'aisleconfig.selectprompt','Describe your rack above, then use a matched existing config to inspect its exact codes and layout.')),selectedParsed&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.panel,ref:detailsRef},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacing:'300'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row___default.a,{alignmentVertical:'center',widths:["fill","fit"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{type:'h500'},getMessage(intl,'aisleconfig.details','Config details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:'primary',size:'small',onClick:copyConfigName},getMessage(intl,'aisleconfig.copy','Copy config name'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('code',{'data-testid':'config-name',style:styles.code},selectedConfig),copyStatus&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_alert___default.a,{type:copyStatus.type,size:'small'},copyStatus.message),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.metadataGrid},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.metadataItem},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{type:'b300'},getMessage(intl,'aisleconfig.details.region','Region')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),selectedParsed.region),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.metadataItem},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{type:'b300'},getMessage(intl,'aisleconfig.details.year','Year')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),selectedParsed.year||getMessage(intl,'aisleconfig.details.yearmissing','Not in filename')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.metadataItem},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{type:'b300'},getMessage(intl,'aisleconfig.details.layout','Layout')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),getConfigTypeMessage(intl,selectedParsed.configType)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.metadataItem},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{type:'b300'},getMessage(intl,'aisleconfig.details.naming','Naming')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),selectedParsed.namingConvention==='legacy'?getMessage(intl,'aisleconfig.details.naminglegacy','Legacy production name'):getMessage(intl,'aisleconfig.details.namingcanonical','Canonical name'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row___default.a,{widths:["fill","fill"],spacing:'300'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.metadataItem},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{type:'b300'},getMessage(intl,'aisleconfig.details.bagcode','Primary / bag code')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('code',{style:styles.code},selectedParsed.aisleCode)),selectedParsed.alternateCode&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.metadataItem},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{type:'b300'},getMessage(intl,'aisleconfig.details.ovcode','Alternate / OV code')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('code',{style:styles.code},selectedParsed.alternateCode))),selectedParsed.canonicalAisleCode!==selectedParsed.aisleCode&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_alert___default.a,{type:'warning',size:'small'},getMessage(intl,'aisleconfig.details.legacytier','Stored tier order is legacy. Canonical equivalent: {code}',{code:selectedParsed.canonicalAisleCode})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_alert___default.a,{type:'informational',size:'small'},getMessage(intl,'aisleconfig.useconfiguration','Copy this exact existing name and select it in the LED Controller Configuration tab.')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.panel},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacing:'300'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{type:'h500'},getMessage(intl,'aisleconfig.preview','Rack preview')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row___default.a,{spacing:'300'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,null,getMessage(intl,'aisleconfig.legend.bag','Bag')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:Object.assign({},styles.cell,styles.bagCell,{minWidth:'32px',padding:'2px'})},' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,null,getMessage(intl,'aisleconfig.legend.ov','OV')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:Object.assign({},styles.cell,styles.ovCell,{minWidth:'32px',padding:'2px'})},' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,null,getMessage(intl,'aisleconfig.legend.flex','Flex')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:Object.assign({},styles.cell,styles.flexCell,{minWidth:'32px',padding:'2px'})},' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(RackPreview,{parsedConfig:selectedParsed,intl:intl})))));};var AisleConfigFinder=function AisleConfigFinder(_ref6){var intl=_ref6.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__context_LEDControllerOverviewContext__["a" /* LEDControllerOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(viewModel.aisleTypes.size===0){dispatch({type:'LOAD_AISLE_TYPES',data:{dispatcher:dispatch}});}},[]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AisleConfigFinderView,{configs:[].concat(_toConsumableArray(viewModel.aisleTypes)),intl:intl});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(AisleConfigFinder));

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VisualRackBuilder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AisleConfigColors__ = __webpack_require__(510);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _modeStyles,_MODE_MESSAGES,_ERROR_MESSAGES,_this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// Shared with the rack preview so a painted column reads as the same colour in both views.
var modeStyles=(_modeStyles={},_defineProperty(_modeStyles,__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].ABSENT,Object.assign({},__WEBPACK_IMPORTED_MODULE_8__AisleConfigColors__["a" /* RACK_ZONE_COLORS */].ABSENT)),_defineProperty(_modeStyles,__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].BAG,Object.assign({},__WEBPACK_IMPORTED_MODULE_8__AisleConfigColors__["a" /* RACK_ZONE_COLORS */].BAG)),_defineProperty(_modeStyles,__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].OV,Object.assign({},__WEBPACK_IMPORTED_MODULE_8__AisleConfigColors__["a" /* RACK_ZONE_COLORS */].OV)),_defineProperty(_modeStyles,__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].FLEX,Object.assign({},__WEBPACK_IMPORTED_MODULE_8__AisleConfigColors__["a" /* RACK_ZONE_COLORS */].FLEX)),_modeStyles);var getMessage=function getMessage(intl,id,defaultMessage,values){return intl.formatMessage({id:id,defaultMessage:defaultMessage},values);};var MODE_MESSAGES=(_MODE_MESSAGES={},_defineProperty(_MODE_MESSAGES,__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].ABSENT,{id:'aisleconfig.builder.mode.absent',defaultMessage:'Not present'}),_defineProperty(_MODE_MESSAGES,__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].BAG,{id:'aisleconfig.builder.mode.bag',defaultMessage:'Bag'}),_defineProperty(_MODE_MESSAGES,__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].OV,{id:'aisleconfig.builder.mode.ov',defaultMessage:'OV'}),_defineProperty(_MODE_MESSAGES,__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].FLEX,{id:'aisleconfig.builder.mode.flex',defaultMessage:'Flex'}),_MODE_MESSAGES);// The Clear chip erases a column, so it carries its own label instead of "Not present".
var PAINT_MODES=[{mode:__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].BAG,message:MODE_MESSAGES[__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].BAG]},{mode:__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].OV,message:MODE_MESSAGES[__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].OV]},{mode:__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].FLEX,message:MODE_MESSAGES[__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].FLEX]},{mode:__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].ABSENT,message:{id:'aisleconfig.builder.mode.clear',defaultMessage:'Clear'}}];// Every machine-readable validation code from the model maps to a localizable message;
// the params supplied by the model interpolate into the ICU placeholders.
var ERROR_MESSAGES=(_ERROR_MESSAGES={},_defineProperty(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["c" /* BUILDER_VALIDATION_CODES */].FLEX_PAIRS_REQUIRED,{id:'aisleconfig.builder.error.flexpairs',defaultMessage:'Select Flex columns in adjacent pairs — every two columns form one physical footprint.'}),_defineProperty(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["c" /* BUILDER_VALIDATION_CODES */].FLEX_NOT_ADJACENT,{id:'aisleconfig.builder.error.flexadjacent',defaultMessage:'Flex columns must be adjacent, with no Bag or OV column between them.'}),_defineProperty(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["c" /* BUILDER_VALIDATION_CODES */].PILLAR_INSIDE_FLEX_ZONE,{id:'aisleconfig.builder.error.flexpillar',defaultMessage:'A pillar cannot sit inside the Flex zone (after column {columns}).'}),_defineProperty(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["c" /* BUILDER_VALIDATION_CODES */].FLEX_OV_LABELS_NOT_UNIQUE,{id:'aisleconfig.builder.error.flexlabelsunique',defaultMessage:'Every flex OV label must be unique — each footprint needs its own top and bottom letters.'}),_defineProperty(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["c" /* BUILDER_VALIDATION_CODES */].FLEX_OV_LABEL_REUSED,{id:'aisleconfig.builder.error.flexlabelreused',defaultMessage:'Flex OV labels cannot reuse a letter already selected as a Bag or OV column ({letters}).'}),_defineProperty(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["c" /* BUILDER_VALIDATION_CODES */].NO_COLUMNS_SELECTED,{id:'aisleconfig.builder.error.nocolumns',defaultMessage:'Select at least one rack column.'}),_ERROR_MESSAGES);var getErrorMessage=function getErrorMessage(intl,error){var definition=ERROR_MESSAGES[error.code]||{id:'aisleconfig.builder.error.generic',defaultMessage:'The current rack description is not valid.'};return getMessage(intl,definition.id,definition.defaultMessage,error.params);};var styles={shell:{border:'1px solid #d9e2e8',borderRadius:'12px',backgroundColor:'#ffffff',boxShadow:'0 2px 8px rgba(15, 41, 61, 0.08)',overflow:'hidden'},header:{background:'linear-gradient(120deg, #0b4d74 0%, #007eb9 100%)',padding:'18px 22px',color:'#ffffff'},headerTitle:{margin:0,fontSize:'20px',fontWeight:700,color:'#ffffff'},headerSubtitle:{margin:'4px 0 0',fontSize:'13px',color:'#d6ecf7'},headerControlLabel:{display:'block',marginBottom:'2px',fontSize:'11px',fontWeight:700,color:'#d6ecf7',textTransform:'uppercase',letterSpacing:'0.4px'},body:{padding:'20px',display:'grid',gap:'16px'},section:{border:'1px solid #e4ebf0',borderRadius:'10px',padding:'16px',backgroundColor:'#ffffff'},previewSection:{border:'1px solid #cfe3ef',borderRadius:'10px',padding:'16px',backgroundColor:'#f7fbfd'},sectionTitle:{display:'flex',alignItems:'center',fontSize:'15px',fontWeight:700,color:'#16191f'},hint:{margin:'6px 0 0',fontSize:'12px',color:'#5f6b7a'},paintBar:{display:'flex',alignItems:'center',flexWrap:'wrap',gap:'8px',marginTop:'12px'},paintLabel:{fontSize:'11px',fontWeight:700,color:'#5f6b7a',textTransform:'uppercase',letterSpacing:'0.4px'},paintChip:function paintChip(mode,selected){return{padding:'5px 14px',borderRadius:'999px',borderStyle:'solid',borderWidth:'1px',borderColor:modeStyles[mode].borderColor,backgroundColor:modeStyles[mode].backgroundColor,color:modeStyles[mode].color,fontSize:'12px',fontWeight:selected?800:600,cursor:'pointer',boxShadow:selected?'0 0 0 2px rgba(0, 126, 185, 0.35)':'none'};},hintInline:{fontSize:'11px',color:'#5f6b7a'},columnStrip:{display:'flex',flexWrap:'wrap',alignItems:'stretch',gap:'2px',marginTop:'12px'},columnButton:{width:'72px',borderStyle:'solid',borderWidth:'2px',borderRadius:'8px',minHeight:'60px',cursor:'pointer',fontWeight:700,transition:'transform 80ms ease, box-shadow 80ms ease'},columnLetter:{fontSize:'17px',lineHeight:'20px'},columnCaption:{fontSize:'10px',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.4px'},pillarSlot:function pillarSlot(active,enabled){return{width:'14px',minHeight:'60px',padding:0,borderRadius:'4px',border:active?'1px solid #5f6b7a':'1px dashed #c4cfd8',backgroundColor:active?'#5f6b7a':enabled?__WEBPACK_IMPORTED_MODULE_8__AisleConfigColors__["a" /* RACK_ZONE_COLORS */].ABSENT.backgroundColor:'transparent',color:'#ffffff',cursor:enabled?'pointer':'default',opacity:enabled?1:0.3,fontSize:'10px'};},matchChip:function matchChip(hasMatches){var status=hasMatches?__WEBPACK_IMPORTED_MODULE_8__AisleConfigColors__["b" /* STATUS_COLORS */].MATCHED:__WEBPACK_IMPORTED_MODULE_8__AisleConfigColors__["b" /* STATUS_COLORS */].UNMATCHED;return{padding:'4px 12px',borderRadius:'999px',border:'1px solid '+status.borderColor,backgroundColor:status.backgroundColor,color:status.color,fontSize:'12px',fontWeight:700,cursor:'pointer'};},derivedGrid:{display:'grid',gridTemplateColumns:'repeat(auto-fit, minmax(240px, 1fr))',gap:'10px',marginTop:'10px'},derivedItem:{border:'1px solid #e4ebf0',borderLeft:'3px solid #007eb9',borderRadius:'6px',padding:'10px 12px',backgroundColor:'#ffffff'},derivedLabel:{fontSize:'11px',fontWeight:700,color:'#5f6b7a',textTransform:'uppercase',letterSpacing:'0.4px'},code:{display:'block',marginTop:'4px',fontSize:'13px',overflowWrap:'anywhere'},candidateName:{display:'block',marginTop:'4px',padding:'10px 12px',borderRadius:'6px',backgroundColor:'#0b4d74',color:'#eaf6fc',fontSize:'13px',overflowWrap:'anywhere'},copyButton:{padding:'3px 12px',borderRadius:'999px',border:'1px solid #007eb9',backgroundColor:'#ffffff',color:'#007eb9',fontSize:'11px',fontWeight:700,cursor:'pointer'},confirmation:{fontSize:'12px',fontWeight:700,color:__WEBPACK_IMPORTED_MODULE_8__AisleConfigColors__["b" /* STATUS_COLORS */].MATCHED.color}};var getModeLabel=function getModeLabel(intl,mode){var message=MODE_MESSAGES[mode];return getMessage(intl,message.id,message.defaultMessage);};var VisualRackBuilder=function VisualRackBuilder(_ref){var configs=_ref.configs,intl=_ref.intl,RackPreviewComponent=_ref.RackPreviewComponent,onSelectConfig=_ref.onSelectConfig;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])('NA'),_useState2=_slicedToArray(_useState,2),region=_useState2[0],setRegion=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["g" /* createInitialColumnModes */]),_useState4=_slicedToArray(_useState3,2),columnModes=_useState4[0],setColumnModes=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),_useState6=_slicedToArray(_useState5,2),pillars=_useState6[0],setPillars=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),_useState8=_slicedToArray(_useState7,2),flexOvOverrides=_useState8[0],setFlexOvOverrides=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState10=_slicedToArray(_useState9,2),selectedMatch=_useState10[0],setSelectedMatch=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState12=_slicedToArray(_useState11,2),confirmedMatch=_useState12[0],setConfirmedMatch=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState14=_slicedToArray(_useState13,2),paintMode=_useState14[0],setPaintMode=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),isPainting=_useState16[0],setIsPainting=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState18=_slicedToArray(_useState17,2),candidateCopyStatus=_useState18[0],setCandidateCopyStatus=_useState18[1];var matchesRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);var description=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])(function(){return Object(__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["f" /* buildRackDescription */])({region:region,columnModes:columnModes,pillars:pillars,flexOvLabels:flexOvOverrides});},[region,columnModes,pillars,flexOvOverrides]);var matches=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])(function(){return Object(__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["i" /* findConfigsByRackDescription */])(configs,description);},[configs,description]);var hasColumns=description.columns.length>0;var hasErrors=description.errors.length>0;var resetMatchSelection=function resetMatchSelection(){setSelectedMatch('');setConfirmedMatch('');};var applyColumnMode=function applyColumnMode(label,nextMode){var currentMode=columnModes[label];if(currentMode!==nextMode&&(currentMode===__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].FLEX||nextMode===__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].FLEX)){setFlexOvOverrides([]);}setColumnModes(function(current){return Object.assign({},current,_defineProperty({},label,nextMode));});resetMatchSelection();};var handleColumnClick=function handleColumnClick(label){applyColumnMode(label,paintMode!==null?paintMode:Object(__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["h" /* cycleColumnMode */])(columnModes[label]));};var togglePillar=function togglePillar(label){setPillars(function(current){return current.includes(label)?current.filter(function(value){return value!==label;}):[].concat(_toConsumableArray(current),[label]);});resetMatchSelection();};var setFootprintOvLabel=function setFootprintOvLabel(footprintIndex,slot,letter){var base=description.footprints[footprintIndex]?[].concat(_toConsumableArray(description.footprints[footprintIndex].ovLabels)):['T','U'];base[slot]=letter;setFlexOvOverrides(function(current){var next=[].concat(_toConsumableArray(current));next[footprintIndex]=base;return next;});resetMatchSelection();};var resetBuilder=function resetBuilder(){setColumnModes(Object(__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["g" /* createInitialColumnModes */])());setPillars([]);setFlexOvOverrides([]);setPaintMode(null);setIsPainting(false);setCandidateCopyStatus('');resetMatchSelection();};var copyCandidateName=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var unavailableMessage;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setCandidateCopyStatus('');unavailableMessage=getMessage(intl,'aisleconfig.copy.unavailable','Clipboard access is unavailable. Select the config name and copy it manually.');if(!(navigator.clipboard&&navigator.clipboard.writeText)){_context.next=14;break;}_context.prev=3;_context.next=6;return navigator.clipboard.writeText(description.candidateName);case 6:setCandidateCopyStatus(getMessage(intl,'aisleconfig.copy.success','Config name copied.'));_context.next=12;break;case 9:_context.prev=9;_context.t0=_context['catch'](3);setCandidateCopyStatus(unavailableMessage);case 12:_context.next=15;break;case 14:setCandidateCopyStatus(unavailableMessage);case 15:case'end':return _context.stop();}}},_callee,_this,[[3,9]]);}));return function copyCandidateName(){return _ref2.apply(this,arguments);};}();var scrollToMatches=function scrollToMatches(){if(matchesRef.current&&typeof matchesRef.current.scrollIntoView==='function'){matchesRef.current.scrollIntoView({behavior:'smooth',block:'start'});}};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.shell,'data-testid':'visual-rack-builder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.header},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default.a,{widths:["fill","fit","fit"],alignmentVertical:'center',spacing:'300'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:styles.headerTitle},getMessage(intl,'aisleconfig.builder.title','SBL Aisle Config Builder')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:styles.headerSubtitle},getMessage(intl,'aisleconfig.builder.subtitle','Describe the physical rack — the aisle code, config name, and matching '+'existing configs are derived for you. No naming knowledge needed.'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:styles.headerControlLabel},getMessage(intl,'aisleconfig.builder.region','Region')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select___default.a,{id:'rack-region',value:region,width:90,onChange:function onChange(value){setRegion(value);resetMatchSelection();}},['NA','EU','FE'].map(function(value){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:value});}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default.a,{size:'small',type:'secondary',onClick:resetBuilder},getMessage(intl,'aisleconfig.builder.reset','Reset')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.body},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.section,'data-testid':'column-selection-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.sectionTitle},getMessage(intl,'aisleconfig.builder.selectcolumns','Select Bag, OV, and Flex columns')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:styles.hint},getMessage(intl,'aisleconfig.builder.selecthint','Pick a paint mode and click or drag across columns to apply it — or leave paint '+'off to cycle a column per click. Click the thin gap after a column to toggle a '+'physical pillar. Every two adjacent Flex columns form one footprint — pick its '+'top and bottom OV labels directly in the preview below.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.paintBar,'data-testid':'paint-mode-bar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:styles.paintLabel},getMessage(intl,'aisleconfig.builder.paintmode','Paint mode')),PAINT_MODES.map(function(_ref3){var mode=_ref3.mode,message=_ref3.message;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{key:'paint-'+mode,type:'button','data-testid':'paint-mode-'+mode,'aria-pressed':paintMode===mode,style:styles.paintChip(mode,paintMode===mode),onClick:function onClick(){setPaintMode(paintMode===mode?null:mode);setIsPainting(false);}},getMessage(intl,message.id,message.defaultMessage));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:styles.hintInline},paintMode===null?getMessage(intl,'aisleconfig.builder.paintoff','Paint off — clicking a column cycles its type.'):getMessage(intl,'aisleconfig.builder.painton','Click or drag across columns to apply.'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.columnStrip,onMouseUp:function onMouseUp(){return setIsPainting(false);},onMouseLeave:function onMouseLeave(){return setIsPainting(false);}},__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["a" /* ALLOWED_COLUMN_LABELS */].map(function(label){var mode=columnModes[label];var active=mode!==__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].ABSENT;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,{key:label},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button','aria-label':getMessage(intl,'aisleconfig.builder.columnaria','Column {label}: {mode}',{label:label,mode:getModeLabel(intl,mode)}),'data-testid':'rack-column-'+label,style:Object.assign({},styles.columnButton,modeStyles[mode]),onMouseDown:function onMouseDown(){if(paintMode!==null){setIsPainting(true);handleColumnClick(label);}},onMouseEnter:function onMouseEnter(){if(isPainting&&paintMode!==null){handleColumnClick(label);}},onClick:function onClick(){// Always apply on click: keyboard activation paints
// too, and a re-apply after mousedown is a no-op.
handleColumnClick(label);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.columnLetter},mode===__WEBPACK_IMPORTED_MODULE_7__AisleConfigModel__["b" /* BUILDER_COLUMN_MODES */].OV?label.toUpperCase():label),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.columnCaption},getModeLabel(intl,mode))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button','data-testid':'pillar-slot-'+label,'aria-label':getMessage(intl,'aisleconfig.builder.pillararia','Pillar after column {label}: {state}',{label:label,state:pillars.includes(label)?getMessage(intl,'aisleconfig.builder.pillar.present','present'):getMessage(intl,'aisleconfig.builder.pillar.absent','absent')}),title:getMessage(intl,'aisleconfig.builder.pillartitle','Toggle a pillar (physical gap) after this column'),disabled:!active,style:styles.pillarSlot(pillars.includes(label),active),onClick:function onClick(){return togglePillar(label);}},pillars.includes(label)?'▮':''));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.previewSection,'data-testid':'rack-preview-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default.a,{widths:["fill","fit"],alignmentVertical:'center',spacing:'300'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.sectionTitle},getMessage(intl,'aisleconfig.builder.livepreview','Live rack preview')),hasColumns&&!hasErrors&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button','data-testid':'match-count-chip',style:styles.matchChip(matches.length>0),title:getMessage(intl,'aisleconfig.builder.matchchiptitle','Jump to the matching existing configs'),onClick:scrollToMatches},matches.length===1?getMessage(intl,'aisleconfig.builder.matchchip.one','{count} existing config matches',{count:matches.length}):getMessage(intl,'aisleconfig.builder.matchchip.many','{count} existing configs match',{count:matches.length}))),!hasColumns?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert___default.a,{type:'informational'},getMessage(intl,'aisleconfig.builder.emptypreview','Select a column above to preview the physical rack.')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,hasErrors&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert___default.a,{type:'warning'},description.errors.map(function(error){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:error.code},getErrorMessage(intl,error));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(RackPreviewComponent,{columns:description.columns,intl:intl,onFlexOvLabelChange:setFootprintOvLabel})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.derivedGrid},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.derivedItem},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:styles.derivedLabel},getMessage(intl,'aisleconfig.builder.aislecode','Aisle code')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('code',{style:styles.code,'data-testid':'derived-aisle-code'},description.aisleCode)),description.bagCode&&description.ovCode&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.derivedItem},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:styles.derivedLabel},getMessage(intl,'aisleconfig.builder.ovcode','OV-mode code')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('code',{style:styles.code,'data-testid':'derived-ov-code'},description.ovCode))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default.a,{widths:["fill","fit"],alignmentVertical:'center',spacing:'300'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:styles.derivedLabel},getMessage(intl,'aisleconfig.builder.derivedname','Derived config name (year auto-stamped; matching ignores year)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button','data-testid':'copy-candidate-name',style:styles.copyButton,onClick:copyCandidateName},getMessage(intl,'aisleconfig.builder.copy','Copy'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('code',{style:styles.candidateName,'data-testid':'candidate-config-name'},description.candidateName),candidateCopyStatus&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:'6px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert___default.a,{type:'informational',size:'small'},candidateCopyStatus))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert___default.a,{type:'informational',size:'small'},getMessage(intl,'aisleconfig.builder.previewnote','This preview is derived from your description. Authoritative LED/bin '+'mappings from the S3 JSON will appear once the read-only NDMS '+'config-content operation is available.'))))),!hasErrors&&hasColumns&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.section,'data-testid':'matches-section',ref:matchesRef},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:styles.sectionTitle},getMessage(intl,'aisleconfig.builder.matchestitle','Existing structural matches: {count}',{count:matches.length})),matches.length===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_alert___default.a,{type:'warning'},getMessage(intl,'aisleconfig.builder.nomatches','No existing S3 config name matches this physical structure (any year).'))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,{spacing:'200',spacingInset:'300 none none none'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select___default.a,{id:'structural-match',value:selectedMatch,onChange:function onChange(value){setSelectedMatch(value);setConfirmedMatch('');},placeholder:getMessage(intl,'aisleconfig.builder.matchplaceholder','Select a matching existing config')},matches.map(function(name){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select__["SelectOption"],{key:name,value:name,label:name});})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default.a,{alignmentVertical:'center',spacing:'300'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default.a,{type:'primary',size:'small',disabled:!selectedMatch,onClick:function onClick(){setConfirmedMatch(selectedMatch);onSelectConfig(selectedMatch);}},getMessage(intl,'aisleconfig.builder.usematch','Use matched config')),confirmedMatch&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{'data-testid':'match-selection-confirmation',style:styles.confirmation},getMessage(intl,'aisleconfig.builder.matchselected','✓ Selected — full details below')))))));};/* harmony default export */ __webpack_exports__["a"] = (VisualRackBuilder);

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_TrafficLightOverviewContext__ = __webpack_require__(121);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var TrafficLightPage=function(_Component){_inherits(TrafficLightPage,_Component);function TrafficLightPage(){_classCallCheck(this,TrafficLightPage);return _possibleConstructorReturn(this,(TrafficLightPage.__proto__||Object.getPrototypeOf(TrafficLightPage)).apply(this,arguments));}_createClass(TrafficLightPage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__context_TrafficLightOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__["z" /* TRAFFIC_LIGHTS */],location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__["z" /* TRAFFIC_LIGHTS */]})));}}]);return TrafficLightPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TrafficLightPage);

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrafficLightOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_TrafficLightOverviewNetworkAPI__ = __webpack_require__(1293);
var TrafficLightOverviewReducer=function TrafficLightOverviewReducer(state,action){switch(action.type){case"LOAD_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_TrafficLightOverviewNetworkAPI__["c" /* fetchTrafficLightControllerDetails */])(action.data.dispatcher);return state;case"RECEIVE_DATA":return Object.assign({},state,{deviceInformation:action.data,loadingOverview:false});case"UPDATE_TRAFFIC_LIGHT_SIGNAL_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_TrafficLightOverviewNetworkAPI__["e" /* updateTrafficLightSignalDetails */])(action.data.dispatcher,action.data.controllerDataIndex,action.data.trafficLightDataIndex,action.data.assetDetails);return state;case"UPDATE_TRAFFIC_LIGHT_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_TrafficLightOverviewNetworkAPI__["d" /* updateTrafficLightDeviceDetails */])(action.data.dispatcher,action.data.index,action.data.assetDetails);return state;case"ADD_CONTROLLER_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_TrafficLightOverviewNetworkAPI__["a" /* addTrafficLightControllerDetails */])(action.data.dispatcher,action.data.assetDetails);return state;case"DELETE_CONTROLLER_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_TrafficLightOverviewNetworkAPI__["b" /* deleteTrafficLightDeviceDetails */])(action.data.dispatcher,action.data.mac);return state;case"SHOW_UPDATE_RESPONSE_MODAL":return Object.assign({},state,{showResponseModal:action.data.modalState,modalMessageToDisplay:action.data.message});case"UPDATE_DATA":var updatedDeviceInformation=Object.assign({},state.deviceInformation);updatedDeviceInformation.assetDetails[action.data.index]=Object.assign({},action.data.assetDetails);return Object.assign({},state,{deviceInformation:updatedDeviceInformation});default:return state;}};

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchTrafficLightControllerDetails;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateTrafficLightDeviceDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateTrafficLightSignalDetails; });
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteTrafficLightDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["a"] = addTrafficLightControllerDetails;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__ = __webpack_require__(51);
var filterTrafficLightDeviceInformation=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(getAssetsResult){var filteredDeviceInformation,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,trafficLightDetails,getAssetByLabelResult;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:filteredDeviceInformation=[];if(!("data"in getAssetsResult&&"assetDetailsList"in getAssetsResult.data)){_context.next=32;break;}_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context.prev=5;_iterator=getAssetsResult.data.assetDetailsList[Symbol.iterator]();case 7:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context.next=18;break;}trafficLightDetails=_step.value;if(!(trafficLightDetails.assetStatus===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */])){_context.next=15;break;}_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(trafficLightDetails.assetLabel);case 12:getAssetByLabelResult=_context.sent;trafficLightDetails["assetMappings"]=getAssetByLabelResult.data.asset.assetMappings;filteredDeviceInformation.push(trafficLightDetails);case 15:_iteratorNormalCompletion=true;_context.next=7;break;case 18:_context.next=24;break;case 20:_context.prev=20;_context.t0=_context["catch"](5);_didIteratorError=true;_iteratorError=_context.t0;case 24:_context.prev=24;_context.prev=25;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 27:_context.prev=27;if(!_didIteratorError){_context.next=30;break;}throw _iteratorError;case 30:return _context.finish(27);case 31:return _context.finish(24);case 32:return _context.abrupt("return",filteredDeviceInformation);case 33:case"end":return _context.stop();}}},_callee,this,[[5,20,24,32],[25,,27,31]]);}));return function filterTrafficLightDeviceInformation(_x){return _ref.apply(this,arguments);};}();var getTrafficLightDeviceDetails=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatcher,request){var getAssetsResult,updatedTrafficLightDeviceInformation;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["g" /* getAssets */])(request.nodeId,request.assetType,null);case 2:getAssetsResult=_context2.sent;if(!(getAssetsResult.status===200)){_context2.next=10;break;}_context2.next=6;return filterTrafficLightDeviceInformation(getAssetsResult);case 6:updatedTrafficLightDeviceInformation=_context2.sent;dispatcher({type:"RECEIVE_DATA",data:{"assetDetails":updatedTrafficLightDeviceInformation}});_context2.next=11;break;case 10:dispatcher({type:"RECEIVE_DATA",data:{"assetDetails":[]}});case 11:case"end":return _context2.stop();}}},_callee2,this);}));return function getTrafficLightDeviceDetails(_x2,_x3){return _ref2.apply(this,arguments);};}();var publishTrafficLightCommandToThinClient=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatcher,request){var args,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(request,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_60" /* ENDPOINT_PUBLISH_TRAFFIC_LIGHT_COMMAND_TO_THIN_CLIENT */]);args.requestBody["nodeId"]=request.nodeId;_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:response=_context3.sent;if(response.status!==200){dispatcher({type:"SHOW_UPDATE_RESPONSE_MODAL",data:{modalState:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_133" /* MODAL_ERROR */],message:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["w" /* ALERT_PUBLISH_TRAFFIC_LIGHT_COMMAND_MESSAGE */]}});}case 6:case"end":return _context3.stop();}}},_callee3,this);}));return function publishTrafficLightCommandToThinClient(_x4,_x5){return _ref3.apply(this,arguments);};}();var setAssetLabelAsDeprecated=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatcher,request){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetLabel,request.assetStatus).then(function(result){if(result.status===200){fetchTrafficLightControllerDetails(dispatcher);}else{dispatcher({type:"RECEIVE_DATA",data:[]});}});case 1:case"end":return _context6.stop();}}},_callee6,this);}));return function setAssetLabelAsDeprecated(_x13,_x14){return _ref6.apply(this,arguments);};}();var addControllerDetails=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatcher,request){var _this=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["a" /* addAsset */])(request).then(function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(result){var getAssetResult,responseSetAssetStatus,responseUpdateAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(!(result.status!==200)){_context7.next=19;break;}_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 3:getAssetResult=_context7.sent;if(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(getAssetResult.data.asset.assetDetails.assetStatus)){_context7.next=7;break;}dispatcher({type:"SHOW_UPDATE_RESPONSE_MODAL",data:{modalState:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_133" /* MODAL_ERROR */],message:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["B" /* ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET */]}});return _context7.abrupt("return");case 7:_context7.next=9;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);case 9:responseSetAssetStatus=_context7.sent;if(!(responseSetAssetStatus.status!==200)){_context7.next=13;break;}dispatcher({type:"SHOW_UPDATE_RESPONSE_MODAL",data:{modalState:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_133" /* MODAL_ERROR */],message:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]}});return _context7.abrupt("return");case 13:_context7.next=15;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 15:responseUpdateAsset=_context7.sent;if(!(responseUpdateAsset.status!==200)){_context7.next=19;break;}dispatcher({type:"SHOW_UPDATE_RESPONSE_MODAL",data:{modalState:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_133" /* MODAL_ERROR */],message:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]}});return _context7.abrupt("return");case 19:fetchTrafficLightControllerDetails(dispatcher);case 20:case"end":return _context7.stop();}}},_callee7,_this);}));return function(_x17){return _ref8.apply(this,arguments);};}());case 1:case"end":return _context8.stop();}}},_callee8,this);}));return function addControllerDetails(_x15,_x16){return _ref7.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function fetchTrafficLightControllerDetails(dispatcher){var request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_206" /* TRAFFIC_LIGHT_CONTROLLER_ASSET_TYPE */]};getTrafficLightDeviceDetails(dispatcher,request);}var updateTrafficLightDeviceDetails=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatcher,index,updatedAssetDetails){var request,setAssetStatusResponse,getAssetResult,updateAssetResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:request=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["p" /* convertTableJsonToAssetForTrafficLight */])(updatedAssetDetails,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_206" /* TRAFFIC_LIGHT_CONTROLLER_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);case 3:setAssetStatusResponse=_context4.sent;if(!(setAssetStatusResponse.status!==200)){_context4.next=7;break;}dispatcher({type:"SHOW_UPDATE_RESPONSE_MODAL",data:{modalState:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_133" /* MODAL_ERROR */],message:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]}});return _context4.abrupt("return");case 7:_context4.next=9;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 9:getAssetResult=_context4.sent;_context4.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 12:updateAssetResponse=_context4.sent;if(updateAssetResponse.status!==200){dispatcher({type:"SHOW_UPDATE_RESPONSE_MODAL",data:{modalState:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_133" /* MODAL_ERROR */],message:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]}});}else{dispatcher({type:"UPDATE_DATA",data:{"index":index,"assetDetails":updatedAssetDetails}});}case 14:case"end":return _context4.stop();}}},_callee4,this);}));return function updateTrafficLightDeviceDetails(_x6,_x7,_x8){return _ref4.apply(this,arguments);};}();var updateTrafficLightSignalDetails=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatcher,controllerDataIndex,trafficLightDataIndex,updatedAssetDetails){var ndmsRequest;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return updateTrafficLightDeviceDetails(dispatcher,controllerDataIndex,updatedAssetDetails);case 2:ndmsRequest=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["r" /* convertTableJsonToRequestForNDMS */])(trafficLightDataIndex,updatedAssetDetails);publishTrafficLightCommandToThinClient(dispatcher,ndmsRequest);case 4:case"end":return _context5.stop();}}},_callee5,this);}));return function updateTrafficLightSignalDetails(_x9,_x10,_x11,_x12){return _ref5.apply(this,arguments);};}();function deleteTrafficLightDeviceDetails(dispatcher,mac){var request={assetLabel:{type:"MAC_ADDRESS",value:mac},assetStatus:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_19" /* DEPRECATED */]};setAssetLabelAsDeprecated(dispatcher,request);}function addTrafficLightControllerDetails(dispatcher,assetDetails){assetDetails.mac=assetDetails.mac.toLowerCase();var request=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["o" /* convertTableJsonToAsset */])(assetDetails,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_206" /* TRAFFIC_LIGHT_CONTROLLER_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);addControllerDetails(dispatcher,request);}

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_TrafficLightOverviewContext__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TrafficLightControlPage__ = __webpack_require__(1295);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var TrafficLightControllerSelectPage=function TrafficLightControllerSelectPage(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__context_TrafficLightOverviewContext__["a" /* TrafficLightDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),deviceConfigs=_useState2[0],setDeviceConfigs=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState4=_slicedToArray(_useState3,2),filteredDeviceConfig=_useState4[0],setFilteredDeviceConfig=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),selectedMac=_useState6[0],setSelectedMac=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState8=_slicedToArray(_useState7,2),indexForControllerData=_useState8[0],setIndexForControllerData=_useState8[1];var fetchDeviceInformation=function fetchDeviceInformation(){dispatch({type:'LOAD_DATA',data:{dispatcher:dispatch}});};var changeSelectedMac=function changeSelectedMac(value){setSelectedMac(value);var selectedDeviceConfig={};deviceConfigs.forEach(function(device,index){if(device.assetAttributes.mac===value){selectedDeviceConfig=Object.assign({},device);setIndexForControllerData(index);setFilteredDeviceConfig(selectedDeviceConfig);return;}});};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!viewModel.deviceInformation.assetDetails){fetchDeviceInformation();}else{var newDeviceInformation=JSON.parse(JSON.stringify(viewModel.deviceInformation.assetDetails));setDeviceConfigs(newDeviceInformation);}},[viewModel.deviceInformation.assetDetails]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default.a,{type:"fill",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",widths:["fill",'30%'],spacing:"400"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"devicename.title",defaultMessage:"Select Device"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select___default.a,{value:selectedMac,onChange:changeSelectedMac,placeholder:"Select Device",size:"small",width:250},deviceConfigs.map(function(device){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_select__["SelectOption"],{key:device.assetAttributes.mac,value:device.assetAttributes.mac,label:device.assetAttributes.name+" ("+device.assetAttributes.mac+")"});}),!deviceConfigs.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default.a,{alignment:"center"}," No devices available ")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TrafficLightControlPage__["a" /* default */],{controllerDetails:filteredDeviceConfig,indexForControllerData:indexForControllerData})));};/* harmony default export */ __webpack_exports__["a"] = (TrafficLightControllerSelectPage);

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__meridian_components_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Button__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modal_AddTrafficLightDeviceModal__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__context_TrafficLightOverviewContext__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modal_UpdateDeviceDetailsResponse__ = __webpack_require__(511);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var TrafficLightControlPage=function TrafficLightControlPage(_ref){var controllerDetails=_ref.controllerDetails,indexForControllerData=_ref.indexForControllerData;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10__context_TrafficLightOverviewContext__["a" /* TrafficLightDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(controllerDetails),_useState2=_slicedToArray(_useState,2),controllerConfig=_useState2[0],setControllerConfig=_useState2[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openAddNewDeviceModal=_useState4[0],setOpenAddNewDeviceModal=_useState4[1];var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__permissions_PermissionsContext__["a" /* PermissionsContext */]),isManager=_useContext2.isManager;var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('name'),_useState6=_slicedToArray(_useState5,2),sortColumn=_useState6[0],setSortColumn=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('ascending'),_useState8=_slicedToArray(_useState7,2),sortDirection=_useState8[0],setSortDirection=_useState8[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setControllerConfig(controllerDetails);},[controllerDetails.assetMappings]);var updateDeviceStatus=function updateDeviceStatus(newStatus,index){var updatedTrafficLightAssetDetails=Object.assign({},controllerConfig);updatedTrafficLightAssetDetails["assetMappings"][index]["mappingAttributes"]["color"]=updatedTrafficLightAssetDetails["assetMappings"][index]["mappingAttributes"]["color"]===newStatus?null:newStatus;dispatch({type:'UPDATE_TRAFFIC_LIGHT_SIGNAL_DATA',data:{dispatcher:dispatch,controllerDataIndex:indexForControllerData,trafficLightDataIndex:index,assetDetails:updatedTrafficLightAssetDetails}});setControllerConfig(updatedTrafficLightAssetDetails);};var deleteDevice=function deleteDevice(index){var updatedTrafficLightAssetDetails=Object.assign({},controllerConfig);updatedTrafficLightAssetDetails["assetMappings"].splice(index,1);dispatch({type:'UPDATE_TRAFFIC_LIGHT_DEVICE_DATA',data:{dispatcher:dispatch,index:indexForControllerData,assetDetails:updatedTrafficLightAssetDetails}});setControllerConfig(updatedTrafficLightAssetDetails);};var onSort=function onSort(sortDetails){var sortedDeviceList=Object.assign({},controllerDetails);sortedDeviceList&&sortedDeviceList.assetMappings.sort(function(a,b){if(a[sortDetails.sortColumn]<b[sortDetails.sortColumn]){return sortDetails.sortDirection==="ascending"?-1:1;}if(a[sortDetails.sortColumn]>b[sortDetails.sortColumn]){return sortDetails.sortDirection==="ascending"?1:-1;}return 0;});setSortColumn(sortDetails.sortColumn);setSortDirection(sortDetails.sortDirection);setControllerConfig(sortedDeviceList);};return controllerConfig.assetMappings?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__meridian_components_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_RefreshTimer__["a" /* default */],{deps:[viewModel]})),controllerConfig.assetMappings.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.device",defaultMessage:"No device present for this station."})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",showDividers:true,showStripes:true,sortColumn:sortColumn,onSort:onSort,sortDirection:sortDirection},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],{sortColumn:"mappedResourceLabel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.name",defaultMessage:"Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.wave",defaultMessage:"Wave"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null)),controllerConfig.assetMappings.map(function(device,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableRow"],{key:index,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.mappedResourceLabel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.mappingAttributes.wave)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__meridian_components_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Button__["a" /* default */],{variant:device.mappingAttributes.color==="RED"?'danger':"outline-danger",onClick:function onClick(){return updateDeviceStatus("RED",index);},disabled:!isManager},"Red"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Button__["a" /* default */],{variant:device.mappingAttributes.color==="GREEN"?'success':"outline-success",onClick:function onClick(){return updateDeviceStatus("GREEN",index);},disabled:!isManager},"Green"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Button__["a" /* default */],{variant:device.mappingAttributes.color==="YELLOW"?'warning':"outline-warning",onClick:function onClick(){return updateDeviceStatus("YELLOW",index);},disabled:!isManager},"Yellow"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Button__["a" /* default */],{variant:"danger",size:"small",onClick:function onClick(){return deleteDevice(index);},disabled:!isManager},"Delete Device")));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Button__["a" /* default */],{variant:"info",size:"small",onClick:function onClick(){return setOpenAddNewDeviceModal(true);},disabled:!isManager},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.add_device_button_modal",defaultMessage:"Add Device Configuration"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__modal_AddTrafficLightDeviceModal__["a" /* default */],{open:openAddNewDeviceModal,setOpen:setOpenAddNewDeviceModal,controllerConfig:controllerConfig,indexForControllerData:indexForControllerData}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__modal_UpdateDeviceDetailsResponse__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef}))):null;};/* harmony default export */ __webpack_exports__["a"] = (TrafficLightControlPage);

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_TrafficLightOverviewContext__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Constants__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddTrafficLightDeviceModal=function AddTrafficLightDeviceModal(_ref){var open=_ref.open,setOpen=_ref.setOpen,controllerConfig=_ref.controllerConfig,indexForControllerData=_ref.indexForControllerData;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__context_TrafficLightOverviewContext__["a" /* TrafficLightDeviceOverviewContext */]),dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),label=_useState2[0],setLabel=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),wave=_useState4[0],setWave=_useState4[1];var onCloseModal=function onCloseModal(){setOpen(false);resetInputState();};var addAsset=function addAsset(){var newAssetMapping={"mappedResourceLabel":label,"mappedResourceType":__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_207" /* TRAFFIC_LIGHT_RESOURCE_TYPE */],"mappingAttributes":{"color":null,"wave":wave}};var newControllerConfig=Object.assign({},controllerConfig);newControllerConfig["assetMappings"].push(newAssetMapping);dispatch({type:'UPDATE_TRAFFIC_LIGHT_DEVICE_DATA',data:{dispatcher:dispatch,index:indexForControllerData,assetDetails:newControllerConfig}});};var onClickConfirm=function onClickConfirm(){addAsset();resetInputState();setOpen(false);};function resetInputState(){resetAssetDetails();}var resetAssetDetails=function resetAssetDetails(){setLabel("");setWave(null);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"name-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.name",defaultMessage:"Device Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_input___default.a,{id:"name-input",value:label,onChange:setLabel,helperText:"Enter label of the device. e.g. \"L0-T1\""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"wave-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.wave",defaultMessage:"Wave Number"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_input___default.a,{id:"wave-input",value:wave,onChange:setWave,type:"number"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:onClickConfirm},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"})))));};/* harmony default export */ __webpack_exports__["a"] = (AddTrafficLightDeviceModal);

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__meridian_components_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Button__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_TrafficLightOverviewContext__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_AddControllerModal__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modal_UpdateDeviceDetailsResponse__ = __webpack_require__(511);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var TrafficLightControllerOverview=function TrafficLightControllerOverview(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__context_TrafficLightOverviewContext__["a" /* TrafficLightDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__permissions_PermissionsContext__["a" /* PermissionsContext */]),isManager=_useContext2.isManager;var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),controllerDeviceInformation=_useState2[0],setControllerDeviceInformation=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openAddNewControllerModal=_useState4[0],setOpenAddNewControllerModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('name'),_useState6=_slicedToArray(_useState5,2),sortColumn=_useState6[0],setSortColumn=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('ascending'),_useState8=_slicedToArray(_useState7,2),sortDirection=_useState8[0],setSortDirection=_useState8[1];var fetchDeviceInformation=function fetchDeviceInformation(){dispatch({type:'LOAD_DATA',data:{dispatcher:dispatch}});};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!viewModel.deviceInformation.assetDetails){fetchDeviceInformation();}else{setControllerDeviceInformation(viewModel.deviceInformation.assetDetails);}},[viewModel.deviceInformation.assetDetails]);var deleteDevice=function deleteDevice(index){var updatedControllerData=[].concat(_toConsumableArray(controllerDeviceInformation));dispatch({type:'DELETE_CONTROLLER_DATA',data:{dispatcher:dispatch,mac:controllerDeviceInformation[index].assetLabel.value}});updatedControllerData.splice(index,1);setControllerDeviceInformation(updatedControllerData);};var onSort=function onSort(sortDetails){var sortedDeviceList=Object.values(controllerDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){if(a['assetAttributes'][sortDetails.sortColumn]<b['assetAttributes'][sortDetails.sortColumn]){return sortDetails.sortDirection==="ascending"?-1:1;}if(a['assetAttributes'][sortDetails.sortColumn]>b['assetAttributes'][sortDetails.sortColumn]){return sortDetails.sortDirection==="ascending"?1:-1;}return 0;});setSortColumn(sortDetails.sortColumn);setSortDirection(sortDetails.sortDirection);setControllerDeviceInformation(sortedDeviceList);};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__meridian_components_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_RefreshTimer__["a" /* default */],{deps:[viewModel]})),controllerDeviceInformation.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.device",defaultMessage:"No controller present for this station."})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",showDividers:true,showStripes:true,sortColumn:sortColumn,onSort:onSort,sortDirection:sortDirection},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],{sortColumn:"name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.name",defaultMessage:"Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.mac_ip",defaultMessage:"MAC/IP"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null)),controllerDeviceInformation.map(function(device,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableRow"],{key:index,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.assetAttributes.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.assetAttributes.mac),device.assetAttributes.ip)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Button__["a" /* default */],{variant:"danger",size:"small",onClick:function onClick(){return deleteDevice(index);},disabled:!isManager},"Delete Device")));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_Button__["a" /* default */],{variant:"info",size:"small",onClick:function onClick(){return setOpenAddNewControllerModal(true);},disabled:!isManager},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.add_device_button_modal",defaultMessage:"Add Device Configuration"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__modal_AddControllerModal__["a" /* default */],{open:openAddNewControllerModal,setOpen:setOpenAddNewControllerModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__modal_UpdateDeviceDetailsResponse__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (TrafficLightControllerOverview);

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_TrafficLightOverviewContext__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddControllerModal=function AddControllerModal(_ref){var open=_ref.open,setOpen=_ref.setOpen;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__context_TrafficLightOverviewContext__["a" /* TrafficLightDeviceOverviewContext */]),dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),name=_useState4[0],setName=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),ip=_useState6[0],setIp=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),mac=_useState8[0],setMac=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),nameErr=_useState10[0],setNameErr=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),ipErr=_useState12[0],setIpErr=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),macErr=_useState14[0],setMacErr=_useState14[1];var onCloseModal=function onCloseModal(){setOpen(false);resetInputState();setShowAlert(false);};var addAsset=function addAsset(){dispatch({type:'ADD_CONTROLLER_DATA',data:{dispatcher:dispatch,assetDetails:{mac:mac,ip:ip,name:name}}});};var onClickConfirm=function onClickConfirm(){if(Object(__WEBPACK_IMPORTED_MODULE_2__util_Validations__["X" /* validateNewControllerDevice */])(mac,ip,name)){setShowAlert(false);addAsset();resetInputState();setOpen(false);}else{setShowAlert(true);}};function resetInputState(){resetAssetDetails();resetAssetDetailErrors();}var resetAssetDetails=function resetAssetDetails(){setMac("");setIp("");setName("");};var resetAssetDetailErrors=function resetAssetDetailErrors(){setMacErr(false);setIpErr(false);setNameErr(false);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal___default.a,{open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"modal.mac",defaultMessage:"MAC Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_input___default.a,{id:"mac-input",value:mac,onChange:setMac,mask:__WEBPACK_IMPORTED_MODULE_2__util_Validations__["i" /* MAC_MASK */],onBlur:function onBlur(){setMacErr(!Object(__WEBPACK_IMPORTED_MODULE_2__util_Validations__["L" /* isValidEntry */])(mac,__WEBPACK_IMPORTED_MODULE_2__util_Validations__["j" /* PATTERNS */].MAC));},error:macErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"ip-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"modal.ip",defaultMessage:"IP Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_input___default.a,{id:"ip-input",value:ip,onChange:setIp,onBlur:function onBlur(){return setIpErr(!Object(__WEBPACK_IMPORTED_MODULE_2__util_Validations__["L" /* isValidEntry */])(ip,__WEBPACK_IMPORTED_MODULE_2__util_Validations__["g" /* IP_ADDRESS_PATTERN */]));},error:ipErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"name-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"modal.name",defaultMessage:"Device Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_input___default.a,{id:"name-input",value:name,onChange:setName,onBlur:function onBlur(){return setNameErr(!Object(__WEBPACK_IMPORTED_MODULE_2__util_Validations__["L" /* isValidEntry */])(name,__WEBPACK_IMPORTED_MODULE_2__util_Validations__["j" /* PATTERNS */].NAME));},error:nameErr,helperText:"Display name of the device. e.g. \"Controller 1\""}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__meridian_components_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:onClickConfirm},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"})))));};/* harmony default export */ __webpack_exports__["a"] = (AddControllerModal);

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AdtfDeviceOverviewContext__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modal_AddAdtfSingleDeviceModal__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__commonui_DeleteSingleDeviceModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__commonui_EditMacAddressModal__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commonui_DisableMonitoringModal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__ = __webpack_require__(91);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AdtfDeviceOverview=function AdtfDeviceOverview(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_AdtfDeviceOverviewContext__["a" /* AdtfDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_26__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorized=_useContext2.isAuthorized;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),openAddModal=_useState2[0],setOpenAddModal=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openDeleteModal=_useState4[0],setOpenDeleteModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),openEditMacModal=_useState6[0],setOpenEditMaceModal=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState8=_slicedToArray(_useState7,2),openActionsMenu=_useState8[0],setOpenActionsMenu=_useState8[1];var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),selected=_useState10[0],setSelected=_useState10[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),openDisableMonitoringModal=_useState12[0],setOpenDisableMonitoringModal=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),mac=_useState14[0],setMac=_useState14[1];var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=true;setOpenActionsMenu(_open);},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=false;setOpenActionsMenu(_open);},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openAddModal&&!openDeleteModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["D" /* getAssetRefreshInterval */])());var statusInterval=setInterval(function(){if(!document.hidden){getStatusData();}},Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_11" /* getStatusRefreshInterval */])());return function(){clearInterval(interval);clearInterval(statusInterval);};}},[openAddModal,openDeleteModal]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,viewModel.adtfDeviceInformation.length);},[viewModel.adtfDeviceInformation]);var onSort=function onSort(sortDetails){dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};var updateData=function updateData(stateValues,mac){dispatch({type:'UPDATE_MONITORING_DATA',data:{dispatcher:dispatch,stateValues:stateValues,mac:mac}});};var onClickDisableMonitoring=function onClickDisableMonitoring(mac){setMac(mac);setOpenDisableMonitoringModal(true);};var onClickEnableMonitoring=function onClickEnableMonitoring(startTime,reason,mac){var stateValues={"startTime":startTime,"endTime":Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["I" /* getCurrentDate */])().toString(),"reason":reason};updateData(stateValues,mac);getData();};var renderDeviceMonitoring=function renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{style:{color:monitoringStatusColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:monitoringStatusId,defaultMessage:monitoringStatusDefaultMessage}));};var sortedDeviceList=Object.values(viewModel.adtfDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){var _viewModel$sortPref=viewModel.sortPref,column=_viewModel$sortPref.column,direction=_viewModel$sortPref.direction;var compareValue=void 0;if(Object.keys(__WEBPACK_IMPORTED_MODULE_25__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */]).includes(column)){if(column==="vendor"){compareValue=Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column]+a.vendorAttributes["spec_version"],b.vendorAttributes[column]+b.vendorAttributes["spec_version"]);}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column],b.vendorAttributes[column]);}}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_32" /* sortComparator */])(a[column],b[column]);}if(direction===__WEBPACK_IMPORTED_MODULE_25__util_Constants__["J" /* ASCENDING */]){return compareValue;}else{return-compareValue;}});var getData=function getData(){setOpenAddModal(false);setOpenDeleteModal(false);setOpenDisableMonitoringModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var getStatusData=function getStatusData(){dispatch({type:'LOAD_STATUS',data:{dispatcher:dispatch}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var onClickEditDevice=function onClickEditDevice(mac){setSelected(mac);setOpenAddModal(true);};var onClickRemove=function onClickRemove(mac){setSelected(mac);setOpenDeleteModal(true);};var onClickAddEditConfig=function onClickAddEditConfig(){setSelected("");setOpenAddModal(true);};var onClickChangeMac=function onClickChangeMac(mac){setSelected(mac);setOpenEditMaceModal(true);};var getAdtfStateValues=function getAdtfStateValues(mac){if(!mac)return{};var device=viewModel.adtfDeviceInformation[mac];if(!device)return{};var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};return{mac:mac,ip:device.ip,name:device.name,deviceType:device.deviceType,port:device.port,deviceConfig:JSON.stringify({type:__WEBPACK_IMPORTED_MODULE_10__util_Util__["e" /* assetTypeToConfigTypeDict */].typeADTF,id:device.id}),vendorAttributes:device.vendorAttributes,monitoring:JSON.stringify(deviceMonitoring),sorterConfig:JSON.stringify(viewModel.sorterConfig[mac]),sorterTestPackage:JSON.stringify(viewModel.sorterTestPackageConfig[mac])};};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default.a,{position:"top",title:intl.formatMessage({id:'tooltip.scrolltobottom',defaultMessage:'Scroll to bottom'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"alert.device",defaultMessage:"No device present for this station."})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"device.name",defaultMessage:"Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"device.mac_ip",defaultMessage:"MAC/IP"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_24__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.connectionstatus'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"connection"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"device.connection",defaultMessage:"Connection Status"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"device.monitoring",defaultMessage:"Monitoring Status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"vendor"},Object(__WEBPACK_IMPORTED_MODULE_24__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'device.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"sorter_type"},Object(__WEBPACK_IMPORTED_MODULE_24__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'device.sorter_type'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"device.action",defaultMessage:"Action"}))),sortedDeviceList.map(function(device,index){var vendorAttributes=device.vendorAttributes;var monitoring=Object(__WEBPACK_IMPORTED_MODULE_23__util_Validations__["u" /* checkDeviceMonitoringEnabled */])(Number(device.startTime),Number(device.endTime));var _getMonitoringStatusD=Object(__WEBPACK_IMPORTED_MODULE_23__util_Validations__["F" /* getMonitoringStatusDetails */])(monitoring),monitoringStatusColor=_getMonitoringStatusD.monitoringStatusColor,monitoringStatusId=_getMonitoringStatusD.monitoringStatusId,monitoringStatusDefaultMessage=_getMonitoringStatusD.monitoringStatusDefaultMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{key:index,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),device.deviceType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.mac),device.ip,":",device.port)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,device.assetStatus?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{color:device.assetStatus.toUpperCase()===__WEBPACK_IMPORTED_MODULE_25__util_Constants__["b" /* ACTIVE */]?__WEBPACK_IMPORTED_MODULE_25__util_Constants__["X" /* BLUE_COLOR */]:__WEBPACK_IMPORTED_MODULE_25__util_Constants__["_149" /* ORANGE_COLOR */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.assetStatus)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"loading.text",defaultMessage:"Loading..."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_23__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][vendorAttributes.vendor]," ",__WEBPACK_IMPORTED_MODULE_23__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][vendorAttributes.spec_version])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_23__util_Validations__["o" /* SORTER_TYPE_DISPLAY_VALUES */][vendorAttributes.sorter_type])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_24__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"left"},child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"my-menu","aria-haspopup":"menu","aria-expanded":"false",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_25__util_Constants__["_202" /* THREE_DOTS */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu___default.a,{anchorNode:actionButtonRefs.current[index],open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEditDevice(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"actions.addDevice",defaultMessage:"Edit Device"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickRemove(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"actions.deleteDevice",defaultMessage:"Delete Device"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickChangeMac(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"actions.changeMac",defaultMessage:"Change device mac-address"})),monitoring.isMonitoringEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDisableMonitoring(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_disable",defaultMessage:"Disable Monitoring"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEnableMonitoring(device.startTime,device.reason,device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_enable",defaultMessage:"Enable Monitoring"}))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_24__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"end"},child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{onClick:onClickAddEditConfig,type:"primary",size:"small",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"device.add_device_button_modal",defaultMessage:"Add Device Configuration"}))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_27__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_24__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"end"},child:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{onClick:function onClick(){return setOpenDeleteModal(true);},type:"tertiary",size:"small",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */],{id:"button.delete",defaultMessage:"Delete device"}))})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__modal_AddAdtfSingleDeviceModal__["a" /* default */],{open:openAddModal,setOpen:setOpenAddModal,selected:selected,setSelected:setSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__commonui_DeleteSingleDeviceModal__["a" /* default */],{open:openDeleteModal,setOpen:setOpenDeleteModal,selected:selected,setSelected:setSelected,macAddressArray:viewModel.macAddressArray,dispatch:dispatch}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__commonui_EditMacAddressModal__["a" /* default */],{open:openEditMacModal,setOpen:setOpenEditMaceModal,selectedMac:selected,setSelectedMac:setSelected,dispatch:dispatch,stateValues:getAdtfStateValues(selected)}),openDisableMonitoringModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__commonui_DisableMonitoringModal__["a" /* default */],{mac:mac,state:openDisableMonitoringModal,onStateChange:setOpenDisableMonitoringModal,context:__WEBPACK_IMPORTED_MODULE_2__context_AdtfDeviceOverviewContext__["a" /* AdtfDeviceOverviewContext */],reducer:'UPDATE_MONITORING_DATA'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_intl__["d" /* injectIntl */])(AdtfDeviceOverview));

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdtfDeviceOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_AdtfDeviceOverviewNetworkAPI__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
var AdtfDeviceOverviewReducer=function AdtfDeviceOverviewReducer(state,action){switch(action.type){case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingOverview:false,timestamp:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_14" /* getTimestampNow */])()});case"LOAD_VIEW":if(state.assetSubtype)Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtfDeviceOverviewNetworkAPI__["d" /* fetchAdtfSubTypeDeviceDetails */])(action.data.dispatcher,state.assetSubtype);else Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtfDeviceOverviewNetworkAPI__["b" /* fetchAdtfDeviceDetails */])(action.data.dispatcher);return state;case"LOAD_STATUS":Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtfDeviceOverviewNetworkAPI__["c" /* fetchAdtfStatusDetails */])(action.data.dispatcher,state);return state;case"UPDATE_ADTF_CONFIGURATION":Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtfDeviceOverviewNetworkAPI__["f" /* updateAdtfConfiguration */])(action.data.dispatcher,action.data.configurations,action.data.mac,action.data.showCustomAlert);return state;case"ADD_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtfDeviceOverviewNetworkAPI__["e" /* setAdtfDeviceDetails */])(action.data.dispatcher,action.data.stateValues,action.data.showCustomAlert,state.assetSubtype);return state;case"UPDATE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtfDeviceOverviewNetworkAPI__["g" /* updateAdtfDeviceDetails */])(action.data.dispatcher,action.data.stateValues,action.data.showCustomAlert,state.assetSubtype);return state;case"UPDATE_DEVICE_MAC":Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtfDeviceOverviewNetworkAPI__["h" /* updateAdtfDeviceMac */])(action.data.dispatcher,action.data.stateValues,action.data.mac,action.data.showCustomAlert,state.assetSubtype);return state;case"DELETE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtfDeviceOverviewNetworkAPI__["a" /* deleteAdtfDeviceDetails */])(action.data.dispatcher,action.data.mac);return state;case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});case"UPDATE_MONITORING_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AdtfDeviceOverviewNetworkAPI__["i" /* updateAdtfMonitoringDetails */])(action.data.dispatcher,action.data.stateValues,action.data.mac);return state;default:return state;}};

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export refreshAdtfDeviceData */
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchAdtfSubTypeDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAdtfDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAdtfStatusDetails;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteAdtfDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["e"] = setAdtfDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateAdtfDeviceDetails;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateAdtfDeviceMac; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateAdtfConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateAdtfMonitoringDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datamodel_AdtfAssetModelResource__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources_StatusResource__ = __webpack_require__(270);
var getAdtfDeviceSubTypeDetails=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatcher,request,assetSubType){var _this=this;var pageToken,assetDeviceDetailList,startTime,isSuccess,isFault,_loop,model;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:pageToken=null;assetDeviceDetailList=[];startTime=Date.now();isSuccess=true;isFault=false;// Get assets
_loop=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var getAssetsResult,assetListResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["g" /* getAssets */])(request.nodeId,request.assetType,pageToken);case 2:getAssetsResult=_context2.sent;assetListResponse=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetsResult.data.assetDetailsList;},[]);assetDeviceDetailList=assetDeviceDetailList.concat(assetListResponse);isSuccess=getAssetsResult.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(getAssetsResult.status);pageToken=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetsResult.data.pageToken;},null);case 8:case"end":return _context2.stop();}}},_callee2,_this);});case 6:return _context3.delegateYield(_loop(),"t0",7);case 7:if(pageToken){_context3.next=6;break;}case 8:// Extract data filtered by assetSubType
model=extractAdtfSubTypeInformation(assetDeviceDetailList,assetSubType);model.sorterConfig={};model.sorterTestPackageConfig={};// Fetch static asset details
// await getADTFDeviceStaticDetails(dispatcher, model, request);
// Fetch asset status details
_context3.next=13;return getAdtfDeviceStatusDetails(dispatcher,model);case 13:// Log operation
Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAdtfComponentDetails",isSuccess,isFault);case 14:case"end":return _context3.stop();}}},_callee3,this);}));return function getAdtfDeviceSubTypeDetails(_x6,_x7,_x8){return _ref2.apply(this,arguments);};}();var getAdtfDeviceDetails=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatcher,request){var model;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:model={adtfDeviceInformation:{},sorterConfig:{},sorterTestPackageConfig:{},macAddressArray:[]// Fetch static asset details
};_context4.next=3;return getADTFDeviceStaticDetails(dispatcher,model,request);case 3:_context4.next=5;return getAdtfDeviceStatusDetails(dispatcher,model);case 5:case"end":return _context4.stop();}}},_callee4,this);}));return function getAdtfDeviceDetails(_x9,_x10){return _ref3.apply(this,arguments);};}();var getAdtfDeviceStatusDetails=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatcher,model){var startTime,adtfStatusResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:// Fetch Adtf device statuses
startTime=Date.now();_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_5__resources_StatusResource__["b" /* getAdtfDeviceStatus */])(model.macAddressArray);case 3:adtfStatusResponse=_context5.sent;isSuccess=adtfStatusResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(adtfStatusResponse.status);// Merge status to model and return
if(isSuccess){mergeStatusToModel(adtfStatusResponse,model);}else{model.macAddressArray.forEach(function(mac){model.adtfDeviceInformation[mac].assetStatus=__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_109" /* LOADING_FAILED */];});}dispatcher({type:"RECEIVE_DATA",data:model});// Log operation
Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAdtfDeviceStatusDetails",isSuccess,isFault);case 9:case"end":return _context5.stop();}}},_callee5,this);}));return function getAdtfDeviceStatusDetails(_x11,_x12){return _ref4.apply(this,arguments);};}();var getADTFDeviceStaticDetails=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatcher,model,request){var pageToken,startTime,_getAssetsResult,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:pageToken=null;// do-while loop until we get a valid pageToken
case 1:startTime=Date.now();_context6.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["g" /* getAssets */])(request.nodeId,request.assetType,pageToken);case 4:_getAssetsResult=_context6.sent;isSuccess=_getAssetsResult.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(_getAssetsResult.status);// Log operation
Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAdtfDeviceDetails",isSuccess,isFault);if(isSuccess){addADTFDeviceStaticDetailsToModel(_getAssetsResult,model);// modifying pageToken to fetch from the latest get assets' result
pageToken=_getAssetsResult.data.pageToken;}else{dispatcher({type:"RECEIVE_DATA",data:[]});}case 9:if(pageToken){_context6.next=1;break;}case 10:case"end":return _context6.stop();}}},_callee6,this);}));return function getADTFDeviceStaticDetails(_x13,_x14,_x15){return _ref5.apply(this,arguments);};}();var setAssetLabelDeprecatedAdtfDeviceDetails=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatcher,request){var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:startTime=Date.now();Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetLabel,request.assetStatus).then(function(result){if(result.status===200){Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteAdtfDeviceDetails",true,false);fetchAdtfDeviceDetails(dispatcher);}else{var isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(result.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteAdtfDeviceDetails",false,isFault);dispatcher({type:"RECEIVE_DATA",data:[]});}});case 2:case"end":return _context7.stop();}}},_callee7,this);}));return function setAssetLabelDeprecatedAdtfDeviceDetails(_x16,_x17){return _ref6.apply(this,arguments);};}();var addAdtfDeviceDetails=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatcher,request,showCustomAlert,assetSubtype){var _this2=this;var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:startTime=Date.now();Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["a" /* addAsset */])(request).then(function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(result){var isFault,getAssetResult,responseSetAssetStatus,responseUpdateAsset,isFaultInUpdateAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(result.status);if(!(result.status===200)){_context9.next=5;break;}Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAdtfDeviceDetails",true,false);_context9.next=28;break;case 5:_context9.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 7:getAssetResult=_context9.sent;if(Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(getAssetResult.data.asset.assetDetails.assetStatus)){_context9.next=12;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["B" /* ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET */]);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAdtfDeviceDetails",false,isFault);return _context9.abrupt("return");case 12:_context9.next=14;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]);case 14:responseSetAssetStatus=_context9.sent;if(!(responseSetAssetStatus.status!==200)){_context9.next=19;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAdtfDeviceDetails",false,isFault);return _context9.abrupt("return");case 19:_context9.next=21;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 21:responseUpdateAsset=_context9.sent;if(!(responseUpdateAsset.status!==200)){_context9.next=27;break;}isFaultInUpdateAsset=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(responseUpdateAsset.status);showCustomAlert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAdtfDeviceDetails",false,isFaultInUpdateAsset);return _context9.abrupt("return");case 27:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAdtfDeviceDetails",true,false);case 28:refreshAdtfDeviceData(dispatcher,assetSubtype);case 29:case"end":return _context9.stop();}}},_callee9,_this2);}));return function(_x26){return _ref9.apply(this,arguments);};}());case 2:case"end":return _context10.stop();}}},_callee10,this);}));return function addAdtfDeviceDetails(_x22,_x23,_x24,_x25){return _ref8.apply(this,arguments);};}();var updateAdtfAsset=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatcher,request,showCustomAlert,assetSubtype){var setAssetStatusResponse,startTime,getAssetResult,updateAssetResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]);case 2:setAssetStatusResponse=_context11.sent;if(!(setAssetStatusResponse.status!==200)){_context11.next=7;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);_context11.next=17;break;case 7:// Update asset details
startTime=Date.now();_context11.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 10:getAssetResult=_context11.sent;_context11.next=13;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 13:updateAssetResponse=_context11.sent;isSuccess=updateAssetResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(updateAssetResponse.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAdtfDeviceDetails",isSuccess,isFault);case 17:// Refresh data regardless of success/failure
refreshAdtfDeviceData(dispatcher,assetSubtype);case 18:case"end":return _context11.stop();}}},_callee11,this);}));return function updateAdtfAsset(_x27,_x28,_x29,_x30){return _ref10.apply(this,arguments);};}();var updateAdtfMonitoringSchedule=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(dispatcher,request){var startTime,getAssetResult,updateAssetInPlaceResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:// Update asset details
startTime=Date.now();_context12.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 3:getAssetResult=_context12.sent;_context12.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["l" /* updateAssetInPlace */])(request,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.lastUpdateTime;},null));case 6:updateAssetInPlaceResponse=_context12.sent;isSuccess=updateAssetInPlaceResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(updateAssetInPlaceResponse.status);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAdtfDeviceDetails",isSuccess,isFault);fetchAdtfDeviceDetails(dispatcher);case 11:case"end":return _context12.stop();}}},_callee12,this);}));return function updateAdtfMonitoringSchedule(_x31,_x32){return _ref11.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="ADTF_DEVICE_DETAILS";function refreshAdtfDeviceData(dispatcher,assetSubtype){if(assetSubtype){fetchAdtfSubTypeDeviceDetails(dispatcher,assetSubtype);}else{fetchAdtfDeviceDetails(dispatcher);}}function fetchAdtfSubTypeDeviceDetails(dispatcher,assetSubType){var request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["e" /* ADTF_ASSET_TYPE */]};getAdtfDeviceSubTypeDetails(dispatcher,request,assetSubType);}function fetchAdtfDeviceDetails(dispatcher){var request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["e" /* ADTF_ASSET_TYPE */]};getAdtfDeviceDetails(dispatcher,request);}function fetchAdtfStatusDetails(dispatcher,model){getAdtfDeviceStatusDetails(dispatcher,model);}function deleteAdtfDeviceDetails(dispatcher,mac){var request={assetLabel:{type:"MAC_ADDRESS",value:mac},assetStatus:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_19" /* DEPRECATED */]};setAssetLabelDeprecatedAdtfDeviceDetails(dispatcher,request);}function setAdtfDeviceDetails(dispatcher,stateValues,showCustomAlert,assetSubtype){stateValues.mac=stateValues.mac.toLowerCase();var request=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["e" /* ADTF_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */],assetSubtype);addAdtfDeviceDetails(dispatcher,request,showCustomAlert,assetSubtype);}function updateAdtfDeviceDetails(dispatcher,stateValues,showCustomAlert,assetSubtype){var request=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_1__util_Constants__["e" /* ADTF_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */],assetSubtype);updateAdtfAsset(dispatcher,request,showCustomAlert,assetSubtype);}var updateAdtfDeviceMac=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher,stateValues,mac,showCustomAlert,assetSubtype){var startTime,assetLabel,assetResult,nodeId,assetStatus;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:startTime=Date.now();assetLabel=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["C" /* getAssetLabelFromMac */])(stateValues.mac.toLowerCase());_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(assetLabel);case 4:assetResult=_context.sent;nodeId=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.nodeId;},null);assetStatus=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.assetStatus;},null);if(assetStatus&&!Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(assetStatus)){showCustomAlert(Object(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_225" /* getUpdateAssetMessageAlertWithSite */])(nodeId));Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAdtfDeviceDetails",false,false);}else{deleteAdtfDeviceDetails(dispatcher,mac);setAdtfDeviceDetails(dispatcher,stateValues,showCustomAlert,assetSubtype);}case 8:case"end":return _context.stop();}}},_callee,this);}));return function updateAdtfDeviceMac(_x,_x2,_x3,_x4,_x5){return _ref.apply(this,arguments);};}();var extractAdtfSubTypeInformation=function extractAdtfSubTypeInformation(assetDeviceDetailList,assetSubType){var model={adtfDeviceInformation:{},sorterConfig:{},sorterTestPackageConfig:{},macAddressArray:[]};assetDeviceDetailList.forEach(function(adtfDeviceDetail){if(adtfDeviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]&&assetSubType===adtfDeviceDetail.assetSubType){model.macAddressArray.push(adtfDeviceDetail.assetAttributes.mac);var mac=adtfDeviceDetail.assetAttributes.mac;var id=JSON.parse(adtfDeviceDetail.assetAttributes.deviceConfig).id;model.adtfDeviceInformation[mac]={name:adtfDeviceDetail.assetAttributes.name,mac:adtfDeviceDetail.assetAttributes.mac,ip:adtfDeviceDetail.assetAttributes.ip,id:id,port:adtfDeviceDetail.assetAttributes.port,vendorAttributes:adtfDeviceDetail.vendorAttributes||__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */],assetStatus:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_110" /* LOADING_STRING */],deviceType:adtfDeviceDetail.assetAttributes.deviceType,assetType:adtfDeviceDetail.assetType,assetSubType:adtfDeviceDetail.assetSubType,startTime:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(adtfDeviceDetail.assetAttributes.monitoring).startTime;},"0"),endTime:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(adtfDeviceDetail.assetAttributes.monitoring).endTime;},"0"),reason:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(adtfDeviceDetail.assetAttributes.monitoring).reason;},"")};model.sorterTestPackageConfig[mac]=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(adtfDeviceDetail.assetAttributes.sorterTestPackage,[]);});var sorterConfig=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(adtfDeviceDetail.assetAttributes.sorterConfig);},[]);model.sorterConfig[mac]=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["u" /* flattenADTFSorterConfig */])(sorterConfig);}});return model;};var addADTFDeviceStaticDetailsToModel=function addADTFDeviceStaticDetailsToModel(result,model){if("data"in result&&"assetDetailsList"in result.data){result.data.assetDetailsList.forEach(function(adtfDeviceDetail){if(adtfDeviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_1__util_Constants__["b" /* ACTIVE */]){model.macAddressArray.push(adtfDeviceDetail.assetAttributes.mac);var mac=adtfDeviceDetail.assetAttributes.mac;var id=JSON.parse(adtfDeviceDetail.assetAttributes.deviceConfig).id;model.adtfDeviceInformation[mac]={name:adtfDeviceDetail.assetAttributes.name,mac:adtfDeviceDetail.assetAttributes.mac,ip:adtfDeviceDetail.assetAttributes.ip,id:id,port:adtfDeviceDetail.assetAttributes.port,vendorAttributes:adtfDeviceDetail.vendorAttributes||__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */],assetStatus:__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_110" /* LOADING_STRING */],deviceType:adtfDeviceDetail.assetAttributes.deviceType,assetType:adtfDeviceDetail.assetType,startTime:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(adtfDeviceDetail.assetAttributes.monitoring).startTime;},"0"),endTime:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(adtfDeviceDetail.assetAttributes.monitoring).endTime;},"0"),reason:Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(adtfDeviceDetail.assetAttributes.monitoring).reason;},"")};model.sorterTestPackageConfig[mac]=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(adtfDeviceDetail.assetAttributes.sorterTestPackage,[]);});var sorterConfig=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(adtfDeviceDetail.assetAttributes.sorterConfig);},[]);model.sorterConfig[mac]=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["u" /* flattenADTFSorterConfig */])(sorterConfig);}});}return model;};var updateAdtfConfiguration=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatcher,configurations,mac,showCustomAlert){var getAssetResult,startTime,alias,updatedAsset,updateResult,isUpdateSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 2:getAssetResult=_context8.sent;// Merge current configuration into existing configuration and update
startTime=Date.now();_context8.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["B" /* getAliasFromParent */])();case 6:alias=_context8.sent;updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_4__datamodel_AdtfAssetModelResource__["a" /* updateConfigurationsInAdtfAssetObject */])(getAssetResult.data.asset,configurations,alias);_context8.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(updatedAsset,Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 10:updateResult=_context8.sent;isUpdateSuccess=updateResult.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_17" /* isResponseCode5xx */])(updateResult.status);fetchAdtfDeviceDetails(dispatcher);// Log operation
isUpdateSuccess?showCustomAlert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["D" /* ALERT_UPDATE_SUCCESS_ASSET_MESSAGE */]):showCustomAlert(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAdtfConfiguration",isUpdateSuccess,isFault);case 16:case"end":return _context8.stop();}}},_callee8,this);}));return function updateAdtfConfiguration(_x18,_x19,_x20,_x21){return _ref7.apply(this,arguments);};}();function mergeStatusToModel(response,model){if("data"in response&&"adtfStatusList"in response.data){response.data.adtfStatusList.forEach(function(singleAdtfDeviceStatusDetail){model.adtfDeviceInformation[singleAdtfDeviceStatusDetail.mac].assetStatus=singleAdtfDeviceStatusDetail.status;});}}var updateExistingAssetAttributes=function updateExistingAssetAttributes(asset,stateValues){var updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["t" /* deepCopyObject */])(asset);updatedAsset.assetDetails.assetAttributes.monitoring=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(stateValues);},asset.assetDetails.assetAttributes.monitoring);return updatedAsset;};var updateAdtfMonitoringDetails=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(dispatcher,stateValues,mac){var getAssetResult,updatedAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 2:getAssetResult=_context13.sent;updatedAsset=updateExistingAssetAttributes(getAssetResult.data.asset,stateValues);updateAdtfMonitoringSchedule(dispatcher,updatedAsset);case 5:case"end":return _context13.stop();}}},_callee13,this);}));return function updateAdtfMonitoringDetails(_x33,_x34,_x35){return _ref12.apply(this,arguments);};}();

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateConfigurationsInAdtfAssetObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Util__ = __webpack_require__(5);
var updateConfigurationsInAdtfAssetObject=function updateConfigurationsInAdtfAssetObject(asset,configurations,alias){var updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["t" /* deepCopyObject */])(asset);updatedAsset.assetDetails.alias=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return alias.toString();},"");updatedAsset.assetDetails.assetAttributes.sorterConfig=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(configurations.sorterConfig);},"[]");updatedAsset.assetDetails.assetAttributes.sorterTestPackage=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(configurations.sorterTestPackage);},"[]");return updatedAsset;};

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_AdtfDeviceOverviewContext__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddAdtfSingleDeviceModal=function AddAdtfSingleDeviceModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__context_AdtfDeviceOverviewContext__["a" /* AdtfDeviceOverviewContext */]),viewModel=_useContext2.viewModel,dispatch=_useContext2.dispatch;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),port=_useState4[0],setPort=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["k" /* PROTOCOLS */].ADTF[0]),_useState6=_slicedToArray(_useState5,2),deviceType=_useState6[0],setDeviceType=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),name=_useState8[0],setName=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),ip=_useState10[0],setIp=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),mac=_useState12[0],setMac=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_13__util_Constants__["f" /* ADTF_DEFAULT_DEVICE_ID */]),_useState14=_slicedToArray(_useState13,2),id=_useState14[0],setId=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),vendor=_useState16[0],setVendor=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),specVersion=_useState18[0],setSpecVersion=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState20=_slicedToArray(_useState19,2),sorterType=_useState20[0],setSorterType=_useState20[1];// Error
var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),portErr=_useState22[0],setPortErr=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),deviceTypeErr=_useState24[0],setDeviceTypeErr=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),nameErr=_useState26[0],setNameErr=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),vendorErr=_useState28[0],setVendorErr=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState30=_slicedToArray(_useState29,2),specVersionErr=_useState30[0],setSpecVersionErr=_useState30[1];var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState32=_slicedToArray(_useState31,2),sorterTypeErr=_useState32[0],setSorterTypeErr=_useState32[1];var _useState33=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState34=_slicedToArray(_useState33,2),ipErr=_useState34[0],setIpErr=_useState34[1];var _useState35=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState36=_slicedToArray(_useState35,2),macErr=_useState36[0],setMacErr=_useState36[1];var _useState37=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState38=_slicedToArray(_useState37,2),idErr=_useState38[0],setIdErr=_useState38[1];var initialMonitoringValue={startTime:"0",endTime:"0",reason:""};var _useState39=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(JSON.stringify(initialMonitoringValue)),_useState40=_slicedToArray(_useState39,2),monitoring=_useState40[0],setMonitoring=_useState40[1];var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext3.showCustomAlert;var stateValues={mac:mac,ip:ip,name:name,deviceType:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["k" /* PROTOCOLS */].ADTF[0],port:port,deviceConfig:{type:__WEBPACK_IMPORTED_MODULE_11__util_Util__["e" /* assetTypeToConfigTypeDict */].typeADTF,id:id},vendorAttributes:{vendor:vendor,spec_version:specVersion,sorter_type:sorterType},monitoring:monitoring};var onCloseModal=function onCloseModal(){setOpen(false);setSelected("");resetInputState();setShowAlert(false);};var onClickConfirm=function onClickConfirm(stateValues){if(Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["R" /* validateNewAdtfDevice */])(stateValues)){showWarning(formatMessage({id:"device.editWarning"}),function(){setShowAlert(false);stateValues.deviceConfig=JSON.stringify(stateValues.deviceConfig);if(selected){stateValues.sorterConfig=JSON.stringify(viewModel.sorterConfig[stateValues.mac]);stateValues.sorterTestPackage=JSON.stringify(viewModel.sorterTestPackageConfig[stateValues.mac]);updateData(stateValues);}else{stateValues.sorterConfig="[]";stateValues.sorterTestPackage="[]";addData(stateValues);}resetInputState();setOpen(false);});}else{setShowAlert(true);}};function resetInputState(){// setting state of input fields as empty to have empty inputs on clicking Add Device again
setMac("");setMacErr(false);setMonitoring(JSON.stringify(initialMonitoringValue));resetAssetDetails();resetAssetDetailErrors();}var resetAssetDetails=function resetAssetDetails(){setIp("");setId(__WEBPACK_IMPORTED_MODULE_13__util_Constants__["f" /* ADTF_DEFAULT_DEVICE_ID */]);setPort("");setDeviceType(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["k" /* PROTOCOLS */].ADTF[0]);setName("");setVendor("");setSpecVersion("");setSorterType("");};var resetAssetDetailErrors=function resetAssetDetailErrors(){setIpErr(false);setIdErr(false);setPortErr(false);setDeviceTypeErr(false);setNameErr(false);setVendorErr(false);setSpecVersionErr(false);setSorterTypeErr(false);};var prefill=function prefill(value){if(viewModel.adtfDeviceInformation.hasOwnProperty(value)){setSelected(value);var device=viewModel.adtfDeviceInformation[value];var vendorAttributes=device.vendorAttributes;resetAssetDetailErrors();setMac(device.mac);setIp(device.ip);setId(device.id);setPort(device.port);setDeviceType(device.deviceType);setName(device.name);setVendor(vendorAttributes.vendor);setSpecVersion(vendorAttributes.spec_version);setSorterType(vendorAttributes.sorter_type);var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};setMonitoring(JSON.stringify(deviceMonitoring));}else if(selected){setSelected("");resetAssetDetails();}};var addData=function addData(stateValues){dispatch({type:'ADD_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues,showCustomAlert:showCustomAlert}});};var updateData=function updateData(stateValues){dispatch({type:'UPDATE_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues,showCustomAlert:showCustomAlert}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.add_device_button_modal"}),open:open,onOpen:function onOpen(){return prefill(selected);},onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.mac",defaultMessage:"MAC Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"mac-input",value:mac,onChange:setMac,mask:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["i" /* MAC_MASK */],disabled:selected,onBlur:function onBlur(){setMacErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.mac,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].MAC));prefill(mac);},error:macErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"ip-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.ip",defaultMessage:"IP Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"ip-input",value:ip,onChange:setIp,onBlur:function onBlur(){return setIpErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.ip,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["g" /* IP_ADDRESS_PATTERN */]));},error:ipErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"port-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.port",defaultMessage:"Port"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"port-input",value:port,onChange:setPort,onBlur:function onBlur(){return setPortErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.port,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].PORT));},error:portErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.protocol",defaultMessage:"Protocol"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"device-type-input",value:deviceType,error:deviceTypeErr,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"name-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.name",defaultMessage:"Device Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"name-input",value:name,onChange:setName,onBlur:function onBlur(){return setNameErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.name,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].NAME));},error:nameErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.name_matrix_desc'})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"id-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.device_id",defaultMessage:"Device ID"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"id-input",value:id,onChange:setId,onBlur:function onBlur(){return setIdErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.deviceConfig.id,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].DEVICE_ID));},error:idErr,helperText:"Unique local identifier for the device. Default is 1"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_select___default.a,{id:"device-type-input",value:vendor,onChange:function onChange(value){return setVendor(value);},onBlur:function onBlur(){return setVendorErr(!vendor);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_vendor'}),error:vendorErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].VENDOR).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.spec_version'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_select___default.a,{id:"device-type-input",value:specVersion,onChange:function onChange(value){return setSpecVersion(value);},onBlur:function onBlur(){return setSpecVersionErr(!specVersion);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_version'}),error:specVersionErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].SPEC_VERSION).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.sorter_type'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_select___default.a,{id:"device-type-input",value:sorterType,onChange:function onChange(value){return setSorterType(value);},onBlur:function onBlur(){return setSorterTypeErr(!sorterType);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_sorter_type'}),error:sorterTypeErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].SORTER_TYPE).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["o" /* SORTER_TYPE_DISPLAY_VALUES */][value]});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stateValues);}},selected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmEdit",defaultMessage:"Confirm edit"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddAdtfSingleDeviceModal));

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_AdtfDeviceOverviewContext__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modal_AddAdtfSorterConfigurationModal__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_arrow_right_large__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_arrow_right_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_arrow_right_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modal_DeleteAdtfSorterConfigurationModal__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_upload_small__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_upload_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_upload_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modal_AddAdtfSorterTestPackageModal__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modal_DeleteAdtfSorterTestPackageModal__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__commonui_UploadFileModal__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_Parsers__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__commonui_ConfigurationTabHeader__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__commonui_PaginatedTable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__rollback_RollbackModal__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__util_ConditionalWrapping__ = __webpack_require__(91);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var AdtfDeviceConfiguration=function AdtfDeviceConfiguration(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__context_AdtfDeviceOverviewContext__["a" /* AdtfDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_23__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext2.getDraftData,setDraftData=_useContext2.setDraftData,resetDraftData=_useContext2.resetDraftData,getFilteredDraftData=_useContext2.getFilteredDraftData,isDataEdited=_useContext2.isDataEdited;var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_31__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorized=_useContext3.isAuthorized;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),openAddModal=_useState2[0],setOpenAddModal=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openDeleteModal=_useState4[0],setOpenDeleteModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),openCSVModal=_useState6[0],setOpenCSVModal=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),valueConfiguration=_useState8[0],setValueConfiguration=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),selectedMac=_useState10[0],setSelectedMac=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),showRollbackModal=_useState12[0],setShowRollbackModal=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),isVersionsLoading=_useState14[0],setIsVersionsLoading=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),selectedVersion=_useState16[0],setSelectedVersion=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),_useState18=_slicedToArray(_useState17,2),rollBackVersions=_useState18[0],setRollbackVersions=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])("scannables"),_useState20=_slicedToArray(_useState19,2),sorterTestPackageSortColumn=_useState20[0],setSorterTestPackageSortColumn=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_22__util_Constants__["J" /* ASCENDING */]),_useState22=_slicedToArray(_useState21,2),sorterTestPackageSortOrder=_useState22[0],setSorterTestPackageSortOrder=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])("destinationId"),_useState24=_slicedToArray(_useState23,2),sorterDestinationSortColumn=_useState24[0],setSorterDestinationSortColumn=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_22__util_Constants__["J" /* ASCENDING */]),_useState26=_slicedToArray(_useState25,2),sorterDestinationSortOrder=_useState26[0],setSorterDestinationSortOrder=_useState26[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);var _useState27=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState28=_slicedToArray(_useState27,2),scannablesSearchInput=_useState28[0],setScannablesSearchInput=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState30=_slicedToArray(_useState29,2),sortZoneSearchInput=_useState30[0],setSortZoneSearchInput=_useState30[1];var _useContext4=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_30__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext4.showCustomAlert;var PAGE_CONFIGURATION_KEYS=[__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_TEST_PACKAGE,__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION];var searchDataForTestConfigTable=function searchDataForTestConfigTable(){var data=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_TEST_PACKAGE,subKey:selectedMac});data=data.filter(function(item){return Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_13" /* getTestConfigKey */])(item.scannables).toLowerCase().includes(scannablesSearchInput.toLowerCase());}).filter(function(item){return item.sortZone.toLowerCase().includes(sortZoneSearchInput.toLowerCase());});data=data.sort(function(a,b){return sortTestConfigColumns[sorterTestPackageSortColumn](a,b,sorterTestPackageSortOrder===__WEBPACK_IMPORTED_MODULE_22__util_Constants__["J" /* ASCENDING */]);});return data;};var getModalContent=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var versionsData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setIsVersionsLoading(true);_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_27__resources_AssetResource__["f" /* getAssetVersions */])(selectedMac);case 3:versionsData=_context.sent;setRollbackVersions(versionsData.data.assetVersionDetailsList);setIsVersionsLoading(false);case 6:case"end":return _context.stop();}}},_callee,_this);}));return function getModalContent(){return _ref2.apply(this,arguments);};}();var loadRollbackDataToDraft=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var rollbackData,sortTestPackageData,sorterConfigData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_27__resources_AssetResource__["e" /* getAssetByVersion */])(selectedMac,selectedVersion);case 2:rollbackData=_context2.sent;sortTestPackageData=Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.sorterTestPackage);},[]);sorterConfigData=Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.sorterConfig);},[]);if(sortTestPackageData.length){setDraftData({data:sortTestPackageData,stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_TEST_PACKAGE,subKey:selectedMac,allRowsAdded:true,override:true});}if(sorterConfigData.length){setDraftData({data:sorterConfigData,stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION,subKey:selectedMac,allRowsAdded:true,override:true});}case 7:case"end":return _context2.stop();}}},_callee2,_this);}));return function loadRollbackDataToDraft(){return _ref3.apply(this,arguments);};}();Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(!openAddModal&&!openDeleteModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["D" /* getAssetRefreshInterval */])());return function(){return clearInterval(interval);};}},[openAddModal,openDeleteModal]);Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return viewModel.sorterTestPackageConfig[selectedMac];},[]),stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_TEST_PACKAGE,subKey:selectedMac});setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return viewModel.sorterConfig[selectedMac];},[]),stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION,subKey:selectedMac});},[selectedMac]);var getSortedDeviceList=function getSortedDeviceList(){var sortedDeviceList=Object.values(viewModel.adtfDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){if(a.name<b.name){return-1;}else if(b.name>a.name){return 1;}return 0;});return sortedDeviceList;};var getData=function getData(){if(isDataEdited(PAGE_CONFIGURATION_KEYS))return;setOpenAddModal(false);setOpenDeleteModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var updateDestinationConfigDraftData=function updateDestinationConfigDraftData(sorterConfig){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return sorterConfig;},[]),stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION,subKey:selectedMac,allRowsAdded:true,override:true});};var updateTestConfigDraftData=function updateTestConfigDraftData(sorterTestPackage){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return sorterTestPackage;},[]),stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_TEST_PACKAGE,subKey:selectedMac,allRowsAdded:true,override:true});};var deployDraftADTFAsset=function deployDraftADTFAsset(){var sorterDestinationList=getFilteredDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION,subKey:selectedMac});var testPackageList=getFilteredDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_TEST_PACKAGE,subKey:selectedMac});dispatch({type:'UPDATE_ADTF_CONFIGURATION',data:{dispatcher:dispatch,showCustomAlert:showCustomAlert,configurations:{sorterTestPackage:testPackageList,sorterConfig:Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["m" /* convertADTFSorterConfigIntoDBFormat */])(sorterDestinationList)},mac:selectedMac}});setDraftData({data:sorterDestinationList,stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION,subKey:selectedMac,override:true});setDraftData({data:testPackageList,stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_TEST_PACKAGE,subKey:selectedMac,override:true});};function onClickUploadCSV(){setOpenCSVModal(true);}function onClickAddSingle(){setOpenAddModal(true);}function onClickDeleteConfiguration(){setOpenDeleteModal(true);}var getDataStringFromConfig=function getDataStringFromConfig(config){return config.installation.locations.join(' ');};var renderSorterConfigTableRow=function renderSorterConfigTableRow(config,index){var dataString=getDataStringFromConfig(config);var prevDataString=Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return getDataStringFromConfig(config.prev);},null);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:true,key:index,backgroundColor:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_148" /* OPERATION_COLOR */][config.operation]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,{spacingInset:"200 none none"},config.destinationId)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,config.sorterId),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,config.installation.type),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,null,prevDataString&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_text___default.a,null," ",prevDataString," "),prevDataString&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_text___default.a,null," ",dataString," "))));};var sortDestinationConfigColumns={destinationId:function destinationId(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.destinationId,b.destinationId):-Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.destinationId,b.destinationId);},sorterId:function sorterId(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.sorterId,b.sorterId):-Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.sorterId,b.sorterId);},installationType:function installationType(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.installation.type,b.installation.type):-Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.installation.type,b.installation.type);},location:function location(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(getDataStringFromConfig(a),getDataStringFromConfig(b)):-Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(getDataStringFromConfig(a),getDataStringFromConfig(b));}};var sortTestConfigColumns={scannables:function scannables(a,b,ascending){var scannableFirst=Array.isArray(a.scannables)?a.scannables.join(' '):a.scannables;var scannableSecond=Array.isArray(b.scannables)?b.scannables.join(' '):b.scannables;return ascending?Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(scannableFirst,scannableSecond):-Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(scannableFirst,scannableSecond);},sortZone:function sortZone(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.sortZone,b.sortZone):-Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.sortZone,b.sortZone);}};var renderSorterConfigTableHeader=function renderSorterConfigTableHeader(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"destinationId"},"Destination Id"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"sorterId"},"Sorter Id"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"installationType"},"Installation Type"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"location"},"Locations"));};var getHeaderProps=function getHeaderProps(){return{selectedMac:selectedMac,setSelectedMac:setSelectedMac,valueConfiguration:valueConfiguration,setValueConfiguration:setValueConfiguration,isSorterConfig:valueConfiguration===__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION,isAuthorized:isAuthorized,intl:intl,defaultSelection:"",resetDraftData:resetDraftData,deployDraft:deployDraftADTFAsset,scrollToBottom:scrollToBottom,sortedDeviceList:getSortedDeviceList(),configurationKeys:PAGE_CONFIGURATION_KEYS,refreshDeps:[viewModel.timestamp],isDeployDisabled:!isDataEdited(PAGE_CONFIGURATION_KEYS),isRollbackDisabled:!selectedMac||isDataEdited(PAGE_CONFIGURATION_KEYS),rollbackClickHandler:function rollbackClickHandler(){getModalContent();setShowRollbackModal(true);}};};var renderTestConfigTableHeader=function renderTestConfigTableHeader(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.index",defaultMessage:"Index"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"scannables"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.scannables",defaultMessage:"Scannables"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"sortZone"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.sortzone",defaultMessage:"Sort Zone"})));};var renderTestConfigTableRow=function renderTestConfigTableRow(config,serialNumber){var dataString=config.sortZone;var prevDataString=Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return config.prev.sortZone;},null);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:true,backgroundColor:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_148" /* OPERATION_COLOR */][config.operation]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,serialNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,Array.isArray(config.scannables)?config.scannables.join(' '):config.scannables),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,prevDataString&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_text___default.a,null," ",prevDataString," "),prevDataString&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_text___default.a,null," ",dataString," ")));};var renderSearchRow=function renderSearchRow(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{backgroundColor:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_177" /* SEARCH_ROW_COLOR */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_input___default.a,{className:"input-search-class",value:scannablesSearchInput,onChange:setScannablesSearchInput,type:"text",placeholder:"Search",width:"70%",size:"small"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_input___default.a,{className:"input-search-class",value:sortZoneSearchInput,onChange:setSortZoneSearchInput,type:"text",placeholder:"Search",width:"70%",size:"small"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null));};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__commonui_ConfigurationTabHeader__["a" /* default */],getHeaderProps()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__rollback_RollbackModal__["a" /* default */],{showRollbackModal:showRollbackModal,setShowRollbackModal:setShowRollbackModal,isVersionsLoading:isVersionsLoading,selectedVersion:selectedVersion,setSelectedVersion:setSelectedVersion,rollBackVersions:rollBackVersions,loadRollbackDataToDraft:loadRollbackDataToDraft,intl:intl}),valueConfiguration===__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION&&selectedMac&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__commonui_PaginatedTable__["a" /* default */],{data:getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION,subKey:selectedMac}).sort(function(a,b){return sortDestinationConfigColumns[sorterDestinationSortColumn](a,b,sorterDestinationSortOrder===__WEBPACK_IMPORTED_MODULE_22__util_Constants__["J" /* ASCENDING */]);}),renderRow:renderSorterConfigTableRow,renderHeader:renderSorterConfigTableHeader,sortColumn:sorterDestinationSortColumn,sortDirection:sorterDestinationSortOrder,onSort:function onSort(_ref4){var sortColumn=_ref4.sortColumn,sortDirection=_ref4.sortDirection;setSorterDestinationSortColumn(sortColumn);setSorterDestinationSortOrder(sortDirection);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",widths:["100","100","fill","100"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_33__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_32__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"top"},child:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{onClick:onClickAddSingle,type:"primary",size:"small",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"sorterconfig.addupdate",defaultMessage:"Add/Update Sorter Destination Configuration"}))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_33__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_32__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"top"},child:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{onClick:onClickUploadCSV,type:"primary",size:"small",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_upload_small___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"sorterconfig.uploadCSV",defaultMessage:"Upload Sorter Destination Configuration CSV"}))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__util_ConditionalWrapping__["a" /* ConditionalWrapping */],{condition:!isAuthorized,wrapper:__WEBPACK_IMPORTED_MODULE_33__util_ConditionalWrapping__["b" /* tooltipWrapper */],args:{title:Object(__WEBPACK_IMPORTED_MODULE_32__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}),position:"top"},child:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{onClick:onClickDeleteConfiguration,size:"small",type:"tertiary",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"config.delete",defaultMessage:"Delete Configuration"}))})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__commonui_UploadFileModal__["a" /* default */],{mac:selectedMac,open:openCSVModal,setOpen:setOpenCSVModal,parser:__WEBPACK_IMPORTED_MODULE_21__util_Parsers__["a" /* ADTFSorterConfigCSVParser */],updateConfig:updateDestinationConfigDraftData}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__modal_AddAdtfSorterConfigurationModal__["a" /* default */],{mac:selectedMac,open:openAddModal,setOpen:setOpenAddModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__modal_DeleteAdtfSorterConfigurationModal__["a" /* default */],{mac:selectedMac,open:openDeleteModal,setOpen:setOpenDeleteModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{ref:tableEndRef})),valueConfiguration===__WEBPACK_IMPORTED_MODULE_22__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_TEST_PACKAGE&&selectedMac&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__commonui_PaginatedTable__["a" /* default */],{data:searchDataForTestConfigTable(),renderRow:renderTestConfigTableRow,renderHeader:renderTestConfigTableHeader,renderSearchRow:renderSearchRow,sortColumn:sorterTestPackageSortColumn,sortDirection:sorterTestPackageSortOrder,onSort:function onSort(_ref5){var sortColumn=_ref5.sortColumn,sortDirection=_ref5.sortDirection;setSorterTestPackageSortColumn(sortColumn);setSorterTestPackageSortOrder(sortDirection);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",widths:["100","100","fill","100"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{onClick:onClickAddSingle,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"sortertestconfig.addupdatetest",defaultMessage:"Add/Update Sorter Test Package Configuration"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{onClick:onClickUploadCSV,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_upload_small___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"sortertestconfig.uploadCSV",defaultMessage:"Upload Sorter Test Package Configuration CSV"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{onClick:onClickDeleteConfiguration,size:"small",type:"tertiary"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"config.deletetest",defaultMessage:"Delete Sorter Test Package Configuration"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__commonui_UploadFileModal__["a" /* default */],{mac:selectedMac,open:openCSVModal,setOpen:setOpenCSVModal,parser:__WEBPACK_IMPORTED_MODULE_21__util_Parsers__["k" /* TestConfigCSVParser */],updateConfig:updateTestConfigDraftData}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__modal_AddAdtfSorterTestPackageModal__["a" /* default */],{mac:selectedMac,open:openAddModal,setOpen:setOpenAddModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__modal_DeleteAdtfSorterTestPackageModal__["a" /* default */],{mac:selectedMac,open:openDeleteModal,setOpen:setOpenDeleteModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AdtfDeviceConfiguration));

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_FeatureUtility__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddAdtfSorterConfigurationModal=function AddAdtfSorterConfigurationModal(props){var intl=props.intl;var formatMessage=intl.formatMessage;var mac=props.mac;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,addInstance=_useContext.addInstance,editInstance=_useContext.editInstance;// Temporarily added MISS in order to maintain parity between backend and frontend.
// Should be removed in long-term, refer: https://t.corp.amazon.com/D219308494
var ADTF_INSTALLATION_TYPES=Object.assign({},__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_84" /* INSTALLATION_TYPES */],{MISS:{label:"Miss",value:"miss"}// Stow Station diversion (Dual Stow Operation) is behind a feature flag; hide the option until enabled.
});if(!__WEBPACK_IMPORTED_MODULE_14__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_14__util_FeatureUtility__["a" /* FEATURES */].IS_STOW_STATION_INSTALLATION_TYPE_ENABLED)){delete ADTF_INSTALLATION_TYPES.STOW_STATION;}// Visual controls
var open=props.open,setOpen=props.setOpen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),show=_useState2[0],setShow=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),edit=_useState4[0],setEdit=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState6=_slicedToArray(_useState5,2),showLocation=_useState6[0],setShowLocation=_useState6[1];// Values
var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),locations=_useState8[0],setLocations=_useState8[1];// For stow station, the location is entered as a cluster + tier pair (e.g. "A#2")
// instead of a free-form text box. These drive the `locations` string when type is stow station.
var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),cluster=_useState10[0],setCluster=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),tier=_useState12[0],setTier=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),type=_useState14[0],setType=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),destinationId=_useState16[0],setDestinationId=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),sorterId=_useState18[0],setSorterId=_useState18[1];// Error
var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState20=_slicedToArray(_useState19,2),locationsErr=_useState20[0],setLocationsErr=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),typeErr=_useState22[0],setTypeErr=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),destinationIdErr=_useState24[0],setDestinationIdErr=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),sorterIdErr=_useState26[0],setSorterIdErr=_useState26[1];var onCloseModal=function onCloseModal(){setShow(false);setOpen(false);resetInputState();};var isStowStation=type===__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_84" /* INSTALLATION_TYPES */].STOW_STATION.value;// For stow station, the location string is a single cluster#tier pair built from the
// cluster text box and tier dropdown. For all other types it is the free-form text box.
var effectiveLocations=isStowStation?cluster&&tier?cluster+"#"+tier:"":locations;var modalSorterConfig={destinationId:destinationId,sorterId:sorterId,installation:{type:type,locations:effectiveLocations}/* Filling a map: sorterConfigMap with destinationId as key in case of an update of existing asset */};var sorterConfigMap={};getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION,subKey:mac}).forEach(function(value){var key=Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["y" /* getADTFSorterConfigKey */])(value.sorterId,value.destinationId,value.installation.type);sorterConfigMap[key]={locations:value.installation.locations,sorterId:value.sorterId,type:value.type};});var onClickConfirm=function onClickConfirm(modalSorterConfig,mac){if(Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["x" /* checkModalValidationsForConfig */])(modalSorterConfig,mac,__WEBPACK_IMPORTED_MODULE_10__util_Constants__["e" /* ADTF_ASSET_TYPE */])){setConfigData(modalSorterConfig,mac);setOpen(false);resetInputState();setShow(false);}else{setShow(true);}};function resetInputState(){setDestinationId("");setSorterId("");setDestinationIdErr(false);setSorterIdErr(false);setType("");setTypeErr(false);resetConfigDetails();resetConfigErrorDetails();}var resetConfigDetails=function resetConfigDetails(){setLocations("");setCluster("");setTier("");setShowLocation(true);};var resetConfigErrorDetails=function resetConfigErrorDetails(){setTypeErr(false);setLocationsErr(false);};var processType=function processType(type){if(type==='miss'||type==='jackpot'||type==='ov'||type===__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_84" /* INSTALLATION_TYPES */].FRAGILE.value){setShowLocation(false);}else{setShowLocation(true);}};var prefill=function prefill(){var key=Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["y" /* getADTFSorterConfigKey */])(sorterId,destinationId,type);if(sorterConfigMap.hasOwnProperty(key)){setEdit(true);resetConfigErrorDetails();var locationString=Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["_9" /* getSorterConfigLocationStringForm */])(sorterConfigMap[key].locations);setLocations(locationString);// For stow station, split the "cluster#tier" pair back into the dropdown fields.
if(type===__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_84" /* INSTALLATION_TYPES */].STOW_STATION.value){var _split=(locationString||"").split("#"),_split2=_slicedToArray(_split,2),prefillCluster=_split2[0],prefillTier=_split2[1];setCluster(prefillCluster||"");setTier(prefillTier||"");}}else if(edit){setEdit(false);resetConfigDetails();}};var setConfigData=function setConfigData(modalSorterConfig,mac){if(modalSorterConfig.installation.locations){modalSorterConfig.installation.locations=modalSorterConfig.installation.locations.replace(/\s/g,'').split(';').filter(Boolean);}else{modalSorterConfig.installation.locations=[];}/* sorter config are stored and passed as map with destinationId as key */if(edit){editInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION,subKey:mac,instance:modalSorterConfig,keyComparator:function keyComparator(config1,config2){return Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["y" /* getADTFSorterConfigKey */])(config1.sorterId,config1.destinationId,config1.installation.type)===Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["y" /* getADTFSorterConfigKey */])(config2.sorterId,config2.destinationId,config2.installation.type);},valueComparator:function valueComparator(config1,config2){return JSON.stringify(config1.sorterId)===JSON.stringify(config2.sorterId)&&JSON.stringify(config1.installation.locations)===JSON.stringify(config2.installation.locations);}});}else{addInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION,subKey:mac,instance:modalSorterConfig});}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"sorterconfig.addupdate"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.addheading",defaultMessage:"To edit an existing configuration, enter the Destination Id."}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.destinationid",defaultMessage:"Destination ID"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"destination-id-input",value:destinationId,onChange:setDestinationId,onBlur:function onBlur(){prefill();},error:destinationIdErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.sorterId",defaultMessage:"Sorter ID"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"sorter-id-input",value:sorterId,onChange:setSorterId,onBlur:function onBlur(){prefill();},error:sorterIdErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.installationtype",defaultMessage:"Installation Type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default.a,{id:"type-input",value:type,onChange:setType,onBlur:function onBlur(){processType(type);prefill();},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.enter_value",defaultMessage:"Enter value..."}),width:"100%",error:typeErr},Object.values(ADTF_INSTALLATION_TYPES).map(function(_ref,index){var label=_ref.label,value=_ref.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__["SelectOption"],{key:index,value:value,label:label});}))),showLocation&&(isStowStation?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{spacing:"large",alignmentVertical:"top",widths:["fill","fill"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"cluster-input"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cluster"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"cluster-input",value:cluster,onChange:setCluster,onBlur:function onBlur(){return setLocationsErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(effectiveLocations,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].STOW_STATION_LOCATION));},error:locationsErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"tier-input"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.tier"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default.a,{id:"tier-input",value:tier,onChange:setTier,onBlur:function onBlur(){return setLocationsErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(effectiveLocations,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].STOW_STATION_LOCATION));},placeholder:Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.enter_value"}),width:"100%",error:locationsErr},__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_193" /* STOW_STATION_TIERS */].map(function(_ref2){var label=_ref2.label,value=_ref2.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:label});})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.location",defaultMessage:"Locations"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"location-input",value:locations,onChange:setLocations,onBlur:function onBlur(){setLocationsErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(locations,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].LOCATION));},error:locationsErr,helperText:"Cluster can have values like: A, B, C..."})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["x" /* checkModalValidationsForConfig */])(modalSorterConfig,mac,__WEBPACK_IMPORTED_MODULE_10__util_Constants__["e" /* ADTF_ASSET_TYPE */])&&show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(modalSorterConfig,mac);}},edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmUpdate",defaultMessage:"Confirm update"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddAdtfSorterConfigurationModal));

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var DeleteAdtfSorterConfigurationModal=function DeleteAdtfSorterConfigurationModal(props){var formatMessage=props.intl.formatMessage;var mac=props.mac;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,deleteInstance=_useContext.deleteInstance,deleteAll=_useContext.deleteAll;var open=props.open,setOpen=props.setOpen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),destinationId=_useState2[0],setDestinationId=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),sorterId=_useState4[0],setSorterId=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),destinationIdSearchQuery=_useState6[0],setDestinationIdSearchQuery=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),sorterIdSearchQuery=_useState8[0],setSorterIdSearchQuery=_useState8[1];var onCloseModal=function onCloseModal(){setOpen(false);resetInputState();};var stateValues={destinationId:destinationId,sorterId:sorterId,mac:mac};var sorterConfig=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION,subKey:mac});var destinationIdList=sorterConfig.map(function(_ref){var destinationId=_ref.destinationId;return destinationId;});var sorterIdList=sorterConfig.map(function(_ref2){var sorterId=_ref2.sorterId;return sorterId;});var destinationIdSearchRegExp=new RegExp(__WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp___default()(destinationIdSearchQuery),"i");var sorterIdSearchRegExp=new RegExp(__WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp___default()(sorterIdSearchQuery),"i");// Converting to set to remove non-unique destination ids from DDB form
destinationIdList=[].concat(_toConsumableArray(new Set(destinationIdList.filter(function(option){return!destinationIdSearchQuery||destinationIdSearchRegExp.test(option);}))));sorterIdList=[].concat(_toConsumableArray(new Set(sorterIdList.filter(function(option){return!sorterIdSearchQuery||sorterIdSearchRegExp.test(option);}))));var onClickConfirm=function onClickConfirm(stateValues){deleteData(stateValues);setOpen(false);resetInputState();};function resetInputState(){setDestinationId("");}var deleteData=function deleteData(stateValues){deleteInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION,subKey:stateValues.mac,keyComparator:function keyComparator(instance){return instance.destinationId===stateValues.destinationId&&instance.sorterId===stateValues.sorterId;}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.delete_config_button_modal"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},"Please select the Destination Id and Sorter Id you would like to remove:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default.a,{value:destinationId,onChange:setDestinationId,searchQuery:destinationIdSearchQuery,onSearch:setDestinationIdSearchQuery,placeholder:"Select destination ID",width:"100%"},destinationIdList.map(function(destinationId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__["SelectOption"],{key:destinationId,value:destinationId,label:destinationId});}),!destinationIdList.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},destinationIdList?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," No matching destination IDs "):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," No destination IDs available ")):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default.a,{value:sorterId,onChange:setSorterId,searchQuery:sorterIdSearchQuery,onSearch:setSorterIdSearchQuery,placeholder:"Select sorter ID",width:"100%"},sorterIdList.map(function(sorterId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__["SelectOption"],{key:sorterId,value:sorterId,label:sorterId});}),!sorterIdList.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},destinationIdList?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," No matching sorter IDs "):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," No sorter IDs available ")):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{size:"small",className:"redBtn",onClick:function onClick(){deleteAll({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_DESTINATION,subKey:stateValues.mac});onCloseModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.deleteAll",defaultMessage:"Delete All"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"secondary",size:"small",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:function onClick(){return onClickConfirm(stateValues);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.confirm",defaultMessage:"Confirm"})))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(DeleteAdtfSorterConfigurationModal));

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_Util__ = __webpack_require__(5);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddAdtfSorterTestPackageModal=function AddAdtfSorterTestPackageModal(props){var formatMessage=props.intl.formatMessage;var mac=props.mac;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,addInstance=_useContext.addInstance,editInstance=_useContext.editInstance;// Visual controls
var open=props.open,setOpen=props.setOpen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),show=_useState2[0],setShow=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),edit=_useState4[0],setEdit=_useState4[1];// Values
var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),scannables=_useState6[0],setScannables=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),sortZone=_useState8[0],setSortZone=_useState8[1];// Error
var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),scannablesErr=_useState10[0],setScannablesErr=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),sortZoneErr=_useState12[0],setSortZoneErr=_useState12[1];function onCloseModal(){setShow(false);setOpen(false);resetInputState();}var sorterTestPackage={scannables:scannables.split(';').filter(Boolean),sortZone:sortZone};var testConfigMap={};getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_TEST_PACKAGE,subKey:mac}).forEach(function(value){var key=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_13" /* getTestConfigKey */])(value.scannables);testConfigMap[key]={sortZone:value.sortZone};});var onClickConfirm=function onClickConfirm(sorterTestPackage,mac){if(Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["z" /* checkModalValidationsForTestPackage */])(sorterTestPackage)){setConfigData(sorterTestPackage,mac);setOpen(false);resetInputState();setShow(false);}else{setShow(true);}};var prefill=function prefill(){var key=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_13" /* getTestConfigKey */])(sorterTestPackage.scannables);if(testConfigMap.hasOwnProperty(key)){setEdit(true);resetConfigErrorDetails();setSortZone(testConfigMap[key].sortZone);}else if(edit){setEdit(false);resetConfigDetails();}};function resetInputState(){setScannables("");resetConfigDetails();resetConfigErrorDetails();}var resetConfigDetails=function resetConfigDetails(){setSortZone("");};var resetConfigErrorDetails=function resetConfigErrorDetails(){setSortZoneErr(false);};var setConfigData=function setConfigData(sorterTestPackage,mac){if(edit){editInstance({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_TEST_PACKAGE,subKey:mac,instance:sorterTestPackage,keyComparator:function keyComparator(config1,config2){return Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_13" /* getTestConfigKey */])(config1.scannables)===Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_13" /* getTestConfigKey */])(config2.scannables);},valueComparator:function valueComparator(config1,config2){return config1.sortZone===config2.sortZone;}});}else{addInstance({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_TEST_PACKAGE,subKey:mac,instance:sorterTestPackage});}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"sortertestconfig.addupdatetest"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.addheadingtest",defaultMessage:"To edit an existing configuration, enter its Sort Zone."}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.scannables",defaultMessage:"Scannables"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"scannables-input",value:scannables,onChange:function onChange(value){setScannables(value.replace(/\s/g,''));},onBlur:function onBlur(){setScannablesErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(scannables,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].TEST_SCANNABLE));prefill();},error:scannablesErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.scannables_description",defaultMessage:"Tracking/Shipment ID. Separate multiple values by semicolon (;)"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.sortzone",defaultMessage:"Sort Zone"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"sort-zone-input",value:sortZone,onChange:setSortZone,onBlur:function onBlur(){setSortZoneErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(sortZone,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].SORT_ZONE));},error:sortZoneErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"bay.sortzone_description",defaultMessage:"eg. EU: A1-1A, NA: A-1.1A"})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["z" /* checkModalValidationsForTestPackage */])(sorterTestPackage)&&show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(sorterTestPackage,mac);}},edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmUpdate",defaultMessage:"Confirm update"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddAdtfSorterTestPackageModal));

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_trash__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DeleteAdtfSorterTestPackageModal=function DeleteAdtfSorterTestPackageModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,mac=props.mac;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,deleteInstance=_useContext.deleteInstance,deleteAll=_useContext.deleteAll;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),selectedScannables=_useState2[0],setSelectedScannables=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),searchQuery=_useState4[0],setSearchQuery=_useState4[1];var onCloseModal=function onCloseModal(){setOpen(false);resetInputState();};var scannableKeyList=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_TEST_PACKAGE,subKey:mac}).map(function(_ref){var scannables=_ref.scannables;return Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_13" /* getTestConfigKey */])(scannables);});var searchRegExp=new RegExp(__WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp___default()(searchQuery),"i");var matchedKeys=scannableKeyList.filter(function(option){return!searchQuery||searchRegExp.test(option);});var onClickConfirm=function onClickConfirm(){deleteData();setOpen(false);resetInputState();};function resetInputState(){setSelectedScannables("");}var deleteData=function deleteData(){deleteInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_TEST_PACKAGE,subKey:mac,keyComparator:function keyComparator(instance){return Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_13" /* getTestConfigKey */])(instance.scannables)===selectedScannables;}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default.a,{title:formatMessage({id:"config.deletetest"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.sortzonedelete",defaultMessage:"Please select the scannable you would like to remove."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default.a,{value:selectedScannables,onChange:setSelectedScannables,searchQuery:searchQuery,onSearch:setSearchQuery,placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"sortertestconfig.delete",defaultMessage:"Select test package to be deleted."}),width:"100%"},matchedKeys.map(function(scannable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__["SelectOption"],{key:scannable,value:scannable,label:scannable});}),!matchedKeys.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},scannableKeyList?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"sortertestconfig.nomatch",defaultMessage:"No matching test packages"}),"  "):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"sortertestconfig.notavailable",defaultMessage:"No test packages available"})," ")):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{size:"small",className:"redBtn",onClick:function onClick(){deleteAll({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].ADTF_SORTER_TEST_PACKAGE,subKey:mac});onCloseModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.deleteAll",defaultMessage:"Delete All"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"secondary",size:"small",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:onClickConfirm},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"modal.confirm",defaultMessage:"Confirm"})))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(DeleteAdtfSorterTestPackageModal));

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AdtfDeviceOverviewContext__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Constants__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var AdtfMatrixPage=function(_Component){_inherits(AdtfMatrixPage,_Component);function AdtfMatrixPage(){_classCallCheck(this,AdtfMatrixPage);return _possibleConstructorReturn(this,(AdtfMatrixPage.__proto__||Object.getPrototypeOf(AdtfMatrixPage)).apply(this,arguments));}_createClass(AdtfMatrixPage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_AdtfDeviceOverviewContext__["b" /* default */],{data:{assetSubtype:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["g" /* ADTF_MATRIX */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["c" /* ADTF_MATRIX_ROUTE */],location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["c" /* ADTF_MATRIX_ROUTE */]})));}}]);return AdtfMatrixPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AdtfMatrixPage);

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_AdtfDeviceOverviewContext__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonui_CommonDeviceLogstream__ = __webpack_require__(102);
var AdtfDeviceLogstream=function AdtfDeviceLogstream(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__context_AdtfDeviceOverviewContext__["a" /* AdtfDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var deviceList=Object.values(viewModel.adtfDeviceInformation);var props={protocols:__WEBPACK_IMPORTED_MODULE_3__util_Validations__["k" /* PROTOCOLS */].ADTF,dispatch:dispatch,deviceList:deviceList,deviceType:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["e" /* ADTF_ASSET_TYPE */],intl:intl};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonui_CommonDeviceLogstream__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(AdtfDeviceLogstream));

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AdtaDeviceOverviewContext__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_mheValidation_ValidationTabBody__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mhevalidation_context_MHEValidationContext__ = __webpack_require__(180);
var AdtaDeviceValidation=function AdtaDeviceValidation(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_AdtaDeviceOverviewContext__["a" /* AdtaDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var deviceList=Object.values(viewModel.adtaDeviceInformation);var props={dispatch:dispatch,deviceList:deviceList,intl:intl};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__mhevalidation_context_MHEValidationContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_mheValidation_ValidationTabBody__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(AdtaDeviceValidation));

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Localization__ = __webpack_require__(14);
var renderDeviceSelectionRow=function renderDeviceSelectionRow(props){var selectedMac=props.selectedMac,setSelectedMac=props.setSelectedMac,deviceList=props.deviceList,setOpenTriggerValidationModal=props.setOpenTriggerValidationModal,intl=props.intl;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_box___default.a,{type:"fill",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",widths:["fill",'30%'],spacing:"400"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'devicename.title'})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select___default.a,{value:selectedMac,onChange:setSelectedMac,placeholder:Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'devicename.title'}),size:"small",width:250},deviceList.map(function(device){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_select__["SelectOption"],{key:device.mac,value:device.mac,label:device.name+" ("+device.mac+")"});}),!deviceList.length&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default.a,{alignment:"center"},Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'modal.no_device_available'}))))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__amzn_meridian_row___default.a,{alignmentHorizontal:"end"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{size:"small",disabled:!selectedMac,onClick:function onClick(){return setOpenTriggerValidationModal(true);}},Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'mhevalidation.newvalidation'})))));};var MHEValidationTabHeader=function MHEValidationTabHeader(props){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_column___default.a,null,renderDeviceSelectionRow(Object.assign({},props)));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(MHEValidationTabHeader));

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_date_picker__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_time_picker__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_addDays__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_textarea__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_Constants__ = __webpack_require__(2);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var NewValidationModal=function NewValidationModal(props){var dispatch=props.dispatch,selectedDevice=props.selectedDevice,intl=props.intl,locale=props.locale;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_15__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext.showCustomAlert;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),valueDateFrom=_useState2[0],setValueDateFrom=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),valueTimeFrom=_useState4[0],setValueTimeFrom=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),valueDateTo=_useState6[0],setValueDateTo=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),valueTimeTo=_useState8[0],setValueTimeTo=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),remarks=_useState10[0],setRemarks=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),showWarning=_useState12[0],setShowWarning=_useState12[1];var yesterday=Object(__WEBPACK_IMPORTED_MODULE_14__util_Util__["K" /* getDateInIsoFormat */])(Object(__WEBPACK_IMPORTED_MODULE_12_date_fns_addDays__["default"])(new Date(),-1));var today=Object(__WEBPACK_IMPORTED_MODULE_14__util_Util__["K" /* getDateInIsoFormat */])(new Date());var onCloseModal=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function(){return props.onStateChange(false);},[]);function onClickCancel(){setShowWarning(false);props.onStateChange(false);setInputState();}var stateValues={"startTime":Date.parse(Object(__WEBPACK_IMPORTED_MODULE_14__util_Util__["v" /* formatDate */])(valueDateFrom)+" "+valueTimeFrom+__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_217" /* UTC_TIMEZONE_OFFSET_STRING */]),"endTime":Date.parse(Object(__WEBPACK_IMPORTED_MODULE_14__util_Util__["v" /* formatDate */])(valueDateTo)+" "+valueTimeTo+__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_217" /* UTC_TIMEZONE_OFFSET_STRING */]),"remarks":remarks};var dateTimeInput={"valueDateFrom":valueDateFrom,"valueDateTo":valueDateTo,"valueTimeFrom":valueTimeFrom,"valueTimeTo":valueTimeTo};var triggerMHEValidation=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(stateValues){var triggerData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setShowWarning(true);if(Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["A" /* checkModalValidationsForTriggeringMHEValidation */])(stateValues,dateTimeInput)){triggerData={"nodeId":Object(__WEBPACK_IMPORTED_MODULE_14__util_Util__["X" /* getNodeId */])(),"macAddress":selectedDevice.mac,"startTime":stateValues.startTime,"endTime":stateValues.endTime,"validationAttributes":{"remarks":stateValues.remarks},"assetType":selectedDevice.assetType,"assetSubType":selectedDevice.assetSubType,"deviceType":selectedDevice.deviceType,"deviceName":selectedDevice.name};dispatch({type:"TRIGGER_VALIDATION",data:{triggerData:triggerData,dispatcher:dispatch,showCustomAlert:showCustomAlert}});props.onStateChange(false);setShowWarning(false);setInputState();}case 2:case"end":return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}());function setInputState(){// setting state of input fields as empty to have empty inputs on clicking Add Device again
setValueDateFrom("");setValueTimeFrom("");setValueTimeTo("");setValueDateTo("");setRemarks("");}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal___default.a,{title:"New Validation",open:props.state,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.validationstart"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_date_picker___default.a,{value:valueDateFrom,onChange:setValueDateFrom,label:"Date",presets:[{label:"Yesterday",value:yesterday},{label:"Today",value:today}],monthsInView:1,locale:locale}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_time_picker___default.a,{placeholder:Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"timepicker.placeholder"}),value:valueTimeFrom,onChange:setValueTimeFrom,invalidInputMessage:Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"timepicker.invalidinput"}),width:300,format:{hourCycle:"h23",hour:"2-digit",minute:"2-digit"},showIcon:false,label:Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"timepicker.label"})}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.validationend"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_date_picker___default.a,{value:valueDateTo,onChange:setValueDateTo,label:"Date",presets:[{label:"Yesterday",value:yesterday},{label:"Today",value:today}],monthsInView:1,locale:locale}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_time_picker___default.a,{placeholder:Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"timepicker.placeholder"}),value:valueTimeTo,onChange:setValueTimeTo,invalidInputMessage:Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"timepicker.invalidinput"}),width:300,format:{hourCycle:"h23",hour:"2-digit",minute:"2-digit"},showIcon:false,label:Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"timepicker.label"})}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.validationremarks"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_textarea___default.a,{id:"my-input",value:remarks,onChange:setRemarks,type:"text"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["J" /* isFromAndToDateTimeEntered */])(dateTimeInput)&&showWarning&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.timenotentered"})),Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["K" /* isStartTimeLaterThanEndTime */])(stateValues)&&showWarning&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.time"})),Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["I" /* isDurationMoreThanTwelveHours */])(stateValues)&&showWarning&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.longduration"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onClickCancel},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cancel"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return triggerMHEValidation(stateValues);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirm"}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(NewValidationModal));

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MHEValidationReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_MHEValidationNetworkAPI__ = __webpack_require__(1315);
var MHEValidationReducer=function MHEValidationReducer(state,action){switch(action.type){case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingValidationDetails:false});case"LOAD_VIEW":Object(__WEBPACK_IMPORTED_MODULE_0__network_MHEValidationNetworkAPI__["a" /* fetchMheValidationDetails */])(action.data.dispatcher,action.data.macAddress);return state;case"TRIGGER_VALIDATION":Object(__WEBPACK_IMPORTED_MODULE_0__network_MHEValidationNetworkAPI__["c" /* triggerMheValidationDetails */])(action.data.dispatcher,action.data.triggerData,action.data.showCustomAlert);return state;case"GET_PRESIGNED_URL":Object(__WEBPACK_IMPORTED_MODULE_0__network_MHEValidationNetworkAPI__["b" /* getPresignedURL */])(action.data.dispatcher,action.data.objectKey,action.data.showCustomAlert);return state;default:return state;}};

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchMheValidationDetails;
/* harmony export (immutable) */ __webpack_exports__["c"] = triggerMheValidationDetails;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPresignedURL;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_MHEValidationResource__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Constants__ = __webpack_require__(2);
var getMHEValidationDetails=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher,request){var startTime,response,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:startTime=Date.now();_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_MHEValidationResource__["a" /* getMHEValidations */])(request.macAddress);case 3:response=_context.sent;isSuccess=response.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);// Log operation
Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getMHEValidationData",isSuccess,isFault);if(response.data){// return data to page
dispatcher({type:"RECEIVE_DATA",data:{mheValidationInformation:response.data}});}else{dispatcher({type:"RECEIVE_DATA",data:{mheValidationInformation:{mheValidationInstanceList:[]}}});}case 8:case"end":return _context.stop();}}},_callee,this);}));return function getMHEValidationDetails(_x,_x2){return _ref.apply(this,arguments);};}();var triggerMHEValidation=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatcher,request,showCustomAlert){var startTime,response,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_30" /* setAliasToTriggerMHEValidationRequest */])(request);case 2:startTime=Date.now();_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_MHEValidationResource__["c" /* triggerMHEValidations */])(request.triggerData);case 5:response=_context2.sent;isSuccess=response.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);if(isFault){showCustomAlert(__WEBPACK_IMPORTED_MODULE_3__util_Constants__["t" /* ALERT_MHE_VALIDATION_FAILED_MESSAGE */],__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_122" /* MERIDIAN_ALERT_TYPE */].ERROR);}// Log operation
Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"triggerMHEValidationData",isSuccess,isFault);fetchMheValidationDetails(dispatcher,request.triggerData.macAddress);case 11:case"end":return _context2.stop();}}},_callee2,this);}));return function triggerMHEValidation(_x3,_x4,_x5){return _ref2.apply(this,arguments);};}();var getPresignedURLdata=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatcher,objectKey,showCustomAlert){var startTime,response,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:startTime=Date.now();_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__resources_MHEValidationResource__["b" /* getPresignedURLcall */])(objectKey);case 3:response=_context3.sent;isSuccess=response.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);// Log operation
Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getPresignedUrl",isSuccess,isFault);if(isSuccess&&response.data&&response.data.presignedUrl){window.open(response.data.presignedUrl,"_self");}if(isFault){showCustomAlert(__WEBPACK_IMPORTED_MODULE_3__util_Constants__["u" /* ALERT_MHE_VALIDATION_REPORT_DOES_NOT_EXIST */],__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_122" /* MERIDIAN_ALERT_TYPE */].ERROR);}case 9:case"end":return _context3.stop();}}},_callee3,this);}));return function getPresignedURLdata(_x6,_x7,_x8){return _ref3.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="MHE_VALIDATION_DETAILS";function fetchMheValidationDetails(dispatcher,macAddress){var request={macAddress:macAddress};getMHEValidationDetails(dispatcher,request);}function triggerMheValidationDetails(dispatcher,triggerData,showCustomAlert){var request={triggerData:triggerData};triggerMHEValidation(dispatcher,request,showCustomAlert);}function getPresignedURL(dispatcher,objectKey,showCustomAlert){getPresignedURLdata(dispatcher,objectKey,showCustomAlert);}

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMHEValidations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return triggerMHEValidations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPresignedURLcall; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__ = __webpack_require__(51);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/**
 * Fetches Validation execution data for a device
 *
 * @returns {Promise<*>}
 * @param macAddress
 */var getMHEValidations=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(macAddress){var requestBody,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:requestBody={macAddress:macAddress};args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(requestBody,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_50" /* ENDPOINT_GET_MHE_VALIDATION */]);_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context.abrupt("return",_context.sent);case 5:case"end":return _context.stop();}}},_callee,this);}));return function getMHEValidations(_x){return _ref.apply(this,arguments);};}();/**
 * Triggers an instance of MHE Validation
 *
 * @returns {Promise<*>}
 * @param triggerData
 */var triggerMHEValidations=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(triggerData){var requestBody,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:requestBody=triggerData;args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(requestBody,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_65" /* ENDPOINT_TRIGGER_MHE_VALIDATION */]);_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context2.abrupt("return",_context2.sent);case 5:case"end":return _context2.stop();}}},_callee2,this);}));return function triggerMHEValidations(_x2){return _ref2.apply(this,arguments);};}();/**
 * Fetches S3Presigned Url for MHE Validation report
 *
 * @returns {Promise<*>}
 * @param objectKey
 */var getPresignedURLcall=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(objectKey){var requestBody,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:requestBody={objectKey:objectKey};args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(requestBody,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_52" /* ENDPOINT_GET_PRESIGNED_URL_MHE_VALIDATION */]);_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context3.abrupt("return",_context3.sent);case 5:case"end":return _context3.stop();}}},_callee3,this);}));return function getPresignedURLcall(_x3){return _ref3.apply(this,arguments);};}();

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonui_mheValidation_ValidationTabBody__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_AslDeviceOverviewContext__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mhevalidation_context_MHEValidationContext__ = __webpack_require__(180);
var AslDeviceValidation=function AslDeviceValidation(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__context_AslDeviceOverviewContext__["a" /* AslDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var deviceList=Object.values(viewModel.aslDeviceInformation);var props={dispatch:dispatch,deviceList:deviceList,intl:intl};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__mhevalidation_context_MHEValidationContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonui_mheValidation_ValidationTabBody__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(AslDeviceValidation));

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_ZancaSortDeviceOverviewContext__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var ZancaSortDevicePage=function(_Component){_inherits(ZancaSortDevicePage,_Component);function ZancaSortDevicePage(){_classCallCheck(this,ZancaSortDevicePage);return _possibleConstructorReturn(this,(ZancaSortDevicePage.__proto__||Object.getPrototypeOf(ZancaSortDevicePage)).apply(this,arguments));}_createClass(ZancaSortDevicePage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__context_ZancaSortDeviceOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["D" /* ZANCA_SORT */],location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["D" /* ZANCA_SORT */]})));}}]);return ZancaSortDevicePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ZancaSortDevicePage);

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZancaSortDeviceOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_ZancaSortDeviceNetworkAPI__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
var ZancaSortDeviceOverviewReducer=function ZancaSortDeviceOverviewReducer(state,action){switch(action.type){case"LOAD_VIEW":Object(__WEBPACK_IMPORTED_MODULE_0__network_ZancaSortDeviceNetworkAPI__["b" /* fetchZancaSortDeviceDetails */])(action.data.dispatcher);return state;case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingOverview:false,timestamp:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_14" /* getTimestampNow */])()});case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});case"ADD_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_ZancaSortDeviceNetworkAPI__["c" /* setZancaSortDeviceDetails */])(action.data.dispatcher,action.data.stateValues,action.data.showCustomAlert);return state;case"UPDATE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_ZancaSortDeviceNetworkAPI__["f" /* updateZancaSortDeviceDetails */])(action.data.dispatcher,action.data.stateValues,action.data.showCustomAlert);return state;case"UPDATE_DEVICE_MAC":Object(__WEBPACK_IMPORTED_MODULE_0__network_ZancaSortDeviceNetworkAPI__["g" /* updateZancaSortDeviceMac */])(action.data.dispatcher,action.data.stateValues,action.data.mac,action.data.showCustomAlert);return state;case"UPDATE_MONITORING_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_ZancaSortDeviceNetworkAPI__["h" /* updateZancaSortMonitoringDetails */])(action.data.dispatcher,action.data.stateValues,action.data.mac);return state;case"DELETE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_ZancaSortDeviceNetworkAPI__["a" /* deleteZancaSortDeviceDetails */])(action.data.dispatcher,action.data.mac);return state;case"UPDATE_ZANCA_SORT_CONFIGURATION":Object(__WEBPACK_IMPORTED_MODULE_0__network_ZancaSortDeviceNetworkAPI__["e" /* updateZancaSortConfiguration */])(action.data.dispatcher,action.data.configurations,action.data.mac,action.data.showCustomAlert);return state;default:return state;}};

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateConfigurationsInZancaSortAssetObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Util__ = __webpack_require__(5);
var updateConfigurationsInZancaSortAssetObject=function updateConfigurationsInZancaSortAssetObject(asset,configurations,alias){var updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["t" /* deepCopyObject */])(asset);updatedAsset.assetDetails.alias=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return alias.toString();},"");updatedAsset.assetDetails.assetAttributes.testConfig=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(configurations.testConfig);},"[]");updatedAsset.assetDetails.assetAttributes.locationConfig=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(configurations.locationConfig);},"[]");updatedAsset.assetDetails.assetAttributes.tierConfig=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){var tierConfigObj={};(configurations.tierConfig||[]).forEach(function(tier){tierConfigObj[tier.tierName]={capacity:tier.capacity,levels:tier.startLevel+":"+tier.endLevel};});return JSON.stringify(tierConfigObj);},"{}");return updatedAsset;};

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_ZancaSortDeviceOverviewContext__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modal_AddZancaSortSingleDeviceModal__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commonui_DeleteSingleDeviceModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__commonui_EditMacAddressModal__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__commonui_DisableMonitoringModal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modal_ToggleStowStationsModal__ = __webpack_require__(1323);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var ZancaSortDeviceOverview=function ZancaSortDeviceOverview(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__context_ZancaSortDeviceOverviewContext__["a" /* ZancaSortDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),selected=_useState2[0],setSelected=_useState2[1];var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState4=_slicedToArray(_useState3,2),openActionsMenu=_useState4[0],setOpenActionsMenu=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),mac=_useState6[0],setMac=_useState6[1];// Handle modal state (open/hidden)
var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),openAddModal=_useState8[0],setOpenAddModal=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),openDeleteModal=_useState10[0],setOpenDeleteModal=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),openEditMacModal=_useState12[0],setOpenEditMacModal=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),openDisableMonitoringModal=_useState14[0],setOpenDisableMonitoringModal=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),openToggleStowStationsModal=_useState16[0],setOpenToggleStowStationsModal=_useState16[1];var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=true;setOpenActionsMenu(_open);},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=false;setOpenActionsMenu(_open);},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openAddModal){// fetch overview data in regular intervals if the add device modal is not open
getData();var assetInterval=setInterval(function(){if(!document.hidden){getData();// get asset data
}},Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["D" /* getAssetRefreshInterval */])());var statusInterval=setInterval(function(){if(!document.hidden){getStatusData();// get status update
}},Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_11" /* getStatusRefreshInterval */])());return function(){clearInterval(assetInterval);clearInterval(statusInterval);};}},[openAddModal]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,viewModel.zancaSortDeviceInformation.length);},[viewModel.zancaSortDeviceInformation]);var getData=function getData(){setOpenAddModal(false);setOpenDeleteModal(false);setOpenEditMacModal(false);setOpenDisableMonitoringModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var getStatusData=function getStatusData(){dispatch({type:'LOAD_STATUS',data:{dispatcher:dispatch,state:viewModel}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var onSort=function onSort(sortDetails){dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};var onClickAddEditConfig=function onClickAddEditConfig(){setSelected("");setOpenAddModal(true);};var onClickEditDevice=function onClickEditDevice(mac){setSelected(mac);setOpenAddModal(true);};var onClickRemove=function onClickRemove(mac){setSelected(mac);setOpenDeleteModal(true);};var onClickChangeMac=function onClickChangeMac(mac){setSelected(mac);setOpenEditMacModal(true);};var onClickDisableMonitoring=function onClickDisableMonitoring(mac){setMac(mac);setOpenDisableMonitoringModal(true);};var onClickEnableMonitoring=function onClickEnableMonitoring(startTime,reason,mac){var stateValues={"startTime":startTime,"endTime":Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["I" /* getCurrentDate */])().toString(),"reason":reason};updateData(stateValues,mac);getData();};var onClickToggleStowStations=function onClickToggleStowStations(mac){setSelected(mac);setOpenToggleStowStationsModal(true);};var updateData=function updateData(stateValues,mac){dispatch({type:'UPDATE_MONITORING_DATA',data:{dispatcher:dispatch,stateValues:stateValues,mac:mac}});};var getZancaSortStateValues=function getZancaSortStateValues(mac){if(!mac)return{};var device=viewModel.zancaSortDeviceInformation[mac];if(!device)return{};var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};return{name:device.name,mac:mac,ip:device.ip,port:device.port,deviceType:device.deviceType,deviceConfig:JSON.stringify({type:__WEBPACK_IMPORTED_MODULE_2__util_Util__["e" /* assetTypeToConfigTypeDict */].typeZANCASORT,id:device.id}),vendorAttributes:device.vendorAttributes,monitoring:JSON.stringify(deviceMonitoring)};};var renderDeviceMonitoring=function renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{style:{color:monitoringStatusColor}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:monitoringStatusId}));};var sortedDeviceList=Object.values(viewModel.zancaSortDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){var _viewModel$sortPref=viewModel.sortPref,column=_viewModel$sortPref.column,direction=_viewModel$sortPref.direction;var compareValue=void 0;if(Object.keys(__WEBPACK_IMPORTED_MODULE_18__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */]).includes(column)){if(column==="vendor"){compareValue=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column]+a.vendorAttributes["spec_version"],b.vendorAttributes[column]+b.vendorAttributes["spec_version"]);}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column],b.vendorAttributes[column]);}}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_32" /* sortComparator */])(a[column],b[column]);}if(direction===__WEBPACK_IMPORTED_MODULE_18__util_Constants__["J" /* ASCENDING */]){return compareValue;}else{return-compareValue;}});if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.scrolltobottom"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert___default.a,{type:"informational",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.device"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],{sortColumn:"name"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],{sortColumn:"vendor"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'device.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.mac_ip"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.connectionstatus'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],{sortColumn:"connection"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.connection"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.monitoring"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.action"}))),sortedDeviceList.map(function(device,index){var vendorAttributes=device.vendorAttributes;var monitoring=Object(__WEBPACK_IMPORTED_MODULE_17__util_Validations__["u" /* checkDeviceMonitoringEnabled */])(Number(device.startTime),Number(device.endTime));var _getMonitoringStatusD=Object(__WEBPACK_IMPORTED_MODULE_17__util_Validations__["F" /* getMonitoringStatusDetails */])(monitoring),monitoringStatusColor=_getMonitoringStatusD.monitoringStatusColor,monitoringStatusId=_getMonitoringStatusD.monitoringStatusId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableRow"],{key:index,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),device.deviceType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_17__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][vendorAttributes.vendor]),__WEBPACK_IMPORTED_MODULE_17__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][vendorAttributes.spec_version])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.mac),device.ip,":",device.port)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,device.assetStatus?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{color:device.assetStatus.toUpperCase()===__WEBPACK_IMPORTED_MODULE_18__util_Constants__["b" /* ACTIVE */]?__WEBPACK_IMPORTED_MODULE_18__util_Constants__["X" /* BLUE_COLOR */]:__WEBPACK_IMPORTED_MODULE_18__util_Constants__["_149" /* ORANGE_COLOR */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.assetStatus)):Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"loading.text"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"my-menu","aria-haspopup":"menu","aria-expanded":"false"},__WEBPACK_IMPORTED_MODULE_18__util_Constants__["a" /* ACTIONS_STRING */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu___default.a,{anchorNode:actionButtonRefs.current[index],open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEditDevice(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.addDevice"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickRemove(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.deleteDevice"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickChangeMac(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.changeMac"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickToggleStowStations(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.toggleStowStations"})),monitoring.isMonitoringEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDisableMonitoring(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.monitoring_disable"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEnableMonitoring(device.startTime,device.reason,device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.monitoring_enable"}))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{onClick:onClickAddEditConfig,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle___default.a}),Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.add_device_button_modal"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{onClick:function onClick(){return onClickRemove("");},type:"tertiary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"button.delete"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__modal_AddZancaSortSingleDeviceModal__["a" /* default */],{open:openAddModal,setOpen:setOpenAddModal,selected:selected,setSelected:setSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__commonui_DeleteSingleDeviceModal__["a" /* default */],{open:openDeleteModal,setOpen:setOpenDeleteModal,selected:selected,setSelected:setSelected,macAddressArray:viewModel.macAddressArray,dispatch:dispatch}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__commonui_EditMacAddressModal__["a" /* default */],{open:openEditMacModal,setOpen:setOpenEditMacModal,selectedMac:selected,setSelectedMac:setSelected,dispatch:dispatch,stateValues:getZancaSortStateValues(selected)}),openDisableMonitoringModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__commonui_DisableMonitoringModal__["a" /* default */],{mac:mac,state:openDisableMonitoringModal,onStateChange:setOpenDisableMonitoringModal,context:__WEBPACK_IMPORTED_MODULE_1__context_ZancaSortDeviceOverviewContext__["a" /* ZancaSortDeviceOverviewContext */],reducer:'UPDATE_MONITORING_DATA'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__modal_ToggleStowStationsModal__["a" /* default */],{open:openToggleStowStationsModal,setOpen:setOpenToggleStowStationsModal,selectedMac:selected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["d" /* injectIntl */])(ZancaSortDeviceOverview));

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_ZancaSortDeviceOverviewContext__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddZancaSortSingleDeviceModal=function AddZancaSortSingleDeviceModal(props){var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_ZancaSortDeviceOverviewContext__["a" /* ZancaSortDeviceOverviewContext */]),viewModel=_useContext2.viewModel,dispatch=_useContext2.dispatch;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),name=_useState4[0],setName=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),mac=_useState6[0],setMac=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),ip=_useState8[0],setIp=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),port=_useState10[0],setPort=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),deviceType=_useState12[0],setDeviceType=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),id=_useState14[0],setId=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),vendor=_useState16[0],setVendor=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),specVersion=_useState18[0],setSpecVersion=_useState18[1];// Bare mac of the parent ADTF. Held unprefixed to match what the user types and what ASRS reads.
var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState20=_slicedToArray(_useState19,2),parentMac=_useState20[0],setParentMac=_useState20[1];// Error
var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),nameErr=_useState22[0],setNameErr=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),macErr=_useState24[0],setMacErr=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),ipErr=_useState26[0],setIpErr=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),portErr=_useState28[0],setPortErr=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState30=_slicedToArray(_useState29,2),deviceTypeErr=_useState30[0],setDeviceTypeErr=_useState30[1];var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState32=_slicedToArray(_useState31,2),idErr=_useState32[0],setIdErr=_useState32[1];var _useState33=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState34=_slicedToArray(_useState33,2),vendorErr=_useState34[0],setVendorErr=_useState34[1];var _useState35=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState36=_slicedToArray(_useState35,2),specVersionErr=_useState36[0],setSpecVersionErr=_useState36[1];var _useState37=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState38=_slicedToArray(_useState37,2),parentMacErr=_useState38[0],setParentMacErr=_useState38[1];var initialMonitoringValue={startTime:"0",endTime:"0",reason:""};var _useState39=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(JSON.stringify(initialMonitoringValue)),_useState40=_slicedToArray(_useState39,2),monitoring=_useState40[0],setMonitoring=_useState40[1];var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext3.showCustomAlert;var stateValues={name:name,mac:mac,ip:ip,port:port,deviceType:deviceType,deviceConfig:{type:__WEBPACK_IMPORTED_MODULE_3__util_Util__["e" /* assetTypeToConfigTypeDict */].typeZANCASORT,id:id},vendorAttributes:{vendor:vendor,spec_version:specVersion},monitoring:monitoring,// Lifted out to assetDetails.parentAssetLabel by convertTableJsonToAsset, not stored as an asset attribute.
parentAssetLabel:Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_34" /* toParentAssetLabel */])(parentMac)};var onClickConfirm=function onClickConfirm(stateValues){if(Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["_1" /* validateNewZancaSortDevice */])(stateValues)){showWarning(Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"device.editWarning"}),function(){setShowAlert(false);stateValues.deviceConfig=JSON.stringify(stateValues.deviceConfig);if(selected){stateValues.testConfig=JSON.stringify(viewModel.testConfig[stateValues.mac]);updateData(stateValues);}else{addData(stateValues);}resetInputState();setOpen(false);});}else{setShowAlert(true);}};var addData=function addData(stateValues){dispatch({type:'ADD_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues,showCustomAlert:showCustomAlert}});};var updateData=function updateData(stateValues){dispatch({type:'UPDATE_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues,showCustomAlert:showCustomAlert}});};var onCloseModal=function onCloseModal(){setOpen(false);setSelected("");resetInputState();setShowAlert(false);};function resetInputState(){// setting state of input fields as empty to have empty inputs on clicking Add Device again
setMac("");setMacErr(false);setMonitoring(JSON.stringify(initialMonitoringValue));resetAssetDetails();resetAssetDetailErrors();}var resetAssetDetails=function resetAssetDetails(){setName("");setIp("");setPort("");setDeviceType("");setId("");setVendor("");setSpecVersion("");setParentMac("");};var resetAssetDetailErrors=function resetAssetDetailErrors(){setNameErr(false);setIpErr(false);setPortErr(false);setDeviceTypeErr(false);setIdErr(false);setVendorErr(false);setSpecVersionErr(false);setParentMacErr(false);};var prefill=function prefill(value){if(viewModel.zancaSortDeviceInformation.hasOwnProperty(value)){setSelected(value);var device=viewModel.zancaSortDeviceInformation[value];var vendorAttributes=device.vendorAttributes;resetAssetDetailErrors();setName(device.name);setMac(device.mac);setIp(device.ip);setPort(device.port);setDeviceType(device.deviceType);setId(device.id);setVendor(vendorAttributes.vendor);setSpecVersion(vendorAttributes.spec_version);setParentMac(Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_22" /* macFromParentAssetLabel */])(device.parentAssetLabel));var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};setMonitoring(JSON.stringify(deviceMonitoring));}else if(selected){setSelected("");resetAssetDetails();}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal___default.a,{title:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"device.add_device_button_modal"}),open:open,onOpen:function onOpen(){return prefill(selected);},onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.mac"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"mac-input",value:mac,onChange:setMac,mask:__WEBPACK_IMPORTED_MODULE_4__util_Validations__["i" /* MAC_MASK */],disabled:selected,onBlur:function onBlur(){setMacErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.mac,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].MAC));prefill(mac);},error:macErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"ip-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.ip"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"ip-input",value:ip,onChange:setIp,onBlur:function onBlur(){return setIpErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.ip,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["g" /* IP_ADDRESS_PATTERN */]));},error:ipErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"port-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.port"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"port-input",value:port,onChange:setPort,onBlur:function onBlur(){return setPortErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.port,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].PORT));},error:portErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.protocol"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{id:"device-type-input",value:deviceType,onChange:function onChange(value){return setDeviceType(value);},onBlur:function onBlur(){return setDeviceTypeErr(!deviceType);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.select_protocol"}),error:deviceTypeErr,width:"100%"},__WEBPACK_IMPORTED_MODULE_4__util_Validations__["k" /* PROTOCOLS */].ZANCASORT.map(function(protocol){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{key:protocol,value:protocol,label:protocol});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"name-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"name-input",value:name,onChange:setName,onBlur:function onBlur(){return setNameErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.name,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].NAME));},error:nameErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.name_cluster_desc"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"id-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.device_id"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"id-input",value:id,onChange:setId,onBlur:function onBlur(){return setIdErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.deviceConfig.id,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].DEVICE_ID));},error:idErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.device_id_cluster_desc"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{id:"device-type-input",value:vendor,onChange:function onChange(value){return setVendor(value);},onBlur:function onBlur(){return setVendorErr(!vendor);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_vendor'}),error:vendorErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["r" /* VENDOR_INFO_KEYS */].VENDOR).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_4__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.spec_version'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{id:"device-type-input",value:specVersion,onChange:function onChange(value){return setSpecVersion(value);},onBlur:function onBlur(){return setSpecVersionErr(!specVersion);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_version'}),error:specVersionErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["r" /* VENDOR_INFO_KEYS */].SPEC_VERSION).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_4__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"parent-mac-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.parent_asset_mac"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"parent-mac-input",value:parentMac,onChange:setParentMac,mask:__WEBPACK_IMPORTED_MODULE_4__util_Validations__["i" /* MAC_MASK */],onBlur:function onBlur(){return setParentMacErr(!!parentMac&&!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(parentMac,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].MAC));},error:parentMacErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.parent_asset_mac_desc"})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default.a,{type:"warning",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'alert.missingfields'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.cancel'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stateValues);}},selected?Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.confirmEdit'}):Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.confirmAdd'})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddZancaSortSingleDeviceModal));

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_ZancaSortDeviceOverviewContext__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_toggle__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__network_ZancaSortDeviceNetworkAPI__ = __webpack_require__(512);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var ToggleStowStationsModal=function ToggleStowStationsModal(props){var open=props.open,setOpen=props.setOpen,selectedMac=props.selectedMac;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning,showCustomAlert=_useContext.showCustomAlert;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__context_ZancaSortDeviceOverviewContext__["a" /* ZancaSortDeviceOverviewContext */]),viewModel=_useContext2.viewModel,dispatch=_useContext2.dispatch;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isUpdating=_useState2[0],setIsUpdating=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),topStationEnabled=_useState4[0],setTopStationEnabled=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),bottomStationEnabled=_useState6[0],setBottomStationEnabled=_useState6[1];var onOpen=function onOpen(){var device=viewModel.zancaSortDeviceInformation[selectedMac];if(device&&device.stowStationState){setTopStationEnabled(device.stowStationState.StowStationEnabled_Top);setBottomStationEnabled(device.stowStationState.StowStationEnabled_Bottom);}else{setTopStationEnabled(false);setBottomStationEnabled(false);}};var stowStationStateAttributeName='stowStationState';var onConfirm=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:showWarning(Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"device.editWarning"}),_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var success;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setIsUpdating(true);_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_13__network_ZancaSortDeviceNetworkAPI__["d" /* updateAssetAttribute */])(dispatch,selectedMac,stowStationStateAttributeName,{StowStationEnabled_Top:topStationEnabled,StowStationEnabled_Bottom:bottomStationEnabled},showCustomAlert);case 3:success=_context.sent;if(success){onClose();}else{setIsUpdating(false);}case 5:case"end":return _context.stop();}}},_callee,_this);})));case 1:case"end":return _context2.stop();}}},_callee2,_this);}));return function onConfirm(){return _ref.apply(this,arguments);};}();var onClose=function onClose(){setOpen(false);setTopStationEnabled(false);setBottomStationEnabled(false);setIsUpdating(false);};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal___default.a,{title:Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.toggleStowStations.title"}),open:open,onOpen:onOpen,onClose:onClose,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"medium"},isUpdating?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium",alignmentHorizontal:"center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__loader_Loader__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{type:"b200"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.toggleStowStations.updating"}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default.a,{alignmentVertical:"center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{width:"145px",marginRight:"4px",display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.toggleStowStations.topStation"}),":")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",alignItems:"center",marginTop:"4px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_toggle___default.a,{checked:topStationEnabled,onChange:setTopStationEnabled}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default.a,{alignmentVertical:"center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{width:"145px",marginRight:"4px",display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.toggleStowStations.bottomStation"}),":")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{display:"flex",alignItems:"center",marginTop:"4px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_toggle___default.a,{checked:bottomStationEnabled,onChange:setBottomStationEnabled})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onClose,disabled:isUpdating},Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.cancel"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:onConfirm,disabled:isUpdating},Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.confirm"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */])(ToggleStowStationsModal));

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toggle = _interopRequireDefault(__webpack_require__(1325));

var _default = _toggle["default"];
exports["default"] = _default;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _typeof = __webpack_require__(25);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _emotion = __webpack_require__(11);

var _toggle = _interopRequireDefault(__webpack_require__(1326));

var _checkSmall = _interopRequireDefault(__webpack_require__(1327));

var _theme = __webpack_require__(24);

var _useFocus2 = _interopRequireDefault(__webpack_require__(66));

var _token = __webpack_require__(20);

var _functional = __webpack_require__(38);

var _getIconCss = _interopRequireDefault(__webpack_require__(156));

var _focusRing = _interopRequireDefault(__webpack_require__(73));

var _text = _interopRequireDefault(__webpack_require__(47));

var _visuallyHidden = _interopRequireDefault(__webpack_require__(95));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var checkIcon = (0, _token.getIconFromTokens)(_checkSmall["default"]); // Root styles for the entire component. This makes it a block-level component
// without stretching the clickable-area beyond the visible label

var containerStyles = (0, _emotion.css)({
  // NOTE: Use "flex" instead of "block" to acheive block-level display while
  // fixing the min-height issue in IE11:
  // https://stackoverflow.com/questions/44700068/flexbox-min-height-and-ie11
  display: "flex",
  fontSize: 0
});
var labelStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var disabled = _ref.disabled;
  var textStyleObject = (0, _text["default"])(t);
  return (0, _emotion.css)(textStyleObject, {
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    position: "relative",
    color: t("foregroundColor", disabled ? "disabled" : "default"),
    cursor: disabled ? "not-allowed" : "pointer",
    userSelect: "none"
  });
}, ["disabled"]); // Styles for the toggle track

var trackStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var _css;

  var size = _ref2.size,
      checked = _ref2.checked,
      focus = _ref2.focus,
      disabled = _ref2.disabled;
  var modifier = checked ? "selected" : "unselected";
  var state = disabled ? "disabled" : "default";
  return (0, _emotion.css)((_css = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexShrink: 0,
    boxSizing: "border-box",
    padding: t("trackSpacingInset"),
    width: t("trackWidth", size),
    borderStyle: "solid",
    borderWidth: t("trackBorderWidth"),
    borderRadius: t("trackBorderRadius"),
    borderColor: t("trackBorderColor", [modifier, state]),
    backgroundColor: t("trackBackgroundColor", [modifier, state]),
    "label:hover &": !disabled && {
      backgroundColor: t("trackBackgroundColor", [modifier, "hover"])
    },
    "input:active + &": !disabled && {
      backgroundColor: t("trackBackgroundColor", [modifier, "pressed"])
    },
    backgroundImage: (0, _getIconCss["default"])(checkIcon.data, t("trackBackgroundColorUnselectedDefault")),
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center left 4px"
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    backgroundPosition: "center right 4px"
  }), (0, _defineProperty2["default"])(_css, "transition", t.transitionCss("motion", "background-color")), _css), !disabled ? (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: 4,
    borderRadius: t("trackBorderRadius"),
    borderWidth: t("trackBorderWidth"),
    dropShadow: true,
    hoverSelector: "*:hover > &"
  }) : undefined);
}, ["size", "checked", "focus", "disabled"]); // Styles for the toggle ball

var ballStyles = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var _css2;

  var checked = _ref3.checked,
      disabled = _ref3.disabled,
      size = _ref3.size;
  var modifier = checked ? "selected" : "unselected";
  var state = disabled ? "disabled" : "default";
  var checkedTransform = t("trackWidth", size) - t("ballDiameter", size) - t("trackSpacingInset") * 2 - t("trackBorderWidth") * 2;
  return (0, _emotion.css)((_css2 = {
    boxSizing: "border-box",
    width: t("ballDiameter", size),
    height: t("ballDiameter", size),
    borderRadius: t("ballBorderRadius"),
    transform: checked ? "translateX(".concat(checkedTransform, "px)") : "translateX(0px)"
  }, (0, _defineProperty2["default"])(_css2, "[dir=\"rtl\"] &", {
    transform: checked ? "translateX(-".concat(checkedTransform, "px)") : "translateX(0px)"
  }), (0, _defineProperty2["default"])(_css2, "backgroundColor", t("ballBackgroundColor", [modifier, state])), (0, _defineProperty2["default"])(_css2, "label:hover &", !disabled && {
    boxShadow: t.boxShadowCss("ballDropShadowHoverPressed"),
    backgroundColor: t("ballBackgroundColor", [modifier, "hover"])
  }), (0, _defineProperty2["default"])(_css2, "input:active + div > &", !disabled && {
    boxShadow: t.boxShadowCss("ballDropShadowHoverPressed"),
    backgroundColor: t("ballBackgroundColor", [modifier, "pressed"])
  }), (0, _defineProperty2["default"])(_css2, "transition", t.transitionCss("motion", ["background-color", "transform"])), _css2));
}, ["checked", "disabled", "size"]); // Styles for the actual HTML toggle element that is hidden from the user

var hiddenInputStyles = (0, _emotion.css)(_visuallyHidden["default"]); // Styles that wrap a toggle's children / label

var childrenStyles = (0, _functional.memoize)(function (t) {
  return (0, _emotion.css)((0, _defineProperty2["default"])({
    // HACK: IE11 does not support margin-inline-* or margin-block-* so we have
    // to use directional margin-left/right. If/when we drop IE11 we can simplify
    // these styles to be:
    // {
    //   marginInlineStart: t("spacingHorizontal"),
    // },
    marginLeft: t("spacingHorizontal")
  }, "[dir=\"rtl\"] &", {
    marginLeft: 0,
    marginRight: t("spacingHorizontal")
  }));
});

var Toggle = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children,
      size = props.size,
      onChange = props.onChange,
      disabled = props.disabled,
      checked = props.checked;
  var t = (0, _theme.useTheme)(_toggle["default"], "toggle");

  var _useFocus = (0, _useFocus2["default"])(),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
  var onChangeInput = (0, _react.useCallback)(function (event) {
    if (onChange) onChange(event.target.checked);
  }, [onChange]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: containerStyles
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: labelStyles(t, {
      disabled: disabled,
      size: size
    })
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, passThroughProps, focusProps, {
    id: props.id,
    className: hiddenInputStyles,
    type: "checkbox",
    name: props.name,
    value: props.value,
    checked: // Cast `checked` to a boolean so that a value of `undefined`
    // doesn't flip the input into React's "uncontrolled" mode.
    Boolean(checked),
    disabled: disabled,
    role: "switch",
    "aria-checked": Boolean(checked),
    tabIndex: props.tabIndex,
    onChange: onChangeInput,
    ref: ref
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: trackStyles(t, {
      checked: checked,
      focus: focus && focusTrigger === "keyboard",
      disabled: disabled,
      size: size
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: ballStyles(t, {
      checked: checked,
      disabled: disabled,
      size: size
    })
  })), children && /*#__PURE__*/_react["default"].createElement("div", {
    className: childrenStyles(t)
  }, children)));
});

Toggle.displayName = "Toggle";
Toggle.propTypes =  false ? {
  /**
   * The checked state of the component. Use this in conjunction with the
   * `onChange` prop to make the component interactive.
   */
  checked: _propTypes["default"].bool,

  /**
   * The component's label. Plain text is recommended. This will be displayed
   * next to the form control, and will trigger a state change when clicked.
   */
  children: _propTypes["default"].node,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["medium", "large"]),

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The value of the underlying input element. This is used to populate the
   * form data when submitting a form. To change the on/off status of the
   * component use the `checked` prop.
   */
  value: _propTypes["default"].any,

  /**
   * A function that will be called when the user attempts to change the checked
   * state of the component (e.g. by clicking on it). The new checked state will
   * be passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the checked state provided to this function somewhere in
   * your state and pass it back via the `checked` prop in order to make this
   * component interactive.
   */
  onChange: _propTypes["default"].func
} : {};
Toggle.defaultProps = {
  size: "medium"
};
var _default = Toggle;
exports["default"] = _default;

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    toggleForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    toggleForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    toggleSpacingHorizontal: 12,
    toggleMotionDuration: "200ms",
    toggleMotionFunction: "ease",
    toggleTrackSpacingInset: 3,
    toggleTrackWidthMedium: 40,
    toggleTrackWidthLarge: 48,
    toggleTrackBorderWidth: 1,
    toggleTrackBorderRadius: 12,
    toggleTrackBorderColorSelectedDefault: "rgba(0, 0, 0, 0)",
    toggleTrackBorderColorSelectedDisabled: tokens.themeBorderPrimaryDisabled,
    toggleTrackBorderColorUnselectedDefault: tokens.themeBorderPrimaryDefault,
    toggleTrackBorderColorUnselectedDisabled: tokens.themeForegroundSecondaryDisabled,
    toggleTrackBackgroundColorSelectedDefault: tokens.themeForegroundAccentDefault,
    toggleTrackBackgroundColorSelectedHover: tokens.themeForegroundAccentHover,
    toggleTrackBackgroundColorSelectedPressed: tokens.themeForegroundAccentPressed,
    toggleTrackBackgroundColorSelectedDisabled: tokens.themeForegroundAccentDisabled,
    toggleTrackBackgroundColorUnselectedDefault: tokens.themeBackgroundPrimaryDefault,
    toggleTrackBackgroundColorUnselectedHover: tokens.themeBackgroundTertiaryDefault,
    toggleTrackBackgroundColorUnselectedPressed: tokens.themeBackgroundTertiaryHover,
    toggleTrackBackgroundColorUnselectedDisabled: tokens.themeBackgroundAlternateTertiaryFocus,
    toggleBallBorderRadius: 999,
    toggleBallDropShadowHoverPressedOffsetX: 0,
    toggleBallDropShadowHoverPressedOffsetY: 1,
    toggleBallDropShadowHoverPressedBlur: 2,
    toggleBallDropShadowHoverPressedSpread: 0,
    toggleBallDropShadowHoverPressedColor: "rgba(11, 12, 12, 0.16)",
    toggleBallBackgroundColorSelectedDefault: tokens.themeBackgroundPrimaryDefault,
    toggleBallBackgroundColorSelectedDisabled: tokens.themeBackgroundPrimaryDefault,
    toggleBallBackgroundColorUnselectedDefault: tokens.themeForegroundSecondaryDefault,
    toggleBallBackgroundColorUnselectedDisabled: tokens.themeForegroundSecondaryDisabled,
    toggleBallDiameterMedium: 12,
    toggleBallDiameterLarge: 16
  }
};

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconCheckSmallData: "data:image/svg+xml,%3csvg width='10' height='8' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 3.458l2.988 3.084L9 1.458' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e",
  iconCheckSmallWidth: 10,
  iconCheckSmallHeight: 8
};

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_TesseractDeviceOverviewContext__ = __webpack_require__(181);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var TesseractDevicePage=function(_Component){_inherits(TesseractDevicePage,_Component);function TesseractDevicePage(){_classCallCheck(this,TesseractDevicePage);return _possibleConstructorReturn(this,(TesseractDevicePage.__proto__||Object.getPrototypeOf(TesseractDevicePage)).apply(this,arguments));}_createClass(TesseractDevicePage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__context_TesseractDeviceOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_TabLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__["x" /* TESSERACT */],location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_TabLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__["x" /* TESSERACT */]})));}}]);return TesseractDevicePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TesseractDevicePage);

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TesseractDeviceOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_TesseractDeviceNetworkAPI__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
var TesseractDeviceOverviewReducer=function TesseractDeviceOverviewReducer(state,action){switch(action.type){case"LOAD_VIEW":Object(__WEBPACK_IMPORTED_MODULE_0__network_TesseractDeviceNetworkAPI__["b" /* fetchTesseractDeviceDetails */])(action.data.dispatcher);return state;case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingOverview:false,timestamp:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_14" /* getTimestampNow */])()});case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});case"ADD_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_TesseractDeviceNetworkAPI__["c" /* setTesseractDeviceDetails */])(action.data.dispatcher,action.data.stateValues,action.data.showCustomAlert);return state;case"UPDATE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_TesseractDeviceNetworkAPI__["e" /* updateTesseractDeviceDetails */])(action.data.dispatcher,action.data.stateValues,action.data.showCustomAlert);return state;case"UPDATE_DEVICE_MAC":Object(__WEBPACK_IMPORTED_MODULE_0__network_TesseractDeviceNetworkAPI__["f" /* updateTesseractDeviceMac */])(action.data.dispatcher,action.data.stateValues,action.data.mac,action.data.showCustomAlert);return state;case"UPDATE_MONITORING_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_TesseractDeviceNetworkAPI__["g" /* updateTesseractMonitoringDetails */])(action.data.dispatcher,action.data.stateValues,action.data.mac);return state;case"DELETE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_TesseractDeviceNetworkAPI__["a" /* deleteTesseractDeviceDetails */])(action.data.dispatcher,action.data.mac);return state;case"UPDATE_TESSERACT_CONFIGURATION":Object(__WEBPACK_IMPORTED_MODULE_0__network_TesseractDeviceNetworkAPI__["d" /* updateTesseractConfiguration */])(action.data.dispatcher,action.data.configurations,action.data.mac,action.data.showCustomAlert);return state;default:return state;}};

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchTesseractDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["c"] = setTesseractDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateTesseractDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteTesseractDeviceDetails;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateTesseractDeviceMac; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateTesseractConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateTesseractMonitoringDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datamodel_TesseractAssetModelResource__ = __webpack_require__(1331);
var addTesseractDeviceDetails=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatcher,request,showCustomAlert){var _this=this;var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:startTime=Date.now();_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_29" /* setAliasToRequest */])(request);case 3:Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["a" /* addAsset */])(request).then(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(result){var isFault,getAssetResult,responseSetAssetStatus,responseUpdateAsset,isFaultInUpdateAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(result.status===200)){_context3.next=4;break;}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addTesseractDeviceDetails",true,false);_context3.next=28;break;case 4:// 500 response status can be for any reason. One of those is : asset already exists so trying to update it.
// UpdateAsset only works on ACTIVE devices so first setting status as ACTIVE.
isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(result.status);_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 7:getAssetResult=_context3.sent;if(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(getAssetResult.data.asset.assetDetails.assetStatus)){_context3.next=12;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["B" /* ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addTesseractDeviceDetails",false,isFault);return _context3.abrupt("return");case 12:_context3.next=14;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);case 14:responseSetAssetStatus=_context3.sent;if(!(responseSetAssetStatus.status!==200)){_context3.next=19;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addTesseractDeviceDetails",false,isFault);return _context3.abrupt("return");case 19:_context3.next=21;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 21:responseUpdateAsset=_context3.sent;if(!(responseUpdateAsset.status!==200)){_context3.next=27;break;}isFaultInUpdateAsset=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(responseUpdateAsset.status);showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addTesseractDeviceDetails",false,isFaultInUpdateAsset);return _context3.abrupt("return");case 27:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addTesseractDeviceDetails",true,false);case 28:fetchTesseractDeviceDetails(dispatcher);case 29:case"end":return _context3.stop();}}},_callee3,_this);}));return function(_x12){return _ref4.apply(this,arguments);};}());case 4:case"end":return _context4.stop();}}},_callee4,this);}));return function addTesseractDeviceDetails(_x9,_x10,_x11){return _ref3.apply(this,arguments);};}();var updateTesseractAsset=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatcher,request,showCustomAlert){var setAssetStatusResponse,startTime,getAssetResult,updateAssetResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);case 2:setAssetStatusResponse=_context5.sent;if(!(setAssetStatusResponse.status!==200)){_context5.next=7;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);fetchTesseractDeviceDetails(dispatcher);return _context5.abrupt("return");case 7:// Update asset details
startTime=Date.now();_context5.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_29" /* setAliasToRequest */])(request);case 10:_context5.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 12:getAssetResult=_context5.sent;_context5.next=15;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 15:updateAssetResponse=_context5.sent;isSuccess=updateAssetResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateAssetResponse.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateTesseractDeviceDetails",isSuccess,isFault);fetchTesseractDeviceDetails(dispatcher);case 20:case"end":return _context5.stop();}}},_callee5,this);}));return function updateTesseractAsset(_x13,_x14,_x15){return _ref5.apply(this,arguments);};}();var getTesseractDeviceDetails=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatcher,request){var model;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:model={tesseractDeviceInformation:{},testConfig:{},stowConfig:{},macAddressArray:[]// Fetch static asset details
};_context6.next=3;return getTesseractDeviceStaticDetails(dispatcher,model,request);case 3:case"end":return _context6.stop();}}},_callee6,this);}));return function getTesseractDeviceDetails(_x16,_x17){return _ref6.apply(this,arguments);};}();var getTesseractDeviceStaticDetails=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatcher,model,request){var pageToken,startTime,getAssetsResult,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:pageToken=null;// do-while loop until we get a valid pageToken
case 1:startTime=Date.now();_context7.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["g" /* getAssets */])(request.nodeId,request.assetType,pageToken);case 4:getAssetsResult=_context7.sent;isSuccess=getAssetsResult.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(getAssetsResult.status);// Log operation
Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getTesseractDeviceDetails",isSuccess,isFault);if(isSuccess){addTesseractDeviceStaticDetailsToModel(getAssetsResult,model);// modifying pageToken to fetch from the latest get assets' result
pageToken=getAssetsResult.data.pageToken;}else{dispatcher({type:"RECEIVE_DATA",data:[]});}case 9:if(pageToken){_context7.next=1;break;}case 10:dispatcher({type:"RECEIVE_DATA",data:model});case 11:case"end":return _context7.stop();}}},_callee7,this);}));return function getTesseractDeviceStaticDetails(_x18,_x19,_x20){return _ref7.apply(this,arguments);};}();var setAssetLabelDeprecatedTesseractDeviceDetails=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatcher,request){var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:startTime=Date.now();Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetLabel,request.assetStatus).then(function(result){if(result.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteTesseractDeviceDetails",true,false);fetchTesseractDeviceDetails(dispatcher);}else{var isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(result.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteTesseractDeviceDetails",false,isFault);dispatcher({type:"RECEIVE_DATA",data:[]});}});case 2:case"end":return _context8.stop();}}},_callee8,this);}));return function setAssetLabelDeprecatedTesseractDeviceDetails(_x21,_x22){return _ref8.apply(this,arguments);};}();var updateTesseractMonitoringSchedule=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatcher,request){var startTime,getAssetResult,updateAssetInPlaceResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:// Update asset details
startTime=Date.now();_context10.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 3:getAssetResult=_context10.sent;_context10.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["l" /* updateAssetInPlace */])(request,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.lastUpdateTime;},null));case 6:updateAssetInPlaceResponse=_context10.sent;isSuccess=updateAssetInPlaceResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateAssetInPlaceResponse.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateTesseractDeviceDetails",isSuccess,isFault);fetchTesseractDeviceDetails(dispatcher);case 11:case"end":return _context10.stop();}}},_callee10,this);}));return function updateTesseractMonitoringSchedule(_x26,_x27){return _ref10.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="TESSERACT_DEVICE_DETAILS";function fetchTesseractDeviceDetails(dispatcher){var request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_200" /* TESSERACT_ASSET_TYPE */]};getTesseractDeviceDetails(dispatcher,request);}function setTesseractDeviceDetails(dispatcher,stateValues,showCustomAlert){stateValues.mac=stateValues.mac.toLowerCase();var request=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_200" /* TESSERACT_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);addTesseractDeviceDetails(dispatcher,request,showCustomAlert);}function updateTesseractDeviceDetails(dispatcher,stateValues,showCustomAlert){var request=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_200" /* TESSERACT_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);updateTesseractAsset(dispatcher,request,showCustomAlert);}function deleteTesseractDeviceDetails(dispatcher,mac){var request={assetLabel:{type:"MAC_ADDRESS",value:mac},assetStatus:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_19" /* DEPRECATED */]};setAssetLabelDeprecatedTesseractDeviceDetails(dispatcher,request);}var updateTesseractDeviceMac=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher,stateValues,mac,showCustomAlert){var startTime,assetLabel,assetResult,nodeId,assetStatus;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:startTime=Date.now();assetLabel=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(stateValues.mac.toLowerCase());_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(assetLabel);case 4:assetResult=_context.sent;nodeId=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.nodeId;},null);assetStatus=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.assetStatus;},null);if(assetStatus&&!Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(assetStatus)){showCustomAlert(Object(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_225" /* getUpdateAssetMessageAlertWithSite */])(nodeId));Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addTesseractDeviceDetails",false,false);}else{deleteTesseractDeviceDetails(dispatcher,mac);setTesseractDeviceDetails(dispatcher,stateValues,showCustomAlert);}case 8:case"end":return _context.stop();}}},_callee,this);}));return function updateTesseractDeviceMac(_x,_x2,_x3,_x4){return _ref.apply(this,arguments);};}();var updateTesseractConfiguration=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatcher,configurations,mac,showCustomAlert){var getAssetResult,startTime,alias,updatedAsset,updateResult,isUpdateSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 2:getAssetResult=_context2.sent;// Merge current configuration into existing configuration and update
startTime=Date.now();_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["B" /* getAliasFromParent */])();case 6:alias=_context2.sent;updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_4__datamodel_TesseractAssetModelResource__["a" /* updateConfigurationsInTesseractAssetObject */])(getAssetResult.data.asset,configurations,alias);_context2.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(updatedAsset,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 10:updateResult=_context2.sent;isUpdateSuccess=updateResult.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateResult.status);fetchTesseractDeviceDetails(dispatcher);// Log operation
isUpdateSuccess?showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["D" /* ALERT_UPDATE_SUCCESS_ASSET_MESSAGE */]):showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateTesseractConfiguration",isUpdateSuccess,isFault);case 16:case"end":return _context2.stop();}}},_callee2,this);}));return function updateTesseractConfiguration(_x5,_x6,_x7,_x8){return _ref2.apply(this,arguments);};}();var addTesseractDeviceStaticDetailsToModel=function addTesseractDeviceStaticDetailsToModel(result,model){if("data"in result&&"assetDetailsList"in result.data){result.data.assetDetailsList.forEach(function(deviceDetail){if(deviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]){model.macAddressArray.push(deviceDetail.assetAttributes.mac);var mac=deviceDetail.assetAttributes.mac;var id=JSON.parse(deviceDetail.assetAttributes.deviceConfig).id;model.tesseractDeviceInformation[mac]={name:deviceDetail.assetAttributes.name,mac:deviceDetail.assetAttributes.mac,ip:deviceDetail.assetAttributes.ip,id:id,port:deviceDetail.assetAttributes.port,vendorAttributes:deviceDetail.vendorAttributes||__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */],assetStatus:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_110" /* LOADING_STRING */],deviceType:deviceDetail.assetAttributes.deviceType,assetType:deviceDetail.assetType,startTime:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.monitoring).startTime;},"0"),endTime:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.monitoring).endTime;},"0"),reason:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.monitoring).reason;},"")};model.stowConfig[mac]=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.stowConfig,[]);});model.testConfig[mac]=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.testConfig,[]);});}});}return model;};var updateTesseractMonitoringDetails=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatcher,stateValues,mac){var getAssetResult,updatedAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 2:getAssetResult=_context9.sent;updatedAsset=updateExistingAssetAttributes(getAssetResult.data.asset,stateValues);updateTesseractMonitoringSchedule(dispatcher,updatedAsset);case 5:case"end":return _context9.stop();}}},_callee9,this);}));return function updateTesseractMonitoringDetails(_x23,_x24,_x25){return _ref9.apply(this,arguments);};}();var updateExistingAssetAttributes=function updateExistingAssetAttributes(asset,stateValues){var updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["t" /* deepCopyObject */])(asset);updatedAsset.assetDetails.assetAttributes.monitoring=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(stateValues);},asset.assetDetails.assetAttributes.monitoring);return updatedAsset;};

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateConfigurationsInTesseractAssetObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Util__ = __webpack_require__(5);
var updateConfigurationsInTesseractAssetObject=function updateConfigurationsInTesseractAssetObject(asset,configurations,alias){var updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["t" /* deepCopyObject */])(asset);updatedAsset.assetDetails.alias=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return alias.toString();},"");updatedAsset.assetDetails.assetAttributes.testConfig=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(configurations.testConfig);},"[]");updatedAsset.assetDetails.assetAttributes.stowConfig=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(configurations.stowConfig);},"[]");return updatedAsset;};

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_TesseractDeviceOverviewContext__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modal_AddTesseractSingleDeviceModal__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commonui_DeleteSingleDeviceModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__commonui_EditMacAddressModal__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__commonui_DisableMonitoringModal__ = __webpack_require__(78);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var TesseractDeviceOverview=function TesseractDeviceOverview(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__context_TesseractDeviceOverviewContext__["a" /* TesseractDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),selected=_useState2[0],setSelected=_useState2[1];var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState4=_slicedToArray(_useState3,2),openActionsMenu=_useState4[0],setOpenActionsMenu=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),mac=_useState6[0],setMac=_useState6[1];// Handle modal state (open/hidden)
var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),openAddModal=_useState8[0],setOpenAddModal=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),openDeleteModal=_useState10[0],setOpenDeleteModal=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),openEditMacModal=_useState12[0],setOpenEditMacModal=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),openDisableMonitoringModal=_useState14[0],setOpenDisableMonitoringModal=_useState14[1];var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=true;setOpenActionsMenu(_open);},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=false;setOpenActionsMenu(_open);},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openAddModal){// fetch overview data in regular intervals if the add device modal is not open
getData();var assetInterval=setInterval(function(){if(!document.hidden){getData();// get asset data
}},Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["D" /* getAssetRefreshInterval */])());var statusInterval=setInterval(function(){if(!document.hidden){getStatusData();// get status update
}},Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_11" /* getStatusRefreshInterval */])());return function(){clearInterval(assetInterval);clearInterval(statusInterval);};}},[openAddModal]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,viewModel.tesseractDeviceInformation.length);},[viewModel.tesseractDeviceInformation]);var getData=function getData(){setOpenAddModal(false);setOpenDeleteModal(false);setOpenEditMacModal(false);setOpenDisableMonitoringModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var getStatusData=function getStatusData(){dispatch({type:'LOAD_STATUS',data:{dispatcher:dispatch,state:viewModel}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var onSort=function onSort(sortDetails){dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};var onClickAddEditConfig=function onClickAddEditConfig(){setSelected("");setOpenAddModal(true);};var onClickEditDevice=function onClickEditDevice(mac){setSelected(mac);setOpenAddModal(true);};var onClickRemove=function onClickRemove(mac){setSelected(mac);setOpenDeleteModal(true);};var onClickChangeMac=function onClickChangeMac(mac){setSelected(mac);setOpenEditMacModal(true);};var onClickDisableMonitoring=function onClickDisableMonitoring(mac){setMac(mac);setOpenDisableMonitoringModal(true);};var onClickEnableMonitoring=function onClickEnableMonitoring(startTime,reason,mac){var stateValues={"startTime":startTime,"endTime":Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["I" /* getCurrentDate */])().toString(),"reason":reason};updateData(stateValues,mac);getData();};var updateData=function updateData(stateValues,mac){dispatch({type:'UPDATE_MONITORING_DATA',data:{dispatcher:dispatch,stateValues:stateValues,mac:mac}});};var getTesseractStateValues=function getTesseractStateValues(mac){if(!mac)return{};var device=viewModel.tesseractDeviceInformation[mac];if(!device)return{};var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};return{name:device.name,mac:mac,ip:device.ip,port:device.port,deviceType:device.deviceType,deviceConfig:JSON.stringify({type:__WEBPACK_IMPORTED_MODULE_2__util_Util__["e" /* assetTypeToConfigTypeDict */].typeTesseract,id:device.id}),vendorAttributes:device.vendorAttributes,monitoring:JSON.stringify(deviceMonitoring)};};var renderDeviceMonitoring=function renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{style:{color:monitoringStatusColor}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:monitoringStatusId}));};var sortedDeviceList=Object.values(viewModel.tesseractDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){var _viewModel$sortPref=viewModel.sortPref,column=_viewModel$sortPref.column,direction=_viewModel$sortPref.direction;var compareValue=void 0;if(Object.keys(__WEBPACK_IMPORTED_MODULE_18__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */]).includes(column)){if(column==="vendor"){compareValue=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column]+a.vendorAttributes["spec_version"],b.vendorAttributes[column]+b.vendorAttributes["spec_version"]);}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column],b.vendorAttributes[column]);}}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_32" /* sortComparator */])(a[column],b[column]);}if(direction===__WEBPACK_IMPORTED_MODULE_18__util_Constants__["J" /* ASCENDING */]){return compareValue;}else{return-compareValue;}});if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.scrolltobottom"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert___default.a,{type:"informational",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.device"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],{sortColumn:"name"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],{sortColumn:"vendor"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'device.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.mac_ip"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.connectionstatus'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],{sortColumn:"connection"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.connection"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.monitoring"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.action"}))),sortedDeviceList.map(function(device,index){var vendorAttributes=device.vendorAttributes;var monitoring=Object(__WEBPACK_IMPORTED_MODULE_17__util_Validations__["u" /* checkDeviceMonitoringEnabled */])(Number(device.startTime),Number(device.endTime));var _getMonitoringStatusD=Object(__WEBPACK_IMPORTED_MODULE_17__util_Validations__["F" /* getMonitoringStatusDetails */])(monitoring),monitoringStatusColor=_getMonitoringStatusD.monitoringStatusColor,monitoringStatusId=_getMonitoringStatusD.monitoringStatusId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableRow"],{key:index,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),device.deviceType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_17__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][vendorAttributes.vendor]),__WEBPACK_IMPORTED_MODULE_17__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][vendorAttributes.spec_version])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.mac),device.ip,":",device.port)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,device.assetStatus?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{color:device.assetStatus.toUpperCase()===__WEBPACK_IMPORTED_MODULE_18__util_Constants__["b" /* ACTIVE */]?__WEBPACK_IMPORTED_MODULE_18__util_Constants__["X" /* BLUE_COLOR */]:__WEBPACK_IMPORTED_MODULE_18__util_Constants__["_149" /* ORANGE_COLOR */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.assetStatus)):Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"loading.text"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"my-menu","aria-haspopup":"menu","aria-expanded":"false"},__WEBPACK_IMPORTED_MODULE_18__util_Constants__["a" /* ACTIONS_STRING */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu___default.a,{anchorNode:actionButtonRefs.current[index],open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEditDevice(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.addDevice"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickRemove(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.deleteDevice"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickChangeMac(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.changeMac"})),monitoring.isMonitoringEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDisableMonitoring(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.monitoring_disable"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEnableMonitoring(device.startTime,device.reason,device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.monitoring_enable"}))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{onClick:onClickAddEditConfig,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle___default.a}),Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.add_device_button_modal"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{onClick:function onClick(){return onClickRemove("");},type:"tertiary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"button.delete"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__modal_AddTesseractSingleDeviceModal__["a" /* default */],{open:openAddModal,setOpen:setOpenAddModal,selected:selected,setSelected:setSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__commonui_DeleteSingleDeviceModal__["a" /* default */],{open:openDeleteModal,setOpen:setOpenDeleteModal,selected:selected,setSelected:setSelected,macAddressArray:viewModel.macAddressArray,dispatch:dispatch}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__commonui_EditMacAddressModal__["a" /* default */],{open:openEditMacModal,setOpen:setOpenEditMacModal,selectedMac:selected,setSelectedMac:setSelected,dispatch:dispatch,stateValues:getTesseractStateValues(selected)}),openDisableMonitoringModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__commonui_DisableMonitoringModal__["a" /* default */],{mac:mac,state:openDisableMonitoringModal,onStateChange:setOpenDisableMonitoringModal,context:__WEBPACK_IMPORTED_MODULE_1__context_TesseractDeviceOverviewContext__["a" /* TesseractDeviceOverviewContext */],reducer:'UPDATE_MONITORING_DATA'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["d" /* injectIntl */])(TesseractDeviceOverview));

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_TesseractDeviceOverviewContext__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddTesseractSingleDeviceModal=function AddTesseractSingleDeviceModal(props){var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_TesseractDeviceOverviewContext__["a" /* TesseractDeviceOverviewContext */]),viewModel=_useContext2.viewModel,dispatch=_useContext2.dispatch;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),name=_useState4[0],setName=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),mac=_useState6[0],setMac=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),ip=_useState8[0],setIp=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),port=_useState10[0],setPort=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),deviceType=_useState12[0],setDeviceType=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),id=_useState14[0],setId=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),vendor=_useState16[0],setVendor=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),specVersion=_useState18[0],setSpecVersion=_useState18[1];// Error
var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState20=_slicedToArray(_useState19,2),nameErr=_useState20[0],setNameErr=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),macErr=_useState22[0],setMacErr=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),ipErr=_useState24[0],setIpErr=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),portErr=_useState26[0],setPortErr=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),deviceTypeErr=_useState28[0],setDeviceTypeErr=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState30=_slicedToArray(_useState29,2),idErr=_useState30[0],setIdErr=_useState30[1];var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState32=_slicedToArray(_useState31,2),vendorErr=_useState32[0],setVendorErr=_useState32[1];var _useState33=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState34=_slicedToArray(_useState33,2),specVersionErr=_useState34[0],setSpecVersionErr=_useState34[1];var initialMonitoringValue={startTime:"0",endTime:"0",reason:""};var _useState35=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(JSON.stringify(initialMonitoringValue)),_useState36=_slicedToArray(_useState35,2),monitoring=_useState36[0],setMonitoring=_useState36[1];var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext3.showCustomAlert;var stateValues={name:name,mac:mac,ip:ip,port:port,deviceType:deviceType,deviceConfig:{type:__WEBPACK_IMPORTED_MODULE_3__util_Util__["e" /* assetTypeToConfigTypeDict */].typeTESSERACT,id:id},vendorAttributes:{vendor:vendor,spec_version:specVersion},monitoring:monitoring};var onClickConfirm=function onClickConfirm(stateValues){if(Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["_0" /* validateNewTesseractDevice */])(stateValues)){showWarning(Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"device.editWarning"}),function(){setShowAlert(false);stateValues.deviceConfig=JSON.stringify(stateValues.deviceConfig);if(selected){stateValues.testConfig=JSON.stringify(viewModel.testConfig[stateValues.mac]);updateData(stateValues);}else{addData(stateValues);}resetInputState();setOpen(false);});}else{setShowAlert(true);}};var addData=function addData(stateValues){dispatch({type:'ADD_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues,showCustomAlert:showCustomAlert}});};var updateData=function updateData(stateValues){dispatch({type:'UPDATE_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues,showCustomAlert:showCustomAlert}});};var onCloseModal=function onCloseModal(){setOpen(false);setSelected("");resetInputState();setShowAlert(false);};function resetInputState(){// setting state of input fields as empty to have empty inputs on clicking Add Device again
setMac("");setMacErr(false);setMonitoring(JSON.stringify(initialMonitoringValue));resetAssetDetails();resetAssetDetailErrors();}var resetAssetDetails=function resetAssetDetails(){setName("");setIp("");setPort("");setDeviceType("");setId("");setVendor("");setSpecVersion("");};var resetAssetDetailErrors=function resetAssetDetailErrors(){setNameErr(false);setIpErr(false);setPortErr(false);setDeviceTypeErr(false);setIdErr(false);setVendorErr(false);setSpecVersionErr(false);};var prefill=function prefill(value){if(viewModel.tesseractDeviceInformation.hasOwnProperty(value)){setSelected(value);var device=viewModel.tesseractDeviceInformation[value];var vendorAttributes=device.vendorAttributes;resetAssetDetailErrors();setName(device.name);setMac(device.mac);setIp(device.ip);setPort(device.port);setDeviceType(device.deviceType);setId(device.id);setVendor(vendorAttributes.vendor);setSpecVersion(vendorAttributes.spec_version);var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};setMonitoring(JSON.stringify(deviceMonitoring));}else if(selected){setSelected("");resetAssetDetails();}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal___default.a,{title:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"device.add_device_button_modal"}),open:open,onOpen:function onOpen(){return prefill(selected);},onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.mac"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"mac-input",value:mac,onChange:setMac,mask:__WEBPACK_IMPORTED_MODULE_4__util_Validations__["i" /* MAC_MASK */],disabled:selected,onBlur:function onBlur(){setMacErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.mac,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].MAC));prefill(mac);},error:macErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"ip-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.ip"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"ip-input",value:ip,onChange:setIp,onBlur:function onBlur(){return setIpErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.ip,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["g" /* IP_ADDRESS_PATTERN */]));},error:ipErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"port-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.port"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"port-input",value:port,onChange:setPort,onBlur:function onBlur(){return setPortErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.port,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].PORT));},error:portErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.protocol"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{id:"device-type-input",value:deviceType,onChange:function onChange(value){return setDeviceType(value);},onBlur:function onBlur(){return setDeviceTypeErr(!deviceType);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.select_protocol"}),error:deviceTypeErr,width:"100%"},__WEBPACK_IMPORTED_MODULE_4__util_Validations__["k" /* PROTOCOLS */].TESSERACT.map(function(protocol){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{key:protocol,value:protocol,label:protocol});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"name-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"name-input",value:name,onChange:setName,onBlur:function onBlur(){return setNameErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.name,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].NAME));},error:nameErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.name_cluster_desc"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"id-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.device_id"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"id-input",value:id,onChange:setId,onBlur:function onBlur(){return setIdErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.deviceConfig.id,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].DEVICE_ID));},error:idErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.device_id_cluster_desc"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{id:"device-type-input",value:vendor,onChange:function onChange(value){return setVendor(value);},onBlur:function onBlur(){return setVendorErr(!vendor);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_vendor'}),error:vendorErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["r" /* VENDOR_INFO_KEYS */].VENDOR).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_4__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.spec_version'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{id:"device-type-input",value:specVersion,onChange:function onChange(value){return setSpecVersion(value);},onBlur:function onBlur(){return setSpecVersionErr(!specVersion);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_version'}),error:specVersionErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["r" /* VENDOR_INFO_KEYS */].SPEC_VERSION).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_4__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][value]});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default.a,{type:"warning",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'alert.missingfields'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.cancel'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stateValues);}},selected?Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.confirmEdit'}):Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.confirmAdd'})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddTesseractSingleDeviceModal));

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_ZancaSortDeviceOverviewContext__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonui_ConfigurationTabHeader__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rollback_RollbackModal__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonui_PaginatedTable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_arrow_right_large__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_arrow_right_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_arrow_right_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modal_AddZancaSortTestPackageModal__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modal_AddZancaSortLocationConfigurationModal__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modal_DeleteZancaSortLocationConfigurationModal__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__util_Parsers__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__commonui_UploadFileModal__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__amzn_meridian_tokens_base_icon_upload_small__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__amzn_meridian_tokens_base_icon_upload_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__amzn_meridian_tokens_base_icon_upload_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__commonui_DeleteTestPackageConfigurationModal__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__modal_AddZancaSortTierConfigModal__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__modal_DeleteZancaSortTierConfigurationModal__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__util_FeatureUtility__ = __webpack_require__(63);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var ZancaSortDeviceConfiguration=function ZancaSortDeviceConfiguration(_ref){var intl=_ref.intl;var isNewZancasortTestConfigEnabled=__WEBPACK_IMPORTED_MODULE_34__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_34__util_FeatureUtility__["a" /* FEATURES */].IS_NEW_ZANCASORT_TEST_CONFIG_ENABLED);//Add Context
var _useContext=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__context_ZancaSortDeviceOverviewContext__["a" /* ZancaSortDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext2.getDraftData,setDraftData=_useContext2.setDraftData,resetDraftData=_useContext2.resetDraftData,getFilteredDraftData=_useContext2.getFilteredDraftData,isDataEdited=_useContext2.isDataEdited;var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_25__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext3.showCustomAlert;var _useState=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),selectedMac=_useState2[0],setSelectedMac=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),valueConfiguration=_useState4[0],setValueConfiguration=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])([]),_useState6=_slicedToArray(_useState5,2),rollBackVersions=_useState6[0],setRollbackVersions=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),isVersionsLoading=_useState8[0],setIsVersionsLoading=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),selectedVersion=_useState10[0],setSelectedVersion=_useState10[1];// Modal state
var _useState11=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),showRollbackModal=_useState12[0],setShowRollbackModal=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),openAddModal=_useState14[0],setOpenAddModal=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),openDeleteModal=_useState16[0],setOpenDeleteModal=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState18=_slicedToArray(_useState17,2),openCSVModal=_useState18[0],setOpenCSVModal=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState20=_slicedToArray(_useState19,2),openAddLocationModal=_useState20[0],setOpenAddLocationModal=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),openDeleteLocationModal=_useState22[0],setOpenDeleteLocationModal=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),openLocationCSVModal=_useState24[0],setOpenLocationCSVModal=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),openAddTierModal=_useState26[0],setOpenAddTierModal=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),openTierCSVModal=_useState28[0],setOpenTierCSVModal=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState30=_slicedToArray(_useState29,2),openDeleteTierModal=_useState30[0],setOpenDeleteTierModal=_useState30[1];// Search row state values
var _useState31=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(''),_useState32=_slicedToArray(_useState31,2),scannablesSearchInput=_useState32[0],setScannablesSearchInput=_useState32[1];var _useState33=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(''),_useState34=_slicedToArray(_useState33,2),destinationSearchInput=_useState34[0],setDestinationSearchInput=_useState34[1];var _useState35=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(''),_useState36=_slicedToArray(_useState35,2),containerListSearchInput=_useState36[0],setContainerListSearchInput=_useState36[1];var _useState37=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(''),_useState38=_slicedToArray(_useState37,2),locationIdSearchInput=_useState38[0],setLocationIdSearchInput=_useState38[1];var _useState39=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(''),_useState40=_slicedToArray(_useState39,2),locationTypeSearchInput=_useState40[0],setLocationTypeSearchInput=_useState40[1];//Data Sort prefs for test config table
var _useState41=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])("destination"),_useState42=_slicedToArray(_useState41,2),testConfigSortColumn=_useState42[0],setTestConfigSortColumn=_useState42[1];var _useState43=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(__WEBPACK_IMPORTED_MODULE_9__util_Constants__["J" /* ASCENDING */]),_useState44=_slicedToArray(_useState43,2),testConfigSortOrder=_useState44[0],setTestConfigSortOrder=_useState44[1];//Data Sort prefs for destination config table
var _useState45=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])("locationId"),_useState46=_slicedToArray(_useState45,2),locationConfigSortColumn=_useState46[0],setLocationConfigSortColumn=_useState46[1];var _useState47=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(__WEBPACK_IMPORTED_MODULE_9__util_Constants__["J" /* ASCENDING */]),_useState48=_slicedToArray(_useState47,2),locationConfigSortOrder=_useState48[0],setLocationConfigSortOrder=_useState48[1];//Data Sort prefs for tier config table
var _useState49=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])("tierName"),_useState50=_slicedToArray(_useState49,2),tierConfigSortColumn=_useState50[0],setTierConfigSortColumn=_useState50[1];var _useState51=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(__WEBPACK_IMPORTED_MODULE_9__util_Constants__["J" /* ASCENDING */]),_useState52=_slicedToArray(_useState51,2),tierConfigSortOrder=_useState52[0],setTierConfigSortOrder=_useState52[1];// Search row state values for tier config
var _useState53=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(''),_useState54=_slicedToArray(_useState53,2),tierNameSearchInput=_useState54[0],setTierNameSearchInput=_useState54[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(null);var PAGE_CONFIGURATION_KEYS=[__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION,__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_LOCATION_CONFIGURATION,__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TIER_CONFIGURATION];Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function(){if(!openAddModal&&!openDeleteModal&&!openAddLocationModal&&!openDeleteLocationModal&&!openLocationCSVModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["D" /* getAssetRefreshInterval */])());return function(){return clearInterval(interval);};}},[openAddModal,openDeleteModal,openAddLocationModal,openDeleteLocationModal,openLocationCSVModal]);Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function(){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return viewModel.testConfig[selectedMac];},[]),stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION,subKey:selectedMac});setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return viewModel.locationConfig[selectedMac];},[]),stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_LOCATION_CONFIGURATION,subKey:selectedMac});setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return viewModel.tierConfig[selectedMac];},[]),stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TIER_CONFIGURATION,subKey:selectedMac});},[selectedMac]);var getData=function getData(){if(isDataEdited(PAGE_CONFIGURATION_KEYS))return;setOpenAddModal(false);setOpenDeleteModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var getModalContent=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var versionsData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setIsVersionsLoading(true);_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_10__resources_AssetResource__["f" /* getAssetVersions */])(selectedMac);case 3:versionsData=_context.sent;setRollbackVersions(versionsData.data.assetVersionDetailsList);setIsVersionsLoading(false);case 6:case"end":return _context.stop();}}},_callee,_this);}));return function getModalContent(){return _ref2.apply(this,arguments);};}();var loadRollbackDataToDraft=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var rollbackData,testConfigData,locationConfigData,tierConfigData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10__resources_AssetResource__["e" /* getAssetByVersion */])(selectedMac,selectedVersion);case 2:rollbackData=_context2.sent;testConfigData=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.testConfig);},[]);locationConfigData=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.locationConfig);},[]);tierConfigData=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){var raw=JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.tierConfig);return Object.entries(raw).map(function(_ref4){var _ref5=_slicedToArray(_ref4,2),tierName=_ref5[0],val=_ref5[1];return{tierName:tierName,capacity:val.capacity,startLevel:parseInt(val.levels.split(':')[0],10),endLevel:parseInt(val.levels.split(':')[1],10)};});},[]);if(testConfigData.length){setDraftData({data:testConfigData,stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION,subKey:selectedMac,allRowsAdded:true,override:true});}if(locationConfigData.length){setDraftData({data:locationConfigData,stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_LOCATION_CONFIGURATION,subKey:selectedMac,allRowsAdded:true,override:true});}if(tierConfigData.length){setDraftData({data:tierConfigData,stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TIER_CONFIGURATION,subKey:selectedMac,allRowsAdded:true,override:true});}case 9:case"end":return _context2.stop();}}},_callee2,_this);}));return function loadRollbackDataToDraft(){return _ref3.apply(this,arguments);};}();var updateTestConfigDraftData=function updateTestConfigDraftData(stowTestPackage){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return stowTestPackage;},[]),stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION,subKey:selectedMac,allRowsAdded:true,override:true});};var updateLocationConfigDraftData=function updateLocationConfigDraftData(locationConfig){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return locationConfig;},[]),stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_LOCATION_CONFIGURATION,subKey:selectedMac,allRowsAdded:true,override:true});};var updateTierConfigDraftData=function updateTierConfigDraftData(tierConfig){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return tierConfig;},[]),stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TIER_CONFIGURATION,subKey:selectedMac,allRowsAdded:true,override:true});};var deployDraftZancaSortAsset=function deployDraftZancaSortAsset(){var testPackageList=getFilteredDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION,subKey:selectedMac});var locationConfigList=getFilteredDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_LOCATION_CONFIGURATION,subKey:selectedMac});var tierConfigs=getFilteredDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TIER_CONFIGURATION,subKey:selectedMac});dispatch({type:'UPDATE_ZANCA_SORT_CONFIGURATION',data:{dispatcher:dispatch,showCustomAlert:showCustomAlert,configurations:{testConfig:testPackageList,locationConfig:locationConfigList,tierConfig:tierConfigs},mac:selectedMac}});setDraftData({data:testPackageList,stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION,subKey:selectedMac,override:true});setDraftData({data:locationConfigList,stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_LOCATION_CONFIGURATION,subKey:selectedMac,override:true});setDraftData({data:tierConfigs,stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TIER_CONFIGURATION,subKey:selectedMac,override:true});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var sortTestConfigColumns={scannables:function scannables(a,b,ascending){var scannableFirst=Array.isArray(a.scannables)?a.scannables.join(' '):a.scannables;var scannableSecond=Array.isArray(b.scannables)?b.scannables.join(' '):b.scannables;return ascending?Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(scannableFirst,scannableSecond):-Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(scannableFirst,scannableSecond);},destination:function destination(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(a.destination,b.destination):-Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(a.destination,b.destination);},containerList:function containerList(a,b,ascending){var containerListFirst=a&&a.containerList?Array.isArray(a.containerList)?a.containerList.join(' '):a.containerList:'';var containerListSecond=b&&b.containerList?Array.isArray(b.containerList)?b.containerList.join(' '):b.containerList:'';return ascending?Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(containerListFirst,containerListSecond):-Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(containerListFirst,containerListSecond);}};var sortLocationConfigColumns={locationId:function locationId(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(a.locationId,b.locationId):-Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(a.locationId,b.locationId);},locationType:function locationType(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(a.locationType,b.locationType):-Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(a.locationType,b.locationType);}};var sortTierConfigColumns={tierName:function tierName(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(a.tierName,b.tierName):-Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(a.tierName,b.tierName);},capacity:function capacity(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(a.capacity,b.capacity):-Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(a.capacity,b.capacity);},startLevel:function startLevel(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(a.startLevel,b.startLevel):-Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(a.startLevel,b.startLevel);},endLevel:function endLevel(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(a.endLevel,b.endLevel):-Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_32" /* sortComparator */])(a.endLevel,b.endLevel);}};var searchDataForTestConfigTable=function searchDataForTestConfigTable(){var data=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION,subKey:selectedMac});data=data.filter(function(item){return Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_13" /* getTestConfigKey */])(item.scannables).toLowerCase().includes(scannablesSearchInput.toLowerCase());});if(isNewZancasortTestConfigEnabled){data=data.filter(function(item){var destination=item&&item.destination;return destination?destination.toLowerCase().includes(destinationSearchInput.toLowerCase()):false;}).filter(function(item){var containerList=item&&item.containerList;var containerListString=containerList?Array.isArray(containerList)?containerList.join(' '):containerList:'';return containerListString.toLowerCase().includes(containerListSearchInput.toLowerCase());});}else{data=data.filter(function(item){return item.destination.toLowerCase().includes(destinationSearchInput.toLowerCase());});}data=data.sort(function(a,b){return sortTestConfigColumns[testConfigSortColumn](a,b,testConfigSortOrder===__WEBPACK_IMPORTED_MODULE_9__util_Constants__["J" /* ASCENDING */]);});return data;};var searchDataForLocationConfigTable=function searchDataForLocationConfigTable(){var data=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_LOCATION_CONFIGURATION,subKey:selectedMac});data=data.filter(function(item){return item.locationId.toLowerCase().includes(locationIdSearchInput.toLowerCase());}).filter(function(item){return item.locationType.toLowerCase().includes(locationTypeSearchInput.toLowerCase());});data=data.sort(function(a,b){return sortLocationConfigColumns[locationConfigSortColumn](a,b,locationConfigSortOrder===__WEBPACK_IMPORTED_MODULE_9__util_Constants__["J" /* ASCENDING */]);});return data;};var searchDataForTierConfigTable=function searchDataForTierConfigTable(){var data=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TIER_CONFIGURATION,subKey:selectedMac});data=data.filter(function(item){return item.tierName.toLowerCase().includes(tierNameSearchInput.toLowerCase());});data=data.sort(function(a,b){return sortTierConfigColumns[tierConfigSortColumn](a,b,tierConfigSortOrder===__WEBPACK_IMPORTED_MODULE_9__util_Constants__["J" /* ASCENDING */]);});return data;};var getSortedDeviceList=function getSortedDeviceList(){// Device List sorted based on device "name"
var sortedDeviceList=Object.values(viewModel.zancaSortDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){if(a.name<b.name){return-1;}else if(b.name>a.name){return 1;}return 0;});return sortedDeviceList;};var getHeaderProps=function getHeaderProps(){return{selectedMac:selectedMac,setSelectedMac:setSelectedMac,valueConfiguration:valueConfiguration,setValueConfiguration:setValueConfiguration,defaultSelection:"",resetDraftData:resetDraftData,deployDraft:deployDraftZancaSortAsset,scrollToBottom:scrollToBottom,sortedDeviceList:getSortedDeviceList(),configurationKeys:PAGE_CONFIGURATION_KEYS,refreshDeps:[viewModel.timestamp],isDeployDisabled:!isDataEdited(PAGE_CONFIGURATION_KEYS),isRollbackDisabled:!selectedMac||isDataEdited(PAGE_CONFIGURATION_KEYS),rollbackClickHandler:function rollbackClickHandler(){getModalContent();setShowRollbackModal(true);}};};function onClickAddSingle(){setOpenAddModal(true);}function onClickUploadCSV(){setOpenCSVModal(true);}function onClickDeleteConfiguration(){setOpenDeleteModal(true);}function onClickAddLocation(){setOpenAddLocationModal(true);}function onClickDeleteLocationConfiguration(){setOpenDeleteLocationModal(true);}function onClickUploadLocationCSV(){setOpenLocationCSVModal(true);}var renderTestConfigTableHeader=function renderTestConfigTableHeader(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"table.index"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],{sortColumn:"scannables"},Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.scannables"})),isNewZancasortTestConfigEnabled?[__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],{sortColumn:"destination"},Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.sortZone"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],{key:"containerList",sortColumn:"containerList"},Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.bag_list"}))]:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],{sortColumn:"destination"},Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.destination"})));};var renderSearchRow=function renderSearchRow(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableRow"],{backgroundColor:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_177" /* SEARCH_ROW_COLOR */]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_input___default.a,{className:"input-search-class",value:scannablesSearchInput,onChange:setScannablesSearchInput,type:"text",placeholder:"Search",width:"70%",size:"small"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_input___default.a,{className:"input-search-class",value:destinationSearchInput,onChange:setDestinationSearchInput,type:"text",placeholder:"Search",width:"70%",size:"small"})),isNewZancasortTestConfigEnabled?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_input___default.a,{className:"input-search-class",value:containerListSearchInput,onChange:setContainerListSearchInput,type:"text",placeholder:"Search",width:"70%",size:"small"})):null);};var renderTestConfigTableRow=function renderTestConfigTableRow(config,serialNumber){if(isNewZancasortTestConfigEnabled){var sortZoneString=config.destination;var prevSortZoneString=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return config.prev.destination;},null);var containerListString=config.containerList?Array.isArray(config.containerList)?config.containerList.join(' '):config.containerList:'';var prevContainerListString=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return config.prev.containerList?Array.isArray(config.prev.containerList)?config.prev.containerList.join(' '):config.prev.containerList:null;},null);var sortZoneChanged=prevSortZoneString&&sortZoneString!==prevSortZoneString;var containerListChanged=prevContainerListString&&containerListString!==prevContainerListString;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableRow"],{highlightOnHover:true,backgroundColor:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_148" /* OPERATION_COLOR */][config.operation]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,serialNumber),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,Array.isArray(config.scannables)?config.scannables.join(' '):config.scannables),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,sortZoneChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",prevSortZoneString," "),sortZoneChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",sortZoneString," ")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,containerListChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",prevContainerListString," "),containerListChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",containerListString," ")));}else{var dataString=config.destination;var prevDataString=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return config.prev.destination;},null);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableRow"],{highlightOnHover:true,backgroundColor:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_148" /* OPERATION_COLOR */][config.operation]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,serialNumber),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,Array.isArray(config.scannables)?config.scannables.join(' '):config.scannables),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,prevDataString&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",prevDataString," "),prevDataString&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",dataString," ")));}};var renderLocationConfigTableRow=function renderLocationConfigTableRow(config){var locationIdString=config.locationId;var prevLocationIdString=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return config.prev.locationId;},null);var locationTypeString=config.locationType;var prevLocationTypeString=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return config.prev.locationType;},null);var locationIdChanged=prevLocationIdString&&locationIdString!==prevLocationIdString;var locationTypeChanged=prevLocationTypeString&&locationTypeString!==prevLocationTypeString;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableRow"],{highlightOnHover:true,backgroundColor:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_148" /* OPERATION_COLOR */][config.operation]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,locationIdChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",prevLocationIdString," "),locationIdChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",locationIdString," ")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,locationTypeChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",prevLocationTypeString," "),locationTypeChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",locationTypeString," ")));};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonui_ConfigurationTabHeader__["a" /* default */],getHeaderProps()),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__rollback_RollbackModal__["a" /* default */],{showRollbackModal:showRollbackModal,setShowRollbackModal:setShowRollbackModal,isVersionsLoading:isVersionsLoading,selectedVersion:selectedVersion,setSelectedVersion:setSelectedVersion,rollBackVersions:rollBackVersions,loadRollbackDataToDraft:loadRollbackDataToDraft,intl:intl}),valueConfiguration===__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION&&selectedMac&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonui_PaginatedTable__["a" /* default */],{data:searchDataForTestConfigTable(),renderHeader:renderTestConfigTableHeader,renderSearchRow:renderSearchRow,renderRow:renderTestConfigTableRow,sortColumn:testConfigSortColumn,sortDirection:testConfigSortOrder,onSort:function onSort(_ref6){var sortColumn=_ref6.sortColumn,sortDirection=_ref6.sortDirection;setTestConfigSortColumn(sortColumn);setTestConfigSortOrder(sortDirection);}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default.a,{width:"100%",widths:["100","100","fill","100"]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default.a,{onClick:onClickAddSingle,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_plus_circle___default.a}),Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowtestconfig.addupdate"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default.a,{onClick:onClickUploadCSV,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_28__amzn_meridian_tokens_base_icon_upload_small___default.a}),Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowtestconfig.uploadCSV"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default.a,{onClick:onClickDeleteConfiguration,size:"small",type:"tertiary"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_30__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowtestconfig.deleteconfig"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__modal_AddZancaSortTestPackageModal__["a" /* default */],{mac:selectedMac,open:openAddModal,setOpen:setOpenAddModal}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__commonui_UploadFileModal__["a" /* default */],{mac:selectedMac,open:openCSVModal,setOpen:setOpenCSVModal,parser:__WEBPACK_IMPORTED_MODULE_26__util_Parsers__["m" /* ZancaSortTestConfigCSVParser */],updateConfig:updateTestConfigDraftData}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__commonui_DeleteTestPackageConfigurationModal__["a" /* default */],{mac:selectedMac,testConfig:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION,open:openDeleteModal,setOpen:setOpenDeleteModal}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{ref:tableEndRef})),valueConfiguration===__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_LOCATION_CONFIGURATION&&selectedMac&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonui_PaginatedTable__["a" /* default */],{data:searchDataForLocationConfigTable(),renderHeader:function renderHeader(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"location.id"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"location.type"})));},renderSearchRow:function renderSearchRow(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableRow"],{backgroundColor:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_177" /* SEARCH_ROW_COLOR */]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_input___default.a,{className:"input-search-class",value:locationIdSearchInput,onChange:setLocationIdSearchInput,type:"text",placeholder:"Search",width:"70%",size:"small"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_input___default.a,{className:"input-search-class",value:locationTypeSearchInput,onChange:setLocationTypeSearchInput,type:"text",placeholder:"Search",width:"70%",size:"small"})));},renderRow:renderLocationConfigTableRow,sortColumn:locationConfigSortColumn,sortDirection:locationConfigSortOrder,onSort:function onSort(_ref7){var sortColumn=_ref7.sortColumn,sortDirection=_ref7.sortDirection;setLocationConfigSortColumn(sortColumn);setLocationConfigSortOrder(sortDirection);}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default.a,{width:"100%",widths:["100","100","fill","100"]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default.a,{onClick:onClickAddLocation,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_plus_circle___default.a}),Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationconfig.addupdate"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default.a,{onClick:onClickUploadLocationCSV,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_28__amzn_meridian_tokens_base_icon_upload_small___default.a}),Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationconfig.uploadCSV"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default.a,{onClick:onClickDeleteLocationConfiguration,size:"small",type:"tertiary"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_30__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationconfig.deleteconfig"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__modal_AddZancaSortLocationConfigurationModal__["a" /* default */],{mac:selectedMac,open:openAddLocationModal,setOpen:setOpenAddLocationModal}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__commonui_UploadFileModal__["a" /* default */],{mac:selectedMac,open:openLocationCSVModal,setOpen:setOpenLocationCSVModal,parser:__WEBPACK_IMPORTED_MODULE_26__util_Parsers__["l" /* ZancaSortLocationConfigCSVParser */],updateConfig:updateLocationConfigDraftData}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__modal_DeleteZancaSortLocationConfigurationModal__["a" /* default */],{mac:selectedMac,open:openDeleteLocationModal,setOpen:setOpenDeleteLocationModal}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{ref:tableEndRef})),valueConfiguration===__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TIER_CONFIGURATION&&selectedMac&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonui_PaginatedTable__["a" /* default */],{data:searchDataForTierConfigTable(),renderHeader:function renderHeader(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],{sortColumn:"tierName"},Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tierconfig.tierName"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],{sortColumn:"capacity"},Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tierconfig.capacity"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],{sortColumn:"startLevel"},Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tierconfig.startLevel"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],{sortColumn:"endLevel"},Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tierconfig.endLevel"})));},renderSearchRow:function renderSearchRow(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableRow"],{backgroundColor:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_177" /* SEARCH_ROW_COLOR */]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_input___default.a,{className:"input-search-class",value:tierNameSearchInput,onChange:setTierNameSearchInput,type:"text",placeholder:"Search",width:"70%",size:"small"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null));},renderRow:function renderRow(config){var tierNameString=config.tierName;var prevTierNameString=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return config.prev.tierName;},null);var capacityChanged=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return config.prev.capacity;},null)!==null&&config.capacity!==config.prev.capacity;var startLevelChanged=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return config.prev.startLevel;},null)!==null&&config.startLevel!==config.prev.startLevel;var endLevelChanged=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["f" /* chainWalk */])(function(){return config.prev.endLevel;},null)!==null&&config.endLevel!==config.prev.endLevel;var tierNameChanged=prevTierNameString&&tierNameString!==prevTierNameString;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableRow"],{highlightOnHover:true,backgroundColor:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_148" /* OPERATION_COLOR */][config.operation]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,tierNameChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",prevTierNameString," "),tierNameChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",tierNameString," ")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,capacityChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",config.prev.capacity," "),capacityChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",config.capacity," ")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,startLevelChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",config.prev.startLevel," "),startLevelChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",config.startLevel," ")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_table__["TableCell"],null,endLevelChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",config.prev.endLevel," "),endLevelChanged&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_text___default.a,null," ",config.endLevel," ")));},sortColumn:tierConfigSortColumn,sortDirection:tierConfigSortOrder,onSort:function onSort(_ref8){var sortColumn=_ref8.sortColumn,sortDirection=_ref8.sortDirection;setTierConfigSortColumn(sortColumn);setTierConfigSortOrder(sortDirection);}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default.a,{width:"100%",widths:["100","100","fill","100"]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default.a,{onClick:function onClick(){return setOpenAddTierModal(true);},type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_plus_circle___default.a}),Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tierconfig.addupdate"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default.a,{onClick:function onClick(){return setOpenTierCSVModal(true);},type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_28__amzn_meridian_tokens_base_icon_upload_small___default.a}),Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tierconfig.uploadCSV"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default.a,{onClick:function onClick(){return setOpenDeleteTierModal(true);},size:"small",type:"tertiary"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_30__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_18__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tierconfig.deleteconfig"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__modal_AddZancaSortTierConfigModal__["a" /* default */],{mac:selectedMac,open:openAddTierModal,setOpen:setOpenAddTierModal}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__commonui_UploadFileModal__["a" /* default */],{mac:selectedMac,open:openTierCSVModal,setOpen:setOpenTierCSVModal,parser:__WEBPACK_IMPORTED_MODULE_26__util_Parsers__["n" /* ZancaSortTierConfigCSVParser */],updateConfig:updateTierConfigDraftData}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__modal_DeleteZancaSortTierConfigurationModal__["a" /* default */],{mac:selectedMac,open:openDeleteTierModal,setOpen:setOpenDeleteTierModal}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ZancaSortDeviceConfiguration));

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_FeatureUtility__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__global_context_GlobalStateContext__ = __webpack_require__(33);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddZancaSortTestPackageModal=function AddZancaSortTestPackageModal(props){var mac=props.mac,intl=props.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,addInstance=_useContext.addInstance,editInstance=_useContext.editInstance;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_15__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext2.showCustomAlert;var isNewZancasortTestConfigEnabled=__WEBPACK_IMPORTED_MODULE_14__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_14__util_FeatureUtility__["a" /* FEATURES */].IS_NEW_ZANCASORT_TEST_CONFIG_ENABLED);// Visual controls
var open=props.open,setOpen=props.setOpen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),show=_useState2[0],setShow=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),edit=_useState4[0],setEdit=_useState4[1];// Values
var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),scannables=_useState6[0],setScannables=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),destination=_useState8[0],setDestination=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),containerList=_useState10[0],setContainerList=_useState10[1];// Error
var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),scannablesErr=_useState12[0],setScannablesErr=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),destinationErr=_useState14[0],setDestinationErr=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),containerListErr=_useState16[0],setContainerListErr=_useState16[1];var setConfigData=function setConfigData(stowTestPackage,mac){if(isNewZancasortTestConfigEnabled){var existingData=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION,subKey:mac});var currentKey=edit?Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_13" /* getTestConfigKey */])(stowTestPackage.scannables):null;var duplicateScannables=Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["v" /* checkDuplicateScannables */])(stowTestPackage.scannables,existingData,currentKey);if(duplicateScannables.length>0){var errorMsg=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"testconfig.error.duplicatescannables",values:{scannableIds:duplicateScannables.join(", ")},defaultMessage:"Duplicate scannables found: {scannableIds}"});showCustomAlert(errorMsg,__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_122" /* MERIDIAN_ALERT_TYPE */].ERROR);return;}var duplicateContainers=Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["t" /* checkContainerDestinationConflicts */])(stowTestPackage.containerList,stowTestPackage.destination,existingData,currentKey);if(duplicateContainers.length>0){var _errorMsg=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:"testconfig.error.duplicatebagtosz",values:{containerId:duplicateContainers},defaultMessage:"Bag is already mapped to a different sort zone."});showCustomAlert(_errorMsg,__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_122" /* MERIDIAN_ALERT_TYPE */].ERROR);return;}}if(edit){if(isNewZancasortTestConfigEnabled){editInstance({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION,subKey:mac,instance:stowTestPackage,keyComparator:function keyComparator(config1,config2){return Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_13" /* getTestConfigKey */])(config1.scannables)===Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_13" /* getTestConfigKey */])(config2.scannables);},valueComparator:function valueComparator(config1,config2){return config1.destination===config2.destination&&Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_13" /* getTestConfigKey */])(config1.containerList)===Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_13" /* getTestConfigKey */])(config2.containerList);}});}else{editInstance({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION,subKey:mac,instance:stowTestPackage,keyComparator:function keyComparator(config1,config2){return config1.destination===config2.destination;},valueComparator:function valueComparator(config1,config2){return Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_13" /* getTestConfigKey */])(config1.scannables)===Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_13" /* getTestConfigKey */])(config2.scannables);}});}}else{addInstance({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION,subKey:mac,instance:stowTestPackage});}};var stowTestPackage=isNewZancasortTestConfigEnabled?{scannables:scannables.split(';').filter(Boolean),destination:destination,containerList:containerList?containerList.split(';').filter(Boolean):[]}:{scannables:scannables.split(';').filter(Boolean),destination:destination};var testConfigMap={};getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION,subKey:mac}).forEach(function(value){if(isNewZancasortTestConfigEnabled){testConfigMap[value.destination]={scannables:Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_13" /* getTestConfigKey */])(value.scannables),containerList:Array.isArray(value.containerList)?value.containerList.join(';'):''};}else{testConfigMap[value.destination]={scannables:Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_13" /* getTestConfigKey */])(value.scannables)};}});var resetConfigDetails=function resetConfigDetails(){if(isNewZancasortTestConfigEnabled){setDestination("");setContainerList("");}else{setDestination("");}};var resetConfigErrorDetails=function resetConfigErrorDetails(){if(isNewZancasortTestConfigEnabled){setDestinationErr(false);setContainerListErr(false);}else{setDestinationErr(false);}};function resetInputState(){setScannables("");resetConfigDetails();resetConfigErrorDetails();}function onCloseModal(){setShow(false);setOpen(false);resetInputState();}var prefill=function prefill(){if(isNewZancasortTestConfigEnabled){// Get all existing data
var existingData=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TEST_CONFIGURATION,subKey:mac});// Look for entry with exactly matching scannables
var matchingEntry=existingData.find(function(entry){return Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_13" /* getTestConfigKey */])(entry.scannables)===Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_13" /* getTestConfigKey */])(scannables.split(';').filter(Boolean));});if(matchingEntry){setEdit(true);resetConfigErrorDetails();setDestination(matchingEntry.destination||'');setContainerList(Array.isArray(matchingEntry.containerList)?matchingEntry.containerList.join(';'):'');}else{setEdit(false);resetConfigDetails();}}else{var key=stowTestPackage.destination;if(testConfigMap.hasOwnProperty(key)){setEdit(true);resetConfigErrorDetails();setScannables(testConfigMap[key].scannables);}else if(edit){setEdit(false);resetConfigDetails();}}};var onClickConfirm=function onClickConfirm(stowTestPackage,mac){if(Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["D" /* checkZancaSortAddTestPackageModalValidations */])(stowTestPackage)){setConfigData(stowTestPackage,mac);setOpen(false);resetInputState();setShow(false);}else{setShow(true);}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal___default.a,{title:Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowtestconfig.addupdate"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.headingtest"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.scannables"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"scannables-input",value:scannables,onChange:function onChange(value){setScannables(value.replace(/\s/g,''));},onBlur:function onBlur(){setScannablesErr(!Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["L" /* isValidEntry */])(scannables,__WEBPACK_IMPORTED_MODULE_8__util_Validations__["j" /* PATTERNS */].TEST_SCANNABLE));if(isNewZancasortTestConfigEnabled){prefill();}},error:scannablesErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.scannables_description"})})),isNewZancasortTestConfigEnabled?[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.sortZone"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"destination-input",value:destination,onChange:setDestination,onBlur:function onBlur(){setDestinationErr(!Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["L" /* isValidEntry */])(destination,__WEBPACK_IMPORTED_MODULE_8__util_Validations__["j" /* PATTERNS */].SORT_LOCATION));},error:destinationErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.destination_sort_zone_description"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.bag_list"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"containers-input",value:containerList,onChange:function onChange(value){setContainerList(value.replace(/\s/g,''));},onBlur:function onBlur(){setContainerListErr(!Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["L" /* isValidEntry */])(containerList,__WEBPACK_IMPORTED_MODULE_8__util_Validations__["j" /* PATTERNS */].BAG_LIST));},error:containerListErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.destination_bag_description"})}))]:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.destination"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"destination-input",value:destination,onChange:setDestination,onBlur:function onBlur(){setDestinationErr(!Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["L" /* isValidEntry */])(destination,__WEBPACK_IMPORTED_MODULE_8__util_Validations__["j" /* PATTERNS */].BAG_LABEL));prefill();},error:destinationErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.destination_bag_description"})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,null,!Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["D" /* checkZancaSortAddTestPackageModalValidations */])(stowTestPackage)&&show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_alert___default.a,{type:"warning",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.missingfields"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stowTestPackage,mac);}},edit?Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirmUpdate"}):Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirmAdd"}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(AddZancaSortTestPackageModal));

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddZancaSortLocationConfigurationModal=function AddZancaSortLocationConfigurationModal(props){var formatMessage=props.intl.formatMessage;var mac=props.mac,intl=props.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,addInstance=_useContext.addInstance,editInstance=_useContext.editInstance;// Visual controls
var open=props.open,setOpen=props.setOpen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),show=_useState2[0],setShow=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),edit=_useState4[0],setEdit=_useState4[1];// Values
var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),locationId=_useState6[0],setLocationId=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),locationType=_useState8[0],setLocationType=_useState8[1];// Error
var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),locationIdErr=_useState10[0],setLocationIdErr=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),locationTypeErr=_useState12[0],setLocationTypeErr=_useState12[1];var onCloseModal=function onCloseModal(){setShow(false);setOpen(false);resetInputState();};var modalLocationConfig={locationId:locationId,locationType:locationType/* Filling a map: locationConfigMap with locationId as key in case of an update of existing config */};var locationConfigMap={};getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_LOCATION_CONFIGURATION,subKey:mac}).forEach(function(value){locationConfigMap[value.locationId]={locationType:value.locationType};});var checkValidations=function checkValidations(){return locationId.trim()!==""&&locationType!=="";};var onClickConfirm=function onClickConfirm(modalLocationConfig,mac){if(checkValidations()){setConfigData(modalLocationConfig,mac);setOpen(false);resetInputState();setShow(false);}else{setShow(true);}};function resetInputState(){setLocationId("");setLocationIdErr(false);setLocationType("");setLocationTypeErr(false);setEdit(false);}var prefill=function prefill(){if(locationConfigMap.hasOwnProperty(locationId)){setEdit(true);setLocationType(locationConfigMap[locationId].locationType);setLocationTypeErr(false);}else if(edit){setEdit(false);setLocationType("");}};var setConfigData=function setConfigData(modalLocationConfig,mac){if(edit){editInstance({stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_LOCATION_CONFIGURATION,subKey:mac,instance:modalLocationConfig,keyComparator:function keyComparator(config1,config2){return config1.locationId===config2.locationId;},valueComparator:function valueComparator(config1,config2){return config1.locationType===config2.locationType;}});}else{addInstance({stateKey:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_LOCATION_CONFIGURATION,subKey:mac,instance:modalLocationConfig});}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"locationconfig.addupdate"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.addlocationheading",defaultMessage:"To edit an existing configuration, enter the Location Id."}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"location-id-input"},Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"location.id"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"location-id-input",value:locationId,onChange:setLocationId,onBlur:function onBlur(){setLocationIdErr(locationId.trim()==="");prefill();},error:locationIdErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"location-type-input"},Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"location.type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select___default.a,{id:"location-type-input",value:locationType,onChange:setLocationType,onBlur:function onBlur(){setLocationTypeErr(locationType==="");},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.enter_value",defaultMessage:"Enter value..."}),width:"100%",error:locationTypeErr},Object.values(__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_223" /* ZANCASORT_LOCATION_TYPES */]).map(function(_ref,index){var label=_ref.label,value=_ref.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select__["SelectOption"],{key:index,value:value,label:label});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,!checkValidations()&&show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(modalLocationConfig,mac);}},edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmUpdate",defaultMessage:"Confirm update"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddZancaSortLocationConfigurationModal));

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_escapeRegExp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_escapeRegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_escapeRegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Constants__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DeleteZancaSortLocationConfigurationModal=function DeleteZancaSortLocationConfigurationModal(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,deleteInstance=_useContext.deleteInstance,deleteAll=_useContext.deleteAll;var open=props.open,setOpen=props.setOpen,mac=props.mac,intl=props.intl;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),selectedLocationId=_useState2[0],setSelectedLocationId=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),searchQuery=_useState4[0],setSearchQuery=_useState4[1];var locationIdList=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_13__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_LOCATION_CONFIGURATION,subKey:mac}).map(function(_ref){var locationId=_ref.locationId;return locationId;});var searchRegExp=new RegExp(__WEBPACK_IMPORTED_MODULE_11_lodash_escapeRegExp___default()(searchQuery),"i");var matchedKeys=locationIdList.filter(function(option){return!searchQuery||searchRegExp.test(option);});var deleteData=function deleteData(){deleteInstance({stateKey:__WEBPACK_IMPORTED_MODULE_13__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_LOCATION_CONFIGURATION,subKey:mac,keyComparator:function keyComparator(instance){return instance.locationId===selectedLocationId;}});};var onClickConfirm=function onClickConfirm(){deleteData();setOpen(false);resetInputState();};function resetInputState(){setSelectedLocationId("");}var onCloseModal=function onCloseModal(){setOpen(false);resetInputState();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal___default.a,{title:Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationconfig.deleteconfig"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.delete_location_config"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default.a,{value:selectedLocationId,onChange:setSelectedLocationId,searchQuery:searchQuery,onSearch:setSearchQuery,placeholder:Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationconfig.delete"}),width:"100%"},matchedKeys.map(function(locationId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__["SelectOption"],{key:locationId,value:locationId,label:locationId});}),!matchedKeys.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},locationIdList.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{alignment:"center"},Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"testconfig.nomatch"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{alignment:"center"},Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"testconfig.notavailable"}))):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{size:"small",className:"redBtn",onClick:function onClick(){deleteAll({stateKey:__WEBPACK_IMPORTED_MODULE_13__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_LOCATION_CONFIGURATION,subKey:mac});onCloseModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.deleteAll"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{type:"secondary",size:"small",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:onClickConfirm},Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirm"})))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_intl__["d" /* injectIntl */])(DeleteZancaSortLocationConfigurationModal));

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Validations__ = __webpack_require__(15);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var AddZancaSortTierConfigModal=function AddZancaSortTierConfigModal(props){var mac=props.mac,intl=props.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,addInstance=_useContext.addInstance,editInstance=_useContext.editInstance;// Visual controls
var open=props.open,setOpen=props.setOpen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showError=_useState2[0],setShowError=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),errorMessage=_useState4[0],setErrorMessage=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),edit=_useState6[0],setEdit=_useState6[1];// Values
var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),tierName=_useState8[0],setTierName=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),capacity=_useState10[0],setCapacity=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),startLevel=_useState12[0],setStartLevel=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),endLevel=_useState14[0],setEndLevel=_useState14[1];// Error states
var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),tierNameErr=_useState16[0],setTierNameErr=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState18=_slicedToArray(_useState17,2),capacityErr=_useState18[0],setCapacityErr=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState20=_slicedToArray(_useState19,2),startLevelErr=_useState20[0],setStartLevelErr=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),endLevelErr=_useState22[0],setEndLevelErr=_useState22[1];var onCloseModal=function onCloseModal(){setShowError(false);setErrorMessage("");setOpen(false);resetInputState();};var getExistingTierConfigs=function getExistingTierConfigs(){return getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TIER_CONFIGURATION,subKey:mac});};var buildTierConfig=function buildTierConfig(){return{tierName:tierName,capacity:parseInt(capacity,10),startLevel:parseInt(startLevel,10),endLevel:parseInt(endLevel,10)};};var checkValidations=function checkValidations(){var config=buildTierConfig();if(!Object(__WEBPACK_IMPORTED_MODULE_13__util_Validations__["_5" /* validateZancaSortTierConfig */])(config)){setErrorMessage("Please enter all fields in correct format.");return false;}// Check overlap against existing tiers (excluding current tier if editing)
var existingTiers=getExistingTierConfigs().filter(function(t){return t.tierName!==config.tierName;});var allTiers=[].concat(_toConsumableArray(existingTiers),[config]);var overlap=Object(__WEBPACK_IMPORTED_MODULE_13__util_Validations__["C" /* checkTierConfigLevelOverlap */])(allTiers);if(overlap){setErrorMessage("Level overlap detected between "+overlap.tier1+" and "+overlap.tier2+".");return false;}return true;};var prefill=function prefill(selectedTierName){var existing=getExistingTierConfigs();var match=existing.find(function(t){return t.tierName===selectedTierName;});if(match){setEdit(true);setCapacity(String(match.capacity));setStartLevel(String(match.startLevel));setEndLevel(String(match.endLevel));setCapacityErr(false);setStartLevelErr(false);setEndLevelErr(false);}else if(edit){setEdit(false);setCapacity("");setStartLevel("");setEndLevel("");}};var onClickConfirm=function onClickConfirm(){if(checkValidations()){var config=buildTierConfig();var existingTiers=getExistingTierConfigs();var isEdit=existingTiers.some(function(t){return t.tierName===config.tierName;});setConfigData(config,isEdit);setOpen(false);resetInputState();setShowError(false);setErrorMessage("");}else{setShowError(true);}};var setConfigData=function setConfigData(config,isEdit){if(isEdit){editInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TIER_CONFIGURATION,subKey:mac,instance:config,keyComparator:function keyComparator(config1,config2){return config1.tierName===config2.tierName;},valueComparator:function valueComparator(config1,config2){return config1.capacity===config2.capacity&&config1.startLevel===config2.startLevel&&config1.endLevel===config2.endLevel;}});}else{addInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TIER_CONFIGURATION,subKey:mac,instance:config});}};function resetInputState(){setTierName("");setCapacity("");setStartLevel("");setEndLevel("");setTierNameErr(false);setCapacityErr(false);setStartLevelErr(false);setEndLevelErr(false);setEdit(false);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tierconfig.addupdate"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.addtierheading"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"tier-name-select"},Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tierconfig.tierName"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_select___default.a,{id:"tier-name-select",value:tierName,onChange:function onChange(selectedTierName){setTierName(selectedTierName);setTierNameErr(!selectedTierName);prefill(selectedTierName);},error:tierNameErr,placeholder:Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tierconfig.selectTier"}),width:"100%"},__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_224" /* ZANCA_SORT_TIER_NAMES */].map(function(name){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_select__["SelectOption"],{key:name,value:name,label:name});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"capacity-input"},Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tierconfig.capacity"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"capacity-input",value:capacity,onChange:setCapacity,onBlur:function onBlur(){var val=parseInt(capacity,10);setCapacityErr(!Number.isInteger(val)||val<=0);},error:capacityErr,type:"number",placeholder:"e.g. 50"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"start-level-input"},Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tierconfig.startLevel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"start-level-input",value:startLevel,onChange:setStartLevel,onBlur:function onBlur(){var val=parseInt(startLevel,10);setStartLevelErr(!Number.isInteger(val)||val<1);},error:startLevelErr,type:"number",placeholder:"e.g. 1"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"end-level-input"},Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tierconfig.endLevel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"end-level-input",value:endLevel,onChange:setEndLevel,onBlur:function onBlur(){var val=parseInt(endLevel,10);setEndLevelErr(!Number.isInteger(val)||val<1);},error:endLevelErr,type:"number",placeholder:"e.g. 5"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,null,showError&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},errorMessage||Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.missingfields"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:onClickConfirm},edit?Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirmUpdate"}):Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirmAdd"}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddZancaSortTierConfigModal));

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_escapeRegExp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_escapeRegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_escapeRegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Constants__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DeleteZancaSortTierConfigurationModal=function DeleteZancaSortTierConfigurationModal(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,deleteInstance=_useContext.deleteInstance,deleteAll=_useContext.deleteAll;var open=props.open,setOpen=props.setOpen,mac=props.mac,intl=props.intl;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),selectedTierName=_useState2[0],setSelectedTierName=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),searchQuery=_useState4[0],setSearchQuery=_useState4[1];var tierNameList=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_13__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TIER_CONFIGURATION,subKey:mac}).map(function(_ref){var tierName=_ref.tierName;return tierName;});var searchRegExp=new RegExp(__WEBPACK_IMPORTED_MODULE_11_lodash_escapeRegExp___default()(searchQuery),"i");var matchedKeys=tierNameList.filter(function(option){return!searchQuery||searchRegExp.test(option);});var deleteData=function deleteData(){deleteInstance({stateKey:__WEBPACK_IMPORTED_MODULE_13__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TIER_CONFIGURATION,subKey:mac,keyComparator:function keyComparator(instance){return instance.tierName===selectedTierName;}});};var onClickConfirm=function onClickConfirm(){deleteData();setOpen(false);resetInputState();};function resetInputState(){setSelectedTierName("");}var onCloseModal=function onCloseModal(){setOpen(false);resetInputState();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal___default.a,{title:Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tierconfig.deleteconfig"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"tier-delete-select"},Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.delete_tier_config"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default.a,{id:"tier-delete-select",value:selectedTierName,onChange:setSelectedTierName,searchQuery:searchQuery,onSearch:setSearchQuery,placeholder:Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tierconfig.selectTier"}),width:"100%"},matchedKeys.map(function(tierName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__["SelectOption"],{key:tierName,value:tierName,label:tierName});}),!matchedKeys.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},tierNameList.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{alignment:"center"},Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"testconfig.nomatch"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{alignment:"center"},Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"testconfig.notavailable"}))):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{size:"small",className:"redBtn",onClick:function onClick(){deleteAll({stateKey:__WEBPACK_IMPORTED_MODULE_13__util_Constants__["_4" /* CONFIG_TYPE */].ZANCA_SORT_TIER_CONFIGURATION,subKey:mac});onCloseModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.deleteAll"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{type:"secondary",size:"small",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:onClickConfirm},Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirm"})))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_intl__["d" /* injectIntl */])(DeleteZancaSortTierConfigurationModal));

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_TesseractDeviceOverviewContext__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_tokens_base_icon_arrow_right_large__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_tokens_base_icon_arrow_right_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_tokens_base_icon_arrow_right_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_loader__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__rollback_RollbackModal__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__commonui_ConfigurationTabHeader__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__commonui_PaginatedTable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modal_AddTesseractTestPackageModal__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__amzn_meridian_tokens_base_icon_upload_small__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__amzn_meridian_tokens_base_icon_upload_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__amzn_meridian_tokens_base_icon_upload_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__commonui_UploadFileModal__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__util_Parsers__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__commonui_DeleteTestPackageConfigurationModal__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__modal_AddTesseractStowConfigurationModal__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__modal_DeleteTesseractStowConfigurationModal__ = __webpack_require__(1343);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var TesseractDeviceConfiguration=function TesseractDeviceConfiguration(_ref){var intl=_ref.intl;//Add Context
var _useContext=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__context_TesseractDeviceOverviewContext__["a" /* TesseractDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext2.getDraftData,setDraftData=_useContext2.setDraftData,resetDraftData=_useContext2.resetDraftData,getFilteredDraftData=_useContext2.getFilteredDraftData,isDataEdited=_useContext2.isDataEdited;var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext3.showCustomAlert;var _useState=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),selectedMac=_useState2[0],setSelectedMac=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),valueConfiguration=_useState4[0],setValueConfiguration=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])([]),_useState6=_slicedToArray(_useState5,2),rollBackVersions=_useState6[0],setRollbackVersions=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),isVersionsLoading=_useState8[0],setIsVersionsLoading=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),selectedVersion=_useState10[0],setSelectedVersion=_useState10[1];// Modal state
var _useState11=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),showRollbackModal=_useState12[0],setShowRollbackModal=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),openAddModal=_useState14[0],setOpenAddModal=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),openDeleteModal=_useState16[0],setOpenDeleteModal=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(false),_useState18=_slicedToArray(_useState17,2),openCSVModal=_useState18[0],setOpenCSVModal=_useState18[1];// Search row state values
var _useState19=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(''),_useState20=_slicedToArray(_useState19,2),scannablesSearchInput=_useState20[0],setScannablesSearchInput=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(''),_useState22=_slicedToArray(_useState21,2),destinationSearchInput=_useState22[0],setDestinationSearchInput=_useState22[1];//Data Sort prefs for test config table
var _useState23=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])("scannables"),_useState24=_slicedToArray(_useState23,2),testConfigSortColumn=_useState24[0],setTestConfigSortColumn=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(__WEBPACK_IMPORTED_MODULE_5__util_Constants__["J" /* ASCENDING */]),_useState26=_slicedToArray(_useState25,2),testConfigSortOrder=_useState26[0],setTestConfigSortOrder=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])("containerType"),_useState28=_slicedToArray(_useState27,2),stowConfigSortColumn=_useState28[0],setStowConfigSortColumn=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(__WEBPACK_IMPORTED_MODULE_5__util_Constants__["J" /* ASCENDING */]),_useState30=_slicedToArray(_useState29,2),stowConfigSortOrder=_useState30[0],setStowConfigSortOrder=_useState30[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(null);var PAGE_CONFIGURATION_KEYS=[__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_TEST_CONFIGURATION,__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_STOW_CONFIGURATION];Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function(){if(!openAddModal&&!openDeleteModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["D" /* getAssetRefreshInterval */])());return function(){return clearInterval(interval);};}},[openAddModal,openDeleteModal]);Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function(){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return viewModel.stowConfig[selectedMac];},[]),stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_STOW_CONFIGURATION,subKey:selectedMac});setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return viewModel.testConfig[selectedMac];},[]),stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_TEST_CONFIGURATION,subKey:selectedMac});},[selectedMac]);var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var getData=function getData(){if(isDataEdited(PAGE_CONFIGURATION_KEYS))return;setOpenAddModal(false);setOpenDeleteModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var getModalContent=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var versionsData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setIsVersionsLoading(true);_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_13__resources_AssetResource__["f" /* getAssetVersions */])(selectedMac);case 3:versionsData=_context.sent;setRollbackVersions(versionsData.data.assetVersionDetailsList);setIsVersionsLoading(false);case 6:case"end":return _context.stop();}}},_callee,_this);}));return function getModalContent(){return _ref2.apply(this,arguments);};}();var loadRollbackDataToDraft=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var rollbackData,testConfigData,stowConfigData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_13__resources_AssetResource__["e" /* getAssetByVersion */])(selectedMac,selectedVersion);case 2:rollbackData=_context2.sent;testConfigData=Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.testConfig);},[]);stowConfigData=Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.stowConfig);},[]);if(testConfigData.length){setDraftData({data:testConfigData,stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_TEST_CONFIGURATION,subKey:selectedMac,allRowsAdded:true,override:true});}if(stowConfigData.length){setDraftData({data:stowConfigData,stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_STOW_CONFIGURATION,subKey:selectedMac,allRowsAdded:true,override:true});}case 7:case"end":return _context2.stop();}}},_callee2,_this);}));return function loadRollbackDataToDraft(){return _ref3.apply(this,arguments);};}();var updateTestConfigDraftData=function updateTestConfigDraftData(stowTestPackage){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return stowTestPackage;},[]),stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_TEST_CONFIGURATION,subKey:selectedMac,allRowsAdded:true,override:true});};var updateStowConfigDraftData=function updateStowConfigDraftData(stowConfig){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return stowConfig;},[]),stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_STOW_CONFIGURATION,subKey:selectedMac,allRowsAdded:true,override:true});};var deployDraftTesseractAsset=function deployDraftTesseractAsset(){var testPackageList=getFilteredDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_TEST_CONFIGURATION,subKey:selectedMac});var stowConfigList=getFilteredDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_STOW_CONFIGURATION,subKey:selectedMac});dispatch({type:'UPDATE_TESSERACT_CONFIGURATION',data:{dispatcher:dispatch,showCustomAlert:showCustomAlert,configurations:{testConfig:testPackageList,stowConfig:stowConfigList},mac:selectedMac}});setDraftData({data:testPackageList,stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_TEST_CONFIGURATION,subKey:selectedMac,override:true});setDraftData({data:stowConfigList,stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_STOW_CONFIGURATION,subKey:selectedMac,override:true});};var searchDataForTestConfigTable=function searchDataForTestConfigTable(){var data=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_TEST_CONFIGURATION,subKey:selectedMac});data=data.filter(function(item){return Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_13" /* getTestConfigKey */])(item.scannables).toLowerCase().includes(scannablesSearchInput.toLowerCase());}).filter(function(item){return item.destination.toLowerCase().includes(destinationSearchInput.toLowerCase());});data=data.sort(function(a,b){return sortTestConfigColumns[testConfigSortColumn](a,b,testConfigSortOrder===__WEBPACK_IMPORTED_MODULE_5__util_Constants__["J" /* ASCENDING */]);});return data;};var getDataForStowConfigTable=function getDataForStowConfigTable(){return getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_STOW_CONFIGURATION,subKey:selectedMac}).sort(function(a,b){return sortStowConfigColumns[stowConfigSortColumn](a,b,stowConfigSortOrder===__WEBPACK_IMPORTED_MODULE_5__util_Constants__["J" /* ASCENDING */]);});};var getSortedDeviceList=function getSortedDeviceList(){// Device List sorted based on device "name"
var sortedDeviceList=Object.values(viewModel.tesseractDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){if(a.name<b.name){return-1;}else if(b.name>a.name){return 1;}return 0;});return sortedDeviceList;};var sortStowConfigColumns={containerType:function containerType(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.containerType,b.containerType):-Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.containerType,b.containerType);},containerLabel:function containerLabel(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.containerLabel,b.containerLabel):-Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.containerLabel,b.containerLabel);}};var sortTestConfigColumns={scannables:function scannables(a,b,ascending){var scannableFirst=Array.isArray(a.scannables)?a.scannables.join(' '):a.scannables;var scannableSecond=Array.isArray(b.scannables)?b.scannables.join(' '):b.scannables;return ascending?Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(scannableFirst,scannableSecond):-Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(scannableFirst,scannableSecond);},destination:function destination(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.destination,b.destination):-Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["_32" /* sortComparator */])(a.destination,b.destination);}};var getHeaderProps=function getHeaderProps(){return{selectedMac:selectedMac,setSelectedMac:setSelectedMac,valueConfiguration:valueConfiguration,setValueConfiguration:setValueConfiguration,defaultSelection:"",resetDraftData:resetDraftData,deployDraft:deployDraftTesseractAsset,scrollToBottom:scrollToBottom,sortedDeviceList:getSortedDeviceList(),configurationKeys:PAGE_CONFIGURATION_KEYS,refreshDeps:[viewModel.timestamp],isDeployDisabled:!isDataEdited(PAGE_CONFIGURATION_KEYS),isRollbackDisabled:!selectedMac||isDataEdited(PAGE_CONFIGURATION_KEYS),rollbackClickHandler:function rollbackClickHandler(){getModalContent();setShowRollbackModal(true);}};};function onClickAddSingle(){setOpenAddModal(true);}function onClickUploadCSV(){setOpenCSVModal(true);}function onClickDeleteConfiguration(){setOpenDeleteModal(true);}var renderTestConfigTableHeader=function renderTestConfigTableHeader(){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"table.index"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],{sortColumn:"scannables"},Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.scannables"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],{sortColumn:"destination"},Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.destination"})));};var renderStowConfigTableHeader=function renderStowConfigTableHeader(){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"table.index"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],{sortColumn:"containerType"},Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"container.type"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],{sortColumn:"containerLabel"},Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"container.label"})));};var renderSearchRow=function renderSearchRow(){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableRow"],{backgroundColor:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_177" /* SEARCH_ROW_COLOR */]},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_input___default.a,{className:"input-search-class",value:scannablesSearchInput,onChange:setScannablesSearchInput,type:"text",placeholder:"Search",width:"70%",size:"small"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_input___default.a,{className:"input-search-class",value:destinationSearchInput,onChange:setDestinationSearchInput,type:"text",placeholder:"Search",width:"70%",size:"small"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null));};var renderTestConfigTableRow=function renderTestConfigTableRow(config,serialNumber){var dataString=config.destination;var prevDataString=Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return config.prev.destination;},null);return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableRow"],{highlightOnHover:true,backgroundColor:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_148" /* OPERATION_COLOR */][config.operation]},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,serialNumber),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,Array.isArray(config.scannables)?config.scannables.join(' '):config.scannables),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,prevDataString&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__amzn_meridian_text___default.a,null," ",prevDataString," "),prevDataString&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__amzn_meridian_text___default.a,null," ",dataString," ")));};var renderStowConfigTableRow=function renderStowConfigTableRow(config,serialNumber){var dataString=config.containerLabel;var prevDataString=Object(__WEBPACK_IMPORTED_MODULE_7__util_Util__["f" /* chainWalk */])(function(){return config.prev.containerLabel;},null);return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableRow"],{highlightOnHover:true,backgroundColor:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_148" /* OPERATION_COLOR */][config.operation]},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,serialNumber),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,config.containerType),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,prevDataString&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__amzn_meridian_text___default.a,null," ",prevDataString," "),prevDataString&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__amzn_meridian_text___default.a,null," ",dataString," ")));};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_loader___default.a,null);}else{return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__commonui_ConfigurationTabHeader__["a" /* default */],getHeaderProps()),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__rollback_RollbackModal__["a" /* default */],{showRollbackModal:showRollbackModal,setShowRollbackModal:setShowRollbackModal,isVersionsLoading:isVersionsLoading,selectedVersion:selectedVersion,setSelectedVersion:setSelectedVersion,rollBackVersions:rollBackVersions,loadRollbackDataToDraft:loadRollbackDataToDraft,intl:intl}),valueConfiguration===__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_STOW_CONFIGURATION&&selectedMac&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__commonui_PaginatedTable__["a" /* default */],{data:getDataForStowConfigTable(),renderHeader:renderStowConfigTableHeader,renderRow:renderStowConfigTableRow,sortColumn:stowConfigSortColumn,sortDirection:stowConfigSortOrder,onSort:function onSort(_ref4){var sortColumn=_ref4.sortColumn,sortDirection=_ref4.sortDirection;setStowConfigSortColumn(sortColumn);setStowConfigSortOrder(sortDirection);}}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_row___default.a,{width:"100%",widths:["100","100","fill","100"]},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default.a,{onClick:onClickAddSingle,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle___default.a}),Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowconfig.addupdate"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default.a,{onClick:onClickUploadCSV,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_24__amzn_meridian_tokens_base_icon_upload_small___default.a}),Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowconfig.uploadCSV"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default.a,{onClick:onClickDeleteConfiguration,size:"small",type:"tertiary"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowconfig.deleteconfig"}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__commonui_UploadFileModal__["a" /* default */],{mac:selectedMac,open:openCSVModal,setOpen:setOpenCSVModal,parser:__WEBPACK_IMPORTED_MODULE_28__util_Parsers__["i" /* TesseractStowConfigCSVParser */],updateConfig:updateStowConfigDraftData}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__modal_AddTesseractStowConfigurationModal__["a" /* default */],{mac:selectedMac,open:openAddModal,setOpen:setOpenAddModal}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__modal_DeleteTesseractStowConfigurationModal__["a" /* default */],{mac:selectedMac,open:openDeleteModal,setOpen:setOpenDeleteModal})),valueConfiguration===__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_TEST_CONFIGURATION&&selectedMac&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__commonui_PaginatedTable__["a" /* default */],{data:searchDataForTestConfigTable(),renderHeader:renderTestConfigTableHeader,renderSearchRow:renderSearchRow,renderRow:renderTestConfigTableRow,sortColumn:testConfigSortColumn,sortDirection:testConfigSortOrder,onSort:function onSort(_ref5){var sortColumn=_ref5.sortColumn,sortDirection=_ref5.sortDirection;setTestConfigSortColumn(sortColumn);setTestConfigSortOrder(sortDirection);}}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_row___default.a,{width:"100%",widths:["100","100","fill","100"]},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default.a,{onClick:onClickAddSingle,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle___default.a}),Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowtestconfig.addupdate"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default.a,{onClick:onClickUploadCSV,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_24__amzn_meridian_tokens_base_icon_upload_small___default.a}),Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowtestconfig.uploadCSV"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_button___default.a,{onClick:onClickDeleteConfiguration,size:"small",type:"tertiary"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_26__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_8__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowtestconfig.deleteconfig"}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__modal_AddTesseractTestPackageModal__["a" /* default */],{mac:selectedMac,open:openAddModal,setOpen:setOpenAddModal}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__commonui_UploadFileModal__["a" /* default */],{mac:selectedMac,open:openCSVModal,setOpen:setOpenCSVModal,parser:__WEBPACK_IMPORTED_MODULE_28__util_Parsers__["j" /* TesseractTestConfigCSVParser */],updateConfig:updateTestConfigDraftData}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__commonui_DeleteTestPackageConfigurationModal__["a" /* default */],{mac:selectedMac,testConfig:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_TEST_CONFIGURATION,open:openDeleteModal,setOpen:setOpenDeleteModal}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["d" /* injectIntl */])(TesseractDeviceConfiguration));

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddTesseractTestPackageModal=function AddTesseractTestPackageModal(props){var mac=props.mac,intl=props.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,addInstance=_useContext.addInstance,editInstance=_useContext.editInstance;// Visual controls
var open=props.open,setOpen=props.setOpen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),show=_useState2[0],setShow=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),edit=_useState4[0],setEdit=_useState4[1];// Values
var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),trackingId=_useState6[0],setTrackingId=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),shippingId=_useState8[0],setShippingId=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),destination=_useState10[0],setDestination=_useState10[1];// Error
var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),trackingIdErr=_useState12[0],setTrackingIdErr=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),shippingIdErr=_useState14[0],setShippingIdErr=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),destinationErr=_useState16[0],setDestinationErr=_useState16[1];var setConfigData=function setConfigData(stowTestPackage,mac){if(edit){editInstance({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_TEST_CONFIGURATION,subKey:mac,instance:stowTestPackage,keyComparator:function keyComparator(config1,config2){return config1.trackingId===config2.trackingId;},valueComparator:function valueComparator(config1,config2){return config1.scannables===config2.scannables&&config1.destination===config2.destination;}});}else{addInstance({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_TEST_CONFIGURATION,subKey:mac,instance:stowTestPackage});}};var stowTestPackage={trackingId:trackingId,scannables:Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_12" /* getStowConfigScannableList */])(trackingId,shippingId),destination:destination};var testConfigMap={};getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_TEST_CONFIGURATION,subKey:mac}).forEach(function(value){testConfigMap[value.trackingId]={shippingId:Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_5" /* getShippingIdFromScannableList */])(value.scannables,value.trackingId),destination:value.destination};});var resetConfigDetails=function resetConfigDetails(){setShippingId("");setDestination("");};var resetConfigErrorDetails=function resetConfigErrorDetails(){setShippingIdErr("");setDestinationErr(false);};function resetInputState(){setTrackingId("");resetConfigDetails();resetConfigErrorDetails();}function onCloseModal(){setShow(false);setOpen(false);resetInputState();}var prefill=function prefill(){var key=stowTestPackage.trackingId;if(testConfigMap.hasOwnProperty(key)){setEdit(true);resetConfigErrorDetails();setShippingId(testConfigMap[key].shippingId);setDestination(testConfigMap[key].destination);}else if(edit){setEdit(false);resetConfigDetails();}};var onClickConfirm=function onClickConfirm(stowTestPackage,mac){if(Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["B" /* checkTesseractAddTestPackageModalValidations */])(stowTestPackage)){setConfigData(stowTestPackage,mac);setOpen(false);resetInputState();setShow(false);}else{setShow(true);}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal___default.a,{title:Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowtestconfig.addupdate"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.tesseract_headingtest"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.tracking_id"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"tracking-id-input",value:trackingId,onChange:function onChange(value){setTrackingId(value.replace(/\s/g,''));},onBlur:function onBlur(){setTrackingIdErr(!Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["L" /* isValidEntry */])(trackingId,__WEBPACK_IMPORTED_MODULE_8__util_Validations__["j" /* PATTERNS */].TEST_PACKAGE_ID));prefill();},error:trackingIdErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.tracking_id_description"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.alt_id"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"scannables-input",value:shippingId,onChange:function onChange(value){setShippingId(value.replace(/\s/g,''));},onBlur:function onBlur(){if(shippingId){setShippingIdErr(!Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["L" /* isValidEntry */])(shippingId,__WEBPACK_IMPORTED_MODULE_8__util_Validations__["j" /* PATTERNS */].TEST_PACKAGE_ID));}},error:shippingIdErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.alt_id_description"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.destination"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"destination-input",value:destination,onChange:setDestination,onBlur:function onBlur(){setDestinationErr(!Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["L" /* isValidEntry */])(destination,__WEBPACK_IMPORTED_MODULE_8__util_Validations__["j" /* PATTERNS */].CONTAINER_LABEL));},error:destinationErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.tesseract_window_description"})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"400"},show&&!Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["B" /* checkTesseractAddTestPackageModalValidations */])(stowTestPackage)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_alert___default.a,{type:"warning",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.missingfields"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stowTestPackage,mac);}},edit?Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirmUpdate"}):Object(__WEBPACK_IMPORTED_MODULE_3__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirmAdd"})))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(AddTesseractTestPackageModal));

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_button__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddTesseractStowConfigurationModal=function AddTesseractStowConfigurationModal(props){var mac=props.mac,intl=props.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,addInstance=_useContext.addInstance,editInstance=_useContext.editInstance;// Visual controls
var open=props.open,setOpen=props.setOpen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),show=_useState2[0],setShow=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),edit=_useState4[0],setEdit=_useState4[1];// Values
var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),containerType=_useState6[0],setContainerType=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),containerLabel=_useState8[0],setContainerLabel=_useState8[1];// Error
var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),containerTypeErr=_useState10[0],setContainerTypeErr=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),containerLabelErr=_useState12[0],setContainerLabelErr=_useState12[1];var stowConfig={containerType:containerType,containerLabel:containerLabel};var stowConfigMap={};getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_STOW_CONFIGURATION,subKey:mac}).forEach(function(value){stowConfigMap[value.containerType]={containerLabel:value.containerLabel};});function resetInputState(){setContainerType("");resetConfigDetails();}function resetConfigDetails(){setContainerLabel("");}function resetConfigErrorDetails(){setContainerLabelErr(false);}var prefill=function prefill(){if(stowConfigMap.hasOwnProperty(containerType)){setEdit(true);resetConfigErrorDetails();setContainerLabel(stowConfigMap[containerType].containerLabel);}else{setEdit(false);resetConfigDetails();}};var onCloseModal=function onCloseModal(){setShow(false);setOpen(false);resetInputState();};var onClickConfirm=function onClickConfirm(stowConfig,mac){var confirm=Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["x" /* checkModalValidationsForConfig */])(stowConfig,mac,__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_200" /* TESSERACT_ASSET_TYPE */]);if(confirm){setConfigData(stowConfig,mac);setOpen(false);resetInputState();setShow(false);}else{setShow(true);}};var setConfigData=function setConfigData(stowConfig,mac){if(edit){editInstance({stateKey:__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_STOW_CONFIGURATION,subKey:mac,instance:stowConfig,keyComparator:function keyComparator(config1,config2){return config1.containerType===config2.containerType;},valueComparator:function valueComparator(config1,config2){return config1.containerLabel===config2.containerLabel;}});}else{addInstance({stateKey:__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_STOW_CONFIGURATION,subKey:mac,instance:stowConfig});}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default.a,{title:Object(__WEBPACK_IMPORTED_MODULE_6__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowconfig.addupdate"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,Object(__WEBPACK_IMPORTED_MODULE_6__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.tesseract_headingconfig"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_6__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"container.type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"container-type-input",value:containerType,onChange:setContainerType,onBlur:function onBlur(){setContainerTypeErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(containerType,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].CONTAINER_TYPE));prefill();},error:containerTypeErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_6__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.tesseract_containerType_description"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_6__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"container.label"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"container-label-input",value:containerLabel,onChange:setContainerLabel,onBlur:function onBlur(){setContainerLabelErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(containerLabel,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].CONTAINER_LABEL));},error:containerLabelErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_6__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.tesseract_containerLabel_description"})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,null,!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["x" /* checkModalValidationsForConfig */])(stowConfig,mac,__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_200" /* TESSERACT_ASSET_TYPE */])&&show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default.a,{type:"warning",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_6__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.missingfields"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_6__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stowConfig,mac);}},edit?Object(__WEBPACK_IMPORTED_MODULE_6__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirmUpdate"}):Object(__WEBPACK_IMPORTED_MODULE_6__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirmAdd"})))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(AddTesseractStowConfigurationModal));

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_escapeRegExp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_escapeRegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_escapeRegExp__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DeleteTesseractStowConfigurationModal=function DeleteTesseractStowConfigurationModal(props){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,deleteInstance=_useContext.deleteInstance,deleteAll=_useContext.deleteAll;var open=props.open,setOpen=props.setOpen,mac=props.mac,intl=props.intl;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),selectedContainerType=_useState2[0],setSelectedContainerType=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),searchQuery=_useState4[0],setSearchQuery=_useState4[1];var containerTypeKeyList=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_STOW_CONFIGURATION,subKey:mac}).map(function(config){return config.containerType;});var searchRegExp=new RegExp(__WEBPACK_IMPORTED_MODULE_13_lodash_escapeRegExp___default()(searchQuery),"i");var matchedKeys=containerTypeKeyList.filter(function(option){return!searchQuery||searchRegExp.test(option);});var deleteData=function deleteData(){deleteInstance({stateKey:__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_STOW_CONFIGURATION,subKey:mac,keyComparator:function keyComparator(instance){return instance.containerType===selectedContainerType;}});};var onClickConfirm=function onClickConfirm(){deleteData();setOpen(false);resetInputState();};function resetInputState(){setSelectedContainerType("");}var onCloseModal=function onCloseModal(){setOpen(false);resetInputState();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal___default.a,{title:Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowconfig.deleteconfig"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.tesseract_delete_stow_config"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default.a,{value:selectedContainerType,onChange:setSelectedContainerType,searchQuery:searchQuery,onSearch:setSearchQuery,placeholder:Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowconfig.delete"}),width:"100%"},matchedKeys.map(function(containerType){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__["SelectOption"],{key:containerType,value:containerType,label:containerType});}),!matchedKeys.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},containerTypeKeyList?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{alignment:"center"},Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowconfig.nomatch"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_text___default.a,{alignment:"center"},Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"stowconfig.notavailable"}))):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{size:"small",className:"redBtn",onClick:function onClick(){deleteAll({stateKey:__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_4" /* CONFIG_TYPE */].TESSERACT_STOW_CONFIGURATION,subKey:mac});onCloseModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.deleteAll"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{type:"secondary",size:"small",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:onClickConfirm},Object(__WEBPACK_IMPORTED_MODULE_4__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirm"})))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_intl__["d" /* injectIntl */])(DeleteTesseractStowConfigurationModal));

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_AutoRetrieverDeviceOverviewContext__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__commonui_DeleteSingleDeviceModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__commonui_EditMacAddressModal__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commonui_DisableMonitoringModal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modal_AddAutoRetrieverSingleDeviceModal__ = __webpack_require__(1347);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AutoRetrieverDeviceOverview=function AutoRetrieverDeviceOverview(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__context_AutoRetrieverDeviceOverviewContext__["a" /* AutoRetrieverDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),selected=_useState2[0],setSelected=_useState2[1];var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])([]);var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(null);var _useState3=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])({}),_useState4=_slicedToArray(_useState3,2),openActionsMenu=_useState4[0],setOpenActionsMenu=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),mac=_useState6[0],setMac=_useState6[1];// Handle modal state (open/hidden)
var _useState7=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),openAddModal=_useState8[0],setOpenAddModal=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),openDeleteModal=_useState10[0],setOpenDeleteModal=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),openEditMacModal=_useState12[0],setOpenEditMacModal=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),openDisableMonitoringModal=_useState14[0],setOpenDisableMonitoringModal=_useState14[1];var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=true;setOpenActionsMenu(_open);},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=false;setOpenActionsMenu(_open);},[]);Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function(){if(!openAddModal){// fetch overview data in regular intervals if the add device modal is not open
getData();var assetInterval=setInterval(function(){if(!document.hidden){getData();// get asset data
}},Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["D" /* getAssetRefreshInterval */])());var statusInterval=setInterval(function(){if(!document.hidden){getStatusData();// get status update
}},Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_11" /* getStatusRefreshInterval */])());return function(){clearInterval(assetInterval);clearInterval(statusInterval);};}},[openAddModal]);Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,viewModel.autoRetrieverDeviceInformation.length);},[viewModel.autoRetrieverDeviceInformation]);var getData=function getData(){setOpenAddModal(false);setOpenDeleteModal(false);setOpenEditMacModal(false);setOpenDisableMonitoringModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var getStatusData=function getStatusData(){dispatch({type:'LOAD_STATUS',data:{dispatcher:dispatch,state:viewModel}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var onSort=function onSort(sortDetails){dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};var onClickAddEditConfig=function onClickAddEditConfig(){setSelected("");setOpenAddModal(true);};var onClickEditDevice=function onClickEditDevice(mac){setSelected(mac);setOpenAddModal(true);};var onClickRemove=function onClickRemove(mac){setSelected(mac);setOpenDeleteModal(true);};var onClickChangeMac=function onClickChangeMac(mac){setSelected(mac);setOpenEditMacModal(true);};var onClickDisableMonitoring=function onClickDisableMonitoring(mac){setMac(mac);setOpenDisableMonitoringModal(true);};var onClickEnableMonitoring=function onClickEnableMonitoring(startTime,reason,mac){var stateValues={"startTime":startTime,"endTime":Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["I" /* getCurrentDate */])().toString(),"reason":reason};updateData(stateValues,mac);getData();};var updateData=function updateData(stateValues,mac){dispatch({type:'UPDATE_MONITORING_DATA',data:{dispatcher:dispatch,stateValues:stateValues,mac:mac}});};var getAutoRetrieverStateValues=function getAutoRetrieverStateValues(mac){if(!mac)return{};var device=viewModel.autoRetrieverDeviceInformation[mac];if(!device)return{};var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};return{name:device.name,mac:mac,ip:device.ip,port:device.port,deviceType:device.deviceType,deviceConfig:JSON.stringify({type:__WEBPACK_IMPORTED_MODULE_3__util_Util__["e" /* assetTypeToConfigTypeDict */].typeAUTO_RETRIEVER,id:device.id}),vendorAttributes:device.vendorAttributes,monitoring:JSON.stringify(deviceMonitoring),pickStations:JSON.stringify(device.pickStations)};};var renderDeviceMonitoring=function renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",{style:{color:monitoringStatusColor}},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:monitoringStatusId}));};var sortedDeviceList=Object.values(viewModel.autoRetrieverDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){var _viewModel$sortPref=viewModel.sortPref,column=_viewModel$sortPref.column,direction=_viewModel$sortPref.direction;var compareValue=void 0;if(Object.keys(__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */]).includes(column)){if(column==="vendor"){compareValue=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column]+a.vendorAttributes["spec_version"],b.vendorAttributes[column]+b.vendorAttributes["spec_version"]);}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column],b.vendorAttributes[column]);}}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_32" /* sortComparator */])(a[column],b[column]);}if(direction===__WEBPACK_IMPORTED_MODULE_4__util_Constants__["J" /* ASCENDING */]){return compareValue;}else{return-compareValue;}});if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader___default.a,null);}else{return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.scrolltobottom"})},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_alert___default.a,{type:"informational",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.device"})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableCell"],{sortColumn:"name"},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.name"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableCell"],{sortColumn:"vendor"},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'device.vendor'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.mac_ip"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.connectionstatus'})},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableCell"],{sortColumn:"connection"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.connection"})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.monitoring"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.pick_stations"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.action"}))),sortedDeviceList.map(function(device,index){var vendorAttributes=device.vendorAttributes;var monitoring=Object(__WEBPACK_IMPORTED_MODULE_23__util_Validations__["u" /* checkDeviceMonitoringEnabled */])(Number(device.startTime),Number(device.endTime));var _getMonitoringStatusD=Object(__WEBPACK_IMPORTED_MODULE_23__util_Validations__["F" /* getMonitoringStatusDetails */])(monitoring),monitoringStatusColor=_getMonitoringStatusD.monitoringStatusColor,monitoringStatusId=_getMonitoringStatusD.monitoringStatusId;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableRow"],{key:index,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,device.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br",null),device.deviceType),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_23__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][vendorAttributes.vendor]),__WEBPACK_IMPORTED_MODULE_23__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][vendorAttributes.spec_version])),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,device.mac),device.ip,":",device.port)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableCell"],null,device.assetStatus?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("p",{style:{color:device.assetStatus.toUpperCase()===__WEBPACK_IMPORTED_MODULE_4__util_Constants__["b" /* ACTIVE */]?__WEBPACK_IMPORTED_MODULE_4__util_Constants__["X" /* BLUE_COLOR */]:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_149" /* ORANGE_COLOR */]}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,device.assetStatus)):Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"loading.text"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableCell"],null,renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_column___default.a,null,Array.isArray(device.pickStations)?device.pickStations.join(' '):device.pickStations)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"my-menu","aria-haspopup":"menu","aria-expanded":"false"},__WEBPACK_IMPORTED_MODULE_4__util_Constants__["a" /* ACTIONS_STRING */]),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__amzn_meridian_menu___default.a,{anchorNode:actionButtonRefs.current[index],open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEditDevice(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.addDevice"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickRemove(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.deleteDevice"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickChangeMac(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.changeMac"})),monitoring.isMonitoringEnabled?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDisableMonitoring(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.monitoring_disable"})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEnableMonitoring(device.startTime,device.reason,device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.monitoring_enable"}))))));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_button___default.a,{onClick:onClickAddEditConfig,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_plus_circle___default.a}),Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.add_device_button_modal"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_button___default.a,{onClick:function onClick(){return onClickRemove("");},type:"tertiary",size:"small"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"button.delete"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__modal_AddAutoRetrieverSingleDeviceModal__["a" /* default */],{open:openAddModal,setOpen:setOpenAddModal,selected:selected,setSelected:setSelected}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__commonui_DeleteSingleDeviceModal__["a" /* default */],{open:openDeleteModal,setOpen:setOpenDeleteModal,selected:selected,setSelected:setSelected,macAddressArray:viewModel.macAddressArray,dispatch:dispatch}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__commonui_EditMacAddressModal__["a" /* default */],{open:openEditMacModal,setOpen:setOpenEditMacModal,selectedMac:selected,setSelectedMac:setSelected,dispatch:dispatch,stateValues:getAutoRetrieverStateValues(selected)}),openDisableMonitoringModal&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__commonui_DisableMonitoringModal__["a" /* default */],{mac:mac,state:openDisableMonitoringModal,onStateChange:setOpenDisableMonitoringModal,context:__WEBPACK_IMPORTED_MODULE_1__context_AutoRetrieverDeviceOverviewContext__["a" /* AutoRetrieverDeviceOverviewContext */],reducer:'UPDATE_MONITORING_DATA'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["d" /* injectIntl */])(AutoRetrieverDeviceOverview));

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoRetrieverDeviceOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__network_AutoRetrieverDeviceNetworkAPI__ = __webpack_require__(1346);
var AutoRetrieverDeviceOverviewReducer=function AutoRetrieverDeviceOverviewReducer(state,action){switch(action.type){case"LOAD_VIEW":Object(__WEBPACK_IMPORTED_MODULE_1__network_AutoRetrieverDeviceNetworkAPI__["b" /* fetchAutoRetrieverDeviceDetails */])(action.data.dispatcher);return state;case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingOverview:false,timestamp:Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["_14" /* getTimestampNow */])()});case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});case"ADD_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_1__network_AutoRetrieverDeviceNetworkAPI__["e" /* setAutoRetrieverDeviceDetails */])(action.data.dispatcher,action.data.stateValues,action.data.showCustomAlert);return state;case"UPDATE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_1__network_AutoRetrieverDeviceNetworkAPI__["g" /* updateAutoRetrieverDeviceDetails */])(action.data.dispatcher,action.data.stateValues,action.data.showCustomAlert);return state;case"UPDATE_DEVICE_MAC":Object(__WEBPACK_IMPORTED_MODULE_1__network_AutoRetrieverDeviceNetworkAPI__["h" /* updateAutoRetrieverDeviceMac */])(action.data.dispatcher,action.data.stateValues,action.data.mac,action.data.showCustomAlert);return state;case"UPDATE_MONITORING_DATA":Object(__WEBPACK_IMPORTED_MODULE_1__network_AutoRetrieverDeviceNetworkAPI__["i" /* updateAutoRetrieverMonitoringDetails */])(action.data.dispatcher,action.data.stateValues,action.data.mac);return state;case"DELETE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_1__network_AutoRetrieverDeviceNetworkAPI__["a" /* deleteAutoRetrieverDeviceDetails */])(action.data.dispatcher,action.data.mac);return state;case"START_MOCK_TEST":Object(__WEBPACK_IMPORTED_MODULE_1__network_AutoRetrieverDeviceNetworkAPI__["f" /* startMockTestForAutoRetriever */])(action.data.dispatcher,action.data.mac,action.data.showCustomAlert);return Object.assign({},state,{loadingOverview:true});case"LOAD_PICK_STATION_RESOURCES":Object(__WEBPACK_IMPORTED_MODULE_1__network_AutoRetrieverDeviceNetworkAPI__["d" /* fetchPickStationResources */])(action.data.dispatcher);return Object.assign({},state,{loadingPickStationResources:true});case"RECEIVE_PICK_STATION_RESOURCES":return Object.assign({},state,{pickStationResources:action.data,loadingPickStationResources:false});case"SAVE_PICK_STATION_CONFIG":Object(__WEBPACK_IMPORTED_MODULE_1__network_AutoRetrieverDeviceNetworkAPI__["j" /* updatePickStationConfig */])(action.data.dispatcher,action.data.mac,action.data.config,action.data.showCustomAlert);return state;case"LOAD_PICK_POINT_RESOURCES":Object(__WEBPACK_IMPORTED_MODULE_1__network_AutoRetrieverDeviceNetworkAPI__["c" /* fetchPickPointResources */])(action.data.dispatcher);return Object.assign({},state,{loadingPickPointResources:true});case"RECEIVE_PICK_POINT_RESOURCES":return Object.assign({},state,{pickPointResources:action.data,loadingPickPointResources:false});case"SAVE_RETRIEVER_LOCATION_MAPPING":Object(__WEBPACK_IMPORTED_MODULE_1__network_AutoRetrieverDeviceNetworkAPI__["k" /* updateRetrieverLocationMapping */])(action.data.dispatcher,action.data.mac,action.data.config,action.data.showCustomAlert);return state;default:return state;}};

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAutoRetrieverDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["e"] = setAutoRetrieverDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateAutoRetrieverDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteAutoRetrieverDeviceDetails;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateAutoRetrieverDeviceMac; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return startMockTestForAutoRetriever; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateAutoRetrieverMonitoringDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchPickStationResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchPickPointResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updatePickStationConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateRetrieverLocationMapping; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources_NodeResource__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_http_status_codes__ = __webpack_require__(450);
var addAutoRetrieverDeviceDetails=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatcher,request,showCustomAlert){var _this=this;var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:startTime=Date.now();_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_29" /* setAliasToRequest */])(request);case 3:Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["a" /* addAsset */])(request).then(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(result){var isFault,getAssetResult,responseSetAssetStatus,responseUpdateAsset,isFaultInUpdateAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(result.status===200)){_context3.next=4;break;}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAutoRetrieverDeviceDetails",true,false);_context3.next=28;break;case 4:// 500 response status can be for any reason. One of those is : asset already exists so trying to update it.
// UpdateAsset only works on ACTIVE devices so first setting status as ACTIVE.
isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(result.status);_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 7:getAssetResult=_context3.sent;if(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(getAssetResult.data.asset.assetDetails.assetStatus)){_context3.next=12;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["B" /* ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAutoRetrieverDeviceDetails",false,isFault);return _context3.abrupt("return");case 12:_context3.next=14;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);case 14:responseSetAssetStatus=_context3.sent;if(!(responseSetAssetStatus.status!==200)){_context3.next=19;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAutoRetrieverDeviceDetails",false,isFault);return _context3.abrupt("return");case 19:_context3.next=21;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 21:responseUpdateAsset=_context3.sent;if(!(responseUpdateAsset.status!==200)){_context3.next=27;break;}isFaultInUpdateAsset=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(responseUpdateAsset.status);showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAutoRetrieverDeviceDetails",false,isFaultInUpdateAsset);return _context3.abrupt("return");case 27:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAutoRetrieverDeviceDetails",true,false);case 28:fetchAutoRetrieverDeviceDetails(dispatcher);case 29:case"end":return _context3.stop();}}},_callee3,_this);}));return function(_x11){return _ref4.apply(this,arguments);};}());case 4:case"end":return _context4.stop();}}},_callee4,this);}));return function addAutoRetrieverDeviceDetails(_x8,_x9,_x10){return _ref3.apply(this,arguments);};}();var updateAutoRetrieverAsset=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatcher,request,showCustomAlert){var setAssetStatusResponse,startTime,getAssetResult,updateAssetResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);case 2:setAssetStatusResponse=_context5.sent;if(!(setAssetStatusResponse.status!==200)){_context5.next=7;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);fetchAutoRetrieverDeviceDetails(dispatcher);return _context5.abrupt("return");case 7:// Update asset details
startTime=Date.now();_context5.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_29" /* setAliasToRequest */])(request);case 10:_context5.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 12:getAssetResult=_context5.sent;_context5.next=15;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 15:updateAssetResponse=_context5.sent;isSuccess=updateAssetResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateAssetResponse.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAutoRetrieverDeviceDetails",isSuccess,isFault);fetchAutoRetrieverDeviceDetails(dispatcher);case 20:case"end":return _context5.stop();}}},_callee5,this);}));return function updateAutoRetrieverAsset(_x12,_x13,_x14){return _ref5.apply(this,arguments);};}();var getAutoRetrieverDeviceDetails=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatcher,request){var model;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:model={autoRetrieverDeviceInformation:{},testConfig:{},macAddressArray:[]// Fetch static asset details
};_context6.next=3;return getAutoRetrieverDeviceStaticDetails(dispatcher,model,request);case 3:case"end":return _context6.stop();}}},_callee6,this);}));return function getAutoRetrieverDeviceDetails(_x15,_x16){return _ref6.apply(this,arguments);};}();var getAutoRetrieverDeviceStaticDetails=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatcher,model,request){var pageToken,startTime,getAssetsResult,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:pageToken=null;// do-while loop until we get a valid pageToken
case 1:startTime=Date.now();_context7.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["g" /* getAssets */])(request.nodeId,request.assetType,pageToken);case 4:getAssetsResult=_context7.sent;isSuccess=getAssetsResult.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(getAssetsResult.status);// Log operation
Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAutoRetrieverDeviceDetails",isSuccess,isFault);if(isSuccess){addAutoRetrieverDeviceStaticDetailsToModel(getAssetsResult,model);// modifying pageToken to fetch from the latest get assets' result
pageToken=getAssetsResult.data.pageToken;}else{dispatcher({type:"RECEIVE_DATA",data:[]});}case 9:if(pageToken){_context7.next=1;break;}case 10:dispatcher({type:"RECEIVE_DATA",data:model});case 11:case"end":return _context7.stop();}}},_callee7,this);}));return function getAutoRetrieverDeviceStaticDetails(_x17,_x18,_x19){return _ref7.apply(this,arguments);};}();var setAssetLabelDeprecatedAutoRetrieverDeviceDetails=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatcher,request){var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:startTime=Date.now();Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetLabel,request.assetStatus).then(function(result){if(result.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteAutoRetrieverDeviceDetails",true,false);fetchAutoRetrieverDeviceDetails(dispatcher);}else{var isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(result.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteAutoRetrieverDeviceDetails",false,isFault);dispatcher({type:"RECEIVE_DATA",data:[]});}});case 2:case"end":return _context8.stop();}}},_callee8,this);}));return function setAssetLabelDeprecatedAutoRetrieverDeviceDetails(_x20,_x21){return _ref8.apply(this,arguments);};}();var updateAutoRetrieverMonitoringSchedule=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatcher,request){var startTime,getAssetResult,updateAssetInPlaceResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:// Update asset details
startTime=Date.now();_context10.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 3:getAssetResult=_context10.sent;_context10.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["l" /* updateAssetInPlace */])(request,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.lastUpdateTime;},null));case 6:updateAssetInPlaceResponse=_context10.sent;isSuccess=updateAssetInPlaceResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateAssetInPlaceResponse.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAutoRetrieverDeviceDetails",isSuccess,isFault);fetchAutoRetrieverDeviceDetails(dispatcher);case 11:case"end":return _context10.stop();}}},_callee10,this);}));return function updateAutoRetrieverMonitoringSchedule(_x25,_x26){return _ref10.apply(this,arguments);};}();var fetchNodeResources=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatcher,resourceType,metricName,receiveAction){var startTime,result,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:startTime=Date.now();_context11.prev=1;_context11.next=4;return Object(__WEBPACK_IMPORTED_MODULE_5__resources_NodeResource__["b" /* getResourcesV2 */])(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),resourceType);case 4:result=_context11.sent;if(result.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,metricName,true,false);dispatcher({type:receiveAction,data:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return result.data.nodeResources;},[])});}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(result.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,metricName,false,isFault);dispatcher({type:receiveAction,data:[]});}_context11.next=13;break;case 8:_context11.prev=8;_context11.t0=_context11["catch"](1);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,metricName,false,true);console.error("Failed to fetch node resources for "+resourceType,_context11.t0);dispatcher({type:receiveAction,data:[]});case 13:case"end":return _context11.stop();}}},_callee11,this,[[1,8]]);}));return function fetchNodeResources(_x27,_x28,_x29,_x30){return _ref11.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="AUTO_RETRIEVER_DEVICE_DETAILS";function fetchAutoRetrieverDeviceDetails(dispatcher){var request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["S" /* AUTO_RETRIEVER_ASSET_TYPE */]};getAutoRetrieverDeviceDetails(dispatcher,request);}function setAutoRetrieverDeviceDetails(dispatcher,stateValues,showCustomAlert){stateValues.mac=stateValues.mac.toLowerCase();var request=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["S" /* AUTO_RETRIEVER_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);addAutoRetrieverDeviceDetails(dispatcher,request,showCustomAlert);}function updateAutoRetrieverDeviceDetails(dispatcher,stateValues,showCustomAlert){var request=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["S" /* AUTO_RETRIEVER_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);updateAutoRetrieverAsset(dispatcher,request,showCustomAlert);}function deleteAutoRetrieverDeviceDetails(dispatcher,mac){var request={assetLabel:{type:"MAC_ADDRESS",value:mac},assetStatus:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_19" /* DEPRECATED */]};setAssetLabelDeprecatedAutoRetrieverDeviceDetails(dispatcher,request);}var updateAutoRetrieverDeviceMac=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher,stateValues,mac,showCustomAlert){var startTime,assetLabel,assetResult,nodeId,assetStatus;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:startTime=Date.now();assetLabel=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(stateValues.mac.toLowerCase());_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(assetLabel);case 4:assetResult=_context.sent;nodeId=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.nodeId;},null);assetStatus=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.assetStatus;},null);if(assetStatus&&!Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(assetStatus)){showCustomAlert(Object(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_225" /* getUpdateAssetMessageAlertWithSite */])(nodeId));Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAutoRetrieverDeviceDetails",false,false);}else{deleteAutoRetrieverDeviceDetails(dispatcher,mac);setAutoRetrieverDeviceDetails(dispatcher,stateValues,showCustomAlert);}case 8:case"end":return _context.stop();}}},_callee,this);}));return function updateAutoRetrieverDeviceMac(_x,_x2,_x3,_x4){return _ref.apply(this,arguments);};}();var startMockTestForAutoRetriever=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatcher,mac,showCustomAlert){var requestInput,startTime,args,response,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;requestInput={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),macAddress:mac};startTime=Date.now();args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(requestInput,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_63" /* ENDPOINT_START_MOCK_TEST_FOR_AR */]);_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_4__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 6:response=_context2.sent;if(response.status===__WEBPACK_IMPORTED_MODULE_6_http_status_codes__["a" /* default */].OK){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"startMockTestForAR",true,false);setTimeout(function(){dispatcher({type:'LOAD_VIEW',data:{dispatcher:dispatcher}});},__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_199" /* TEN_SECONDS_LOADER_TIMER */]);}else{isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"startMockTestForAR",false,isFault);dispatcher({type:'LOAD_VIEW',data:{dispatcher:dispatcher}});showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["y" /* ALERT_START_AR_MOCK_TEST */]);}_context2.next=14;break;case 10:_context2.prev=10;_context2.t0=_context2["catch"](0);console.log("Mac Address "+mac+" start mock test failed ",_context2.t0);showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["y" /* ALERT_START_AR_MOCK_TEST */]);case 14:case"end":return _context2.stop();}}},_callee2,this,[[0,10]]);}));return function startMockTestForAutoRetriever(_x5,_x6,_x7){return _ref2.apply(this,arguments);};}();var addAutoRetrieverDeviceStaticDetailsToModel=function addAutoRetrieverDeviceStaticDetailsToModel(result,model){if("data"in result&&"assetDetailsList"in result.data){result.data.assetDetailsList.forEach(function(deviceDetail){if(deviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]){model.macAddressArray.push(deviceDetail.assetAttributes.mac);var mac=deviceDetail.assetAttributes.mac;var id=JSON.parse(deviceDetail.assetAttributes.deviceConfig).id;model.autoRetrieverDeviceInformation[mac]={name:deviceDetail.assetAttributes.name,mac:deviceDetail.assetAttributes.mac,ip:deviceDetail.assetAttributes.ip,id:id,port:deviceDetail.assetAttributes.port,vendorAttributes:deviceDetail.vendorAttributes||__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */],assetStatus:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_110" /* LOADING_STRING */],deviceType:deviceDetail.assetAttributes.deviceType,assetType:deviceDetail.assetType,pickStations:JSON.parse(deviceDetail.assetAttributes.pickStations),pickStationConfig:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.pickStationConfig);},[]),retrieverLocationMapping:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.retrieverLocationMapping);},[]),startTime:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.monitoring).startTime;},"0"),endTime:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.monitoring).endTime;},"0"),reason:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.monitoring).reason;},"")};model.testConfig[mac]=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.testConfigForAR);},{});}});}return model;};var updateAutoRetrieverMonitoringDetails=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatcher,stateValues,mac){var getAssetResult,updatedAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 2:getAssetResult=_context9.sent;updatedAsset=updateExistingAssetAttributes(getAssetResult.data.asset,stateValues);updateAutoRetrieverMonitoringSchedule(dispatcher,updatedAsset);case 5:case"end":return _context9.stop();}}},_callee9,this);}));return function updateAutoRetrieverMonitoringDetails(_x22,_x23,_x24){return _ref9.apply(this,arguments);};}();var updateExistingAssetAttributes=function updateExistingAssetAttributes(asset,stateValues){var updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["t" /* deepCopyObject */])(asset);updatedAsset.assetDetails.assetAttributes.monitoring=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(stateValues);},asset.assetDetails.assetAttributes.monitoring);return updatedAsset;};var fetchPickStationResources=function fetchPickStationResources(dispatcher){return fetchNodeResources(dispatcher,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_141" /* NODE_RESOURCE_TYPE */].PICK_STATION,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_124" /* METRIC_GET_PICK_STATION_RESOURCES */],"RECEIVE_PICK_STATION_RESOURCES");};var fetchPickPointResources=function fetchPickPointResources(dispatcher){return fetchNodeResources(dispatcher,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_141" /* NODE_RESOURCE_TYPE */].PICK_POINT,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_123" /* METRIC_GET_PICK_POINT_RESOURCES */],"RECEIVE_PICK_POINT_RESOURCES");};var updatePickStationConfig=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(dispatcher,mac,config,showCustomAlert){var startTime,getAssetResult,updatedAsset,updateResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:startTime=Date.now();_context12.prev=1;_context12.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 4:getAssetResult=_context12.sent;updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["t" /* deepCopyObject */])(getAssetResult.data.asset);updatedAsset.assetDetails.assetAttributes.pickStationConfig=JSON.stringify(config);_context12.next=9;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["l" /* updateAssetInPlace */])(updatedAsset,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.lastUpdateTime;},null));case 9:updateResponse=_context12.sent;isSuccess=updateResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateResponse.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_127" /* METRIC_UPDATE_PICK_STATION_CONFIG */],isSuccess,isFault);if(!isSuccess){showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);}fetchAutoRetrieverDeviceDetails(dispatcher);_context12.next=23;break;case 17:_context12.prev=17;_context12.t0=_context12["catch"](1);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_127" /* METRIC_UPDATE_PICK_STATION_CONFIG */],false,true);console.error("Failed to update pick station config",_context12.t0);showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);fetchAutoRetrieverDeviceDetails(dispatcher);case 23:case"end":return _context12.stop();}}},_callee12,this,[[1,17]]);}));return function updatePickStationConfig(_x31,_x32,_x33,_x34){return _ref12.apply(this,arguments);};}();var updateRetrieverLocationMapping=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(dispatcher,mac,config,showCustomAlert){var startTime,getAssetResult,updatedAsset,updateResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:startTime=Date.now();_context13.prev=1;_context13.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 4:getAssetResult=_context13.sent;updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["t" /* deepCopyObject */])(getAssetResult.data.asset);updatedAsset.assetDetails.assetAttributes.retrieverLocationMapping=JSON.stringify(config);_context13.next=9;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["l" /* updateAssetInPlace */])(updatedAsset,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.lastUpdateTime;},null));case 9:updateResponse=_context13.sent;isSuccess=updateResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateResponse.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_128" /* METRIC_UPDATE_RETRIEVER_LOCATION_MAPPING */],isSuccess,isFault);if(!isSuccess){showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);}fetchAutoRetrieverDeviceDetails(dispatcher);_context13.next=23;break;case 17:_context13.prev=17;_context13.t0=_context13["catch"](1);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_128" /* METRIC_UPDATE_RETRIEVER_LOCATION_MAPPING */],false,true);console.error("Failed to update retriever location mapping",_context13.t0);showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);fetchAutoRetrieverDeviceDetails(dispatcher);case 23:case"end":return _context13.stop();}}},_callee13,this,[[1,17]]);}));return function updateRetrieverLocationMapping(_x35,_x36,_x37,_x38){return _ref13.apply(this,arguments);};}();

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AutoRetrieverDeviceOverviewContext__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_Constants__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddAutoRetrieverSingleDeviceModal=function AddAutoRetrieverSingleDeviceModal(props){var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_AutoRetrieverDeviceOverviewContext__["a" /* AutoRetrieverDeviceOverviewContext */]),viewModel=_useContext2.viewModel,dispatch=_useContext2.dispatch;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),name=_useState4[0],setName=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),mac=_useState6[0],setMac=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),ip=_useState8[0],setIp=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),port=_useState10[0],setPort=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),deviceType=_useState12[0],setDeviceType=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),id=_useState14[0],setId=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),vendor=_useState16[0],setVendor=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),specVersion=_useState18[0],setSpecVersion=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState20=_slicedToArray(_useState19,2),pickStations=_useState20[0],setPickStations=_useState20[1];// Error
var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),nameErr=_useState22[0],setNameErr=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),macErr=_useState24[0],setMacErr=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),ipErr=_useState26[0],setIpErr=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),portErr=_useState28[0],setPortErr=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState30=_slicedToArray(_useState29,2),deviceTypeErr=_useState30[0],setDeviceTypeErr=_useState30[1];var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState32=_slicedToArray(_useState31,2),idErr=_useState32[0],setIdErr=_useState32[1];var _useState33=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState34=_slicedToArray(_useState33,2),vendorErr=_useState34[0],setVendorErr=_useState34[1];var _useState35=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState36=_slicedToArray(_useState35,2),specVersionErr=_useState36[0],setSpecVersionErr=_useState36[1];var _useState37=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState38=_slicedToArray(_useState37,2),pickStationsErr=_useState38[0],setPickStationsErr=_useState38[1];var initialMonitoringValue={startTime:"0",endTime:"0",reason:""};var _useState39=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(JSON.stringify(initialMonitoringValue)),_useState40=_slicedToArray(_useState39,2),monitoring=_useState40[0],setMonitoring=_useState40[1];var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext3.showCustomAlert;var stateValues={name:name,mac:mac,ip:ip,port:port,deviceType:deviceType,deviceConfig:{type:__WEBPACK_IMPORTED_MODULE_3__util_Util__["e" /* assetTypeToConfigTypeDict */].typeAUTO_RETRIEVER,id:id},vendorAttributes:{vendor:vendor,spec_version:specVersion},monitoring:monitoring,pickStations:pickStations};var onClickConfirm=function onClickConfirm(stateValues){if(Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["W" /* validateNewAutoRetrieverDevice */])(stateValues)){showWarning(Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"device.editWarning"}),function(){setShowAlert(false);stateValues.deviceConfig=JSON.stringify(stateValues.deviceConfig);stateValues.pickStations=JSON.stringify(pickStations.split(__WEBPACK_IMPORTED_MODULE_15__util_Constants__["_178" /* SEMI_COLON */]).filter(Boolean).sort());stateValues.testConfigForAR=JSON.stringify(viewModel.testConfig[stateValues.mac]);if(selected){updateData(stateValues);}else{addData(stateValues);}resetInputState();setOpen(false);});}else{setShowAlert(true);}};var addData=function addData(stateValues){dispatch({type:'ADD_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues,showCustomAlert:showCustomAlert}});};var updateData=function updateData(stateValues){dispatch({type:'UPDATE_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues,showCustomAlert:showCustomAlert}});};var onCloseModal=function onCloseModal(){setOpen(false);setSelected("");resetInputState();setShowAlert(false);};function resetInputState(){// setting state of input fields as empty to have empty inputs on clicking Add Device again
setMac("");setMacErr(false);setMonitoring(JSON.stringify(initialMonitoringValue));resetAssetDetails();resetAssetDetailErrors();}var resetAssetDetails=function resetAssetDetails(){setName("");setIp("");setPort("");setDeviceType("");setId("");setVendor("");setSpecVersion("");setPickStations("");};var resetAssetDetailErrors=function resetAssetDetailErrors(){setNameErr(false);setIpErr(false);setPortErr(false);setDeviceTypeErr(false);setIdErr(false);setVendorErr(false);setSpecVersionErr(false);setPickStationsErr(false);};var prefill=function prefill(value){if(viewModel.autoRetrieverDeviceInformation.hasOwnProperty(value)){setSelected(value);var device=viewModel.autoRetrieverDeviceInformation[value];var vendorAttributes=device.vendorAttributes;resetAssetDetailErrors();setName(device.name);setMac(device.mac);setIp(device.ip);setPort(device.port);setDeviceType(device.deviceType);setId(device.id);setVendor(vendorAttributes.vendor);setSpecVersion(vendorAttributes.spec_version);var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};setMonitoring(JSON.stringify(deviceMonitoring));setPickStations(Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_0" /* getPickStationsValue */])(device.pickStations));}else if(selected){setSelected("");resetAssetDetails();}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal___default.a,{title:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"device.add_device_button_modal"}),open:open,onOpen:function onOpen(){return prefill(selected);},onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.mac"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"mac-input",value:mac,onChange:setMac,mask:__WEBPACK_IMPORTED_MODULE_4__util_Validations__["i" /* MAC_MASK */],disabled:selected,onBlur:function onBlur(){setMacErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.mac,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].MAC));prefill(mac);},error:macErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"ip-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.ip"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"ip-input",value:ip,onChange:setIp,onBlur:function onBlur(){return setIpErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.ip,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["g" /* IP_ADDRESS_PATTERN */]));},error:ipErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"port-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.port"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"port-input",value:port,onChange:setPort,onBlur:function onBlur(){return setPortErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.port,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].PORT));},error:portErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.protocol"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{id:"device-type-input",value:deviceType,onChange:function onChange(value){return setDeviceType(value);},onBlur:function onBlur(){return setDeviceTypeErr(!deviceType);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.select_protocol"}),error:deviceTypeErr,width:"100%"},__WEBPACK_IMPORTED_MODULE_4__util_Validations__["k" /* PROTOCOLS */].AUTO_RETRIEVER.map(function(protocol){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{key:protocol,value:protocol,label:protocol});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"name-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"name-input",value:name,onChange:setName,onBlur:function onBlur(){return setNameErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.name,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].NAME));},error:nameErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.name_cluster_desc"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"id-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.device_id"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"id-input",value:id,onChange:setId,onBlur:function onBlur(){return setIdErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.deviceConfig.id,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].DEVICE_ID));},error:idErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.device_id_cluster_desc"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{id:"device-type-input",value:vendor,onChange:function onChange(value){return setVendor(value);},onBlur:function onBlur(){return setVendorErr(!vendor);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_vendor'}),error:vendorErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["r" /* VENDOR_INFO_KEYS */].VENDOR).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_4__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.spec_version'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{id:"device-type-input",value:specVersion,onChange:function onChange(value){return setSpecVersion(value);},onBlur:function onBlur(){return setSpecVersionErr(!specVersion);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_version'}),error:specVersionErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["r" /* VENDOR_INFO_KEYS */].SPEC_VERSION).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_4__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"ps-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.pick_stations"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"id-input",value:pickStations,onChange:setPickStations,onBlur:function onBlur(){return setPickStationsErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.pickStations,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].PICK_STATIONS));},error:pickStationsErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.pick_stations_desc"})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default.a,{type:"warning",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'alert.missingfields'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.cancel'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stateValues);}},selected?Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.confirmEdit'}):Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.confirmAdd'})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddAutoRetrieverSingleDeviceModal));

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AutoRetrieverDeviceOverviewContext__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutoRetrieverDevicePage=function(_Component){_inherits(AutoRetrieverDevicePage,_Component);function AutoRetrieverDevicePage(){_classCallCheck(this,AutoRetrieverDevicePage);return _possibleConstructorReturn(this,(AutoRetrieverDevicePage.__proto__||Object.getPrototypeOf(AutoRetrieverDevicePage)).apply(this,arguments));}_createClass(AutoRetrieverDevicePage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_AutoRetrieverDeviceOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["l" /* AUTO_RETRIEVER */],location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["l" /* AUTO_RETRIEVER */]})));}}]);return AutoRetrieverDevicePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AutoRetrieverDevicePage);

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_BagTrackingContext__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BagTracking__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BagTrackingUtil__ = __webpack_require__(312);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BagTrackingPage=function(_Component){_inherits(BagTrackingPage,_Component);function BagTrackingPage(){_classCallCheck(this,BagTrackingPage);return _possibleConstructorReturn(this,(BagTrackingPage.__proto__||Object.getPrototypeOf(BagTrackingPage)).apply(this,arguments));}_createClass(BagTrackingPage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BagTrackingUtil__["a" /* BagTrackingBanner */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_BagTrackingContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BagTracking__["a" /* default */],null)));}}]);return BagTrackingPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (BagTrackingPage);

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BagTrackingReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_BagTrackingNetworkAPI__ = __webpack_require__(1351);
var BagTrackingReducer=function BagTrackingReducer(state,action){switch(action.type){case'RECEIVE_DATA':state.bagList=action.data.bagList?action.data.bagList:{};state.loadingOverview=false;return Object.assign({},state);case'LOAD_VIEW':Object(__WEBPACK_IMPORTED_MODULE_0__network_BagTrackingNetworkAPI__["a" /* fetchBagLocationInfo */])(action.data.dispatcher);return Object.assign({},state);default:return state;}};

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchBagLocationInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__ = __webpack_require__(51);
var getBagLocationInfo=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher,request){var startTime,response,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:startTime=Date.now();_context.next=3;return getBagLocationInfoDetails(request.nodeId);case 3:response=_context.sent;isSuccess=response.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(response.status);// Log operations. This adds a metric on how many HTTPS requests are successfully completed.
Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getBagLocationInfo",isSuccess,isFault);dispatcher({type:"RECEIVE_DATA",data:{bagList:response.data}});case 8:case"end":return _context.stop();}}},_callee,this);}));return function getBagLocationInfo(_x,_x2){return _ref.apply(this,arguments);};}();var getBagLocationInfoDetails=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(siteId){var requestBody,args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:requestBody={"nodeId":siteId};args=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["A" /* getAPIGatewayPostRequest */])(requestBody,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_45" /* ENDPOINT_GET_BAG_LOCATION_INFO */]);_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args);case 4:return _context2.abrupt("return",_context2.sent);case 5:case"end":return _context2.stop();}}},_callee2,this);}));return function getBagLocationInfoDetails(_x3){return _ref2.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="BAG_LOCATION_DETAILS";function fetchBagLocationInfo(dispatcher){var request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])()};getBagLocationInfo(dispatcher,request);};;;

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_pagination__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_heading__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__context_BagTrackingContext__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BagTrackingUtil__ = __webpack_require__(312);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var BagTracking=function BagTracking(){var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__context_BagTrackingContext__["a" /* BagTrackingContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var getBagInfo=function getBagInfo(){dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};/** In Line Table Filters **/var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),transporterIdFilter=_useState2[0],setTransporterIdFilter=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),bagIdFilter=_useState4[0],setBagIdFilter=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),bagStatusFilter=_useState6[0],setBagStatusFilter=_useState6[1];/** Time and Date Filter **/var today=new Date();var utcHours=today.getUTCHours();var startTime="12:00:00";//Hardcoding start time for pilot at DJR5. It is according to depart time at the station.
var startDate=void 0;//If current UTC hours is between 0 and 12 then we need to consider previous day also for displaying bagInfo as we're displaying data from 12 UTC (d-1) - 12 UTC (d)
if(utcHours>=0&&utcHours<12){startDate=new Date(Date.UTC(today.getUTCFullYear(),today.getUTCMonth(),today.getUTCDate()-1)).toISOString().slice(0,10);}else{startDate=new Date(today).toISOString().slice(0,10);}/** Initial Date Time Filter Values **/var dateTimeFilterValues={startDate:startDate,startTime:startTime};/** Sorting. This section keeps the states for sorting column **/var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("departEventTime"),_useState8=_slicedToArray(_useState7,2),sortColumn=_useState8[0],setSortColumn=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("ascending"),_useState10=_slicedToArray(_useState9,2),sortDirection=_useState10[0],setSortDirection=_useState10[1];var onSort=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(_ref){var sortColumn=_ref.sortColumn,sortDirection=_ref.sortDirection;setSortDirection(sortDirection);setSortColumn(sortColumn);},[]);/** Pagination State. This section creates state for pagination. If number of item is greater than 50, a new page will be generated **/var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),_useState12=_slicedToArray(_useState11,2),currentPage=_useState12[0],setCurrentPage=_useState12[1];var itemOnPage=50;var bagInfoList=[];var bagTrackingMetrics={totalBags:0,departedBags:0,receivedBags:0};if(viewModel.loadingOverview===false){if(viewModel.bagList!=null){bagInfoList=viewModel.bagList.bagLocationInfoList?viewModel.bagList.bagLocationInfoList:[];/** Filter Bag Info based on filter values **/bagInfoList=bagInfoList.filter(function(bag){return Object(__WEBPACK_IMPORTED_MODULE_13__BagTrackingUtil__["f" /* filterBagInfoByDepartTime */])(bag,dateTimeFilterValues);}).filter(function(bag){return Object(__WEBPACK_IMPORTED_MODULE_13__BagTrackingUtil__["e" /* filterBagInfo */])(bag,transporterIdFilter,"transporterId");}).filter(function(bag){return Object(__WEBPACK_IMPORTED_MODULE_13__BagTrackingUtil__["e" /* filterBagInfo */])(bag,bagIdFilter,"bagId");}).filter(function(bag){return Object(__WEBPACK_IMPORTED_MODULE_13__BagTrackingUtil__["e" /* filterBagInfo */])(bag,bagStatusFilter,"eventType");});};bagInfoList.forEach(function(bag){Object(__WEBPACK_IMPORTED_MODULE_13__BagTrackingUtil__["g" /* setBagStatus */])(bag);switch(bag.eventType){case"Outside Station":bagTrackingMetrics.departedBags=bagTrackingMetrics.departedBags+1;break;case"Inside Station":bagTrackingMetrics.receivedBags=bagTrackingMetrics.receivedBags+1;break;default:break;};bagTrackingMetrics.totalBags=bagTrackingMetrics.totalBags+1;});};bagInfoList.sort(function(a,b){if(a[sortColumn]<b[sortColumn]){return sortDirection===__WEBPACK_IMPORTED_MODULE_10__util_Constants__["J" /* ASCENDING */]?-1:1;};if(a[sortColumn]>b[sortColumn]){return sortDirection===__WEBPACK_IMPORTED_MODULE_10__util_Constants__["J" /* ASCENDING */]?1:-1;};return 0;});/** Pagination State. This section creates state for pagination. If number of item is greater than 50, a new page will be generated **/var totalPages=Math.ceil(bagInfoList.length/itemOnPage);var startIndexInPage=(currentPage-1)*itemOnPage;var endIndexInPage=Math.min(startIndexInPage+itemOnPage-1,bagInfoList.length-1);if(startIndexInPage>bagInfoList.length){setCurrentPage(1);};/** Get Bag Info and refresh the information in a proper interval**/Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){getBagInfo();var interval=setInterval(function(){if(!document.hidden){getBagInfo();};},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_1" /* getRFIDStatusRefreshInterval */])());return function(){clearInterval(interval);};},[]);return viewModel.loadingOverview?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__loader_Loader__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_heading___default.a,{level:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"bagTracking.heading",defaultMessage:"Bag Tracking"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{widths:["grid-4","grid-4","grid-4"],alignmentVertical:"bottom",spacingInset:"300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_box___default.a,{type:"outline",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BagTrackingUtil__["c" /* StageStatusView */],{stageStatus:{title:"bag.total",message:"Total Bags",value:bagTrackingMetrics.totalBags}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_box___default.a,{type:"outline",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{width:"100%",spacing:"small",alignmentVertical:"bottom"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BagTrackingUtil__["c" /* StageStatusView */],{stageStatus:{title:"bag.departed",message:"Outside Station",value:bagTrackingMetrics.departedBags}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BagTrackingUtil__["c" /* StageStatusView */],{stageStatus:{title:"bag.received",message:"Inside Station",value:bagTrackingMetrics.receivedBags}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BagTrackingUtil__["b" /* ScrollableElementWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{width:"100%",widths:"fill",className:"enable-scroll-x"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table___default.a,{showStripes:true,headerColumns:1,stickyHeaderColumn:true,fixHeaderRows:true,headerRows:1,stickyHeaderRow:true,showDividers:true,spacing:"small",sortColumn:sortColumn,sortDirection:sortDirection,onSort:onSort},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"center",sortColumn:"transporterId"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"bagTable.transporterId",defaultMessage:"Transporter ID"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"center",sortColumn:"bagId"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"bagTable.bagId",defaultMessage:"Bag ID"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"center",sortColumn:"eventType"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"bagTable.bagStatus",defaultMessage:"Bag Status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"center",sortColumn:"departEventTime"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"bagTable.departTime",defaultMessage:"Depart Time"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"center",sortColumn:"receiveEventTime"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */],{id:"bagTable.receiveTime",defaultMessage:"Receive Time"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_input___default.a,{alignmentHorizontal:"center",type:"text",size:"small",value:transporterIdFilter,onChange:setTransporterIdFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_input___default.a,{alignmentHorizontal:"center",type:"text",size:"small",value:bagIdFilter,onChange:setBagIdFilter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_input___default.a,{type:"text",size:"small",value:bagStatusFilter,onChange:setBagStatusFilter}))),bagInfoList?bagInfoList.map(function(bag,key){return key>=startIndexInPage&&key<=endIndexInPage?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableRow"],{key:bag.bagId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"center"},bag.transporterId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"center"},bag.bagId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"center"},bag.eventType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"center"},Object(__WEBPACK_IMPORTED_MODULE_13__BagTrackingUtil__["d" /* convertTimestampToLocaleString */])(bag.departEventTime,bag.eventType,__WEBPACK_IMPORTED_MODULE_10__util_Constants__["V" /* BAG_TRACKING_CONSTANTS */].DEPART_TIME)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_table__["TableCell"],{alignmentHorizontal:"center"},Object(__WEBPACK_IMPORTED_MODULE_13__BagTrackingUtil__["d" /* convertTimestampToLocaleString */])(bag.receiveEventTime,bag.eventType,__WEBPACK_IMPORTED_MODULE_10__util_Constants__["V" /* BAG_TRACKING_CONSTANTS */].RECEIVE_TIME))):null;}):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{width:"100%",alignmentHorizontal:"center",spacingInset:"medium none none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_pagination___default.a,{numberOfPages:totalPages,onChange:setCurrentPage,currentPage:currentPage}))))))));};/* harmony default export */ __webpack_exports__["a"] = (BagTracking);

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(23));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _text = _interopRequireDefault(__webpack_require__(9));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(39));

var Heading = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
  return /*#__PURE__*/_react["default"].createElement(_text["default"], (0, _extends2["default"])({
    type: props.type ? props.type : "h".concat(7 - props.level, "00"),
    tag: "h".concat(props.level),
    id: props.id,
    color: props.color,
    alignment: props.alignment,
    transform: props.transform,
    truncate: props.truncate,
    fontFamily: props.fontFamily,
    className: props.className,
    tabIndex: props.tabIndex,
    ref: ref
  }, passThroughProps), props.children);
});

Heading.displayName = "Heading";
Heading.propTypes =  false ? {
  /**
   * The heading text.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * The heading level. This corresponds directly to the [6 HTML headings](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Heading_Elements).
   */
  level: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]).isRequired,

  /**
   * The text alignment of the heading.
   */
  alignment: _propTypes["default"].oneOf(["left", "start", "center", "right", "end", "justify"]),

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * The color of the heading's text. See the [Color Fundamentals page](https://meridian.a2z.com/fundamentals/color/?platform=react-web)
   * for information on the correct usage of these colors.
   */
  color: _propTypes["default"].oneOf(["primary", "secondary"]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.18.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * The font family of the heading's text. This is an advanced feature, and
   * generally should not be changed.
   *
   * Note that you must manually load the necessary web fonts before using this
   * prop.
   */
  fontFamily: _propTypes["default"].oneOf(["amazonEmber", "amazonEmberDisplay", "amazonEmberMonospace", "bookerly", "bookerlyDisplay"]),

  /**
   * Sets an `id` attribute on the component's DOM element.
   *
   * Use this for testing, for accessibility, or to target custom elements
   * inside the component. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * Setting tabIndex to "-1" allows the Heading to be programmatically focused
   * without adding it to the tab order. Programmatically focusing is useful
   * when, for instance, a user presses an anchor link and expects to scroll
   * and focus on particular content.
   *
   * @since 5.23.0
   */
  tabIndex: _propTypes["default"].oneOf(["-1"]),

  /**
   * Use this to apply a [CSS text transform](https://developer.mozilla.org/en-US/docs/Web/CSS/text-transform)
   * to the heading.
   */
  transform: _propTypes["default"].oneOf(["none", "capitalize", "uppercase", "lowercase"]),

  /**
   * Set this to true to truncate the text to a single line using ellipsis. If
   * the text already fits on a single line no truncation will be applied. This
   * relies on the CSS text-overflow property, refer to [the text-overflow documentation](https://developer.mozilla.org/en-US/docs/Web/CSS/text-overflow)
   * for details.
   */
  truncate: _propTypes["default"].bool,

  /**
   * This determines which entry from [Meridian's type scale](https://meridian.a2z.com/fundamentals/typography/?platform=reactjs&detailsTab=type-scale)
   * is used to render the heading text.
   */
  type: _propTypes["default"].oneOf(["d300", "d200", "d100", "d50", "h600", "h500", "h400", "h300", "h200", "h100", "b500", "b400", "b300", "b200", "b100"])
} : {};
var _default = Heading;
exports["default"] = _default;

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonui_CommonDeviceLogstream__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_ZancaSortDeviceOverviewContext__ = __webpack_require__(149);
var ZancaSortDeviceLogstream=function ZancaSortDeviceLogstream(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__context_ZancaSortDeviceOverviewContext__["a" /* ZancaSortDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var deviceList=Object.values(viewModel.zancaSortDeviceInformation);var props={protocols:__WEBPACK_IMPORTED_MODULE_3__util_Validations__["k" /* PROTOCOLS */].ZANCASORT,dispatch:dispatch,deviceList:deviceList,deviceType:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_222" /* ZANCASORT_ASSET_TYPE */],intl:intl};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonui_CommonDeviceLogstream__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ZancaSortDeviceLogstream));

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonui_CommonDeviceLogstream__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_TesseractDeviceOverviewContext__ = __webpack_require__(181);
var TesseractDeviceLogstream=function TesseractDeviceLogstream(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__context_TesseractDeviceOverviewContext__["a" /* TesseractDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var deviceList=Object.values(viewModel.tesseractDeviceInformation);var props={protocols:__WEBPACK_IMPORTED_MODULE_3__util_Validations__["k" /* PROTOCOLS */].TESSERACT,dispatch:dispatch,deviceList:deviceList,deviceType:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_200" /* TESSERACT_ASSET_TYPE */],intl:intl};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonui_CommonDeviceLogstream__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(TesseractDeviceLogstream));

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonui_CommonDeviceLogstream__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_AutoRetrieverDeviceOverviewContext__ = __webpack_require__(122);
var AutoRetrieverDeviceLogstream=function AutoRetrieverDeviceLogstream(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__context_AutoRetrieverDeviceOverviewContext__["a" /* AutoRetrieverDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var deviceList=Object.values(viewModel.autoRetrieverDeviceInformation);var props={protocols:__WEBPACK_IMPORTED_MODULE_3__util_Validations__["k" /* PROTOCOLS */].AUTO_RETRIEVER,dispatch:dispatch,deviceList:deviceList,deviceType:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["S" /* AUTO_RETRIEVER_ASSET_TYPE */],intl:intl};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonui_CommonDeviceLogstream__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(AutoRetrieverDeviceLogstream));

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_SelectLayout__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_FeatureUtility__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AsmlSubComponentSelectPage=function(_Component){_inherits(AsmlSubComponentSelectPage,_Component);function AsmlSubComponentSelectPage(){_classCallCheck(this,AsmlSubComponentSelectPage);return _possibleConstructorReturn(this,(AsmlSubComponentSelectPage.__proto__||Object.getPrototypeOf(AsmlSubComponentSelectPage)).apply(this,arguments));}_createClass(AsmlSubComponentSelectPage,[{key:"render",value:function render(){var routes=__WEBPACK_IMPORTED_MODULE_4__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_4__util_FeatureUtility__["a" /* FEATURES */].IS_IN_SITE_ENABLED)?__WEBPACK_IMPORTED_MODULE_2__util_RouteConstants__["q" /* IN_SITE_ASML_SUB_COMPONENT_ROUTES */]:__WEBPACK_IMPORTED_MODULE_2__util_RouteConstants__["i" /* ASML_SUB_COMPONENT_ROUTES */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_SelectLayout__["b" /* default */],{routes:[].concat(_toConsumableArray(routes)).sort(function(a,b){return a.name.localeCompare(b.name);}),location:this.props.location,history:this.props.history,isComponentTypeSelect:"true"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_SelectLayout__["a" /* NavigationRoutes */],{routes:routes}));}}]);return AsmlSubComponentSelectPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AsmlSubComponentSelectPage);

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_SelectLayout__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AsmlProtocolValidationSubComponentSelectionPage=function(_Component){_inherits(AsmlProtocolValidationSubComponentSelectionPage,_Component);function AsmlProtocolValidationSubComponentSelectionPage(){_classCallCheck(this,AsmlProtocolValidationSubComponentSelectionPage);return _possibleConstructorReturn(this,(AsmlProtocolValidationSubComponentSelectionPage.__proto__||Object.getPrototypeOf(AsmlProtocolValidationSubComponentSelectionPage)).apply(this,arguments));}_createClass(AsmlProtocolValidationSubComponentSelectionPage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_SelectLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__["j" /* ASML_SUB_COMPONENT_VALIDATION_ROUTES */].sort(function(a,b){return a.name.localeCompare(b.name);}),location:this.props.location,history:this.props.history,isComponentTypeSelect:"true"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_SelectLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__["j" /* ASML_SUB_COMPONENT_VALIDATION_ROUTES */]}));}}]);return AsmlProtocolValidationSubComponentSelectionPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AsmlProtocolValidationSubComponentSelectionPage);

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AsmlDeviceOverviewContext__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonui_mheValidation_ValidationTabBody__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mhevalidation_context_MHEValidationContext__ = __webpack_require__(180);
var InductCameraDeviceValidation=function InductCameraDeviceValidation(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_AsmlDeviceOverviewContext__["a" /* AsmlDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var deviceList=viewModel&&viewModel.inductCameraDeviceInformation?Object.values(viewModel.inductCameraDeviceInformation):[];var props={dispatch:dispatch,deviceList:deviceList,intl:intl};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__mhevalidation_context_MHEValidationContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonui_mheValidation_ValidationTabBody__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(InductCameraDeviceValidation));

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsmlDeviceOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
var AsmlDeviceOverviewReducer=function AsmlDeviceOverviewReducer(state,action){switch(action.type){case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingOverview:false,timestamp:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_14" /* getTimestampNow */])()});case"LOAD_VIEW":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["d" /* fetchAsmlDeviceDetails */])(action.data.dispatcher);return state;case"LOAD_STATUS":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["e" /* fetchAsmlDeviceStatusDetails */])(action.data.dispatcher,state);return state;case"ADD_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["g" /* setAsmlDeviceDetails */])(action.data.dispatcher,action.data.stateValues);return state;case"UPDATE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["k" /* updateAsmlDeviceDetails */])(action.data.dispatcher,action.data.stateValues);return state;case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});default:return state;}};

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonui_mheValidation_ValidationTabBody__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mhevalidation_context_MHEValidationContext__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_AsmlDeviceOverviewContext__ = __webpack_require__(150);
var VerificationCameraDeviceValidation=function VerificationCameraDeviceValidation(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__context_AsmlDeviceOverviewContext__["a" /* AsmlDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var deviceList=viewModel&&viewModel.verificationCameraDeviceInformation?Object.values(viewModel.verificationCameraDeviceInformation):[];var props={dispatch:dispatch,deviceList:deviceList,intl:intl};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__mhevalidation_context_MHEValidationContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonui_mheValidation_ValidationTabBody__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(VerificationCameraDeviceValidation));

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_InductCameraDeviceOverviewContext__ = __webpack_require__(313);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var InductCameraDevicePage=function(_Component){_inherits(InductCameraDevicePage,_Component);function InductCameraDevicePage(){_classCallCheck(this,InductCameraDevicePage);return _possibleConstructorReturn(this,(InductCameraDevicePage.__proto__||Object.getPrototypeOf(InductCameraDevicePage)).apply(this,arguments));}_createClass(InductCameraDevicePage,[{key:"render",value:function render(){var getInductCameraRoutes=function getInductCameraRoutes(){return __WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__["p" /* INDUCT_CAMERA */];};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__context_InductCameraDeviceOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["b" /* default */],{routes:getInductCameraRoutes(),location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["a" /* NavigationRoutes */],{routes:getInductCameraRoutes()})));}}]);return InductCameraDevicePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (InductCameraDevicePage);

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InductCameraDeviceOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
var InductCameraDeviceOverviewReducer=function InductCameraDeviceOverviewReducer(state,action){switch(action.type){case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingOverview:false,timestamp:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_14" /* getTimestampNow */])()});case"LOAD_VIEW":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["b" /* fetchAsmlComponentDetails */])(action.data.dispatcher,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_83" /* INDUCT_CAMERA_SUB_ASSET_TYPE */]);return state;case"LOAD_STATUS":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["c" /* fetchAsmlComponentStatusDetails */])(action.data.dispatcher,state);return state;case"ADD_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["f" /* setAsmlComponentDetails */])(action.data.dispatcher,action.data.stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_83" /* INDUCT_CAMERA_SUB_ASSET_TYPE */]);return state;case"UPDATE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["h" /* updateAsmlComponentDetails */])(action.data.dispatcher,action.data.stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_83" /* INDUCT_CAMERA_SUB_ASSET_TYPE */]);return state;case"DELETE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["a" /* deleteAsmlComponentDetails */])(action.data.dispatcher,action.data.mac);return state;case"UPDATE_DEVICE_MAC":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["i" /* updateAsmlComponentMac */])(action.data.dispatcher,action.data.stateValues,action.data.mac,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_83" /* INDUCT_CAMERA_SUB_ASSET_TYPE */]);return state;case"UPDATE_MONITORING_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["j" /* updateAsmlComponentMonitoringDetails */])(action.data.dispatcher,action.data.stateValues,action.data.mac,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_83" /* INDUCT_CAMERA_SUB_ASSET_TYPE */]);return state;case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});default:return state;}};

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_InductCameraDeviceOverviewContext__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modal_AddInductCameraSingleDeviceModal__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__commonui_DeleteSingleDeviceModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__commonui_DisableMonitoringModal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_Validations__ = __webpack_require__(15);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var InductCameraDeviceOverview=function InductCameraDeviceOverview(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_InductCameraDeviceOverviewContext__["a" /* InductCameraDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState2=_slicedToArray(_useState,2),openActionsMenu=_useState2[0],setOpenActionsMenu=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openAddModal=_useState4[0],setOpenAddModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),selected=_useState6[0],setSelected=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),openDeleteModal=_useState8[0],setOpenDeleteModal=_useState8[1];var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),openDisableMonitoringModal=_useState10[0],setOpenDisableMonitoringModal=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),mac=_useState12[0],setMac=_useState12[1];var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=true;setOpenActionsMenu(_open);},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=false;setOpenActionsMenu(_open);},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openAddModal&&!openDeleteModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["D" /* getAssetRefreshInterval */])());var statusInterval=setInterval(function(){if(!document.hidden){getStatusData();}},Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_11" /* getStatusRefreshInterval */])());return function(){clearInterval(interval);clearInterval(statusInterval);};}},[openAddModal,openDeleteModal]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,viewModel.asmlComponentInformation.length);},[viewModel.asmlComponentInformation]);var onSort=function onSort(sortDetails){dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};var sortedDeviceList=Object.values(viewModel.asmlComponentInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){var _viewModel$sortPref=viewModel.sortPref,column=_viewModel$sortPref.column,direction=_viewModel$sortPref.direction;var compareValue=void 0;if(Object.keys(__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */]).includes(column)){if(column==="vendor"){compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column]+a.vendorAttributes["spec_version"],b.vendorAttributes[column]+b.vendorAttributes["spec_version"]);}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column],b.vendorAttributes[column]);}}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a[column],b[column]);}if(direction===__WEBPACK_IMPORTED_MODULE_12__util_Constants__["J" /* ASCENDING */]){return compareValue;}else{return-compareValue;}});var updateData=function updateData(stateValues,mac){dispatch({type:'UPDATE_MONITORING_DATA',data:{dispatcher:dispatch,stateValues:stateValues,mac:mac}});};var onClickDisableMonitoring=function onClickDisableMonitoring(mac){setMac(mac);setOpenDisableMonitoringModal(true);};var onClickEnableMonitoring=function onClickEnableMonitoring(startTime,reason,mac){var stateValues={"startTime":startTime,"endTime":Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["I" /* getCurrentDate */])().toString(),"reason":reason};updateData(stateValues,mac);getData();};var renderDeviceMonitoring=function renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{style:{color:monitoringStatusColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:monitoringStatusId,defaultMessage:monitoringStatusDefaultMessage}));};var getData=function getData(){setOpenAddModal(false);setOpenDeleteModal(false);setOpenDisableMonitoringModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var getStatusData=function getStatusData(){dispatch({type:'LOAD_STATUS',data:{dispatcher:dispatch}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var onClickAddEditDevice=function onClickAddEditDevice(){setSelected("");setOpenAddModal(true);};var onClickEditDevice=function onClickEditDevice(mac){setSelected(mac);setOpenAddModal(true);};var onClickRemove=function onClickRemove(mac){setSelected(mac);setOpenDeleteModal(true);};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default.a,{position:"top",title:intl.formatMessage({id:'tooltip.scrolltobottom',defaultMessage:'Scroll to bottom'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.device",defaultMessage:"No device present for this station."})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.name",defaultMessage:"Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.mac_ip",defaultMessage:"MAC/IP"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_22__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.connectionstatus'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"connection"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.connection",defaultMessage:"Connection Status"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.monitoring",defaultMessage:"Monitoring Status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"vendor"},Object(__WEBPACK_IMPORTED_MODULE_22__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'device.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.firmwareVersion",defaultMessage:"Firmware Version"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.action",defaultMessage:"Action"}))),sortedDeviceList.map(function(device,index){var vendorAttributes=device.vendorAttributes;var monitoring=Object(__WEBPACK_IMPORTED_MODULE_24__util_Validations__["u" /* checkDeviceMonitoringEnabled */])(Number(device.startTime),Number(device.endTime));var _getMonitoringStatusD=Object(__WEBPACK_IMPORTED_MODULE_24__util_Validations__["F" /* getMonitoringStatusDetails */])(monitoring),monitoringStatusColor=_getMonitoringStatusD.monitoringStatusColor,monitoringStatusId=_getMonitoringStatusD.monitoringStatusId,monitoringStatusDefaultMessage=_getMonitoringStatusD.monitoringStatusDefaultMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableRow"],{key:index,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),device.deviceType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.mac),device.ip,":",device.port)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,device.assetStatus?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{color:device.assetStatus.toUpperCase()===__WEBPACK_IMPORTED_MODULE_12__util_Constants__["b" /* ACTIVE */]?__WEBPACK_IMPORTED_MODULE_12__util_Constants__["X" /* BLUE_COLOR */]:__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_149" /* ORANGE_COLOR */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.assetStatus)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"loading.text",defaultMessage:"Loading..."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_24__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][vendorAttributes.vendor]," ",__WEBPACK_IMPORTED_MODULE_24__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][vendorAttributes.spec_version])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,device.firmwareVersion?device.firmwareVersion+" ("+(device.firmwareVersionUpdatedAt||"N/A")+")":"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"my-menu","aria-haspopup":"menu","aria-expanded":"false"},"..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu___default.a,{anchorNode:actionButtonRefs.current[index],open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEditDevice(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.addDevice",defaultMessage:"Edit"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickRemove(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.deleteDevice",defaultMessage:"Delete"})),monitoring.isMonitoringEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDisableMonitoring(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_disable",defaultMessage:"Disable Monitoring"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEnableMonitoring(device.startTime,device.reason,device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_enable",defaultMessage:"Enable Monitoring"}))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:onClickAddEditDevice,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.add_device_button_modal",defaultMessage:"Add Device Configuration"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:function onClick(){return setOpenDeleteModal(true);},type:"tertiary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"button.delete",defaultMessage:"Delete device"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__modal_AddInductCameraSingleDeviceModal__["a" /* default */],{open:openAddModal,setOpen:setOpenAddModal,selected:selected,setSelected:setSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__commonui_DeleteSingleDeviceModal__["a" /* default */],{open:openDeleteModal,setOpen:setOpenDeleteModal,selected:selected,setSelected:setSelected,macAddressArray:viewModel.macAddressArray,dispatch:dispatch}),openDisableMonitoringModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__commonui_DisableMonitoringModal__["a" /* default */],{mac:mac,state:openDisableMonitoringModal,onStateChange:setOpenDisableMonitoringModal,context:__WEBPACK_IMPORTED_MODULE_2__context_InductCameraDeviceOverviewContext__["a" /* InductCameraDeviceOverviewContext */],reducer:'UPDATE_MONITORING_DATA'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(InductCameraDeviceOverview));

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_InductCameraDeviceOverviewContext__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddInductCameraSingleDeviceModal=function AddInductCameraSingleDeviceModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__context_InductCameraDeviceOverviewContext__["a" /* InductCameraDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_13__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext2.showWarning;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),port=_useState4[0],setPort=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),deviceType=_useState6[0],setDeviceType=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),name=_useState8[0],setName=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),ip=_useState10[0],setIp=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),mac=_useState12[0],setMac=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),id=_useState14[0],setId=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),vendor=_useState16[0],setVendor=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),specVersion=_useState18[0],setSpecVersion=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState20=_slicedToArray(_useState19,2),parentAssetLabel=_useState20[0],setParentAssetLabel=_useState20[1];// Error states
var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),portErr=_useState22[0],setPortErr=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),deviceTypeErr=_useState24[0],setDeviceTypeErr=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),nameErr=_useState26[0],setNameErr=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),ipErr=_useState28[0],setIpErr=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState30=_slicedToArray(_useState29,2),macErr=_useState30[0],setMacErr=_useState30[1];var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState32=_slicedToArray(_useState31,2),idErr=_useState32[0],setIdErr=_useState32[1];var _useState33=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState34=_slicedToArray(_useState33,2),vendorErr=_useState34[0],setVendorErr=_useState34[1];var _useState35=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState36=_slicedToArray(_useState35,2),specVersionErr=_useState36[0],setSpecVersionErr=_useState36[1];var initialMonitoringValue={startTime:"0",endTime:"0",reason:""};var _useState37=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(JSON.stringify(initialMonitoringValue)),_useState38=_slicedToArray(_useState37,2),monitoring=_useState38[0],setMonitoring=_useState38[1];var stateValues={mac:mac,ip:ip,name:name,deviceType:deviceType,port:port,deviceConfig:{type:__WEBPACK_IMPORTED_MODULE_11__util_Util__["e" /* assetTypeToConfigTypeDict */].typeASML,id:id},vendorAttributes:{vendor:vendor,spec_version:specVersion},monitoring:monitoring,parentAssetLabel:parentAssetLabel};var onCloseModal=function onCloseModal(){setOpen(false);setSelected("");resetInputState();setShowAlert(false);};var onClickConfirm=function onClickConfirm(stateValues){if(Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["T" /* validateNewAsmlComponentDevice */])(stateValues)){showWarning(formatMessage({id:"device.editWarning"}),function(){setShowAlert(false);stateValues.deviceConfig=JSON.stringify(stateValues.deviceConfig);if(selected){stateValues.divertConfig=JSON.stringify(viewModel.asmlComponentInformation[stateValues.mac].divertConfig);updateData(stateValues);}else{addData(stateValues);}setOpen(false);resetInputState();});}else{setShowAlert(true);}};function resetInputState(){setMac("");setMacErr(false);setMonitoring(JSON.stringify(initialMonitoringValue));setVendor("");setSpecVersion("");resetAssetDetails();clearAssetDetailErrors();}function resetAssetDetails(){setIp("");setId("");setPort("");setDeviceType("");setVendorErr(false);setSpecVersionErr(false);setName("");}function clearAssetDetailErrors(){setIpErr(false);setIdErr(false);setPortErr(false);setDeviceTypeErr(false);setNameErr(false);}var prefill=function prefill(value){if(viewModel.asmlComponentInformation.hasOwnProperty(value)){setSelected(value);var device=viewModel.asmlComponentInformation[value];var vendorAttributes=device.vendorAttributes;clearAssetDetailErrors();setMac(device.mac);setIp(device.ip);setId(device.id||"");setPort(device.port);setDeviceType(device.deviceType);setName(device.name);setVendor(vendorAttributes.vendor);setSpecVersion(vendorAttributes.spec_version);setParentAssetLabel(device.parentAssetLabel);var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};setMonitoring(JSON.stringify(deviceMonitoring));}else if(selected){setSelected(false);resetAssetDetails();}};var resetDeviceConfigFields=function resetDeviceConfigFields(){setId("");};var addData=function addData(stateValues){dispatch({type:'ADD_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues}});};var updateData=function updateData(stateValues){dispatch({type:'UPDATE_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.add_device_button_modal"}),open:open,onOpen:function onOpen(){return prefill(selected);},onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.mac",defaultMessage:"MAC Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"mac-input",value:mac,onChange:setMac,mask:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["i" /* MAC_MASK */],disabled:selected,onBlur:function onBlur(){setMacErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.mac,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].MAC));prefill(mac);},error:macErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"id-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.ip",defaultMessage:"IP Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"ip-input",value:ip,onChange:setIp,onBlur:function onBlur(){return setIpErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.ip,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["g" /* IP_ADDRESS_PATTERN */]));},error:ipErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"port-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.port",defaultMessage:"Port"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"port-input",value:port,onChange:setPort,onBlur:function onBlur(){return setPortErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.port,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].PORT));},error:portErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"name-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.name",defaultMessage:"Device Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"name-input",value:name,onChange:setName,onBlur:function onBlur(){return setNameErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.name,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].NAME));},error:nameErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.name_line_desc",defaultMessage:"Display name of the device. e.g. \"Line 3\""})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.protocol",defaultMessage:"Protocol"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default.a,{value:deviceType,onChange:function onChange(value){setDeviceType(value);resetDeviceConfigFields();},onBlur:function onBlur(){return setDeviceTypeErr(!deviceType);},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.select_protocol",defaultMessage:"Select a protocol"}),error:deviceTypeErr,width:"100%"},__WEBPACK_IMPORTED_MODULE_10__util_Validations__["k" /* PROTOCOLS */].ASML.map(function(protocol){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__["SelectOption"],{key:protocol,value:protocol,label:protocol});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"id-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.device_id",defaultMessage:"Device ID"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"id-input",value:id,onChange:setId,onBlur:function onBlur(){return setIdErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.deviceConfig.id,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].DEVICE_ID));},error:idErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.device_id_line_desc",defaultMessage:"Unique local identifier for the device. eg. \"3\" for \"Line 3\""})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default.a,{id:"device-type-input",value:vendor,onChange:function onChange(value){return setVendor(value);},onBlur:function onBlur(){return setVendorErr(!vendor);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_vendor'}),error:vendorErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].VENDOR).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.spec_version'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default.a,{id:"device-type-input",value:specVersion,onChange:function onChange(value){return setSpecVersion(value);},onBlur:function onBlur(){return setSpecVersionErr(!specVersion);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_version'}),error:specVersionErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].SPEC_VERSION).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][value]});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stateValues);}},selected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmEdit",defaultMessage:"Confirm edit"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddInductCameraSingleDeviceModal));

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_PrinterDeviceOverviewContext__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modal_AddPrinterSingleDeviceModal__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__commonui_DeleteSingleDeviceModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__commonui_DisableMonitoringModal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_Validations__ = __webpack_require__(15);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var PrinterDeviceOverview=function PrinterDeviceOverview(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_PrinterDeviceOverviewContext__["a" /* PrinterDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState2=_slicedToArray(_useState,2),openActionsMenu=_useState2[0],setOpenActionsMenu=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openAddModal=_useState4[0],setOpenAddModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),selected=_useState6[0],setSelected=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),openDeleteModal=_useState8[0],setOpenDeleteModal=_useState8[1];var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),openDisableMonitoringModal=_useState10[0],setOpenDisableMonitoringModal=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),mac=_useState12[0],setMac=_useState12[1];var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=true;setOpenActionsMenu(_open);},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=false;setOpenActionsMenu(_open);},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openAddModal&&!openDeleteModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["D" /* getAssetRefreshInterval */])());var statusInterval=setInterval(function(){if(!document.hidden){getStatusData();}},Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_11" /* getStatusRefreshInterval */])());return function(){clearInterval(interval);clearInterval(statusInterval);};}},[openAddModal,openDeleteModal]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,viewModel.asmlComponentInformation.length);},[viewModel.asmlComponentInformation]);var onSort=function onSort(sortDetails){dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};var sortedDeviceList=Object.values(viewModel.asmlComponentInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){var _viewModel$sortPref=viewModel.sortPref,column=_viewModel$sortPref.column,direction=_viewModel$sortPref.direction;var compareValue=void 0;if(Object.keys(__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */]).includes(column)){if(column==="vendor"){compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column]+a.vendorAttributes["spec_version"],b.vendorAttributes[column]+b.vendorAttributes["spec_version"]);}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column],b.vendorAttributes[column]);}}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a[column],b[column]);}if(direction===__WEBPACK_IMPORTED_MODULE_12__util_Constants__["J" /* ASCENDING */]){return compareValue;}else{return-compareValue;}});var updateData=function updateData(stateValues,mac){dispatch({type:'UPDATE_MONITORING_DATA',data:{dispatcher:dispatch,stateValues:stateValues,mac:mac}});};var onClickDisableMonitoring=function onClickDisableMonitoring(mac){setMac(mac);setOpenDisableMonitoringModal(false);};var onClickEnableMonitoring=function onClickEnableMonitoring(startTime,reason,mac){var stateValues={"startTime":startTime,"endTime":Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["I" /* getCurrentDate */])().toString(),"reason":reason};updateData(stateValues,mac);getData();};var renderDeviceMonitoring=function renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{style:{color:monitoringStatusColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:monitoringStatusId,defaultMessage:monitoringStatusDefaultMessage}));};var getData=function getData(){setOpenAddModal(false);setOpenDeleteModal(false);setOpenDisableMonitoringModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var getStatusData=function getStatusData(){dispatch({type:'LOAD_STATUS',data:{dispatcher:dispatch}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var onClickAddEditDevice=function onClickAddEditDevice(){setSelected("");setOpenAddModal(true);};var onClickEditDevice=function onClickEditDevice(mac){setSelected(mac);setOpenAddModal(true);};var onClickRemove=function onClickRemove(mac){setSelected(mac);setOpenDeleteModal(true);};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default.a,{position:"top",title:intl.formatMessage({id:'tooltip.scrolltobottom',defaultMessage:'Scroll to bottom'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.device",defaultMessage:"No device present for this station."})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.name",defaultMessage:"Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.mac_ip",defaultMessage:"MAC/IP"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_22__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.connectionstatus'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"connection"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.connection",defaultMessage:"Connection Status"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.monitoring",defaultMessage:"Monitoring Status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"vendor"},Object(__WEBPACK_IMPORTED_MODULE_22__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'device.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.firmwareVersion",defaultMessage:"Firmware Version"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.action",defaultMessage:"Action"}))),sortedDeviceList.map(function(device,index){var vendorAttributes=device.vendorAttributes;var monitoring=Object(__WEBPACK_IMPORTED_MODULE_24__util_Validations__["u" /* checkDeviceMonitoringEnabled */])(Number(device.startTime),Number(device.endTime));var _getMonitoringStatusD=Object(__WEBPACK_IMPORTED_MODULE_24__util_Validations__["F" /* getMonitoringStatusDetails */])(monitoring),monitoringStatusColor=_getMonitoringStatusD.monitoringStatusColor,monitoringStatusId=_getMonitoringStatusD.monitoringStatusId,monitoringStatusDefaultMessage=_getMonitoringStatusD.monitoringStatusDefaultMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableRow"],{key:index,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),device.deviceType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.mac),device.ip,":",device.port)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,device.assetStatus?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{color:device.assetStatus.toUpperCase()===__WEBPACK_IMPORTED_MODULE_12__util_Constants__["b" /* ACTIVE */]?__WEBPACK_IMPORTED_MODULE_12__util_Constants__["X" /* BLUE_COLOR */]:__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_149" /* ORANGE_COLOR */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.assetStatus)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"loading.text",defaultMessage:"Loading..."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_24__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][vendorAttributes.vendor]," ",__WEBPACK_IMPORTED_MODULE_24__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][vendorAttributes.spec_version])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,device.firmwareVersion||"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"my-menu","aria-haspopup":"menu","aria-expanded":"false"},"..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu___default.a,{anchorNode:actionButtonRefs.current[index],open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEditDevice(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.addDevice",defaultMessage:"Edit"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickRemove(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.deleteDevice",defaultMessage:"Delete"})),monitoring.isMonitoringEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDisableMonitoring(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_disable",defaultMessage:"Disable Monitoring"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEnableMonitoring(device.startTime,device.reason,device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_enable",defaultMessage:"Enable Monitoring"}))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:onClickAddEditDevice,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.add_device_button_modal",defaultMessage:"Add Device Configuration"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:function onClick(){return setOpenDeleteModal(true);},type:"tertiary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"button.delete",defaultMessage:"Delete device"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__modal_AddPrinterSingleDeviceModal__["a" /* default */],{open:openAddModal,setOpen:setOpenAddModal,selected:selected,setSelected:setSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__commonui_DeleteSingleDeviceModal__["a" /* default */],{open:openDeleteModal,setOpen:setOpenDeleteModal,selected:selected,setSelected:setSelected,macAddressArray:viewModel.macAddressArray,dispatch:dispatch}),openDisableMonitoringModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__commonui_DisableMonitoringModal__["a" /* default */],{mac:mac,state:openDisableMonitoringModal,onStateChange:setOpenDisableMonitoringModal,context:__WEBPACK_IMPORTED_MODULE_2__context_PrinterDeviceOverviewContext__["a" /* PrinterDeviceOverviewContext */],reducer:'UPDATE_MONITORING_DATA'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(PrinterDeviceOverview));

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrinterDeviceOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
var PrinterDeviceOverviewReducer=function PrinterDeviceOverviewReducer(state,action){switch(action.type){case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingOverview:false,timestamp:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_14" /* getTimestampNow */])()});case"LOAD_VIEW":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["b" /* fetchAsmlComponentDetails */])(action.data.dispatcher,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_159" /* PRINTER_SUB_ASSET_TYPE */]);return state;case"LOAD_STATUS":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["c" /* fetchAsmlComponentStatusDetails */])(action.data.dispatcher,state);return state;case"ADD_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["f" /* setAsmlComponentDetails */])(action.data.dispatcher,action.data.stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_159" /* PRINTER_SUB_ASSET_TYPE */]);return state;case"UPDATE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["h" /* updateAsmlComponentDetails */])(action.data.dispatcher,action.data.stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_159" /* PRINTER_SUB_ASSET_TYPE */]);return state;case"DELETE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["a" /* deleteAsmlComponentDetails */])(action.data.dispatcher,action.data.mac);return state;case"UPDATE_DEVICE_MAC":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["i" /* updateAsmlComponentMac */])(action.data.dispatcher,action.data.stateValues,action.data.mac,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_159" /* PRINTER_SUB_ASSET_TYPE */]);return state;case"UPDATE_MONITORING_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["j" /* updateAsmlComponentMonitoringDetails */])(action.data.dispatcher,action.data.stateValues,action.data.mac,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_159" /* PRINTER_SUB_ASSET_TYPE */]);return state;case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});default:return state;}};

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_PrinterDeviceOverviewContext__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddPrinterSingleDeviceModal=function AddPrinterSingleDeviceModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__context_PrinterDeviceOverviewContext__["a" /* PrinterDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_13__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext2.showWarning;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),port=_useState4[0],setPort=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),deviceType=_useState6[0],setDeviceType=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),name=_useState8[0],setName=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),ip=_useState10[0],setIp=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),mac=_useState12[0],setMac=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),id=_useState14[0],setId=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),vendor=_useState16[0],setVendor=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),parentAssetLabel=_useState18[0],setParentAssetLabel=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState20=_slicedToArray(_useState19,2),specVersion=_useState20[0],setSpecVersion=_useState20[1];// Error states
var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),portErr=_useState22[0],setPortErr=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),deviceTypeErr=_useState24[0],setDeviceTypeErr=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),nameErr=_useState26[0],setNameErr=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),ipErr=_useState28[0],setIpErr=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState30=_slicedToArray(_useState29,2),macErr=_useState30[0],setMacErr=_useState30[1];var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState32=_slicedToArray(_useState31,2),idErr=_useState32[0],setIdErr=_useState32[1];var _useState33=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState34=_slicedToArray(_useState33,2),vendorErr=_useState34[0],setVendorErr=_useState34[1];var _useState35=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState36=_slicedToArray(_useState35,2),specVersionErr=_useState36[0],setSpecVersionErr=_useState36[1];var initialMonitoringValue={startTime:"0",endTime:"0",reason:""};var _useState37=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(JSON.stringify(initialMonitoringValue)),_useState38=_slicedToArray(_useState37,2),monitoring=_useState38[0],setMonitoring=_useState38[1];var stateValues={mac:mac,ip:ip,name:name,deviceType:deviceType,port:port,deviceConfig:{type:__WEBPACK_IMPORTED_MODULE_11__util_Util__["e" /* assetTypeToConfigTypeDict */].typeASML,id:id},vendorAttributes:{vendor:vendor,spec_version:specVersion},monitoring:monitoring,parentAssetLabel:parentAssetLabel};var onCloseModal=function onCloseModal(){setOpen(false);setSelected("");resetInputState();setShowAlert(false);};var onClickConfirm=function onClickConfirm(stateValues){if(Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["T" /* validateNewAsmlComponentDevice */])(stateValues)){showWarning(formatMessage({id:"device.editWarning"}),function(){setShowAlert(false);stateValues.deviceConfig=JSON.stringify(stateValues.deviceConfig);if(selected){stateValues.divertConfig=JSON.stringify(viewModel.asmlComponentInformation[stateValues.mac].divertConfig);updateData(stateValues);}else{addData(stateValues);}setOpen(false);resetInputState();});}else{setShowAlert(true);}};function resetInputState(){setMac("");setMacErr(false);setMonitoring(JSON.stringify(initialMonitoringValue));setVendor("");setSpecVersion("");resetAssetDetails();clearAssetDetailErrors();}function resetAssetDetails(){setIp("");setId("");setPort("");setDeviceType("");setVendorErr(false);setSpecVersionErr(false);setName("");}function clearAssetDetailErrors(){setIpErr(false);setIdErr(false);setPortErr(false);setDeviceTypeErr(false);setNameErr(false);}var prefill=function prefill(value){if(viewModel.asmlComponentInformation.hasOwnProperty(value)){setSelected(value);var device=viewModel.asmlComponentInformation[value];var vendorAttributes=device.vendorAttributes;clearAssetDetailErrors();setMac(device.mac);setIp(device.ip);setId(device.id||"");setPort(device.port);setDeviceType(device.deviceType);setName(device.name);setVendor(vendorAttributes.vendor);setSpecVersion(vendorAttributes.spec_version);setParentAssetLabel(device.parentAssetLabel);var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};setMonitoring(JSON.stringify(deviceMonitoring));}else if(selected){setSelected(false);resetAssetDetails();}};var resetDeviceConfigFields=function resetDeviceConfigFields(){setId("");};var addData=function addData(stateValues){dispatch({type:'ADD_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues}});};var updateData=function updateData(stateValues){dispatch({type:'UPDATE_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.add_device_button_modal"}),open:open,onOpen:function onOpen(){return prefill(selected);},onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.mac",defaultMessage:"MAC Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"mac-input",value:mac,onChange:setMac,mask:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["i" /* MAC_MASK */],disabled:selected,onBlur:function onBlur(){setMacErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.mac,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].MAC));prefill(mac);},error:macErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"id-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.ip",defaultMessage:"IP Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"ip-input",value:ip,onChange:setIp,onBlur:function onBlur(){return setIpErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.ip,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["g" /* IP_ADDRESS_PATTERN */]));},error:ipErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"port-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.port",defaultMessage:"Port"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"port-input",value:port,onChange:setPort,onBlur:function onBlur(){return setPortErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.port,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].PORT));},error:portErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"name-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.name",defaultMessage:"Device Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"name-input",value:name,onChange:setName,onBlur:function onBlur(){return setNameErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.name,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].NAME));},error:nameErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.name_line_desc",defaultMessage:"Display name of the device. e.g. \"Line 3\""})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.protocol",defaultMessage:"Protocol"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default.a,{value:deviceType,onChange:function onChange(value){setDeviceType(value);resetDeviceConfigFields();},onBlur:function onBlur(){return setDeviceTypeErr(!deviceType);},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.select_protocol",defaultMessage:"Select a protocol"}),error:deviceTypeErr,width:"100%"},__WEBPACK_IMPORTED_MODULE_10__util_Validations__["k" /* PROTOCOLS */].ASML.map(function(protocol){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__["SelectOption"],{key:protocol,value:protocol,label:protocol});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"id-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.device_id",defaultMessage:"Device ID"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"id-input",value:id,onChange:setId,onBlur:function onBlur(){return setIdErr(!Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["L" /* isValidEntry */])(stateValues.deviceConfig.id,__WEBPACK_IMPORTED_MODULE_10__util_Validations__["j" /* PATTERNS */].DEVICE_ID));},error:idErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.device_id_line_desc",defaultMessage:"Unique local identifier for the device. eg. \"3\" for \"Line 3\""})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default.a,{id:"device-type-input",value:vendor,onChange:function onChange(value){return setVendor(value);},onBlur:function onBlur(){return setVendorErr(!vendor);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_vendor'}),error:vendorErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].VENDOR).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.spec_version'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default.a,{id:"device-type-input",value:specVersion,onChange:function onChange(value){return setSpecVersion(value);},onBlur:function onBlur(){return setSpecVersionErr(!specVersion);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_version'}),error:specVersionErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["r" /* VENDOR_INFO_KEYS */].SPEC_VERSION).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_10__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][value]});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stateValues);}},selected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmEdit",defaultMessage:"Confirm edit"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddPrinterSingleDeviceModal));

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_PrinterDeviceOverviewContext__ = __webpack_require__(314);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var PrinterDevicePage=function(_Component){_inherits(PrinterDevicePage,_Component);function PrinterDevicePage(){_classCallCheck(this,PrinterDevicePage);return _possibleConstructorReturn(this,(PrinterDevicePage.__proto__||Object.getPrototypeOf(PrinterDevicePage)).apply(this,arguments));}_createClass(PrinterDevicePage,[{key:"render",value:function render(){var getPrinterRoutes=function getPrinterRoutes(){return __WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__["w" /* PRINTER */];};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__context_PrinterDeviceOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["b" /* default */],{routes:getPrinterRoutes(),location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["a" /* NavigationRoutes */],{routes:getPrinterRoutes()})));}}]);return PrinterDevicePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrinterDevicePage);

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_AutoRetrieverDeviceOverviewContext__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_loader__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonui_ConfigurationTabHeader__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonui_PaginatedTable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_small__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_chevron_right_small__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_chevron_right_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_chevron_right_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__amzn_meridian_tokens_base_icon_refresh__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__amzn_meridian_tokens_base_icon_refresh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__amzn_meridian_tokens_base_icon_refresh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__PickStationConfiguration__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__RetrieverLocationMappingConfiguration__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__rollback_RollbackModal__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__resources_AssetResource__ = __webpack_require__(56);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var AutoRetrieverDeviceConfiguration=function AutoRetrieverDeviceConfiguration(_ref){var intl=_ref.intl;//Add Context
var _useContext=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__context_AutoRetrieverDeviceOverviewContext__["a" /* AutoRetrieverDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext2.getDraftData,setDraftData=_useContext2.setDraftData,getFilteredDraftData=_useContext2.getFilteredDraftData,_resetDraftData=_useContext2.resetDraftData,isDataEdited=_useContext2.isDataEdited;var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext3.showCustomAlert;var _useState=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),selectedMac=_useState2[0],setSelectedMac=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),valueConfiguration=_useState4[0],setValueConfiguration=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(''),_useState6=_slicedToArray(_useState5,2),scannablesSearchInput=_useState6[0],setScannablesSearchInput=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])("id"),_useState8=_slicedToArray(_useState7,2),testConfigSortColumn=_useState8[0],setTestConfigSortColumn=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(__WEBPACK_IMPORTED_MODULE_5__util_Constants__["J" /* ASCENDING */]),_useState10=_slicedToArray(_useState9,2),testConfigSortOrder=_useState10[0],setTestConfigSortOrder=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])([]),_useState12=_slicedToArray(_useState11,2),expandedRows=_useState12[0],setExpandedRows=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),showRollbackModal=_useState14[0],setShowRollbackModal=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])([]),_useState16=_slicedToArray(_useState15,2),rollBackVersions=_useState16[0],setRollbackVersions=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),selectedVersion=_useState18[0],setSelectedVersion=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState20=_slicedToArray(_useState19,2),isVersionsLoading=_useState20[0],setIsVersionsLoading=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),isPickStationEditMode=_useState22[0],setIsPickStationEditMode=_useState22[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(null);var PAGE_CONFIGURATION_KEYS=[__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].AUTO_RETRIEVER_TEST_CONFIGURATION,__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].PICK_STATION_CONFIGURATION,__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].RETRIEVER_LOCATION_MAPPING];Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function(){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["D" /* getAssetRefreshInterval */])());return function(){return clearInterval(interval);};},[]);Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function(){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return extractTestConfigForPick(viewModel.testConfig[selectedMac]);},[]),stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].AUTO_RETRIEVER_TEST_CONFIGURATION,subKey:selectedMac});setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return viewModel.autoRetrieverDeviceInformation[selectedMac].retrieverLocationMapping;},[]),stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].RETRIEVER_LOCATION_MAPPING,subKey:selectedMac});},[selectedMac]);var getData=function getData(){dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var onClickStartTest=function onClickStartTest(){dispatch({type:"START_MOCK_TEST",data:{dispatcher:dispatch,showCustomAlert:showCustomAlert,mac:selectedMac}});};var isValidTestConfig=function isValidTestConfig(){var config=viewModel.testConfig[selectedMac];return config&&config.picklists&&Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_19" /* isTimestampWithinHours */])(config.timestamp,8);};var extractTestConfigForPick=function extractTestConfigForPick(testConfigForAR){var result=[];if(!isValidTestConfig()){return result;}testConfigForAR.picklists.forEach(function(picklist){var allPickItemsForPicklist=[];Object.keys(picklist.pickItems).forEach(function(cluster){picklist.pickItems[cluster].forEach(function(item){item.cluster=cluster;allPickItemsForPicklist.push(item);});});result.push({id:picklist.id+"#"+picklist.groupId,pickStation:picklist.pickStation,pickItems:allPickItemsForPicklist});});return result;};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var updateExpandedRows=function updateExpandedRows(row){var newExpandedRows=expandedRows.includes(row)?expandedRows.filter(function(expandedRow){return expandedRow!==row;}):[].concat(_toConsumableArray(expandedRows),[row]);setExpandedRows(newExpandedRows);};var getSortedDeviceList=function getSortedDeviceList(){// Device List sorted based on device "name"
var sortedDeviceList=Object.values(viewModel.autoRetrieverDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){if(a.name<b.name){return-1;}else if(b.name>a.name){return 1;}return 0;});return sortedDeviceList;};var searchDataForTestConfigTable=function searchDataForTestConfigTable(){var data=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].AUTO_RETRIEVER_TEST_CONFIGURATION,subKey:selectedMac});data=data.filter(function(item){return getTestConfigKey(item.pickItems).toLowerCase().includes(scannablesSearchInput.toLowerCase());});data=data.sort(function(a,b){return sortTestConfigColumns[testConfigSortColumn](a,b,testConfigSortOrder===__WEBPACK_IMPORTED_MODULE_5__util_Constants__["J" /* ASCENDING */]);});return data;};var getTestConfigKey=function getTestConfigKey(pickItems){return pickItems.map(function(item){return item.id;}).join(';');};var sortTestConfigColumns={id:function id(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.id,b.id):-Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.id,b.id);},pickItemsCount:function pickItemsCount(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.pickItems.length,b.pickItems.length):-Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.pickItems.length,b.pickItems.length);},pickStation:function pickStation(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.pickStation,b.pickStation):-Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.pickStation,b.pickStation);}};var renderSearchRow=function renderSearchRow(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableRow"],{backgroundColor:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_177" /* SEARCH_ROW_COLOR */]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{columnSpan:3}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_input___default.a,{className:"input-search-class",value:scannablesSearchInput,onChange:setScannablesSearchInput,type:"text",placeholder:"Search",width:"100%",size:"small"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{columnSpan:3}));};var renderTestConfigExpandableTableHeader=function renderTestConfigExpandableTableHeader(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{width:60}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{sortColumn:"id"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"table.index"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{sortColumn:"pickItemsCount"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"testconfig.items_count"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"testconfig.pick_item"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"testconfig.pick_item_type"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"testconfig.cluster"})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{sortColumn:"pickStation"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"testconfig.pick_station"})));};var renderTestConfigExpandableTableRow=function renderTestConfigExpandableTableRow(config,serialNumber){var rows=[];rows.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{rowSpan:expandedRows.includes(config.id)?config.pickItems.length:1,alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_button___default.a,{type:"icon",size:"small",onClick:function onClick(){return updateExpandedRows(config.id);}},expandedRows.includes(config.id)?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_small___default.a},"Collapse rows"):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_chevron_right_small___default.a},"Expand rows"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{rowSpan:expandedRows.includes(config.id)?config.pickItems.length:1,alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default.a,{spacingInset:"200 none none"},config.id)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{rowSpan:expandedRows.includes(config.id)?config.pickItems.length:1,alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default.a,{spacingInset:"200 none none"},config.pickItems.length," items")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,config.pickItems[0].id),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,config.pickItems[0].type),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,config.pickItems[0].cluster),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,config.pickStation)));if(expandedRows.includes(config.id)){config.pickItems.slice(1).map(function(item){return rows.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{showCell:false}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],{showCell:false}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,item.id),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,item.type),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,item.cluster),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_table__["TableCell"],null,config.pickStation)));});}return rows;};var deployPickStationConfig=function deployPickStationConfig(){var configData=getFilteredDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].PICK_STATION_CONFIGURATION,subKey:selectedMac});dispatch({type:"SAVE_PICK_STATION_CONFIG",data:{dispatcher:dispatch,mac:selectedMac,config:configData,showCustomAlert:showCustomAlert}});setDraftData({data:configData,stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].PICK_STATION_CONFIGURATION,subKey:selectedMac,override:true});setIsPickStationEditMode(false);};var deployLocationMapping=function deployLocationMapping(){var configData=getFilteredDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].RETRIEVER_LOCATION_MAPPING,subKey:selectedMac});dispatch({type:"SAVE_RETRIEVER_LOCATION_MAPPING",data:{dispatcher:dispatch,mac:selectedMac,config:configData,showCustomAlert:showCustomAlert}});setDraftData({data:configData,stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].RETRIEVER_LOCATION_MAPPING,subKey:selectedMac,override:true});};var getRollbackVersions=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var versionsData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setIsVersionsLoading(true);_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_27__resources_AssetResource__["f" /* getAssetVersions */])(selectedMac);case 3:versionsData=_context.sent;setRollbackVersions(Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return versionsData.data.assetVersionDetailsList;},[]));setIsVersionsLoading(false);case 6:case"end":return _context.stop();}}},_callee,_this);}));return function getRollbackVersions(){return _ref2.apply(this,arguments);};}();var loadRollbackDataToDraft=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var rollbackData,pickStationConfigData,locationMappingData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_27__resources_AssetResource__["e" /* getAssetByVersion */])(selectedMac,selectedVersion);case 2:rollbackData=_context2.sent;if(isPickStationConfig){pickStationConfigData=Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.pickStationConfig);},[]);if(pickStationConfigData.length){setDraftData({data:pickStationConfigData,stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].PICK_STATION_CONFIGURATION,subKey:selectedMac,allRowsAdded:true,override:true});}}if(isLocationMapping){locationMappingData=Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.retrieverLocationMapping);},[]);if(locationMappingData.length){setDraftData({data:locationMappingData,stateKey:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].RETRIEVER_LOCATION_MAPPING,subKey:selectedMac,allRowsAdded:true,override:true});}}case 5:case"end":return _context2.stop();}}},_callee2,_this);}));return function loadRollbackDataToDraft(){return _ref3.apply(this,arguments);};}();var isPickStationConfig=valueConfiguration===__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].PICK_STATION_CONFIGURATION;var isLocationMapping=valueConfiguration===__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].RETRIEVER_LOCATION_MAPPING;var getHeaderProps=function getHeaderProps(){var baseProps={selectedMac:selectedMac,setSelectedMac:setSelectedMac,valueConfiguration:valueConfiguration,setValueConfiguration:setValueConfiguration,defaultSelection:"",scrollToBottom:scrollToBottom,sortedDeviceList:getSortedDeviceList(),configurationKeys:PAGE_CONFIGURATION_KEYS,refreshDeps:[viewModel.timestamp]};if(isPickStationConfig){return Object.assign({},baseProps,{deployDraft:deployPickStationConfig,resetDraftData:function resetDraftData(stateKeys,subKey){_resetDraftData(stateKeys,subKey);setIsPickStationEditMode(false);},isDeployDisabled:!isDataEdited([__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].PICK_STATION_CONFIGURATION]),isRollbackDisabled:!selectedMac||isDataEdited([__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].PICK_STATION_CONFIGURATION]),rollbackClickHandler:function rollbackClickHandler(){getRollbackVersions();setShowRollbackModal(true);}});}if(isLocationMapping){return Object.assign({},baseProps,{deployDraft:deployLocationMapping,resetDraftData:function resetDraftData(){return _resetDraftData([__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].RETRIEVER_LOCATION_MAPPING],selectedMac);},isDeployDisabled:!isDataEdited([__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].RETRIEVER_LOCATION_MAPPING]),isRollbackDisabled:!selectedMac||isDataEdited([__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].RETRIEVER_LOCATION_MAPPING]),rollbackClickHandler:function rollbackClickHandler(){getRollbackVersions();setShowRollbackModal(true);}});}return Object.assign({},baseProps,{isViewOnly:true});};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_loader___default.a,null);}else{return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonui_ConfigurationTabHeader__["a" /* default */],getHeaderProps()),valueConfiguration===__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].AUTO_RETRIEVER_TEST_CONFIGURATION&&selectedMac&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_column___default.a,null,isValidTestConfig()&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonui_PaginatedTable__["a" /* default */],{data:searchDataForTestConfigTable(),renderHeader:renderTestConfigExpandableTableHeader,renderSearchRow:renderSearchRow,renderRow:renderTestConfigExpandableTableRow,sortColumn:testConfigSortColumn,sortDirection:testConfigSortOrder,onSort:function onSort(_ref4){var sortColumn=_ref4.sortColumn,sortDirection=_ref4.sortDirection;setTestConfigSortColumn(sortColumn);setTestConfigSortOrder(sortDirection);}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tooltip___default.a,{position:"end",title:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.start_retrieval_test_desc"})},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_button___default.a,{onClick:onClickStartTest,size:"medium",type:"primary"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_22__amzn_meridian_tokens_base_icon_refresh___default.a}),Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"testconfig.start"}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_box___default.a,null),isValidTestConfig()&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_text___default.a,{type:"b200"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"common.data_created"}),": ",Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["O" /* getFormattedTime */])(intl.locale,viewModel.testConfig[selectedMac].timestamp))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{ref:tableEndRef})),valueConfiguration===__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].PICK_STATION_CONFIGURATION&&selectedMac&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__PickStationConfiguration__["a" /* default */],{selectedMac:selectedMac,isEditMode:isPickStationEditMode,setIsEditMode:setIsPickStationEditMode}),valueConfiguration===__WEBPACK_IMPORTED_MODULE_5__util_Constants__["_4" /* CONFIG_TYPE */].RETRIEVER_LOCATION_MAPPING&&selectedMac&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__RetrieverLocationMappingConfiguration__["a" /* default */],{selectedMac:selectedMac}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__rollback_RollbackModal__["a" /* default */],{showRollbackModal:showRollbackModal,setShowRollbackModal:setShowRollbackModal,isVersionsLoading:isVersionsLoading,selectedVersion:selectedVersion,setSelectedVersion:setSelectedVersion,rollBackVersions:rollBackVersions,loadRollbackDataToDraft:loadRollbackDataToDraft,intl:intl}));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(AutoRetrieverDeviceConfiguration));

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconRefreshData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round' stroke='currentColor' stroke-width='2'%3e%3cpath d='M20.128 2l-.493 5.635L14 7.142M19.44 6.935a9 9 0 101.023 8.134'/%3e%3c/g%3e%3c/svg%3e",
  iconRefreshWidth: 24,
  iconRefreshHeight: 24
};

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AutoRetrieverDeviceOverviewContext__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text__);
var DEFAULT_PICK_STATION_STATUS=__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_153" /* PICK_STATION_STATUS */].ENABLED;var STATE_KEY=__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_4" /* CONFIG_TYPE */].PICK_STATION_CONFIGURATION;var PickStationConfiguration=function PickStationConfiguration(_ref){var intl=_ref.intl,selectedMac=_ref.selectedMac,isEditMode=_ref.isEditMode,setIsEditMode=_ref.setIsEditMode;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_AutoRetrieverDeviceOverviewContext__["a" /* AutoRetrieverDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext2.getDraftData,setDraftData=_useContext2.setDraftData,editInstance=_useContext2.editInstance;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){dispatch({type:"LOAD_PICK_STATION_RESOURCES",data:{dispatcher:dispatch}});},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(selectedMac&&viewModel.pickStationResources.length>0){initializeDraft();}},[selectedMac,viewModel.pickStationResources,viewModel.timestamp]);var initializeDraft=function initializeDraft(){var mergedConfig=getMergedConfig();setDraftData({data:mergedConfig,stateKey:STATE_KEY,subKey:selectedMac});};var getMergedConfig=function getMergedConfig(){var savedConfig=getSavedConfig();var savedConfigMap={};savedConfig.forEach(function(item){savedConfigMap[item.label]=item.status;});return viewModel.pickStationResources.map(function(resource){return{label:resource.label,status:savedConfigMap[resource.label]||DEFAULT_PICK_STATION_STATUS};});};var getSavedConfig=function getSavedConfig(){if(!selectedMac)return[];var device=viewModel.autoRetrieverDeviceInformation[selectedMac];if(!device||!device.pickStationConfig)return[];return device.pickStationConfig;};var onClickEdit=function onClickEdit(){setIsEditMode(true);};var onStatusChange=function onStatusChange(label,newStatus){editInstance({stateKey:STATE_KEY,subKey:selectedMac,instance:{label:label,status:newStatus},keyComparator:function keyComparator(a,b){return a.label===b.label;},valueComparator:function valueComparator(a,b){return a.status===b.status;}});};if(viewModel.loadingPickStationResources){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader___default.a,null);}if(!selectedMac){return null;}if(viewModel.pickStationResources.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_alert___default.a,{type:"informational",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"pickstation.no_resources"}));}var displayConfig=getDraftData({stateKey:STATE_KEY,subKey:selectedMac})||[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"400"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",showDividers:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"pickstation.label"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.status"}))),displayConfig.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableRow"],{key:item.label,highlightOnHover:true,backgroundColor:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_148" /* OPERATION_COLOR */][item.operation]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,item.label))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,isEditMode?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{value:item.status,onChange:function onChange(value){return onStatusChange(item.label,value);},size:"small",width:150},__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_154" /* PICK_STATION_STATUSES */].map(function(status){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{key:status,value:status,label:status});})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{style:{color:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_155" /* PICK_STATION_STATUS_COLOR */][item.status]}},item.status))));})),!isEditMode&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default.a,{spacing:"300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:onClickEdit},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"button.edit"}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(PickStationConfiguration));

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AutoRetrieverDeviceOverviewContext__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_upload_small__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_upload_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_upload_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modal_AddRetrieverLocationMappingModal__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modal_DeleteRetrieverLocationMappingModal__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__commonui_UploadFileModal__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_Parsers__ = __webpack_require__(100);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var STATE_KEY=__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_4" /* CONFIG_TYPE */].RETRIEVER_LOCATION_MAPPING;var RetrieverLocationMappingConfiguration=function RetrieverLocationMappingConfiguration(_ref){var intl=_ref.intl,selectedMac=_ref.selectedMac;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_AutoRetrieverDeviceOverviewContext__["a" /* AutoRetrieverDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext2.getDraftData,setDraftData=_useContext2.setDraftData;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),openAddModal=_useState2[0],setOpenAddModal=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openDeleteModal=_useState4[0],setOpenDeleteModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),openCSVModal=_useState6[0],setOpenCSVModal=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState8=_slicedToArray(_useState7,2),editRow=_useState8[0],setEditRow=_useState8[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){dispatch({type:"LOAD_PICK_POINT_RESOURCES",data:{dispatcher:dispatch}});},[]);var onClickAdd=function onClickAdd(){setEditRow(null);setOpenAddModal(true);};var onClickEdit=function onClickEdit(row){setEditRow(row);setOpenAddModal(true);};var onClickDelete=function onClickDelete(){setOpenDeleteModal(true);};var onClickUploadCSV=function onClickUploadCSV(){setOpenCSVModal(true);};var updateLocationMappingFromCSV=function updateLocationMappingFromCSV(data){setDraftData({data:data,stateKey:STATE_KEY,subKey:selectedMac,allRowsAdded:true,override:true});};if(viewModel.loadingPickPointResources){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_loader___default.a,null);}if(!selectedMac){return null;}var hasPickPoints=viewModel.pickPointResources.length>0;var displayConfig=getDraftData({stateKey:STATE_KEY,subKey:selectedMac})||[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"400"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",showDividers:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.destination"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.locations"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.action"}))),displayConfig.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableRow"],{key:item.destination+"-"+item.type+"-"+index,highlightOnHover:true,backgroundColor:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_148" /* OPERATION_COLOR */][item.operation]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,item.destination))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text___default.a,{type:"b300"},item.type)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text___default.a,{type:"b300"},Array.isArray(item.locations)?item.locations.join(", "):"")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_table__["TableCell"],null,item.operation!==__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_147" /* OPERATIONS */].DELETE&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button___default.a,{type:"link",size:"small",onClick:function onClick(){return onClickEdit(item);}},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"button.edit"}))));})),!hasPickPoints&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default.a,{type:"informational",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.no_pick_points"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default.a,{width:"100%",widths:["100","100","fill","100"]},hasPickPoints&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button___default.a,{onClick:onClickAdd,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tokens_base_icon_plus_circle___default.a}),Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.add"})),hasPickPoints&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button___default.a,{onClick:onClickUploadCSV,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_upload_small___default.a}),Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.uploadCSV"})),!hasPickPoints&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box___default.a,null),displayConfig.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_button___default.a,{onClick:onClickDelete,size:"small",type:"tertiary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_5__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.delete_config"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__modal_AddRetrieverLocationMappingModal__["a" /* default */],{open:openAddModal,setOpen:setOpenAddModal,selectedMac:selectedMac,editRow:editRow,pickPointResources:viewModel.pickPointResources}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__modal_DeleteRetrieverLocationMappingModal__["a" /* default */],{open:openDeleteModal,setOpen:setOpenDeleteModal,selectedMac:selectedMac}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__commonui_UploadFileModal__["a" /* default */],{mac:selectedMac,open:openCSVModal,setOpen:setOpenCSVModal,parser:Object(__WEBPACK_IMPORTED_MODULE_21__util_Parsers__["o" /* createRetrieverLocationMappingCSVParser */])(viewModel.pickPointResources.map(function(r){return r.label;}),intl),updateConfig:updateLocationMappingFromCSV}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(RetrieverLocationMappingConfiguration));

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Validations__ = __webpack_require__(15);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var STATE_KEY=__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].RETRIEVER_LOCATION_MAPPING;var AddRetrieverLocationMappingModal=function AddRetrieverLocationMappingModal(_ref){var intl=_ref.intl,open=_ref.open,setOpen=_ref.setOpen,selectedMac=_ref.selectedMac,editRow=_ref.editRow,pickPointResources=_ref.pickPointResources;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),addInstance=_useContext.addInstance,editInstance=_useContext.editInstance,getDraftData=_useContext.getDraftData;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),destination=_useState2[0],setDestination=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),itemType=_useState4[0],setItemType=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState6=_slicedToArray(_useState5,2),selectedLocations=_useState6[0],setSelectedLocations=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),error=_useState8[0],setError=_useState8[1];var isEdit=!!editRow;Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(open&&editRow){setDestination(editRow.destination||"");setItemType(editRow.type||"");setSelectedLocations(editRow.locations||[]);setError("");}else if(open){resetForm();}},[open,editRow]);var resetForm=function resetForm(){setDestination("");setItemType("");setSelectedLocations([]);setError("");};var onClose=function onClose(){setOpen(false);resetForm();};var formatValidationError=function formatValidationError(result){return intl.formatMessage({id:result.id},result.values||{});};var onConfirm=function onConfirm(){var allRows=getDraftData({stateKey:STATE_KEY,subKey:selectedMac})||[];var existingRows=allRows.filter(function(row){return row.operation!==__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_147" /* OPERATIONS */].DELETE;});var validationResult=Object(__WEBPACK_IMPORTED_MODULE_13__util_Validations__["P" /* validateLocationMappingRow */])(destination,itemType,selectedLocations,existingRows,isEdit);if(validationResult){setError(formatValidationError(validationResult));return;}var instance={destination:destination.trim(),type:itemType,locations:selectedLocations};if(isEdit){editInstance({stateKey:STATE_KEY,subKey:selectedMac,instance:instance,keyComparator:function keyComparator(a,b){return a.destination===b.destination&&a.type===b.type;},valueComparator:function valueComparator(a,b){return a.destination===b.destination&&a.type===b.type&&JSON.stringify(a.locations)===JSON.stringify(b.locations);}});}else{addInstance({stateKey:STATE_KEY,subKey:selectedMac,instance:instance});}onClose();};var pickPointLabels=pickPointResources.map(function(r){return r.label;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal___default.a,{title:isEdit?Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.modal.edit_title"}):Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.modal.add_title"}),open:open,onClose:function onClose(){},scrollContainer:"viewport",width:600},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,{spacing:"400"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_text___default.a,{type:"b300"},Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.destination"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_input___default.a,{value:destination,onChange:function onChange(val){setDestination(val);setError("");},placeholder:Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.destination.placeholder"}),size:"small",disabled:isEdit})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_text___default.a,{type:"b300"},Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select___default.a,{value:itemType,onChange:function onChange(val){setItemType(val);setError("");},placeholder:Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.type.placeholder"}),size:"small",disabled:isEdit},__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_152" /* PICK_ITEM_TYPES */].map(function(type){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select__["SelectOption"],{key:type,value:type,label:type});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_text___default.a,{type:"b300"},Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.locations"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select___default.a,{value:selectedLocations,onChange:function onChange(val){setSelectedLocations(val);setError("");},valueLabel:selectedLocations.length>0?function(){return selectedLocations.length+" selected ("+selectedLocations.join(", ")+")";}:undefined,placeholder:Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.locations.placeholder"}),size:"small",searchable:true},pickPointLabels.map(function(label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_select__["SelectOption"],{key:label,value:label,label:label});}))),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"error",size:"small"},error),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default.a,{spacing:"300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:onConfirm},Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirm"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_button___default.a,{type:"secondary",size:"small",onClick:onClose},Object(__WEBPACK_IMPORTED_MODULE_12__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cancel"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(AddRetrieverLocationMappingModal));

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Localization__ = __webpack_require__(14);
var STATE_KEY=__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_4" /* CONFIG_TYPE */].RETRIEVER_LOCATION_MAPPING;var DeleteRetrieverLocationMappingModal=function DeleteRetrieverLocationMappingModal(_ref){var intl=_ref.intl,open=_ref.open,setOpen=_ref.setOpen,selectedMac=_ref.selectedMac;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),deleteAll=_useContext.deleteAll;var onConfirm=function onConfirm(){deleteAll({stateKey:STATE_KEY,subKey:selectedMac});setOpen(false);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_modal___default.a,{title:Object(__WEBPACK_IMPORTED_MODULE_9__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.delete_title"}),open:open,onClose:function onClose(){return setOpen(false);},scrollContainer:"viewport",closeLabel:"Close"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,{spacing:"400"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_9__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"locationmapping.delete_confirmation"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_row___default.a,{spacing:"300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:onConfirm},Object(__WEBPACK_IMPORTED_MODULE_9__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirm"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_button___default.a,{type:"secondary",size:"small",onClick:function onClick(){return setOpen(false);}},Object(__WEBPACK_IMPORTED_MODULE_9__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cancel"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(DeleteRetrieverLocationMappingModal));

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_VerificationCameraDeviceOverviewContext__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modal_AddVerificationCameraSingleDeviceModal__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__commonui_DeleteSingleDeviceModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__commonui_DisableMonitoringModal__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_Validations__ = __webpack_require__(15);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var VerificationCameraDeviceOverview=function VerificationCameraDeviceOverview(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_VerificationCameraDeviceOverviewContext__["a" /* VerificationCameraDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState2=_slicedToArray(_useState,2),openActionsMenu=_useState2[0],setOpenActionsMenu=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openAddModal=_useState4[0],setOpenAddModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),selected=_useState6[0],setSelected=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),openDeleteModal=_useState8[0],setOpenDeleteModal=_useState8[1];var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),openDisableMonitoringModal=_useState10[0],setOpenDisableMonitoringModal=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),mac=_useState12[0],setMac=_useState12[1];var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=true;setOpenActionsMenu(_open);},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=false;setOpenActionsMenu(_open);},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openAddModal&&!openDeleteModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["D" /* getAssetRefreshInterval */])());var statusInterval=setInterval(function(){if(!document.hidden){getStatusData();}},Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_11" /* getStatusRefreshInterval */])());return function(){clearInterval(interval);clearInterval(statusInterval);};}},[openAddModal,openDeleteModal]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,viewModel.asmlComponentInformation.length);},[viewModel.asmlComponentInformation]);var onSort=function onSort(sortDetails){dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};var sortedDeviceList=Object.values(viewModel.asmlComponentInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){var _viewModel$sortPref=viewModel.sortPref,column=_viewModel$sortPref.column,direction=_viewModel$sortPref.direction;var compareValue=void 0;if(Object.keys(__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */]).includes(column)){if(column==="vendor"){compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column]+a.vendorAttributes["spec_version"],b.vendorAttributes[column]+b.vendorAttributes["spec_version"]);}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column],b.vendorAttributes[column]);}}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a[column],b[column]);}if(direction===__WEBPACK_IMPORTED_MODULE_12__util_Constants__["J" /* ASCENDING */]){return compareValue;}else{return-compareValue;}});var updateData=function updateData(stateValues,mac){dispatch({type:'UPDATE_MONITORING_DATA',data:{dispatcher:dispatch,stateValues:stateValues,mac:mac}});};var onClickDisableMonitoring=function onClickDisableMonitoring(mac){setMac(mac);setOpenDisableMonitoringModal(false);};var onClickEnableMonitoring=function onClickEnableMonitoring(startTime,reason,mac){var stateValues={"startTime":startTime,"endTime":Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["I" /* getCurrentDate */])().toString(),"reason":reason};updateData(stateValues,mac);getData();};var renderDeviceMonitoring=function renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{style:{color:monitoringStatusColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:monitoringStatusId,defaultMessage:monitoringStatusDefaultMessage}));};var getData=function getData(){setOpenAddModal(false);setOpenDeleteModal(false);setOpenDisableMonitoringModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var getStatusData=function getStatusData(){dispatch({type:'LOAD_STATUS',data:{dispatcher:dispatch}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var onClickAddEditDevice=function onClickAddEditDevice(){setSelected("");setOpenAddModal(true);};var onClickEditDevice=function onClickEditDevice(mac){setSelected(mac);setOpenAddModal(true);};var onClickRemove=function onClickRemove(mac){setSelected(mac);setOpenDeleteModal(true);};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default.a,{position:"top",title:intl.formatMessage({id:'tooltip.scrolltobottom',defaultMessage:'Scroll to bottom'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.device",defaultMessage:"No device present for this station."})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.name",defaultMessage:"Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.mac_ip",defaultMessage:"MAC/IP"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_22__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.connectionstatus'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"connection"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.connection",defaultMessage:"Connection Status"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.monitoring",defaultMessage:"Monitoring Status"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],{sortColumn:"vendor"},Object(__WEBPACK_IMPORTED_MODULE_22__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'device.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.firmwareVersion",defaultMessage:"Firmware Version"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.action",defaultMessage:"Action"}))),sortedDeviceList.map(function(device,index){var vendorAttributes=device.vendorAttributes;var monitoring=Object(__WEBPACK_IMPORTED_MODULE_24__util_Validations__["u" /* checkDeviceMonitoringEnabled */])(Number(device.startTime),Number(device.endTime));var _getMonitoringStatusD=Object(__WEBPACK_IMPORTED_MODULE_24__util_Validations__["F" /* getMonitoringStatusDetails */])(monitoring),monitoringStatusColor=_getMonitoringStatusD.monitoringStatusColor,monitoringStatusId=_getMonitoringStatusD.monitoringStatusId,monitoringStatusDefaultMessage=_getMonitoringStatusD.monitoringStatusDefaultMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableRow"],{key:index,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),device.deviceType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.mac),device.ip,":",device.port)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,device.assetStatus?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{color:device.assetStatus.toUpperCase()===__WEBPACK_IMPORTED_MODULE_12__util_Constants__["b" /* ACTIVE */]?__WEBPACK_IMPORTED_MODULE_12__util_Constants__["X" /* BLUE_COLOR */]:__WEBPACK_IMPORTED_MODULE_12__util_Constants__["_149" /* ORANGE_COLOR */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.assetStatus)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"loading.text",defaultMessage:"Loading..."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId,monitoringStatusDefaultMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_24__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][vendorAttributes.vendor]," ",__WEBPACK_IMPORTED_MODULE_24__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][vendorAttributes.spec_version])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,device.firmwareVersion||"N/A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"my-menu","aria-haspopup":"menu","aria-expanded":"false"},"..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu___default.a,{anchorNode:actionButtonRefs.current[index],open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEditDevice(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.addDevice",defaultMessage:"Edit"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickRemove(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.deleteDevice",defaultMessage:"Delete"})),monitoring.isMonitoringEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDisableMonitoring(device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_disable",defaultMessage:"Disable Monitoring"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEnableMonitoring(device.startTime,device.reason,device.mac);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.monitoring_enable",defaultMessage:"Enable Monitoring"}))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:onClickAddEditDevice,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.add_device_button_modal",defaultMessage:"Add Device Configuration"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:function onClick(){return setOpenDeleteModal(true);},type:"tertiary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_tokens_base_icon_trash___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"button.delete",defaultMessage:"Delete device"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__modal_AddVerificationCameraSingleDeviceModal__["a" /* default */],{open:openAddModal,setOpen:setOpenAddModal,selected:selected,setSelected:setSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__commonui_DeleteSingleDeviceModal__["a" /* default */],{open:openDeleteModal,setOpen:setOpenDeleteModal,selected:selected,setSelected:setSelected,macAddressArray:viewModel.macAddressArray,dispatch:dispatch}),openDisableMonitoringModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__commonui_DisableMonitoringModal__["a" /* default */],{mac:mac,state:openDisableMonitoringModal,onStateChange:setOpenDisableMonitoringModal,context:__WEBPACK_IMPORTED_MODULE_2__context_VerificationCameraDeviceOverviewContext__["a" /* VerificationCameraDeviceOverviewContext */],reducer:'UPDATE_MONITORING_DATA'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(VerificationCameraDeviceOverview));

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VerificationCameraDeviceOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
var VerificationCameraDeviceOverviewReducer=function VerificationCameraDeviceOverviewReducer(state,action){switch(action.type){case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingOverview:false,timestamp:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_14" /* getTimestampNow */])()});case"LOAD_VIEW":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["b" /* fetchAsmlComponentDetails */])(action.data.dispatcher,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_220" /* VERIFICATION_CAMERA_SUB_ASSET_TYPE */]);return state;case"LOAD_STATUS":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["c" /* fetchAsmlComponentStatusDetails */])(action.data.dispatcher,state);return state;case"ADD_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["f" /* setAsmlComponentDetails */])(action.data.dispatcher,action.data.stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_220" /* VERIFICATION_CAMERA_SUB_ASSET_TYPE */]);return state;case"UPDATE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["h" /* updateAsmlComponentDetails */])(action.data.dispatcher,action.data.stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_220" /* VERIFICATION_CAMERA_SUB_ASSET_TYPE */]);return state;case"DELETE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["a" /* deleteAsmlComponentDetails */])(action.data.dispatcher,action.data.mac);return state;case"UPDATE_DEVICE_MAC":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["i" /* updateAsmlComponentMac */])(action.data.dispatcher,action.data.stateValues,action.data.mac,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_220" /* VERIFICATION_CAMERA_SUB_ASSET_TYPE */]);return state;case"UPDATE_MONITORING_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AsmlDeviceOverviewNetworkAPI__["j" /* updateAsmlComponentMonitoringDetails */])(action.data.dispatcher,action.data.stateValues,action.data.mac,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_220" /* VERIFICATION_CAMERA_SUB_ASSET_TYPE */]);return state;case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});default:return state;}};

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__context_VerificationCameraDeviceOverviewContext__ = __webpack_require__(315);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddVerificationCameraSingleDeviceModal=function AddVerificationCameraSingleDeviceModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_14__context_VerificationCameraDeviceOverviewContext__["a" /* VerificationCameraDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext2.showWarning;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),port=_useState4[0],setPort=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),deviceType=_useState6[0],setDeviceType=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),name=_useState8[0],setName=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),ip=_useState10[0],setIp=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),mac=_useState12[0],setMac=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),id=_useState14[0],setId=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),vendor=_useState16[0],setVendor=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),specVersion=_useState18[0],setSpecVersion=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState20=_slicedToArray(_useState19,2),parentAssetLabel=_useState20[0],setParentAssetLabel=_useState20[1];// Error states
var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),portErr=_useState22[0],setPortErr=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),deviceTypeErr=_useState24[0],setDeviceTypeErr=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),nameErr=_useState26[0],setNameErr=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),ipErr=_useState28[0],setIpErr=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState30=_slicedToArray(_useState29,2),macErr=_useState30[0],setMacErr=_useState30[1];var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState32=_slicedToArray(_useState31,2),idErr=_useState32[0],setIdErr=_useState32[1];var _useState33=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState34=_slicedToArray(_useState33,2),vendorErr=_useState34[0],setVendorErr=_useState34[1];var _useState35=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState36=_slicedToArray(_useState35,2),specVersionErr=_useState36[0],setSpecVersionErr=_useState36[1];var initialMonitoringValue={startTime:"0",endTime:"0",reason:""};var _useState37=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(JSON.stringify(initialMonitoringValue)),_useState38=_slicedToArray(_useState37,2),monitoring=_useState38[0],setMonitoring=_useState38[1];var stateValues={mac:mac,ip:ip,name:name,deviceType:deviceType,port:port,deviceConfig:{type:__WEBPACK_IMPORTED_MODULE_10__util_Util__["e" /* assetTypeToConfigTypeDict */].typeASML,id:id},vendorAttributes:{vendor:vendor,spec_version:specVersion},monitoring:monitoring,parentAssetLabel:parentAssetLabel};var onCloseModal=function onCloseModal(){setOpen(false);setSelected("");resetInputState();setShowAlert(false);};var onClickConfirm=function onClickConfirm(stateValues){if(Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["T" /* validateNewAsmlComponentDevice */])(stateValues)){showWarning(formatMessage({id:"device.editWarning"}),function(){setShowAlert(false);stateValues.deviceConfig=JSON.stringify(stateValues.deviceConfig);if(selected){stateValues.divertConfig=JSON.stringify(viewModel.asmlComponentInformation[stateValues.mac].divertConfig);updateData(stateValues);}else{addData(stateValues);}setOpen(false);resetInputState();});}else{setShowAlert(true);}};function resetInputState(){setMac("");setMacErr(false);setMonitoring(JSON.stringify(initialMonitoringValue));setVendor("");setSpecVersion("");resetAssetDetails();clearAssetDetailErrors();}function resetAssetDetails(){setIp("");setId("");setPort("");setDeviceType("");setVendorErr(false);setSpecVersionErr(false);setName("");}function clearAssetDetailErrors(){setIpErr(false);setIdErr(false);setPortErr(false);setDeviceTypeErr(false);setNameErr(false);}var prefill=function prefill(value){if(viewModel.asmlComponentInformation.hasOwnProperty(value)){setSelected(value);var device=viewModel.asmlComponentInformation[value];var vendorAttributes=device.vendorAttributes;clearAssetDetailErrors();setMac(device.mac);setIp(device.ip);setId(device.id||"");setPort(device.port);setDeviceType(device.deviceType);setName(device.name);setVendor(vendorAttributes.vendor);setSpecVersion(vendorAttributes.spec_version);setParentAssetLabel(device.parentAssetLabel);var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};setMonitoring(JSON.stringify(deviceMonitoring));}else if(selected){setSelected(false);resetAssetDetails();}};var resetDeviceConfigFields=function resetDeviceConfigFields(){setId("");};var addData=function addData(stateValues){dispatch({type:'ADD_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues}});};var updateData=function updateData(stateValues){dispatch({type:'UPDATE_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.add_device_button_modal"}),open:open,onOpen:function onOpen(){return prefill(selected);},onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.mac",defaultMessage:"MAC Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"mac-input",value:mac,onChange:setMac,mask:__WEBPACK_IMPORTED_MODULE_9__util_Validations__["i" /* MAC_MASK */],disabled:selected,onBlur:function onBlur(){setMacErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(stateValues.mac,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].MAC));prefill(mac);},error:macErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"id-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.ip",defaultMessage:"IP Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"ip-input",value:ip,onChange:setIp,onBlur:function onBlur(){return setIpErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(stateValues.ip,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["g" /* IP_ADDRESS_PATTERN */]));},error:ipErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"port-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.port",defaultMessage:"Port"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"port-input",value:port,onChange:setPort,onBlur:function onBlur(){return setPortErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(stateValues.port,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].PORT));},error:portErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"name-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.name",defaultMessage:"Device Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"name-input",value:name,onChange:setName,onBlur:function onBlur(){return setNameErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(stateValues.name,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].NAME));},error:nameErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.name_line_desc",defaultMessage:"Display name of the device. e.g. \"Line 3\""})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.protocol",defaultMessage:"Protocol"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select___default.a,{value:deviceType,onChange:function onChange(value){setDeviceType(value);resetDeviceConfigFields();},onBlur:function onBlur(){return setDeviceTypeErr(!deviceType);},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.select_protocol",defaultMessage:"Select a protocol"}),error:deviceTypeErr,width:"100%"},__WEBPACK_IMPORTED_MODULE_9__util_Validations__["k" /* PROTOCOLS */].ASML.map(function(protocol){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select__["SelectOption"],{key:protocol,value:protocol,label:protocol});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"id-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.device_id",defaultMessage:"Device ID"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"id-input",value:id,onChange:setId,onBlur:function onBlur(){return setIdErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(stateValues.deviceConfig.id,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].DEVICE_ID));},error:idErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.device_id_line_desc",defaultMessage:"Unique local identifier for the device. eg. \"3\" for \"Line 3\""})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select___default.a,{id:"device-type-input",value:vendor,onChange:function onChange(value){return setVendor(value);},onBlur:function onBlur(){return setVendorErr(!vendor);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_vendor'}),error:vendorErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["r" /* VENDOR_INFO_KEYS */].VENDOR).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_9__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.spec_version'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select___default.a,{id:"device-type-input",value:specVersion,onChange:function onChange(value){return setSpecVersion(value);},onBlur:function onBlur(){return setSpecVersionErr(!specVersion);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_version'}),error:specVersionErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["r" /* VENDOR_INFO_KEYS */].SPEC_VERSION).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_9__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][value]});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stateValues);}},selected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmEdit",defaultMessage:"Confirm edit"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddVerificationCameraSingleDeviceModal));

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_VerificationCameraDeviceOverviewContext__ = __webpack_require__(315);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var VerificationCameraDevicePage=function(_Component){_inherits(VerificationCameraDevicePage,_Component);function VerificationCameraDevicePage(){_classCallCheck(this,VerificationCameraDevicePage);return _possibleConstructorReturn(this,(VerificationCameraDevicePage.__proto__||Object.getPrototypeOf(VerificationCameraDevicePage)).apply(this,arguments));}_createClass(VerificationCameraDevicePage,[{key:"render",value:function render(){var getVerificationCameraRoutes=function getVerificationCameraRoutes(){return __WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__["C" /* VERIFICATION_CAMERA */];};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__context_VerificationCameraDeviceOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["b" /* default */],{routes:getVerificationCameraRoutes(),location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["a" /* NavigationRoutes */],{routes:getVerificationCameraRoutes()})));}}]);return VerificationCameraDevicePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (VerificationCameraDevicePage);

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_AsmlDeviceOverviewContext__ = __webpack_require__(150);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var AsmlDevicePage=function(_Component){_inherits(AsmlDevicePage,_Component);function AsmlDevicePage(){_classCallCheck(this,AsmlDevicePage);return _possibleConstructorReturn(this,(AsmlDevicePage.__proto__||Object.getPrototypeOf(AsmlDevicePage)).apply(this,arguments));}_createClass(AsmlDevicePage,[{key:"render",value:function render(){var getAsmlRoutes=function getAsmlRoutes(){return __WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__["h" /* ASML */];};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__context_AsmlDeviceOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["b" /* default */],{routes:getAsmlRoutes(),location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["a" /* NavigationRoutes */],{routes:getAsmlRoutes()})));}}]);return AsmlDevicePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AsmlDevicePage);

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_HandsfreeCameraDeviceOverviewContext__ = __webpack_require__(516);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HandsfreeCameraDevicePage=function(_Component){_inherits(HandsfreeCameraDevicePage,_Component);function HandsfreeCameraDevicePage(){_classCallCheck(this,HandsfreeCameraDevicePage);return _possibleConstructorReturn(this,(HandsfreeCameraDevicePage.__proto__||Object.getPrototypeOf(HandsfreeCameraDevicePage)).apply(this,arguments));}_createClass(HandsfreeCameraDevicePage,[{key:"render",value:function render(){var getHandsfreeCameraRoutes=function getHandsfreeCameraRoutes(){return __WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__["o" /* HANDSFREE_CAMERA */];};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__context_HandsfreeCameraDeviceOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["b" /* default */],{routes:getHandsfreeCameraRoutes(),location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["a" /* NavigationRoutes */],{routes:getHandsfreeCameraRoutes()})));}}]);return HandsfreeCameraDevicePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HandsfreeCameraDevicePage);

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HandsfreeCameraDeviceOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CameraDeviceOverviewReducer__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Constants__ = __webpack_require__(2);
var HandsfreeCameraDeviceOverviewReducer=Object(__WEBPACK_IMPORTED_MODULE_0__CameraDeviceOverviewReducer__["a" /* createCameraDeviceOverviewReducer */])(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_79" /* HANDSFREE_CAMERA_SUB_ASSET_TYPE */]);

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_HandsfreeCameraDeviceOverviewContext__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CameraDeviceOverview__ = __webpack_require__(518);
var HandsfreeCameraDeviceOverview=function HandsfreeCameraDeviceOverview(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CameraDeviceOverview__["a" /* default */],Object.assign({},props,{deviceContext:__WEBPACK_IMPORTED_MODULE_1__context_HandsfreeCameraDeviceOverviewContext__["a" /* HandsfreeCameraDeviceOverviewContext */]}));};/* harmony default export */ __webpack_exports__["a"] = (HandsfreeCameraDeviceOverview);

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddCameraSingleDeviceModal=function AddCameraSingleDeviceModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(props.deviceContext),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_12__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext2.showWarning;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),port=_useState4[0],setPort=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),deviceType=_useState6[0],setDeviceType=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),name=_useState8[0],setName=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),ip=_useState10[0],setIp=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),mac=_useState12[0],setMac=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),id=_useState14[0],setId=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),vendor=_useState16[0],setVendor=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),specVersion=_useState18[0],setSpecVersion=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState20=_slicedToArray(_useState19,2),parentAssetLabel=_useState20[0],setParentAssetLabel=_useState20[1];// Error states
var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),portErr=_useState22[0],setPortErr=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),deviceTypeErr=_useState24[0],setDeviceTypeErr=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),nameErr=_useState26[0],setNameErr=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),ipErr=_useState28[0],setIpErr=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState30=_slicedToArray(_useState29,2),macErr=_useState30[0],setMacErr=_useState30[1];var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState32=_slicedToArray(_useState31,2),idErr=_useState32[0],setIdErr=_useState32[1];var _useState33=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState34=_slicedToArray(_useState33,2),vendorErr=_useState34[0],setVendorErr=_useState34[1];var _useState35=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState36=_slicedToArray(_useState35,2),specVersionErr=_useState36[0],setSpecVersionErr=_useState36[1];var initialMonitoringValue={startTime:"0",endTime:"0",reason:""};var _useState37=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(JSON.stringify(initialMonitoringValue)),_useState38=_slicedToArray(_useState37,2),monitoring=_useState38[0],setMonitoring=_useState38[1];var stateValues={mac:mac,ip:ip,name:name,deviceType:deviceType,port:port,deviceConfig:{type:__WEBPACK_IMPORTED_MODULE_10__util_Util__["e" /* assetTypeToConfigTypeDict */].typeASML,id:id},vendorAttributes:{vendor:vendor,spec_version:specVersion},monitoring:monitoring,parentAssetLabel:parentAssetLabel};var onCloseModal=function onCloseModal(){setOpen(false);setSelected("");resetInputState();setShowAlert(false);};var onClickConfirm=function onClickConfirm(stateValues){if(Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["T" /* validateNewAsmlComponentDevice */])(stateValues)){showWarning(formatMessage({id:"device.editWarning"}),function(){setShowAlert(false);stateValues.deviceConfig=JSON.stringify(stateValues.deviceConfig);if(selected){stateValues.divertConfig=JSON.stringify(viewModel.asmlComponentInformation[stateValues.mac].divertConfig);updateData(stateValues);}else{addData(stateValues);}setOpen(false);resetInputState();});}else{setShowAlert(true);}};function resetInputState(){setMac("");setMacErr(false);setMonitoring(JSON.stringify(initialMonitoringValue));setVendor("");setSpecVersion("");resetAssetDetails();clearAssetDetailErrors();}function resetAssetDetails(){setIp("");setId("");setPort("");setDeviceType("");setVendorErr(false);setSpecVersionErr(false);setName("");}function clearAssetDetailErrors(){setIpErr(false);setIdErr(false);setPortErr(false);setDeviceTypeErr(false);setNameErr(false);}var prefill=function prefill(value){if(viewModel.asmlComponentInformation.hasOwnProperty(value)){setSelected(value);var device=viewModel.asmlComponentInformation[value];var vendorAttributes=device.vendorAttributes;clearAssetDetailErrors();setMac(device.mac);setIp(device.ip);setId(device.id||"");setPort(device.port);setDeviceType(device.deviceType);setName(device.name);setVendor(vendorAttributes.vendor);setSpecVersion(vendorAttributes.spec_version);setParentAssetLabel(device.parentAssetLabel);var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};setMonitoring(JSON.stringify(deviceMonitoring));}else if(selected){setSelected("");resetAssetDetails();}};var resetDeviceConfigFields=function resetDeviceConfigFields(){setId("");};var addData=function addData(stateValues){dispatch({type:'ADD_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues}});};var updateData=function updateData(stateValues){dispatch({type:'UPDATE_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.add_device_button_modal"}),open:open,onOpen:function onOpen(){return prefill(selected);},onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.mac",defaultMessage:"MAC Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"mac-input",value:mac,onChange:setMac,mask:__WEBPACK_IMPORTED_MODULE_9__util_Validations__["i" /* MAC_MASK */],disabled:selected,onBlur:function onBlur(){setMacErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(stateValues.mac,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].MAC));prefill(mac);},error:macErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"ip-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.ip",defaultMessage:"IP Address"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"ip-input",value:ip,onChange:setIp,onBlur:function onBlur(){return setIpErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(stateValues.ip,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["g" /* IP_ADDRESS_PATTERN */]));},error:ipErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"port-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.port",defaultMessage:"Port"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"port-input",value:port,onChange:setPort,onBlur:function onBlur(){return setPortErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(stateValues.port,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].PORT));},error:portErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"name-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.name",defaultMessage:"Device Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"name-input",value:name,onChange:setName,onBlur:function onBlur(){return setNameErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(stateValues.name,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].NAME));},error:nameErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.name_line_desc",defaultMessage:"Display name of the device. e.g. \"Line 3\""})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"protocol-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.protocol",defaultMessage:"Protocol"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select___default.a,{id:"protocol-input",value:deviceType,onChange:function onChange(value){setDeviceType(value);resetDeviceConfigFields();},onBlur:function onBlur(){return setDeviceTypeErr(!deviceType);},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.select_protocol",defaultMessage:"Select a protocol"}),error:deviceTypeErr,width:"100%"},__WEBPACK_IMPORTED_MODULE_9__util_Validations__["k" /* PROTOCOLS */].ASML.map(function(protocol){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select__["SelectOption"],{key:protocol,value:protocol,label:protocol});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"id-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.device_id",defaultMessage:"Device ID"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"id-input",value:id,onChange:setId,onBlur:function onBlur(){return setIdErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(stateValues.deviceConfig.id,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].DEVICE_ID));},error:idErr,helperText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.device_id_line_desc",defaultMessage:"Unique local identifier for the device. eg. \"3\" for \"Line 3\""})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"vendor-input"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select___default.a,{id:"vendor-input",value:vendor,onChange:function onChange(value){return setVendor(value);},onBlur:function onBlur(){return setVendorErr(!vendor);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_vendor'}),error:vendorErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["r" /* VENDOR_INFO_KEYS */].VENDOR).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_9__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"spec-version-input"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.spec_version'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select___default.a,{id:"spec-version-input",value:specVersion,onChange:function onChange(value){return setSpecVersion(value);},onBlur:function onBlur(){return setSpecVersionErr(!specVersion);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_version'}),error:specVersionErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_10__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["r" /* VENDOR_INFO_KEYS */].SPEC_VERSION).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_9__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][value]});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stateValues);}},selected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmEdit",defaultMessage:"Confirm edit"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddCameraSingleDeviceModal));

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_OverheadCameraDeviceOverviewContext__ = __webpack_require__(519);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OverheadCameraDevicePage=function(_Component){_inherits(OverheadCameraDevicePage,_Component);function OverheadCameraDevicePage(){_classCallCheck(this,OverheadCameraDevicePage);return _possibleConstructorReturn(this,(OverheadCameraDevicePage.__proto__||Object.getPrototypeOf(OverheadCameraDevicePage)).apply(this,arguments));}_createClass(OverheadCameraDevicePage,[{key:"render",value:function render(){var getOverheadCameraRoutes=function getOverheadCameraRoutes(){return __WEBPACK_IMPORTED_MODULE_3__util_RouteConstants__["v" /* OVERHEAD_CAMERA */];};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__context_OverheadCameraDeviceOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["b" /* default */],{routes:getOverheadCameraRoutes(),location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["a" /* NavigationRoutes */],{routes:getOverheadCameraRoutes()})));}}]);return OverheadCameraDevicePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (OverheadCameraDevicePage);

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverheadCameraDeviceOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CameraDeviceOverviewReducer__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Constants__ = __webpack_require__(2);
var OverheadCameraDeviceOverviewReducer=Object(__WEBPACK_IMPORTED_MODULE_0__CameraDeviceOverviewReducer__["a" /* createCameraDeviceOverviewReducer */])(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_150" /* OVERHEAD_CAMERA_SUB_ASSET_TYPE */]);

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_OverheadCameraDeviceOverviewContext__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CameraDeviceOverview__ = __webpack_require__(518);
var OverheadCameraDeviceOverview=function OverheadCameraDeviceOverview(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CameraDeviceOverview__["a" /* default */],Object.assign({},props,{deviceContext:__WEBPACK_IMPORTED_MODULE_1__context_OverheadCameraDeviceOverviewContext__["a" /* OverheadCameraDeviceOverviewContext */]}));};/* harmony default export */ __webpack_exports__["a"] = (OverheadCameraDeviceOverview);

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AsmlDeviceOverviewContext__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modal_AddAsmlSingleDeviceModal__ = __webpack_require__(1389);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var AsmlDeviceOverview=function AsmlDeviceOverview(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_AsmlDeviceOverviewContext__["a" /* AsmlDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState2=_slicedToArray(_useState,2),openActionsMenu=_useState2[0],setOpenActionsMenu=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openAddModal=_useState4[0],setOpenAddModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),selectedInductCamera=_useState6[0],setSelectedInductCamera=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),selectedPrinter=_useState8[0],setSelectedPrinter=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),selectedVerificationCamera=_useState10[0],setSelectedVerificationCamera=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),openDeleteModal=_useState12[0],setOpenDeleteModal=_useState12[1];var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=true;setOpenActionsMenu(_open);},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=false;setOpenActionsMenu(_open);},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openAddModal&&!openDeleteModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["D" /* getAssetRefreshInterval */])());var statusInterval=setInterval(function(){if(!document.hidden){getStatusData();}},Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_11" /* getStatusRefreshInterval */])());return function(){clearInterval(interval);clearInterval(statusInterval);};}},[openAddModal,openDeleteModal]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,viewModel.inductCameraDeviceInformation.length);},[viewModel.inductCameraDeviceInformation]);var onSort=function onSort(sortDetails){dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};var sortedDeviceList=Object.values(viewModel.inductCameraDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){var _viewModel$sortPref=viewModel.sortPref,column=_viewModel$sortPref.column,direction=_viewModel$sortPref.direction;var compareValue=void 0;if(Object.keys(__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */]).includes(column)){if(column==="vendor"){compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column]+a.vendorAttributes["spec_version"],b.vendorAttributes[column]+b.vendorAttributes["spec_version"]);}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column],b.vendorAttributes[column]);}}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a[column],b[column]);}if(direction===__WEBPACK_IMPORTED_MODULE_11__util_Constants__["J" /* ASCENDING */]){return compareValue;}else{return-compareValue;}});var getData=function getData(){setOpenAddModal(false);setOpenDeleteModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var getStatusData=function getStatusData(){dispatch({type:'LOAD_STATUS',data:{dispatcher:dispatch}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var onClickAddEditDevice=function onClickAddEditDevice(){setSelectedInductCamera("");setSelectedPrinter("");setSelectedVerificationCamera("");setOpenAddModal(true);};var onClickEditDevice=function onClickEditDevice(inductCameraMac,printerMac,verificationCameraMac){setSelectedInductCamera(inductCameraMac);setSelectedPrinter(printerMac);setSelectedVerificationCamera(verificationCameraMac);setOpenAddModal(true);};var getAsmlStatusDisplayContent=function getAsmlStatusDisplayContent(childComponent){if(childComponent===null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null);}else{if(childComponent.assetStatus){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{color:childComponent.assetStatus.toUpperCase()===__WEBPACK_IMPORTED_MODULE_11__util_Constants__["b" /* ACTIVE */]?__WEBPACK_IMPORTED_MODULE_11__util_Constants__["X" /* BLUE_COLOR */]:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_149" /* ORANGE_COLOR */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,childComponent.assetStatus),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"loading.text",defaultMessage:"Loading..."}));}}};var getAvailableMacAddressList=function getAvailableMacAddressList(allMacAddressList,usedMacAddressList){var availableMacAddressList=allMacAddressList.filter(function(x){return!usedMacAddressList.includes(x);});return availableMacAddressList;};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default.a,{position:"top",title:intl.formatMessage({id:'tooltip.scrolltobottom',defaultMessage:'Scroll to bottom'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_alert___default.a,{type:"informational",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"alert.device",defaultMessage:"No device present for this station."})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],{sortColumn:"name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.name",defaultMessage:"Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.component_type",defaultMessage:"Component Type"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.mac_ip",defaultMessage:"MAC/IP"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_19__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.connectionstatus'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],{sortColumn:"connection"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.connection",defaultMessage:"Connection Status"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.action",defaultMessage:"Action"}))),sortedDeviceList.map(function(inductCameraDevice,index){var printerChildAsset=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["H" /* getChildDeviceBySubType */])(inductCameraDevice.mac,Object.values(viewModel.printerDeviceInformation),__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_159" /* PRINTER_SUB_ASSET_TYPE */]);var printerDevice=printerChildAsset.childAsset;var verificationCameraChildAsset=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["H" /* getChildDeviceBySubType */])(inductCameraDevice.mac,Object.values(viewModel.verificationCameraDeviceInformation),__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_220" /* VERIFICATION_CAMERA_SUB_ASSET_TYPE */]);var verificationCameraDevice=verificationCameraChildAsset.childAsset;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableRow"],{key:index,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,inductCameraDevice.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),inductCameraDevice.deviceType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"INDUCT CAMERA"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),printerDevice!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"PRINTER"))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),verificationCameraDevice!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"VERIFICATION CAMERA"))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,inductCameraDevice.mac),inductCameraDevice.ip,":",inductCameraDevice.port)),printerDevice!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,printerDevice.mac),printerDevice.ip,":",printerDevice.port)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),verificationCameraDevice!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,verificationCameraDevice.mac),verificationCameraDevice.ip,":",verificationCameraDevice.port)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],{alignmentVertical:"top"},getAsmlStatusDisplayContent(inductCameraDevice),getAsmlStatusDisplayContent(printerDevice),getAsmlStatusDisplayContent(verificationCameraDevice)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_table__["TableCell"],{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"my-menu","aria-haspopup":"menu","aria-expanded":"false"},"..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu___default.a,{anchorNode:actionButtonRefs.current[index],open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEditDevice(inductCameraDevice.mac,printerDevice?printerDevice.mac:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_142" /* NO_PRINTER_ASSIGNED */],verificationCameraDevice?verificationCameraDevice.mac:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_143" /* NO_VERIFICATION_CAMERA_ASSIGNED */]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"actions.addDevice",defaultMessage:"Edit"}))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__meridian_components_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_button___default.a,{onClick:onClickAddEditDevice,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_plus_circle___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */],{id:"device.add_device_button_modal",defaultMessage:"Add Device Configuration"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_box___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__modal_AddAsmlSingleDeviceModal__["a" /* default */],{open:openAddModal,setOpen:setOpenAddModal,availableInductCameraMacAddressList:getAvailableMacAddressList(viewModel.allInductCameraMacAddressArray,viewModel.usedInductCameraMacAddressArray),availablePrinterMacAddressList:getAvailableMacAddressList(viewModel.allPrinterMacAddressArray,viewModel.usedPrinterMacAddressArray),availableVerificationCameraMacAddressList:getAvailableMacAddressList(viewModel.allVerificationCameraMacAddressArray,viewModel.usedVerificationCameraMacAddressArray),selectedInductCameraMac:selectedInductCamera,setSelectedInductCameraMac:setSelectedInductCamera,selectedPrinterMac:selectedPrinter,setSelectedPrinterMac:setSelectedPrinter,selectedVerificationCameraMac:selectedVerificationCamera,setSelectedVerificationCameraMac:setSelectedVerificationCamera,editAvailableInductCameraMacAddressList:[].concat(_toConsumableArray(getAvailableMacAddressList(viewModel.allInductCameraMacAddressArray,viewModel.usedInductCameraMacAddressArray)),[selectedInductCamera]),editAvailablePrinterMacAddressList:[].concat(_toConsumableArray(getAvailableMacAddressList(viewModel.allPrinterMacAddressArray,viewModel.usedPrinterMacAddressArray)),[selectedPrinter,__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_210" /* UNASSIGN_PRINTER */]]),editAvailableVerificationCameraMacAddressList:[].concat(_toConsumableArray(getAvailableMacAddressList(viewModel.allVerificationCameraMacAddressArray,viewModel.usedVerificationCameraMacAddressArray)),[selectedVerificationCamera,__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_211" /* UNASSIGN_VERIFICATION_CAMERA */]])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AsmlDeviceOverview));

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context_AsmlDeviceOverviewContext__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddAsmlSingleDeviceModal=function AddAsmlSingleDeviceModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,selectedInductCameraMac=props.selectedInductCameraMac,selectedPrinterMac=props.selectedPrinterMac,selectedVerificationCameraMac=props.selectedVerificationCameraMac;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__context_AsmlDeviceOverviewContext__["a" /* AsmlDeviceOverviewContext */]),dispatch=_useContext.dispatch;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),inductCameraMac=_useState4[0],setInductCameraMac=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),printerMac=_useState6[0],setPrinterMac=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),verificationCameraMac=_useState8[0],setVerificationCameraMac=_useState8[1];// Error states
var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),inductCameraMacErr=_useState10[0],setInductCameraMacErr=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),printerMacErr=_useState12[0],setPrinterMacErr=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),verificationCameraMacErr=_useState14[0],setVerificationCameraMacErr=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.availableInductCameraMacAddressList),_useState16=_slicedToArray(_useState15,2),availableInductCameraMacAddressList=_useState16[0],setAvailableInductCameraMacAddressList=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.availablePrinterMacAddressList),_useState18=_slicedToArray(_useState17,2),availablePrinterMacAddressList=_useState18[0],setAvailablePrinterMacAddressList=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.availableVerificationCameraMacAddressList),_useState20=_slicedToArray(_useState19,2),availableVerificationCameraMacAddressList=_useState20[0],setAvailableVerificationCameraMacAddressList=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState22=_slicedToArray(_useState21,2),originalInductCameraMac=_useState22[0],setOriginalInductCameraMac=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState24=_slicedToArray(_useState23,2),originalPrinterMac=_useState24[0],setOriginalPrinterMac=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState26=_slicedToArray(_useState25,2),originalVerificationCameraMac=_useState26[0],setOriginalVerificationCameraMac=_useState26[1];var stateValues={inductCameraMac:inductCameraMac,printerMac:printerMac,verificationCameraMac:verificationCameraMac,originalInductCameraMac:originalInductCameraMac,originalPrinterMac:originalPrinterMac,originalVerificationCameraMac:originalVerificationCameraMac};var onCloseModal=function onCloseModal(){setOpen(false);setInductCameraMac("");setPrinterMac("");setVerificationCameraMac("");clearAssetDetailErrors();setShowAlert(false);};function clearAssetDetailErrors(){setInductCameraMacErr(false);setPrinterMacErr(false);setVerificationCameraMacErr(false);}var onClickConfirm=function onClickConfirm(stateValues){if(Object(__WEBPACK_IMPORTED_MODULE_10__util_Validations__["U" /* validateNewAsmlDevice */])(stateValues)){setShowAlert(false);setOpen(false);if(selectedInductCameraMac){updateData(stateValues);}else{addData(stateValues);}setInductCameraMac("");setPrinterMac("");setVerificationCameraMac("");}else{setShowAlert(true);}};var prefill=function prefill(value){if(selectedInductCameraMac){setInductCameraMac(selectedInductCameraMac);setAvailableInductCameraMacAddressList(props.editAvailableInductCameraMacAddressList);setOriginalInductCameraMac(selectedInductCameraMac);setPrinterMac(selectedPrinterMac);setAvailablePrinterMacAddressList(props.editAvailablePrinterMacAddressList);setOriginalPrinterMac(selectedPrinterMac);setVerificationCameraMac(selectedVerificationCameraMac);setAvailableVerificationCameraMacAddressList(props.editAvailableVerificationCameraMacAddressList);setOriginalVerificationCameraMac(selectedVerificationCameraMac);}else{setAvailableInductCameraMacAddressList(props.availableInductCameraMacAddressList);setAvailablePrinterMacAddressList(props.availablePrinterMacAddressList);setAvailableVerificationCameraMacAddressList(props.availableVerificationCameraMacAddressList);}};var addData=function addData(stateValues){dispatch({type:'ADD_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues}});};var updateData=function updateData(stateValues){dispatch({type:'UPDATE_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.add_device_button_modal"}),open:open,onOpen:function onOpen(){return prefill(selectedInductCameraMac);},onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.induct_camera_mac'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_select___default.a,{value:inductCameraMac,onChange:function onChange(value){setInductCameraMac(value);setOriginalInductCameraMac(selectedInductCameraMac);},onBlur:function onBlur(){return setInductCameraMacErr(!inductCameraMac);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_induct_camera_mac'}),error:inductCameraMacErr,width:"100%"},availableInductCameraMacAddressList.map(function(macAddress){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_select__["SelectOption"],{key:macAddress,value:macAddress,label:macAddress});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.printer_mac'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_select___default.a,{value:printerMac,onChange:function onChange(value){setPrinterMac(value);setOriginalPrinterMac(selectedPrinterMac);},onBlur:function onBlur(){return setPrinterMacErr(!printerMac);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_printer_mac'}),error:printerMacErr,width:"100%"},availablePrinterMacAddressList.map(function(macAddress){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_select__["SelectOption"],{key:macAddress,value:macAddress,label:macAddress});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.verification_camera_mac'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_select___default.a,{value:verificationCameraMac,onChange:function onChange(value){setVerificationCameraMac(value);setOriginalVerificationCameraMac(selectedVerificationCameraMac);},onBlur:function onBlur(){return setVerificationCameraMacErr(!verificationCameraMac);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_11__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_verification_camera_mac'}),error:verificationCameraMacErr,width:"100%"},availableVerificationCameraMacAddressList.map(function(macAddress){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_select__["SelectOption"],{key:macAddress,value:macAddress,label:macAddress});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__meridian_components_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"alert.missingfields",defaultMessage:"Please enter all fields in correct format!"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.cancel",defaultMessage:"Cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stateValues);}},selectedInductCameraMac?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmEdit",defaultMessage:"Confirm edit"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */],{id:"modal.confirmAdd",defaultMessage:"Confirm add"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */])(AddAsmlSingleDeviceModal));

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_AsmlDeviceOverviewContext__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonui_CommonDeviceLogstream__ = __webpack_require__(102);
var AsmlDeviceLogstream=function AsmlDeviceLogstream(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__context_AsmlDeviceOverviewContext__["a" /* AsmlDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var deviceList=[viewModel.inductCameraDeviceInformation,viewModel.printerDeviceInformation,viewModel.verificationCameraDeviceInformation].flatMap(function(obj){return Object.values(obj);});var props={protocols:__WEBPACK_IMPORTED_MODULE_3__util_Validations__["k" /* PROTOCOLS */].ASML,dispatch:dispatch,deviceList:deviceList,deviceType:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["L" /* ASML_ASSET_TYPE */],intl:intl};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonui_CommonDeviceLogstream__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(AsmlDeviceLogstream));

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_LidarOverviewContext__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_ProvisioningContext__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__handler_ParentDataHandler__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lidarTester_LidarTesterGridView__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lidarTester_ProvisioningProgressIndicator__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_LidarTesterUtil__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_alert__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var CONTAINER_STYLE={overflow:'auto'};var LidarTesterTool=function LidarTesterTool(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__context_LidarOverviewContext__["a" /* LidarOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__context_ProvisioningContext__["a" /* ProvisioningContext */]),provisioningViewModel=_useContext2.provisioningViewModel,provisioningDispatch=_useContext2.provisioningDispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),selectedMac=_useState2[0],setSelectedMac=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),error=_useState4[0],setError=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),showPageRefreshAlert=_useState6[0],setShowPageRefreshAlert=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),showConnectivityAlert=_useState8[0],setShowConnectivityAlert=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState10=_slicedToArray(_useState9,2),connectivityAlertTimeout=_useState10[0],setConnectivityAlertTimeout=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState12=_slicedToArray(_useState11,2),branchProvisioningRequestTimeOut=_useState12[0],setBranchProvisioningRequestTimeOut=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState14=_slicedToArray(_useState13,2),leafProvisioningStatus=_useState14[0],setLeafProvisioningStatus=_useState14[1];// null, 'in-progress', 'success', 'error', 'timeout'
var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState16=_slicedToArray(_useState15,2),leafProvisioningRequestTimeout=_useState16[0],setProvisioningRequestLeafTimeout=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState18=_slicedToArray(_useState17,2),leafProvisioningLocked=_useState18[0],setLeafProvisioningLocked=_useState18[1];// To prevent updates after timeout
// Extract values from provisioningViewModel with default values
var provisioningTriggered=provisioningViewModel?provisioningViewModel.provisioningTriggered:false;var clusterStatus=provisioningViewModel?provisioningViewModel.clusterStatus:null;var expectedBranchNodeCount=provisioningViewModel?provisioningViewModel.expectedBranchNodeCount:0;var detectedBranchNodeCount=provisioningViewModel?provisioningViewModel.detectedBranchNodeCount:0;var provisioningData=provisioningViewModel?provisioningViewModel.provisioningData:[];var device=viewModel.lidarDeviceInformation[selectedMac];var activateLidarTester=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){var args=Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["A" /* getAPIGatewayPostRequest */])(Object(__WEBPACK_IMPORTED_MODULE_12__util_LidarTesterUtil__["k" /* getLidarTesterActivationRequest */])(),__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_58" /* ENDPOINT_PUBLISH_COMMAND_TO_THIN_CLIENT */]);Object(__WEBPACK_IMPORTED_MODULE_8__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args).then(function(r){return console.log("Lidar Tester Activated");});},[]);var onClickTriggerProvision=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){if(selectedMac&&device){// Check device connectivity before proceeding
if(device.connectivity.toLowerCase()!==__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_145" /* ONLINE_OK */]){// Clear any existing timeout
clearTimeout(connectivityAlertTimeout);setShowConnectivityAlert(true);// Set 5-second timeout to auto-hide alert
var timeoutId=setTimeout(function(){return setShowConnectivityAlert(false);},5000);setConnectivityAlertTimeout(timeoutId);return;}// Reset leaf provisioning state for new attempt
setLeafProvisioningStatus(null);setLeafProvisioningLocked(false);clearTimeout(leafProvisioningRequestTimeout);setProvisioningRequestLeafTimeout(null);// Initialize provisioning via the context
provisioningDispatch({type:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_187" /* SKYLARK_PROVISIONING_ACTIONS */].INIT_PROVISIONING});// Clear any existing timeout
clearTimeout(branchProvisioningRequestTimeOut);// First stage: Branch provisioning
var branchProvisionRequest={nodeId:Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["X" /* getNodeId */])(),commandType:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_162" /* PROVISION_REQUEST */],commandParams:JSON.stringify({event:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_182" /* SKYLARK_BRANCH_PROVISION_REQUEST */],lidarControllerIP:device.ip})};var args=Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["A" /* getAPIGatewayPostRequest */])(branchProvisionRequest,__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_58" /* ENDPOINT_PUBLISH_COMMAND_TO_THIN_CLIENT */]);Object(__WEBPACK_IMPORTED_MODULE_8__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args).then(function(response){console.log(response);if(response&&response.status===500){setShowPageRefreshAlert(true);// Reset provisioning state on session expiration
provisioningDispatch({type:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_187" /* SKYLARK_PROVISIONING_ACTIONS */].RESET_PROVISIONING});return;}// Set a 25-second timeout for branch provisioning response
var newBranchProvisioningRequestTimeOut=setTimeout(function(){provisioningDispatch({type:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_187" /* SKYLARK_PROVISIONING_ACTIONS */].SET_CLUSTER_STATUS,data:{status:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_204" /* TIMEOUT_STRING */]}});},__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_183" /* SKYLARK_BRANCH_PROVISION_TIMEOUT_IN_SECONDS */]*1000);setBranchProvisioningRequestTimeOut(newBranchProvisioningRequestTimeOut);}).catch(function(error){setError(true);});}},[selectedMac,device,branchProvisioningRequestTimeOut,provisioningDispatch,provisioningViewModel,setError]);// Combined useEffect for provisioning workflow management
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){// Handle cluster status changes and trigger leaf provisioning
if(clusterStatus&&branchProvisioningRequestTimeOut){clearTimeout(branchProvisioningRequestTimeOut);setBranchProvisioningRequestTimeOut(null);// If branch provisioning was successful, trigger leaf provisioning
if(clusterStatus===__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_194" /* SUCCESS_STRING */]&&selectedMac&&device&&!leafProvisioningLocked){setLeafProvisioningStatus(__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_85" /* IN_PROGRESS_STRING */]);// Second stage: Leaf provisioning
var leafProvisionRequest={nodeId:Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["X" /* getNodeId */])(),commandType:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_162" /* PROVISION_REQUEST */],commandParams:JSON.stringify({event:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_184" /* SKYLARK_LEAF_PROVISION_REQUEST */],lidarControllerIP:device.ip})};var args=Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["A" /* getAPIGatewayPostRequest */])(leafProvisionRequest,__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_58" /* ENDPOINT_PUBLISH_COMMAND_TO_THIN_CLIENT */]);Object(__WEBPACK_IMPORTED_MODULE_8__handler_ParentDataHandler__["a" /* getAPIGatewayDataFromParent */])(args).then(function(){// Set a timeout for leaf provisioning response
var newLeafProvisioningRequestTimeout=setTimeout(function(){// Only update if not already locked (prevents race conditions)
if(!leafProvisioningLocked){setLeafProvisioningStatus(__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_204" /* TIMEOUT_STRING */]);setLeafProvisioningLocked(true);// Lock status updates
}},__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_185" /* SKYLARK_LEAF_PROVISION_TIMEOUT_IN_SECONDS */]*1000);setProvisioningRequestLeafTimeout(newLeafProvisioningRequestTimeout);}).catch(function(error){if(!leafProvisioningLocked){setLeafProvisioningStatus(__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_71" /* ERROR_STRING */]);setLeafProvisioningLocked(true);// Lock status updates on error
}setError(true);});}}},[clusterStatus,branchProvisioningRequestTimeOut,selectedMac,device,leafProvisioningLocked]);// Combined effect for initialization and cleanup
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){// Load view data on mount
dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});// Initial lidar tester activation
activateLidarTester();// Set up interval for subsequent activations
var lidarActivationInterval=setInterval(function(){activateLidarTester();},__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_103" /* LIDAR_TESTER_ACTIVATION_INTERVAL_MS */]);// Cleanup function
return function(){clearInterval(lidarActivationInterval);// Clean up any timeouts when component unmounts
clearTimeout(branchProvisioningRequestTimeOut);clearTimeout(leafProvisioningRequestTimeout);};},[dispatch,activateLidarTester]);// Note: timeoutId and leafProvisioningRequestTimeout removed from deps to avoid re-running
// Effect to monitor provisioning data and update leaf provisioning status
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){// Only process if we're in leaf provisioning phase and not locked
if(leafProvisioningStatus===__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_85" /* IN_PROGRESS_STRING */]&&!leafProvisioningLocked&&provisioningData.length>0){// Check if we have leaf node data
var leafNodes=provisioningData.filter(function(item){return item.nodeType===__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_96" /* LEAF */];});if(leafNodes.length>0){// Check if all leaf nodes are provisioned successfully
var allLeafNodesProvisioned=leafNodes.length===expectedBranchNodeCount&&leafNodes.every(function(node){return node.expectedNodeCount===node.detectedNodeCount;});if(allLeafNodesProvisioned){// All leaf nodes are provisioned successfully
setLeafProvisioningStatus(__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_194" /* SUCCESS_STRING */]);// Clear the timeout as we've received a successful response
clearTimeout(leafProvisioningRequestTimeout);setProvisioningRequestLeafTimeout(null);}else{// Some leaf nodes failed to provision
// Only update if we've received responses from all expected leaf nodes
var allLeafNodesResponded=leafNodes.length===(device&&device.displayableAssetMappings?device.displayableAssetMappings.length:0);if(allLeafNodesResponded){setLeafProvisioningStatus(__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_71" /* ERROR_STRING */]);// Clear the timeout as we've received responses from all nodes
clearTimeout(leafProvisioningRequestTimeout);setProvisioningRequestLeafTimeout(null);}}}}},[provisioningData,leafProvisioningStatus,leafProvisioningLocked,device,leafProvisioningRequestTimeout]);// Reset provisioning state when device selection changes
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){// Reset provisioning state via context
provisioningDispatch({type:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_187" /* SKYLARK_PROVISIONING_ACTIONS */].RESET_PROVISIONING});setError(false);setLeafProvisioningStatus(null);setLeafProvisioningLocked(false);// Clear any existing timeouts
clearTimeout(branchProvisioningRequestTimeOut);setBranchProvisioningRequestTimeOut(null);clearTimeout(leafProvisioningRequestTimeout);setProvisioningRequestLeafTimeout(null);clearTimeout(connectivityAlertTimeout);setConnectivityAlertTimeout(null);},[selectedMac,provisioningDispatch]);// Only depend on selectedMac and provisioningDispatch to prevent unnecessary re-renders. 
// This useEffect block will be in action only when a different LidarController is being selected.
// Helper functions for status display - eliminates nested ternary operators
var getBranchStatusDisplay=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(status,detectedCount,expectedCount){var config=__WEBPACK_IMPORTED_MODULE_12__util_LidarTesterUtil__["a" /* BRANCH_STATUS_CONFIG */][status];return{backgroundColor:config.backgroundColor,textColor:config.textColor,message:config.getMessage(expectedCount,detectedCount)};},[]);var getLeafStatusDisplay=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(status){var config=__WEBPACK_IMPORTED_MODULE_12__util_LidarTesterUtil__["b" /* LEAF_STATUS_CONFIG */][status];return{backgroundColor:config.backgroundColor,textColor:config.textColor,message:config.getMessage()};},[]);var renderStatusDisplay=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(statusDisplay,status){if(!statusDisplay)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:'100%',padding:'8px',backgroundColor:statusDisplay.backgroundColor,color:statusDisplay.textColor,borderRadius:'4px',textAlign:'center',boxShadow:'0 2px 4px rgba(0,0,0,0.1)'}},Object(__WEBPACK_IMPORTED_MODULE_5__util_Util__["_28" /* renderStatusWithIcon */])(status,statusDisplay.message,statusDisplay.textColor));},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:CONTAINER_STYLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"label",type:"b300",color:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_158" /* PRIMARY_TEXT_COLOUR */]},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"lidarTester.select"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:'flex',alignItems:'center',minHeight:'40px',overflowX:'auto',gap:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_select___default.a,{value:selectedMac,onChange:setSelectedMac,placeholder:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"lidarTester.select"}),size:"small",width:250},Object.values(viewModel.lidarDeviceInformation).map(function(device){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_select__["SelectOption"],{key:device.mac,value:device.mac,label:device.location+" ("+device.mac+")"});})),selectedMac&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_button___default.a,{onClick:onClickTriggerProvision,type:"tertiary",size:"small",style:{backgroundColor:provisioningTriggered&&clusterStatus===__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_194" /* SUCCESS_STRING */]?'var(--button-background-color-tertiary-pressed)':provisioningTriggered?'var(--button-background-color-tertiary-hover)':undefined,cursor:provisioningTriggered&&!clusterStatus?'not-allowed':'pointer'// Change cursor when in progress
},disabled:provisioningTriggered&&!clusterStatus// Disable button during provisioning
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,null,Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"button.startProvision"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{marginTop:'10px'}}),selectedMac&&device&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row___default.a,{style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:'flex',alignItems:'center',gap:'60px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{style:{fontWeight:'bold'}},"Connection Status:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:Object(__WEBPACK_IMPORTED_MODULE_12__util_LidarTesterUtil__["h" /* getConnectivityBadgeStyle */])(device.connectivity)},device.connectivity&&device.connectivity.toLowerCase()===__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_145" /* ONLINE_OK */]?'Connected':'Disconnected')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{style:{fontWeight:'bold'}},"Scanless Activation Status:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:Object(__WEBPACK_IMPORTED_MODULE_12__util_LidarTesterUtil__["n" /* getStatusBadgeStyle */])(device.status)},device.status&&device.status.toUpperCase()==='ACTIVE'?'Active':'Inactive')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{marginTop:'20px'}}),provisioningTriggered&&!clusterStatus&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__lidarTester_ProvisioningProgressIndicator__["a" /* default */],{nodeType:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["Y" /* BRANCH */],timeoutSeconds:__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_181" /* SKYLARK_BRANCH_PROVISION_DISPLAY_TIMEOUT_IN_SECONDS */]}),provisioningTriggered&&clusterStatus&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row___default.a,{style:{marginBottom:'20px'}},renderStatusDisplay(getBranchStatusDisplay(clusterStatus,detectedBranchNodeCount,expectedBranchNodeCount),clusterStatus)),provisioningTriggered&&clusterStatus===__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_194" /* SUCCESS_STRING */]&&leafProvisioningStatus&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_row___default.a,{style:{marginBottom:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:'100%'}},renderStatusDisplay(getLeafStatusDisplay(leafProvisioningStatus),leafProvisioningStatus))),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_alert___default.a,{type:"error"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'log.error'})),showPageRefreshAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_alert___default.a,{type:"error"},"Session expired. Please refresh the page to continue."),showConnectivityAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_alert___default.a,{type:"error",onClose:function onClose(){clearTimeout(connectivityAlertTimeout);setShowConnectivityAlert(false);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{dangerouslySetInnerHTML:{__html:"Cluster Controller is Disconnected. <a href=\""+__WEBPACK_IMPORTED_MODULE_9__util_Constants__["_208" /* TROUBLESHOOTING_URLS */].SKYLARK_PROVISIONING+"\" target=\"_blank\" rel=\"noopener noreferrer\">Troubleshooting Guide</a>"}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{marginTop:'10px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__lidarTester_LidarTesterGridView__["a" /* default */],{device:device,selectedMac:selectedMac,intl:intl,cartRecipesMap:viewModel.cartRecipesMap}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(LidarTesterTool));

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AisleLabel__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Bin__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProvisioningStatus__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BinColorLegend__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_LidarTesterUtil__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_LidarTesterContext__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_MQTTUtility__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__context_ProvisioningContext__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ColumnLabelRow__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var GRID_STYLE={display:"flex"};var LidarTesterGridView=function LidarTesterGridView(props){var device=props.device,selectedMac=props.selectedMac,intl=props.intl,cartRecipesMap=props.cartRecipesMap;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__context_LidarTesterContext__["a" /* LidarTesterContext */]),testerViewModel=_useContext.testerViewModel,testerDispatch=_useContext.testerDispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),error=_useState2[0],setError=_useState2[1];var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10__context_ProvisioningContext__["a" /* ProvisioningContext */]),provisioningViewModel=_useContext2.provisioningViewModel,provisioningDispatch=_useContext2.provisioningDispatch;var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),isSubscribing=_useState4[0],setIsSubscribing=_useState4[1];// Extract values from provisioningViewModel with default values
var provisioningTriggered=provisioningViewModel?provisioningViewModel.provisioningTriggered:false;var provisioningData=provisioningViewModel?provisioningViewModel.provisioningData:[];var clusterStatus=provisioningViewModel?provisioningViewModel.clusterStatus:null;// Memoize derived values to prevent unnecessary recalculations
var sortedAssetByAisle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function(){return device?Object(__WEBPACK_IMPORTED_MODULE_7__util_LidarTesterUtil__["m" /* getSortedAssetByAisle */])(device):null;},[device]);var exhaustiveLabelSet=__WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function(){return device?Object(__WEBPACK_IMPORTED_MODULE_7__util_LidarTesterUtil__["j" /* getExhaustiveLabelSet */])(device,cartRecipesMap):null;},[device,cartRecipesMap]);var isSensorLevelConfigEnabled=__WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function(){return device?Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_18" /* isSensorLevelConfigEnabledForLidarController */])(device):false;},[device]);// Load state map only when device changes or when component mounts
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(device&&testerDispatch){testerDispatch({type:"LOAD_STATE_MAP",data:{sortedAssetByAisle:sortedAssetByAisle,dispatcher:testerDispatch,macAddress:device.mac,columnsList:exhaustiveLabelSet,isSensorLevelConfigEnabled:isSensorLevelConfigEnabled,cartRecipesMap:cartRecipesMap}});}},[device,testerDispatch]);// Only depend on device and testerDispatch
/**
     * Checks if the message is a provisioning message
     * @param {Object} data - The parsed message data
     * @returns {boolean} - Whether it's a provisioning message
     */var isProvisioningMessage=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(data){return data&&typeof data.nodeType==='string'&&(data.nodeType===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["Y" /* BRANCH */]||data.nodeType===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_96" /* LEAF */]);},[]);/**
     * Checks if the message is a LidarTester message
     * @param {Object} data - The parsed message data
     * @returns {boolean} - Whether it's a LidarTester message
     */var isLidarTesterMessage=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(data){return data&&typeof data.aisleLabel==='string'&&typeof data.columnLabel==='string'&&data.address!==undefined&&data.sensorIndex!==undefined;},[]);/**
     * Handles provisioning messages
     * @param {Object} data - The parsed message data
     */var handleProvisioningMessage=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(data){// Always process provisioning messages to maintain separation of concerns
// The ProvisioningReducer will handle its own state management
provisioningDispatch({type:"UPDATE_PROVISIONING_DATA",data:{message:data}});},[provisioningDispatch]);/**
     * Handles LidarTester messages
     * @param {Object} data - The parsed message data
     */var handleLidarTesterMessage=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(data){// Always process LidarTester messages to maintain separation of concerns
// The LidarTesterReducer will handle its own state management
testerDispatch({type:"UPDATE_STATE_MAP",data:{dispatcher:testerDispatch,message:data}});},[testerDispatch]);/**
     * Handles message processing errors
     * @param {Error} error - The error that occurred
     * @param {Object} message - The raw message
     */var handleMessageError=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(error,message){console.error("Error processing MQTT message:",error);setError(true);},[setError]);// MQTT message handler
var onMessage=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(message){try{var messageStr=message.toString();var parsedData=JSON.parse(messageStr);// Determine message type and route to appropriate handler
if(isProvisioningMessage(parsedData)){handleProvisioningMessage(parsedData);}else if(isLidarTesterMessage(parsedData)){// Don't log every LidarTester message to reduce noise
handleLidarTesterMessage(parsedData);}else{console.log("Received unknown message format, ignoring",parsedData);}}catch(error){handleMessageError(error,message);}},[isProvisioningMessage,isLidarTesterMessage,handleProvisioningMessage,handleLidarTesterMessage,handleMessageError]);// MQTT props for the subscription
var mqttUtilityProps=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){if(!device||!device.ip)return null;return{topic:Object(__WEBPACK_IMPORTED_MODULE_7__util_LidarTesterUtil__["l" /* getMqttTopicForLidarTester */])(Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["X" /* getNodeId */])(),device.ip),config:Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["V" /* getMQTTClientConfig */])(),onMessage:onMessage,setError:setError,setIsSubscribing:setIsSubscribing,isSubscribing:isSubscribing};},[device,onMessage,setError,setIsSubscribing,isSubscribing]);/**
     * Generates props for Bin components with sensor states and merge information
     * 
     * @param {string} aisleLabel - Formatted aisle label (e.g., "A-1")
     * @param {string} label - Column label (e.g., "A", "TU", "JK")
     * @param {number} binIndex - Index in exhaustiveLabelSet for merge detection
     * @returns {Object} Props object for Bin component
     * 
     * @example
     * getBinColumnProps("A-1", "TU", 2)
     * Returns: { sensorStates: [...], isAnomaly: false, columnLabel: "TU", shouldMergeRight: false, shouldMergeLeft: false }
     */var getBinColumnProps=function getBinColumnProps(aisleLabel,label,binIndex){var isSensorLevelConfigEnabled=Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_18" /* isSensorLevelConfigEnabledForLidarController */])(device);// Determine merge directions based on adjacent columns
var _determineMergeDirect=Object(__WEBPACK_IMPORTED_MODULE_7__util_LidarTesterUtil__["e" /* determineMergeDirection */])({exhaustiveLabelSet:exhaustiveLabelSet,binIndex:binIndex,device:device,aisleLabel:aisleLabel}),shouldMergeRight=_determineMergeDirect.shouldMergeRight,shouldMergeLeft=_determineMergeDirect.shouldMergeLeft;// Calculate sensor states based on column type and merge state
var _calculateSensorState=Object(__WEBPACK_IMPORTED_MODULE_7__util_LidarTesterUtil__["c" /* calculateSensorStatesByType */])({testerViewModel:testerViewModel,aisleLabel:aisleLabel,label:label,isSensorLevelConfigEnabled:isSensorLevelConfigEnabled,shouldMergeRight:shouldMergeRight,shouldMergeLeft:shouldMergeLeft}),sensorStates=_calculateSensorState.sensorStates,isAnomaly=_calculateSensorState.isAnomaly;return{sensorStates:sensorStates,isAnomaly:isAnomaly,columnLabel:label,shouldMergeRight:shouldMergeRight,shouldMergeLeft:shouldMergeLeft,aisleLabel:aisleLabel,device:device};};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,selectedMac&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__util_MQTTUtility__["a" /* default */],mqttUtilityProps()),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert___default.a,{type:"error"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'log.error'})),exhaustiveLabelSet&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:GRID_STYLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ColumnLabelRow__["a" /* default */],{labelList:exhaustiveLabelSet}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:"200px",height:"25px",textAlign:"center",fontWeight:"bold",visibility:provisioningTriggered?'visible':'hidden',minWidth:"200px",// Ensure consistent width
backgroundColor:'transparent',borderRadius:'4px',display:'flex',alignItems:'center',justifyContent:'center',border:'none'}},"Provisioning")),sortedAssetByAisle&&sortedAssetByAisle.map(function(assetMapping,index){var branchIndex=Object(__WEBPACK_IMPORTED_MODULE_7__util_LidarTesterUtil__["g" /* getBranchIndexForAssetMapping */])(assetMapping);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:"aisle-row-"+assetMapping.aisleLabel+"-"+index,style:GRID_STYLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AisleLabel__["a" /* default */],{aisleLabel:assetMapping.aisleLabel}),exhaustiveLabelSet&&exhaustiveLabelSet.map(function(label,binIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Bin__["a" /* default */],Object.assign({key:"bin-"+assetMapping.aisleLabel+"-"+label+"-"+binIndex},getBinColumnProps(Object(__WEBPACK_IMPORTED_MODULE_7__util_LidarTesterUtil__["f" /* formatAisleLabel */])(assetMapping.aisleLabel),label,binIndex)));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProvisioningStatus__["a" /* default */],{isProvisioned:provisioningTriggered&&branchIndex!==null&&provisioningData.some(function(item){return item.nodeType===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_96" /* LEAF */]&&item.parentNodeIndex===branchIndex&&item.expectedNodeCount===item.detectedNodeCount;}),provisioningData:provisioningTriggered&&branchIndex!==null?provisioningData.find(function(item){return item.nodeType===__WEBPACK_IMPORTED_MODULE_6__util_Constants__["_96" /* LEAF */]&&item.parentNodeIndex===branchIndex;}):null,visible:provisioningTriggered,clusterStatus:clusterStatus,key:"prov-status-"+assetMapping.aisleLabel}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{marginTop:'30px'}}),selectedMac&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BinColorLegend__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{marginTop:'40px'}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(LidarTesterGridView));

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LidarSensor__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_LidarTesterUtil__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Validations__ = __webpack_require__(15);
/**
 * Generates styling for bin columns based on type and merge state
 * 
 * @param {string} columnLabel - Column label for type detection
 * @param {boolean} isAnomaly - Whether column is in anomaly state
 * @param {boolean} shouldMergeRight - Whether to merge with right column
 * @param {boolean} shouldMergeLeft - Whether to merge with left column
 * @param {string} aisleLabel - Aisle label for per-aisle detection
 * @param {Object} device - Device configuration for merge detection
 * @returns {Object} CSS style object
 */var getBinColumnStyle=function getBinColumnStyle(columnLabel,isAnomaly){var shouldMergeRight=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var shouldMergeLeft=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var aisleLabel=arguments[4];var device=arguments[5];// Determine background color based on column type and state
var backgroundColor=__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_100" /* LIDAR_COLUMN_COLORS */].REGULAR;// Default: white
// Check if this column uses flex cart recipe (for merged flex columns)
var isFlexCartType=device&&aisleLabel&&device.displayableAssetMappings&&device.displayableAssetMappings.find(function(mapping){return Object(__WEBPACK_IMPORTED_MODULE_3__util_LidarTesterUtil__["f" /* formatAisleLabel */])(mapping.aisleLabel)===aisleLabel;})&&device.displayableAssetMappings.find(function(mapping){return Object(__WEBPACK_IMPORTED_MODULE_3__util_LidarTesterUtil__["f" /* formatAisleLabel */])(mapping.aisleLabel)===aisleLabel;}).columns&&device.displayableAssetMappings.find(function(mapping){return Object(__WEBPACK_IMPORTED_MODULE_3__util_LidarTesterUtil__["f" /* formatAisleLabel */])(mapping.aisleLabel)===aisleLabel;}).columns.some(function(column){var label=Object(__WEBPACK_IMPORTED_MODULE_3__util_LidarTesterUtil__["i" /* getDisplayableColumnLabel */])(column.columnLabel,column.rowLabels,column.cartType);return label===columnLabel&&__WEBPACK_IMPORTED_MODULE_5__util_Validations__["s" /* WW_FLEX_CART_RECIPES */].includes(column.cartType);});if(isAnomaly){backgroundColor=__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_100" /* LIDAR_COLUMN_COLORS */].ANOMALY;// Black for errors
}else if(Object(__WEBPACK_IMPORTED_MODULE_3__util_LidarTesterUtil__["p" /* isFlexColumn */])(columnLabel)||isFlexCartType){backgroundColor=__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_100" /* LIDAR_COLUMN_COLORS */].FLEX;// Soft minty green for flex columns
}else if(Object(__WEBPACK_IMPORTED_MODULE_3__util_LidarTesterUtil__["o" /* isAisleMergedOV */])(columnLabel,aisleLabel,device)){backgroundColor=__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_100" /* LIDAR_COLUMN_COLORS */].UNIFIED_OV;// Light blue for dynamically merged OV
}return{width:Object(__WEBPACK_IMPORTED_MODULE_3__util_LidarTesterUtil__["s" /* shouldUseWideWidth */])(columnLabel)?__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_101" /* LIDAR_COLUMN_DIMENSIONS */].WIDE_WIDTH:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_101" /* LIDAR_COLUMN_DIMENSIONS */].NARROW_WIDTH,height:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_101" /* LIDAR_COLUMN_DIMENSIONS */].HEIGHT,display:"flex",borderTop:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_101" /* LIDAR_COLUMN_DIMENSIONS */].BORDER,borderBottom:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_101" /* LIDAR_COLUMN_DIMENSIONS */].BORDER,borderLeft:shouldMergeLeft?"none":__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_101" /* LIDAR_COLUMN_DIMENSIONS */].BORDER,borderRight:shouldMergeRight?"none":__WEBPACK_IMPORTED_MODULE_4__util_Constants__["_101" /* LIDAR_COLUMN_DIMENSIONS */].BORDER,justifyContent:"space-around",alignItems:"center",background:backgroundColor};};/**
 * Bin component represents a single column in the Lidar tester grid
 * Supports visual merging with adjacent columns for flex configurations
 */var Bin=function Bin(props){var isAnomaly=props.isAnomaly,sensorStates=props.sensorStates,columnLabel=props.columnLabel,shouldMergeRight=props.shouldMergeRight,shouldMergeLeft=props.shouldMergeLeft,aisleLabel=props.aisleLabel,device=props.device;var getSensorProps=function getSensorProps(index){return{sensorState:sensorStates[index]};};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:getBinColumnStyle(columnLabel,isAnomaly,shouldMergeRight,shouldMergeLeft,aisleLabel,device)},!isAnomaly&&sensorStates&&sensorStates.map(function(val,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LidarSensor__["a" /* default */],Object.assign({key:i},getSensorProps(i)));}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(Bin));

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var colorMap={1:"#e6e6e6",// grey
2:"green",3:"red"};var LIDAR_SENSOR_STYLE=function LIDAR_SENSOR_STYLE(state){return{background:colorMap[state],width:"21px",height:"21px",borderRadius:50,border:'1px solid black',textAlign:'center',lineHeight:'19px',color:'white'};};var LidarSensor=function LidarSensor(props){var sensorState=props.sensorState;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(1),_useState2=_slicedToArray(_useState,2),state=_useState2[0],setState=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),value=_useState4[0],setValue=_useState4[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){setSensorStateAndValue(sensorState.state,sensorState.value);var timeout=setTimeout(function(){setSensorStateAndValue(1,"");},__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_105" /* LIDAR_TESTER_EVENT_CLEAR_TIMER_MS */]);return function(){clearTimeout(timeout);};},[sensorState.time]);var setSensorStateAndValue=function setSensorStateAndValue(state,value){setState(state);setValue(value);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:LIDAR_SENSOR_STYLE(state)},value);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(LidarSensor));

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
var PROVISIONING_STATUS_STYLE=function PROVISIONING_STATUS_STYLE(status){var backgroundColor="#FFFFFF";// Default white
var textColor="#000000";// Default black text
if(status==="success"){backgroundColor=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_191" /* STATUS_COLORS */].SUCCESS.BACKGROUND;textColor=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_191" /* STATUS_COLORS */].SUCCESS.TEXT;}else if(status==="error"){backgroundColor=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_191" /* STATUS_COLORS */].ERROR.BACKGROUND;textColor=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_191" /* STATUS_COLORS */].ERROR.TEXT;}else if(status==="timeout"){backgroundColor=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_191" /* STATUS_COLORS */].WARNING.BACKGROUND;textColor=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_191" /* STATUS_COLORS */].WARNING.TEXT;}else if(status==="pending"){backgroundColor=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_191" /* STATUS_COLORS */].INFO.BACKGROUND;textColor=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_191" /* STATUS_COLORS */].INFO.TEXT;}else if(status==="not-started"){backgroundColor="#FFFFFF";// White
textColor="#000000";// black text
}return{width:"200px",height:"25px",textAlign:"center",backgroundColor:backgroundColor,border:"0.5px solid black",display:"flex",flexDirection:"column",// Stack content vertically
justifyContent:"center",alignItems:"center",color:textColor,minWidth:"200px",// Ensure consistent width
boxSizing:"border-box",// Include border in width calculation
position:"relative",// For tooltip positioning
cursor:"pointer",// Indicate it's interactive
fontSize:"11px",// Smaller font to fit more text
padding:"2px"};};var CONTAINER_STYLE={position:"relative",display:"inline-block","&:hover .tooltip":{visibility:"visible",opacity:1}/**
 * Component to display provisioning status for an aisle
 */};var ProvisioningStatus=function ProvisioningStatus(props){var isProvisioned=props.isProvisioned,provisioningData=props.provisioningData,clusterStatus=props.clusterStatus,_props$visible=props.visible,visible=_props$visible===undefined?true:_props$visible;// If provisioning is not visible, show an empty cell with the same dimensions
if(!visible){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:Object.assign({},PROVISIONING_STATUS_STYLE("none"),{visibility:'hidden'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"\xA0"));}// If we don't have any provisioning data yet, show a pending cell
if(clusterStatus==='success'){if(!provisioningData){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:PROVISIONING_STATUS_STYLE("pending")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:'12px',marginTop:'2px'}},"In Progress..."));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:PROVISIONING_STATUS_STYLE("not-started")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:'12px',marginTop:'2px'}},"Not Started"));}// If we have data, determine the status
var status=void 0;var statusText=void 0;if(isProvisioned){status="success";statusText="Success";}else{status="error";statusText=__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_75" /* EXPECTED */]+": "+provisioningData.expectedNodeCount+", "+__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_20" /* DETECTED */]+": "+provisioningData.detectedNodeCount;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:CONTAINER_STYLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:PROVISIONING_STATUS_STYLE(status)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontSize:'13px',marginTop:'1px',fontWeight:'bold'}},statusText)));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ProvisioningStatus));

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Constants__ = __webpack_require__(2);
var LEGEND_ITEM_STYLE={display:"flex",alignItems:"center",marginRight:"15px"};var COLOR_BOX_STYLE=function COLOR_BOX_STYLE(color){return{width:"20px",height:"20px",backgroundColor:color,border:"1px solid black",marginRight:"5px"};};var LEGEND_CONTAINER_STYLE={display:"flex",marginBottom:"10px",fontSize:"12px"};var BinColorLegend=function BinColorLegend(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:LEGEND_CONTAINER_STYLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:LEGEND_ITEM_STYLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:COLOR_BOX_STYLE(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_100" /* LIDAR_COLUMN_COLORS */].REGULAR)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Regular Bag/Two-Tier OV")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:LEGEND_ITEM_STYLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:COLOR_BOX_STYLE(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_100" /* LIDAR_COLUMN_COLORS */].FLEX)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Flex")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:LEGEND_ITEM_STYLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:COLOR_BOX_STYLE(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_100" /* LIDAR_COLUMN_COLORS */].UNIFIED_OV)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"One-Tier OV")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:LEGEND_ITEM_STYLE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:COLOR_BOX_STYLE(__WEBPACK_IMPORTED_MODULE_1__util_Constants__["_100" /* LIDAR_COLUMN_COLORS */].ANOMALY)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"No Column")));};/* harmony default export */ __webpack_exports__["a"] = (BinColorLegend);

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AisleLabel__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ColumnLabel__ = __webpack_require__(1398);
var ColumnLabelRow=function ColumnLabelRow(props){var labelList=props.labelList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AisleLabel__["a" /* default */],null),labelList.map(function(label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ColumnLabel__["a" /* default */],{label:label});}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ColumnLabelRow));

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_LidarTesterUtil__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Constants__ = __webpack_require__(2);
var COLUMN_LABEL_STYLE=function COLUMN_LABEL_STYLE(label){return{width:label&&label.length>1||Object(__WEBPACK_IMPORTED_MODULE_2__util_LidarTesterUtil__["q" /* isUnifiedOVColumn */])(label)?__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_101" /* LIDAR_COLUMN_DIMENSIONS */].WIDE_WIDTH:__WEBPACK_IMPORTED_MODULE_3__util_Constants__["_101" /* LIDAR_COLUMN_DIMENSIONS */].NARROW_WIDTH,textAlign:"center"};};var ColumnLabel=function ColumnLabel(props){var label=props.label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:COLUMN_LABEL_STYLE(label)},label);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ColumnLabel));

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/**
 * Component to show provisioning progress with a countdown timer
 * @param {Object} props - Component props
 * @param {number} props.timeoutSeconds - Number of seconds before timeout
 */var ProvisioningProgressIndicator=function ProvisioningProgressIndicator(_ref){var nodeType=_ref.nodeType,_ref$timeoutSeconds=_ref.timeoutSeconds,timeoutSeconds=_ref$timeoutSeconds===undefined?30:_ref$timeoutSeconds,_ref$clusterStatus=_ref.clusterStatus,clusterStatus=_ref$clusterStatus===undefined?undefined:_ref$clusterStatus;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(timeoutSeconds),_useState2=_slicedToArray(_useState,2),secondsLeft=_useState2[0],setSecondsLeft=_useState2[1];// Countdown timer effect
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){// Reset timer when component mounts
setSecondsLeft(timeoutSeconds);// Set up interval to decrement timer
var intervalId=setInterval(function(){setSecondsLeft(function(prevSeconds){if(prevSeconds<=1){clearInterval(intervalId);return 0;}return prevSeconds-1;});},1000);// Clean up interval on unmount
return function(){return clearInterval(intervalId);};},[timeoutSeconds]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_row___default.a,{style:{marginBottom:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:'100%',padding:'8px',backgroundColor:'#00A8E1',// Blue for in-progress
color:'#FFFFFF',borderRadius:'4px',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center',position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{position:'absolute',bottom:0,left:0,height:'3px',backgroundColor:'#B6E3FF',width:secondsLeft/timeoutSeconds*100+"%",transition:'width 1s linear'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:'16px',height:'16px',border:'3px solid rgba(255,255,255,0.3)',borderRadius:'50%',borderTopColor:'#FFFFFF',animation:'spin 1s linear infinite',marginRight:'10px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style",null,"\n                    @keyframes spin {\n                        to { transform: rotate(360deg); }\n                    }\n                "),!clusterStatus&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_text___default.a,{color:"inverse"},nodeType," Provisioning in Progress - Waiting for Response... (",secondsLeft,"s remaining)")));};/* harmony default export */ __webpack_exports__["a"] = (ProvisioningProgressIndicator);

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_AutoLoaderDeviceOverviewContext__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var AutoLoaderDevicePage=function(_Component){_inherits(AutoLoaderDevicePage,_Component);function AutoLoaderDevicePage(){_classCallCheck(this,AutoLoaderDevicePage);return _possibleConstructorReturn(this,(AutoLoaderDevicePage.__proto__||Object.getPrototypeOf(AutoLoaderDevicePage)).apply(this,arguments));}_createClass(AutoLoaderDevicePage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__context_AutoLoaderDeviceOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["k" /* AUTO_LOADER */],location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_TabLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["k" /* AUTO_LOADER */]})));}}]);return AutoLoaderDevicePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AutoLoaderDevicePage);

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoLoaderDeviceOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__network_AutoLoaderDeviceNetworkAPI__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
var AutoLoaderDeviceOverviewReducer=function AutoLoaderDeviceOverviewReducer(state,action){switch(action.type){case"LOAD_VIEW":Object(__WEBPACK_IMPORTED_MODULE_0__network_AutoLoaderDeviceNetworkAPI__["b" /* fetchAutoLoaderDeviceDetails */])(action.data.dispatcher);return state;case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingOverview:false,timestamp:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_14" /* getTimestampNow */])()});case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});case"ADD_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AutoLoaderDeviceNetworkAPI__["c" /* setAutoLoaderDeviceDetails */])(action.data.dispatcher,action.data.stateValues,action.data.showCustomAlert);return state;case"UPDATE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AutoLoaderDeviceNetworkAPI__["e" /* updateAutoLoaderDeviceDetails */])(action.data.dispatcher,action.data.stateValues,action.data.showCustomAlert);return state;case"UPDATE_DEVICE_MAC":Object(__WEBPACK_IMPORTED_MODULE_0__network_AutoLoaderDeviceNetworkAPI__["f" /* updateAutoLoaderDeviceMac */])(action.data.dispatcher,action.data.stateValues,action.data.mac,action.data.showCustomAlert);return state;case"UPDATE_MONITORING_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AutoLoaderDeviceNetworkAPI__["g" /* updateAutoLoaderMonitoringDetails */])(action.data.dispatcher,action.data.stateValues,action.data.mac);return state;case"DELETE_DEVICE_DATA":Object(__WEBPACK_IMPORTED_MODULE_0__network_AutoLoaderDeviceNetworkAPI__["a" /* deleteAutoLoaderDeviceDetails */])(action.data.dispatcher,action.data.mac);return state;case"UPDATE_AUTOLOADER_CONFIGURATION":Object(__WEBPACK_IMPORTED_MODULE_0__network_AutoLoaderDeviceNetworkAPI__["d" /* updateAutoLoaderConfiguration */])(action.data.dispatcher,action.data.configurations,action.data.mac,action.data.showCustomAlert);return state;default:return state;}};

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAutoLoaderDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["c"] = setAutoLoaderDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateAutoLoaderDeviceDetails;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteAutoLoaderDeviceDetails;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateAutoLoaderConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateAutoLoaderDeviceMac; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateAutoLoaderMonitoringDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datamodel_AutoLoaderAssetModelResource__ = __webpack_require__(1403);
var addAutoLoaderDeviceDetails=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatcher,request,showCustomAlert){var _this=this;var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:startTime=Date.now();_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_29" /* setAliasToRequest */])(request);case 3:Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["a" /* addAsset */])(request).then(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(result){var isFault,getAssetResult,responseSetAssetStatus,responseUpdateAsset,isFaultInUpdateAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(result.status===200)){_context3.next=4;break;}Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAutoLoaderDeviceDetails",true,false);_context3.next=28;break;case 4:// 500 response status can be for any reason. One of those is : asset already exists so trying to update it.
// UpdateAsset only works on ACTIVE devices so first setting status as ACTIVE.
isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(result.status);_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 7:getAssetResult=_context3.sent;if(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(getAssetResult.data.asset.assetDetails.assetStatus)){_context3.next=12;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["B" /* ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAutoLoaderDeviceDetails",false,isFault);return _context3.abrupt("return");case 12:_context3.next=14;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);case 14:responseSetAssetStatus=_context3.sent;if(!(responseSetAssetStatus.status!==200)){_context3.next=19;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAutoLoaderDeviceDetails",false,isFault);return _context3.abrupt("return");case 19:_context3.next=21;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 21:responseUpdateAsset=_context3.sent;if(!(responseUpdateAsset.status!==200)){_context3.next=27;break;}isFaultInUpdateAsset=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(responseUpdateAsset.status);showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAutoLoaderDeviceDetails",false,isFaultInUpdateAsset);return _context3.abrupt("return");case 27:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAutoLoaderDeviceDetails",true,false);case 28:fetchAutoLoaderDeviceDetails(dispatcher);case 29:case"end":return _context3.stop();}}},_callee3,_this);}));return function(_x12){return _ref4.apply(this,arguments);};}());case 4:case"end":return _context4.stop();}}},_callee4,this);}));return function addAutoLoaderDeviceDetails(_x9,_x10,_x11){return _ref3.apply(this,arguments);};}();var updateAutoLoaderAsset=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatcher,request,showCustomAlert){var setAssetStatusResponse,startTime,getAssetResult,updateAssetResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetDetails.assetLabel,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);case 2:setAssetStatusResponse=_context5.sent;if(!(setAssetStatusResponse.status!==200)){_context5.next=7;break;}showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["n" /* ALERT_ASSET_STATUS_MESSAGE */]);fetchAutoLoaderDeviceDetails(dispatcher);return _context5.abrupt("return");case 7:// Update asset details
startTime=Date.now();_context5.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_29" /* setAliasToRequest */])(request);case 10:_context5.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 12:getAssetResult=_context5.sent;_context5.next=15;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(request,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 15:updateAssetResponse=_context5.sent;isSuccess=updateAssetResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateAssetResponse.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAutoLoaderDeviceDetails",isSuccess,isFault);fetchAutoLoaderDeviceDetails(dispatcher);case 20:case"end":return _context5.stop();}}},_callee5,this);}));return function updateAutoLoaderAsset(_x13,_x14,_x15){return _ref5.apply(this,arguments);};}();var getAutoLoaderDeviceDetails=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatcher,request){var model;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:model={autoLoaderDeviceInformation:{},macAddressArray:[]// Fetch static asset details
};_context6.next=3;return getAutoLoaderDeviceStaticDetails(dispatcher,model,request);case 3:case"end":return _context6.stop();}}},_callee6,this);}));return function getAutoLoaderDeviceDetails(_x16,_x17){return _ref6.apply(this,arguments);};}();var getAutoLoaderDeviceStaticDetails=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatcher,model,request){var pageToken,startTime,getAssetsResult,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:pageToken=null;// do-while loop until we get a valid pageToken
case 1:startTime=Date.now();_context7.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["g" /* getAssets */])(request.nodeId,request.assetType,pageToken);case 4:getAssetsResult=_context7.sent;isSuccess=getAssetsResult.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(getAssetsResult.status);// Log operation
Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"getAutoLoaderDeviceDetails",isSuccess,isFault);if(isSuccess){addAutoLoaderDeviceStaticDetailsToModel(getAssetsResult,model);// modifying pageToken to fetch from the latest get assets' result
pageToken=getAssetsResult.data.pageToken;}else{dispatcher({type:"RECEIVE_DATA",data:[]});}case 9:if(pageToken){_context7.next=1;break;}case 10:dispatcher({type:"RECEIVE_DATA",data:model});case 11:case"end":return _context7.stop();}}},_callee7,this);}));return function getAutoLoaderDeviceStaticDetails(_x18,_x19,_x20){return _ref7.apply(this,arguments);};}();var setAssetLabelDeprecatedAutoLoaderDeviceDetails=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatcher,request){var startTime;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:startTime=Date.now();Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["j" /* setAssetStatus */])(request.assetLabel,request.assetStatus).then(function(result){if(result.status===200){Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteAutoLoaderDeviceDetails",true,false);fetchAutoLoaderDeviceDetails(dispatcher);}else{var isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(result.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"deleteAutoLoaderDeviceDetails",false,isFault);dispatcher({type:"RECEIVE_DATA",data:[]});}});case 2:case"end":return _context8.stop();}}},_callee8,this);}));return function setAssetLabelDeprecatedAutoLoaderDeviceDetails(_x21,_x22){return _ref8.apply(this,arguments);};}();var updateAutoLoaderMonitoringSchedule=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatcher,request){var startTime,getAssetResult,updateAssetInPlaceResponse,isSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:// Update asset details
startTime=Date.now();_context10.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(request.assetDetails.assetLabel);case 3:getAssetResult=_context10.sent;_context10.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["l" /* updateAssetInPlace */])(request,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.lastUpdateTime;},null));case 6:updateAssetInPlaceResponse=_context10.sent;isSuccess=updateAssetInPlaceResponse.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateAssetInPlaceResponse.status);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAutoLoaderDeviceDetails",isSuccess,isFault);fetchAutoLoaderDeviceDetails(dispatcher);case 11:case"end":return _context10.stop();}}},_callee10,this);}));return function updateAutoLoaderMonitoringSchedule(_x26,_x27){return _ref10.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var metricProcessName="AUTOLOADER_DEVICE_DETAILS";function fetchAutoLoaderDeviceDetails(dispatcher){var request={nodeId:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["X" /* getNodeId */])(),assetType:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["R" /* AUTO_LOADER_ASSET_TYPE */]};getAutoLoaderDeviceDetails(dispatcher,request);}function setAutoLoaderDeviceDetails(dispatcher,stateValues,showCustomAlert){stateValues.mac=stateValues.mac.toLowerCase();var request=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["R" /* AUTO_LOADER_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);addAutoLoaderDeviceDetails(dispatcher,request,showCustomAlert);}function updateAutoLoaderDeviceDetails(dispatcher,stateValues,showCustomAlert){var request=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["o" /* convertTableJsonToAsset */])(stateValues,__WEBPACK_IMPORTED_MODULE_2__util_Constants__["R" /* AUTO_LOADER_ASSET_TYPE */],__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]);updateAutoLoaderAsset(dispatcher,request,showCustomAlert);}function deleteAutoLoaderDeviceDetails(dispatcher,mac){var request={assetLabel:{type:"MAC_ADDRESS",value:mac},assetStatus:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_19" /* DEPRECATED */]};setAssetLabelDeprecatedAutoLoaderDeviceDetails(dispatcher,request);}var updateAutoLoaderConfiguration=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatcher,configurations,mac,showCustomAlert){var getAssetResult,startTime,alias,updatedAsset,updateResult,isUpdateSuccess,isFault;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 2:getAssetResult=_context.sent;// Merge current configuration into existing configuration and update
startTime=Date.now();_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["B" /* getAliasFromParent */])();case 6:alias=_context.sent;updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_4__datamodel_AutoLoaderAssetModelResource__["a" /* updateConfigurationsInAutoLoaderAssetObject */])(getAssetResult.data.asset,configurations,alias);_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["k" /* updateAsset */])(updatedAsset,Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return getAssetResult.data.asset.assetDetails.creationTime;},null));case 10:updateResult=_context.sent;isUpdateSuccess=updateResult.status===200;isFault=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_17" /* isResponseCode5xx */])(updateResult.status);fetchAutoLoaderDeviceDetails(dispatcher);// Log operation
isUpdateSuccess?showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["D" /* ALERT_UPDATE_SUCCESS_ASSET_MESSAGE */]):showCustomAlert(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["A" /* ALERT_UPDATE_ASSET_MESSAGE */]);Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"updateAutoLoaderConfiguration",isUpdateSuccess,isFault);case 16:case"end":return _context.stop();}}},_callee,this);}));return function updateAutoLoaderConfiguration(_x,_x2,_x3,_x4){return _ref.apply(this,arguments);};}();var updateAutoLoaderDeviceMac=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatcher,stateValues,mac,showCustomAlert){var startTime,assetLabel,assetResult,nodeId,assetStatus;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:startTime=Date.now();assetLabel=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(stateValues.mac.toLowerCase());_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(assetLabel);case 4:assetResult=_context2.sent;nodeId=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.nodeId;},null);assetStatus=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return assetResult.data.asset.assetDetails.assetStatus;},null);if(assetStatus&&!Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["h" /* checkInactiveOrDeprecatedAsset */])(assetStatus)){showCustomAlert(Object(__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_225" /* getUpdateAssetMessageAlertWithSite */])(nodeId));Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["_21" /* logOperationalMetric */])(startTime,metricProcessName,"addAutoLoaderDeviceDetails",false,false);}else{deleteAutoLoaderDeviceDetails(dispatcher,mac);setAutoLoaderDeviceDetails(dispatcher,stateValues,showCustomAlert);}case 8:case"end":return _context2.stop();}}},_callee2,this);}));return function updateAutoLoaderDeviceMac(_x5,_x6,_x7,_x8){return _ref2.apply(this,arguments);};}();var addAutoLoaderDeviceStaticDetailsToModel=function addAutoLoaderDeviceStaticDetailsToModel(result,model){if("data"in result&&"assetDetailsList"in result.data){result.data.assetDetailsList.forEach(function(deviceDetail){if(deviceDetail.assetStatus===__WEBPACK_IMPORTED_MODULE_2__util_Constants__["b" /* ACTIVE */]){model.macAddressArray.push(deviceDetail.assetAttributes.mac);var mac=deviceDetail.assetAttributes.mac;var id=JSON.parse(deviceDetail.assetAttributes.deviceConfig).id;model.autoLoaderDeviceInformation[mac]={name:deviceDetail.assetAttributes.name,mac:deviceDetail.assetAttributes.mac,ip:deviceDetail.assetAttributes.ip,id:id,port:deviceDetail.assetAttributes.port,vendorAttributes:deviceDetail.vendorAttributes||__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */],assetStatus:__WEBPACK_IMPORTED_MODULE_2__util_Constants__["_110" /* LOADING_STRING */],deviceType:deviceDetail.assetAttributes.deviceType,assetType:deviceDetail.assetType,startTime:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.monitoring).startTime;},"0"),endTime:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.monitoring).endTime;},"0"),reason:Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(deviceDetail.assetAttributes.monitoring).reason;},"")};}});}return model;};var updateAutoLoaderMonitoringDetails=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatcher,stateValues,mac){var getAssetResult,updatedAsset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__resources_AssetResource__["d" /* getAssetByAssetLabel */])(Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["C" /* getAssetLabelFromMac */])(mac));case 2:getAssetResult=_context9.sent;updatedAsset=updateExistingAssetAttributes(getAssetResult.data.asset,stateValues);updateAutoLoaderMonitoringSchedule(dispatcher,updatedAsset);case 5:case"end":return _context9.stop();}}},_callee9,this);}));return function updateAutoLoaderMonitoringDetails(_x23,_x24,_x25){return _ref9.apply(this,arguments);};}();var updateExistingAssetAttributes=function updateExistingAssetAttributes(asset,stateValues){var updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["t" /* deepCopyObject */])(asset);updatedAsset.assetDetails.assetAttributes.monitoring=Object(__WEBPACK_IMPORTED_MODULE_1__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(stateValues);},asset.assetDetails.assetAttributes.monitoring);return updatedAsset;};

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateConfigurationsInAutoLoaderAssetObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Util__ = __webpack_require__(5);
var updateConfigurationsInAutoLoaderAssetObject=function updateConfigurationsInAutoLoaderAssetObject(asset,configurations,alias){var updatedAsset=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["t" /* deepCopyObject */])(asset);updatedAsset.assetDetails.alias=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return alias.toString();},"");updatedAsset.assetDetails.assetAttributes.autoLoaderConfig=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(configurations.autoLoaderConfig);},"[]");updatedAsset.assetDetails.assetAttributes.autoLoaderTestPackage=Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["f" /* chainWalk */])(function(){return JSON.stringify(configurations.autoLoaderTestPackage);},"[]");return updatedAsset;};

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_AutoLoaderDeviceOverviewContext__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modal_AddAutoLoaderSingleDeviceModal__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commonui_DeleteSingleDeviceModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__commonui_EditMacAddressModal__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__commonui_DisableMonitoringModal__ = __webpack_require__(78);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AutoLoaderDeviceOverview=function AutoLoaderDeviceOverview(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__context_AutoLoaderDeviceOverviewContext__["a" /* AutoLoaderDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),selected=_useState2[0],setSelected=_useState2[1];var actionButtonRefs=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),_useState4=_slicedToArray(_useState3,2),openActionsMenu=_useState4[0],setOpenActionsMenu=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),mac=_useState6[0],setMac=_useState6[1];// Handle modal state (open/hidden)
var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),openAddModal=_useState8[0],setOpenAddModal=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),openDeleteModal=_useState10[0],setOpenDeleteModal=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),openEditMacModal=_useState12[0],setOpenEditMacModal=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),openDisableMonitoringModal=_useState14[0],setOpenDisableMonitoringModal=_useState14[1];var onClickActionsButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=true;setOpenActionsMenu(_open);},[]);var onCloseActions=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(index){var _open=Object.assign({},openActionsMenu);_open[index]=false;setOpenActionsMenu(_open);},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!openAddModal){// fetch overview data in regular intervals if the add device modal is not open
getData();var assetInterval=setInterval(function(){if(!document.hidden){getData();// get asset data
}},Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["D" /* getAssetRefreshInterval */])());var statusInterval=setInterval(function(){if(!document.hidden){getStatusData();// get status update
}},Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_11" /* getStatusRefreshInterval */])());return function(){clearInterval(assetInterval);clearInterval(statusInterval);};}},[openAddModal]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){actionButtonRefs.current=actionButtonRefs.current.slice(0,viewModel.autoLoaderDeviceInformation.length);},[viewModel.autoLoaderDeviceInformation]);var getData=function getData(){setOpenAddModal(false);setOpenDeleteModal(false);setOpenEditMacModal(false);setOpenDisableMonitoringModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var getStatusData=function getStatusData(){dispatch({type:'LOAD_STATUS',data:{dispatcher:dispatch,state:viewModel}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var onSort=function onSort(sortDetails){dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};var onClickAddEditConfig=function onClickAddEditConfig(){setSelected("");setOpenAddModal(true);};var onClickEditDevice=function onClickEditDevice(mac){setSelected(mac);setOpenAddModal(true);};var onClickRemove=function onClickRemove(mac){setSelected(mac);setOpenDeleteModal(true);};var onClickChangeMac=function onClickChangeMac(mac){setSelected(mac);setOpenEditMacModal(true);};var onClickDisableMonitoring=function onClickDisableMonitoring(mac){setMac(mac);setOpenDisableMonitoringModal(true);};var onClickEnableMonitoring=function onClickEnableMonitoring(startTime,reason,mac){var stateValues={"startTime":startTime,"endTime":Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["I" /* getCurrentDate */])().toString(),"reason":reason};updateData(stateValues,mac);getData();};var updateData=function updateData(stateValues,mac){dispatch({type:'UPDATE_MONITORING_DATA',data:{dispatcher:dispatch,stateValues:stateValues,mac:mac}});};var getAutoLoaderStateValues=function getAutoLoaderStateValues(mac){if(!mac)return{};var device=viewModel.autoLoaderDeviceInformation[mac];if(!device)return{};var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};return{name:device.name,mac:mac,ip:device.ip,port:device.port,deviceType:device.deviceType,deviceConfig:JSON.stringify({type:__WEBPACK_IMPORTED_MODULE_2__util_Util__["e" /* assetTypeToConfigTypeDict */].typeAUTO_LOADER,id:device.id}),vendorAttributes:device.vendorAttributes,monitoring:JSON.stringify(deviceMonitoring)};};var renderDeviceMonitoring=function renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{style:{color:monitoringStatusColor}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:monitoringStatusId}));};var sortedDeviceList=Object.values(viewModel.autoLoaderDeviceInformation);sortedDeviceList&&sortedDeviceList.sort(function(a,b){var _viewModel$sortPref=viewModel.sortPref,column=_viewModel$sortPref.column,direction=_viewModel$sortPref.direction;var compareValue=void 0;if(Object.keys(__WEBPACK_IMPORTED_MODULE_18__util_Constants__["_15" /* DEFAULT_VENDOR_ATTRIBUTES */]).includes(column)){if(column==="vendor"){compareValue=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column]+a.vendorAttributes["spec_version"],b.vendorAttributes[column]+b.vendorAttributes["spec_version"]);}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_32" /* sortComparator */])(a.vendorAttributes[column],b.vendorAttributes[column]);}}else{compareValue=Object(__WEBPACK_IMPORTED_MODULE_2__util_Util__["_32" /* sortComparator */])(a[column],b[column]);}if(direction===__WEBPACK_IMPORTED_MODULE_18__util_Constants__["J" /* ASCENDING */]){return compareValue;}else{return-compareValue;}});if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.scrolltobottom"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_alert___default.a,{type:"informational",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.device"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],{sortColumn:"name"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],{sortColumn:"vendor"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'device.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.mac_ip"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:'tooltip.connectionstatus'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],{sortColumn:"connection"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.connection"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.monitoring"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.action"}))),sortedDeviceList.map(function(device,index){var vendorAttributes=device.vendorAttributes;var monitoring=Object(__WEBPACK_IMPORTED_MODULE_17__util_Validations__["u" /* checkDeviceMonitoringEnabled */])(Number(device.startTime),Number(device.endTime));var _getMonitoringStatusD=Object(__WEBPACK_IMPORTED_MODULE_17__util_Validations__["F" /* getMonitoringStatusDetails */])(monitoring),monitoringStatusColor=_getMonitoringStatusD.monitoringStatusColor,monitoringStatusId=_getMonitoringStatusD.monitoringStatusId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableRow"],{key:index,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),device.deviceType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,__WEBPACK_IMPORTED_MODULE_17__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][vendorAttributes.vendor]),__WEBPACK_IMPORTED_MODULE_17__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][vendorAttributes.spec_version])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.mac),device.ip,":",device.port)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,device.assetStatus?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{color:device.assetStatus.toUpperCase()===__WEBPACK_IMPORTED_MODULE_18__util_Constants__["b" /* ACTIVE */]?__WEBPACK_IMPORTED_MODULE_18__util_Constants__["X" /* BLUE_COLOR */]:__WEBPACK_IMPORTED_MODULE_18__util_Constants__["_149" /* ORANGE_COLOR */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.assetStatus)):Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"loading.text"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,renderDeviceMonitoring(monitoringStatusColor,monitoringStatusId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_text___default.a,{type:"b300"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{ref:function ref(el){return actionButtonRefs.current[index]=el;},type:"icon",size:"medium",onClick:function onClick(){return onClickActionsButton(index);},"aria-controls":"my-menu","aria-haspopup":"menu","aria-expanded":"false"},__WEBPACK_IMPORTED_MODULE_18__util_Constants__["a" /* ACTIONS_STRING */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu___default.a,{anchorNode:actionButtonRefs.current[index],open:openActionsMenu[index]?openActionsMenu[index]:false,position:"left",onClose:function onClose(){return onCloseActions(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEditDevice(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.addDevice"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickRemove(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.deleteDevice"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickChangeMac(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.changeMac"})),monitoring.isMonitoringEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickDisableMonitoring(device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.monitoring_disable"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_menu__["MenuItem"],{onClick:function onClick(){return onClickEnableMonitoring(device.startTime,device.reason,device.mac);}},Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"actions.monitoring_enable"}))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{onClick:onClickAddEditConfig,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_tokens_base_icon_plus_circle___default.a}),Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.add_device_button_modal"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{onClick:function onClick(){return onClickRemove("");},type:"tertiary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_16__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"button.delete"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__modal_AddAutoLoaderSingleDeviceModal__["a" /* default */],{open:openAddModal,setOpen:setOpenAddModal,selected:selected,setSelected:setSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__commonui_DeleteSingleDeviceModal__["a" /* default */],{open:openDeleteModal,setOpen:setOpenDeleteModal,selected:selected,setSelected:setSelected,macAddressArray:viewModel.macAddressArray,dispatch:dispatch}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__commonui_EditMacAddressModal__["a" /* default */],{open:openEditMacModal,setOpen:setOpenEditMacModal,selectedMac:selected,setSelectedMac:setSelected,dispatch:dispatch,stateValues:getAutoLoaderStateValues(selected)}),openDisableMonitoringModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__commonui_DisableMonitoringModal__["a" /* default */],{mac:mac,state:openDisableMonitoringModal,onStateChange:setOpenDisableMonitoringModal,context:__WEBPACK_IMPORTED_MODULE_1__context_AutoLoaderDeviceOverviewContext__["a" /* AutoLoaderDeviceOverviewContext */],reducer:'UPDATE_MONITORING_DATA'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_intl__["d" /* injectIntl */])(AutoLoaderDeviceOverview));

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AutoLoaderDeviceOverviewContext__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddAutoLoaderSingleDeviceModal=function AddAutoLoaderSingleDeviceModal(props){var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_AutoLoaderDeviceOverviewContext__["a" /* AutoLoaderDeviceOverviewContext */]),viewModel=_useContext2.viewModel,dispatch=_useContext2.dispatch;// Visual controls
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),name=_useState4[0],setName=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),mac=_useState6[0],setMac=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),ip=_useState8[0],setIp=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),port=_useState10[0],setPort=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),deviceType=_useState12[0],setDeviceType=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),id=_useState14[0],setId=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),vendor=_useState16[0],setVendor=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),specVersion=_useState18[0],setSpecVersion=_useState18[1];// Error
var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState20=_slicedToArray(_useState19,2),nameErr=_useState20[0],setNameErr=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),macErr=_useState22[0],setMacErr=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),ipErr=_useState24[0],setIpErr=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),portErr=_useState26[0],setPortErr=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),deviceTypeErr=_useState28[0],setDeviceTypeErr=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState30=_slicedToArray(_useState29,2),idErr=_useState30[0],setIdErr=_useState30[1];var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState32=_slicedToArray(_useState31,2),vendorErr=_useState32[0],setVendorErr=_useState32[1];var _useState33=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState34=_slicedToArray(_useState33,2),specVersionErr=_useState34[0],setSpecVersionErr=_useState34[1];var initialMonitoringValue={startTime:"0",endTime:"0",reason:""};var _useState35=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(JSON.stringify(initialMonitoringValue)),_useState36=_slicedToArray(_useState35,2),monitoring=_useState36[0],setMonitoring=_useState36[1];var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext3.showCustomAlert;var stateValues={name:name,mac:mac,ip:ip,port:port,deviceType:deviceType,deviceConfig:{type:__WEBPACK_IMPORTED_MODULE_3__util_Util__["e" /* assetTypeToConfigTypeDict */].typeAUTO_LOADER,id:id},vendorAttributes:{vendor:vendor,spec_version:specVersion},monitoring:monitoring};var onClickConfirm=function onClickConfirm(stateValues){if(Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["V" /* validateNewAutoLoaderDevice */])(stateValues)){showWarning(Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"device.editWarning"}),function(){setShowAlert(false);stateValues.deviceConfig=JSON.stringify(stateValues.deviceConfig);if(selected){updateData(stateValues);}else{addData(stateValues);}resetInputState();setOpen(false);});}else{setShowAlert(true);}};var addData=function addData(stateValues){dispatch({type:'ADD_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues,showCustomAlert:showCustomAlert}});};var updateData=function updateData(stateValues){dispatch({type:'UPDATE_DEVICE_DATA',data:{dispatcher:dispatch,stateValues:stateValues,showCustomAlert:showCustomAlert}});};var onCloseModal=function onCloseModal(){setOpen(false);setSelected("");resetInputState();setShowAlert(false);};function resetInputState(){// setting state of input fields as empty to have empty inputs on clicking Add Device again
setMac("");setMacErr(false);setMonitoring(JSON.stringify(initialMonitoringValue));resetAssetDetails();resetAssetDetailErrors();}var resetAssetDetails=function resetAssetDetails(){setName("");setIp("");setPort("");setDeviceType("");setId("");setVendor("");setSpecVersion("");};var resetAssetDetailErrors=function resetAssetDetailErrors(){setNameErr(false);setIpErr(false);setPortErr(false);setDeviceTypeErr(false);setIdErr(false);setVendorErr(false);setSpecVersionErr(false);};var prefill=function prefill(value){if(viewModel.autoLoaderDeviceInformation.hasOwnProperty(value)){setSelected(value);var device=viewModel.autoLoaderDeviceInformation[value];var vendorAttributes=device.vendorAttributes;resetAssetDetailErrors();setName(device.name);setMac(device.mac);setIp(device.ip);setPort(device.port);setDeviceType(device.deviceType);setId(device.id);setVendor(vendorAttributes.vendor);setSpecVersion(vendorAttributes.spec_version);var deviceMonitoring={startTime:device.startTime,endTime:device.endTime,reason:device.reason};setMonitoring(JSON.stringify(deviceMonitoring));}else if(selected){setSelected("");resetAssetDetails();}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal___default.a,{title:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"device.add_device_button_modal"}),open:open,onOpen:function onOpen(){return prefill(selected);},onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"mac-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.mac"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"mac-input",value:mac,onChange:setMac,mask:__WEBPACK_IMPORTED_MODULE_4__util_Validations__["i" /* MAC_MASK */],disabled:selected,onBlur:function onBlur(){setMacErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.mac,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].MAC));prefill(mac);},error:macErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"ip-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.ip"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"ip-input",value:ip,onChange:setIp,onBlur:function onBlur(){return setIpErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.ip,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["g" /* IP_ADDRESS_PATTERN */]));},error:ipErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"port-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.port"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"port-input",value:port,onChange:setPort,onBlur:function onBlur(){return setPortErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.port,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].PORT));},error:portErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.protocol"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{id:"device-type-input",value:deviceType,onChange:function onChange(value){return setDeviceType(value);},onBlur:function onBlur(){return setDeviceTypeErr(!deviceType);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.select_protocol"}),error:deviceTypeErr,width:"100%"},__WEBPACK_IMPORTED_MODULE_4__util_Validations__["k" /* PROTOCOLS */].AUTO_LOADER.map(function(protocol){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{key:protocol,value:protocol,label:protocol});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"name-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"name-input",value:name,onChange:setName,onBlur:function onBlur(){return setNameErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.name,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].NAME));},error:nameErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.name_induct_line_desc"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"id-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.device_id"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{id:"id-input",value:id,onChange:setId,onBlur:function onBlur(){return setIdErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(stateValues.deviceConfig.id,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].DEVICE_ID));},error:idErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.device_id_induct_line_desc"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.vendor'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{id:"device-type-input",value:vendor,onChange:function onChange(value){return setVendor(value);},onBlur:function onBlur(){return setVendorErr(!vendor);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_vendor'}),error:vendorErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["r" /* VENDOR_INFO_KEYS */].VENDOR).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_4__util_Validations__["q" /* VENDOR_DISPLAY_VALUES */][value]});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"device-type-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.spec_version'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{id:"device-type-input",value:specVersion,onChange:function onChange(value){return setSpecVersion(value);},onBlur:function onBlur(){return setSpecVersionErr(!specVersion);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.select_version'}),error:specVersionErr,width:"100%"},Object(__WEBPACK_IMPORTED_MODULE_3__util_Util__["_6" /* getSortedListWithOther */])(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["r" /* VENDOR_INFO_KEYS */].SPEC_VERSION).map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{key:value,value:value,label:__WEBPACK_IMPORTED_MODULE_4__util_Validations__["p" /* SPEC_VERSION_DISPLAY_VALUES */][value]});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default.a,{type:"warning",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'alert.missingfields'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.cancel'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(stateValues);}},selected?Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.confirmEdit'}):Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:'modal.confirmAdd'})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddAutoLoaderSingleDeviceModal));

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_arrow_right_large__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_arrow_right_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_arrow_right_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__loader_Loader__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_upload_small__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_upload_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_upload_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commonui_UploadFileModal__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_Parsers__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__commonui_ConfigurationTabHeader__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__commonui_PaginatedTable__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__resources_AssetResource__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__rollback_RollbackModal__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__context_AutoLoaderDeviceOverviewContext__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modal_DeleteAutoLoaderConfigurationModal__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__modal_AddAutoLoaderConfigurationModal__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__modal_DeleteAutoLoaderTestPackageModal__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__modal_AddAutoLoaderTestPackageModal__ = __webpack_require__(1410);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var AutoLoaderDeviceConfiguration=function AutoLoaderDeviceConfiguration(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_26__context_AutoLoaderDeviceOverviewContext__["a" /* AutoLoaderDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_18__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext2.getDraftData,setDraftData=_useContext2.setDraftData,resetDraftData=_useContext2.resetDraftData,getFilteredDraftData=_useContext2.getFilteredDraftData,isDataEdited=_useContext2.isDataEdited;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),openAddModal=_useState2[0],setOpenAddModal=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),openDeleteModal=_useState4[0],setOpenDeleteModal=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),openCSVModal=_useState6[0],setOpenCSVModal=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),valueConfiguration=_useState8[0],setValueConfiguration=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),selectedMac=_useState10[0],setSelectedMac=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),showRollbackModal=_useState12[0],setShowRollbackModal=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),isVersionsLoading=_useState14[0],setIsVersionsLoading=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),selectedVersion=_useState16[0],setSelectedVersion=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),_useState18=_slicedToArray(_useState17,2),rollBackVersions=_useState18[0],setRollbackVersions=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])("scannables"),_useState20=_slicedToArray(_useState19,2),autoLoaderTestPackageSortColumn=_useState20[0],setAutoLoaderTestPackageSortColumn=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_17__util_Constants__["J" /* ASCENDING */]),_useState22=_slicedToArray(_useState21,2),autoLoaderTestPackageSortOrder=_useState22[0],setAutoLoaderTestPackageSortOrder=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])("destination"),_useState24=_slicedToArray(_useState23,2),autoLoaderDestinationColumn=_useState24[0],setAutoLoaderDestinationColumn=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_17__util_Constants__["J" /* ASCENDING */]),_useState26=_slicedToArray(_useState25,2),autoLoaderConfigSortOrder=_useState26[0],setAutoLoaderConfigSortOrder=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState28=_slicedToArray(_useState27,2),scannablesSearchInput=_useState28[0],setScannablesSearchInput=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),_useState30=_slicedToArray(_useState29,2),sortZoneSearchInput=_useState30[0],setSortZoneSearchInput=_useState30[1];var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_24__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext3.showCustomAlert;var PAGE_CONFIGURATION_KEYS=[__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION,__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_TEST_PACKAGE];var searchDataForTestConfigTable=function searchDataForTestConfigTable(){var data=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_TEST_PACKAGE,subKey:selectedMac});data=data.filter(function(item){return Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_13" /* getTestConfigKey */])(item.scannables).toLowerCase().includes(scannablesSearchInput.toLowerCase());}).filter(function(item){return item.sortZone.toLowerCase().includes(sortZoneSearchInput.toLowerCase());});data=data.sort(function(a,b){return autoLoaderTestConfigColumns[autoLoaderTestPackageSortColumn](a,b,autoLoaderTestPackageSortOrder===__WEBPACK_IMPORTED_MODULE_17__util_Constants__["J" /* ASCENDING */]);});return data;};var getModalContent=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var versionsData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setIsVersionsLoading(true);_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_22__resources_AssetResource__["f" /* getAssetVersions */])(selectedMac);case 3:versionsData=_context.sent;setRollbackVersions(versionsData.data.assetVersionDetailsList);setIsVersionsLoading(false);case 6:case"end":return _context.stop();}}},_callee,_this);}));return function getModalContent(){return _ref2.apply(this,arguments);};}();var loadRollbackDataToDraft=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var rollbackData,testPackageData,autoLoaderConfigData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_22__resources_AssetResource__["e" /* getAssetByVersion */])(selectedMac,selectedVersion);case 2:rollbackData=_context2.sent;testPackageData=Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.autoLoaderTestPackage);},[]);autoLoaderConfigData=Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return JSON.parse(rollbackData.data.asset.assetDetails.assetAttributes.autoLoaderConfig);},[]);if(testPackageData.length){setDraftData({data:testPackageData,stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_TEST_PACKAGE,subKey:selectedMac,allRowsAdded:true,override:true});}if(autoLoaderConfigData.length){setDraftData({data:autoLoaderConfigData,stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION,subKey:selectedMac,allRowsAdded:true,override:true});}case 7:case"end":return _context2.stop();}}},_callee2,_this);}));return function loadRollbackDataToDraft(){return _ref3.apply(this,arguments);};}();Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){if(!openAddModal&&!openDeleteModal){getData();var interval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["D" /* getAssetRefreshInterval */])());return function(){return clearInterval(interval);};}},[openAddModal,openDeleteModal]);Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return viewModel.autoLoaderTestPackage[selectedMac];},[]),stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_TEST_PACKAGE,subKey:selectedMac});setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return viewModel.autoLoaderConfig[selectedMac];},[]),stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION,subKey:selectedMac});},[selectedMac]);var getAutoLoaderDeviceList=function getAutoLoaderDeviceList(){var autoLoaderDeviceList=Object.values(viewModel.autoLoaderDeviceInformation);autoLoaderDeviceList&&autoLoaderDeviceList.sort(function(a,b){if(a.name<b.name){return-1;}else if(b.name>a.name){return 1;}return 0;});return autoLoaderDeviceList;};var getData=function getData(){if(isDataEdited(PAGE_CONFIGURATION_KEYS))return;setOpenAddModal(false);setOpenDeleteModal(false);dispatch({type:'LOAD_VIEW',data:{dispatcher:dispatch}});};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var updateDestinationConfigDraftData=function updateDestinationConfigDraftData(autoLoaderConfig){var compressedAutoLoaderConfig=Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["k" /* compressAutoLoaderConfig */])(autoLoaderConfig);setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return compressedAutoLoaderConfig;},[]),stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION,subKey:selectedMac,allRowsAdded:true,override:true});};var updateTestConfigDraftData=function updateTestConfigDraftData(testPackage){setDraftData({data:Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return testPackage;},[]),stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_TEST_PACKAGE,subKey:selectedMac,allRowsAdded:true,override:true});};var deployDraftAutoLoaderAsset=function deployDraftAutoLoaderAsset(){var autoLoaderDestinationList=getFilteredDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION,subKey:selectedMac});var testPackageList=getFilteredDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_TEST_PACKAGE,subKey:selectedMac});dispatch({type:'UPDATE_AUTOLOADER_CONFIGURATION',data:{dispatcher:dispatch,showCustomAlert:showCustomAlert,configurations:{autoLoaderConfig:autoLoaderDestinationList,autoLoaderTestPackage:testPackageList},mac:selectedMac}});setDraftData({data:autoLoaderDestinationList,stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION,subKey:selectedMac,override:true});setDraftData({data:testPackageList,stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_TEST_PACKAGE,subKey:selectedMac,override:true});};function onClickUploadCSV(){setOpenCSVModal(true);}function onClickAddSingle(){setOpenAddModal(true);}function onClickDeleteConfiguration(){setOpenDeleteModal(true);}var getDataStringFromConfig=function getDataStringFromConfig(config){return Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return config.installation.locations.join(' ');});};var renderAutoLoaderConfigTableRow=function renderAutoLoaderConfigTableRow(config,index){var dataString=getDataStringFromConfig(config);var prevDataString=Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["f" /* chainWalk */])(function(){return getDataStringFromConfig(config.prev);},null);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:true,key:index,backgroundColor:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_148" /* OPERATION_COLOR */][config.operation]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{alignmentVertical:"top"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,{spacingInset:"200 none none"},config.destination)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,config.installation.type),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,null,prevDataString&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_text___default.a,null," ",prevDataString," "),prevDataString&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_tokens_base_icon_arrow_right_large___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_text___default.a,null," ",dataString," "))));};var autoLoaderDestinationConfigColumns={destination:function destination(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.destination,b.destination):-Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.destination,b.destination);},installationType:function installationType(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.installation.type,b.installation.type):-Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.installation.type,b.installation.type);},locations:function locations(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(getDataStringFromConfig(a),getDataStringFromConfig(b)):-Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(getDataStringFromConfig(a),getDataStringFromConfig(b));}};var autoLoaderTestConfigColumns={scannables:function scannables(a,b,ascending){var scannableFirst=Array.isArray(a.scannables)?a.scannables.join(' '):a.scannables;var scannableSecond=Array.isArray(b.scannables)?b.scannables.join(' '):b.scannables;return ascending?Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(scannableFirst,scannableSecond):-Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(scannableFirst,scannableSecond);},sortZone:function sortZone(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.sortZone,b.sortZone):-Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(a.sortZone,b.sortZone);},length:function length(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(parseFloat(a.length),parseFloat(b.length)):-Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(parseFloat(a.length),parseFloat(b.length));},height:function height(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(parseFloat(a.height),parseFloat(b.height)):-Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(parseFloat(a.height),parseFloat(b.height));},width:function width(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(parseFloat(a.width),parseFloat(b.width)):-Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(parseFloat(a.width),parseFloat(b.width));},weight:function weight(a,b,ascending){return ascending?Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(parseFloat(a.weight),parseFloat(b.weight)):-Object(__WEBPACK_IMPORTED_MODULE_6__util_Util__["_32" /* sortComparator */])(parseFloat(a.weight),parseFloat(b.weight));}};var renderAutoLoaderConfigTableHeader=function renderAutoLoaderConfigTableHeader(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"destination"},Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.id"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"installationType"},Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.installationtype"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"location"},Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.locations"})));};var getHeaderProps=function getHeaderProps(){return{selectedMac:selectedMac,setSelectedMac:setSelectedMac,valueConfiguration:valueConfiguration,setValueConfiguration:setValueConfiguration,isAutoLoaderConfig:valueConfiguration===__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION,intl:intl,defaultSelection:"",resetDraftData:resetDraftData,deployDraft:deployDraftAutoLoaderAsset,scrollToBottom:scrollToBottom,sortedDeviceList:getAutoLoaderDeviceList(),configurationKeys:PAGE_CONFIGURATION_KEYS,refreshDeps:[viewModel.timestamp],isDeployDisabled:!isDataEdited(PAGE_CONFIGURATION_KEYS),isRollbackDisabled:!selectedMac||isDataEdited(PAGE_CONFIGURATION_KEYS),rollbackClickHandler:function rollbackClickHandler(){getModalContent();setShowRollbackModal(true);}};};var renderTestConfigTableHeader=function renderTestConfigTableHeader(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"table.index"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"scannables"},Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.scannables"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"length"},Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.length"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"height"},Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.height"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"width"},Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.width"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"weight"},Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.weight"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],{sortColumn:"sortZone"},Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"bay.sortzone"})));};var renderTestConfigTableRow=function renderTestConfigTableRow(config,serialNumber){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{highlightOnHover:true,backgroundColor:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_148" /* OPERATION_COLOR */][config.operation]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,serialNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,Array.isArray(config.scannables)?config.scannables.join(' '):config.scannables),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,config.length),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,config.height),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,config.width),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,config.weight),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,config.sortZone));};var renderSearchRow=function renderSearchRow(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableRow"],{backgroundColor:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_177" /* SEARCH_ROW_COLOR */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_input___default.a,{className:"input-search-class",value:scannablesSearchInput,onChange:setScannablesSearchInput,type:"text",placeholder:"Search",width:"70%",size:"small"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__amzn_meridian_input___default.a,{className:"input-search-class",value:sortZoneSearchInput,onChange:setSortZoneSearchInput,type:"text",placeholder:"Search",width:"70%",size:"small"})));};if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__loader_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__commonui_ConfigurationTabHeader__["a" /* default */],getHeaderProps()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__rollback_RollbackModal__["a" /* default */],{showRollbackModal:showRollbackModal,setShowRollbackModal:setShowRollbackModal,isVersionsLoading:isVersionsLoading,selectedVersion:selectedVersion,setSelectedVersion:setSelectedVersion,rollBackVersions:rollBackVersions,loadRollbackDataToDraft:loadRollbackDataToDraft,intl:intl}),valueConfiguration===__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION&&selectedMac&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__commonui_PaginatedTable__["a" /* default */],{data:getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION,subKey:selectedMac}).sort(function(a,b){return autoLoaderDestinationConfigColumns[autoLoaderDestinationColumn](a,b,autoLoaderConfigSortOrder===__WEBPACK_IMPORTED_MODULE_17__util_Constants__["J" /* ASCENDING */]);}),renderRow:renderAutoLoaderConfigTableRow,renderHeader:renderAutoLoaderConfigTableHeader,sortColumn:autoLoaderDestinationColumn,sortDirection:autoLoaderConfigSortOrder,onSort:function onSort(_ref4){var sortColumn=_ref4.sortColumn,sortDirection=_ref4.sortDirection;setAutoLoaderDestinationColumn(sortColumn);setAutoLoaderConfigSortOrder(sortDirection);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",widths:["100","100","fill","100"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{onClick:onClickAddSingle,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_plus_circle___default.a}),Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"autoloaderconfig.addupdate"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{onClick:onClickUploadCSV,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_upload_small___default.a}),Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"autoloaderconfig.uploadCSV"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{onClick:onClickDeleteConfiguration,size:"small",type:"tertiary"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"config.delete"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commonui_UploadFileModal__["a" /* default */],{mac:selectedMac,open:openCSVModal,setOpen:setOpenCSVModal,parser:__WEBPACK_IMPORTED_MODULE_16__util_Parsers__["c" /* AutoLoaderConfigCSVParser */],updateConfig:updateDestinationConfigDraftData}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__modal_AddAutoLoaderConfigurationModal__["a" /* default */],{mac:selectedMac,open:openAddModal,setOpen:setOpenAddModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__modal_DeleteAutoLoaderConfigurationModal__["a" /* default */],{mac:selectedMac,open:openDeleteModal,setOpen:setOpenDeleteModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{ref:tableEndRef})),valueConfiguration===__WEBPACK_IMPORTED_MODULE_17__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_TEST_PACKAGE&&selectedMac&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__commonui_PaginatedTable__["a" /* default */],{data:searchDataForTestConfigTable(),renderRow:renderTestConfigTableRow,renderHeader:renderTestConfigTableHeader,renderSearchRow:renderSearchRow,sortColumn:autoLoaderTestPackageSortColumn,sortDirection:autoLoaderTestPackageSortOrder,onSort:function onSort(_ref5){var sortColumn=_ref5.sortColumn,sortDirection=_ref5.sortDirection;setAutoLoaderTestPackageSortColumn(sortColumn);setAutoLoaderTestPackageSortOrder(sortDirection);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_row___default.a,{width:"100%",widths:["100","100","fill","100"]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{onClick:onClickAddSingle,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_plus_circle___default.a}),Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"autoloadertestconfig.addupdate"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{onClick:onClickUploadCSV,type:"primary",size:"small"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_tokens_base_icon_upload_small___default.a}),Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"autoloadertestconfig.uploadCSV"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_button___default.a,{onClick:onClickDeleteConfiguration,size:"small",type:"tertiary"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_25__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"autoloader.testconfig.delete"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commonui_UploadFileModal__["a" /* default */],{mac:selectedMac,open:openCSVModal,setOpen:setOpenCSVModal,parser:__WEBPACK_IMPORTED_MODULE_16__util_Parsers__["d" /* AutoLoaderTestConfigCSVParser */],updateConfig:updateTestConfigDraftData}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__modal_AddAutoLoaderTestPackageModal__["a" /* default */],{mac:selectedMac,open:openAddModal,setOpen:setOpenAddModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__modal_DeleteAutoLoaderTestPackageModal__["a" /* default */],{mac:selectedMac,open:openDeleteModal,setOpen:setOpenDeleteModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{ref:tableEndRef})));}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AutoLoaderDeviceConfiguration));

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var DeleteAutoLoaderConfigurationModal=function DeleteAutoLoaderConfigurationModal(props){var formatMessage=props.intl.formatMessage;var mac=props.mac,intl=props.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,deleteInstance=_useContext.deleteInstance,deleteAll=_useContext.deleteAll;var open=props.open,setOpen=props.setOpen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),destination=_useState2[0],setDestination=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),searchQuery=_useState4[0],setSearchQuery=_useState4[1];var onCloseModal=function onCloseModal(){setOpen(false);resetInputState();};var stateValues={destination:destination,mac:mac};var autoLoaderConfigList=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION,subKey:mac}).map(function(_ref){var destination=_ref.destination;return destination;});var searchRegExp=new RegExp(__WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp___default()(searchQuery),"i");// Converting to set to remove non-unique destination from DDB form
var matchedOptions=[].concat(_toConsumableArray(new Set(autoLoaderConfigList.filter(function(option){return!searchQuery||searchRegExp.test(option);}))));var onClickConfirm=function onClickConfirm(stateValues){deleteData(stateValues);setOpen(false);resetInputState();};function resetInputState(){setDestination("");}var deleteData=function deleteData(stateValues){deleteInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION,subKey:stateValues.mac,keyComparator:function keyComparator(instance){return instance.destination===stateValues.destination;}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default.a,{title:formatMessage({id:"device.delete_config_button_modal_autoloader"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.destinationdelete"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default.a,{value:destination,onChange:setDestination,searchQuery:searchQuery,onSearch:setSearchQuery,placeholder:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.selectdestinationid"}),width:"100%"},matchedOptions.map(function(destination){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__["SelectOption"],{key:destination,value:destination,label:destination});}),!matchedOptions.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},autoLoaderConfigList?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," ",Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"message.noMatchingDestination"})," "):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," ",Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"message.noDestinationAvailable"})," ")):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{size:"small",className:"redBtn",onClick:function onClick(){deleteAll({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION,subKey:stateValues.mac});onCloseModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.deleteAll"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"secondary",size:"small",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:function onClick(){return onClickConfirm(stateValues);}},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirm"})))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(DeleteAutoLoaderConfigurationModal));

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddAutoLoaderConfigurationModal=function AddAutoLoaderConfigurationModal(props){var formatMessage=props.intl.formatMessage;var mac=props.mac,intl=props.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,addInstance=_useContext.addInstance,editInstance=_useContext.editInstance;var installationType=Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["R" /* getInstallationTypes */])(__WEBPACK_IMPORTED_MODULE_10__util_Constants__["R" /* AUTO_LOADER_ASSET_TYPE */]);// Visual controls
var open=props.open,setOpen=props.setOpen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),show=_useState2[0],setShow=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),edit=_useState4[0],setEdit=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState6=_slicedToArray(_useState5,2),showLocation=_useState6[0],setShowLocation=_useState6[1];// Values
var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),locations=_useState8[0],setLocations=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),type=_useState10[0],setType=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),destination=_useState12[0],setDestination=_useState12[1];// Error
var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),locationsErr=_useState14[0],setLocationsErr=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),typeErr=_useState16[0],setTypeErr=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState18=_slicedToArray(_useState17,2),destinationErr=_useState18[0],setDestinationErr=_useState18[1];var onCloseModal=function onCloseModal(){setShow(false);setOpen(false);resetInputState();};var modalAutoLoaderConfig={destination:destination,installation:{type:type,locations:locations}/* Filling a map: autoloaderConfigMap with Destination as key in case of an update of existing asset */};var autoLoaderConfigMap={};getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION,subKey:mac}).forEach(function(value){var key=Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["E" /* getAutoLoaderConfigKey */])(value.destination,value.installation.type);autoLoaderConfigMap[key]={destination:value.destination,locations:value.installation.locations,type:value.installation.type};});var onClickConfirm=function onClickConfirm(modalAutoLoaderConfig,mac){if(Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["x" /* checkModalValidationsForConfig */])(modalAutoLoaderConfig,mac,__WEBPACK_IMPORTED_MODULE_10__util_Constants__["R" /* AUTO_LOADER_ASSET_TYPE */])){setConfigData(modalAutoLoaderConfig,mac);setOpen(false);resetInputState();setShow(false);}else{setShow(true);}};function resetInputState(){setDestination("");setDestinationErr(false);setType("");setTypeErr(false);resetConfigDetails();resetConfigErrorDetails();}var resetConfigDetails=function resetConfigDetails(){setLocations("");setShowLocation(true);};var resetConfigErrorDetails=function resetConfigErrorDetails(){setTypeErr(false);setLocationsErr(false);};var prefill=function prefill(){var key=Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["E" /* getAutoLoaderConfigKey */])(destination,type);console.log('Checking for existing config:',key,autoLoaderConfigMap);if(autoLoaderConfigMap.hasOwnProperty(key)){setEdit(true);resetConfigErrorDetails();setLocations(Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["F" /* getAutoLoaderConfigLocationStringForm */])(autoLoaderConfigMap[key].locations));setDestination(autoLoaderConfigMap[key].destination);}else if(edit){setEdit(false);resetConfigDetails();}};var setConfigData=function setConfigData(modalAutoLoaderConfig,mac){if(__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_1" /* CATCH_ALL_INSTALLATION_TYPES */].includes(modalAutoLoaderConfig.installation.type)&&modalAutoLoaderConfig.installation.locations.length===0){modalAutoLoaderConfig.installation.locations=[""];}else if(modalAutoLoaderConfig.installation.locations){modalAutoLoaderConfig.installation.locations=modalAutoLoaderConfig.installation.locations.replace(/\s/g,'').split(';').filter(Boolean);}else{modalAutoLoaderConfig.installation.locations=[];}if(edit){editInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION,subKey:mac,instance:modalAutoLoaderConfig,keyComparator:function keyComparator(config1,config2){return Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["E" /* getAutoLoaderConfigKey */])(config1.destination,config1.installation.type)===Object(__WEBPACK_IMPORTED_MODULE_13__util_Util__["E" /* getAutoLoaderConfigKey */])(config2.destination,config2.installation.type);},valueComparator:function valueComparator(config1,config2){return JSON.stringify(config1.destination.locations)===JSON.stringify(config2.destination.locations)&&JSON.stringify(config1.installation.locations)===JSON.stringify(config2.installation.locations);}});}else{addInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_DESTINATION,subKey:mac,instance:modalAutoLoaderConfig});}};var generateHelperText=function generateHelperText(){return __WEBPACK_IMPORTED_MODULE_10__util_Constants__["_1" /* CATCH_ALL_INSTALLATION_TYPES */].includes(type)?Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.optional.example"}):Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.location_example"});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"autoloaderconfig.addupdate"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null," ",Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.addheadingautoloader"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.id"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"destination-id-input",value:destination,onChange:setDestination,onBlur:function onBlur(){setDestinationErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(destination,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].DESTINATION));prefill();},error:destinationErr})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.installationtype"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select___default.a,{id:"type-input",value:type,onChange:setType,onBlur:function onBlur(){prefill();},placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.enter_value"}),width:"100%",error:typeErr},Object.values(installationType).map(function(_ref,index){var label=_ref.label,value=_ref.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_select__["SelectOption"],{key:index,value:value,label:label});}))),showLocation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.location"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"location-input",value:locations,onChange:setLocations,onBlur:function onBlur(){setLocationsErr(!(type===__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_84" /* INSTALLATION_TYPES */].SIDELINE.value&&Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(locations,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].CATCH_ALL_LOCATION)||Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(locations,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].LOCATION)));},error:locationsErr,helperText:generateHelperText()}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["x" /* checkModalValidationsForConfig */])(modalAutoLoaderConfig,mac,__WEBPACK_IMPORTED_MODULE_10__util_Constants__["R" /* AUTO_LOADER_ASSET_TYPE */])&&show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.missingfields"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(modalAutoLoaderConfig,mac);}},edit?Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirmUpdate"}):Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirmAdd"}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddAutoLoaderConfigurationModal));

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_trash__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var DeleteAutoLoaderTestPackageModal=function DeleteAutoLoaderTestPackageModal(props){var formatMessage=props.intl.formatMessage;var open=props.open,setOpen=props.setOpen,mac=props.mac,intl=props.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,deleteInstance=_useContext.deleteInstance,deleteAll=_useContext.deleteAll;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState2=_slicedToArray(_useState,2),selectedScannables=_useState2[0],setSelectedScannables=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),searchQuery=_useState4[0],setSearchQuery=_useState4[1];var onCloseModal=function onCloseModal(){setOpen(false);resetInputState();};var scannableKeyList=getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_TEST_PACKAGE,subKey:mac}).map(function(_ref){var scannables=_ref.scannables;return Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_13" /* getTestConfigKey */])(scannables);});var searchRegExp=new RegExp(__WEBPACK_IMPORTED_MODULE_8_lodash_escapeRegExp___default()(searchQuery),"i");var matchedKeys=scannableKeyList.filter(function(option){return!searchQuery||searchRegExp.test(option);});var onClickConfirm=function onClickConfirm(){deleteData();setOpen(false);resetInputState();};function resetInputState(){setSelectedScannables("");}var deleteData=function deleteData(){deleteInstance({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_TEST_PACKAGE,subKey:mac,keyComparator:function keyComparator(instance){return Object(__WEBPACK_IMPORTED_MODULE_11__util_Util__["_13" /* getTestConfigKey */])(instance.scannables)===selectedScannables;}});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal___default.a,{title:formatMessage({id:"autoloader.testconfig.delete"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.delete_test_package"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select___default.a,{value:selectedScannables,onChange:setSelectedScannables,searchQuery:searchQuery,onSearch:setSearchQuery,placeholder:Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"sortertestconfig.delete"}),width:"100%"},matchedKeys.map(function(scannable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_select__["SelectOption"],{key:scannable,value:scannable,label:scannable});}),!matchedKeys.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{alignmentVertical:"center",spacing:"100",spacingInset:"100"},scannableKeyList?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," ",Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"sortertestconfig.nomatch"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_text___default.a,{alignment:"center"}," ",Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"sortertestconfig.notavailable"}))):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"justify",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{size:"small",className:"redBtn",onClick:function onClick(){deleteAll({stateKey:__WEBPACK_IMPORTED_MODULE_10__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_TEST_PACKAGE,subKey:mac});onCloseModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_tokens_base_icon_trash___default.a}),Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.deleteAll"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"secondary",size:"small",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_button___default.a,{type:"primary",size:"small",onClick:onClickConfirm},Object(__WEBPACK_IMPORTED_MODULE_14__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirm"})))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(DeleteAutoLoaderTestPackageModal));

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__draftSave_context_DraftSaveContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_Localization__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddAutoLoaderTestPackageModal=function AddAutoLoaderTestPackageModal(props){var formatMessage=props.intl.formatMessage;var mac=props.mac,intl=props.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10__draftSave_context_DraftSaveContext__["a" /* DraftContext */]),getDraftData=_useContext.getDraftData,addInstance=_useContext.addInstance,editInstance=_useContext.editInstance;// Visual controls
var open=props.open,setOpen=props.setOpen;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),show=_useState2[0],setShow=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),edit=_useState4[0],setEdit=_useState4[1];// Values
var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),scannables=_useState6[0],setScannables=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),sortZone=_useState8[0],setSortZone=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),length=_useState10[0],setLength=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),width=_useState12[0],setWidth=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),height=_useState14[0],setHeight=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),weight=_useState16[0],setWeight=_useState16[1];// Error
var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState18=_slicedToArray(_useState17,2),scannablesErr=_useState18[0],setScannablesErr=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState20=_slicedToArray(_useState19,2),sortZoneErr=_useState20[0],setSortZoneErr=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState22=_slicedToArray(_useState21,2),lengthErr=_useState22[0],setLengthErr=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),widthErr=_useState24[0],setWidthErr=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),heightErr=_useState26[0],setHeightErr=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),weightErr=_useState28[0],setWeightErr=_useState28[1];function onCloseModal(){setShow(false);setOpen(false);resetInputState();}var autoLoaderTestPackage={scannables:scannables.split(';').filter(Boolean),sortZone:sortZone,length:parseFloat(length),width:parseFloat(width),height:parseFloat(height),weight:parseFloat(weight)};var testConfigMap={};getDraftData({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_TEST_PACKAGE,subKey:mac}).forEach(function(value){var key=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_13" /* getTestConfigKey */])(value.scannables);testConfigMap[key]={sortZone:value.sortZone,length:value.length,width:value.width,height:value.height,weight:value.weight};});var onClickConfirm=function onClickConfirm(autoLoaderTestPackage,mac){if(Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["w" /* checkModalValidationsForAutoloaderTestPackage */])(autoLoaderTestPackage)){setConfigData(autoLoaderTestPackage,mac);setOpen(false);resetInputState();setShow(false);}else{setShow(true);}};var prefill=function prefill(){var key=Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_13" /* getTestConfigKey */])(autoLoaderTestPackage.scannables);if(testConfigMap.hasOwnProperty(key)){setEdit(true);resetConfigErrorDetails();setSortZone(testConfigMap[key].sortZone);setLength(testConfigMap[key].length.toString());setWidth(testConfigMap[key].width.toString());setHeight(testConfigMap[key].height.toString());setWeight(testConfigMap[key].weight.toString());}else if(edit){setEdit(false);resetConfigDetails();}};function resetInputState(){setScannables("");resetConfigDetails();resetConfigErrorDetails();}var resetConfigDetails=function resetConfigDetails(){setSortZone("");setLength("");setWidth("");setHeight("");setWeight("");};var resetConfigErrorDetails=function resetConfigErrorDetails(){setSortZoneErr(false);setLengthErr(false);setWidthErr(false);setHeightErr(false);setWeightErr(false);};var validateDimension=function validateDimension(value){var num=parseFloat(value);return!isNaN(num)&&num>0;};var setConfigData=function setConfigData(autoLoaderTestPackage,mac){if(edit){editInstance({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_TEST_PACKAGE,subKey:mac,instance:autoLoaderTestPackage,keyComparator:function keyComparator(config1,config2){return Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_13" /* getTestConfigKey */])(config1.scannables)===Object(__WEBPACK_IMPORTED_MODULE_12__util_Util__["_13" /* getTestConfigKey */])(config2.scannables);},valueComparator:function valueComparator(config1,config2){return config1.sortZone===config2.sortZone&&config1.length===config2.length&&config1.width===config2.width&&config1.height===config2.height&&config1.weight===config2.weight;}});}else{addInstance({stateKey:__WEBPACK_IMPORTED_MODULE_11__util_Constants__["_4" /* CONFIG_TYPE */].AUTOLOADER_TEST_PACKAGE,subKey:mac,instance:autoLoaderTestPackage});}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal___default.a,{title:formatMessage({id:"autoloadertestconfig.addupdate"}),open:open,onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null," ",Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.addheadingtest"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"bay.scannables"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"scannables-input",value:scannables,onChange:function onChange(value){setScannables(value.replace(/\s/g,''));},onBlur:function onBlur(){setScannablesErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(scannables,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].TEST_SCANNABLE));prefill();},error:scannablesErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"test.scannables_description"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"bay.sortzone"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"sort-zone-input",value:sortZone,onChange:setSortZone,onBlur:function onBlur(){setSortZoneErr(!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["L" /* isValidEntry */])(sortZone,__WEBPACK_IMPORTED_MODULE_9__util_Validations__["j" /* PATTERNS */].SORT_ZONE));},error:sortZoneErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"bay.sortzone_description"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.length"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"length-input",type:"number",value:length,onChange:setLength,onBlur:function onBlur(){setLengthErr(!validateDimension(length));},error:lengthErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.length_description"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.width"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"width-input",type:"number",value:width,onChange:setWidth,onBlur:function onBlur(){setWidthErr(!validateDimension(width));},error:widthErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.width_description"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.height"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"height-input",type:"number",value:height,onChange:setHeight,onBlur:function onBlur(){setHeightErr(!validateDimension(height));},error:heightErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.height_description"})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary",htmlFor:"my-input"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.weight"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_input___default.a,{id:"weight-input",type:"number",value:weight,onChange:setWeight,onBlur:function onBlur(){setWeightErr(!validateDimension(weight));},error:weightErr,helperText:Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"destination.weight_description"})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__meridian_components_column___default.a,null,!Object(__WEBPACK_IMPORTED_MODULE_9__util_Validations__["w" /* checkModalValidationsForAutoloaderTestPackage */])(autoLoaderTestPackage)&&show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_alert___default.a,{type:"warning",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.missingfields"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:function onClick(){return onClickConfirm(autoLoaderTestPackage,mac);}},edit?Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirmUpdate"}):Object(__WEBPACK_IMPORTED_MODULE_13__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"modal.confirmAdd"}))))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddAutoLoaderTestPackageModal));

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_AutoLoaderDeviceOverviewContext__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonui_CommonDeviceLogstream__ = __webpack_require__(102);
var AutoLoaderDeviceLogstream=function AutoLoaderDeviceLogstream(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__context_AutoLoaderDeviceOverviewContext__["a" /* AutoLoaderDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var deviceList=Object.values(viewModel.autoLoaderDeviceInformation);var props={protocols:__WEBPACK_IMPORTED_MODULE_3__util_Validations__["k" /* PROTOCOLS */].AUTO_LOADER,dispatch:dispatch,deviceList:deviceList,deviceType:__WEBPACK_IMPORTED_MODULE_4__util_Constants__["R" /* AUTO_LOADER_ASSET_TYPE */],intl:intl};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonui_CommonDeviceLogstream__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(AutoLoaderDeviceLogstream));

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_SelectLayout__ = __webpack_require__(232);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AdtfSubComponentSelectPage=function(_Component){_inherits(AdtfSubComponentSelectPage,_Component);function AdtfSubComponentSelectPage(){_classCallCheck(this,AdtfSubComponentSelectPage);return _possibleConstructorReturn(this,(AdtfSubComponentSelectPage.__proto__||Object.getPrototypeOf(AdtfSubComponentSelectPage)).apply(this,arguments));}_createClass(AdtfSubComponentSelectPage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_SelectLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_2__util_RouteConstants__["f" /* ADTF_SUB_COMPONENT_ROUTES */].sort(function(a,b){return a.name.localeCompare(b.name);}),location:this.props.location,history:this.props.history,isComponentTypeSelect:"true"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_SelectLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_2__util_RouteConstants__["f" /* ADTF_SUB_COMPONENT_ROUTES */]}));}}]);return AdtfSubComponentSelectPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AdtfSubComponentSelectPage);

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AdtfDeviceOverviewContext__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Constants__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var AdtfPullModePage=function(_Component){_inherits(AdtfPullModePage,_Component);function AdtfPullModePage(){_classCallCheck(this,AdtfPullModePage);return _possibleConstructorReturn(this,(AdtfPullModePage.__proto__||Object.getPrototypeOf(AdtfPullModePage)).apply(this,arguments));}_createClass(AdtfPullModePage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_AdtfDeviceOverviewContext__["b" /* default */],{data:{assetSubtype:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["h" /* ADTF_PULLMODE */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["d" /* ADTF_PULLMODE_ROUTE */],location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["d" /* ADTF_PULLMODE_ROUTE */]})));}}]);return AdtfPullModePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AdtfPullModePage);

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AdtfDeviceOverviewContext__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Constants__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var AdtfSimplePage=function(_Component){_inherits(AdtfSimplePage,_Component);function AdtfSimplePage(){_classCallCheck(this,AdtfSimplePage);return _possibleConstructorReturn(this,(AdtfSimplePage.__proto__||Object.getPrototypeOf(AdtfSimplePage)).apply(this,arguments));}_createClass(AdtfSimplePage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_AdtfDeviceOverviewContext__["b" /* default */],{data:{assetSubtype:__WEBPACK_IMPORTED_MODULE_5__util_Constants__["i" /* ADTF_SIMPLE */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["e" /* ADTF_SIMPLE_ROUTE */],location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["e" /* ADTF_SIMPLE_ROUTE */]})));}}]);return AdtfSimplePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AdtfSimplePage);

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_AdtfDeviceOverviewContext__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */var AdtfDevicePage=function(_Component){_inherits(AdtfDevicePage,_Component);function AdtfDevicePage(){_classCallCheck(this,AdtfDevicePage);return _possibleConstructorReturn(this,(AdtfDevicePage.__proto__||Object.getPrototypeOf(AdtfDevicePage)).apply(this,arguments));}_createClass(AdtfDevicePage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_AdtfDeviceOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["b" /* ADTF */],location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["b" /* ADTF */]})));}}]);return AdtfDevicePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AdtfDevicePage);

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ledcontroller_context_SBLDashboardContext__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__ = __webpack_require__(44);
var LEDControllerSTAGPage=function LEDControllerSTAGPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ledcontroller_context_SBLDashboardContext__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["t" /* LED_CONTROLLER_STAG_ROUTES */]})));};/* harmony default export */ __webpack_exports__["a"] = (LEDControllerSTAGPage);

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_VaprDeviceOverviewContext__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_TabLayout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VaprDevicePage=function(_Component){_inherits(VaprDevicePage,_Component);function VaprDevicePage(){_classCallCheck(this,VaprDevicePage);return _possibleConstructorReturn(this,(VaprDevicePage.__proto__||Object.getPrototypeOf(VaprDevicePage)).apply(this,arguments));}_createClass(VaprDevicePage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_VaprDeviceOverviewContext__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["b" /* default */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["B" /* VAPR */],location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_TabLayout__["a" /* NavigationRoutes */],{routes:__WEBPACK_IMPORTED_MODULE_4__util_RouteConstants__["B" /* VAPR */]})));}}]);return VaprDevicePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (VaprDevicePage);

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VaprDeviceOverviewReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Util__ = __webpack_require__(5);
var VaprDeviceOverviewReducer=function VaprDeviceOverviewReducer(state,action){switch(action.type){case"RECEIVE_DATA":return Object.assign({},state,action.data,{loadingOverview:false,timestamp:Object(__WEBPACK_IMPORTED_MODULE_0__util_Util__["_14" /* getTimestampNow */])()});case"SORT_DATA":return Object.assign({},state,{sortPref:action.data});default:return state;}};

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_VaprDeviceOverviewContext__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__network_VaprDeviceNetworkAPI__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_FeatureUtility__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__permissions_PermissionsContext__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal_AddVaprSingleDeviceModal__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_loader__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_chevron_down_large__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_chevron_down_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_chevron_down_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_RefreshTimer__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_text__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var VaprDeviceOverview=function VaprDeviceOverview(_ref){var intl=_ref.intl;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_VaprDeviceOverviewContext__["a" /* VaprDeviceOverviewContext */]),viewModel=_useContext.viewModel,dispatch=_useContext.dispatch;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__permissions_PermissionsContext__["a" /* PermissionsContext */]),isAuthorized=_useContext2.isAuthorized;var tableEndRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),openAddModal=_useState2[0],setOpenAddModal=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),selected=_useState4[0],setSelected=_useState4[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){getData();var assetInterval=setInterval(function(){if(!document.hidden){getData();}},Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["D" /* getAssetRefreshInterval */])());return function(){return clearInterval(assetInterval);};},[]);var getData=function getData(){Object(__WEBPACK_IMPORTED_MODULE_3__network_VaprDeviceNetworkAPI__["a" /* fetchVaprDeviceDetails */])(dispatch);};var scrollToBottom=function scrollToBottom(){tableEndRef.current.scrollIntoView({behavior:"smooth"});};var onSort=function onSort(sortDetails){dispatch({type:'SORT_DATA',data:{column:sortDetails.sortColumn,direction:sortDetails.sortDirection}});};var sortedDeviceList=Object.values(viewModel.vaprDeviceInformation);sortedDeviceList.sort(function(a,b){var _viewModel$sortPref=viewModel.sortPref,column=_viewModel$sortPref.column,direction=_viewModel$sortPref.direction;var compareValue=Object(__WEBPACK_IMPORTED_MODULE_4__util_Util__["_32" /* sortComparator */])(a[column],b[column]);return direction===__WEBPACK_IMPORTED_MODULE_5__util_Constants__["J" /* ASCENDING */]?compareValue:-compareValue;});if(viewModel.loadingOverview){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_loader___default.a,null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default.a,{widths:"100%",alignmentVertical:"top",spacingInset:"none none large none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default.a,{width:"100%",widths:["100","fill","100"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__util_RefreshTimer__["a" /* default */],{deps:[viewModel]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default.a,{position:"top",title:Object(__WEBPACK_IMPORTED_MODULE_7__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.scrolltobottom"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_button___default.a,{onClick:scrollToBottom,type:"secondary",size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_18__amzn_meridian_tokens_base_icon_chevron_down_large___default.a})))),sortedDeviceList.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__amzn_meridian_alert___default.a,{type:"informational",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_7__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"alert.device"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table___default.a,{headerRows:1,spacing:"small",sortColumn:viewModel.sortPref.column,sortDirection:viewModel.sortPref.direction,onSort:onSort,showDividers:true,showStripes:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__["TableRow"],{highlightOnHover:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__["TableCell"],{sortColumn:"name"},Object(__WEBPACK_IMPORTED_MODULE_7__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__["TableCell"],{sortColumn:"mac"},Object(__WEBPACK_IMPORTED_MODULE_7__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.mac_ip"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Connection Status")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"Monitoring")),__WEBPACK_IMPORTED_MODULE_6__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_6__util_FeatureUtility__["a" /* FEATURES */].IS_VAPR_FOV_ENABLED)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default.a,{position:"top",title:"D: Detection Field of View, P: Projection Field of View (Length \xD7 Breadth)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"FOV"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__["TableCell"],null,Object(__WEBPACK_IMPORTED_MODULE_7__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.action"}))),sortedDeviceList.map(function(device){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__["TableRow"],{key:device.mac,highlightOnHover:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default.a,{position:"top",title:"Device ID: "+device.deviceId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.name),device.deviceType))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_column___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,device.mac),device.ip,":",device.port)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_text___default.a,{color:"secondary"},"Status Unavailable")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__["TableCell"],null,function(){var monitoring=Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["u" /* checkDeviceMonitoringEnabled */])(Number(device.monitoringStartTime),Number(device.monitoringEndTime));var _getMonitoringStatusD=Object(__WEBPACK_IMPORTED_MODULE_8__util_Validations__["F" /* getMonitoringStatusDetails */])(monitoring),monitoringStatusColor=_getMonitoringStatusD.monitoringStatusColor,monitoringStatusDefaultMessage=_getMonitoringStatusD.monitoringStatusDefaultMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{style:{color:monitoringStatusColor}},monitoringStatusDefaultMessage);}()),__WEBPACK_IMPORTED_MODULE_6__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_6__util_FeatureUtility__["a" /* FEATURES */].IS_VAPR_FOV_ENABLED)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_column___default.a,null,device.detectionFovLength&&device.detectionFovBreadth?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"D: ",device.detectionFovLength," \xD7 ",device.detectionFovBreadth," ",device.detectionFovUnit):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"D: -"),device.projectionFovLength&&device.projectionFovBreadth?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"P: ",device.projectionFovLength," \xD7 ",device.projectionFovBreadth," ",device.projectionFovUnit):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"P: -"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__amzn_meridian_table__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__amzn_meridian_text___default.a,{color:"secondary"},"-")));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default.a,{width:"100%",widths:["100","fill"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__amzn_meridian_tooltip___default.a,{position:"end",title:!isAuthorized?Object(__WEBPACK_IMPORTED_MODULE_7__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"tooltip.isAuthorized"}):""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__amzn_meridian_button___default.a,{onClick:function onClick(){return setOpenAddModal(true);},type:"primary",size:"small",disabled:!isAuthorized},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_19__amzn_meridian_tokens_base_icon_plus_circle___default.a}),Object(__WEBPACK_IMPORTED_MODULE_7__util_Localization__["a" /* getLocalizedMessage */])({intl:intl,stringId:"device.add_device_button_modal"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__amzn_meridian_box___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__modal_AddVaprSingleDeviceModal__["a" /* default */],{open:openAddModal,setOpen:setOpenAddModal,selected:selected,setSelected:setSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:tableEndRef})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(VaprDeviceOverview));

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_VaprDeviceOverviewContext__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Validations__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_FeatureUtility__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_Localization__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__network_VaprDeviceNetworkAPI__ = __webpack_require__(521);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var AddVaprSingleDeviceModal=function AddVaprSingleDeviceModal(props){var open=props.open,setOpen=props.setOpen,selected=props.selected,setSelected=props.setSelected;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showWarning=_useContext.showWarning;var _useContext2=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__context_VaprDeviceOverviewContext__["a" /* VaprDeviceOverviewContext */]),viewModel=_useContext2.viewModel,dispatch=_useContext2.dispatch;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showAlert=_useState2[0],setShowAlert=_useState2[1];// States
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState4=_slicedToArray(_useState3,2),mac=_useState4[0],setMac=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState6=_slicedToArray(_useState5,2),ip=_useState6[0],setIp=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState8=_slicedToArray(_useState7,2),port=_useState8[0],setPort=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState10=_slicedToArray(_useState9,2),deviceType=_useState10[0],setDeviceType=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState12=_slicedToArray(_useState11,2),name=_useState12[0],setName=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState14=_slicedToArray(_useState13,2),id=_useState14[0],setId=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState16=_slicedToArray(_useState15,2),detectionFovLength=_useState16[0],setDetectionFovLength=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState18=_slicedToArray(_useState17,2),detectionFovBreadth=_useState18[0],setDetectionFovBreadth=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState20=_slicedToArray(_useState19,2),projectionFovLength=_useState20[0],setProjectionFovLength=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),_useState22=_slicedToArray(_useState21,2),projectionFovBreadth=_useState22[0],setProjectionFovBreadth=_useState22[1];// Errors
var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),macErr=_useState24[0],setMacErr=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),ipErr=_useState26[0],setIpErr=_useState26[1];var _useState27=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState28=_slicedToArray(_useState27,2),portErr=_useState28[0],setPortErr=_useState28[1];var _useState29=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState30=_slicedToArray(_useState29,2),deviceTypeErr=_useState30[0],setDeviceTypeErr=_useState30[1];var _useState31=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState32=_slicedToArray(_useState31,2),nameErr=_useState32[0],setNameErr=_useState32[1];var _useState33=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState34=_slicedToArray(_useState33,2),idErr=_useState34[0],setIdErr=_useState34[1];var _useState35=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState36=_slicedToArray(_useState35,2),detectionFovLengthErr=_useState36[0],setDetectionFovLengthErr=_useState36[1];var _useState37=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState38=_slicedToArray(_useState37,2),detectionFovBreadthErr=_useState38[0],setDetectionFovBreadthErr=_useState38[1];var _useState39=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState40=_slicedToArray(_useState39,2),projectionFovLengthErr=_useState40[0],setProjectionFovLengthErr=_useState40[1];var _useState41=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState42=_slicedToArray(_useState41,2),projectionFovBreadthErr=_useState42[0],setProjectionFovBreadthErr=_useState42[1];var initialMonitoringValue={startTime:"0",endTime:"0",reason:""};var _useState43=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(JSON.stringify(initialMonitoringValue)),_useState44=_slicedToArray(_useState43,2),monitoring=_useState44[0],setMonitoring=_useState44[1];var _useContext3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),showCustomAlert=_useContext3.showCustomAlert;var fovEnabled=__WEBPACK_IMPORTED_MODULE_14__util_FeatureUtility__["b" /* FeatureUtility */].getFeatureStatus(__WEBPACK_IMPORTED_MODULE_14__util_FeatureUtility__["a" /* FEATURES */].IS_VAPR_FOV_ENABLED);var stateValues=Object.assign({name:name,mac:mac,ip:ip,port:port,deviceType:deviceType,deviceConfig:{type:__WEBPACK_IMPORTED_MODULE_3__util_Util__["e" /* assetTypeToConfigTypeDict */].typeVAPR,id:id}},fovEnabled&&{detectionFov:JSON.stringify({length:Number(detectionFovLength),breadth:Number(detectionFovBreadth),unit:"mm"}),projectionFov:JSON.stringify({length:Number(projectionFovLength),breadth:Number(projectionFovBreadth),unit:"mm"})},{monitoring:monitoring});var validateForm=function validateForm(){return Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(mac,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].MAC)&&Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(ip,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["g" /* IP_ADDRESS_PATTERN */])&&Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(port,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].PORT)&&__WEBPACK_IMPORTED_MODULE_4__util_Validations__["k" /* PROTOCOLS */].VAPR.includes(deviceType)&&Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(name,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].NAME)&&Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(id,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].DEVICE_ID)&&(// FOV validation only applies while the fields are enabled.
!fovEnabled||Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(detectionFovLength,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].INTEGER)&&Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(detectionFovBreadth,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].INTEGER)&&Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(projectionFovLength,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].INTEGER)&&Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(projectionFovBreadth,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].INTEGER));};var onClickConfirm=function onClickConfirm(){if(validateForm()){showWarning(Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"device.editWarning"}),function(){setShowAlert(false);var submitValues=Object.assign({},stateValues);submitValues.deviceConfig=JSON.stringify(submitValues.deviceConfig);if(selected){Object(__WEBPACK_IMPORTED_MODULE_16__network_VaprDeviceNetworkAPI__["c" /* updateVaprDeviceDetails */])(dispatch,submitValues,showCustomAlert);}else{Object(__WEBPACK_IMPORTED_MODULE_16__network_VaprDeviceNetworkAPI__["b" /* setVaprDeviceDetails */])(dispatch,submitValues,showCustomAlert);}resetInputState();setSelected("");setOpen(false);});}else{setShowAlert(true);}};var prefill=function prefill(value){if(viewModel.vaprDeviceInformation.hasOwnProperty(value)){setSelected(value);var device=viewModel.vaprDeviceInformation[value];resetAssetDetailErrors();setMac(device.mac);setIp(device.ip);setPort(device.port);setDeviceType(device.deviceType);setName(device.name);setId(device.deviceId);setDetectionFovLength(device.detectionFovLength?String(device.detectionFovLength):"");setDetectionFovBreadth(device.detectionFovBreadth?String(device.detectionFovBreadth):"");setProjectionFovLength(device.projectionFovLength?String(device.projectionFovLength):"");setProjectionFovBreadth(device.projectionFovBreadth?String(device.projectionFovBreadth):"");var deviceMonitoring={startTime:device.monitoringStartTime,endTime:device.monitoringEndTime,reason:""};setMonitoring(JSON.stringify(deviceMonitoring));}else if(selected){setSelected("");resetAssetDetails();}};var resetAssetDetails=function resetAssetDetails(){setIp("");setPort("");setDeviceType("");setName("");setId("");setDetectionFovLength("");setDetectionFovBreadth("");setProjectionFovLength("");setProjectionFovBreadth("");setMonitoring(JSON.stringify(initialMonitoringValue));};var resetAssetDetailErrors=function resetAssetDetailErrors(){setIpErr(false);setPortErr(false);setDeviceTypeErr(false);setNameErr(false);setIdErr(false);setDetectionFovLengthErr(false);setDetectionFovBreadthErr(false);setProjectionFovLengthErr(false);setProjectionFovBreadthErr(false);};var resetInputState=function resetInputState(){setMac("");setMacErr(false);setMonitoring(JSON.stringify(initialMonitoringValue));resetAssetDetails();resetAssetDetailErrors();setShowAlert(false);};var onCloseModal=function onCloseModal(){setOpen(false);setSelected("");resetInputState();};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal___default.a,{title:Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"device.add_device_button_modal"}),open:open,onOpen:function onOpen(){return prefill(selected);},onClose:onCloseModal,scrollContainer:"viewport",closeLabel:"Close",bodySpacingInset:"medium",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"medium",spacingInset:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.mac"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{value:mac,onChange:setMac,mask:__WEBPACK_IMPORTED_MODULE_4__util_Validations__["i" /* MAC_MASK */],disabled:!!selected,onBlur:function onBlur(){setMacErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(mac,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].MAC));prefill(mac);},error:macErr,placeholder:"e.g. aa:bb:cc:dd:ee:ff"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.ip"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{value:ip,onChange:setIp,onBlur:function onBlur(){return setIpErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(ip,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["g" /* IP_ADDRESS_PATTERN */]));},error:ipErr,placeholder:"e.g. 10.34.57.101"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.port"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{value:port,onChange:setPort,onBlur:function onBlur(){return setPortErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(port,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].PORT));},error:portErr,placeholder:"e.g. 5000"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.protocol"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select___default.a,{value:deviceType,onChange:function onChange(value){return setDeviceType(value);},onBlur:function onBlur(){return setDeviceTypeErr(!deviceType);},placeholder:Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.select_protocol"}),error:deviceTypeErr,width:"100%"},__WEBPACK_IMPORTED_MODULE_4__util_Validations__["k" /* PROTOCOLS */].VAPR.map(function(protocol){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_select__["SelectOption"],{key:protocol,value:protocol,label:protocol});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{value:name,onChange:setName,onBlur:function onBlur(){return setNameErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(name,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].NAME));},error:nameErr,placeholder:"e.g. VAPR-101"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.device_id"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{value:id,onChange:setId,onBlur:function onBlur(){return setIdErr(!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(id,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].DEVICE_ID));},error:idErr,placeholder:"e.g. B (1-4 uppercase alphanumeric chars)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{type:"h100",color:"primary"},"Detection Field of View (mm)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default.a,{widths:["fill","fill"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},"Length"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{value:detectionFovLength,onChange:setDetectionFovLength,onBlur:function onBlur(){return setDetectionFovLengthErr(fovEnabled&&!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(detectionFovLength,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].INTEGER));},error:detectionFovLengthErr,disabled:!fovEnabled,placeholder:"e.g. 1200"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},"Breadth"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{value:detectionFovBreadth,onChange:setDetectionFovBreadth,onBlur:function onBlur(){return setDetectionFovBreadthErr(fovEnabled&&!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(detectionFovBreadth,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].INTEGER));},error:detectionFovBreadthErr,disabled:!fovEnabled,placeholder:"e.g. 1400"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{type:"h100",color:"primary"},"Projection Field of View (mm)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default.a,{widths:["fill","fill"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},"Length"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{value:projectionFovLength,onChange:setProjectionFovLength,onBlur:function onBlur(){return setProjectionFovLengthErr(fovEnabled&&!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(projectionFovLength,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].INTEGER));},error:projectionFovLengthErr,disabled:!fovEnabled,placeholder:"e.g. 800"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,{spacing:"200"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_text___default.a,{tag:"label",type:"b200",color:"primary"},"Breadth"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_input___default.a,{value:projectionFovBreadth,onChange:setProjectionFovBreadth,onBlur:function onBlur(){return setProjectionFovBreadthErr(fovEnabled&&!Object(__WEBPACK_IMPORTED_MODULE_4__util_Validations__["L" /* isValidEntry */])(projectionFovBreadth,__WEBPACK_IMPORTED_MODULE_4__util_Validations__["j" /* PATTERNS */].INTEGER));},error:projectionFovBreadthErr,disabled:!fovEnabled,placeholder:"e.g. 600"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_modal__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_column___default.a,null,showAlert&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__amzn_meridian_alert___default.a,{type:"warning",size:"small"},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"alert.missingfields"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__amzn_meridian_row___default.a,{alignmentHorizontal:"right",widths:"fit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default.a,{type:"secondary",size:"medium",onClick:onCloseModal},Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.cancel"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__amzn_meridian_button___default.a,{type:"primary",size:"medium",onClick:onClickConfirm},selected?Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.confirmEdit"}):Object(__WEBPACK_IMPORTED_MODULE_15__util_Localization__["a" /* getLocalizedMessage */])({intl:props.intl,stringId:"modal.confirmAdd"})))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(AddVaprSingleDeviceModal));

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_heading__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amzn_meridian_heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tokens_base_icon_export_small__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tokens_base_icon_export_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tokens_base_icon_export_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_box__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__amzn_meridian_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Util__ = __webpack_require__(5);
var renderExternalLinks=function renderExternalLinks(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row___default.a,null,__WEBPACK_IMPORTED_MODULE_11__Constants__["_76" /* EXTERNAL_LINKS */].map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row___default.a,null,index>0&&Object(__WEBPACK_IMPORTED_MODULE_12__Util__["_25" /* renderElementSeparator */])(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__amzn_meridian_link___default.a,{target:"_blank",rel:"noopener noreferrer",type:"secondary",href:item.links[Object(__WEBPACK_IMPORTED_MODULE_12__Util__["_15" /* getUTRRegion */])()]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:item.id})," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__amzn_meridian_icon___default.a,{tokens:__WEBPACK_IMPORTED_MODULE_8__amzn_meridian_tokens_base_icon_export_small___default.a})));}));};/**
 * Returns the page heading and description
 * @param head
 * @param headAlt
 * @param desc
 * @param descAlt
 * @return JSX.Element
 */var PageHeader=function PageHeader(_ref){var head=_ref.head,headAlt=_ref.headAlt,desc=_ref.desc,descAlt=_ref.descAlt;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__amzn_meridian_column___default.a,{spacing:"none"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__amzn_meridian_heading___default.a,{level:2,type:"h400",alignment:"left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:head,defaultMessage:headAlt})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__amzn_meridian_row___default.a,{widths:["fit","fill","fit"],overflowX:"scroll"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__amzn_meridian_text___default.a,{color:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */],{id:desc,defaultMessage:descAlt})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__amzn_meridian_box___default.a,null),renderExternalLinks()));};PageHeader.propTypes={head:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,headAlt:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,desc:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,descAlt:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (PageHeader);

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accordion__ = __webpack_require__(1424);
/* unused harmony reexport KatAccordion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accordion_item__ = __webpack_require__(1430);
/* unused harmony reexport KatAccordionItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_bar__ = __webpack_require__(1431);
/* unused harmony reexport KatActionBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__activity_list__ = __webpack_require__(1432);
/* unused harmony reexport KatActivityList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__activity_list_item__ = __webpack_require__(1433);
/* unused harmony reexport KatActivityListItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__alert__ = __webpack_require__(1434);
/* unused harmony reexport KatAlert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_layout__ = __webpack_require__(1435);
/* unused harmony reexport KatAppLayout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__badge__ = __webpack_require__(1436);
/* unused harmony reexport KatBadge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blueprint_dashboard__ = __webpack_require__(1437);
/* unused harmony reexport KatBlueprintDashboard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__blueprint_dashboard_action__ = __webpack_require__(1438);
/* unused harmony reexport KatBlueprintDashboardAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__blueprint_dashboard_focus__ = __webpack_require__(1439);
/* unused harmony reexport KatBlueprintDashboardFocus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__blueprint_dashboard_identify__ = __webpack_require__(1440);
/* unused harmony reexport KatBlueprintDashboardIdentify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__blueprint_dashboard_overview__ = __webpack_require__(1441);
/* unused harmony reexport KatBlueprintDashboardOverview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__blueprint_entity_detail__ = __webpack_require__(1442);
/* unused harmony reexport KatBlueprintEntityDetail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__blueprint_entity_detail_action__ = __webpack_require__(1443);
/* unused harmony reexport KatBlueprintEntityDetailAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__blueprint_entity_detail_focus__ = __webpack_require__(1444);
/* unused harmony reexport KatBlueprintEntityDetailFocus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__blueprint_entity_detail_identify__ = __webpack_require__(1445);
/* unused harmony reexport KatBlueprintEntityDetailIdentify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__blueprint_entity_detail_overview__ = __webpack_require__(1446);
/* unused harmony reexport KatBlueprintEntityDetailOverview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__blueprint_manage_entity_list__ = __webpack_require__(1447);
/* unused harmony reexport KatBlueprintManageEntityList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__blueprint_manage_entity_list_action__ = __webpack_require__(1448);
/* unused harmony reexport KatBlueprintManageEntityListAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__blueprint_manage_entity_list_focus__ = __webpack_require__(1449);
/* unused harmony reexport KatBlueprintManageEntityListFocus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__blueprint_manage_entity_list_identify__ = __webpack_require__(1450);
/* unused harmony reexport KatBlueprintManageEntityListIdentify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__blueprint_manage_entity_list_overview__ = __webpack_require__(1451);
/* unused harmony reexport KatBlueprintManageEntityListOverview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__blueprint_report__ = __webpack_require__(1452);
/* unused harmony reexport KatBlueprintReport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__blueprint_report_action__ = __webpack_require__(1453);
/* unused harmony reexport KatBlueprintReportAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__blueprint_report_context__ = __webpack_require__(1454);
/* unused harmony reexport KatBlueprintReportContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__blueprint_report_focus__ = __webpack_require__(1455);
/* unused harmony reexport KatBlueprintReportFocus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__blueprint_report_identify__ = __webpack_require__(1456);
/* unused harmony reexport KatBlueprintReportIdentify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__blueprint_report_overview__ = __webpack_require__(1457);
/* unused harmony reexport KatBlueprintReportOverview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__blueprint_workflow__ = __webpack_require__(1458);
/* unused harmony reexport KatBlueprintWorkflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__blueprint_workflow_action__ = __webpack_require__(1459);
/* unused harmony reexport KatBlueprintWorkflowAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__blueprint_workflow_focus__ = __webpack_require__(1460);
/* unused harmony reexport KatBlueprintWorkflowFocus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__blueprint_workflow_identify__ = __webpack_require__(1461);
/* unused harmony reexport KatBlueprintWorkflowIdentify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__blueprint_workflow_overview__ = __webpack_require__(1462);
/* unused harmony reexport KatBlueprintWorkflowOverview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__box__ = __webpack_require__(1463);
/* unused harmony reexport KatBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__breadcrumb__ = __webpack_require__(1464);
/* unused harmony reexport KatBreadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__breadcrumb_item__ = __webpack_require__(1465);
/* unused harmony reexport KatBreadcrumbItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__button__ = __webpack_require__(1466);
/* unused harmony reexport KatButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__button_group__ = __webpack_require__(1467);
/* unused harmony reexport KatButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__calendar__ = __webpack_require__(1468);
/* unused harmony reexport KatCalendar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__card__ = __webpack_require__(1469);
/* unused harmony reexport KatCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__carousel__ = __webpack_require__(1470);
/* unused harmony reexport KatCarousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__carousel_image__ = __webpack_require__(1471);
/* unused harmony reexport KatCarouselImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__carousel_item__ = __webpack_require__(1472);
/* unused harmony reexport KatCarouselItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__carousel_items__ = __webpack_require__(1473);
/* unused harmony reexport KatCarouselItems */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__changeover_anchor__ = __webpack_require__(1474);
/* unused harmony reexport KatChangeoverAnchor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__checkbox__ = __webpack_require__(1475);
/* unused harmony reexport KatCheckbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__column__ = __webpack_require__(1476);
/* unused harmony reexport KatColumn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__currency_selector__ = __webpack_require__(1477);
/* unused harmony reexport KatCurrencySelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__data_grid__ = __webpack_require__(1478);
/* unused harmony reexport KatDataGrid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__data_table__ = __webpack_require__(1479);
/* unused harmony reexport KatDataTable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__date_picker__ = __webpack_require__(1480);
/* unused harmony reexport KatDatePicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__date_range_picker__ = __webpack_require__(1481);
/* unused harmony reexport KatDateRangePicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__description_list__ = __webpack_require__(1482);
/* unused harmony reexport KatDescriptionList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__divider__ = __webpack_require__(1483);
/* unused harmony reexport KatDivider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__dropdown__ = __webpack_require__(1484);
/* unused harmony reexport KatDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__dropdown_button__ = __webpack_require__(1485);
/* unused harmony reexport KatDropdownButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__expander__ = __webpack_require__(1486);
/* unused harmony reexport KatExpander */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__file_upload__ = __webpack_require__(1487);
/* unused harmony reexport KatFileUpload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__filter_bar__ = __webpack_require__(1488);
/* unused harmony reexport KatFilterBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__flag__ = __webpack_require__(1489);
/* unused harmony reexport KatFlag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__flashbar__ = __webpack_require__(1490);
/* unused harmony reexport KatFlashbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__grid__ = __webpack_require__(1491);
/* unused harmony reexport KatGrid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__grid_item__ = __webpack_require__(1492);
/* unused harmony reexport KatGridItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__hero__ = __webpack_require__(1493);
/* unused harmony reexport KatHero */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__hero_actions__ = __webpack_require__(1494);
/* unused harmony reexport KatHeroActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__hero_details__ = __webpack_require__(1495);
/* unused harmony reexport KatHeroDetails */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__hero_extended_info__ = __webpack_require__(1496);
/* unused harmony reexport KatHeroExtendedInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__hero_image__ = __webpack_require__(1497);
/* unused harmony reexport KatHeroImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__hero_list_actions__ = __webpack_require__(1498);
/* unused harmony reexport KatHeroListActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__hero_section_header_group__ = __webpack_require__(1499);
/* unused harmony reexport KatHeroSectionHeaderGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__hero_status__ = __webpack_require__(1500);
/* unused harmony reexport KatHeroStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__hmd__ = __webpack_require__(1501);
/* unused harmony reexport KatHmd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__icon__ = __webpack_require__(1502);
/* unused harmony reexport KatIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__input__ = __webpack_require__(1503);
/* unused harmony reexport KatInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__input_group__ = __webpack_require__(1504);
/* unused harmony reexport KatInputGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__kpi_bar__ = __webpack_require__(1505);
/* unused harmony reexport KatKpiBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__kpi_bar_item__ = __webpack_require__(1506);
/* unused harmony reexport KatKpiBarItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__label__ = __webpack_require__(1507);
/* unused harmony reexport KatLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__layout__ = __webpack_require__(1508);
/* unused harmony reexport KatLayout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__link__ = __webpack_require__(1509);
/* unused harmony reexport KatLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__list__ = __webpack_require__(1510);
/* unused harmony reexport KatList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__metric__ = __webpack_require__(1511);
/* unused harmony reexport KatMetric */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__metric_actions__ = __webpack_require__(1512);
/* unused harmony reexport KatMetricActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__metric_amount__ = __webpack_require__(1513);
/* unused harmony reexport KatMetricAmount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__metric_control__ = __webpack_require__(1514);
/* unused harmony reexport KatMetricControl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__metric_simple__ = __webpack_require__(1515);
/* unused harmony reexport KatMetricSimple */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__metric_visualization__ = __webpack_require__(1516);
/* unused harmony reexport KatMetricVisualization */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__modal__ = __webpack_require__(1517);
/* unused harmony reexport KatModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__navigation__ = __webpack_require__(1518);
/* unused harmony reexport KatNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__navigation_section__ = __webpack_require__(1519);
/* unused harmony reexport KatNavigationSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__optgroup__ = __webpack_require__(1520);
/* unused harmony reexport KatOptgroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__option__ = __webpack_require__(1521);
/* unused harmony reexport KatOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__page_header__ = __webpack_require__(1522);
/* unused harmony reexport KatPageHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__page_header_alerts__ = __webpack_require__(1523);
/* unused harmony reexport KatPageHeaderAlerts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__page_header_page_actions__ = __webpack_require__(1524);
/* unused harmony reexport KatPageHeaderPageActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__page_header_utility_actions__ = __webpack_require__(1525);
/* unused harmony reexport KatPageHeaderUtilityActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__page_header_utility_links__ = __webpack_require__(1526);
/* unused harmony reexport KatPageHeaderUtilityLinks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__pagination__ = __webpack_require__(1527);
/* unused harmony reexport KatPagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__panel__ = __webpack_require__(1528);
/* unused harmony reexport KatPanel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__panel_wrapper__ = __webpack_require__(1529);
/* unused harmony reexport KatPanelWrapper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__popover__ = __webpack_require__(1530);
/* unused harmony reexport KatPopover */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__popover_hide__ = __webpack_require__(1531);
/* unused harmony reexport KatPopoverHide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__popover_trigger__ = __webpack_require__(1532);
/* unused harmony reexport KatPopoverTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__predictive_input__ = __webpack_require__(1533);
/* unused harmony reexport KatPredictiveInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__progress__ = __webpack_require__(1534);
/* unused harmony reexport KatProgress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__progressbar__ = __webpack_require__(1535);
/* unused harmony reexport KatProgressbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__radiobutton__ = __webpack_require__(1536);
/* unused harmony reexport KatRadiobutton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__radiobutton_group__ = __webpack_require__(1537);
/* unused harmony reexport KatRadiobuttonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__region_selector__ = __webpack_require__(1538);
/* unused harmony reexport KatRegionSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__row__ = __webpack_require__(1539);
/* unused harmony reexport KatRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__section_header__ = __webpack_require__(1540);
/* unused harmony reexport KatSectionHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__section_header_group__ = __webpack_require__(1541);
/* unused harmony reexport KatSectionHeaderGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__selection_card__ = __webpack_require__(1542);
/* unused harmony reexport KatSelectionCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__selection_card_group__ = __webpack_require__(1543);
/* unused harmony reexport KatSelectionCardGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__selection_list__ = __webpack_require__(1544);
/* unused harmony reexport KatSelectionList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__selection_list_item__ = __webpack_require__(1545);
/* unused harmony reexport KatSelectionListItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__spinner__ = __webpack_require__(1546);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_117__spinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__star_rating__ = __webpack_require__(1547);
/* unused harmony reexport KatStarRating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__statusindicator__ = __webpack_require__(1548);
/* unused harmony reexport KatStatusindicator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__statustracker__ = __webpack_require__(1549);
/* unused harmony reexport KatStatustracker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__summary__ = __webpack_require__(1550);
/* unused harmony reexport KatSummary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__tab__ = __webpack_require__(1551);
/* unused harmony reexport KatTab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__table__ = __webpack_require__(1552);
/* unused harmony reexport KatTable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__table_body__ = __webpack_require__(1553);
/* unused harmony reexport KatTableBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__table_cell__ = __webpack_require__(1554);
/* unused harmony reexport KatTableCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__table_footer__ = __webpack_require__(1555);
/* unused harmony reexport KatTableFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__table_head__ = __webpack_require__(1556);
/* unused harmony reexport KatTableHead */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__table_row__ = __webpack_require__(1557);
/* unused harmony reexport KatTableRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__tabs__ = __webpack_require__(1558);
/* unused harmony reexport KatTabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__tag__ = __webpack_require__(1559);
/* unused harmony reexport KatTag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__textarea__ = __webpack_require__(1560);
/* unused harmony reexport KatTextarea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__thumbnail__ = __webpack_require__(1561);
/* unused harmony reexport KatThumbnail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__tile__ = __webpack_require__(1562);
/* unused harmony reexport KatTile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__tile_container__ = __webpack_require__(1563);
/* unused harmony reexport KatTileContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__tile_grid__ = __webpack_require__(1564);
/* unused harmony reexport KatTileGrid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__tile_grid_container__ = __webpack_require__(1565);
/* unused harmony reexport KatTileGridContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__tile_primary_list__ = __webpack_require__(1566);
/* unused harmony reexport KatTilePrimaryList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__tile_secondary_list__ = __webpack_require__(1567);
/* unused harmony reexport KatTileSecondaryList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__tile_titles__ = __webpack_require__(1568);
/* unused harmony reexport KatTileTitles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__toast_group__ = __webpack_require__(1569);
/* unused harmony reexport KatToastGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__toggle__ = __webpack_require__(1570);
/* unused harmony reexport KatToggle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__tooltip__ = __webpack_require__(1571);
/* unused harmony reexport KatTooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__workflowtracker__ = __webpack_require__(1572);
/* unused harmony reexport KatWorkflowtracker */


















































































































































/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatAccordion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatAccordion = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-accordion', 'KatAccordion', {}, {});


/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPrimitive;
/**
 * Determine whether a value is a primitive. Primitive values are
 * string, number, boolean, null, undefined. Basically anything but object &
 * function.
 */
function isPrimitive(val) {
    if (val == null) {
        return true;
    }
    var valType = typeof val;
    return valType !== 'object' && valType !== 'function';
}


/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = forEach;
/**
 * Loop over each key/val pair of the given object, calling the callback for
 * each one.
 * @param obj The object to loop over.
 * @param cb The callback to call for each val/key pair.
 */
function forEach(obj, cb) {
    for (var key in obj) {
        var val = obj[key];
        cb(key, val);
    }
}


/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pickBy;
/**
 * Picks the key/value pairs from the given object that return true for the
 * given filter.
 * @param obj The object to pick from.
 * @param filter A filter function that will be called with each key/value pair.
 * @param modKey A function receiving the key, and returning the new key.
 * @return The filtered object.
 */
function pickBy(obj, filter, modKey) {
    var toReturn = {};
    for (var key in obj) {
        var val = obj[key];
        if (filter(key, val)) {
            var newKey = modKey ? modKey(key) : key;
            toReturn[newKey] = val;
        }
    }
    return toReturn;
}


/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEventHandler;
/**
 * Checks if the given name is a react event handler. Event handler names start
 * with "on", followed by a capital letter.
 */
function isEventHandler(name) {
    return /^on[A-Z]/.test(name);
}


/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isReactFalsy;
/**
 * Check if `val` would normally cause an attribute in react to be omitted,
 * instead of set to the literal value.
 * Returns true for `false`, `null`, and `undefined`.
 */
function isReactFalsy(val) {
    return val == null || val === false;
}


/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatAccordionItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatAccordionItem = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-accordion-item', 'KatAccordionItem', {
    'badgeLabel': 'badge-label',
    'badgeType': 'badge-type',
    'remainsExpanded': 'remains-expanded',
}, {
    'onCollapse': 'collapse',
    'onExpand': 'expand',
}, [
    'label',
    'badge',
]);


/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatActionBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatActionBar = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-action-bar', 'KatActionBar', {}, {}, [
    'actions',
]);


/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatActivityList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatActivityList = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-activity-list', 'KatActivityList', {}, {
    'onCollapse': 'collapse',
    'onExpand': 'expand',
});


/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatActivityListItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatActivityListItem = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-activity-list-item', 'KatActivityListItem', {}, {});


/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatAlert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatAlert = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-alert', 'KatAlert', {}, {
    'onDismiss': 'dismiss',
}, [
    'header',
    'cta',
]);


/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatAppLayout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatAppLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-app-layout', 'KatAppLayout', {}, {}, [
    'header',
    'top',
    'left',
    'bottom',
]);


/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBadge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBadge = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-badge', 'KatBadge', {}, {});


/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintDashboard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintDashboard = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-dashboard', 'KatBlueprintDashboard', {}, {});


/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintDashboardAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintDashboardAction = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-dashboard-action', 'KatBlueprintDashboardAction', {}, {});


/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintDashboardFocus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintDashboardFocus = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-dashboard-focus', 'KatBlueprintDashboardFocus', {}, {});


/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintDashboardIdentify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintDashboardIdentify = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-dashboard-identify', 'KatBlueprintDashboardIdentify', {}, {});


/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintDashboardOverview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintDashboardOverview = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-dashboard-overview', 'KatBlueprintDashboardOverview', {}, {});


/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintEntityDetail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintEntityDetail = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-entity-detail', 'KatBlueprintEntityDetail', {}, {});


/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintEntityDetailAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintEntityDetailAction = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-entity-detail-action', 'KatBlueprintEntityDetailAction', {}, {});


/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintEntityDetailFocus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintEntityDetailFocus = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-entity-detail-focus', 'KatBlueprintEntityDetailFocus', {}, {});


/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintEntityDetailIdentify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintEntityDetailIdentify = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-entity-detail-identify', 'KatBlueprintEntityDetailIdentify', {}, {});


/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintEntityDetailOverview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintEntityDetailOverview = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-entity-detail-overview', 'KatBlueprintEntityDetailOverview', {}, {});


/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintManageEntityList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintManageEntityList = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-manage-entity-list', 'KatBlueprintManageEntityList', {}, {});


/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintManageEntityListAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintManageEntityListAction = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-manage-entity-list-action', 'KatBlueprintManageEntityListAction', {}, {});


/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintManageEntityListFocus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintManageEntityListFocus = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-manage-entity-list-focus', 'KatBlueprintManageEntityListFocus', {}, {});


/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintManageEntityListIdentify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintManageEntityListIdentify = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-manage-entity-list-identify', 'KatBlueprintManageEntityListIdentify', {}, {});


/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintManageEntityListOverview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintManageEntityListOverview = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-manage-entity-list-overview', 'KatBlueprintManageEntityListOverview', {}, {});


/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintReport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintReport = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-report', 'KatBlueprintReport', {}, {});


/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintReportAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintReportAction = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-report-action', 'KatBlueprintReportAction', {}, {});


/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintReportContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintReportContext = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-report-context', 'KatBlueprintReportContext', {}, {});


/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintReportFocus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintReportFocus = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-report-focus', 'KatBlueprintReportFocus', {}, {});


/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintReportIdentify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintReportIdentify = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-report-identify', 'KatBlueprintReportIdentify', {}, {});


/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintReportOverview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintReportOverview = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-report-overview', 'KatBlueprintReportOverview', {}, {});


/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintWorkflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintWorkflow = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-workflow', 'KatBlueprintWorkflow', {}, {});


/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintWorkflowAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintWorkflowAction = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-workflow-action', 'KatBlueprintWorkflowAction', {}, {});


/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintWorkflowFocus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintWorkflowFocus = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-workflow-focus', 'KatBlueprintWorkflowFocus', {}, {});


/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintWorkflowIdentify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintWorkflowIdentify = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-workflow-identify', 'KatBlueprintWorkflowIdentify', {}, {});


/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBlueprintWorkflowOverview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBlueprintWorkflowOverview = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-blueprint-workflow-overview', 'KatBlueprintWorkflowOverview', {}, {});


/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBox = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-box', 'KatBox', {}, {});


/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBreadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBreadcrumb = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-breadcrumb', 'KatBreadcrumb', {
    'homeHref': 'home-href',
}, {});


/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatBreadcrumbItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatBreadcrumbItem = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-breadcrumb-item', 'KatBreadcrumbItem', {
    'iconName': 'icon-name',
}, {});


/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatButton = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-button', 'KatButton', {
    'fullWidth': 'full-width',
    'katAriaLabel': 'kat-aria-label',
}, {}, [
    'icon',
]);


/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatButtonGroup = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-button-group', 'KatButtonGroup', {}, {
    'onChange': 'change',
    'onCollapse': 'collapse',
    'onExpand': 'expand',
});


/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatCalendar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatCalendar = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-calendar', 'KatCalendar', {}, {
    'onChange': 'change',
    'onHide': 'hide',
});


/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatCard = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-card', 'KatCard', {
    'noBodyPadding': 'no-body-padding',
}, {}, [
    'title',
    'action',
    'subtitle',
    'footer',
]);


/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatCarousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatCarousel = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-carousel', 'KatCarousel', {
    'aspectHeight': 'aspect-height',
    'aspectWidth': 'aspect-width',
    'autoCycle': 'auto-cycle',
    'autoCyclePeriodMs': 'auto-cycle-period-ms',
    'disableNavArrows': 'disable-nav-arrows',
    'disableNavDots': 'disable-nav-dots',
    'katAriaLabel': 'kat-aria-label',
}, {
    'onSlideEnd': 'slideEnd',
    'onSlideStart': 'slideStart',
});


/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatCarouselImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatCarouselImage = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-carousel-image', 'KatCarouselImage', {
    'imageFit': 'image-fit',
    'katAriaLabel': 'kat-aria-label',
    'linkHref': 'link-href',
    'linkTarget': 'link-target',
}, {});


/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatCarouselItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatCarouselItem = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-carousel-item', 'KatCarouselItem', {}, {});


/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatCarouselItems */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatCarouselItems = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-carousel-items', 'KatCarouselItems', {}, {});


/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatChangeoverAnchor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatChangeoverAnchor = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-changeover-anchor', 'KatChangeoverAnchor', {
    'alignX': 'align-x',
    'alignY': 'align-y',
    'dismissDelay': 'dismiss-delay',
}, {
    'onChange': 'change',
    'onHide': 'hide',
    'onShow': 'show',
}, [
    'cta',
]);


/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatCheckbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatCheckbox = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-checkbox', 'KatCheckbox', {
    'constraintLabel': 'constraint-label',
    'katAriaLabel': 'kat-aria-label',
    'katAriaLabelledby': 'kat-aria-labelledby',
}, {
    'onChange': 'change',
});


/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatColumn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

function getClasses(props) {
    var classes = [];
    for (var bp in props) {
        var size = props[bp];
        if (size) {
            classes.push("kat-col-" + bp + "-" + size);
        }
    }
    if (classes.length === 0) {
        throw new Error('KatColumn requires at least one break point (xs, sm, md, lg)');
    }
    return classes;
}
// eslint-disable-next-line import/export
var KatColumn = function (props) {
    var id = props.id, className = props.className, children = props.children, xs = props.xs, sm = props.sm, md = props.md, lg = props.lg, delegated = __rest(props, ["id", "className", "children", "xs", "sm", "md", "lg"]);
    var bps = getClasses({ xs: xs, sm: sm, md: md, lg: lg });
    var cn = (className || '') + " " + bps.join(' ');
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", __assign({ id: id, className: cn }, delegated), children));
};
KatColumn.displayName = 'KatColumn';


/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatCurrencySelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatCurrencySelector = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-currency-selector', 'KatCurrencySelector', {
    'maxHeight': 'max-height',
    'mobileLabel': 'mobile-label',
    'showClear': 'show-clear',
    'stateEmphasis': 'state-emphasis',
    'stateLabel': 'state-label',
}, {
    'onChange': 'change',
    'onCollapse': 'collapse',
    'onExpand': 'expand',
});


/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatDataGrid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatDataGrid = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-data-grid', 'KatDataGrid', {
    'actionColMinWidth': 'action-col-min-width',
    'additionalFilter': 'additional-filter',
    'allFilter': 'all-filter',
    'alwaysAutoSizeColumns': 'always-auto-size-columns',
    'autoFilterRowCount': 'auto-filter-row-count',
    'autoHeight': 'auto-height',
    'bulkEdit': 'bulk-edit',
    'clientSideData': 'client-side-data',
    'detailRowHeight': 'detail-row-height',
    'indefiniteResultsSize': 'indefinite-results-size',
    'isLoading': 'is-loading',
    'licenseKey': 'license-key',
    'loadingText': 'loading-text',
    'masterDetail': 'master-detail',
    'noFilteredResultsMessage': 'no-filtered-results-message',
    'noResultsMessage': 'no-results-message',
    'pageSize': 'page-size',
    'paginationPrefix': 'pagination-prefix',
    'primaryKeyField': 'primary-key-field',
    'resultsPerPageOptions': 'results-per-page-options',
    'rowData': 'row-data',
    'rowEdit': 'row-edit',
    'searchOptions': 'search-options',
    'searchPlaceholder': 'search-placeholder',
    'searchTerm': 'search-term',
    'showSearchDropDown': 'show-search-drop-down',
    'totalRowCount': 'total-row-count',
    'totalRowCountAfterFilter': 'total-row-count-after-filter',
}, {
    'onCustomFilterChanged': 'customFilterChanged',
    'onFiltersCleared': 'filtersCleared',
    'onGridReady': 'gridReady',
    'onRowsEdited': 'rowsEdited',
    'onSelectionChanged': 'selectionChanged',
}, [
    'filter',
    'selection-actionbar',
    'custom-controls',
]);


/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatDataTable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatDataTable = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-data-table', 'KatDataTable', {
    'titleLabel': 'title-label',
}, {
    'onRowDataChanged': 'rowDataChanged',
    'onSelectAll': 'selectAll',
    'onSelectRow': 'selectRow',
    'onSelectionChanged': 'selectionChanged',
    'onSettingsChanged': 'settingsChanged',
    'onSortColumnChanged': 'sortColumnChanged',
    'onUnselectAll': 'unselectAll',
    'onUnselectRow': 'unselectRow',
});


/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatDatePicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatDatePicker = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-date-picker', 'KatDatePicker', {
    'constraintEmphasis': 'constraint-emphasis',
    'constraintLabel': 'constraint-label',
    'katAriaLabel': 'kat-aria-label',
    'showClear': 'show-clear',
    'stateEmphasis': 'state-emphasis',
    'stateLabel': 'state-label',
    'tooltipPosition': 'tooltip-position',
    'tooltipText': 'tooltip-text',
    'tooltipTriggerIcon': 'tooltip-trigger-icon',
}, {
    'onChange': 'change',
    'onInvalid': 'invalid',
});


/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatDateRangePicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatDateRangePicker = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-date-range-picker', 'KatDateRangePicker', {
    'endLabel': 'end-label',
    'endName': 'end-name',
    'endValue': 'end-value',
    'startLabel': 'start-label',
    'startName': 'start-name',
    'startValue': 'start-value',
}, {
    'onChange': 'change',
});


/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatDescriptionList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatDescriptionList = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-description-list', 'KatDescriptionList', {}, {});


/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatDivider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatDivider = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-divider', 'KatDivider', {}, {});


/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatDropdown = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-dropdown', 'KatDropdown', {
    'constraintEmphasis': 'constraint-emphasis',
    'constraintLabel': 'constraint-label',
    'expandDirection': 'expand-direction',
    'katAriaLabel': 'kat-aria-label',
    'maxHeight': 'max-height',
    'mobileLabel': 'mobile-label',
    'multipleHideSelect': 'multiple-hide-select',
    'multipleShowApply': 'multiple-show-apply',
    'multipleStickyApply': 'multiple-sticky-apply',
    'richSelectionLabel': 'rich-selection-label',
    'showClear': 'show-clear',
    'stateEmphasis': 'state-emphasis',
    'stateLabel': 'state-label',
    'tooltipPosition': 'tooltip-position',
    'tooltipText': 'tooltip-text',
    'tooltipTriggerIcon': 'tooltip-trigger-icon',
}, {
    'onChange': 'change',
    'onCollapse': 'collapse',
    'onExpand': 'expand',
});


/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatDropdownButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatDropdownButton = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-dropdown-button', 'KatDropdownButton', {
    'singleTarget': 'single-target',
    'singleTargetIcon': 'single-target-icon',
    'singleTargetLabel': 'single-target-label',
}, {
    'onAction': 'action',
    'onCollapse': 'collapse',
    'onExpand': 'expand',
});


/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatExpander */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatExpander = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-expander', 'KatExpander', {
    'badgeLabel': 'badge-label',
    'badgeType': 'badge-type',
}, {
    'onCollapse': 'collapse',
    'onExpand': 'expand',
}, [
    'label',
    'badge',
    'toggle',
]);


/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatFileUpload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatFileUpload = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-file-upload', 'KatFileUpload', {
    'fileStates': 'file-states',
    'fileView': 'file-view',
    'hideClearAll': 'hide-clear-all',
    'maxFilesPerGridRow': 'max-files-per-grid-row',
    'maxSize': 'max-size',
}, {
    'onFilesAttached': 'filesAttached',
    'onFilesAttachedError': 'filesAttachedError',
    'onFilesRemoved': 'filesRemoved',
    'onFilesReplaced': 'filesReplaced',
}, [
    'label',
    'hint',
    'error',
    'constraints-message',
    'file-thumbnail-FILE_NAME',
    'file-error-summary-FILE_NAME',
    'file-error-detail-FILE_NAME',
]);


/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatFilterBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatFilterBar = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-filter-bar', 'KatFilterBar', {
    'katFilterBarAction': 'KatFilterBarAction',
    'showActionApply': 'show-action-apply',
    'showActionClear': 'show-action-clear',
    'showActionFilters': 'show-action-filters',
    'showActionSearch': 'show-action-search',
    'showActionSettings': 'show-action-settings',
    'showActionSort': 'show-action-sort',
    'showFilterCreate': 'show-filter-create',
    'showFilterEdit': 'show-filter-edit',
}, {
    'onAction': 'action',
}, [
    'quick-filters',
]);


/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatFlag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatFlag = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-flag', 'KatFlag', {}, {});


/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatFlashbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatFlashbar = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-flashbar', 'KatFlashbar', {
    'linkHref': 'link-href',
    'linkLabel': 'link-label',
    'linkPreventDefault': 'link-prevent-default',
    'linkTarget': 'link-target',
}, {
    'onDismissed': 'dismissed',
    'onLinkClick': 'link-click',
});


/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatGrid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatGrid = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-grid', 'KatGrid', {
    'colsL': 'cols-l',
    'colsM': 'cols-m',
    'colsS': 'cols-s',
    'colsXl': 'cols-xl',
    'colsXxl': 'cols-xxl',
    'verticalList': 'vertical-list',
}, {});


/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatGridItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatGridItem = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-grid-item', 'KatGridItem', {}, {});


/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatHero */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatHero = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-hero', 'KatHero', {
    'extendedInfoLabel': 'extended-info-label',
}, {});


/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatHeroActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatHeroActions = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-hero-actions', 'KatHeroActions', {}, {});


/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatHeroDetails */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatHeroDetails = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-hero-details', 'KatHeroDetails', {}, {});


/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatHeroExtendedInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatHeroExtendedInfo = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-hero-extended-info', 'KatHeroExtendedInfo', {}, {});


/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatHeroImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatHeroImage = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-hero-image', 'KatHeroImage', {}, {});


/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatHeroListActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatHeroListActions = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-hero-list-actions', 'KatHeroListActions', {}, {});


/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatHeroSectionHeaderGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatHeroSectionHeaderGroup = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-hero-section-header-group', 'KatHeroSectionHeaderGroup', {}, {});


/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatHeroStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatHeroStatus = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-hero-status', 'KatHeroStatus', {}, {});


/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatHmd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatHmd = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-hmd', 'KatHmd', {
    'ratingStyle': 'rating-style',
}, {
    'onClose': 'close',
    'onOpen': 'open',
    'onSubmit': 'submit',
});


/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-icon', 'KatIcon', {
    'katAriaLabel': 'kat-aria-label',
}, {});


/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatInput = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-input', 'KatInput', {
    'constraintEmphasis': 'constraint-emphasis',
    'constraintLabel': 'constraint-label',
    'katAriaLabel': 'kat-aria-label',
    'katSpellcheck': 'kat-spellcheck',
    'showClear': 'show-clear',
    'stateEmphasis': 'state-emphasis',
    'stateLabel': 'state-label',
    'tooltipPosition': 'tooltip-position',
    'tooltipText': 'tooltip-text',
    'tooltipTriggerIcon': 'tooltip-trigger-icon',
    'uniqueId': 'unique-id',
}, {
    'onBlur': 'blur',
    'onChange': 'change',
    'onFocus': 'focus',
    'onInput': 'input',
    'onKeydown': 'keydown',
    'onKeyup': 'keyup',
    'onMouseup': 'mouseup',
});


/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatInputGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatInputGroup = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-input-group', 'KatInputGroup', {}, {});


/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatKpiBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatKpiBar = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-kpi-bar', 'KatKpiBar', {}, {}, [
    'kpi-bar-utility-actions',
]);


/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatKpiBarItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatKpiBarItem = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-kpi-bar-item', 'KatKpiBarItem', {
    'secondaryLabel': 'secondary-label',
    'showControlIcon': 'show-control-icon',
    'trendPolarity': 'trend-polarity',
}, {
    'onControlClick': 'controlClick',
}, [
    'error',
]);


/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatLabel = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-label', 'KatLabel', {
    'tooltipPosition': 'tooltip-position',
    'tooltipText': 'tooltip-text',
    'tooltipTriggerIcon': 'tooltip-trigger-icon',
    'uniqueId': 'unique-id',
}, {});


/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatLayout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatLayout = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-layout', 'KatLayout', {
    'collapseLeft': 'collapse-left',
    'collapseRight': 'collapse-right',
}, {}, [
    'main',
    'right',
    'left',
]);


/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatLink = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-link', 'KatLink', {
    'katAriaLabel': 'kat-aria-label',
}, {});


/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatList = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-list', 'KatList', {}, {});


/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatMetric */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatMetric = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-metric', 'KatMetric', {
    'headerClickable': 'header-clickable',
    'trendPolarity': 'trend-polarity',
    'trendValue': 'trend-value',
}, {
    'onClicked': 'clicked',
}, [
    'control',
    'actions',
    'amount',
    'visualization',
]);


/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatMetricActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatMetricActions = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-metric-actions', 'KatMetricActions', {}, {});


/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatMetricAmount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatMetricAmount = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-metric-amount', 'KatMetricAmount', {}, {});


/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatMetricControl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatMetricControl = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-metric-control', 'KatMetricControl', {}, {});


/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatMetricSimple */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatMetricSimple = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-metric-simple', 'KatMetricSimple', {
    'headerClickable': 'header-clickable',
    'trendPolarity': 'trend-polarity',
    'trendValue': 'trend-value',
}, {});


/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatMetricVisualization */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatMetricVisualization = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-metric-visualization', 'KatMetricVisualization', {
    'class': 'class',
}, {});


/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatModal = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-modal', 'KatModal', {
    'noCloseIcon': 'no-close-icon',
    'scrollAll': 'scroll-all',
}, {
    'onClose': 'close',
    'onOpen': 'open',
}, [
    'title',
    'footer',
]);


/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatNavigation = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-navigation', 'KatNavigation', {}, {}, [
    'label',
]);


/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatNavigationSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatNavigationSection = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-navigation-section', 'KatNavigationSection', {}, {});


/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatOptgroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatOptgroup = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-optgroup', 'KatOptgroup', {
    'multipleHideSelect': 'multiple-hide-select',
}, {}, [
    'label',
]);


/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatOption = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-option', 'KatOption', {}, {});


/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatPageHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatPageHeader = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-page-header', 'KatPageHeader', {}, {});


/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatPageHeaderAlerts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatPageHeaderAlerts = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-page-header-alerts', 'KatPageHeaderAlerts', {}, {});


/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatPageHeaderPageActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatPageHeaderPageActions = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-page-header-page-actions', 'KatPageHeaderPageActions', {}, {});


/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatPageHeaderUtilityActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatPageHeaderUtilityActions = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-page-header-utility-actions', 'KatPageHeaderUtilityActions', {}, {});


/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatPageHeaderUtilityLinks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatPageHeaderUtilityLinks = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-page-header-utility-links', 'KatPageHeaderUtilityLinks', {}, {});


/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatPagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatPagination = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-pagination', 'KatPagination', {
    'itemsPerPage': 'items-per-page',
    'itemsPerPageOptions': 'items-per-page-options',
    'openEnded': 'open-ended',
    'totalItems': 'total-items',
}, {
    'onChange': 'change',
    'onItemsPerPageChange': 'items-per-page-change',
    'onPageChanged': 'page-changed',
});


/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatPanel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatPanel = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-panel', 'KatPanel', {
    'disableAnimation': 'disable-animation',
    'katAriaLabel': 'kat-aria-label',
}, {
    'onClose': 'close',
    'onOpen': 'open',
}, [
    'header',
]);


/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatPanelWrapper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatPanelWrapper = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-panel-wrapper', 'KatPanelWrapper', {
    'maskBackground': 'mask-background',
    'panelVisible': 'panel-visible',
}, {}, [
    'panel',
]);


/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatPopover */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatPopover = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-popover', 'KatPopover', {
    'disableMobileFullWidth': 'disable-mobile-full-width',
    'hideBehavior': 'hide-behavior',
    'katAriaBehavior': 'kat-aria-behavior',
    'triggerType': 'trigger-type',
}, {
    'onHide': 'hide',
    'onShow': 'show',
}, [
    'trigger',
]);


/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatPopoverHide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatPopoverHide = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-popover-hide', 'KatPopoverHide', {}, {});


/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatPopoverTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatPopoverTrigger = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-popover-trigger', 'KatPopoverTrigger', {}, {});


/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatPredictiveInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatPredictiveInput = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-predictive-input', 'KatPredictiveInput', {
    'constraintEmphasis': 'constraint-emphasis',
    'constraintLabel': 'constraint-label',
    'filterType': 'filter-type',
    'isLoading': 'is-loading',
    'katAriaLabel': 'kat-aria-label',
    'katSpellcheck': 'kat-spellcheck',
    'maxHeight': 'max-height',
    'showClear': 'show-clear',
    'stateEmphasis': 'state-emphasis',
    'stateLabel': 'state-label',
    'tooltipPosition': 'tooltip-position',
    'tooltipText': 'tooltip-text',
    'tooltipTriggerIcon': 'tooltip-trigger-icon',
    'uniqueId': 'unique-id',
    'virtualScroll': 'virtual-scroll',
}, {
    'onBlur': 'blur',
    'onChange': 'change',
    'onCollapse': 'collapse',
    'onExpand': 'expand',
    'onFocus': 'focus',
    'onInput': 'input',
    'onKeydown': 'keydown',
    'onMouseup': 'mouseup',
    'onOnLoadItems': 'onLoadItems',
});


/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatProgress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatProgress = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-progress', 'KatProgress', {
    'endValue': 'end-value',
    'hideValue': 'hide-value',
    'katAriaLabel': 'kat-aria-label',
    'startValue': 'start-value',
}, {}, [
    'label',
]);


/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatProgressbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatProgressbar = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-progressbar', 'KatProgressbar', {}, {});


/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatRadiobutton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatRadiobutton = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-radiobutton', 'KatRadiobutton', {
    'constraintLabel': 'constraint-label',
    'katAriaLabel': 'kat-aria-label',
    'katAriaLabelledby': 'kat-aria-labelledby',
    'uniqueId': 'unique-id',
}, {
    'onBlur': 'blur',
    'onChange': 'change',
    'onFocus': 'focus',
});


/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatRadiobuttonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatRadiobuttonGroup = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-radiobutton-group', 'KatRadiobuttonGroup', {
    'constraintLabel': 'constraint-label',
    'errorLabel': 'error-label',
}, {
    'onBlur': 'blur',
    'onChange': 'change',
    'onFocus': 'focus',
}, [
    'label',
]);


/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatRegionSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatRegionSelector = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-region-selector', 'KatRegionSelector', {
    'maxHeight': 'max-height',
    'mobileLabel': 'mobile-label',
    'showClear': 'show-clear',
    'stateEmphasis': 'state-emphasis',
    'stateLabel': 'state-label',
}, {
    'onChange': 'change',
    'onCollapse': 'collapse',
    'onExpand': 'expand',
});


/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

// eslint-disable-next-line import/export
var KatRow = function (_a) {
    var id = _a.id, children = _a.children, className = _a.className, noGutters = _a.noGutters, delegated = __rest(_a, ["id", "children", "className", "noGutters"]);
    var gutters = noGutters ? 'kat-no-gutters' : '';
    var cn = "kat-row " + gutters + " " + (className || '');
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", __assign({ id: id, className: cn }, delegated), children));
};
KatRow.displayName = 'KatRow';


/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatSectionHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatSectionHeader = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-section-header', 'KatSectionHeader', {
    'actionIcon': 'action-icon',
    'actionLabel': 'action-label',
    'statusType': 'status-type',
}, {
    'onAction': 'action',
    'onCollapse': 'collapse',
    'onExpand': 'expand',
});


/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatSectionHeaderGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatSectionHeaderGroup = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-section-header-group', 'KatSectionHeaderGroup', {
    'colsL': 'cols-l',
    'colsM': 'cols-m',
    'colsS': 'cols-s',
    'colsXl': 'cols-xl',
    'colsXxl': 'cols-xxl',
}, {});


/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatSelectionCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatSelectionCard = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-selection-card', 'KatSelectionCard', {
    'imageAlt': 'image-alt',
    'imageSrc': 'image-src',
}, {
    'onChange': 'change',
}, [
    'subheader',
    'body',
    'footer',
    'image',
]);


/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatSelectionCardGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatSelectionCardGroup = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-selection-card-group', 'KatSelectionCardGroup', {}, {
    'onChange': 'change',
});


/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatSelectionList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatSelectionList = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-selection-list', 'KatSelectionList', {}, {
    'onChange': 'change',
}, [
    'title',
]);


/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatSelectionListItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatSelectionListItem = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-selection-list-item', 'KatSelectionListItem', {}, {});


/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KatSpinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatSpinner = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-spinner', 'KatSpinner', {}, {});


/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatStarRating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatStarRating = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-star-rating', 'KatStarRating', {
    'errorLabel': 'error-label',
}, {
    'onChange': 'change',
});


/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatStatusindicator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatStatusindicator = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-statusindicator', 'KatStatusindicator', {
    'katAriaLabel': 'kat-aria-label',
}, {});


/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatStatustracker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatStatustracker = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-statustracker', 'KatStatustracker', {}, {});


/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatSummary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatSummary = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-summary', 'KatSummary', {}, {}, [
    'actions',
]);


/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTab = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-tab', 'KatTab', {
    'overflowTabSelected': 'overflow-tab-selected',
    'secondaryLabel': 'secondary-label',
    'tabId': 'tab-id',
    'trendPolarity': 'trend-polarity',
}, {}, [
    'label',
    'status',
]);


/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTable = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-table', 'KatTable', {}, {});


/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTableBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTableBody = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-table-body', 'KatTableBody', {}, {});


/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTableCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTableCell = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-table-cell', 'KatTableCell', {}, {});


/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTableFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTableFooter = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-table-footer', 'KatTableFooter', {}, {});


/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTableHead */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTableHead = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-table-head', 'KatTableHead', {}, {});


/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTableRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTableRow = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-table-row', 'KatTableRow', {}, {});


/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTabs = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-tabs', 'KatTabs', {
    'addOffset': 'add-offset',
    'fullWidthTabs': 'full-width-tabs',
    'tabsBeforeOverflow': 'tabs-before-overflow',
}, {
    'onChange': 'change',
});


/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTag = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-tag', 'KatTag', {
    'katAriaLabel': 'kat-aria-label',
}, {
    'onDismiss': 'dismiss',
});


/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTextarea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTextarea = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-textarea', 'KatTextarea', {
    'constraintEmphasis': 'constraint-emphasis',
    'constraintLabel': 'constraint-label',
    'katAriaLabel': 'kat-aria-label',
    'katSpellcheck': 'kat-spellcheck',
    'stateEmphasis': 'state-emphasis',
    'stateLabel': 'state-label',
    'tooltipPosition': 'tooltip-position',
    'tooltipText': 'tooltip-text',
    'tooltipTriggerIcon': 'tooltip-trigger-icon',
    'uniqueId': 'unique-id',
}, {
    'onBlur': 'blur',
    'onChange': 'change',
    'onFocus': 'focus',
    'onInput': 'input',
    'onKeydown': 'keydown',
    'onKeyup': 'keyup',
    'onMouseup': 'mouseup',
});


/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatThumbnail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatThumbnail = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-thumbnail', 'KatThumbnail', {
    'altText': 'alt-text',
}, {});


/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTile = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-tile', 'KatTile', {
    'imageHeight': 'image-height',
}, {
    'onClick': 'click',
    'onSelected': 'selected',
});


/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTileContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTileContainer = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-tile-container', 'KatTileContainer', {}, {});


/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTileGrid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTileGrid = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-tile-grid', 'KatTileGrid', {
    'gridWidth': 'grid-width',
}, {});


/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTileGridContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTileGridContainer = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-tile-grid-container', 'KatTileGridContainer', {}, {});


/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTilePrimaryList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTilePrimaryList = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-tile-primary-list', 'KatTilePrimaryList', {}, {});


/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTileSecondaryList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTileSecondaryList = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-tile-secondary-list', 'KatTileSecondaryList', {}, {});


/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTileTitles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTileTitles = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-tile-titles', 'KatTileTitles', {}, {});


/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatToastGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatToastGroup = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-toast-group', 'KatToastGroup', {}, {
    'onCtaClicked': 'ctaClicked',
    'onToastClosed': 'toastClosed',
    'onToastOpened': 'toastOpened',
});


/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatToggle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatToggle = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-toggle', 'KatToggle', {
    'textChecked': 'text-checked',
    'textUnchecked': 'text-unchecked',
    'uniqueId': 'unique-id',
}, {
    'onChange': 'change',
}, [
    'unchecked',
]);


/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatTooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatTooltip = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-tooltip', 'KatTooltip', {
    'katAriaLabel': 'kat-aria-label',
    'katAriaTrigger': 'kat-aria-trigger',
    'triggerIcon': 'trigger-icon',
    'triggerText': 'trigger-text',
}, {});


/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KatWorkflowtracker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__ = __webpack_require__(3);

var KatWorkflowtracker = Object(__WEBPACK_IMPORTED_MODULE_0__utils_createCustomElementWrapper__["a" /* default */])('kat-workflowtracker', 'KatWorkflowtracker', {}, {
    'onClick': 'click',
});


/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLocale; });
/* harmony export (immutable) */ __webpack_exports__["a"] = getDirection;
/* harmony export (immutable) */ __webpack_exports__["c"] = getMessages;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_locales_en_json__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_locales_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__i18n_locales_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_locales_es_json__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_locales_es_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__i18n_locales_es_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_locales_fr_json__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_locales_fr_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__i18n_locales_fr_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_locales_it_json__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_locales_it_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__i18n_locales_it_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_locales_ja_json__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_locales_ja_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__i18n_locales_ja_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_locales_de_json__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_locales_de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__i18n_locales_de_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_locales_ar_json__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_locales_ar_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__i18n_locales_ar_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ParentDataHandler__ = __webpack_require__(51);
var fetchLocale=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var localeResponse,locale;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_9__ParentDataHandler__["d" /* getLocaleFromParent */])();case 2:localeResponse=_context2.sent;if(!(__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_204" /* TIMEOUT_STRING */]===localeResponse)){_context2.next=5;break;}return _context2.abrupt('return',navigator.language);case 5:locale=JSON.parse(localeResponse.locale);if(!(__WEBPACK_IMPORTED_MODULE_8__util_Constants__["_25" /* EMPTY_STRING */]===locale)){_context2.next=8;break;}return _context2.abrupt('return',navigator.language);case 8:return _context2.abrupt('return',locale);case 9:case'end':return _context2.stop();}}},_callee2,this);}));return function fetchLocale(){return _ref2.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getLocale=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var locale;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetchLocale();case 2:locale=_context.sent;_context.t0=locale;_context.next=_context.t0==="de"?6:_context.t0==="de-DE"?6:_context.t0==="de-CH"?6:_context.t0==="de-AT"?6:_context.t0==="de-LU"?6:_context.t0==="de-LI"?6:_context.t0==="es"?7:_context.t0==="es-ES"?7:_context.t0==="es-AR"?7:_context.t0==="es-GT"?7:_context.t0==="es-CR"?7:_context.t0==="es-PA"?7:_context.t0==="es-DO"?7:_context.t0==="es-MX"?7:_context.t0==="es-VE"?7:_context.t0==="es-CO"?7:_context.t0==="es-PE"?7:_context.t0==="es-EC"?7:_context.t0==="es-CL"?7:_context.t0==="es-UY"?7:_context.t0==="es-PY"?7:_context.t0==="es-BO"?7:_context.t0==="es-SV"?7:_context.t0==="es-HN"?7:_context.t0==="es-NI"?7:_context.t0==="es-PR"?7:_context.t0==="ja"?8:_context.t0==="ja-JP"?8:_context.t0==="it"?9:_context.t0==="it-IT"?9:_context.t0==="it-CH"?9:_context.t0==="fr"?10:_context.t0==="fr-FR"?10:_context.t0==="fr-BE"?10:_context.t0==="fr-CA"?10:_context.t0==="fr-CH"?10:_context.t0==="fr-LU"?10:_context.t0==="ar"?11:_context.t0==="ar-SA"?11:_context.t0==="ar-IQ"?11:_context.t0==="ar-EG"?11:_context.t0==="ar-LY"?11:_context.t0==="ar-DZ"?11:_context.t0==="ar-MA"?11:_context.t0==="ar-TN"?11:_context.t0==="ar-OM"?11:_context.t0==="ar-YE"?11:_context.t0==="ar-SY"?11:_context.t0==="ar-JO"?11:_context.t0==="ar-LB"?11:_context.t0==="ar-KW"?11:_context.t0==="ar-AE"?11:_context.t0==="ar-BH"?11:_context.t0==="ar-QA"?11:12;break;case 6:return _context.abrupt('return',"de");case 7:return _context.abrupt('return',"es");case 8:return _context.abrupt('return',"ja");case 9:return _context.abrupt('return',"it");case 10:return _context.abrupt('return',"fr");case 11:return _context.abrupt('return',"ar");case 12:return _context.abrupt('return',"en");case 13:case'end':return _context.stop();}}},_callee,this);}));return function getLocale(){return _ref.apply(this,arguments);};}();function getDirection(locale){return locale==="ar"?"rtl":"ltr";}function getMessages(locale){switch(locale){case"en":return __WEBPACK_IMPORTED_MODULE_1__i18n_locales_en_json___default.a;case"es":return __WEBPACK_IMPORTED_MODULE_2__i18n_locales_es_json___default.a;case"fr":return __WEBPACK_IMPORTED_MODULE_3__i18n_locales_fr_json___default.a;case"it":return __WEBPACK_IMPORTED_MODULE_4__i18n_locales_it_json___default.a;case"ja":return __WEBPACK_IMPORTED_MODULE_5__i18n_locales_ja_json___default.a;case"de":return __WEBPACK_IMPORTED_MODULE_6__i18n_locales_de_json___default.a;case"ar":return __WEBPACK_IMPORTED_MODULE_7__i18n_locales_ar_json___default.a;default:return __WEBPACK_IMPORTED_MODULE_1__i18n_locales_en_json___default.a;}}

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

module.exports = {"external.logs":"Panel de log","external.dashboard":"Panel de ingeniería","asl.heading":"Dispositivos ASL","thinclients.heading":"Clientes delgados","adta.heading":"Dispositivos ADTA","zancasort.heading":"Dispositivos ZancaSort","tesseract.heading":"Dispositivos Teseracto","autoretriever.heading":"Recuperador automático","common.data_last_updated":"Datos actualizados por última vez","adta.connected":"Conexo","sbl.heading":"Dispositivos SBL","device.name":"Nombre","device.location":"Ubicación","device.mac_ip":"Dirección MAC/IP","device.device_type":"Tipo de dispositivo","device.component_type":"Tipo de componente","device.connection":"Estado de conexión","device.action":"Acción","device.pick_stations":"puesto de picking","device.add_device_button_modal":"Añadir/actualizar la configuración de un solo dispositivo","device.delete_device_button_modal":"Eliminar configuración de dispositivo único","device.edit_device_mac_modal":"Editar la dirección MAC de un solo dispositivo","device.delete_config_button_modal":"Eliminar la configuración de destino del clasificador","device.delete_divert_config_button_modal":"Eliminar configuración de desvío guiado","device.edit_config":"Agregar o editar la configuración","device.device_category":"Localización de dispositivos fuera de línea","device.offline_devices_locations":"Ubicaciones de dispositivos sin conexión","asl.desc":"Esta página muestra el estado en tiempo real de los dispositivos ASL junto con el dispositivo y la configuración de desvío guiado de ASL","adta.desc":"Esta página muestra el estado en tiempo real de los dispositivos ADTA junto con la configuración del destino del clasificador y del paquete de prueba del clasificador","sbl.desc":"Esta página muestra el estado en tiempo real de los controladores LED junto con la dirección MAC/IP y la conectividad","thinclient.desc":"Esta página muestra el estado en tiempo real de los dispositivos Thin Client junto con la dirección MAC/IP y el estado de salud","device.vlan":"VLAN","device.usecase":"Caso de uso","device.status":"Estado","device.swstatus":"Estado del software","device.remark":"Observación","device.monitoring":"Estado de monitorización","device.monitoringEnabled":"Habilitado","device.monitoringDisabled":"Discapacitado","device.invalidEntry":"Entrada no válida","device.editWarning":"Está a punto de realizar un cambio que afectará temporalmente al funcionamiento de ASL/ADTA. Asegúrese de que no haya ningún ciclo en ejecución en estas máquinas antes de continuar","actions.deleteDevice":"Eliminar dispositivo","actions.addDevice":"Editar dispositivo","actions.edit":"Editar mediante JSON","actions.changeMac":"Cambiar la dirección MAC del dispositivo","actions.toggleStowStations":"Alternar estaciones de almacenamiento","actions.monitoring_disable":"Desactivar la monitorización","actions.monitoring_enable":"Habilitar monitorización","actions.deploydraft":"Despliegue el borrador","actions.discarddraft":"Descartar borrador","actions.rollback":"Reversión","actions.deploy":"Desplegar","actions.restart":"Reiniciar aplicación","button.add":"Añadir/editar mediante JSON","button.addcsv":"Añadir/editar mediante CSV","button.delete":"Eliminar dispositivo","button.save":"Guardar","button.edit":"Editar","pickstation.label":"Puesto de picking","pickstation.no_resources":"No se encontraron puestos de picking para esta estación.","modal.adta_heading":"DATOS","modal.asl_heading":"ASL","modal.confirm":"Confirmar","modal.confirmAdd":"Confirmar añadir","modal.confirmEdit":"Confirmar edición","modal.cancel":"Cancelar","modal.copy":"Copiar","modal.paste":"Pegar","modal.remove":"Eliminar","modal.selectusecase":"Seleccionar caso de uso","modal.selectnewusecase":"Seleccione un nuevo caso de uso para Thin Client.","modal.confirmchangeusecase":"Confirme el nuevo caso de uso de Thin Client que ha seleccionado.","tab.testing":"Probando","tab.sbldashboard":"Panel de control SBL","tab.configuration":"Configuración","tab.aisleconfigfinder":"SBL Config Finder","tab.overview":"Resumen","tab.logstream":"Flujo de registro","tab.managebyexceptions":"Administrar por excepciones","tab.lidartester":"Probador Lidar","deviceManagement.filters":"Seleccione el tipo de dispositivo","deviceManagement.tag":"Tipo de dispositivo","deviceManagement.noresults":"No hay resultados","modal.mac":"Dirección MAC","modal.startAisle":"Pasillo de inicio","modal.startPort":"Puerto de inicio","modal.aisleCount":"Cantidad de pasillos","modal.config":"Rellene el JSON de configuración","modal.configcsv":"Cargue el archivo CSV de configuración.","modal.macdelete":"Introduzca la dirección MAC del dispositivo que desea eliminar.","modal.selectmacdelete":"Seleccione la dirección MAC que desee eliminar.","modal.confirmmacdelete":"Confirme que desea eliminar el siguiente dispositivo:","modal.confirmmacedit":"Introduzca la nueva dirección MAC para el siguiente dispositivo:","modal.deleteAll":"Eliminar todo","modal.bayiddelete":"Selecciona el ID de bahía que deseas eliminar:","modal.selectbayid":"Seleccione el ID de bahía","modal.divertcodedelete":"Introduzca el código de desvío que desea eliminar","modal.select_divert_code":"Seleccione el código de desvío que desee eliminar.","modal.pick_stations":"puesto de picking","modal.pick_stations_desc":"Introduzca las etiquetas de las estaciones de selección asociadas separadas por (;)","modal.device_id":"ID del dispositivo","modal.device_id_line_desc":"Identificador local único para el dispositivo. Por ejemplo, «3\" para «Línea 3\"","modal.device_id_finger_desc":"Identificador local único para el dispositivo. p. ej. «A» para «Dedo A»","modal.device_id_cluster_desc":"Identificador local único para el dispositivo. p.ej. \"A\" para \"Grupo A\"","modal.port":"Puerto","modal.protocol_msg":"Ya sea «sort» o «sort-2021-v1\"","modal.protocol":"Protocolo","modal.induct_camera_mac":"Cámara inducida MAC","modal.printer_mac":"Impresora MAC","modal.verification_camera_mac":"Cámara de verificación MAC","modal.select_protocol":"Seleccione un protocolo","modal.select_induct_camera_mac":"Seleccione la dirección MAC de la cámara de inducción","modal.select_printer_mac":"Seleccione la dirección MAC de la impresora","modal.select_verification_camera_mac":"Seleccione la dirección MAC de la cámara de verificación","modal.responsePort":"Puerto de respuesta","modal.userId":"ID de usuario","modal.inductLocation":"Ubicación de inducción","modal.name":"Nombre del dispositivo","modal.name_line_desc":"Mostrar el nombre del dispositivo. Por ejemplo, «Línea 3\"","modal.no_device_available":"No hay dispositivos disponibles","modal.name_finger_desc":"Mostrar el nombre del dispositivo. Por ejemplo, «Finger A»","modal.name_cluster_desc":"Nombre para mostrar del dispositivo. p.ej. \"Grupo A\"","modal.parent_asset_mac":"Dirección MAC del activo principal","modal.parent_asset_mac_desc":"[Opcional] Dirección MAC del ADTF principal que desvía a las estaciones de almacenamiento de este grupo.","modal.name_matrix_desc":"Mostrar el nombre del dispositivo. Por ejemplo, «Matrix A»","modal.device_type_asl":"Tipo de dispositivo (debe ser uno de los siguientes: slam, slam-2021-v1)","modal.ip":"Dirección IP","modal.sortzonedelete":"Selecciona el escaneable que deseas eliminar.","modal.vendor":"Vendedor","modal.select_vendor":"Seleccione un proveedor","modal.spec_version":"Versión de especificación de hardware","modal.select_version":"Seleccione la versión de especificación de hardware","modal.sorter_type":"Tecnología de clasificación","modal.select_sorter_type":"Seleccionar tecnología de clasificación","modal.hamper_vendor":"Vendedor de cestas","modal.select_hamper_vendor":"Seleccione un proveedor de cestas","modal.hamper_version":"Versión Hamper","modal.select_hamper_version":"Seleccione la versión de la cesta","modal.incoming_auto_singulated":"Los paquetes se singulan automáticamente","modal.incoming_auto_sorted":"Los paquetes se clasifican automáticamente al dedo","modal.select_incoming_auto_singulated":"Seleccione Sí o No","modal.select_incoming_auto_sorted":"Seleccione Sí o No","modal.confirmUpdate":"Confirmar actualización","device.vendor":"Proveedor/versión","device.sorter_type":"Tecnología de clasificación","device.hamper_vendor":"Proveedor/versión de Hamper","devicemanagement.heading":"Administración de dispositivos","devicemanagement.desc":"Esta página muestra el estado en tiempo real de los dispositivos de automatización, Thin Clients y SBL y le ayuda a configurar el tipo de dispositivo seleccionado.","actions.secondary":"Hacer caso de uso secundario","actions.primary":"Hacer caso de uso principal","actions.usecase":"Cambiar caso de uso de cliente ligero","bay.location":"Localizaciones","bay.installlationtype":"Tipo de instalación","bay.id":"ID de bahía","destination.id":"Identificador de destino","bay.index":"Índice","bay.scannables":"Escaneables","bay.scannables_description":"ID de seguimiento/envío. Separe los valores múltiples mediante punto y coma (;)","bay.sortzone":"Zona de clasificación","bay.sortzone_description":"por ejemplo. EU: A1-1A, NA: A-1.1A","device.delete_config_button_modal_autoloader":"Configurationem AutoLoader Dele","modal.destinationiddelete":"Identificatorem Destinationis quem removere vis, quaeso, elige","autoloaderconfig.addupdate":"Configurationem AutoLoader Adde/Renova","autoloaderconfig.uploadCSV":"Configurationem AutoLoader CSV Impone","radio.loader":"Destinatio AutoLoader","modal.device_id_induct_line_desc":"Identificador local único para el dispositivo. Por ejemplo, \"1\" para \"Línea de inducto 1\"","modal.name_induct_line_desc":"Nombre para mostrar del dispositivo. Por ejemplo, \"Línea de inducto 1\"","configtype.title":"Seleccione el tipo de configuración","devicename.title":"Seleccione dispositivo","sorterconfig.addupdate":"Añadir/actualizar la configuración de destino del clasificador","sorterconfig.uploadCSV":"Cargar CSV de configuración de destino del clasificador","sortertestconfig.addupdatetest":"Añadir/actualizar la configuración del paquete de prueba del clasificador","sortertestconfig.uploadCSV":"Cargar archivo CSV de configuración del paquete de prueba de Sorter","sortertestconfig.delete":"Seleccione el paquete de prueba que desee eliminar.","sortertestconfig.nomatch":"No hay paquetes de prueba coincidentes","sortertestconfig.notavailable":"No hay paquetes de prueba disponibles","config.delete":"Eliminar configuración","config.deletetest":"Eliminar la configuración del paquete de prueba de Sorter","config.download":"Descarga Config","upload.title":"Cargar la configuración a través de CSV","upload.subtitle":"Cargue el archivo CSV para sobrescribir la configuración existente.","upload.upload_file":"Cargar archivo","upload.drag_here":"o arrastra el archivo aquí","upload.download_sample":"Descargar archivo CSV de muestra","upload.file_length":"El archivo cargado contiene filas de {length}.","upload.confirm_overwrite":"Pulse confirmar para sobrescribir la configuración.","modal.bayid":"ID de bahía","modal.cluster":"Clúster","modal.installationtype":"Tipo de instalación","modal.location":"Localizaciones","modal.tier":"Nivel","modal.optional":"[Opcional] ","modal.location_example":"Separe varios pasillos con punto y coma, por ejemplo: J,1; J,2; J,3","modal.adtr_location_example":"Separe las ubicaciones mediante punto y coma, por ejemplo: A.L01;A.L02","modal.enter_value":"Introduzca un valor...","modal.fingerName":"Nombre del dedo","modal.fingerName_desc":"[Campo opcional] Estas bahías deben asociarse con el nombre de su dedo para identificarlas en caso de que haya varios dedos dentro del mismo ADTA.","modal.addheading":"Para editar una configuración existente, introduzca su ID de bahía y escriba","modal.addheadingtest":"Para editar una configuración existente, introduzca la zona de clasificación.","modal.start":"Hora de inicio en formato UTC: MM/DD/YYYY HH:MM:SS","modal.end":"Hora de finalización en formato UTC: MM/DD/YYYY HH:MM:SS","modal.reason":"Motivo","device.active":"Activo","device.inactive":"Inactivo","device.delete":"Borrar","status.tooltip":"Saludable: el dispositivo funciona correctamente. Desconectado: el dispositivo no está conectado correctamente a Internet ni a la red local. Fallo al cargar: no se pudo obtener el estado de la conexión del dispositivo, es posible que algo esté mal.","radio.sorter":"Destino más ordenado","radio.test":"Paquete de prueba Sorter","alert.missingfields":"¡Introduzca todos los campos en el formato correcto!","alert.time":"¡Asegúrese de que la hora de inicio sea inferior o igual a la hora de finalización!","alert.testing":"No hay ninguna configuración de prueba.","alert.device":"No hay ningún dispositivo presente para esta estación.","alert.configuration":"No hay ninguna configuración de configuración presente.","alert.actionsdisabled":"Está utilizando el portal en modo de solo lectura. Todas las acciones de la página están deshabilitadas.","config.addupdateasl":"Añadir/actualizar la configuración de desvío guiado","modal.addheadingasl":"Para editar una configuración existente, vuelva a introducir el mismo código de desvío.","modal.divertcode":"Código de desvío","modal.divertcode_desc":"Rango: 10 a 99","slam.clusters":"Clusteres","modal.clusters":"Clusteres","modal.clusters_desc":"Separe los valores múltiples por punto y coma, p. ej.: A; B; C","radio.guideddivert":"Configuración de desvío guiado","tooltip.scrolltobottom":"Desplácese hasta abajo","tooltip.connectionstatus":"Activo: el dispositivo funciona correctamente. Inactivo: está conectado pero no puede recibir mensajes de latidos cardíacos del dispositivo. Desconocido/Dispositivo no encontrado: no se puede conectar al dispositivo ","tooltip.disconnectedipvlan":"Es posible que la información de IP/VLAN no sea precisa ya que el dispositivo está desconectado de la red","tooltip.isAuthorized":"No autorizado","tooltip.selectmacaddress":"Por favor, seleccione primero una dirección MAC","loading.text":"Cargando...","device.monitoring_modal":"Desactivar la monitorización","device.usecase_change_modal":"Cambiar caso de uso de cliente ligero","table.nodata":"No hay datos","alert.testconfig":"No hay configuraciones de paquetes de prueba para esta dirección MAC.","tooltip.statusLoading":"Estado de carga","bintester.errorMessage":"Se ha producido un error al obtener la configuración del sitio para esta estación","alert.asset_details_success":"Detalles del activo actualizados con éxito","alert.asset_details_fail":"Error al actualizar los detalles del recurso. ¡Intentar otra vez!","alert.createdOn":"creado el: ","alert.byUser":" por usuario: ","device.mcm":"MCM ","device.ticket":"boleto ","device.justification":"Otra justificación","device.linkPlaceHolder":"Introduzca MCM/Enlace del ticket/Otra justificación...","device.firmwareVersion":"Versión de firmware","log.stopMonitoring":"Detener registros de monitoreo","log.startMonitoring":"Empezar a monitorear registros","log.clear":"Limpiar","log.filterBySubstring":"Filtrar registros por subcadena...","log.filterByDeviceName":"Filtrar registros por nombre de dispositivo...","log.messagesToCapture":"Mensajes para capturar","log.error":"Algo salió mal, por favor inténtalo de nuevo más tarde...","log.messageCountError":"El numero de mensajes no puede exceder los 300","log.download":"Descargar registros","mhelog.datetime":"Fecha/Hora (UTC)","mhelog.protocol":"Protocolo","mhelog.devicetype":"Tipo de dispositivo","mhelog.devicename":"Nombre del dispositivo","mhelog.macip":"MAC/IP","mhelog.mac":"MAC","mhelog.ip":"IP","mhelog.eventtype":"Tipo de evento","mhelog.message":"Mensaje","mhelog.payload":"Carga útil","banner.peakPermission":"El acceso a la funcionalidad de administración está limitado durante las horas pico. Es posible que no pueda realizar ciertas funciones de edición en el sitio web si no pertenece a los grupos RME/IT/Admin. Para más detalles, lea ","banner.wiki":"la wiki de administración de dispositivos","banner.bagTracking":"Este panel proporciona un seguimiento en tiempo real de las bolsas DSP equipadas con etiquetas inteligentes.","table.index":"Índice","test.scannables":"Scannables","test.tracking_id":"ID de rastreo","test.alt_id":"Identificación de envío","test.destination":"Destino","test.scannables_description":"ID de seguimiento/envío. Separe los valores múltiples mediante punto y coma (;)","test.tracking_id_description":"Ingrese el ID de seguimiento del paquete","test.alt_id_description":"Ingrese el ID de envío del paquete","test.destination_bag_description":"por ejemplo. EU: EU_ZZ-AM-1024_BLK , NA: AK-T-0103-503-BLK","container.type":"Tipo de contenedor","container.label":"Etiqueta del contenedor","stowconfig.addupdate":"Agregar/actualizar la configuración del paquete Stow","stowconfig.uploadCSV":"Cargue CSV para la configuración del paquete Stow","stowconfig.delete":"Seleccione el tipo de contenedor que desea eliminar","stowconfig.deleteconfig":"Eliminar configuración","stowconfig.nomatch":"No se encontró ningún ID coincidente","stowconfig.notavailable":"No hay configuración disponible","stowtestconfig.addupdate":"Agregar/actualizar la configuración del paquete de prueba","modal.headingtest":"Para editar una configuración existente, ingrese el ID de bolsa de destino.,","stowtestconfig.delete":"Seleccione el paquete de prueba que desea eliminar.","stowtestconfig.deleteconfig":"Eliminar la configuración del paquete de prueba","stowtestconfig.uploadCSV":"Cargar CSV de configuración del paquete de prueba Stow","testconfig.nomatch":"No hay paquetes de prueba coincidentes","testconfig.notavailable":"No hay paquetes de prueba disponibles","modal.delete_test_package":"Seleccione el archivo escaneable que desea eliminar.","modal.tesseract_headingtest":"Para editar una configuración existente, ingrese el ID de seguimiento del paquete","modal.tesseract_containerLabel_description":"Ingrese la etiqueta del contenedor de Tesseract, por ejemplo. UE: A1, NA: A-1","modal.tesseract_containerType_description":"Introduzca el tipo de contenedor de la máquina, por ejemplo. SAMPLE_01","modal.tesseract_headingconfig":"Para editar una configuración existente, ingrese el tipo de contenedor","modal.tesseract_delete_stow_config":"Seleccione el tipo de contenedor que desea eliminar","bagtracking.heading":"Seguimiento de maletas","filter.heading":"Filtrar por hora de salida","bagTable.transporterId":"Identificación del transportador","bagTable.bagId":"Identificación de la bolsa","bagTable.bagStatus":"Estado de la bolsa","bagTable.departTime":"Hora de salida","bagTable.receiveTime":"Recibir hora","lidarTester.select":"Seleccione el controlador Lidar","modal.selectAisleType":"Seleccionar tipo de pasillo","modal.ledControllerType":"Tipo de controlador LED","modal.defaultAisleType":"Tipo de pasillo predeterminado","modal.colorOrder":"Orden de colores","modal.selectLedControllerType":"Seleccionar tipo de controlador LED","modal.selectDefaultAisleType":"Seleccionar tipo de pasillo predeterminado","modal.selectColorOrder":"Seleccionar orden de colores","device.add_only_device_button_modal":"Agregar configuración de dispositivo único","device.device.add_aisles_button_modal":"Agregar configuración de pasillos","node.update_defaults_button_modal":"Actualizar configuraciones predeterminadas","alert.aisleduplicatefields":"¡Por favor ingrese un nombre de pasillo único!","alert.portduplicatefields":"¡Por favor ingrese un número de puerto único!","config.addonerow":"Agregar una fila","config.addmultiplerows":"Agregar varias filas","config.updateledcontroller":"Actualizar controlador LED","modal.aislename":"Nombre del pasillo","modal.aisletype":"Tipo de pasillo","modal.actions":"Acciones","alert.asset_delete_success":"El activo ha sido eliminado con éxito","alert.asset_defaults_success":"Las configuraciones predeterminadas del activo se han actualizado con éxito","alert.asset_delete_fail":"No se pudo eliminar el activo. ¡Intente de nuevo!","alert.asset_defaults_fail":"No se pudo actualizar las configuraciones predeterminadas del activo. ¡Intente de nuevo!","alert.asset_create_success":"El activo se ha creado con éxito","modal.selectLidarControllerType":"Seleccionar tipo de controlador Lidar","device.controller_type":"Tipo de controlador","banner.dmwPermission":"No tienes autorización para acceder a este dispositivo. Consulta el enlace a continuación para acceder.","locationconfig.addupdate":"Añadir/actualizar la configuración de ubicación de ZancaSort","locationconfig.uploadCSV":"Cargue el CSV de configuración de ubicación de ZancaSort","locationconfig.deleteconfig":"Eliminar la configuración de ubicación de ZancaSort","tierconfig.addupdate":"Añadir/actualizar la configuración de niveles de ZancaSort","tierconfig.uploadCSV":"Cargar CSV de configuración de niveles de ZancaSort","tierconfig.deleteconfig":"Eliminar la configuración de niveles de ZancaSort","tierconfig.tierName":"Nombre del nivel","tierconfig.capacity":"Capacidad","tierconfig.startLevel":"Nivel inicial (inclusivo)","tierconfig.endLevel":"Nivel final (inclusivo)","modal.addtierheading":"Para editar una configuración existente, seleccione el nombre del nivel.","modal.delete_tier_config":"Seleccione el nombre del nivel que desea eliminar","tierconfig.selectTier":"Seleccionar nombre del nivel","location.id":"Ubicación","location.type":"Tipo de ubicación","locationconfig.delete":"Selecciona el identificador de ubicación","modal.delete_location_config":"Selecciona el identificador de ubicación que deseas eliminar","modal.toggleStowStations.title":"Estaciones Toggle Stow","modal.toggleStowStations.topStation":"Estación Top Stow","modal.toggleStowStations.bottomStation":"Estación Bottom Stow","modal.toggleStowStations.updating":"Actualizando la configuración de la estación de almacenamiento...","locationmapping.destination":"Pick Chute","locationmapping.type":"Item Type","locationmapping.locations":"Pick Point(s)","locationmapping.add":"Add Config","locationmapping.uploadCSV":"Upload Location Config CSV","locationmapping.destination.placeholder":"e.g. PC1","locationmapping.type.placeholder":"Select item type","locationmapping.locations.placeholder":"Select pick points","locationmapping.error.column_count":"Expected 3 columns but found {count}.","locationmapping.error.pick_point_not_found":"Pick point \"{pickPoint}\" does not exist at this station.","locationmapping.error.row_prefix":"Row {row}: {message}","locationmapping.delete_config":"Delete Config","locationmapping.delete_title":"Delete Location Mapping","locationmapping.delete_confirmation":"Are you sure you want to delete the entire location mapping configuration? This action will be applied when you deploy the draft.","locationmapping.no_pick_points":"No pick points found for this station.","locationmapping.modal.add_title":"Add Location Mapping","locationmapping.modal.edit_title":"Edit Location Mapping","locationmapping.error.destination_required":"Destination is required.","locationmapping.error.destination_invalid":"Destination must start with a letter, contain only letters, digits, underscore, hyphen, or period, and be at most 50 characters.","locationmapping.error.type_required":"Item type is required.","locationmapping.error.locations_required":"At least one pick point must be selected.","locationmapping.error.duplicate":"A mapping for \"{destination}\" with type \"{type}\" already exists.","locationmapping.error.conflict":"Pick point \"{pickPoint}\" is already mapped to \"{destination}\" for type \"{type}\"."}

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

module.exports = {"external.logs":"Tableau de bord du journal","external.dashboard":"Tableau de bord d'ingénierie","asl.heading":"Appareils ASL","thinclients.heading":"Clients légers","adta.heading":"Appareils ADTA","common.data_last_updated":"Dernière mise à jour des données","adta.connected":"Connecté","zancasort.heading":"Appareils ZancaSort","tesseract.heading":"Appareils Tesseract","autoretriever.heading":"Auto Retriever","sbl.heading":"Appareils SBL","device.name":"Nom","device.location":"Emplacement","device.mac_ip":"Adresse MAC/IP","device.device_type":"Type d'appareil","device.component_type":"Type de composant","device.connection":"État de la connexion","device.action":"Action","device.pick_stations":"postes de picking","device.add_device_button_modal":"Ajouter/mettre à jour la configuration d'un seul appareil","device.delete_device_button_modal":"Supprimer la configuration d'un seul appareil","device.edit_device_mac_modal":"Modifier l'adresse Mac d'un seul appareil","device.delete_config_button_modal":"Supprimer la configuration de destination du trieur","device.delete_divert_config_button_modal":"Supprimer la configuration de dérivation guidée","device.edit_config":"Ajouter ou modifier une configuration","device.delete_config_button_modal_autoloader":"Supprimer la configuration de l'AutoLoader","modal.destinationiddelete":"Veuillez sélectionner l'identifiant de destination à supprimer","autoloaderconfig.addupdate":"Ajouter/Mettre à jour la configuration de l'AutoLoader","autoloaderconfig.uploadCSV":"Télécharger le fichier CSV de configuration de l'AutoLoader","radio.loader":"Destination de l'AutoLoader","modal.device_id_induct_line_desc":"Identifiant local unique de l'appareil. Par exemple, « 1 » pour « Ligne d'induction 1 ».","modal.name_induct_line_desc":"Nom d'affichage de l'appareil. Par exemple, « Ligne d'induction 1 ».","device.device_category":"Catégorie d'appareil","device.offline_devices_locations":"Emplacements des appareils hors ligne","asl.desc":"Cette page affiche l'état en temps réel des appareils ASL ainsi que la configuration du périphérique et du renvoi guidé ASL","adta.desc":"Cette page affiche l'état en temps réel des appareils ADTA ainsi que la destination du sorteur et la configuration du package de test du trieur","sbl.desc":"Cette page affiche l'état en temps réel des contrôleurs LED ainsi que l'adresse MAC/IP et la connectivité","thinclient.desc":"Cette page affiche l'état en temps réel des appareils Thin Client ainsi que l'adresse MAC/IP et l'état de santé","device.vlan":"VLAN","device.usecase":"Cas d'utilisation","device.status":"Statut","device.swstatus":"État du logiciel","device.remark":"Remarque","device.monitoring":"État de la surveillance","device.monitoringEnabled":"Activé","device.monitoringDisabled":"handicapé","device.invalidEntry":"Entrée non valide","device.editWarning":"Vous êtes sur le point d'apporter une modification qui affectera temporairement le fonctionnement de l'ASL ou de l'ADTA. Assurez-vous qu'aucun cycle n'est en cours d'exécution sur ces machines avant de continuer","actions.deleteDevice":"Supprimer l'appareil","actions.addDevice":"Modifier l'appareil","actions.edit":"Modifier via JSON","actions.changeMac":"Modifier l'adresse MAC de l'appareil","actions.toggleStowStations":"Basculer les stations de rangement","actions.monitoring_disable":"Désactiver la surveillance","actions.monitoring_enable":"Activer la surveillance","actions.deploydraft":"Déployer le brou","actions.discarddraft":"Supprimer le brouillon","actions.rollback":"Annulation","actions.deploy":"Déployez","actions.restart":"Redémarrer l'application","button.add":"Ajouter/modifier via JSON","button.addcsv":"Ajouter/modifier via CSV","button.delete":"Supprimer l'appareil","button.save":"Enregistrer","button.edit":"Modifier","pickstation.label":"Poste de picking","pickstation.no_resources":"Aucun poste de picking trouvé pour cette station.","modal.adta_heading":"DONNÉES","modal.asl_heading":"ASL","modal.confirm":"Confirmez","modal.confirmAdd":"Confirmer l'ajout","modal.confirmEdit":"Confirmer la modification","modal.cancel":"Annuler","modal.copy":"Copier","modal.paste":"Coller","modal.remove":"Supprimer","tab.testing":"Tester","tab.sbldashboard":"Tableau de bord SBL","tab.configuration":"Configuration","tab.aisleconfigfinder":"SBL Config Finder","tab.overview":"Vue d'ensemble","tab.logstream":"Flux de journaux","tab.managebyexceptions":"Gérer par exceptions","tab.lidartester":"Testeur Lidar","deviceManagement.filters":"Sélectionnez le type d'appareil","deviceManagement.tag":"Type d'appareil","deviceManagement.noresults":"Aucun résultat","modal.mac":"Adresse MAC","modal.startAisle":"Allée de départ","modal.startPort":"Port de départ","modal.aisleCount":"Nombre d'allées","modal.config":"Renseignez le fichier de configuration JSON","modal.configcsv":"Téléchargez le fichier CSV de configuration.","modal.macdelete":"Entrez l'adresse MAC de l'appareil que vous souhaitez supprimer.","modal.selectmacdelete":"Sélectionnez l'adresse MAC à supprimer.","modal.confirmmacdelete":"Confirmez que vous souhaitez supprimer l'appareil suivant :","modal.confirmmacedit":"Entrez la nouvelle adresse MAC pour l'appareil suivant :","modal.deleteAll":"Tout supprimer","modal.bayiddelete":"Sélectionnez l'identifiant de baie que vous souhaitez supprimer :","modal.selectbayid":"Sélectionnez l'identifiant de la baie","modal.divertcodedelete":"Veuillez saisir le code de renvoi que vous souhaitez supprimer","modal.select_divert_code":"Sélectionnez le code de renvoi à supprimer.","modal.pick_stations":"postes de picking","modal.pick_stations_desc":"Saisissez les étiquettes du poste de prélèvement associé séparées par (;)","modal.device_id":"ID de l'appareil","modal.device_id_line_desc":"Identifiant local unique pour l'appareil. Par exemple, « 3 » pour « Line 3 »","modal.device_id_finger_desc":"Identifiant local unique pour l'appareil. Par exemple. « A » pour « Finger A »","modal.device_id_cluster_desc":"Identificateur local unique de l'appareil. par exemple. \"A\" pour \"Cluster A\"","modal.port":"Port","modal.protocol_msg":"Soit « sort », soit « sort-2021-v1\"","modal.protocol":"Protocole","modal.induct_camera_mac":"Caméra d'induction MAC","modal.printer_mac":"Imprimante MAC","modal.verification_camera_mac":"Caméra de vérification MAC","modal.select_protocol":"Sélectionnez un protocole","modal.select_induct_camera_mac":"Sélectionnez l'adresse MAC de la caméra d'intégration","modal.select_printer_mac":"Sélectionnez l'adresse MAC de l'imprimante","modal.select_verification_camera_mac":"Sélectionnez l'adresse MAC de la caméra de vérification","modal.responsePort":"Port de réponse","modal.userId":"ID utilisateur","modal.inductLocation":"Emplacement de l'induction","modal.name":"Nom de l'appareil","modal.name_line_desc":"Nom d'affichage de l'appareil, par exemple « Line 3 »","modal.no_device_available":"Aucun appareil disponible","modal.name_finger_desc":"Nom d'affichage de l'appareil, par exemple « Finger A »","modal.name_cluster_desc":"Nom d'affichage de l'appareil. par exemple. \"Grappe A\"","modal.parent_asset_mac":"Adresse MAC de l'actif parent","modal.parent_asset_mac_desc":"[Facultatif] Adresse MAC de l'ADTF parent qui dévie vers les stations de rangement de ce cluster.","modal.name_matrix_desc":"Nom d'affichage de l'appareil, par exemple « Matrix A »","modal.device_type_asl":"Type d'appareil (doit être l'un des suivants : slam, slam-2021-v1)","modal.ip":"Adresse IP","modal.sortzonedelete":"Sélectionnez le fichier scannable que vous souhaitez supprimer.","modal.vendor":"Fournisseur","modal.select_vendor":"Sélectionnez un fournisseur","modal.spec_version":"Version des spécifications matérielles","modal.select_version":"Sélectionnez la version des spécifications matérielles","modal.sorter_type":"Technologie de tri","modal.select_sorter_type":"Sélectionnez la technologie de tri","modal.hamper_vendor":"Fournisseur de paniers","modal.select_hamper_vendor":"Sélectionnez le fournisseur du panier","modal.hamper_version":"Version panier","modal.select_hamper_version":"Sélectionnez la version du panier","modal.incoming_auto_singulated":"Les colis sont automatiquement singulés","modal.incoming_auto_sorted":"Les colis sont automatiquement triés vers le doigt","modal.select_incoming_auto_singulated":"Sélectionnez Oui ou Non","modal.select_incoming_auto_sorted":"Sélectionnez Oui ou Non","modal.selectusecase":"Sélectionnez le cas d'utilisation","modal.selectnewusecase":"Veuillez sélectionner un nouveau cas d'utilisation pour Thin Client.","modal.confirmchangeusecase":"Veuillez confirmer le nouveau cas d'utilisation de client léger que vous avez sélectionné.","modal.confirmUpdate":"Confirmer la mise à jour","device.vendor":"Fournisseur/Version","device.sorter_type":"Technologie de tri","device.hamper_vendor":"Fournisseur/Version du panier","devicemanagement.heading":"Gestion des appareils","devicemanagement.desc":"Cette page affiche l'état en temps réel des appareils Automation, des clients légers et des appareils SBL et vous aide à définir la configuration du type d'appareil sélectionné.","actions.secondary":"Créer un cas d'utilisation secondaire","actions.primary":"Définir le cas d'utilisation principal","actions.usecase":"Modifier le cas d'utilisation du client léger","bay.location":"Emplacements","bay.installlationtype":"Type d'installation","bay.id":"ID de baie","destination.id":"Identifiant du destinataire","bay.index":"Indice","bay.scannables":"Scannables","bay.scannables_description":"Numéro de suivi/d'expédition. Séparez les valeurs multiples par des points-virgules (;)","bay.sortzone":"Zone de tri","bay.sortzone_description":"par exemple. EU : A1-1A, NA : A-1.1A","configtype.title":"Sélectionnez le type de configuration","devicename.title":"Sélectionnez un appareil","sorterconfig.addupdate":"Ajouter/mettre à jour la configuration de destination du trieur","sorterconfig.uploadCSV":"Télécharger le fichier CSV de configuration de destination du trieur","sortertestconfig.addupdatetest":"Ajouter/mettre à jour la configuration du package de test du trieur","sortertestconfig.uploadCSV":"Télécharger le fichier CSV de configuration du package de test du trieur","sortertestconfig.delete":"Sélectionnez le package de test à supprimer.","sortertestconfig.nomatch":"Aucun package de test correspondant","sortertestconfig.notavailable":"Aucun package de test disponible","config.delete":"Supprimer la configuration","config.deletetest":"Supprimer la configuration du package de test du trieur","config.download":"Télécharger la configuration","upload.title":"Télécharger la configuration via CSV","upload.subtitle":"Téléchargez le fichier CSV pour remplacer la configuration existante.","upload.upload_file":"Charger un fichier","upload.drag_here":"ou faites glisser le fichier ici","upload.download_sample":"Télécharger un exemple de fichier CSV","upload.file_length":"Le fichier chargé contient des lignes {length}.","upload.confirm_overwrite":"Appuyez sur Confirmer pour remplacer la configuration.","modal.bayid":"ID de baie","modal.cluster":"Cluster","modal.installationtype":"Type d'installation","modal.location":"Emplacements","modal.tier":"Niveau","modal.optional":"[Facultatif] ","modal.location_example":"Séparez les allées multiples par un point-virgule, par exemple: J,1; J,2; J,3","modal.adtr_location_example":"Séparez les emplacements par un point-virgule - par exemple:A.L01;A.L02","modal.enter_value":"Entrez une valeur...","modal.fingerName":"Nom du doigt","modal.fingerName_desc":"[Champ facultatif] Ces baies doivent être associées à leur nom de doigt pour les identifier en cas de plusieurs doigts dans le même ADTA.","modal.addheading":"Pour modifier une configuration existante, entrez son ID de baie et tapez","modal.addheadingtest":"Pour modifier une configuration existante, entrez dans la zone de tri.","modal.start":"Heure de début au format UTC : MM/DD/YYYY HH:MM:SS","modal.end":"Heure de fin au format UTC : MM/DD/YYYY HH:MM:SS","modal.reason":"Raison","device.active":"Actif","device.inactive":"Inactif","device.delete":"Supprimer","status.tooltip":"Sain : l'appareil fonctionne correctement. Déconnecté : l'appareil n'est pas correctement connecté à Internet et au réseau local. Échec du chargement : Impossible de récupérer l'état de connexion de l'appareil, il se peut qu'il y ait un problème.","radio.sorter":"Destination du trieur","radio.test":"Package de test Sorter","alert.missingfields":"Veuillez saisir tous les champs au format correct !","alert.time":"Assurez-vous que l'heure de début est inférieure ou égale à l'heure de fin !","alert.testing":"Aucune configuration de test n'est présente.","alert.device":"Aucun appareil n'est présent pour cette station.","alert.configuration":"Aucune installation de configuration n'est présente.","alert.actionsdisabled":"Vous utilisez le portail en mode lecture seule. Toutes les actions de la page sont désactivées.","config.addupdateasl":"Ajouter/mettre à jour la configuration de renvoi guidé","modal.addheadingasl":"Pour modifier une configuration existante, entrez à nouveau le même code de renvoi.","modal.divertcode":"Code de dérivation","modal.divertcode_desc":"Gamme : 10 à 99","slam.clusters":"Clusters","modal.clusters":"Clusters","modal.clusters_desc":"Séparez les valeurs multiples par des points-virgules, par exemple : A ; B ; C","radio.guideddivert":"Configuration de déviation guidée","tooltip.scrolltobottom":"Faites défiler vers le bas","tooltip.connectionstatus":"Actif : l'appareil fonctionne correctement. Inactif : connecté mais incapable de recevoir les messages de rythme cardiaque de l'appareil. Inconnu/Appareil introuvable : impossible de se connecter à l'appareil ","tooltip.disconnectedipvlan":"Les informations IP/VLAN peuvent ne pas être exactes car l'appareil est déconnecté du réseau","tooltip.isAuthorized":"Pas autorisé","tooltip.selectmacaddress":"Veuillez d'abord sélectionner une adresse MAC","loading.text":"Chargement en cours...","device.monitoring_modal":"Désactiver la surveillance","device.usecase_change_modal":"Modifier le cas d'utilisation du client léger","table.nodata":"Aucune donnée présente","alert.testconfig":"Aucune configuration de package de test n'est présente pour cette adresse MAC.","tooltip.statusLoading":"État de chargement","bintester.errorMessage":"Une erreur s'est produite lors de la récupération de la configuration du site pour cette station","alert.asset_details_success":"Détails de l'actif mis à jour avec succès","alert.asset_details_fail":"Échec de la mise à jour des détails de l'actif. Essayer à nouveau!","alert.createdOn":"créé sur: ","alert.byUser":" par utilisateur: ","device.mcm":"MCM ","device.ticket":"Billet ","device.justification":"Autre justification ","device.linkPlaceHolder":"Entrez MCM/Lien du billet/Autre justification...","device.firmwareVersion":"Version du firmware","log.stopMonitoring":"Arrêter les journaux de surveillance","log.startMonitoring":"Démarrer les journaux de surveillance","log.clear":"Supprimer","log.filterBySubstring":"Filtrer les journaux par sous-chaîne...","log.filterByDeviceName":"Filtrer les journaux par nom d'appareil...","log.messagesToCapture":"Messages à capturer","log.error":"Une erreur s'est produite. Merci d'essayer plus tard...","log.messageCountError":"Le nombre de messages ne peut pas dépasser 300","log.download":"Télécharger les journaux","mhelog.datetime":"Date/Heure (UTC)","mhelog.protocol":"Protocole","mhelog.devicetype":"Type d'appareil","mhelog.devicename":"Nom de l'appareil","mhelog.macip":"MAC/IP","mhelog.mac":"MAC","mhelog.ip":"IP","mhelog.eventtype":"Type d'événement","mhelog.message":"Message","mhelog.payload":"Charge utile","banner.peakPermission":"L'accès aux fonctionnalités d'administration est limité pendant les heures de pointe. Vous ne pourrez peut-être pas exécuter certaines fonctions d'édition sur le site Web si vous n'appartenez pas aux groupes RME/IT/Admin. Pour plus de détails, lisez ","banner.wiki":"le wiki de gestion des appareils","banner.bagTracking":"Ce tableau de bord permet de suivre en temps réel les sacs DSP équipés de balises intelligentes.","table.index":"Indice","test.scannables":"Scannables","test.tracking_id":"Identifiant de suivi","test.alt_id":"Identifiant d'expédition","test.destination":"Destination","test.scannables_description":"ID de suivi/expédition. Séparez plusieurs valeurs par un point-virgule (;)","test.tracking_id_description":"Entrez l'ID de suivi du colis","test.alt_id_description":"Entrez l'ID d'expédition du colis","test.destination_bag_description":"Par exemple EU: EU_ZZ-AM-1024_BLK , NA: AK-T-0103-503-BLK","container.type":"Type de conteneur","container.label":"Étiquette du conteneur","stowconfig.addupdate":"Ajouter/mettre à jour la configuration du package Stow","stowconfig.uploadCSV":"Télécharger le fichier CSV de configuration du package Stow","stowconfig.delete":"Sélectionnez le type de conteneur à supprimer","stowconfig.deleteconfig":"Supprimer la configuration","stowconfig.nomatch":"Aucun identifiant correspondant trouvé","stowconfig.notavailable":"Aucune configuration disponible","stowtestconfig.addupdate":"Ajouter/mettre à jour la configuration du package de test","modal.headingtest":"Pour modifier une configuration existante, entrez le Destination BagId","stowtestconfig.delete":"Sélectionnez le package de test à supprimer.","stowtestconfig.deleteconfig":"Supprimer la configuration du package de test","stowtestconfig.uploadCSV":"Télécharger Fichier CSV de configuration du package de test Stow","testconfig.nomatch":"Aucun package de test correspondant","testconfig.notavailable":"Aucun package de test disponible","modal.delete_test_package":"Veuillez sélectionner l'entrée que vous souhaitez supprimer.","modal.tesseract_headingtest":"Pour modifier une configuration existante, saisissez l'ID de suivi du colis.","modal.tesseract_containerLabel_description":"Entrez l'étiquette du conteneur tesseract, par exemple. UE : A1, NA : A-1","modal.tesseract_containerType_description":"Entrez le type de conteneur de la machine, par exemple. SAMPL_01","modal.tesseract_headingconfig":"Pour modifier une configuration existante, entrez le type de conteneur","modal.tesseract_delete_stow_config":"Veuillez sélectionner le type de conteneur que vous souhaitez supprimer","bagtracking.heading":"Suivi des sacs","filter.heading":"Filtrer par heure de départ","bagTable.transporterId":"Identifiant du transporteur","bagTable.bagId":"Identifiant du sac","bagTable.bagStatus":"Statut du sac","bagTable.departTime":"Heure de départ","bagTable.receiveTime":"Recevez l'heure","lidarTester.select":"Sélectionnez le contrôleur Lidar","modal.selectAisleType":"Sélectionner le type de couloir","modal.ledControllerType":"Type de contrôleur LED","modal.defaultAisleType":"Type de couloir par défaut","modal.colorOrder":"Ordre des couleurs","modal.selectLedControllerType":"Sélectionner le type de contrôleur LED","modal.selectDefaultAisleType":"Sélectionner le type de couloir par défaut","modal.selectColorOrder":"Sélectionner l'ordre des couleurs","device.add_only_device_button_modal":"Ajouter la configuration d'un seul appareil","device.device.add_aisles_button_modal":"Ajouter des couloirs pour un contrôleur LED","node.update_defaults_button_modal":"Mettre à jour les paramètres par défaut","alert.aisleduplicatefields":"Veuillez entrer un nom de couloir unique !","alert.portduplicatefields":"Veuillez entrer un numéro de port unique !","config.addonerow":"Ajouter une ligne","config.addmultiplerows":"Ajouter plusieurs lignes","config.updateledcontroller":"Mettre à jour le contrôleur LED","modal.aislename":"Nom du couloir","modal.aisletype":"Type de couloir","modal.actions":"Actions","alert.asset_delete_success":"L'actif a été supprimé avec succès","alert.asset_defaults_success":"Les paramètres par défaut de l'actif ont été mis à jour avec succès","alert.asset_create_success":"L'actif a été créé avec succès","alert.asset_delete_fail":"Échec de la suppression de l'actif. Essayez à nouveau !","alert.asset_defaults_fail":"Échec de la mise à jour des paramètres par défaut de l'actif. Essayez à nouveau !","modal.selectLidarControllerType":"Sélectionner le type de contrôleur Lidar","device.controller_type":"Type de contrôleur","banner.dmwPermission":"Vous n'êtes pas autorisé à accéder à cet appareil. Veuillez consulter le lien ci-dessous pour y accéder.","locationconfig.addupdate":"Ajouter/mettre à jour la configuration de localisation de ZancaSort","locationconfig.uploadCSV":"Télécharger le fichier CSV de configuration de localisation de ZancaSort","locationconfig.deleteconfig":"Supprimer la configuration de localisation de ZancaSort","tierconfig.addupdate":"Ajouter/mettre à jour la configuration de niveaux ZancaSort","tierconfig.uploadCSV":"Télécharger le CSV de configuration de niveaux ZancaSort","tierconfig.deleteconfig":"Supprimer la configuration de niveaux ZancaSort","tierconfig.tierName":"Nom du niveau","tierconfig.capacity":"Capacité","tierconfig.startLevel":"Niveau de début (inclusif)","tierconfig.endLevel":"Niveau de fin (inclusif)","modal.addtierheading":"Pour modifier une configuration existante, sélectionnez le nom du niveau.","modal.delete_tier_config":"Veuillez sélectionner le nom du niveau que vous souhaitez supprimer","tierconfig.selectTier":"Sélectionner le nom du niveau","location.id":"Lieu","location.type":"Type de lieu","locationconfig.delete":"Sélectionnez l'ID de localisation","modal.delete_location_config":"Veuillez sélectionner l'identifiant de localisation que vous souhaitez supprimer","modal.toggleStowStations.title":"Postes de rangement Toggle","modal.toggleStowStations.topStation":"Gare de Top Stow","modal.toggleStowStations.bottomStation":"Gare de Bottom Stow","modal.toggleStowStations.updating":"Mise à jour de la configuration de la station de rangement...","locationmapping.destination":"Pick Chute","locationmapping.type":"Item Type","locationmapping.locations":"Pick Point(s)","locationmapping.add":"Add Config","locationmapping.uploadCSV":"Upload Location Config CSV","locationmapping.destination.placeholder":"e.g. PC1","locationmapping.type.placeholder":"Select item type","locationmapping.locations.placeholder":"Select pick points","locationmapping.error.column_count":"Expected 3 columns but found {count}.","locationmapping.error.pick_point_not_found":"Pick point \"{pickPoint}\" does not exist at this station.","locationmapping.error.row_prefix":"Row {row}: {message}","locationmapping.delete_config":"Delete Config","locationmapping.delete_title":"Delete Location Mapping","locationmapping.delete_confirmation":"Are you sure you want to delete the entire location mapping configuration? This action will be applied when you deploy the draft.","locationmapping.no_pick_points":"No pick points found for this station.","locationmapping.modal.add_title":"Add Location Mapping","locationmapping.modal.edit_title":"Edit Location Mapping","locationmapping.error.destination_required":"Destination is required.","locationmapping.error.destination_invalid":"Destination must start with a letter, contain only letters, digits, underscore, hyphen, or period, and be at most 50 characters.","locationmapping.error.type_required":"Item type is required.","locationmapping.error.locations_required":"At least one pick point must be selected.","locationmapping.error.duplicate":"A mapping for \"{destination}\" with type \"{type}\" already exists.","locationmapping.error.conflict":"Pick point \"{pickPoint}\" is already mapped to \"{destination}\" for type \"{type}\"."}

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

module.exports = {"external.logs":"Cruscotto di log","external.dashboard":"Cruscotti ingegneristici","asl.heading":"Dispositivi ASL","thinclients.heading":"Thin Client","adta.heading":"Dispositivi ADTA","common.data_last_updated":"Ultimo aggiornamento dei dati","adta.connected":"Connesso","zancasort.heading":"Dispositivi ZancaSort","tesseract.heading":"Dispositivi Tesseract","autoretriever.heading":"Automatico Retriever","sbl.heading":"Dispositivi SBL","device.name":"Nome","device.location":"Posizione","device.mac_ip":"Indirizzo MAC/IP","device.device_type":"Tipo di dispositivo","device.component_type":"Tipo di componente","device.connection":"Stato della connessione","device.action":"Azione","device.pick_stations":"Postazione di picking","device.add_device_button_modal":"Aggiungi/aggiorna la configurazione di un singolo dispositivo","device.delete_device_button_modal":"Elimina la configurazione di un singolo dispositivo","device.edit_device_mac_modal":"Modifica l'indirizzo Mac di un singolo dispositivo","device.delete_config_button_modal":"Elimina la configurazione della destinazione dell'ordinatore","device.delete_divert_config_button_modal":"Elimina configurazione di deviazione guidata","device.delete_config_button_modal_autoloader":"Elimina la configurazione di AutoLoader","modal.destinationiddelete":"Seleziona l'ID destinazione che desideri rimuovere","autoloaderconfig.addupdate":"Aggiungi/Aggiorna la configurazione di AutoLoader","autoloaderconfig.uploadCSV":"Carica il file CSV della configurazione di AutoLoader","radio.loader":"Destinazione di AutoLoader","modal.device_id_induct_line_desc":"Identificativo locale univoco del dispositivo. Ad esempio \"1\" per \"Induct Line 1\"","modal.name_induct_line_desc":"Nome visualizzato del dispositivo. Ad esempio \"Induct Line 1\"","device.edit_config":"Aggiungi o modifica configurazione","device.device_category":"Categoria dispositivo","device.offline_devices_locations":"Posizioni dei dispositivi offline","asl.desc":"Questa pagina mostra lo stato in tempo reale dei dispositivi ASL insieme al dispositivo e alla configurazione di deviazione guidata ASL","adta.desc":"Questa pagina mostra lo stato in tempo reale dei dispositivi ADTA insieme alla configurazione del pacchetto Sorter Destination e Sorter Test Package","sbl.desc":"Questa pagina mostra lo stato in tempo reale dei controller LED insieme all'indirizzo MAC/IP e alla connettività","thinclient.desc":"Questa pagina mostra lo stato in tempo reale dei dispositivi Thin Client insieme all'indirizzo MAC/IP e allo stato di integrità","device.vlan":"VLAN","device.usecase":"Caso d'uso","device.status":"Status","device.swstatus":"Stato del software","device.remark":"Osservazione","device.monitoring":"Stato di monitoraggio","device.monitoringEnabled":"Abilitato","device.monitoringDisabled":"Disabili","device.invalidEntry":"Inserimento non valido","device.editWarning":"Stai per apportare una modifica che influirà temporaneamente sul funzionamento di ASL/ADTA. Assicurati che nessun ciclo sia in esecuzione su queste macchine prima di continuare","actions.deleteDevice":"Elimina dispositivo","actions.addDevice":"Modifica dispositivo","actions.edit":"Modifica tramite JSON","actions.changeMac":"Cambia l'indirizzo mac del dispositivo","actions.toggleStowStations":"Attiva/disattiva stazioni di stoccaggio","actions.monitoring_disable":"Disabilita il monitoraggio","actions.monitoring_enable":"Abilita monitoraggio","actions.deploydraft":"Distribuisci bozza","actions.discarddraft":"Elimina bozza","actions.rollback":"Rollback","actions.deploy":"Distribuisci","actions.restart":"Riavvia l'applicazione","button.add":"Aggiungi/modifica tramite JSON","button.addcsv":"Aggiungi/modifica tramite CSV","button.delete":"Elimina dispositivo","button.save":"Salva","button.edit":"Modifica","pickstation.label":"Postazione di picking","pickstation.no_resources":"Nessuna postazione di picking trovata per questa stazione.","modal.adta_heading":"DATI","modal.asl_heading":"ASL","modal.confirm":"Confermare","modal.confirmAdd":"Conferma aggiunta","modal.confirmEdit":"Conferma modifica","modal.cancel":"Annullare","modal.copy":"Copia","modal.paste":"Incolla","modal.remove":"Rimuovi","tab.testing":"Collaudo","tab.sbldashboard":"Dashboard SBL","tab.configuration":"Configurazione","tab.aisleconfigfinder":"SBL Config Finder","tab.overview":"Panoramica","tab.logstream":"Flusso di log","tab.managebyexceptions":"Gestisci per eccezioni","tab.lidartester":"Tester Lidar","deviceManagement.filters":"Seleziona il tipo di dispositivo","deviceManagement.tag":"Tipo di dispositivo","deviceManagement.noresults":"Nessun risultato","modal.mac":"Indirizzo MAC","modal.startAisle":"Inizia corridoio","modal.startPort":"Porta di avvio","modal.aisleCount":"Conteggio dei corridoi","modal.config":"Compila la configurazione JSON","modal.configcsv":"Carica il file CSV di configurazione.","modal.macdelete":"Inserisci l'indirizzo MAC del dispositivo che desideri rimuovere.","modal.selectmacdelete":"Seleziona l'indirizzo MAC da eliminare.","modal.confirmmacdelete":"Conferma di voler eliminare il seguente dispositivo:","modal.confirmmacedit":"Inserisci un nuovo indirizzo mac per il seguente dispositivo:","modal.deleteAll":"Elimina tutto","modal.bayiddelete":"Seleziona l'ID della baia che desideri rimuovere:","modal.selectbayid":"Seleziona l'ID della baia","modal.divertcodedelete":"Inserisci il codice di deviazione che desideri rimuovere","modal.select_divert_code":"Seleziona il codice di deviazione da eliminare.","modal.pick_stations":"Postazione di picking","modal.pick_stations_desc":"Inserisci le etichette delle stazioni di prelievo associate separate da (;)","modal.device_id":"ID del dispositivo","modal.device_id_line_desc":"Identificatore locale univoco per il dispositivo, ad esempio «3\" per «Linea 3\"","modal.device_id_finger_desc":"Identificatore locale univoco per il dispositivo. ad es. «A» per «Finger A»","modal.device_id_cluster_desc":"Identificatore locale univoco per il dispositivo. per esempio. \"A\" per \"Cluster A\"","modal.port":"Porto","modal.protocol_msg":"O «sort» o «sort-2021-v1\"","modal.protocol":"Protocollo","modal.induct_camera_mac":"Introduci il MAC della fotocamera","modal.printer_mac":"MAC della stampante","modal.verification_camera_mac":"MAC della fotocamera di verifica","modal.select_protocol":"Seleziona un protocollo","modal.select_induct_camera_mac":"Selezionare Inserisci indirizzo MAC della telecamera","modal.select_printer_mac":"Selezionare l'indirizzo MAC della stampante","modal.select_verification_camera_mac":"Seleziona Verifica indirizzo MAC della telecamera","modal.responsePort":"Porta di risposta","modal.userId":"ID utente","modal.inductLocation":"Posizione dell'indotto","modal.name":"Nome dispositivo","modal.name_line_desc":"Visualizza il nome del dispositivo, ad esempio «Line 3\"","modal.no_device_available":"Nessun dispositivo disponibile","modal.name_finger_desc":"Nome visualizzato del dispositivo, ad esempio «Finger A»","modal.name_cluster_desc":"Visualizza il nome del dispositivo. per esempio. \"Gruppo A\"","modal.parent_asset_mac":"Indirizzo MAC dell'asset principale","modal.parent_asset_mac_desc":"[Facoltativo] Indirizzo MAC dell'ADTF principale che devia verso le stazioni di stoccaggio di questo cluster.","modal.name_matrix_desc":"Nome visualizzato del dispositivo, ad esempio «Matrix A»","modal.device_type_asl":"Tipo di dispositivo (deve essere uno dei seguenti: slam, slam-2021-v1)","modal.ip":"Indirizzo IP","modal.sortzonedelete":"Seleziona lo scanner che desideri rimuovere.","modal.vendor":"Venditore","modal.select_vendor":"Seleziona fornitore","modal.spec_version":"Versione delle specifiche hardware","modal.select_version":"Seleziona la versione delle specifiche hardware","modal.sorter_type":"Tecnologia del selezionatore","modal.select_sorter_type":"Seleziona la tecnologia di smistamento","modal.hamper_vendor":"Venditore di cesti","modal.select_hamper_vendor":"Seleziona Hamper Vendor","modal.hamper_version":"Versione Hamper","modal.select_hamper_version":"Seleziona la versione Hamper","modal.incoming_auto_singulated":"I pacchi vengono singolati automaticamente","modal.incoming_auto_sorted":"I pacchi vengono smistati automaticamente al finger","modal.select_incoming_auto_singulated":"Seleziona Sì o No","modal.select_incoming_auto_sorted":"Seleziona Sì o No","modal.selectusecase":"Seleziona Caso d'uso","modal.selectnewusecase":"Selezionare un nuovo caso d'uso per Thin Client.","modal.confirmchangeusecase":"Conferma il nuovo caso d'uso del Thin Client che hai selezionato.","modal.confirmUpdate":"Conferma aggiornamento","device.vendor":"Fornitore/versione","device.sorter_type":"Tecnologia del selezionatore","device.hamper_vendor":"Venditore/versione Hamper","devicemanagement.heading":"Gestione dei dispositivi","devicemanagement.desc":"Questa pagina mostra lo stato in tempo reale dei dispositivi di automazione, dei Thin Client e dei dispositivi SBL e aiuta a impostare la configurazione del tipo di dispositivo selezionato.","actions.secondary":"Crea un caso d'uso secondario","actions.primary":"Crea caso d'uso principale","actions.usecase":"Cambia caso d'uso del thin client","bay.location":"Sedi","bay.installlationtype":"Tipo di installazione","bay.id":"ID della baia","destination.id":"Identificatore di destinazione","bay.index":"Indice","bay.scannables":"Scannerabili","bay.scannables_description":"ID di tracciamento/spedizione. Separare più valori con punto e virgola (;)","bay.sortzone":"Zona di ordinamento","bay.sortzone_description":"ad esempio. EU: A1-1A, NA: A-1.1A","configtype.title":"Seleziona il tipo di configurazione","devicename.title":"Seleziona dispositivo","sorterconfig.addupdate":"Aggiungi/aggiorna la configurazione della destinazione dell'ordinatore","sorterconfig.uploadCSV":"Upload Sorter Destination Configuration CSV","sortertestconfig.addupdatetest":"Aggiungi/aggiorna la configurazione del pacchetto di test Sorter","sortertestconfig.uploadCSV":"Configurazione del pacchetto di test Upload Sorter (CSV)","sortertestconfig.delete":"Seleziona il pacchetto di test da eliminare.","sortertestconfig.nomatch":"Nessun pacchetto di test corrispondente","sortertestconfig.notavailable":"Nessun pacchetto di test disponibile","config.delete":"Elimina configurazione","config.deletetest":"Elimina la configurazione del pacchetto di test Sorter","config.download":"Scarica Config","upload.title":"Carica la configurazione tramite CSV","upload.subtitle":"Carica il file CSV per sovrascrivere la configurazione esistente.","upload.upload_file":"Carica file","upload.drag_here":"oppure trascina il file qui","upload.download_sample":"Scarica il file CSV di esempio","upload.file_length":"Il file caricato contiene {length} righe.","upload.confirm_overwrite":"Premi conferma per sovrascrivere la configurazione.","modal.bayid":"ID della baia","modal.cluster":"Cluster","modal.installationtype":"Tipo di installazione","modal.location":"Sedi","modal.tier":"Livello","modal.optional":"[Facoltativo]  ","modal.location_example":"Separare più corridoi con punto e virgola, ad esempio: J,1; J,2; J,3","modal.adtr_location_example":"Separa le posizioni con il punto e virgola - ad esempio: A.L01;A.L02","modal.enter_value":"Inserisci il valore...","modal.fingerName":"Nome del dito","modal.fingerName_desc":"[Campo facoltativo] Questi alloggiamenti devono essere associati al nome del dito per identificarli in caso di più dita all'interno dello stesso ADTA.","modal.addheading":"Per modificare una configurazione esistente, inserisci il suo Bay Id e digita","modal.addheadingtest":"Per modificare una configurazione esistente, inserisci la zona di ordinamento.","modal.start":"Ora di inizio nel formato UTC: MM/GG/AAAA HH:MM:SS","modal.end":"Ora di fine in formato UTC: MM/GG/AAAA HH:MM:SS","modal.reason":"Motivo","device.active":"Attivo","device.inactive":"Inattivo","device.delete":"Elimina","status.tooltip":"Sano: il dispositivo funziona correttamente. Disconnesso: il dispositivo non è connesso correttamente a Internet e alla rete locale. Caricamento non riuscito: impossibile recuperare lo stato della connessione del dispositivo, qualcosa potrebbe essere sbagliato.","radio.sorter":"Destinazione più ordinata","radio.test":"Pacchetto di test Sorter","alert.missingfields":"Inserisci tutti i campi nel formato corretto!","alert.time":"Assicurati che l'ora di inizio sia inferiore o uguale all'ora di fine!","alert.testing":"Nessuna configurazione di test presente.","alert.device":"Nessun dispositivo presente per questa stazione.","alert.configuration":"Nessuna configurazione di configurazione presente.","alert.actionsdisabled":"Stai utilizzando il portale in modalità di sola lettura. Tutte le azioni sulla pagina sono disattivate.","config.addupdateasl":"Aggiungi/aggiorna la configurazione di deviazione guidata","modal.addheadingasl":"Per modificare una configurazione esistente, inserisci nuovamente lo stesso codice di deviazione.","modal.divertcode":"Codice di deviazione","modal.divertcode_desc":"Intervallo: da 10 a 99","slam.clusters":"Grappoli","modal.clusters":"Grappoli","modal.clusters_desc":"Separare più valori con punto e virgola, ad esempio: A; B; C","radio.guideddivert":"Configurazione del deviamento guidato","tooltip.scrolltobottom":"Scorri verso il basso","tooltip.connectionstatus":"Attivo: il dispositivo funziona correttamente. Inattivo: connesso ma incapace di ricevere messaggi sul battito cardiaco dal dispositivo. Sconosciuto/dispositivo non trovato: impossibile connettersi al dispositivo ","tooltip.disconnectedipvlan":"Le informazioni IP/VLAN potrebbero non essere accurate quando il dispositivo viene disconnesso dalla rete","tooltip.isAuthorized":"Non autorizzato","tooltip.selectmacaddress":"Si prega di selezionare prima un indirizzo MAC","loading.text":"Caricamento...","device.monitoring_modal":"Disabilita il monitoraggio","device.usecase_change_modal":"Cambia caso d'uso del thin client","table.nodata":"Nessun dato presente","alert.testconfig":"Nessuna configurazione del pacchetto di test presente per questo indirizzo MAC.","tooltip.statusLoading":"Stato di caricamento","bintester.errorMessage":"Si è verificato un errore durante il recupero della configurazione del sito per questa stazione","alert.asset_details_success":"Dettagli della risorsa aggiornati correttamente","alert.asset_details_fail":"Impossibile aggiornare i dettagli della risorsa. Riprova!","alert.createdOn":"creato: ","alert.byUser":" per utente: ","device.mcm":"MCM ","device.ticket":"Biglietto ","device.justification":"Altra giustificazione ","device.linkPlaceHolder":"Inserisci MCM/Link ticket/ Altra giustificazione...","device.firmwareVersion":"Versione firmware","log.stopMonitoring":"Interrompi il monitoraggio del registro","log.startMonitoring":"Inizia a monitorare il registro","log.clear":"Svuota","log.filterBySubstring":"Filtra il registro per stringa...","log.filterByDeviceName":"Filtra il registro per nome del dispositivo...","log.messagesToCapture":"Messaggi da catturare","log.error":"Qualcosa è andato storto, riprova più tardi...","log.messageCountError":"Il numero dei messaggi non può superare 300","log.download":"Scarica il registro","mhelog.datetime":"Data/Ora (UTC)","mhelog.protocol":"Protocollo","mhelog.devicetype":"Tipo di dispositivo","mhelog.devicename":"Nome del dispositivo","mhelog.macip":"MAC/IP","mhelog.mac":"MAC","mhelog.ip":"IP","mhelog.eventtype":"Tipo di evento","mhelog.message":"Messaggio","mhelog.payload":"Carico utile","banner.peakPermission":"L'accesso alle funzionalità di amministrazione è limitato durante i periodi di punta. Potresti non essere in grado di eseguire alcune funzioni di modifica sul sito web se non appartieni ai gruppi RME/IT/Admin. Per maggiori dettagli, leggi ","banner.wiki":"il wiki di gestione del dispositivo","banner.bagTracking":"Questa dashboard fornisce il monitoraggio in tempo reale delle borse DSP dotate di smart tag.","table.index":"Indice","test.scannables":"Scannables","test.tracking_id":"ID monitoraggio","test.alt_id":"ID spedizione","test.destination":"Destinazione","test.scannables_description":"ID tracciabilità/spedizione. Separare più valori con il punto e virgola (;)","test.tracking_id_description":"Inserisci l'ID di monitoraggio del pacco","test.alt_id_description":"Inserisci l'ID di spedizione del pacco","test.destination_bag_description":"Per esempio EU: EU_ZZ-AM-1024_BLK , NA: AK-T-0103-503-BLK","container.type":"Tipo di contenitore","container.label":"Etichetta del contenitore","stowconfig.addupdate":"Aggiungi/Aggiorna la configurazione del pacchetto Stow","stowconfig.uploadCSV":"Carica il CSV di configurazione del pacchetto Stow","stowconfig.delete":"Seleziona il tipo di contenitore da eliminare","stowconfig.deleteconfig":"Elimina configurazione","stowconfig.nomatch":"Nessun ID corrispondente trovato","stowconfig.notavailable":"Nessuna configurazione disponibile","stowtestconfig.addupdate":"Aggiungi/Aggiorna la configurazione del pacchetto di test","modal.headingtest":"Per modificare una configurazione esistente, inserisci il BagId di destinazione.","stowtestconfig.delete":"Seleziona il pacchetto di prova da eliminare.","stowtestconfig.deleteconfig":"Elimina la configurazione del pacchetto di prova","stowtestconfig.uploadCSV":"Carica il CSV di configurazione del pacchetto di test Stow","testconfig.nomatch":"Nessun pacchetto di test corrispondente","testconfig.notavailable":"Nessun pacchetto di prova disponibile","modal.delete_test_package":"Seleziona la voce che desideri rimuovere.","modal.tesseract_headingtest":"Per modificare una configurazione esistente, inserisci l'ID di monitoraggio del pacco","modal.tesseract_containerLabel_description":"Inserisci l'etichetta del contenitore tesseract, ad es. UE: A1, NA: A-1","modal.tesseract_containerType_description":"Inserisci il tipo di contenitore della macchina, ad es. SAMPL_01","modal.tesseract_headingconfig":"Per modificare una configurazione esistente, inserisci il Tipo di contenitore","modal.tesseract_delete_stow_config":"Seleziona il tipo di contenitore che desideri rimuovere","bagtracking.heading":"Monitoraggio delle borse","filter.heading":"Filtra per orario di partenza","bagTable.transporterId":"Identificativo del trasportatore","bagTable.bagId":"Identificativo borsa","bagTable.bagStatus":"Stato della borsa","bagTable.departTime":"Orario di partenza","bagTable.receiveTime":"Ricevi tempo","lidarTester.select":"Seleziona Controller Lidar","modal.selectAisleType":"Seleziona tipo di corridoio","modal.ledControllerType":"Tipo di controller LED","modal.defaultAisleType":"Tipo di corridoio predefinito","modal.colorOrder":"Ordine dei colori","modal.selectLedControllerType":"Seleziona tipo di controller LED","modal.selectDefaultAisleType":"Seleziona tipo di corridoio predefinito","modal.selectColorOrder":"Seleziona ordine dei colori","device.add_only_device_button_modal":"Aggiungi configurazione dispositivo singolo","device.device.add_aisles_button_modal":"Aggiungi configurazione corridoi","node.update_defaults_button_modal":"Aggiorna impostazioni predefinite","alert.aisleduplicatefields":"Per favore inserisci un nome corridoio unico!","alert.portduplicatefields":"Per favore inserisci un numero di porta unico!","config.addonerow":"Aggiungi una riga","config.addmultiplerows":"Aggiungi più righe","config.updateledcontroller":"Aggiorna controller LED","modal.aislename":"Nome del corridoio","modal.aisletype":"Tipo di corridoio","modal.actions":"Azioni","alert.asset_delete_success":"L'asset è stato eliminato con successo","alert.asset_defaults_success":"Le impostazioni predefinite dell'asset sono state aggiornate con successo","alert.asset_delete_fail":"Impossibile eliminare l'asset. Riprova!","alert.asset_defaults_fail":"Impossibile aggiornare le impostazioni predefinite dell'asset. Riprova!","alert.asset_create_success":"L'asset è stato creato con successo","modal.selectLidarControllerType":"Seleziona il tipo di controller Lidar","device.controller_type":"Tipo di controller","banner.dmwPermission":"Non sei autorizzato ad accedere a questo dispositivo. Per ottenere l'accesso, consulta il link sottostante.","locationconfig.addupdate":"Aggiungi/aggiorna la configurazione della posizione ZancaSort","locationconfig.uploadCSV":"Carica il file CSV di configurazione della posizione ZancaSort","locationconfig.deleteconfig":"Elimina la configurazione della posizione ZancaSort","tierconfig.addupdate":"Aggiungi/aggiorna la configurazione dei livelli ZancaSort","tierconfig.uploadCSV":"Carica CSV configurazione livelli ZancaSort","tierconfig.deleteconfig":"Elimina la configurazione dei livelli ZancaSort","tierconfig.tierName":"Nome livello","tierconfig.capacity":"Capacità","tierconfig.startLevel":"Livello iniziale (inclusivo)","tierconfig.endLevel":"Livello finale (inclusivo)","modal.addtierheading":"Per modificare una configurazione esistente, seleziona il nome del livello.","modal.delete_tier_config":"Seleziona il nome del livello che desideri rimuovere","tierconfig.selectTier":"Seleziona il nome del livello","location.id":"Posizione","location.type":"Tipo di ubicazione","locationconfig.delete":"Seleziona l'ID della località","modal.delete_location_config":"Seleziona l'ID della località che desideri rimuovere","modal.toggleStowStations.title":"Attiva/disattiva le stazioni di stivaggio","modal.toggleStowStations.topStation":"Stazione Top Stow","modal.toggleStowStations.bottomStation":"Stazione Bottom Stow","modal.toggleStowStations.updating":"Mise à jour de la configuration de la station de rangement...","locationmapping.destination":"Pick Chute","locationmapping.type":"Item Type","locationmapping.locations":"Pick Point(s)","locationmapping.add":"Add Config","locationmapping.uploadCSV":"Upload Location Config CSV","locationmapping.destination.placeholder":"e.g. PC1","locationmapping.type.placeholder":"Select item type","locationmapping.locations.placeholder":"Select pick points","locationmapping.error.column_count":"Expected 3 columns but found {count}.","locationmapping.error.pick_point_not_found":"Pick point \"{pickPoint}\" does not exist at this station.","locationmapping.error.row_prefix":"Row {row}: {message}","locationmapping.delete_config":"Delete Config","locationmapping.delete_title":"Delete Location Mapping","locationmapping.delete_confirmation":"Are you sure you want to delete the entire location mapping configuration? This action will be applied when you deploy the draft.","locationmapping.no_pick_points":"No pick points found for this station.","locationmapping.modal.add_title":"Add Location Mapping","locationmapping.modal.edit_title":"Edit Location Mapping","locationmapping.error.destination_required":"Destination is required.","locationmapping.error.destination_invalid":"Destination must start with a letter, contain only letters, digits, underscore, hyphen, or period, and be at most 50 characters.","locationmapping.error.type_required":"Item type is required.","locationmapping.error.locations_required":"At least one pick point must be selected.","locationmapping.error.duplicate":"A mapping for \"{destination}\" with type \"{type}\" already exists.","locationmapping.error.conflict":"Pick point \"{pickPoint}\" is already mapped to \"{destination}\" for type \"{type}\"."}

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

module.exports = {"external.logs":"エンジニアリング ダッシュボード","external.dashboard":"ロギング ダッシュボード","asl.heading":"ASL デバイス","thinclients.heading":"シンクライアント","adta.heading":"ADTA デバイス","common.data_last_updated":"データ最終更新日","adta.connected":"接続済み","zancasort.heading":"ZancaSort デバイス","tesseract.heading":"Tesseract デバイス","autoretriever.heading":"オートレトリバー","sbl.heading":"SBL デバイス","device.name":"[名前]","device.location":"場所","device.mac_ip":"MAC/IP アドレス","device.device_type":"デバイスタイプ","device.component_type":"コンポーネントの種類","device.connection":"接続ステータス","device.action":"アクション","device.pick_stations":"ピッキングステーション","device.add_device_button_modal":"単一デバイス構成の追加/更新","device.delete_device_button_modal":"単一デバイス構成を削除","device.edit_device_mac_modal":"単一デバイスの MAC アドレスの編集","device.delete_config_button_modal":"ソーター送信先設定の削除","device.delete_divert_config_button_modal":"ガイド付き転送設定の削除","device.delete_config_button_modal_autoloader":"AutoLoader設定を削除","modal.destinationiddelete":"削除する送信先IDを選択してください","autoloaderconfig.addupdate":"AutoLoader設定を追加/更新","autoloaderconfig.uploadCSV":"AutoLoader設定CSVをアップロード","radio.loader":"AutoLoader送信先","modal.device_id_induct_line_desc":"デバイスの一意のローカル識別子。例: \"誘導線 1\" の場合は \"1\"","modal.name_induct_line_desc":"デバイスの表示名。例: \"インダクトライン 1\"","device.edit_config":"構成を追加または編集","device.device_category":"デバイスカテゴリ","device.offline_devices_locations":"オフラインデバイスの場所","device.disable_obstruction_button_modal":"単一デバイスの妨害を無効にする","device.enable_obstruction_button_modal":"単一デバイスの妨害を有効にする","device.obstructiondisableduntil":"妨害は1分後に無効化され、〜まで無効のままになります","device.obstructionwillbeenabled":"これから妨害が有効になります","asl.desc":"このページには、ASL デバイスのリアルタイムのステータスが、デバイスと ASL ガイド付き転送設定とともに表示されます。","adta.desc":"このページには、ADTAデバイスのリアルタイムのステータスと、ソーター宛先およびソーターテストパッケージ構成が表示されます。","sbl.desc":"このページには、LEDコントローラのリアルタイムのステータスが、MAC/IPアドレスと接続とともに表示されます","thinclient.desc":"このページには、シンクライアントデバイスのリアルタイムのステータスが、MAC/IPアドレスとヘルスステータスとともに表示されます。","device.vlan":"VLAN","device.usecase":"ユースケース","device.status":"ステータス","device.swstatus":"ソフトウェアステータス","device.remark":"リマーク","device.monitoring":"モニタリングステータス","device.monitoringEnabled":"有効","device.monitoringDisabled":"無効","device.invalidEntry":"入力が無効です","device.editWarning":"ASL/ADTA の機能に一時的に影響する変更を加えようとしています。続行する前に、これらのマシンでサイクルが実行されていないことを確認してください","actions.deleteDevice":"デバイスを削除","actions.addDevice":"デバイスを編集","actions.edit":"JSON による編集","actions.changeMac":"デバイスの MAC アドレスを変更","actions.toggleStowStations":"収納ステーションを切り替え","actions.monitoring_disable":"監視を無効にする","actions.monitoring_enable":"監視を有効にする","actions.deploydraft":"ドラフトをデプロイ","actions.discarddraft":"ドラフトを破棄","actions.rollback":"ロールバック","actions.deploy":"デプロイ","actions.disableObstruction":"障害物を無効にする","actions.enableObstruction":"障害物を有効にする","actions.restart":"アプリケーションを再起動する","button.add":"JSON による追加/編集","button.addcsv":"CSV による追加/編集","button.delete":"デバイスを削除","button.save":"保存","button.edit":"編集","pickstation.label":"ピッキングステーション","pickstation.no_resources":"このステーションにピッキングステーションが見つかりません。","modal.adta_heading":"データ","modal.asl_heading":"ASL","modal.confirm":"確認する","modal.confirmAdd":"追加を確認","modal.confirmEdit":"編集を確認","modal.cancel":"[キャンセル]","modal.copy":"コピーする","modal.paste":"貼り付ける","modal.remove":"削除する","tab.testing":"テスト","tab.configuration":"コンフィギュレーション","tab.aisleconfigfinder":"SBL Config Finder","tab.overview":"[概要]","tab.logstream":"ログストリーム","tab.managebyexceptions":"例外による管理","tab.lidartester":"ライダーテスター","deviceManagement.filters":"デバイスタイプを選択","deviceManagement.tag":"デバイスタイプ","deviceManagement.noresults":"結果なし","modal.mac":"MAC アドレス","modal.startAisle":"開始通路","modal.startPort":"開始ポート","modal.aisleCount":"通路数","modal.config":"設定の JSON を入力します。","modal.configcsv":"設定 CSV ファイルをアップロードします。","modal.macdelete":"削除するデバイスの MAC アドレスを入力してください。","modal.selectmacdelete":"削除する MAC アドレスを選択します。","modal.confirmmacdelete":"次のデバイスを削除することを確認してください。","modal.confirmmacedit":"次のデバイスの新しい MAC アドレスを入力してください。","modal.deleteAll":"[すべて削除]","modal.bayiddelete":"削除したいベイIDを選択してください:","modal.selectbayid":"ベイ ID を選択","modal.divertcodedelete":"削除したい転送コードを入力してください","modal.select_divert_code":"削除する転送コードを選択してください。","modal.pick_stations":"ピッキングステーション","modal.pick_stations_desc":"関連するピック ステーションのラベルを (;) で区切って入力します。","modal.device_id":"デバイス ID","modal.device_id_line_desc":"デバイスの固有のローカル識別子。例:「Line 3」の場合は「3」","modal.device_id_finger_desc":"デバイスの固有のローカル識別子。例えば「フィンガーA」の「A」","modal.device_id_cluster_desc":"デバイスの一意のローカル識別子。例えば。 「A」は「クラスター A」を表します","modal.confirmdisableobstructionupdate":"次のデバイスの障害を無効にすることを確認してください:","modal.port":"ポート","modal.protocol_msg":"「ソート」または「ソート-2021-v1」","modal.protocol":"プロトコル","modal.induct_camera_mac":"インダクトカメラMAC","modal.printer_mac":"プリンターMAC","modal.verification_camera_mac":"認証カメラMAC","modal.select_protocol":"プロトコルを選択する","modal.select_induct_camera_mac":"カメラの MAC アドレスを選択します","modal.select_printer_mac":"プリンターのMACアドレスの選択","modal.select_verification_camera_mac":"認証カメラのMACアドレスを選択","modal.responsePort":"レスポンスポート","modal.userId":"ユーザ ID","modal.inductLocation":"ロケーションを誘導","modal.name":"デバイス名","modal.name_line_desc":"デバイスの名前を表示します。例:「Line 3」","modal.no_device_available":"使用可能なデバイスはありません","modal.name_finger_desc":"デバイスの名前を表示します。例:「Finger A」","modal.name_cluster_desc":"デバイスの表示名。例えば「クラスターA」","modal.parent_asset_mac":"親アセットの MAC アドレス","modal.parent_asset_mac_desc":"[オプション] このクラスターの収納ステーションに仕分ける親 ADTF の MAC アドレス。","modal.name_matrix_desc":"デバイスの名前を表示します。例:「Matrix A」","modal.device_type_asl":"デバイスタイプ（スラム、スラム-2021-v1のいずれかである必要があります）","modal.ip":"IP アドレス","modal.sortzonedelete":"削除するスキャナブルを選択してください。","modal.vendor":"ベンダー","modal.select_vendor":"ベンダーの選択","modal.spec_version":"ハードウェア仕様のバージョン","modal.select_version":"ハードウェア仕様バージョンの選択","modal.sorter_type":"選別技術","modal.select_sorter_type":"選別機テクノロジーの選択","modal.hamper_vendor":"バスケットベンダー","modal.select_hamper_vendor":"ハンパーベンダーを選択","modal.hamper_version":"ハンパーバージョン","modal.select_hamper_version":"ハンパーバージョンを選択","modal.incoming_auto_singulated":"荷物は自動で分離されます","modal.incoming_auto_sorted":"荷物は自動でフィンガーに仕分けされます","modal.select_incoming_auto_singulated":"はいかいいえを選んでください","modal.select_incoming_auto_sorted":"はいかいいえを選んでください","modal.selectusecase":"ユースケースの選択","modal.selectnewusecase":"シンクライアントの新しいユースケースを選択してください。","modal.confirmchangeusecase":"選択した新しいシンクライアントの使用例を確認してください。","modal.confirmUpdate":"更新を確認する","device.vendor":"ベンダー/バージョン","device.sorter_type":"選別技術","device.hamper_vendor":"バスケットベンダー/バージョン","devicemanagement.heading":"デバイス管理","devicemanagement.desc":"このページには、オートメーションデバイス、シンクライアント、SBLデバイスのリアルタイムステータスが表示され、選択したデバイスタイプの設定に役立ちます。","actions.secondary":"二次ユースケースを作成","actions.primary":"主なユースケースを作成","actions.usecase":"シンクライアントのユースケースを変更する","bay.location":"拠点","bay.installlationtype":"インストールタイプ","bay.id":"ベイ ID","destination.id":"宛先識別子","bay.index":"索引","bay.scannables":"スキャナブル","bay.scannables_description":"追跡/発送ID。複数の値はセミコロン (;) で区切ります","bay.sortzone":"ソートゾーン","bay.sortzone_description":"例えば。欧州:A1-1A、NA: A-1.1A","configtype.title":"構成タイプを選択","devicename.title":"デバイスを選択","sorterconfig.addupdate":"ソーター宛先設定の追加/更新","sorterconfig.uploadCSV":"ソーター送信先設定CSVをアップロード","sortertestconfig.addupdatetest":"ソーターテストパッケージ構成の追加/更新","sortertestconfig.uploadCSV":"ソーターテストパッケージ設定 CSV をアップロード","sortertestconfig.delete":"削除するテストパッケージを選択します。","sortertestconfig.nomatch":"一致するテストパッケージはありません","sortertestconfig.notavailable":"テストパッケージはありません","config.delete":"構成を削除","config.deletetest":"ソーターテストパッケージ設定の削除","config.download":"構成をダウンロード","upload.title":"CSV による設定のアップロード","upload.subtitle":"CSV ファイルをアップロードして既存の設定を上書きします。","upload.upload_file":"ファイルをアップロード","upload.drag_here":"またはここにファイルをドラッグ","upload.download_sample":"サンプル CSV ファイルをダウンロードする","upload.file_length":"アップロードされたファイルには {length} 行が含まれています。","upload.confirm_overwrite":"確認を押して設定を上書きします。","modal.bayid":"ベイ ID","modal.cluster":"クラスター","modal.installationtype":"インストールタイプ","modal.location":"拠点","modal.tier":"段","modal.optional":"[オプション] ","modal.location_example":"複数の通路はセミコロンで区切ります。例:J,1; J,2; J,3","modal.adtr_location_example":"セミコロンで場所を区切ります - 例: A.L01;A.L02","modal.enter_value":"値を入力...","modal.fingerName":"フィンガーネーム","modal.fingerName_desc":"[オプションのフィールド] これらのベイは、同じ ADTA 内に複数のフィンガーがある場合に識別できるように、フィンガー名に関連付ける必要があります。","modal.addheading":"既存の構成を編集するには、ベイ ID を入力して次のように入力します","modal.addheadingtest":"既存の構成を編集するには、ソートゾーンを入力します。","modal.start":"UTC 形式の開始時間:月/日/年、Y、Y、Y、H: MM: SS","modal.end":"UTC フォーマットの終了時刻:月/日/年/年:月:秒","modal.reason":"理由","device.active":"アクティブ","device.inactive":"非アクティブ","device.delete":"[削除]","status.tooltip":"正常:デバイスは正常に動作しています。接続解除:デバイスがインターネットとローカルネットワークの両方に正しく接続されていません。読み込み失敗:デバイスの接続ステータスを取得できませんでした。何か問題がある可能性があります。","radio.sorter":"ソーター目的地","radio.test":"ソーターテストパッケージ","alert.missingfields":"すべてのフィールドを正しい形式で入力してください!","alert.time":"開始時間が終了時間以下であることを確認してください！","alert.testing":"テスト設定はありません。","alert.device":"このステーションにはデバイスがありません。","alert.configuration":"構成セットアップはありません。","alert.actionsdisabled":"ポータルを読み取り専用モードで使用しています。ページ上のすべてのアクションは無効になっています。","config.addupdateasl":"ガイド付き転送設定を追加/更新","modal.addheadingasl":"既存の構成を編集するには、同じ転送コードをもう一度入力します。","modal.divertcode":"転送コード","modal.divertcode_desc":"レンジ:10 から 99","slam.clusters":"クラスタ","modal.clusters":"クラスタ","modal.clusters_desc":"複数の値はセミコロンで区切ります。例:A; B; C","radio.guideddivert":"ガイド付き転送設定","tooltip.scrolltobottom":"一番下までスクロール","tooltip.connectionstatus":"アクティブ:デバイスは正常に動作しています。非アクティブ:接続されていますが、デバイスからハートビートメッセージを受信できません。不明/デバイスが見つかりません:デバイスに接続できません ","tooltip.disconnectedipvlan":"デバイスがネットワークから切り離されているため、IP/VLAN情報が正確でない場合があります","tooltip.isAuthorized":"許可されていません","tooltip.selectmacaddress":"最初にMACアドレスを選択してください","loading.text":"読み込み中...","device.monitoring_modal":"監視を無効にする","device.usecase_change_modal":"シンクライアントのユースケースを変更する","table.nodata":"データなし","alert.testconfig":"この MAC アドレスのテストパッケージ構成はありません。","tooltip.statusLoading":"読み込み状況","bintester.errorMessage":"このステーションのサイト構成を取得中にエラーが発生しました","alert.asset_details_success":"アセットの詳細が正常に更新されました","alert.asset_details_fail":"アセットの詳細を更新できませんでした。再試行する！","alert.createdOn":"作成日: ","alert.byUser":" ユーザー別: ","device.mcm":"MCM ","device.ticket":"チケット ","device.justification":"その他の理由","device.linkPlaceHolder":"MCM/チケット リンク/その他の理由を入力してください...","device.firmwareVersion":"ファームウェアバージョン","log.stopMonitoring":"ログの監視を停止する","log.startMonitoring":"ログの監視を開始する","log.clear":"クリア","log.filterBySubstring":"ログを文字列でフィルタリングします...","log.filterByDeviceName":"デバイス名でログをフィルタリングします...","log.messagesToCapture":"キャプチャするメッセージ","log.error":"エラーが発生しました。後ほどもう一度試してください...","log.messageCountError":"メッセージ数は300を超えることはできません","log.download":"ログをダウンロード","mhelog.datetime":"日付/時刻 (UTC)","mhelog.protocol":"プロトコル","mhelog.devicetype":"デバイスタイプ","mhelog.devicename":"デバイス名","mhelog.macip":"MAC/IP","mhelog.mac":"MAC","mhelog.ip":"IP","mhelog.eventtype":"イベントタイプ","mhelog.message":"メッセージ","mhelog.payload":"ペイロード","banner.peakPermission":"ピーク時には管理機能へのアクセスが制限されます。 RME/IT/Admin グループに属していない場合、Web サイトで特定の編集機能を実行できない場合があります。詳細については、こちらをお読みください ","banner.wiki":"デバイス管理 Wiki","banner.bagTracking":"このダッシュボードでは、スマートタグを装備したDSPバッグをリアルタイムで追跡できます。","table.index":"索引","test.scannables":"スキャン可能なもの","test.tracking_id":"トラッキングID","test.alt_id":"パッケージの出荷ID","test.destination":"行き先","test.scannables_description":"追跡/発送ID。複数の値はセミコロン (;) で区切ります","test.tracking_id_description":"荷物追跡IDを入力してください","test.alt_id_description":"パッケージの配送IDを入力してください","test.destination_bag_description":"例えば。 EU: EU_ZZ-AM-1024_BLK , NA: AK-T-0103-503-BLK","container.type":"コンテナの種類","container.label":"容器ラベル","stowconfig.addupdate":"Stow パッケージ構成の追加/更新","stowconfig.uploadCSV":"Stow パッケージ構成 CSV をアップロードする","stowconfig.delete":"削除するコンテナの種類を選択してください","stowconfig.deleteconfig":"構成の削除","stowconfig.nomatch":"一致する ID が見つかりませんでした","stowconfig.notavailable":"使用可能な構成がありません","stowtestconfig.addupdate":"テストパッケージ構成の追加/更新","modal.headingtest":"既存の設定を編集するには、宛先 BagId を入力します。","stowtestconfig.delete":"削除するテスト パッケージを選択します。","stowtestconfig.deleteconfig":"テストパッケージ構成の削除","stowtestconfig.uploadCSV":"Stow テスト パッケージ構成 CSV をアップロードする","testconfig.nomatch":"一致するテスト パッケージがありません","testconfig.notavailable":"利用可能なテスト パッケージがありません","modal.delete_test_package":"削除するエントリを選択します。","modal.tesseract_headingtest":"既存の構成を編集するには、パッケージ追跡 ID を入力します","modal.tesseract_containerLabel_description":"tesseractコンテナラベルを入力します。 EU: A1、NA: A-1","modal.tesseract_containerType_description":"マシンコンテナのタイプを入力します。 SAMPL_01","modal.tesseract_headingconfig":"既存の構成を編集するには、コンテナ タイプを入力します。","modal.tesseract_delete_stow_config":"削除したいコンテナのタイプを選択してください","bagtracking.heading":"手荷物追跡","filter.heading":"出発時間によるフィルター","bagTable.transporterId":"トランスポーターID","bagTable.bagId":"バッグID","bagTable.bagStatus":"バッグのステータス","bagTable.departTime":"出発時間","bagTable.receiveTime":"受信時間","lidarTester.select":"LIDAR コントローラーの選択","modal.selectAisleType":"通路タイプを選択","modal.ledControllerType":"LEDコントローラータイプ","modal.defaultAisleType":"デフォルト通路タイプ","modal.colorOrder":"色順序","modal.selectLedControllerType":"LEDコントローラータイプを選択","modal.selectDefaultAisleType":"デフォルト通路タイプを選択","modal.selectColorOrder":"色順序を選択","device.add_only_device_button_modal":"単一デバイス設定を追加","device.device.add_aisles_button_modal":"通路設定を追加","node.update_defaults_button_modal":"デフォルト設定を更新","alert.aisleduplicatefields":"一意の通路名を入力してください！","alert.portduplicatefields":"一意のポート番号を入力してください！","config.addonerow":"1行を追加","config.addmultiplerows":"複数行を追加","config.updateledcontroller":"LEDコントローラーを更新","modal.aislename":"通路名","modal.aisletype":"通路タイプ","modal.actions":"アクション","alert.asset_delete_success":"資産が正常に削除されました","alert.asset_defaults_success":"資産のデフォルト設定が正常に更新されました","alert.asset_delete_fail":"資産の削除に失敗しました。再試行してください！","alert.asset_defaults_fail":"資産のデフォルト設定の更新に失敗しました。再試行してください！","alert.asset_create_success":"資産が正常に作成されました","modal.selectLidarControllerType":"Lidarコントローラーの種類を選択","device.controller_type":"コントローラーの種類","banner.dmwPermission":"このデバイスにアクセスする権限がありません。アクセスするには、以下のリンクを確認してください。","locationconfig.addupdate":"ZancaSortロケーション構成の追加/更新","locationconfig.uploadCSV":"ZancaSort ロケーション設定 CSV をアップロード","locationconfig.deleteconfig":"ZancaSort ロケーション設定の削除","tierconfig.addupdate":"ZancaSort ティア構成の追加/更新","tierconfig.uploadCSV":"ZancaSort ティア構成 CSV をアップロード","tierconfig.deleteconfig":"ZancaSort ティア構成の削除","tierconfig.tierName":"ティア名","tierconfig.capacity":"容量","tierconfig.startLevel":"開始レベル (含む)","tierconfig.endLevel":"終了レベル (含む)","modal.addtierheading":"既存の構成を編集するには、ティア名を選択してください。","modal.delete_tier_config":"削除したいティア名を選択してください","tierconfig.selectTier":"ティア名を選択","location.id":"ロケーション","location.type":"ロケーションタイプ","locationconfig.delete":"ロケーション ID を選択","modal.delete_location_config":"削除したいロケーションIDを選択してください","modal.toggleStowStations.title":"ストウステーションの切り替え","modal.toggleStowStations.topStation":"トップストウステーション","modal.toggleStowStations.bottomStation":"ボトムストウステーション","modal.toggleStowStations.updating":"ストウステーションの設定を更新中...","locationmapping.destination":"Pick Chute","locationmapping.type":"Item Type","locationmapping.locations":"Pick Point(s)","locationmapping.add":"Add Config","locationmapping.uploadCSV":"Upload Location Config CSV","locationmapping.destination.placeholder":"e.g. PC1","locationmapping.type.placeholder":"Select item type","locationmapping.locations.placeholder":"Select pick points","locationmapping.error.column_count":"Expected 3 columns but found {count}.","locationmapping.error.pick_point_not_found":"Pick point \"{pickPoint}\" does not exist at this station.","locationmapping.error.row_prefix":"Row {row}: {message}","locationmapping.delete_config":"Delete Config","locationmapping.delete_title":"Delete Location Mapping","locationmapping.delete_confirmation":"Are you sure you want to delete the entire location mapping configuration? This action will be applied when you deploy the draft.","locationmapping.no_pick_points":"No pick points found for this station.","locationmapping.modal.add_title":"Add Location Mapping","locationmapping.modal.edit_title":"Edit Location Mapping","locationmapping.error.destination_required":"Destination is required.","locationmapping.error.destination_invalid":"Destination must start with a letter, contain only letters, digits, underscore, hyphen, or period, and be at most 50 characters.","locationmapping.error.type_required":"Item type is required.","locationmapping.error.locations_required":"At least one pick point must be selected.","locationmapping.error.duplicate":"A mapping for \"{destination}\" with type \"{type}\" already exists.","locationmapping.error.conflict":"Pick point \"{pickPoint}\" is already mapped to \"{destination}\" for type \"{type}\"."}

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

module.exports = {"external.logs":"Protokollierungs-Dashboard","external.dashboard":"Engineering-Dashboard","asl.heading":"ASL-Geräte","thinclients.heading":"Thin Clients","adta.heading":"ADTA-Geräte","zancasort.heading":"ZancaSort Geräte","tesseract.heading":"Tesseract Geräte","autoretriever.heading":"Auto-Retriever","common.data_last_updated":"Letzte Aktualisierung der Daten","adta.connected":"Verbunden","sbl.heading":"SBL Geräte","device.name":"Nennen","device.location":"Standort","device.mac_ip":"MAC-/IP-Adresse","device.device_type":"Art des Geräts","device.component_type":"Komponententyp","device.connection":"Status der Verbindung","device.action":"Aktion","device.pick_stations":"Kommissionierstationen","device.add_device_button_modal":"Einzelgerätekonfiguration hinzufügen/aktualisieren","device.delete_device_button_modal":"Einzelgerätekonfiguration löschen","device.edit_device_mac_modal":"Mac-Adresse eines einzelnen Geräts bearbeiten","device.delete_config_button_modal":"Konfiguration des Sorter-Ziels löschen","device.delete_divert_config_button_modal":"Konfiguration für Guided Divert löschen","device.edit_config":"Konfiguration hinzufügen oder bearbeiten","device.device_category":"Gerätekategorie","device.offline_devices_locations":"Standorte für Offline-Geräte","asl.desc":"Diese Seite zeigt den Echtzeitstatus der ASL-Geräte zusammen mit dem Gerät und der ASL Guided Divert Configuration","adta.desc":"Diese Seite zeigt den Echtzeitstatus von ADTA-Geräten zusammen mit der Konfiguration des Sorter-Ziels und des Sorter-Testpakets","sbl.desc":"Diese Seite zeigt den Echtzeitstatus der LED-Controller zusammen mit der MAC/IP-Adresse und Konnektivität","thinclient.desc":"Diese Seite zeigt den Echtzeitstatus von Thin Client-Geräten zusammen mit der MAC-/IP-Adresse und dem Gesundheitsstatus","device.vlan":"VLAN","device.usecase":"Anwendungsfall","device.status":"Status","device.swstatus":"Status der Software","device.remark":"Bemerkung","device.monitoring":"Status überwachen","device.monitoringEnabled":"Aktiviert","device.monitoringDisabled":"Deaktiviert","device.invalidEntry":"Ungültiger Eintrag","device.editWarning":"Sie sind im Begriff, eine Änderung vorzunehmen, die die ASL/ADTA-Funktion vorübergehend beeinträchtigt. Bitte stellen Sie sicher, dass auf diesen Maschinen kein Zyklus läuft, bevor Sie fortfahren","actions.deleteDevice":"Gerät löschen","actions.addDevice":"Gerät bearbeiten","actions.edit":"Per JSON bearbeiten","actions.changeMac":"Mac-Adresse des Geräts ändern","actions.toggleStowStations":"Staustellungen umschalten","actions.monitoring_disable":"Überwachung deaktivieren","actions.monitoring_enable":"Überwachung aktivieren","actions.deploydraft":"Entwurf bereitstellen","actions.discarddraft":"Entwurf verwerfen","actions.rollback":"Rollback","actions.deploy":"Bereitstellen","actions.restart":"Applikation neustarten","button.add":"Über JSON hinzufügen/bearbeiten","button.addcsv":"Über CSV hinzufügen/bearbeiten","button.delete":"Gerät löschen","button.save":"Speichern","button.edit":"Bearbeiten","pickstation.label":"Kommissionierstation","pickstation.no_resources":"Keine Kommissionierstationen für diese Station gefunden.","modal.adta_heading":"DATEN","modal.asl_heading":"ASL","modal.confirm":"Bestätigen","modal.confirmAdd":"Bestätigen Sie das Hinzufügen","modal.confirmEdit":"Bearbeitung bestätigen","modal.cancel":"Stornieren","modal.copy":"Kopieren","modal.paste":"Einfügen","modal.remove":"Entfernen","tab.testing":"Testen","tab.sbldashboard":"SBL-Dashboard","tab.configuration":"Konfiguration","tab.aisleconfigfinder":"SBL Config Finder","tab.overview":"Überblick","tab.logstream":"Log-Stream","tab.managebyexceptions":"Verwalten nach Ausnahmen","tab.lidartester":"Lidar-Tester","deviceManagement.filters":"Wählen Sie den Gerätetyp","deviceManagement.tag":"Art des Geräts","deviceManagement.noresults":"Keine Ergebnisse","modal.mac":"MAC-Adresse","modal.startAisle":"Startgang","modal.startPort":"Startanschluss","modal.aisleCount":"Anzahl der Gänge","modal.config":"Füllen Sie das Konfigurations-JSON aus","modal.configcsv":"Laden Sie die Konfigurations-CSV-Datei hoch.","modal.macdelete":"Bitte geben Sie die MAC-Adresse des Geräts ein, das Sie entfernen möchten.","modal.selectmacdelete":"Wählen Sie die zu löschende MAC-Adresse aus.","modal.confirmmacdelete":"Bitte bestätigen Sie, dass Sie das folgende Gerät löschen möchten:","modal.confirmmacedit":"Bitte geben Sie eine neue MAC-Adresse für das folgende Gerät ein:","modal.deleteAll":"Alles löschen","modal.bayiddelete":"Bitte wählen Sie die Bay-ID aus, die Sie entfernen möchten:","modal.selectbayid":"Wählen Sie die Bay-ID","modal.divertcodedelete":"Bitte geben Sie den Umleitungscode ein, den Sie entfernen möchten","modal.select_divert_code":"Wählen Sie den Umleitungscode aus, der gelöscht werden soll.","modal.pick_stations":"Kommissionierstationen","modal.pick_stations_desc":"Labels zugehöriger Kommissionierstationen getrennt mit (;)","modal.device_id":"Geräte-ID","modal.device_id_line_desc":"Eindeutige lokale Kennung für das Gerät. z. B. „3\" für „Line 3\"","modal.device_id_finger_desc":"Eindeutige lokale Kennung für das Gerät. z.B. „A“ für „Finger A“","modal.device_id_cluster_desc":"Eindeutige lokale Kennung für das Gerät. z.B. „A“ für „Cluster A“","modal.port":"Hafen","modal.protocol_msg":"Entweder „sortieren“ oder „sort-2021-v1\"","modal.protocol":"Protokoll","modal.induct_camera_mac":"Kamera MAC einführen","modal.printer_mac":"Drucker MAC","modal.verification_camera_mac":"Verifizierungskamera MAC","modal.select_protocol":"Wählen Sie ein Protokoll","modal.select_induct_camera_mac":"Wählen Sie die MAC-Adresse der Induct-Kamera aus","modal.select_printer_mac":"Wählen Sie die MAC-Adresse des Druckers aus","modal.select_verification_camera_mac":"Wählen Sie die MAC-Adresse der Verifizierungskamera aus","modal.responsePort":"Antwort-Port","modal.userId":"Benutzer-ID","modal.inductLocation":"Standort einleiten","modal.name":"Gerätename","modal.name_line_desc":"Anzeigename des Geräts. z. B. „Line 3\"","modal.no_device_available":"Keine Geräte verfügbar","modal.name_finger_desc":"Anzeigename des Geräts. z. B. „Finger A“","modal.name_cluster_desc":"Anzeigename des Geräts. z.B. „Cluster A“","modal.parent_asset_mac":"MAC-Adresse des übergeordneten Assets","modal.parent_asset_mac_desc":"[Optional] MAC-Adresse des übergeordneten ADTF, der zu den Staustellungen dieses Clusters umleitet.","modal.name_matrix_desc":"Anzeigename des Geräts. z. B. „Matrix A“","modal.device_type_asl":"Gerätetyp (muss einer der folgenden sein: slam, slam-2021-v1)","modal.ip":"IP-Adresse","modal.sortzonedelete":"Bitte wählen Sie das scannbare Objekt aus, das Sie entfernen möchten.","modal.vendor":"Verkäufer","modal.select_vendor":"Wählen Sie einen Anbieter","modal.spec_version":"Hardware-Spezifikationsversion","modal.select_version":"Wählen Sie Hardwarespezifikationsversion aus","modal.sorter_type":"Sortiertechnologie","modal.select_sorter_type":"Wählen Sie Sortiertechnologie","modal.hamper_vendor":"Verkäufer von Geschenkkörben","modal.select_hamper_vendor":"Wählen Sie Hamper Vendor","modal.hamper_version":"Version mit Korb","modal.select_hamper_version":"Wählen Sie die Hamper-Version","modal.incoming_auto_singulated":"Pakete werden automatisch einzeln geführt","modal.incoming_auto_sorted":"Pakete werden automatisch zum Finger sortiert","modal.select_incoming_auto_singulated":"Wählen Sie Ja oder Nein","modal.select_incoming_auto_sorted":"Wählen Sie Ja oder Nein","modal.selectusecase":"Wählen Sie Anwendungsfall aus","modal.selectnewusecase":"Bitte wählen Sie einen neuen Anwendungsfall für Thin Client aus.","modal.confirmchangeusecase":"Bitte bestätigen Sie den neuen Thin Client-Anwendungsfall, den Sie ausgewählt haben.","device.vendor":"Anbieter/Version","device.sorter_type":"Sortiertechnologie","device.hamper_vendor":"Hamper Anbieter/Version","devicemanagement.heading":"Verwaltung von Geräten","devicemanagement.desc":"Diese Seite zeigt den Echtzeitstatus von Automatisierungsgeräten, Thin Clients und SBL-Geräten und hilft Ihnen bei der Konfiguration des ausgewählten Gerätetyps.","actions.secondary":"Sekundären Anwendungsfall erstellen","actions.primary":"Primäres Anwendungsbeispiel erstellen","actions.usecase":"Ändern Sie den Thin Client-Anwendungsfall","bay.location":"Standorte","bay.installlationtype":"Art der Installation","bay.id":"Bucht-ID","destination.id":"Destination Identifikator","bay.index":"Index","bay.scannables":"Scannbare","bay.scannables_description":"Sendungsverfolgungs-/Sendungsnummer. Trennen Sie mehrere Werte durch ein Semikolon (;)","bay.sortzone":"Zone sortieren","bay.sortzone_description":"z. B. EU: A1-1A, NA: A-1.1A","configtype.title":"Wählen Sie den Konfigurationstyp","devicename.title":"Gerät wählen","sorterconfig.addupdate":"Sorter-Zielkonfiguration hinzufügen/aktualisieren","sorterconfig.uploadCSV":"Laden Sie die CSV-Datei mit der Sorter-Zielkonfiguration hoch","sortertestconfig.addupdatetest":"Konfiguration des Sorter-Testpakets hinzufügen/aktualisieren","sortertestconfig.uploadCSV":"Laden Sie die CSV-Konfiguration des Sorter-Testpakets hoch","sortertestconfig.delete":"Wählen Sie das Testpaket aus, das gelöscht werden soll.","sortertestconfig.nomatch":"Keine passenden Testpakete","device.delete_config_button_modal_autoloader":"AutoLoader-Konfiguration löschen","modal.destinationiddelete":"Bitte wählen Sie die Ziel-ID aus, die Sie entfernen möchten","autoloaderconfig.addupdate":"AutoLoader-Konfiguration hinzufügen/aktualisieren","autoloaderconfig.uploadCSV":"AutoLoader-Konfigurations-CSV hochladen","radio.loader":"AutoLoader-Ziel","sortertestconfig.notavailable":"Keine Testpakete verfügbar","config.delete":"Konfiguration löschen","config.deletetest":"Konfiguration des Sorter-Testpakets löschen","config.download":"Config herunterladen","upload.title":"Konfiguration über CSV hochladen","upload.subtitle":"Laden Sie eine CSV-Datei hoch, um die bestehende Konfiguration zu überschreiben.","upload.upload_file":"Datei hochladen","upload.drag_here":"oder ziehen Sie die Datei hierher","upload.download_sample":"Laden Sie die CSV-Beispieldatei herunter","upload.file_length":"Die hochgeladene Datei enthält Zeilen vom Typ {length}.","upload.confirm_overwrite":"Drücken Sie auf Bestätigen, um die Konfiguration zu überschreiben.","modal.bayid":"Bucht-ID","modal.cluster":"Cluster","modal.installationtype":"Art der Installation","modal.location":"Standorte","modal.tier":"Ebene","modal.optional":"[Optional] ","modal.location_example":"Trennen Sie mehrere Gänge durch ein Semikolon, z. B.: J,1; J,2; J,3","modal.adtr_location_example":"Trennen Sie Standorte durch Semikolon – z. B.: A.L01;A.L02","modal.enter_value":"Wert eingeben...","modal.fingerName":"Fingername","modal.fingerName_desc":"[Optionales Feld] Diese Buchten sollten mit ihrem Fingernamen verknüpft werden, um sie bei mehreren Fingern innerhalb desselben ADTA zu identifizieren.","modal.addheading":"Um eine bestehende Konfiguration zu bearbeiten, geben Sie ihre Bay-ID ein und geben Sie","modal.addheadingtest":"Um eine bestehende Konfiguration zu bearbeiten, geben Sie die Sortierzone ein.","modal.start":"Startzeit im UTC-Format: MM/DD/YYYY HH:MM:SS","modal.end":"Endzeit im UTC-Format: MM/DD/YYYY HH:MM:SS","modal.confirmUpdate":"Bestätigen Sie die Aktualisierung","modal.reason":"Grund","device.active":"Aktiv","device.inactive":"Inaktiv","device.delete":"Löschen","status.tooltip":"Gesund: Das Gerät funktioniert ordnungsgemäß. Getrennt: Das Gerät ist nicht ordnungsgemäß mit dem Internet und dem lokalen Netzwerk verbunden. Ladevorgang fehlgeschlagen: Der Verbindungsstatus des Geräts konnte nicht abgerufen werden. Möglicherweise stimmt etwas nicht.","radio.sorter":"Ziel sortieren","radio.test":"Sorter Testpaket","alert.missingfields":"Bitte geben Sie alle Felder im richtigen Format ein!","alert.time":"Bitte stellen Sie sicher, dass die Startzeit kleiner oder gleich der Endzeit ist!","alert.testing":"Kein Test-Setup vorhanden.","alert.device":"Für diese Station ist kein Gerät vorhanden.","alert.configuration":"Kein Konfigurations-Setup vorhanden.","alert.actionsdisabled":"Sie verwenden das Portal im schreibgeschützten Modus. Alle Aktionen auf der Seite sind deaktiviert.","config.addupdateasl":"Konfiguration für Guided Divert hinzufügen/aktualisieren","modal.addheadingasl":"Um eine bestehende Konfiguration zu bearbeiten, geben Sie denselben Umleitungscode erneut ein.","modal.divertcode":"Code umleiten","modal.divertcode_desc":"Bereich: 10 bis 99","slam.clusters":"Cluster","modal.clusters":"Cluster","modal.clusters_desc":"Trennen Sie mehrere Werte durch ein Semikolon - z. B.: A; B; C","radio.guideddivert":"Konfiguration von Guided Divert","tooltip.scrolltobottom":"Scrollen Sie nach unten","tooltip.connectionstatus":"Aktiv: Das Gerät funktioniert ordnungsgemäß. Inaktiv: Verbunden, kann aber keine Herzschlagnachrichten vom Gerät empfangen. Unbekannt/Gerät nicht gefunden: Es kann keine Verbindung zum Gerät hergestellt werden ","tooltip.disconnectedipvlan":"IP/VLAN-Informationen sind möglicherweise nicht korrekt, da das Gerät vom Netzwerk getrennt ist","tooltip.isAuthorized":"Nicht berechtigt","tooltip.selectmacaddress":"Bitte wählen Sie zuerst eine MAC-Adresse aus","loading.text":"Wird geladen...","device.monitoring_modal":"Überwachung deaktivieren","device.usecase_change_modal":"Ändern Sie den Thin Client-Anwendungsfall","table.nodata":"Keine Daten vorhanden","alert.testconfig":"Für diese MAC-Adresse sind keine Testpaketkonfigurationen vorhanden.","tooltip.statusLoading":"Status wird geladen","bintester.errorMessage":"Beim Abrufen der Site-Konfiguration für diese Station ist ein Fehler aufgetreten","alert.asset_details_success":"Asset-Details erfolgreich aktualisiert","alert.asset_details_fail":"Inhaltsdetails konnten nicht aktualisiert werden. Versuchen Sie es erneut!","alert.createdOn":"Erstellt am: ","alert.byUser":" Nach Benutzer: ","device.mcm":"MCM ","device.ticket":"Fahrkarte ","device.justification":"Andere Begründung ","device.linkPlaceHolder":"Geben Sie MCM/Ticket-Link/andere Begründung ein...","device.firmwareVersion":"Firmware-Version","log.stopMonitoring":"Beende die Überwachung von Protokollen","log.startMonitoring":"Starten die Überwachung von Protokollen","log.clear":"Klar","log.filterBySubstring":"Protokolle nach Teilzeichenfolge filtern...","log.filterByDeviceName":"Protokolle nach Gerätenamen filtern...","log.messagesToCapture":"Nachrichten zum Erfassen","log.error":"Etwas ist schief gelaufen, bitte versuche es später noch einmal...","log.messageCountError":"Die Anzahl der Nachrichten darf 300 nicht überschreiten","log.download":"Protokolle herunterladen","mhelog.datetime":"Datum/Uhrzeit (UTC)","mhelog.protocol":"Protokoll","mhelog.devicetype":"Gerätetyp","mhelog.devicename":"Gerätename","mhelog.macip":"MAC/IP","mhelog.mac":"MAC","mhelog.ip":"IP","mhelog.eventtype":"Ereignistyp","mhelog.message":"Nachricht","mhelog.payload":"Nutzlast","banner.peakPermission":"Der Zugriff auf die Admin-Funktionalität ist während der Spitzenzeiten eingeschränkt. Möglicherweise können Sie bestimmte Bearbeitungsfunktionen auf der Website nicht ausführen, wenn Sie nicht zu den Gruppen RME/IT/Admin gehören. Weitere Einzelheiten finden Sie unter ","banner.wiki":"das Geräteverwaltungs-Wiki","banner.bagTracking":"Dieses Dashboard bietet Echtzeit-Tracking für DSP-Taschen, die mit Smart Tags ausgestattet sind.","table.index":"Index","test.scannables":"Scannbare","test.tracking_id":"Tracking Id","test.alt_id":"Versand-ID","test.destination":"Zielort","test.scannables_description":"Sendungsverfolgungs-/Sendungsnummer. Trennen Sie mehrere Werte durch ein Semikolon (;)","test.tracking_id_description":"Geben Sie die Paketverfolgungs-ID ein","test.alt_id_description":"Enter the shipping ID of the package","test.destination_bag_description":"z.B. EU: EU_ZZ-AM-1024_BLK , NA: AK-T-0103-503-BLK","container.type":"Containertyp","container.label":"Behälteretikett","stowconfig.addupdate":"Stow-Paketkonfiguration hinzufügen/aktualisieren","stowconfig.uploadCSV":"Laden Sie die CSV-Datei der Stow-Paketkonfiguration hoch","stowconfig.delete":"Wählen Sie die zu löschende Fenster-ID aus","stowconfig.deleteconfig":"Konfiguration löschen","stowconfig.nomatch":"Keine passende ID gefunden","stowconfig.notavailable":"Keine Konfiguration verfügbar","stowtestconfig.addupdate":"Testpaketkonfiguration hinzufügen/aktualisieren","modal.headingtest":"Um eine vorhandene Konfiguration zu bearbeiten, geben Sie die Ziel-BagId ein.","stowtestconfig.delete":"Wählen Sie das zu löschende Testpaket aus.","stowtestconfig.deleteconfig":"Testpaketkonfiguration löschen","stowtestconfig.uploadCSV":"Laden Sie die CSV-Datei für die Konfiguration des Stow-Testpakets hoch","testconfig.nomatch":"Keine passenden Testpakete","testconfig.notavailable":"Keine Testpakete verfügbar","modal.delete_test_package":"Bitte wählen Sie das Scanobjekt aus, das Sie entfernen möchten.","modal.tesseract_headingtest":"Um eine vorhandene Konfiguration zu bearbeiten, geben Sie die Paketverfolgungs-ID ein","modal.tesseract_containerLabel_description":"Geben Sie das Etikett des Tesseract-Behälters ein, z. B. EU: A1, NA: A-1","tesseract_containerType_description":"Geben Sie den Typ des Maschinencontainers ein, z. SAMPL_01","modal.tesseract_headingconfig":"Um eine vorhandene Konfiguration zu bearbeiten, geben Sie den Containertyp ein","modal.tesseract_delete_stow_config":"Bitte wählen Sie den Containertyp aus, den Sie entfernen möchten","bagtracking.heading":"Taschenverfolgung","filter.heading":"Nach Abfahrtszeit filtern","bagTable.transporterId":"Transporter-ID","bagTable.bagId":"Taschen-ID","bagTable.bagStatus":"Taschenstatus","bagTable.departTime":"Abfahrtszeit","bagTable.receiveTime":"Zeit empfangen","lidarTester.select":"Wählen Sie Lidar-Controller aus","modal.selectAisleType":"Wählen Sie den Mertyp aus","modal.ledControllerType":"LED-Steuerungstyp","modal.defaultAisleType":"Standard-Merrtyp","modal.colorOrder":"Farbenreihenfolge","modal.selectLedControllerType":"Wählen Sie den LED-Steuerungstyp aus","modal.selectDefaultAisleType":"Wählen Sie den Standard-Merrtyp aus","modal.selectColorOrder":"Wählen Sie die Farbenreihenfolge aus","device.add_only_device_button_modal":"Einzelne Geräte-Konfiguration hinzufügen","device.device.add_aisles_button_modal":"Geräte-Auslese-Konfiguration hinzufügen","node.update_defaults_button_modal":"Standardeinstellungen aktualisieren","alert.aisleduplicatefields":"Bitte geben Sie einen eindeutigen Mernamen ein!","alert.portduplicatefields":"Bitte geben Sie eine eindeutige Portnummer ein!","config.addonerow":"Eine Zeile hinzufügen","config.addmultiplerows":"Mehrere Zeilen hinzufügen","config.updateledcontroller":"LED-Steuerung aktualisieren","modal.aislename":"Merrname","modal.aisletype":"Merrtyp","modal.actions":"Aktionen","alert.asset_delete_success":"Das Asset wurde erfolgreich gelöscht","alert.asset_defaults_success":"Die Standard-Einstellungen des Assets wurden erfolgreich aktualisiert","alert.asset_delete_fail":"Fehler beim Löschen des Assets. Versuchen Sie es erneut!","alert.asset_defaults_fail":"Fehler beim Aktualisieren der Asset-Standardeinstellungen. Versuchen Sie es erneut!","alert.asset_create_success":"Das Asset wurde erfolgreich erstellt","modal.selectLidarControllerType":"Lidar-Controller-Typ auswählen","device.controller_type":"Controllertyp","banner.dmwPermission":"Sie sind nicht berechtigt, auf dieses Gerät zuzugreifen. Klicken Sie auf den unten stehenden Link, um Zugriff zu erhalten.","locationconfig.addupdate":"ZancaSort-Standortkonfiguration hinzufügen/aktualisieren","locationconfig.uploadCSV":"Laden Sie die ZancaSort-Standortkonfiguration als CSV hoch","locationconfig.deleteconfig":"ZancaSort-Standortkonfiguration löschen","tierconfig.addupdate":"ZancaSort-Tier-Konfiguration hinzufügen/aktualisieren","tierconfig.uploadCSV":"ZancaSort-Tier-Konfiguration CSV hochladen","tierconfig.deleteconfig":"ZancaSort-Tier-Konfiguration löschen","tierconfig.tierName":"Tier-Name","tierconfig.capacity":"Kapazität","tierconfig.startLevel":"Startebene (inklusiv)","tierconfig.endLevel":"Endebene (inklusiv)","modal.addtierheading":"Um eine bestehende Konfiguration zu bearbeiten, wählen Sie den Tier-Namen aus.","modal.delete_tier_config":"Bitte wählen Sie den Tier-Namen aus, den Sie entfernen möchten","tierconfig.selectTier":"Tier-Name auswählen","location.id":"Standort","location.type":"Art des Standorts","locationconfig.delete":"Wählen Sie die Standort-ID","modal.delete_location_config":"Bitte wählen Sie die Standort-ID aus, die Sie entfernen möchten","modal.toggleStowStations.title":"Stow Stations umschalten","modal.toggleStowStations.topStation":"Haltestelle Stow","modal.toggleStowStations.bottomStation":"Bahnhof Bottom Stow","modal.toggleStowStations.updating":"Die Stow Station-Konfiguration wird aktualisiert...","locationmapping.destination":"Pick Chute","locationmapping.type":"Item Type","locationmapping.locations":"Pick Point(s)","locationmapping.add":"Add Config","locationmapping.uploadCSV":"Upload Location Config CSV","locationmapping.destination.placeholder":"e.g. PC1","locationmapping.type.placeholder":"Select item type","locationmapping.locations.placeholder":"Select pick points","locationmapping.error.column_count":"Expected 3 columns but found {count}.","locationmapping.error.pick_point_not_found":"Pick point \"{pickPoint}\" does not exist at this station.","locationmapping.error.row_prefix":"Row {row}: {message}","locationmapping.delete_config":"Delete Config","locationmapping.delete_title":"Delete Location Mapping","locationmapping.delete_confirmation":"Are you sure you want to delete the entire location mapping configuration? This action will be applied when you deploy the draft.","locationmapping.no_pick_points":"No pick points found for this station.","locationmapping.modal.add_title":"Add Location Mapping","locationmapping.modal.edit_title":"Edit Location Mapping","locationmapping.error.destination_required":"Destination is required.","locationmapping.error.destination_invalid":"Destination must start with a letter, contain only letters, digits, underscore, hyphen, or period, and be at most 50 characters.","locationmapping.error.type_required":"Item type is required.","locationmapping.error.locations_required":"At least one pick point must be selected.","locationmapping.error.duplicate":"A mapping for \"{destination}\" with type \"{type}\" already exists.","locationmapping.error.conflict":"Pick point \"{pickPoint}\" is already mapped to \"{destination}\" for type \"{type}\"."}

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

module.exports = {"external.logs":"لوحة القيادة للسجلات","external.dashboard":"لوحة القيادة الهندسية","asl.heading":"أجهزة ASL","thinclients.heading":"العملاء النحيفون","adta.heading":"أجهزة البيانات","zancasort.heading":"أجهزة زانكا سورت","tesseract.heading":"أجهزة تسراكت","autoretriever.heading":"المسترد التلقائي","common.data_last_updated":"آخر تحديث للبيانات","adta.connected":"متصل","sbl.heading":"أجهزة إس بي إل","device.name":"الاسم","device.location":"الموقع","device.mac_ip":"عنوان MAC/IP","device.device_type":"نوع الجهاز","device.component_type":"نوع المكون","device.connection":"حالة الاتصال","device.add_only_device_button_modal":"إضافة تكوين جهاز واحد","device.add_aisles_button_modal":"إضافة ممرات لوحدة تحكم LED","node.update_defaults_button_modal":"تحديث الإعدادات الافتراضية","device.action":"الإجراء","device.pick_stations":"محطات الانتقاء","device.add_device_button_modal":"إضافة/تحديث تكوين جهاز واحد","device.delete_device_button_modal":"حذف تكوين جهاز واحد","device.edit_device_mac_modal":"تحرير عنوان Mac لجهاز واحد","device.delete_config_button_modal":"حذف تكوين وجهة الفرز","device.delete_divert_config_button_modal":"حذف تكوين التحويل الموجه","device.edit_config":"إضافة التكوين أو تحريره","asl.desc":"تعرض هذه الصفحة الحالة في الوقت الفعلي لأجهزة ASL جنبًا إلى جنب مع الجهاز وتكوين التحويل الموجه لـ ASL","adta.desc":"تعرض هذه الصفحة الحالة في الوقت الفعلي لأجهزة ADTA جنبًا إلى جنب مع تكوين وجهة الفرز وحزمة اختبار الفرز","sbl.desc":"تعرض هذه الصفحة حالة وحدات تحكم LED في الوقت الفعلي بالإضافة إلى عنوان MAC/IP والاتصال","thinclient.desc":"تعرض هذه الصفحة الحالة في الوقت الفعلي لأجهزة Thin Client جنبًا إلى جنب مع عنوان MAC/IP والحالة الصحية","device.vlan":"شبكة محلية افتراضية","device.usecase":"حالة الاستخدام","device.status":"الحالة","device.swstatus":"حالة البرنامج","device.remark":"ملاحظة","device.monitoring":"حالة المراقبة","device.monitoringEnabled":"تم تمكينه","device.monitoringDisabled":"معاق","device.invalidEntry":"إدخال غير صالح","device.editWarning":"أنت على وشك إجراء تغيير سيؤثر مؤقتًا على أداء ASL/ADTA. يرجى التأكد من عدم تشغيل أي دورة على هذه الأجهزة قبل المتابعة","actions.deleteDevice":"حذف الجهاز","device.delete_config_button_modal_autoloader":"حذف إعدادات أداة التحميل التلقائي","modal.destinationiddelete":"الرجاء تحديد مُعرّف الوجهة الذي ترغب في إزالته","autoloaderconfig.addupdate":"إضافة/تحديث إعدادات أداة التحميل التلقائي","autoloaderconfig.uploadCSV":"تحميل إعدادات أداة التحميل التلقائي بصيغة CSV","radio.loader":"وجهة أداة التحميل التلقائي","actions.addDevice":"تحرير الجهاز","actions.edit":"تحرير عبر JSON","actions.changeMac":"تغيير عنوان Mac الخاص بالجهاز","actions.toggleStowStations":"تبديل محطات التخزين","actions.monitoring_disable":"تعطيل المراقبة","actions.monitoring_enable":"تمكين المراقبة","actions.deploydraft":"نشر المسودة","actions.discarddraft":"تجاهل المسودة","actions.rollback":"التراجع","actions.deploy":"انشر","actions.restart":"إعادة تشغيل التطبيق","button.add":"إضافة/تحرير عبر JSON","button.addcsv":"إضافة/تحرير عبر CSV","button.delete":"حذف الجهاز","button.save":"حفظ","button.edit":"تعديل","pickstation.label":"محطة الانتقاء","pickstation.no_resources":"لم يتم العثور على محطات انتقاء لهذه المحطة.","modal.adta_heading":"البيانات","modal.asl_heading":"ASL","modal.confirm":"قم بالتأكيد","modal.confirmAdd":"تأكيد الإضافة","modal.confirmEdit":"تأكيد التحرير","modal.cancel":"إلغاء","modal.copy":"نسخ","modal.paste":"لصق","modal.remove":"إزالة","modal.selectAisleType":"اختر نوع الممر","modal.ledControllerType":"نوع وحدة تحكم LED","modal.defaultAisleType":"نوع الممر الافتراضي","modal.colorOrder":"ترتيب اللون","modal.selectLedControllerType":"اختر نوع وحدة تحكم LED","modal.selectDefaultAisleType":"اختر نوع الممر الافتراضي","modal.selectColorOrder":"اختر ترتيب اللون","tab.testing":"الاختبار","tab.configuration":"التكوين","tab.aisleconfigfinder":"SBL Config Finder","tab.overview":"نظرة عامة","tab.logstream":"تجمع السجلات","deviceManagement.filters":"حدد نوع الجهاز","deviceManagement.tag":"نوع الجهاز","deviceManagement.noresults":"لا توجد نتائج","modal.mac":"عنوان ماك","modal.startAisle":"ابدأ الممر","modal.startPort":"منفذ البدء","modal.aisleCount":"عدد الممرات","modal.config":"املأ التكوين JSON","modal.configcsv":"قم بتحميل ملف CSV الخاص بالتكوين.","modal.macdelete":"يرجى إدخال عنوان MAC الخاص بالجهاز الذي تريد إزالته.","modal.selectmacdelete":"حدد عنوان MAC ليتم حذفه.","modal.confirmmacdelete":"يرجى تأكيد رغبتك في حذف الجهاز التالي:","modal.confirmmacedit":"يرجى إدخال عنوان mac الجديد للجهاز التالي:","modal.deleteAll":"حذف الكل","modal.bayiddelete":"يرجى تحديد معرف Bay الذي ترغب في إزالته:","modal.selectbayid":"حدد معرف الطفل","modal.divertcodedelete":"يرجى إدخال رمز التحويل الذي تريد إزالته","modal.select_divert_code":"حدد رمز التحويل ليتم حذفه.","modal.pick_stations":"محطات الانتقاء","modal.pick_stations_desc":"أدخل تسميات محطة الانتقاء المرتبطة مفصولة بـ (;)","modal.device_id":"معرف الجهاز","modal.device_id_line_desc":"معرف محلي فريد للجهاز. على سبيل المثال «3\" لـ «Line 3\"","modal.device_id_finger_desc":"معرف محلي فريد للجهاز. على سبيل المثال. «A» لـ «الإصبع A»","modal.device_id_cluster_desc":"المعرف المحلي الفريد للجهاز. على سبيل المثال. \"أ\" لـ \"المجموعة أ\"","modal.port":"ميناء","modal.protocol_msg":"إما «الفرز» أو «الفرز -2021-v1\"","modal.protocol":"بروتوكول","modal.induct_camera_mac":"أدخل كاميرا ماك","modal.printer_mac":"طابعة ماك","modal.verification_camera_mac":"كاميرا التحقق ماك","modal.select_protocol":"حدد بروتوكولًا","modal.select_induct_camera_mac":"حدد عنوان MAC للكاميرا","modal.select_printer_mac":"حدد عنوان MAC للطابعة","modal.select_verification_camera_mac":"حدد عنوان MAC لكاميرا التحقق","modal.responsePort":"منفذ الاستجابة","modal.userId":"معرف المستخدم","modal.inductLocation":"موقع إنكت","modal.name":"اسم الجهاز","modal.name_line_desc":"اسم العرض للجهاز. على سبيل المثال «Line 3\"","modal.no_device_available":"لا توجد أجهزة متاحة","modal.name_finger_desc":"اسم شاشة الجهاز. على سبيل المثال «Finger A»","modal.name_cluster_desc":"اسم العرض للجهاز. على سبيل المثال \"المجموعة أ\"","modal.parent_asset_mac":"عنوان MAC للأصل الأصلي","modal.parent_asset_mac_desc":"[اختياري] عنوان MAC لجهاز ADTF الأصلي الذي يحول الطرود إلى محطات التخزين لهذه المجموعة.","modal.name_matrix_desc":"اسم شاشة الجهاز. على سبيل المثال «Matrix A»","modal.device_type_asl":"نوع الجهاز (يجب أن يكون واحدًا مما يلي: slam، slam-2021-v1)","modal.ip":"عنوان بروتوكول الإنترنت","modal.sortzonedelete":"يرجى تحديد الماسح الضوئي الذي تريد إزالته.","modal.vendor":"المورّد","modal.select_vendor":"حدد البائع","modal.spec_version":"إصدار مواصفات الأجهزة","modal.select_version":"حدد إصدار مواصفات الأجهزة","modal.sorter_type":"تقنية الفرز","modal.select_sorter_type":"تقنية الفرز المختار","modal.hamper_vendor":"بائع السلة","modal.select_hamper_vendor":"حدد بائع سلة التسوق","modal.hamper_version":"إصدار هامبر","modal.select_hamper_version":"حدد إصدار هامبر","modal.incoming_auto_singulated":"يتم فصل الطرود تلقائيًا","modal.incoming_auto_sorted":"يتم فرز الطرود تلقائيًا إلى الإصبع","modal.select_incoming_auto_singulated":"اختر نعم أو لا","modal.select_incoming_auto_sorted":"اختر نعم أو لا","device.vendor":"المورد/الإصدار","device.sorter_type":"تقنية الفرز","device.hamper_vendor":"بائع/إصدار سلة","devicemanagement.heading":"إدارة الأجهزة","devicemanagement.desc":"تعرض هذه الصفحة الحالة في الوقت الفعلي لأجهزة Automation و Thin Clients وأجهزة SBL وتساعدك على تعيين تكوين نوع الجهاز المحدد.","actions.secondary":"قم بعمل حالة استخدام ثانوية","actions.primary":"قم بعمل حالة الاستخدام الأساسي","actions.usecase":"تغيير حالة استخدام العميل الرقيق","bay.location":"مواقع","bay.installlationtype":"نوع التثبيت","bay.id":"معرف الطفل","destination.id":"معرف الوجهة","bay.index":"الفهرس","bay.scannables":"الماسحات الضوئية","bay.scannables_description":"معرف التتبع/الشحن. افصل القيم المتعددة بفاصلة منقوطة (؛)","bay.sortzone":"منطقة الفرز","bay.sortzone_description":"على سبيل المثال. الاتحاد الأوروبي: A1-1A، NA: A-1.1A","configtype.title":"حدد نوع التكوين","devicename.title":"حدد الجهاز","sorterconfig.addupdate":"إضافة/تحديث تكوين وجهة الفرز","sorterconfig.uploadCSV":"تحميل ملف تكوين وجهة الفرز CSV","sortertestconfig.addupdatetest":"إضافة/تحديث تكوين حزمة اختبار الفرز","sortertestconfig.uploadCSV":"تحميل ملف تكوين حزمة اختبار الفرز CSV","sortertestconfig.delete":"حدد حزمة الاختبار لحذفها.","sortertestconfig.nomatch":"لا توجد حزم اختبار مطابقة","sortertestconfig.notavailable":"لا توجد حزم اختبار متاحة","config.delete":"حذف التكوين","config.deletetest":"حذف تكوين حزمة اختبار الفرز","config.download":"تنزيل التكوين","upload.title":"تكوين التحميل من خلال CSV","upload.subtitle":"قم بتحميل ملف CSV للكتابة فوق التكوين الحالي.","upload.upload_file":"رفع ملف","upload.drag_here":"أو اسحب الملف هنا","upload.download_sample":"قم بتنزيل نموذج ملف CSV","upload.file_length":"يحتوي الملف الذي تم تحميله على صفوف {length}.","upload.confirm_overwrite":"اضغط على التأكيد للكتابة فوق التكوين.","modal.bayid":"معرف الطفل","modal.cluster":"مجموعة","modal.installationtype":"نوع التثبيت","modal.location":"مواقع","modal.tier":"المستوى","modal.optional":" [اختياري]","modal.location_example":"افصل الممرات المتعددة بفاصلة منقوطة - على سبيل المثال: J,1; J,2; J,3","modal.adtr_location_example":"مواقع منفصلة بفاصلة منقوطة - على سبيل المثال: A.L01؛ A.L02","modal.enter_value":"أدخل القيمة...","modal.fingerName":"اسم الإصبع","modal.fingerName_desc":"[حقل اختياري] يجب أن ترتبط هذه الخلجان باسم إصبعهم للتعرف عليها في حالة وجود أصابع متعددة داخل نفس ADTA.","modal.addheading":"لتحرير تكوين موجود، أدخل معرف Bay الخاص به واكتب","modal.addheadingtest":"لتحرير تكوين موجود، أدخل منطقة الفرز.","modal.start":"وقت البدء بصيغة التوقيت العالمي المنسق: MM/DD/YYYY HH: MM:SS","modal.end":"وقت الانتهاء بصيغة التوقيت العالمي المنسق: MM/DD/YYYY HH: MM:SS","modal.selectusecase":"حدد واقعة الاستخدام","modal.selectnewusecase":"الرجاء تحديد حالة استخدام جديدة لـ Thin Client.","modal.confirmchangeusecase":"يرجى تأكيد حالة استخدام Thin Client الجديدة التي حددتها.","modal.confirmUpdate":"تأكيد التحديث","modal.reason":"السبب","device.active":"نشيط","device.inactive":"غير نشطة","device.delete":"حذف","status.tooltip":"صحي: الجهاز يعمل بشكل صحيح. غير متصل: الجهاز غير متصل بشكل صحيح بكل من الإنترنت والشبكة المحلية. فشل التحميل: فشل جلب حالة اتصال الجهاز، قد يكون هناك خطأ ما.","radio.sorter":"وجهة الفرز","radio.test":"حزمة اختبار الفرز","alert.missingfields":"يرجى إدخال جميع الحقول بالتنسيق الصحيح!","alert.time":"يرجى التأكد من أن وقت البدء أقل من أو يساوي وقت الانتهاء!","alert.testing":"لا يوجد إعداد اختبار.","alert.device":"لا يوجد جهاز لهذه المحطة.","alert.configuration":"لا يوجد إعداد تكوين.","alert.aisleduplicatefields":"يرجى إدخال اسم ممر فريد!","alert.portduplicatefields":"يرجى إدخال رقم منفذ فريد!","alert.actionsdisabled":"أنت تستخدم البوابة الإلكترونية في وضع القراءة فقط. تم تعطيل جميع الإجراءات على الصفحة.","config.addupdateasl":"إضافة/تحديث تكوين التحويل الموجه","config.addonerow":"أضف صفًا واحدًا","config.addmultiplerows":"أضف عدة صفوف","config.updateledcontroller":"تحديث وحدة تحكم LED","modal.addheadingasl":"لتحرير تكوين موجود، أدخل نفس رمز التحويل مرة أخرى.","modal.divertcode":"كود التحويل","modal.divertcode_desc":"النطاق: من 10 إلى 99","modal.aislename":"اسم الممر","modal.aisletype":"نوع الممر","modal.actions":"الإجراءات","slam.clusters":"مجموعات","modal.clusters":"مجموعات","modal.clusters_desc":"افصل القيم المتعددة بفاصلة منقوطة - على سبيل المثال: A؛ B؛ C","radio.guideddivert":"تكوين التحويل الموجه","tooltip.scrolltobottom":"انتقل إلى الأسفل","tooltip.connectionstatus":"نشط: الجهاز يعمل بشكل صحيح. غير نشط: متصل ولكن غير قادر على تلقي رسائل نبضات القلب من الجهاز. غير معروف/لم يتم العثور على الجهاز: غير قادر على الاتصال بالجهاز ","tooltip.disconnectedipvlan":"قد لا تكون معلومات IP/VLAN دقيقة نظرًا لفصل الجهاز عن الشبكة","tooltip.isAuthorized":"غير مخول","tooltip.selectmacaddress":"الرجاء تحديد عنوان MAC أولاً","loading.text":"جاري التحميل...","device.monitoring_modal":"تعطيل المراقبة","device.usecase_change_modal":"تغيير حالة استخدام العميل الرقيق","table.nodata":"لا توجد بيانات","alert.testconfig":"لا توجد تكوينات لحزمة الاختبار لعنوان MAC هذا.","alert.asset_delete_success":"تم حذف الأصول بنجاح","alert.asset_defaults_success":"تم تحديث إعدادات الأصول الافتراضية بنجاح","alert.asset_delete_fail":"فشل في حذف الأصول. حاول مرة أخرى!","alert.asset_create_success":"تم إنشاء الأصل بنجاح","alert.asset_defaults_fail":"فشل في تحديث إعدادات الأصول الافتراضية. حاول مرة أخرى!","tooltip.statusLoading":"حالة التحميل","bintester.errorMessage":"حدث خطأ أثناء جلب تكوين الموقع لهذه المحطة","alert.asset_details_success":"تم تحديث تفاصيل الأصول بنجاح","alert.asset_details_fail":"فشل تحديث تفاصيل الأصول. حاول ثانية!","alert.createdOn":"تم إنشاؤه في: ","alert.byUser":"بواسطة المستخدم: ","device.mcm":"MCM ","device.ticket":"تذكرة ","device.justification":"مبررات أخرى","device.linkPlaceHolder":"أدخل MCM / رابط التذكرة / سبب آخر ...","device.firmwareVersion":"إصدار البرنامج الثابت","log.stopMonitoring":"إيقاف سجلات المراقبة","log.startMonitoring":"ابدأ بمراقبة السجلات","log.clear":"حذف","log.filterBySubstring":"تصفية السجلات حسب السلسلة الفرعية...","log.filterByDeviceName":"تصفية السجلات حسب اسم الجهاز...","log.messagesToCapture":"كتابة الرسائل","log.error":"هناك شئ خاطئ، يرجى المحاولة فى وقت لاحق...","log.messageCountError":"لا يمكن أن يتجاوز عدد الرسائل 300","log.download":"تحميل السجلات","mhelog.datetime":"التاريخ/الوقت (التوقيت العالمي المنسق)","mhelog.protocol":"بروتوكول","mhelog.devicetype":"نوع الجهاز","mhelog.devicename":"اسم الجهاز","mhelog.macip":"ماك/IP","mhelog.mac":"ماك","mhelog.ip":"IP","mhelog.eventtype":"نوع الحدث","mhelog.message":"رسالة","mhelog.payload":"الحمولة","banner.peakPermission":"يقتصر الوصول إلى وظائف الإدارة خلال فترة الذروة. قد لا تتمكن من أداء بعض وظائف التحرير على موقع الويب إذا لم تكن من مجموعات RME/IT/Admin. لمزيد من التفاصيل، اقرأ ","banner.wiki":"ويكي إدارة الجهاز ","banner.bagTracking":"توفر لوحة القيادة هذه تتبعًا في الوقت الفعلي لأكياس DSP المجهزة بعلامات ذكية.","table.index":"فِهرِس","test.scannables":"الماسحات الضوئية","test.tracking_id":"معرف التتبع","test.alt_id":"معرف الشحن","test.destination":"موقع وجهة","test.scannables_description":"معرف التتبع/الشحن. افصل القيم المتعددة بفاصلة منقوطة (؛)","test.tracking_id_description":"أدخل معرف تتبع الحزمة","test.alt_id_description":"أدخل معرف شحن الحزمة","test.destination_bag_description":"على سبيل المثال. EU: EU_ZZ-AM-1024_BLK , NA: AK-T-0103-503-BLK","container.type":"نوع الحاوية","container.label":"تسمية الحاوية","stowconfig.addupdate":"إضافة/تحديث تكوين حزمة المخزن","stowconfig.uploadCSV":"تحميل ملف تكوين حزمة التخزين بتنسيق CSV","stowconfig.delete":"حدد نوع الحاوية المراد حذفها","stowconfig.deleteconfig":"حذف التكوين","stowconfig.nomatch":"لم يتم العثور على معرف مطابق","stowconfig.notavailable":"لا يوجد تكوين متاح","stowtestconfig.addupdate":"إضافة/تحديث تكوين حزمة الاختبار","modal.headingtest":"لتحرير تكوين موجود، أدخل Destination BagId.","stowtestconfig.delete":"حدد حزمة الاختبار المراد حذفها.","stowtestconfig.deleteconfig":"حذف تكوين حزمة الاختبار","stowtestconfig.uploadCSV":"قم بتحميل ملف CSV لتكوين حزمة الاختبار","testconfig.nomatch":"لا توجد حزم اختبار مطابقة","testconfig.notavailable":"لا توجد حزم اختبار متاحة","modal.delete_test_package":"الرجاء تحديد الإدخال الذي ترغب في إزالته.","modal.tesseract_headingtest":"لتحرير تكوين موجود، أدخل معرف تتبع الحزمة","modal.tesseract_containerLabel_description":"أدخل تسمية حاوية tesseract على سبيل المثال. الاتحاد الأوروبي: A1، NA: A-1","modal.tesseract_containerType_description":"أدخل نوع الحاوية من الجهاز، على سبيل المثال. SAMPL_01","modal.tesseract_headingconfig":"لتحرير تكوين موجود، أدخل نوع الحاوية","modal.tesseract_delete_stow_config":"الرجاء تحديد نوع الحاوية التي ترغب في إزالتها","bagtracking.heading":"تتبع الحقيبة","filter.heading":"تصفية حسب وقت المغادرة","bagTable.transporterId":"معرف الناقل","bagTable.bagId":"معرف الحقيبة","bagTable.bagStatus":"حالة الحقيبة","bagTable.departTime":"تغادر مرة","bagTable.receiveTime":"تلقي الوقت","modal.selectLidarControllerType":"اختر نوع وحدة تحكم ليدار","device.controller_type":"نوع وحدة التحكم","banner.dmwPermission":"ليس لديك تصريح بالوصول إلى هذا الجهاز. يُرجى مراجعة الرابط أدناه للوصول.","locationconfig.addupdate":"إضافة/تحديث تكوين موقع ZancaSort","locationconfig.uploadCSV":"تحميل ملف CSV لتكوين موقع ZancaSort","locationconfig.deleteconfig":"حذف تكوين موقع ZancaSort","tierconfig.addupdate":"إضافة/تحديث تكوين طبقة ZancaSort","tierconfig.uploadCSV":"تحميل ملف CSV لتكوين طبقة ZancaSort","tierconfig.deleteconfig":"حذف تكوين طبقة ZancaSort","tierconfig.tierName":"اسم الطبقة","tierconfig.capacity":"السعة","tierconfig.startLevel":"مستوى البداية (شامل)","tierconfig.endLevel":"مستوى النهاية (شامل)","modal.addtierheading":"لتعديل تكوين موجود، حدد اسم الطبقة.","modal.delete_tier_config":"يرجى تحديد اسم الطبقة التي تريد إزالتها","tierconfig.selectTier":"حدد اسم الطبقة","location.id":"الموقع","location.type":"نوع الموقع","locationconfig.delete":"حدد معرف الموقع","modal.delete_location_config":"يرجى تحديد معرف الموقع الذي تريد إزالته","modal.toggleStowStations.title":"تبديل محطات التخزين","modal.toggleStowStations.topStation":"محطة توب ستو","modal.toggleStowStations.bottomStation":"محطة بوتوم ستو","modal.toggleStowStations.updating":"جاري تحديث تكوين محطة التخزين...","locationmapping.destination":"Pick Chute","locationmapping.type":"Item Type","locationmapping.locations":"Pick Point(s)","locationmapping.add":"Add Config","locationmapping.uploadCSV":"Upload Location Config CSV","locationmapping.destination.placeholder":"e.g. PC1","locationmapping.type.placeholder":"Select item type","locationmapping.locations.placeholder":"Select pick points","locationmapping.error.column_count":"Expected 3 columns but found {count}.","locationmapping.error.pick_point_not_found":"Pick point \"{pickPoint}\" does not exist at this station.","locationmapping.error.row_prefix":"Row {row}: {message}","locationmapping.delete_config":"Delete Config","locationmapping.delete_title":"Delete Location Mapping","locationmapping.delete_confirmation":"Are you sure you want to delete the entire location mapping configuration? This action will be applied when you deploy the draft.","locationmapping.no_pick_points":"No pick points found for this station.","locationmapping.modal.add_title":"Add Location Mapping","locationmapping.modal.edit_title":"Edit Location Mapping","locationmapping.error.destination_required":"Destination is required.","locationmapping.error.destination_invalid":"Destination must start with a letter, contain only letters, digits, underscore, hyphen, or period, and be at most 50 characters.","locationmapping.error.type_required":"Item type is required.","locationmapping.error.locations_required":"At least one pick point must be selected.","locationmapping.error.duplicate":"A mapping for \"{destination}\" with type \"{type}\" already exists.","locationmapping.error.conflict":"Pick point \"{pickPoint}\" is already mapped to \"{destination}\" for type \"{type}\"."}

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var t=String(e).split("."),o=!t[1],n=Number(t[0])==e,r=n&&t[0].slice(-1),i=n&&t[0].slice(-2);return a?1==r&&11!=i?"one":2==r&&12!=i?"two":3==r&&13!=i?"few":"other":1==e&&o?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yr."},past:{one:"{0} yr. ago",other:"{0} yr. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hr."},past:{one:"{0} hr. ago",other:"{0} hr. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} min."},past:{one:"{0} min. ago",other:"{0} min. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} sec."},past:{one:"{0} sec. ago",other:"{0} sec. ago"}}}}},{locale:"en-001",parentLocale:"en",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo",other:"in {0} mo"},past:{one:"{0} mo ago",other:"{0} mo ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yrs"},past:{one:"{0} yr ago",other:"{0} yrs ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"h",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hrs"},past:{one:"{0} hr ago",other:"{0} hrs ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins"},past:{one:"{0} min. ago",other:"{0} mins ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs"},past:{one:"{0} sec. ago",other:"{0} secs ago"}}}}},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yrs."},past:{one:"{0} yr. ago",other:"{0} yrs. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mos."},past:{one:"{0} mo. ago",other:"{0} mos. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hrs."},past:{one:"{0} hr. ago",other:"{0} hrs. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins."},past:{one:"{0} min. ago",other:"{0} mins. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs."},past:{one:"{0} sec. ago",other:"{0} secs. ago"}}}}},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr",1:"next yr","-1":"last yr"},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mth",relative:{0:"this mth",1:"next mth","-1":"last mth"},relativeTime:{future:{one:"in {0} mth",other:"in {0} mth"},past:{one:"{0} mth ago",other:"{0} mth ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ja=t())}(this,function(){"use strict";return[{locale:"ja",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"翌年","-1":"昨年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"翌年","-1":"昨年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"今月",1:"翌月","-1":"先月"},relativeTime:{future:{other:"{0} か月後"},past:{other:"{0} か月前"}}},"month-short":{displayName:"月",relative:{0:"今月",1:"翌月","-1":"先月"},relativeTime:{future:{other:"{0} か月後"},past:{other:"{0} か月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"明後日","-2":"一昨日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},"day-short":{displayName:"日",relative:{0:"今日",1:"明日",2:"明後日","-2":"一昨日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"時",relative:{0:"1 時間以内"},relativeTime:{future:{other:"{0} 時間後"},past:{other:"{0} 時間前"}}},"hour-short":{displayName:"時",relative:{0:"1 時間以内"},relativeTime:{future:{other:"{0} 時間後"},past:{other:"{0} 時間前"}}},minute:{displayName:"分",relative:{0:"1 分以内"},relativeTime:{future:{other:"{0} 分後"},past:{other:"{0} 分前"}}},"minute-short":{displayName:"分",relative:{0:"1 分以内"},relativeTime:{future:{other:"{0} 分後"},past:{other:"{0} 分前"}}},second:{displayName:"秒",relative:{0:"今"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"今"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}}]});


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.it=a())}(this,function(){"use strict";return[{locale:"it",pluralRuleFunction:function(e,a){var t=!String(e).split(".")[1];return a?11==e||8==e||80==e||800==e?"many":"other":1==e&&t?"one":"other"},fields:{year:{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},"year-short":{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},month:{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},"month-short":{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},day:{displayName:"giorno",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} giorno",other:"tra {0} giorni"},past:{one:"{0} giorno fa",other:"{0} giorni fa"}}},"day-short":{displayName:"g",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} g",other:"tra {0} gg"},past:{one:"{0} g fa",other:"{0} gg fa"}}},hour:{displayName:"ora",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} ora",other:"tra {0} ore"},past:{one:"{0} ora fa",other:"{0} ore fa"}}},"hour-short":{displayName:"h.",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} h",other:"tra {0} h"},past:{one:"{0} h fa",other:"{0} h fa"}}},minute:{displayName:"minuto",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} minuto",other:"tra {0} minuti"},past:{one:"{0} minuto fa",other:"{0} minuti fa"}}},"minute-short":{displayName:"min",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} min",other:"tra {0} min"},past:{one:"{0} min fa",other:"{0} min fa"}}},second:{displayName:"secondo",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} secondo",other:"tra {0} secondi"},past:{one:"{0} secondo fa",other:"{0} secondi fa"}}},"second-short":{displayName:"s",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} s",other:"tra {0} sec."},past:{one:"{0} s fa",other:"{0} sec. fa"}}}}},{locale:"it-CH",parentLocale:"it"},{locale:"it-SM",parentLocale:"it"},{locale:"it-VA",parentLocale:"it"}]});


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";return[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&e<2?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},"year-short":{displayName:"a",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"jr.",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"hr",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min.",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}]});


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} días",other:"dentro de {0} días"},past:{one:"hace {0} días",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419"},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419"},{locale:"es-HN",parentLocale:"es-419"},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"en {0} a",other:"en {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} m",other:"en {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"en {0} día",other:"en {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"en {0} h",other:"en {0} n"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"en {0} min",other:"en {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"en {0} s",other:"en {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-NI",parentLocale:"es-419"},{locale:"es-PA",parentLocale:"es-419"},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-US",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.de=t())}(this,function(){"use strict";return[{locale:"de",pluralRuleFunction:function(e,t){var n=!String(e).split(".")[1];return t?"other":1==e&&n?"one":"other"},fields:{year:{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},"year-short":{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},month:{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},"month-short":{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},day:{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},"day-short":{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},hour:{displayName:"Stunde",relative:{0:"in dieser Stunde"},relativeTime:{future:{one:"in {0} Stunde",other:"in {0} Stunden"},past:{one:"vor {0} Stunde",other:"vor {0} Stunden"}}},"hour-short":{displayName:"Std.",relative:{0:"in dieser Stunde"},relativeTime:{future:{one:"in {0} Std.",other:"in {0} Std."},past:{one:"vor {0} Std.",other:"vor {0} Std."}}},minute:{displayName:"Minute",relative:{0:"in dieser Minute"},relativeTime:{future:{one:"in {0} Minute",other:"in {0} Minuten"},past:{one:"vor {0} Minute",other:"vor {0} Minuten"}}},"minute-short":{displayName:"Min.",relative:{0:"in dieser Minute"},relativeTime:{future:{one:"in {0} Min.",other:"in {0} Min."},past:{one:"vor {0} Min.",other:"vor {0} Min."}}},second:{displayName:"Sekunde",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sekunde",other:"in {0} Sekunden"},past:{one:"vor {0} Sekunde",other:"vor {0} Sekunden"}}},"second-short":{displayName:"Sek.",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sek.",other:"in {0} Sek."},past:{one:"vor {0} Sek.",other:"vor {0} Sek."}}}}},{locale:"de-AT",parentLocale:"de"},{locale:"de-BE",parentLocale:"de"},{locale:"de-CH",parentLocale:"de"},{locale:"de-IT",parentLocale:"de"},{locale:"de-LI",parentLocale:"de"},{locale:"de-LU",parentLocale:"de"}]});


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ar=a())}(this,function(){"use strict";return[{locale:"ar",pluralRuleFunction:function(e,a){var o=String(e).split("."),r=Number(o[0])==e&&o[0].slice(-2);return a?"other":0==e?"zero":1==e?"one":2==e?"two":r>=3&&r<=10?"few":r>=11&&r<=99?"many":"other"},fields:{year:{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},"year-short":{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},"month-short":{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"خلال {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},"day-short":{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},"hour-short":{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},"minute-short":{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}},"second-short":{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانٍ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-AE",parentLocale:"ar",fields:{year:{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},"year-short":{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},"month-short":{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"خلال {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},"day-short":{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},"hour-short":{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},"minute-short":{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}},"second-short":{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانٍ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-BH",parentLocale:"ar"},{locale:"ar-DJ",parentLocale:"ar"},{locale:"ar-DZ",parentLocale:"ar"},{locale:"ar-EG",parentLocale:"ar"},{locale:"ar-EH",parentLocale:"ar"},{locale:"ar-ER",parentLocale:"ar"},{locale:"ar-IL",parentLocale:"ar"},{locale:"ar-IQ",parentLocale:"ar"},{locale:"ar-JO",parentLocale:"ar"},{locale:"ar-KM",parentLocale:"ar"},{locale:"ar-KW",parentLocale:"ar"},{locale:"ar-LB",parentLocale:"ar"},{locale:"ar-LY",parentLocale:"ar"},{locale:"ar-MA",parentLocale:"ar"},{locale:"ar-MR",parentLocale:"ar"},{locale:"ar-OM",parentLocale:"ar"},{locale:"ar-PS",parentLocale:"ar"},{locale:"ar-QA",parentLocale:"ar"},{locale:"ar-SA",parentLocale:"ar"},{locale:"ar-SD",parentLocale:"ar"},{locale:"ar-SO",parentLocale:"ar"},{locale:"ar-SS",parentLocale:"ar"},{locale:"ar-SY",parentLocale:"ar"},{locale:"ar-TD",parentLocale:"ar"},{locale:"ar-TN",parentLocale:"ar"},{locale:"ar-YE",parentLocale:"ar"}]});


/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorPage__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_context_GlobalStateContext__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ErrorBoundary=function ErrorBoundary(_ref){var children=_ref.children;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),asyncError=_useContext.asyncError,resetID=_useContext.resetID;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ErrorBoundaryClass,{key:resetID,asyncError:asyncError},children);};var ErrorBoundaryClass=function(_Component){_inherits(ErrorBoundaryClass,_Component);function ErrorBoundaryClass(props){_classCallCheck(this,ErrorBoundaryClass);var _this=_possibleConstructorReturn(this,(ErrorBoundaryClass.__proto__||Object.getPrototypeOf(ErrorBoundaryClass)).call(this,props));_this.state={hasError:false,error:''};return _this;}_createClass(ErrorBoundaryClass,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.asyncError!==this.props.asyncError&&this.props.asyncError!==''){this.setState({hasError:true,error:this.props.asyncError});}}},{key:'render',value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ErrorPage__["a" /* default */],{errorTitle:'Something went wrong',errorMessage:this.props.asyncError});}return this.props.children;}}],[{key:'getDerivedStateFromError',value:function getDerivedStateFromError(error){return{hasError:true,error:error};}}]);return ErrorBoundaryClass;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__meridian_components_alert__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__meridian_components_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__meridian_components_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__meridian_components_column__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__meridian_components_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__meridian_components_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_context_GlobalStateContext__ = __webpack_require__(33);
var ErrorPage=function ErrorPage(_ref){var errorTitle=_ref.errorTitle,errorMessage=_ref.errorMessage;var _useContext=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__global_context_GlobalStateContext__["a" /* GlobalStateContext */]),restartApp=_useContext.restartApp;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__meridian_components_column___default.a,{spacingInset:'400'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__meridian_components_alert___default.a,{type:'error',size:'large',width:'100%',title:errorTitle,onClose:restartApp},errorMessage.toString()));};/* harmony default export */ __webpack_exports__["a"] = (ErrorPage);

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _alert = _interopRequireDefault(__webpack_require__(1590));

var _default = _alert["default"];
exports["default"] = _default;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(167);

var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(522));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(97));

var _emotion = __webpack_require__(11);

var _uniqueId = _interopRequireDefault(__webpack_require__(1594));

var _alert = _interopRequireDefault(__webpack_require__(1595));

var _alertErrorXlarge = _interopRequireDefault(__webpack_require__(1596));

var _alertErrorLarge = _interopRequireDefault(__webpack_require__(1597));

var _alertErrorSmall = _interopRequireDefault(__webpack_require__(1598));

var _alertInformationalLarge = _interopRequireDefault(__webpack_require__(1599));

var _alertInformationalSmall = _interopRequireDefault(__webpack_require__(1600));

var _alertSuccessXlarge = _interopRequireDefault(__webpack_require__(1601));

var _alertSuccessLarge = _interopRequireDefault(__webpack_require__(1602));

var _alertSuccessSmall = _interopRequireDefault(__webpack_require__(1603));

var _alertWarningXlarge = _interopRequireDefault(__webpack_require__(1604));

var _alertWarningLarge = _interopRequireDefault(__webpack_require__(1605));

var _alertWarningSmall = _interopRequireDefault(__webpack_require__(1606));

var _close = _interopRequireDefault(__webpack_require__(1607));

var _theme = __webpack_require__(273);

var _button = _interopRequireDefault(__webpack_require__(1608));

var _token = __webpack_require__(113);

var _focus = __webpack_require__(1628);

var _getIconCss = _interopRequireDefault(__webpack_require__(1637));

var _text = _interopRequireDefault(__webpack_require__(527));

var iconTokens = {
  small: {
    error: _alertErrorSmall["default"],
    informational: _alertInformationalSmall["default"],
    success: _alertSuccessSmall["default"],
    warning: _alertWarningSmall["default"]
  },
  medium: {
    error: _alertErrorSmall["default"],
    informational: _alertInformationalSmall["default"],
    success: _alertSuccessSmall["default"],
    warning: _alertWarningSmall["default"]
  },
  large: {
    error: _alertErrorLarge["default"],
    informational: _alertInformationalLarge["default"],
    success: _alertSuccessLarge["default"],
    warning: _alertWarningLarge["default"]
  },
  xlarge: {
    error: _alertErrorXlarge["default"],
    informational: _alertInformationalLarge["default"],
    success: _alertSuccessXlarge["default"],
    warning: _alertWarningXlarge["default"]
  }
};
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var size = _ref.size,
      type = _ref.type,
      toast = _ref.toast,
      width = _ref.width;
  var borderWidth = t("borderWidth", size);
  var icon = (0, _token.getIconFromTokens)(iconTokens[size][type]);
  return (0, _emotion.css)({
    /**
     * Container styles
     */
    boxSizing: "border-box",
    display: "flex",
    flexDirection: size === "xlarge" ? "column" : "row",
    alignItems: size === "xlarge" ? "center" : "flex-start",
    backgroundColor: t("backgroundColor", [size, type]),
    borderWidth: borderWidth,
    borderColor: t("borderColor", type),
    borderStyle: borderWidth ? "solid" : undefined,
    borderRadius: t("borderRadius"),
    padding: t("spacingInset", size),
    width: width,
    boxShadow: toast && (size === "medium" || size === "large") ? t.boxShadowCss("shadow") : undefined,
    "& > * + *": {
      marginLeft: t("spacingHorizontal", size)
    },

    /**
     * Icon styles
     */
    "& > [role=img]": {
      flexShrink: 0,
      alignSelf: size === "xlarge" ? "center" : "stretch",
      backgroundImage: (0, _getIconCss["default"])(icon.data, t("foregroundColor", [size, type])),
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      width: icon.width,
      // This ensures that the icon is vertically centered on the first line of
      // text for single-line alerts and on the first two lines of text for
      // multi-line alerts.
      minHeight: icon.height,
      maxHeight: icon.height * 2
    },

    /**
     * Title/message wrapper styles
     */
    "& > div": (0, _emotion.css)((0, _text["default"])(t, {
      fontSize: ["message", size],
      fontWeight: "body",
      lineHeight: ["message", size]
    }), {
      textAlign: size === "xlarge" ? "center" : "initial",
      color: t("foregroundColor", [size, type]),
      flex: "auto"
    }),

    /**
     * Title styles
     */
    "& > div > [role=heading]": (0, _emotion.css)((0, _text["default"])(t, {
      fontSize: ["title", size],
      fontWeight: "title",
      lineHeight: ["title", size]
    }), {
      color: t("foregroundColor", [size, type]),
      display: size === "xlarge" ? "block" : "initial",
      flexShrink: 0,
      fontWeight: t("fontWeightTitle"),
      marginRight: t("titleSpacingRight", size),
      marginTop: t("spacingVertical", size)
    }),

    /**
     * Message styles
     */
    "& > div > [mrdn-text]": {
      display: "inline-block",
      margin: "".concat(t("spacingVertical", size), "px 0 0 0")
    }
  });
}, ["size", "type", "toast", "width"]);

var closeButtonStyles = function closeButtonStyles(t, _ref2) {
  var size = _ref2.size;
  return (0, _emotion.css)(size === "xlarge" ? {
    position: "absolute",
    top: t("closeButtonSpacing", size),
    right: t("closeButtonSpacing", size)
  } : {
    flexShrink: 0,
    margin: t("closeButtonSpacing", size) - t("spacingInset", size),
    marginLeft: t("spacingHorizontal", size)
  });
};
/**
 * Render a banner that communicates status, feedback, and severity to the
 * customer.
 */


function Alert(props) {
  var t = (0, _theme.useTheme)(_alert["default"], "alert");
  var idPrefix = (0, _react.useMemo)(function () {
    return (0, _uniqueId["default"])("alert-");
  }, []);
  var node = (0, _react.useRef)();
  var big = props.size === "large" || props.size === "xlarge";
  var title = big ? props.title : undefined;
  var titleId = title ? "".concat(idPrefix, "-title") : undefined;
  var childrenId = "".concat(idPrefix, "-children");
  var showCloseButton = props.onClose && props.size !== "small"; // If autoFocus is true then focus on the first interactive element in the
  // alert. This'll either be the first action rendered by the user or the
  // alert's close button if there are no actions.

  var autoFocus = props.autoFocus;
  (0, _react.useEffect)(function () {
    if (autoFocus) {
      var _getKeyboardFocusNode = (0, _focus.getKeyboardFocusNodes)(node.current),
          _getKeyboardFocusNode2 = (0, _slicedToArray2["default"])(_getKeyboardFocusNode, 1),
          firstFocusNode = _getKeyboardFocusNode2[0];

      if (firstFocusNode) {
        firstFocusNode.focus();
      }
    }
  }, [autoFocus]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, props),
    ref: autoFocus ? node : undefined,
    role: showCloseButton ? "alertdialog" : "alert",
    "aria-labelledby": titleId,
    "aria-describedby": childrenId
  }, /*#__PURE__*/_react["default"].createElement("span", {
    role: "img",
    "aria-hidden": "true"
  }), /*#__PURE__*/_react["default"].createElement("div", null, title ? /*#__PURE__*/_react["default"].createElement("span", {
    role: "heading",
    id: titleId
  }, title) : null, /*#__PURE__*/_react["default"].createElement("span", {
    "mrdn-text": "",
    id: childrenId
  }, props.children)), showCloseButton ? /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "icon",
    size: big ? "medium" : "small",
    iconTokens: _close["default"],
    onClick: props.onClose,
    backdropColor: t("backgroundColor", [props.size, props.type]),
    className: closeButtonStyles(t, props)
  }, props.closeLabel) : null);
}

Alert.propTypes =  false ? {
  /**
   * The main message to be shown in the alert. Any elements are allowed, but
   * plain text and links are recommended.
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * Automatically focus on the alert when it's presented. The first interactive
   * element rendered in the alert will be focused, otherwise the alert's close
   * button will be focused. This will have no effect if the alert does not
   * contain any interactive elements.
   *
   * Use this when presenting an urgent alert that should grab the user's focus.
   * This will disrupt the user's current task, so use this with caution.
   *
   * @since 4.x
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * An accessible label for the alert's dismiss button. This is not shown in
   * the UI, but will be read by screen-readers.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset. Note that this also
   * affects the layout of the alert and the availability of other props (namely
   * `title` and `onClose`).
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * A text-only title to display before the main message. This is only
   * available for alerts with `size` set to `"large"` or `"xlarge"`.
   */
  title: _propTypes["default"].string,

  /**
   * Use this to indicate that the Alert is being used to display a toast
   * message. A drop shadow will be rendered behind the alert's body. This is
   * only applicable to "medium" and "large" alerts.
   *
   * @since 4.x
   */
  toast: _propTypes["default"].bool,

  /**
   * The type of message that is being communicated with the alert. See the
   * design guidelines for recommendations regarding which type to use.
   */
  type: _propTypes["default"].oneOf(["error", "warning", "success", "informational"]),

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   *
   * @since 4.x
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * If a function is supplied here then a dismiss button will be rendered in
   * the alert. The function will be called when the dismiss button is clicked.
   * The function will not receive any arguments.
   *
   * This only applies to alerts that are not size small. For alert with `size`
   * set to `"xlarge"` the dismiss button will be placed in the top right of
   * the closest parent element of the alert with non-static positioning.
   */
  onClose: _propTypes["default"].func
} : {};
Alert.defaultProps = {
  size: "large",
  type: "informational",
  closeLabel: "Dismiss"
};
var _default = Alert;
exports["default"] = _default;

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(432);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 1595 */
/***/ (function(module, exports) {

module.exports = function(tokens) {
  return {
    alertMobileFontSizeTitleSmall: 14,
    alertMobileFontSizeTitleMedium: 14,
    alertMobileFontSizeTitleLarge: 16,
    alertMobileFontSizeTitleXlarge: 24,
    alertMobileFontSizeMessageSmall: 14,
    alertMobileFontSizeMessageMedium: 14,
    alertMobileFontSizeMessageLarge: 16,
    alertMobileFontSizeMessageXlarge: 16,
    alertMobileLineHeightTitleSmall: "16px",
    alertMobileLineHeightTitleMedium: "16px",
    alertMobileLineHeightTitleLarge: "24px",
    alertMobileLineHeightTitleXlarge: "32px",
    alertMobileLineHeightMessageSmall: "16px",
    alertMobileLineHeightMessageMedium: "16px",
    alertMobileLineHeightMessageLarge: "24px",
    alertMobileLineHeightMessageXlarge: "24px",
    alertMobileMessageSpacingInsetHorizontalLarge: 15,
    alertMobileMessageSpacingInsetVerticalLarge: 8,
    alertMobileCloseButtonSpacingLarge: 3,
    alertBackgroundColorMediumError: "#F9D5E2",
    alertBackgroundColorMediumWarning: "#FEF2B8",
    alertBackgroundColorMediumSuccess: "#DCF3A0",
    alertBackgroundColorMediumInformational: "#F0F1F2",
    alertBackgroundColorLargeError: "#F9D5E2",
    alertBackgroundColorLargeWarning: "#FEF2B8",
    alertBackgroundColorLargeSuccess: "#DCF3A0",
    alertBackgroundColorLargeInformational: "#F0F1F2",
    alertForegroundColorSmallDefault: tokens.themeForegroundPrimaryDefault,
    alertForegroundColorSmallError: tokens.themeForegroundPrimaryError,
    alertForegroundColorMediumDefault: "#232F3E",
    alertForegroundColorLargeDefault: "#232F3E",
    alertForegroundColorXlargeDefault: tokens.themeForegroundPrimaryDefault,
    alertFontSizeTitleSmall: 14,
    alertFontSizeTitleMedium: 14,
    alertFontSizeTitleLarge: 16,
    alertFontSizeTitleXlarge: 24,
    alertFontSizeMessageSmall: 14,
    alertFontSizeMessageMedium: 14,
    alertFontSizeMessageLarge: 16,
    alertFontSizeMessageXlarge: 16,
    alertFontWeightTitle: 600,
    alertFontWeightBody: 400,
    alertLineHeightTitleSmall: "16px",
    alertLineHeightTitleMedium: "16px",
    alertLineHeightTitleLarge: "24px",
    alertLineHeightTitleXlarge: "32px",
    alertLineHeightMessageSmall: "16px",
    alertLineHeightMessageMedium: "16px",
    alertLineHeightMessageLarge: "24px",
    alertLineHeightMessageXlarge: "24px",
    alertBorderWidthMedium: 1,
    alertBorderWidthLarge: 1,
    alertBorderRadius: 4,
    alertBorderColorError: "#CC0C39",
    alertBorderColorWarning: "#DCB700",
    alertBorderColorSuccess: "#98C91E",
    alertBorderColorInformational: "#BBC0C1",
    alertSpacingInsetMedium: 8,
    alertSpacingInsetLarge: 15,
    alertSpacingInsetXlarge: 15,
    alertSpacingHorizontalSmall: 8,
    alertSpacingHorizontalMedium: 8,
    alertSpacingHorizontalLarge: 16,
    alertSpacingHorizontalXlarge: 0,
    alertCloseButtonSpacingMedium: 0,
    alertCloseButtonSpacingLarge: 7,
    alertCloseButtonSpacingXlarge: 7,
    alertTitleSpacingRightDefault: 8,
    alertTitleSpacingRightXlarge: 0,
    alertSpacingVerticalXlarge: 24,
    alertMotionDuration: "200ms",
    alertMotionFunction: "ease",
    alertShadowColor: "rgba(11, 12, 12, 0.1)",
    alertShadowOffsetX: 0,
    alertShadowOffsetY: 8,
    alertShadowBlur: 16,
    alertShadowSpread: 0
  }
};

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

module.exports = {
  iconAlertErrorXlargeData: "data:image/svg+xml,%3csvg width='88' height='88' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle stroke='%23CC0C39' stroke-width='8' fill='%23FF7494' cx='44' cy='44' r='40'/%3e%3cpath d='M44 58.667a5 5 0 100 10 5 5 0 000-10z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M44 23.333v18.334' stroke='%23232F3E' stroke-width='8' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertErrorXlargeWidth: 88,
  iconAlertErrorXlargeHeight: 88
};

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

module.exports = {
  iconAlertErrorLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle stroke='%23CC0C39' stroke-width='2' fill='%23FF7494' cx='12' cy='12' r='11'/%3e%3cpath d='M12 16.273A1.364 1.364 0 1012 19a1.364 1.364 0 000-2.727z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M12 7v5' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertErrorLargeWidth: 24,
  iconAlertErrorLargeHeight: 24
};

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

module.exports = {
  iconAlertErrorSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23FF7494' fill-rule='nonzero' cx='8' cy='8' r='8'/%3e%3cpath d='M8 16A8 8 0 108 0a8 8 0 000 16zm0-1A7 7 0 118 1a7 7 0 010 14z' fill='%23CC0C39' fill-rule='nonzero'/%3e%3cpath d='M8 4v4' stroke='%23232F3E' stroke-width='2' stroke-linecap='round'/%3e%3ccircle fill='%23232F3E' fill-rule='nonzero' cx='8' cy='12' r='1'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertErrorSmallWidth: 16,
  iconAlertErrorSmallHeight: 16
};

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

module.exports = {
  iconAlertInformationalLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23E7E9E9' cx='12' cy='12' r='11'/%3e%3cpath d='M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z' fill='%23BBC0C1' fill-rule='nonzero'/%3e%3cpath d='M12 11v6M13 17h-2M12 11h-1' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3ccircle fill='%23232F3E' fill-rule='nonzero' cx='12' cy='8' r='1'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertInformationalLargeWidth: 24,
  iconAlertInformationalLargeHeight: 24
};

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

module.exports = {
  iconAlertInformationalSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23E7E9E9' fill-rule='nonzero' cx='8' cy='8' r='7.5'/%3e%3cpath d='M8 7.063v3.75M8 7.063h-.938M8.938 10.813H7.062' stroke='%23232F3E' stroke-width='2' stroke-linecap='round'/%3e%3ccircle fill='%23232F3E' fill-rule='nonzero' cx='8' cy='4.25' r='1'/%3e%3cpath d='M8 16A8 8 0 108 0a8 8 0 000 16zm0-1A7 7 0 118 1a7 7 0 010 14z' fill='%23BBC0C1' fill-rule='nonzero'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertInformationalSmallWidth: 16,
  iconAlertInformationalSmallHeight: 16
};

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

module.exports = {
  iconAlertSuccessXlargeData: "data:image/svg+xml,%3csvg width='88' height='88' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23C3EB5E' cx='44' cy='44' r='40.333'/%3e%3cpath d='M44 88c24.3 0 44-19.7 44-44S68.3 0 44 0 0 19.7 0 44s19.7 44 44 44zm0-7.333C23.75 80.667 7.333 64.25 7.333 44S23.75 7.333 44 7.333 80.667 23.75 80.667 44 64.25 80.667 44 80.667z' fill='%2398C91E' fill-rule='nonzero'/%3e%3cpath stroke='%23232F3E' stroke-width='8' stroke-linecap='round' stroke-linejoin='round' d='M22 44.061l14.65 14.66L62.358 33'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertSuccessXlargeWidth: 88,
  iconAlertSuccessXlargeHeight: 88
};

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

module.exports = {
  iconAlertSuccessLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23C3EB5E' cx='12' cy='12' r='11'/%3e%3cpath d='M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z' fill='%2398C91E' fill-rule='nonzero'/%3e%3cpath stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' d='M6 12.017l3.996 3.998L17.006 9'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertSuccessLargeWidth: 24,
  iconAlertSuccessLargeHeight: 24
};

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

module.exports = {
  iconAlertSuccessSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle fill='%23C3EB5E' fill-rule='nonzero' cx='7.97' cy='7.97' r='7.47'/%3e%3cpath d='M11.705 6.103l-4.669 4.669M7.036 10.772l-2.8-2.802' stroke='%23232F3E' stroke-width='2' stroke-linecap='round'/%3e%3cpath d='M7.97 15.94A7.97 7.97 0 107.97 0a7.97 7.97 0 000 15.94zm0-1A6.97 6.97 0 117.97 1a6.97 6.97 0 010 13.94z' fill='%2398C91E' fill-rule='nonzero'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertSuccessSmallWidth: 16,
  iconAlertSuccessSmallHeight: 16
};

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

module.exports = {
  iconAlertWarningXlargeData: "data:image/svg+xml,%3csvg width='88' height='88' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M82.293 72.449L49.898 7.583A6.656 6.656 0 0043.996 4a6.656 6.656 0 00-5.902 3.583L5.699 72.449C1.756 80.29 7.605 84 11.273 84h65.67c3.494 0 9.29-3.814 5.35-11.551z' stroke='%23DCB700' stroke-width='8' fill='%23FCDE4D' stroke-linecap='round' stroke-linejoin='round'/%3e%3cpath d='M43.57 62.333a4.583 4.583 0 100 9.167 4.583 4.583 0 000-9.167z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M43.57 36.667v14.666' stroke='%23232F3E' stroke-width='7.333' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertWarningXlargeWidth: 88,
  iconAlertWarningXlargeHeight: 88
};

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

module.exports = {
  iconAlertWarningLargeData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M22.532 19.823L13.623 1.985a1.83 1.83 0 00-3.246 0L1.468 19.823C.384 21.98 1.993 23 3.001 23h18.06c.96 0 2.554-1.049 1.47-3.177z' fill='%23FCDE4D'/%3e%3cpath d='M14.518 1.538A2.837 2.837 0 0012 0a2.83 2.83 0 00-2.51 1.523L.574 19.377C-.698 21.905.87 24 3 24h18.06c2.083 0 3.631-2.133 2.364-4.627L14.518 1.538zm7.123 18.74c.552 1.084.09 1.722-.58 1.722H3c-.732 0-1.196-.62-.64-1.727l8.91-17.841a.83.83 0 011.465.015l8.901 17.823.004.007z' fill='%23DCB700' fill-rule='nonzero'/%3e%3cpath d='M12 17a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M12 10v4' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertWarningLargeWidth: 24,
  iconAlertWarningLargeHeight: 24
};

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

module.exports = {
  iconAlertWarningSmallData: "data:image/svg+xml,%3csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpath d='M15.205 13.08L9.11.994A1.254 1.254 0 008 .326c-.467 0-.895.257-1.111.668L.794 13.08c-.742 1.462.358 2.153 1.048 2.153h12.356c.658 0 1.748-.71 1.007-2.153z' fill='%23FCDE4D'/%3e%3cpath d='M9.557.942a1.757 1.757 0 00-3.11-.007L.302 13.12C-.506 14.71.468 16 1.797 16h12.448c1.296 0 2.258-1.312 1.452-2.882L9.557.942zm4.688 14.077H1.797c-.644 0-1.072-.566-.62-1.456L7.32 1.384A.77.77 0 018 .981c.29 0 .553.159.685.41l6.138 12.17c.45.879.027 1.458-.577 1.458z' fill='%23DCB700' fill-rule='nonzero'/%3e%3cpath d='M8 11.667a1 1 0 100 2 1 1 0 000-2z' fill='%23232F3E' fill-rule='nonzero'/%3e%3cpath d='M8 6v3' stroke='%23232F3E' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/g%3e%3c/svg%3e",
  iconAlertWarningSmallWidth: 16,
  iconAlertWarningSmallHeight: 16
};

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

module.exports = {
  iconCloseData: "data:image/svg+xml,%3csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M1.76 1.76l8.48 8.48M10.24 1.76l-8.48 8.48'/%3e%3c/g%3e%3c/svg%3e",
  iconCloseWidth: 12,
  iconCloseHeight: 12
};

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _button = _interopRequireDefault(__webpack_require__(1609));

var _default = _button["default"];
exports["default"] = _default;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(1610));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(97));

var _emotion = __webpack_require__(11);

var _button = _interopRequireDefault(__webpack_require__(1611));

var _theme = __webpack_require__(273);

var _clickable = _interopRequireDefault(__webpack_require__(1612));

var _useFocus2 = _interopRequireDefault(__webpack_require__(1617));

var _icon = _interopRequireDefault(__webpack_require__(1619));

var _buttonStyles = __webpack_require__(1621);

var _text = _interopRequireDefault(__webpack_require__(527));

var _token = __webpack_require__(113);

var _isColorDark = _interopRequireDefault(__webpack_require__(1626));

var _isElementOf = _interopRequireDefault(__webpack_require__(1627));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(526));

var isIcon = (0, _isElementOf["default"])(_icon["default"]);
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var size = _ref.size,
      type = _ref.type,
      focus = _ref.focus,
      disabled = _ref.disabled,
      minWidth = _ref.minWidth,
      _ref$backdropColor = _ref.backdropColor,
      backdropColor = _ref$backdropColor === void 0 ? t.tokens.themeBackgroundPrimaryDefault : _ref$backdropColor,
      iconOnly = _ref.iconOnly,
      circular = _ref.circular;
  var state = disabled ? "disabled" : "default";
  var linkOrIcon = type === "link" || type === "icon";
  var backdrop = linkOrIcon && (0, _isColorDark["default"])(backdropColor) ? "darkBackdrop" : linkOrIcon ? "lightBackdrop" : undefined;
  var borderColor = t("borderColor", [type, state]);
  var borderWidth = borderColor ? t("borderWidth") : 0;
  var borderStyle = borderColor ? "solid" : undefined;
  var borderRadius = circular && iconOnly ? 999 : t("borderRadius");
  return (0, _emotion.css)((0, _text["default"])(t, {
    fontSize: size
  }), disabled ? (0, _buttonStyles.disabledStyles)(t, {
    type: type,
    backdrop: backdrop
  }) : (0, _buttonStyles.defaultStyles)(t, {
    type: type,
    backdrop: backdrop
  }), {
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    outline: "none",
    position: "relative",
    minWidth: minWidth ? minWidth : undefined,
    height: t("height", size),
    // Make icon-only buttons square w/ no padding and all other buttons
    // flexible with padding.
    width: iconOnly ? t("height", size) : undefined,
    flexShrink: iconOnly ? 0 : undefined,
    padding: iconOnly ? undefined : "0 ".concat(t("spacingInsetHorizontal", size), "px"),
    transition: t.transitionCss("motion", ["color", "background-color", "border-color"]),
    borderRadius: borderRadius,
    borderStyle: borderStyle,
    borderWidth: borderWidth,
    whiteSpace: "nowrap",
    // HACK: IE11 will only show a pseudo element on a button if
    // overflow is set to visible, and our focus ring is displayed with a
    // pseudo element.
    overflow: "visible",
    "& > * + *": {
      marginLeft: t("spacingInsetHorizontal", size)
    },
    ":hover": !disabled ? (0, _buttonStyles.hoverStyles)(t, {
      type: type,
      backdrop: backdrop
    }) : undefined,
    ":active": !disabled ? (0, _buttonStyles.activeStyles)(t, {
      type: type,
      backdrop: backdrop
    }) : undefined
  }, !disabled ? (0, _buttonStyles.focusStyles)(t, {
    focus: focus,
    borderWidth: borderWidth,
    borderRadius: borderRadius,
    backdropColor: backdropColor,
    linkOrIcon: linkOrIcon
  }) : undefined);
}, ["size", "type", "focus", "disabled", "backdropColor", "minWidth", "iconOnly", "circular"]); // Used to wrap button text in spans. This allows the margins applied by the
// button to take effect, since you can't apply a margin to a text node. This
// was implemented with the <Button><Icon /> text</Button> use case in mind
// where spacing needs to be applied between the icon and the text. Note that
// this is not applied if the button only has one child.

var wrapStringSiblingsInSpans = function wrapStringSiblingsInSpans(children) {
  var arr = _react["default"].Children.toArray(children);

  return arr.length > 1 ? arr.map(function (child, index) {
    return typeof child === "string" ? /*#__PURE__*/_react["default"].createElement("span", {
      key: index
    }, child) : child;
  }) : children;
};
/**
 * Render a button. Note that won't necessarily result in a "button" tag in the
 * DOM - if you provide an href attribute then an "a" tag will be used for
 * accessibility purposes.
 */


var Button = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_button["default"], "button"); // If a label prop was supplied, use that to label the button. Otherwise if
  // we're dealing with an icon button, use any string children as the label.

  var ariaLabel = props.label ? props.label : props.type === "icon" ? _react["default"].Children.toArray(props.children).filter(function (child) {
    return typeof child === "string";
  }).join(" ").trim() : undefined; // Does the button contain only an icon (no text)? Takes into account the
  // deprecated API (iconTokens) as well as the current API (passing an Icon as
  // a child).

  var iconOnly = props.type === "icon" && props.iconTokens || _react["default"].Children.count(props.children) === 1 && isIcon(props.children); // Pull popovers closer to icon buttons so that they're offset from the edge
  // of the icon (which is visible), not the edge of the button element (which
  // is not visible). The magic "24" here is the size of a standard icon. By
  // subtracting that from the height of the button and dividing by 2 we get the
  // distance between the invisible edge of the button and the visible edge of
  // the icon.

  var popoverOffset = props.type === "icon" ? -(t("height", props.size) - 24) / 2 : undefined;

  var _useFocus = (0, _useFocus2["default"])(props),
      focus = _useFocus.focus,
      focusTrigger = _useFocus.focusTrigger,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
  return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, {
    ref: ref,
    className: (0, _emotion.cx)(styles(t, {
      type: props.type,
      size: props.size,
      disabled: props.disabled,
      circular: props.circular,
      backdropColor: props.backdropColor,
      minWidth: props.minWidth,
      focus: focus && focusTrigger === "keyboard",
      iconOnly: iconOnly
    }), props.className),
    disabled: props.disabled,
    id: props.id,
    href: props.href,
    rel: props.rel,
    target: props.target,
    onClick: props.onClick,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    propagateClickEvent: props.propagateClickEvent,
    tabIndex: props.tabIndex,
    download: props.download,
    submit: props.submit,
    "aria-hidden": props["aria-hidden"],
    "aria-label": ariaLabel,
    "mrdn-popover-offset": popoverOffset
  }, focusProps), props.type === "icon" && props.iconTokens ? /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: props.iconTokens
  }) : wrapStringSiblingsInSpans(props.children));
});

Button.displayName = "Button";
Button.propTypes =  false ? {
  /**
   * The button's label.
   *
   * Since 4.x an Icon component can be passed as the only child to render an
   * icon-only button (in 3.x and earlier the `iconTokens` prop must be used).
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * This can be used to hide the element from screen readers. Only use this if
   * the element is also visually hidden.
   */
  "aria-hidden": _propTypes["default"].bool,

  /**
   * This optimizes the button for display when placed over a particular
   * background color. This is only helpful if the button is placed over a
   * background color other than the current theme's primary background color.
   */
  backdropColor: _propTypes["default"].string,

  /**
   * Render a circular button. This is only applicable to icon-only buttons.
   * Buttons with text labels cannot be circular.
   *
   * @since 4.x
   */
  circular: _propTypes["default"].bool,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   *
   * @since 4.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Use this in conjunction with the `href` prop to render a button that
   * triggers the download of a file. See docs for the [HTML download attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-download).
   */
  download: _propTypes["default"].string,

  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * **Deprecated:** Set the `type` prop to `"icon"` and pass an [Icon](https://meridian.a2z.com/components/icon/?platform=react-web)
   * component in via the `children` prop.
   *
   * Use this in conjunction with `type="icon"` to render an icon-only button.
   * The value of this prop should be an object of icon tokens imported directly
   * from the Meridian token library (e.g. `import cogTokens from "@meridian/tokens/base/icon/cog`).
   *
   * See the [Iconography page](https://meridian.a2z.com/fundamentals/iconography/?platform=react-web)
   * for a full list of the available icons.
   *
   * @deprecated 4.x
   */
  iconTokens: _propTypes["default"].object,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   *
   * @since 4.x
   */
  id: _propTypes["default"].string,

  /**
   * An accessible label for the component. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   *
   */
  label: _propTypes["default"].string,

  /**
   * Sets the minimum width on the button. The button may grow wider than this
   * value depending on the length of its label, but it will not grow narrow
   * than this value.
   */
  minWidth: _propTypes["default"].string,

  /**
   * Determines whether or not the click event will continue to bubble up
   * through the DOM. Read the [Event.stopPropagation() docs](https://developer.mozilla.org/en-US/docs/Web/API/Event/stopPropagation)
   * for details.
   *
   * @since 4.x
   */
  propagateClickEvent: _propTypes["default"].bool,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   *
   * @since 4.x
   */
  rel: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * If set to true the button will automatically trigger the submit action of
   * any `<form />` that it's placed in.
   */
  submit: _propTypes["default"].bool,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * This determines the visual style of the button.
   */
  type: _propTypes["default"].oneOf(["primary", "secondary", "tertiary", "link", "icon"]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=react-web)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves over the component. The [mouseenter event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseenter_event)
   * is passed as the first argument to the function.
   */
  onMouseEnter: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves off of the component. The [mouseleave event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseleave_event)
   * is passed as the first argument to the function.
   */
  onMouseLeave: _propTypes["default"].func
} : {};
Button.defaultProps = {
  propagateClickEvent: true,
  size: "medium",
  type: "primary"
};
var _default = Button;
exports["default"] = _default;

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

module.exports = function(tokens) {
  return {
    buttonMotionDuration: "100ms",
    buttonMotionFunction: "ease",
    buttonBackgroundColorPrimaryDefault: tokens.themeForegroundAccentDefault,
    buttonBackgroundColorPrimaryHover: tokens.themeForegroundAccentHover,
    buttonBackgroundColorPrimaryPressed: tokens.themeForegroundAccentPressed,
    buttonBackgroundColorPrimaryDisabled: tokens.themeForegroundAccentDisabled,
    buttonBackgroundColorSecondaryDefault: tokens.themeBackgroundTertiaryDefault,
    buttonBackgroundColorSecondaryHover: tokens.themeBackgroundTertiaryHover,
    buttonBackgroundColorSecondaryPressed: tokens.themeBackgroundTertiaryPressed,
    buttonBackgroundColorSecondaryDisabled: tokens.themeBackgroundTertiaryDisabled,
    buttonBackgroundColorTertiaryDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorTertiaryHover: tokens.themeForegroundAccentHover,
    buttonBackgroundColorTertiaryPressed: tokens.themeForegroundAccentPressed,
    buttonBackgroundColorLinkDarkBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorLinkDarkBackdropHover: "rgba(255, 255, 255, 0.22)",
    buttonBackgroundColorLinkDarkBackdropPressed: "rgba(255, 255, 255, 0.36)",
    buttonBackgroundColorLinkLightBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorLinkLightBackdropHover: "rgba(11, 12, 12, 0.1)",
    buttonBackgroundColorLinkLightBackdropPressed: "rgba(11, 12, 12, 0.26)",
    buttonBackgroundColorIconDarkBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorIconDarkBackdropHover: "rgba(255, 255, 255, 0.22)",
    buttonBackgroundColorIconDarkBackdropPressed: "rgba(255, 255, 255, 0.36)",
    buttonBackgroundColorIconLightBackdropDefault: "rgba(0, 0, 0, 0)",
    buttonBackgroundColorIconLightBackdropHover: "rgba(11, 12, 12, 0.1)",
    buttonBackgroundColorIconLightBackdropPressed: "rgba(11, 12, 12, 0.26)",
    buttonForegroundColorPrimaryDefault: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorPrimaryDisabled: tokens.themeBackgroundAccentDisabled,
    buttonForegroundColorSecondaryDefault: tokens.themeForegroundPrimaryDefault,
    buttonForegroundColorSecondaryDisabled: tokens.themeForegroundTertiaryDisabled,
    buttonForegroundColorTertiaryDefault: tokens.themeForegroundAccentDefault,
    buttonForegroundColorTertiaryHover: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorTertiaryFocus: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorTertiaryPressed: tokens.themeForegroundInvertedDefault,
    buttonForegroundColorTertiaryDisabled: tokens.themeBorderAccentDisabled,
    buttonForegroundColorLinkDarkBackdropDefault: tokens.themePalette300,
    buttonForegroundColorLinkDarkBackdropHover: tokens.themePalette200,
    buttonForegroundColorLinkDarkBackdropPressed: tokens.themePalette100,
    buttonForegroundColorLinkDarkBackdropDisabled: tokens.themePaletteMuted500,
    buttonForegroundColorLinkLightBackdropDefault: tokens.themePalette500,
    buttonForegroundColorLinkLightBackdropHover: tokens.themePalette600,
    buttonForegroundColorLinkLightBackdropPressed: tokens.themePalette700,
    buttonForegroundColorLinkLightBackdropDisabled: tokens.themePaletteMuted200,
    buttonForegroundColorIconDarkBackdropDefault: "#FFFFFF",
    buttonForegroundColorIconDarkBackdropDisabled: "#6C7778",
    buttonForegroundColorIconLightBackdropDefault: "#232F3E",
    buttonForegroundColorIconLightBackdropDisabled: "#BBC0C1",
    buttonFontSizeSmall: 14,
    buttonFontSizeMedium: 16,
    buttonFontSizeLarge: 18,
    buttonFontSizeXlarge: 28,
    buttonBorderWidth: 2,
    buttonBorderRadius: 4,
    buttonBorderColorTertiaryDefault: tokens.themeForegroundAccentDefault,
    buttonBorderColorTertiaryHover: tokens.themeForegroundAccentHover,
    buttonBorderColorTertiaryPressed: tokens.themeForegroundAccentPressed,
    buttonBorderColorTertiaryDisabled: tokens.themeBorderAccentDisabled,
    buttonSpacingInsetHorizontalSmall: 10,
    buttonSpacingInsetHorizontalMedium: 16,
    buttonSpacingInsetHorizontalLarge: 16,
    buttonSpacingInsetHorizontalXlarge: 24,
    buttonHeightSmall: 32,
    buttonHeightMedium: 40,
    buttonHeightLarge: 48,
    buttonHeightXlarge: 64,
    buttonFocusOutlineOffset: 4
  }
};

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _clickable = _interopRequireDefault(__webpack_require__(1613));

var _default = _clickable["default"];
exports["default"] = _default;

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(167);

var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(166));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(97));

var _emotion = __webpack_require__(11);

var _keycode = _interopRequireDefault(__webpack_require__(1614));

var _noop = _interopRequireDefault(__webpack_require__(525));

var _buttonReset = _interopRequireDefault(__webpack_require__(1615));

var _linkReset = _interopRequireDefault(__webpack_require__(1616));

var _functional = __webpack_require__(98);

var _cxMemoized = _interopRequireDefault(__webpack_require__(168));

var _filterPropsByPrefix = _interopRequireDefault(__webpack_require__(526));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = (0, _functional.memoizeByKeys)(function (_ref) {
  var tag = _ref.tag,
      disabled = _ref.disabled;
  return (0, _emotion.css)({
    button: _objectSpread(_objectSpread({}, _buttonReset["default"]), {}, {
      // HACK: IE offsets the contents of buttons on mouse down (in the active
      // state) to create a faux 3D effect. These styles are applied to every
      // child of  the button in order to counter this effect so that we are
      // the masters of our own button-content-position-destiny.
      "& > *": {
        position: "relative"
      }
    }),
    a: _linkReset["default"]
  }[tag], {
    cursor: disabled ? "not-allowed" : "pointer",
    outline: "none"
  });
}, ["tag", "disabled"]);

var getPropsForNativeLink = function getPropsForNativeLink(props) {
  return {
    href: props.disabled ? undefined : props.href,
    target: props.target,
    rel: props.rel,
    "aria-disabled": props.disabled || undefined,
    role: props.role !== "link" ? props.role : undefined,
    tabIndex: props.disabled ? "-1" : props.tabIndex,
    onClick: props.onClick
  };
};

var getPropsForNativeButton = function getPropsForNativeButton(props) {
  return {
    disabled: props.disabled || undefined,
    type: props.submit ? "submit" : "button",
    role: props.role !== "button" ? props.role : undefined,
    tabIndex: props.tabIndex,
    onClick: props.onClick
  };
};

var getPropsForCustomClickable = function getPropsForCustomClickable(props) {
  return {
    href: props.disabled ? undefined : props.href,
    target: props.target,
    rel: props.rel,
    "aria-disabled": props.disabled || undefined,
    tabIndex: props.disabled ? "-1" : props.tabIndex || "0",
    role: props.role,
    onKeyDown: function onKeyDown(event) {
      var key = (0, _keycode["default"])(event);
      var focus = document.activeElement === event.currentTarget; // Trigger a click on enter-key-down for buttons and links

      if (focus && key === "enter") {
        props.onClick(event);
      } // Disable scrolling on space-key-down for buttons


      if (focus && key === "space" && props.role === "button") {
        event.preventDefault();
      }
    },
    onKeyUp: props.role === "button" ? function (event) {
      var key = (0, _keycode["default"])(event);
      var focus = document.activeElement === event.currentTarget; // Trigger a click on space-key-up for buttons

      if (focus && key === "space") {
        // NOTE: event.preventDefault() will have already been called at
        // this point to keep the space key from triggering a scroll
        // (see `onKeyDown` above), so instead of passing the original
        // event this will pass a mock event that looks like it hasn't
        // had preventDefault() called.
        props.onClick({
          defaultPrevented: false,
          preventDefault: _noop["default"]
        });
      }
    } : undefined,
    onClick: props.onClick
  };
};
/**
 * Simulate a link click by creating an anchor tag and clicking on it. This
 * allows features like the "rel" attribute to be used on Clickable that have
 * an href but aren't rendered as an "a" tag (e.g. a Card that might be rendered
 * as a div so it can contain action buttons/links).
 */


var simulateLinkClick = function simulateLinkClick(linkAttributes) {
  // Create a link element that we can click
  var link = document.createElement("a"); // Assign attributes to the link (e.g. href). Filter out undefined attributes.
  // React normally does this for us, but the DOM doesn't so we have to do it
  // manually to avoid things like `download="undefined"` in the DOM.

  Object.assign(link, Object.keys(linkAttributes).reduce(function (result, key) {
    if (linkAttributes[key] !== undefined) {
      result[key] = linkAttributes[key];
    }

    return result;
  }, {})); // Add the link to the DOM (necessary for this to work in some browsers like
  // FF)

  document.body.appendChild(link); // Trigger a click on the link

  link.click(); // Remove the link from the dom.

  document.body.removeChild(link);
};
/**
 * This component determines whether an `a` or `button` tag is most appropriate
 * given the props passed to it. It will render the element to the dom with its
 * styles completely reset. It also handles link disabling (not a native feature
 * of the web) and default event prevention for links with click handlers.
 *
 * The goal of this component is to provide a uniform API for clickable elements
 * while ensuring that we are always using the correct html element under the
 * hood. This allows us to can take advantage of default browser behavior and
 * maintain good accessibility.
 *
 * This component also allows nesting so that clickable parents can have
 * clickable children and the streams won't get crossed. For these use cases the
 * `tag` prop can be used to manually choose the html tag rendered by the
 * component, since clickable elements should not be nested inside native
 * buttons or links.
 */


var Clickable = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var onClick = props.onClick,
      href = props.href,
      target = props.target,
      submit = props.submit,
      disabled = props.disabled,
      rel = props.rel,
      download = props.download,
      tabIndex = props.tabIndex,
      propagateClickEvent = props.propagateClickEvent; // Figure out the role of the clickable element and the tag to render to the
  // DOM

  var nativeRole = href && !submit ? "link" : "button";
  var role = props.role !== undefined ? props.role : nativeRole;
  var tag = props.tag ? props.tag : nativeRole === "link" ? "a" : "button";
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "mrdn-"]); // What happens when the Clickable is clicked. Pretty key.

  var onClickTag = (0, _react.useCallback)(function (event) {
    // If the default event behavior was already prevented (e.g. by a nested
    // Clickable inside this one) then don't do anything
    if (!event.defaultPrevented) {
      var nativeBehavior = tag === "a" && href || tag === "button" && submit; // Call `preventDefault` for elements that are either disabled, have a
      // custom onClick handler, or do not have any native browser behavior.
      // This keeps any parent Clickable elements higher up in the DOM tree from
      // also handling the event. This doesn't stop propagation though - other
      // elements may want to react to the event even if its default behavior
      // was cancelled.

      if (disabled || onClick || !nativeBehavior) {
        event.preventDefault();
      } // If we were explicitly told to stop propagation on the event then
      // do so now


      if (!propagateClickEvent) {
        event.stopPropagation();
      } // If we're not disabled then handle the click


      if (!disabled) {
        // If the element has native behavior and we don't have a custom
        // onClick handler, then fall back to the native behavior (and stop
        // propagation to keep anyone else from handling the click).
        if (nativeBehavior && !onClick) {
          event.stopPropagation();
        } // If we've got an element with an href and the user has attempted to
        // open it in a new tab (via control-click, command-click, or
        // middle-mouse-button click) then do that
        else if (href && (event.ctrlKey || event.metaKey || event.button === 1)) {
            simulateLinkClick({
              href: href,
              target: "_blank",
              rel: "noopener noreferrer",
              download: download
            });
          } // If we were given a custom onClick handle then call it and pass the
          // href (if we have one). This makes it easy to do html5-history-style
          // links like this:
          //   <Clickable href="/path" onClick={push}>
          //     my accessible html5 link
          //   </Clickable>
          else if (onClick) {
              onClick(href);
            } // For non-link elements with an href and no onClick handler we have
            // to manually navigate to the href
            else if (href) {
                simulateLinkClick({
                  href: href,
                  target: target,
                  rel: rel,
                  download: download
                });
              }
      }
    }
  }, [onClick, href, target, submit, disabled, tag, rel, download, propagateClickEvent]); // Generate props that are specific to the tag we're rendering (e.g. a link,
  // a button, and a div will all require different props in order to acheive
  // a particular behavior). Memoize these to reduce the number of large objects
  // created on each render.

  var clickableProps = (0, _react.useMemo)(function () {
    var props = {
      onClick: onClickTag,
      role: role,
      disabled: disabled,
      href: href,
      rel: rel,
      target: target,
      tabIndex: tabIndex,
      submit: submit
    };
    return tag === "a" && href ? getPropsForNativeLink(props) : tag === "button" ? getPropsForNativeButton(props) : getPropsForCustomClickable(props);
  }, [tag, onClickTag, role, disabled, href, rel, target, tabIndex, submit]); // HACK: Wrap string children in a span so that the IE positioning
  // hack (see the button styles above) can take effect

  var applyIE11StyleHack = tag === "button" && _react["default"].Children.toArray(props.children).filter(function (child) {
    return typeof child !== "string";
  }).length === 0;
  return /*#__PURE__*/_react["default"].createElement(tag, _objectSpread(_objectSpread(_objectSpread({}, passThroughProps), clickableProps), {}, {
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    onMouseMove: props.onMouseMove,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    id: props.id,
    download: props.download,
    "aria-selected": props["aria-selected"] || undefined,
    "aria-label": props["aria-label"] || undefined,
    "aria-current": props["aria-current"] || undefined,
    "aria-expanded": props["aria-expanded"] || undefined,
    "aria-hidden": props["aria-hidden"] || undefined,
    className: (0, _cxMemoized["default"])(styles({
      tag: tag,
      disabled: props.disabled
    }), props.className),
    ref: ref
  }), applyIE11StyleHack ? /*#__PURE__*/_react["default"].createElement("span", null, props.children) : props.children);
});

Clickable.displayName = "Clickable";
Clickable.propTypes =  false ? {
  /**
   * See docs for the [aria-current attribute](https://www.w3.org/TR/wai-aria/#aria-current).
   */
  "aria-current": _propTypes["default"].string,

  /**
   * See docs for the [aria-expanded attribute](https://www.w3.org/TR/wai-aria/#aria-expanded).
   */
  "aria-expanded": _propTypes["default"].bool,

  /**
   * This can be used to hide the element from screen readers. Only use this if
   * the element is also visually hidden.
   */
  "aria-hidden": _propTypes["default"].bool,

  /**
   * An accessible label for the component. This will not be visible in the UI, but
   * will be read by screen readers.
   *
   * See docs for the [aria-label attribute](https://www.w3.org/TR/wai-aria/#aria-label)
   * for details on appropriate usage.
   */
  "aria-label": _propTypes["default"].string,

  /**
   * See docs for the [aria-selected attribute](https://www.w3.org/TR/wai-aria/#aria-selected).
   */
  "aria-selected": _propTypes["default"].bool,

  /**
   * The contents of the component.
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   *
   * @since 4.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * See docs for the [a tag's download attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-download).
   */
  download: _propTypes["default"].string,

  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * Determines whether or not the clickable propagates the click event.
   * Setting to false will run `event.stopPropagation()`.
   */
  propagateClickEvent: _propTypes["default"].bool,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,

  /**
   * See docs for the [aria role attribute](https://www.w3.org/TR/wai-aria/#host_general_role).
   */
  role: _propTypes["default"].string,

  /**
   * See docs for the "submit" value of the [button tag's type attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attr-type).
   */
  submit: _propTypes["default"].bool,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].string,

  /**
   * The tag used to render the component in the DOM. This defaults to either
   * `a` or `button`, whichever is the more appropriate choice given the other
   * props provided (e.g. `href` or `onClick`).
   */
  tag: _propTypes["default"].string,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves over the component. The [mouseenter event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseenter_event)
   * is passed as the first argument to the function.
   */
  onMouseEnter: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves off of the component. The [mouseleave event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseleave_event)
   * is passed as the first argument to the function.
   */
  onMouseLeave: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves within the component. The [mousemove event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mousemove_event)
   * is passed as the first argument to the function.
   */
  onMouseMove: _propTypes["default"].func
} : {};
Clickable.defaultProps = {
  propagateClickEvent: true
};
var _default = Clickable;
exports["default"] = _default;

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var buttonReset = {
  display: "inline-block",
  padding: 0,
  border: 0,
  outline: "none",
  backgroundColor: "transparent",
  textAlign: "inherit",
  color: "inherit",
  fontFamily: "inherit",
  fontSize: "inherit",
  fontWeight: "inherit",
  lineHeight: "inherit",
  WebkitAppearance: "none",
  WebkitMarginBefore: 0,
  WebkitMarginAfter: 0,
  WebkitMarginStart: 0,
  WebkitMarginEnd: 0,
  "::-moz-focus-inner": {
    border: 0
  }
};
var _default = buttonReset;
exports["default"] = _default;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var linkReset = {
  display: "inline-block",
  outline: "none",
  textDecoration: "none",
  color: "inherit",
  cursor: "default"
};
var _default = linkReset;
exports["default"] = _default;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _useFocus = _interopRequireDefault(__webpack_require__(1618));

var _default = _useFocus["default"];
exports["default"] = _default;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(522));

var _react = __webpack_require__(0);

var _noop = _interopRequireDefault(__webpack_require__(525));

/**
 * @callback focusEventCallback
 * @param {*} focusEvent
 * @returns *
 */

/**
 * Options for the useFocus hook
 *
 * @typedef focusOptions
 * @type {object}
 * @property {boolean} [disabled=false] - A bug in React means that onBlur is not called
 *   when an element with focus is disabled. This prop allows you to manually
 *   inform the Focus component when the element(s) that it manages are disabled
 *   so that it can turn off its internal focus state. See:
 *   https://github.com/facebook/react/issues/9142
 * @property {boolean} [multipleNodes=false] - Turn this on if you are tracking the focus
 *   of multiple DOM nodes (i.e. if you are applying the `focusProps` returned
 *   from this hook to multiple elements).
 * @property {focusEventCallback} [onBlur] - This is called when the component loses
 *   focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
 *   is passed as the first argument to the function.
 * @property {focusEventCallback} [onFocus] - This is called when the component gains
 *   focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
 *   is passed as the first argument to the function.
 */

/**
 * Focus state returned by the useFocus hook
 *
 * @typedef focusReturn
 * @type {object}
 * @property {boolean} focus - Are the tracked node(s) focused?
 * @property {('keyboard'|'mouse')} focusTrigger - The type of device that
 *   triggered the focus.
 * @property {Object} focusProps - An object containing onFocus and onBlur
 *   event handlers that can be bound to any node you want to track focus for.
 */

/**
 * This hook helps track the focus state of a DOM node or set of DOM nodes.
 *
 * When to use this component: if you need to make a distinction between mouse
 * focus and keyboard focus, or if you need to treat multiple focuseable dom
 * nodes as a single focuseable unit. If you don't need these features you
 * should probably just track focus using local state or style using the CSS
 * :focus selector.
 *
 * This component tracks focus state for its children, including the type of
 * device that triggered the focus (keyboard or pointer). This component
 * essentially takes the place of the CSS pseudo-selectors `:focus-within` and
 * `:focus-visible`, which are not well supported. It also allows you to
 * simulate something like `:focus-visible-within`, which doesn't exist in CSS
 * at all. See:
 *   - https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
 *   - https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo
 *
 * ```
 * // The button wrapper will be outlined in blue if the button or the div is
 * // focused with the keyboard, and will not be outlined if the elements are
 * // focused with the mouse (or if they are not focused at all).
 * const MyFocuseableButton = () => {
 *   const { focus, focusTrigger, focusProps } = useFocus()
 *   return (
 *     <div style={{
 *       outline: focus && focusTrigger === "keyboard" ? "1px solid blue" : "none"
 *     }}>
 *       <button {...focusProps}>Click me!</button>
 *       <div tabIndex={0}>Also click me!</div>
 *     </div>
 *   )
 * }
 * ```
 *
 * NOTE: Components that use this hook will re-render when the nodes that are
 * are being tracked by the hook are focused or blurred. To avoid re-rendering
 * an unnecessary amount of components on focus & blur, call this hook at the
 * lowest level possible. In other words, don't call this hook in a high-level
 * component that holds a ton of children just to track the focus on a single
 * child. Instead wrap the child in its own component and call the hook there,
 * limiting focus-related renders to just that child.
 *
 * @param {focusOptions} options - Options that determine how focus is tracked.
 * @returns {focusReturn}
 */
var useFocus = function useFocus() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      disabled = _ref.disabled,
      multipleNodes = _ref.multipleNodes,
      _ref$onBlur = _ref.onBlur,
      onBlurCallback = _ref$onBlur === void 0 ? _noop["default"] : _ref$onBlur,
      _ref$onFocus = _ref.onFocus,
      onFocusCallback = _ref$onFocus === void 0 ? _noop["default"] : _ref$onFocus;

  var _useState = (0, _react.useState)([false, null]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      _useState2$ = (0, _slicedToArray2["default"])(_useState2[0], 2),
      focus = _useState2$[0],
      focusDescendent = _useState2$[1],
      setFocus = _useState2[1];

  var focusedNode = (0, _react.useRef)();
  var blurTimeout = (0, _react.useRef)();
  var onFocus = (0, _react.useCallback)(function (event) {
    clearTimeout(blurTimeout.current);
    focusedNode.current = event ? event.target : undefined;
    var nextFocusDescendent = Boolean(event) && event.currentTarget !== focusedNode.current;

    if (!focus || focusDescendent !== nextFocusDescendent) {
      setFocus([true, nextFocusDescendent]);
    }

    if (!focus) {
      onFocusCallback(event, getInteractionDevice());
    }
  }, [onFocusCallback, focus, focusDescendent]);
  var onBlurComplete = (0, _react.useCallback)(function (event) {
    setFocus([false, false]);
    onBlurCallback(event, getInteractionDevice());
  }, [onBlurCallback]);
  var onBlur = (0, _react.useCallback)(function (event) {
    if (event && multipleNodes) {
      clearTimeout(blurTimeout.current); // Don't trigger `onBlurComplete` right away if we're managing focus for
      // multiple elements. Instead, wait briefly using setTimeout to see if
      // onFocus is called for another element we're tracking. If it is then
      // we consider the state to still be focused, otherwise we can move ahead
      // and call `onBlurComplete`.

      event.persist();
      blurTimeout.current = setTimeout(function () {
        if (event.target === focusedNode.current) {
          onBlurComplete(event);
        }
      }, 0);
    } else {
      onBlurComplete(event);
    }
  }, [onBlurComplete, multipleNodes]);
  var focusProps = (0, _react.useMemo)(function () {
    return {
      onFocus: onFocus,
      onBlur: onBlur
    };
  }, [onFocus, onBlur]);
  (0, _react.useEffect)(function () {
    // When the node(s) are focused and we flip from enabled to disabled, clear
    // the focus (see the docs for the disabled param re: why this is
    // necessary).
    if (focus && disabled) {
      setFocus([false, false]);
    } // Clear the timeout when unmounting


    return function () {
      return clearTimeout(blurTimeout.current);
    };
  }, [focus, disabled]);
  return {
    focus: focus,
    focusProps: focusProps,
    focusDescendent: focusDescendent,
    focusTrigger: getInteractionDevice()
  };
};
/**
 * This tracks whether the user is using their mouse or keyboard to interact
 * with the application. This state is tracked outside of React because it
 * updates on every mousedown or keydown in the window. Tracking this inside of
 * React using component state would trigger a re-render of every component
 * with useFocus for every one of these events, which would result in a ton of
 * unnecessary re-rendering. The value of this state is only relevant when a new
 * element is focused anyway, so `onFocus` can fetch the new value when that
 * happens.
 */


var getInteractionDevice = function () {
  var device = "keyboard";

  if (typeof window !== "undefined" && window.addEventListener) {
    window.addEventListener("mousedown", function () {
      return device = "mouse";
    }, true);
    window.addEventListener("keydown", function () {
      return device = "keyboard";
    }, true);
  }

  return function () {
    return device;
  };
}();

var _default = useFocus;
exports["default"] = _default;

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _icon = _interopRequireDefault(__webpack_require__(1620));

var _default = _icon["default"];
exports["default"] = _default;

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

var _interopRequireWildcard = __webpack_require__(167);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(97));

var _emotion = __webpack_require__(11);

var _token = __webpack_require__(113);

var _functional = __webpack_require__(98);

var _cxMemoized = _interopRequireDefault(__webpack_require__(168));

var styles = (0, _functional.memoize)(function (size) {
  return (0, _emotion.css)({
    position: "relative",
    flexShrink: 0,
    display: "inline-block",
    width: size,
    height: size,
    verticalAlign: "middle",
    // Don't show the icon's label
    fontSize: 0,
    // Center the icon image
    "& svg": {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translateY(-50%) translateX(-50%)"
    }
  });
});

var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
  return nextProps.tokens === prevProps.tokens && nextProps.className === prevProps.className && nextProps.children === prevProps.children;
};

var Icon = /*#__PURE__*/_react["default"].memo( /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _getIconFromTokens = (0, _token.getIconFromTokens)(props.tokens),
      data = _getIconFromTokens.data,
      width = _getIconFromTokens.width,
      height = _getIconFromTokens.height;

  var svg = decodeURIComponent(data.replace(/^data:image\/svg\+xml,/, "")) // Add aria-hidden="true" so that screen readers ignore the underlying svg
  // (we label the parent span) and focusable="false" because IE11 defaults
  // to adding SVGs to the tab order
  .replace(/<svg/, "<svg aria-hidden=\"true\" focusable=\"false\"");
  var html = (0, _react.useMemo)(function () {
    return {
      __html: svg
    };
  }, [svg]);
  var size = width > Icon.sizes.small || height > Icon.sizes.small ? Icon.sizes.large : Icon.sizes.small;
  var simpleChildren = props.children === undefined || typeof props.children === "string";
  return /*#__PURE__*/_react["default"].createElement("span", {
    role: "img",
    "aria-hidden": !props.children ? true : undefined,
    "aria-label": simpleChildren ? props.children : undefined,
    className: (0, _cxMemoized["default"])(styles(size), props.className),
    tabIndex: props.tabIndex,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    ref: ref,
    dangerouslySetInnerHTML: simpleChildren ? html : undefined
  }, simpleChildren ? null : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: html
  }), props.children));
}), shouldNotUpdate);

Icon.sizes = {
  small: 16,
  large: 24
};
Icon.displayName = "Icon";
Icon.propTypes =  false ? {
  /**
   * An object of icon tokens imported from the Meridian token library.
   */
  tokens: _propTypes["default"].object.isRequired,

  /**
   * An accessible label for the icon (not visible in the UI). Since version 4.x
   * a Badge component can be passed in along with the label in order to render
   * a badge on the icon (visible in the UI).
   *
   * @since 4.x
   */
  children: _propTypes["default"].node,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   * This can be used for positioning the icon or setting the icon's color
   *
   * This should *not* be used to override other styles on the component.
   * Meridian's internal CSS and HTML are private APIs and may change at any
   * time, potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,

  /**
   * Manually specify the order of the component in sequential keyboard navigation.
   *
   * If this is not specified the component will not be focuseable.
   *
   * Use this with caution. See docs for the [HTML tabindex attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex)
   * for details on appropriate usage.
   */
  tabIndex: _propTypes["default"].number,

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   *
   * Note that `tabIndex` must be specified in order for the component to be
   * focuseable.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   *
   * Note that `tabIndex` must be specified in order for the component to be
   * focuseable.
   */
  onFocus: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves over the component. The [mouseenter event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseenter_event)
   * is passed as the first argument to the function.
   *
   * @deprecated 4.x
   */
  onMouseEnter: _propTypes["default"].func,

  /**
   * This is called when the mouse cursor moves off of the component. The [mouseleave event](https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseleave_event)
   * is passed as the first argument to the function.
   *
   * @deprecated 4.x
   */
  onMouseLeave: _propTypes["default"].func
} : {};
Icon.sizes = {
  small: 16,
  large: 24
};
var _default = Icon;
exports["default"] = _default;

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disabledStyles = exports.defaultStyles = exports.focusStyles = exports.hoverStyles = exports.activeStyles = void 0;

var _focusRing = _interopRequireDefault(__webpack_require__(1622));

var getStyles = function getStyles(t, _ref) {
  var type = _ref.type,
      backdrop = _ref.backdrop,
      state = _ref.state;
  return {
    color: t("foregroundColor", [type, backdrop, state]),
    backgroundColor: t("backgroundColor", [type, backdrop, state]),
    borderColor: t("borderColor", [type, state])
  };
};

var activeStyles = function activeStyles(t, _ref2) {
  var type = _ref2.type,
      backdrop = _ref2.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "pressed"
  });
};

exports.activeStyles = activeStyles;

var hoverStyles = function hoverStyles(t, _ref3) {
  var type = _ref3.type,
      backdrop = _ref3.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "hover"
  });
};

exports.hoverStyles = hoverStyles;

var defaultStyles = function defaultStyles(t, _ref4) {
  var type = _ref4.type,
      backdrop = _ref4.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "default"
  });
};

exports.defaultStyles = defaultStyles;

var disabledStyles = function disabledStyles(t, _ref5) {
  var type = _ref5.type,
      backdrop = _ref5.backdrop;
  return getStyles(t, {
    type: type,
    backdrop: backdrop,
    state: "disabled"
  });
};

exports.disabledStyles = disabledStyles;

var focusStyles = function focusStyles(t, _ref6) {
  var focus = _ref6.focus,
      borderWidth = _ref6.borderWidth,
      borderRadius = _ref6.borderRadius,
      backdropColor = _ref6.backdropColor,
      linkOrIcon = _ref6.linkOrIcon;
  return (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    borderWidth: borderWidth,
    borderRadius: borderRadius,
    gapColor: backdropColor,
    dropShadow: !linkOrIcon,
    offset: t("focusOutlineOffset")
  });
};

exports.focusStyles = focusStyles;

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(166));

var _focusRing = _interopRequireDefault(__webpack_require__(1623));

var _elevation = __webpack_require__(1624);

var _token = __webpack_require__(113);

/**
 * Styles for our focus ring. Apply these to the focuseable element.
 *
 * NOTE: This applies "position: relative" to the focuseable element in order to
 * position the ring absolutely. This method will not work on elements without
 * a box (e.g. a link that wraps across lines, or an element with display set to
 * "content").
 */
var focusRing = function focusRing(themeTokens, _ref) {
  var _ref2;

  var focus = _ref.focus,
      error = _ref.error,
      dropShadow = _ref.dropShadow,
      gapColor = _ref.gapColor,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset,
      _ref$borderWidth = _ref.borderWidth,
      borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 0 : _ref$borderRadius,
      _ref$hoverSelector = _ref.hoverSelector,
      hoverSelector = _ref$hoverSelector === void 0 ? "&:hover" : _ref$hoverSelector;
  var tokens = (0, _focusRing["default"])(themeTokens);
  var state = focus ? "focus" : error ? "error" : undefined;
  var width = (0, _token.getToken)(tokens, "focusRingWidth");
  var color = (0, _token.getToken)(tokens, "focusRingColor", state);
  var dropShadowCss = dropShadow === true ? "".concat((0, _token.getToken)(tokens, "focusRingDropShadowOffsetX"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowOffsetY"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowBlur"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowSpread"), "px ").concat((0, _token.getToken)(tokens, "focusRingDropShadowColor")) : dropShadow; // If we're supposed to fill in the gap between the focus ring and the
  // element then use an inset box shadow.

  var gapShadowCss = color && gapColor ? "inset 0 0 0 ".concat(offset - width, "px ").concat(gapColor) : undefined;
  var dropShadowAndGapShadowCss = dropShadowCss && gapShadowCss ? "".concat(dropShadowCss, ", ").concat(gapShadowCss) : dropShadowCss || gapShadowCss;
  return _ref2 = {
    // The focuseable element needs to be relatively positioned so that we can
    // absolutely position the focus ring
    position: "relative",
    // If the ring entirely overlaps the focused element's border, turn the
    // element's border off to avoid artifacts near the rounded corners
    borderColor: color && offset >= 0 && width - offset >= borderWidth ? "transparent" : undefined
  }, (0, _defineProperty2["default"])(_ref2, hoverSelector, dropShadowCss && !color ? {
    boxShadow: dropShadowCss
  } : undefined), (0, _defineProperty2["default"])(_ref2, "".concat(hoverSelector, ":after"), dropShadowCss && state === "error" ? {
    boxShadow: dropShadowAndGapShadowCss
  } : undefined), (0, _defineProperty2["default"])(_ref2, "zIndex", focus ? _elevation.elevationForeground : error ? _elevation.elevationMidground : _elevation.elevationBackground), (0, _defineProperty2["default"])(_ref2, "&:after", color ? {
    content: "''",
    pointerEvents: "none",
    position: "absolute",
    top: -offset - borderWidth,
    right: -offset - borderWidth,
    bottom: -offset - borderWidth,
    left: -offset - borderWidth,
    border: "".concat(width, "px solid ").concat(color),
    borderRadius: typeof borderRadius === "string" ? borderRadius.split(" ").map(function (radius) {
      var r = parseInt(radius);
      return r > 0 ? "".concat(parseInt(radius) + offset, "px") : "0";
    }).join(" ") : borderRadius > 0 ? borderRadius + offset : 0,
    boxShadow: state === "focus" ? dropShadowAndGapShadowCss : gapShadowCss
  } : undefined), _ref2;
};

var _default = focusRing;
exports["default"] = _default;

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

module.exports = function(tokens) {
  return {
    focusRingWidth: 2,
    focusRingColorFocus: tokens.themeBorderPrimaryFocus,
    focusRingColorError: tokens.themeBorderPrimaryError,
    focusRingDropShadowOffsetX: 0,
    focusRingDropShadowOffsetY: 1,
    focusRingDropShadowBlur: 2,
    focusRingDropShadowSpread: 0,
    focusRingDropShadowColor: "rgba(11, 12, 12, 0.16)"
  }
};

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

module.exports = {
  elevationBackground: 0,
  elevationMidground: 10,
  elevationForeground: 20,
  elevationMasthead: 30,
  elevationFixture: 40,
  elevationSideMenu: 50,
  elevationModal: 60,
  elevationPopover: 70,
  elevationTooltip: 80
};

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

module.exports = function(tokens) {
  return {
    textFontFamilyAmazonEmber: "Amazon Ember",
    textFontFamilyAmazonEmberDisplay: "Amazon Ember Display",
    textFontFamilyAmazonEmberMonospace: "Amazon Ember Monospace",
    textFontFamilyBookerly: "Bookerly",
    textFontFamilyBookerlyDisplay: "Bookerly Display",
    textFontSizeD300: 76,
    textFontSizeD200: 54,
    textFontSizeD100: 48,
    textFontSizeD50: 36,
    textFontSizeH600: 36,
    textFontSizeH500: 28,
    textFontSizeH400: 24,
    textFontSizeH300: 20,
    textFontSizeH200: 18,
    textFontSizeH100: 16,
    textFontSizeB500: 20,
    textFontSizeB400: 18,
    textFontSizeB300: 16,
    textFontSizeB200: 14,
    textFontSizeB100: 12,
    textFontWeightD300: 200,
    textFontWeightD200: 200,
    textFontWeightD100: 200,
    textFontWeightD50: 200,
    textFontWeightH600: 600,
    textFontWeightH500: 600,
    textFontWeightH400: 600,
    textFontWeightH300: 600,
    textFontWeightH200: 600,
    textFontWeightH100: 600,
    textFontWeightB500: 400,
    textFontWeightB400: 400,
    textFontWeightB300: 400,
    textFontWeightB200: 400,
    textFontWeightB100: 400,
    textLineHeightD300: "96px",
    textLineHeightD200: "64px",
    textLineHeightD100: "60px",
    textLineHeightD50: "48px",
    textLineHeightH600: "48px",
    textLineHeightH500: "36px",
    textLineHeightH400: "32px",
    textLineHeightH300: "24px",
    textLineHeightH200: "24px",
    textLineHeightH100: "20px",
    textLineHeightB500: "28px",
    textLineHeightB400: "28px",
    textLineHeightB300: "24px",
    textLineHeightB200: "20px",
    textLineHeightB100: "16px",
    textColorPrimary: tokens.themeForegroundPrimaryDefault,
    textColorSecondary: tokens.themeForegroundSecondaryDefault,
    textColorError: tokens.themeForegroundPrimaryError,
    textColorInverted: tokens.themeForegroundInvertedDefault,
    textListSpacingHorizontal: 20,
    textListSpacingVertical: 8
  }
};

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Thanks StackOverflow!
var getBrightness = function getBrightness(hex) {
  var decimal = parseInt(hex.substring(1), 16); // convert hex (rrggbb) to decimal

  var r = decimal >> 16 & 0xff; // extract red

  var g = decimal >> 8 & 0xff; // extract green

  var b = decimal >> 0 & 0xff; // extract blue

  return 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
};

var isColorDark = function isColorDark(hex) {
  return getBrightness(hex) < 128;
};

var _default = isColorDark;
exports["default"] = _default;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Determines if two components are the same. Uses some tricks to smooth out
 * wrinkles with react-hot-loader in development mode
 *
 * @example
 * import Checkbox from "@meridian/components/checkbox"
 * import Radio from "@meridian/components/radio"
 *
 * console.log(isSameComponent(Checkbox, Checkbox)) // true
 * console.log(isSameComponent(Checkbox, Radio)) // false
 */
var isSameComponent = function isSameComponent(a, b) {
  if (!a || !b) {
    // Bail if either component wasn't provided
    return false;
  } else if (false) {
    // If a name is set then rely on that in development mode. The component
    // name is more reliable than the type in development mode becaues of a
    // limitation of react-hot-loader (see:
    // https://github.com/gaearon/react-hot-loader/issues/304). Don't use this
    // in production though because minification will change the name and break
    // the comparison.
    var aName = a.displayName || a.name;
    var bName = b.displayName || b.name;
    return aName === bName;
  } else {
    // Just check if the components reference the same class/function.
    return a === b;
  }
};
/**
 * Determines if an element is an instance of a particular component.
 *
 * @example
 * import Checkbox from "@meridian/components/checkbox"
 *
 * const isCheckbox = isElementOf(Checkbox)
 * console.log(isCheckbox(<Checkbox />)) // true
 */


var isElementOf = function isElementOf(component) {
  return function (element) {
    if (!component || !element) {
      // Bail if either the component or element wasn't provided
      return false;
    } else if (element.type && element.type.WrappedComponent) {
      // If the element's component has a static WrappedComponent property, assume
      // we're working with a HoC and compare the wrapped component instead of the
      // HoC component. The connect HoC from redux uses this pattern, so this
      // check ensures that isElementOf works correctly on redux-connected
      // components.
      return isSameComponent(element.type.WrappedComponent, component) || isSameComponent(element.type.WrappedComponent, component.WrappedComponent);
    } else {
      // If WrappedComonent isn't set do a normal comparison of element.type
      // (the component that element was instantiated from) and component.
      return isSameComponent(element.type, component);
    }
  };
};

var _default = isElementOf;
exports["default"] = _default;

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(50);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoundingFocusNodes = exports.getKeyboardFocusNodes = exports.getFocusNodes = exports.canKeyboardFocusNode = exports.canFocusNode = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(1629));

var _findIndex = _interopRequireDefault(__webpack_require__(1633));

var _findLastIndex = _interopRequireDefault(__webpack_require__(1636));

var focusNodeQuery = "button, input, select, textarea, [tabindex], [href]";
/**
 * Indicates whether a node is
 */

var canFocusNode = function canFocusNode(node) {
  return node && node.matches ? node.matches(focusNodeQuery) : node && node.msMatchesSelector ? node.msMatchesSelector(focusNodeQuery) : false;
};

exports.canFocusNode = canFocusNode;

var canKeyboardFocusNode = function canKeyboardFocusNode(node) {
  return canFocusNode(node) && node.getAttribute("tabindex") !== "-1";
};

exports.canKeyboardFocusNode = canKeyboardFocusNode;

var getFocusNodes = function getFocusNodes(node) {
  return node ? [].slice.call(node.querySelectorAll(focusNodeQuery)) : [];
};

exports.getFocusNodes = getFocusNodes;

var getKeyboardFocusNodes = function getKeyboardFocusNodes(node) {
  return getFocusNodes(node).filter(canKeyboardFocusNode);
};
/**
 * Returns an object containing two arrays of focuseable nodes keyed under
 * "startNodes" and "endNodes". The startNodes array contains every node that,
 * when focused, will cause the parent node to lose focus if the user presses
 * shift + tab (moving back in the tab order). The endNodes array contains every
 * node that, when focused, will cause the parent node to lose focus if the user
 * presses tab (moving forward in the tab order).
 */


exports.getKeyboardFocusNodes = getKeyboardFocusNodes;

var getBoundingFocusNodes = function getBoundingFocusNodes(node) {
  var nodes = [canFocusNode(node) ? node : undefined].concat((0, _toConsumableArray2["default"])(getFocusNodes(node))).filter(Boolean);
  var startFocusIndex = (0, _findIndex["default"])(nodes, canKeyboardFocusNode);
  var endFocusIndex = (0, _findLastIndex["default"])(nodes, canKeyboardFocusNode);
  var startNodes = startFocusIndex !== -1 ? nodes.slice(0, startFocusIndex + 1) : nodes;
  var endNodes = endFocusIndex !== -1 ? nodes.slice(endFocusIndex) : nodes;
  return {
    startNodes: startNodes,
    endNodes: endNodes
  };
};

exports.getBoundingFocusNodes = getBoundingFocusNodes;

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(1630);

var iterableToArray = __webpack_require__(1631);

var unsupportedIterableToArray = __webpack_require__(523);

var nonIterableSpread = __webpack_require__(1632);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(524);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(528),
    baseIteratee = __webpack_require__(280),
    toInteger = __webpack_require__(529);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(1635);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(210),
    isSymbol = __webpack_require__(215);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(528),
    baseIteratee = __webpack_require__(280),
    toInteger = __webpack_require__(529);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = fromIndex < 0
      ? nativeMax(length + index, 0)
      : nativeMin(index, length - 1);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}

module.exports = findLastIndex;


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Generate a CSS value for an encoded svg icon. This essentially just sets the
 * color and wraps the data in a "url()".
 *
 * @example
 * getIconCss(data, "#000")
 */
var getIconCss = function getIconCss(data, color) {
  return data && color ? "url(\"".concat(data.replace(new RegExp("currentColor", "g"), // NOTE: Encode any "#" chars in the color value to future proof against
  // this change: https://www.chromestatus.com/feature/5656049583390720
  color.replace(new RegExp("#", "g"), "%23")), "\")") : "none";
};

var _default = getIconCss;
exports["default"] = _default;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.d019dfed.js